(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("60Fn4", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $4602d59ebac9de2f$export$6503ec6e8aabbaf; }, function (v) { return $4602d59ebac9de2f$export$6503ec6e8aabbaf = v; });
var $4602d59ebac9de2f$export$6503ec6e8aabbaf;
var $4602d59ebac9de2f$export$f7ad0328861e2f03;
"use strict";
var $4602d59ebac9de2f$var$mapping = new Map();
function $4602d59ebac9de2f$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$4602d59ebac9de2f$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $4602d59ebac9de2f$var$resolve(id) {
    var resolved = $4602d59ebac9de2f$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$4602d59ebac9de2f$export$6503ec6e8aabbaf = $4602d59ebac9de2f$var$register;
$4602d59ebac9de2f$export$f7ad0328861e2f03 = $4602d59ebac9de2f$var$resolve;

});

parcelRegister("lslan", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $f9eca1ae85e3993e$export$bdfd709ae4826697; }, function (v) { return $f9eca1ae85e3993e$export$bdfd709ae4826697 = v; });
var $f9eca1ae85e3993e$export$bdfd709ae4826697;
var $f9eca1ae85e3993e$export$c9e73fbda7da57b6;
var $f9eca1ae85e3993e$export$5a759dc7a1cfb72a;
"use strict";
var $f9eca1ae85e3993e$var$bundleURL = {};
function $f9eca1ae85e3993e$var$getBundleURLCached(id) {
    var value = $f9eca1ae85e3993e$var$bundleURL[id];
    if (!value) {
        value = $f9eca1ae85e3993e$var$getBundleURL();
        $f9eca1ae85e3993e$var$bundleURL[id] = value;
    }
    return value;
}
function $f9eca1ae85e3993e$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $f9eca1ae85e3993e$var$getBaseURL(matches[2]);
    }
    return '/';
}
function $f9eca1ae85e3993e$var$getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $f9eca1ae85e3993e$var$getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
$f9eca1ae85e3993e$export$bdfd709ae4826697 = $f9eca1ae85e3993e$var$getBundleURLCached;
$f9eca1ae85e3993e$export$c9e73fbda7da57b6 = $f9eca1ae85e3993e$var$getBaseURL;
$f9eca1ae85e3993e$export$5a759dc7a1cfb72a = $f9eca1ae85e3993e$var$getOrigin;

});

parcelRegister("8FY87", function(module, exports) {
'use strict';

module.exports = (parcelRequire("4rNqi"));

});
parcelRegister("4rNqi", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $33d0057184af2d0e$export$dca3b0875bd9a954; }, function (v) { return $33d0057184af2d0e$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $33d0057184af2d0e$export$16fa2f45be04daa8; }, function (v) { return $33d0057184af2d0e$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $33d0057184af2d0e$export$ffb0004e005737fa; }, function (v) { return $33d0057184af2d0e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $33d0057184af2d0e$export$e2c29f18771995cb; }, function (v) { return $33d0057184af2d0e$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $33d0057184af2d0e$export$221d75b3f55bb0bd; }, function (v) { return $33d0057184af2d0e$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $33d0057184af2d0e$export$5f8d39834fd61797; }, function (v) { return $33d0057184af2d0e$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $33d0057184af2d0e$export$74bf444e3cd11ea5; }, function (v) { return $33d0057184af2d0e$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $33d0057184af2d0e$export$ae55be85d98224ed; }, function (v) { return $33d0057184af2d0e$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $33d0057184af2d0e$export$3ba232387fd5d6dd; }, function (v) { return $33d0057184af2d0e$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $33d0057184af2d0e$export$e530037191fcd5d7; }, function (v) { return $33d0057184af2d0e$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $33d0057184af2d0e$export$fd42f52fd3ae1109; }, function (v) { return $33d0057184af2d0e$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $33d0057184af2d0e$export$c8a8987d4410bf2d; }, function (v) { return $33d0057184af2d0e$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $33d0057184af2d0e$export$d38cd72104c1f0e9; }, function (v) { return $33d0057184af2d0e$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $33d0057184af2d0e$export$7d1e3a5e95ceca43; }, function (v) { return $33d0057184af2d0e$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $33d0057184af2d0e$export$257a8862b851cb5b; }, function (v) { return $33d0057184af2d0e$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $33d0057184af2d0e$export$a8257692ac88316c; }, function (v) { return $33d0057184af2d0e$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $33d0057184af2d0e$export$488013bae63b21da; }, function (v) { return $33d0057184af2d0e$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $33d0057184af2d0e$export$7c73462e0d25e514; }, function (v) { return $33d0057184af2d0e$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $33d0057184af2d0e$export$7568632d0d33d16d; }, function (v) { return $33d0057184af2d0e$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $33d0057184af2d0e$export$88948ce120ea2619; }, function (v) { return $33d0057184af2d0e$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $33d0057184af2d0e$export$35808ee640e87ca7; }, function (v) { return $33d0057184af2d0e$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $33d0057184af2d0e$export$fae74005e78b1a27; }, function (v) { return $33d0057184af2d0e$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $33d0057184af2d0e$export$dc8fbce3eb94dc1e; }, function (v) { return $33d0057184af2d0e$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $33d0057184af2d0e$export$6a7bc4e911dc01cf; }, function (v) { return $33d0057184af2d0e$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $33d0057184af2d0e$export$6d9c69b0de29b591; }, function (v) { return $33d0057184af2d0e$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $33d0057184af2d0e$export$f680877a34711e37; }, function (v) { return $33d0057184af2d0e$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $33d0057184af2d0e$export$d5a552a76deda3c2; }, function (v) { return $33d0057184af2d0e$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $33d0057184af2d0e$export$aaabe4eda9ed9969; }, function (v) { return $33d0057184af2d0e$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $33d0057184af2d0e$export$e5c5a5f917a5871c; }, function (v) { return $33d0057184af2d0e$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $33d0057184af2d0e$export$1538c33de8887b59; }, function (v) { return $33d0057184af2d0e$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $33d0057184af2d0e$export$13e3392192263954; }, function (v) { return $33d0057184af2d0e$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $33d0057184af2d0e$export$b8f5890fc79d6aca; }, function (v) { return $33d0057184af2d0e$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $33d0057184af2d0e$export$60241385465d0a34; }, function (v) { return $33d0057184af2d0e$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $33d0057184af2d0e$export$306c0aa65ff9ec16; }, function (v) { return $33d0057184af2d0e$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $33d0057184af2d0e$export$7b286972b8d8ccbf; }, function (v) { return $33d0057184af2d0e$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $33d0057184af2d0e$export$83d89fbfd8236492; }, function (v) { return $33d0057184af2d0e$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $33d0057184af2d0e$export$dca3b0875bd9a954;
var $33d0057184af2d0e$export$16fa2f45be04daa8;
var $33d0057184af2d0e$export$ffb0004e005737fa;
var $33d0057184af2d0e$export$e2c29f18771995cb;
var $33d0057184af2d0e$export$221d75b3f55bb0bd;
var $33d0057184af2d0e$export$5f8d39834fd61797;
var $33d0057184af2d0e$export$74bf444e3cd11ea5;
var $33d0057184af2d0e$export$ae55be85d98224ed;
var $33d0057184af2d0e$export$3ba232387fd5d6dd;
var $33d0057184af2d0e$export$e530037191fcd5d7;
var $33d0057184af2d0e$export$fd42f52fd3ae1109;
var $33d0057184af2d0e$export$c8a8987d4410bf2d;
var $33d0057184af2d0e$export$d38cd72104c1f0e9;
var $33d0057184af2d0e$export$7d1e3a5e95ceca43;
var $33d0057184af2d0e$export$257a8862b851cb5b;
var $33d0057184af2d0e$export$a8257692ac88316c;
var $33d0057184af2d0e$export$488013bae63b21da;
var $33d0057184af2d0e$export$7c73462e0d25e514;
var $33d0057184af2d0e$export$7568632d0d33d16d;
var $33d0057184af2d0e$export$88948ce120ea2619;
var $33d0057184af2d0e$export$35808ee640e87ca7;
var $33d0057184af2d0e$export$fae74005e78b1a27;
var $33d0057184af2d0e$export$dc8fbce3eb94dc1e;
var $33d0057184af2d0e$export$6a7bc4e911dc01cf;
var $33d0057184af2d0e$export$6d9c69b0de29b591;
var $33d0057184af2d0e$export$f680877a34711e37;
var $33d0057184af2d0e$export$d5a552a76deda3c2;
var $33d0057184af2d0e$export$aaabe4eda9ed9969;
var $33d0057184af2d0e$export$e5c5a5f917a5871c;
var $33d0057184af2d0e$export$1538c33de8887b59;
var $33d0057184af2d0e$export$13e3392192263954;
var $33d0057184af2d0e$export$b8f5890fc79d6aca;
var $33d0057184af2d0e$export$60241385465d0a34;
var $33d0057184af2d0e$export$306c0aa65ff9ec16;
var $33d0057184af2d0e$export$7b286972b8d8ccbf;
var $33d0057184af2d0e$export$83d89fbfd8236492;
'use strict';
var $33d0057184af2d0e$var$l = Symbol.for("react.element"), $33d0057184af2d0e$var$n = Symbol.for("react.portal"), $33d0057184af2d0e$var$p = Symbol.for("react.fragment"), $33d0057184af2d0e$var$q = Symbol.for("react.strict_mode"), $33d0057184af2d0e$var$r = Symbol.for("react.profiler"), $33d0057184af2d0e$var$t = Symbol.for("react.provider"), $33d0057184af2d0e$var$u = Symbol.for("react.context"), $33d0057184af2d0e$var$v = Symbol.for("react.forward_ref"), $33d0057184af2d0e$var$w = Symbol.for("react.suspense"), $33d0057184af2d0e$var$x = Symbol.for("react.memo"), $33d0057184af2d0e$var$y = Symbol.for("react.lazy"), $33d0057184af2d0e$var$z = Symbol.iterator;
function $33d0057184af2d0e$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $33d0057184af2d0e$var$z && a[$33d0057184af2d0e$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $33d0057184af2d0e$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $33d0057184af2d0e$var$C = Object.assign, $33d0057184af2d0e$var$D = {};
function $33d0057184af2d0e$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $33d0057184af2d0e$var$D;
    this.updater = e || $33d0057184af2d0e$var$B;
}
$33d0057184af2d0e$var$E.prototype.isReactComponent = {};
$33d0057184af2d0e$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$33d0057184af2d0e$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $33d0057184af2d0e$var$F() {}
$33d0057184af2d0e$var$F.prototype = $33d0057184af2d0e$var$E.prototype;
function $33d0057184af2d0e$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $33d0057184af2d0e$var$D;
    this.updater = e || $33d0057184af2d0e$var$B;
}
var $33d0057184af2d0e$var$H = $33d0057184af2d0e$var$G.prototype = new $33d0057184af2d0e$var$F;
$33d0057184af2d0e$var$H.constructor = $33d0057184af2d0e$var$G;
$33d0057184af2d0e$var$C($33d0057184af2d0e$var$H, $33d0057184af2d0e$var$E.prototype);
$33d0057184af2d0e$var$H.isPureReactComponent = !0;
var $33d0057184af2d0e$var$I = Array.isArray, $33d0057184af2d0e$var$J = Object.prototype.hasOwnProperty, $33d0057184af2d0e$var$K = {
    current: null
}, $33d0057184af2d0e$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $33d0057184af2d0e$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$33d0057184af2d0e$var$J.call(b, d) && !$33d0057184af2d0e$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $33d0057184af2d0e$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $33d0057184af2d0e$var$K.current
    };
}
function $33d0057184af2d0e$var$N(a, b) {
    return {
        $$typeof: $33d0057184af2d0e$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $33d0057184af2d0e$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $33d0057184af2d0e$var$l;
}
function $33d0057184af2d0e$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $33d0057184af2d0e$var$P = /\/+/g;
function $33d0057184af2d0e$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $33d0057184af2d0e$var$escape("" + a.key) : b.toString(36);
}
function $33d0057184af2d0e$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $33d0057184af2d0e$var$l:
                case $33d0057184af2d0e$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $33d0057184af2d0e$var$Q(h, 0) : d, $33d0057184af2d0e$var$I(c) ? (e = "", null != a && (e = a.replace($33d0057184af2d0e$var$P, "$&/") + "/"), $33d0057184af2d0e$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($33d0057184af2d0e$var$O(c) && (c = $33d0057184af2d0e$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($33d0057184af2d0e$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($33d0057184af2d0e$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $33d0057184af2d0e$var$Q(k, g);
        h += $33d0057184af2d0e$var$R(k, b, e, f, c);
    }
    else if (f = $33d0057184af2d0e$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $33d0057184af2d0e$var$Q(k, g++), h += $33d0057184af2d0e$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $33d0057184af2d0e$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $33d0057184af2d0e$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $33d0057184af2d0e$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $33d0057184af2d0e$var$U = {
    current: null
}, $33d0057184af2d0e$var$V = {
    transition: null
}, $33d0057184af2d0e$var$W = {
    ReactCurrentDispatcher: $33d0057184af2d0e$var$U,
    ReactCurrentBatchConfig: $33d0057184af2d0e$var$V,
    ReactCurrentOwner: $33d0057184af2d0e$var$K
};
function $33d0057184af2d0e$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$33d0057184af2d0e$export$dca3b0875bd9a954 = {
    map: $33d0057184af2d0e$var$S,
    forEach: function(a, b, e) {
        $33d0057184af2d0e$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $33d0057184af2d0e$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $33d0057184af2d0e$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$33d0057184af2d0e$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$33d0057184af2d0e$export$16fa2f45be04daa8 = $33d0057184af2d0e$var$E;
$33d0057184af2d0e$export$ffb0004e005737fa = $33d0057184af2d0e$var$p;
$33d0057184af2d0e$export$e2c29f18771995cb = $33d0057184af2d0e$var$r;
$33d0057184af2d0e$export$221d75b3f55bb0bd = $33d0057184af2d0e$var$G;
$33d0057184af2d0e$export$5f8d39834fd61797 = $33d0057184af2d0e$var$q;
$33d0057184af2d0e$export$74bf444e3cd11ea5 = $33d0057184af2d0e$var$w;
$33d0057184af2d0e$export$ae55be85d98224ed = $33d0057184af2d0e$var$W;
$33d0057184af2d0e$export$3ba232387fd5d6dd = $33d0057184af2d0e$var$X;
$33d0057184af2d0e$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $33d0057184af2d0e$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $33d0057184af2d0e$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$33d0057184af2d0e$var$J.call(b, f) && !$33d0057184af2d0e$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $33d0057184af2d0e$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$33d0057184af2d0e$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $33d0057184af2d0e$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $33d0057184af2d0e$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$33d0057184af2d0e$export$c8a8987d4410bf2d = $33d0057184af2d0e$var$M;
$33d0057184af2d0e$export$d38cd72104c1f0e9 = function(a) {
    var b = $33d0057184af2d0e$var$M.bind(null, a);
    b.type = a;
    return b;
};
$33d0057184af2d0e$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$33d0057184af2d0e$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $33d0057184af2d0e$var$v,
        render: a
    };
};
$33d0057184af2d0e$export$a8257692ac88316c = $33d0057184af2d0e$var$O;
$33d0057184af2d0e$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $33d0057184af2d0e$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $33d0057184af2d0e$var$T
    };
};
$33d0057184af2d0e$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $33d0057184af2d0e$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$33d0057184af2d0e$export$7568632d0d33d16d = function(a) {
    var b = $33d0057184af2d0e$var$V.transition;
    $33d0057184af2d0e$var$V.transition = {};
    try {
        a();
    } finally{
        $33d0057184af2d0e$var$V.transition = b;
    }
};
$33d0057184af2d0e$export$88948ce120ea2619 = $33d0057184af2d0e$var$X;
$33d0057184af2d0e$export$35808ee640e87ca7 = function(a, b) {
    return $33d0057184af2d0e$var$U.current.useCallback(a, b);
};
$33d0057184af2d0e$export$fae74005e78b1a27 = function(a) {
    return $33d0057184af2d0e$var$U.current.useContext(a);
};
$33d0057184af2d0e$export$dc8fbce3eb94dc1e = function() {};
$33d0057184af2d0e$export$6a7bc4e911dc01cf = function(a) {
    return $33d0057184af2d0e$var$U.current.useDeferredValue(a);
};
$33d0057184af2d0e$export$6d9c69b0de29b591 = function(a, b) {
    return $33d0057184af2d0e$var$U.current.useEffect(a, b);
};
$33d0057184af2d0e$export$f680877a34711e37 = function() {
    return $33d0057184af2d0e$var$U.current.useId();
};
$33d0057184af2d0e$export$d5a552a76deda3c2 = function(a, b, e) {
    return $33d0057184af2d0e$var$U.current.useImperativeHandle(a, b, e);
};
$33d0057184af2d0e$export$aaabe4eda9ed9969 = function(a, b) {
    return $33d0057184af2d0e$var$U.current.useInsertionEffect(a, b);
};
$33d0057184af2d0e$export$e5c5a5f917a5871c = function(a, b) {
    return $33d0057184af2d0e$var$U.current.useLayoutEffect(a, b);
};
$33d0057184af2d0e$export$1538c33de8887b59 = function(a, b) {
    return $33d0057184af2d0e$var$U.current.useMemo(a, b);
};
$33d0057184af2d0e$export$13e3392192263954 = function(a, b, e) {
    return $33d0057184af2d0e$var$U.current.useReducer(a, b, e);
};
$33d0057184af2d0e$export$b8f5890fc79d6aca = function(a) {
    return $33d0057184af2d0e$var$U.current.useRef(a);
};
$33d0057184af2d0e$export$60241385465d0a34 = function(a) {
    return $33d0057184af2d0e$var$U.current.useState(a);
};
$33d0057184af2d0e$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $33d0057184af2d0e$var$U.current.useSyncExternalStore(a, b, e);
};
$33d0057184af2d0e$export$7b286972b8d8ccbf = function() {
    return $33d0057184af2d0e$var$U.current.useTransition();
};
$33d0057184af2d0e$export$83d89fbfd8236492 = "18.3.1";

});


parcelRegister("f30MD", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $af47be6906de36aa$export$ae55be85d98224ed; }, function (v) { return $af47be6906de36aa$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $af47be6906de36aa$export$d39a5bbd09211389; }, function (v) { return $af47be6906de36aa$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $af47be6906de36aa$export$882461b6382ed46c; }, function (v) { return $af47be6906de36aa$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $af47be6906de36aa$export$466bfc07425424d5; }, function (v) { return $af47be6906de36aa$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $af47be6906de36aa$export$cd75ccfd720a3cd4; }, function (v) { return $af47be6906de36aa$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $af47be6906de36aa$export$fa8d919ba61d84db; }, function (v) { return $af47be6906de36aa$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $af47be6906de36aa$export$757ceba2d55c277e; }, function (v) { return $af47be6906de36aa$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $af47be6906de36aa$export$b3890eb0ae9dca99; }, function (v) { return $af47be6906de36aa$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $af47be6906de36aa$export$502457920280e6be; }, function (v) { return $af47be6906de36aa$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $af47be6906de36aa$export$c78a37762a8d58e1; }, function (v) { return $af47be6906de36aa$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $af47be6906de36aa$export$dc54d992c10e8a18; }, function (v) { return $af47be6906de36aa$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $af47be6906de36aa$export$83d89fbfd8236492; }, function (v) { return $af47be6906de36aa$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $af47be6906de36aa$export$ae55be85d98224ed;
var $af47be6906de36aa$export$d39a5bbd09211389;
var $af47be6906de36aa$export$882461b6382ed46c;
var $af47be6906de36aa$export$466bfc07425424d5;
var $af47be6906de36aa$export$cd75ccfd720a3cd4;
var $af47be6906de36aa$export$fa8d919ba61d84db;
var $af47be6906de36aa$export$757ceba2d55c277e;
var $af47be6906de36aa$export$b3890eb0ae9dca99;
var $af47be6906de36aa$export$502457920280e6be;
var $af47be6906de36aa$export$c78a37762a8d58e1;
var $af47be6906de36aa$export$dc54d992c10e8a18;
var $af47be6906de36aa$export$83d89fbfd8236492;
'use strict';

var $8FY87 = parcelRequire("8FY87");

var $9LPgQ = parcelRequire("9LPgQ");
function $af47be6906de36aa$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $af47be6906de36aa$var$da = new Set, $af47be6906de36aa$var$ea = {};
function $af47be6906de36aa$var$fa(a, b) {
    $af47be6906de36aa$var$ha(a, b);
    $af47be6906de36aa$var$ha(a + "Capture", b);
}
function $af47be6906de36aa$var$ha(a, b) {
    $af47be6906de36aa$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$af47be6906de36aa$var$da.add(b[a]);
}
var $af47be6906de36aa$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $af47be6906de36aa$var$ja = Object.prototype.hasOwnProperty, $af47be6906de36aa$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $af47be6906de36aa$var$la = {}, $af47be6906de36aa$var$ma = {};
function $af47be6906de36aa$var$oa(a) {
    if ($af47be6906de36aa$var$ja.call($af47be6906de36aa$var$ma, a)) return !0;
    if ($af47be6906de36aa$var$ja.call($af47be6906de36aa$var$la, a)) return !1;
    if ($af47be6906de36aa$var$ka.test(a)) return $af47be6906de36aa$var$ma[a] = !0;
    $af47be6906de36aa$var$la[a] = !0;
    return !1;
}
function $af47be6906de36aa$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $af47be6906de36aa$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $af47be6906de36aa$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $af47be6906de36aa$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $af47be6906de36aa$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $af47be6906de36aa$var$z[a] = new $af47be6906de36aa$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $af47be6906de36aa$var$z[b] = new $af47be6906de36aa$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $af47be6906de36aa$var$z[a] = new $af47be6906de36aa$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $af47be6906de36aa$var$z[a] = new $af47be6906de36aa$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $af47be6906de36aa$var$z[a] = new $af47be6906de36aa$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $af47be6906de36aa$var$z[a] = new $af47be6906de36aa$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $af47be6906de36aa$var$z[a] = new $af47be6906de36aa$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $af47be6906de36aa$var$z[a] = new $af47be6906de36aa$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $af47be6906de36aa$var$z[a] = new $af47be6906de36aa$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $af47be6906de36aa$var$ra = /[\-:]([a-z])/g;
function $af47be6906de36aa$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($af47be6906de36aa$var$ra, $af47be6906de36aa$var$sa);
    $af47be6906de36aa$var$z[b] = new $af47be6906de36aa$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($af47be6906de36aa$var$ra, $af47be6906de36aa$var$sa);
    $af47be6906de36aa$var$z[b] = new $af47be6906de36aa$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($af47be6906de36aa$var$ra, $af47be6906de36aa$var$sa);
    $af47be6906de36aa$var$z[b] = new $af47be6906de36aa$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $af47be6906de36aa$var$z[a] = new $af47be6906de36aa$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$af47be6906de36aa$var$z.xlinkHref = new $af47be6906de36aa$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $af47be6906de36aa$var$z[a] = new $af47be6906de36aa$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $af47be6906de36aa$var$ta(a, b, c, d) {
    var e = $af47be6906de36aa$var$z.hasOwnProperty(b) ? $af47be6906de36aa$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $af47be6906de36aa$var$qa(b, c, e, d) && (c = null), d || null === e ? $af47be6906de36aa$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $af47be6906de36aa$var$ua = $8FY87.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $af47be6906de36aa$var$va = Symbol.for("react.element"), $af47be6906de36aa$var$wa = Symbol.for("react.portal"), $af47be6906de36aa$var$ya = Symbol.for("react.fragment"), $af47be6906de36aa$var$za = Symbol.for("react.strict_mode"), $af47be6906de36aa$var$Aa = Symbol.for("react.profiler"), $af47be6906de36aa$var$Ba = Symbol.for("react.provider"), $af47be6906de36aa$var$Ca = Symbol.for("react.context"), $af47be6906de36aa$var$Da = Symbol.for("react.forward_ref"), $af47be6906de36aa$var$Ea = Symbol.for("react.suspense"), $af47be6906de36aa$var$Fa = Symbol.for("react.suspense_list"), $af47be6906de36aa$var$Ga = Symbol.for("react.memo"), $af47be6906de36aa$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $af47be6906de36aa$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $af47be6906de36aa$var$Ja = Symbol.iterator;
function $af47be6906de36aa$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $af47be6906de36aa$var$Ja && a[$af47be6906de36aa$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $af47be6906de36aa$var$A = Object.assign, $af47be6906de36aa$var$La;
function $af47be6906de36aa$var$Ma(a) {
    if (void 0 === $af47be6906de36aa$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $af47be6906de36aa$var$La = b && b[1] || "";
    }
    return "\n" + $af47be6906de36aa$var$La + a;
}
var $af47be6906de36aa$var$Na = !1;
function $af47be6906de36aa$var$Oa(a, b) {
    if (!a || $af47be6906de36aa$var$Na) return "";
    $af47be6906de36aa$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $af47be6906de36aa$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $af47be6906de36aa$var$Ma(a) : "";
}
function $af47be6906de36aa$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $af47be6906de36aa$var$Ma(a.type);
        case 16:
            return $af47be6906de36aa$var$Ma("Lazy");
        case 13:
            return $af47be6906de36aa$var$Ma("Suspense");
        case 19:
            return $af47be6906de36aa$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $af47be6906de36aa$var$Oa(a.type, !1), a;
        case 11:
            return a = $af47be6906de36aa$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $af47be6906de36aa$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $af47be6906de36aa$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $af47be6906de36aa$var$ya:
            return "Fragment";
        case $af47be6906de36aa$var$wa:
            return "Portal";
        case $af47be6906de36aa$var$Aa:
            return "Profiler";
        case $af47be6906de36aa$var$za:
            return "StrictMode";
        case $af47be6906de36aa$var$Ea:
            return "Suspense";
        case $af47be6906de36aa$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $af47be6906de36aa$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $af47be6906de36aa$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $af47be6906de36aa$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $af47be6906de36aa$var$Ga:
            return b = a.displayName || null, null !== b ? b : $af47be6906de36aa$var$Qa(a.type) || "Memo";
        case $af47be6906de36aa$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $af47be6906de36aa$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $af47be6906de36aa$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $af47be6906de36aa$var$Qa(b);
        case 8:
            return b === $af47be6906de36aa$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $af47be6906de36aa$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $af47be6906de36aa$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $af47be6906de36aa$var$Ua(a) {
    var b = $af47be6906de36aa$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $af47be6906de36aa$var$Va(a) {
    a._valueTracker || (a._valueTracker = $af47be6906de36aa$var$Ua(a));
}
function $af47be6906de36aa$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $af47be6906de36aa$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $af47be6906de36aa$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $af47be6906de36aa$var$Ya(a, b) {
    var c = b.checked;
    return $af47be6906de36aa$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $af47be6906de36aa$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $af47be6906de36aa$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $af47be6906de36aa$var$ab(a, b) {
    b = b.checked;
    null != b && $af47be6906de36aa$var$ta(a, "checked", b, !1);
}
function $af47be6906de36aa$var$bb(a, b) {
    $af47be6906de36aa$var$ab(a, b);
    var c = $af47be6906de36aa$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $af47be6906de36aa$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $af47be6906de36aa$var$cb(a, b.type, $af47be6906de36aa$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $af47be6906de36aa$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $af47be6906de36aa$var$cb(a, b, c) {
    if ("number" !== b || $af47be6906de36aa$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $af47be6906de36aa$var$eb = Array.isArray;
function $af47be6906de36aa$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $af47be6906de36aa$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $af47be6906de36aa$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($af47be6906de36aa$var$p(91));
    return $af47be6906de36aa$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $af47be6906de36aa$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($af47be6906de36aa$var$p(92));
            if ($af47be6906de36aa$var$eb(c)) {
                if (1 < c.length) throw Error($af47be6906de36aa$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $af47be6906de36aa$var$Sa(c)
    };
}
function $af47be6906de36aa$var$ib(a, b) {
    var c = $af47be6906de36aa$var$Sa(b.value), d = $af47be6906de36aa$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $af47be6906de36aa$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $af47be6906de36aa$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $af47be6906de36aa$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $af47be6906de36aa$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $af47be6906de36aa$var$mb, $af47be6906de36aa$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $af47be6906de36aa$var$mb = $af47be6906de36aa$var$mb || document.createElement("div");
        $af47be6906de36aa$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $af47be6906de36aa$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $af47be6906de36aa$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $af47be6906de36aa$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $af47be6906de36aa$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($af47be6906de36aa$var$pb).forEach(function(a) {
    $af47be6906de36aa$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $af47be6906de36aa$var$pb[b] = $af47be6906de36aa$var$pb[a];
    });
});
function $af47be6906de36aa$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $af47be6906de36aa$var$pb.hasOwnProperty(a) && $af47be6906de36aa$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $af47be6906de36aa$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $af47be6906de36aa$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $af47be6906de36aa$var$tb = $af47be6906de36aa$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $af47be6906de36aa$var$ub(a, b) {
    if (b) {
        if ($af47be6906de36aa$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($af47be6906de36aa$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($af47be6906de36aa$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($af47be6906de36aa$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($af47be6906de36aa$var$p(62));
    }
}
function $af47be6906de36aa$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $af47be6906de36aa$var$wb = null;
function $af47be6906de36aa$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $af47be6906de36aa$var$yb = null, $af47be6906de36aa$var$zb = null, $af47be6906de36aa$var$Ab = null;
function $af47be6906de36aa$var$Bb(a) {
    if (a = $af47be6906de36aa$var$Cb(a)) {
        if ("function" !== typeof $af47be6906de36aa$var$yb) throw Error($af47be6906de36aa$var$p(280));
        var b = a.stateNode;
        b && (b = $af47be6906de36aa$var$Db(b), $af47be6906de36aa$var$yb(a.stateNode, a.type, b));
    }
}
function $af47be6906de36aa$var$Eb(a) {
    $af47be6906de36aa$var$zb ? $af47be6906de36aa$var$Ab ? $af47be6906de36aa$var$Ab.push(a) : $af47be6906de36aa$var$Ab = [
        a
    ] : $af47be6906de36aa$var$zb = a;
}
function $af47be6906de36aa$var$Fb() {
    if ($af47be6906de36aa$var$zb) {
        var a = $af47be6906de36aa$var$zb, b = $af47be6906de36aa$var$Ab;
        $af47be6906de36aa$var$Ab = $af47be6906de36aa$var$zb = null;
        $af47be6906de36aa$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$af47be6906de36aa$var$Bb(b[a]);
    }
}
function $af47be6906de36aa$var$Gb(a, b) {
    return a(b);
}
function $af47be6906de36aa$var$Hb() {}
var $af47be6906de36aa$var$Ib = !1;
function $af47be6906de36aa$var$Jb(a, b, c) {
    if ($af47be6906de36aa$var$Ib) return a(b, c);
    $af47be6906de36aa$var$Ib = !0;
    try {
        return $af47be6906de36aa$var$Gb(a, b, c);
    } finally{
        if ($af47be6906de36aa$var$Ib = !1, null !== $af47be6906de36aa$var$zb || null !== $af47be6906de36aa$var$Ab) $af47be6906de36aa$var$Hb(), $af47be6906de36aa$var$Fb();
    }
}
function $af47be6906de36aa$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $af47be6906de36aa$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($af47be6906de36aa$var$p(231, b, typeof c));
    return c;
}
var $af47be6906de36aa$var$Lb = !1;
if ($af47be6906de36aa$var$ia) try {
    var $af47be6906de36aa$var$Mb = {};
    Object.defineProperty($af47be6906de36aa$var$Mb, "passive", {
        get: function() {
            $af47be6906de36aa$var$Lb = !0;
        }
    });
    window.addEventListener("test", $af47be6906de36aa$var$Mb, $af47be6906de36aa$var$Mb);
    window.removeEventListener("test", $af47be6906de36aa$var$Mb, $af47be6906de36aa$var$Mb);
} catch (a) {
    $af47be6906de36aa$var$Lb = !1;
}
function $af47be6906de36aa$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $af47be6906de36aa$var$Ob = !1, $af47be6906de36aa$var$Pb = null, $af47be6906de36aa$var$Qb = !1, $af47be6906de36aa$var$Rb = null, $af47be6906de36aa$var$Sb = {
    onError: function(a) {
        $af47be6906de36aa$var$Ob = !0;
        $af47be6906de36aa$var$Pb = a;
    }
};
function $af47be6906de36aa$var$Tb(a, b, c, d, e, f, g, h, k) {
    $af47be6906de36aa$var$Ob = !1;
    $af47be6906de36aa$var$Pb = null;
    $af47be6906de36aa$var$Nb.apply($af47be6906de36aa$var$Sb, arguments);
}
function $af47be6906de36aa$var$Ub(a, b, c, d, e, f, g, h, k) {
    $af47be6906de36aa$var$Tb.apply(this, arguments);
    if ($af47be6906de36aa$var$Ob) {
        if ($af47be6906de36aa$var$Ob) {
            var l = $af47be6906de36aa$var$Pb;
            $af47be6906de36aa$var$Ob = !1;
            $af47be6906de36aa$var$Pb = null;
        } else throw Error($af47be6906de36aa$var$p(198));
        $af47be6906de36aa$var$Qb || ($af47be6906de36aa$var$Qb = !0, $af47be6906de36aa$var$Rb = l);
    }
}
function $af47be6906de36aa$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $af47be6906de36aa$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $af47be6906de36aa$var$Xb(a) {
    if ($af47be6906de36aa$var$Vb(a) !== a) throw Error($af47be6906de36aa$var$p(188));
}
function $af47be6906de36aa$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $af47be6906de36aa$var$Vb(a);
        if (null === b) throw Error($af47be6906de36aa$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $af47be6906de36aa$var$Xb(e), a;
                if (f === d) return $af47be6906de36aa$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($af47be6906de36aa$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($af47be6906de36aa$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($af47be6906de36aa$var$p(190));
    }
    if (3 !== c.tag) throw Error($af47be6906de36aa$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $af47be6906de36aa$var$Zb(a) {
    a = $af47be6906de36aa$var$Yb(a);
    return null !== a ? $af47be6906de36aa$var$$b(a) : null;
}
function $af47be6906de36aa$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $af47be6906de36aa$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $af47be6906de36aa$var$ac = $9LPgQ.unstable_scheduleCallback, $af47be6906de36aa$var$bc = $9LPgQ.unstable_cancelCallback, $af47be6906de36aa$var$cc = $9LPgQ.unstable_shouldYield, $af47be6906de36aa$var$dc = $9LPgQ.unstable_requestPaint, $af47be6906de36aa$var$B = $9LPgQ.unstable_now, $af47be6906de36aa$var$ec = $9LPgQ.unstable_getCurrentPriorityLevel, $af47be6906de36aa$var$fc = $9LPgQ.unstable_ImmediatePriority, $af47be6906de36aa$var$gc = $9LPgQ.unstable_UserBlockingPriority, $af47be6906de36aa$var$hc = $9LPgQ.unstable_NormalPriority, $af47be6906de36aa$var$ic = $9LPgQ.unstable_LowPriority, $af47be6906de36aa$var$jc = $9LPgQ.unstable_IdlePriority, $af47be6906de36aa$var$kc = null, $af47be6906de36aa$var$lc = null;
function $af47be6906de36aa$var$mc(a) {
    if ($af47be6906de36aa$var$lc && "function" === typeof $af47be6906de36aa$var$lc.onCommitFiberRoot) try {
        $af47be6906de36aa$var$lc.onCommitFiberRoot($af47be6906de36aa$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $af47be6906de36aa$var$oc = Math.clz32 ? Math.clz32 : $af47be6906de36aa$var$nc, $af47be6906de36aa$var$pc = Math.log, $af47be6906de36aa$var$qc = Math.LN2;
function $af47be6906de36aa$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($af47be6906de36aa$var$pc(a) / $af47be6906de36aa$var$qc | 0) | 0;
}
var $af47be6906de36aa$var$rc = 64, $af47be6906de36aa$var$sc = 4194304;
function $af47be6906de36aa$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $af47be6906de36aa$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $af47be6906de36aa$var$tc(h) : (f &= g, 0 !== f && (d = $af47be6906de36aa$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $af47be6906de36aa$var$tc(g) : 0 !== f && (d = $af47be6906de36aa$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $af47be6906de36aa$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $af47be6906de36aa$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $af47be6906de36aa$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $af47be6906de36aa$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $af47be6906de36aa$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $af47be6906de36aa$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $af47be6906de36aa$var$yc() {
    var a = $af47be6906de36aa$var$rc;
    $af47be6906de36aa$var$rc <<= 1;
    0 === ($af47be6906de36aa$var$rc & 4194240) && ($af47be6906de36aa$var$rc = 64);
    return a;
}
function $af47be6906de36aa$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $af47be6906de36aa$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $af47be6906de36aa$var$oc(b);
    a[b] = c;
}
function $af47be6906de36aa$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $af47be6906de36aa$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $af47be6906de36aa$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $af47be6906de36aa$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $af47be6906de36aa$var$C = 0;
function $af47be6906de36aa$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $af47be6906de36aa$var$Ec, $af47be6906de36aa$var$Fc, $af47be6906de36aa$var$Gc, $af47be6906de36aa$var$Hc, $af47be6906de36aa$var$Ic, $af47be6906de36aa$var$Jc = !1, $af47be6906de36aa$var$Kc = [], $af47be6906de36aa$var$Lc = null, $af47be6906de36aa$var$Mc = null, $af47be6906de36aa$var$Nc = null, $af47be6906de36aa$var$Oc = new Map, $af47be6906de36aa$var$Pc = new Map, $af47be6906de36aa$var$Qc = [], $af47be6906de36aa$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $af47be6906de36aa$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $af47be6906de36aa$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $af47be6906de36aa$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $af47be6906de36aa$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $af47be6906de36aa$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $af47be6906de36aa$var$Pc.delete(b.pointerId);
    }
}
function $af47be6906de36aa$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $af47be6906de36aa$var$Cb(b), null !== b && $af47be6906de36aa$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $af47be6906de36aa$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $af47be6906de36aa$var$Lc = $af47be6906de36aa$var$Tc($af47be6906de36aa$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $af47be6906de36aa$var$Mc = $af47be6906de36aa$var$Tc($af47be6906de36aa$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $af47be6906de36aa$var$Nc = $af47be6906de36aa$var$Tc($af47be6906de36aa$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $af47be6906de36aa$var$Oc.set(f, $af47be6906de36aa$var$Tc($af47be6906de36aa$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $af47be6906de36aa$var$Pc.set(f, $af47be6906de36aa$var$Tc($af47be6906de36aa$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $af47be6906de36aa$var$Vc(a) {
    var b = $af47be6906de36aa$var$Wc(a.target);
    if (null !== b) {
        var c = $af47be6906de36aa$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $af47be6906de36aa$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $af47be6906de36aa$var$Ic(a.priority, function() {
                        $af47be6906de36aa$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $af47be6906de36aa$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $af47be6906de36aa$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $af47be6906de36aa$var$wb = d;
            c.target.dispatchEvent(d);
            $af47be6906de36aa$var$wb = null;
        } else return b = $af47be6906de36aa$var$Cb(c), null !== b && $af47be6906de36aa$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $af47be6906de36aa$var$Zc(a, b, c) {
    $af47be6906de36aa$var$Xc(a) && c.delete(b);
}
function $af47be6906de36aa$var$$c() {
    $af47be6906de36aa$var$Jc = !1;
    null !== $af47be6906de36aa$var$Lc && $af47be6906de36aa$var$Xc($af47be6906de36aa$var$Lc) && ($af47be6906de36aa$var$Lc = null);
    null !== $af47be6906de36aa$var$Mc && $af47be6906de36aa$var$Xc($af47be6906de36aa$var$Mc) && ($af47be6906de36aa$var$Mc = null);
    null !== $af47be6906de36aa$var$Nc && $af47be6906de36aa$var$Xc($af47be6906de36aa$var$Nc) && ($af47be6906de36aa$var$Nc = null);
    $af47be6906de36aa$var$Oc.forEach($af47be6906de36aa$var$Zc);
    $af47be6906de36aa$var$Pc.forEach($af47be6906de36aa$var$Zc);
}
function $af47be6906de36aa$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $af47be6906de36aa$var$Jc || ($af47be6906de36aa$var$Jc = !0, $9LPgQ.unstable_scheduleCallback($9LPgQ.unstable_NormalPriority, $af47be6906de36aa$var$$c)));
}
function $af47be6906de36aa$var$bd(a) {
    function b(b) {
        return $af47be6906de36aa$var$ad(b, a);
    }
    if (0 < $af47be6906de36aa$var$Kc.length) {
        $af47be6906de36aa$var$ad($af47be6906de36aa$var$Kc[0], a);
        for(var c = 1; c < $af47be6906de36aa$var$Kc.length; c++){
            var d = $af47be6906de36aa$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $af47be6906de36aa$var$Lc && $af47be6906de36aa$var$ad($af47be6906de36aa$var$Lc, a);
    null !== $af47be6906de36aa$var$Mc && $af47be6906de36aa$var$ad($af47be6906de36aa$var$Mc, a);
    null !== $af47be6906de36aa$var$Nc && $af47be6906de36aa$var$ad($af47be6906de36aa$var$Nc, a);
    $af47be6906de36aa$var$Oc.forEach(b);
    $af47be6906de36aa$var$Pc.forEach(b);
    for(c = 0; c < $af47be6906de36aa$var$Qc.length; c++)d = $af47be6906de36aa$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $af47be6906de36aa$var$Qc.length && (c = $af47be6906de36aa$var$Qc[0], null === c.blockedOn);)$af47be6906de36aa$var$Vc(c), null === c.blockedOn && $af47be6906de36aa$var$Qc.shift();
}
var $af47be6906de36aa$var$cd = $af47be6906de36aa$var$ua.ReactCurrentBatchConfig, $af47be6906de36aa$var$dd = !0;
function $af47be6906de36aa$var$ed(a, b, c, d) {
    var e = $af47be6906de36aa$var$C, f = $af47be6906de36aa$var$cd.transition;
    $af47be6906de36aa$var$cd.transition = null;
    try {
        $af47be6906de36aa$var$C = 1, $af47be6906de36aa$var$fd(a, b, c, d);
    } finally{
        $af47be6906de36aa$var$C = e, $af47be6906de36aa$var$cd.transition = f;
    }
}
function $af47be6906de36aa$var$gd(a, b, c, d) {
    var e = $af47be6906de36aa$var$C, f = $af47be6906de36aa$var$cd.transition;
    $af47be6906de36aa$var$cd.transition = null;
    try {
        $af47be6906de36aa$var$C = 4, $af47be6906de36aa$var$fd(a, b, c, d);
    } finally{
        $af47be6906de36aa$var$C = e, $af47be6906de36aa$var$cd.transition = f;
    }
}
function $af47be6906de36aa$var$fd(a, b, c, d) {
    if ($af47be6906de36aa$var$dd) {
        var e = $af47be6906de36aa$var$Yc(a, b, c, d);
        if (null === e) $af47be6906de36aa$var$hd(a, b, d, $af47be6906de36aa$var$id, c), $af47be6906de36aa$var$Sc(a, d);
        else if ($af47be6906de36aa$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($af47be6906de36aa$var$Sc(a, d), b & 4 && -1 < $af47be6906de36aa$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $af47be6906de36aa$var$Cb(e);
                null !== f && $af47be6906de36aa$var$Ec(f);
                f = $af47be6906de36aa$var$Yc(a, b, c, d);
                null === f && $af47be6906de36aa$var$hd(a, b, d, $af47be6906de36aa$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $af47be6906de36aa$var$hd(a, b, d, null, c);
    }
}
var $af47be6906de36aa$var$id = null;
function $af47be6906de36aa$var$Yc(a, b, c, d) {
    $af47be6906de36aa$var$id = null;
    a = $af47be6906de36aa$var$xb(d);
    a = $af47be6906de36aa$var$Wc(a);
    if (null !== a) {
        if (b = $af47be6906de36aa$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $af47be6906de36aa$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $af47be6906de36aa$var$id = a;
    return null;
}
function $af47be6906de36aa$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($af47be6906de36aa$var$ec()){
                case $af47be6906de36aa$var$fc:
                    return 1;
                case $af47be6906de36aa$var$gc:
                    return 4;
                case $af47be6906de36aa$var$hc:
                case $af47be6906de36aa$var$ic:
                    return 16;
                case $af47be6906de36aa$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $af47be6906de36aa$var$kd = null, $af47be6906de36aa$var$ld = null, $af47be6906de36aa$var$md = null;
function $af47be6906de36aa$var$nd() {
    if ($af47be6906de36aa$var$md) return $af47be6906de36aa$var$md;
    var a, b = $af47be6906de36aa$var$ld, c = b.length, d, e = "value" in $af47be6906de36aa$var$kd ? $af47be6906de36aa$var$kd.value : $af47be6906de36aa$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $af47be6906de36aa$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $af47be6906de36aa$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $af47be6906de36aa$var$pd() {
    return !0;
}
function $af47be6906de36aa$var$qd() {
    return !1;
}
function $af47be6906de36aa$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $af47be6906de36aa$var$pd : $af47be6906de36aa$var$qd;
        this.isPropagationStopped = $af47be6906de36aa$var$qd;
        return this;
    }
    $af47be6906de36aa$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $af47be6906de36aa$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $af47be6906de36aa$var$pd);
        },
        persist: function() {},
        isPersistent: $af47be6906de36aa$var$pd
    });
    return b;
}
var $af47be6906de36aa$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $af47be6906de36aa$var$td = $af47be6906de36aa$var$rd($af47be6906de36aa$var$sd), $af47be6906de36aa$var$ud = $af47be6906de36aa$var$A({}, $af47be6906de36aa$var$sd, {
    view: 0,
    detail: 0
}), $af47be6906de36aa$var$vd = $af47be6906de36aa$var$rd($af47be6906de36aa$var$ud), $af47be6906de36aa$var$wd, $af47be6906de36aa$var$xd, $af47be6906de36aa$var$yd, $af47be6906de36aa$var$Ad = $af47be6906de36aa$var$A({}, $af47be6906de36aa$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $af47be6906de36aa$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $af47be6906de36aa$var$yd && ($af47be6906de36aa$var$yd && "mousemove" === a.type ? ($af47be6906de36aa$var$wd = a.screenX - $af47be6906de36aa$var$yd.screenX, $af47be6906de36aa$var$xd = a.screenY - $af47be6906de36aa$var$yd.screenY) : $af47be6906de36aa$var$xd = $af47be6906de36aa$var$wd = 0, $af47be6906de36aa$var$yd = a);
        return $af47be6906de36aa$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $af47be6906de36aa$var$xd;
    }
}), $af47be6906de36aa$var$Bd = $af47be6906de36aa$var$rd($af47be6906de36aa$var$Ad), $af47be6906de36aa$var$Cd = $af47be6906de36aa$var$A({}, $af47be6906de36aa$var$Ad, {
    dataTransfer: 0
}), $af47be6906de36aa$var$Dd = $af47be6906de36aa$var$rd($af47be6906de36aa$var$Cd), $af47be6906de36aa$var$Ed = $af47be6906de36aa$var$A({}, $af47be6906de36aa$var$ud, {
    relatedTarget: 0
}), $af47be6906de36aa$var$Fd = $af47be6906de36aa$var$rd($af47be6906de36aa$var$Ed), $af47be6906de36aa$var$Gd = $af47be6906de36aa$var$A({}, $af47be6906de36aa$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $af47be6906de36aa$var$Hd = $af47be6906de36aa$var$rd($af47be6906de36aa$var$Gd), $af47be6906de36aa$var$Id = $af47be6906de36aa$var$A({}, $af47be6906de36aa$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $af47be6906de36aa$var$Jd = $af47be6906de36aa$var$rd($af47be6906de36aa$var$Id), $af47be6906de36aa$var$Kd = $af47be6906de36aa$var$A({}, $af47be6906de36aa$var$sd, {
    data: 0
}), $af47be6906de36aa$var$Ld = $af47be6906de36aa$var$rd($af47be6906de36aa$var$Kd), $af47be6906de36aa$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $af47be6906de36aa$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $af47be6906de36aa$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $af47be6906de36aa$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $af47be6906de36aa$var$Od[a]) ? !!b[a] : !1;
}
function $af47be6906de36aa$var$zd() {
    return $af47be6906de36aa$var$Pd;
}
var $af47be6906de36aa$var$Qd = $af47be6906de36aa$var$A({}, $af47be6906de36aa$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $af47be6906de36aa$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $af47be6906de36aa$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $af47be6906de36aa$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $af47be6906de36aa$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $af47be6906de36aa$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $af47be6906de36aa$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $af47be6906de36aa$var$Rd = $af47be6906de36aa$var$rd($af47be6906de36aa$var$Qd), $af47be6906de36aa$var$Sd = $af47be6906de36aa$var$A({}, $af47be6906de36aa$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $af47be6906de36aa$var$Td = $af47be6906de36aa$var$rd($af47be6906de36aa$var$Sd), $af47be6906de36aa$var$Ud = $af47be6906de36aa$var$A({}, $af47be6906de36aa$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $af47be6906de36aa$var$zd
}), $af47be6906de36aa$var$Vd = $af47be6906de36aa$var$rd($af47be6906de36aa$var$Ud), $af47be6906de36aa$var$Wd = $af47be6906de36aa$var$A({}, $af47be6906de36aa$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $af47be6906de36aa$var$Xd = $af47be6906de36aa$var$rd($af47be6906de36aa$var$Wd), $af47be6906de36aa$var$Yd = $af47be6906de36aa$var$A({}, $af47be6906de36aa$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $af47be6906de36aa$var$Zd = $af47be6906de36aa$var$rd($af47be6906de36aa$var$Yd), $af47be6906de36aa$var$$d = [
    9,
    13,
    27,
    32
], $af47be6906de36aa$var$ae = $af47be6906de36aa$var$ia && "CompositionEvent" in window, $af47be6906de36aa$var$be = null;
$af47be6906de36aa$var$ia && "documentMode" in document && ($af47be6906de36aa$var$be = document.documentMode);
var $af47be6906de36aa$var$ce = $af47be6906de36aa$var$ia && "TextEvent" in window && !$af47be6906de36aa$var$be, $af47be6906de36aa$var$de = $af47be6906de36aa$var$ia && (!$af47be6906de36aa$var$ae || $af47be6906de36aa$var$be && 8 < $af47be6906de36aa$var$be && 11 >= $af47be6906de36aa$var$be), $af47be6906de36aa$var$ee = String.fromCharCode(32), $af47be6906de36aa$var$fe = !1;
function $af47be6906de36aa$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $af47be6906de36aa$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $af47be6906de36aa$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $af47be6906de36aa$var$ie = !1;
function $af47be6906de36aa$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $af47be6906de36aa$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $af47be6906de36aa$var$fe = !0;
            return $af47be6906de36aa$var$ee;
        case "textInput":
            return a = b.data, a === $af47be6906de36aa$var$ee && $af47be6906de36aa$var$fe ? null : a;
        default:
            return null;
    }
}
function $af47be6906de36aa$var$ke(a, b) {
    if ($af47be6906de36aa$var$ie) return "compositionend" === a || !$af47be6906de36aa$var$ae && $af47be6906de36aa$var$ge(a, b) ? (a = $af47be6906de36aa$var$nd(), $af47be6906de36aa$var$md = $af47be6906de36aa$var$ld = $af47be6906de36aa$var$kd = null, $af47be6906de36aa$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $af47be6906de36aa$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $af47be6906de36aa$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $af47be6906de36aa$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$af47be6906de36aa$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $af47be6906de36aa$var$ne(a, b, c, d) {
    $af47be6906de36aa$var$Eb(d);
    b = $af47be6906de36aa$var$oe(b, "onChange");
    0 < b.length && (c = new $af47be6906de36aa$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $af47be6906de36aa$var$pe = null, $af47be6906de36aa$var$qe = null;
function $af47be6906de36aa$var$re(a) {
    $af47be6906de36aa$var$se(a, 0);
}
function $af47be6906de36aa$var$te(a) {
    var b = $af47be6906de36aa$var$ue(a);
    if ($af47be6906de36aa$var$Wa(b)) return a;
}
function $af47be6906de36aa$var$ve(a, b) {
    if ("change" === a) return b;
}
var $af47be6906de36aa$var$we = !1;
if ($af47be6906de36aa$var$ia) {
    var $af47be6906de36aa$var$xe;
    if ($af47be6906de36aa$var$ia) {
        var $af47be6906de36aa$var$ye = "oninput" in document;
        if (!$af47be6906de36aa$var$ye) {
            var $af47be6906de36aa$var$ze = document.createElement("div");
            $af47be6906de36aa$var$ze.setAttribute("oninput", "return;");
            $af47be6906de36aa$var$ye = "function" === typeof $af47be6906de36aa$var$ze.oninput;
        }
        $af47be6906de36aa$var$xe = $af47be6906de36aa$var$ye;
    } else $af47be6906de36aa$var$xe = !1;
    $af47be6906de36aa$var$we = $af47be6906de36aa$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $af47be6906de36aa$var$Ae() {
    $af47be6906de36aa$var$pe && ($af47be6906de36aa$var$pe.detachEvent("onpropertychange", $af47be6906de36aa$var$Be), $af47be6906de36aa$var$qe = $af47be6906de36aa$var$pe = null);
}
function $af47be6906de36aa$var$Be(a) {
    if ("value" === a.propertyName && $af47be6906de36aa$var$te($af47be6906de36aa$var$qe)) {
        var b = [];
        $af47be6906de36aa$var$ne(b, $af47be6906de36aa$var$qe, a, $af47be6906de36aa$var$xb(a));
        $af47be6906de36aa$var$Jb($af47be6906de36aa$var$re, b);
    }
}
function $af47be6906de36aa$var$Ce(a, b, c) {
    "focusin" === a ? ($af47be6906de36aa$var$Ae(), $af47be6906de36aa$var$pe = b, $af47be6906de36aa$var$qe = c, $af47be6906de36aa$var$pe.attachEvent("onpropertychange", $af47be6906de36aa$var$Be)) : "focusout" === a && $af47be6906de36aa$var$Ae();
}
function $af47be6906de36aa$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $af47be6906de36aa$var$te($af47be6906de36aa$var$qe);
}
function $af47be6906de36aa$var$Ee(a, b) {
    if ("click" === a) return $af47be6906de36aa$var$te(b);
}
function $af47be6906de36aa$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $af47be6906de36aa$var$te(b);
}
function $af47be6906de36aa$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $af47be6906de36aa$var$He = "function" === typeof Object.is ? Object.is : $af47be6906de36aa$var$Ge;
function $af47be6906de36aa$var$Ie(a, b) {
    if ($af47be6906de36aa$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$af47be6906de36aa$var$ja.call(b, e) || !$af47be6906de36aa$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $af47be6906de36aa$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $af47be6906de36aa$var$Ke(a, b) {
    var c = $af47be6906de36aa$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $af47be6906de36aa$var$Je(c);
    }
}
function $af47be6906de36aa$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $af47be6906de36aa$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $af47be6906de36aa$var$Me() {
    for(var a = window, b = $af47be6906de36aa$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $af47be6906de36aa$var$Xa(a.document);
    }
    return b;
}
function $af47be6906de36aa$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $af47be6906de36aa$var$Oe(a) {
    var b = $af47be6906de36aa$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $af47be6906de36aa$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $af47be6906de36aa$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $af47be6906de36aa$var$Ke(c, f);
                var g = $af47be6906de36aa$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $af47be6906de36aa$var$Pe = $af47be6906de36aa$var$ia && "documentMode" in document && 11 >= document.documentMode, $af47be6906de36aa$var$Qe = null, $af47be6906de36aa$var$Re = null, $af47be6906de36aa$var$Se = null, $af47be6906de36aa$var$Te = !1;
function $af47be6906de36aa$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $af47be6906de36aa$var$Te || null == $af47be6906de36aa$var$Qe || $af47be6906de36aa$var$Qe !== $af47be6906de36aa$var$Xa(d) || (d = $af47be6906de36aa$var$Qe, "selectionStart" in d && $af47be6906de36aa$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $af47be6906de36aa$var$Se && $af47be6906de36aa$var$Ie($af47be6906de36aa$var$Se, d) || ($af47be6906de36aa$var$Se = d, d = $af47be6906de36aa$var$oe($af47be6906de36aa$var$Re, "onSelect"), 0 < d.length && (b = new $af47be6906de36aa$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $af47be6906de36aa$var$Qe)));
}
function $af47be6906de36aa$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $af47be6906de36aa$var$We = {
    animationend: $af47be6906de36aa$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $af47be6906de36aa$var$Ve("Animation", "AnimationIteration"),
    animationstart: $af47be6906de36aa$var$Ve("Animation", "AnimationStart"),
    transitionend: $af47be6906de36aa$var$Ve("Transition", "TransitionEnd")
}, $af47be6906de36aa$var$Xe = {}, $af47be6906de36aa$var$Ye = {};
$af47be6906de36aa$var$ia && ($af47be6906de36aa$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $af47be6906de36aa$var$We.animationend.animation, delete $af47be6906de36aa$var$We.animationiteration.animation, delete $af47be6906de36aa$var$We.animationstart.animation), "TransitionEvent" in window || delete $af47be6906de36aa$var$We.transitionend.transition);
function $af47be6906de36aa$var$Ze(a) {
    if ($af47be6906de36aa$var$Xe[a]) return $af47be6906de36aa$var$Xe[a];
    if (!$af47be6906de36aa$var$We[a]) return a;
    var b = $af47be6906de36aa$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $af47be6906de36aa$var$Ye) return $af47be6906de36aa$var$Xe[a] = b[c];
    return a;
}
var $af47be6906de36aa$var$$e = $af47be6906de36aa$var$Ze("animationend"), $af47be6906de36aa$var$af = $af47be6906de36aa$var$Ze("animationiteration"), $af47be6906de36aa$var$bf = $af47be6906de36aa$var$Ze("animationstart"), $af47be6906de36aa$var$cf = $af47be6906de36aa$var$Ze("transitionend"), $af47be6906de36aa$var$df = new Map, $af47be6906de36aa$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $af47be6906de36aa$var$ff(a, b) {
    $af47be6906de36aa$var$df.set(a, b);
    $af47be6906de36aa$var$fa(b, [
        a
    ]);
}
for(var $af47be6906de36aa$var$gf = 0; $af47be6906de36aa$var$gf < $af47be6906de36aa$var$ef.length; $af47be6906de36aa$var$gf++){
    var $af47be6906de36aa$var$hf = $af47be6906de36aa$var$ef[$af47be6906de36aa$var$gf], $af47be6906de36aa$var$jf = $af47be6906de36aa$var$hf.toLowerCase(), $af47be6906de36aa$var$kf = $af47be6906de36aa$var$hf[0].toUpperCase() + $af47be6906de36aa$var$hf.slice(1);
    $af47be6906de36aa$var$ff($af47be6906de36aa$var$jf, "on" + $af47be6906de36aa$var$kf);
}
$af47be6906de36aa$var$ff($af47be6906de36aa$var$$e, "onAnimationEnd");
$af47be6906de36aa$var$ff($af47be6906de36aa$var$af, "onAnimationIteration");
$af47be6906de36aa$var$ff($af47be6906de36aa$var$bf, "onAnimationStart");
$af47be6906de36aa$var$ff("dblclick", "onDoubleClick");
$af47be6906de36aa$var$ff("focusin", "onFocus");
$af47be6906de36aa$var$ff("focusout", "onBlur");
$af47be6906de36aa$var$ff($af47be6906de36aa$var$cf, "onTransitionEnd");
$af47be6906de36aa$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$af47be6906de36aa$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$af47be6906de36aa$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$af47be6906de36aa$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$af47be6906de36aa$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$af47be6906de36aa$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$af47be6906de36aa$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$af47be6906de36aa$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$af47be6906de36aa$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$af47be6906de36aa$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $af47be6906de36aa$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $af47be6906de36aa$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($af47be6906de36aa$var$lf));
function $af47be6906de36aa$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $af47be6906de36aa$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $af47be6906de36aa$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $af47be6906de36aa$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $af47be6906de36aa$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($af47be6906de36aa$var$Qb) throw a = $af47be6906de36aa$var$Rb, $af47be6906de36aa$var$Qb = !1, $af47be6906de36aa$var$Rb = null, a;
}
function $af47be6906de36aa$var$D(a, b) {
    var c = b[$af47be6906de36aa$var$of];
    void 0 === c && (c = b[$af47be6906de36aa$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($af47be6906de36aa$var$pf(b, a, 2, !1), c.add(d));
}
function $af47be6906de36aa$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $af47be6906de36aa$var$pf(c, a, d, b);
}
var $af47be6906de36aa$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $af47be6906de36aa$var$sf(a) {
    if (!a[$af47be6906de36aa$var$rf]) {
        a[$af47be6906de36aa$var$rf] = !0;
        $af47be6906de36aa$var$da.forEach(function(b) {
            "selectionchange" !== b && ($af47be6906de36aa$var$mf.has(b) || $af47be6906de36aa$var$qf(b, !1, a), $af47be6906de36aa$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$af47be6906de36aa$var$rf] || (b[$af47be6906de36aa$var$rf] = !0, $af47be6906de36aa$var$qf("selectionchange", !1, b));
    }
}
function $af47be6906de36aa$var$pf(a, b, c, d) {
    switch($af47be6906de36aa$var$jd(b)){
        case 1:
            var e = $af47be6906de36aa$var$ed;
            break;
        case 4:
            e = $af47be6906de36aa$var$gd;
            break;
        default:
            e = $af47be6906de36aa$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$af47be6906de36aa$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $af47be6906de36aa$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $af47be6906de36aa$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $af47be6906de36aa$var$Jb(function() {
        var d = f, e = $af47be6906de36aa$var$xb(c), g = [];
        a: {
            var h = $af47be6906de36aa$var$df.get(a);
            if (void 0 !== h) {
                var k = $af47be6906de36aa$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $af47be6906de36aa$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $af47be6906de36aa$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $af47be6906de36aa$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $af47be6906de36aa$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $af47be6906de36aa$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $af47be6906de36aa$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $af47be6906de36aa$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $af47be6906de36aa$var$Vd;
                        break;
                    case $af47be6906de36aa$var$$e:
                    case $af47be6906de36aa$var$af:
                    case $af47be6906de36aa$var$bf:
                        k = $af47be6906de36aa$var$Hd;
                        break;
                    case $af47be6906de36aa$var$cf:
                        k = $af47be6906de36aa$var$Xd;
                        break;
                    case "scroll":
                        k = $af47be6906de36aa$var$vd;
                        break;
                    case "wheel":
                        k = $af47be6906de36aa$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $af47be6906de36aa$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $af47be6906de36aa$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $af47be6906de36aa$var$Kb(w, x), null != F && t.push($af47be6906de36aa$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $af47be6906de36aa$var$wb && (n = c.relatedTarget || c.fromElement) && ($af47be6906de36aa$var$Wc(n) || n[$af47be6906de36aa$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $af47be6906de36aa$var$Wc(n) : null, null !== n && (J = $af47be6906de36aa$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $af47be6906de36aa$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $af47be6906de36aa$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $af47be6906de36aa$var$ue(k);
                        u = null == n ? h : $af47be6906de36aa$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $af47be6906de36aa$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $af47be6906de36aa$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $af47be6906de36aa$var$vf(F))u++;
                            for(; 0 < w - u;)t = $af47be6906de36aa$var$vf(t), w--;
                            for(; 0 < u - w;)x = $af47be6906de36aa$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $af47be6906de36aa$var$vf(t);
                                x = $af47be6906de36aa$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $af47be6906de36aa$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $af47be6906de36aa$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $af47be6906de36aa$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $af47be6906de36aa$var$ve;
                else if ($af47be6906de36aa$var$me(h)) {
                    if ($af47be6906de36aa$var$we) na = $af47be6906de36aa$var$Fe;
                    else {
                        na = $af47be6906de36aa$var$De;
                        var xa = $af47be6906de36aa$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $af47be6906de36aa$var$Ee);
                if (na && (na = na(a, d))) {
                    $af47be6906de36aa$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $af47be6906de36aa$var$cb(h, "number", h.value);
            }
            xa = d ? $af47be6906de36aa$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($af47be6906de36aa$var$me(xa) || "true" === xa.contentEditable) $af47be6906de36aa$var$Qe = xa, $af47be6906de36aa$var$Re = d, $af47be6906de36aa$var$Se = null;
                    break;
                case "focusout":
                    $af47be6906de36aa$var$Se = $af47be6906de36aa$var$Re = $af47be6906de36aa$var$Qe = null;
                    break;
                case "mousedown":
                    $af47be6906de36aa$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $af47be6906de36aa$var$Te = !1;
                    $af47be6906de36aa$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($af47be6906de36aa$var$Pe) break;
                case "keydown":
                case "keyup":
                    $af47be6906de36aa$var$Ue(g, c, e);
            }
            var $a;
            if ($af47be6906de36aa$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $af47be6906de36aa$var$ie ? $af47be6906de36aa$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($af47be6906de36aa$var$de && "ko" !== c.locale && ($af47be6906de36aa$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $af47be6906de36aa$var$ie && ($a = $af47be6906de36aa$var$nd()) : ($af47be6906de36aa$var$kd = e, $af47be6906de36aa$var$ld = "value" in $af47be6906de36aa$var$kd ? $af47be6906de36aa$var$kd.value : $af47be6906de36aa$var$kd.textContent, $af47be6906de36aa$var$ie = !0)), xa = $af47be6906de36aa$var$oe(d, ba), 0 < xa.length && (ba = new $af47be6906de36aa$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $af47be6906de36aa$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $af47be6906de36aa$var$ce ? $af47be6906de36aa$var$je(a, c) : $af47be6906de36aa$var$ke(a, c)) d = $af47be6906de36aa$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $af47be6906de36aa$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $af47be6906de36aa$var$se(g, b);
    });
}
function $af47be6906de36aa$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $af47be6906de36aa$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $af47be6906de36aa$var$Kb(a, c), null != f && d.unshift($af47be6906de36aa$var$tf(a, f, e)), f = $af47be6906de36aa$var$Kb(a, b), null != f && d.push($af47be6906de36aa$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $af47be6906de36aa$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $af47be6906de36aa$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $af47be6906de36aa$var$Kb(c, f), null != k && g.unshift($af47be6906de36aa$var$tf(c, k, h))) : e || (k = $af47be6906de36aa$var$Kb(c, f), null != k && g.push($af47be6906de36aa$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $af47be6906de36aa$var$xf = /\r\n?/g, $af47be6906de36aa$var$yf = /\u0000|\uFFFD/g;
function $af47be6906de36aa$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($af47be6906de36aa$var$xf, "\n").replace($af47be6906de36aa$var$yf, "");
}
function $af47be6906de36aa$var$Af(a, b, c) {
    b = $af47be6906de36aa$var$zf(b);
    if ($af47be6906de36aa$var$zf(a) !== b && c) throw Error($af47be6906de36aa$var$p(425));
}
function $af47be6906de36aa$var$Bf() {}
var $af47be6906de36aa$var$Cf = null, $af47be6906de36aa$var$Df = null;
function $af47be6906de36aa$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $af47be6906de36aa$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $af47be6906de36aa$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $af47be6906de36aa$var$Hf = "function" === typeof Promise ? Promise : void 0, $af47be6906de36aa$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $af47be6906de36aa$var$Hf ? function(a) {
    return $af47be6906de36aa$var$Hf.resolve(null).then(a).catch($af47be6906de36aa$var$If);
} : $af47be6906de36aa$var$Ff;
function $af47be6906de36aa$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $af47be6906de36aa$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $af47be6906de36aa$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $af47be6906de36aa$var$bd(b);
}
function $af47be6906de36aa$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $af47be6906de36aa$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $af47be6906de36aa$var$Nf = Math.random().toString(36).slice(2), $af47be6906de36aa$var$Of = "__reactFiber$" + $af47be6906de36aa$var$Nf, $af47be6906de36aa$var$Pf = "__reactProps$" + $af47be6906de36aa$var$Nf, $af47be6906de36aa$var$uf = "__reactContainer$" + $af47be6906de36aa$var$Nf, $af47be6906de36aa$var$of = "__reactEvents$" + $af47be6906de36aa$var$Nf, $af47be6906de36aa$var$Qf = "__reactListeners$" + $af47be6906de36aa$var$Nf, $af47be6906de36aa$var$Rf = "__reactHandles$" + $af47be6906de36aa$var$Nf;
function $af47be6906de36aa$var$Wc(a) {
    var b = a[$af47be6906de36aa$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$af47be6906de36aa$var$uf] || c[$af47be6906de36aa$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $af47be6906de36aa$var$Mf(a); null !== a;){
                if (c = a[$af47be6906de36aa$var$Of]) return c;
                a = $af47be6906de36aa$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $af47be6906de36aa$var$Cb(a) {
    a = a[$af47be6906de36aa$var$Of] || a[$af47be6906de36aa$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $af47be6906de36aa$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($af47be6906de36aa$var$p(33));
}
function $af47be6906de36aa$var$Db(a) {
    return a[$af47be6906de36aa$var$Pf] || null;
}
var $af47be6906de36aa$var$Sf = [], $af47be6906de36aa$var$Tf = -1;
function $af47be6906de36aa$var$Uf(a) {
    return {
        current: a
    };
}
function $af47be6906de36aa$var$E(a) {
    0 > $af47be6906de36aa$var$Tf || (a.current = $af47be6906de36aa$var$Sf[$af47be6906de36aa$var$Tf], $af47be6906de36aa$var$Sf[$af47be6906de36aa$var$Tf] = null, $af47be6906de36aa$var$Tf--);
}
function $af47be6906de36aa$var$G(a, b) {
    $af47be6906de36aa$var$Tf++;
    $af47be6906de36aa$var$Sf[$af47be6906de36aa$var$Tf] = a.current;
    a.current = b;
}
var $af47be6906de36aa$var$Vf = {}, $af47be6906de36aa$var$H = $af47be6906de36aa$var$Uf($af47be6906de36aa$var$Vf), $af47be6906de36aa$var$Wf = $af47be6906de36aa$var$Uf(!1), $af47be6906de36aa$var$Xf = $af47be6906de36aa$var$Vf;
function $af47be6906de36aa$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $af47be6906de36aa$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $af47be6906de36aa$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $af47be6906de36aa$var$$f() {
    $af47be6906de36aa$var$E($af47be6906de36aa$var$Wf);
    $af47be6906de36aa$var$E($af47be6906de36aa$var$H);
}
function $af47be6906de36aa$var$ag(a, b, c) {
    if ($af47be6906de36aa$var$H.current !== $af47be6906de36aa$var$Vf) throw Error($af47be6906de36aa$var$p(168));
    $af47be6906de36aa$var$G($af47be6906de36aa$var$H, b);
    $af47be6906de36aa$var$G($af47be6906de36aa$var$Wf, c);
}
function $af47be6906de36aa$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($af47be6906de36aa$var$p(108, $af47be6906de36aa$var$Ra(a) || "Unknown", e));
    return $af47be6906de36aa$var$A({}, c, d);
}
function $af47be6906de36aa$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $af47be6906de36aa$var$Vf;
    $af47be6906de36aa$var$Xf = $af47be6906de36aa$var$H.current;
    $af47be6906de36aa$var$G($af47be6906de36aa$var$H, a);
    $af47be6906de36aa$var$G($af47be6906de36aa$var$Wf, $af47be6906de36aa$var$Wf.current);
    return !0;
}
function $af47be6906de36aa$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($af47be6906de36aa$var$p(169));
    c ? (a = $af47be6906de36aa$var$bg(a, b, $af47be6906de36aa$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $af47be6906de36aa$var$E($af47be6906de36aa$var$Wf), $af47be6906de36aa$var$E($af47be6906de36aa$var$H), $af47be6906de36aa$var$G($af47be6906de36aa$var$H, a)) : $af47be6906de36aa$var$E($af47be6906de36aa$var$Wf);
    $af47be6906de36aa$var$G($af47be6906de36aa$var$Wf, c);
}
var $af47be6906de36aa$var$eg = null, $af47be6906de36aa$var$fg = !1, $af47be6906de36aa$var$gg = !1;
function $af47be6906de36aa$var$hg(a) {
    null === $af47be6906de36aa$var$eg ? $af47be6906de36aa$var$eg = [
        a
    ] : $af47be6906de36aa$var$eg.push(a);
}
function $af47be6906de36aa$var$ig(a) {
    $af47be6906de36aa$var$fg = !0;
    $af47be6906de36aa$var$hg(a);
}
function $af47be6906de36aa$var$jg() {
    if (!$af47be6906de36aa$var$gg && null !== $af47be6906de36aa$var$eg) {
        $af47be6906de36aa$var$gg = !0;
        var a = 0, b = $af47be6906de36aa$var$C;
        try {
            var c = $af47be6906de36aa$var$eg;
            for($af47be6906de36aa$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $af47be6906de36aa$var$eg = null;
            $af47be6906de36aa$var$fg = !1;
        } catch (e) {
            throw null !== $af47be6906de36aa$var$eg && ($af47be6906de36aa$var$eg = $af47be6906de36aa$var$eg.slice(a + 1)), $af47be6906de36aa$var$ac($af47be6906de36aa$var$fc, $af47be6906de36aa$var$jg), e;
        } finally{
            $af47be6906de36aa$var$C = b, $af47be6906de36aa$var$gg = !1;
        }
    }
    return null;
}
var $af47be6906de36aa$var$kg = [], $af47be6906de36aa$var$lg = 0, $af47be6906de36aa$var$mg = null, $af47be6906de36aa$var$ng = 0, $af47be6906de36aa$var$og = [], $af47be6906de36aa$var$pg = 0, $af47be6906de36aa$var$qg = null, $af47be6906de36aa$var$rg = 1, $af47be6906de36aa$var$sg = "";
function $af47be6906de36aa$var$tg(a, b) {
    $af47be6906de36aa$var$kg[$af47be6906de36aa$var$lg++] = $af47be6906de36aa$var$ng;
    $af47be6906de36aa$var$kg[$af47be6906de36aa$var$lg++] = $af47be6906de36aa$var$mg;
    $af47be6906de36aa$var$mg = a;
    $af47be6906de36aa$var$ng = b;
}
function $af47be6906de36aa$var$ug(a, b, c) {
    $af47be6906de36aa$var$og[$af47be6906de36aa$var$pg++] = $af47be6906de36aa$var$rg;
    $af47be6906de36aa$var$og[$af47be6906de36aa$var$pg++] = $af47be6906de36aa$var$sg;
    $af47be6906de36aa$var$og[$af47be6906de36aa$var$pg++] = $af47be6906de36aa$var$qg;
    $af47be6906de36aa$var$qg = a;
    var d = $af47be6906de36aa$var$rg;
    a = $af47be6906de36aa$var$sg;
    var e = 32 - $af47be6906de36aa$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $af47be6906de36aa$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $af47be6906de36aa$var$rg = 1 << 32 - $af47be6906de36aa$var$oc(b) + e | c << e | d;
        $af47be6906de36aa$var$sg = f + a;
    } else $af47be6906de36aa$var$rg = 1 << f | c << e | d, $af47be6906de36aa$var$sg = a;
}
function $af47be6906de36aa$var$vg(a) {
    null !== a.return && ($af47be6906de36aa$var$tg(a, 1), $af47be6906de36aa$var$ug(a, 1, 0));
}
function $af47be6906de36aa$var$wg(a) {
    for(; a === $af47be6906de36aa$var$mg;)$af47be6906de36aa$var$mg = $af47be6906de36aa$var$kg[--$af47be6906de36aa$var$lg], $af47be6906de36aa$var$kg[$af47be6906de36aa$var$lg] = null, $af47be6906de36aa$var$ng = $af47be6906de36aa$var$kg[--$af47be6906de36aa$var$lg], $af47be6906de36aa$var$kg[$af47be6906de36aa$var$lg] = null;
    for(; a === $af47be6906de36aa$var$qg;)$af47be6906de36aa$var$qg = $af47be6906de36aa$var$og[--$af47be6906de36aa$var$pg], $af47be6906de36aa$var$og[$af47be6906de36aa$var$pg] = null, $af47be6906de36aa$var$sg = $af47be6906de36aa$var$og[--$af47be6906de36aa$var$pg], $af47be6906de36aa$var$og[$af47be6906de36aa$var$pg] = null, $af47be6906de36aa$var$rg = $af47be6906de36aa$var$og[--$af47be6906de36aa$var$pg], $af47be6906de36aa$var$og[$af47be6906de36aa$var$pg] = null;
}
var $af47be6906de36aa$var$xg = null, $af47be6906de36aa$var$yg = null, $af47be6906de36aa$var$I = !1, $af47be6906de36aa$var$zg = null;
function $af47be6906de36aa$var$Ag(a, b) {
    var c = $af47be6906de36aa$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $af47be6906de36aa$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $af47be6906de36aa$var$xg = a, $af47be6906de36aa$var$yg = $af47be6906de36aa$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $af47be6906de36aa$var$xg = a, $af47be6906de36aa$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $af47be6906de36aa$var$qg ? {
                id: $af47be6906de36aa$var$rg,
                overflow: $af47be6906de36aa$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $af47be6906de36aa$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $af47be6906de36aa$var$xg = a, $af47be6906de36aa$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $af47be6906de36aa$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $af47be6906de36aa$var$Eg(a) {
    if ($af47be6906de36aa$var$I) {
        var b = $af47be6906de36aa$var$yg;
        if (b) {
            var c = b;
            if (!$af47be6906de36aa$var$Cg(a, b)) {
                if ($af47be6906de36aa$var$Dg(a)) throw Error($af47be6906de36aa$var$p(418));
                b = $af47be6906de36aa$var$Lf(c.nextSibling);
                var d = $af47be6906de36aa$var$xg;
                b && $af47be6906de36aa$var$Cg(a, b) ? $af47be6906de36aa$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $af47be6906de36aa$var$I = !1, $af47be6906de36aa$var$xg = a);
            }
        } else {
            if ($af47be6906de36aa$var$Dg(a)) throw Error($af47be6906de36aa$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $af47be6906de36aa$var$I = !1;
            $af47be6906de36aa$var$xg = a;
        }
    }
}
function $af47be6906de36aa$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $af47be6906de36aa$var$xg = a;
}
function $af47be6906de36aa$var$Gg(a) {
    if (a !== $af47be6906de36aa$var$xg) return !1;
    if (!$af47be6906de36aa$var$I) return $af47be6906de36aa$var$Fg(a), $af47be6906de36aa$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$af47be6906de36aa$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $af47be6906de36aa$var$yg)) {
        if ($af47be6906de36aa$var$Dg(a)) throw $af47be6906de36aa$var$Hg(), Error($af47be6906de36aa$var$p(418));
        for(; b;)$af47be6906de36aa$var$Ag(a, b), b = $af47be6906de36aa$var$Lf(b.nextSibling);
    }
    $af47be6906de36aa$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($af47be6906de36aa$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $af47be6906de36aa$var$yg = $af47be6906de36aa$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $af47be6906de36aa$var$yg = null;
        }
    } else $af47be6906de36aa$var$yg = $af47be6906de36aa$var$xg ? $af47be6906de36aa$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $af47be6906de36aa$var$Hg() {
    for(var a = $af47be6906de36aa$var$yg; a;)a = $af47be6906de36aa$var$Lf(a.nextSibling);
}
function $af47be6906de36aa$var$Ig() {
    $af47be6906de36aa$var$yg = $af47be6906de36aa$var$xg = null;
    $af47be6906de36aa$var$I = !1;
}
function $af47be6906de36aa$var$Jg(a) {
    null === $af47be6906de36aa$var$zg ? $af47be6906de36aa$var$zg = [
        a
    ] : $af47be6906de36aa$var$zg.push(a);
}
var $af47be6906de36aa$var$Kg = $af47be6906de36aa$var$ua.ReactCurrentBatchConfig;
function $af47be6906de36aa$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($af47be6906de36aa$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($af47be6906de36aa$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($af47be6906de36aa$var$p(284));
        if (!c._owner) throw Error($af47be6906de36aa$var$p(290, a));
    }
    return a;
}
function $af47be6906de36aa$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($af47be6906de36aa$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $af47be6906de36aa$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $af47be6906de36aa$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $af47be6906de36aa$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $af47be6906de36aa$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $af47be6906de36aa$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $af47be6906de36aa$var$Ha && $af47be6906de36aa$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $af47be6906de36aa$var$Lg(a, b, c), d.return = a, d;
        d = $af47be6906de36aa$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $af47be6906de36aa$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $af47be6906de36aa$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $af47be6906de36aa$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $af47be6906de36aa$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $af47be6906de36aa$var$va:
                    return c = $af47be6906de36aa$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $af47be6906de36aa$var$Lg(a, null, b), c.return = a, c;
                case $af47be6906de36aa$var$wa:
                    return b = $af47be6906de36aa$var$Sg(b, a.mode, c), b.return = a, b;
                case $af47be6906de36aa$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($af47be6906de36aa$var$eb(b) || $af47be6906de36aa$var$Ka(b)) return b = $af47be6906de36aa$var$Tg(b, a.mode, c, null), b.return = a, b;
            $af47be6906de36aa$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $af47be6906de36aa$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $af47be6906de36aa$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $af47be6906de36aa$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($af47be6906de36aa$var$eb(c) || $af47be6906de36aa$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $af47be6906de36aa$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $af47be6906de36aa$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $af47be6906de36aa$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $af47be6906de36aa$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($af47be6906de36aa$var$eb(d) || $af47be6906de36aa$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $af47be6906de36aa$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $af47be6906de36aa$var$I && $af47be6906de36aa$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $af47be6906de36aa$var$I && $af47be6906de36aa$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $af47be6906de36aa$var$I && $af47be6906de36aa$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $af47be6906de36aa$var$Ka(h);
        if ("function" !== typeof l) throw Error($af47be6906de36aa$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($af47be6906de36aa$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $af47be6906de36aa$var$I && $af47be6906de36aa$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $af47be6906de36aa$var$I && $af47be6906de36aa$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $af47be6906de36aa$var$I && $af47be6906de36aa$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $af47be6906de36aa$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $af47be6906de36aa$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $af47be6906de36aa$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $af47be6906de36aa$var$Ha && $af47be6906de36aa$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $af47be6906de36aa$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $af47be6906de36aa$var$ya ? (d = $af47be6906de36aa$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $af47be6906de36aa$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $af47be6906de36aa$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $af47be6906de36aa$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $af47be6906de36aa$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $af47be6906de36aa$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($af47be6906de36aa$var$eb(f)) return n(a, d, f, h);
            if ($af47be6906de36aa$var$Ka(f)) return t(a, d, f, h);
            $af47be6906de36aa$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $af47be6906de36aa$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $af47be6906de36aa$var$Ug = $af47be6906de36aa$var$Og(!0), $af47be6906de36aa$var$Vg = $af47be6906de36aa$var$Og(!1), $af47be6906de36aa$var$Wg = $af47be6906de36aa$var$Uf(null), $af47be6906de36aa$var$Xg = null, $af47be6906de36aa$var$Yg = null, $af47be6906de36aa$var$Zg = null;
function $af47be6906de36aa$var$$g() {
    $af47be6906de36aa$var$Zg = $af47be6906de36aa$var$Yg = $af47be6906de36aa$var$Xg = null;
}
function $af47be6906de36aa$var$ah(a) {
    var b = $af47be6906de36aa$var$Wg.current;
    $af47be6906de36aa$var$E($af47be6906de36aa$var$Wg);
    a._currentValue = b;
}
function $af47be6906de36aa$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $af47be6906de36aa$var$ch(a, b) {
    $af47be6906de36aa$var$Xg = a;
    $af47be6906de36aa$var$Zg = $af47be6906de36aa$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($af47be6906de36aa$var$dh = !0), a.firstContext = null);
}
function $af47be6906de36aa$var$eh(a) {
    var b = a._currentValue;
    if ($af47be6906de36aa$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $af47be6906de36aa$var$Yg) {
            if (null === $af47be6906de36aa$var$Xg) throw Error($af47be6906de36aa$var$p(308));
            $af47be6906de36aa$var$Yg = a;
            $af47be6906de36aa$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $af47be6906de36aa$var$Yg = $af47be6906de36aa$var$Yg.next = a;
    }
    return b;
}
var $af47be6906de36aa$var$fh = null;
function $af47be6906de36aa$var$gh(a) {
    null === $af47be6906de36aa$var$fh ? $af47be6906de36aa$var$fh = [
        a
    ] : $af47be6906de36aa$var$fh.push(a);
}
function $af47be6906de36aa$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $af47be6906de36aa$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $af47be6906de36aa$var$ih(a, d);
}
function $af47be6906de36aa$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $af47be6906de36aa$var$jh = !1;
function $af47be6906de36aa$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $af47be6906de36aa$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $af47be6906de36aa$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $af47be6906de36aa$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($af47be6906de36aa$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $af47be6906de36aa$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $af47be6906de36aa$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $af47be6906de36aa$var$ih(a, c);
}
function $af47be6906de36aa$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $af47be6906de36aa$var$Cc(a, c);
    }
}
function $af47be6906de36aa$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $af47be6906de36aa$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $af47be6906de36aa$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $af47be6906de36aa$var$A({}, q, r);
                            break a;
                        case 2:
                            $af47be6906de36aa$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $af47be6906de36aa$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $af47be6906de36aa$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($af47be6906de36aa$var$p(191, e));
            e.call(d);
        }
    }
}
var $af47be6906de36aa$var$th = {}, $af47be6906de36aa$var$uh = $af47be6906de36aa$var$Uf($af47be6906de36aa$var$th), $af47be6906de36aa$var$vh = $af47be6906de36aa$var$Uf($af47be6906de36aa$var$th), $af47be6906de36aa$var$wh = $af47be6906de36aa$var$Uf($af47be6906de36aa$var$th);
function $af47be6906de36aa$var$xh(a) {
    if (a === $af47be6906de36aa$var$th) throw Error($af47be6906de36aa$var$p(174));
    return a;
}
function $af47be6906de36aa$var$yh(a, b) {
    $af47be6906de36aa$var$G($af47be6906de36aa$var$wh, b);
    $af47be6906de36aa$var$G($af47be6906de36aa$var$vh, a);
    $af47be6906de36aa$var$G($af47be6906de36aa$var$uh, $af47be6906de36aa$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $af47be6906de36aa$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $af47be6906de36aa$var$lb(b, a);
    }
    $af47be6906de36aa$var$E($af47be6906de36aa$var$uh);
    $af47be6906de36aa$var$G($af47be6906de36aa$var$uh, b);
}
function $af47be6906de36aa$var$zh() {
    $af47be6906de36aa$var$E($af47be6906de36aa$var$uh);
    $af47be6906de36aa$var$E($af47be6906de36aa$var$vh);
    $af47be6906de36aa$var$E($af47be6906de36aa$var$wh);
}
function $af47be6906de36aa$var$Ah(a) {
    $af47be6906de36aa$var$xh($af47be6906de36aa$var$wh.current);
    var b = $af47be6906de36aa$var$xh($af47be6906de36aa$var$uh.current);
    var c = $af47be6906de36aa$var$lb(b, a.type);
    b !== c && ($af47be6906de36aa$var$G($af47be6906de36aa$var$vh, a), $af47be6906de36aa$var$G($af47be6906de36aa$var$uh, c));
}
function $af47be6906de36aa$var$Bh(a) {
    $af47be6906de36aa$var$vh.current === a && ($af47be6906de36aa$var$E($af47be6906de36aa$var$uh), $af47be6906de36aa$var$E($af47be6906de36aa$var$vh));
}
var $af47be6906de36aa$var$L = $af47be6906de36aa$var$Uf(0);
function $af47be6906de36aa$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $af47be6906de36aa$var$Dh = [];
function $af47be6906de36aa$var$Eh() {
    for(var a = 0; a < $af47be6906de36aa$var$Dh.length; a++)$af47be6906de36aa$var$Dh[a]._workInProgressVersionPrimary = null;
    $af47be6906de36aa$var$Dh.length = 0;
}
var $af47be6906de36aa$var$Fh = $af47be6906de36aa$var$ua.ReactCurrentDispatcher, $af47be6906de36aa$var$Gh = $af47be6906de36aa$var$ua.ReactCurrentBatchConfig, $af47be6906de36aa$var$Hh = 0, $af47be6906de36aa$var$M = null, $af47be6906de36aa$var$N = null, $af47be6906de36aa$var$O = null, $af47be6906de36aa$var$Ih = !1, $af47be6906de36aa$var$Jh = !1, $af47be6906de36aa$var$Kh = 0, $af47be6906de36aa$var$Lh = 0;
function $af47be6906de36aa$var$P() {
    throw Error($af47be6906de36aa$var$p(321));
}
function $af47be6906de36aa$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$af47be6906de36aa$var$He(a[c], b[c])) return !1;
    return !0;
}
function $af47be6906de36aa$var$Nh(a, b, c, d, e, f) {
    $af47be6906de36aa$var$Hh = f;
    $af47be6906de36aa$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $af47be6906de36aa$var$Fh.current = null === a || null === a.memoizedState ? $af47be6906de36aa$var$Oh : $af47be6906de36aa$var$Ph;
    a = c(d, e);
    if ($af47be6906de36aa$var$Jh) {
        f = 0;
        do {
            $af47be6906de36aa$var$Jh = !1;
            $af47be6906de36aa$var$Kh = 0;
            if (25 <= f) throw Error($af47be6906de36aa$var$p(301));
            f += 1;
            $af47be6906de36aa$var$O = $af47be6906de36aa$var$N = null;
            b.updateQueue = null;
            $af47be6906de36aa$var$Fh.current = $af47be6906de36aa$var$Qh;
            a = c(d, e);
        }while ($af47be6906de36aa$var$Jh);
    }
    $af47be6906de36aa$var$Fh.current = $af47be6906de36aa$var$Rh;
    b = null !== $af47be6906de36aa$var$N && null !== $af47be6906de36aa$var$N.next;
    $af47be6906de36aa$var$Hh = 0;
    $af47be6906de36aa$var$O = $af47be6906de36aa$var$N = $af47be6906de36aa$var$M = null;
    $af47be6906de36aa$var$Ih = !1;
    if (b) throw Error($af47be6906de36aa$var$p(300));
    return a;
}
function $af47be6906de36aa$var$Sh() {
    var a = 0 !== $af47be6906de36aa$var$Kh;
    $af47be6906de36aa$var$Kh = 0;
    return a;
}
function $af47be6906de36aa$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $af47be6906de36aa$var$O ? $af47be6906de36aa$var$M.memoizedState = $af47be6906de36aa$var$O = a : $af47be6906de36aa$var$O = $af47be6906de36aa$var$O.next = a;
    return $af47be6906de36aa$var$O;
}
function $af47be6906de36aa$var$Uh() {
    if (null === $af47be6906de36aa$var$N) {
        var a = $af47be6906de36aa$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $af47be6906de36aa$var$N.next;
    var b = null === $af47be6906de36aa$var$O ? $af47be6906de36aa$var$M.memoizedState : $af47be6906de36aa$var$O.next;
    if (null !== b) $af47be6906de36aa$var$O = b, $af47be6906de36aa$var$N = a;
    else {
        if (null === a) throw Error($af47be6906de36aa$var$p(310));
        $af47be6906de36aa$var$N = a;
        a = {
            memoizedState: $af47be6906de36aa$var$N.memoizedState,
            baseState: $af47be6906de36aa$var$N.baseState,
            baseQueue: $af47be6906de36aa$var$N.baseQueue,
            queue: $af47be6906de36aa$var$N.queue,
            next: null
        };
        null === $af47be6906de36aa$var$O ? $af47be6906de36aa$var$M.memoizedState = $af47be6906de36aa$var$O = a : $af47be6906de36aa$var$O = $af47be6906de36aa$var$O.next = a;
    }
    return $af47be6906de36aa$var$O;
}
function $af47be6906de36aa$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $af47be6906de36aa$var$Wh(a) {
    var b = $af47be6906de36aa$var$Uh(), c = b.queue;
    if (null === c) throw Error($af47be6906de36aa$var$p(311));
    c.lastRenderedReducer = a;
    var d = $af47be6906de36aa$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($af47be6906de36aa$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $af47be6906de36aa$var$M.lanes |= m;
                $af47be6906de36aa$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $af47be6906de36aa$var$He(d, b.memoizedState) || ($af47be6906de36aa$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $af47be6906de36aa$var$M.lanes |= f, $af47be6906de36aa$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $af47be6906de36aa$var$Xh(a) {
    var b = $af47be6906de36aa$var$Uh(), c = b.queue;
    if (null === c) throw Error($af47be6906de36aa$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $af47be6906de36aa$var$He(f, b.memoizedState) || ($af47be6906de36aa$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $af47be6906de36aa$var$Yh() {}
function $af47be6906de36aa$var$Zh(a, b) {
    var c = $af47be6906de36aa$var$M, d = $af47be6906de36aa$var$Uh(), e = b(), f = !$af47be6906de36aa$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $af47be6906de36aa$var$dh = !0);
    d = d.queue;
    $af47be6906de36aa$var$$h($af47be6906de36aa$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $af47be6906de36aa$var$O && $af47be6906de36aa$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $af47be6906de36aa$var$bi(9, $af47be6906de36aa$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $af47be6906de36aa$var$Q) throw Error($af47be6906de36aa$var$p(349));
        0 !== ($af47be6906de36aa$var$Hh & 30) || $af47be6906de36aa$var$di(c, b, e);
    }
    return e;
}
function $af47be6906de36aa$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $af47be6906de36aa$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $af47be6906de36aa$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $af47be6906de36aa$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $af47be6906de36aa$var$ei(b) && $af47be6906de36aa$var$fi(a);
}
function $af47be6906de36aa$var$ai(a, b, c) {
    return c(function() {
        $af47be6906de36aa$var$ei(b) && $af47be6906de36aa$var$fi(a);
    });
}
function $af47be6906de36aa$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$af47be6906de36aa$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $af47be6906de36aa$var$fi(a) {
    var b = $af47be6906de36aa$var$ih(a, 1);
    null !== b && $af47be6906de36aa$var$gi(b, a, 1, -1);
}
function $af47be6906de36aa$var$hi(a) {
    var b = $af47be6906de36aa$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $af47be6906de36aa$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $af47be6906de36aa$var$ii.bind(null, $af47be6906de36aa$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $af47be6906de36aa$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $af47be6906de36aa$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $af47be6906de36aa$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $af47be6906de36aa$var$ji() {
    return $af47be6906de36aa$var$Uh().memoizedState;
}
function $af47be6906de36aa$var$ki(a, b, c, d) {
    var e = $af47be6906de36aa$var$Th();
    $af47be6906de36aa$var$M.flags |= a;
    e.memoizedState = $af47be6906de36aa$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $af47be6906de36aa$var$li(a, b, c, d) {
    var e = $af47be6906de36aa$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $af47be6906de36aa$var$N) {
        var g = $af47be6906de36aa$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $af47be6906de36aa$var$Mh(d, g.deps)) {
            e.memoizedState = $af47be6906de36aa$var$bi(b, c, f, d);
            return;
        }
    }
    $af47be6906de36aa$var$M.flags |= a;
    e.memoizedState = $af47be6906de36aa$var$bi(1 | b, c, f, d);
}
function $af47be6906de36aa$var$mi(a, b) {
    return $af47be6906de36aa$var$ki(8390656, 8, a, b);
}
function $af47be6906de36aa$var$$h(a, b) {
    return $af47be6906de36aa$var$li(2048, 8, a, b);
}
function $af47be6906de36aa$var$ni(a, b) {
    return $af47be6906de36aa$var$li(4, 2, a, b);
}
function $af47be6906de36aa$var$oi(a, b) {
    return $af47be6906de36aa$var$li(4, 4, a, b);
}
function $af47be6906de36aa$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $af47be6906de36aa$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $af47be6906de36aa$var$li(4, 4, $af47be6906de36aa$var$pi.bind(null, b, a), c);
}
function $af47be6906de36aa$var$ri() {}
function $af47be6906de36aa$var$si(a, b) {
    var c = $af47be6906de36aa$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $af47be6906de36aa$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $af47be6906de36aa$var$ti(a, b) {
    var c = $af47be6906de36aa$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $af47be6906de36aa$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $af47be6906de36aa$var$ui(a, b, c) {
    if (0 === ($af47be6906de36aa$var$Hh & 21)) return a.baseState && (a.baseState = !1, $af47be6906de36aa$var$dh = !0), a.memoizedState = c;
    $af47be6906de36aa$var$He(c, b) || (c = $af47be6906de36aa$var$yc(), $af47be6906de36aa$var$M.lanes |= c, $af47be6906de36aa$var$rh |= c, a.baseState = !0);
    return b;
}
function $af47be6906de36aa$var$vi(a, b) {
    var c = $af47be6906de36aa$var$C;
    $af47be6906de36aa$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $af47be6906de36aa$var$Gh.transition;
    $af47be6906de36aa$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $af47be6906de36aa$var$C = c, $af47be6906de36aa$var$Gh.transition = d;
    }
}
function $af47be6906de36aa$var$wi() {
    return $af47be6906de36aa$var$Uh().memoizedState;
}
function $af47be6906de36aa$var$xi(a, b, c) {
    var d = $af47be6906de36aa$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($af47be6906de36aa$var$zi(a)) $af47be6906de36aa$var$Ai(b, c);
    else if (c = $af47be6906de36aa$var$hh(a, b, c, d), null !== c) {
        var e = $af47be6906de36aa$var$R();
        $af47be6906de36aa$var$gi(c, a, d, e);
        $af47be6906de36aa$var$Bi(c, b, d);
    }
}
function $af47be6906de36aa$var$ii(a, b, c) {
    var d = $af47be6906de36aa$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($af47be6906de36aa$var$zi(a)) $af47be6906de36aa$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($af47be6906de36aa$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $af47be6906de36aa$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $af47be6906de36aa$var$hh(a, b, e, d);
        null !== c && (e = $af47be6906de36aa$var$R(), $af47be6906de36aa$var$gi(c, a, d, e), $af47be6906de36aa$var$Bi(c, b, d));
    }
}
function $af47be6906de36aa$var$zi(a) {
    var b = a.alternate;
    return a === $af47be6906de36aa$var$M || null !== b && b === $af47be6906de36aa$var$M;
}
function $af47be6906de36aa$var$Ai(a, b) {
    $af47be6906de36aa$var$Jh = $af47be6906de36aa$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $af47be6906de36aa$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $af47be6906de36aa$var$Cc(a, c);
    }
}
var $af47be6906de36aa$var$Rh = {
    readContext: $af47be6906de36aa$var$eh,
    useCallback: $af47be6906de36aa$var$P,
    useContext: $af47be6906de36aa$var$P,
    useEffect: $af47be6906de36aa$var$P,
    useImperativeHandle: $af47be6906de36aa$var$P,
    useInsertionEffect: $af47be6906de36aa$var$P,
    useLayoutEffect: $af47be6906de36aa$var$P,
    useMemo: $af47be6906de36aa$var$P,
    useReducer: $af47be6906de36aa$var$P,
    useRef: $af47be6906de36aa$var$P,
    useState: $af47be6906de36aa$var$P,
    useDebugValue: $af47be6906de36aa$var$P,
    useDeferredValue: $af47be6906de36aa$var$P,
    useTransition: $af47be6906de36aa$var$P,
    useMutableSource: $af47be6906de36aa$var$P,
    useSyncExternalStore: $af47be6906de36aa$var$P,
    useId: $af47be6906de36aa$var$P,
    unstable_isNewReconciler: !1
}, $af47be6906de36aa$var$Oh = {
    readContext: $af47be6906de36aa$var$eh,
    useCallback: function(a, b) {
        $af47be6906de36aa$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $af47be6906de36aa$var$eh,
    useEffect: $af47be6906de36aa$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $af47be6906de36aa$var$ki(4194308, 4, $af47be6906de36aa$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $af47be6906de36aa$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $af47be6906de36aa$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $af47be6906de36aa$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $af47be6906de36aa$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $af47be6906de36aa$var$xi.bind(null, $af47be6906de36aa$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $af47be6906de36aa$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $af47be6906de36aa$var$hi,
    useDebugValue: $af47be6906de36aa$var$ri,
    useDeferredValue: function(a) {
        return $af47be6906de36aa$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $af47be6906de36aa$var$hi(!1), b = a[0];
        a = $af47be6906de36aa$var$vi.bind(null, a[1]);
        $af47be6906de36aa$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $af47be6906de36aa$var$M, e = $af47be6906de36aa$var$Th();
        if ($af47be6906de36aa$var$I) {
            if (void 0 === c) throw Error($af47be6906de36aa$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $af47be6906de36aa$var$Q) throw Error($af47be6906de36aa$var$p(349));
            0 !== ($af47be6906de36aa$var$Hh & 30) || $af47be6906de36aa$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $af47be6906de36aa$var$mi($af47be6906de36aa$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $af47be6906de36aa$var$bi(9, $af47be6906de36aa$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $af47be6906de36aa$var$Th(), b = $af47be6906de36aa$var$Q.identifierPrefix;
        if ($af47be6906de36aa$var$I) {
            var c = $af47be6906de36aa$var$sg;
            var d = $af47be6906de36aa$var$rg;
            c = (d & ~(1 << 32 - $af47be6906de36aa$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $af47be6906de36aa$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $af47be6906de36aa$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $af47be6906de36aa$var$Ph = {
    readContext: $af47be6906de36aa$var$eh,
    useCallback: $af47be6906de36aa$var$si,
    useContext: $af47be6906de36aa$var$eh,
    useEffect: $af47be6906de36aa$var$$h,
    useImperativeHandle: $af47be6906de36aa$var$qi,
    useInsertionEffect: $af47be6906de36aa$var$ni,
    useLayoutEffect: $af47be6906de36aa$var$oi,
    useMemo: $af47be6906de36aa$var$ti,
    useReducer: $af47be6906de36aa$var$Wh,
    useRef: $af47be6906de36aa$var$ji,
    useState: function() {
        return $af47be6906de36aa$var$Wh($af47be6906de36aa$var$Vh);
    },
    useDebugValue: $af47be6906de36aa$var$ri,
    useDeferredValue: function(a) {
        var b = $af47be6906de36aa$var$Uh();
        return $af47be6906de36aa$var$ui(b, $af47be6906de36aa$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $af47be6906de36aa$var$Wh($af47be6906de36aa$var$Vh)[0], b = $af47be6906de36aa$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $af47be6906de36aa$var$Yh,
    useSyncExternalStore: $af47be6906de36aa$var$Zh,
    useId: $af47be6906de36aa$var$wi,
    unstable_isNewReconciler: !1
}, $af47be6906de36aa$var$Qh = {
    readContext: $af47be6906de36aa$var$eh,
    useCallback: $af47be6906de36aa$var$si,
    useContext: $af47be6906de36aa$var$eh,
    useEffect: $af47be6906de36aa$var$$h,
    useImperativeHandle: $af47be6906de36aa$var$qi,
    useInsertionEffect: $af47be6906de36aa$var$ni,
    useLayoutEffect: $af47be6906de36aa$var$oi,
    useMemo: $af47be6906de36aa$var$ti,
    useReducer: $af47be6906de36aa$var$Xh,
    useRef: $af47be6906de36aa$var$ji,
    useState: function() {
        return $af47be6906de36aa$var$Xh($af47be6906de36aa$var$Vh);
    },
    useDebugValue: $af47be6906de36aa$var$ri,
    useDeferredValue: function(a) {
        var b = $af47be6906de36aa$var$Uh();
        return null === $af47be6906de36aa$var$N ? b.memoizedState = a : $af47be6906de36aa$var$ui(b, $af47be6906de36aa$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $af47be6906de36aa$var$Xh($af47be6906de36aa$var$Vh)[0], b = $af47be6906de36aa$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $af47be6906de36aa$var$Yh,
    useSyncExternalStore: $af47be6906de36aa$var$Zh,
    useId: $af47be6906de36aa$var$wi,
    unstable_isNewReconciler: !1
};
function $af47be6906de36aa$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $af47be6906de36aa$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $af47be6906de36aa$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $af47be6906de36aa$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $af47be6906de36aa$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $af47be6906de36aa$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $af47be6906de36aa$var$R(), e = $af47be6906de36aa$var$yi(a), f = $af47be6906de36aa$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $af47be6906de36aa$var$nh(a, f, e);
        null !== b && ($af47be6906de36aa$var$gi(b, a, e, d), $af47be6906de36aa$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $af47be6906de36aa$var$R(), e = $af47be6906de36aa$var$yi(a), f = $af47be6906de36aa$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $af47be6906de36aa$var$nh(a, f, e);
        null !== b && ($af47be6906de36aa$var$gi(b, a, e, d), $af47be6906de36aa$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $af47be6906de36aa$var$R(), d = $af47be6906de36aa$var$yi(a), e = $af47be6906de36aa$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $af47be6906de36aa$var$nh(a, e, d);
        null !== b && ($af47be6906de36aa$var$gi(b, a, d, c), $af47be6906de36aa$var$oh(b, a, d));
    }
};
function $af47be6906de36aa$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$af47be6906de36aa$var$Ie(c, d) || !$af47be6906de36aa$var$Ie(e, f) : !0;
}
function $af47be6906de36aa$var$Gi(a, b, c) {
    var d = !1, e = $af47be6906de36aa$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $af47be6906de36aa$var$eh(f) : (e = $af47be6906de36aa$var$Zf(b) ? $af47be6906de36aa$var$Xf : $af47be6906de36aa$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $af47be6906de36aa$var$Yf(a, e) : $af47be6906de36aa$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $af47be6906de36aa$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $af47be6906de36aa$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $af47be6906de36aa$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $af47be6906de36aa$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $af47be6906de36aa$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $af47be6906de36aa$var$eh(f) : (f = $af47be6906de36aa$var$Zf(b) ? $af47be6906de36aa$var$Xf : $af47be6906de36aa$var$H.current, e.context = $af47be6906de36aa$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($af47be6906de36aa$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $af47be6906de36aa$var$Ei.enqueueReplaceState(e, e.state, null), $af47be6906de36aa$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $af47be6906de36aa$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $af47be6906de36aa$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $af47be6906de36aa$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $af47be6906de36aa$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $af47be6906de36aa$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $af47be6906de36aa$var$Ni(a, b, c) {
    c = $af47be6906de36aa$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $af47be6906de36aa$var$Oi || ($af47be6906de36aa$var$Oi = !0, $af47be6906de36aa$var$Pi = d);
        $af47be6906de36aa$var$Li(a, b);
    };
    return c;
}
function $af47be6906de36aa$var$Qi(a, b, c) {
    c = $af47be6906de36aa$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $af47be6906de36aa$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $af47be6906de36aa$var$Li(a, b);
        "function" !== typeof d && (null === $af47be6906de36aa$var$Ri ? $af47be6906de36aa$var$Ri = new Set([
            this
        ]) : $af47be6906de36aa$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $af47be6906de36aa$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $af47be6906de36aa$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $af47be6906de36aa$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $af47be6906de36aa$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $af47be6906de36aa$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $af47be6906de36aa$var$mh(-1, 1), b.tag = 2, $af47be6906de36aa$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $af47be6906de36aa$var$Wi = $af47be6906de36aa$var$ua.ReactCurrentOwner, $af47be6906de36aa$var$dh = !1;
function $af47be6906de36aa$var$Xi(a, b, c, d) {
    b.child = null === a ? $af47be6906de36aa$var$Vg(b, null, c, d) : $af47be6906de36aa$var$Ug(b, a.child, c, d);
}
function $af47be6906de36aa$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $af47be6906de36aa$var$ch(b, e);
    d = $af47be6906de36aa$var$Nh(a, b, c, d, f, e);
    c = $af47be6906de36aa$var$Sh();
    if (null !== a && !$af47be6906de36aa$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $af47be6906de36aa$var$Zi(a, b, e);
    $af47be6906de36aa$var$I && c && $af47be6906de36aa$var$vg(b);
    b.flags |= 1;
    $af47be6906de36aa$var$Xi(a, b, d, e);
    return b.child;
}
function $af47be6906de36aa$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$af47be6906de36aa$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $af47be6906de36aa$var$bj(a, b, f, d, e);
        a = $af47be6906de36aa$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $af47be6906de36aa$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $af47be6906de36aa$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $af47be6906de36aa$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $af47be6906de36aa$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($af47be6906de36aa$var$Ie(f, d) && a.ref === b.ref) {
            if ($af47be6906de36aa$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($af47be6906de36aa$var$dh = !0);
            else return b.lanes = a.lanes, $af47be6906de36aa$var$Zi(a, b, e);
        }
    }
    return $af47be6906de36aa$var$cj(a, b, c, d, e);
}
function $af47be6906de36aa$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $af47be6906de36aa$var$G($af47be6906de36aa$var$ej, $af47be6906de36aa$var$fj), $af47be6906de36aa$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $af47be6906de36aa$var$G($af47be6906de36aa$var$ej, $af47be6906de36aa$var$fj), $af47be6906de36aa$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $af47be6906de36aa$var$G($af47be6906de36aa$var$ej, $af47be6906de36aa$var$fj);
            $af47be6906de36aa$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $af47be6906de36aa$var$G($af47be6906de36aa$var$ej, $af47be6906de36aa$var$fj), $af47be6906de36aa$var$fj |= d;
    $af47be6906de36aa$var$Xi(a, b, e, c);
    return b.child;
}
function $af47be6906de36aa$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $af47be6906de36aa$var$cj(a, b, c, d, e) {
    var f = $af47be6906de36aa$var$Zf(c) ? $af47be6906de36aa$var$Xf : $af47be6906de36aa$var$H.current;
    f = $af47be6906de36aa$var$Yf(b, f);
    $af47be6906de36aa$var$ch(b, e);
    c = $af47be6906de36aa$var$Nh(a, b, c, d, f, e);
    d = $af47be6906de36aa$var$Sh();
    if (null !== a && !$af47be6906de36aa$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $af47be6906de36aa$var$Zi(a, b, e);
    $af47be6906de36aa$var$I && d && $af47be6906de36aa$var$vg(b);
    b.flags |= 1;
    $af47be6906de36aa$var$Xi(a, b, c, e);
    return b.child;
}
function $af47be6906de36aa$var$hj(a, b, c, d, e) {
    if ($af47be6906de36aa$var$Zf(c)) {
        var f = !0;
        $af47be6906de36aa$var$cg(b);
    } else f = !1;
    $af47be6906de36aa$var$ch(b, e);
    if (null === b.stateNode) $af47be6906de36aa$var$ij(a, b), $af47be6906de36aa$var$Gi(b, c, d), $af47be6906de36aa$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $af47be6906de36aa$var$eh(l) : (l = $af47be6906de36aa$var$Zf(c) ? $af47be6906de36aa$var$Xf : $af47be6906de36aa$var$H.current, l = $af47be6906de36aa$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $af47be6906de36aa$var$Hi(b, g, d, l);
        $af47be6906de36aa$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $af47be6906de36aa$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $af47be6906de36aa$var$Wf.current || $af47be6906de36aa$var$jh ? ("function" === typeof m && ($af47be6906de36aa$var$Di(b, c, m, d), k = b.memoizedState), (h = $af47be6906de36aa$var$jh || $af47be6906de36aa$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $af47be6906de36aa$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $af47be6906de36aa$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $af47be6906de36aa$var$eh(k) : (k = $af47be6906de36aa$var$Zf(c) ? $af47be6906de36aa$var$Xf : $af47be6906de36aa$var$H.current, k = $af47be6906de36aa$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $af47be6906de36aa$var$Hi(b, g, d, k);
        $af47be6906de36aa$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $af47be6906de36aa$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $af47be6906de36aa$var$Wf.current || $af47be6906de36aa$var$jh ? ("function" === typeof y && ($af47be6906de36aa$var$Di(b, c, y, d), n = b.memoizedState), (l = $af47be6906de36aa$var$jh || $af47be6906de36aa$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $af47be6906de36aa$var$jj(a, b, c, d, f, e);
}
function $af47be6906de36aa$var$jj(a, b, c, d, e, f) {
    $af47be6906de36aa$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $af47be6906de36aa$var$dg(b, c, !1), $af47be6906de36aa$var$Zi(a, b, f);
    d = b.stateNode;
    $af47be6906de36aa$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $af47be6906de36aa$var$Ug(b, a.child, null, f), b.child = $af47be6906de36aa$var$Ug(b, null, h, f)) : $af47be6906de36aa$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $af47be6906de36aa$var$dg(b, c, !0);
    return b.child;
}
function $af47be6906de36aa$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $af47be6906de36aa$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $af47be6906de36aa$var$ag(a, b.context, !1);
    $af47be6906de36aa$var$yh(a, b.containerInfo);
}
function $af47be6906de36aa$var$lj(a, b, c, d, e) {
    $af47be6906de36aa$var$Ig();
    $af47be6906de36aa$var$Jg(e);
    b.flags |= 256;
    $af47be6906de36aa$var$Xi(a, b, c, d);
    return b.child;
}
var $af47be6906de36aa$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $af47be6906de36aa$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $af47be6906de36aa$var$oj(a, b, c) {
    var d = b.pendingProps, e = $af47be6906de36aa$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $af47be6906de36aa$var$G($af47be6906de36aa$var$L, e & 1);
    if (null === a) {
        $af47be6906de36aa$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $af47be6906de36aa$var$pj(g, d, 0, null), a = $af47be6906de36aa$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $af47be6906de36aa$var$nj(c), b.memoizedState = $af47be6906de36aa$var$mj, a) : $af47be6906de36aa$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $af47be6906de36aa$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $af47be6906de36aa$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $af47be6906de36aa$var$Pg(h, f) : (f = $af47be6906de36aa$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $af47be6906de36aa$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $af47be6906de36aa$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $af47be6906de36aa$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $af47be6906de36aa$var$qj(a, b) {
    b = $af47be6906de36aa$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $af47be6906de36aa$var$sj(a, b, c, d) {
    null !== d && $af47be6906de36aa$var$Jg(d);
    $af47be6906de36aa$var$Ug(b, a.child, null, c);
    a = $af47be6906de36aa$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $af47be6906de36aa$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $af47be6906de36aa$var$Ki(Error($af47be6906de36aa$var$p(422))), $af47be6906de36aa$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $af47be6906de36aa$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $af47be6906de36aa$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $af47be6906de36aa$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $af47be6906de36aa$var$nj(g);
        b.memoizedState = $af47be6906de36aa$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $af47be6906de36aa$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($af47be6906de36aa$var$p(419));
        d = $af47be6906de36aa$var$Ki(f, d, void 0);
        return $af47be6906de36aa$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($af47be6906de36aa$var$dh || h) {
        d = $af47be6906de36aa$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $af47be6906de36aa$var$ih(a, e), $af47be6906de36aa$var$gi(d, a, e, -1));
        }
        $af47be6906de36aa$var$tj();
        d = $af47be6906de36aa$var$Ki(Error($af47be6906de36aa$var$p(421)));
        return $af47be6906de36aa$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $af47be6906de36aa$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $af47be6906de36aa$var$yg = $af47be6906de36aa$var$Lf(e.nextSibling);
    $af47be6906de36aa$var$xg = b;
    $af47be6906de36aa$var$I = !0;
    $af47be6906de36aa$var$zg = null;
    null !== a && ($af47be6906de36aa$var$og[$af47be6906de36aa$var$pg++] = $af47be6906de36aa$var$rg, $af47be6906de36aa$var$og[$af47be6906de36aa$var$pg++] = $af47be6906de36aa$var$sg, $af47be6906de36aa$var$og[$af47be6906de36aa$var$pg++] = $af47be6906de36aa$var$qg, $af47be6906de36aa$var$rg = a.id, $af47be6906de36aa$var$sg = a.overflow, $af47be6906de36aa$var$qg = b);
    b = $af47be6906de36aa$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $af47be6906de36aa$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $af47be6906de36aa$var$bh(a.return, b, c);
}
function $af47be6906de36aa$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $af47be6906de36aa$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $af47be6906de36aa$var$Xi(a, b, d.children, c);
    d = $af47be6906de36aa$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $af47be6906de36aa$var$vj(a, c, b);
            else if (19 === a.tag) $af47be6906de36aa$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $af47be6906de36aa$var$G($af47be6906de36aa$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $af47be6906de36aa$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $af47be6906de36aa$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $af47be6906de36aa$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $af47be6906de36aa$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $af47be6906de36aa$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $af47be6906de36aa$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $af47be6906de36aa$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $af47be6906de36aa$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($af47be6906de36aa$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $af47be6906de36aa$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $af47be6906de36aa$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $af47be6906de36aa$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $af47be6906de36aa$var$kj(b);
            $af47be6906de36aa$var$Ig();
            break;
        case 5:
            $af47be6906de36aa$var$Ah(b);
            break;
        case 1:
            $af47be6906de36aa$var$Zf(b.type) && $af47be6906de36aa$var$cg(b);
            break;
        case 4:
            $af47be6906de36aa$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $af47be6906de36aa$var$G($af47be6906de36aa$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $af47be6906de36aa$var$G($af47be6906de36aa$var$L, $af47be6906de36aa$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $af47be6906de36aa$var$oj(a, b, c);
                $af47be6906de36aa$var$G($af47be6906de36aa$var$L, $af47be6906de36aa$var$L.current & 1);
                a = $af47be6906de36aa$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $af47be6906de36aa$var$G($af47be6906de36aa$var$L, $af47be6906de36aa$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $af47be6906de36aa$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $af47be6906de36aa$var$G($af47be6906de36aa$var$L, $af47be6906de36aa$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $af47be6906de36aa$var$dj(a, b, c);
    }
    return $af47be6906de36aa$var$Zi(a, b, c);
}
var $af47be6906de36aa$var$zj, $af47be6906de36aa$var$Aj, $af47be6906de36aa$var$Bj, $af47be6906de36aa$var$Cj;
$af47be6906de36aa$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$af47be6906de36aa$var$Aj = function() {};
$af47be6906de36aa$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $af47be6906de36aa$var$xh($af47be6906de36aa$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $af47be6906de36aa$var$Ya(a, e);
                d = $af47be6906de36aa$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $af47be6906de36aa$var$A({}, e, {
                    value: void 0
                });
                d = $af47be6906de36aa$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $af47be6906de36aa$var$gb(a, e);
                d = $af47be6906de36aa$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $af47be6906de36aa$var$Bf);
        }
        $af47be6906de36aa$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($af47be6906de36aa$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($af47be6906de36aa$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $af47be6906de36aa$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$af47be6906de36aa$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $af47be6906de36aa$var$Dj(a, b) {
    if (!$af47be6906de36aa$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $af47be6906de36aa$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $af47be6906de36aa$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $af47be6906de36aa$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $af47be6906de36aa$var$S(b), null;
        case 1:
            return $af47be6906de36aa$var$Zf(b.type) && $af47be6906de36aa$var$$f(), $af47be6906de36aa$var$S(b), null;
        case 3:
            d = b.stateNode;
            $af47be6906de36aa$var$zh();
            $af47be6906de36aa$var$E($af47be6906de36aa$var$Wf);
            $af47be6906de36aa$var$E($af47be6906de36aa$var$H);
            $af47be6906de36aa$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $af47be6906de36aa$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $af47be6906de36aa$var$zg && ($af47be6906de36aa$var$Fj($af47be6906de36aa$var$zg), $af47be6906de36aa$var$zg = null));
            $af47be6906de36aa$var$Aj(a, b);
            $af47be6906de36aa$var$S(b);
            return null;
        case 5:
            $af47be6906de36aa$var$Bh(b);
            var e = $af47be6906de36aa$var$xh($af47be6906de36aa$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $af47be6906de36aa$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($af47be6906de36aa$var$p(166));
                    $af47be6906de36aa$var$S(b);
                    return null;
                }
                a = $af47be6906de36aa$var$xh($af47be6906de36aa$var$uh.current);
                if ($af47be6906de36aa$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$af47be6906de36aa$var$Of] = b;
                    d[$af47be6906de36aa$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $af47be6906de36aa$var$D("cancel", d);
                            $af47be6906de36aa$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $af47be6906de36aa$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $af47be6906de36aa$var$lf.length; e++)$af47be6906de36aa$var$D($af47be6906de36aa$var$lf[e], d);
                            break;
                        case "source":
                            $af47be6906de36aa$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $af47be6906de36aa$var$D("error", d);
                            $af47be6906de36aa$var$D("load", d);
                            break;
                        case "details":
                            $af47be6906de36aa$var$D("toggle", d);
                            break;
                        case "input":
                            $af47be6906de36aa$var$Za(d, f);
                            $af47be6906de36aa$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $af47be6906de36aa$var$D("invalid", d);
                            break;
                        case "textarea":
                            $af47be6906de36aa$var$hb(d, f), $af47be6906de36aa$var$D("invalid", d);
                    }
                    $af47be6906de36aa$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $af47be6906de36aa$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $af47be6906de36aa$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $af47be6906de36aa$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $af47be6906de36aa$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $af47be6906de36aa$var$Va(d);
                            $af47be6906de36aa$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $af47be6906de36aa$var$Va(d);
                            $af47be6906de36aa$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $af47be6906de36aa$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $af47be6906de36aa$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$af47be6906de36aa$var$Of] = b;
                    a[$af47be6906de36aa$var$Pf] = d;
                    $af47be6906de36aa$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $af47be6906de36aa$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $af47be6906de36aa$var$D("cancel", a);
                                $af47be6906de36aa$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $af47be6906de36aa$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $af47be6906de36aa$var$lf.length; e++)$af47be6906de36aa$var$D($af47be6906de36aa$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $af47be6906de36aa$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $af47be6906de36aa$var$D("error", a);
                                $af47be6906de36aa$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $af47be6906de36aa$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $af47be6906de36aa$var$Za(a, d);
                                e = $af47be6906de36aa$var$Ya(a, d);
                                $af47be6906de36aa$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $af47be6906de36aa$var$A({}, d, {
                                    value: void 0
                                });
                                $af47be6906de36aa$var$D("invalid", a);
                                break;
                            case "textarea":
                                $af47be6906de36aa$var$hb(a, d);
                                e = $af47be6906de36aa$var$gb(a, d);
                                $af47be6906de36aa$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $af47be6906de36aa$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $af47be6906de36aa$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $af47be6906de36aa$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $af47be6906de36aa$var$ob(a, k) : "number" === typeof k && $af47be6906de36aa$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($af47be6906de36aa$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $af47be6906de36aa$var$D("scroll", a) : null != k && $af47be6906de36aa$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $af47be6906de36aa$var$Va(a);
                                $af47be6906de36aa$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $af47be6906de36aa$var$Va(a);
                                $af47be6906de36aa$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $af47be6906de36aa$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $af47be6906de36aa$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $af47be6906de36aa$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $af47be6906de36aa$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $af47be6906de36aa$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $af47be6906de36aa$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($af47be6906de36aa$var$p(166));
                c = $af47be6906de36aa$var$xh($af47be6906de36aa$var$wh.current);
                $af47be6906de36aa$var$xh($af47be6906de36aa$var$uh.current);
                if ($af47be6906de36aa$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$af47be6906de36aa$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $af47be6906de36aa$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $af47be6906de36aa$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $af47be6906de36aa$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$af47be6906de36aa$var$Of] = b, b.stateNode = d;
            }
            $af47be6906de36aa$var$S(b);
            return null;
        case 13:
            $af47be6906de36aa$var$E($af47be6906de36aa$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($af47be6906de36aa$var$I && null !== $af47be6906de36aa$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $af47be6906de36aa$var$Hg(), $af47be6906de36aa$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $af47be6906de36aa$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($af47be6906de36aa$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($af47be6906de36aa$var$p(317));
                        f[$af47be6906de36aa$var$Of] = b;
                    } else $af47be6906de36aa$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $af47be6906de36aa$var$S(b);
                    f = !1;
                } else null !== $af47be6906de36aa$var$zg && ($af47be6906de36aa$var$Fj($af47be6906de36aa$var$zg), $af47be6906de36aa$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($af47be6906de36aa$var$L.current & 1) ? 0 === $af47be6906de36aa$var$T && ($af47be6906de36aa$var$T = 3) : $af47be6906de36aa$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $af47be6906de36aa$var$S(b);
            return null;
        case 4:
            return $af47be6906de36aa$var$zh(), $af47be6906de36aa$var$Aj(a, b), null === a && $af47be6906de36aa$var$sf(b.stateNode.containerInfo), $af47be6906de36aa$var$S(b), null;
        case 10:
            return $af47be6906de36aa$var$ah(b.type._context), $af47be6906de36aa$var$S(b), null;
        case 17:
            return $af47be6906de36aa$var$Zf(b.type) && $af47be6906de36aa$var$$f(), $af47be6906de36aa$var$S(b), null;
        case 19:
            $af47be6906de36aa$var$E($af47be6906de36aa$var$L);
            f = b.memoizedState;
            if (null === f) return $af47be6906de36aa$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $af47be6906de36aa$var$Dj(f, !1);
                else {
                    if (0 !== $af47be6906de36aa$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $af47be6906de36aa$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $af47be6906de36aa$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $af47be6906de36aa$var$G($af47be6906de36aa$var$L, $af47be6906de36aa$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $af47be6906de36aa$var$B() > $af47be6906de36aa$var$Gj && (b.flags |= 128, d = !0, $af47be6906de36aa$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $af47be6906de36aa$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $af47be6906de36aa$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$af47be6906de36aa$var$I) return $af47be6906de36aa$var$S(b), null;
                    } else 2 * $af47be6906de36aa$var$B() - f.renderingStartTime > $af47be6906de36aa$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $af47be6906de36aa$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $af47be6906de36aa$var$B(), b.sibling = null, c = $af47be6906de36aa$var$L.current, $af47be6906de36aa$var$G($af47be6906de36aa$var$L, d ? c & 1 | 2 : c & 1), b;
            $af47be6906de36aa$var$S(b);
            return null;
        case 22:
        case 23:
            return $af47be6906de36aa$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($af47be6906de36aa$var$fj & 1073741824) && ($af47be6906de36aa$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $af47be6906de36aa$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($af47be6906de36aa$var$p(156, b.tag));
}
function $af47be6906de36aa$var$Ij(a, b) {
    $af47be6906de36aa$var$wg(b);
    switch(b.tag){
        case 1:
            return $af47be6906de36aa$var$Zf(b.type) && $af47be6906de36aa$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $af47be6906de36aa$var$zh(), $af47be6906de36aa$var$E($af47be6906de36aa$var$Wf), $af47be6906de36aa$var$E($af47be6906de36aa$var$H), $af47be6906de36aa$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $af47be6906de36aa$var$Bh(b), null;
        case 13:
            $af47be6906de36aa$var$E($af47be6906de36aa$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($af47be6906de36aa$var$p(340));
                $af47be6906de36aa$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $af47be6906de36aa$var$E($af47be6906de36aa$var$L), null;
        case 4:
            return $af47be6906de36aa$var$zh(), null;
        case 10:
            return $af47be6906de36aa$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $af47be6906de36aa$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $af47be6906de36aa$var$Jj = !1, $af47be6906de36aa$var$U = !1, $af47be6906de36aa$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $af47be6906de36aa$var$V = null;
function $af47be6906de36aa$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $af47be6906de36aa$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $af47be6906de36aa$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $af47be6906de36aa$var$W(a, b, d);
    }
}
var $af47be6906de36aa$var$Nj = !1;
function $af47be6906de36aa$var$Oj(a, b) {
    $af47be6906de36aa$var$Cf = $af47be6906de36aa$var$dd;
    a = $af47be6906de36aa$var$Me();
    if ($af47be6906de36aa$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $af47be6906de36aa$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $af47be6906de36aa$var$dd = !1;
    for($af47be6906de36aa$var$V = b; null !== $af47be6906de36aa$var$V;)if (b = $af47be6906de36aa$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $af47be6906de36aa$var$V = a;
    else for(; null !== $af47be6906de36aa$var$V;){
        b = $af47be6906de36aa$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $af47be6906de36aa$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($af47be6906de36aa$var$p(163));
            }
        } catch (F) {
            $af47be6906de36aa$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $af47be6906de36aa$var$V = a;
            break;
        }
        $af47be6906de36aa$var$V = b.return;
    }
    n = $af47be6906de36aa$var$Nj;
    $af47be6906de36aa$var$Nj = !1;
    return n;
}
function $af47be6906de36aa$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $af47be6906de36aa$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $af47be6906de36aa$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $af47be6906de36aa$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $af47be6906de36aa$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $af47be6906de36aa$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$af47be6906de36aa$var$Of], delete b[$af47be6906de36aa$var$Pf], delete b[$af47be6906de36aa$var$of], delete b[$af47be6906de36aa$var$Qf], delete b[$af47be6906de36aa$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $af47be6906de36aa$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $af47be6906de36aa$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $af47be6906de36aa$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $af47be6906de36aa$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $af47be6906de36aa$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($af47be6906de36aa$var$Vj(a, b, c), a = a.sibling; null !== a;)$af47be6906de36aa$var$Vj(a, b, c), a = a.sibling;
}
function $af47be6906de36aa$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($af47be6906de36aa$var$Wj(a, b, c), a = a.sibling; null !== a;)$af47be6906de36aa$var$Wj(a, b, c), a = a.sibling;
}
var $af47be6906de36aa$var$X = null, $af47be6906de36aa$var$Xj = !1;
function $af47be6906de36aa$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$af47be6906de36aa$var$Zj(a, b, c), c = c.sibling;
}
function $af47be6906de36aa$var$Zj(a, b, c) {
    if ($af47be6906de36aa$var$lc && "function" === typeof $af47be6906de36aa$var$lc.onCommitFiberUnmount) try {
        $af47be6906de36aa$var$lc.onCommitFiberUnmount($af47be6906de36aa$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $af47be6906de36aa$var$U || $af47be6906de36aa$var$Lj(c, b);
        case 6:
            var d = $af47be6906de36aa$var$X, e = $af47be6906de36aa$var$Xj;
            $af47be6906de36aa$var$X = null;
            $af47be6906de36aa$var$Yj(a, b, c);
            $af47be6906de36aa$var$X = d;
            $af47be6906de36aa$var$Xj = e;
            null !== $af47be6906de36aa$var$X && ($af47be6906de36aa$var$Xj ? (a = $af47be6906de36aa$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $af47be6906de36aa$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $af47be6906de36aa$var$X && ($af47be6906de36aa$var$Xj ? (a = $af47be6906de36aa$var$X, c = c.stateNode, 8 === a.nodeType ? $af47be6906de36aa$var$Kf(a.parentNode, c) : 1 === a.nodeType && $af47be6906de36aa$var$Kf(a, c), $af47be6906de36aa$var$bd(a)) : $af47be6906de36aa$var$Kf($af47be6906de36aa$var$X, c.stateNode));
            break;
        case 4:
            d = $af47be6906de36aa$var$X;
            e = $af47be6906de36aa$var$Xj;
            $af47be6906de36aa$var$X = c.stateNode.containerInfo;
            $af47be6906de36aa$var$Xj = !0;
            $af47be6906de36aa$var$Yj(a, b, c);
            $af47be6906de36aa$var$X = d;
            $af47be6906de36aa$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$af47be6906de36aa$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $af47be6906de36aa$var$Mj(c, b, g) : 0 !== (f & 4) && $af47be6906de36aa$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $af47be6906de36aa$var$Yj(a, b, c);
            break;
        case 1:
            if (!$af47be6906de36aa$var$U && ($af47be6906de36aa$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $af47be6906de36aa$var$W(c, b, h);
            }
            $af47be6906de36aa$var$Yj(a, b, c);
            break;
        case 21:
            $af47be6906de36aa$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($af47be6906de36aa$var$U = (d = $af47be6906de36aa$var$U) || null !== c.memoizedState, $af47be6906de36aa$var$Yj(a, b, c), $af47be6906de36aa$var$U = d) : $af47be6906de36aa$var$Yj(a, b, c);
            break;
        default:
            $af47be6906de36aa$var$Yj(a, b, c);
    }
}
function $af47be6906de36aa$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $af47be6906de36aa$var$Kj);
        b.forEach(function(b) {
            var d = $af47be6906de36aa$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $af47be6906de36aa$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $af47be6906de36aa$var$X = h.stateNode;
                        $af47be6906de36aa$var$Xj = !1;
                        break a;
                    case 3:
                        $af47be6906de36aa$var$X = h.stateNode.containerInfo;
                        $af47be6906de36aa$var$Xj = !0;
                        break a;
                    case 4:
                        $af47be6906de36aa$var$X = h.stateNode.containerInfo;
                        $af47be6906de36aa$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $af47be6906de36aa$var$X) throw Error($af47be6906de36aa$var$p(160));
            $af47be6906de36aa$var$Zj(f, g, e);
            $af47be6906de36aa$var$X = null;
            $af47be6906de36aa$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $af47be6906de36aa$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$af47be6906de36aa$var$dk(b, a), b = b.sibling;
}
function $af47be6906de36aa$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $af47be6906de36aa$var$ck(b, a);
            $af47be6906de36aa$var$ek(a);
            if (d & 4) {
                try {
                    $af47be6906de36aa$var$Pj(3, a, a.return), $af47be6906de36aa$var$Qj(3, a);
                } catch (t) {
                    $af47be6906de36aa$var$W(a, a.return, t);
                }
                try {
                    $af47be6906de36aa$var$Pj(5, a, a.return);
                } catch (t) {
                    $af47be6906de36aa$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $af47be6906de36aa$var$ck(b, a);
            $af47be6906de36aa$var$ek(a);
            d & 512 && null !== c && $af47be6906de36aa$var$Lj(c, c.return);
            break;
        case 5:
            $af47be6906de36aa$var$ck(b, a);
            $af47be6906de36aa$var$ek(a);
            d & 512 && null !== c && $af47be6906de36aa$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $af47be6906de36aa$var$ob(e, "");
                } catch (t) {
                    $af47be6906de36aa$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $af47be6906de36aa$var$ab(e, f);
                    $af47be6906de36aa$var$vb(h, g);
                    var l = $af47be6906de36aa$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $af47be6906de36aa$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $af47be6906de36aa$var$nb(e, q) : "children" === m ? $af47be6906de36aa$var$ob(e, q) : $af47be6906de36aa$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $af47be6906de36aa$var$bb(e, f);
                            break;
                        case "textarea":
                            $af47be6906de36aa$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $af47be6906de36aa$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $af47be6906de36aa$var$fb(e, !!f.multiple, f.defaultValue, !0) : $af47be6906de36aa$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$af47be6906de36aa$var$Pf] = f;
                } catch (t) {
                    $af47be6906de36aa$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $af47be6906de36aa$var$ck(b, a);
            $af47be6906de36aa$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($af47be6906de36aa$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $af47be6906de36aa$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $af47be6906de36aa$var$ck(b, a);
            $af47be6906de36aa$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $af47be6906de36aa$var$bd(b.containerInfo);
            } catch (t) {
                $af47be6906de36aa$var$W(a, a.return, t);
            }
            break;
        case 4:
            $af47be6906de36aa$var$ck(b, a);
            $af47be6906de36aa$var$ek(a);
            break;
        case 13:
            $af47be6906de36aa$var$ck(b, a);
            $af47be6906de36aa$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($af47be6906de36aa$var$fk = $af47be6906de36aa$var$B()));
            d & 4 && $af47be6906de36aa$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($af47be6906de36aa$var$U = (l = $af47be6906de36aa$var$U) || m, $af47be6906de36aa$var$ck(b, a), $af47be6906de36aa$var$U = l) : $af47be6906de36aa$var$ck(b, a);
            $af47be6906de36aa$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($af47be6906de36aa$var$V = a, m = a.child; null !== m;){
                    for(q = $af47be6906de36aa$var$V = m; null !== $af47be6906de36aa$var$V;){
                        r = $af47be6906de36aa$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $af47be6906de36aa$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $af47be6906de36aa$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $af47be6906de36aa$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $af47be6906de36aa$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $af47be6906de36aa$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $af47be6906de36aa$var$V = y) : $af47be6906de36aa$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $af47be6906de36aa$var$rb("display", g));
                            } catch (t) {
                                $af47be6906de36aa$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $af47be6906de36aa$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $af47be6906de36aa$var$ck(b, a);
            $af47be6906de36aa$var$ek(a);
            d & 4 && $af47be6906de36aa$var$ak(a);
            break;
        case 21:
            break;
        default:
            $af47be6906de36aa$var$ck(b, a), $af47be6906de36aa$var$ek(a);
    }
}
function $af47be6906de36aa$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($af47be6906de36aa$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($af47be6906de36aa$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($af47be6906de36aa$var$ob(e, ""), d.flags &= -33);
                    var f = $af47be6906de36aa$var$Uj(a);
                    $af47be6906de36aa$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $af47be6906de36aa$var$Uj(a);
                    $af47be6906de36aa$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($af47be6906de36aa$var$p(161));
            }
        } catch (k) {
            $af47be6906de36aa$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $af47be6906de36aa$var$hk(a, b, c) {
    $af47be6906de36aa$var$V = a;
    $af47be6906de36aa$var$ik(a, b, c);
}
function $af47be6906de36aa$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $af47be6906de36aa$var$V;){
        var e = $af47be6906de36aa$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $af47be6906de36aa$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $af47be6906de36aa$var$U;
                h = $af47be6906de36aa$var$Jj;
                var l = $af47be6906de36aa$var$U;
                $af47be6906de36aa$var$Jj = g;
                if (($af47be6906de36aa$var$U = k) && !l) for($af47be6906de36aa$var$V = e; null !== $af47be6906de36aa$var$V;)g = $af47be6906de36aa$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $af47be6906de36aa$var$jk(e) : null !== k ? (k.return = g, $af47be6906de36aa$var$V = k) : $af47be6906de36aa$var$jk(e);
                for(; null !== f;)$af47be6906de36aa$var$V = f, $af47be6906de36aa$var$ik(f, b, c), f = f.sibling;
                $af47be6906de36aa$var$V = e;
                $af47be6906de36aa$var$Jj = h;
                $af47be6906de36aa$var$U = l;
            }
            $af47be6906de36aa$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $af47be6906de36aa$var$V = f) : $af47be6906de36aa$var$kk(a, b, c);
    }
}
function $af47be6906de36aa$var$kk(a) {
    for(; null !== $af47be6906de36aa$var$V;){
        var b = $af47be6906de36aa$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $af47be6906de36aa$var$U || $af47be6906de36aa$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$af47be6906de36aa$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $af47be6906de36aa$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $af47be6906de36aa$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $af47be6906de36aa$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $af47be6906de36aa$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($af47be6906de36aa$var$p(163));
                }
                $af47be6906de36aa$var$U || b.flags & 512 && $af47be6906de36aa$var$Rj(b);
            } catch (r) {
                $af47be6906de36aa$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $af47be6906de36aa$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $af47be6906de36aa$var$V = c;
            break;
        }
        $af47be6906de36aa$var$V = b.return;
    }
}
function $af47be6906de36aa$var$gk(a) {
    for(; null !== $af47be6906de36aa$var$V;){
        var b = $af47be6906de36aa$var$V;
        if (b === a) {
            $af47be6906de36aa$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $af47be6906de36aa$var$V = c;
            break;
        }
        $af47be6906de36aa$var$V = b.return;
    }
}
function $af47be6906de36aa$var$jk(a) {
    for(; null !== $af47be6906de36aa$var$V;){
        var b = $af47be6906de36aa$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $af47be6906de36aa$var$Qj(4, b);
                    } catch (k) {
                        $af47be6906de36aa$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $af47be6906de36aa$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $af47be6906de36aa$var$Rj(b);
                    } catch (k) {
                        $af47be6906de36aa$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $af47be6906de36aa$var$Rj(b);
                    } catch (k) {
                        $af47be6906de36aa$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $af47be6906de36aa$var$W(b, b.return, k);
        }
        if (b === a) {
            $af47be6906de36aa$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $af47be6906de36aa$var$V = h;
            break;
        }
        $af47be6906de36aa$var$V = b.return;
    }
}
var $af47be6906de36aa$var$lk = Math.ceil, $af47be6906de36aa$var$mk = $af47be6906de36aa$var$ua.ReactCurrentDispatcher, $af47be6906de36aa$var$nk = $af47be6906de36aa$var$ua.ReactCurrentOwner, $af47be6906de36aa$var$ok = $af47be6906de36aa$var$ua.ReactCurrentBatchConfig, $af47be6906de36aa$var$K = 0, $af47be6906de36aa$var$Q = null, $af47be6906de36aa$var$Y = null, $af47be6906de36aa$var$Z = 0, $af47be6906de36aa$var$fj = 0, $af47be6906de36aa$var$ej = $af47be6906de36aa$var$Uf(0), $af47be6906de36aa$var$T = 0, $af47be6906de36aa$var$pk = null, $af47be6906de36aa$var$rh = 0, $af47be6906de36aa$var$qk = 0, $af47be6906de36aa$var$rk = 0, $af47be6906de36aa$var$sk = null, $af47be6906de36aa$var$tk = null, $af47be6906de36aa$var$fk = 0, $af47be6906de36aa$var$Gj = Infinity, $af47be6906de36aa$var$uk = null, $af47be6906de36aa$var$Oi = !1, $af47be6906de36aa$var$Pi = null, $af47be6906de36aa$var$Ri = null, $af47be6906de36aa$var$vk = !1, $af47be6906de36aa$var$wk = null, $af47be6906de36aa$var$xk = 0, $af47be6906de36aa$var$yk = 0, $af47be6906de36aa$var$zk = null, $af47be6906de36aa$var$Ak = -1, $af47be6906de36aa$var$Bk = 0;
function $af47be6906de36aa$var$R() {
    return 0 !== ($af47be6906de36aa$var$K & 6) ? $af47be6906de36aa$var$B() : -1 !== $af47be6906de36aa$var$Ak ? $af47be6906de36aa$var$Ak : $af47be6906de36aa$var$Ak = $af47be6906de36aa$var$B();
}
function $af47be6906de36aa$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($af47be6906de36aa$var$K & 2) && 0 !== $af47be6906de36aa$var$Z) return $af47be6906de36aa$var$Z & -$af47be6906de36aa$var$Z;
    if (null !== $af47be6906de36aa$var$Kg.transition) return 0 === $af47be6906de36aa$var$Bk && ($af47be6906de36aa$var$Bk = $af47be6906de36aa$var$yc()), $af47be6906de36aa$var$Bk;
    a = $af47be6906de36aa$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $af47be6906de36aa$var$jd(a.type);
    return a;
}
function $af47be6906de36aa$var$gi(a, b, c, d) {
    if (50 < $af47be6906de36aa$var$yk) throw $af47be6906de36aa$var$yk = 0, $af47be6906de36aa$var$zk = null, Error($af47be6906de36aa$var$p(185));
    $af47be6906de36aa$var$Ac(a, c, d);
    if (0 === ($af47be6906de36aa$var$K & 2) || a !== $af47be6906de36aa$var$Q) a === $af47be6906de36aa$var$Q && (0 === ($af47be6906de36aa$var$K & 2) && ($af47be6906de36aa$var$qk |= c), 4 === $af47be6906de36aa$var$T && $af47be6906de36aa$var$Ck(a, $af47be6906de36aa$var$Z)), $af47be6906de36aa$var$Dk(a, d), 1 === c && 0 === $af47be6906de36aa$var$K && 0 === (b.mode & 1) && ($af47be6906de36aa$var$Gj = $af47be6906de36aa$var$B() + 500, $af47be6906de36aa$var$fg && $af47be6906de36aa$var$jg());
}
function $af47be6906de36aa$var$Dk(a, b) {
    var c = a.callbackNode;
    $af47be6906de36aa$var$wc(a, b);
    var d = $af47be6906de36aa$var$uc(a, a === $af47be6906de36aa$var$Q ? $af47be6906de36aa$var$Z : 0);
    if (0 === d) null !== c && $af47be6906de36aa$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $af47be6906de36aa$var$bc(c);
        if (1 === b) 0 === a.tag ? $af47be6906de36aa$var$ig($af47be6906de36aa$var$Ek.bind(null, a)) : $af47be6906de36aa$var$hg($af47be6906de36aa$var$Ek.bind(null, a)), $af47be6906de36aa$var$Jf(function() {
            0 === ($af47be6906de36aa$var$K & 6) && $af47be6906de36aa$var$jg();
        }), c = null;
        else {
            switch($af47be6906de36aa$var$Dc(d)){
                case 1:
                    c = $af47be6906de36aa$var$fc;
                    break;
                case 4:
                    c = $af47be6906de36aa$var$gc;
                    break;
                case 16:
                    c = $af47be6906de36aa$var$hc;
                    break;
                case 536870912:
                    c = $af47be6906de36aa$var$jc;
                    break;
                default:
                    c = $af47be6906de36aa$var$hc;
            }
            c = $af47be6906de36aa$var$Fk(c, $af47be6906de36aa$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $af47be6906de36aa$var$Gk(a, b) {
    $af47be6906de36aa$var$Ak = -1;
    $af47be6906de36aa$var$Bk = 0;
    if (0 !== ($af47be6906de36aa$var$K & 6)) throw Error($af47be6906de36aa$var$p(327));
    var c = a.callbackNode;
    if ($af47be6906de36aa$var$Hk() && a.callbackNode !== c) return null;
    var d = $af47be6906de36aa$var$uc(a, a === $af47be6906de36aa$var$Q ? $af47be6906de36aa$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $af47be6906de36aa$var$Ik(a, d);
    else {
        b = d;
        var e = $af47be6906de36aa$var$K;
        $af47be6906de36aa$var$K |= 2;
        var f = $af47be6906de36aa$var$Jk();
        if ($af47be6906de36aa$var$Q !== a || $af47be6906de36aa$var$Z !== b) $af47be6906de36aa$var$uk = null, $af47be6906de36aa$var$Gj = $af47be6906de36aa$var$B() + 500, $af47be6906de36aa$var$Kk(a, b);
        for(;;)try {
            $af47be6906de36aa$var$Lk();
            break;
        } catch (h) {
            $af47be6906de36aa$var$Mk(a, h);
        }
        $af47be6906de36aa$var$$g();
        $af47be6906de36aa$var$mk.current = f;
        $af47be6906de36aa$var$K = e;
        null !== $af47be6906de36aa$var$Y ? b = 0 : ($af47be6906de36aa$var$Q = null, $af47be6906de36aa$var$Z = 0, b = $af47be6906de36aa$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $af47be6906de36aa$var$xc(a), 0 !== e && (d = e, b = $af47be6906de36aa$var$Nk(a, e)));
        if (1 === b) throw c = $af47be6906de36aa$var$pk, $af47be6906de36aa$var$Kk(a, 0), $af47be6906de36aa$var$Ck(a, d), $af47be6906de36aa$var$Dk(a, $af47be6906de36aa$var$B()), c;
        if (6 === b) $af47be6906de36aa$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$af47be6906de36aa$var$Ok(e) && (b = $af47be6906de36aa$var$Ik(a, d), 2 === b && (f = $af47be6906de36aa$var$xc(a), 0 !== f && (d = f, b = $af47be6906de36aa$var$Nk(a, f))), 1 === b)) throw c = $af47be6906de36aa$var$pk, $af47be6906de36aa$var$Kk(a, 0), $af47be6906de36aa$var$Ck(a, d), $af47be6906de36aa$var$Dk(a, $af47be6906de36aa$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($af47be6906de36aa$var$p(345));
                case 2:
                    $af47be6906de36aa$var$Pk(a, $af47be6906de36aa$var$tk, $af47be6906de36aa$var$uk);
                    break;
                case 3:
                    $af47be6906de36aa$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $af47be6906de36aa$var$fk + 500 - $af47be6906de36aa$var$B(), 10 < b)) {
                        if (0 !== $af47be6906de36aa$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $af47be6906de36aa$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $af47be6906de36aa$var$Ff($af47be6906de36aa$var$Pk.bind(null, a, $af47be6906de36aa$var$tk, $af47be6906de36aa$var$uk), b);
                        break;
                    }
                    $af47be6906de36aa$var$Pk(a, $af47be6906de36aa$var$tk, $af47be6906de36aa$var$uk);
                    break;
                case 4:
                    $af47be6906de36aa$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $af47be6906de36aa$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $af47be6906de36aa$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $af47be6906de36aa$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $af47be6906de36aa$var$Ff($af47be6906de36aa$var$Pk.bind(null, a, $af47be6906de36aa$var$tk, $af47be6906de36aa$var$uk), d);
                        break;
                    }
                    $af47be6906de36aa$var$Pk(a, $af47be6906de36aa$var$tk, $af47be6906de36aa$var$uk);
                    break;
                case 5:
                    $af47be6906de36aa$var$Pk(a, $af47be6906de36aa$var$tk, $af47be6906de36aa$var$uk);
                    break;
                default:
                    throw Error($af47be6906de36aa$var$p(329));
            }
        }
    }
    $af47be6906de36aa$var$Dk(a, $af47be6906de36aa$var$B());
    return a.callbackNode === c ? $af47be6906de36aa$var$Gk.bind(null, a) : null;
}
function $af47be6906de36aa$var$Nk(a, b) {
    var c = $af47be6906de36aa$var$sk;
    a.current.memoizedState.isDehydrated && ($af47be6906de36aa$var$Kk(a, b).flags |= 256);
    a = $af47be6906de36aa$var$Ik(a, b);
    2 !== a && (b = $af47be6906de36aa$var$tk, $af47be6906de36aa$var$tk = c, null !== b && $af47be6906de36aa$var$Fj(b));
    return a;
}
function $af47be6906de36aa$var$Fj(a) {
    null === $af47be6906de36aa$var$tk ? $af47be6906de36aa$var$tk = a : $af47be6906de36aa$var$tk.push.apply($af47be6906de36aa$var$tk, a);
}
function $af47be6906de36aa$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$af47be6906de36aa$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $af47be6906de36aa$var$Ck(a, b) {
    b &= ~$af47be6906de36aa$var$rk;
    b &= ~$af47be6906de36aa$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $af47be6906de36aa$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $af47be6906de36aa$var$Ek(a) {
    if (0 !== ($af47be6906de36aa$var$K & 6)) throw Error($af47be6906de36aa$var$p(327));
    $af47be6906de36aa$var$Hk();
    var b = $af47be6906de36aa$var$uc(a, 0);
    if (0 === (b & 1)) return $af47be6906de36aa$var$Dk(a, $af47be6906de36aa$var$B()), null;
    var c = $af47be6906de36aa$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $af47be6906de36aa$var$xc(a);
        0 !== d && (b = d, c = $af47be6906de36aa$var$Nk(a, d));
    }
    if (1 === c) throw c = $af47be6906de36aa$var$pk, $af47be6906de36aa$var$Kk(a, 0), $af47be6906de36aa$var$Ck(a, b), $af47be6906de36aa$var$Dk(a, $af47be6906de36aa$var$B()), c;
    if (6 === c) throw Error($af47be6906de36aa$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $af47be6906de36aa$var$Pk(a, $af47be6906de36aa$var$tk, $af47be6906de36aa$var$uk);
    $af47be6906de36aa$var$Dk(a, $af47be6906de36aa$var$B());
    return null;
}
function $af47be6906de36aa$var$Qk(a, b) {
    var c = $af47be6906de36aa$var$K;
    $af47be6906de36aa$var$K |= 1;
    try {
        return a(b);
    } finally{
        $af47be6906de36aa$var$K = c, 0 === $af47be6906de36aa$var$K && ($af47be6906de36aa$var$Gj = $af47be6906de36aa$var$B() + 500, $af47be6906de36aa$var$fg && $af47be6906de36aa$var$jg());
    }
}
function $af47be6906de36aa$var$Rk(a) {
    null !== $af47be6906de36aa$var$wk && 0 === $af47be6906de36aa$var$wk.tag && 0 === ($af47be6906de36aa$var$K & 6) && $af47be6906de36aa$var$Hk();
    var b = $af47be6906de36aa$var$K;
    $af47be6906de36aa$var$K |= 1;
    var c = $af47be6906de36aa$var$ok.transition, d = $af47be6906de36aa$var$C;
    try {
        if ($af47be6906de36aa$var$ok.transition = null, $af47be6906de36aa$var$C = 1, a) return a();
    } finally{
        $af47be6906de36aa$var$C = d, $af47be6906de36aa$var$ok.transition = c, $af47be6906de36aa$var$K = b, 0 === ($af47be6906de36aa$var$K & 6) && $af47be6906de36aa$var$jg();
    }
}
function $af47be6906de36aa$var$Hj() {
    $af47be6906de36aa$var$fj = $af47be6906de36aa$var$ej.current;
    $af47be6906de36aa$var$E($af47be6906de36aa$var$ej);
}
function $af47be6906de36aa$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $af47be6906de36aa$var$Gf(c));
    if (null !== $af47be6906de36aa$var$Y) for(c = $af47be6906de36aa$var$Y.return; null !== c;){
        var d = c;
        $af47be6906de36aa$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $af47be6906de36aa$var$$f();
                break;
            case 3:
                $af47be6906de36aa$var$zh();
                $af47be6906de36aa$var$E($af47be6906de36aa$var$Wf);
                $af47be6906de36aa$var$E($af47be6906de36aa$var$H);
                $af47be6906de36aa$var$Eh();
                break;
            case 5:
                $af47be6906de36aa$var$Bh(d);
                break;
            case 4:
                $af47be6906de36aa$var$zh();
                break;
            case 13:
                $af47be6906de36aa$var$E($af47be6906de36aa$var$L);
                break;
            case 19:
                $af47be6906de36aa$var$E($af47be6906de36aa$var$L);
                break;
            case 10:
                $af47be6906de36aa$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $af47be6906de36aa$var$Hj();
        }
        c = c.return;
    }
    $af47be6906de36aa$var$Q = a;
    $af47be6906de36aa$var$Y = a = $af47be6906de36aa$var$Pg(a.current, null);
    $af47be6906de36aa$var$Z = $af47be6906de36aa$var$fj = b;
    $af47be6906de36aa$var$T = 0;
    $af47be6906de36aa$var$pk = null;
    $af47be6906de36aa$var$rk = $af47be6906de36aa$var$qk = $af47be6906de36aa$var$rh = 0;
    $af47be6906de36aa$var$tk = $af47be6906de36aa$var$sk = null;
    if (null !== $af47be6906de36aa$var$fh) {
        for(b = 0; b < $af47be6906de36aa$var$fh.length; b++)if (c = $af47be6906de36aa$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $af47be6906de36aa$var$fh = null;
    }
    return a;
}
function $af47be6906de36aa$var$Mk(a, b) {
    do {
        var c = $af47be6906de36aa$var$Y;
        try {
            $af47be6906de36aa$var$$g();
            $af47be6906de36aa$var$Fh.current = $af47be6906de36aa$var$Rh;
            if ($af47be6906de36aa$var$Ih) {
                for(var d = $af47be6906de36aa$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $af47be6906de36aa$var$Ih = !1;
            }
            $af47be6906de36aa$var$Hh = 0;
            $af47be6906de36aa$var$O = $af47be6906de36aa$var$N = $af47be6906de36aa$var$M = null;
            $af47be6906de36aa$var$Jh = !1;
            $af47be6906de36aa$var$Kh = 0;
            $af47be6906de36aa$var$nk.current = null;
            if (null === c || null === c.return) {
                $af47be6906de36aa$var$T = 1;
                $af47be6906de36aa$var$pk = b;
                $af47be6906de36aa$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $af47be6906de36aa$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $af47be6906de36aa$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $af47be6906de36aa$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $af47be6906de36aa$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $af47be6906de36aa$var$Si(f, l, b);
                            $af47be6906de36aa$var$tj();
                            break a;
                        }
                        k = Error($af47be6906de36aa$var$p(426));
                    }
                } else if ($af47be6906de36aa$var$I && h.mode & 1) {
                    var J = $af47be6906de36aa$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $af47be6906de36aa$var$Vi(J, g, h, f, b);
                        $af47be6906de36aa$var$Jg($af47be6906de36aa$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $af47be6906de36aa$var$Ji(k, h);
                4 !== $af47be6906de36aa$var$T && ($af47be6906de36aa$var$T = 2);
                null === $af47be6906de36aa$var$sk ? $af47be6906de36aa$var$sk = [
                    f
                ] : $af47be6906de36aa$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $af47be6906de36aa$var$Ni(f, k, b);
                            $af47be6906de36aa$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $af47be6906de36aa$var$Ri || !$af47be6906de36aa$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $af47be6906de36aa$var$Qi(f, h, b);
                                $af47be6906de36aa$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $af47be6906de36aa$var$Sk(c);
        } catch (na) {
            b = na;
            $af47be6906de36aa$var$Y === c && null !== c && ($af47be6906de36aa$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $af47be6906de36aa$var$Jk() {
    var a = $af47be6906de36aa$var$mk.current;
    $af47be6906de36aa$var$mk.current = $af47be6906de36aa$var$Rh;
    return null === a ? $af47be6906de36aa$var$Rh : a;
}
function $af47be6906de36aa$var$tj() {
    if (0 === $af47be6906de36aa$var$T || 3 === $af47be6906de36aa$var$T || 2 === $af47be6906de36aa$var$T) $af47be6906de36aa$var$T = 4;
    null === $af47be6906de36aa$var$Q || 0 === ($af47be6906de36aa$var$rh & 268435455) && 0 === ($af47be6906de36aa$var$qk & 268435455) || $af47be6906de36aa$var$Ck($af47be6906de36aa$var$Q, $af47be6906de36aa$var$Z);
}
function $af47be6906de36aa$var$Ik(a, b) {
    var c = $af47be6906de36aa$var$K;
    $af47be6906de36aa$var$K |= 2;
    var d = $af47be6906de36aa$var$Jk();
    if ($af47be6906de36aa$var$Q !== a || $af47be6906de36aa$var$Z !== b) $af47be6906de36aa$var$uk = null, $af47be6906de36aa$var$Kk(a, b);
    for(;;)try {
        $af47be6906de36aa$var$Tk();
        break;
    } catch (e) {
        $af47be6906de36aa$var$Mk(a, e);
    }
    $af47be6906de36aa$var$$g();
    $af47be6906de36aa$var$K = c;
    $af47be6906de36aa$var$mk.current = d;
    if (null !== $af47be6906de36aa$var$Y) throw Error($af47be6906de36aa$var$p(261));
    $af47be6906de36aa$var$Q = null;
    $af47be6906de36aa$var$Z = 0;
    return $af47be6906de36aa$var$T;
}
function $af47be6906de36aa$var$Tk() {
    for(; null !== $af47be6906de36aa$var$Y;)$af47be6906de36aa$var$Uk($af47be6906de36aa$var$Y);
}
function $af47be6906de36aa$var$Lk() {
    for(; null !== $af47be6906de36aa$var$Y && !$af47be6906de36aa$var$cc();)$af47be6906de36aa$var$Uk($af47be6906de36aa$var$Y);
}
function $af47be6906de36aa$var$Uk(a) {
    var b = $af47be6906de36aa$var$Vk(a.alternate, a, $af47be6906de36aa$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $af47be6906de36aa$var$Sk(a) : $af47be6906de36aa$var$Y = b;
    $af47be6906de36aa$var$nk.current = null;
}
function $af47be6906de36aa$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $af47be6906de36aa$var$Ej(c, b, $af47be6906de36aa$var$fj), null !== c) {
                $af47be6906de36aa$var$Y = c;
                return;
            }
        } else {
            c = $af47be6906de36aa$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $af47be6906de36aa$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $af47be6906de36aa$var$T = 6;
                $af47be6906de36aa$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $af47be6906de36aa$var$Y = b;
            return;
        }
        $af47be6906de36aa$var$Y = b = a;
    }while (null !== b);
    0 === $af47be6906de36aa$var$T && ($af47be6906de36aa$var$T = 5);
}
function $af47be6906de36aa$var$Pk(a, b, c) {
    var d = $af47be6906de36aa$var$C, e = $af47be6906de36aa$var$ok.transition;
    try {
        $af47be6906de36aa$var$ok.transition = null, $af47be6906de36aa$var$C = 1, $af47be6906de36aa$var$Wk(a, b, c, d);
    } finally{
        $af47be6906de36aa$var$ok.transition = e, $af47be6906de36aa$var$C = d;
    }
    return null;
}
function $af47be6906de36aa$var$Wk(a, b, c, d) {
    do $af47be6906de36aa$var$Hk();
    while (null !== $af47be6906de36aa$var$wk);
    if (0 !== ($af47be6906de36aa$var$K & 6)) throw Error($af47be6906de36aa$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($af47be6906de36aa$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $af47be6906de36aa$var$Bc(a, f);
    a === $af47be6906de36aa$var$Q && ($af47be6906de36aa$var$Y = $af47be6906de36aa$var$Q = null, $af47be6906de36aa$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $af47be6906de36aa$var$vk || ($af47be6906de36aa$var$vk = !0, $af47be6906de36aa$var$Fk($af47be6906de36aa$var$hc, function() {
        $af47be6906de36aa$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $af47be6906de36aa$var$ok.transition;
        $af47be6906de36aa$var$ok.transition = null;
        var g = $af47be6906de36aa$var$C;
        $af47be6906de36aa$var$C = 1;
        var h = $af47be6906de36aa$var$K;
        $af47be6906de36aa$var$K |= 4;
        $af47be6906de36aa$var$nk.current = null;
        $af47be6906de36aa$var$Oj(a, c);
        $af47be6906de36aa$var$dk(c, a);
        $af47be6906de36aa$var$Oe($af47be6906de36aa$var$Df);
        $af47be6906de36aa$var$dd = !!$af47be6906de36aa$var$Cf;
        $af47be6906de36aa$var$Df = $af47be6906de36aa$var$Cf = null;
        a.current = c;
        $af47be6906de36aa$var$hk(c, a, e);
        $af47be6906de36aa$var$dc();
        $af47be6906de36aa$var$K = h;
        $af47be6906de36aa$var$C = g;
        $af47be6906de36aa$var$ok.transition = f;
    } else a.current = c;
    $af47be6906de36aa$var$vk && ($af47be6906de36aa$var$vk = !1, $af47be6906de36aa$var$wk = a, $af47be6906de36aa$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($af47be6906de36aa$var$Ri = null);
    $af47be6906de36aa$var$mc(c.stateNode, d);
    $af47be6906de36aa$var$Dk(a, $af47be6906de36aa$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($af47be6906de36aa$var$Oi) throw $af47be6906de36aa$var$Oi = !1, a = $af47be6906de36aa$var$Pi, $af47be6906de36aa$var$Pi = null, a;
    0 !== ($af47be6906de36aa$var$xk & 1) && 0 !== a.tag && $af47be6906de36aa$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $af47be6906de36aa$var$zk ? $af47be6906de36aa$var$yk++ : ($af47be6906de36aa$var$yk = 0, $af47be6906de36aa$var$zk = a) : $af47be6906de36aa$var$yk = 0;
    $af47be6906de36aa$var$jg();
    return null;
}
function $af47be6906de36aa$var$Hk() {
    if (null !== $af47be6906de36aa$var$wk) {
        var a = $af47be6906de36aa$var$Dc($af47be6906de36aa$var$xk), b = $af47be6906de36aa$var$ok.transition, c = $af47be6906de36aa$var$C;
        try {
            $af47be6906de36aa$var$ok.transition = null;
            $af47be6906de36aa$var$C = 16 > a ? 16 : a;
            if (null === $af47be6906de36aa$var$wk) var d = !1;
            else {
                a = $af47be6906de36aa$var$wk;
                $af47be6906de36aa$var$wk = null;
                $af47be6906de36aa$var$xk = 0;
                if (0 !== ($af47be6906de36aa$var$K & 6)) throw Error($af47be6906de36aa$var$p(331));
                var e = $af47be6906de36aa$var$K;
                $af47be6906de36aa$var$K |= 4;
                for($af47be6906de36aa$var$V = a.current; null !== $af47be6906de36aa$var$V;){
                    var f = $af47be6906de36aa$var$V, g = f.child;
                    if (0 !== ($af47be6906de36aa$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($af47be6906de36aa$var$V = l; null !== $af47be6906de36aa$var$V;){
                                    var m = $af47be6906de36aa$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $af47be6906de36aa$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $af47be6906de36aa$var$V = q;
                                    else for(; null !== $af47be6906de36aa$var$V;){
                                        m = $af47be6906de36aa$var$V;
                                        var r = m.sibling, y = m.return;
                                        $af47be6906de36aa$var$Sj(m);
                                        if (m === l) {
                                            $af47be6906de36aa$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $af47be6906de36aa$var$V = r;
                                            break;
                                        }
                                        $af47be6906de36aa$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $af47be6906de36aa$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $af47be6906de36aa$var$V = g;
                    else b: for(; null !== $af47be6906de36aa$var$V;){
                        f = $af47be6906de36aa$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $af47be6906de36aa$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $af47be6906de36aa$var$V = x;
                            break b;
                        }
                        $af47be6906de36aa$var$V = f.return;
                    }
                }
                var w = a.current;
                for($af47be6906de36aa$var$V = w; null !== $af47be6906de36aa$var$V;){
                    g = $af47be6906de36aa$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $af47be6906de36aa$var$V = u;
                    else b: for(g = w; null !== $af47be6906de36aa$var$V;){
                        h = $af47be6906de36aa$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $af47be6906de36aa$var$Qj(9, h);
                            }
                        } catch (na) {
                            $af47be6906de36aa$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $af47be6906de36aa$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $af47be6906de36aa$var$V = F;
                            break b;
                        }
                        $af47be6906de36aa$var$V = h.return;
                    }
                }
                $af47be6906de36aa$var$K = e;
                $af47be6906de36aa$var$jg();
                if ($af47be6906de36aa$var$lc && "function" === typeof $af47be6906de36aa$var$lc.onPostCommitFiberRoot) try {
                    $af47be6906de36aa$var$lc.onPostCommitFiberRoot($af47be6906de36aa$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $af47be6906de36aa$var$C = c, $af47be6906de36aa$var$ok.transition = b;
        }
    }
    return !1;
}
function $af47be6906de36aa$var$Xk(a, b, c) {
    b = $af47be6906de36aa$var$Ji(c, b);
    b = $af47be6906de36aa$var$Ni(a, b, 1);
    a = $af47be6906de36aa$var$nh(a, b, 1);
    b = $af47be6906de36aa$var$R();
    null !== a && ($af47be6906de36aa$var$Ac(a, 1, b), $af47be6906de36aa$var$Dk(a, b));
}
function $af47be6906de36aa$var$W(a, b, c) {
    if (3 === a.tag) $af47be6906de36aa$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $af47be6906de36aa$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $af47be6906de36aa$var$Ri || !$af47be6906de36aa$var$Ri.has(d))) {
                a = $af47be6906de36aa$var$Ji(c, a);
                a = $af47be6906de36aa$var$Qi(b, a, 1);
                b = $af47be6906de36aa$var$nh(b, a, 1);
                a = $af47be6906de36aa$var$R();
                null !== b && ($af47be6906de36aa$var$Ac(b, 1, a), $af47be6906de36aa$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $af47be6906de36aa$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $af47be6906de36aa$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $af47be6906de36aa$var$Q === a && ($af47be6906de36aa$var$Z & c) === c && (4 === $af47be6906de36aa$var$T || 3 === $af47be6906de36aa$var$T && ($af47be6906de36aa$var$Z & 130023424) === $af47be6906de36aa$var$Z && 500 > $af47be6906de36aa$var$B() - $af47be6906de36aa$var$fk ? $af47be6906de36aa$var$Kk(a, 0) : $af47be6906de36aa$var$rk |= c);
    $af47be6906de36aa$var$Dk(a, b);
}
function $af47be6906de36aa$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $af47be6906de36aa$var$sc, $af47be6906de36aa$var$sc <<= 1, 0 === ($af47be6906de36aa$var$sc & 130023424) && ($af47be6906de36aa$var$sc = 4194304)));
    var c = $af47be6906de36aa$var$R();
    a = $af47be6906de36aa$var$ih(a, b);
    null !== a && ($af47be6906de36aa$var$Ac(a, b, c), $af47be6906de36aa$var$Dk(a, c));
}
function $af47be6906de36aa$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $af47be6906de36aa$var$Yk(a, c);
}
function $af47be6906de36aa$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($af47be6906de36aa$var$p(314));
    }
    null !== d && d.delete(b);
    $af47be6906de36aa$var$Yk(a, c);
}
var $af47be6906de36aa$var$Vk;
$af47be6906de36aa$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $af47be6906de36aa$var$Wf.current) $af47be6906de36aa$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $af47be6906de36aa$var$dh = !1, $af47be6906de36aa$var$yj(a, b, c);
            $af47be6906de36aa$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $af47be6906de36aa$var$dh = !1, $af47be6906de36aa$var$I && 0 !== (b.flags & 1048576) && $af47be6906de36aa$var$ug(b, $af47be6906de36aa$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $af47be6906de36aa$var$ij(a, b);
            a = b.pendingProps;
            var e = $af47be6906de36aa$var$Yf(b, $af47be6906de36aa$var$H.current);
            $af47be6906de36aa$var$ch(b, c);
            e = $af47be6906de36aa$var$Nh(null, b, d, a, e, c);
            var f = $af47be6906de36aa$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $af47be6906de36aa$var$Zf(d) ? (f = !0, $af47be6906de36aa$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $af47be6906de36aa$var$kh(b), e.updater = $af47be6906de36aa$var$Ei, b.stateNode = e, e._reactInternals = b, $af47be6906de36aa$var$Ii(b, d, a, c), b = $af47be6906de36aa$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $af47be6906de36aa$var$I && f && $af47be6906de36aa$var$vg(b), $af47be6906de36aa$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $af47be6906de36aa$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $af47be6906de36aa$var$Zk(d);
                a = $af47be6906de36aa$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $af47be6906de36aa$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $af47be6906de36aa$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $af47be6906de36aa$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $af47be6906de36aa$var$$i(null, b, d, $af47be6906de36aa$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($af47be6906de36aa$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $af47be6906de36aa$var$Ci(d, e), $af47be6906de36aa$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $af47be6906de36aa$var$Ci(d, e), $af47be6906de36aa$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $af47be6906de36aa$var$kj(b);
                if (null === a) throw Error($af47be6906de36aa$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $af47be6906de36aa$var$lh(a, b);
                $af47be6906de36aa$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $af47be6906de36aa$var$Ji(Error($af47be6906de36aa$var$p(423)), b);
                        b = $af47be6906de36aa$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $af47be6906de36aa$var$Ji(Error($af47be6906de36aa$var$p(424)), b);
                        b = $af47be6906de36aa$var$lj(a, b, d, c, e);
                        break a;
                    } else for($af47be6906de36aa$var$yg = $af47be6906de36aa$var$Lf(b.stateNode.containerInfo.firstChild), $af47be6906de36aa$var$xg = b, $af47be6906de36aa$var$I = !0, $af47be6906de36aa$var$zg = null, c = $af47be6906de36aa$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $af47be6906de36aa$var$Ig();
                    if (d === e) {
                        b = $af47be6906de36aa$var$Zi(a, b, c);
                        break a;
                    }
                    $af47be6906de36aa$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $af47be6906de36aa$var$Ah(b), null === a && $af47be6906de36aa$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $af47be6906de36aa$var$Ef(d, e) ? g = null : null !== f && $af47be6906de36aa$var$Ef(d, f) && (b.flags |= 32), $af47be6906de36aa$var$gj(a, b), $af47be6906de36aa$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $af47be6906de36aa$var$Eg(b), null;
        case 13:
            return $af47be6906de36aa$var$oj(a, b, c);
        case 4:
            return $af47be6906de36aa$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $af47be6906de36aa$var$Ug(b, null, d, c) : $af47be6906de36aa$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $af47be6906de36aa$var$Ci(d, e), $af47be6906de36aa$var$Yi(a, b, d, e, c);
        case 7:
            return $af47be6906de36aa$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $af47be6906de36aa$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $af47be6906de36aa$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $af47be6906de36aa$var$G($af47be6906de36aa$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($af47be6906de36aa$var$He(f.value, g)) {
                        if (f.children === e.children && !$af47be6906de36aa$var$Wf.current) {
                            b = $af47be6906de36aa$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $af47be6906de36aa$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $af47be6906de36aa$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($af47be6906de36aa$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $af47be6906de36aa$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $af47be6906de36aa$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $af47be6906de36aa$var$ch(b, c), e = $af47be6906de36aa$var$eh(e), d = d(e), b.flags |= 1, $af47be6906de36aa$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $af47be6906de36aa$var$Ci(d, b.pendingProps), e = $af47be6906de36aa$var$Ci(d.type, e), $af47be6906de36aa$var$$i(a, b, d, e, c);
        case 15:
            return $af47be6906de36aa$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $af47be6906de36aa$var$Ci(d, e), $af47be6906de36aa$var$ij(a, b), b.tag = 1, $af47be6906de36aa$var$Zf(d) ? (a = !0, $af47be6906de36aa$var$cg(b)) : a = !1, $af47be6906de36aa$var$ch(b, c), $af47be6906de36aa$var$Gi(b, d, e), $af47be6906de36aa$var$Ii(b, d, e, c), $af47be6906de36aa$var$jj(null, b, d, !0, a, c);
        case 19:
            return $af47be6906de36aa$var$xj(a, b, c);
        case 22:
            return $af47be6906de36aa$var$dj(a, b, c);
    }
    throw Error($af47be6906de36aa$var$p(156, b.tag));
};
function $af47be6906de36aa$var$Fk(a, b) {
    return $af47be6906de36aa$var$ac(a, b);
}
function $af47be6906de36aa$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $af47be6906de36aa$var$Bg(a, b, c, d) {
    return new $af47be6906de36aa$var$$k(a, b, c, d);
}
function $af47be6906de36aa$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $af47be6906de36aa$var$Zk(a) {
    if ("function" === typeof a) return $af47be6906de36aa$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $af47be6906de36aa$var$Da) return 11;
        if (a === $af47be6906de36aa$var$Ga) return 14;
    }
    return 2;
}
function $af47be6906de36aa$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $af47be6906de36aa$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $af47be6906de36aa$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $af47be6906de36aa$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $af47be6906de36aa$var$ya:
            return $af47be6906de36aa$var$Tg(c.children, e, f, b);
        case $af47be6906de36aa$var$za:
            g = 8;
            e |= 8;
            break;
        case $af47be6906de36aa$var$Aa:
            return a = $af47be6906de36aa$var$Bg(12, c, b, e | 2), a.elementType = $af47be6906de36aa$var$Aa, a.lanes = f, a;
        case $af47be6906de36aa$var$Ea:
            return a = $af47be6906de36aa$var$Bg(13, c, b, e), a.elementType = $af47be6906de36aa$var$Ea, a.lanes = f, a;
        case $af47be6906de36aa$var$Fa:
            return a = $af47be6906de36aa$var$Bg(19, c, b, e), a.elementType = $af47be6906de36aa$var$Fa, a.lanes = f, a;
        case $af47be6906de36aa$var$Ia:
            return $af47be6906de36aa$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $af47be6906de36aa$var$Ba:
                    g = 10;
                    break a;
                case $af47be6906de36aa$var$Ca:
                    g = 9;
                    break a;
                case $af47be6906de36aa$var$Da:
                    g = 11;
                    break a;
                case $af47be6906de36aa$var$Ga:
                    g = 14;
                    break a;
                case $af47be6906de36aa$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($af47be6906de36aa$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $af47be6906de36aa$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $af47be6906de36aa$var$Tg(a, b, c, d) {
    a = $af47be6906de36aa$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $af47be6906de36aa$var$pj(a, b, c, d) {
    a = $af47be6906de36aa$var$Bg(22, a, d, b);
    a.elementType = $af47be6906de36aa$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $af47be6906de36aa$var$Qg(a, b, c) {
    a = $af47be6906de36aa$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $af47be6906de36aa$var$Sg(a, b, c) {
    b = $af47be6906de36aa$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $af47be6906de36aa$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $af47be6906de36aa$var$zc(0);
    this.expirationTimes = $af47be6906de36aa$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $af47be6906de36aa$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $af47be6906de36aa$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $af47be6906de36aa$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $af47be6906de36aa$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $af47be6906de36aa$var$kh(f);
    return a;
}
function $af47be6906de36aa$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $af47be6906de36aa$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $af47be6906de36aa$var$dl(a) {
    if (!a) return $af47be6906de36aa$var$Vf;
    a = a._reactInternals;
    a: {
        if ($af47be6906de36aa$var$Vb(a) !== a || 1 !== a.tag) throw Error($af47be6906de36aa$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($af47be6906de36aa$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($af47be6906de36aa$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($af47be6906de36aa$var$Zf(c)) return $af47be6906de36aa$var$bg(a, c, b);
    }
    return b;
}
function $af47be6906de36aa$var$el(a, b, c, d, e, f, g, h, k) {
    a = $af47be6906de36aa$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $af47be6906de36aa$var$dl(null);
    c = a.current;
    d = $af47be6906de36aa$var$R();
    e = $af47be6906de36aa$var$yi(c);
    f = $af47be6906de36aa$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $af47be6906de36aa$var$nh(c, f, e);
    a.current.lanes = e;
    $af47be6906de36aa$var$Ac(a, e, d);
    $af47be6906de36aa$var$Dk(a, d);
    return a;
}
function $af47be6906de36aa$var$fl(a, b, c, d) {
    var e = b.current, f = $af47be6906de36aa$var$R(), g = $af47be6906de36aa$var$yi(e);
    c = $af47be6906de36aa$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $af47be6906de36aa$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $af47be6906de36aa$var$nh(e, b, g);
    null !== a && ($af47be6906de36aa$var$gi(a, e, g, f), $af47be6906de36aa$var$oh(a, e, g));
    return g;
}
function $af47be6906de36aa$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $af47be6906de36aa$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $af47be6906de36aa$var$il(a, b) {
    $af47be6906de36aa$var$hl(a, b);
    (a = a.alternate) && $af47be6906de36aa$var$hl(a, b);
}
function $af47be6906de36aa$var$jl() {
    return null;
}
var $af47be6906de36aa$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $af47be6906de36aa$var$ll(a) {
    this._internalRoot = a;
}
$af47be6906de36aa$var$ml.prototype.render = $af47be6906de36aa$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($af47be6906de36aa$var$p(409));
    $af47be6906de36aa$var$fl(a, b, null, null);
};
$af47be6906de36aa$var$ml.prototype.unmount = $af47be6906de36aa$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $af47be6906de36aa$var$Rk(function() {
            $af47be6906de36aa$var$fl(null, a, null, null);
        });
        b[$af47be6906de36aa$var$uf] = null;
    }
};
function $af47be6906de36aa$var$ml(a) {
    this._internalRoot = a;
}
$af47be6906de36aa$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $af47be6906de36aa$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $af47be6906de36aa$var$Qc.length && 0 !== b && b < $af47be6906de36aa$var$Qc[c].priority; c++);
        $af47be6906de36aa$var$Qc.splice(c, 0, a);
        0 === c && $af47be6906de36aa$var$Vc(a);
    }
};
function $af47be6906de36aa$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $af47be6906de36aa$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $af47be6906de36aa$var$pl() {}
function $af47be6906de36aa$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $af47be6906de36aa$var$gl(g);
                f.call(a);
            };
        }
        var g = $af47be6906de36aa$var$el(b, d, a, 0, null, !1, !1, "", $af47be6906de36aa$var$pl);
        a._reactRootContainer = g;
        a[$af47be6906de36aa$var$uf] = g.current;
        $af47be6906de36aa$var$sf(8 === a.nodeType ? a.parentNode : a);
        $af47be6906de36aa$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $af47be6906de36aa$var$gl(k);
            h.call(a);
        };
    }
    var k = $af47be6906de36aa$var$bl(a, 0, !1, null, null, !1, !1, "", $af47be6906de36aa$var$pl);
    a._reactRootContainer = k;
    a[$af47be6906de36aa$var$uf] = k.current;
    $af47be6906de36aa$var$sf(8 === a.nodeType ? a.parentNode : a);
    $af47be6906de36aa$var$Rk(function() {
        $af47be6906de36aa$var$fl(b, k, c, d);
    });
    return k;
}
function $af47be6906de36aa$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $af47be6906de36aa$var$gl(g);
                h.call(a);
            };
        }
        $af47be6906de36aa$var$fl(b, g, a, e);
    } else g = $af47be6906de36aa$var$ql(c, b, a, e, d);
    return $af47be6906de36aa$var$gl(g);
}
$af47be6906de36aa$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $af47be6906de36aa$var$tc(b.pendingLanes);
                0 !== c && ($af47be6906de36aa$var$Cc(b, c | 1), $af47be6906de36aa$var$Dk(b, $af47be6906de36aa$var$B()), 0 === ($af47be6906de36aa$var$K & 6) && ($af47be6906de36aa$var$Gj = $af47be6906de36aa$var$B() + 500, $af47be6906de36aa$var$jg()));
            }
            break;
        case 13:
            $af47be6906de36aa$var$Rk(function() {
                var b = $af47be6906de36aa$var$ih(a, 1);
                if (null !== b) {
                    var c = $af47be6906de36aa$var$R();
                    $af47be6906de36aa$var$gi(b, a, 1, c);
                }
            }), $af47be6906de36aa$var$il(a, 1);
    }
};
$af47be6906de36aa$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $af47be6906de36aa$var$ih(a, 134217728);
        if (null !== b) {
            var c = $af47be6906de36aa$var$R();
            $af47be6906de36aa$var$gi(b, a, 134217728, c);
        }
        $af47be6906de36aa$var$il(a, 134217728);
    }
};
$af47be6906de36aa$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $af47be6906de36aa$var$yi(a), c = $af47be6906de36aa$var$ih(a, b);
        if (null !== c) {
            var d = $af47be6906de36aa$var$R();
            $af47be6906de36aa$var$gi(c, a, b, d);
        }
        $af47be6906de36aa$var$il(a, b);
    }
};
$af47be6906de36aa$var$Hc = function() {
    return $af47be6906de36aa$var$C;
};
$af47be6906de36aa$var$Ic = function(a, b) {
    var c = $af47be6906de36aa$var$C;
    try {
        return $af47be6906de36aa$var$C = a, b();
    } finally{
        $af47be6906de36aa$var$C = c;
    }
};
$af47be6906de36aa$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $af47be6906de36aa$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $af47be6906de36aa$var$Db(d);
                        if (!e) throw Error($af47be6906de36aa$var$p(90));
                        $af47be6906de36aa$var$Wa(d);
                        $af47be6906de36aa$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $af47be6906de36aa$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $af47be6906de36aa$var$fb(a, !!c.multiple, b, !1);
    }
};
$af47be6906de36aa$var$Gb = $af47be6906de36aa$var$Qk;
$af47be6906de36aa$var$Hb = $af47be6906de36aa$var$Rk;
var $af47be6906de36aa$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $af47be6906de36aa$var$Cb,
        $af47be6906de36aa$var$ue,
        $af47be6906de36aa$var$Db,
        $af47be6906de36aa$var$Eb,
        $af47be6906de36aa$var$Fb,
        $af47be6906de36aa$var$Qk
    ]
}, $af47be6906de36aa$var$tl = {
    findFiberByHostInstance: $af47be6906de36aa$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $af47be6906de36aa$var$ul = {
    bundleType: $af47be6906de36aa$var$tl.bundleType,
    version: $af47be6906de36aa$var$tl.version,
    rendererPackageName: $af47be6906de36aa$var$tl.rendererPackageName,
    rendererConfig: $af47be6906de36aa$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $af47be6906de36aa$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $af47be6906de36aa$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $af47be6906de36aa$var$tl.findFiberByHostInstance || $af47be6906de36aa$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $af47be6906de36aa$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$af47be6906de36aa$var$vl.isDisabled && $af47be6906de36aa$var$vl.supportsFiber) try {
        $af47be6906de36aa$var$kc = $af47be6906de36aa$var$vl.inject($af47be6906de36aa$var$ul), $af47be6906de36aa$var$lc = $af47be6906de36aa$var$vl;
    } catch (a) {}
}
$af47be6906de36aa$export$ae55be85d98224ed = $af47be6906de36aa$var$sl;
$af47be6906de36aa$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$af47be6906de36aa$var$nl(b)) throw Error($af47be6906de36aa$var$p(200));
    return $af47be6906de36aa$var$cl(a, b, null, c);
};
$af47be6906de36aa$export$882461b6382ed46c = function(a, b) {
    if (!$af47be6906de36aa$var$nl(a)) throw Error($af47be6906de36aa$var$p(299));
    var c = !1, d = "", e = $af47be6906de36aa$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $af47be6906de36aa$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$af47be6906de36aa$var$uf] = b.current;
    $af47be6906de36aa$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $af47be6906de36aa$var$ll(b);
};
$af47be6906de36aa$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($af47be6906de36aa$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($af47be6906de36aa$var$p(268, a));
    }
    a = $af47be6906de36aa$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$af47be6906de36aa$export$cd75ccfd720a3cd4 = function(a) {
    return $af47be6906de36aa$var$Rk(a);
};
$af47be6906de36aa$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$af47be6906de36aa$var$ol(b)) throw Error($af47be6906de36aa$var$p(200));
    return $af47be6906de36aa$var$rl(null, a, b, !0, c);
};
$af47be6906de36aa$export$757ceba2d55c277e = function(a, b, c) {
    if (!$af47be6906de36aa$var$nl(a)) throw Error($af47be6906de36aa$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $af47be6906de36aa$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $af47be6906de36aa$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$af47be6906de36aa$var$uf] = b.current;
    $af47be6906de36aa$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $af47be6906de36aa$var$ml(b);
};
$af47be6906de36aa$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$af47be6906de36aa$var$ol(b)) throw Error($af47be6906de36aa$var$p(200));
    return $af47be6906de36aa$var$rl(null, a, b, !1, c);
};
$af47be6906de36aa$export$502457920280e6be = function(a) {
    if (!$af47be6906de36aa$var$ol(a)) throw Error($af47be6906de36aa$var$p(40));
    return a._reactRootContainer ? ($af47be6906de36aa$var$Rk(function() {
        $af47be6906de36aa$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$af47be6906de36aa$var$uf] = null;
        });
    }), !0) : !1;
};
$af47be6906de36aa$export$c78a37762a8d58e1 = $af47be6906de36aa$var$Qk;
$af47be6906de36aa$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$af47be6906de36aa$var$ol(c)) throw Error($af47be6906de36aa$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($af47be6906de36aa$var$p(38));
    return $af47be6906de36aa$var$rl(a, b, c, !1, d);
};
$af47be6906de36aa$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("9LPgQ", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jICNm"));

});
parcelRegister("jICNm", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $e5b038469f55a924$export$c4744153514ff05d; }, function (v) { return $e5b038469f55a924$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $e5b038469f55a924$export$3e506c1ccc9cc1a7; }, function (v) { return $e5b038469f55a924$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $e5b038469f55a924$export$e26fe2ed2fa76875; }, function (v) { return $e5b038469f55a924$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $e5b038469f55a924$export$502329bbf4b505b1; }, function (v) { return $e5b038469f55a924$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $e5b038469f55a924$export$6e3807111c4874c4; }, function (v) { return $e5b038469f55a924$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $e5b038469f55a924$export$c27134553091fb3a; }, function (v) { return $e5b038469f55a924$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $e5b038469f55a924$export$33ee1acdc04fd2a2; }, function (v) { return $e5b038469f55a924$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $e5b038469f55a924$export$b00a404bbd5edef2; }, function (v) { return $e5b038469f55a924$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $e5b038469f55a924$export$8352ce38b91d0c62; }, function (v) { return $e5b038469f55a924$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $e5b038469f55a924$export$d66a1c1c77bd778b; }, function (v) { return $e5b038469f55a924$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $e5b038469f55a924$export$d3dfb8e4810cb555; }, function (v) { return $e5b038469f55a924$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $e5b038469f55a924$export$839f9183b0465a69; }, function (v) { return $e5b038469f55a924$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $e5b038469f55a924$export$72fdf0e06517287b; }, function (v) { return $e5b038469f55a924$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $e5b038469f55a924$export$4b844e58a3e414b4; }, function (v) { return $e5b038469f55a924$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $e5b038469f55a924$export$816d2913ae6b83b1; }, function (v) { return $e5b038469f55a924$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $e5b038469f55a924$export$61bcfe829111a1d0; }, function (v) { return $e5b038469f55a924$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $e5b038469f55a924$export$7ee8c9beb337bc3f; }, function (v) { return $e5b038469f55a924$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $e5b038469f55a924$export$b5836b71941fa3ed; }, function (v) { return $e5b038469f55a924$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $e5b038469f55a924$export$cf845f2c119da08a; }, function (v) { return $e5b038469f55a924$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e5b038469f55a924$export$c4744153514ff05d;
var $e5b038469f55a924$export$3e506c1ccc9cc1a7;
var $e5b038469f55a924$export$e26fe2ed2fa76875;
var $e5b038469f55a924$export$502329bbf4b505b1;
var $e5b038469f55a924$export$6e3807111c4874c4;
var $e5b038469f55a924$export$c27134553091fb3a;
var $e5b038469f55a924$export$33ee1acdc04fd2a2;
var $e5b038469f55a924$export$b00a404bbd5edef2;
var $e5b038469f55a924$export$8352ce38b91d0c62;
var $e5b038469f55a924$export$d66a1c1c77bd778b;
var $e5b038469f55a924$export$d3dfb8e4810cb555;
var $e5b038469f55a924$export$839f9183b0465a69;
var $e5b038469f55a924$export$72fdf0e06517287b;
var $e5b038469f55a924$export$4b844e58a3e414b4;
var $e5b038469f55a924$export$816d2913ae6b83b1;
var $e5b038469f55a924$export$61bcfe829111a1d0;
var $e5b038469f55a924$export$7ee8c9beb337bc3f;
var $e5b038469f55a924$export$b5836b71941fa3ed;
var $e5b038469f55a924$export$cf845f2c119da08a;
'use strict';
function $e5b038469f55a924$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $e5b038469f55a924$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $e5b038469f55a924$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $e5b038469f55a924$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $e5b038469f55a924$var$g(C, c)) n < e && 0 > $e5b038469f55a924$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $e5b038469f55a924$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $e5b038469f55a924$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $e5b038469f55a924$var$l = performance;
    $e5b038469f55a924$export$c4744153514ff05d = function() {
        return $e5b038469f55a924$var$l.now();
    };
} else {
    var $e5b038469f55a924$var$p = Date, $e5b038469f55a924$var$q = $e5b038469f55a924$var$p.now();
    $e5b038469f55a924$export$c4744153514ff05d = function() {
        return $e5b038469f55a924$var$p.now() - $e5b038469f55a924$var$q;
    };
}
var $e5b038469f55a924$var$r = [], $e5b038469f55a924$var$t = [], $e5b038469f55a924$var$u = 1, $e5b038469f55a924$var$v = null, $e5b038469f55a924$var$y = 3, $e5b038469f55a924$var$z = !1, $e5b038469f55a924$var$A = !1, $e5b038469f55a924$var$B = !1, $e5b038469f55a924$var$D = "function" === typeof setTimeout ? setTimeout : null, $e5b038469f55a924$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $e5b038469f55a924$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $e5b038469f55a924$var$G(a) {
    for(var b = $e5b038469f55a924$var$h($e5b038469f55a924$var$t); null !== b;){
        if (null === b.callback) $e5b038469f55a924$var$k($e5b038469f55a924$var$t);
        else if (b.startTime <= a) $e5b038469f55a924$var$k($e5b038469f55a924$var$t), b.sortIndex = b.expirationTime, $e5b038469f55a924$var$f($e5b038469f55a924$var$r, b);
        else break;
        b = $e5b038469f55a924$var$h($e5b038469f55a924$var$t);
    }
}
function $e5b038469f55a924$var$H(a) {
    $e5b038469f55a924$var$B = !1;
    $e5b038469f55a924$var$G(a);
    if (!$e5b038469f55a924$var$A) {
        if (null !== $e5b038469f55a924$var$h($e5b038469f55a924$var$r)) $e5b038469f55a924$var$A = !0, $e5b038469f55a924$var$I($e5b038469f55a924$var$J);
        else {
            var b = $e5b038469f55a924$var$h($e5b038469f55a924$var$t);
            null !== b && $e5b038469f55a924$var$K($e5b038469f55a924$var$H, b.startTime - a);
        }
    }
}
function $e5b038469f55a924$var$J(a, b) {
    $e5b038469f55a924$var$A = !1;
    $e5b038469f55a924$var$B && ($e5b038469f55a924$var$B = !1, $e5b038469f55a924$var$E($e5b038469f55a924$var$L), $e5b038469f55a924$var$L = -1);
    $e5b038469f55a924$var$z = !0;
    var c = $e5b038469f55a924$var$y;
    try {
        $e5b038469f55a924$var$G(b);
        for($e5b038469f55a924$var$v = $e5b038469f55a924$var$h($e5b038469f55a924$var$r); null !== $e5b038469f55a924$var$v && (!($e5b038469f55a924$var$v.expirationTime > b) || a && !$e5b038469f55a924$var$M());){
            var d = $e5b038469f55a924$var$v.callback;
            if ("function" === typeof d) {
                $e5b038469f55a924$var$v.callback = null;
                $e5b038469f55a924$var$y = $e5b038469f55a924$var$v.priorityLevel;
                var e = d($e5b038469f55a924$var$v.expirationTime <= b);
                b = $e5b038469f55a924$export$c4744153514ff05d();
                "function" === typeof e ? $e5b038469f55a924$var$v.callback = e : $e5b038469f55a924$var$v === $e5b038469f55a924$var$h($e5b038469f55a924$var$r) && $e5b038469f55a924$var$k($e5b038469f55a924$var$r);
                $e5b038469f55a924$var$G(b);
            } else $e5b038469f55a924$var$k($e5b038469f55a924$var$r);
            $e5b038469f55a924$var$v = $e5b038469f55a924$var$h($e5b038469f55a924$var$r);
        }
        if (null !== $e5b038469f55a924$var$v) var w = !0;
        else {
            var m = $e5b038469f55a924$var$h($e5b038469f55a924$var$t);
            null !== m && $e5b038469f55a924$var$K($e5b038469f55a924$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $e5b038469f55a924$var$v = null, $e5b038469f55a924$var$y = c, $e5b038469f55a924$var$z = !1;
    }
}
var $e5b038469f55a924$var$N = !1, $e5b038469f55a924$var$O = null, $e5b038469f55a924$var$L = -1, $e5b038469f55a924$var$P = 5, $e5b038469f55a924$var$Q = -1;
function $e5b038469f55a924$var$M() {
    return $e5b038469f55a924$export$c4744153514ff05d() - $e5b038469f55a924$var$Q < $e5b038469f55a924$var$P ? !1 : !0;
}
function $e5b038469f55a924$var$R() {
    if (null !== $e5b038469f55a924$var$O) {
        var a = $e5b038469f55a924$export$c4744153514ff05d();
        $e5b038469f55a924$var$Q = a;
        var b = !0;
        try {
            b = $e5b038469f55a924$var$O(!0, a);
        } finally{
            b ? $e5b038469f55a924$var$S() : ($e5b038469f55a924$var$N = !1, $e5b038469f55a924$var$O = null);
        }
    } else $e5b038469f55a924$var$N = !1;
}
var $e5b038469f55a924$var$S;
if ("function" === typeof $e5b038469f55a924$var$F) $e5b038469f55a924$var$S = function() {
    $e5b038469f55a924$var$F($e5b038469f55a924$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $e5b038469f55a924$var$T = new MessageChannel, $e5b038469f55a924$var$U = $e5b038469f55a924$var$T.port2;
    $e5b038469f55a924$var$T.port1.onmessage = $e5b038469f55a924$var$R;
    $e5b038469f55a924$var$S = function() {
        $e5b038469f55a924$var$U.postMessage(null);
    };
} else $e5b038469f55a924$var$S = function() {
    $e5b038469f55a924$var$D($e5b038469f55a924$var$R, 0);
};
function $e5b038469f55a924$var$I(a) {
    $e5b038469f55a924$var$O = a;
    $e5b038469f55a924$var$N || ($e5b038469f55a924$var$N = !0, $e5b038469f55a924$var$S());
}
function $e5b038469f55a924$var$K(a, b) {
    $e5b038469f55a924$var$L = $e5b038469f55a924$var$D(function() {
        a($e5b038469f55a924$export$c4744153514ff05d());
    }, b);
}
$e5b038469f55a924$export$3e506c1ccc9cc1a7 = 5;
$e5b038469f55a924$export$e26fe2ed2fa76875 = 1;
$e5b038469f55a924$export$502329bbf4b505b1 = 4;
$e5b038469f55a924$export$6e3807111c4874c4 = 3;
$e5b038469f55a924$export$c27134553091fb3a = null;
$e5b038469f55a924$export$33ee1acdc04fd2a2 = 2;
$e5b038469f55a924$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$e5b038469f55a924$export$8352ce38b91d0c62 = function() {
    $e5b038469f55a924$var$A || $e5b038469f55a924$var$z || ($e5b038469f55a924$var$A = !0, $e5b038469f55a924$var$I($e5b038469f55a924$var$J));
};
$e5b038469f55a924$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $e5b038469f55a924$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$e5b038469f55a924$export$d3dfb8e4810cb555 = function() {
    return $e5b038469f55a924$var$y;
};
$e5b038469f55a924$export$839f9183b0465a69 = function() {
    return $e5b038469f55a924$var$h($e5b038469f55a924$var$r);
};
$e5b038469f55a924$export$72fdf0e06517287b = function(a) {
    switch($e5b038469f55a924$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $e5b038469f55a924$var$y;
    }
    var c = $e5b038469f55a924$var$y;
    $e5b038469f55a924$var$y = b;
    try {
        return a();
    } finally{
        $e5b038469f55a924$var$y = c;
    }
};
$e5b038469f55a924$export$4b844e58a3e414b4 = function() {};
$e5b038469f55a924$export$816d2913ae6b83b1 = function() {};
$e5b038469f55a924$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $e5b038469f55a924$var$y;
    $e5b038469f55a924$var$y = a;
    try {
        return b();
    } finally{
        $e5b038469f55a924$var$y = c;
    }
};
$e5b038469f55a924$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $e5b038469f55a924$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $e5b038469f55a924$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $e5b038469f55a924$var$f($e5b038469f55a924$var$t, a), null === $e5b038469f55a924$var$h($e5b038469f55a924$var$r) && a === $e5b038469f55a924$var$h($e5b038469f55a924$var$t) && ($e5b038469f55a924$var$B ? ($e5b038469f55a924$var$E($e5b038469f55a924$var$L), $e5b038469f55a924$var$L = -1) : $e5b038469f55a924$var$B = !0, $e5b038469f55a924$var$K($e5b038469f55a924$var$H, c - d))) : (a.sortIndex = e, $e5b038469f55a924$var$f($e5b038469f55a924$var$r, a), $e5b038469f55a924$var$A || $e5b038469f55a924$var$z || ($e5b038469f55a924$var$A = !0, $e5b038469f55a924$var$I($e5b038469f55a924$var$J)));
    return a;
};
$e5b038469f55a924$export$b5836b71941fa3ed = $e5b038469f55a924$var$M;
$e5b038469f55a924$export$cf845f2c119da08a = function(a) {
    var b = $e5b038469f55a924$var$y;
    return function() {
        var c = $e5b038469f55a924$var$y;
        $e5b038469f55a924$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $e5b038469f55a924$var$y = c;
        }
    };
};

});



parcelRegister("485sq", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $cHXYB.default;
    }
});

var $cHXYB = parcelRequire("cHXYB");

});
parcelRegister("cHXYB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94080648cd21a29c$export$2e2bcd8739ae039; });

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");

var $e6kBo = parcelRequire("e6kBo");

var $2PPWI = parcelRequire("2PPWI");
'use client';
function $94080648cd21a29c$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $e6kBo.default), (0, $zgVxD.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $e6kBo.default).muiName;
    return /*#__PURE__*/ $8FY87.memo(/*#__PURE__*/ $8FY87.forwardRef(Component));
}

});
parcelRegister("zgVxD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06a0665dcc321f02$export$2e2bcd8739ae039; });
function $06a0665dcc321f02$export$2e2bcd8739ae039() {
    return $06a0665dcc321f02$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $06a0665dcc321f02$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("e6kBo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4419b66b424491c$export$2e2bcd8739ae039; });

var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $lXBIJ = parcelRequire("lXBIJ");

var $ifmKX = parcelRequire("ifmKX");

var $6lkQ3 = parcelRequire("6lkQ3");

var $lbp1P = parcelRequire("lbp1P");

var $2Eek4 = parcelRequire("2Eek4");

var $2PPWI = parcelRequire("2PPWI");
'use client';
const $a4419b66b424491c$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $a4419b66b424491c$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $ifmKX.default)(color)}`,
            `fontSize${(0, $ifmKX.default)(fontSize)}`
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $2Eek4.getSvgIconUtilityClass), classes);
};
const $a4419b66b424491c$var$SvgIconRoot = (0, $lbp1P.default)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $ifmKX.default)(ownerState.color)}`],
            styles[`fontSize${(0, $ifmKX.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : 'currentColor',
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, 'fill', {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: 'inherit',
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || '1.25rem',
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || '1.5rem',
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || '2.1875rem'
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $a4419b66b424491c$var$SvgIcon = /*#__PURE__*/ $8FY87.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24' } = props, other = (0, $93aRW.default)(props, $a4419b66b424491c$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $8FY87.isValidElement(children) && children.type === 'svg';
    const ownerState = (0, $zgVxD.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $a4419b66b424491c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2PPWI.jsxs)($a4419b66b424491c$var$SvgIconRoot, (0, $zgVxD.default)({
        as: component,
        className: (0, $efJYy.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $2PPWI.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$a4419b66b424491c$var$SvgIcon.muiName = 'SvgIcon';
var $a4419b66b424491c$export$2e2bcd8739ae039 = $a4419b66b424491c$var$SvgIcon;

});
parcelRegister("93aRW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $696cd33f2f0a6e01$export$2e2bcd8739ae039; });
function $696cd33f2f0a6e01$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("efJYy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6391a001990f8c59$export$2e2bcd8739ae039; });
function $6391a001990f8c59$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $6391a001990f8c59$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $6391a001990f8c59$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $6391a001990f8c59$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $6391a001990f8c59$export$2e2bcd8739ae039 = $6391a001990f8c59$export$4f5d2d50c9deca37;

});

parcelRegister("lXBIJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ffcc5e2452a3153c$export$2e2bcd8739ae039; });
function $ffcc5e2452a3153c$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== '') acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(' ');
    });
    return output;
}

});

parcelRegister("ifmKX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d48b47aae1bda38a$export$2e2bcd8739ae039; });

var $d1bCP = parcelRequire("d1bCP");
var $d48b47aae1bda38a$export$2e2bcd8739ae039 = (0, $d1bCP.default);

});
parcelRegister("d1bCP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97a462e7d95ddff3$export$2e2bcd8739ae039; });

var $9wLPa = parcelRequire("9wLPa");
function $97a462e7d95ddff3$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $9wLPa.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("9wLPa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6efc3318e742f816$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $6efc3318e742f816$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = 'https://mui.com/production-error/?code=' + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
    return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
/* eslint-enable prefer-template */ }

});



parcelRegister("6lkQ3", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", function () { return $49e4de5cb1adbbd4$export$2440da353cedad43; });

var $zgVxD = parcelRequire("zgVxD");
parcelRequire("8FY87");


var $fkLNr = parcelRequire("fkLNr");

var $2PPWI = parcelRequire("2PPWI");
'use client';
function $49e4de5cb1adbbd4$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $fkLNr.default), (0, $zgVxD.default)({}, props));
}
var $49e4de5cb1adbbd4$export$2e2bcd8739ae039 = $49e4de5cb1adbbd4$var$DefaultPropsProvider;
function $49e4de5cb1adbbd4$export$2440da353cedad43(params) {
    return (0, $fkLNr.useDefaultProps)(params);
}

});
parcelRegister("fkLNr", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", function () { return $b29dcca2468eaa44$export$2440da353cedad43; });
$parcel$export(module.exports, "default", function () { return $b29dcca2468eaa44$export$2e2bcd8739ae039; });

var $8FY87 = parcelRequire("8FY87");


var $1p637 = parcelRequire("1p637");

var $2PPWI = parcelRequire("2PPWI");
'use client';
const $b29dcca2468eaa44$var$PropsContext = /*#__PURE__*/ $8FY87.createContext(undefined);
function $b29dcca2468eaa44$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $2PPWI.jsx)($b29dcca2468eaa44$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $b29dcca2468eaa44$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $1p637.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $1p637.default)(config, props);
    return props;
}
function $b29dcca2468eaa44$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $8FY87.useContext($b29dcca2468eaa44$var$PropsContext);
    return $b29dcca2468eaa44$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $b29dcca2468eaa44$export$2e2bcd8739ae039 = $b29dcca2468eaa44$var$DefaultPropsProvider;

});
parcelRegister("1p637", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $105cd1820ff7f54e$export$2e2bcd8739ae039; });

var $zgVxD = parcelRequire("zgVxD");
function $105cd1820ff7f54e$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $zgVxD.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $zgVxD.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $zgVxD.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $105cd1820ff7f54e$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});

parcelRegister("2PPWI", function(module, exports) {
'use strict';

module.exports = (parcelRequire("d5yqR"));

});
parcelRegister("d5yqR", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $98767380a4764855$export$ffb0004e005737fa; }, function (v) { return $98767380a4764855$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $98767380a4764855$export$34b9dba7ce09269b; }, function (v) { return $98767380a4764855$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $98767380a4764855$export$25062201e9e25d76; }, function (v) { return $98767380a4764855$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $98767380a4764855$export$ffb0004e005737fa;
var $98767380a4764855$export$34b9dba7ce09269b;
var $98767380a4764855$export$25062201e9e25d76;
'use strict';

var $8FY87 = parcelRequire("8FY87");
var $98767380a4764855$var$k = Symbol.for("react.element"), $98767380a4764855$var$l = Symbol.for("react.fragment"), $98767380a4764855$var$m = Object.prototype.hasOwnProperty, $98767380a4764855$var$n = $8FY87.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $98767380a4764855$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $98767380a4764855$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$98767380a4764855$var$m.call(a, b) && !$98767380a4764855$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $98767380a4764855$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $98767380a4764855$var$n.current
    };
}
$98767380a4764855$export$ffb0004e005737fa = $98767380a4764855$var$l;
$98767380a4764855$export$34b9dba7ce09269b = $98767380a4764855$var$q;
$98767380a4764855$export$25062201e9e25d76 = $98767380a4764855$var$q;

});




parcelRegister("lbp1P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03face9da3848d10$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "rootShouldForwardProp", function () { return (parcelRequire("awHZI")).default; });

var $cWc9h = parcelRequire("cWc9h");

var $jyLqM = parcelRequire("jyLqM");

var $ab2pD = parcelRequire("ab2pD");

var $awHZI = parcelRequire("awHZI");

var $jZXCu = parcelRequire("jZXCu");
'use client';
const $03face9da3848d10$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($cWc9h)))({
    themeId: (0, $ab2pD.default),
    defaultTheme: $jyLqM.default,
    rootShouldForwardProp: $awHZI.default
});
var $03face9da3848d10$export$2e2bcd8739ae039 = $03face9da3848d10$var$styled;

});
parcelRegister("cWc9h", function(module, exports) {
"use strict";

var $bcBLN = parcelRequire("bcBLN");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $96b45346361b68a5$var$createStyled;
module.exports.shouldForwardProp = $96b45346361b68a5$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $96b45346361b68a5$var$_extends2 = $bcBLN((parcelRequire("aVADP")));

var $96b45346361b68a5$var$_objectWithoutPropertiesLoose2 = $bcBLN((parcelRequire("8C7WP")));

var $96b45346361b68a5$var$_styledEngine = $96b45346361b68a5$var$_interopRequireWildcard((parcelRequire("hDbmX")));

var $d5ARM = parcelRequire("d5ARM");

var $96b45346361b68a5$var$_capitalize = $bcBLN((parcelRequire("jAkST")));

var $96b45346361b68a5$var$_getDisplayName = $bcBLN((parcelRequire("4LObi")));

var $96b45346361b68a5$var$_createTheme = $bcBLN((parcelRequire("7778B")));

var $96b45346361b68a5$var$_styleFunctionSx = $bcBLN((parcelRequire("2Cc5V")));
const $96b45346361b68a5$var$_excluded = [
    "ownerState"
], $96b45346361b68a5$var$_excluded2 = [
    "variants"
], $96b45346361b68a5$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function $96b45346361b68a5$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($96b45346361b68a5$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $96b45346361b68a5$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $96b45346361b68a5$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $96b45346361b68a5$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $96b45346361b68a5$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function $96b45346361b68a5$var$shouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $96b45346361b68a5$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
const $96b45346361b68a5$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $96b45346361b68a5$var$_createTheme.default)();
const $96b45346361b68a5$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $96b45346361b68a5$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $96b45346361b68a5$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $96b45346361b68a5$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $96b45346361b68a5$var$processStyleArg(callableStyle, _ref, layerName) {
    let { ownerState: ownerState } = _ref, props = (0, $96b45346361b68a5$var$_objectWithoutPropertiesLoose2.default)(_ref, $96b45346361b68a5$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, $96b45346361b68a5$var$_extends2.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$96b45346361b68a5$var$processStyleArg(resolvedStyle, (0, $96b45346361b68a5$var$_extends2.default)({
            ownerState: ownerState
        }, props), layerName));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $96b45346361b68a5$var$_objectWithoutPropertiesLoose2.default)(resolvedStylesArg, $96b45346361b68a5$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, $96b45346361b68a5$var$_extends2.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                const variantStyle = typeof variant.style === 'function' ? variant.style((0, $96b45346361b68a5$var$_extends2.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style;
                result.push(layerName ? $96b45346361b68a5$var$shallowLayer((0, $96b45346361b68a5$var$_styledEngine.internal_serializeStyles)(variantStyle), layerName) : variantStyle);
            }
        });
        return result;
    }
    return layerName ? $96b45346361b68a5$var$shallowLayer((0, $96b45346361b68a5$var$_styledEngine.internal_serializeStyles)(resolvedStylesArg), layerName) : resolvedStylesArg;
}
function $96b45346361b68a5$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $96b45346361b68a5$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $96b45346361b68a5$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $96b45346361b68a5$var$shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, $96b45346361b68a5$var$_styleFunctionSx.default)((0, $96b45346361b68a5$var$_extends2.default)({}, props, {
            theme: $96b45346361b68a5$var$resolveTheme((0, $96b45346361b68a5$var$_extends2.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $96b45346361b68a5$var$_styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $96b45346361b68a5$var$defaultOverridesResolver($96b45346361b68a5$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $96b45346361b68a5$var$_objectWithoutPropertiesLoose2.default)(inputOptions, $96b45346361b68a5$var$_excluded3);
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $96b45346361b68a5$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($96b45346361b68a5$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $96b45346361b68a5$var$_styledEngine.default)(tag, (0, $96b45346361b68a5$var$_extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, $d5ARM.isPlainObject)(stylesArg)) return (props)=>{
                const theme = $96b45346361b68a5$var$resolveTheme({
                    theme: props.theme,
                    defaultTheme: defaultTheme,
                    themeId: themeId
                });
                return $96b45346361b68a5$var$processStyleArg(stylesArg, (0, $96b45346361b68a5$var$_extends2.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? layerName : undefined);
            };
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $96b45346361b68a5$var$resolveTheme((0, $96b45346361b68a5$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $96b45346361b68a5$var$processStyleArg(slotStyle, (0, $96b45346361b68a5$var$_extends2.default)({}, props, {
                        theme: theme
                    }), theme.modularCssLayers ? 'theme' : undefined);
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $96b45346361b68a5$var$resolveTheme((0, $96b45346361b68a5$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $96b45346361b68a5$var$processStyleArg({
                    variants: themeVariants
                }, (0, $96b45346361b68a5$var$_extends2.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRegister("bcBLN", function(module, exports) {
function $827e1d0443654293$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $827e1d0443654293$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("aVADP", function(module, exports) {
function $7f4ba673b85b3473$var$_extends() {
    return module.exports = $7f4ba673b85b3473$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $7f4ba673b85b3473$var$_extends.apply(null, arguments);
}
module.exports = $7f4ba673b85b3473$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8C7WP", function(module, exports) {
function $6458099cac16af04$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $6458099cac16af04$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("hDbmX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $cd5ee5de0b6ed63b$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_processStyles", function () { return $cd5ee5de0b6ed63b$export$e00380445f2b9e0c; });
$parcel$export(module.exports, "internal_serializeStyles", function () { return $cd5ee5de0b6ed63b$export$13a2d3ef13012b32; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("8MSLN")).T; });
$parcel$export(module.exports, "keyframes", function () { return (parcelRequire("icSEh")).keyframes; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("icSEh")).css; });
$parcel$export(module.exports, "StyledEngineProvider", function () { return (parcelRequire("29VbU")).default; });
$parcel$export(module.exports, "GlobalStyles", function () { return (parcelRequire("jr996")).default; });
/**
 * @mui/styled-engine v5.18.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $hQEaz = parcelRequire("hQEaz");

var $2R5SH = parcelRequire("2R5SH");

var $icSEh = parcelRequire("icSEh");
var $8MSLN = parcelRequire("8MSLN");

var $29VbU = parcelRequire("29VbU");

var $jr996 = parcelRequire("jr996");
'use client';
function $cd5ee5de0b6ed63b$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $hQEaz.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $cd5ee5de0b6ed63b$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};
// Emotion only accepts an array, but we want to avoid allocations
const $cd5ee5de0b6ed63b$var$wrapper = [];
function $cd5ee5de0b6ed63b$export$13a2d3ef13012b32(styles) {
    $cd5ee5de0b6ed63b$var$wrapper[0] = styles;
    return (0, $2R5SH.serializeStyles)($cd5ee5de0b6ed63b$var$wrapper);
}

});
parcelRegister("hQEaz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfe673d298c0af69$export$2e2bcd8739ae039; });

var $2PS5X = parcelRequire("2PS5X");
parcelRequire("aVADP");

parcelRequire("2R5SH");
parcelRequire("gFv23");
parcelRequire("fq9jv");
parcelRequire("8FY87");
parcelRequire("7fY6k");
var $cfe673d298c0af69$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $cfe673d298c0af69$export$2e2bcd8739ae039 = (0, $2PS5X.default).bind(null);
$cfe673d298c0af69$var$tags.forEach(function(tagName) {
    $cfe673d298c0af69$export$2e2bcd8739ae039[tagName] = $cfe673d298c0af69$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("2PS5X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $210a4e59d6b66572$export$2e2bcd8739ae039; });

var $zgVxD = parcelRequire("zgVxD");
parcelRequire("icSEh");
var $8MSLN = parcelRequire("8MSLN");

var $2R5SH = parcelRequire("2R5SH");

var $gFv23 = parcelRequire("gFv23");

var $fq9jv = parcelRequire("fq9jv");

var $8FY87 = parcelRequire("8FY87");

var $7fY6k = parcelRequire("7fY6k");
var $210a4e59d6b66572$var$isBrowser = typeof document !== 'undefined';
var $210a4e59d6b66572$var$isDevelopment = false;
var $210a4e59d6b66572$var$testOmitPropsOnStringTag = (0, $7fY6k.default);
var $210a4e59d6b66572$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $210a4e59d6b66572$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $210a4e59d6b66572$var$testOmitPropsOnStringTag : $210a4e59d6b66572$var$testOmitPropsOnComponent;
};
var $210a4e59d6b66572$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $210a4e59d6b66572$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $fq9jv.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $gFv23.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $fq9jv.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$210a4e59d6b66572$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $8FY87.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $210a4e59d6b66572$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $210a4e59d6b66572$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $210a4e59d6b66572$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $8MSLN.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $8FY87.useContext((0, $8MSLN.T));
            }
            if (typeof props.className === 'string') className = (0, $fq9jv.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $2R5SH.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $210a4e59d6b66572$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, null, /*#__PURE__*/ $8FY87.createElement($210a4e59d6b66572$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $8FY87.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $210a4e59d6b66572$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $zgVxD.default)({}, options, nextOptions, {
                shouldForwardProp: $210a4e59d6b66572$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("icSEh", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $d413bd128c13442b$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $d413bd128c13442b$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $d413bd128c13442b$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("8MSLN")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("8MSLN")).w; });

var $8MSLN = parcelRequire("8MSLN");

var $8FY87 = parcelRequire("8FY87");

var $fq9jv = parcelRequire("fq9jv");

var $gFv23 = parcelRequire("gFv23");

var $2R5SH = parcelRequire("2R5SH");
parcelRequire("doYkk");
parcelRequire("aVADP");
parcelRequire("aXTeZ");

parcelRequire("7bVaI");
var $d413bd128c13442b$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $8MSLN.h).call(props, 'css')) return $8FY87.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $8MSLN.E);
    createElementArgArray[1] = (0, $8MSLN.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $8FY87.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($d413bd128c13442b$export$c8a8987d4410bf2d || ($d413bd128c13442b$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $d413bd128c13442b$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $8MSLN.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $2R5SH.serializeStyles)([
        styles
    ], undefined, $8FY87.useContext((0, $8MSLN.T)));
    if (!(0, $8MSLN.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $8FY87.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $8FY87.useRef();
    (0, $gFv23.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $gFv23.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $fq9jv.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $d413bd128c13442b$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $2R5SH.serializeStyles)(args);
}
function $d413bd128c13442b$export$d25ddfdf17c3ad3e() {
    var insertable = $d413bd128c13442b$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $d413bd128c13442b$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $d413bd128c13442b$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $fq9jv.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $d413bd128c13442b$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $gFv23.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $fq9jv.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $8MSLN.i) && res !== undefined) rules += res;
        }
        if (!(0, $8MSLN.i)) return rules;
    });
    if (!(0, $8MSLN.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $8FY87.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $d413bd128c13442b$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $8MSLN.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $8MSLN.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $2R5SH.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $fq9jv.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $8MSLN.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $d413bd128c13442b$var$merge(cache.registered, css, $d413bd128c13442b$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $8FY87.useContext((0, $8MSLN.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, null, /*#__PURE__*/ $8FY87.createElement($d413bd128c13442b$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("8MSLN", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $665d4a92df538612$export$407448d2b89b1813; });
$parcel$export(module.exports, "i", function () { return $665d4a92df538612$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "C", function () { return $665d4a92df538612$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $665d4a92df538612$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $665d4a92df538612$export$971d5caa766a69d7; });
$parcel$export(module.exports, "h", function () { return $665d4a92df538612$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "c", function () { return $665d4a92df538612$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $665d4a92df538612$export$a9c23c6ac3fc3eca; });

var $8FY87 = parcelRequire("8FY87");

var $doYkk = parcelRequire("doYkk");

var $zgVxD = parcelRequire("zgVxD");

var $aXTeZ = parcelRequire("aXTeZ");

var $4cRLz = parcelRequire("4cRLz");

var $fq9jv = parcelRequire("fq9jv");

var $2R5SH = parcelRequire("2R5SH");

var $gFv23 = parcelRequire("gFv23");
var $665d4a92df538612$export$407448d2b89b1813 = false;
var $665d4a92df538612$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $665d4a92df538612$var$EmotionCacheContext = /* #__PURE__ */ $8FY87.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $doYkk.default)({
    key: 'css'
}) : null);
var $665d4a92df538612$export$e7094788287c5e9b = $665d4a92df538612$var$EmotionCacheContext.Provider;
var $665d4a92df538612$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $8FY87.useContext)($665d4a92df538612$var$EmotionCacheContext);
};
var $665d4a92df538612$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $8FY87.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $8FY87.useContext)($665d4a92df538612$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$665d4a92df538612$export$23f2a1d2818174ef) $665d4a92df538612$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $8FY87.useContext)($665d4a92df538612$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $doYkk.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $8FY87.createElement($665d4a92df538612$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $665d4a92df538612$export$971d5caa766a69d7 = /* #__PURE__ */ $8FY87.createContext({});
var $665d4a92df538612$export$3b14a55fb2447963 = function useTheme() {
    return $8FY87.useContext($665d4a92df538612$export$971d5caa766a69d7);
};
var $665d4a92df538612$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $zgVxD.default)({}, outerTheme, theme);
};
var $665d4a92df538612$var$createCacheWithTheme = /* #__PURE__ */ (0, $aXTeZ.default)(function(outerTheme) {
    return (0, $aXTeZ.default)(function(theme) {
        return $665d4a92df538612$var$getTheme(outerTheme, theme);
    });
});
var $665d4a92df538612$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $8FY87.useContext($665d4a92df538612$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $665d4a92df538612$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $8FY87.createElement($665d4a92df538612$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $665d4a92df538612$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $8FY87.forwardRef(function render(props, ref) {
        var theme = $8FY87.useContext($665d4a92df538612$export$971d5caa766a69d7);
        return /*#__PURE__*/ $8FY87.createElement(Component, (0, $zgVxD.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $4cRLz.default)(WithTheme, Component);
}
var $665d4a92df538612$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $665d4a92df538612$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $665d4a92df538612$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($665d4a92df538612$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$665d4a92df538612$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $665d4a92df538612$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $fq9jv.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $gFv23.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $fq9jv.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$665d4a92df538612$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $8FY87.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $665d4a92df538612$var$Emotion = /* #__PURE__ */ $665d4a92df538612$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$665d4a92df538612$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $fq9jv.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $2R5SH.serializeStyles)(registeredStyles, undefined, $8FY87.useContext($665d4a92df538612$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($665d4a92df538612$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $665d4a92df538612$var$typePropName && !$665d4a92df538612$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, null, /*#__PURE__*/ $8FY87.createElement($665d4a92df538612$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $8FY87.createElement(WrappedComponent, newProps));
});
var $665d4a92df538612$export$a9c23c6ac3fc3eca = $665d4a92df538612$var$Emotion;

});
parcelRegister("doYkk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $028495ef11b28529$export$2e2bcd8739ae039; });

var $hSToX = parcelRequire("hSToX");

var $bmQuu = parcelRequire("bmQuu");

var $aXTeZ = parcelRequire("aXTeZ");

var $chUI2 = parcelRequire("chUI2");
var $028495ef11b28529$var$isBrowser = typeof document !== 'undefined';
var $028495ef11b28529$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $bmQuu.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $bmQuu.token)(character)) break;
        (0, $bmQuu.next)();
    }
    return (0, $bmQuu.slice)(begin, (0, $bmQuu.position));
};
var $028495ef11b28529$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $bmQuu.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $bmQuu.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $028495ef11b28529$var$identifierWithPointTracking((0, $bmQuu.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $bmQuu.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $bmQuu.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $bmQuu.from)(character);
    }
    while (character = (0, $bmQuu.next)());
    return parsed;
};
var $028495ef11b28529$var$getRules = function getRules(value, points) {
    return (0, $bmQuu.dealloc)($028495ef11b28529$var$toRules((0, $bmQuu.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $028495ef11b28529$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $028495ef11b28529$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$028495ef11b28529$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $028495ef11b28529$var$fixedElements.set(element, true);
    var points = [];
    var rules = $028495ef11b28529$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $028495ef11b28529$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $028495ef11b28529$var$prefix(value, length) {
    switch((0, $bmQuu.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $bmQuu.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $bmQuu.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $bmQuu.WEBKIT) + value + (0, $bmQuu.MOZ) + value + (0, $bmQuu.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $bmQuu.WEBKIT) + value + (0, $bmQuu.MS) + value + value;
        // order
        case 6165:
            return (0, $bmQuu.WEBKIT) + value + (0, $bmQuu.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $bmQuu.WEBKIT) + value + (0, $bmQuu.replace)(value, /(\w+).+(:[^]+)/, (0, $bmQuu.WEBKIT) + 'box-$1$2' + (0, $bmQuu.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $bmQuu.WEBKIT) + value + (0, $bmQuu.MS) + 'flex-item-' + (0, $bmQuu.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $bmQuu.WEBKIT) + value + (0, $bmQuu.MS) + 'flex-line-pack' + (0, $bmQuu.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $bmQuu.WEBKIT) + value + (0, $bmQuu.MS) + (0, $bmQuu.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $bmQuu.WEBKIT) + value + (0, $bmQuu.MS) + (0, $bmQuu.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $bmQuu.WEBKIT) + 'box-' + (0, $bmQuu.replace)(value, '-grow', '') + (0, $bmQuu.WEBKIT) + value + (0, $bmQuu.MS) + (0, $bmQuu.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $bmQuu.WEBKIT) + (0, $bmQuu.replace)(value, /([^-])(transform)/g, '$1' + (0, $bmQuu.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $bmQuu.replace)((0, $bmQuu.replace)((0, $bmQuu.replace)(value, /(zoom-|grab)/, (0, $bmQuu.WEBKIT) + '$1'), /(image-set)/, (0, $bmQuu.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $bmQuu.replace)(value, /(image-set\([^]*)/, (0, $bmQuu.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $bmQuu.replace)((0, $bmQuu.replace)(value, /(.+:)(flex-)?(.*)/, (0, $bmQuu.WEBKIT) + 'box-pack:$3' + (0, $bmQuu.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $bmQuu.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $bmQuu.replace)(value, /(.+)-inline(.+)/, (0, $bmQuu.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $bmQuu.strlen)(value) - 1 - length > 6) switch((0, $bmQuu.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $bmQuu.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $bmQuu.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $bmQuu.WEBKIT) + '$2-$3' + '$1' + (0, $bmQuu.MOZ) + ((0, $bmQuu.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $bmQuu.indexof)(value, 'stretch') ? $028495ef11b28529$var$prefix((0, $bmQuu.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $bmQuu.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $bmQuu.charat)(value, (0, $bmQuu.strlen)(value) - 3 - (~(0, $bmQuu.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $bmQuu.replace)(value, ':', ':' + (0, $bmQuu.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $bmQuu.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $bmQuu.WEBKIT) + ((0, $bmQuu.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $bmQuu.WEBKIT) + '$2$3' + '$1' + (0, $bmQuu.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $bmQuu.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $bmQuu.WEBKIT) + value + (0, $bmQuu.MS) + (0, $bmQuu.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $bmQuu.WEBKIT) + value + (0, $bmQuu.MS) + (0, $bmQuu.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $bmQuu.WEBKIT) + value + (0, $bmQuu.MS) + (0, $bmQuu.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $bmQuu.WEBKIT) + value + (0, $bmQuu.MS) + value + value;
    }
    return value;
}
var $028495ef11b28529$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $bmQuu.DECLARATION:
                element["return"] = $028495ef11b28529$var$prefix(element.value, element.length);
                break;
            case 0, $bmQuu.KEYFRAMES:
                return (0, $bmQuu.serialize)([
                    (0, $bmQuu.copy)(element, {
                        value: (0, $bmQuu.replace)(element.value, '@', '@' + (0, $bmQuu.WEBKIT))
                    })
                ], callback);
            case 0, $bmQuu.RULESET:
                if (element.length) return (0, $bmQuu.combine)(element.props, function(value) {
                    switch((0, $bmQuu.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $bmQuu.serialize)([
                                (0, $bmQuu.copy)(element, {
                                    props: [
                                        (0, $bmQuu.replace)(value, /:(read-\w+)/, ':' + (0, $bmQuu.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $bmQuu.serialize)([
                                (0, $bmQuu.copy)(element, {
                                    props: [
                                        (0, $bmQuu.replace)(value, /:(plac\w+)/, ':' + (0, $bmQuu.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $bmQuu.copy)(element, {
                                    props: [
                                        (0, $bmQuu.replace)(value, /:(plac\w+)/, ':' + (0, $bmQuu.MOZ) + '$1')
                                    ]
                                }),
                                (0, $bmQuu.copy)(element, {
                                    props: [
                                        (0, $bmQuu.replace)(value, /:(plac\w+)/, (0, $bmQuu.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $028495ef11b28529$var$getServerStylisCache = $028495ef11b28529$var$isBrowser ? undefined : (0, $aXTeZ.default)(function() {
    return (0, $chUI2.default)(function() {
        return {};
    });
});
var $028495ef11b28529$var$defaultStylisPlugins = [
    $028495ef11b28529$var$prefixer
];
var $028495ef11b28529$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($028495ef11b28529$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $028495ef11b28529$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($028495ef11b28529$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $028495ef11b28529$var$compat,
        $028495ef11b28529$var$removeLabel
    ];
    if (!$028495ef11b28529$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $bmQuu.stringify),
            (0, $bmQuu.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $bmQuu.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $bmQuu.serialize)((0, $bmQuu.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $bmQuu.stringify)
        ];
        var _serializer = (0, $bmQuu.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $bmQuu.serialize)((0, $bmQuu.compile)(styles), _serializer);
        };
        var serverStylisCache = $028495ef11b28529$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $hSToX.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("hSToX", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $d052746655a5cd57$export$9d753cd7ae895cce; });
var $d052746655a5cd57$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $d052746655a5cd57$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $d052746655a5cd57$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $d052746655a5cd57$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$d052746655a5cd57$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($d052746655a5cd57$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $d052746655a5cd57$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("bmQuu", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $f212c67d2aff02bb$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $f212c67d2aff02bb$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $f212c67d2aff02bb$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $f212c67d2aff02bb$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $f212c67d2aff02bb$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $f212c67d2aff02bb$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $f212c67d2aff02bb$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $f212c67d2aff02bb$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $f212c67d2aff02bb$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $f212c67d2aff02bb$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $f212c67d2aff02bb$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $f212c67d2aff02bb$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $f212c67d2aff02bb$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $f212c67d2aff02bb$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $f212c67d2aff02bb$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $f212c67d2aff02bb$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $f212c67d2aff02bb$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $f212c67d2aff02bb$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $f212c67d2aff02bb$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $f212c67d2aff02bb$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $f212c67d2aff02bb$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $f212c67d2aff02bb$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $f212c67d2aff02bb$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $f212c67d2aff02bb$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $f212c67d2aff02bb$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $f212c67d2aff02bb$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $f212c67d2aff02bb$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $f212c67d2aff02bb$export$38bcb760f1d4871c; });
var $f212c67d2aff02bb$export$71ad59f2e432cfe8 = "-ms-";
var $f212c67d2aff02bb$export$2c0f367103c8d01c = "-moz-";
var $f212c67d2aff02bb$export$39dfd62a25e0fe93 = "-webkit-";
var $f212c67d2aff02bb$export$a29989082612d0d9 = "comm";
var $f212c67d2aff02bb$export$aa3a2e812ca8570d = "rule";
var $f212c67d2aff02bb$export$527d108ccf083c2b = "decl";
var $f212c67d2aff02bb$export$d3d35020fa5b54f0 = "@page";
var $f212c67d2aff02bb$export$500415a86c544f73 = "@media";
var $f212c67d2aff02bb$export$a763edbf796b780a = "@import";
var $f212c67d2aff02bb$export$2790aeb8b4e5c826 = "@charset";
var $f212c67d2aff02bb$export$1cc683e23b84b133 = "@viewport";
var $f212c67d2aff02bb$export$9447a5efea57e862 = "@supports";
var $f212c67d2aff02bb$export$ef011b4e114b1fba = "@document";
var $f212c67d2aff02bb$export$6aad947bda0f3f46 = "@namespace";
var $f212c67d2aff02bb$export$b44a8529a35fcb60 = "@keyframes";
var $f212c67d2aff02bb$export$2c16de31893252e6 = "@font-face";
var $f212c67d2aff02bb$export$3d846dd52e150c6f = "@counter-style";
var $f212c67d2aff02bb$export$22314bfbb57653fe = "@font-feature-values";
var $f212c67d2aff02bb$export$d773506282b3cfe6 = "@layer";
var $f212c67d2aff02bb$export$2335f513bbd82c6d = Math.abs;
var $f212c67d2aff02bb$export$6788812c4e6611e6 = String.fromCharCode;
var $f212c67d2aff02bb$export$e6e34fd1f2686227 = Object.assign;
function $f212c67d2aff02bb$export$d6af199866bfb566(e, r) {
    return $f212c67d2aff02bb$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $f212c67d2aff02bb$export$a9db5e087081082d(e, 0)) << 2 ^ $f212c67d2aff02bb$export$a9db5e087081082d(e, 1)) << 2 ^ $f212c67d2aff02bb$export$a9db5e087081082d(e, 2)) << 2 ^ $f212c67d2aff02bb$export$a9db5e087081082d(e, 3) : 0;
}
function $f212c67d2aff02bb$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $f212c67d2aff02bb$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $f212c67d2aff02bb$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $f212c67d2aff02bb$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $f212c67d2aff02bb$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $f212c67d2aff02bb$export$36776f635604f274(e) {
    return e.length;
}
function $f212c67d2aff02bb$export$f9084667e487ed46(e) {
    return e.length;
}
function $f212c67d2aff02bb$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $f212c67d2aff02bb$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $f212c67d2aff02bb$export$53f1d5ea8de3d7c = 1;
var $f212c67d2aff02bb$export$4e0c71f277ca26b3 = 1;
var $f212c67d2aff02bb$export$f24224f1c91d8156 = 0;
var $f212c67d2aff02bb$export$5880b8b5730aff45 = 0;
var $f212c67d2aff02bb$export$c0306caf338ac095 = 0;
var $f212c67d2aff02bb$export$30a86d91af8ff6e6 = "";
function $f212c67d2aff02bb$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $f212c67d2aff02bb$export$53f1d5ea8de3d7c,
        column: $f212c67d2aff02bb$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $f212c67d2aff02bb$export$784d13d8ee351f07(e, r) {
    return $f212c67d2aff02bb$export$e6e34fd1f2686227($f212c67d2aff02bb$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $f212c67d2aff02bb$export$eba6f6f03b0a92e7() {
    return $f212c67d2aff02bb$export$c0306caf338ac095;
}
function $f212c67d2aff02bb$export$232faf9add678146() {
    $f212c67d2aff02bb$export$c0306caf338ac095 = $f212c67d2aff02bb$export$5880b8b5730aff45 > 0 ? $f212c67d2aff02bb$export$a9db5e087081082d($f212c67d2aff02bb$export$30a86d91af8ff6e6, --$f212c67d2aff02bb$export$5880b8b5730aff45) : 0;
    if ($f212c67d2aff02bb$export$4e0c71f277ca26b3--, $f212c67d2aff02bb$export$c0306caf338ac095 === 10) $f212c67d2aff02bb$export$4e0c71f277ca26b3 = 1, $f212c67d2aff02bb$export$53f1d5ea8de3d7c--;
    return $f212c67d2aff02bb$export$c0306caf338ac095;
}
function $f212c67d2aff02bb$export$48cfd1e771a65c4f() {
    $f212c67d2aff02bb$export$c0306caf338ac095 = $f212c67d2aff02bb$export$5880b8b5730aff45 < $f212c67d2aff02bb$export$f24224f1c91d8156 ? $f212c67d2aff02bb$export$a9db5e087081082d($f212c67d2aff02bb$export$30a86d91af8ff6e6, $f212c67d2aff02bb$export$5880b8b5730aff45++) : 0;
    if ($f212c67d2aff02bb$export$4e0c71f277ca26b3++, $f212c67d2aff02bb$export$c0306caf338ac095 === 10) $f212c67d2aff02bb$export$4e0c71f277ca26b3 = 1, $f212c67d2aff02bb$export$53f1d5ea8de3d7c++;
    return $f212c67d2aff02bb$export$c0306caf338ac095;
}
function $f212c67d2aff02bb$export$4d3fb11e950abb9e() {
    return $f212c67d2aff02bb$export$a9db5e087081082d($f212c67d2aff02bb$export$30a86d91af8ff6e6, $f212c67d2aff02bb$export$5880b8b5730aff45);
}
function $f212c67d2aff02bb$export$e88cb2efb12ae807() {
    return $f212c67d2aff02bb$export$5880b8b5730aff45;
}
function $f212c67d2aff02bb$export$58adb3bec8346d0f(e, r) {
    return $f212c67d2aff02bb$export$2f35ab04d2335697($f212c67d2aff02bb$export$30a86d91af8ff6e6, e, r);
}
function $f212c67d2aff02bb$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $f212c67d2aff02bb$export$2de70f21292aac9e(e) {
    return $f212c67d2aff02bb$export$53f1d5ea8de3d7c = $f212c67d2aff02bb$export$4e0c71f277ca26b3 = 1, $f212c67d2aff02bb$export$f24224f1c91d8156 = $f212c67d2aff02bb$export$36776f635604f274($f212c67d2aff02bb$export$30a86d91af8ff6e6 = e), $f212c67d2aff02bb$export$5880b8b5730aff45 = 0, [];
}
function $f212c67d2aff02bb$export$45918ac1574455b1(e) {
    return $f212c67d2aff02bb$export$30a86d91af8ff6e6 = "", e;
}
function $f212c67d2aff02bb$export$410ac95b9ec204b8(e) {
    return $f212c67d2aff02bb$export$87c2784dc9fc4ab($f212c67d2aff02bb$export$58adb3bec8346d0f($f212c67d2aff02bb$export$5880b8b5730aff45 - 1, $f212c67d2aff02bb$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $f212c67d2aff02bb$export$660b2ee2d4fb4eff(e) {
    return $f212c67d2aff02bb$export$45918ac1574455b1($f212c67d2aff02bb$export$5f8c09e3ae6f64e1($f212c67d2aff02bb$export$2de70f21292aac9e(e)));
}
function $f212c67d2aff02bb$export$7af1228ff777d175(e) {
    while($f212c67d2aff02bb$export$c0306caf338ac095 = $f212c67d2aff02bb$export$4d3fb11e950abb9e())if ($f212c67d2aff02bb$export$c0306caf338ac095 < 33) $f212c67d2aff02bb$export$48cfd1e771a65c4f();
    else break;
    return $f212c67d2aff02bb$export$9e1725a4cfeada27(e) > 2 || $f212c67d2aff02bb$export$9e1725a4cfeada27($f212c67d2aff02bb$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $f212c67d2aff02bb$export$5f8c09e3ae6f64e1(e) {
    while($f212c67d2aff02bb$export$48cfd1e771a65c4f())switch($f212c67d2aff02bb$export$9e1725a4cfeada27($f212c67d2aff02bb$export$c0306caf338ac095)){
        case 0:
            $f212c67d2aff02bb$export$10d8903dec122b9d($f212c67d2aff02bb$export$c2ab62c7bf24634($f212c67d2aff02bb$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $f212c67d2aff02bb$export$10d8903dec122b9d($f212c67d2aff02bb$export$410ac95b9ec204b8($f212c67d2aff02bb$export$c0306caf338ac095), e);
            break;
        default:
            $f212c67d2aff02bb$export$10d8903dec122b9d($f212c67d2aff02bb$export$6788812c4e6611e6($f212c67d2aff02bb$export$c0306caf338ac095), e);
    }
    return e;
}
function $f212c67d2aff02bb$export$955ba06d119e085e(e, r) {
    while(--r && $f212c67d2aff02bb$export$48cfd1e771a65c4f())if ($f212c67d2aff02bb$export$c0306caf338ac095 < 48 || $f212c67d2aff02bb$export$c0306caf338ac095 > 102 || $f212c67d2aff02bb$export$c0306caf338ac095 > 57 && $f212c67d2aff02bb$export$c0306caf338ac095 < 65 || $f212c67d2aff02bb$export$c0306caf338ac095 > 70 && $f212c67d2aff02bb$export$c0306caf338ac095 < 97) break;
    return $f212c67d2aff02bb$export$58adb3bec8346d0f(e, $f212c67d2aff02bb$export$e88cb2efb12ae807() + (r < 6 && $f212c67d2aff02bb$export$4d3fb11e950abb9e() == 32 && $f212c67d2aff02bb$export$48cfd1e771a65c4f() == 32));
}
function $f212c67d2aff02bb$export$c889f2fcc19dbf12(e) {
    while($f212c67d2aff02bb$export$48cfd1e771a65c4f())switch($f212c67d2aff02bb$export$c0306caf338ac095){
        case e:
            return $f212c67d2aff02bb$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $f212c67d2aff02bb$export$c889f2fcc19dbf12($f212c67d2aff02bb$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $f212c67d2aff02bb$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $f212c67d2aff02bb$export$48cfd1e771a65c4f();
            break;
    }
    return $f212c67d2aff02bb$export$5880b8b5730aff45;
}
function $f212c67d2aff02bb$export$4254d4e2b3745c4c(e, r) {
    while($f212c67d2aff02bb$export$48cfd1e771a65c4f())if (e + $f212c67d2aff02bb$export$c0306caf338ac095 === 57) break;
    else if (e + $f212c67d2aff02bb$export$c0306caf338ac095 === 84 && $f212c67d2aff02bb$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $f212c67d2aff02bb$export$58adb3bec8346d0f(r, $f212c67d2aff02bb$export$5880b8b5730aff45 - 1) + "*" + $f212c67d2aff02bb$export$6788812c4e6611e6(e === 47 ? e : $f212c67d2aff02bb$export$48cfd1e771a65c4f());
}
function $f212c67d2aff02bb$export$c2ab62c7bf24634(e) {
    while(!$f212c67d2aff02bb$export$9e1725a4cfeada27($f212c67d2aff02bb$export$4d3fb11e950abb9e()))$f212c67d2aff02bb$export$48cfd1e771a65c4f();
    return $f212c67d2aff02bb$export$58adb3bec8346d0f(e, $f212c67d2aff02bb$export$5880b8b5730aff45);
}
function $f212c67d2aff02bb$export$ef7acd7185315e22(e) {
    return $f212c67d2aff02bb$export$45918ac1574455b1($f212c67d2aff02bb$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $f212c67d2aff02bb$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $f212c67d2aff02bb$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $f212c67d2aff02bb$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $f212c67d2aff02bb$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($f212c67d2aff02bb$export$f8e21b1e77979a08(j += $f212c67d2aff02bb$export$77ad94ebf1c2b9ed($f212c67d2aff02bb$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $f212c67d2aff02bb$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $f212c67d2aff02bb$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $f212c67d2aff02bb$export$955ba06d119e085e($f212c67d2aff02bb$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($f212c67d2aff02bb$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $f212c67d2aff02bb$export$10d8903dec122b9d($f212c67d2aff02bb$export$4a34f930e789283c($f212c67d2aff02bb$export$4254d4e2b3745c4c($f212c67d2aff02bb$export$48cfd1e771a65c4f(), $f212c67d2aff02bb$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $f212c67d2aff02bb$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $f212c67d2aff02bb$export$36776f635604f274(j) - l) $f212c67d2aff02bb$export$10d8903dec122b9d(p > 32 ? $f212c67d2aff02bb$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $f212c67d2aff02bb$export$f8483753829ec8f3($f212c67d2aff02bb$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $f212c67d2aff02bb$export$10d8903dec122b9d(y = $f212c67d2aff02bb$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $f212c67d2aff02bb$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $f212c67d2aff02bb$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $f212c67d2aff02bb$export$98e6a39c04603d36(e, y, y, n && $f212c67d2aff02bb$export$10d8903dec122b9d($f212c67d2aff02bb$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $f212c67d2aff02bb$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $f212c67d2aff02bb$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $f212c67d2aff02bb$export$232faf9add678146() == 125) continue;
            }
            switch(j += $f212c67d2aff02bb$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($f212c67d2aff02bb$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($f212c67d2aff02bb$export$4d3fb11e950abb9e() === 45) j += $f212c67d2aff02bb$export$410ac95b9ec204b8($f212c67d2aff02bb$export$48cfd1e771a65c4f());
                    v = $f212c67d2aff02bb$export$4d3fb11e950abb9e(), o = l = $f212c67d2aff02bb$export$36776f635604f274(g = j += $f212c67d2aff02bb$export$c2ab62c7bf24634($f212c67d2aff02bb$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $f212c67d2aff02bb$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $f212c67d2aff02bb$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $f212c67d2aff02bb$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $f212c67d2aff02bb$export$2f35ab04d2335697(e, v + 1, v = $f212c67d2aff02bb$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $f212c67d2aff02bb$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $f212c67d2aff02bb$export$35059013cd4a06db(e, r, a, s === 0 ? $f212c67d2aff02bb$export$aa3a2e812ca8570d : i, f, o, l);
}
function $f212c67d2aff02bb$export$4a34f930e789283c(e, r, a) {
    return $f212c67d2aff02bb$export$35059013cd4a06db(e, r, a, $f212c67d2aff02bb$export$a29989082612d0d9, $f212c67d2aff02bb$export$6788812c4e6611e6($f212c67d2aff02bb$export$eba6f6f03b0a92e7()), $f212c67d2aff02bb$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $f212c67d2aff02bb$export$f8483753829ec8f3(e, r, a, n) {
    return $f212c67d2aff02bb$export$35059013cd4a06db(e, r, a, $f212c67d2aff02bb$export$527d108ccf083c2b, $f212c67d2aff02bb$export$2f35ab04d2335697(e, 0, n), $f212c67d2aff02bb$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $f212c67d2aff02bb$export$82e9f45cca5ba907(n, c, s) {
    switch($f212c67d2aff02bb$export$d6af199866bfb566(n, c)){
        case 5103:
            return $f212c67d2aff02bb$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $f212c67d2aff02bb$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $f212c67d2aff02bb$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $f212c67d2aff02bb$export$39dfd62a25e0fe93 + n + $f212c67d2aff02bb$export$2c0f367103c8d01c + n + $f212c67d2aff02bb$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($f212c67d2aff02bb$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $f212c67d2aff02bb$export$39dfd62a25e0fe93 + n + $f212c67d2aff02bb$export$71ad59f2e432cfe8 + $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $f212c67d2aff02bb$export$39dfd62a25e0fe93 + n + $f212c67d2aff02bb$export$71ad59f2e432cfe8 + $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $f212c67d2aff02bb$export$39dfd62a25e0fe93 + n + $f212c67d2aff02bb$export$71ad59f2e432cfe8 + $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $f212c67d2aff02bb$export$39dfd62a25e0fe93 + n + $f212c67d2aff02bb$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $f212c67d2aff02bb$export$39dfd62a25e0fe93 + n + $f212c67d2aff02bb$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $f212c67d2aff02bb$export$39dfd62a25e0fe93 + n + $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $f212c67d2aff02bb$export$39dfd62a25e0fe93 + "box-$1$2" + $f212c67d2aff02bb$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $f212c67d2aff02bb$export$39dfd62a25e0fe93 + n + $f212c67d2aff02bb$export$71ad59f2e432cfe8 + "flex-item-" + $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$f212c67d2aff02bb$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $f212c67d2aff02bb$export$71ad59f2e432cfe8 + "grid-row-" + $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $f212c67d2aff02bb$export$39dfd62a25e0fe93 + n + $f212c67d2aff02bb$export$71ad59f2e432cfe8 + "flex-line-pack" + $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $f212c67d2aff02bb$export$39dfd62a25e0fe93 + n + $f212c67d2aff02bb$export$71ad59f2e432cfe8 + $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $f212c67d2aff02bb$export$39dfd62a25e0fe93 + n + $f212c67d2aff02bb$export$71ad59f2e432cfe8 + $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $f212c67d2aff02bb$export$39dfd62a25e0fe93 + "box-" + $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(n, "-grow", "") + $f212c67d2aff02bb$export$39dfd62a25e0fe93 + n + $f212c67d2aff02bb$export$71ad59f2e432cfe8 + $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $f212c67d2aff02bb$export$39dfd62a25e0fe93 + $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $f212c67d2aff02bb$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $f212c67d2aff02bb$export$77ad94ebf1c2b9ed($f212c67d2aff02bb$export$77ad94ebf1c2b9ed($f212c67d2aff02bb$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $f212c67d2aff02bb$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $f212c67d2aff02bb$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $f212c67d2aff02bb$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $f212c67d2aff02bb$export$77ad94ebf1c2b9ed($f212c67d2aff02bb$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $f212c67d2aff02bb$export$39dfd62a25e0fe93 + "box-pack:$3" + $f212c67d2aff02bb$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $f212c67d2aff02bb$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$f212c67d2aff02bb$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $f212c67d2aff02bb$export$71ad59f2e432cfe8 + "grid-column-align" + $f212c67d2aff02bb$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $f212c67d2aff02bb$export$71ad59f2e432cfe8 + $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $f212c67d2aff02bb$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$f212c67d2aff02bb$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $f212c67d2aff02bb$export$71ad59f2e432cfe8 + $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $f212c67d2aff02bb$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$f212c67d2aff02bb$export$f8e21b1e77979a08(s, "span") ? $f212c67d2aff02bb$export$4659b591c19bdf3d(s, /\d+/) : +$f212c67d2aff02bb$export$4659b591c19bdf3d(s, /\d+/) - +$f212c67d2aff02bb$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $f212c67d2aff02bb$export$71ad59f2e432cfe8 + $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $f212c67d2aff02bb$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $f212c67d2aff02bb$export$71ad59f2e432cfe8 + $f212c67d2aff02bb$export$77ad94ebf1c2b9ed($f212c67d2aff02bb$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $f212c67d2aff02bb$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($f212c67d2aff02bb$export$36776f635604f274(n) - 1 - c > 6) switch($f212c67d2aff02bb$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($f212c67d2aff02bb$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $f212c67d2aff02bb$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $f212c67d2aff02bb$export$2c0f367103c8d01c + ($f212c67d2aff02bb$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$f212c67d2aff02bb$export$f8e21b1e77979a08(n, "stretch") ? $f212c67d2aff02bb$export$82e9f45cca5ba907($f212c67d2aff02bb$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $f212c67d2aff02bb$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $f212c67d2aff02bb$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($f212c67d2aff02bb$export$a9db5e087081082d(n, c + 6) === 121) return $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(n, ":", ":" + $f212c67d2aff02bb$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($f212c67d2aff02bb$export$a9db5e087081082d(n, $f212c67d2aff02bb$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $f212c67d2aff02bb$export$39dfd62a25e0fe93 + ($f212c67d2aff02bb$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $f212c67d2aff02bb$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $f212c67d2aff02bb$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(n, ":", ":" + $f212c67d2aff02bb$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $f212c67d2aff02bb$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $f212c67d2aff02bb$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $f212c67d2aff02bb$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $f212c67d2aff02bb$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $f212c67d2aff02bb$export$a763edbf796b780a:
        case $f212c67d2aff02bb$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $f212c67d2aff02bb$export$a29989082612d0d9:
            return "";
        case $f212c67d2aff02bb$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $f212c67d2aff02bb$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $f212c67d2aff02bb$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $f212c67d2aff02bb$export$36776f635604f274(a = $f212c67d2aff02bb$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $f212c67d2aff02bb$export$5a7767152ae0305f(e) {
    var r = $f212c67d2aff02bb$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $f212c67d2aff02bb$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $f212c67d2aff02bb$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $f212c67d2aff02bb$export$527d108ccf083c2b:
                n.return = $f212c67d2aff02bb$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $f212c67d2aff02bb$export$b44a8529a35fcb60:
                return $f212c67d2aff02bb$export$dfdc1655ccc5b9cb([
                    $f212c67d2aff02bb$export$784d13d8ee351f07(n, {
                        value: $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $f212c67d2aff02bb$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $f212c67d2aff02bb$export$aa3a2e812ca8570d:
                if (n.length) return $f212c67d2aff02bb$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($f212c67d2aff02bb$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $f212c67d2aff02bb$export$dfdc1655ccc5b9cb([
                                $f212c67d2aff02bb$export$784d13d8ee351f07(n, {
                                    props: [
                                        $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $f212c67d2aff02bb$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $f212c67d2aff02bb$export$dfdc1655ccc5b9cb([
                                $f212c67d2aff02bb$export$784d13d8ee351f07(n, {
                                    props: [
                                        $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $f212c67d2aff02bb$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $f212c67d2aff02bb$export$784d13d8ee351f07(n, {
                                    props: [
                                        $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $f212c67d2aff02bb$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $f212c67d2aff02bb$export$784d13d8ee351f07(n, {
                                    props: [
                                        $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $f212c67d2aff02bb$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $f212c67d2aff02bb$export$76a88f7de6507443(e) {
    switch(e.type){
        case $f212c67d2aff02bb$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $f212c67d2aff02bb$export$1be1fc439b849fdf($f212c67d2aff02bb$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($f212c67d2aff02bb$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $f212c67d2aff02bb$export$2f35ab04d2335697(r, 1, $f212c67d2aff02bb$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $f212c67d2aff02bb$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $f212c67d2aff02bb$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $f212c67d2aff02bb$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("aXTeZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7fba43bf73410f49$export$2e2bcd8739ae039; });
var $7fba43bf73410f49$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("chUI2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f230fd7415c39d6$export$2e2bcd8739ae039; });
function $8f230fd7415c39d6$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("4cRLz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3101fd4c95d2afad$export$2e2bcd8739ae039; });

var $7bVaI = parcelRequire("7bVaI");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $3101fd4c95d2afad$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7bVaI)))(targetComponent, sourceComponent);
};

});
parcelRegister("7bVaI", function(module, exports) {
'use strict';

var $b6gAy = parcelRequire("b6gAy");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $53c5e898301e8eb2$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $53c5e898301e8eb2$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $53c5e898301e8eb2$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $53c5e898301e8eb2$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $53c5e898301e8eb2$var$TYPE_STATICS = {};
$53c5e898301e8eb2$var$TYPE_STATICS[$b6gAy.ForwardRef] = $53c5e898301e8eb2$var$FORWARD_REF_STATICS;
$53c5e898301e8eb2$var$TYPE_STATICS[$b6gAy.Memo] = $53c5e898301e8eb2$var$MEMO_STATICS;
function $53c5e898301e8eb2$var$getStatics(component) {
    // React v16.11 and below
    if ($b6gAy.isMemo(component)) return $53c5e898301e8eb2$var$MEMO_STATICS;
     // React v16.12 and above
    return $53c5e898301e8eb2$var$TYPE_STATICS[component['$$typeof']] || $53c5e898301e8eb2$var$REACT_STATICS;
}
var $53c5e898301e8eb2$var$defineProperty = Object.defineProperty;
var $53c5e898301e8eb2$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $53c5e898301e8eb2$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $53c5e898301e8eb2$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $53c5e898301e8eb2$var$getPrototypeOf = Object.getPrototypeOf;
var $53c5e898301e8eb2$var$objectPrototype = Object.prototype;
function $53c5e898301e8eb2$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($53c5e898301e8eb2$var$objectPrototype) {
            var inheritedComponent = $53c5e898301e8eb2$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $53c5e898301e8eb2$var$objectPrototype) $53c5e898301e8eb2$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $53c5e898301e8eb2$var$getOwnPropertyNames(sourceComponent);
        if ($53c5e898301e8eb2$var$getOwnPropertySymbols) keys = keys.concat($53c5e898301e8eb2$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $53c5e898301e8eb2$var$getStatics(targetComponent);
        var sourceStatics = $53c5e898301e8eb2$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$53c5e898301e8eb2$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $53c5e898301e8eb2$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $53c5e898301e8eb2$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $53c5e898301e8eb2$var$hoistNonReactStatics;

});
parcelRegister("b6gAy", function(module, exports) {
'use strict';

module.exports = (parcelRequire("aetFv"));

});
parcelRegister("aetFv", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $773239b973926140$export$2b8d127b894957b9; }, function (v) { return $773239b973926140$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $773239b973926140$export$cea3a54a6425200c; }, function (v) { return $773239b973926140$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $773239b973926140$export$a7c73072b1a182ae; }, function (v) { return $773239b973926140$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $773239b973926140$export$9f27bc3417b4524d; }, function (v) { return $773239b973926140$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $773239b973926140$export$db77ccec0bb4ccac; }, function (v) { return $773239b973926140$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $773239b973926140$export$8392c0c9d3dcbd35; }, function (v) { return $773239b973926140$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $773239b973926140$export$ffb0004e005737fa; }, function (v) { return $773239b973926140$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $773239b973926140$export$b624eff549462981; }, function (v) { return $773239b973926140$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $773239b973926140$export$7897aa7841a5380c; }, function (v) { return $773239b973926140$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $773239b973926140$export$602eac185826482c; }, function (v) { return $773239b973926140$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $773239b973926140$export$e2c29f18771995cb; }, function (v) { return $773239b973926140$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $773239b973926140$export$5f8d39834fd61797; }, function (v) { return $773239b973926140$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $773239b973926140$export$74bf444e3cd11ea5; }, function (v) { return $773239b973926140$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $773239b973926140$export$92387174baf9b227; }, function (v) { return $773239b973926140$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $773239b973926140$export$ec112efeb987d9c6; }, function (v) { return $773239b973926140$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $773239b973926140$export$b706b080d889d2c9; }, function (v) { return $773239b973926140$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $773239b973926140$export$5be5a87408f70ddc; }, function (v) { return $773239b973926140$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $773239b973926140$export$45a5e7f76e0caa8d; }, function (v) { return $773239b973926140$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $773239b973926140$export$455c2e768291efa6; }, function (v) { return $773239b973926140$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $773239b973926140$export$9522e17588c12572; }, function (v) { return $773239b973926140$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $773239b973926140$export$2110ac352bb060b9; }, function (v) { return $773239b973926140$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $773239b973926140$export$56885ab8b9c456ab; }, function (v) { return $773239b973926140$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $773239b973926140$export$d927fcb6adf8f9de; }, function (v) { return $773239b973926140$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $773239b973926140$export$b82d16f27459e05a; }, function (v) { return $773239b973926140$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $773239b973926140$export$522c17b4f5e123e8; }, function (v) { return $773239b973926140$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $773239b973926140$export$1aabd8a0274ecfd6; }, function (v) { return $773239b973926140$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $773239b973926140$export$9b621391a187a31a; }, function (v) { return $773239b973926140$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $773239b973926140$export$f5bbd400c2f4426f; }, function (v) { return $773239b973926140$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $773239b973926140$export$2b8d127b894957b9;
var $773239b973926140$export$cea3a54a6425200c;
var $773239b973926140$export$a7c73072b1a182ae;
var $773239b973926140$export$9f27bc3417b4524d;
var $773239b973926140$export$db77ccec0bb4ccac;
var $773239b973926140$export$8392c0c9d3dcbd35;
var $773239b973926140$export$ffb0004e005737fa;
var $773239b973926140$export$b624eff549462981;
var $773239b973926140$export$7897aa7841a5380c;
var $773239b973926140$export$602eac185826482c;
var $773239b973926140$export$e2c29f18771995cb;
var $773239b973926140$export$5f8d39834fd61797;
var $773239b973926140$export$74bf444e3cd11ea5;
var $773239b973926140$export$92387174baf9b227;
var $773239b973926140$export$ec112efeb987d9c6;
var $773239b973926140$export$b706b080d889d2c9;
var $773239b973926140$export$5be5a87408f70ddc;
var $773239b973926140$export$45a5e7f76e0caa8d;
var $773239b973926140$export$455c2e768291efa6;
var $773239b973926140$export$9522e17588c12572;
var $773239b973926140$export$2110ac352bb060b9;
var $773239b973926140$export$56885ab8b9c456ab;
var $773239b973926140$export$d927fcb6adf8f9de;
var $773239b973926140$export$b82d16f27459e05a;
var $773239b973926140$export$522c17b4f5e123e8;
var $773239b973926140$export$1aabd8a0274ecfd6;
var $773239b973926140$export$9b621391a187a31a;
var $773239b973926140$export$f5bbd400c2f4426f;
'use strict';
var $773239b973926140$var$b = "function" === typeof Symbol && Symbol.for, $773239b973926140$var$c = $773239b973926140$var$b ? Symbol.for("react.element") : 60103, $773239b973926140$var$d = $773239b973926140$var$b ? Symbol.for("react.portal") : 60106, $773239b973926140$var$e = $773239b973926140$var$b ? Symbol.for("react.fragment") : 60107, $773239b973926140$var$f = $773239b973926140$var$b ? Symbol.for("react.strict_mode") : 60108, $773239b973926140$var$g = $773239b973926140$var$b ? Symbol.for("react.profiler") : 60114, $773239b973926140$var$h = $773239b973926140$var$b ? Symbol.for("react.provider") : 60109, $773239b973926140$var$k = $773239b973926140$var$b ? Symbol.for("react.context") : 60110, $773239b973926140$var$l = $773239b973926140$var$b ? Symbol.for("react.async_mode") : 60111, $773239b973926140$var$m = $773239b973926140$var$b ? Symbol.for("react.concurrent_mode") : 60111, $773239b973926140$var$n = $773239b973926140$var$b ? Symbol.for("react.forward_ref") : 60112, $773239b973926140$var$p = $773239b973926140$var$b ? Symbol.for("react.suspense") : 60113, $773239b973926140$var$q = $773239b973926140$var$b ? Symbol.for("react.suspense_list") : 60120, $773239b973926140$var$r = $773239b973926140$var$b ? Symbol.for("react.memo") : 60115, $773239b973926140$var$t = $773239b973926140$var$b ? Symbol.for("react.lazy") : 60116, $773239b973926140$var$v = $773239b973926140$var$b ? Symbol.for("react.block") : 60121, $773239b973926140$var$w = $773239b973926140$var$b ? Symbol.for("react.fundamental") : 60117, $773239b973926140$var$x = $773239b973926140$var$b ? Symbol.for("react.responder") : 60118, $773239b973926140$var$y = $773239b973926140$var$b ? Symbol.for("react.scope") : 60119;
function $773239b973926140$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $773239b973926140$var$c:
                switch(a = a.type, a){
                    case $773239b973926140$var$l:
                    case $773239b973926140$var$m:
                    case $773239b973926140$var$e:
                    case $773239b973926140$var$g:
                    case $773239b973926140$var$f:
                    case $773239b973926140$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $773239b973926140$var$k:
                            case $773239b973926140$var$n:
                            case $773239b973926140$var$t:
                            case $773239b973926140$var$r:
                            case $773239b973926140$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $773239b973926140$var$d:
                return u;
        }
    }
}
function $773239b973926140$var$A(a) {
    return $773239b973926140$var$z(a) === $773239b973926140$var$m;
}
$773239b973926140$export$2b8d127b894957b9 = $773239b973926140$var$l;
$773239b973926140$export$cea3a54a6425200c = $773239b973926140$var$m;
$773239b973926140$export$a7c73072b1a182ae = $773239b973926140$var$k;
$773239b973926140$export$9f27bc3417b4524d = $773239b973926140$var$h;
$773239b973926140$export$db77ccec0bb4ccac = $773239b973926140$var$c;
$773239b973926140$export$8392c0c9d3dcbd35 = $773239b973926140$var$n;
$773239b973926140$export$ffb0004e005737fa = $773239b973926140$var$e;
$773239b973926140$export$b624eff549462981 = $773239b973926140$var$t;
$773239b973926140$export$7897aa7841a5380c = $773239b973926140$var$r;
$773239b973926140$export$602eac185826482c = $773239b973926140$var$d;
$773239b973926140$export$e2c29f18771995cb = $773239b973926140$var$g;
$773239b973926140$export$5f8d39834fd61797 = $773239b973926140$var$f;
$773239b973926140$export$74bf444e3cd11ea5 = $773239b973926140$var$p;
$773239b973926140$export$92387174baf9b227 = function(a) {
    return $773239b973926140$var$A(a) || $773239b973926140$var$z(a) === $773239b973926140$var$l;
};
$773239b973926140$export$ec112efeb987d9c6 = $773239b973926140$var$A;
$773239b973926140$export$b706b080d889d2c9 = function(a) {
    return $773239b973926140$var$z(a) === $773239b973926140$var$k;
};
$773239b973926140$export$5be5a87408f70ddc = function(a) {
    return $773239b973926140$var$z(a) === $773239b973926140$var$h;
};
$773239b973926140$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $773239b973926140$var$c;
};
$773239b973926140$export$455c2e768291efa6 = function(a) {
    return $773239b973926140$var$z(a) === $773239b973926140$var$n;
};
$773239b973926140$export$9522e17588c12572 = function(a) {
    return $773239b973926140$var$z(a) === $773239b973926140$var$e;
};
$773239b973926140$export$2110ac352bb060b9 = function(a) {
    return $773239b973926140$var$z(a) === $773239b973926140$var$t;
};
$773239b973926140$export$56885ab8b9c456ab = function(a) {
    return $773239b973926140$var$z(a) === $773239b973926140$var$r;
};
$773239b973926140$export$d927fcb6adf8f9de = function(a) {
    return $773239b973926140$var$z(a) === $773239b973926140$var$d;
};
$773239b973926140$export$b82d16f27459e05a = function(a) {
    return $773239b973926140$var$z(a) === $773239b973926140$var$g;
};
$773239b973926140$export$522c17b4f5e123e8 = function(a) {
    return $773239b973926140$var$z(a) === $773239b973926140$var$f;
};
$773239b973926140$export$1aabd8a0274ecfd6 = function(a) {
    return $773239b973926140$var$z(a) === $773239b973926140$var$p;
};
$773239b973926140$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $773239b973926140$var$e || a === $773239b973926140$var$m || a === $773239b973926140$var$g || a === $773239b973926140$var$f || a === $773239b973926140$var$p || a === $773239b973926140$var$q || "object" === typeof a && null !== a && (a.$$typeof === $773239b973926140$var$t || a.$$typeof === $773239b973926140$var$r || a.$$typeof === $773239b973926140$var$h || a.$$typeof === $773239b973926140$var$k || a.$$typeof === $773239b973926140$var$n || a.$$typeof === $773239b973926140$var$w || a.$$typeof === $773239b973926140$var$x || a.$$typeof === $773239b973926140$var$y || a.$$typeof === $773239b973926140$var$v);
};
$773239b973926140$export$f5bbd400c2f4426f = $773239b973926140$var$z;

});




parcelRegister("fq9jv", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $b3a08232133d7916$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $b3a08232133d7916$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $b3a08232133d7916$export$6f077d94b33a01aa; });
var $b3a08232133d7916$var$isBrowser = typeof document !== 'undefined';
function $b3a08232133d7916$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $b3a08232133d7916$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $b3a08232133d7916$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $b3a08232133d7916$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $b3a08232133d7916$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$b3a08232133d7916$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$b3a08232133d7916$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("2R5SH", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $214517e6b8b3b2f8$export$6321afa313b251b5; });

var $iQamK = parcelRequire("iQamK");

var $3Vtnq = parcelRequire("3Vtnq");

var $chUI2 = parcelRequire("chUI2");
var $214517e6b8b3b2f8$var$isDevelopment = false;
var $214517e6b8b3b2f8$var$hyphenateRegex = /[A-Z]|^ms/g;
var $214517e6b8b3b2f8$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $214517e6b8b3b2f8$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $214517e6b8b3b2f8$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $214517e6b8b3b2f8$var$processStyleName = /* #__PURE__ */ (0, $chUI2.default)(function(styleName) {
    return $214517e6b8b3b2f8$var$isCustomProperty(styleName) ? styleName : styleName.replace($214517e6b8b3b2f8$var$hyphenateRegex, '-$&').toLowerCase();
});
var $214517e6b8b3b2f8$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($214517e6b8b3b2f8$var$animationRegex, function(match, p1, p2) {
                $214517e6b8b3b2f8$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $214517e6b8b3b2f8$var$cursor
                };
                return p1;
            });
    }
    if ((0, $3Vtnq.default)[key] !== 1 && !$214517e6b8b3b2f8$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $214517e6b8b3b2f8$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $214517e6b8b3b2f8$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $214517e6b8b3b2f8$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $214517e6b8b3b2f8$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $214517e6b8b3b2f8$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $214517e6b8b3b2f8$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $214517e6b8b3b2f8$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $214517e6b8b3b2f8$var$cursor;
                var result = interpolation(mergedProps);
                $214517e6b8b3b2f8$var$cursor = previousCursor;
                return $214517e6b8b3b2f8$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $214517e6b8b3b2f8$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $214517e6b8b3b2f8$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($214517e6b8b3b2f8$var$isProcessableValue(asString)) string += $214517e6b8b3b2f8$var$processStyleName(key) + ":" + $214517e6b8b3b2f8$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $214517e6b8b3b2f8$var$isDevelopment) throw new Error($214517e6b8b3b2f8$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($214517e6b8b3b2f8$var$isProcessableValue(value[_i])) string += $214517e6b8b3b2f8$var$processStyleName(key) + ":" + $214517e6b8b3b2f8$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $214517e6b8b3b2f8$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $214517e6b8b3b2f8$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $214517e6b8b3b2f8$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $214517e6b8b3b2f8$var$cursor;
function $214517e6b8b3b2f8$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $214517e6b8b3b2f8$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $214517e6b8b3b2f8$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $214517e6b8b3b2f8$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $214517e6b8b3b2f8$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $214517e6b8b3b2f8$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $iQamK.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $214517e6b8b3b2f8$var$cursor
    };
}

});
parcelRegister("iQamK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db751fc9f4ee9019$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $db751fc9f4ee9019$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("3Vtnq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2dbd7b9ac95184a6$export$2e2bcd8739ae039; });
var $2dbd7b9ac95184a6$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("gFv23", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $c2288c019178c828$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $c2288c019178c828$export$811a713a7276cb9d; });

var $8FY87 = parcelRequire("8FY87");
var $c2288c019178c828$var$isBrowser = typeof document !== 'undefined';
var $c2288c019178c828$var$syncFallback = function syncFallback(create) {
    return create();
};
var $c2288c019178c828$var$useInsertionEffect = $8FY87.useInsertionEffect ? $8FY87.useInsertionEffect : false;
var $c2288c019178c828$export$db21c7ffa21794e7 = !$c2288c019178c828$var$isBrowser ? $c2288c019178c828$var$syncFallback : $c2288c019178c828$var$useInsertionEffect || $c2288c019178c828$var$syncFallback;
var $c2288c019178c828$export$811a713a7276cb9d = $c2288c019178c828$var$useInsertionEffect || $8FY87.useLayoutEffect;

});



parcelRegister("7fY6k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54888def81595797$export$2e2bcd8739ae039; });

var $chUI2 = parcelRequire("chUI2");
// eslint-disable-next-line no-undef
var $54888def81595797$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $54888def81595797$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $chUI2.default)(function(prop) {
    return $54888def81595797$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("29VbU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1928c900581f9689$export$2e2bcd8739ae039; });

var $8FY87 = parcelRequire("8FY87");


var $8MSLN = parcelRequire("8MSLN");

var $doYkk = parcelRequire("doYkk");

var $2PPWI = parcelRequire("2PPWI");
'use client';
function $1928c900581f9689$var$getCache(injectFirst, enableCssLayer) {
    const emotionCache = (0, $doYkk.default)({
        key: 'css',
        prepend: injectFirst
    });
    if (enableCssLayer) {
        const prevInsert = emotionCache.insert;
        emotionCache.insert = (...args)=>{
            if (!args[1].styles.match(/^@layer\s+[^{]*$/)) // avoid nested @layer
            args[1].styles = `@layer mui {${args[1].styles}}`;
            return prevInsert(...args);
        };
    }
    return emotionCache;
}
const $1928c900581f9689$var$cacheMap = new Map();
function $1928c900581f9689$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, enableCssLayer: enableCssLayer, children: children } = props;
    const cache = $8FY87.useMemo(()=>{
        const cacheKey = `${injectFirst}-${enableCssLayer}`;
        if (typeof document === 'object' && $1928c900581f9689$var$cacheMap.has(cacheKey)) return $1928c900581f9689$var$cacheMap.get(cacheKey);
        const fresh = $1928c900581f9689$var$getCache(injectFirst, enableCssLayer);
        $1928c900581f9689$var$cacheMap.set(cacheKey, fresh);
        return fresh;
    }, [
        injectFirst,
        enableCssLayer
    ]);
    if (injectFirst || enableCssLayer) return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8MSLN.C), {
        value: cache,
        children: children
    });
    return children;
}

});

parcelRegister("jr996", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e267a21f686783e3$export$2e2bcd8739ae039; });
parcelRequire("8FY87");


var $icSEh = parcelRequire("icSEh");

var $2PPWI = parcelRequire("2PPWI");
'use client';
function $e267a21f686783e3$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $e267a21f686783e3$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($e267a21f686783e3$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $icSEh.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("d5ARM", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $987856e696b5bb72$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $987856e696b5bb72$export$2e2bcd8739ae039; });

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");
function $987856e696b5bb72$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $987856e696b5bb72$var$deepClone(source) {
    if (/*#__PURE__*/ $8FY87.isValidElement(source) || !$987856e696b5bb72$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $987856e696b5bb72$var$deepClone(source[key]);
    });
    return output;
}
function $987856e696b5bb72$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $zgVxD.default)({}, target) : target;
    if ($987856e696b5bb72$export$53b83ca8eaab0383(target) && $987856e696b5bb72$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $8FY87.isValidElement(source[key])) output[key] = source[key];
        else if ($987856e696b5bb72$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $987856e696b5bb72$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $987856e696b5bb72$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $987856e696b5bb72$export$53b83ca8eaab0383(source[key]) ? $987856e696b5bb72$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("jAkST", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("d1bCP")).default; });

var $d1bCP = parcelRequire("d1bCP");

});

parcelRegister("4LObi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("3PzLI")).default; });

var $3PzLI = parcelRequire("3PzLI");
$parcel$exportWildcard(module.exports, $3PzLI);

});
parcelRegister("3PzLI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getFunctionName", function () { return $2ca1e1662d5fb1c2$export$aad197c7121a6651; });
$parcel$export(module.exports, "default", function () { return $2ca1e1662d5fb1c2$export$2e2bcd8739ae039; });

var $2UaVB = parcelRequire("2UaVB");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const $2ca1e1662d5fb1c2$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function $2ca1e1662d5fb1c2$export$aad197c7121a6651(fn) {
    const match = `${fn}`.match($2ca1e1662d5fb1c2$var$fnNameMatchRegex);
    const name = match && match[1];
    return name || '';
}
function $2ca1e1662d5fb1c2$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || $2ca1e1662d5fb1c2$export$aad197c7121a6651(Component) || fallback;
}
function $2ca1e1662d5fb1c2$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $2ca1e1662d5fb1c2$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $2ca1e1662d5fb1c2$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $2ca1e1662d5fb1c2$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $2UaVB.ForwardRef:
            return $2ca1e1662d5fb1c2$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $2UaVB.Memo:
            return $2ca1e1662d5fb1c2$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});
parcelRegister("2UaVB", function(module, exports) {
'use strict';

module.exports = (parcelRequire("czKqd"));

});
parcelRegister("czKqd", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $927cc34f010a28ab$export$a7c73072b1a182ae; }, function (v) { return $927cc34f010a28ab$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $927cc34f010a28ab$export$9f27bc3417b4524d; }, function (v) { return $927cc34f010a28ab$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $927cc34f010a28ab$export$db77ccec0bb4ccac; }, function (v) { return $927cc34f010a28ab$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $927cc34f010a28ab$export$8392c0c9d3dcbd35; }, function (v) { return $927cc34f010a28ab$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $927cc34f010a28ab$export$ffb0004e005737fa; }, function (v) { return $927cc34f010a28ab$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $927cc34f010a28ab$export$b624eff549462981; }, function (v) { return $927cc34f010a28ab$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $927cc34f010a28ab$export$7897aa7841a5380c; }, function (v) { return $927cc34f010a28ab$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $927cc34f010a28ab$export$602eac185826482c; }, function (v) { return $927cc34f010a28ab$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $927cc34f010a28ab$export$e2c29f18771995cb; }, function (v) { return $927cc34f010a28ab$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $927cc34f010a28ab$export$5f8d39834fd61797; }, function (v) { return $927cc34f010a28ab$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $927cc34f010a28ab$export$74bf444e3cd11ea5; }, function (v) { return $927cc34f010a28ab$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $927cc34f010a28ab$export$998bcd577473dd93; }, function (v) { return $927cc34f010a28ab$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $927cc34f010a28ab$export$b706b080d889d2c9; }, function (v) { return $927cc34f010a28ab$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $927cc34f010a28ab$export$5be5a87408f70ddc; }, function (v) { return $927cc34f010a28ab$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $927cc34f010a28ab$export$45a5e7f76e0caa8d; }, function (v) { return $927cc34f010a28ab$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $927cc34f010a28ab$export$455c2e768291efa6; }, function (v) { return $927cc34f010a28ab$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $927cc34f010a28ab$export$9522e17588c12572; }, function (v) { return $927cc34f010a28ab$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $927cc34f010a28ab$export$2110ac352bb060b9; }, function (v) { return $927cc34f010a28ab$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $927cc34f010a28ab$export$56885ab8b9c456ab; }, function (v) { return $927cc34f010a28ab$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $927cc34f010a28ab$export$d927fcb6adf8f9de; }, function (v) { return $927cc34f010a28ab$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $927cc34f010a28ab$export$b82d16f27459e05a; }, function (v) { return $927cc34f010a28ab$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $927cc34f010a28ab$export$522c17b4f5e123e8; }, function (v) { return $927cc34f010a28ab$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $927cc34f010a28ab$export$1aabd8a0274ecfd6; }, function (v) { return $927cc34f010a28ab$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $927cc34f010a28ab$export$3d6c20d97e46b957; }, function (v) { return $927cc34f010a28ab$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $927cc34f010a28ab$export$9b621391a187a31a; }, function (v) { return $927cc34f010a28ab$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $927cc34f010a28ab$export$f5bbd400c2f4426f; }, function (v) { return $927cc34f010a28ab$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $927cc34f010a28ab$export$a7c73072b1a182ae;
var $927cc34f010a28ab$export$9f27bc3417b4524d;
var $927cc34f010a28ab$export$db77ccec0bb4ccac;
var $927cc34f010a28ab$export$8392c0c9d3dcbd35;
var $927cc34f010a28ab$export$ffb0004e005737fa;
var $927cc34f010a28ab$export$b624eff549462981;
var $927cc34f010a28ab$export$7897aa7841a5380c;
var $927cc34f010a28ab$export$602eac185826482c;
var $927cc34f010a28ab$export$e2c29f18771995cb;
var $927cc34f010a28ab$export$5f8d39834fd61797;
var $927cc34f010a28ab$export$74bf444e3cd11ea5;
var $927cc34f010a28ab$export$998bcd577473dd93;
var $927cc34f010a28ab$export$b706b080d889d2c9;
var $927cc34f010a28ab$export$5be5a87408f70ddc;
var $927cc34f010a28ab$export$45a5e7f76e0caa8d;
var $927cc34f010a28ab$export$455c2e768291efa6;
var $927cc34f010a28ab$export$9522e17588c12572;
var $927cc34f010a28ab$export$2110ac352bb060b9;
var $927cc34f010a28ab$export$56885ab8b9c456ab;
var $927cc34f010a28ab$export$d927fcb6adf8f9de;
var $927cc34f010a28ab$export$b82d16f27459e05a;
var $927cc34f010a28ab$export$522c17b4f5e123e8;
var $927cc34f010a28ab$export$1aabd8a0274ecfd6;
var $927cc34f010a28ab$export$3d6c20d97e46b957;
var $927cc34f010a28ab$export$9b621391a187a31a;
var $927cc34f010a28ab$export$f5bbd400c2f4426f;
"use strict";
var $927cc34f010a28ab$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $927cc34f010a28ab$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $927cc34f010a28ab$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $927cc34f010a28ab$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $927cc34f010a28ab$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $927cc34f010a28ab$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $927cc34f010a28ab$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $927cc34f010a28ab$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $927cc34f010a28ab$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $927cc34f010a28ab$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $927cc34f010a28ab$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $927cc34f010a28ab$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $927cc34f010a28ab$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $927cc34f010a28ab$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $927cc34f010a28ab$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $927cc34f010a28ab$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $927cc34f010a28ab$var$REACT_FRAGMENT_TYPE:
                    case $927cc34f010a28ab$var$REACT_PROFILER_TYPE:
                    case $927cc34f010a28ab$var$REACT_STRICT_MODE_TYPE:
                    case $927cc34f010a28ab$var$REACT_SUSPENSE_TYPE:
                    case $927cc34f010a28ab$var$REACT_SUSPENSE_LIST_TYPE:
                    case $927cc34f010a28ab$var$REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $927cc34f010a28ab$var$REACT_CONTEXT_TYPE:
                            case $927cc34f010a28ab$var$REACT_FORWARD_REF_TYPE:
                            case $927cc34f010a28ab$var$REACT_LAZY_TYPE:
                            case $927cc34f010a28ab$var$REACT_MEMO_TYPE:
                                return object;
                            case $927cc34f010a28ab$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $927cc34f010a28ab$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$927cc34f010a28ab$export$a7c73072b1a182ae = $927cc34f010a28ab$var$REACT_CONSUMER_TYPE;
$927cc34f010a28ab$export$9f27bc3417b4524d = $927cc34f010a28ab$var$REACT_CONTEXT_TYPE;
$927cc34f010a28ab$export$db77ccec0bb4ccac = $927cc34f010a28ab$var$REACT_ELEMENT_TYPE;
$927cc34f010a28ab$export$8392c0c9d3dcbd35 = $927cc34f010a28ab$var$REACT_FORWARD_REF_TYPE;
$927cc34f010a28ab$export$ffb0004e005737fa = $927cc34f010a28ab$var$REACT_FRAGMENT_TYPE;
$927cc34f010a28ab$export$b624eff549462981 = $927cc34f010a28ab$var$REACT_LAZY_TYPE;
$927cc34f010a28ab$export$7897aa7841a5380c = $927cc34f010a28ab$var$REACT_MEMO_TYPE;
$927cc34f010a28ab$export$602eac185826482c = $927cc34f010a28ab$var$REACT_PORTAL_TYPE;
$927cc34f010a28ab$export$e2c29f18771995cb = $927cc34f010a28ab$var$REACT_PROFILER_TYPE;
$927cc34f010a28ab$export$5f8d39834fd61797 = $927cc34f010a28ab$var$REACT_STRICT_MODE_TYPE;
$927cc34f010a28ab$export$74bf444e3cd11ea5 = $927cc34f010a28ab$var$REACT_SUSPENSE_TYPE;
$927cc34f010a28ab$export$998bcd577473dd93 = $927cc34f010a28ab$var$REACT_SUSPENSE_LIST_TYPE;
$927cc34f010a28ab$export$b706b080d889d2c9 = function(object) {
    return $927cc34f010a28ab$var$typeOf(object) === $927cc34f010a28ab$var$REACT_CONSUMER_TYPE;
};
$927cc34f010a28ab$export$5be5a87408f70ddc = function(object) {
    return $927cc34f010a28ab$var$typeOf(object) === $927cc34f010a28ab$var$REACT_CONTEXT_TYPE;
};
$927cc34f010a28ab$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $927cc34f010a28ab$var$REACT_ELEMENT_TYPE;
};
$927cc34f010a28ab$export$455c2e768291efa6 = function(object) {
    return $927cc34f010a28ab$var$typeOf(object) === $927cc34f010a28ab$var$REACT_FORWARD_REF_TYPE;
};
$927cc34f010a28ab$export$9522e17588c12572 = function(object) {
    return $927cc34f010a28ab$var$typeOf(object) === $927cc34f010a28ab$var$REACT_FRAGMENT_TYPE;
};
$927cc34f010a28ab$export$2110ac352bb060b9 = function(object) {
    return $927cc34f010a28ab$var$typeOf(object) === $927cc34f010a28ab$var$REACT_LAZY_TYPE;
};
$927cc34f010a28ab$export$56885ab8b9c456ab = function(object) {
    return $927cc34f010a28ab$var$typeOf(object) === $927cc34f010a28ab$var$REACT_MEMO_TYPE;
};
$927cc34f010a28ab$export$d927fcb6adf8f9de = function(object) {
    return $927cc34f010a28ab$var$typeOf(object) === $927cc34f010a28ab$var$REACT_PORTAL_TYPE;
};
$927cc34f010a28ab$export$b82d16f27459e05a = function(object) {
    return $927cc34f010a28ab$var$typeOf(object) === $927cc34f010a28ab$var$REACT_PROFILER_TYPE;
};
$927cc34f010a28ab$export$522c17b4f5e123e8 = function(object) {
    return $927cc34f010a28ab$var$typeOf(object) === $927cc34f010a28ab$var$REACT_STRICT_MODE_TYPE;
};
$927cc34f010a28ab$export$1aabd8a0274ecfd6 = function(object) {
    return $927cc34f010a28ab$var$typeOf(object) === $927cc34f010a28ab$var$REACT_SUSPENSE_TYPE;
};
$927cc34f010a28ab$export$3d6c20d97e46b957 = function(object) {
    return $927cc34f010a28ab$var$typeOf(object) === $927cc34f010a28ab$var$REACT_SUSPENSE_LIST_TYPE;
};
$927cc34f010a28ab$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $927cc34f010a28ab$var$REACT_FRAGMENT_TYPE || type === $927cc34f010a28ab$var$REACT_PROFILER_TYPE || type === $927cc34f010a28ab$var$REACT_STRICT_MODE_TYPE || type === $927cc34f010a28ab$var$REACT_SUSPENSE_TYPE || type === $927cc34f010a28ab$var$REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $927cc34f010a28ab$var$REACT_LAZY_TYPE || type.$$typeof === $927cc34f010a28ab$var$REACT_MEMO_TYPE || type.$$typeof === $927cc34f010a28ab$var$REACT_CONTEXT_TYPE || type.$$typeof === $927cc34f010a28ab$var$REACT_CONSUMER_TYPE || type.$$typeof === $927cc34f010a28ab$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $927cc34f010a28ab$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$927cc34f010a28ab$export$f5bbd400c2f4426f = $927cc34f010a28ab$var$typeOf;

});




parcelRegister("7778B", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("1BEIC")).default; });
$parcel$export(module.exports, "private_createBreakpoints", function () { return (parcelRequire("NL5S6")).default; });
$parcel$export(module.exports, "unstable_applyStyles", function () { return (parcelRequire("cQVAl")).default; });

var $1BEIC = parcelRequire("1BEIC");

var $NL5S6 = parcelRequire("NL5S6");

var $cQVAl = parcelRequire("cQVAl");

});
parcelRegister("1BEIC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12b8d50a4b25723a$export$2e2bcd8739ae039; });

var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");

var $d5ARM = parcelRequire("d5ARM");

var $NL5S6 = parcelRequire("NL5S6");

var $gO6rn = parcelRequire("gO6rn");

var $a2pLr = parcelRequire("a2pLr");

var $lqCXV = parcelRequire("lqCXV");

var $cJAMJ = parcelRequire("cJAMJ");

var $cQVAl = parcelRequire("cQVAl");
const $12b8d50a4b25723a$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $12b8d50a4b25723a$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $93aRW.default)(options, $12b8d50a4b25723a$var$_excluded);
    const breakpoints = (0, $NL5S6.default)(breakpointsInput);
    const spacing = (0, $a2pLr.default)(spacingInput);
    let muiTheme = (0, $d5ARM.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: (0, $zgVxD.default)({
            mode: 'light'
        }, paletteInput),
        spacing: spacing,
        shape: (0, $zgVxD.default)({}, (0, $gO6rn.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $cQVAl.default);
    muiTheme = args.reduce((acc, argument)=>(0, $d5ARM.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $zgVxD.default)({}, (0, $cJAMJ.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $lqCXV.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $12b8d50a4b25723a$export$2e2bcd8739ae039 = $12b8d50a4b25723a$var$createTheme;

});
parcelRegister("NL5S6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09591b8bd8d13d79$export$2e2bcd8739ae039; });

var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");
const $09591b8bd8d13d79$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $09591b8bd8d13d79$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $09591b8bd8d13d79$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $zgVxD.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $09591b8bd8d13d79$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5 } = breakpoints, other = (0, $93aRW.default)(breakpoints, $09591b8bd8d13d79$var$_excluded);
    const sortedValues = $09591b8bd8d13d79$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return (0, $zgVxD.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("gO6rn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3c64fccabf9d025$export$2e2bcd8739ae039; });
const $c3c64fccabf9d025$var$shape = {
    borderRadius: 4
};
var $c3c64fccabf9d025$export$2e2bcd8739ae039 = $c3c64fccabf9d025$var$shape;

});

parcelRegister("a2pLr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74ee138082af3a7e$export$2e2bcd8739ae039; });

var $keZWu = parcelRequire("keZWu");
function $74ee138082af3a7e$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $keZWu.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("keZWu", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $ebc529e931612d91$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $ebc529e931612d91$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $ebc529e931612d91$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $ebc529e931612d91$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $ebc529e931612d91$export$6f98e8eaf0be1996; });


var $bvo1Q = parcelRequire("bvo1Q");

var $iZBtv = parcelRequire("iZBtv");

var $8oNmn = parcelRequire("8oNmn");

var $9dyht = parcelRequire("9dyht");
const $ebc529e931612d91$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $ebc529e931612d91$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $ebc529e931612d91$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $ebc529e931612d91$var$getCssProperties = (0, $9dyht.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($ebc529e931612d91$var$aliases[prop]) prop = $ebc529e931612d91$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $ebc529e931612d91$var$properties[a];
    const direction = $ebc529e931612d91$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $ebc529e931612d91$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $ebc529e931612d91$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $ebc529e931612d91$var$spacingKeys = [
    ...$ebc529e931612d91$export$aab52a0dde05ad8a,
    ...$ebc529e931612d91$export$f8397d44f03ab6ad
];
function $ebc529e931612d91$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $iZBtv.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === 'number') return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $ebc529e931612d91$export$1def6f833384e3d1(theme) {
    return $ebc529e931612d91$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $ebc529e931612d91$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === 'number') return -transformed;
    return `-${transformed}`;
}
function $ebc529e931612d91$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $ebc529e931612d91$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $ebc529e931612d91$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $ebc529e931612d91$var$getCssProperties(prop);
    const styleFromPropValue = $ebc529e931612d91$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $bvo1Q.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $ebc529e931612d91$var$style(props, keys) {
    const transformer = $ebc529e931612d91$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$ebc529e931612d91$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $8oNmn.default), {});
}
function $ebc529e931612d91$export$7ede87f9b603dd3c(props) {
    return $ebc529e931612d91$var$style(props, $ebc529e931612d91$export$aab52a0dde05ad8a);
}
$ebc529e931612d91$export$7ede87f9b603dd3c.propTypes = {};
$ebc529e931612d91$export$7ede87f9b603dd3c.filterProps = $ebc529e931612d91$export$aab52a0dde05ad8a;
function $ebc529e931612d91$export$6f98e8eaf0be1996(props) {
    return $ebc529e931612d91$var$style(props, $ebc529e931612d91$export$f8397d44f03ab6ad);
}
$ebc529e931612d91$export$6f98e8eaf0be1996.propTypes = {};
$ebc529e931612d91$export$6f98e8eaf0be1996.filterProps = $ebc529e931612d91$export$f8397d44f03ab6ad;
function $ebc529e931612d91$var$spacing(props) {
    return $ebc529e931612d91$var$style(props, $ebc529e931612d91$var$spacingKeys);
}
$ebc529e931612d91$var$spacing.propTypes = {};
$ebc529e931612d91$var$spacing.filterProps = $ebc529e931612d91$var$spacingKeys;
var $ebc529e931612d91$export$2e2bcd8739ae039 = $ebc529e931612d91$var$spacing;

});
parcelRegister("bvo1Q", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $86053a965a02d3d5$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $86053a965a02d3d5$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $86053a965a02d3d5$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $86053a965a02d3d5$export$8922c90b6e020726; });
$parcel$export(module.exports, "mergeBreakpointsInOrder", function () { return $86053a965a02d3d5$export$b89a003a1e05c0ee; });
$parcel$export(module.exports, "resolveBreakpointValues", function () { return $86053a965a02d3d5$export$980e6a259d807490; });

var $zgVxD = parcelRequire("zgVxD");


var $d5ARM = parcelRequire("d5ARM");

var $8oNmn = parcelRequire("8oNmn");
const $86053a965a02d3d5$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $86053a965a02d3d5$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$86053a965a02d3d5$export$68c286be0e7e55b7[key]}px)`
};
function $86053a965a02d3d5$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $86053a965a02d3d5$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $86053a965a02d3d5$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $86053a965a02d3d5$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $86053a965a02d3d5$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $86053a965a02d3d5$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $zgVxD.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $8oNmn.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $86053a965a02d3d5$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $86053a965a02d3d5$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $86053a965a02d3d5$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $86053a965a02d3d5$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $d5ARM.default)(prev, next), {});
    return $86053a965a02d3d5$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $86053a965a02d3d5$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $86053a965a02d3d5$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $86053a965a02d3d5$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $86053a965a02d3d5$export$2e2bcd8739ae039 = $86053a965a02d3d5$var$breakpoints;

});
parcelRegister("8oNmn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61d6da7578eebbf9$export$2e2bcd8739ae039; });

var $d5ARM = parcelRequire("d5ARM");
function $61d6da7578eebbf9$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $d5ARM.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $61d6da7578eebbf9$export$2e2bcd8739ae039 = $61d6da7578eebbf9$var$merge;

});


parcelRegister("iZBtv", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $dd3afe3de8354b4c$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $dd3afe3de8354b4c$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $dd3afe3de8354b4c$export$2e2bcd8739ae039; });

var $d1bCP = parcelRequire("d1bCP");


var $bvo1Q = parcelRequire("bvo1Q");
function $dd3afe3de8354b4c$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $dd3afe3de8354b4c$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $dd3afe3de8354b4c$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $dd3afe3de8354b4c$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $dd3afe3de8354b4c$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $dd3afe3de8354b4c$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $dd3afe3de8354b4c$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $d1bCP.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $bvo1Q.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $dd3afe3de8354b4c$export$2e2bcd8739ae039 = $dd3afe3de8354b4c$var$style;

});

parcelRegister("9dyht", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b5feb65ae87f6b4$export$2e2bcd8739ae039; });
function $6b5feb65ae87f6b4$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("lqCXV", function(module, exports) {

$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return $f99a4070b4189c36$export$7d53d8bf2911e013; });
$parcel$export(module.exports, "default", function () { return $f99a4070b4189c36$export$2e2bcd8739ae039; });

var $d1bCP = parcelRequire("d1bCP");

var $8oNmn = parcelRequire("8oNmn");

var $iZBtv = parcelRequire("iZBtv");

var $bvo1Q = parcelRequire("bvo1Q");

var $cJAMJ = parcelRequire("cJAMJ");
function $f99a4070b4189c36$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $f99a4070b4189c36$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $f99a4070b4189c36$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $iZBtv.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $iZBtv.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $iZBtv.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $d1bCP.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $bvo1Q.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {}, nested: nested } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $cJAMJ.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $bvo1Q.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $f99a4070b4189c36$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $8oNmn.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $bvo1Q.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($f99a4070b4189c36$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme,
                                nested: true
                            });
                            else css = (0, $8oNmn.default)(css, breakpointsValues);
                        }
                    } else css = (0, $8oNmn.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, $bvo1Q.removeUnusedBreakpoints)(breakpointsKeys, css)
            };
            return (0, $bvo1Q.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $f99a4070b4189c36$var$styleFunctionSx = $f99a4070b4189c36$export$7d53d8bf2911e013();
$f99a4070b4189c36$var$styleFunctionSx.filterProps = [
    'sx'
];
var $f99a4070b4189c36$export$2e2bcd8739ae039 = $f99a4070b4189c36$var$styleFunctionSx;

});
parcelRegister("cJAMJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $945638c2d62cd118$export$2e2bcd8739ae039; });

var $keZWu = parcelRequire("keZWu");

var $7DqfU = parcelRequire("7DqfU");

var $goPjs = parcelRequire("goPjs");

var $hGuYn = parcelRequire("hGuYn");

var $3MSJ1 = parcelRequire("3MSJ1");
const $945638c2d62cd118$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $7DqfU.borderTransform)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $7DqfU.borderTransform)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $7DqfU.borderTransform)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $7DqfU.borderTransform)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $7DqfU.borderTransform)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $7DqfU.borderTransform)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $7DqfU.borderRadius)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $hGuYn.paletteTransform)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $hGuYn.paletteTransform)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $hGuYn.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $keZWu.padding)
    },
    pt: {
        style: (0, $keZWu.padding)
    },
    pr: {
        style: (0, $keZWu.padding)
    },
    pb: {
        style: (0, $keZWu.padding)
    },
    pl: {
        style: (0, $keZWu.padding)
    },
    px: {
        style: (0, $keZWu.padding)
    },
    py: {
        style: (0, $keZWu.padding)
    },
    padding: {
        style: (0, $keZWu.padding)
    },
    paddingTop: {
        style: (0, $keZWu.padding)
    },
    paddingRight: {
        style: (0, $keZWu.padding)
    },
    paddingBottom: {
        style: (0, $keZWu.padding)
    },
    paddingLeft: {
        style: (0, $keZWu.padding)
    },
    paddingX: {
        style: (0, $keZWu.padding)
    },
    paddingY: {
        style: (0, $keZWu.padding)
    },
    paddingInline: {
        style: (0, $keZWu.padding)
    },
    paddingInlineStart: {
        style: (0, $keZWu.padding)
    },
    paddingInlineEnd: {
        style: (0, $keZWu.padding)
    },
    paddingBlock: {
        style: (0, $keZWu.padding)
    },
    paddingBlockStart: {
        style: (0, $keZWu.padding)
    },
    paddingBlockEnd: {
        style: (0, $keZWu.padding)
    },
    m: {
        style: (0, $keZWu.margin)
    },
    mt: {
        style: (0, $keZWu.margin)
    },
    mr: {
        style: (0, $keZWu.margin)
    },
    mb: {
        style: (0, $keZWu.margin)
    },
    ml: {
        style: (0, $keZWu.margin)
    },
    mx: {
        style: (0, $keZWu.margin)
    },
    my: {
        style: (0, $keZWu.margin)
    },
    margin: {
        style: (0, $keZWu.margin)
    },
    marginTop: {
        style: (0, $keZWu.margin)
    },
    marginRight: {
        style: (0, $keZWu.margin)
    },
    marginBottom: {
        style: (0, $keZWu.margin)
    },
    marginLeft: {
        style: (0, $keZWu.margin)
    },
    marginX: {
        style: (0, $keZWu.margin)
    },
    marginY: {
        style: (0, $keZWu.margin)
    },
    marginInline: {
        style: (0, $keZWu.margin)
    },
    marginInlineStart: {
        style: (0, $keZWu.margin)
    },
    marginInlineEnd: {
        style: (0, $keZWu.margin)
    },
    marginBlock: {
        style: (0, $keZWu.margin)
    },
    marginBlockStart: {
        style: (0, $keZWu.margin)
    },
    marginBlockEnd: {
        style: (0, $keZWu.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $goPjs.gap)
    },
    rowGap: {
        style: (0, $goPjs.rowGap)
    },
    columnGap: {
        style: (0, $goPjs.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $3MSJ1.sizingTransform)
    },
    maxWidth: {
        style: (0, $3MSJ1.maxWidth)
    },
    minWidth: {
        transform: (0, $3MSJ1.sizingTransform)
    },
    height: {
        transform: (0, $3MSJ1.sizingTransform)
    },
    maxHeight: {
        transform: (0, $3MSJ1.sizingTransform)
    },
    minHeight: {
        transform: (0, $3MSJ1.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $945638c2d62cd118$export$2e2bcd8739ae039 = $945638c2d62cd118$var$defaultSxConfig;

});
parcelRegister("7DqfU", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $58f08abcd2fd76b1$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $58f08abcd2fd76b1$export$7a57f79000377ca2; });


var $iZBtv = parcelRequire("iZBtv");

var $jFkdn = parcelRequire("jFkdn");

var $keZWu = parcelRequire("keZWu");

var $bvo1Q = parcelRequire("bvo1Q");
function $58f08abcd2fd76b1$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $58f08abcd2fd76b1$var$createBorderStyle(prop, transform) {
    return (0, $iZBtv.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $58f08abcd2fd76b1$export$1edee58a52776cd9 = $58f08abcd2fd76b1$var$createBorderStyle('border', $58f08abcd2fd76b1$export$34e2febe53ae29cc);
const $58f08abcd2fd76b1$export$f9a7b6bd24892946 = $58f08abcd2fd76b1$var$createBorderStyle('borderTop', $58f08abcd2fd76b1$export$34e2febe53ae29cc);
const $58f08abcd2fd76b1$export$5abca33e6be905d2 = $58f08abcd2fd76b1$var$createBorderStyle('borderRight', $58f08abcd2fd76b1$export$34e2febe53ae29cc);
const $58f08abcd2fd76b1$export$e2ce9f12a980a822 = $58f08abcd2fd76b1$var$createBorderStyle('borderBottom', $58f08abcd2fd76b1$export$34e2febe53ae29cc);
const $58f08abcd2fd76b1$export$47658cca1a909427 = $58f08abcd2fd76b1$var$createBorderStyle('borderLeft', $58f08abcd2fd76b1$export$34e2febe53ae29cc);
const $58f08abcd2fd76b1$export$e7fb0694ba2404fc = $58f08abcd2fd76b1$var$createBorderStyle('borderColor');
const $58f08abcd2fd76b1$export$126a92c968acdb85 = $58f08abcd2fd76b1$var$createBorderStyle('borderTopColor');
const $58f08abcd2fd76b1$export$85cc51cb8fbb8c0e = $58f08abcd2fd76b1$var$createBorderStyle('borderRightColor');
const $58f08abcd2fd76b1$export$340b0327727f6d1a = $58f08abcd2fd76b1$var$createBorderStyle('borderBottomColor');
const $58f08abcd2fd76b1$export$60beef91a985b4bf = $58f08abcd2fd76b1$var$createBorderStyle('borderLeftColor');
const $58f08abcd2fd76b1$export$f9258c55612cbed7 = $58f08abcd2fd76b1$var$createBorderStyle('outline', $58f08abcd2fd76b1$export$34e2febe53ae29cc);
const $58f08abcd2fd76b1$export$621fe586efeb64b9 = $58f08abcd2fd76b1$var$createBorderStyle('outlineColor');
const $58f08abcd2fd76b1$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $keZWu.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $keZWu.getValue)(transformer, propValue)
            });
        return (0, $bvo1Q.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$58f08abcd2fd76b1$export$7a57f79000377ca2.propTypes = {};
$58f08abcd2fd76b1$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $58f08abcd2fd76b1$var$borders = (0, $jFkdn.default)($58f08abcd2fd76b1$export$1edee58a52776cd9, $58f08abcd2fd76b1$export$f9a7b6bd24892946, $58f08abcd2fd76b1$export$5abca33e6be905d2, $58f08abcd2fd76b1$export$e2ce9f12a980a822, $58f08abcd2fd76b1$export$47658cca1a909427, $58f08abcd2fd76b1$export$e7fb0694ba2404fc, $58f08abcd2fd76b1$export$126a92c968acdb85, $58f08abcd2fd76b1$export$85cc51cb8fbb8c0e, $58f08abcd2fd76b1$export$340b0327727f6d1a, $58f08abcd2fd76b1$export$60beef91a985b4bf, $58f08abcd2fd76b1$export$7a57f79000377ca2, $58f08abcd2fd76b1$export$f9258c55612cbed7, $58f08abcd2fd76b1$export$621fe586efeb64b9);
var $58f08abcd2fd76b1$export$2e2bcd8739ae039 = $58f08abcd2fd76b1$var$borders;

});
parcelRegister("jFkdn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e51186dd59c7e05b$export$2e2bcd8739ae039; });

var $8oNmn = parcelRequire("8oNmn");
function $e51186dd59c7e05b$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $8oNmn.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $e51186dd59c7e05b$export$2e2bcd8739ae039 = $e51186dd59c7e05b$var$compose;

});


parcelRegister("goPjs", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $bf06b0de524c4863$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $bf06b0de524c4863$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $bf06b0de524c4863$export$8a833ffa5f5dbeda; });

var $iZBtv = parcelRequire("iZBtv");

var $jFkdn = parcelRequire("jFkdn");

var $keZWu = parcelRequire("keZWu");

var $bvo1Q = parcelRequire("bvo1Q");

const $bf06b0de524c4863$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $keZWu.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $keZWu.getValue)(transformer, propValue)
            });
        return (0, $bvo1Q.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$bf06b0de524c4863$export$5df9adcb0db95e1e.propTypes = {};
$bf06b0de524c4863$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $bf06b0de524c4863$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $keZWu.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $keZWu.getValue)(transformer, propValue)
            });
        return (0, $bvo1Q.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$bf06b0de524c4863$export$ec60d70ff941a580.propTypes = {};
$bf06b0de524c4863$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $bf06b0de524c4863$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $keZWu.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $keZWu.getValue)(transformer, propValue)
            });
        return (0, $bvo1Q.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$bf06b0de524c4863$export$8a833ffa5f5dbeda.propTypes = {};
$bf06b0de524c4863$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $bf06b0de524c4863$export$baf44164ca3a34e8 = (0, $iZBtv.default)({
    prop: 'gridColumn'
});
const $bf06b0de524c4863$export$8f7213a1cd01e832 = (0, $iZBtv.default)({
    prop: 'gridRow'
});
const $bf06b0de524c4863$export$b0e0abbc49ba668 = (0, $iZBtv.default)({
    prop: 'gridAutoFlow'
});
const $bf06b0de524c4863$export$bcd8b929d4b4142 = (0, $iZBtv.default)({
    prop: 'gridAutoColumns'
});
const $bf06b0de524c4863$export$e5039a674e14c828 = (0, $iZBtv.default)({
    prop: 'gridAutoRows'
});
const $bf06b0de524c4863$export$42bd9088661ffb03 = (0, $iZBtv.default)({
    prop: 'gridTemplateColumns'
});
const $bf06b0de524c4863$export$920682ae05b999bc = (0, $iZBtv.default)({
    prop: 'gridTemplateRows'
});
const $bf06b0de524c4863$export$1b88fbdd482fd33a = (0, $iZBtv.default)({
    prop: 'gridTemplateAreas'
});
const $bf06b0de524c4863$export$bdb486e40d52d26f = (0, $iZBtv.default)({
    prop: 'gridArea'
});
const $bf06b0de524c4863$var$grid = (0, $jFkdn.default)($bf06b0de524c4863$export$5df9adcb0db95e1e, $bf06b0de524c4863$export$ec60d70ff941a580, $bf06b0de524c4863$export$8a833ffa5f5dbeda, $bf06b0de524c4863$export$baf44164ca3a34e8, $bf06b0de524c4863$export$8f7213a1cd01e832, $bf06b0de524c4863$export$b0e0abbc49ba668, $bf06b0de524c4863$export$bcd8b929d4b4142, $bf06b0de524c4863$export$e5039a674e14c828, $bf06b0de524c4863$export$42bd9088661ffb03, $bf06b0de524c4863$export$920682ae05b999bc, $bf06b0de524c4863$export$1b88fbdd482fd33a, $bf06b0de524c4863$export$bdb486e40d52d26f);
var $bf06b0de524c4863$export$2e2bcd8739ae039 = $bf06b0de524c4863$var$grid;

});

parcelRegister("hGuYn", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $cdfe627a7e7fcaea$export$dbaffd4420ea0ac6; });

var $iZBtv = parcelRequire("iZBtv");

var $jFkdn = parcelRequire("jFkdn");
function $cdfe627a7e7fcaea$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $cdfe627a7e7fcaea$export$35e9368ef982300f = (0, $iZBtv.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $cdfe627a7e7fcaea$export$dbaffd4420ea0ac6
});
const $cdfe627a7e7fcaea$export$2506f56c10355b33 = (0, $iZBtv.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $cdfe627a7e7fcaea$export$dbaffd4420ea0ac6
});
const $cdfe627a7e7fcaea$export$8c5a050822fd698c = (0, $iZBtv.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $cdfe627a7e7fcaea$export$dbaffd4420ea0ac6
});
const $cdfe627a7e7fcaea$var$palette = (0, $jFkdn.default)($cdfe627a7e7fcaea$export$35e9368ef982300f, $cdfe627a7e7fcaea$export$2506f56c10355b33, $cdfe627a7e7fcaea$export$8c5a050822fd698c);
var $cdfe627a7e7fcaea$export$2e2bcd8739ae039 = $cdfe627a7e7fcaea$var$palette;

});

parcelRegister("3MSJ1", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $2c204e14ea070919$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $2c204e14ea070919$export$488fda99655ff65a; });

var $iZBtv = parcelRequire("iZBtv");

var $jFkdn = parcelRequire("jFkdn");

var $bvo1Q = parcelRequire("bvo1Q");
function $2c204e14ea070919$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $2c204e14ea070919$export$7e3df82ee760448c = (0, $iZBtv.default)({
    prop: 'width',
    transform: $2c204e14ea070919$export$8afece71750ec241
});
const $2c204e14ea070919$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $bvo1Q.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $2c204e14ea070919$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $bvo1Q.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$2c204e14ea070919$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $2c204e14ea070919$export$ee148fbbe8357dd2 = (0, $iZBtv.default)({
    prop: 'minWidth',
    transform: $2c204e14ea070919$export$8afece71750ec241
});
const $2c204e14ea070919$export$ac607276a8fe9f0a = (0, $iZBtv.default)({
    prop: 'height',
    transform: $2c204e14ea070919$export$8afece71750ec241
});
const $2c204e14ea070919$export$dc0d8bd0b94f8570 = (0, $iZBtv.default)({
    prop: 'maxHeight',
    transform: $2c204e14ea070919$export$8afece71750ec241
});
const $2c204e14ea070919$export$a43cf604e12f3b17 = (0, $iZBtv.default)({
    prop: 'minHeight',
    transform: $2c204e14ea070919$export$8afece71750ec241
});
const $2c204e14ea070919$export$ffed9f14fb65e276 = (0, $iZBtv.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $2c204e14ea070919$export$8afece71750ec241
});
const $2c204e14ea070919$export$905076ed6620e671 = (0, $iZBtv.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $2c204e14ea070919$export$8afece71750ec241
});
const $2c204e14ea070919$export$6ccc93f785106a58 = (0, $iZBtv.default)({
    prop: 'boxSizing'
});
const $2c204e14ea070919$var$sizing = (0, $jFkdn.default)($2c204e14ea070919$export$7e3df82ee760448c, $2c204e14ea070919$export$488fda99655ff65a, $2c204e14ea070919$export$ee148fbbe8357dd2, $2c204e14ea070919$export$ac607276a8fe9f0a, $2c204e14ea070919$export$dc0d8bd0b94f8570, $2c204e14ea070919$export$a43cf604e12f3b17, $2c204e14ea070919$export$6ccc93f785106a58);
var $2c204e14ea070919$export$2e2bcd8739ae039 = $2c204e14ea070919$var$sizing;

});



parcelRegister("cQVAl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95b702959af79e81$export$2e2bcd8739ae039; });
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $95b702959af79e81$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === 'function') {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, '*:where($1)');
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});



parcelRegister("2Cc5V", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("lqCXV")).default; });
$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return (parcelRequire("lqCXV")).unstable_createStyleFunctionSx; });
$parcel$export(module.exports, "extendSxProp", function () { return (parcelRequire("bZmXB")).default; });
$parcel$export(module.exports, "unstable_defaultSxConfig", function () { return (parcelRequire("cJAMJ")).default; });

var $lqCXV = parcelRequire("lqCXV");

var $bZmXB = parcelRequire("bZmXB");

var $cJAMJ = parcelRequire("cJAMJ");

});
parcelRegister("bZmXB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ba733a40eab9683$export$2e2bcd8739ae039; });

var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");

var $d5ARM = parcelRequire("d5ARM");

var $cJAMJ = parcelRequire("cJAMJ");
const $8ba733a40eab9683$var$_excluded = [
    "sx"
];
const $8ba733a40eab9683$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $cJAMJ.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $8ba733a40eab9683$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $93aRW.default)(props, $8ba733a40eab9683$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $8ba733a40eab9683$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $d5ARM.isPlainObject)(result)) return systemProps;
        return (0, $zgVxD.default)({}, systemProps, result);
    };
    else finalSx = (0, $zgVxD.default)({}, systemProps, inSx);
    return (0, $zgVxD.default)({}, otherProps, {
        sx: finalSx
    });
}

});



parcelRegister("jyLqM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3d5fc18645c5898$export$2e2bcd8739ae039; });

var $ccfLL = parcelRequire("ccfLL");
'use client';
const $e3d5fc18645c5898$var$defaultTheme = (0, $ccfLL.default)();
var $e3d5fc18645c5898$export$2e2bcd8739ae039 = $e3d5fc18645c5898$var$defaultTheme;

});
parcelRegister("ccfLL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e12d68225a0ddaf$export$2e2bcd8739ae039; });

var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");

var $9wLPa = parcelRequire("9wLPa");

var $d5ARM = parcelRequire("d5ARM");

var $lqCXV = parcelRequire("lqCXV");
var $cJAMJ = parcelRequire("cJAMJ");

var $1BEIC = parcelRequire("1BEIC");


var $c5kxk = parcelRequire("c5kxk");

var $jJplR = parcelRequire("jJplR");

var $8fzyw = parcelRequire("8fzyw");

var $4AOx2 = parcelRequire("4AOx2");

var $cydtL = parcelRequire("cydtL");

var $37nDc = parcelRequire("37nDc");
const $8e12d68225a0ddaf$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $8e12d68225a0ddaf$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $93aRW.default)(options, $8e12d68225a0ddaf$var$_excluded);
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateCssVars` is the closest identifier for checking that the `options` is a result of `extendTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateCssVars === undefined) throw new Error((0, $9wLPa.default)(18));
    const palette = (0, $jJplR.default)(paletteInput);
    const systemTheme = (0, $1BEIC.default)(options);
    let muiTheme = (0, $d5ARM.default)(systemTheme, {
        mixins: (0, $c5kxk.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $4AOx2.default).slice(),
        typography: (0, $8fzyw.default)(palette, typographyInput),
        transitions: (0, $cydtL.default)(transitionsInput),
        zIndex: (0, $zgVxD.default)({}, (0, $37nDc.default))
    });
    muiTheme = (0, $d5ARM.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $d5ARM.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $zgVxD.default)({}, (0, $cJAMJ.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $lqCXV.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $8e12d68225a0ddaf$var$warnedOnce = false;
function $8e12d68225a0ddaf$export$c469355549431d9b(...args) {
    return $8e12d68225a0ddaf$var$createTheme(...args);
}
var $8e12d68225a0ddaf$export$2e2bcd8739ae039 = $8e12d68225a0ddaf$var$createTheme;

});
parcelRegister("c5kxk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8cc5e1cf06ff9b1c$export$2e2bcd8739ae039; });

var $zgVxD = parcelRequire("zgVxD");
function $8cc5e1cf06ff9b1c$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $zgVxD.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("jJplR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5d5e292a57a1163$export$2e2bcd8739ae039; });

var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");

var $9wLPa = parcelRequire("9wLPa");

var $d5ARM = parcelRequire("d5ARM");

var $1r55V = parcelRequire("1r55V");

var $d2WgN = parcelRequire("d2WgN");

var $6KIHn = parcelRequire("6KIHn");

var $gkbKp = parcelRequire("gkbKp");

var $1qaqc = parcelRequire("1qaqc");

var $jyozN = parcelRequire("jyozN");

var $8n3z9 = parcelRequire("8n3z9");

var $b99Cs = parcelRequire("b99Cs");

var $48BY1 = parcelRequire("48BY1");
const $e5d5e292a57a1163$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $e5d5e292a57a1163$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: 'rgba(0, 0, 0, 0.87)',
        // Secondary text.
        secondary: 'rgba(0, 0, 0, 0.6)',
        // Disabled text have even lower visual prominence.
        disabled: 'rgba(0, 0, 0, 0.38)'
    },
    // The color used to divide different elements.
    divider: 'rgba(0, 0, 0, 0.12)',
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $d2WgN.default).white,
        default: (0, $d2WgN.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: 'rgba(0, 0, 0, 0.54)',
        // The color of an hovered action.
        hover: 'rgba(0, 0, 0, 0.04)',
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: 'rgba(0, 0, 0, 0.08)',
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: 'rgba(0, 0, 0, 0.26)',
        // The background color of a disabled action.
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(0, 0, 0, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $e5d5e292a57a1163$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $d2WgN.default).white,
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)',
        icon: 'rgba(255, 255, 255, 0.5)'
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: '#121212',
        default: '#121212'
    },
    action: {
        active: (0, $d2WgN.default).white,
        hover: 'rgba(255, 255, 255, 0.08)',
        hoverOpacity: 0.08,
        selected: 'rgba(255, 255, 255, 0.16)',
        selectedOpacity: 0.16,
        disabled: 'rgba(255, 255, 255, 0.3)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(255, 255, 255, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $e5d5e292a57a1163$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $1r55V.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $1r55V.darken)(intent.main, tonalOffsetDark);
    }
}
function $e5d5e292a57a1163$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $8n3z9.default)[200],
        light: (0, $8n3z9.default)[50],
        dark: (0, $8n3z9.default)[400]
    };
    return {
        main: (0, $8n3z9.default)[700],
        light: (0, $8n3z9.default)[400],
        dark: (0, $8n3z9.default)[800]
    };
}
function $e5d5e292a57a1163$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $gkbKp.default)[200],
        light: (0, $gkbKp.default)[50],
        dark: (0, $gkbKp.default)[400]
    };
    return {
        main: (0, $gkbKp.default)[500],
        light: (0, $gkbKp.default)[300],
        dark: (0, $gkbKp.default)[700]
    };
}
function $e5d5e292a57a1163$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $1qaqc.default)[500],
        light: (0, $1qaqc.default)[300],
        dark: (0, $1qaqc.default)[700]
    };
    return {
        main: (0, $1qaqc.default)[700],
        light: (0, $1qaqc.default)[400],
        dark: (0, $1qaqc.default)[800]
    };
}
function $e5d5e292a57a1163$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $b99Cs.default)[400],
        light: (0, $b99Cs.default)[300],
        dark: (0, $b99Cs.default)[700]
    };
    return {
        main: (0, $b99Cs.default)[700],
        light: (0, $b99Cs.default)[500],
        dark: (0, $b99Cs.default)[900]
    };
}
function $e5d5e292a57a1163$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $48BY1.default)[400],
        light: (0, $48BY1.default)[300],
        dark: (0, $48BY1.default)[700]
    };
    return {
        main: (0, $48BY1.default)[800],
        light: (0, $48BY1.default)[500],
        dark: (0, $48BY1.default)[900]
    };
}
function $e5d5e292a57a1163$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $jyozN.default)[400],
        light: (0, $jyozN.default)[300],
        dark: (0, $jyozN.default)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $jyozN.default)[500],
        dark: (0, $jyozN.default)[900]
    };
}
function $e5d5e292a57a1163$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $93aRW.default)(palette, $e5d5e292a57a1163$var$_excluded);
    const primary = palette.primary || $e5d5e292a57a1163$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $e5d5e292a57a1163$var$getDefaultSecondary(mode);
    const error = palette.error || $e5d5e292a57a1163$var$getDefaultError(mode);
    const info = palette.info || $e5d5e292a57a1163$var$getDefaultInfo(mode);
    const success = palette.success || $e5d5e292a57a1163$var$getDefaultSuccess(mode);
    const warning = palette.warning || $e5d5e292a57a1163$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $1r55V.getContrastRatio)(background, $e5d5e292a57a1163$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $e5d5e292a57a1163$export$55ce6f3a06c59543.text.primary : $e5d5e292a57a1163$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $zgVxD.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $9wLPa.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $9wLPa.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        $e5d5e292a57a1163$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $e5d5e292a57a1163$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $e5d5e292a57a1163$export$55ce6f3a06c59543,
        light: $e5d5e292a57a1163$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $d5ARM.default)((0, $zgVxD.default)({
        // A collection of common colors.
        common: (0, $zgVxD.default)({}, (0, $d2WgN.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $6KIHn.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("1r55V", function(module, exports) {
"use strict";

var $bcBLN = parcelRequire("bcBLN");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alpha = $10bc43beb58484af$var$alpha;
module.exports.blend = $10bc43beb58484af$var$blend;
module.exports.colorChannel = void 0;
module.exports.darken = $10bc43beb58484af$var$darken;
module.exports.decomposeColor = $10bc43beb58484af$var$decomposeColor;
module.exports.emphasize = $10bc43beb58484af$var$emphasize;
module.exports.getContrastRatio = $10bc43beb58484af$var$getContrastRatio;
module.exports.getLuminance = $10bc43beb58484af$var$getLuminance;
module.exports.hexToRgb = $10bc43beb58484af$var$hexToRgb;
module.exports.hslToRgb = $10bc43beb58484af$var$hslToRgb;
module.exports.lighten = $10bc43beb58484af$var$lighten;
module.exports.private_safeAlpha = $10bc43beb58484af$var$private_safeAlpha;
module.exports.private_safeColorChannel = void 0;
module.exports.private_safeDarken = $10bc43beb58484af$var$private_safeDarken;
module.exports.private_safeEmphasize = $10bc43beb58484af$var$private_safeEmphasize;
module.exports.private_safeLighten = $10bc43beb58484af$var$private_safeLighten;
module.exports.recomposeColor = $10bc43beb58484af$var$recomposeColor;
module.exports.rgbToHex = $10bc43beb58484af$var$rgbToHex;

var $10bc43beb58484af$var$_formatMuiErrorMessage2 = $bcBLN((parcelRequire("1B12F")));

var $10bc43beb58484af$var$_clamp = $bcBLN((parcelRequire("iGd1v")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $10bc43beb58484af$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $10bc43beb58484af$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $10bc43beb58484af$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $10bc43beb58484af$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $10bc43beb58484af$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $10bc43beb58484af$var$decomposeColor($10bc43beb58484af$var$hexToRgb(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error((0, $10bc43beb58484af$var$_formatMuiErrorMessage2.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error((0, $10bc43beb58484af$var$_formatMuiErrorMessage2.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $10bc43beb58484af$var$colorChannel = (color)=>{
    const decomposedColor = $10bc43beb58484af$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
module.exports.colorChannel = $10bc43beb58484af$var$colorChannel;
const $10bc43beb58484af$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $10bc43beb58484af$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ module.exports.private_safeColorChannel = $10bc43beb58484af$var$private_safeColorChannel;
function $10bc43beb58484af$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $10bc43beb58484af$var$rgbToHex(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values: values } = $10bc43beb58484af$var$decomposeColor(color);
    return `#${values.map((n, i)=>$10bc43beb58484af$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $10bc43beb58484af$var$hslToRgb(color) {
    color = $10bc43beb58484af$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $10bc43beb58484af$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $10bc43beb58484af$var$getLuminance(color) {
    color = $10bc43beb58484af$var$decomposeColor(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $10bc43beb58484af$var$decomposeColor($10bc43beb58484af$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $10bc43beb58484af$var$getContrastRatio(foreground, background) {
    const lumA = $10bc43beb58484af$var$getLuminance(foreground);
    const lumB = $10bc43beb58484af$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $10bc43beb58484af$var$alpha(color, value) {
    color = $10bc43beb58484af$var$decomposeColor(color);
    value = $10bc43beb58484af$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $10bc43beb58484af$var$recomposeColor(color);
}
function $10bc43beb58484af$var$private_safeAlpha(color, value, warning) {
    try {
        return $10bc43beb58484af$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $10bc43beb58484af$var$darken(color, coefficient) {
    color = $10bc43beb58484af$var$decomposeColor(color);
    coefficient = $10bc43beb58484af$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $10bc43beb58484af$var$recomposeColor(color);
}
function $10bc43beb58484af$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $10bc43beb58484af$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $10bc43beb58484af$var$lighten(color, coefficient) {
    color = $10bc43beb58484af$var$decomposeColor(color);
    coefficient = $10bc43beb58484af$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $10bc43beb58484af$var$recomposeColor(color);
}
function $10bc43beb58484af$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $10bc43beb58484af$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $10bc43beb58484af$var$emphasize(color, coefficient = 0.15) {
    return $10bc43beb58484af$var$getLuminance(color) > 0.5 ? $10bc43beb58484af$var$darken(color, coefficient) : $10bc43beb58484af$var$lighten(color, coefficient);
}
function $10bc43beb58484af$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $10bc43beb58484af$var$emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $10bc43beb58484af$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $10bc43beb58484af$var$decomposeColor(background);
    const overlayColor = $10bc43beb58484af$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $10bc43beb58484af$var$recomposeColor({
        type: 'rgb',
        values: rgb
    });
}

});
parcelRegister("1B12F", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("9wLPa")).default; });

var $9wLPa = parcelRequire("9wLPa");

});

parcelRegister("iGd1v", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("fjFws")).default; });

var $fjFws = parcelRequire("fjFws");

});
parcelRegister("fjFws", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b268d6d8909daddb$export$2e2bcd8739ae039; });
function $b268d6d8909daddb$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $b268d6d8909daddb$export$2e2bcd8739ae039 = $b268d6d8909daddb$var$clamp;

});



parcelRegister("d2WgN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97f8a96e44ad4913$export$2e2bcd8739ae039; });
const $97f8a96e44ad4913$var$common = {
    black: '#000',
    white: '#fff'
};
var $97f8a96e44ad4913$export$2e2bcd8739ae039 = $97f8a96e44ad4913$var$common;

});

parcelRegister("6KIHn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ea9b62e9cfb1881$export$2e2bcd8739ae039; });
const $4ea9b62e9cfb1881$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $4ea9b62e9cfb1881$export$2e2bcd8739ae039 = $4ea9b62e9cfb1881$var$grey;

});

parcelRegister("gkbKp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be27a0645fc94d0c$export$2e2bcd8739ae039; });
const $be27a0645fc94d0c$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $be27a0645fc94d0c$export$2e2bcd8739ae039 = $be27a0645fc94d0c$var$purple;

});

parcelRegister("1qaqc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10904daa6210a589$export$2e2bcd8739ae039; });
const $10904daa6210a589$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $10904daa6210a589$export$2e2bcd8739ae039 = $10904daa6210a589$var$red;

});

parcelRegister("jyozN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3c441aa1ec495fe$export$2e2bcd8739ae039; });
const $e3c441aa1ec495fe$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $e3c441aa1ec495fe$export$2e2bcd8739ae039 = $e3c441aa1ec495fe$var$orange;

});

parcelRegister("8n3z9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61833cd1ad53102a$export$2e2bcd8739ae039; });
const $61833cd1ad53102a$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $61833cd1ad53102a$export$2e2bcd8739ae039 = $61833cd1ad53102a$var$blue;

});

parcelRegister("b99Cs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81d7ff2ad17378b5$export$2e2bcd8739ae039; });
const $81d7ff2ad17378b5$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $81d7ff2ad17378b5$export$2e2bcd8739ae039 = $81d7ff2ad17378b5$var$lightBlue;

});

parcelRegister("48BY1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30355c4153f69151$export$2e2bcd8739ae039; });
const $30355c4153f69151$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $30355c4153f69151$export$2e2bcd8739ae039 = $30355c4153f69151$var$green;

});


parcelRegister("8fzyw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $601b4e1a73c5b937$export$2e2bcd8739ae039; });

var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");

var $d5ARM = parcelRequire("d5ARM");
const $601b4e1a73c5b937$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $601b4e1a73c5b937$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $601b4e1a73c5b937$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $601b4e1a73c5b937$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $601b4e1a73c5b937$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === 'function' ? typography(palette) : typography, { fontFamily: fontFamily = $601b4e1a73c5b937$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $93aRW.default)(_ref, $601b4e1a73c5b937$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $zgVxD.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $601b4e1a73c5b937$var$defaultFontFamily ? {
            letterSpacing: `${$601b4e1a73c5b937$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $601b4e1a73c5b937$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $601b4e1a73c5b937$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $d5ARM.default)((0, $zgVxD.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("4AOx2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3581b8ce3a43c60f$export$2e2bcd8739ae039; });
const $3581b8ce3a43c60f$var$shadowKeyUmbraOpacity = 0.2;
const $3581b8ce3a43c60f$var$shadowKeyPenumbraOpacity = 0.14;
const $3581b8ce3a43c60f$var$shadowAmbientShadowOpacity = 0.12;
function $3581b8ce3a43c60f$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$3581b8ce3a43c60f$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$3581b8ce3a43c60f$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$3581b8ce3a43c60f$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $3581b8ce3a43c60f$var$shadows = [
    'none',
    $3581b8ce3a43c60f$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $3581b8ce3a43c60f$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $3581b8ce3a43c60f$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $3581b8ce3a43c60f$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $3581b8ce3a43c60f$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $3581b8ce3a43c60f$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $3581b8ce3a43c60f$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $3581b8ce3a43c60f$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $3581b8ce3a43c60f$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $3581b8ce3a43c60f$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $3581b8ce3a43c60f$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $3581b8ce3a43c60f$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $3581b8ce3a43c60f$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $3581b8ce3a43c60f$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $3581b8ce3a43c60f$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $3581b8ce3a43c60f$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $3581b8ce3a43c60f$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $3581b8ce3a43c60f$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $3581b8ce3a43c60f$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $3581b8ce3a43c60f$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $3581b8ce3a43c60f$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $3581b8ce3a43c60f$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $3581b8ce3a43c60f$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $3581b8ce3a43c60f$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $3581b8ce3a43c60f$export$2e2bcd8739ae039 = $3581b8ce3a43c60f$var$shadows;

});

parcelRegister("cydtL", function(module, exports) {

$parcel$export(module.exports, "duration", function () { return $92331daa4df37070$export$1f34108aa9eb96ab; });
$parcel$export(module.exports, "default", function () { return $92331daa4df37070$export$2e2bcd8739ae039; });

var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");
const $92331daa4df37070$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $92331daa4df37070$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $92331daa4df37070$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $92331daa4df37070$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $92331daa4df37070$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $92331daa4df37070$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $zgVxD.default)({}, $92331daa4df37070$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $zgVxD.default)({}, $92331daa4df37070$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $93aRW.default)(options, $92331daa4df37070$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $92331daa4df37070$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $92331daa4df37070$var$formatMs(delay)}`).join(',');
    };
    return (0, $zgVxD.default)({
        getAutoHeightDuration: $92331daa4df37070$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("37nDc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24545b32aa7fb5f1$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $24545b32aa7fb5f1$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $24545b32aa7fb5f1$export$2e2bcd8739ae039 = $24545b32aa7fb5f1$var$zIndex;

});



parcelRegister("ab2pD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $768ccd86c830417b$export$2e2bcd8739ae039; });
var $768ccd86c830417b$export$2e2bcd8739ae039 = '$$material';

});

parcelRegister("awHZI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a9f04e59d44d610$export$2e2bcd8739ae039; });

var $jZXCu = parcelRequire("jZXCu");
const $7a9f04e59d44d610$var$rootShouldForwardProp = (prop)=>(0, $jZXCu.default)(prop) && prop !== 'classes';
var $7a9f04e59d44d610$export$2e2bcd8739ae039 = $7a9f04e59d44d610$var$rootShouldForwardProp;

});
parcelRegister("jZXCu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8f1f611528cf94a$export$2e2bcd8739ae039; });
// copied from @mui/system/createStyled
function $e8f1f611528cf94a$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $e8f1f611528cf94a$export$2e2bcd8739ae039 = $e8f1f611528cf94a$var$slotShouldForwardProp;

});



parcelRegister("2Eek4", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", function () { return $1eda6d6079ab0f44$export$c7c50641356bdfa5; });

var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $1eda6d6079ab0f44$export$c7c50641356bdfa5(slot) {
    return (0, $jP65K.default)('MuiSvgIcon', slot);
}
const $1eda6d6079ab0f44$var$svgIconClasses = (0, $cOYaX.default)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $1eda6d6079ab0f44$export$2e2bcd8739ae039 = $1eda6d6079ab0f44$var$svgIconClasses;

});
parcelRegister("cOYaX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9558d5360d6fd7ee$export$2e2bcd8739ae039; });

var $jP65K = parcelRequire("jP65K");
function $9558d5360d6fd7ee$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $jP65K.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("jP65K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6e7816e249fc51c$export$2e2bcd8739ae039; });

var $9Wg9x = parcelRequire("9Wg9x");
const $e6e7816e249fc51c$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $e6e7816e249fc51c$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $e6e7816e249fc51c$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $9Wg9x.default).generate(componentName)}-${slot}`;
}
function $e6e7816e249fc51c$export$34c0130b1f3e8ae3(slot) {
    return $e6e7816e249fc51c$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("9Wg9x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73c60f70fe2ede86$export$2e2bcd8739ae039; });
const $73c60f70fe2ede86$var$defaultGenerator = (componentName)=>componentName;
const $73c60f70fe2ede86$var$createClassNameGenerator = ()=>{
    let generate = $73c60f70fe2ede86$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $73c60f70fe2ede86$var$defaultGenerator;
        }
    };
};
const $73c60f70fe2ede86$var$ClassNameGenerator = $73c60f70fe2ede86$var$createClassNameGenerator();
var $73c60f70fe2ede86$export$2e2bcd8739ae039 = $73c60f70fe2ede86$var$ClassNameGenerator;

});







parcelRegister("7uBZg", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $2C7wN = parcelRequire("2C7wN");
function $5748cd33616574f3$var$emptyFunction() {}
function $5748cd33616574f3$var$emptyFunctionWithReset() {}
$5748cd33616574f3$var$emptyFunctionWithReset.resetWarningCache = $5748cd33616574f3$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $2C7wN) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $5748cd33616574f3$var$emptyFunctionWithReset,
        resetWarningCache: $5748cd33616574f3$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("2C7wN", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $1e74f84c21ada14c$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $1e74f84c21ada14c$var$ReactPropTypesSecret;

});


parcelRegister("f1BG0", function(module, exports) {

module.exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "logo-light.df1bd14c.svg";

});

parcelRegister("2ATL3", function(module, exports) {

module.exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "rocket-logo.af3c998e.svg";

});

parcelRegister("h3Dbm", function(module, exports) {

module.exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "navbar-profile.876c9cb4.svg";

});

parcelRegister("eMfMQ", function(module, exports) {

module.exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "logo-dark.68c3823e.svg";

});

parcelRegister("1G3w8", function(module, exports) {

module.exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "logo-dark-small.1a2a9d82.svg";

});

parcelRegister("1wv3p", function(module, exports) {

module.exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "facebook.083eecc3.svg";

});

parcelRegister("d8mEN", function(module, exports) {

module.exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "twitter.b8b54306.svg";

});

parcelRegister("hGbt5", function(module, exports) {

module.exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "footer-linkedin.56e84146.svg";

});

parcelRegister("8DHux", function(module, exports) {

module.exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "white-bg-template.fe3b3c87.png";

});

parcelRegister("gOCEf", function(module, exports) {

module.exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "expand.e615d568.svg";

});

parcelRegister("4C3P5", function(module, exports) {

module.exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "no-website.fffbae5b.svg";

});

parcelRegister("czwuE", function(module, exports) {

module.exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "site-setting.e5143146.svg";

});

parcelRegister("jzVBy", function(module, exports) {

module.exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "extra-option.a28af855.svg";

});

parcelRegister("3DtD5", function(module, exports) {

module.exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "bg-img.fec22d75.svg";

});

parcelRegister("9IpHO", function(module, exports) {

module.exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "rocketpages-logo.e311c3bc.svg";

});

parcelRegister("bUg1X", function(module, exports) {

module.exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "header-illustration-light.37da4125.svg";

});

parcelRegister("4RZke", function(module, exports) {

module.exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "hero-media-illustration-light.c5bde580.svg";

});

parcelRegister("fRZd1", function(module, exports) {

module.exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "hero-media-light.f6bb078c.svg";

});

parcelRegister("7dcuj", function(module, exports) {

module.exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "hero-media-dark.761b0542.svg";

});

parcelRegister("cU9P7", function(module, exports) {

module.exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "rocketpages-logo-light.738f3460.svg";

});

parcelRegister("dxgjV", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});

parcelRegister("ckAAE", function(module, exports) {
/**
 * Copyright (c) 2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule normalizeWheel
 * @typechecks
 */ 'use strict';

var $lWq0I = parcelRequire("lWq0I");

var $2Cdh3 = parcelRequire("2Cdh3");
// Reasonable defaults
var $8fa3bc5b263db062$var$PIXEL_STEP = 10;
var $8fa3bc5b263db062$var$LINE_HEIGHT = 40;
var $8fa3bc5b263db062$var$PAGE_HEIGHT = 800;
/**
 * Mouse wheel (and 2-finger trackpad) support on the web sucks.  It is
 * complicated, thus this doc is long and (hopefully) detailed enough to answer
 * your questions.
 *
 * If you need to react to the mouse wheel in a predictable way, this code is
 * like your bestest friend. * hugs *
 *
 * As of today, there are 4 DOM event types you can listen to:
 *
 *   'wheel'                -- Chrome(31+), FF(17+), IE(9+)
 *   'mousewheel'           -- Chrome, IE(6+), Opera, Safari
 *   'MozMousePixelScroll'  -- FF(3.5 only!) (2010-2013) -- don't bother!
 *   'DOMMouseScroll'       -- FF(0.9.7+) since 2003
 *
 * So what to do?  The is the best:
 *
 *   normalizeWheel.getEventType();
 *
 * In your event callback, use this code to get sane interpretation of the
 * deltas.  This code will return an object with properties:
 *
 *   spinX   -- normalized spin speed (use for zoom) - x plane
 *   spinY   -- " - y plane
 *   pixelX  -- normalized distance (to pixels) - x plane
 *   pixelY  -- " - y plane
 *
 * Wheel values are provided by the browser assuming you are using the wheel to
 * scroll a web page by a number of lines or pixels (or pages).  Values can vary
 * significantly on different platforms and browsers, forgetting that you can
 * scroll at different speeds.  Some devices (like trackpads) emit more events
 * at smaller increments with fine granularity, and some emit massive jumps with
 * linear speed or acceleration.
 *
 * This code does its best to normalize the deltas for you:
 *
 *   - spin is trying to normalize how far the wheel was spun (or trackpad
 *     dragged).  This is super useful for zoom support where you want to
 *     throw away the chunky scroll steps on the PC and make those equal to
 *     the slow and smooth tiny steps on the Mac. Key data: This code tries to
 *     resolve a single slow step on a wheel to 1.
 *
 *   - pixel is normalizing the desired scroll delta in pixel units.  You'll
 *     get the crazy differences between browsers, but at least it'll be in
 *     pixels!
 *
 *   - positive value indicates scrolling DOWN/RIGHT, negative UP/LEFT.  This
 *     should translate to positive value zooming IN, negative zooming OUT.
 *     This matches the newer 'wheel' event.
 *
 * Why are there spinX, spinY (or pixels)?
 *
 *   - spinX is a 2-finger side drag on the trackpad, and a shift + wheel turn
 *     with a mouse.  It results in side-scrolling in the browser by default.
 *
 *   - spinY is what you expect -- it's the classic axis of a mouse wheel.
 *
 *   - I dropped spinZ/pixelZ.  It is supported by the DOM 3 'wheel' event and
 *     probably is by browsers in conjunction with fancy 3D controllers .. but
 *     you know.
 *
 * Implementation info:
 *
 * Examples of 'wheel' event if you scroll slowly (down) by one step with an
 * average mouse:
 *
 *   OS X + Chrome  (mouse)     -    4   pixel delta  (wheelDelta -120)
 *   OS X + Safari  (mouse)     -  N/A   pixel delta  (wheelDelta  -12)
 *   OS X + Firefox (mouse)     -    0.1 line  delta  (wheelDelta  N/A)
 *   Win8 + Chrome  (mouse)     -  100   pixel delta  (wheelDelta -120)
 *   Win8 + Firefox (mouse)     -    3   line  delta  (wheelDelta -120)
 *
 * On the trackpad:
 *
 *   OS X + Chrome  (trackpad)  -    2   pixel delta  (wheelDelta   -6)
 *   OS X + Firefox (trackpad)  -    1   pixel delta  (wheelDelta  N/A)
 *
 * On other/older browsers.. it's more complicated as there can be multiple and
 * also missing delta values.
 *
 * The 'wheel' event is more standard:
 *
 * http://www.w3.org/TR/DOM-Level-3-Events/#events-wheelevents
 *
 * The basics is that it includes a unit, deltaMode (pixels, lines, pages), and
 * deltaX, deltaY and deltaZ.  Some browsers provide other values to maintain
 * backward compatibility with older events.  Those other values help us
 * better normalize spin speed.  Example of what the browsers provide:
 *
 *                          | event.wheelDelta | event.detail
 *        ------------------+------------------+--------------
 *          Safari v5/OS X  |       -120       |       0
 *          Safari v5/Win7  |       -120       |       0
 *         Chrome v17/OS X  |       -120       |       0
 *         Chrome v17/Win7  |       -120       |       0
 *                IE9/Win7  |       -120       |   undefined
 *         Firefox v4/OS X  |     undefined    |       1
 *         Firefox v4/Win7  |     undefined    |       3
 *
 */ function $8fa3bc5b263db062$var$normalizeWheel(/*object*/ event) /*object*/ {
    var sX = 0, sY = 0, pX = 0, pY = 0; // pixelX, pixelY
    // Legacy
    if ('detail' in event) sY = event.detail;
    if ('wheelDelta' in event) sY = -event.wheelDelta / 120;
    if ('wheelDeltaY' in event) sY = -event.wheelDeltaY / 120;
    if ('wheelDeltaX' in event) sX = -event.wheelDeltaX / 120;
    // side scrolling on FF with DOMMouseScroll
    if ('axis' in event && event.axis === event.HORIZONTAL_AXIS) {
        sX = sY;
        sY = 0;
    }
    pX = sX * $8fa3bc5b263db062$var$PIXEL_STEP;
    pY = sY * $8fa3bc5b263db062$var$PIXEL_STEP;
    if ('deltaY' in event) pY = event.deltaY;
    if ('deltaX' in event) pX = event.deltaX;
    if ((pX || pY) && event.deltaMode) {
        if (event.deltaMode == 1) {
            pX *= $8fa3bc5b263db062$var$LINE_HEIGHT;
            pY *= $8fa3bc5b263db062$var$LINE_HEIGHT;
        } else {
            pX *= $8fa3bc5b263db062$var$PAGE_HEIGHT;
            pY *= $8fa3bc5b263db062$var$PAGE_HEIGHT;
        }
    }
    // Fall-back if spin cannot be determined
    if (pX && !sX) sX = pX < 1 ? -1 : 1;
    if (pY && !sY) sY = pY < 1 ? -1 : 1;
    return {
        spinX: sX,
        spinY: sY,
        pixelX: pX,
        pixelY: pY
    };
}
/**
 * The best combination if you prefer spinX + spinY normalization.  It favors
 * the older DOMMouseScroll for Firefox, as FF does not include wheelDelta with
 * 'wheel' event, making spin speed determination impossible.
 */ $8fa3bc5b263db062$var$normalizeWheel.getEventType = function() /*string*/ {
    return $lWq0I.firefox() ? 'DOMMouseScroll' : $2Cdh3('wheel') ? 'wheel' : 'mousewheel';
};
module.exports = $8fa3bc5b263db062$var$normalizeWheel;

});
parcelRegister("lWq0I", function(module, exports) {
/**
 * Copyright 2004-present Facebook. All Rights Reserved.
 *
 * @providesModule UserAgent_DEPRECATED
 */ /**
 *  Provides entirely client-side User Agent and OS detection. You should prefer
 *  the non-deprecated UserAgent module when possible, which exposes our
 *  authoritative server-side PHP-based detection to the client.
 *
 *  Usage is straightforward:
 *
 *    if (UserAgent_DEPRECATED.ie()) {
 *      //  IE
 *    }
 *
 *  You can also do version checks:
 *
 *    if (UserAgent_DEPRECATED.ie() >= 7) {
 *      //  IE7 or better
 *    }
 *
 *  The browser functions will return NaN if the browser does not match, so
 *  you can also do version compares the other way:
 *
 *    if (UserAgent_DEPRECATED.ie() < 7) {
 *      //  IE6 or worse
 *    }
 *
 *  Note that the version is a float and may include a minor version number,
 *  so you should always use range operators to perform comparisons, not
 *  strict equality.
 *
 *  **Note:** You should **strongly** prefer capability detection to browser
 *  version detection where it's reasonable:
 *
 *    http://www.quirksmode.org/js/support.html
 *
 *  Further, we have a large number of mature wrapper functions and classes
 *  which abstract away many browser irregularities. Check the documentation,
 *  grep for things, or ask on javascript@lists.facebook.com before writing yet
 *  another copy of "event || window.event".
 *
 */ var $041f46fb66f93b71$var$_populated = false;
// Browsers
var $041f46fb66f93b71$var$_ie, $041f46fb66f93b71$var$_firefox, $041f46fb66f93b71$var$_opera, $041f46fb66f93b71$var$_webkit, $041f46fb66f93b71$var$_chrome;
// Actual IE browser for compatibility mode
var $041f46fb66f93b71$var$_ie_real_version;
// Platforms
var $041f46fb66f93b71$var$_osx, $041f46fb66f93b71$var$_windows, $041f46fb66f93b71$var$_linux, $041f46fb66f93b71$var$_android;
// Architectures
var $041f46fb66f93b71$var$_win64;
// Devices
var $041f46fb66f93b71$var$_iphone, $041f46fb66f93b71$var$_ipad, $041f46fb66f93b71$var$_native;
var $041f46fb66f93b71$var$_mobile;
function $041f46fb66f93b71$var$_populate() {
    if ($041f46fb66f93b71$var$_populated) return;
    $041f46fb66f93b71$var$_populated = true;
    // To work around buggy JS libraries that can't handle multi-digit
    // version numbers, Opera 10's user agent string claims it's Opera
    // 9, then later includes a Version/X.Y field:
    //
    // Opera/9.80 (foo) Presto/2.2.15 Version/10.10
    var uas = navigator.userAgent;
    var agent = /(?:MSIE.(\d+\.\d+))|(?:(?:Firefox|GranParadiso|Iceweasel).(\d+\.\d+))|(?:Opera(?:.+Version.|.)(\d+\.\d+))|(?:AppleWebKit.(\d+(?:\.\d+)?))|(?:Trident\/\d+\.\d+.*rv:(\d+\.\d+))/.exec(uas);
    var os = /(Mac OS X)|(Windows)|(Linux)/.exec(uas);
    $041f46fb66f93b71$var$_iphone = /\b(iPhone|iP[ao]d)/.exec(uas);
    $041f46fb66f93b71$var$_ipad = /\b(iP[ao]d)/.exec(uas);
    $041f46fb66f93b71$var$_android = /Android/i.exec(uas);
    $041f46fb66f93b71$var$_native = /FBAN\/\w+;/i.exec(uas);
    $041f46fb66f93b71$var$_mobile = /Mobile/i.exec(uas);
    // Note that the IE team blog would have you believe you should be checking
    // for 'Win64; x64'.  But MSDN then reveals that you can actually be coming
    // from either x64 or ia64;  so ultimately, you should just check for Win64
    // as in indicator of whether you're in 64-bit IE.  32-bit IE on 64-bit
    // Windows will send 'WOW64' instead.
    $041f46fb66f93b71$var$_win64 = !!/Win64/.exec(uas);
    if (agent) {
        $041f46fb66f93b71$var$_ie = agent[1] ? parseFloat(agent[1]) : agent[5] ? parseFloat(agent[5]) : NaN;
        // IE compatibility mode
        if ($041f46fb66f93b71$var$_ie && document && document.documentMode) $041f46fb66f93b71$var$_ie = document.documentMode;
        // grab the "true" ie version from the trident token if available
        var trident = /(?:Trident\/(\d+.\d+))/.exec(uas);
        $041f46fb66f93b71$var$_ie_real_version = trident ? parseFloat(trident[1]) + 4 : $041f46fb66f93b71$var$_ie;
        $041f46fb66f93b71$var$_firefox = agent[2] ? parseFloat(agent[2]) : NaN;
        $041f46fb66f93b71$var$_opera = agent[3] ? parseFloat(agent[3]) : NaN;
        $041f46fb66f93b71$var$_webkit = agent[4] ? parseFloat(agent[4]) : NaN;
        if ($041f46fb66f93b71$var$_webkit) {
            // We do not add the regexp to the above test, because it will always
            // match 'safari' only since 'AppleWebKit' appears before 'Chrome' in
            // the userAgent string.
            agent = /(?:Chrome\/(\d+\.\d+))/.exec(uas);
            $041f46fb66f93b71$var$_chrome = agent && agent[1] ? parseFloat(agent[1]) : NaN;
        } else $041f46fb66f93b71$var$_chrome = NaN;
    } else $041f46fb66f93b71$var$_ie = $041f46fb66f93b71$var$_firefox = $041f46fb66f93b71$var$_opera = $041f46fb66f93b71$var$_chrome = $041f46fb66f93b71$var$_webkit = NaN;
    if (os) {
        if (os[1]) {
            // Detect OS X version.  If no version number matches, set _osx to true.
            // Version examples:  10, 10_6_1, 10.7
            // Parses version number as a float, taking only first two sets of
            // digits.  If only one set of digits is found, returns just the major
            // version number.
            var ver = /(?:Mac OS X (\d+(?:[._]\d+)?))/.exec(uas);
            $041f46fb66f93b71$var$_osx = ver ? parseFloat(ver[1].replace('_', '.')) : true;
        } else $041f46fb66f93b71$var$_osx = false;
        $041f46fb66f93b71$var$_windows = !!os[2];
        $041f46fb66f93b71$var$_linux = !!os[3];
    } else $041f46fb66f93b71$var$_osx = $041f46fb66f93b71$var$_windows = $041f46fb66f93b71$var$_linux = false;
}
var $041f46fb66f93b71$var$UserAgent_DEPRECATED = {
    /**
   *  Check if the UA is Internet Explorer.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */ ie: function() {
        return $041f46fb66f93b71$var$_populate() || $041f46fb66f93b71$var$_ie;
    },
    /**
   * Check if we're in Internet Explorer compatibility mode.
   *
   * @return bool true if in compatibility mode, false if
   * not compatibility mode or not ie
   */ ieCompatibilityMode: function() {
        return $041f46fb66f93b71$var$_populate() || $041f46fb66f93b71$var$_ie_real_version > $041f46fb66f93b71$var$_ie;
    },
    /**
   * Whether the browser is 64-bit IE.  Really, this is kind of weak sauce;  we
   * only need this because Skype can't handle 64-bit IE yet.  We need to remove
   * this when we don't need it -- tracked by #601957.
   */ ie64: function() {
        return $041f46fb66f93b71$var$UserAgent_DEPRECATED.ie() && $041f46fb66f93b71$var$_win64;
    },
    /**
   *  Check if the UA is Firefox.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */ firefox: function() {
        return $041f46fb66f93b71$var$_populate() || $041f46fb66f93b71$var$_firefox;
    },
    /**
   *  Check if the UA is Opera.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */ opera: function() {
        return $041f46fb66f93b71$var$_populate() || $041f46fb66f93b71$var$_opera;
    },
    /**
   *  Check if the UA is WebKit.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */ webkit: function() {
        return $041f46fb66f93b71$var$_populate() || $041f46fb66f93b71$var$_webkit;
    },
    /**
   *  For Push
   *  WILL BE REMOVED VERY SOON. Use UserAgent_DEPRECATED.webkit
   */ safari: function() {
        return $041f46fb66f93b71$var$UserAgent_DEPRECATED.webkit();
    },
    /**
   *  Check if the UA is a Chrome browser.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */ chrome: function() {
        return $041f46fb66f93b71$var$_populate() || $041f46fb66f93b71$var$_chrome;
    },
    /**
   *  Check if the user is running Windows.
   *
   *  @return bool `true' if the user's OS is Windows.
   */ windows: function() {
        return $041f46fb66f93b71$var$_populate() || $041f46fb66f93b71$var$_windows;
    },
    /**
   *  Check if the user is running Mac OS X.
   *
   *  @return float|bool   Returns a float if a version number is detected,
   *                       otherwise true/false.
   */ osx: function() {
        return $041f46fb66f93b71$var$_populate() || $041f46fb66f93b71$var$_osx;
    },
    /**
   * Check if the user is running Linux.
   *
   * @return bool `true' if the user's OS is some flavor of Linux.
   */ linux: function() {
        return $041f46fb66f93b71$var$_populate() || $041f46fb66f93b71$var$_linux;
    },
    /**
   * Check if the user is running on an iPhone or iPod platform.
   *
   * @return bool `true' if the user is running some flavor of the
   *    iPhone OS.
   */ iphone: function() {
        return $041f46fb66f93b71$var$_populate() || $041f46fb66f93b71$var$_iphone;
    },
    mobile: function() {
        return $041f46fb66f93b71$var$_populate() || $041f46fb66f93b71$var$_iphone || $041f46fb66f93b71$var$_ipad || $041f46fb66f93b71$var$_android || $041f46fb66f93b71$var$_mobile;
    },
    nativeApp: function() {
        // webviews inside of the native apps
        return $041f46fb66f93b71$var$_populate() || $041f46fb66f93b71$var$_native;
    },
    android: function() {
        return $041f46fb66f93b71$var$_populate() || $041f46fb66f93b71$var$_android;
    },
    ipad: function() {
        return $041f46fb66f93b71$var$_populate() || $041f46fb66f93b71$var$_ipad;
    }
};
module.exports = $041f46fb66f93b71$var$UserAgent_DEPRECATED;

});

parcelRegister("2Cdh3", function(module, exports) {
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isEventSupported
 */ 'use strict';

var $hWJnL = parcelRequire("hWJnL");
var $1e796d5766f38485$var$useHasFeature;
if ($hWJnL.canUseDOM) $1e796d5766f38485$var$useHasFeature = document.implementation && document.implementation.hasFeature && // always returns true in newer browsers as per the standard.
// @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
document.implementation.hasFeature('', '') !== true;
/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */ function $1e796d5766f38485$var$isEventSupported(eventNameSuffix, capture) {
    if (!$hWJnL.canUseDOM || capture && !('addEventListener' in document)) return false;
    var eventName = 'on' + eventNameSuffix;
    var isSupported = eventName in document;
    if (!isSupported) {
        var element = document.createElement('div');
        element.setAttribute(eventName, 'return;');
        isSupported = typeof element[eventName] === 'function';
    }
    if (!isSupported && $1e796d5766f38485$var$useHasFeature && eventNameSuffix === 'wheel') // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
    return isSupported;
}
module.exports = $1e796d5766f38485$var$isEventSupported;

});
parcelRegister("hWJnL", function(module, exports) {
/**
 * Copyright (c) 2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ExecutionEnvironment
 */ /*jslint evil: true */ 'use strict';
var $d10b0e6fbc5948d5$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */ var $d10b0e6fbc5948d5$var$ExecutionEnvironment = {
    canUseDOM: $d10b0e6fbc5948d5$var$canUseDOM,
    canUseWorkers: typeof Worker !== 'undefined',
    canUseEventListeners: $d10b0e6fbc5948d5$var$canUseDOM && !!(window.addEventListener || window.attachEvent),
    canUseViewport: $d10b0e6fbc5948d5$var$canUseDOM && !!window.screen,
    isInWorker: !$d10b0e6fbc5948d5$var$canUseDOM // For now, this is true - might change in the future.
};
module.exports = $d10b0e6fbc5948d5$var$ExecutionEnvironment;

});



parcelRegister("j3cWe", function(module, exports) {

module.exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "rotate-left_.a95436b5.svg";

});

parcelRegister("4RWRe", function(module, exports) {

module.exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "rotate-right.8d3c0cd9.svg";

});

parcelRegister("4INSM", function(module, exports) {

module.exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "flip_right.7d85f9d5.svg";

});

parcelRegister("hKl5P", function(module, exports) {

module.exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "flip_left.039efc05.svg";

});

parcelRegister("inEQW", function(module, exports) {

module.exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "google.cac6ba5e.svg";

});

parcelRegister("gl0e6", function(module, exports) {

module.exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "linkedin.e1fd5c1e.svg";

});

parcelRegister("6ssOa", function(module, exports) {

module.exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "check-icon.5885a3fd.svg";

});

parcelRegister("iAm4v", function(module, exports) {

module.exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "edit.0145d912.svg";

});

parcelRegister("4o8JF", function(module, exports) {

module.exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "delete.d174d7e5.svg";

});

parcelRegister("53tPM", function(module, exports) {

module.exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "no-image.843e7ae4.svg";

});

parcelRegister("dYuXF", function(module, exports) {

module.exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "close.3467343a.svg";

});

parcelRegister("ks21t", function(module, exports) {

module.exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "update-icon.1ba7b631.png";

});

parcelRegister("bmaA8", function(module, exports) {

module.exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "check-icon.9c694b2b.png";

});

parcelRegister("48wd1", function(module, exports) {

var $aAIWi = parcelRequire("aAIWi");

var $6BHME = parcelRequire("6BHME");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $aAIWi.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $6BHME;
module.exports = isBuffer;

});
parcelRegister("aAIWi", function(module, exports) {

var $b1Qy5 = parcelRequire("b1Qy5");
/** Detect free variable `self`. */ var $7b60202a159a0bca$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $7b60202a159a0bca$var$root = $b1Qy5 || $7b60202a159a0bca$var$freeSelf || Function('return this')();
module.exports = $7b60202a159a0bca$var$root;

});
parcelRegister("b1Qy5", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $80788cc8862cf551$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $80788cc8862cf551$var$freeGlobal;

});


parcelRegister("6BHME", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $4cf8294d773c0255$var$stubFalse() {
    return false;
}
module.exports = $4cf8294d773c0255$var$stubFalse;

});


parcelRegister("lw6rp", function(module, exports) {

var $b1Qy5 = parcelRequire("b1Qy5");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $b1Qy5.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("iGrNT", function(module, exports) {

var $aAIWi = parcelRequire("aAIWi");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $aAIWi.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("2eDJ7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a0bb474af3a439e$export$2e2bcd8739ae039; });

var $kgEOh = parcelRequire("kgEOh");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $kgEOh.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $1a0bb474af3a439e$export$2e2bcd8739ae039 = cloneBuffer;

});
parcelRegister("kgEOh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec14f54e1d0135c6$export$2e2bcd8739ae039; });

var $1GLSz = parcelRequire("1GLSz");
/** Detect free variable `self`. */ var $ec14f54e1d0135c6$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $ec14f54e1d0135c6$var$root = (0, $1GLSz.default) || $ec14f54e1d0135c6$var$freeSelf || Function('return this')();
var $ec14f54e1d0135c6$export$2e2bcd8739ae039 = $ec14f54e1d0135c6$var$root;

});
parcelRegister("1GLSz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13aeda7ab341c8ee$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $13aeda7ab341c8ee$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $13aeda7ab341c8ee$export$2e2bcd8739ae039 = $13aeda7ab341c8ee$var$freeGlobal;

});



parcelRegister("kmshc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed2bcbceb4069703$export$2e2bcd8739ae039; });

var $kgEOh = parcelRequire("kgEOh");

var $jnB2o = parcelRequire("jnB2o");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $kgEOh.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $jnB2o.default);
var $ed2bcbceb4069703$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("jnB2o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1bce5366b3992ff$export$2e2bcd8739ae039; });
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $e1bce5366b3992ff$var$stubFalse() {
    return false;
}
var $e1bce5366b3992ff$export$2e2bcd8739ae039 = $e1bce5366b3992ff$var$stubFalse;

});


parcelRegister("5LKLe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43359d462071bd3c$export$2e2bcd8739ae039; });

var $1GLSz = parcelRequire("1GLSz");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $1GLSz.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
var $43359d462071bd3c$export$2e2bcd8739ae039 = nodeUtil;

});

parcelRegister("dvzee", function(module, exports) {

$parcel$export(module.exports, "handleFocus", function () { return handleFocus; });

var $8FY87 = parcelRequire("8FY87");
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var handleFocus = function handleFocus(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
    return function(_React$Component) {
        _inherits(Focus, _React$Component);
        function Focus() {
            var _ref;
            var _temp, _this, _ret;
            _classCallCheck(this, Focus);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                focus: false
            }, _this.handleFocus = function() {
                return _this.setState({
                    focus: true
                });
            }, _this.handleBlur = function() {
                return _this.setState({
                    focus: false
                });
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }
        _createClass(Focus, [
            {
                key: 'render',
                value: function render() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement(Span, {
                        onFocus: this.handleFocus,
                        onBlur: this.handleBlur
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement(Component, _extends({}, this.props, this.state)));
                }
            }
        ]);
        return Focus;
    }((0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).Component);
};

});

parcelRegister("7kCot", function(module, exports) {

module.exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "google.617e6344.svg";

});

parcelRegister("dnc3N", function(module, exports) {

module.exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "LinkedIn.3090dbf2.svg";

});

parcelRegister("bqDqN", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', promiseTag = '[object Promise]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */ function addMapEntry(map, pair) {
    // Don't return `map.set` because it's not chainable in IE 11.
    map.set(pair[0], pair[1]);
    return map;
}
/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */ function addSetEntry(set, value) {
    // Don't return `set.add` because it's not chainable in IE 11.
    set.add(value);
    return set;
}
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach(array, iteratee) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array ? array.length : 0;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__['delete'](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) object[key] = value;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
}
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
    var result;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!isObject(value)) return value;
    var isArr = isArray(value);
    if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) return copyArray(value, result);
    } else {
        var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
        if (isBuffer(value)) return cloneBuffer(value, isDeep);
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
            if (isHostObject(value)) return object ? value : {};
            result = initCloneObject(isFunc ? {} : value);
            if (!isDeep) return copySymbols(value, baseAssign(result, value));
        } else {
            if (!cloneableTags[tag]) return object ? value : {};
            result = initCloneByTag(value, tag, baseClone, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if (!isArr) var props = isFull ? getAllKeys(value) : keys(value);
    arrayEach(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
    });
    return result;
}
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */ function baseCreate(proto) {
    return isObject(proto) ? objectCreate(proto) : {};
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var result = new buffer.constructor(buffer.length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */ function cloneMap(map, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
    return arrayReduce(array, addMapEntry, new map.constructor);
}
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */ function cloneSet(set, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
    return arrayReduce(array, addSetEntry, new set.constructor);
}
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        assignValue(object, key, newValue === undefined ? source[key] : newValue);
    }
    return object;
}
/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function initCloneArray(array) {
    var length = array.length, result = array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneByTag(object, tag, cloneFunc, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case arrayBufferTag:
            return cloneArrayBuffer(object);
        case boolTag:
        case dateTag:
            return new Ctor(+object);
        case dataViewTag:
            return cloneDataView(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
            return cloneTypedArray(object, isDeep);
        case mapTag:
            return cloneMap(object, isDeep, cloneFunc);
        case numberTag:
        case stringTag:
            return new Ctor(object);
        case regexpTag:
            return cloneRegExp(object);
        case setTag:
            return cloneSet(object, isDeep, cloneFunc);
        case symbolTag:
            return cloneSymbol(object);
    }
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function cloneDeep(value) {
    return baseClone(value, true, true);
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = cloneDeep;

});

parcelRegister("c4HIr", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = isEqual;

});

parcelRegister("7Lphs", function(module, exports) {

module.exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "BlogListingThumbnail.839cf68b.png";

});

parcelRegister("4VW2f", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $397980df0374b119$var$ReactIs, $397980df0374b119$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("7uBZg"))();

});

var $faf2a00639aee87a$exports = {};


(parcelRequire("60Fn4")).register((parcelRequire("lslan")).getBundleURL('gCzzu'), JSON.parse("[\"gCzzu\",\"index.8bedba1b.js\",\"jmxYV\",\"header-illustration-light.37da4125.svg\",\"7KK4E\",\"logo-light.df1bd14c.svg\",\"jY36K\",\"rocket-logo.af3c998e.svg\",\"6bfT7\",\"navbar-profile.876c9cb4.svg\",\"jidZt\",\"logo-dark.68c3823e.svg\",\"hlFc9\",\"logo-dark-small.1a2a9d82.svg\",\"32C1w\",\"facebook.083eecc3.svg\",\"e9nzU\",\"twitter.b8b54306.svg\",\"3BMKx\",\"footer-linkedin.56e84146.svg\",\"3VIjF\",\"white-bg-template.fe3b3c87.png\",\"7VGwC\",\"expand.e615d568.svg\",\"iL1jG\",\"no-website.fffbae5b.svg\",\"1j7XB\",\"site-setting.e5143146.svg\",\"8RKP6\",\"extra-option.a28af855.svg\",\"hsLld\",\"bg-img.fec22d75.svg\",\"eAazt\",\"rocketpages-logo.e311c3bc.svg\",\"7haGM\",\"hero-media-illustration-light.c5bde580.svg\",\"jADxd\",\"hero-media-light.f6bb078c.svg\",\"k4XS7\",\"hero-media-dark.761b0542.svg\",\"jdgL2\",\"rocketpages-logo-light.738f3460.svg\",\"b8A5o\",\"rotate-left_.a95436b5.svg\",\"eoXGM\",\"rotate-right.8d3c0cd9.svg\",\"k1H6Y\",\"flip_right.7d85f9d5.svg\",\"1ZfYw\",\"flip_left.039efc05.svg\",\"goZMY\",\"eye-open.4ceb8078.svg\",\"1wucC\",\"eye-closed.6711f686.svg\",\"2fnlU\",\"google.cac6ba5e.svg\",\"4YTBb\",\"linkedin.e1fd5c1e.svg\",\"3yl9v\",\"check-icon.5885a3fd.svg\",\"eDRNY\",\"edit.0145d912.svg\",\"d4ODs\",\"delete.d174d7e5.svg\",\"9F7Bl\",\"no-image.843e7ae4.svg\",\"k1QxQ\",\"close.3467343a.svg\",\"4wqUp\",\"update-icon.1ba7b631.png\",\"lktJA\",\"check-icon.9c694b2b.png\",\"cXFZE\",\"bi_eye.6d8dacc1.svg\",\"9Rp6j\",\"open_eye.688ef7e6.svg\",\"e46va\",\"google.617e6344.svg\",\"62P3y\",\"LinkedIn.3090dbf2.svg\",\"ii37Z\",\"BlogListingThumbnail.839cf68b.png\",\"erH4u\",\"index.a090c581.css\"]"));


var $8FY87 = parcelRequire("8FY87");
// src/index.tsx

var $8FY87 = parcelRequire("8FY87");
var $a0e0aea147ee92d4$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $a0e0aea147ee92d4$var$hasElementType = typeof Element !== 'undefined';
var $a0e0aea147ee92d4$var$hasMap = typeof Map === 'function';
var $a0e0aea147ee92d4$var$hasSet = typeof Set === 'function';
var $a0e0aea147ee92d4$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $a0e0aea147ee92d4$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$a0e0aea147ee92d4$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($a0e0aea147ee92d4$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$a0e0aea147ee92d4$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($a0e0aea147ee92d4$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($a0e0aea147ee92d4$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($a0e0aea147ee92d4$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$a0e0aea147ee92d4$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$a0e0aea147ee92d4$exports = function isEqual(a, b) {
    try {
        return $a0e0aea147ee92d4$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};


var $3f9b5f1fa1b1bb5f$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $3f9b5f1fa1b1bb5f$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$3f9b5f1fa1b1bb5f$exports = $3f9b5f1fa1b1bb5f$var$invariant;


var $5e7cd0595ed1ea76$exports = {};
//
$5e7cd0595ed1ea76$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


// src/constants.ts
var $33586719f2f33a17$var$TAG_NAMES = /* @__PURE__ */ ((TAG_NAMES2)=>{
    TAG_NAMES2["BASE"] = "base";
    TAG_NAMES2["BODY"] = "body";
    TAG_NAMES2["HEAD"] = "head";
    TAG_NAMES2["HTML"] = "html";
    TAG_NAMES2["LINK"] = "link";
    TAG_NAMES2["META"] = "meta";
    TAG_NAMES2["NOSCRIPT"] = "noscript";
    TAG_NAMES2["SCRIPT"] = "script";
    TAG_NAMES2["STYLE"] = "style";
    TAG_NAMES2["TITLE"] = "title";
    TAG_NAMES2["FRAGMENT"] = "Symbol(react.fragment)";
    return TAG_NAMES2;
})($33586719f2f33a17$var$TAG_NAMES || {});
var $33586719f2f33a17$var$SEO_PRIORITY_TAGS = {
    link: {
        rel: [
            "amphtml",
            "canonical",
            "alternate"
        ]
    },
    script: {
        type: [
            "application/ld+json"
        ]
    },
    meta: {
        charset: "",
        name: [
            "generator",
            "robots",
            "description"
        ],
        property: [
            "og:type",
            "og:title",
            "og:url",
            "og:image",
            "og:image:alt",
            "og:description",
            "twitter:url",
            "twitter:title",
            "twitter:description",
            "twitter:image",
            "twitter:image:alt",
            "twitter:card",
            "twitter:site"
        ]
    }
};
var $33586719f2f33a17$var$VALID_TAG_NAMES = Object.values($33586719f2f33a17$var$TAG_NAMES);
var $33586719f2f33a17$var$REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $33586719f2f33a17$var$HTML_TAG_MAP = Object.entries($33586719f2f33a17$var$REACT_TAG_MAP).reduce((carry, [key, value])=>{
    carry[value] = key;
    return carry;
}, {});
var $33586719f2f33a17$var$HELMET_ATTRIBUTE = "data-rh";
// src/utils.ts
var $33586719f2f33a17$var$HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate",
    PRIORITIZE_SEO_TAGS: "prioritizeSeoTags"
};
var $33586719f2f33a17$var$getInnermostProperty = (propsList, property)=>{
    for(let i = propsList.length - 1; i >= 0; i -= 1){
        const props = propsList[i];
        if (Object.prototype.hasOwnProperty.call(props, property)) return props[property];
    }
    return null;
};
var $33586719f2f33a17$var$getTitleFromPropsList = (propsList)=>{
    let innermostTitle = $33586719f2f33a17$var$getInnermostProperty(propsList, "title" /* TITLE */ );
    const innermostTemplate = $33586719f2f33a17$var$getInnermostProperty(propsList, $33586719f2f33a17$var$HELMET_PROPS.TITLE_TEMPLATE);
    if (Array.isArray(innermostTitle)) innermostTitle = innermostTitle.join("");
    if (innermostTemplate && innermostTitle) return innermostTemplate.replace(/%s/g, ()=>innermostTitle);
    const innermostDefaultTitle = $33586719f2f33a17$var$getInnermostProperty(propsList, $33586719f2f33a17$var$HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || void 0;
};
var $33586719f2f33a17$var$getOnChangeClientState = (propsList)=>$33586719f2f33a17$var$getInnermostProperty(propsList, $33586719f2f33a17$var$HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || (()=>{});
var $33586719f2f33a17$var$getAttributesFromPropsList = (tagType, propsList)=>propsList.filter((props)=>typeof props[tagType] !== "undefined").map((props)=>props[tagType]).reduce((tagAttrs, current)=>({
            ...tagAttrs,
            ...current
        }), {});
var $33586719f2f33a17$var$getBaseTagFromPropsList = (primaryAttributes, propsList)=>propsList.filter((props)=>typeof props["base" /* BASE */ ] !== "undefined").map((props)=>props["base" /* BASE */ ]).reverse().reduce((innermostBaseTag, tag)=>{
        if (!innermostBaseTag.length) {
            const keys = Object.keys(tag);
            for(let i = 0; i < keys.length; i += 1){
                const attributeKey = keys[i];
                const lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
var $33586719f2f33a17$var$warn = (msg)=>console && typeof console.warn === "function" && console.warn(msg);
var $33586719f2f33a17$var$getTagsFromPropsList = (tagName, primaryAttributes, propsList)=>{
    const approvedSeenTags = {};
    return propsList.filter((props)=>{
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $33586719f2f33a17$var$warn(`Helmet: ${tagName} should be of type "Array". Instead found type "${typeof props[tagName]}"`);
        return false;
    }).map((props)=>props[tagName]).reverse().reduce((approvedTags, instanceTags)=>{
        const instanceSeenTags = {};
        instanceTags.filter((tag)=>{
            let primaryAttributeKey;
            const keys2 = Object.keys(tag);
            for(let i = 0; i < keys2.length; i += 1){
                const attributeKey = keys2[i];
                const lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === "rel" /* REL */  && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === "rel" /* REL */  && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === "innerHTML" /* INNER_HTML */  || attributeKey === "cssText" /* CSS_TEXT */  || attributeKey === "itemprop" /* ITEM_PROP */ )) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            const value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach((tag)=>approvedTags.push(tag));
        const keys = Object.keys(instanceSeenTags);
        for(let i = 0; i < keys.length; i += 1){
            const attributeKey = keys[i];
            const tagUnion = {
                ...approvedSeenTags[attributeKey],
                ...instanceSeenTags[attributeKey]
            };
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $33586719f2f33a17$var$getAnyTrueFromPropsList = (propsList, checkedTag)=>{
    if (Array.isArray(propsList) && propsList.length) for(let index = 0; index < propsList.length; index += 1){
        const prop = propsList[index];
        if (prop[checkedTag]) return true;
    }
    return false;
};
var $33586719f2f33a17$var$reducePropsToState = (propsList)=>({
        baseTag: $33586719f2f33a17$var$getBaseTagFromPropsList([
            "href" /* HREF */ 
        ], propsList),
        bodyAttributes: $33586719f2f33a17$var$getAttributesFromPropsList("bodyAttributes" /* BODY */ , propsList),
        defer: $33586719f2f33a17$var$getInnermostProperty(propsList, $33586719f2f33a17$var$HELMET_PROPS.DEFER),
        encode: $33586719f2f33a17$var$getInnermostProperty(propsList, $33586719f2f33a17$var$HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $33586719f2f33a17$var$getAttributesFromPropsList("htmlAttributes" /* HTML */ , propsList),
        linkTags: $33586719f2f33a17$var$getTagsFromPropsList("link" /* LINK */ , [
            "rel" /* REL */ ,
            "href" /* HREF */ 
        ], propsList),
        metaTags: $33586719f2f33a17$var$getTagsFromPropsList("meta" /* META */ , [
            "name" /* NAME */ ,
            "charset" /* CHARSET */ ,
            "http-equiv" /* HTTPEQUIV */ ,
            "property" /* PROPERTY */ ,
            "itemprop" /* ITEM_PROP */ 
        ], propsList),
        noscriptTags: $33586719f2f33a17$var$getTagsFromPropsList("noscript" /* NOSCRIPT */ , [
            "innerHTML" /* INNER_HTML */ 
        ], propsList),
        onChangeClientState: $33586719f2f33a17$var$getOnChangeClientState(propsList),
        scriptTags: $33586719f2f33a17$var$getTagsFromPropsList("script" /* SCRIPT */ , [
            "src" /* SRC */ ,
            "innerHTML" /* INNER_HTML */ 
        ], propsList),
        styleTags: $33586719f2f33a17$var$getTagsFromPropsList("style" /* STYLE */ , [
            "cssText" /* CSS_TEXT */ 
        ], propsList),
        title: $33586719f2f33a17$var$getTitleFromPropsList(propsList),
        titleAttributes: $33586719f2f33a17$var$getAttributesFromPropsList("titleAttributes" /* TITLE */ , propsList),
        prioritizeSeoTags: $33586719f2f33a17$var$getAnyTrueFromPropsList(propsList, $33586719f2f33a17$var$HELMET_PROPS.PRIORITIZE_SEO_TAGS)
    });
var $33586719f2f33a17$var$flattenArray = (possibleArray)=>Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
var $33586719f2f33a17$var$checkIfPropsMatch = (props, toMatch)=>{
    const keys = Object.keys(props);
    for(let i = 0; i < keys.length; i += 1){
        if (toMatch[keys[i]] && toMatch[keys[i]].includes(props[keys[i]])) return true;
    }
    return false;
};
var $33586719f2f33a17$var$prioritizer = (elementsList, propsToMatch)=>{
    if (Array.isArray(elementsList)) return elementsList.reduce((acc, elementAttrs)=>{
        if ($33586719f2f33a17$var$checkIfPropsMatch(elementAttrs, propsToMatch)) acc.priority.push(elementAttrs);
        else acc.default.push(elementAttrs);
        return acc;
    }, {
        priority: [],
        default: []
    });
    return {
        default: elementsList,
        priority: []
    };
};
var $33586719f2f33a17$var$without = (obj, key)=>{
    return {
        ...obj,
        [key]: void 0
    };
};
// src/server.ts
var $33586719f2f33a17$var$SELF_CLOSING_TAGS = [
    "noscript" /* NOSCRIPT */ ,
    "script" /* SCRIPT */ ,
    "style" /* STYLE */ 
];
var $33586719f2f33a17$var$encodeSpecialCharacters = (str, encode = true)=>{
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $33586719f2f33a17$var$generateElementAttributesAsString = (attributes)=>Object.keys(attributes).reduce((str, key)=>{
        const attr = typeof attributes[key] !== "undefined" ? `${key}="${attributes[key]}"` : `${key}`;
        return str ? `${str} ${attr}` : attr;
    }, "");
var $33586719f2f33a17$var$generateTitleAsString = (type, title, attributes, encode)=>{
    const attributeString = $33586719f2f33a17$var$generateElementAttributesAsString(attributes);
    const flattenedTitle = $33586719f2f33a17$var$flattenArray(title);
    return attributeString ? `<${type} ${$33586719f2f33a17$var$HELMET_ATTRIBUTE}="true" ${attributeString}>${$33586719f2f33a17$var$encodeSpecialCharacters(flattenedTitle, encode)}</${type}>` : `<${type} ${$33586719f2f33a17$var$HELMET_ATTRIBUTE}="true">${$33586719f2f33a17$var$encodeSpecialCharacters(flattenedTitle, encode)}</${type}>`;
};
var $33586719f2f33a17$var$generateTagsAsString = (type, tags, encode = true)=>tags.reduce((str, t)=>{
        const tag = t;
        const attributeHtml = Object.keys(tag).filter((attribute)=>!(attribute === "innerHTML" /* INNER_HTML */  || attribute === "cssText" /* CSS_TEXT */ )).reduce((string, attribute)=>{
            const attr = typeof tag[attribute] === "undefined" ? attribute : `${attribute}="${$33586719f2f33a17$var$encodeSpecialCharacters(tag[attribute], encode)}"`;
            return string ? `${string} ${attr}` : attr;
        }, "");
        const tagContent = tag.innerHTML || tag.cssText || "";
        const isSelfClosing = $33586719f2f33a17$var$SELF_CLOSING_TAGS.indexOf(type) === -1;
        return `${str}<${type} ${$33586719f2f33a17$var$HELMET_ATTRIBUTE}="true" ${attributeHtml}${isSelfClosing ? `/>` : `>${tagContent}</${type}>`}`;
    }, "");
var $33586719f2f33a17$var$convertElementAttributesToReactProps = (attributes, initProps = {})=>Object.keys(attributes).reduce((obj, key)=>{
        const mapped = $33586719f2f33a17$var$REACT_TAG_MAP[key];
        obj[mapped || key] = attributes[key];
        return obj;
    }, initProps);
var $33586719f2f33a17$var$generateTitleAsReactComponent = (_type, title, attributes)=>{
    const initProps = {
        key: title,
        [$33586719f2f33a17$var$HELMET_ATTRIBUTE]: true
    };
    const props = $33586719f2f33a17$var$convertElementAttributesToReactProps(attributes, initProps);
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("title" /* TITLE */ , props, title)
    ];
};
var $33586719f2f33a17$var$generateTagsAsReactComponent = (type, tags)=>tags.map((tag, i)=>{
        const mappedTag = {
            key: i,
            [$33586719f2f33a17$var$HELMET_ATTRIBUTE]: true
        };
        Object.keys(tag).forEach((attribute)=>{
            const mapped = $33586719f2f33a17$var$REACT_TAG_MAP[attribute];
            const mappedAttribute = mapped || attribute;
            if (mappedAttribute === "innerHTML" /* INNER_HTML */  || mappedAttribute === "cssText" /* CSS_TEXT */ ) {
                const content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement(type, mappedTag);
    });
var $33586719f2f33a17$var$getMethodsForTag = (type, tags, encode = true)=>{
    switch(type){
        case "title" /* TITLE */ :
            return {
                toComponent: ()=>$33586719f2f33a17$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes),
                toString: ()=>$33586719f2f33a17$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode)
            };
        case "bodyAttributes" /* BODY */ :
        case "htmlAttributes" /* HTML */ :
            return {
                toComponent: ()=>$33586719f2f33a17$var$convertElementAttributesToReactProps(tags),
                toString: ()=>$33586719f2f33a17$var$generateElementAttributesAsString(tags)
            };
        default:
            return {
                toComponent: ()=>$33586719f2f33a17$var$generateTagsAsReactComponent(type, tags),
                toString: ()=>$33586719f2f33a17$var$generateTagsAsString(type, tags, encode)
            };
    }
};
var $33586719f2f33a17$var$getPriorityMethods = ({ metaTags: metaTags, linkTags: linkTags, scriptTags: scriptTags, encode: encode })=>{
    const meta = $33586719f2f33a17$var$prioritizer(metaTags, $33586719f2f33a17$var$SEO_PRIORITY_TAGS.meta);
    const link = $33586719f2f33a17$var$prioritizer(linkTags, $33586719f2f33a17$var$SEO_PRIORITY_TAGS.link);
    const script = $33586719f2f33a17$var$prioritizer(scriptTags, $33586719f2f33a17$var$SEO_PRIORITY_TAGS.script);
    const priorityMethods = {
        toComponent: ()=>[
                ...$33586719f2f33a17$var$generateTagsAsReactComponent("meta" /* META */ , meta.priority),
                ...$33586719f2f33a17$var$generateTagsAsReactComponent("link" /* LINK */ , link.priority),
                ...$33586719f2f33a17$var$generateTagsAsReactComponent("script" /* SCRIPT */ , script.priority)
            ],
        toString: ()=>// generate all the tags as strings and concatenate them
            `${$33586719f2f33a17$var$getMethodsForTag("meta" /* META */ , meta.priority, encode)} ${$33586719f2f33a17$var$getMethodsForTag("link" /* LINK */ , link.priority, encode)} ${$33586719f2f33a17$var$getMethodsForTag("script" /* SCRIPT */ , script.priority, encode)}`
    };
    return {
        priorityMethods: priorityMethods,
        metaTags: meta.default,
        linkTags: link.default,
        scriptTags: script.default
    };
};
var $33586719f2f33a17$var$mapStateOnServer = (props)=>{
    const { baseTag: baseTag, bodyAttributes: bodyAttributes, encode: encode = true, htmlAttributes: htmlAttributes, noscriptTags: noscriptTags, styleTags: styleTags, title: title = "", titleAttributes: titleAttributes, prioritizeSeoTags: prioritizeSeoTags } = props;
    let { linkTags: linkTags, metaTags: metaTags, scriptTags: scriptTags } = props;
    let priorityMethods = {
        toComponent: ()=>{},
        toString: ()=>""
    };
    if (prioritizeSeoTags) ({ priorityMethods: priorityMethods, linkTags: linkTags, metaTags: metaTags, scriptTags: scriptTags } = $33586719f2f33a17$var$getPriorityMethods(props));
    return {
        priority: priorityMethods,
        base: $33586719f2f33a17$var$getMethodsForTag("base" /* BASE */ , baseTag, encode),
        bodyAttributes: $33586719f2f33a17$var$getMethodsForTag("bodyAttributes" /* BODY */ , bodyAttributes, encode),
        htmlAttributes: $33586719f2f33a17$var$getMethodsForTag("htmlAttributes" /* HTML */ , htmlAttributes, encode),
        link: $33586719f2f33a17$var$getMethodsForTag("link" /* LINK */ , linkTags, encode),
        meta: $33586719f2f33a17$var$getMethodsForTag("meta" /* META */ , metaTags, encode),
        noscript: $33586719f2f33a17$var$getMethodsForTag("noscript" /* NOSCRIPT */ , noscriptTags, encode),
        script: $33586719f2f33a17$var$getMethodsForTag("script" /* SCRIPT */ , scriptTags, encode),
        style: $33586719f2f33a17$var$getMethodsForTag("style" /* STYLE */ , styleTags, encode),
        title: $33586719f2f33a17$var$getMethodsForTag("title" /* TITLE */ , {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var $33586719f2f33a17$var$server_default = $33586719f2f33a17$var$mapStateOnServer;
// src/HelmetData.ts
var $33586719f2f33a17$var$instances = [];
var $33586719f2f33a17$var$isDocument = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $33586719f2f33a17$export$a9cf6990c9c7feb9 = class {
    instances = [];
    canUseDOM = $33586719f2f33a17$var$isDocument;
    context;
    value = {
        setHelmet: (serverState)=>{
            this.context.helmet = serverState;
        },
        helmetInstances: {
            get: ()=>this.canUseDOM ? $33586719f2f33a17$var$instances : this.instances,
            add: (instance)=>{
                (this.canUseDOM ? $33586719f2f33a17$var$instances : this.instances).push(instance);
            },
            remove: (instance)=>{
                const index = (this.canUseDOM ? $33586719f2f33a17$var$instances : this.instances).indexOf(instance);
                (this.canUseDOM ? $33586719f2f33a17$var$instances : this.instances).splice(index, 1);
            }
        }
    };
    constructor(context, canUseDOM){
        this.context = context;
        this.canUseDOM = canUseDOM || false;
        if (!canUseDOM) context.helmet = $33586719f2f33a17$var$server_default({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
    }
};
// src/Provider.tsx
var $33586719f2f33a17$var$defaultValue = {};
var $33586719f2f33a17$var$Context = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createContext($33586719f2f33a17$var$defaultValue);
var $33586719f2f33a17$export$4719288a8f5f7e71 = class _HelmetProvider extends (0, $8FY87.Component) {
    static canUseDOM = $33586719f2f33a17$var$isDocument;
    helmetData;
    constructor(props){
        super(props);
        this.helmetData = new $33586719f2f33a17$export$a9cf6990c9c7feb9(this.props.context || {}, _HelmetProvider.canUseDOM);
    }
    render() {
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement($33586719f2f33a17$var$Context.Provider, {
            value: this.helmetData.value
        }, this.props.children);
    }
};
// src/client.ts
var $33586719f2f33a17$var$updateTags = (type, tags)=>{
    const headElement = document.head || document.querySelector("head" /* HEAD */ );
    const tagNodes = headElement.querySelectorAll(`${type}[${$33586719f2f33a17$var$HELMET_ATTRIBUTE}]`);
    const oldTags = [].slice.call(tagNodes);
    const newTags = [];
    let indexToDelete;
    if (tags && tags.length) tags.forEach((tag)=>{
        const newElement = document.createElement(type);
        for(const attribute in tag)if (Object.prototype.hasOwnProperty.call(tag, attribute)) {
            if (attribute === "innerHTML" /* INNER_HTML */ ) newElement.innerHTML = tag.innerHTML;
            else if (attribute === "cssText" /* CSS_TEXT */ ) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                const attr = attribute;
                const value = typeof tag[attr] === "undefined" ? "" : tag[attr];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($33586719f2f33a17$var$HELMET_ATTRIBUTE, "true");
        if (oldTags.some((existingTag, index)=>{
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach((tag)=>tag.parentNode?.removeChild(tag));
    newTags.forEach((tag)=>headElement.appendChild(tag));
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $33586719f2f33a17$var$updateAttributes = (tagName, attributes)=>{
    const elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    const helmetAttributeString = elementTag.getAttribute($33586719f2f33a17$var$HELMET_ATTRIBUTE);
    const helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    const attributesToRemove = [
        ...helmetAttributes
    ];
    const attributeKeys = Object.keys(attributes);
    for (const attribute of attributeKeys){
        const value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        const indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(let i = attributesToRemove.length - 1; i >= 0; i -= 1)elementTag.removeAttribute(attributesToRemove[i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($33586719f2f33a17$var$HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($33586719f2f33a17$var$HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($33586719f2f33a17$var$HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $33586719f2f33a17$var$updateTitle = (title, attributes)=>{
    if (typeof title !== "undefined" && document.title !== title) document.title = $33586719f2f33a17$var$flattenArray(title);
    $33586719f2f33a17$var$updateAttributes("title" /* TITLE */ , attributes);
};
var $33586719f2f33a17$var$commitTagChanges = (newState, cb)=>{
    const { baseTag: baseTag, bodyAttributes: bodyAttributes, htmlAttributes: htmlAttributes, linkTags: linkTags, metaTags: metaTags, noscriptTags: noscriptTags, onChangeClientState: onChangeClientState, scriptTags: scriptTags, styleTags: styleTags, title: title, titleAttributes: titleAttributes } = newState;
    $33586719f2f33a17$var$updateAttributes("body" /* BODY */ , bodyAttributes);
    $33586719f2f33a17$var$updateAttributes("html" /* HTML */ , htmlAttributes);
    $33586719f2f33a17$var$updateTitle(title, titleAttributes);
    const tagUpdates = {
        baseTag: $33586719f2f33a17$var$updateTags("base" /* BASE */ , baseTag),
        linkTags: $33586719f2f33a17$var$updateTags("link" /* LINK */ , linkTags),
        metaTags: $33586719f2f33a17$var$updateTags("meta" /* META */ , metaTags),
        noscriptTags: $33586719f2f33a17$var$updateTags("noscript" /* NOSCRIPT */ , noscriptTags),
        scriptTags: $33586719f2f33a17$var$updateTags("script" /* SCRIPT */ , scriptTags),
        styleTags: $33586719f2f33a17$var$updateTags("style" /* STYLE */ , styleTags)
    };
    const addedTags = {};
    const removedTags = {};
    Object.keys(tagUpdates).forEach((tagType)=>{
        const { newTags: newTags, oldTags: oldTags } = tagUpdates[tagType];
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    if (cb) cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $33586719f2f33a17$var$_helmetCallback = null;
var $33586719f2f33a17$var$handleStateChangeOnClient = (newState)=>{
    if ($33586719f2f33a17$var$_helmetCallback) cancelAnimationFrame($33586719f2f33a17$var$_helmetCallback);
    if (newState.defer) $33586719f2f33a17$var$_helmetCallback = requestAnimationFrame(()=>{
        $33586719f2f33a17$var$commitTagChanges(newState, ()=>{
            $33586719f2f33a17$var$_helmetCallback = null;
        });
    });
    else {
        $33586719f2f33a17$var$commitTagChanges(newState);
        $33586719f2f33a17$var$_helmetCallback = null;
    }
};
var $33586719f2f33a17$var$client_default = $33586719f2f33a17$var$handleStateChangeOnClient;
// src/Dispatcher.tsx
var $33586719f2f33a17$var$HelmetDispatcher = class extends (0, $8FY87.Component) {
    rendered = false;
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($5e7cd0595ed1ea76$exports)))(nextProps, this.props);
    }
    componentDidUpdate() {
        this.emitChange();
    }
    componentWillUnmount() {
        const { helmetInstances: helmetInstances } = this.props.context;
        helmetInstances.remove(this);
        this.emitChange();
    }
    emitChange() {
        const { helmetInstances: helmetInstances, setHelmet: setHelmet } = this.props.context;
        let serverState = null;
        const state = $33586719f2f33a17$var$reducePropsToState(helmetInstances.get().map((instance)=>{
            const props = {
                ...instance.props
            };
            delete props.context;
            return props;
        }));
        if ($33586719f2f33a17$export$4719288a8f5f7e71.canUseDOM) $33586719f2f33a17$var$client_default(state);
        else if ($33586719f2f33a17$var$server_default) serverState = $33586719f2f33a17$var$server_default(state);
        setHelmet(serverState);
    }
    // componentWillMount will be deprecated
    // for SSR, initialize on first render
    // constructor is also unsafe in StrictMode
    init() {
        if (this.rendered) return;
        this.rendered = true;
        const { helmetInstances: helmetInstances } = this.props.context;
        helmetInstances.add(this);
        this.emitChange();
    }
    render() {
        this.init();
        return null;
    }
};
// src/index.tsx
var $33586719f2f33a17$export$dcef8f9bb9a41431 = class extends (0, $8FY87.Component) {
    static defaultProps = {
        defer: true,
        encodeSpecialCharacters: true,
        prioritizeSeoTags: false
    };
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($a0e0aea147ee92d4$exports)))($33586719f2f33a17$var$without(this.props, "helmetData"), $33586719f2f33a17$var$without(nextProps, "helmetData"));
    }
    mapNestedChildrenToProps(child, nestedChildren) {
        if (!nestedChildren) return null;
        switch(child.type){
            case "script" /* SCRIPT */ :
            case "noscript" /* NOSCRIPT */ :
                return {
                    innerHTML: nestedChildren
                };
            case "style" /* STYLE */ :
                return {
                    cssText: nestedChildren
                };
            default:
                throw new Error(`<${child.type} /> elements are self-closing and can not contain children. Refer to our API for more information.`);
        }
    }
    flattenArrayTypeChildren(child, arrayTypeChildren, newChildProps, nestedChildren) {
        return {
            ...arrayTypeChildren,
            [child.type]: [
                ...arrayTypeChildren[child.type] || [],
                {
                    ...newChildProps,
                    ...this.mapNestedChildrenToProps(child, nestedChildren)
                }
            ]
        };
    }
    mapObjectTypeChildren(child, newProps, newChildProps, nestedChildren) {
        switch(child.type){
            case "title" /* TITLE */ :
                return {
                    ...newProps,
                    [child.type]: nestedChildren,
                    titleAttributes: {
                        ...newChildProps
                    }
                };
            case "body" /* BODY */ :
                return {
                    ...newProps,
                    bodyAttributes: {
                        ...newChildProps
                    }
                };
            case "html" /* HTML */ :
                return {
                    ...newProps,
                    htmlAttributes: {
                        ...newChildProps
                    }
                };
            default:
                return {
                    ...newProps,
                    [child.type]: {
                        ...newChildProps
                    }
                };
        }
    }
    mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
        let newFlattenedProps = {
            ...newProps
        };
        Object.keys(arrayTypeChildren).forEach((arrayChildName)=>{
            newFlattenedProps = {
                ...newFlattenedProps,
                [arrayChildName]: arrayTypeChildren[arrayChildName]
            };
        });
        return newFlattenedProps;
    }
    warnOnInvalidChildren(child, nestedChildren) {
        (0, (/*@__PURE__*/$parcel$interopDefault($3f9b5f1fa1b1bb5f$exports)))($33586719f2f33a17$var$VALID_TAG_NAMES.some((name)=>child.type === name), typeof child.type === "function" ? `You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.` : `Only elements types ${$33586719f2f33a17$var$VALID_TAG_NAMES.join(", ")} are allowed. Helmet does not support rendering <${child.type}> elements. Refer to our API for more information.`);
        (0, (/*@__PURE__*/$parcel$interopDefault($3f9b5f1fa1b1bb5f$exports)))(!nestedChildren || typeof nestedChildren === "string" || Array.isArray(nestedChildren) && !nestedChildren.some((nestedChild)=>typeof nestedChild !== "string"), `Helmet expects a string as a child of <${child.type}>. Did you forget to wrap your children in braces? ( <${child.type}>{\`\`}</${child.type}> ) Refer to our API for more information.`);
        return true;
    }
    mapChildrenToProps(children, newProps) {
        let arrayTypeChildren = {};
        (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).Children.forEach(children, (child)=>{
            if (!child || !child.props) return;
            const { children: nestedChildren, ...childProps } = child.props;
            const newChildProps = Object.keys(childProps).reduce((obj, key)=>{
                obj[$33586719f2f33a17$var$HTML_TAG_MAP[key] || key] = childProps[key];
                return obj;
            }, {});
            let { type: type } = child;
            if (typeof type === "symbol") type = type.toString();
            else this.warnOnInvalidChildren(child, nestedChildren);
            switch(type){
                case "Symbol(react.fragment)" /* FRAGMENT */ :
                    newProps = this.mapChildrenToProps(nestedChildren, newProps);
                    break;
                case "link" /* LINK */ :
                case "meta" /* META */ :
                case "noscript" /* NOSCRIPT */ :
                case "script" /* SCRIPT */ :
                case "style" /* STYLE */ :
                    arrayTypeChildren = this.flattenArrayTypeChildren(child, arrayTypeChildren, newChildProps, nestedChildren);
                    break;
                default:
                    newProps = this.mapObjectTypeChildren(child, newProps, newChildProps, nestedChildren);
                    break;
            }
        });
        return this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
    }
    render() {
        const { children: children, ...props } = this.props;
        let newProps = {
            ...props
        };
        let { helmetData: helmetData } = props;
        if (children) newProps = this.mapChildrenToProps(children, newProps);
        if (helmetData && !(helmetData instanceof $33586719f2f33a17$export$a9cf6990c9c7feb9)) {
            const data = helmetData;
            helmetData = new $33586719f2f33a17$export$a9cf6990c9c7feb9(data.context, true);
            delete newProps.helmetData;
        }
        return helmetData ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement($33586719f2f33a17$var$HelmetDispatcher, {
            ...newProps,
            context: helmetData.value
        }) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement($33586719f2f33a17$var$Context.Consumer, null, (context)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement($33586719f2f33a17$var$HelmetDispatcher, {
                ...newProps,
                context: context
            }));
    }
};


var $adc227c367c2f6aa$export$882461b6382ed46c;
var $adc227c367c2f6aa$export$757ceba2d55c277e;
'use strict';
var $69d169f7fc8722a7$exports = {};
'use strict';
function $69d169f7fc8722a7$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($69d169f7fc8722a7$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$69d169f7fc8722a7$var$checkDCE();

$69d169f7fc8722a7$exports = (parcelRequire("f30MD"));


var $adc227c367c2f6aa$var$i;
$adc227c367c2f6aa$export$882461b6382ed46c = $69d169f7fc8722a7$exports.createRoot;
$adc227c367c2f6aa$export$757ceba2d55c277e = $69d169f7fc8722a7$exports.hydrateRoot;


/**
 * React Router DOM v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8FY87 = parcelRequire("8FY87");

/**
 * @remix-run/router v1.23.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $e887188a2ce2efb5$var$_extends() {
    $e887188a2ce2efb5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e887188a2ce2efb5$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $e887188a2ce2efb5$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($e887188a2ce2efb5$export$e19cd5f9376f8cee || ($e887188a2ce2efb5$export$e19cd5f9376f8cee = {}));
const $e887188a2ce2efb5$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $e887188a2ce2efb5$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $e887188a2ce2efb5$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $e887188a2ce2efb5$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $e887188a2ce2efb5$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $e887188a2ce2efb5$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $e887188a2ce2efb5$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $e887188a2ce2efb5$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $e887188a2ce2efb5$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $e887188a2ce2efb5$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $e887188a2ce2efb5$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $e887188a2ce2efb5$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $e887188a2ce2efb5$export$fe53371bee54353d(to);
    }
    return $e887188a2ce2efb5$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $e887188a2ce2efb5$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $e887188a2ce2efb5$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $e887188a2ce2efb5$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $e887188a2ce2efb5$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $e887188a2ce2efb5$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $e887188a2ce2efb5$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $e887188a2ce2efb5$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $e887188a2ce2efb5$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $e887188a2ce2efb5$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $e887188a2ce2efb5$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $e887188a2ce2efb5$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $e887188a2ce2efb5$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $e887188a2ce2efb5$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $e887188a2ce2efb5$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $e887188a2ce2efb5$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $e887188a2ce2efb5$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $e887188a2ce2efb5$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $e887188a2ce2efb5$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($e887188a2ce2efb5$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $e887188a2ce2efb5$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $e887188a2ce2efb5$export$e19cd5f9376f8cee.Push;
        let location = $e887188a2ce2efb5$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $e887188a2ce2efb5$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $e887188a2ce2efb5$export$e19cd5f9376f8cee.Replace;
        let location = $e887188a2ce2efb5$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $e887188a2ce2efb5$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $e887188a2ce2efb5$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $e887188a2ce2efb5$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($e887188a2ce2efb5$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($e887188a2ce2efb5$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $e887188a2ce2efb5$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($e887188a2ce2efb5$var$ResultType || ($e887188a2ce2efb5$var$ResultType = {}));
const $e887188a2ce2efb5$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $e887188a2ce2efb5$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $e887188a2ce2efb5$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $e887188a2ce2efb5$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $e887188a2ce2efb5$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($e887188a2ce2efb5$var$isIndexRoute(route)) {
            let indexRoute = $e887188a2ce2efb5$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $e887188a2ce2efb5$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $e887188a2ce2efb5$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $e887188a2ce2efb5$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $e887188a2ce2efb5$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $e887188a2ce2efb5$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $e887188a2ce2efb5$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $e887188a2ce2efb5$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $e887188a2ce2efb5$var$flattenRoutes(routes);
    $e887188a2ce2efb5$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $e887188a2ce2efb5$export$30d21fd6d7295f52(pathname);
        matches = $e887188a2ce2efb5$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $e887188a2ce2efb5$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $e887188a2ce2efb5$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $e887188a2ce2efb5$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $e887188a2ce2efb5$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $e887188a2ce2efb5$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $e887188a2ce2efb5$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $e887188a2ce2efb5$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $e887188a2ce2efb5$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $e887188a2ce2efb5$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $e887188a2ce2efb5$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $e887188a2ce2efb5$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $e887188a2ce2efb5$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $e887188a2ce2efb5$var$paramRe = /^:[\w-]+$/;
const $e887188a2ce2efb5$var$dynamicSegmentValue = 3;
const $e887188a2ce2efb5$var$indexRouteValue = 2;
const $e887188a2ce2efb5$var$emptySegmentValue = 1;
const $e887188a2ce2efb5$var$staticSegmentValue = 10;
const $e887188a2ce2efb5$var$splatPenalty = -2;
const $e887188a2ce2efb5$var$isSplat = (s)=>s === "*";
function $e887188a2ce2efb5$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($e887188a2ce2efb5$var$isSplat)) initialScore += $e887188a2ce2efb5$var$splatPenalty;
    if (index) initialScore += $e887188a2ce2efb5$var$indexRouteValue;
    return segments.filter((s)=>!$e887188a2ce2efb5$var$isSplat(s)).reduce((score, segment)=>score + ($e887188a2ce2efb5$var$paramRe.test(segment) ? $e887188a2ce2efb5$var$dynamicSegmentValue : segment === "" ? $e887188a2ce2efb5$var$emptySegmentValue : $e887188a2ce2efb5$var$staticSegmentValue), initialScore);
}
function $e887188a2ce2efb5$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $e887188a2ce2efb5$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $e887188a2ce2efb5$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $e887188a2ce2efb5$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $e887188a2ce2efb5$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $e887188a2ce2efb5$export$a5c6d149b50c1d86($e887188a2ce2efb5$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $e887188a2ce2efb5$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $e887188a2ce2efb5$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $e887188a2ce2efb5$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $e887188a2ce2efb5$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $e887188a2ce2efb5$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $e887188a2ce2efb5$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $e887188a2ce2efb5$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $e887188a2ce2efb5$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $e887188a2ce2efb5$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $e887188a2ce2efb5$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $e887188a2ce2efb5$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const $e887188a2ce2efb5$var$ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $e887188a2ce2efb5$var$isAbsoluteUrl = (url)=>$e887188a2ce2efb5$var$ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $e887188a2ce2efb5$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $e887188a2ce2efb5$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($e887188a2ce2efb5$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                $e887188a2ce2efb5$export$c0e02632e14916fd(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = $e887188a2ce2efb5$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $e887188a2ce2efb5$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $e887188a2ce2efb5$var$normalizeSearch(search),
        hash: $e887188a2ce2efb5$var$normalizeHash(hash)
    };
}
function $e887188a2ce2efb5$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $e887188a2ce2efb5$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $e887188a2ce2efb5$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $e887188a2ce2efb5$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $e887188a2ce2efb5$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $e887188a2ce2efb5$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $e887188a2ce2efb5$export$8ccf933b0513f8d0(toArg);
    else {
        to = $e887188a2ce2efb5$var$_extends({}, toArg);
        $e887188a2ce2efb5$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $e887188a2ce2efb5$var$getInvalidPathError("?", "pathname", "search", to));
        $e887188a2ce2efb5$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $e887188a2ce2efb5$var$getInvalidPathError("#", "pathname", "hash", to));
        $e887188a2ce2efb5$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $e887188a2ce2efb5$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $e887188a2ce2efb5$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $e887188a2ce2efb5$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $e887188a2ce2efb5$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $e887188a2ce2efb5$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $e887188a2ce2efb5$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $e887188a2ce2efb5$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $e887188a2ce2efb5$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $e887188a2ce2efb5$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $e887188a2ce2efb5$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $e887188a2ce2efb5$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $e887188a2ce2efb5$export$4051a07651545597(data, init) {
    return new $e887188a2ce2efb5$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $e887188a2ce2efb5$export$42a99a7a4bc0e76a extends Error {
}
class $e887188a2ce2efb5$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $e887188a2ce2efb5$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $e887188a2ce2efb5$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $e887188a2ce2efb5$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $e887188a2ce2efb5$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $e887188a2ce2efb5$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $e887188a2ce2efb5$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $e887188a2ce2efb5$var$unwrapTrackedPromise(value) {
    if (!$e887188a2ce2efb5$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $e887188a2ce2efb5$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $e887188a2ce2efb5$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $e887188a2ce2efb5$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $e887188a2ce2efb5$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $e887188a2ce2efb5$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $e887188a2ce2efb5$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $e887188a2ce2efb5$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $e887188a2ce2efb5$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $e887188a2ce2efb5$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $e887188a2ce2efb5$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $e887188a2ce2efb5$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $e887188a2ce2efb5$var$validMutationMethods = new Set($e887188a2ce2efb5$var$validMutationMethodsArr);
const $e887188a2ce2efb5$var$validRequestMethodsArr = [
    "get",
    ...$e887188a2ce2efb5$var$validMutationMethodsArr
];
const $e887188a2ce2efb5$var$validRequestMethods = new Set($e887188a2ce2efb5$var$validRequestMethodsArr);
const $e887188a2ce2efb5$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $e887188a2ce2efb5$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $e887188a2ce2efb5$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $e887188a2ce2efb5$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $e887188a2ce2efb5$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $e887188a2ce2efb5$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $e887188a2ce2efb5$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $e887188a2ce2efb5$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $e887188a2ce2efb5$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $e887188a2ce2efb5$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $e887188a2ce2efb5$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $e887188a2ce2efb5$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $e887188a2ce2efb5$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $e887188a2ce2efb5$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $e887188a2ce2efb5$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $e887188a2ce2efb5$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $e887188a2ce2efb5$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$e887188a2ce2efb5$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$e887188a2ce2efb5$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $e887188a2ce2efb5$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $e887188a2ce2efb5$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $e887188a2ce2efb5$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $e887188a2ce2efb5$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $e887188a2ce2efb5$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$e887188a2ce2efb5$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($e887188a2ce2efb5$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $e887188a2ce2efb5$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $e887188a2ce2efb5$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $e887188a2ce2efb5$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $e887188a2ce2efb5$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $e887188a2ce2efb5$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $e887188a2ce2efb5$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $e887188a2ce2efb5$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $e887188a2ce2efb5$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $e887188a2ce2efb5$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($e887188a2ce2efb5$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $e887188a2ce2efb5$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $e887188a2ce2efb5$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $e887188a2ce2efb5$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $e887188a2ce2efb5$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $e887188a2ce2efb5$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $e887188a2ce2efb5$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $e887188a2ce2efb5$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $e887188a2ce2efb5$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $e887188a2ce2efb5$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $e887188a2ce2efb5$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $e887188a2ce2efb5$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $e887188a2ce2efb5$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $e887188a2ce2efb5$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $e887188a2ce2efb5$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $e887188a2ce2efb5$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $e887188a2ce2efb5$var$findNearestBoundary(matches).route.id,
            {
                type: $e887188a2ce2efb5$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $e887188a2ce2efb5$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($e887188a2ce2efb5$var$isErrorResult(result) && $e887188a2ce2efb5$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $e887188a2ce2efb5$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $e887188a2ce2efb5$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $e887188a2ce2efb5$var$_extends({
            matches: updatedMatches || matches
        }, $e887188a2ce2efb5$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $e887188a2ce2efb5$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $e887188a2ce2efb5$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $e887188a2ce2efb5$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $e887188a2ce2efb5$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $e887188a2ce2efb5$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $e887188a2ce2efb5$var$ResultType.error,
            error: $e887188a2ce2efb5$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($e887188a2ce2efb5$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $e887188a2ce2efb5$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($e887188a2ce2efb5$var$isDeferredResult(result)) throw $e887188a2ce2efb5$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($e887188a2ce2efb5$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $e887188a2ce2efb5$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $e887188a2ce2efb5$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $e887188a2ce2efb5$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $e887188a2ce2efb5$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($e887188a2ce2efb5$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $e887188a2ce2efb5$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $e887188a2ce2efb5$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $e887188a2ce2efb5$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $e887188a2ce2efb5$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $e887188a2ce2efb5$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $e887188a2ce2efb5$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $e887188a2ce2efb5$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $e887188a2ce2efb5$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $e887188a2ce2efb5$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $e887188a2ce2efb5$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$e887188a2ce2efb5$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $e887188a2ce2efb5$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $e887188a2ce2efb5$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $e887188a2ce2efb5$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $e887188a2ce2efb5$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $e887188a2ce2efb5$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $e887188a2ce2efb5$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $e887188a2ce2efb5$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $e887188a2ce2efb5$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $e887188a2ce2efb5$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $e887188a2ce2efb5$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $e887188a2ce2efb5$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $e887188a2ce2efb5$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($e887188a2ce2efb5$var$isRedirectResult(actionResult) || $e887188a2ce2efb5$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $e887188a2ce2efb5$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($e887188a2ce2efb5$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $e887188a2ce2efb5$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $e887188a2ce2efb5$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($e887188a2ce2efb5$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($e887188a2ce2efb5$var$isDeferredResult(actionResult)) throw $e887188a2ce2efb5$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $e887188a2ce2efb5$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $e887188a2ce2efb5$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $e887188a2ce2efb5$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $e887188a2ce2efb5$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $e887188a2ce2efb5$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $e887188a2ce2efb5$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $e887188a2ce2efb5$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $e887188a2ce2efb5$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $e887188a2ce2efb5$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $e887188a2ce2efb5$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $e887188a2ce2efb5$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $e887188a2ce2efb5$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $e887188a2ce2efb5$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $e887188a2ce2efb5$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $e887188a2ce2efb5$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $e887188a2ce2efb5$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($e887188a2ce2efb5$var$isDeferredResult(result)) result = await $e887188a2ce2efb5$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $e887188a2ce2efb5$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($e887188a2ce2efb5$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $e887188a2ce2efb5$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($e887188a2ce2efb5$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $e887188a2ce2efb5$export$3e9cee6b33872309(!$e887188a2ce2efb5$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $e887188a2ce2efb5$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $e887188a2ce2efb5$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $e887188a2ce2efb5$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $e887188a2ce2efb5$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($e887188a2ce2efb5$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $e887188a2ce2efb5$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $e887188a2ce2efb5$export$e19cd5f9376f8cee.Replace : $e887188a2ce2efb5$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $e887188a2ce2efb5$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($e887188a2ce2efb5$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $e887188a2ce2efb5$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $e887188a2ce2efb5$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $e887188a2ce2efb5$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $e887188a2ce2efb5$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $e887188a2ce2efb5$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($e887188a2ce2efb5$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $e887188a2ce2efb5$var$ResultType.redirect,
                response: $e887188a2ce2efb5$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $e887188a2ce2efb5$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $e887188a2ce2efb5$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $e887188a2ce2efb5$var$ResultType.error,
                    error: $e887188a2ce2efb5$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $e887188a2ce2efb5$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $e887188a2ce2efb5$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $e887188a2ce2efb5$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $e887188a2ce2efb5$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $e887188a2ce2efb5$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $e887188a2ce2efb5$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $e887188a2ce2efb5$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $e887188a2ce2efb5$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $e887188a2ce2efb5$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $e887188a2ce2efb5$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $e887188a2ce2efb5$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $e887188a2ce2efb5$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $e887188a2ce2efb5$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $e887188a2ce2efb5$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$e887188a2ce2efb5$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $e887188a2ce2efb5$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $e887188a2ce2efb5$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $e887188a2ce2efb5$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $e887188a2ce2efb5$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $e887188a2ce2efb5$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $e887188a2ce2efb5$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $e887188a2ce2efb5$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $e887188a2ce2efb5$export$4d0306f8f6a4585b = Symbol("deferred");
function $e887188a2ce2efb5$export$3336b097a6fbc59a(routes, opts) {
    $e887188a2ce2efb5$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $e887188a2ce2efb5$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $e887188a2ce2efb5$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $e887188a2ce2efb5$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $e887188a2ce2efb5$var$createLocation("", $e887188a2ce2efb5$export$fe53371bee54353d(url), null, "default");
        let matches = $e887188a2ce2efb5$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$e887188a2ce2efb5$var$isValidMethod(method) && method !== "HEAD") {
            let error = $e887188a2ce2efb5$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $e887188a2ce2efb5$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $e887188a2ce2efb5$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $e887188a2ce2efb5$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($e887188a2ce2efb5$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $e887188a2ce2efb5$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $e887188a2ce2efb5$var$createLocation("", $e887188a2ce2efb5$export$fe53371bee54353d(url), null, "default");
        let matches = $e887188a2ce2efb5$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$e887188a2ce2efb5$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $e887188a2ce2efb5$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $e887188a2ce2efb5$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $e887188a2ce2efb5$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $e887188a2ce2efb5$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $e887188a2ce2efb5$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($e887188a2ce2efb5$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$e887188a2ce2efb5$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $e887188a2ce2efb5$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($e887188a2ce2efb5$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $e887188a2ce2efb5$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $e887188a2ce2efb5$var$isResponse(result) ? result : $e887188a2ce2efb5$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($e887188a2ce2efb5$var$isDataStrategyResult(e) && $e887188a2ce2efb5$var$isResponse(e.result)) {
                if (e.type === $e887188a2ce2efb5$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($e887188a2ce2efb5$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $e887188a2ce2efb5$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $e887188a2ce2efb5$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $e887188a2ce2efb5$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($e887188a2ce2efb5$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($e887188a2ce2efb5$var$isDeferredResult(result)) {
            let error = $e887188a2ce2efb5$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $e887188a2ce2efb5$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($e887188a2ce2efb5$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($e887188a2ce2efb5$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $e887188a2ce2efb5$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $e887188a2ce2efb5$var$_extends({}, context, {
                statusCode: $e887188a2ce2efb5$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $e887188a2ce2efb5$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $e887188a2ce2efb5$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $e887188a2ce2efb5$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $e887188a2ce2efb5$var$isErrorResult(pendingActionResult[1]) ? $e887188a2ce2efb5$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $e887188a2ce2efb5$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $e887188a2ce2efb5$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $e887188a2ce2efb5$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $e887188a2ce2efb5$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $e887188a2ce2efb5$var$callDataStrategyImpl(dataStrategy || $e887188a2ce2efb5$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($e887188a2ce2efb5$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $e887188a2ce2efb5$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($e887188a2ce2efb5$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $e887188a2ce2efb5$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $e887188a2ce2efb5$export$fec11da027c70692(routes, context, error) {
    let newContext = $e887188a2ce2efb5$var$_extends({}, context, {
        statusCode: $e887188a2ce2efb5$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $e887188a2ce2efb5$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $e887188a2ce2efb5$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $e887188a2ce2efb5$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $e887188a2ce2efb5$export$cae722b0cc860f13(to ? to : ".", $e887188a2ce2efb5$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $e887188a2ce2efb5$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $e887188a2ce2efb5$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $e887188a2ce2efb5$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $e887188a2ce2efb5$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $e887188a2ce2efb5$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$e887188a2ce2efb5$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$e887188a2ce2efb5$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $e887188a2ce2efb5$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $e887188a2ce2efb5$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $e887188a2ce2efb5$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$e887188a2ce2efb5$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$e887188a2ce2efb5$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $e887188a2ce2efb5$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $e887188a2ce2efb5$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $e887188a2ce2efb5$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $e887188a2ce2efb5$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $e887188a2ce2efb5$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($e887188a2ce2efb5$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $e887188a2ce2efb5$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $e887188a2ce2efb5$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $e887188a2ce2efb5$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $e887188a2ce2efb5$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $e887188a2ce2efb5$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $e887188a2ce2efb5$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $e887188a2ce2efb5$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $e887188a2ce2efb5$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $e887188a2ce2efb5$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $e887188a2ce2efb5$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($e887188a2ce2efb5$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $e887188a2ce2efb5$var$shouldRevalidateLoader(match, $e887188a2ce2efb5$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $e887188a2ce2efb5$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $e887188a2ce2efb5$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $e887188a2ce2efb5$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $e887188a2ce2efb5$var$shouldRevalidateLoader(fetcherMatch, $e887188a2ce2efb5$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $e887188a2ce2efb5$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $e887188a2ce2efb5$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $e887188a2ce2efb5$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $e887188a2ce2efb5$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $e887188a2ce2efb5$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $e887188a2ce2efb5$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$e887188a2ce2efb5$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $e887188a2ce2efb5$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $e887188a2ce2efb5$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$e887188a2ce2efb5$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $e887188a2ce2efb5$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $e887188a2ce2efb5$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $e887188a2ce2efb5$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$e887188a2ce2efb5$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $e887188a2ce2efb5$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $e887188a2ce2efb5$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $e887188a2ce2efb5$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $e887188a2ce2efb5$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $e887188a2ce2efb5$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $e887188a2ce2efb5$var$ResultType.data,
                result: undefined
            });
        };
        return $e887188a2ce2efb5$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $e887188a2ce2efb5$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $e887188a2ce2efb5$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $e887188a2ce2efb5$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $e887188a2ce2efb5$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $e887188a2ce2efb5$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $e887188a2ce2efb5$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $e887188a2ce2efb5$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($e887188a2ce2efb5$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $e887188a2ce2efb5$var$ResultType.error,
                error: e
            };
        }
        if (type === $e887188a2ce2efb5$var$ResultType.error) return {
            type: $e887188a2ce2efb5$var$ResultType.error,
            error: new $e887188a2ce2efb5$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $e887188a2ce2efb5$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $e887188a2ce2efb5$var$ResultType.error) {
        if ($e887188a2ce2efb5$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $e887188a2ce2efb5$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $e887188a2ce2efb5$var$ResultType.error,
                error: new $e887188a2ce2efb5$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $e887188a2ce2efb5$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $e887188a2ce2efb5$var$ResultType.error,
            error: result,
            statusCode: $e887188a2ce2efb5$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($e887188a2ce2efb5$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $e887188a2ce2efb5$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($e887188a2ce2efb5$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $e887188a2ce2efb5$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $e887188a2ce2efb5$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $e887188a2ce2efb5$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $e887188a2ce2efb5$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$e887188a2ce2efb5$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $e887188a2ce2efb5$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $e887188a2ce2efb5$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($e887188a2ce2efb5$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $e887188a2ce2efb5$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $e887188a2ce2efb5$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($e887188a2ce2efb5$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $e887188a2ce2efb5$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $e887188a2ce2efb5$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $e887188a2ce2efb5$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $e887188a2ce2efb5$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $e887188a2ce2efb5$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $e887188a2ce2efb5$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $e887188a2ce2efb5$export$3e9cee6b33872309(!$e887188a2ce2efb5$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($e887188a2ce2efb5$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $e887188a2ce2efb5$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $e887188a2ce2efb5$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($e887188a2ce2efb5$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $e887188a2ce2efb5$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $e887188a2ce2efb5$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $e887188a2ce2efb5$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($e887188a2ce2efb5$var$isErrorResult(result)) {
            let boundaryMatch = $e887188a2ce2efb5$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $e887188a2ce2efb5$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($e887188a2ce2efb5$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $e887188a2ce2efb5$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($e887188a2ce2efb5$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $e887188a2ce2efb5$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $e887188a2ce2efb5$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $e887188a2ce2efb5$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $e887188a2ce2efb5$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $e887188a2ce2efb5$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $e887188a2ce2efb5$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $e887188a2ce2efb5$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $e887188a2ce2efb5$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $e887188a2ce2efb5$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $e887188a2ce2efb5$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $e887188a2ce2efb5$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($e887188a2ce2efb5$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $e887188a2ce2efb5$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $e887188a2ce2efb5$export$8ccf933b0513f8d0(path) : path;
    return $e887188a2ce2efb5$export$fe53371bee54353d($e887188a2ce2efb5$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $e887188a2ce2efb5$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $e887188a2ce2efb5$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $e887188a2ce2efb5$var$ResultType.data || result.type === $e887188a2ce2efb5$var$ResultType.error);
}
function $e887188a2ce2efb5$var$isRedirectDataStrategyResultResult(result) {
    return $e887188a2ce2efb5$var$isResponse(result.result) && $e887188a2ce2efb5$var$redirectStatusCodes.has(result.result.status);
}
function $e887188a2ce2efb5$var$isDeferredResult(result) {
    return result.type === $e887188a2ce2efb5$var$ResultType.deferred;
}
function $e887188a2ce2efb5$var$isErrorResult(result) {
    return result.type === $e887188a2ce2efb5$var$ResultType.error;
}
function $e887188a2ce2efb5$var$isRedirectResult(result) {
    return (result && result.type) === $e887188a2ce2efb5$var$ResultType.redirect;
}
function $e887188a2ce2efb5$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $e887188a2ce2efb5$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $e887188a2ce2efb5$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $e887188a2ce2efb5$var$isRedirectResponse(result) {
    if (!$e887188a2ce2efb5$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $e887188a2ce2efb5$var$isValidMethod(method) {
    return $e887188a2ce2efb5$var$validRequestMethods.has(method.toLowerCase());
}
function $e887188a2ce2efb5$var$isMutationMethod(method) {
    return $e887188a2ce2efb5$var$validMutationMethods.has(method.toLowerCase());
}
async function $e887188a2ce2efb5$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$e887188a2ce2efb5$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($e887188a2ce2efb5$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $e887188a2ce2efb5$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $e887188a2ce2efb5$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($e887188a2ce2efb5$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $e887188a2ce2efb5$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $e887188a2ce2efb5$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $e887188a2ce2efb5$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $e887188a2ce2efb5$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $e887188a2ce2efb5$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $e887188a2ce2efb5$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $e887188a2ce2efb5$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $e887188a2ce2efb5$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $e887188a2ce2efb5$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $e887188a2ce2efb5$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $e887188a2ce2efb5$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $e887188a2ce2efb5$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $e887188a2ce2efb5$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $e887188a2ce2efb5$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $e887188a2ce2efb5$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $e887188a2ce2efb5$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $e887188a2ce2efb5$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $e887188a2ce2efb5$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($e887188a2ce2efb5$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $e887188a2ce2efb5$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($e887188a2ce2efb5$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $e887188a2ce2efb5$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8FY87 = parcelRequire("8FY87");

function $d5fb2d3e42b0c581$var$_extends() {
    $d5fb2d3e42b0c581$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d5fb2d3e42b0c581$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $d5fb2d3e42b0c581$export$3add0d5dce533e2e = /*#__PURE__*/ $8FY87.createContext(null);
const $d5fb2d3e42b0c581$export$145dfa71566a64dc = /*#__PURE__*/ $8FY87.createContext(null);
const $d5fb2d3e42b0c581$var$AwaitContext = /*#__PURE__*/ $8FY87.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $d5fb2d3e42b0c581$export$26749e8557646306 = /*#__PURE__*/ $8FY87.createContext(null);
const $d5fb2d3e42b0c581$export$c7914228fb69b0f5 = /*#__PURE__*/ $8FY87.createContext(null);
const $d5fb2d3e42b0c581$export$9072aa6dd1f93057 = /*#__PURE__*/ $8FY87.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $d5fb2d3e42b0c581$var$RouteErrorContext = /*#__PURE__*/ $8FY87.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $d5fb2d3e42b0c581$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$d5fb2d3e42b0c581$export$9c954a9d03d32f4a() && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $8FY87.useContext($d5fb2d3e42b0c581$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $d5fb2d3e42b0c581$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $e887188a2ce2efb5$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $d5fb2d3e42b0c581$export$9c954a9d03d32f4a() {
    return $8FY87.useContext($d5fb2d3e42b0c581$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $d5fb2d3e42b0c581$export$45d76561a5302f2b() {
    !$d5fb2d3e42b0c581$export$9c954a9d03d32f4a() && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false);
    return $8FY87.useContext($d5fb2d3e42b0c581$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $d5fb2d3e42b0c581$export$1b3f31771c5d07c() {
    return $8FY87.useContext($d5fb2d3e42b0c581$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $d5fb2d3e42b0c581$export$6c330e8992e8a295(pattern) {
    !$d5fb2d3e42b0c581$export$9c954a9d03d32f4a() && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $d5fb2d3e42b0c581$export$45d76561a5302f2b();
    return $8FY87.useMemo(()=>(0, $e887188a2ce2efb5$export$81336c211d5ff295)(pattern, (0, $e887188a2ce2efb5$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $d5fb2d3e42b0c581$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $d5fb2d3e42b0c581$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $8FY87.useContext($d5fb2d3e42b0c581$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $8FY87.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $d5fb2d3e42b0c581$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $8FY87.useContext($d5fb2d3e42b0c581$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $d5fb2d3e42b0c581$var$useNavigateStable() : $d5fb2d3e42b0c581$var$useNavigateUnstable();
}
function $d5fb2d3e42b0c581$var$useNavigateUnstable() {
    !$d5fb2d3e42b0c581$export$9c954a9d03d32f4a() && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false);
    let dataRouterContext = $8FY87.useContext($d5fb2d3e42b0c581$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $8FY87.useContext($d5fb2d3e42b0c581$export$26749e8557646306);
    let { matches: matches } = $8FY87.useContext($d5fb2d3e42b0c581$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $d5fb2d3e42b0c581$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $e887188a2ce2efb5$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $8FY87.useRef(false);
    $d5fb2d3e42b0c581$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $8FY87.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $e887188a2ce2efb5$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $e887188a2ce2efb5$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $d5fb2d3e42b0c581$var$OutletContext = /*#__PURE__*/ $8FY87.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $d5fb2d3e42b0c581$export$4138103a3ae699cc() {
    return $8FY87.useContext($d5fb2d3e42b0c581$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $d5fb2d3e42b0c581$export$a3be3530d8e40d0b(context) {
    let outlet = $8FY87.useContext($d5fb2d3e42b0c581$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $8FY87.createElement($d5fb2d3e42b0c581$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $d5fb2d3e42b0c581$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $8FY87.useContext($d5fb2d3e42b0c581$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $d5fb2d3e42b0c581$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $8FY87.useContext($d5fb2d3e42b0c581$export$26749e8557646306);
    let { matches: matches } = $8FY87.useContext($d5fb2d3e42b0c581$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $d5fb2d3e42b0c581$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $e887188a2ce2efb5$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $8FY87.useMemo(()=>(0, $e887188a2ce2efb5$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $d5fb2d3e42b0c581$export$5d3fca4a98652595(routes, locationArg) {
    return $d5fb2d3e42b0c581$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $d5fb2d3e42b0c581$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$d5fb2d3e42b0c581$export$9c954a9d03d32f4a() && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $8FY87.useContext($d5fb2d3e42b0c581$export$26749e8557646306);
    let { matches: parentMatches } = $8FY87.useContext($d5fb2d3e42b0c581$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $d5fb2d3e42b0c581$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $e887188a2ce2efb5$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $e887188a2ce2efb5$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $d5fb2d3e42b0c581$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $e887188a2ce2efb5$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $e887188a2ce2efb5$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $8FY87.createElement($d5fb2d3e42b0c581$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $d5fb2d3e42b0c581$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $e887188a2ce2efb5$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $d5fb2d3e42b0c581$var$DefaultErrorComponent() {
    let error = $d5fb2d3e42b0c581$export$ed527bf60f6e05f2();
    let message = (0, $e887188a2ce2efb5$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, null, /*#__PURE__*/ $8FY87.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $8FY87.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $8FY87.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $d5fb2d3e42b0c581$var$defaultErrorElement = /*#__PURE__*/ $8FY87.createElement($d5fb2d3e42b0c581$var$DefaultErrorComponent, null);
class $d5fb2d3e42b0c581$var$RenderErrorBoundary extends $8FY87.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $8FY87.createElement($d5fb2d3e42b0c581$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $8FY87.createElement($d5fb2d3e42b0c581$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $d5fb2d3e42b0c581$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $8FY87.useContext($d5fb2d3e42b0c581$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $8FY87.createElement($d5fb2d3e42b0c581$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $d5fb2d3e42b0c581$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $d5fb2d3e42b0c581$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $d5fb2d3e42b0c581$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $8FY87.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $8FY87.createElement($d5fb2d3e42b0c581$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $8FY87.createElement($d5fb2d3e42b0c581$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $d5fb2d3e42b0c581$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($d5fb2d3e42b0c581$var$DataRouterHook || {});
var $d5fb2d3e42b0c581$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($d5fb2d3e42b0c581$var$DataRouterStateHook || {});
function $d5fb2d3e42b0c581$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $d5fb2d3e42b0c581$var$useDataRouterContext(hookName) {
    let ctx = $8FY87.useContext($d5fb2d3e42b0c581$export$3add0d5dce533e2e);
    !ctx && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false);
    return ctx;
}
function $d5fb2d3e42b0c581$var$useDataRouterState(hookName) {
    let state = $8FY87.useContext($d5fb2d3e42b0c581$export$145dfa71566a64dc);
    !state && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false);
    return state;
}
function $d5fb2d3e42b0c581$var$useRouteContext(hookName) {
    let route = $8FY87.useContext($d5fb2d3e42b0c581$export$9072aa6dd1f93057);
    !route && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $d5fb2d3e42b0c581$var$useCurrentRouteId(hookName) {
    let route = $d5fb2d3e42b0c581$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $d5fb2d3e42b0c581$export$5fc8298006ad9e58() {
    return $d5fb2d3e42b0c581$var$useCurrentRouteId($d5fb2d3e42b0c581$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $d5fb2d3e42b0c581$export$d0fd4b7106de2769() {
    let state = $d5fb2d3e42b0c581$var$useDataRouterState($d5fb2d3e42b0c581$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $d5fb2d3e42b0c581$export$600dc272ed516c15() {
    let dataRouterContext = $d5fb2d3e42b0c581$var$useDataRouterContext($d5fb2d3e42b0c581$var$DataRouterHook.UseRevalidator);
    let state = $d5fb2d3e42b0c581$var$useDataRouterState($d5fb2d3e42b0c581$var$DataRouterStateHook.UseRevalidator);
    return $8FY87.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $d5fb2d3e42b0c581$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $d5fb2d3e42b0c581$var$useDataRouterState($d5fb2d3e42b0c581$var$DataRouterStateHook.UseMatches);
    return $8FY87.useMemo(()=>matches.map((m)=>(0, $e887188a2ce2efb5$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $d5fb2d3e42b0c581$export$1448a5050d252c4d() {
    let state = $d5fb2d3e42b0c581$var$useDataRouterState($d5fb2d3e42b0c581$var$DataRouterStateHook.UseLoaderData);
    let routeId = $d5fb2d3e42b0c581$var$useCurrentRouteId($d5fb2d3e42b0c581$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $d5fb2d3e42b0c581$export$fd5d37484eab868d(routeId) {
    let state = $d5fb2d3e42b0c581$var$useDataRouterState($d5fb2d3e42b0c581$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $d5fb2d3e42b0c581$export$fdc00f3f26066d5e() {
    let state = $d5fb2d3e42b0c581$var$useDataRouterState($d5fb2d3e42b0c581$var$DataRouterStateHook.UseActionData);
    let routeId = $d5fb2d3e42b0c581$var$useCurrentRouteId($d5fb2d3e42b0c581$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $d5fb2d3e42b0c581$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $8FY87.useContext($d5fb2d3e42b0c581$var$RouteErrorContext);
    let state = $d5fb2d3e42b0c581$var$useDataRouterState($d5fb2d3e42b0c581$var$DataRouterStateHook.UseRouteError);
    let routeId = $d5fb2d3e42b0c581$var$useCurrentRouteId($d5fb2d3e42b0c581$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $d5fb2d3e42b0c581$export$78a72ddb39bdd145() {
    let value = $8FY87.useContext($d5fb2d3e42b0c581$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $d5fb2d3e42b0c581$export$17f53340677d5831() {
    let value = $8FY87.useContext($d5fb2d3e42b0c581$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $d5fb2d3e42b0c581$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $d5fb2d3e42b0c581$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $d5fb2d3e42b0c581$var$useDataRouterContext($d5fb2d3e42b0c581$var$DataRouterHook.UseBlocker);
    let state = $d5fb2d3e42b0c581$var$useDataRouterState($d5fb2d3e42b0c581$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $8FY87.useState("");
    let blockerFunction = $8FY87.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $d5fb2d3e42b0c581$var$_extends({}, currentLocation, {
                pathname: (0, $e887188a2ce2efb5$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $d5fb2d3e42b0c581$var$_extends({}, nextLocation, {
                pathname: (0, $e887188a2ce2efb5$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $8FY87.useEffect(()=>{
        let key = String(++$d5fb2d3e42b0c581$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $8FY87.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $e887188a2ce2efb5$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $d5fb2d3e42b0c581$var$useNavigateStable() {
    let { router: router } = $d5fb2d3e42b0c581$var$useDataRouterContext($d5fb2d3e42b0c581$var$DataRouterHook.UseNavigateStable);
    let id = $d5fb2d3e42b0c581$var$useCurrentRouteId($d5fb2d3e42b0c581$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $8FY87.useRef(false);
    $d5fb2d3e42b0c581$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $8FY87.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $d5fb2d3e42b0c581$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $d5fb2d3e42b0c581$var$alreadyWarned$1 = {};
function $d5fb2d3e42b0c581$var$warningOnce(key, cond, message) {
    if (!cond && !$d5fb2d3e42b0c581$var$alreadyWarned$1[key]) $d5fb2d3e42b0c581$var$alreadyWarned$1[key] = true;
}
const $d5fb2d3e42b0c581$var$alreadyWarned = {};
function $d5fb2d3e42b0c581$var$warnOnce(key, message) {}
const $d5fb2d3e42b0c581$var$logDeprecation = (flag, msg, link)=>$d5fb2d3e42b0c581$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $d5fb2d3e42b0c581$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $d5fb2d3e42b0c581$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $d5fb2d3e42b0c581$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $d5fb2d3e42b0c581$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $d5fb2d3e42b0c581$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $d5fb2d3e42b0c581$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $d5fb2d3e42b0c581$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $d5fb2d3e42b0c581$var$START_TRANSITION = "startTransition";
const $d5fb2d3e42b0c581$var$startTransitionImpl = $8FY87[$d5fb2d3e42b0c581$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $d5fb2d3e42b0c581$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $8FY87.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8FY87.useCallback((newState)=>{
        if (v7_startTransition && $d5fb2d3e42b0c581$var$startTransitionImpl) $d5fb2d3e42b0c581$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $8FY87.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $8FY87.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $8FY87.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $8FY87.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $8FY87.useEffect(()=>$d5fb2d3e42b0c581$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, null, /*#__PURE__*/ $8FY87.createElement($d5fb2d3e42b0c581$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8FY87.createElement($d5fb2d3e42b0c581$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $8FY87.createElement($d5fb2d3e42b0c581$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $8FY87.createElement($d5fb2d3e42b0c581$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $d5fb2d3e42b0c581$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $d5fb2d3e42b0c581$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $d5fb2d3e42b0c581$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $8FY87.useRef();
    if (historyRef.current == null) historyRef.current = (0, $e887188a2ce2efb5$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8FY87.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8FY87.useCallback((newState)=>{
        v7_startTransition && $d5fb2d3e42b0c581$var$startTransitionImpl ? $d5fb2d3e42b0c581$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8FY87.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8FY87.useEffect(()=>$d5fb2d3e42b0c581$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $8FY87.createElement($d5fb2d3e42b0c581$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $d5fb2d3e42b0c581$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$d5fb2d3e42b0c581$export$9c954a9d03d32f4a() && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $8FY87.useContext($d5fb2d3e42b0c581$export$26749e8557646306);
    let { matches: matches } = $8FY87.useContext($d5fb2d3e42b0c581$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $d5fb2d3e42b0c581$export$45d76561a5302f2b();
    let navigate = $d5fb2d3e42b0c581$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $e887188a2ce2efb5$export$cae722b0cc860f13)(to, (0, $e887188a2ce2efb5$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $8FY87.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $d5fb2d3e42b0c581$export$910ae8079b2c2852(props) {
    return $d5fb2d3e42b0c581$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $d5fb2d3e42b0c581$export$e7b0ac011bb776c6(_props) {
    (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $d5fb2d3e42b0c581$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $e887188a2ce2efb5$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$d5fb2d3e42b0c581$export$9c954a9d03d32f4a() && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $8FY87.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $d5fb2d3e42b0c581$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $e887188a2ce2efb5$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $8FY87.useMemo(()=>{
        let trailingPathname = (0, $e887188a2ce2efb5$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $8FY87.createElement($d5fb2d3e42b0c581$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $8FY87.createElement($d5fb2d3e42b0c581$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $d5fb2d3e42b0c581$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $d5fb2d3e42b0c581$export$5d3fca4a98652595($d5fb2d3e42b0c581$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $d5fb2d3e42b0c581$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $8FY87.createElement($d5fb2d3e42b0c581$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $8FY87.createElement($d5fb2d3e42b0c581$var$ResolveAwait, null, children));
}
var $d5fb2d3e42b0c581$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($d5fb2d3e42b0c581$var$AwaitRenderStatus || {});
const $d5fb2d3e42b0c581$var$neverSettledPromise = new Promise(()=>{});
class $d5fb2d3e42b0c581$var$AwaitErrorBoundary extends $8FY87.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $d5fb2d3e42b0c581$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $d5fb2d3e42b0c581$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $d5fb2d3e42b0c581$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $d5fb2d3e42b0c581$var$AwaitRenderStatus.error : "_data" in promise ? $d5fb2d3e42b0c581$var$AwaitRenderStatus.success : $d5fb2d3e42b0c581$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $d5fb2d3e42b0c581$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $d5fb2d3e42b0c581$var$AwaitRenderStatus.error && promise._error instanceof (0, $e887188a2ce2efb5$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $d5fb2d3e42b0c581$var$neverSettledPromise;
        if (status === $d5fb2d3e42b0c581$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $d5fb2d3e42b0c581$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $8FY87.createElement($d5fb2d3e42b0c581$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $d5fb2d3e42b0c581$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $8FY87.createElement($d5fb2d3e42b0c581$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $d5fb2d3e42b0c581$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $d5fb2d3e42b0c581$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $d5fb2d3e42b0c581$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $8FY87.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $8FY87.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $8FY87.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $d5fb2d3e42b0c581$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $d5fb2d3e42b0c581$export$e7b0ac011bb776c6) && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $d5fb2d3e42b0c581$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $d5fb2d3e42b0c581$export$daf73786167a7f72(matches) {
    return $d5fb2d3e42b0c581$var$_renderMatches(matches);
}
function $d5fb2d3e42b0c581$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $8FY87.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $8FY87.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $8FY87.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $d5fb2d3e42b0c581$export$f30f7e456d254e83(routes, opts) {
    return (0, $e887188a2ce2efb5$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $d5fb2d3e42b0c581$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $e887188a2ce2efb5$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $d5fb2d3e42b0c581$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $734169eef5d6795a$var$_extends() {
    $734169eef5d6795a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $734169eef5d6795a$var$_extends.apply(this, arguments);
}
function $734169eef5d6795a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $734169eef5d6795a$var$defaultMethod = "get";
const $734169eef5d6795a$var$defaultEncType = "application/x-www-form-urlencoded";
function $734169eef5d6795a$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $734169eef5d6795a$var$isButtonElement(object) {
    return $734169eef5d6795a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $734169eef5d6795a$var$isFormElement(object) {
    return $734169eef5d6795a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $734169eef5d6795a$var$isInputElement(object) {
    return $734169eef5d6795a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $734169eef5d6795a$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $734169eef5d6795a$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$734169eef5d6795a$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $734169eef5d6795a$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $734169eef5d6795a$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $734169eef5d6795a$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $734169eef5d6795a$var$_formDataSupportsSubmitter = null;
function $734169eef5d6795a$var$isFormDataSubmitterSupported() {
    if ($734169eef5d6795a$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $734169eef5d6795a$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $734169eef5d6795a$var$_formDataSupportsSubmitter = true;
    }
    return $734169eef5d6795a$var$_formDataSupportsSubmitter;
}
const $734169eef5d6795a$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $734169eef5d6795a$var$getFormEncType(encType) {
    if (encType != null && !$734169eef5d6795a$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $734169eef5d6795a$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($734169eef5d6795a$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $e887188a2ce2efb5$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $734169eef5d6795a$var$defaultMethod;
        encType = $734169eef5d6795a$var$getFormEncType(target.getAttribute("enctype")) || $734169eef5d6795a$var$defaultEncType;
        formData = new FormData(target);
    } else if ($734169eef5d6795a$var$isButtonElement(target) || $734169eef5d6795a$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $e887188a2ce2efb5$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $734169eef5d6795a$var$defaultMethod;
        encType = $734169eef5d6795a$var$getFormEncType(target.getAttribute("formenctype")) || $734169eef5d6795a$var$getFormEncType(form.getAttribute("enctype")) || $734169eef5d6795a$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$734169eef5d6795a$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($734169eef5d6795a$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $734169eef5d6795a$var$defaultMethod;
        action = null;
        encType = $734169eef5d6795a$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $734169eef5d6795a$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $734169eef5d6795a$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $734169eef5d6795a$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $734169eef5d6795a$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $734169eef5d6795a$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $734169eef5d6795a$export$1f3f55432a00e06d(routes, opts) {
    return (0, $e887188a2ce2efb5$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $734169eef5d6795a$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $e887188a2ce2efb5$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $734169eef5d6795a$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $d5fb2d3e42b0c581$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $734169eef5d6795a$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $e887188a2ce2efb5$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $734169eef5d6795a$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $e887188a2ce2efb5$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $734169eef5d6795a$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $d5fb2d3e42b0c581$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $734169eef5d6795a$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $734169eef5d6795a$var$_extends({}, state, {
        errors: $734169eef5d6795a$var$deserializeErrors(state.errors)
    });
    return state;
}
function $734169eef5d6795a$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $e887188a2ce2efb5$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $734169eef5d6795a$export$7ad602f0e94e62d1 = /*#__PURE__*/ $8FY87.createContext({
    isTransitioning: false
});
const $734169eef5d6795a$export$148fd98d095596d4 = /*#__PURE__*/ $8FY87.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $734169eef5d6795a$var$START_TRANSITION = "startTransition";
const $734169eef5d6795a$var$startTransitionImpl = $8FY87[$734169eef5d6795a$var$START_TRANSITION];
const $734169eef5d6795a$var$FLUSH_SYNC = "flushSync";
const $734169eef5d6795a$var$flushSyncImpl = $69d169f7fc8722a7$exports[$734169eef5d6795a$var$FLUSH_SYNC];
const $734169eef5d6795a$var$USE_ID = "useId";
const $734169eef5d6795a$var$useIdImpl = $8FY87[$734169eef5d6795a$var$USE_ID];
function $734169eef5d6795a$var$startTransitionSafe(cb) {
    if ($734169eef5d6795a$var$startTransitionImpl) $734169eef5d6795a$var$startTransitionImpl(cb);
    else cb();
}
function $734169eef5d6795a$var$flushSyncSafe(cb) {
    if ($734169eef5d6795a$var$flushSyncImpl) $734169eef5d6795a$var$flushSyncImpl(cb);
    else cb();
}
class $734169eef5d6795a$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $734169eef5d6795a$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $8FY87.useState(router.state);
    let [pendingState, setPendingState] = $8FY87.useState();
    let [vtContext, setVtContext] = $8FY87.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $8FY87.useState();
    let [transition, setTransition] = $8FY87.useState();
    let [interruption, setInterruption] = $8FY87.useState();
    let fetcherData = $8FY87.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $8FY87.useCallback((cb)=>{
        if (v7_startTransition) $734169eef5d6795a$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $8FY87.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $734169eef5d6795a$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $734169eef5d6795a$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $734169eef5d6795a$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $734169eef5d6795a$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $734169eef5d6795a$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $8FY87.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $8FY87.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $734169eef5d6795a$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $8FY87.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $8FY87.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $8FY87.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $8FY87.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $8FY87.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $8FY87.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $8FY87.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $8FY87.useEffect(()=>(0, $d5fb2d3e42b0c581$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, null, /*#__PURE__*/ $8FY87.createElement((0, $d5fb2d3e42b0c581$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8FY87.createElement((0, $d5fb2d3e42b0c581$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $8FY87.createElement($734169eef5d6795a$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $8FY87.createElement($734169eef5d6795a$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $8FY87.createElement((0, $d5fb2d3e42b0c581$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $8FY87.createElement($734169eef5d6795a$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $734169eef5d6795a$var$MemoizedDataRoutes = /*#__PURE__*/ $8FY87.memo($734169eef5d6795a$var$DataRoutes);
function $734169eef5d6795a$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $d5fb2d3e42b0c581$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $734169eef5d6795a$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $8FY87.useRef();
    if (historyRef.current == null) historyRef.current = (0, $e887188a2ce2efb5$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8FY87.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8FY87.useCallback((newState)=>{
        v7_startTransition && $734169eef5d6795a$var$startTransitionImpl ? $734169eef5d6795a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8FY87.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8FY87.useEffect(()=>(0, $d5fb2d3e42b0c581$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $8FY87.createElement((0, $d5fb2d3e42b0c581$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $734169eef5d6795a$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $8FY87.useRef();
    if (historyRef.current == null) historyRef.current = (0, $e887188a2ce2efb5$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8FY87.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8FY87.useCallback((newState)=>{
        v7_startTransition && $734169eef5d6795a$var$startTransitionImpl ? $734169eef5d6795a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8FY87.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8FY87.useEffect(()=>(0, $d5fb2d3e42b0c581$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $8FY87.createElement((0, $d5fb2d3e42b0c581$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $734169eef5d6795a$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $8FY87.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8FY87.useCallback((newState)=>{
        v7_startTransition && $734169eef5d6795a$var$startTransitionImpl ? $734169eef5d6795a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8FY87.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8FY87.useEffect(()=>(0, $d5fb2d3e42b0c581$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $8FY87.createElement((0, $d5fb2d3e42b0c581$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $734169eef5d6795a$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $734169eef5d6795a$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $734169eef5d6795a$export$a6c7ac8248d6e38a = /*#__PURE__*/ $8FY87.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $734169eef5d6795a$var$_objectWithoutPropertiesLoose(_ref7, $734169eef5d6795a$var$_excluded);
    let { basename: basename } = $8FY87.useContext((0, $d5fb2d3e42b0c581$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $734169eef5d6795a$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($734169eef5d6795a$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $e887188a2ce2efb5$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $d5fb2d3e42b0c581$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $734169eef5d6795a$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $8FY87.createElement("a", $734169eef5d6795a$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $734169eef5d6795a$export$b0d92dbee9b5b60d = /*#__PURE__*/ $8FY87.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $734169eef5d6795a$var$_objectWithoutPropertiesLoose(_ref8, $734169eef5d6795a$var$_excluded2);
    let path = (0, $d5fb2d3e42b0c581$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)();
    let routerState = $8FY87.useContext((0, $d5fb2d3e42b0c581$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $8FY87.useContext((0, $d5fb2d3e42b0c581$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $734169eef5d6795a$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $e887188a2ce2efb5$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $8FY87.createElement($734169eef5d6795a$export$a6c7ac8248d6e38a, $734169eef5d6795a$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $734169eef5d6795a$export$a7fed597f4b8afd8 = /*#__PURE__*/ $8FY87.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $734169eef5d6795a$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $734169eef5d6795a$var$_objectWithoutPropertiesLoose(_ref9, $734169eef5d6795a$var$_excluded3);
    let submit = $734169eef5d6795a$export$47c85c6e3a081d3();
    let formAction = $734169eef5d6795a$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $8FY87.createElement("form", $734169eef5d6795a$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $734169eef5d6795a$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $734169eef5d6795a$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $734169eef5d6795a$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($734169eef5d6795a$var$DataRouterHook || ($734169eef5d6795a$var$DataRouterHook = {}));
var $734169eef5d6795a$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($734169eef5d6795a$var$DataRouterStateHook || ($734169eef5d6795a$var$DataRouterStateHook = {}));
// Internal hooks
function $734169eef5d6795a$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $734169eef5d6795a$var$useDataRouterContext(hookName) {
    let ctx = $8FY87.useContext((0, $d5fb2d3e42b0c581$export$3add0d5dce533e2e));
    !ctx && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false);
    return ctx;
}
function $734169eef5d6795a$var$useDataRouterState(hookName) {
    let state = $8FY87.useContext((0, $d5fb2d3e42b0c581$export$145dfa71566a64dc));
    !state && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $734169eef5d6795a$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    let location = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)();
    let path = (0, $d5fb2d3e42b0c581$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $8FY87.useCallback((event)=>{
        if ($734169eef5d6795a$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $e887188a2ce2efb5$export$fe53371bee54353d)(location) === (0, $e887188a2ce2efb5$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $734169eef5d6795a$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $8FY87.useRef($734169eef5d6795a$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $8FY87.useRef(false);
    let location = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)();
    let searchParams = $8FY87.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $734169eef5d6795a$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    let setSearchParams = $8FY87.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $734169eef5d6795a$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $734169eef5d6795a$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $734169eef5d6795a$var$fetcherId = 0;
let $734169eef5d6795a$var$getUniqueFetcherId = ()=>"__" + String(++$734169eef5d6795a$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $734169eef5d6795a$export$47c85c6e3a081d3() {
    let { router: router } = $734169eef5d6795a$var$useDataRouterContext($734169eef5d6795a$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $8FY87.useContext((0, $d5fb2d3e42b0c581$export$26749e8557646306));
    let currentRouteId = (0, $d5fb2d3e42b0c581$export$5fc8298006ad9e58)();
    return $8FY87.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $734169eef5d6795a$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $734169eef5d6795a$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $734169eef5d6795a$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $734169eef5d6795a$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $8FY87.useContext((0, $d5fb2d3e42b0c581$export$26749e8557646306));
    let routeContext = $8FY87.useContext((0, $d5fb2d3e42b0c581$export$9072aa6dd1f93057));
    !routeContext && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $734169eef5d6795a$var$_extends({}, (0, $d5fb2d3e42b0c581$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $e887188a2ce2efb5$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $e887188a2ce2efb5$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $734169eef5d6795a$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $734169eef5d6795a$var$useDataRouterContext($734169eef5d6795a$var$DataRouterHook.UseFetcher);
    let state = $734169eef5d6795a$var$useDataRouterState($734169eef5d6795a$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $8FY87.useContext($734169eef5d6795a$export$148fd98d095596d4);
    let route = $8FY87.useContext((0, $d5fb2d3e42b0c581$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false);
    !route && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $734169eef5d6795a$var$useIdImpl ? $734169eef5d6795a$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $8FY87.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($734169eef5d6795a$var$getUniqueFetcherId());
    // Registration/cleanup
    $8FY87.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $8FY87.useCallback((href, opts)=>{
        !routeId && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $734169eef5d6795a$export$47c85c6e3a081d3();
    let submit = $8FY87.useCallback((target, opts)=>{
        submitImpl(target, $734169eef5d6795a$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $8FY87.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $8FY87.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $8FY87.createElement($734169eef5d6795a$export$a7fed597f4b8afd8, $734169eef5d6795a$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $e887188a2ce2efb5$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $8FY87.useMemo(()=>$734169eef5d6795a$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $734169eef5d6795a$export$fa996778a3a31087() {
    let state = $734169eef5d6795a$var$useDataRouterState($734169eef5d6795a$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $734169eef5d6795a$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $734169eef5d6795a$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $734169eef5d6795a$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $734169eef5d6795a$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $734169eef5d6795a$var$useDataRouterContext($734169eef5d6795a$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $734169eef5d6795a$var$useDataRouterState($734169eef5d6795a$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $8FY87.useContext((0, $d5fb2d3e42b0c581$export$26749e8557646306));
    let location = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)();
    let matches = (0, $d5fb2d3e42b0c581$export$2378eb7f5ff86053)();
    let navigation = (0, $d5fb2d3e42b0c581$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $8FY87.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $734169eef5d6795a$var$usePageHide($8FY87.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $734169eef5d6795a$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $734169eef5d6795a$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($734169eef5d6795a$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8FY87.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $734169eef5d6795a$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $734169eef5d6795a$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8FY87.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($734169eef5d6795a$var$_extends({}, location, {
                    pathname: (0, $e887188a2ce2efb5$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($734169eef5d6795a$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8FY87.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $734169eef5d6795a$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $8FY87.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $734169eef5d6795a$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $8FY87.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $734169eef5d6795a$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $d5fb2d3e42b0c581$export$b273b3273281a049)(when);
    $8FY87.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $8FY87.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $734169eef5d6795a$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $8FY87.useContext($734169eef5d6795a$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false);
    let { basename: basename } = $734169eef5d6795a$var$useDataRouterContext($734169eef5d6795a$var$DataRouterHook.useViewTransitionState);
    let path = (0, $d5fb2d3e42b0c581$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $e887188a2ce2efb5$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $e887188a2ce2efb5$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $e887188a2ce2efb5$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $e887188a2ce2efb5$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $8FY87 = parcelRequire("8FY87");


var $7c8f2ac2998e8e4d$exports = {};
"use strict";
"use client";

var $bcBLN = parcelRequire("bcBLN");
Object.defineProperty($7c8f2ac2998e8e4d$exports, "__esModule", {
    value: true
});
$7c8f2ac2998e8e4d$exports.default = void 0;

var $7c8f2ac2998e8e4d$var$_createSvgIcon = $bcBLN((parcelRequire("485sq")));

var $2PPWI = parcelRequire("2PPWI");
var $7c8f2ac2998e8e4d$var$_default = $7c8f2ac2998e8e4d$exports.default = (0, $7c8f2ac2998e8e4d$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
        d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75M19 19H5V5h14z"
    }, "0"),
    /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
        d: "m15.08 11.03-2.12-2.12L7 14.86V17h2.1zm1.77-1.76c.2-.2.2-.51 0-.71l-1.41-1.41c-.2-.2-.51-.2-.71 0l-1.06 1.06 2.12 2.12z"
    }, "1")
], 'NoteAltOutlined');



var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $lXBIJ = parcelRequire("lXBIJ");

var $1r55V = parcelRequire("1r55V");

var $lbp1P = parcelRequire("lbp1P");

var $6lkQ3 = parcelRequire("6lkQ3");

var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $f2d3e61fef1da6e8$export$46f01d01378ec5a2(slot) {
    return (0, $jP65K.default)('MuiDivider', slot);
}
const $f2d3e61fef1da6e8$var$dividerClasses = (0, $cOYaX.default)('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'light',
    'vertical',
    'withChildren',
    'withChildrenVertical',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
var $f2d3e61fef1da6e8$export$2e2bcd8739ae039 = $f2d3e61fef1da6e8$var$dividerClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $30a538faf9a95dbb$var$_excluded = [
    "absolute",
    "children",
    "className",
    "component",
    "flexItem",
    "light",
    "orientation",
    "role",
    "textAlign",
    "variant"
];
const $30a538faf9a95dbb$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            absolute && 'absolute',
            variant,
            light && 'light',
            orientation === 'vertical' && 'vertical',
            flexItem && 'flexItem',
            children && 'withChildren',
            children && orientation === 'vertical' && 'withChildrenVertical',
            textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight',
            textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'
        ],
        wrapper: [
            'wrapper',
            orientation === 'vertical' && 'wrapperVertical'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $f2d3e61fef1da6e8$export$46f01d01378ec5a2), classes);
};
const $30a538faf9a95dbb$var$DividerRoot = (0, $lbp1P.default)('div', {
    name: 'MuiDivider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical,
            ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight,
            ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $zgVxD.default)({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: 'thin'
    }, ownerState.absolute && {
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%'
    }, ownerState.light && {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, $1r55V.alpha)(theme.palette.divider, 0.08)
    }, ownerState.variant === 'inset' && {
        marginLeft: 72
    }, ownerState.variant === 'middle' && ownerState.orientation === 'horizontal' && {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    }, ownerState.variant === 'middle' && ownerState.orientation === 'vertical' && {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    }, ownerState.orientation === 'vertical' && {
        height: '100%',
        borderBottomWidth: 0,
        borderRightWidth: 'thin'
    }, ownerState.flexItem && {
        alignSelf: 'stretch',
        height: 'auto'
    }), ({ ownerState: ownerState })=>(0, $zgVxD.default)({}, ownerState.children && {
        display: 'flex',
        whiteSpace: 'nowrap',
        textAlign: 'center',
        border: 0,
        borderTopStyle: 'solid',
        borderLeftStyle: 'solid',
        '&::before, &::after': {
            content: '""',
            alignSelf: 'center'
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $zgVxD.default)({}, ownerState.children && ownerState.orientation !== 'vertical' && {
        '&::before, &::after': {
            width: '100%',
            borderTop: `thin solid ${(theme.vars || theme).palette.divider}`,
            borderTopStyle: 'inherit'
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $zgVxD.default)({}, ownerState.children && ownerState.orientation === 'vertical' && {
        flexDirection: 'column',
        '&::before, &::after': {
            height: '100%',
            borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`,
            borderLeftStyle: 'inherit'
        }
    }), ({ ownerState: ownerState })=>(0, $zgVxD.default)({}, ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && {
        '&::before': {
            width: '90%'
        },
        '&::after': {
            width: '10%'
        }
    }, ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && {
        '&::before': {
            width: '10%'
        },
        '&::after': {
            width: '90%'
        }
    }));
const $30a538faf9a95dbb$var$DividerWrapper = (0, $lbp1P.default)('span', {
    name: 'MuiDivider',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === 'vertical' && styles.wrapperVertical
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $zgVxD.default)({
        display: 'inline-block',
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`
    }, ownerState.orientation === 'vertical' && {
        paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
        paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
    }));
const $30a538faf9a95dbb$var$Divider = /*#__PURE__*/ $8FY87.forwardRef(function Divider(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiDivider'
    });
    const { absolute: absolute = false, children: children, className: className, component: component = children ? 'div' : 'hr', flexItem: flexItem = false, light: light = false, orientation: orientation = 'horizontal', role: role = component !== 'hr' ? 'separator' : undefined, textAlign: textAlign = 'center', variant: variant = 'fullWidth' } = props, other = (0, $93aRW.default)(props, $30a538faf9a95dbb$var$_excluded);
    const ownerState = (0, $zgVxD.default)({}, props, {
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    });
    const classes = $30a538faf9a95dbb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2PPWI.jsx)($30a538faf9a95dbb$var$DividerRoot, (0, $zgVxD.default)({
        as: component,
        className: (0, $efJYy.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children ? /*#__PURE__*/ (0, $2PPWI.jsx)($30a538faf9a95dbb$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    }));
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ $30a538faf9a95dbb$var$Divider.muiSkipListHighlight = true;
var $30a538faf9a95dbb$export$2e2bcd8739ae039 = $30a538faf9a95dbb$var$Divider;


var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");


var $lXBIJ = parcelRequire("lXBIJ");

var $ifmKX = parcelRequire("ifmKX");

var $lbp1P = parcelRequire("lbp1P");

var $6lkQ3 = parcelRequire("6lkQ3");

var $8FY87 = parcelRequire("8FY87");

var $8FY87 = parcelRequire("8FY87");
'use client';
const $b789a237cc6bd607$var$UNINITIALIZED = {};
function $b789a237cc6bd607$export$2e2bcd8739ae039(init, initArg) {
    const ref = $8FY87.useRef($b789a237cc6bd607$var$UNINITIALIZED);
    if (ref.current === $b789a237cc6bd607$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}



var $8FY87 = parcelRequire("8FY87");
'use client';
const $c3d79f37ce54c0ba$var$EMPTY = [];
function $c3d79f37ce54c0ba$export$2e2bcd8739ae039(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $8FY87.useEffect(fn, $c3d79f37ce54c0ba$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


'use client';
class $d5603345799722cb$export$786b4da70f00938b {
    constructor(){
        this.currentId = null;
        this.clear = ()=>{
            if (this.currentId !== null) {
                clearTimeout(this.currentId);
                this.currentId = null;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
    static create() {
        return new $d5603345799722cb$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
}
function $d5603345799722cb$export$2e2bcd8739ae039() {
    const timeout = (0, $b789a237cc6bd607$export$2e2bcd8739ae039)($d5603345799722cb$export$786b4da70f00938b.create).current;
    (0, $c3d79f37ce54c0ba$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}


'use client';
let $3f033a9a8b6f697d$var$hadKeyboardEvent = true;
let $3f033a9a8b6f697d$var$hadFocusVisibleRecently = false;
const $3f033a9a8b6f697d$var$hadFocusVisibleRecentlyTimeout = new (0, $d5603345799722cb$export$786b4da70f00938b)();
const $3f033a9a8b6f697d$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $3f033a9a8b6f697d$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === 'INPUT' && $3f033a9a8b6f697d$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === 'TEXTAREA' && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $3f033a9a8b6f697d$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $3f033a9a8b6f697d$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $3f033a9a8b6f697d$var$handlePointerDown() {
    $3f033a9a8b6f697d$var$hadKeyboardEvent = false;
}
function $3f033a9a8b6f697d$var$handleVisibilityChange() {
    if (this.visibilityState === 'hidden') // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($3f033a9a8b6f697d$var$hadFocusVisibleRecently) $3f033a9a8b6f697d$var$hadKeyboardEvent = true;
    }
}
function $3f033a9a8b6f697d$var$prepare(doc) {
    doc.addEventListener('keydown', $3f033a9a8b6f697d$var$handleKeyDown, true);
    doc.addEventListener('mousedown', $3f033a9a8b6f697d$var$handlePointerDown, true);
    doc.addEventListener('pointerdown', $3f033a9a8b6f697d$var$handlePointerDown, true);
    doc.addEventListener('touchstart', $3f033a9a8b6f697d$var$handlePointerDown, true);
    doc.addEventListener('visibilitychange', $3f033a9a8b6f697d$var$handleVisibilityChange, true);
}
function $3f033a9a8b6f697d$export$4794d9b1949031cf(doc) {
    doc.removeEventListener('keydown', $3f033a9a8b6f697d$var$handleKeyDown, true);
    doc.removeEventListener('mousedown', $3f033a9a8b6f697d$var$handlePointerDown, true);
    doc.removeEventListener('pointerdown', $3f033a9a8b6f697d$var$handlePointerDown, true);
    doc.removeEventListener('touchstart', $3f033a9a8b6f697d$var$handlePointerDown, true);
    doc.removeEventListener('visibilitychange', $3f033a9a8b6f697d$var$handleVisibilityChange, true);
}
function $3f033a9a8b6f697d$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(':focus-visible');
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $3f033a9a8b6f697d$var$hadKeyboardEvent || $3f033a9a8b6f697d$var$focusTriggersKeyboardModality(target);
}
function $3f033a9a8b6f697d$export$2e2bcd8739ae039() {
    const ref = $8FY87.useCallback((node)=>{
        if (node != null) $3f033a9a8b6f697d$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $8FY87.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $3f033a9a8b6f697d$var$hadFocusVisibleRecently = true;
            $3f033a9a8b6f697d$var$hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                $3f033a9a8b6f697d$var$hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($3f033a9a8b6f697d$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


'use client';
var $f6854f6315de19cb$export$2e2bcd8739ae039 = (0, $3f033a9a8b6f697d$export$2e2bcd8739ae039);



var $8FY87 = parcelRequire("8FY87");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $2b147962174f16a5$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}


'use client';
function $a44e6282d60cc47f$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $8FY87.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $2b147962174f16a5$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


'use client';
var $520629ff5b0e6bac$export$2e2bcd8739ae039 = (0, $a44e6282d60cc47f$export$2e2bcd8739ae039);



var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $bZmXB = parcelRequire("bZmXB");

var $lXBIJ = parcelRequire("lXBIJ");

var $lbp1P = parcelRequire("lbp1P");

var $6lkQ3 = parcelRequire("6lkQ3");

var $ifmKX = parcelRequire("ifmKX");

var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $e8d75f79e14171fa$export$24c1f8f60cbac79e(slot) {
    return (0, $jP65K.default)('MuiTypography', slot);
}
const $e8d75f79e14171fa$var$typographyClasses = (0, $cOYaX.default)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $e8d75f79e14171fa$export$2e2bcd8739ae039 = $e8d75f79e14171fa$var$typographyClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $9e9a2c609bdcf2f0$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $9e9a2c609bdcf2f0$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $ifmKX.default)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $e8d75f79e14171fa$export$24c1f8f60cbac79e), classes);
};
const $9e9a2c609bdcf2f0$export$140e2f5526d3cad8 = (0, $lbp1P.default)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $ifmKX.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $zgVxD.default)({
        margin: 0
    }, ownerState.variant === 'inherit' && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: 'inherit'
    }, ownerState.variant !== 'inherit' && theme.typography[ownerState.variant], ownerState.align !== 'inherit' && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, ownerState.gutterBottom && {
        marginBottom: '0.35em'
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $9e9a2c609bdcf2f0$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $9e9a2c609bdcf2f0$var$colorTransformations = {
    primary: 'primary.main',
    textPrimary: 'text.primary',
    secondary: 'secondary.main',
    textSecondary: 'text.secondary',
    error: 'error.main'
};
const $9e9a2c609bdcf2f0$var$transformDeprecatedColors = (color)=>{
    return $9e9a2c609bdcf2f0$var$colorTransformations[color] || color;
};
const $9e9a2c609bdcf2f0$var$Typography = /*#__PURE__*/ $8FY87.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiTypography'
    });
    const color = $9e9a2c609bdcf2f0$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $bZmXB.default)((0, $zgVxD.default)({}, themeProps, {
        color: color
    }));
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $9e9a2c609bdcf2f0$var$defaultVariantMapping } = props, other = (0, $93aRW.default)(props, $9e9a2c609bdcf2f0$var$_excluded);
    const ownerState = (0, $zgVxD.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $9e9a2c609bdcf2f0$var$defaultVariantMapping[variant]) || 'span';
    const classes = $9e9a2c609bdcf2f0$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2PPWI.jsx)($9e9a2c609bdcf2f0$export$140e2f5526d3cad8, (0, $zgVxD.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $efJYy.default)(classes.root, className)
    }, other));
});
var $9e9a2c609bdcf2f0$export$2e2bcd8739ae039 = $9e9a2c609bdcf2f0$var$Typography;



var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $ae084451c80eba83$export$d6efab9620b78fec(slot) {
    return (0, $jP65K.default)('MuiLink', slot);
}
const $ae084451c80eba83$var$linkClasses = (0, $cOYaX.default)('MuiLink', [
    'root',
    'underlineNone',
    'underlineHover',
    'underlineAlways',
    'button',
    'focusVisible'
]);
var $ae084451c80eba83$export$2e2bcd8739ae039 = $ae084451c80eba83$var$linkClasses;



var $iZBtv = parcelRequire("iZBtv");

var $1r55V = parcelRequire("1r55V");
const $ab8f05c2336660a5$export$c4e140d5d351182b = {
    primary: 'primary.main',
    textPrimary: 'text.primary',
    secondary: 'secondary.main',
    textSecondary: 'text.secondary',
    error: 'error.main'
};
const $ab8f05c2336660a5$var$transformDeprecatedColors = (color)=>{
    return $ab8f05c2336660a5$export$c4e140d5d351182b[color] || color;
};
const $ab8f05c2336660a5$var$getTextDecoration = ({ theme: theme, ownerState: ownerState })=>{
    const transformedColor = $ab8f05c2336660a5$var$transformDeprecatedColors(ownerState.color);
    const color = (0, $iZBtv.getPath)(theme, `palette.${transformedColor}`, false) || ownerState.color;
    const channelColor = (0, $iZBtv.getPath)(theme, `palette.${transformedColor}Channel`);
    if ('vars' in theme && channelColor) return `rgba(${channelColor} / 0.4)`;
    return (0, $1r55V.alpha)(color, 0.4);
};
var $ab8f05c2336660a5$export$2e2bcd8739ae039 = $ab8f05c2336660a5$var$getTextDecoration;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $89a5149760fde35d$var$_excluded = [
    "className",
    "color",
    "component",
    "onBlur",
    "onFocus",
    "TypographyClasses",
    "underline",
    "variant",
    "sx"
];
const $89a5149760fde35d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, component: component, focusVisible: focusVisible, underline: underline } = ownerState;
    const slots = {
        root: [
            'root',
            `underline${(0, $ifmKX.default)(underline)}`,
            component === 'button' && 'button',
            focusVisible && 'focusVisible'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $ae084451c80eba83$export$d6efab9620b78fec), classes);
};
const $89a5149760fde35d$var$LinkRoot = (0, $lbp1P.default)((0, $9e9a2c609bdcf2f0$export$2e2bcd8739ae039), {
    name: 'MuiLink',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`underline${(0, $ifmKX.default)(ownerState.underline)}`],
            ownerState.component === 'button' && styles.button
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    return (0, $zgVxD.default)({}, ownerState.underline === 'none' && {
        textDecoration: 'none'
    }, ownerState.underline === 'hover' && {
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline'
        }
    }, ownerState.underline === 'always' && (0, $zgVxD.default)({
        textDecoration: 'underline'
    }, ownerState.color !== 'inherit' && {
        textDecorationColor: (0, $ab8f05c2336660a5$export$2e2bcd8739ae039)({
            theme: theme,
            ownerState: ownerState
        })
    }, {
        '&:hover': {
            textDecorationColor: 'inherit'
        }
    }), ownerState.component === 'button' && {
        position: 'relative',
        WebkitTapHighlightColor: 'transparent',
        backgroundColor: 'transparent',
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: 'pointer',
        userSelect: 'none',
        verticalAlign: 'middle',
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // Reset
        '&::-moz-focus-inner': {
            borderStyle: 'none' // Remove Firefox dotted outline.
        },
        [`&.${(0, $ae084451c80eba83$export$2e2bcd8739ae039).focusVisible}`]: {
            outline: 'auto'
        }
    });
});
const $89a5149760fde35d$var$Link = /*#__PURE__*/ $8FY87.forwardRef(function Link(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiLink'
    });
    const { className: className, color: color = 'primary', component: component = 'a', onBlur: onBlur, onFocus: onFocus, TypographyClasses: TypographyClasses, underline: underline = 'always', variant: variant = 'inherit', sx: sx } = props, other = (0, $93aRW.default)(props, $89a5149760fde35d$var$_excluded);
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $f6854f6315de19cb$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $8FY87.useState(false);
    const handlerRef = (0, $520629ff5b0e6bac$export$2e2bcd8739ae039)(ref, focusVisibleRef);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = (0, $zgVxD.default)({}, props, {
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    });
    const classes = $89a5149760fde35d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2PPWI.jsx)($89a5149760fde35d$var$LinkRoot, (0, $zgVxD.default)({
        color: color,
        className: (0, $efJYy.default)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: handlerRef,
        ownerState: ownerState,
        variant: variant,
        sx: [
            ...!Object.keys((0, $ab8f05c2336660a5$export$c4e140d5d351182b)).includes(color) ? [
                {
                    color: color
                }
            ] : [],
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ]
    }, other));
});
var $89a5149760fde35d$export$2e2bcd8739ae039 = $89a5149760fde35d$var$Link;



var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $1p637 = parcelRequire("1p637");

var $lXBIJ = parcelRequire("lXBIJ");

var $1r55V = parcelRequire("1r55V");

var $lbp1P = parcelRequire("lbp1P");
var $awHZI = parcelRequire("awHZI");

var $6lkQ3 = parcelRequire("6lkQ3");

var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");



var $lXBIJ = parcelRequire("lXBIJ");

var $lbp1P = parcelRequire("lbp1P");

var $6lkQ3 = parcelRequire("6lkQ3");


var $8FY87 = parcelRequire("8FY87");

var $8FY87 = parcelRequire("8FY87");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $1eb4765744b30085$var$useEnhancedEffect = typeof window !== 'undefined' ? $8FY87.useLayoutEffect : $8FY87.useEffect;
var $1eb4765744b30085$export$2e2bcd8739ae039 = $1eb4765744b30085$var$useEnhancedEffect;


'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $3e2c5a2d96ce42f9$var$useEventCallback(fn) {
    const ref = $8FY87.useRef(fn);
    (0, $1eb4765744b30085$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $8FY87.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $3e2c5a2d96ce42f9$export$2e2bcd8739ae039 = $3e2c5a2d96ce42f9$var$useEventCallback;


'use client';
var $2043fad9aecf10e1$export$2e2bcd8739ae039 = (0, $3e2c5a2d96ce42f9$export$2e2bcd8739ae039);




var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");

var $8FY87 = parcelRequire("8FY87");


var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");
function $f6816a38101a77ff$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $7400a1c0b6aed439$export$2e2bcd8739ae039(t, e) {
    return $7400a1c0b6aed439$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $7400a1c0b6aed439$export$2e2bcd8739ae039(t, e);
}


function $6fad40a1fd710f68$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $7400a1c0b6aed439$export$2e2bcd8739ae039)(t, o);
}




var $8FY87 = parcelRequire("8FY87");

var $8FY87 = parcelRequire("8FY87");
var $f31aef85f58f080c$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createContext(null);



var $8FY87 = parcelRequire("8FY87");
function $4c0b59b061ce563e$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $8FY87.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $8FY87.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $4c0b59b061ce563e$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $4c0b59b061ce563e$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $4c0b59b061ce563e$export$fa71e2345c31d7a2(props, onExited) {
    return $4c0b59b061ce563e$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $8FY87.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $4c0b59b061ce563e$var$getProp(child, 'appear', props),
            enter: $4c0b59b061ce563e$var$getProp(child, 'enter', props),
            exit: $4c0b59b061ce563e$var$getProp(child, 'exit', props)
        });
    });
}
function $4c0b59b061ce563e$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $4c0b59b061ce563e$export$bbc8a025727ea824(nextProps.children);
    var children = $4c0b59b061ce563e$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $8FY87.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $8FY87.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $8FY87.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $4c0b59b061ce563e$var$getProp(child, 'exit', nextProps),
            enter: $4c0b59b061ce563e$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $8FY87.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $8FY87.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $8FY87.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $4c0b59b061ce563e$var$getProp(child, 'exit', nextProps),
            enter: $4c0b59b061ce563e$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}


var $5ab710582dad679e$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $5ab710582dad679e$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $5ab710582dad679e$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $6fad40a1fd710f68$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $f6816a38101a77ff$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $4c0b59b061ce563e$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $4c0b59b061ce563e$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $4c0b59b061ce563e$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $zgVxD.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $93aRW.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $5ab710582dad679e$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $f31aef85f58f080c$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $f31aef85f58f080c$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).Component);
$5ab710582dad679e$var$TransitionGroup.propTypes = {};
$5ab710582dad679e$var$TransitionGroup.defaultProps = $5ab710582dad679e$var$defaultProps;
var $5ab710582dad679e$export$2e2bcd8739ae039 = $5ab710582dad679e$var$TransitionGroup;



var $efJYy = parcelRequire("efJYy");

var $icSEh = parcelRequire("icSEh");


var $lbp1P = parcelRequire("lbp1P");

var $6lkQ3 = parcelRequire("6lkQ3");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $2PPWI = parcelRequire("2PPWI");
'use client';
function $11c7c278b6646737$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $8FY87.useState(false);
    const rippleClassName = (0, $efJYy.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $efJYy.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $8FY87.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
            className: childClassName
        })
    });
}
var $11c7c278b6646737$export$2e2bcd8739ae039 = $11c7c278b6646737$var$Ripple;



var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $61d79f4568950948$export$b464606f735ab902(slot) {
    return (0, $jP65K.default)('MuiTouchRipple', slot);
}
const $61d79f4568950948$var$touchRippleClasses = (0, $cOYaX.default)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $61d79f4568950948$export$2e2bcd8739ae039 = $61d79f4568950948$var$touchRippleClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $5ef830e87f73c899$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $5ef830e87f73c899$var$_ = (t)=>t, $5ef830e87f73c899$var$_t, $5ef830e87f73c899$var$_t2, $5ef830e87f73c899$var$_t3, $5ef830e87f73c899$var$_t4;
const $5ef830e87f73c899$var$DURATION = 550;
const $5ef830e87f73c899$export$95d0c9356b2231a3 = 80;
const $5ef830e87f73c899$var$enterKeyframe = (0, $icSEh.keyframes)($5ef830e87f73c899$var$_t || ($5ef830e87f73c899$var$_t = $5ef830e87f73c899$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $5ef830e87f73c899$var$exitKeyframe = (0, $icSEh.keyframes)($5ef830e87f73c899$var$_t2 || ($5ef830e87f73c899$var$_t2 = $5ef830e87f73c899$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $5ef830e87f73c899$var$pulsateKeyframe = (0, $icSEh.keyframes)($5ef830e87f73c899$var$_t3 || ($5ef830e87f73c899$var$_t3 = $5ef830e87f73c899$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $5ef830e87f73c899$export$f6b7418508c72c25 = (0, $lbp1P.default)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $5ef830e87f73c899$export$676cfe7b12693c4b = (0, $lbp1P.default)((0, $11c7c278b6646737$export$2e2bcd8739ae039), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})($5ef830e87f73c899$var$_t4 || ($5ef830e87f73c899$var$_t4 = $5ef830e87f73c899$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $61d79f4568950948$export$2e2bcd8739ae039).rippleVisible, $5ef830e87f73c899$var$enterKeyframe, $5ef830e87f73c899$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $61d79f4568950948$export$2e2bcd8739ae039).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $61d79f4568950948$export$2e2bcd8739ae039).child, (0, $61d79f4568950948$export$2e2bcd8739ae039).childLeaving, $5ef830e87f73c899$var$exitKeyframe, $5ef830e87f73c899$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $61d79f4568950948$export$2e2bcd8739ae039).childPulsate, $5ef830e87f73c899$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $5ef830e87f73c899$var$TouchRipple = /*#__PURE__*/ $8FY87.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $93aRW.default)(props, $5ef830e87f73c899$var$_excluded);
    const [ripples, setRipples] = $8FY87.useState([]);
    const nextKey = $8FY87.useRef(0);
    const rippleCallback = $8FY87.useRef(null);
    $8FY87.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $8FY87.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $d5603345799722cb$export$2e2bcd8739ae039)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $8FY87.useRef(null);
    const container = $8FY87.useRef(null);
    const startCommit = $8FY87.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $2PPWI.jsx)($5ef830e87f73c899$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $efJYy.default)(classes.ripple, (0, $61d79f4568950948$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $efJYy.default)(classes.rippleVisible, (0, $61d79f4568950948$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $efJYy.default)(classes.ripplePulsate, (0, $61d79f4568950948$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $efJYy.default)(classes.child, (0, $61d79f4568950948$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $efJYy.default)(classes.childLeaving, (0, $61d79f4568950948$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $efJYy.default)(classes.childPulsate, (0, $61d79f4568950948$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $5ef830e87f73c899$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $8FY87.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($5ef830e87f73c899$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $8FY87.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $8FY87.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $8FY87.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $2PPWI.jsx)($5ef830e87f73c899$export$f6b7418508c72c25, (0, $zgVxD.default)({
        className: (0, $efJYy.default)((0, $61d79f4568950948$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $5ab710582dad679e$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $5ef830e87f73c899$export$2e2bcd8739ae039 = $5ef830e87f73c899$var$TouchRipple;



var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $c9d8a520bb69705a$export$fccb0498dcd99783(slot) {
    return (0, $jP65K.default)('MuiButtonBase', slot);
}
const $c9d8a520bb69705a$var$buttonBaseClasses = (0, $cOYaX.default)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $c9d8a520bb69705a$export$2e2bcd8739ae039 = $c9d8a520bb69705a$var$buttonBaseClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $21281888ae95b2bd$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $21281888ae95b2bd$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $lXBIJ.default)(slots, (0, $c9d8a520bb69705a$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $21281888ae95b2bd$export$7ec0dcc5e3cdcd36 = (0, $lbp1P.default)('button', {
    name: 'MuiButtonBase',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $c9d8a520bb69705a$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $21281888ae95b2bd$var$ButtonBase = /*#__PURE__*/ $8FY87.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $93aRW.default)(props, $21281888ae95b2bd$var$_excluded);
    const buttonRef = $8FY87.useRef(null);
    const rippleRef = $8FY87.useRef(null);
    const handleRippleRef = (0, $520629ff5b0e6bac$export$2e2bcd8739ae039)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $f6854f6315de19cb$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $8FY87.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $8FY87.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $8FY87.useState(false);
    $8FY87.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $8FY87.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $2043fad9aecf10e1$export$2e2bcd8739ae039)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler('start', onMouseDown);
    const handleContextMenu = useRippleHandler('stop', onContextMenu);
    const handleDragLeave = useRippleHandler('stop', onDragLeave);
    const handleMouseUp = useRippleHandler('stop', onMouseUp);
    const handleMouseLeave = useRippleHandler('stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler('start', onTouchStart);
    const handleTouchEnd = useRippleHandler('stop', onTouchEnd);
    const handleTouchMove = useRippleHandler('stop', onTouchMove);
    const handleBlur = useRippleHandler('stop', (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $2043fad9aecf10e1$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $8FY87.useRef(false);
    const handleKeyDown = (0, $2043fad9aecf10e1$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $2043fad9aecf10e1$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $520629ff5b0e6bac$export$2e2bcd8739ae039)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $zgVxD.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $21281888ae95b2bd$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2PPWI.jsxs)($21281888ae95b2bd$export$7ec0dcc5e3cdcd36, (0, $zgVxD.default)({
        as: ComponentProp,
        className: (0, $efJYy.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $2PPWI.jsx)((0, $5ef830e87f73c899$export$2e2bcd8739ae039), (0, $zgVxD.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $21281888ae95b2bd$export$2e2bcd8739ae039 = $21281888ae95b2bd$var$ButtonBase;



var $ifmKX = parcelRequire("ifmKX");

var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $843e4679b238e6c4$export$5a6f9035944c8119(slot) {
    return (0, $jP65K.default)('MuiButton', slot);
}
const $843e4679b238e6c4$var$buttonClasses = (0, $cOYaX.default)('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge'
]);
var $843e4679b238e6c4$export$2e2bcd8739ae039 = $843e4679b238e6c4$var$buttonClasses;



var $8FY87 = parcelRequire("8FY87");
/**
 * @ignore - internal component.
 */ const $9b1164fc239e57d3$var$ButtonGroupContext = /*#__PURE__*/ $8FY87.createContext({});
var $9b1164fc239e57d3$export$2e2bcd8739ae039 = $9b1164fc239e57d3$var$ButtonGroupContext;



var $8FY87 = parcelRequire("8FY87");
/**
 * @ignore - internal component.
 */ const $26a73fd5208e4503$var$ButtonGroupButtonContext = /*#__PURE__*/ $8FY87.createContext(undefined);
var $26a73fd5208e4503$export$2e2bcd8739ae039 = $26a73fd5208e4503$var$ButtonGroupButtonContext;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $bd3665a0fad0f879$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $bd3665a0fad0f879$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `${variant}${(0, $ifmKX.default)(color)}`,
            `size${(0, $ifmKX.default)(size)}`,
            `${variant}Size${(0, $ifmKX.default)(size)}`,
            `color${(0, $ifmKX.default)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth'
        ],
        label: [
            'label'
        ],
        startIcon: [
            'icon',
            'startIcon',
            `iconSize${(0, $ifmKX.default)(size)}`
        ],
        endIcon: [
            'icon',
            'endIcon',
            `iconSize${(0, $ifmKX.default)(size)}`
        ]
    };
    const composedClasses = (0, $lXBIJ.default)(slots, (0, $843e4679b238e6c4$export$5a6f9035944c8119), classes);
    return (0, $zgVxD.default)({}, classes, composedClasses);
};
const $bd3665a0fad0f879$var$commonIconStyles = (ownerState)=>(0, $zgVxD.default)({}, ownerState.size === 'small' && {
        '& > *:nth-of-type(1)': {
            fontSize: 18
        }
    }, ownerState.size === 'medium' && {
        '& > *:nth-of-type(1)': {
            fontSize: 20
        }
    }, ownerState.size === 'large' && {
        '& > *:nth-of-type(1)': {
            fontSize: 22
        }
    });
const $bd3665a0fad0f879$var$ButtonRoot = (0, $lbp1P.default)((0, $21281888ae95b2bd$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $awHZI.default)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $ifmKX.default)(ownerState.color)}`],
            styles[`size${(0, $ifmKX.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $ifmKX.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $zgVxD.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: '6px 16px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': (0, $zgVxD.default)({
            textDecoration: 'none',
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $1r55V.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $1r55V.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $1r55V.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'contained' && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        '&:active': (0, $zgVxD.default)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $843e4679b238e6c4$export$2e2bcd8739ae039).focusVisible}`]: (0, $zgVxD.default)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $843e4679b238e6c4$export$2e2bcd8739ae039).disabled}`]: (0, $zgVxD.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === 'outlined' && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === 'contained' && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === 'text' && {
        padding: '6px 8px'
    }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === 'outlined' && {
        padding: '5px 15px',
        border: '1px solid currentColor'
    }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $1r55V.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === 'contained' && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === 'inherit' && {
        color: 'inherit',
        borderColor: 'currentColor'
    }, ownerState.size === 'small' && ownerState.variant === 'text' && {
        padding: '4px 5px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'text' && {
        padding: '8px 11px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
        padding: '3px 9px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'outlined' && {
        padding: '7px 21px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'contained' && {
        padding: '4px 10px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'contained' && {
        padding: '8px 22px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: '100%'
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: 'none',
        '&:hover': {
            boxShadow: 'none'
        },
        [`&.${(0, $843e4679b238e6c4$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: 'none'
        },
        '&:active': {
            boxShadow: 'none'
        },
        [`&.${(0, $843e4679b238e6c4$export$2e2bcd8739ae039).disabled}`]: {
            boxShadow: 'none'
        }
    });
const $bd3665a0fad0f879$var$ButtonStartIcon = (0, $lbp1P.default)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $ifmKX.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $zgVxD.default)({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === 'small' && {
        marginLeft: -2
    }, $bd3665a0fad0f879$var$commonIconStyles(ownerState)));
const $bd3665a0fad0f879$var$ButtonEndIcon = (0, $lbp1P.default)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $ifmKX.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $zgVxD.default)({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === 'small' && {
        marginRight: -2
    }, $bd3665a0fad0f879$var$commonIconStyles(ownerState)));
const $bd3665a0fad0f879$var$Button = /*#__PURE__*/ $8FY87.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $8FY87.useContext((0, $9b1164fc239e57d3$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $8FY87.useContext((0, $26a73fd5208e4503$export$2e2bcd8739ae039));
    const resolvedProps = (0, $1p637.default)(contextProps, inProps);
    const props = (0, $6lkQ3.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text' } = props, other = (0, $93aRW.default)(props, $bd3665a0fad0f879$var$_excluded);
    const ownerState = (0, $zgVxD.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $bd3665a0fad0f879$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $2PPWI.jsx)($bd3665a0fad0f879$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $2PPWI.jsx)($bd3665a0fad0f879$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    return /*#__PURE__*/ (0, $2PPWI.jsxs)($bd3665a0fad0f879$var$ButtonRoot, (0, $zgVxD.default)({
        ownerState: ownerState,
        className: (0, $efJYy.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $efJYy.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $bd3665a0fad0f879$export$2e2bcd8739ae039 = $bd3665a0fad0f879$var$Button;



var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");


var $lXBIJ = parcelRequire("lXBIJ");

var $1r55V = parcelRequire("1r55V");

var $lbp1P = parcelRequire("lbp1P");

var $6lkQ3 = parcelRequire("6lkQ3");


var $ifmKX = parcelRequire("ifmKX");

var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $388c062f89cbecc5$export$5e8702d71474f093(slot) {
    return (0, $jP65K.default)('MuiIconButton', slot);
}
const $388c062f89cbecc5$var$iconButtonClasses = (0, $cOYaX.default)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge'
]);
var $388c062f89cbecc5$export$2e2bcd8739ae039 = $388c062f89cbecc5$var$iconButtonClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $8765ef9b64e3c3e6$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $8765ef9b64e3c3e6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $ifmKX.default)(color)}`,
            edge && `edge${(0, $ifmKX.default)(edge)}`,
            `size${(0, $ifmKX.default)(size)}`
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $388c062f89cbecc5$export$5e8702d71474f093), classes);
};
const $8765ef9b64e3c3e6$var$IconButtonRoot = (0, $lbp1P.default)((0, $21281888ae95b2bd$export$2e2bcd8739ae039), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $ifmKX.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $ifmKX.default)(ownerState.edge)}`],
            styles[`size${(0, $ifmKX.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $zgVxD.default)({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        overflow: 'visible',
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $1r55V.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.edge === 'start' && {
        marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
        marginRight: ownerState.size === 'small' ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $zgVxD.default)({}, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, ownerState.color !== 'inherit' && ownerState.color !== 'default' && (0, $zgVxD.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        '&:hover': (0, $zgVxD.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $1r55V.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        })
    }), ownerState.size === 'small' && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === 'large' && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $388c062f89cbecc5$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $8765ef9b64e3c3e6$var$IconButton = /*#__PURE__*/ $8FY87.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium' } = props, other = (0, $93aRW.default)(props, $8765ef9b64e3c3e6$var$_excluded);
    const ownerState = (0, $zgVxD.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $8765ef9b64e3c3e6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2PPWI.jsx)($8765ef9b64e3c3e6$var$IconButtonRoot, (0, $zgVxD.default)({
        className: (0, $efJYy.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other, {
        ownerState: ownerState,
        children: children
    }));
});
var $8765ef9b64e3c3e6$export$2e2bcd8739ae039 = $8765ef9b64e3c3e6$var$IconButton;



var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");

var $8FY87 = parcelRequire("8FY87");



var $efJYy = parcelRequire("efJYy");

var $lXBIJ = parcelRequire("lXBIJ");


var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");

var $8FY87 = parcelRequire("8FY87");


var $2PPWI = parcelRequire("2PPWI");
const $fd8721cf96f8ae09$var$_excluded = [
    "value"
];
const $fd8721cf96f8ae09$var$RtlContext = /*#__PURE__*/ $8FY87.createContext();
function $fd8721cf96f8ae09$var$RtlProvider(_ref) {
    let { value: value } = _ref, props = (0, $93aRW.default)(_ref, $fd8721cf96f8ae09$var$_excluded);
    return /*#__PURE__*/ (0, $2PPWI.jsx)($fd8721cf96f8ae09$var$RtlContext.Provider, (0, $zgVxD.default)({
        value: value != null ? value : true
    }, props));
}
const $fd8721cf96f8ae09$export$b2dd014b6c321cb = ()=>{
    const value = $8FY87.useContext($fd8721cf96f8ae09$var$RtlContext);
    return value != null ? value : false;
};
var $fd8721cf96f8ae09$export$2e2bcd8739ae039 = $fd8721cf96f8ae09$var$RtlProvider;



var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");


var $zgVxD = parcelRequire("zgVxD");
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $31cee6df5efff63b$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $31cee6df5efff63b$export$2e2bcd8739ae039 = $31cee6df5efff63b$var$isHostComponent;


/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $1b27d471dcde43d6$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $31cee6df5efff63b$export$2e2bcd8739ae039)(elementType)) return otherProps;
    return (0, $zgVxD.default)({}, otherProps, {
        ownerState: (0, $zgVxD.default)({}, otherProps.ownerState, ownerState)
    });
}
var $1b27d471dcde43d6$export$2e2bcd8739ae039 = $1b27d471dcde43d6$var$appendOwnerState;



var $zgVxD = parcelRequire("zgVxD");
function $701b03617a8c039f$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $701b03617a8c039f$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $701b03617a8c039f$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $701b03617a8c039f$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $701b03617a8c039f$export$2e2bcd8739ae039 = $701b03617a8c039f$export$4f5d2d50c9deca37;


/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $e5aafd907334d8d3$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $e5aafd907334d8d3$export$2e2bcd8739ae039 = $e5aafd907334d8d3$var$extractEventHandlers;


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $d7172a0cfe6b6f88$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $d7172a0cfe6b6f88$export$2e2bcd8739ae039 = $d7172a0cfe6b6f88$var$omitEventHandlers;


/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $7f9025fe45817926$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $701b03617a8c039f$export$2e2bcd8739ae039)(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
        const mergedStyle = (0, $zgVxD.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $zgVxD.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $e5aafd907334d8d3$export$2e2bcd8739ae039)((0, $zgVxD.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $d7172a0cfe6b6f88$export$2e2bcd8739ae039)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $d7172a0cfe6b6f88$export$2e2bcd8739ae039)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $701b03617a8c039f$export$2e2bcd8739ae039)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $zgVxD.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $zgVxD.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $7f9025fe45817926$export$2e2bcd8739ae039 = $7f9025fe45817926$var$mergeSlotProps;


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $97eef028f0359e85$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $97eef028f0359e85$export$2e2bcd8739ae039 = $97eef028f0359e85$var$resolveComponentProps;


'use client';
const $eeee79b1d2d55995$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $eeee79b1d2d55995$var$useSlotProps(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false } = parameters, rest = (0, $93aRW.default)(parameters, $eeee79b1d2d55995$var$_excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $97eef028f0359e85$export$2e2bcd8739ae039)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $7f9025fe45817926$export$2e2bcd8739ae039)((0, $zgVxD.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $a44e6282d60cc47f$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $1b27d471dcde43d6$export$2e2bcd8739ae039)(elementType, (0, $zgVxD.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}
var $eeee79b1d2d55995$export$2e2bcd8739ae039 = $eeee79b1d2d55995$var$useSlotProps;



var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");

var $8FY87 = parcelRequire("8FY87");


function $8c19ca9e1b8eb872$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


var $dd645d3436d5a245$export$2e2bcd8739ae039 = (0, $8c19ca9e1b8eb872$export$2e2bcd8739ae039);



var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $lXBIJ = parcelRequire("lXBIJ");

var $lbp1P = parcelRequire("lbp1P");

var $6lkQ3 = parcelRequire("6lkQ3");

var $8FY87 = parcelRequire("8FY87");
'use client';
/**
 * @ignore - internal component.
 */ const $5387b76bde865f68$var$ListContext = /*#__PURE__*/ $8FY87.createContext({});
var $5387b76bde865f68$export$2e2bcd8739ae039 = $5387b76bde865f68$var$ListContext;



var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $507ffeb2fde42f33$export$c6bd6795ed6e3203(slot) {
    return (0, $jP65K.default)('MuiList', slot);
}
const $507ffeb2fde42f33$var$listClasses = (0, $cOYaX.default)('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var $507ffeb2fde42f33$export$2e2bcd8739ae039 = $507ffeb2fde42f33$var$listClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $9ec32e00945028fa$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $9ec32e00945028fa$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $507ffeb2fde42f33$export$c6bd6795ed6e3203), classes);
};
const $9ec32e00945028fa$var$ListRoot = (0, $lbp1P.default)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState })=>(0, $zgVxD.default)({
        listStyle: 'none',
        margin: 0,
        padding: 0,
        position: 'relative'
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $9ec32e00945028fa$var$List = /*#__PURE__*/ $8FY87.forwardRef(function List(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiList'
    });
    const { children: children, className: className, component: component = 'ul', dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $93aRW.default)(props, $9ec32e00945028fa$var$_excluded);
    const context = $8FY87.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $zgVxD.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $9ec32e00945028fa$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $5387b76bde865f68$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $2PPWI.jsxs)($9ec32e00945028fa$var$ListRoot, (0, $zgVxD.default)({
            as: component,
            className: (0, $efJYy.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $9ec32e00945028fa$export$2e2bcd8739ae039 = $9ec32e00945028fa$var$List;


// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $7d7f610f0c8956e8$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}


var $ce60cd5913aa10a5$export$2e2bcd8739ae039 = (0, $7d7f610f0c8956e8$export$2e2bcd8739ae039);




'use client';
var $fb693b740ef0e8ff$export$2e2bcd8739ae039 = (0, $1eb4765744b30085$export$2e2bcd8739ae039);



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $4e08b8904724e76e$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $4e08b8904724e76e$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $4e08b8904724e76e$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $4e08b8904724e76e$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join('')) === 0;
}
function $4e08b8904724e76e$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$4e08b8904724e76e$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $4e08b8904724e76e$var$MenuList = /*#__PURE__*/ $8FY87.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = 'selectedMenu' } = props, other = (0, $93aRW.default)(props, $4e08b8904724e76e$var$_excluded);
    const listRef = $8FY87.useRef(null);
    const textCriteriaRef = $8FY87.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $fb693b740ef0e8ff$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $8FY87.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $ce60cd5913aa10a5$export$2e2bcd8739ae039)((0, $dd645d3436d5a245$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $dd645d3436d5a245$export$2e2bcd8739ae039)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $4e08b8904724e76e$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $4e08b8904724e76e$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $4e08b8904724e76e$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $4e08b8904724e76e$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $4e08b8904724e76e$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $4e08b8904724e76e$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $4e08b8904724e76e$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $4e08b8904724e76e$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $4e08b8904724e76e$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $4e08b8904724e76e$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $4e08b8904724e76e$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $520629ff5b0e6bac$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $8FY87.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $8FY87.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $8FY87.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $8FY87.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $9ec32e00945028fa$export$2e2bcd8739ae039), (0, $zgVxD.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $4e08b8904724e76e$export$2e2bcd8739ae039 = $4e08b8904724e76e$var$MenuList;



var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $lXBIJ = parcelRequire("lXBIJ");








var $lbp1P = parcelRequire("lbp1P");

var $6lkQ3 = parcelRequire("6lkQ3");
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $a303c833c3709ce4$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}


var $35a8cdd58dd5c41a$export$2e2bcd8739ae039 = (0, $a303c833c3709ce4$export$2e2bcd8739ae039);




function $82824f79fb738506$export$2e2bcd8739ae039(node) {
    const doc = (0, $8c19ca9e1b8eb872$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


var $e94801ab1411f138$export$2e2bcd8739ae039 = (0, $82824f79fb738506$export$2e2bcd8739ae039);




var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");

var $8FY87 = parcelRequire("8FY87");




var $8FY87 = parcelRequire("8FY87");
function $d993a907c028af13$export$2e2bcd8739ae039(element) {
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    if (parseInt($8FY87.version, 10) >= 19) {
        var _element$props;
        return (element == null || (_element$props = element.props) == null ? void 0 : _element$props.ref) || null;
    }
    // @ts-expect-error element.ref is not included in the ReactElement type
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    return (element == null ? void 0 : element.ref) || null;
}



var $93aRW = parcelRequire("93aRW");



var $8FY87 = parcelRequire("8FY87");

var $beea4412f0d1293d$export$2e2bcd8739ae039 = {
    disabled: false
};




var $6d8659fd8bd36753$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $f56d5c528e530759$export$bb38bb9a1161268 = 'unmounted';
var $f56d5c528e530759$export$84cbff306f539230 = 'exited';
var $f56d5c528e530759$export$df38205c966be359 = 'entering';
var $f56d5c528e530759$export$78e9e6e3e014d60a = 'entered';
var $f56d5c528e530759$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $f56d5c528e530759$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $6fad40a1fd710f68$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $f56d5c528e530759$export$84cbff306f539230;
                _this.appearStatus = $f56d5c528e530759$export$df38205c966be359;
            } else initialStatus = $f56d5c528e530759$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $f56d5c528e530759$export$bb38bb9a1161268;
        else initialStatus = $f56d5c528e530759$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $f56d5c528e530759$export$bb38bb9a1161268) return {
            status: $f56d5c528e530759$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $f56d5c528e530759$export$df38205c966be359 && status !== $f56d5c528e530759$export$78e9e6e3e014d60a) nextStatus = $f56d5c528e530759$export$df38205c966be359;
            } else if (status === $f56d5c528e530759$export$df38205c966be359 || status === $f56d5c528e530759$export$78e9e6e3e014d60a) nextStatus = $f56d5c528e530759$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $f56d5c528e530759$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($69d169f7fc8722a7$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $6d8659fd8bd36753$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $f56d5c528e530759$export$84cbff306f539230) this.setState({
            status: $f56d5c528e530759$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($69d169f7fc8722a7$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $beea4412f0d1293d$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $f56d5c528e530759$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $f56d5c528e530759$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $f56d5c528e530759$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($69d169f7fc8722a7$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $beea4412f0d1293d$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $f56d5c528e530759$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $f56d5c528e530759$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $f56d5c528e530759$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($69d169f7fc8722a7$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $f56d5c528e530759$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $93aRW.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $f31aef85f58f080c$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).Component);
$f56d5c528e530759$var$Transition.contextType = (0, $f31aef85f58f080c$export$2e2bcd8739ae039);
$f56d5c528e530759$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $f56d5c528e530759$var$noop() {}
$f56d5c528e530759$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $f56d5c528e530759$var$noop,
    onEntering: $f56d5c528e530759$var$noop,
    onEntered: $f56d5c528e530759$var$noop,
    onExit: $f56d5c528e530759$var$noop,
    onExiting: $f56d5c528e530759$var$noop,
    onExited: $f56d5c528e530759$var$noop
};
$f56d5c528e530759$var$Transition.UNMOUNTED = $f56d5c528e530759$export$bb38bb9a1161268;
$f56d5c528e530759$var$Transition.EXITED = $f56d5c528e530759$export$84cbff306f539230;
$f56d5c528e530759$var$Transition.ENTERING = $f56d5c528e530759$export$df38205c966be359;
$f56d5c528e530759$var$Transition.ENTERED = $f56d5c528e530759$export$78e9e6e3e014d60a;
$f56d5c528e530759$var$Transition.EXITING = $f56d5c528e530759$export$4aacc83d4d59139f;
var $f56d5c528e530759$export$2e2bcd8739ae039 = $f56d5c528e530759$var$Transition;


parcelRequire("8FY87");

var $1BEIC = parcelRequire("1BEIC");

var $8FY87 = parcelRequire("8FY87");
parcelRequire("icSEh");
var $8MSLN = parcelRequire("8MSLN");
'use client';
function $5952bd9f3861b4fa$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $5952bd9f3861b4fa$var$useTheme(defaultTheme = null) {
    const contextTheme = $8FY87.useContext((0, $8MSLN.T));
    return !contextTheme || $5952bd9f3861b4fa$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $5952bd9f3861b4fa$export$2e2bcd8739ae039 = $5952bd9f3861b4fa$var$useTheme;


'use client';
const $4ec357bcdd79021e$export$35e57303dbd8a66 = (0, $1BEIC.default)();
function $4ec357bcdd79021e$var$useTheme(defaultTheme = $4ec357bcdd79021e$export$35e57303dbd8a66) {
    return (0, $5952bd9f3861b4fa$export$2e2bcd8739ae039)(defaultTheme);
}
var $4ec357bcdd79021e$export$2e2bcd8739ae039 = $4ec357bcdd79021e$var$useTheme;



var $jyLqM = parcelRequire("jyLqM");

var $ab2pD = parcelRequire("ab2pD");
'use client';
function $0f82922e8f0d344d$export$2e2bcd8739ae039() {
    const theme = (0, $4ec357bcdd79021e$export$2e2bcd8739ae039)((0, $jyLqM.default));
    return theme[0, $ab2pD.default] || theme;
}


const $b705961e7d923fdf$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $b705961e7d923fdf$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === 'object' ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}




var $2PPWI = parcelRequire("2PPWI");
'use client';
const $d703e622fcb56eac$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $d703e622fcb56eac$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $d703e622fcb56eac$var$styles = {
    entering: {
        opacity: 1,
        transform: $d703e622fcb56eac$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $d703e622fcb56eac$var$isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $d703e622fcb56eac$var$Grow = /*#__PURE__*/ $8FY87.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = 'auto', TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $f56d5c528e530759$export$2e2bcd8739ae039) } = props, other = (0, $93aRW.default)(props, $d703e622fcb56eac$var$_excluded);
    const timer = (0, $d5603345799722cb$export$2e2bcd8739ae039)();
    const autoTimeout = $8FY87.useRef();
    const theme = (0, $0f82922e8f0d344d$export$2e2bcd8739ae039)();
    const nodeRef = $8FY87.useRef(null);
    const handleRef = (0, $520629ff5b0e6bac$export$2e2bcd8739ae039)(nodeRef, (0, $d993a907c028af13$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $b705961e7d923fdf$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $b705961e7d923fdf$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $d703e622fcb56eac$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $b705961e7d923fdf$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $d703e622fcb56eac$var$isWebKit154 ? duration : duration * 0.666,
                delay: $d703e622fcb56eac$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = $d703e622fcb56eac$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $2PPWI.jsx)(TransitionComponent, (0, $zgVxD.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $8FY87.cloneElement(children, (0, $zgVxD.default)({
                style: (0, $zgVxD.default)({
                    opacity: 0,
                    transform: $d703e622fcb56eac$var$getScale(0.75),
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $d703e622fcb56eac$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$d703e622fcb56eac$var$Grow.muiSupportAuto = true;
var $d703e622fcb56eac$export$2e2bcd8739ae039 = $d703e622fcb56eac$var$Grow;



var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");



var $lXBIJ = parcelRequire("lXBIJ");


var $8FY87 = parcelRequire("8FY87");



var $2PPWI = parcelRequire("2PPWI");
'use client';
// Inspired by https://github.com/focus-trap/tabbable
const $b86676e22d498bb3$var$candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function $b86676e22d498bb3$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function $b86676e22d498bb3$var$isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $b86676e22d498bb3$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || $b86676e22d498bb3$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $b86676e22d498bb3$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($b86676e22d498bb3$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $b86676e22d498bb3$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$b86676e22d498bb3$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $b86676e22d498bb3$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $b86676e22d498bb3$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $b86676e22d498bb3$var$defaultGetTabbable, isEnabled: isEnabled = $b86676e22d498bb3$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $8FY87.useRef(false);
    const sentinelStart = $8FY87.useRef(null);
    const sentinelEnd = $8FY87.useRef(null);
    const nodeToRestore = $8FY87.useRef(null);
    const reactFocusEventTarget = $8FY87.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $8FY87.useRef(false);
    const rootRef = $8FY87.useRef(null);
    const handleRef = (0, $a44e6282d60cc47f$export$2e2bcd8739ae039)((0, $d993a907c028af13$export$2e2bcd8739ae039)(children), rootRef);
    const lastKeydown = $8FY87.useRef(null);
    $8FY87.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $8FY87.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $8c19ca9e1b8eb872$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', '-1');
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $8FY87.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $8c19ca9e1b8eb872$export$2e2bcd8739ae039)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown$current, _lastKeydown$current2;
                const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $2PPWI.jsxs)($8FY87.Fragment, {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $8FY87.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $b86676e22d498bb3$export$2e2bcd8739ae039 = $b86676e22d498bb3$var$FocusTrap;



var $8FY87 = parcelRequire("8FY87");




var $2PPWI = parcelRequire("2PPWI");
'use client';
function $ec351fd8f7334f84$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/material-ui/api/portal/)
 */ const $ec351fd8f7334f84$var$Portal = /*#__PURE__*/ $8FY87.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $8FY87.useState(null);
    const handleRef = (0, $a44e6282d60cc47f$export$2e2bcd8739ae039)(/*#__PURE__*/ $8FY87.isValidElement(children) ? (0, $d993a907c028af13$export$2e2bcd8739ae039)(children) : null, forwardedRef);
    (0, $1eb4765744b30085$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($ec351fd8f7334f84$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $1eb4765744b30085$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $2b147962174f16a5$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $2b147962174f16a5$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $8FY87.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $8FY87.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $2PPWI.jsx)($8FY87.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $2PPWI.jsx)($8FY87.Fragment, {
        children: mountNode ? /*#__PURE__*/ $69d169f7fc8722a7$exports.createPortal(children, mountNode) : mountNode
    });
});
var $ec351fd8f7334f84$export$2e2bcd8739ae039 = $ec351fd8f7334f84$var$Portal;



var $lbp1P = parcelRequire("lbp1P");

var $6lkQ3 = parcelRequire("6lkQ3");

var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $lXBIJ = parcelRequire("lXBIJ");

var $lbp1P = parcelRequire("lbp1P");

var $6lkQ3 = parcelRequire("6lkQ3");

var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");

var $8FY87 = parcelRequire("8FY87");








var $2PPWI = parcelRequire("2PPWI");
'use client';
const $e8b97d13d921cb51$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $e8b97d13d921cb51$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $e8b97d13d921cb51$var$Fade = /*#__PURE__*/ $8FY87.forwardRef(function Fade(props, ref) {
    const theme = (0, $0f82922e8f0d344d$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $f56d5c528e530759$export$2e2bcd8739ae039) } = props, other = (0, $93aRW.default)(props, $e8b97d13d921cb51$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $8FY87.useRef(null);
    const handleRef = (0, $520629ff5b0e6bac$export$2e2bcd8739ae039)(nodeRef, (0, $d993a907c028af13$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $b705961e7d923fdf$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $b705961e7d923fdf$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $b705961e7d923fdf$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $2PPWI.jsx)(TransitionComponent, (0, $zgVxD.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $8FY87.cloneElement(children, (0, $zgVxD.default)({
                style: (0, $zgVxD.default)({
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $e8b97d13d921cb51$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $e8b97d13d921cb51$export$2e2bcd8739ae039 = $e8b97d13d921cb51$var$Fade;



var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $06a2c4a7b57a48c2$export$9927a91fd93152bd(slot) {
    return (0, $jP65K.default)('MuiBackdrop', slot);
}
const $06a2c4a7b57a48c2$var$backdropClasses = (0, $cOYaX.default)('MuiBackdrop', [
    'root',
    'invisible'
]);
var $06a2c4a7b57a48c2$export$2e2bcd8739ae039 = $06a2c4a7b57a48c2$var$backdropClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $56dcde36b8493878$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $56dcde36b8493878$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $06a2c4a7b57a48c2$export$9927a91fd93152bd), classes);
};
const $56dcde36b8493878$var$BackdropRoot = (0, $lbp1P.default)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $zgVxD.default)({
        position: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        WebkitTapHighlightColor: 'transparent'
    }, ownerState.invisible && {
        backgroundColor: 'transparent'
    }));
const $56dcde36b8493878$var$Backdrop = /*#__PURE__*/ $8FY87.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children: children, className: className, component: component = 'div', components: components = {}, componentsProps: componentsProps = {}, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponent = (0, $e8b97d13d921cb51$export$2e2bcd8739ae039), transitionDuration: transitionDuration } = props, other = (0, $93aRW.default)(props, $56dcde36b8493878$var$_excluded);
    const ownerState = (0, $zgVxD.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $56dcde36b8493878$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $2PPWI.jsx)(TransitionComponent, (0, $zgVxD.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $2PPWI.jsx)($56dcde36b8493878$var$BackdropRoot, (0, $zgVxD.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $efJYy.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $zgVxD.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $56dcde36b8493878$export$2e2bcd8739ae039 = $56dcde36b8493878$var$Backdrop;



var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $2d7581ca16b34e0c$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}




// Is a vertical scrollbar displayed?
function $569454b7f57ecd06$var$isOverflowing(container) {
    const doc = (0, $8c19ca9e1b8eb872$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $82824f79fb738506$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $569454b7f57ecd06$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function $569454b7f57ecd06$var$getPaddingRight(element) {
    return parseInt((0, $82824f79fb738506$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $569454b7f57ecd06$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function $569454b7f57ecd06$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$569454b7f57ecd06$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $569454b7f57ecd06$export$e1bd0c6150f13d96(element, show);
    });
}
function $569454b7f57ecd06$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $569454b7f57ecd06$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($569454b7f57ecd06$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $7d7f610f0c8956e8$export$2e2bcd8739ae039)((0, $8c19ca9e1b8eb872$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$569454b7f57ecd06$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $8c19ca9e1b8eb872$export$2e2bcd8739ae039)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${$569454b7f57ecd06$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $8c19ca9e1b8eb872$export$2e2bcd8739ae039)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $82824f79fb738506$export$2e2bcd8739ae039)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $569454b7f57ecd06$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $569454b7f57ecd06$export$ce11c4ecd08cea67 {
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $569454b7f57ecd06$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $569454b7f57ecd06$var$getHiddenSiblings(container);
        $569454b7f57ecd06$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $569454b7f57ecd06$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $569454b7f57ecd06$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $569454b7f57ecd06$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $569454b7f57ecd06$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $569454b7f57ecd06$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $569454b7f57ecd06$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $569454b7f57ecd06$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}


'use client';
function $1ede1f67d854e7e8$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function $1ede1f67d854e7e8$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $1ede1f67d854e7e8$var$defaultManager = new (0, $569454b7f57ecd06$export$ce11c4ecd08cea67)();
/**
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/#hook)
 *
 * API:
 *
 * - [useModal API](https://mui.com/base-ui/react-modal/hooks-api/#use-modal)
 */ function $1ede1f67d854e7e8$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, manager: // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = $1ede1f67d854e7e8$var$defaultManager, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $8FY87.useRef({});
    const mountNodeRef = $8FY87.useRef(null);
    const modalRef = $8FY87.useRef(null);
    const handleRef = (0, $a44e6282d60cc47f$export$2e2bcd8739ae039)(modalRef, rootRef);
    const [exited, setExited] = $8FY87.useState(!open);
    const hasTransition = $1ede1f67d854e7e8$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $8c19ca9e1b8eb872$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $3e2c5a2d96ce42f9$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $1ede1f67d854e7e8$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $8FY87.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $3e2c5a2d96ce42f9$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $569454b7f57ecd06$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $8FY87.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp,
        manager
    ]);
    $8FY87.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $8FY87.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers$onClic;
            (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $e5aafd907334d8d3$export$2e2bcd8739ae039)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = (0, $zgVxD.default)({}, propsEventHandlers, otherHandlers);
        return (0, $zgVxD.default)({
            role: 'presentation'
        }, externalEventHandlers, {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return (0, $zgVxD.default)({
            'aria-hidden': true
        }, externalEventHandlers, {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        });
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $2d7581ca16b34e0c$export$2e2bcd8739ae039)(handleEnter, children == null ? void 0 : children.props.onEnter),
            onExited: (0, $2d7581ca16b34e0c$export$2e2bcd8739ae039)(handleExited, children == null ? void 0 : children.props.onExited)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $1ede1f67d854e7e8$export$2e2bcd8739ae039 = $1ede1f67d854e7e8$var$useModal;



var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $20d8e2236756287c$export$67960e22b12a638d(slot) {
    return (0, $jP65K.default)('MuiModal', slot);
}
const $20d8e2236756287c$var$modalClasses = (0, $cOYaX.default)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var $20d8e2236756287c$export$2e2bcd8739ae039 = $20d8e2236756287c$var$modalClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $8f893b086317be6b$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "onTransitionEnter",
    "onTransitionExited",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $8f893b086317be6b$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $20d8e2236756287c$export$67960e22b12a638d), classes);
};
const $8f893b086317be6b$var$ModalRoot = (0, $lbp1P.default)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $zgVxD.default)({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: 'hidden'
    }));
const $8f893b086317be6b$var$ModalBackdrop = (0, $lbp1P.default)((0, $56dcde36b8493878$export$2e2bcd8739ae039), {
    name: 'MuiModal',
    slot: 'Backdrop',
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $8f893b086317be6b$var$Modal = /*#__PURE__*/ $8FY87.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $6lkQ3.useDefaultProps)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $8f893b086317be6b$var$ModalBackdrop, BackdropProps: BackdropProps, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, open: open, slotProps: slotProps, slots: slots } = props, other = (0, $93aRW.default)(props, $8f893b086317be6b$var$_excluded);
    const propsWithDefaults = (0, $zgVxD.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $1ede1f67d854e7e8$export$2e2bcd8739ae039)((0, $zgVxD.default)({}, propsWithDefaults, {
        rootRef: ref
    }));
    const ownerState = (0, $zgVxD.default)({}, propsWithDefaults, {
        exited: exited
    });
    const classes = $8f893b086317be6b$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $8f893b086317be6b$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    const rootProps = (0, $eeee79b1d2d55995$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        getSlotProps: getRootProps,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $efJYy.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
    });
    const backdropProps = (0, $eeee79b1d2d55995$export$2e2bcd8739ae039)({
        elementType: BackdropSlot,
        externalSlotProps: backdropSlotProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps((0, $zgVxD.default)({}, otherHandlers, {
                onClick: (e)=>{
                    if (onBackdropClick) onBackdropClick(e);
                    if (otherHandlers != null && otherHandlers.onClick) otherHandlers.onClick(e);
                }
            }));
        },
        className: (0, $efJYy.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $ec351fd8f7334f84$export$2e2bcd8739ae039), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $2PPWI.jsxs)(RootSlot, (0, $zgVxD.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $2PPWI.jsx)(BackdropSlot, (0, $zgVxD.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $b86676e22d498bb3$export$2e2bcd8739ae039), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $8FY87.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $8f893b086317be6b$export$2e2bcd8739ae039 = $8f893b086317be6b$var$Modal;



var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");



var $lXBIJ = parcelRequire("lXBIJ");

var $1r55V = parcelRequire("1r55V");

var $lbp1P = parcelRequire("lbp1P");
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $f328836e6d68a4c4$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $f328836e6d68a4c4$export$2e2bcd8739ae039 = $f328836e6d68a4c4$var$getOverlayAlpha;



var $6lkQ3 = parcelRequire("6lkQ3");


var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $2abbd3a8b8de0537$export$29cdb466b9b6f20b(slot) {
    return (0, $jP65K.default)('MuiPaper', slot);
}
const $2abbd3a8b8de0537$var$paperClasses = (0, $cOYaX.default)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $2abbd3a8b8de0537$export$2e2bcd8739ae039 = $2abbd3a8b8de0537$var$paperClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $d9c49ac25a55e29d$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $d9c49ac25a55e29d$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $2abbd3a8b8de0537$export$29cdb466b9b6f20b), classes);
};
const $d9c49ac25a55e29d$var$PaperRoot = (0, $lbp1P.default)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $zgVxD.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow')
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === 'outlined' && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === 'elevation' && (0, $zgVxD.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === 'dark' && {
        backgroundImage: `linear-gradient(${(0, $1r55V.alpha)('#fff', (0, $f328836e6d68a4c4$export$2e2bcd8739ae039)(ownerState.elevation))}, ${(0, $1r55V.alpha)('#fff', (0, $f328836e6d68a4c4$export$2e2bcd8739ae039)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $d9c49ac25a55e29d$var$Paper = /*#__PURE__*/ $8FY87.forwardRef(function Paper(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiPaper'
    });
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation' } = props, other = (0, $93aRW.default)(props, $d9c49ac25a55e29d$var$_excluded);
    const ownerState = (0, $zgVxD.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $d9c49ac25a55e29d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2PPWI.jsx)($d9c49ac25a55e29d$var$PaperRoot, (0, $zgVxD.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $efJYy.default)(classes.root, className),
        ref: ref
    }, other));
});
var $d9c49ac25a55e29d$export$2e2bcd8739ae039 = $d9c49ac25a55e29d$var$Paper;



var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $876272762a3fea69$export$88f455dd56c95edb(slot) {
    return (0, $jP65K.default)('MuiPopover', slot);
}
const $876272762a3fea69$var$popoverClasses = (0, $cOYaX.default)('MuiPopover', [
    'root',
    'paper'
]);
var $876272762a3fea69$export$2e2bcd8739ae039 = $876272762a3fea69$var$popoverClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $f016e51ac365477c$var$_excluded = [
    "onEntering"
], $f016e51ac365477c$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps",
    "disableScrollLock"
], $f016e51ac365477c$var$_excluded3 = [
    "slotProps"
];
function $f016e51ac365477c$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $f016e51ac365477c$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $f016e51ac365477c$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function $f016e51ac365477c$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const $f016e51ac365477c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $876272762a3fea69$export$88f455dd56c95edb), classes);
};
const $f016e51ac365477c$export$bcce13685275fc99 = (0, $lbp1P.default)((0, $8f893b086317be6b$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $f016e51ac365477c$export$821346c38a2d9390 = (0, $lbp1P.default)((0, $d9c49ac25a55e29d$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $f016e51ac365477c$var$Popover = /*#__PURE__*/ $8FY87.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = 'anchorEl', children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: slots, slotProps: slotProps, transformOrigin: transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, TransitionComponent: TransitionComponent = (0, $d703e622fcb56eac$export$2e2bcd8739ae039), transitionDuration: transitionDurationProp = 'auto', TransitionProps: { onEntering: onEntering } = {}, disableScrollLock: disableScrollLock = false } = props, TransitionProps = (0, $93aRW.default)(props.TransitionProps, $f016e51ac365477c$var$_excluded), other = (0, $93aRW.default)(props, $f016e51ac365477c$var$_excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = $8FY87.useRef();
    const handlePaperRef = (0, $520629ff5b0e6bac$export$2e2bcd8739ae039)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, $zgVxD.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $f016e51ac365477c$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $8FY87.useCallback(()=>{
        if (anchorReference === 'anchorPosition') return anchorPosition;
        const resolvedAnchorEl = $f016e51ac365477c$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $dd645d3436d5a245$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $f016e51ac365477c$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $f016e51ac365477c$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $8FY87.useCallback((elemRect)=>{
        return {
            vertical: $f016e51ac365477c$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $f016e51ac365477c$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $8FY87.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $f016e51ac365477c$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $e94801ab1411f138$export$2e2bcd8739ae039)($f016e51ac365477c$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $f016e51ac365477c$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $8FY87.useState(open);
    const setPositioningStyles = $8FY87.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $8FY87.useEffect(()=>{
        if (disableScrollLock) window.addEventListener('scroll', setPositioningStyles);
        return ()=>window.removeEventListener('scroll', setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $8FY87.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $8FY87.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $8FY87.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $35a8cdd58dd5c41a$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $e94801ab1411f138$export$2e2bcd8739ae039)(anchorEl);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $dd645d3436d5a245$export$2e2bcd8739ae039)($f016e51ac365477c$var$resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : $f016e51ac365477c$export$bcce13685275fc99;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : $f016e51ac365477c$export$821346c38a2d9390;
    const paperProps = (0, $eeee79b1d2d55995$export$2e2bcd8739ae039)({
        elementType: PaperSlot,
        externalSlotProps: (0, $zgVxD.default)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, $zgVxD.default)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation: elevation,
            ref: handlePaperRef
        },
        ownerState: ownerState,
        className: (0, $efJYy.default)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, $eeee79b1d2d55995$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $efJYy.default)(classes.root, className)
    }), { slotProps: rootSlotPropsProp } = _useSlotProps, rootProps = (0, $93aRW.default)(_useSlotProps, $f016e51ac365477c$var$_excluded3);
    return /*#__PURE__*/ (0, $2PPWI.jsx)(RootSlot, (0, $zgVxD.default)({}, rootProps, !(0, $31cee6df5efff63b$export$2e2bcd8739ae039)(RootSlot) && {
        slotProps: rootSlotPropsProp,
        disableScrollLock: disableScrollLock
    }, {
        children: /*#__PURE__*/ (0, $2PPWI.jsx)(TransitionComponent, (0, $zgVxD.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $2PPWI.jsx)(PaperSlot, (0, $zgVxD.default)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
var $f016e51ac365477c$export$2e2bcd8739ae039 = $f016e51ac365477c$var$Popover;



var $lbp1P = parcelRequire("lbp1P");
var $awHZI = parcelRequire("awHZI");

var $6lkQ3 = parcelRequire("6lkQ3");

var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $6e6c06524dca9ff1$export$2cf86a63a84fe23d(slot) {
    return (0, $jP65K.default)('MuiMenu', slot);
}
const $6e6c06524dca9ff1$var$menuClasses = (0, $cOYaX.default)('MuiMenu', [
    'root',
    'paper',
    'list'
]);
var $6e6c06524dca9ff1$export$2e2bcd8739ae039 = $6e6c06524dca9ff1$var$menuClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $0b320025c1b3a544$var$_excluded = [
    "onEntering"
], $0b320025c1b3a544$var$_excluded2 = [
    "autoFocus",
    "children",
    "className",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant",
    "slots",
    "slotProps"
];
const $0b320025c1b3a544$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const $0b320025c1b3a544$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const $0b320025c1b3a544$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $6e6c06524dca9ff1$export$2cf86a63a84fe23d), classes);
};
const $0b320025c1b3a544$var$MenuRoot = (0, $lbp1P.default)((0, $f016e51ac365477c$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $awHZI.default)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $0b320025c1b3a544$export$4f7c51a5920c9f33 = (0, $lbp1P.default)((0, $f016e51ac365477c$export$821346c38a2d9390), {
    name: 'MuiMenu',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const $0b320025c1b3a544$var$MenuMenuList = (0, $lbp1P.default)((0, $4e08b8904724e76e$export$2e2bcd8739ae039), {
    name: 'MuiMenu',
    slot: 'List',
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $0b320025c1b3a544$var$Menu = /*#__PURE__*/ $8FY87.forwardRef(function Menu(inProps, ref) {
    var _slots$paper, _slotProps$paper;
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = 'auto', TransitionProps: { onEntering: onEntering } = {}, variant: variant = 'selectedMenu', slots: slots = {}, slotProps: slotProps = {} } = props, TransitionProps = (0, $93aRW.default)(props.TransitionProps, $0b320025c1b3a544$var$_excluded), other = (0, $93aRW.default)(props, $0b320025c1b3a544$var$_excluded2);
    const isRtl = (0, $fd8721cf96f8ae09$export$b2dd014b6c321cb)();
    const ownerState = (0, $zgVxD.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $0b320025c1b3a544$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $8FY87.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? 'rtl' : 'ltr'
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $8FY87.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $8FY87.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : $0b320025c1b3a544$export$4f7c51a5920c9f33;
    const paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
    const rootSlotProps = (0, $eeee79b1d2d55995$export$2e2bcd8739ae039)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, $eeee79b1d2d55995$export$2e2bcd8739ae039)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState: ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, $2PPWI.jsx)($0b320025c1b3a544$var$MenuRoot, (0, $zgVxD.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? $0b320025c1b3a544$var$RTL_ORIGIN : $0b320025c1b3a544$var$LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $zgVxD.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $2PPWI.jsx)($0b320025c1b3a544$var$MenuMenuList, (0, $zgVxD.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $efJYy.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $0b320025c1b3a544$export$2e2bcd8739ae039 = $0b320025c1b3a544$var$Menu;



var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $lXBIJ = parcelRequire("lXBIJ");

var $1r55V = parcelRequire("1r55V");

var $lbp1P = parcelRequire("lbp1P");
var $awHZI = parcelRequire("awHZI");

var $6lkQ3 = parcelRequire("6lkQ3");






var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $e7081451187db0ff$export$81478e24460c57f2(slot) {
    return (0, $jP65K.default)('MuiListItemIcon', slot);
}
const $e7081451187db0ff$var$listItemIconClasses = (0, $cOYaX.default)('MuiListItemIcon', [
    'root',
    'alignItemsFlexStart'
]);
var $e7081451187db0ff$export$2e2bcd8739ae039 = $e7081451187db0ff$var$listItemIconClasses;



var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $fb61fad9a5efd453$export$1061006a0db3aeb5(slot) {
    return (0, $jP65K.default)('MuiListItemText', slot);
}
const $fb61fad9a5efd453$var$listItemTextClasses = (0, $cOYaX.default)('MuiListItemText', [
    'root',
    'multiline',
    'dense',
    'inset',
    'primary',
    'secondary'
]);
var $fb61fad9a5efd453$export$2e2bcd8739ae039 = $fb61fad9a5efd453$var$listItemTextClasses;



var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $6bf90ec6342cf3dc$export$515f8c67b5305377(slot) {
    return (0, $jP65K.default)('MuiMenuItem', slot);
}
const $6bf90ec6342cf3dc$var$menuItemClasses = (0, $cOYaX.default)('MuiMenuItem', [
    'root',
    'focusVisible',
    'dense',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $6bf90ec6342cf3dc$export$2e2bcd8739ae039 = $6bf90ec6342cf3dc$var$menuItemClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $ee9f19037253b32c$var$_excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
];
const $ee9f19037253b32c$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $ee9f19037253b32c$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            disabled && 'disabled',
            !disableGutters && 'gutters',
            divider && 'divider',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $lXBIJ.default)(slots, (0, $6bf90ec6342cf3dc$export$515f8c67b5305377), classes);
    return (0, $zgVxD.default)({}, classes, composedClasses);
};
const $ee9f19037253b32c$var$MenuItemRoot = (0, $lbp1P.default)((0, $21281888ae95b2bd$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $awHZI.default)(prop) || prop === 'classes',
    name: 'MuiMenuItem',
    slot: 'Root',
    overridesResolver: $ee9f19037253b32c$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $zgVxD.default)({}, theme.typography.body1, {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: 'border-box',
        whiteSpace: 'nowrap'
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: 'padding-box'
    }, {
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $6bf90ec6342cf3dc$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $1r55V.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $6bf90ec6342cf3dc$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $1r55V.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $6bf90ec6342cf3dc$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $1r55V.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $1r55V.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $6bf90ec6342cf3dc$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $6bf90ec6342cf3dc$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $f2d3e61fef1da6e8$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $f2d3e61fef1da6e8$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $fb61fad9a5efd453$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $fb61fad9a5efd453$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $e7081451187db0ff$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up('sm')]: {
            minHeight: 'auto'
        }
    }, ownerState.dense && (0, $zgVxD.default)({
        minHeight: 32,
        // https://m2.material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, $e7081451187db0ff$export$2e2bcd8739ae039).root} svg`]: {
            fontSize: '1.25rem'
        }
    })));
const $ee9f19037253b32c$var$MenuItem = /*#__PURE__*/ $8FY87.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiMenuItem'
    });
    const { autoFocus: autoFocus = false, component: component = 'li', dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = 'menuitem', tabIndex: tabIndexProp, className: className } = props, other = (0, $93aRW.default)(props, $ee9f19037253b32c$var$_excluded);
    const context = $8FY87.useContext((0, $5387b76bde865f68$export$2e2bcd8739ae039));
    const childContext = $8FY87.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $8FY87.useRef(null);
    (0, $fb693b740ef0e8ff$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $zgVxD.default)({}, props, {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $ee9f19037253b32c$var$useUtilityClasses(props);
    const handleRef = (0, $520629ff5b0e6bac$export$2e2bcd8739ae039)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $5387b76bde865f68$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $2PPWI.jsx)($ee9f19037253b32c$var$MenuItemRoot, (0, $zgVxD.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $efJYy.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $efJYy.default)(classes.root, className)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
var $ee9f19037253b32c$export$2e2bcd8739ae039 = $ee9f19037253b32c$var$MenuItem;


// Generated file. Do not edit
var $1541e826bb18c315$export$efd5569f873811b1;
(function(StatusCodes) {
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.2.1
     *
     * This interim response indicates that everything so far is OK and that the client should continue with the request or ignore it if it is already finished.
     */ StatusCodes[StatusCodes["CONTINUE"] = 100] = "CONTINUE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.2.2
     *
     * This code is sent in response to an Upgrade request header by the client, and indicates the protocol the server is switching too.
     */ StatusCodes[StatusCodes["SWITCHING_PROTOCOLS"] = 101] = "SWITCHING_PROTOCOLS";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.1
     *
     * This code indicates that the server has received and is processing the request, but no response is available yet.
     */ StatusCodes[StatusCodes["PROCESSING"] = 102] = "PROCESSING";
    /**
     * Official Documentation @ https://www.rfc-editor.org/rfc/rfc8297#page-3
     *
     * This code indicates to the client that the server is likely to send a final response with the header fields included in the informational response.
     */ StatusCodes[StatusCodes["EARLY_HINTS"] = 103] = "EARLY_HINTS";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.1
     *
     * The request has succeeded. The meaning of a success varies depending on the HTTP method:
     * GET: The resource has been fetched and is transmitted in the message body.
     * HEAD: The entity headers are in the message body.
     * POST: The resource describing the result of the action is transmitted in the message body.
     * TRACE: The message body contains the request message as received by the server
     */ StatusCodes[StatusCodes["OK"] = 200] = "OK";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.2
     *
     * The request has succeeded and a new resource has been created as a result of it. This is typically the response sent after a PUT request.
     */ StatusCodes[StatusCodes["CREATED"] = 201] = "CREATED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.3
     *
     * The request has been received but not yet acted upon. It is non-committal, meaning that there is no way in HTTP to later send an asynchronous response indicating the outcome of processing the request. It is intended for cases where another process or server handles the request, or for batch processing.
     */ StatusCodes[StatusCodes["ACCEPTED"] = 202] = "ACCEPTED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.4
     *
     * This response code means returned meta-information set is not exact set as available from the origin server, but collected from a local or a third party copy. Except this condition, 200 OK response should be preferred instead of this response.
     */ StatusCodes[StatusCodes["NON_AUTHORITATIVE_INFORMATION"] = 203] = "NON_AUTHORITATIVE_INFORMATION";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.5
     *
     * There is no content to send for this request, but the headers may be useful. The user-agent may update its cached headers for this resource with the new ones.
     */ StatusCodes[StatusCodes["NO_CONTENT"] = 204] = "NO_CONTENT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.6
     *
     * This response code is sent after accomplishing request to tell user agent reset document view which sent this request.
     */ StatusCodes[StatusCodes["RESET_CONTENT"] = 205] = "RESET_CONTENT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7233#section-4.1
     *
     * This response code is used because of range header sent by the client to separate download into multiple streams.
     */ StatusCodes[StatusCodes["PARTIAL_CONTENT"] = 206] = "PARTIAL_CONTENT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.2
     *
     * A Multi-Status response conveys information about multiple resources in situations where multiple status codes might be appropriate.
     */ StatusCodes[StatusCodes["MULTI_STATUS"] = 207] = "MULTI_STATUS";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.1
     *
     * The request has more than one possible responses. User-agent or user should choose one of them. There is no standardized way to choose one of the responses.
     */ StatusCodes[StatusCodes["MULTIPLE_CHOICES"] = 300] = "MULTIPLE_CHOICES";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.2
     *
     * This response code means that URI of requested resource has been changed. Probably, new URI would be given in the response.
     */ StatusCodes[StatusCodes["MOVED_PERMANENTLY"] = 301] = "MOVED_PERMANENTLY";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.3
     *
     * This response code means that URI of requested resource has been changed temporarily. New changes in the URI might be made in the future. Therefore, this same URI should be used by the client in future requests.
     */ StatusCodes[StatusCodes["MOVED_TEMPORARILY"] = 302] = "MOVED_TEMPORARILY";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.4
     *
     * Server sent this response to directing client to get requested resource to another URI with an GET request.
     */ StatusCodes[StatusCodes["SEE_OTHER"] = 303] = "SEE_OTHER";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7232#section-4.1
     *
     * This is used for caching purposes. It is telling to client that response has not been modified. So, client can continue to use same cached version of response.
     */ StatusCodes[StatusCodes["NOT_MODIFIED"] = 304] = "NOT_MODIFIED";
    /**
     * @deprecated
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.6
     *
     * Was defined in a previous version of the HTTP specification to indicate that a requested response must be accessed by a proxy. It has been deprecated due to security concerns regarding in-band configuration of a proxy.
     */ StatusCodes[StatusCodes["USE_PROXY"] = 305] = "USE_PROXY";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.7
     *
     * Server sent this response to directing client to get requested resource to another URI with same method that used prior request. This has the same semantic than the 302 Found HTTP response code, with the exception that the user agent must not change the HTTP method used: if a POST was used in the first request, a POST must be used in the second request.
     */ StatusCodes[StatusCodes["TEMPORARY_REDIRECT"] = 307] = "TEMPORARY_REDIRECT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7538#section-3
     *
     * This means that the resource is now permanently located at another URI, specified by the Location: HTTP Response header. This has the same semantics as the 301 Moved Permanently HTTP response code, with the exception that the user agent must not change the HTTP method used: if a POST was used in the first request, a POST must be used in the second request.
     */ StatusCodes[StatusCodes["PERMANENT_REDIRECT"] = 308] = "PERMANENT_REDIRECT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.1
     *
     * This response means that server could not understand the request due to invalid syntax.
     */ StatusCodes[StatusCodes["BAD_REQUEST"] = 400] = "BAD_REQUEST";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7235#section-3.1
     *
     * Although the HTTP standard specifies "unauthorized", semantically this response means "unauthenticated". That is, the client must authenticate itself to get the requested response.
     */ StatusCodes[StatusCodes["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.2
     *
     * This response code is reserved for future use. Initial aim for creating this code was using it for digital payment systems however this is not used currently.
     */ StatusCodes[StatusCodes["PAYMENT_REQUIRED"] = 402] = "PAYMENT_REQUIRED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.3
     *
     * The client does not have access rights to the content, i.e. they are unauthorized, so server is rejecting to give proper response. Unlike 401, the client's identity is known to the server.
     */ StatusCodes[StatusCodes["FORBIDDEN"] = 403] = "FORBIDDEN";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.4
     *
     * The server can not find requested resource. In the browser, this means the URL is not recognized. In an API, this can also mean that the endpoint is valid but the resource itself does not exist. Servers may also send this response instead of 403 to hide the existence of a resource from an unauthorized client. This response code is probably the most famous one due to its frequent occurence on the web.
     */ StatusCodes[StatusCodes["NOT_FOUND"] = 404] = "NOT_FOUND";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.5
     *
     * The request method is known by the server but has been disabled and cannot be used. For example, an API may forbid DELETE-ing a resource. The two mandatory methods, GET and HEAD, must never be disabled and should not return this error code.
     */ StatusCodes[StatusCodes["METHOD_NOT_ALLOWED"] = 405] = "METHOD_NOT_ALLOWED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.6
     *
     * This response is sent when the web server, after performing server-driven content negotiation, doesn't find any content following the criteria given by the user agent.
     */ StatusCodes[StatusCodes["NOT_ACCEPTABLE"] = 406] = "NOT_ACCEPTABLE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7235#section-3.2
     *
     * This is similar to 401 but authentication is needed to be done by a proxy.
     */ StatusCodes[StatusCodes["PROXY_AUTHENTICATION_REQUIRED"] = 407] = "PROXY_AUTHENTICATION_REQUIRED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.7
     *
     * This response is sent on an idle connection by some servers, even without any previous request by the client. It means that the server would like to shut down this unused connection. This response is used much more since some browsers, like Chrome, Firefox 27+, or IE9, use HTTP pre-connection mechanisms to speed up surfing. Also note that some servers merely shut down the connection without sending this message.
     */ StatusCodes[StatusCodes["REQUEST_TIMEOUT"] = 408] = "REQUEST_TIMEOUT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.8
     *
     * This response is sent when a request conflicts with the current state of the server.
     */ StatusCodes[StatusCodes["CONFLICT"] = 409] = "CONFLICT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.9
     *
     * This response would be sent when the requested content has been permenantly deleted from server, with no forwarding address. Clients are expected to remove their caches and links to the resource. The HTTP specification intends this status code to be used for "limited-time, promotional services". APIs should not feel compelled to indicate resources that have been deleted with this status code.
     */ StatusCodes[StatusCodes["GONE"] = 410] = "GONE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.10
     *
     * The server rejected the request because the Content-Length header field is not defined and the server requires it.
     */ StatusCodes[StatusCodes["LENGTH_REQUIRED"] = 411] = "LENGTH_REQUIRED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7232#section-4.2
     *
     * The client has indicated preconditions in its headers which the server does not meet.
     */ StatusCodes[StatusCodes["PRECONDITION_FAILED"] = 412] = "PRECONDITION_FAILED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.11
     *
     * Request entity is larger than limits defined by server; the server might close the connection or return an Retry-After header field.
     */ StatusCodes[StatusCodes["REQUEST_TOO_LONG"] = 413] = "REQUEST_TOO_LONG";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.12
     *
     * The URI requested by the client is longer than the server is willing to interpret.
     */ StatusCodes[StatusCodes["REQUEST_URI_TOO_LONG"] = 414] = "REQUEST_URI_TOO_LONG";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.13
     *
     * The media format of the requested data is not supported by the server, so the server is rejecting the request.
     */ StatusCodes[StatusCodes["UNSUPPORTED_MEDIA_TYPE"] = 415] = "UNSUPPORTED_MEDIA_TYPE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7233#section-4.4
     *
     * The range specified by the Range header field in the request can't be fulfilled; it's possible that the range is outside the size of the target URI's data.
     */ StatusCodes[StatusCodes["REQUESTED_RANGE_NOT_SATISFIABLE"] = 416] = "REQUESTED_RANGE_NOT_SATISFIABLE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.14
     *
     * This response code means the expectation indicated by the Expect request header field can't be met by the server.
     */ StatusCodes[StatusCodes["EXPECTATION_FAILED"] = 417] = "EXPECTATION_FAILED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2324#section-2.3.2
     *
     * Any attempt to brew coffee with a teapot should result in the error code "418 I'm a teapot". The resulting entity body MAY be short and stout.
     */ StatusCodes[StatusCodes["IM_A_TEAPOT"] = 418] = "IM_A_TEAPOT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.6
     *
     * The 507 (Insufficient Storage) status code means the method could not be performed on the resource because the server is unable to store the representation needed to successfully complete the request. This condition is considered to be temporary. If the request which received this status code was the result of a user action, the request MUST NOT be repeated until it is requested by a separate user action.
     */ StatusCodes[StatusCodes["INSUFFICIENT_SPACE_ON_RESOURCE"] = 419] = "INSUFFICIENT_SPACE_ON_RESOURCE";
    /**
     * @deprecated
     * Official Documentation @ https://tools.ietf.org/rfcdiff?difftype=--hwdiff&url2=draft-ietf-webdav-protocol-06.txt
     *
     * A deprecated response used by the Spring Framework when a method has failed.
     */ StatusCodes[StatusCodes["METHOD_FAILURE"] = 420] = "METHOD_FAILURE";
    /**
     * Official Documentation @ https://datatracker.ietf.org/doc/html/rfc7540#section-9.1.2
     *
     * Defined in the specification of HTTP/2 to indicate that a server is not able to produce a response for the combination of scheme and authority that are included in the request URI.
     */ StatusCodes[StatusCodes["MISDIRECTED_REQUEST"] = 421] = "MISDIRECTED_REQUEST";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.3
     *
     * The request was well-formed but was unable to be followed due to semantic errors.
     */ StatusCodes[StatusCodes["UNPROCESSABLE_ENTITY"] = 422] = "UNPROCESSABLE_ENTITY";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.4
     *
     * The resource that is being accessed is locked.
     */ StatusCodes[StatusCodes["LOCKED"] = 423] = "LOCKED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.5
     *
     * The request failed due to failure of a previous request.
     */ StatusCodes[StatusCodes["FAILED_DEPENDENCY"] = 424] = "FAILED_DEPENDENCY";
    /**
     * Official Documentation @ https://datatracker.ietf.org/doc/html/rfc7231#section-6.5.15
     *
     * The server refuses to perform the request using the current protocol but might be willing to do so after the client upgrades to a different protocol.
     */ StatusCodes[StatusCodes["UPGRADE_REQUIRED"] = 426] = "UPGRADE_REQUIRED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc6585#section-3
     *
     * The origin server requires the request to be conditional. Intended to prevent the 'lost update' problem, where a client GETs a resource's state, modifies it, and PUTs it back to the server, when meanwhile a third party has modified the state on the server, leading to a conflict.
     */ StatusCodes[StatusCodes["PRECONDITION_REQUIRED"] = 428] = "PRECONDITION_REQUIRED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc6585#section-4
     *
     * The user has sent too many requests in a given amount of time ("rate limiting").
     */ StatusCodes[StatusCodes["TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc6585#section-5
     *
     * The server is unwilling to process the request because its header fields are too large. The request MAY be resubmitted after reducing the size of the request header fields.
     */ StatusCodes[StatusCodes["REQUEST_HEADER_FIELDS_TOO_LARGE"] = 431] = "REQUEST_HEADER_FIELDS_TOO_LARGE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7725
     *
     * The user-agent requested a resource that cannot legally be provided, such as a web page censored by a government.
     */ StatusCodes[StatusCodes["UNAVAILABLE_FOR_LEGAL_REASONS"] = 451] = "UNAVAILABLE_FOR_LEGAL_REASONS";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.1
     *
     * The server encountered an unexpected condition that prevented it from fulfilling the request.
     */ StatusCodes[StatusCodes["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.2
     *
     * The request method is not supported by the server and cannot be handled. The only methods that servers are required to support (and therefore that must not return this code) are GET and HEAD.
     */ StatusCodes[StatusCodes["NOT_IMPLEMENTED"] = 501] = "NOT_IMPLEMENTED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.3
     *
     * This error response means that the server, while working as a gateway to get a response needed to handle the request, got an invalid response.
     */ StatusCodes[StatusCodes["BAD_GATEWAY"] = 502] = "BAD_GATEWAY";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.4
     *
     * The server is not ready to handle the request. Common causes are a server that is down for maintenance or that is overloaded. Note that together with this response, a user-friendly page explaining the problem should be sent. This responses should be used for temporary conditions and the Retry-After: HTTP header should, if possible, contain the estimated time before the recovery of the service. The webmaster must also take care about the caching-related headers that are sent along with this response, as these temporary condition responses should usually not be cached.
     */ StatusCodes[StatusCodes["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.5
     *
     * This error response is given when the server is acting as a gateway and cannot get a response in time.
     */ StatusCodes[StatusCodes["GATEWAY_TIMEOUT"] = 504] = "GATEWAY_TIMEOUT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.6
     *
     * The HTTP version used in the request is not supported by the server.
     */ StatusCodes[StatusCodes["HTTP_VERSION_NOT_SUPPORTED"] = 505] = "HTTP_VERSION_NOT_SUPPORTED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.6
     *
     * The server has an internal configuration error: the chosen variant resource is configured to engage in transparent content negotiation itself, and is therefore not a proper end point in the negotiation process.
     */ StatusCodes[StatusCodes["INSUFFICIENT_STORAGE"] = 507] = "INSUFFICIENT_STORAGE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc6585#section-6
     *
     * The 511 status code indicates that the client needs to authenticate to gain network access.
     */ StatusCodes[StatusCodes["NETWORK_AUTHENTICATION_REQUIRED"] = 511] = "NETWORK_AUTHENTICATION_REQUIRED";
})($1541e826bb18c315$export$efd5569f873811b1 || ($1541e826bb18c315$export$efd5569f873811b1 = {}));



var $8FY87 = parcelRequire("8FY87");

var $8FY87 = parcelRequire("8FY87");

var $8FY87 = parcelRequire("8FY87");
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ /**
 * Module exports.
 * @public
 */ var $90eabfbe6d8fd730$export$98e6a39c04603d36;
var $90eabfbe6d8fd730$export$dfdc1655ccc5b9cb;
'use strict';
$90eabfbe6d8fd730$export$98e6a39c04603d36 = $90eabfbe6d8fd730$var$parse;
$90eabfbe6d8fd730$export$dfdc1655ccc5b9cb = $90eabfbe6d8fd730$var$serialize;
/**
 * Module variables.
 * @private
 */ var $90eabfbe6d8fd730$var$decode = decodeURIComponent;
var $90eabfbe6d8fd730$var$encode = encodeURIComponent;
/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */ var $90eabfbe6d8fd730$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */ function $90eabfbe6d8fd730$var$parse(str, options) {
    if (typeof str !== 'string') throw new TypeError('argument str must be a string');
    var obj = {};
    var opt = options || {};
    var pairs = str.split(';');
    var dec = opt.decode || $90eabfbe6d8fd730$var$decode;
    for(var i = 0; i < pairs.length; i++){
        var pair = pairs[i];
        var index = pair.indexOf('=');
        // skip things that don't look like key=value
        if (index < 0) continue;
        var key = pair.substring(0, index).trim();
        // only assign once
        if (undefined == obj[key]) {
            var val = pair.substring(index + 1, pair.length).trim();
            // quoted values
            if (val[0] === '"') val = val.slice(1, -1);
            obj[key] = $90eabfbe6d8fd730$var$tryDecode(val, dec);
        }
    }
    return obj;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */ function $90eabfbe6d8fd730$var$serialize(name, val, options) {
    var opt = options || {};
    var enc = opt.encode || $90eabfbe6d8fd730$var$encode;
    if (typeof enc !== 'function') throw new TypeError('option encode is invalid');
    if (!$90eabfbe6d8fd730$var$fieldContentRegExp.test(name)) throw new TypeError('argument name is invalid');
    var value = enc(val);
    if (value && !$90eabfbe6d8fd730$var$fieldContentRegExp.test(value)) throw new TypeError('argument val is invalid');
    var str = name + '=' + value;
    if (null != opt.maxAge) {
        var maxAge = opt.maxAge - 0;
        if (isNaN(maxAge) || !isFinite(maxAge)) throw new TypeError('option maxAge is invalid');
        str += '; Max-Age=' + Math.floor(maxAge);
    }
    if (opt.domain) {
        if (!$90eabfbe6d8fd730$var$fieldContentRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
        str += '; Domain=' + opt.domain;
    }
    if (opt.path) {
        if (!$90eabfbe6d8fd730$var$fieldContentRegExp.test(opt.path)) throw new TypeError('option path is invalid');
        str += '; Path=' + opt.path;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== 'function') throw new TypeError('option expires is invalid');
        str += '; Expires=' + opt.expires.toUTCString();
    }
    if (opt.httpOnly) str += '; HttpOnly';
    if (opt.secure) str += '; Secure';
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += '; SameSite=Strict';
                break;
            case 'lax':
                str += '; SameSite=Lax';
                break;
            case 'strict':
                str += '; SameSite=Strict';
                break;
            case 'none':
                str += '; SameSite=None';
                break;
            default:
                throw new TypeError('option sameSite is invalid');
        }
    }
    return str;
}
/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */ function $90eabfbe6d8fd730$var$tryDecode(str, decode) {
    try {
        return decode(str);
    } catch (e) {
        return str;
    }
}



function $4a028d11d9d69925$export$56232575010ba89() {
    // Can we get/set cookies on document.cookie?
    return typeof document === 'object' && typeof document.cookie === 'string';
}
function $4a028d11d9d69925$export$bfce569af136abdc() {
    document.cookie.split(';').forEach(function(c) {
        document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });
}
function $4a028d11d9d69925$export$d2e637738f5e6ae8(cookies, options) {
    if (typeof cookies === 'string') return $90eabfbe6d8fd730$export$98e6a39c04603d36(cookies, options);
    else if (typeof cookies === 'object' && cookies !== null) return cookies;
    else return {};
}
function $4a028d11d9d69925$export$9f55e081dbb22cd9(value, doNotParse) {
    if (typeof doNotParse === 'undefined') // We guess if the cookie start with { or [, it has been serialized
    doNotParse = !value || value[0] !== '{' && value[0] !== '[' && value[0] !== '"';
    return !doNotParse;
}
function $4a028d11d9d69925$export$bead674655ff515d(value, options) {
    if (options === void 0) options = {};
    var cleanValue = $4a028d11d9d69925$var$cleanupCookieValue(value);
    if ($4a028d11d9d69925$export$9f55e081dbb22cd9(cleanValue, options.doNotParse)) try {
        return JSON.parse(cleanValue);
    } catch (e) {
    // At least we tried
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function $4a028d11d9d69925$var$cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === 'j' && value[1] === ':') return value.substr(2);
    return value;
}


var $07084cf09a0c1624$var$__assign = undefined && undefined.__assign || function() {
    $07084cf09a0c1624$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $07084cf09a0c1624$var$__assign.apply(this, arguments);
};
var $07084cf09a0c1624$var$Cookies = /** @class */ function() {
    function Cookies(cookies, options) {
        var _this = this;
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.cookies = (0, $4a028d11d9d69925$export$d2e637738f5e6ae8)(cookies, options);
        new Promise(function() {
            _this.HAS_DOCUMENT_COOKIE = (0, $4a028d11d9d69925$export$56232575010ba89)();
        }).catch(function() {});
    }
    Cookies.prototype._updateBrowserValues = function(parseOptions) {
        if (!this.HAS_DOCUMENT_COOKIE) return;
        this.cookies = $90eabfbe6d8fd730$export$98e6a39c04603d36(document.cookie, parseOptions);
    };
    Cookies.prototype._emitChange = function(params) {
        for(var i = 0; i < this.changeListeners.length; ++i)this.changeListeners[i](params);
    };
    Cookies.prototype.get = function(name, options, parseOptions) {
        if (options === void 0) options = {};
        this._updateBrowserValues(parseOptions);
        return (0, $4a028d11d9d69925$export$bead674655ff515d)(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function(options, parseOptions) {
        if (options === void 0) options = {};
        this._updateBrowserValues(parseOptions);
        var result = {};
        for(var name_1 in this.cookies)result[name_1] = (0, $4a028d11d9d69925$export$bead674655ff515d)(this.cookies[name_1], options);
        return result;
    };
    Cookies.prototype.set = function(name, value, options) {
        var _a;
        if (typeof value === 'object') value = JSON.stringify(value);
        this.cookies = $07084cf09a0c1624$var$__assign($07084cf09a0c1624$var$__assign({}, this.cookies), (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = $90eabfbe6d8fd730$export$dfdc1655ccc5b9cb(name, value, options);
        this._emitChange({
            name: name,
            value: value,
            options: options
        });
    };
    Cookies.prototype.remove = function(name, options) {
        var finalOptions = options = $07084cf09a0c1624$var$__assign($07084cf09a0c1624$var$__assign({}, options), {
            expires: new Date(1970, 1, 1, 0, 0, 1),
            maxAge: 0
        });
        this.cookies = $07084cf09a0c1624$var$__assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = $90eabfbe6d8fd730$export$dfdc1655ccc5b9cb(name, '', finalOptions);
        this._emitChange({
            name: name,
            value: undefined,
            options: options
        });
    };
    Cookies.prototype.addChangeListener = function(callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function(callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) this.changeListeners.splice(idx, 1);
    };
    return Cookies;
}();
var $07084cf09a0c1624$export$2e2bcd8739ae039 = $07084cf09a0c1624$var$Cookies;


var $611be68d13069d5c$export$2e2bcd8739ae039 = (0, $07084cf09a0c1624$export$2e2bcd8739ae039);


var $181b0cf452bf90ea$export$2e2bcd8739ae039 = (0, $611be68d13069d5c$export$2e2bcd8739ae039);


var $66584bdd2edfca74$var$CookiesContext = $8FY87.createContext(new (0, $181b0cf452bf90ea$export$2e2bcd8739ae039)());
var $66584bdd2edfca74$export$2881499e37b75b9a = $66584bdd2edfca74$var$CookiesContext.Provider, $66584bdd2edfca74$export$b3bffd4bb7da6b8f = $66584bdd2edfca74$var$CookiesContext.Consumer;
var $66584bdd2edfca74$export$2e2bcd8739ae039 = $66584bdd2edfca74$var$CookiesContext;


function $2f261e6f9a82abed$export$23b68da80b41ce8c() {
    return typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined';
}


function $1f373de1ceea6eb7$export$2e2bcd8739ae039(dependencies) {
    var cookies = (0, $8FY87.useContext)((0, $66584bdd2edfca74$export$2e2bcd8739ae039));
    if (!cookies) throw new Error('Missing <CookiesProvider>');
    var initialCookies = cookies.getAll();
    var _a = (0, $8FY87.useState)(initialCookies), allCookies = _a[0], setCookies = _a[1];
    var previousCookiesRef = (0, $8FY87.useRef)(allCookies);
    if ((0, $2f261e6f9a82abed$export$23b68da80b41ce8c)()) (0, $8FY87.useLayoutEffect)(function() {
        function onChange() {
            var newCookies = cookies.getAll();
            if ($1f373de1ceea6eb7$var$shouldUpdate(dependencies || null, newCookies, previousCookiesRef.current)) setCookies(newCookies);
            previousCookiesRef.current = newCookies;
        }
        cookies.addChangeListener(onChange);
        return function() {
            cookies.removeChangeListener(onChange);
        };
    }, [
        cookies
    ]);
    var setCookie = (0, $8FY87.useMemo)(function() {
        return cookies.set.bind(cookies);
    }, [
        cookies
    ]);
    var removeCookie = (0, $8FY87.useMemo)(function() {
        return cookies.remove.bind(cookies);
    }, [
        cookies
    ]);
    return [
        allCookies,
        setCookie,
        removeCookie
    ];
}
function $1f373de1ceea6eb7$var$shouldUpdate(dependencies, newCookies, oldCookies) {
    if (!dependencies) return true;
    for(var _i = 0, dependencies_1 = dependencies; _i < dependencies_1.length; _i++){
        var dependency = dependencies_1[_i];
        if (newCookies[dependency] !== oldCookies[dependency]) return true;
    }
    return false;
}



var $33d3aaa52a311a31$exports = {};
"use strict";
"use client";

var $bcBLN = parcelRequire("bcBLN");
Object.defineProperty($33d3aaa52a311a31$exports, "__esModule", {
    value: true
});
$33d3aaa52a311a31$exports.default = void 0;

var $33d3aaa52a311a31$var$_createSvgIcon = $bcBLN((parcelRequire("485sq")));

var $2PPWI = parcelRequire("2PPWI");
var $33d3aaa52a311a31$var$_default = $33d3aaa52a311a31$exports.default = (0, $33d3aaa52a311a31$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2PPWI.jsx)("path", {
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z"
}), 'ArrowBack');


var $3b2767003d20258a$exports = {};
"use strict";
"use client";

var $bcBLN = parcelRequire("bcBLN");
Object.defineProperty($3b2767003d20258a$exports, "__esModule", {
    value: true
});
$3b2767003d20258a$exports.default = void 0;

var $3b2767003d20258a$var$_createSvgIcon = $bcBLN((parcelRequire("485sq")));

var $2PPWI = parcelRequire("2PPWI");
var $3b2767003d20258a$var$_default = $3b2767003d20258a$exports.default = (0, $3b2767003d20258a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2PPWI.jsx)("path", {
    d: "M12 6.5c3.79 0 7.17 2.13 8.82 5.5-1.65 3.37-5.02 5.5-8.82 5.5S4.83 15.37 3.18 12C4.83 8.63 8.21 6.5 12 6.5m0-2C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5m0 5c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5-2.5-1.12-2.5-2.5 1.12-2.5 2.5-2.5m0-2c-2.48 0-4.5 2.02-4.5 4.5s2.02 4.5 4.5 4.5 4.5-2.02 4.5-4.5-2.02-4.5-4.5-4.5"
}), 'RemoveRedEyeOutlined');


'use strict';
function $cdb9ac81908f91ab$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


var $5fccc6d11b1c7fac$exports = {};
// shim for using process in browser
var $5fccc6d11b1c7fac$var$process = $5fccc6d11b1c7fac$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $5fccc6d11b1c7fac$var$cachedSetTimeout;
var $5fccc6d11b1c7fac$var$cachedClearTimeout;
function $5fccc6d11b1c7fac$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $5fccc6d11b1c7fac$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $5fccc6d11b1c7fac$var$cachedSetTimeout = setTimeout;
        else $5fccc6d11b1c7fac$var$cachedSetTimeout = $5fccc6d11b1c7fac$var$defaultSetTimout;
    } catch (e) {
        $5fccc6d11b1c7fac$var$cachedSetTimeout = $5fccc6d11b1c7fac$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $5fccc6d11b1c7fac$var$cachedClearTimeout = clearTimeout;
        else $5fccc6d11b1c7fac$var$cachedClearTimeout = $5fccc6d11b1c7fac$var$defaultClearTimeout;
    } catch (e) {
        $5fccc6d11b1c7fac$var$cachedClearTimeout = $5fccc6d11b1c7fac$var$defaultClearTimeout;
    }
})();
function $5fccc6d11b1c7fac$var$runTimeout(fun) {
    if ($5fccc6d11b1c7fac$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($5fccc6d11b1c7fac$var$cachedSetTimeout === $5fccc6d11b1c7fac$var$defaultSetTimout || !$5fccc6d11b1c7fac$var$cachedSetTimeout) && setTimeout) {
        $5fccc6d11b1c7fac$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $5fccc6d11b1c7fac$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $5fccc6d11b1c7fac$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $5fccc6d11b1c7fac$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $5fccc6d11b1c7fac$var$runClearTimeout(marker) {
    if ($5fccc6d11b1c7fac$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($5fccc6d11b1c7fac$var$cachedClearTimeout === $5fccc6d11b1c7fac$var$defaultClearTimeout || !$5fccc6d11b1c7fac$var$cachedClearTimeout) && clearTimeout) {
        $5fccc6d11b1c7fac$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $5fccc6d11b1c7fac$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $5fccc6d11b1c7fac$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $5fccc6d11b1c7fac$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $5fccc6d11b1c7fac$var$queue = [];
var $5fccc6d11b1c7fac$var$draining = false;
var $5fccc6d11b1c7fac$var$currentQueue;
var $5fccc6d11b1c7fac$var$queueIndex = -1;
function $5fccc6d11b1c7fac$var$cleanUpNextTick() {
    if (!$5fccc6d11b1c7fac$var$draining || !$5fccc6d11b1c7fac$var$currentQueue) return;
    $5fccc6d11b1c7fac$var$draining = false;
    if ($5fccc6d11b1c7fac$var$currentQueue.length) $5fccc6d11b1c7fac$var$queue = $5fccc6d11b1c7fac$var$currentQueue.concat($5fccc6d11b1c7fac$var$queue);
    else $5fccc6d11b1c7fac$var$queueIndex = -1;
    if ($5fccc6d11b1c7fac$var$queue.length) $5fccc6d11b1c7fac$var$drainQueue();
}
function $5fccc6d11b1c7fac$var$drainQueue() {
    if ($5fccc6d11b1c7fac$var$draining) return;
    var timeout = $5fccc6d11b1c7fac$var$runTimeout($5fccc6d11b1c7fac$var$cleanUpNextTick);
    $5fccc6d11b1c7fac$var$draining = true;
    var len = $5fccc6d11b1c7fac$var$queue.length;
    while(len){
        $5fccc6d11b1c7fac$var$currentQueue = $5fccc6d11b1c7fac$var$queue;
        $5fccc6d11b1c7fac$var$queue = [];
        while(++$5fccc6d11b1c7fac$var$queueIndex < len)if ($5fccc6d11b1c7fac$var$currentQueue) $5fccc6d11b1c7fac$var$currentQueue[$5fccc6d11b1c7fac$var$queueIndex].run();
        $5fccc6d11b1c7fac$var$queueIndex = -1;
        len = $5fccc6d11b1c7fac$var$queue.length;
    }
    $5fccc6d11b1c7fac$var$currentQueue = null;
    $5fccc6d11b1c7fac$var$draining = false;
    $5fccc6d11b1c7fac$var$runClearTimeout(timeout);
}
$5fccc6d11b1c7fac$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $5fccc6d11b1c7fac$var$queue.push(new $5fccc6d11b1c7fac$var$Item(fun, args));
    if ($5fccc6d11b1c7fac$var$queue.length === 1 && !$5fccc6d11b1c7fac$var$draining) $5fccc6d11b1c7fac$var$runTimeout($5fccc6d11b1c7fac$var$drainQueue);
};
// v8 likes predictible objects
function $5fccc6d11b1c7fac$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$5fccc6d11b1c7fac$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$5fccc6d11b1c7fac$var$process.title = 'browser';
$5fccc6d11b1c7fac$var$process.browser = true;
$5fccc6d11b1c7fac$var$process.env = {};
$5fccc6d11b1c7fac$var$process.argv = [];
$5fccc6d11b1c7fac$var$process.version = ''; // empty string to avoid regexp issues
$5fccc6d11b1c7fac$var$process.versions = {};
function $5fccc6d11b1c7fac$var$noop() {}
$5fccc6d11b1c7fac$var$process.on = $5fccc6d11b1c7fac$var$noop;
$5fccc6d11b1c7fac$var$process.addListener = $5fccc6d11b1c7fac$var$noop;
$5fccc6d11b1c7fac$var$process.once = $5fccc6d11b1c7fac$var$noop;
$5fccc6d11b1c7fac$var$process.off = $5fccc6d11b1c7fac$var$noop;
$5fccc6d11b1c7fac$var$process.removeListener = $5fccc6d11b1c7fac$var$noop;
$5fccc6d11b1c7fac$var$process.removeAllListeners = $5fccc6d11b1c7fac$var$noop;
$5fccc6d11b1c7fac$var$process.emit = $5fccc6d11b1c7fac$var$noop;
$5fccc6d11b1c7fac$var$process.prependListener = $5fccc6d11b1c7fac$var$noop;
$5fccc6d11b1c7fac$var$process.prependOnceListener = $5fccc6d11b1c7fac$var$noop;
$5fccc6d11b1c7fac$var$process.listeners = function(name) {
    return [];
};
$5fccc6d11b1c7fac$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$5fccc6d11b1c7fac$var$process.cwd = function() {
    return '/';
};
$5fccc6d11b1c7fac$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$5fccc6d11b1c7fac$var$process.umask = function() {
    return 0;
};


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $0c7b3c2fc951f4eb$var$toString } = Object.prototype;
const { getPrototypeOf: $0c7b3c2fc951f4eb$var$getPrototypeOf } = Object;
const { iterator: $0c7b3c2fc951f4eb$var$iterator, toStringTag: $0c7b3c2fc951f4eb$var$toStringTag } = Symbol;
const $0c7b3c2fc951f4eb$var$kindOf = ((cache)=>(thing)=>{
        const str = $0c7b3c2fc951f4eb$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $0c7b3c2fc951f4eb$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$0c7b3c2fc951f4eb$var$kindOf(thing) === type;
};
const $0c7b3c2fc951f4eb$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $0c7b3c2fc951f4eb$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $0c7b3c2fc951f4eb$var$isUndefined = $0c7b3c2fc951f4eb$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $0c7b3c2fc951f4eb$var$isBuffer(val) {
    return val !== null && !$0c7b3c2fc951f4eb$var$isUndefined(val) && val.constructor !== null && !$0c7b3c2fc951f4eb$var$isUndefined(val.constructor) && $0c7b3c2fc951f4eb$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $0c7b3c2fc951f4eb$var$isArrayBuffer = $0c7b3c2fc951f4eb$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $0c7b3c2fc951f4eb$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $0c7b3c2fc951f4eb$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $0c7b3c2fc951f4eb$var$isString = $0c7b3c2fc951f4eb$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $0c7b3c2fc951f4eb$var$isFunction = $0c7b3c2fc951f4eb$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $0c7b3c2fc951f4eb$var$isNumber = $0c7b3c2fc951f4eb$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $0c7b3c2fc951f4eb$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $0c7b3c2fc951f4eb$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $0c7b3c2fc951f4eb$var$isPlainObject = (val)=>{
    if ($0c7b3c2fc951f4eb$var$kindOf(val) !== 'object') return false;
    const prototype = $0c7b3c2fc951f4eb$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($0c7b3c2fc951f4eb$var$toStringTag in val) && !($0c7b3c2fc951f4eb$var$iterator in val);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $0c7b3c2fc951f4eb$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$0c7b3c2fc951f4eb$var$isObject(val) || $0c7b3c2fc951f4eb$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $0c7b3c2fc951f4eb$var$isDate = $0c7b3c2fc951f4eb$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $0c7b3c2fc951f4eb$var$isFile = $0c7b3c2fc951f4eb$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 * 
 * @param {*} value The value to test
 * 
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $0c7b3c2fc951f4eb$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 * 
 * @param {*} formData The formData to test
 * 
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $0c7b3c2fc951f4eb$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $0c7b3c2fc951f4eb$var$isBlob = $0c7b3c2fc951f4eb$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $0c7b3c2fc951f4eb$var$isFileList = $0c7b3c2fc951f4eb$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $0c7b3c2fc951f4eb$var$isStream = (val)=>$0c7b3c2fc951f4eb$var$isObject(val) && $0c7b3c2fc951f4eb$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $0c7b3c2fc951f4eb$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $0c7b3c2fc951f4eb$var$G = $0c7b3c2fc951f4eb$var$getGlobal();
const $0c7b3c2fc951f4eb$var$FormDataCtor = typeof $0c7b3c2fc951f4eb$var$G.FormData !== 'undefined' ? $0c7b3c2fc951f4eb$var$G.FormData : undefined;
const $0c7b3c2fc951f4eb$var$isFormData = (thing)=>{
    let kind;
    return thing && ($0c7b3c2fc951f4eb$var$FormDataCtor && thing instanceof $0c7b3c2fc951f4eb$var$FormDataCtor || $0c7b3c2fc951f4eb$var$isFunction(thing.append) && ((kind = $0c7b3c2fc951f4eb$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $0c7b3c2fc951f4eb$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $0c7b3c2fc951f4eb$var$isURLSearchParams = $0c7b3c2fc951f4eb$var$kindOfTest('URLSearchParams');
const [$0c7b3c2fc951f4eb$var$isReadableStream, $0c7b3c2fc951f4eb$var$isRequest, $0c7b3c2fc951f4eb$var$isResponse, $0c7b3c2fc951f4eb$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($0c7b3c2fc951f4eb$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $0c7b3c2fc951f4eb$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $0c7b3c2fc951f4eb$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($0c7b3c2fc951f4eb$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($0c7b3c2fc951f4eb$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $0c7b3c2fc951f4eb$var$findKey(obj, key) {
    if ($0c7b3c2fc951f4eb$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $0c7b3c2fc951f4eb$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $0c7b3c2fc951f4eb$var$isContextDefined = (context)=>!$0c7b3c2fc951f4eb$var$isUndefined(context) && context !== $0c7b3c2fc951f4eb$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $0c7b3c2fc951f4eb$var$merge() {
    const { caseless: caseless, skipUndefined: skipUndefined } = $0c7b3c2fc951f4eb$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        const targetKey = caseless && $0c7b3c2fc951f4eb$var$findKey(result, key) || key;
        if ($0c7b3c2fc951f4eb$var$isPlainObject(result[targetKey]) && $0c7b3c2fc951f4eb$var$isPlainObject(val)) result[targetKey] = $0c7b3c2fc951f4eb$var$merge(result[targetKey], val);
        else if ($0c7b3c2fc951f4eb$var$isPlainObject(val)) result[targetKey] = $0c7b3c2fc951f4eb$var$merge({}, val);
        else if ($0c7b3c2fc951f4eb$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$0c7b3c2fc951f4eb$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $0c7b3c2fc951f4eb$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $0c7b3c2fc951f4eb$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $0c7b3c2fc951f4eb$var$forEach(b, (val, key)=>{
        if (thisArg && $0c7b3c2fc951f4eb$var$isFunction(val)) Object.defineProperty(a, key, {
            value: (0, $cdb9ac81908f91ab$export$2e2bcd8739ae039)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $0c7b3c2fc951f4eb$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $0c7b3c2fc951f4eb$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $0c7b3c2fc951f4eb$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $0c7b3c2fc951f4eb$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $0c7b3c2fc951f4eb$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $0c7b3c2fc951f4eb$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($0c7b3c2fc951f4eb$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$0c7b3c2fc951f4eb$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $0c7b3c2fc951f4eb$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $0c7b3c2fc951f4eb$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $0c7b3c2fc951f4eb$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$0c7b3c2fc951f4eb$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $0c7b3c2fc951f4eb$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $0c7b3c2fc951f4eb$var$isHTMLForm = $0c7b3c2fc951f4eb$var$kindOfTest('HTMLFormElement');
const $0c7b3c2fc951f4eb$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $0c7b3c2fc951f4eb$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $0c7b3c2fc951f4eb$var$isRegExp = $0c7b3c2fc951f4eb$var$kindOfTest('RegExp');
const $0c7b3c2fc951f4eb$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $0c7b3c2fc951f4eb$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $0c7b3c2fc951f4eb$var$freezeMethods = (obj)=>{
    $0c7b3c2fc951f4eb$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($0c7b3c2fc951f4eb$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$0c7b3c2fc951f4eb$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $0c7b3c2fc951f4eb$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $0c7b3c2fc951f4eb$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $0c7b3c2fc951f4eb$var$noop = ()=>{};
const $0c7b3c2fc951f4eb$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $0c7b3c2fc951f4eb$var$isSpecCompliantForm(thing) {
    return !!(thing && $0c7b3c2fc951f4eb$var$isFunction(thing.append) && thing[$0c7b3c2fc951f4eb$var$toStringTag] === 'FormData' && thing[$0c7b3c2fc951f4eb$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $0c7b3c2fc951f4eb$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($0c7b3c2fc951f4eb$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            //Buffer check
            if ($0c7b3c2fc951f4eb$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $0c7b3c2fc951f4eb$var$isArray(source) ? [] : {};
                $0c7b3c2fc951f4eb$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$0c7b3c2fc951f4eb$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $0c7b3c2fc951f4eb$var$isAsyncFn = $0c7b3c2fc951f4eb$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $0c7b3c2fc951f4eb$var$isThenable = (thing)=>thing && ($0c7b3c2fc951f4eb$var$isObject(thing) || $0c7b3c2fc951f4eb$var$isFunction(thing)) && $0c7b3c2fc951f4eb$var$isFunction(thing.then) && $0c7b3c2fc951f4eb$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $0c7b3c2fc951f4eb$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $0c7b3c2fc951f4eb$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $0c7b3c2fc951f4eb$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $0c7b3c2fc951f4eb$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $0c7b3c2fc951f4eb$var$isFunction($0c7b3c2fc951f4eb$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $0c7b3c2fc951f4eb$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($0c7b3c2fc951f4eb$var$_global) : typeof $5fccc6d11b1c7fac$exports !== 'undefined' && $5fccc6d11b1c7fac$exports.nextTick || $0c7b3c2fc951f4eb$var$_setImmediate;
// *********************
const $0c7b3c2fc951f4eb$var$isIterable = (thing)=>thing != null && $0c7b3c2fc951f4eb$var$isFunction(thing[$0c7b3c2fc951f4eb$var$iterator]);
var $0c7b3c2fc951f4eb$export$2e2bcd8739ae039 = {
    isArray: $0c7b3c2fc951f4eb$var$isArray,
    isArrayBuffer: $0c7b3c2fc951f4eb$var$isArrayBuffer,
    isBuffer: $0c7b3c2fc951f4eb$var$isBuffer,
    isFormData: $0c7b3c2fc951f4eb$var$isFormData,
    isArrayBufferView: $0c7b3c2fc951f4eb$var$isArrayBufferView,
    isString: $0c7b3c2fc951f4eb$var$isString,
    isNumber: $0c7b3c2fc951f4eb$var$isNumber,
    isBoolean: $0c7b3c2fc951f4eb$var$isBoolean,
    isObject: $0c7b3c2fc951f4eb$var$isObject,
    isPlainObject: $0c7b3c2fc951f4eb$var$isPlainObject,
    isEmptyObject: $0c7b3c2fc951f4eb$var$isEmptyObject,
    isReadableStream: $0c7b3c2fc951f4eb$var$isReadableStream,
    isRequest: $0c7b3c2fc951f4eb$var$isRequest,
    isResponse: $0c7b3c2fc951f4eb$var$isResponse,
    isHeaders: $0c7b3c2fc951f4eb$var$isHeaders,
    isUndefined: $0c7b3c2fc951f4eb$var$isUndefined,
    isDate: $0c7b3c2fc951f4eb$var$isDate,
    isFile: $0c7b3c2fc951f4eb$var$isFile,
    isReactNativeBlob: $0c7b3c2fc951f4eb$var$isReactNativeBlob,
    isReactNative: $0c7b3c2fc951f4eb$var$isReactNative,
    isBlob: $0c7b3c2fc951f4eb$var$isBlob,
    isRegExp: $0c7b3c2fc951f4eb$var$isRegExp,
    isFunction: $0c7b3c2fc951f4eb$var$isFunction,
    isStream: $0c7b3c2fc951f4eb$var$isStream,
    isURLSearchParams: $0c7b3c2fc951f4eb$var$isURLSearchParams,
    isTypedArray: $0c7b3c2fc951f4eb$var$isTypedArray,
    isFileList: $0c7b3c2fc951f4eb$var$isFileList,
    forEach: $0c7b3c2fc951f4eb$var$forEach,
    merge: $0c7b3c2fc951f4eb$var$merge,
    extend: $0c7b3c2fc951f4eb$var$extend,
    trim: $0c7b3c2fc951f4eb$var$trim,
    stripBOM: $0c7b3c2fc951f4eb$var$stripBOM,
    inherits: $0c7b3c2fc951f4eb$var$inherits,
    toFlatObject: $0c7b3c2fc951f4eb$var$toFlatObject,
    kindOf: $0c7b3c2fc951f4eb$var$kindOf,
    kindOfTest: $0c7b3c2fc951f4eb$var$kindOfTest,
    endsWith: $0c7b3c2fc951f4eb$var$endsWith,
    toArray: $0c7b3c2fc951f4eb$var$toArray,
    forEachEntry: $0c7b3c2fc951f4eb$var$forEachEntry,
    matchAll: $0c7b3c2fc951f4eb$var$matchAll,
    isHTMLForm: $0c7b3c2fc951f4eb$var$isHTMLForm,
    hasOwnProperty: $0c7b3c2fc951f4eb$var$hasOwnProperty,
    hasOwnProp: $0c7b3c2fc951f4eb$var$hasOwnProperty,
    reduceDescriptors: $0c7b3c2fc951f4eb$var$reduceDescriptors,
    freezeMethods: $0c7b3c2fc951f4eb$var$freezeMethods,
    toObjectSet: $0c7b3c2fc951f4eb$var$toObjectSet,
    toCamelCase: $0c7b3c2fc951f4eb$var$toCamelCase,
    noop: $0c7b3c2fc951f4eb$var$noop,
    toFiniteNumber: $0c7b3c2fc951f4eb$var$toFiniteNumber,
    findKey: $0c7b3c2fc951f4eb$var$findKey,
    global: $0c7b3c2fc951f4eb$var$_global,
    isContextDefined: $0c7b3c2fc951f4eb$var$isContextDefined,
    isSpecCompliantForm: $0c7b3c2fc951f4eb$var$isSpecCompliantForm,
    toJSONObject: $0c7b3c2fc951f4eb$var$toJSONObject,
    isAsyncFn: $0c7b3c2fc951f4eb$var$isAsyncFn,
    isThenable: $0c7b3c2fc951f4eb$var$isThenable,
    setImmediate: $0c7b3c2fc951f4eb$var$_setImmediate,
    asap: $0c7b3c2fc951f4eb$var$asap,
    isIterable: $0c7b3c2fc951f4eb$var$isIterable
};







'use strict';
class $7836b3da25ffce53$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        const axiosError = new $7836b3da25ffce53$var$AxiosError(error.message, code || error.code, config, request, response);
        axiosError.cause = error;
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
     * Create an Error with the specified message, config, error code, request and response.
     *
     * @param {string} message The error message.
     * @param {string} [code] The error code (for example, 'ECONNABORTED').
     * @param {Object} [config] The config.
     * @param {Object} [request] The request.
     * @param {Object} [response] The response.
     *
     * @returns {Error} The created error.
     */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$7836b3da25ffce53$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$7836b3da25ffce53$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$7836b3da25ffce53$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$7836b3da25ffce53$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$7836b3da25ffce53$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$7836b3da25ffce53$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$7836b3da25ffce53$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$7836b3da25ffce53$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$7836b3da25ffce53$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$7836b3da25ffce53$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$7836b3da25ffce53$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$7836b3da25ffce53$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
var $7836b3da25ffce53$export$2e2bcd8739ae039 = $7836b3da25ffce53$var$AxiosError;


// eslint-disable-next-line strict
var $8f7716808888e99c$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $688cc5ea2aa0f73b$export$a143d493d941bafc;
var $688cc5ea2aa0f73b$export$e4cf37d7f6fb9e0a;
var $688cc5ea2aa0f73b$export$f99ded8fe4b79145;
var $688cc5ea2aa0f73b$export$599f31c3813fae4d;
'use strict';
var $0370db87c131b873$export$a48f0734ac7c2329;
var $0370db87c131b873$export$d622b2ad8d90c771;
var $0370db87c131b873$export$6100ba28696e12de;
'use strict';
$0370db87c131b873$export$a48f0734ac7c2329 = $0370db87c131b873$var$byteLength;
$0370db87c131b873$export$d622b2ad8d90c771 = $0370db87c131b873$var$toByteArray;
$0370db87c131b873$export$6100ba28696e12de = $0370db87c131b873$var$fromByteArray;
var $0370db87c131b873$var$lookup = [];
var $0370db87c131b873$var$revLookup = [];
var $0370db87c131b873$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $0370db87c131b873$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $0370db87c131b873$var$i = 0, $0370db87c131b873$var$len = $0370db87c131b873$var$code.length; $0370db87c131b873$var$i < $0370db87c131b873$var$len; ++$0370db87c131b873$var$i){
    $0370db87c131b873$var$lookup[$0370db87c131b873$var$i] = $0370db87c131b873$var$code[$0370db87c131b873$var$i];
    $0370db87c131b873$var$revLookup[$0370db87c131b873$var$code.charCodeAt($0370db87c131b873$var$i)] = $0370db87c131b873$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$0370db87c131b873$var$revLookup['-'.charCodeAt(0)] = 62;
$0370db87c131b873$var$revLookup['_'.charCodeAt(0)] = 63;
function $0370db87c131b873$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $0370db87c131b873$var$byteLength(b64) {
    var lens = $0370db87c131b873$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $0370db87c131b873$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $0370db87c131b873$var$toByteArray(b64) {
    var tmp;
    var lens = $0370db87c131b873$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $0370db87c131b873$var$Arr($0370db87c131b873$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $0370db87c131b873$var$revLookup[b64.charCodeAt(i)] << 18 | $0370db87c131b873$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $0370db87c131b873$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $0370db87c131b873$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $0370db87c131b873$var$revLookup[b64.charCodeAt(i)] << 2 | $0370db87c131b873$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $0370db87c131b873$var$revLookup[b64.charCodeAt(i)] << 10 | $0370db87c131b873$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $0370db87c131b873$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $0370db87c131b873$var$tripletToBase64(num) {
    return $0370db87c131b873$var$lookup[num >> 18 & 0x3F] + $0370db87c131b873$var$lookup[num >> 12 & 0x3F] + $0370db87c131b873$var$lookup[num >> 6 & 0x3F] + $0370db87c131b873$var$lookup[num & 0x3F];
}
function $0370db87c131b873$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($0370db87c131b873$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $0370db87c131b873$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($0370db87c131b873$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($0370db87c131b873$var$lookup[tmp >> 2] + $0370db87c131b873$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($0370db87c131b873$var$lookup[tmp >> 10] + $0370db87c131b873$var$lookup[tmp >> 4 & 0x3F] + $0370db87c131b873$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $2fccba5c1a2089cc$export$aafa59e2e03f2942;
var $2fccba5c1a2089cc$export$68d8715fc104d294;
$2fccba5c1a2089cc$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$2fccba5c1a2089cc$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $688cc5ea2aa0f73b$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$688cc5ea2aa0f73b$export$a143d493d941bafc = $688cc5ea2aa0f73b$var$Buffer;
$688cc5ea2aa0f73b$export$e4cf37d7f6fb9e0a = $688cc5ea2aa0f73b$var$SlowBuffer;
$688cc5ea2aa0f73b$export$f99ded8fe4b79145 = 50;
const $688cc5ea2aa0f73b$var$K_MAX_LENGTH = 0x7fffffff;
$688cc5ea2aa0f73b$export$599f31c3813fae4d = $688cc5ea2aa0f73b$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $688cc5ea2aa0f73b$var$Buffer.TYPED_ARRAY_SUPPORT = $688cc5ea2aa0f73b$var$typedArraySupport();
if (!$688cc5ea2aa0f73b$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $688cc5ea2aa0f73b$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($688cc5ea2aa0f73b$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$688cc5ea2aa0f73b$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($688cc5ea2aa0f73b$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$688cc5ea2aa0f73b$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $688cc5ea2aa0f73b$var$createBuffer(length) {
    if (length > $688cc5ea2aa0f73b$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $688cc5ea2aa0f73b$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $688cc5ea2aa0f73b$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $688cc5ea2aa0f73b$var$allocUnsafe(arg);
    }
    return $688cc5ea2aa0f73b$var$from(arg, encodingOrOffset, length);
}
$688cc5ea2aa0f73b$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $688cc5ea2aa0f73b$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $688cc5ea2aa0f73b$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $688cc5ea2aa0f73b$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($688cc5ea2aa0f73b$var$isInstance(value, ArrayBuffer) || value && $688cc5ea2aa0f73b$var$isInstance(value.buffer, ArrayBuffer)) return $688cc5ea2aa0f73b$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($688cc5ea2aa0f73b$var$isInstance(value, SharedArrayBuffer) || value && $688cc5ea2aa0f73b$var$isInstance(value.buffer, SharedArrayBuffer))) return $688cc5ea2aa0f73b$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $688cc5ea2aa0f73b$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $688cc5ea2aa0f73b$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $688cc5ea2aa0f73b$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $688cc5ea2aa0f73b$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $688cc5ea2aa0f73b$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($688cc5ea2aa0f73b$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($688cc5ea2aa0f73b$var$Buffer, Uint8Array);
function $688cc5ea2aa0f73b$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $688cc5ea2aa0f73b$var$alloc(size, fill, encoding) {
    $688cc5ea2aa0f73b$var$assertSize(size);
    if (size <= 0) return $688cc5ea2aa0f73b$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $688cc5ea2aa0f73b$var$createBuffer(size).fill(fill, encoding) : $688cc5ea2aa0f73b$var$createBuffer(size).fill(fill);
    return $688cc5ea2aa0f73b$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $688cc5ea2aa0f73b$var$Buffer.alloc = function(size, fill, encoding) {
    return $688cc5ea2aa0f73b$var$alloc(size, fill, encoding);
};
function $688cc5ea2aa0f73b$var$allocUnsafe(size) {
    $688cc5ea2aa0f73b$var$assertSize(size);
    return $688cc5ea2aa0f73b$var$createBuffer(size < 0 ? 0 : $688cc5ea2aa0f73b$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $688cc5ea2aa0f73b$var$Buffer.allocUnsafe = function(size) {
    return $688cc5ea2aa0f73b$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $688cc5ea2aa0f73b$var$Buffer.allocUnsafeSlow = function(size) {
    return $688cc5ea2aa0f73b$var$allocUnsafe(size);
};
function $688cc5ea2aa0f73b$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$688cc5ea2aa0f73b$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $688cc5ea2aa0f73b$var$byteLength(string, encoding) | 0;
    let buf = $688cc5ea2aa0f73b$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $688cc5ea2aa0f73b$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $688cc5ea2aa0f73b$var$checked(array.length) | 0;
    const buf = $688cc5ea2aa0f73b$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $688cc5ea2aa0f73b$var$fromArrayView(arrayView) {
    if ($688cc5ea2aa0f73b$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $688cc5ea2aa0f73b$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $688cc5ea2aa0f73b$var$fromArrayLike(arrayView);
}
function $688cc5ea2aa0f73b$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $688cc5ea2aa0f73b$var$Buffer.prototype);
    return buf;
}
function $688cc5ea2aa0f73b$var$fromObject(obj) {
    if ($688cc5ea2aa0f73b$var$Buffer.isBuffer(obj)) {
        const len = $688cc5ea2aa0f73b$var$checked(obj.length) | 0;
        const buf = $688cc5ea2aa0f73b$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $688cc5ea2aa0f73b$var$numberIsNaN(obj.length)) return $688cc5ea2aa0f73b$var$createBuffer(0);
        return $688cc5ea2aa0f73b$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $688cc5ea2aa0f73b$var$fromArrayLike(obj.data);
}
function $688cc5ea2aa0f73b$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $688cc5ea2aa0f73b$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $688cc5ea2aa0f73b$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $688cc5ea2aa0f73b$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $688cc5ea2aa0f73b$var$Buffer.alloc(+length);
}
$688cc5ea2aa0f73b$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $688cc5ea2aa0f73b$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$688cc5ea2aa0f73b$var$Buffer.compare = function compare(a, b) {
    if ($688cc5ea2aa0f73b$var$isInstance(a, Uint8Array)) a = $688cc5ea2aa0f73b$var$Buffer.from(a, a.offset, a.byteLength);
    if ($688cc5ea2aa0f73b$var$isInstance(b, Uint8Array)) b = $688cc5ea2aa0f73b$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$688cc5ea2aa0f73b$var$Buffer.isBuffer(a) || !$688cc5ea2aa0f73b$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$688cc5ea2aa0f73b$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$688cc5ea2aa0f73b$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $688cc5ea2aa0f73b$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $688cc5ea2aa0f73b$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($688cc5ea2aa0f73b$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$688cc5ea2aa0f73b$var$Buffer.isBuffer(buf)) buf = $688cc5ea2aa0f73b$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$688cc5ea2aa0f73b$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $688cc5ea2aa0f73b$var$byteLength(string, encoding) {
    if ($688cc5ea2aa0f73b$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $688cc5ea2aa0f73b$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $688cc5ea2aa0f73b$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $688cc5ea2aa0f73b$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $688cc5ea2aa0f73b$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$688cc5ea2aa0f73b$var$Buffer.byteLength = $688cc5ea2aa0f73b$var$byteLength;
function $688cc5ea2aa0f73b$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $688cc5ea2aa0f73b$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $688cc5ea2aa0f73b$var$utf8Slice(this, start, end);
        case 'ascii':
            return $688cc5ea2aa0f73b$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $688cc5ea2aa0f73b$var$latin1Slice(this, start, end);
        case 'base64':
            return $688cc5ea2aa0f73b$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $688cc5ea2aa0f73b$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$688cc5ea2aa0f73b$var$Buffer.prototype._isBuffer = true;
function $688cc5ea2aa0f73b$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$688cc5ea2aa0f73b$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$688cc5ea2aa0f73b$var$swap(this, i, i + 1);
    return this;
};
$688cc5ea2aa0f73b$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $688cc5ea2aa0f73b$var$swap(this, i, i + 3);
        $688cc5ea2aa0f73b$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$688cc5ea2aa0f73b$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $688cc5ea2aa0f73b$var$swap(this, i, i + 7);
        $688cc5ea2aa0f73b$var$swap(this, i + 1, i + 6);
        $688cc5ea2aa0f73b$var$swap(this, i + 2, i + 5);
        $688cc5ea2aa0f73b$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$688cc5ea2aa0f73b$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $688cc5ea2aa0f73b$var$utf8Slice(this, 0, length);
    return $688cc5ea2aa0f73b$var$slowToString.apply(this, arguments);
};
$688cc5ea2aa0f73b$var$Buffer.prototype.toLocaleString = $688cc5ea2aa0f73b$var$Buffer.prototype.toString;
$688cc5ea2aa0f73b$var$Buffer.prototype.equals = function equals(b) {
    if (!$688cc5ea2aa0f73b$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $688cc5ea2aa0f73b$var$Buffer.compare(this, b) === 0;
};
$688cc5ea2aa0f73b$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $688cc5ea2aa0f73b$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($688cc5ea2aa0f73b$var$customInspectSymbol) $688cc5ea2aa0f73b$var$Buffer.prototype[$688cc5ea2aa0f73b$var$customInspectSymbol] = $688cc5ea2aa0f73b$var$Buffer.prototype.inspect;
$688cc5ea2aa0f73b$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($688cc5ea2aa0f73b$var$isInstance(target, Uint8Array)) target = $688cc5ea2aa0f73b$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$688cc5ea2aa0f73b$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $688cc5ea2aa0f73b$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($688cc5ea2aa0f73b$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $688cc5ea2aa0f73b$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($688cc5ea2aa0f73b$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $688cc5ea2aa0f73b$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $688cc5ea2aa0f73b$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $688cc5ea2aa0f73b$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$688cc5ea2aa0f73b$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$688cc5ea2aa0f73b$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $688cc5ea2aa0f73b$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$688cc5ea2aa0f73b$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $688cc5ea2aa0f73b$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $688cc5ea2aa0f73b$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($688cc5ea2aa0f73b$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $688cc5ea2aa0f73b$var$utf8Write(buf, string, offset, length) {
    return $688cc5ea2aa0f73b$var$blitBuffer($688cc5ea2aa0f73b$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $688cc5ea2aa0f73b$var$asciiWrite(buf, string, offset, length) {
    return $688cc5ea2aa0f73b$var$blitBuffer($688cc5ea2aa0f73b$var$asciiToBytes(string), buf, offset, length);
}
function $688cc5ea2aa0f73b$var$base64Write(buf, string, offset, length) {
    return $688cc5ea2aa0f73b$var$blitBuffer($688cc5ea2aa0f73b$var$base64ToBytes(string), buf, offset, length);
}
function $688cc5ea2aa0f73b$var$ucs2Write(buf, string, offset, length) {
    return $688cc5ea2aa0f73b$var$blitBuffer($688cc5ea2aa0f73b$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$688cc5ea2aa0f73b$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $688cc5ea2aa0f73b$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $688cc5ea2aa0f73b$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $688cc5ea2aa0f73b$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $688cc5ea2aa0f73b$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $688cc5ea2aa0f73b$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$688cc5ea2aa0f73b$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $688cc5ea2aa0f73b$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $0370db87c131b873$export$6100ba28696e12de(buf);
    else return $0370db87c131b873$export$6100ba28696e12de(buf.slice(start, end));
}
function $688cc5ea2aa0f73b$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $688cc5ea2aa0f73b$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $688cc5ea2aa0f73b$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $688cc5ea2aa0f73b$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $688cc5ea2aa0f73b$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $688cc5ea2aa0f73b$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $688cc5ea2aa0f73b$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $688cc5ea2aa0f73b$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $688cc5ea2aa0f73b$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $688cc5ea2aa0f73b$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $688cc5ea2aa0f73b$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$688cc5ea2aa0f73b$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $688cc5ea2aa0f73b$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $688cc5ea2aa0f73b$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$688cc5ea2aa0f73b$var$Buffer.prototype.readUintLE = $688cc5ea2aa0f73b$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $688cc5ea2aa0f73b$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$688cc5ea2aa0f73b$var$Buffer.prototype.readUintBE = $688cc5ea2aa0f73b$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $688cc5ea2aa0f73b$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$688cc5ea2aa0f73b$var$Buffer.prototype.readUint8 = $688cc5ea2aa0f73b$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $688cc5ea2aa0f73b$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$688cc5ea2aa0f73b$var$Buffer.prototype.readUint16LE = $688cc5ea2aa0f73b$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $688cc5ea2aa0f73b$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$688cc5ea2aa0f73b$var$Buffer.prototype.readUint16BE = $688cc5ea2aa0f73b$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $688cc5ea2aa0f73b$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$688cc5ea2aa0f73b$var$Buffer.prototype.readUint32LE = $688cc5ea2aa0f73b$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $688cc5ea2aa0f73b$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$688cc5ea2aa0f73b$var$Buffer.prototype.readUint32BE = $688cc5ea2aa0f73b$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $688cc5ea2aa0f73b$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$688cc5ea2aa0f73b$var$Buffer.prototype.readBigUInt64LE = $688cc5ea2aa0f73b$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $688cc5ea2aa0f73b$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $688cc5ea2aa0f73b$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$688cc5ea2aa0f73b$var$Buffer.prototype.readBigUInt64BE = $688cc5ea2aa0f73b$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $688cc5ea2aa0f73b$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $688cc5ea2aa0f73b$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$688cc5ea2aa0f73b$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $688cc5ea2aa0f73b$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$688cc5ea2aa0f73b$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $688cc5ea2aa0f73b$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$688cc5ea2aa0f73b$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $688cc5ea2aa0f73b$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$688cc5ea2aa0f73b$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $688cc5ea2aa0f73b$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$688cc5ea2aa0f73b$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $688cc5ea2aa0f73b$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$688cc5ea2aa0f73b$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $688cc5ea2aa0f73b$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$688cc5ea2aa0f73b$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $688cc5ea2aa0f73b$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$688cc5ea2aa0f73b$var$Buffer.prototype.readBigInt64LE = $688cc5ea2aa0f73b$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $688cc5ea2aa0f73b$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $688cc5ea2aa0f73b$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$688cc5ea2aa0f73b$var$Buffer.prototype.readBigInt64BE = $688cc5ea2aa0f73b$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $688cc5ea2aa0f73b$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $688cc5ea2aa0f73b$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$688cc5ea2aa0f73b$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $688cc5ea2aa0f73b$var$checkOffset(offset, 4, this.length);
    return $2fccba5c1a2089cc$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$688cc5ea2aa0f73b$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $688cc5ea2aa0f73b$var$checkOffset(offset, 4, this.length);
    return $2fccba5c1a2089cc$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$688cc5ea2aa0f73b$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $688cc5ea2aa0f73b$var$checkOffset(offset, 8, this.length);
    return $2fccba5c1a2089cc$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$688cc5ea2aa0f73b$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $688cc5ea2aa0f73b$var$checkOffset(offset, 8, this.length);
    return $2fccba5c1a2089cc$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $688cc5ea2aa0f73b$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$688cc5ea2aa0f73b$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$688cc5ea2aa0f73b$var$Buffer.prototype.writeUintLE = $688cc5ea2aa0f73b$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $688cc5ea2aa0f73b$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$688cc5ea2aa0f73b$var$Buffer.prototype.writeUintBE = $688cc5ea2aa0f73b$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $688cc5ea2aa0f73b$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$688cc5ea2aa0f73b$var$Buffer.prototype.writeUint8 = $688cc5ea2aa0f73b$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $688cc5ea2aa0f73b$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$688cc5ea2aa0f73b$var$Buffer.prototype.writeUint16LE = $688cc5ea2aa0f73b$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $688cc5ea2aa0f73b$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$688cc5ea2aa0f73b$var$Buffer.prototype.writeUint16BE = $688cc5ea2aa0f73b$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $688cc5ea2aa0f73b$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$688cc5ea2aa0f73b$var$Buffer.prototype.writeUint32LE = $688cc5ea2aa0f73b$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $688cc5ea2aa0f73b$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$688cc5ea2aa0f73b$var$Buffer.prototype.writeUint32BE = $688cc5ea2aa0f73b$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $688cc5ea2aa0f73b$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $688cc5ea2aa0f73b$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $688cc5ea2aa0f73b$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $688cc5ea2aa0f73b$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $688cc5ea2aa0f73b$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$688cc5ea2aa0f73b$var$Buffer.prototype.writeBigUInt64LE = $688cc5ea2aa0f73b$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $688cc5ea2aa0f73b$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$688cc5ea2aa0f73b$var$Buffer.prototype.writeBigUInt64BE = $688cc5ea2aa0f73b$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $688cc5ea2aa0f73b$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$688cc5ea2aa0f73b$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $688cc5ea2aa0f73b$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$688cc5ea2aa0f73b$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $688cc5ea2aa0f73b$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$688cc5ea2aa0f73b$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $688cc5ea2aa0f73b$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$688cc5ea2aa0f73b$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $688cc5ea2aa0f73b$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$688cc5ea2aa0f73b$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $688cc5ea2aa0f73b$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$688cc5ea2aa0f73b$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $688cc5ea2aa0f73b$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$688cc5ea2aa0f73b$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $688cc5ea2aa0f73b$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$688cc5ea2aa0f73b$var$Buffer.prototype.writeBigInt64LE = $688cc5ea2aa0f73b$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $688cc5ea2aa0f73b$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$688cc5ea2aa0f73b$var$Buffer.prototype.writeBigInt64BE = $688cc5ea2aa0f73b$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $688cc5ea2aa0f73b$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $688cc5ea2aa0f73b$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $688cc5ea2aa0f73b$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $688cc5ea2aa0f73b$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $2fccba5c1a2089cc$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$688cc5ea2aa0f73b$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $688cc5ea2aa0f73b$var$writeFloat(this, value, offset, true, noAssert);
};
$688cc5ea2aa0f73b$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $688cc5ea2aa0f73b$var$writeFloat(this, value, offset, false, noAssert);
};
function $688cc5ea2aa0f73b$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $688cc5ea2aa0f73b$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $2fccba5c1a2089cc$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$688cc5ea2aa0f73b$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $688cc5ea2aa0f73b$var$writeDouble(this, value, offset, true, noAssert);
};
$688cc5ea2aa0f73b$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $688cc5ea2aa0f73b$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$688cc5ea2aa0f73b$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$688cc5ea2aa0f73b$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$688cc5ea2aa0f73b$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$688cc5ea2aa0f73b$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $688cc5ea2aa0f73b$var$Buffer.isBuffer(val) ? val : $688cc5ea2aa0f73b$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $688cc5ea2aa0f73b$var$errors = {};
function $688cc5ea2aa0f73b$var$E(sym, getMessage, Base) {
    $688cc5ea2aa0f73b$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$688cc5ea2aa0f73b$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$688cc5ea2aa0f73b$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$688cc5ea2aa0f73b$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $688cc5ea2aa0f73b$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $688cc5ea2aa0f73b$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $688cc5ea2aa0f73b$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $688cc5ea2aa0f73b$var$checkBounds(buf, offset, byteLength) {
    $688cc5ea2aa0f73b$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $688cc5ea2aa0f73b$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $688cc5ea2aa0f73b$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $688cc5ea2aa0f73b$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $688cc5ea2aa0f73b$var$checkBounds(buf, offset, byteLength);
}
function $688cc5ea2aa0f73b$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $688cc5ea2aa0f73b$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $688cc5ea2aa0f73b$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $688cc5ea2aa0f73b$var$validateNumber(value, type);
        throw new $688cc5ea2aa0f73b$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $688cc5ea2aa0f73b$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $688cc5ea2aa0f73b$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $688cc5ea2aa0f73b$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $688cc5ea2aa0f73b$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($688cc5ea2aa0f73b$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $688cc5ea2aa0f73b$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $688cc5ea2aa0f73b$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $688cc5ea2aa0f73b$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $688cc5ea2aa0f73b$var$base64ToBytes(str) {
    return $0370db87c131b873$export$d622b2ad8d90c771($688cc5ea2aa0f73b$var$base64clean(str));
}
function $688cc5ea2aa0f73b$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $688cc5ea2aa0f73b$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $688cc5ea2aa0f73b$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $688cc5ea2aa0f73b$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $688cc5ea2aa0f73b$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $688cc5ea2aa0f73b$var$BufferBigIntNotDefined : fn;
}
function $688cc5ea2aa0f73b$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $8e034955cb46f531$require$Buffer = $688cc5ea2aa0f73b$export$a143d493d941bafc;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $8e034955cb46f531$var$isVisitable(thing) {
    return (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $8e034955cb46f531$var$removeBrackets(key) {
    return (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $8e034955cb46f531$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $8e034955cb46f531$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $8e034955cb46f531$var$isFlatArray(arr) {
    return (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isArray(arr) && !arr.some($8e034955cb46f531$var$isVisitable);
}
const $8e034955cb46f531$var$predicates = (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).toFlatObject((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $8e034955cb46f531$var$toFormData(obj, formData, options) {
    if (!(0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $8f7716808888e99c$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $7836b3da25ffce53$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $8e034955cb46f531$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isReactNative(formData) && (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isReactNativeBlob(value)) {
            formData.append($8e034955cb46f531$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isArray(value) && $8e034955cb46f531$var$isFlatArray(value) || ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isFileList(value) || (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $8e034955cb46f531$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $8e034955cb46f531$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($8e034955cb46f531$var$isVisitable(value)) return true;
        formData.append($8e034955cb46f531$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($8e034955cb46f531$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $8e034955cb46f531$var$isVisitable
    });
    function build(value, path) {
        if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $8e034955cb46f531$export$2e2bcd8739ae039 = $8e034955cb46f531$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $b90c234b40263599$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $b90c234b40263599$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $8e034955cb46f531$export$2e2bcd8739ae039)(params, this, options);
}
const $b90c234b40263599$var$prototype = $b90c234b40263599$var$AxiosURLSearchParams.prototype;
$b90c234b40263599$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$b90c234b40263599$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $b90c234b40263599$var$encode);
    } : $b90c234b40263599$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $b90c234b40263599$export$2e2bcd8739ae039 = $b90c234b40263599$var$AxiosURLSearchParams;


'use strict';
/**
 * It replaces URL-encoded forms of `:`, `$`, `,`, and spaces with
 * their plain counterparts (`:`, `$`, `,`, `+`).
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $26ff6c6a271c8a8c$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $26ff6c6a271c8a8c$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    const _encode = options && options.encode || $26ff6c6a271c8a8c$var$encode;
    const _options = (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isFunction(options) ? {
        serialize: options
    } : options;
    const serializeFn = _options && _options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $b90c234b40263599$export$2e2bcd8739ae039)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $172b983af925d299$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $172b983af925d299$export$2e2bcd8739ae039 = $172b983af925d299$var$InterceptorManager;





'use strict';
var $323e7251730a0bd5$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true
};






'use strict';
var $aac6a042c44731e2$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $b90c234b40263599$export$2e2bcd8739ae039);


'use strict';
var $93aed35b53fbf325$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $d6b5f3c23df343ef$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $b3b01108a1f0e831$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $aac6a042c44731e2$export$2e2bcd8739ae039,
        FormData: $93aed35b53fbf325$export$2e2bcd8739ae039,
        Blob: $d6b5f3c23df343ef$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $809c960601b992d5$exports = {};

$parcel$export($809c960601b992d5$exports, "hasBrowserEnv", function () { return $809c960601b992d5$export$c4996c4b7b93b0bf; });
$parcel$export($809c960601b992d5$exports, "navigator", function () { return $809c960601b992d5$export$ec7c8efa7f5790ae; });
$parcel$export($809c960601b992d5$exports, "hasStandardBrowserEnv", function () { return $809c960601b992d5$export$c0bcc9250309d66; });
$parcel$export($809c960601b992d5$exports, "hasStandardBrowserWebWorkerEnv", function () { return $809c960601b992d5$export$c81692cf5af97dac; });
$parcel$export($809c960601b992d5$exports, "origin", function () { return $809c960601b992d5$export$f710a83a91838a36; });
const $809c960601b992d5$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $809c960601b992d5$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $809c960601b992d5$export$c0bcc9250309d66 = $809c960601b992d5$export$c4996c4b7b93b0bf && (!$809c960601b992d5$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($809c960601b992d5$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $809c960601b992d5$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $809c960601b992d5$export$f710a83a91838a36 = $809c960601b992d5$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $d6ddacb32deaf344$export$2e2bcd8739ae039 = {
    ...$809c960601b992d5$exports,
    ...(0, $b3b01108a1f0e831$export$2e2bcd8739ae039)
};


'use strict';
function $dbf2991c1f17dfd6$export$2e2bcd8739ae039(data, options) {
    return (0, $8e034955cb46f531$export$2e2bcd8739ae039)(data, new (0, $d6ddacb32deaf344$export$2e2bcd8739ae039).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $d6ddacb32deaf344$export$2e2bcd8739ae039).isNode && (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $a348cb59fad74ca7$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $a348cb59fad74ca7$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $a348cb59fad74ca7$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $a348cb59fad74ca7$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isFormData(formData) && (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($a348cb59fad74ca7$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $a348cb59fad74ca7$export$2e2bcd8739ae039 = $a348cb59fad74ca7$var$formDataToJSON;


'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $2e190458f88388d3$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $2e190458f88388d3$var$defaults = {
    transitional: (0, $323e7251730a0bd5$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $a348cb59fad74ca7$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isBuffer(data) || (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isStream(data) || (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isFile(data) || (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isBlob(data) || (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $dbf2991c1f17dfd6$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $8e034955cb46f531$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $2e190458f88388d3$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $2e190458f88388d3$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isResponse(data) || (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, this.parseReviver);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $7836b3da25ffce53$export$2e2bcd8739ae039).from(e, (0, $7836b3da25ffce53$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $d6ddacb32deaf344$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $d6ddacb32deaf344$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $2e190458f88388d3$var$defaults.headers[method] = {};
});
var $2e190458f88388d3$export$2e2bcd8739ae039 = $2e190458f88388d3$var$defaults;




'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $67607d076520c8a3$var$ignoreDuplicateOf = (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $67607d076520c8a3$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $67607d076520c8a3$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};


'use strict';
const $d697fbd2f0bd2844$var$$internals = Symbol('internals');
function $d697fbd2f0bd2844$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $d697fbd2f0bd2844$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isArray(value) ? value.map($d697fbd2f0bd2844$var$normalizeValue) : String(value).replace(/[\r\n]+$/, '');
}
function $d697fbd2f0bd2844$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $d697fbd2f0bd2844$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $d697fbd2f0bd2844$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $d697fbd2f0bd2844$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $d697fbd2f0bd2844$var$buildAccessors(obj, header) {
    const accessorName = (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $d697fbd2f0bd2844$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $d697fbd2f0bd2844$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $d697fbd2f0bd2844$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$d697fbd2f0bd2844$var$isValidHeaderName(header)) setHeaders((0, $67607d076520c8a3$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isObject(header) && (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $d697fbd2f0bd2844$var$normalizeHeader(header);
        if (header) {
            const key = (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $d697fbd2f0bd2844$var$parseTokens(value);
                if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $d697fbd2f0bd2844$var$normalizeHeader(header);
        if (header) {
            const key = (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $d697fbd2f0bd2844$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $d697fbd2f0bd2844$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $d697fbd2f0bd2844$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $d697fbd2f0bd2844$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $d697fbd2f0bd2844$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $d697fbd2f0bd2844$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $d697fbd2f0bd2844$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get('set-cookie') || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$d697fbd2f0bd2844$var$$internals] = this[$d697fbd2f0bd2844$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $d697fbd2f0bd2844$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $d697fbd2f0bd2844$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$d697fbd2f0bd2844$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).reduceDescriptors($d697fbd2f0bd2844$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).freezeMethods($d697fbd2f0bd2844$var$AxiosHeaders);
var $d697fbd2f0bd2844$export$2e2bcd8739ae039 = $d697fbd2f0bd2844$var$AxiosHeaders;


'use strict';
function $cfcaf00d29e4489d$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $2e190458f88388d3$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $d697fbd2f0bd2844$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $91ac9e427bf9a443$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}




'use strict';
class $14c8de259e9a90fe$var$CanceledError extends (0, $7836b3da25ffce53$export$2e2bcd8739ae039) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $7836b3da25ffce53$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $14c8de259e9a90fe$export$2e2bcd8739ae039 = $14c8de259e9a90fe$var$CanceledError;







'use strict';
function $46805de647202a1f$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $7836b3da25ffce53$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, [
        (0, $7836b3da25ffce53$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $7836b3da25ffce53$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





'use strict';
function $442277630487be7f$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $5a1fafd58ebcd71e$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $5a1fafd58ebcd71e$export$2e2bcd8739ae039 = $5a1fafd58ebcd71e$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $e13b6a1d7314e622$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $e13b6a1d7314e622$export$2e2bcd8739ae039 = $e13b6a1d7314e622$var$throttle;



const $7ae85bfc6c43f802$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $5a1fafd58ebcd71e$export$2e2bcd8739ae039)(50, 250);
    return (0, $e13b6a1d7314e622$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $7ae85bfc6c43f802$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $7ae85bfc6c43f802$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $8b61cb278d4410d3$export$2e2bcd8739ae039 = (0, $d6ddacb32deaf344$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $d6ddacb32deaf344$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $d6ddacb32deaf344$export$2e2bcd8739ae039).origin), (0, $d6ddacb32deaf344$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $d6ddacb32deaf344$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $b1b739ae31793a8a$export$2e2bcd8739ae039 = (0, $d6ddacb32deaf344$export$2e2bcd8739ae039).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $5f905d7cf3dac9dd$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $b66967d686896d9e$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $7f84da20909ff493$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $5f905d7cf3dac9dd$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $b66967d686896d9e$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




'use strict';
const $77c722f71dbda713$var$headersToObject = (thing)=>thing instanceof (0, $d697fbd2f0bd2844$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $77c722f71dbda713$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isPlainObject(target) && (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($77c722f71dbda713$var$headersToObject(a), $77c722f71dbda713$var$headersToObject(b), prop, true)
    };
    (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).forEach(Object.keys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $107c44dc5d5cda46$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $77c722f71dbda713$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $d697fbd2f0bd2844$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $26ff6c6a271c8a8c$export$2e2bcd8739ae039)((0, $7f84da20909ff493$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $d6ddacb32deaf344$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $d6ddacb32deaf344$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // browser handles it
        else if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isFunction(data.getHeaders)) {
            // Node.js FormData (like form-data package)
            const formHeaders = data.getHeaders();
            // Only set safe headers to avoid overwriting security headers
            const allowedHeaders = [
                'content-type',
                'content-length'
            ];
            Object.entries(formHeaders).forEach(([key, val])=>{
                if (allowedHeaders.includes(key.toLowerCase())) headers.set(key, val);
            });
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $d6ddacb32deaf344$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $8b61cb278d4410d3$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $b1b739ae31793a8a$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $6ec826587d22a7d5$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $6ec826587d22a7d5$export$2e2bcd8739ae039 = $6ec826587d22a7d5$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $107c44dc5d5cda46$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $d697fbd2f0bd2844$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $d697fbd2f0bd2844$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $46805de647202a1f$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $7836b3da25ffce53$export$2e2bcd8739ae039)('Request aborted', (0, $7836b3da25ffce53$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $7836b3da25ffce53$export$2e2bcd8739ae039)(msg, (0, $7836b3da25ffce53$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $323e7251730a0bd5$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $7836b3da25ffce53$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $7836b3da25ffce53$export$2e2bcd8739ae039).ETIMEDOUT : (0, $7836b3da25ffce53$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $7ae85bfc6c43f802$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $7ae85bfc6c43f802$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $14c8de259e9a90fe$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $442277630487be7f$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $d6ddacb32deaf344$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $7836b3da25ffce53$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $7836b3da25ffce53$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $a2c3efed56fc4625$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $7836b3da25ffce53$export$2e2bcd8739ae039) ? err : new (0, $14c8de259e9a90fe$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $7836b3da25ffce53$export$2e2bcd8739ae039)(`timeout of ${timeout}ms exceeded`, (0, $7836b3da25ffce53$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $a2c3efed56fc4625$export$2e2bcd8739ae039 = $a2c3efed56fc4625$var$composeSignals;


const $421c42ad06ba0aac$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $421c42ad06ba0aac$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $421c42ad06ba0aac$var$readStream(iterable))yield* $421c42ad06ba0aac$export$71b051935044bd5d(chunk, chunkSize);
};
const $421c42ad06ba0aac$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $421c42ad06ba0aac$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $421c42ad06ba0aac$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $18bfad46cab060a4$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $18bfad46cab060a4$var$isFunction } = (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039);
const $18bfad46cab060a4$var$globalFetchAPI = (({ Request: Request, Response: Response })=>({
        Request: Request,
        Response: Response
    }))((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).global);
const { ReadableStream: $18bfad46cab060a4$var$ReadableStream, TextEncoder: $18bfad46cab060a4$var$TextEncoder } = (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).global;
const $18bfad46cab060a4$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $18bfad46cab060a4$var$factory = (env)=>{
    env = (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, $18bfad46cab060a4$var$globalFetchAPI, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $18bfad46cab060a4$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $18bfad46cab060a4$var$isFunction(Request);
    const isResponseSupported = $18bfad46cab060a4$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $18bfad46cab060a4$var$isFunction($18bfad46cab060a4$var$ReadableStream);
    const encodeText = isFetchSupported && (typeof $18bfad46cab060a4$var$TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new $18bfad46cab060a4$var$TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $18bfad46cab060a4$var$test(()=>{
        let duplexAccessed = false;
        const body = new $18bfad46cab060a4$var$ReadableStream();
        const hasContentType = new Request((0, $d6ddacb32deaf344$export$2e2bcd8739ae039).origin, {
            body: body,
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        }).headers.has('Content-Type');
        body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $18bfad46cab060a4$var$test(()=>(0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $7836b3da25ffce53$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $7836b3da25ffce53$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $d6ddacb32deaf344$export$2e2bcd8739ae039).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
        if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $107c44dc5d5cda46$export$2e2bcd8739ae039)(config);
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $a2c3efed56fc4625$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        try {
            if (onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
                let _request = new Request(url, {
                    method: 'POST',
                    body: data,
                    duplex: 'half'
                });
                let contentTypeHeader;
                if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                if (_request.body) {
                    const [onProgress, flush] = (0, $7ae85bfc6c43f802$export$d9fadd12586c18d6)(requestContentLength, (0, $7ae85bfc6c43f802$export$c1b28109d46c3592)((0, $7ae85bfc6c43f802$export$5d35863c355a22a9)(onUploadProgress)));
                    data = (0, $421c42ad06ba0aac$export$b0119225647bd83)(_request.body, $18bfad46cab060a4$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
                }
            }
            if (!(0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: headers.normalize().toJSON(),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
                const [onProgress, flush] = onDownloadProgress && (0, $7ae85bfc6c43f802$export$d9fadd12586c18d6)(responseContentLength, (0, $7ae85bfc6c43f802$export$c1b28109d46c3592)((0, $7ae85bfc6c43f802$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                response = new Response((0, $421c42ad06ba0aac$export$b0119225647bd83)(response.body, $18bfad46cab060a4$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config);
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $46805de647202a1f$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $d697fbd2f0bd2844$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $7836b3da25ffce53$export$2e2bcd8739ae039)('Network Error', (0, $7836b3da25ffce53$export$2e2bcd8739ae039).ERR_NETWORK, config, request, err && err.response), {
                cause: err.cause || err
            });
            throw (0, $7836b3da25ffce53$export$2e2bcd8739ae039).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $18bfad46cab060a4$var$seedCache = new Map();
const $18bfad46cab060a4$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $18bfad46cab060a4$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $18bfad46cab060a4$var$factory(env));
        map = target;
    }
    return target;
};
const $18bfad46cab060a4$var$adapter = $18bfad46cab060a4$export$3105c6651375d4fa();
var $18bfad46cab060a4$export$2e2bcd8739ae039 = $18bfad46cab060a4$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $56cb1afaad383b88$var$knownAdapters = {
    http: (0, $8f7716808888e99c$export$2e2bcd8739ae039),
    xhr: (0, $6ec826587d22a7d5$export$2e2bcd8739ae039),
    fetch: {
        get: $18bfad46cab060a4$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).forEach($56cb1afaad383b88$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $56cb1afaad383b88$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $56cb1afaad383b88$var$isResolvedHandle = (adapter)=>(0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $56cb1afaad383b88$var$getAdapter(adapters, config) {
    adapters = (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$56cb1afaad383b88$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $56cb1afaad383b88$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $7836b3da25ffce53$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($56cb1afaad383b88$var$renderReason).join('\n') : ' ' + $56cb1afaad383b88$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $7836b3da25ffce53$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $56cb1afaad383b88$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $56cb1afaad383b88$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $56cb1afaad383b88$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $dd1eda2a05906b2a$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $14c8de259e9a90fe$export$2e2bcd8739ae039)(null, config);
}
function $dd1eda2a05906b2a$export$2e2bcd8739ae039(config) {
    $dd1eda2a05906b2a$var$throwIfCancellationRequested(config);
    config.headers = (0, $d697fbd2f0bd2844$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $cfcaf00d29e4489d$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $56cb1afaad383b88$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $2e190458f88388d3$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $dd1eda2a05906b2a$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $cfcaf00d29e4489d$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $d697fbd2f0bd2844$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $91ac9e427bf9a443$export$2e2bcd8739ae039)(reason)) {
            $dd1eda2a05906b2a$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $cfcaf00d29e4489d$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $d697fbd2f0bd2844$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $e0e692a3ebb4a7ca$export$a4ad2735b021c132 = "1.14.0";



'use strict';
const $52dcdd0d57737d2a$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $52dcdd0d57737d2a$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $52dcdd0d57737d2a$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $52dcdd0d57737d2a$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $e0e692a3ebb4a7ca$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $7836b3da25ffce53$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $7836b3da25ffce53$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$52dcdd0d57737d2a$var$deprecatedWarnings[opt]) {
            $52dcdd0d57737d2a$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$52dcdd0d57737d2a$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $52dcdd0d57737d2a$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $7836b3da25ffce53$export$2e2bcd8739ae039)('options must be an object', (0, $7836b3da25ffce53$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $7836b3da25ffce53$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $7836b3da25ffce53$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $7836b3da25ffce53$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $7836b3da25ffce53$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $52dcdd0d57737d2a$export$2e2bcd8739ae039 = {
    assertOptions: $52dcdd0d57737d2a$var$assertOptions,
    validators: $52dcdd0d57737d2a$var$validators
};




'use strict';
const $e897862d257babec$var$validators = (0, $52dcdd0d57737d2a$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $e897862d257babec$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $172b983af925d299$export$2e2bcd8739ae039)(),
            response: new (0, $172b983af925d299$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $77c722f71dbda713$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $52dcdd0d57737d2a$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $e897862d257babec$var$validators.transitional($e897862d257babec$var$validators.boolean),
            forcedJSONParsing: $e897862d257babec$var$validators.transitional($e897862d257babec$var$validators.boolean),
            clarifyTimeoutError: $e897862d257babec$var$validators.transitional($e897862d257babec$var$validators.boolean),
            legacyInterceptorReqResOrdering: $e897862d257babec$var$validators.transitional($e897862d257babec$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $52dcdd0d57737d2a$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $e897862d257babec$var$validators.function,
                serialize: $e897862d257babec$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $52dcdd0d57737d2a$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $e897862d257babec$var$validators.spelling('baseURL'),
            withXsrfToken: $e897862d257babec$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $d697fbd2f0bd2844$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $323e7251730a0bd5$export$2e2bcd8739ae039);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $dd1eda2a05906b2a$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $dd1eda2a05906b2a$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $77c722f71dbda713$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $7f84da20909ff493$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $26ff6c6a271c8a8c$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $e897862d257babec$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $77c722f71dbda713$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $77c722f71dbda713$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $e897862d257babec$var$Axios.prototype[method] = generateHTTPMethod();
    $e897862d257babec$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $e897862d257babec$export$2e2bcd8739ae039 = $e897862d257babec$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $227c6a50460aca7b$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $14c8de259e9a90fe$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $227c6a50460aca7b$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $227c6a50460aca7b$export$2e2bcd8739ae039 = $227c6a50460aca7b$var$CancelToken;






'use strict';
function $65621a92e630e18c$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $a9ba7de335204c3c$export$2e2bcd8739ae039(payload) {
    return (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $a1c4df0bda0dcdd4$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($a1c4df0bda0dcdd4$var$HttpStatusCode).forEach(([key, value])=>{
    $a1c4df0bda0dcdd4$var$HttpStatusCode[value] = key;
});
var $a1c4df0bda0dcdd4$export$2e2bcd8739ae039 = $a1c4df0bda0dcdd4$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $bf5b93105d90423b$var$createInstance(defaultConfig) {
    const context = new (0, $e897862d257babec$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $cdb9ac81908f91ab$export$2e2bcd8739ae039)((0, $e897862d257babec$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).extend(instance, (0, $e897862d257babec$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $bf5b93105d90423b$var$createInstance((0, $77c722f71dbda713$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $bf5b93105d90423b$var$axios = $bf5b93105d90423b$var$createInstance((0, $2e190458f88388d3$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$bf5b93105d90423b$var$axios.Axios = (0, $e897862d257babec$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$bf5b93105d90423b$var$axios.CanceledError = (0, $14c8de259e9a90fe$export$2e2bcd8739ae039);
$bf5b93105d90423b$var$axios.CancelToken = (0, $227c6a50460aca7b$export$2e2bcd8739ae039);
$bf5b93105d90423b$var$axios.isCancel = (0, $91ac9e427bf9a443$export$2e2bcd8739ae039);
$bf5b93105d90423b$var$axios.VERSION = (0, $e0e692a3ebb4a7ca$export$a4ad2735b021c132);
$bf5b93105d90423b$var$axios.toFormData = (0, $8e034955cb46f531$export$2e2bcd8739ae039);
// Expose AxiosError class
$bf5b93105d90423b$var$axios.AxiosError = (0, $7836b3da25ffce53$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$bf5b93105d90423b$var$axios.Cancel = $bf5b93105d90423b$var$axios.CanceledError;
// Expose all/spread
$bf5b93105d90423b$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$bf5b93105d90423b$var$axios.spread = (0, $65621a92e630e18c$export$2e2bcd8739ae039);
// Expose isAxiosError
$bf5b93105d90423b$var$axios.isAxiosError = (0, $a9ba7de335204c3c$export$2e2bcd8739ae039);
// Expose mergeConfig
$bf5b93105d90423b$var$axios.mergeConfig = (0, $77c722f71dbda713$export$2e2bcd8739ae039);
$bf5b93105d90423b$var$axios.AxiosHeaders = (0, $d697fbd2f0bd2844$export$2e2bcd8739ae039);
$bf5b93105d90423b$var$axios.formToJSON = (thing)=>(0, $a348cb59fad74ca7$export$2e2bcd8739ae039)((0, $0c7b3c2fc951f4eb$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$bf5b93105d90423b$var$axios.getAdapter = (0, $56cb1afaad383b88$export$2e2bcd8739ae039).getAdapter;
$bf5b93105d90423b$var$axios.HttpStatusCode = (0, $a1c4df0bda0dcdd4$export$2e2bcd8739ae039);
$bf5b93105d90423b$var$axios.default = $bf5b93105d90423b$var$axios;
var // this module should only have a default export
$bf5b93105d90423b$export$2e2bcd8739ae039 = $bf5b93105d90423b$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $740bced8f629f286$export$1c00760e9e5a4e95, AxiosError: $740bced8f629f286$export$c1fbed17c2f6a328, CanceledError: $740bced8f629f286$export$1ab0c6b20d94fa14, isCancel: $740bced8f629f286$export$3b22524397b493c6, CancelToken: $740bced8f629f286$export$fd08e3cb425f0d61, VERSION: $740bced8f629f286$export$a4ad2735b021c132, all: $740bced8f629f286$export$84bf76cd7afc7469, Cancel: $740bced8f629f286$export$848c9b7ead0df967, isAxiosError: $740bced8f629f286$export$fbafdbe06a5b5a9a, spread: $740bced8f629f286$export$3ae0fd4797ed47c8, toFormData: $740bced8f629f286$export$10ae0d317ea97f8b, AxiosHeaders: $740bced8f629f286$export$4e7d6ff0f3e6520, HttpStatusCode: $740bced8f629f286$export$a972f69c851492b3, formToJSON: $740bced8f629f286$export$86d7c59254d6a2c9, getAdapter: $740bced8f629f286$export$17ddc20a97d669e2, mergeConfig: $740bced8f629f286$export$7ec1ebcfa9d8bd6a } = (0, $bf5b93105d90423b$export$2e2bcd8739ae039);


const $1deddb86eae7e53e$var$axiosInstance = (0, $bf5b93105d90423b$export$2e2bcd8739ae039).create({
    baseURL: "https://api.rocketpages.io",
    withCredentials: true
});
// Add an interceptor to include the access token in the request headers
$1deddb86eae7e53e$var$axiosInstance.interceptors.request.use((config)=>{
    // console.log("axios instance". config)
    // const accessToken = localStorage.getItem("accessToken");
    // if (accessToken) {
    //   config.headers["Authorization"] = `Bearer ${accessToken}`;
    // }
    // config.headers["Access-Control-Allow-Origin"] = `*`;
    return config;
}, (error)=>{
    return Promise.reject(error);
});
$1deddb86eae7e53e$var$axiosInstance.interceptors.response.use((response)=>{
    // Handle successful responses
    return response;
}, (error)=>{
    // Handle response errors
    return Promise.reject(error);
});
var $1deddb86eae7e53e$export$2e2bcd8739ae039 = $1deddb86eae7e53e$var$axiosInstance;



var $8FY87 = parcelRequire("8FY87");



const $d2986c5e52453edd$var$PasswordModal = (props)=>{
    const [isOpen, setIsOpen] = (0, $8FY87.useState)(props.isOpen);
    const [password, setPassword] = (0, $8FY87.useState)("");
    const [error, setError] = (0, $8FY87.useState)("");
    const validPassword = "yourpassword"; // Set your valid password here
    const handlePasswordChange = (e)=>{
        setPassword(e.target.value);
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        let response = await (0, $bf5b93105d90423b$export$2e2bcd8739ae039).post(`${"https://api.rocketpages.io"}/${"upload/rpvalidateinternaluser"}`, {
            password: password
        });
        // console.log(response.data.login);
        //   setSitesData(response.data.data);
        if (response.data.login) {
            setIsOpen(false);
            props.onSuccess();
        } else setError("Invalid password. Please try again.");
    };
    if (!isOpen) return null; // Modal is closed
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-100 z-50"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "bg-white p-6 rounded-lg shadow-lg w-full max-w-sm"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("form", {
        onSubmit: handleSubmit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "mb-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        htmlFor: "password",
        className: "block text-sm font-medium text-gray-700"
    }, "Password"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("input", {
        type: "password",
        id: "password",
        value: password,
        onChange: handlePasswordChange,
        className: "mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm",
        required: true
    })), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", {
        className: "text-red-500 text-sm"
    }, error), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("button", {
        type: "submit",
        className: "bg-catelina-blue hover:bg-catelina-blue text-white font-semibold py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-catelina-blue focus:ring-opacity-50"
    }, "Submit"))));
};
var $d2986c5e52453edd$export$2e2bcd8739ae039 = $d2986c5e52453edd$var$PasswordModal;






const $c0f0a0f6efad2fa3$export$42cfbb80f7861e77 = (props)=>{
    const navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    const location = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)();
    const [searchParams, setSearchParams] = (0, $734169eef5d6795a$export$f1a78c17382fe22a)();
    const currentPath = location.pathname;
    const [cookies, setCookie, removeCookie] = (0, $1f373de1ceea6eb7$export$2e2bcd8739ae039)([
        "rp_user_data",
        "rp_user_id",
        "rp_loggedin",
        "rp_internal_login"
    ]);
    const getQueryParam = (key)=>{
        return searchParams.get(key);
    };
    $8FY87.useEffect(()=>{
        async function checkCookies() {
            try {
                let response = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post(`/api/check-cookies`);
                // console.log(response);
                if (response.status === (0, $1541e826bb18c315$export$efd5569f873811b1).OK) {
                    setCookie("rp_user_data", JSON.stringify(response.data.userData), {
                        maxAge: 604800,
                        domain: ".rocketpages.io"
                    });
                    setCookie("rp_loggedin", true, {
                        maxAge: 604800,
                        domain: window.location.hostname.split(".").slice(1).join("."),
                        sameSite: "none",
                        secure: true,
                        path: "/"
                    });
                    setCookie("rp_user_id", response.data.userData.userId, {
                        maxAge: 604800,
                        domain: ".rocketpages.io"
                    });
                } else navigate("/login", {
                    state: {
                        removeCookies: true
                    }
                });
            } catch (err) {
                navigate("/login", {
                    state: {
                        removeCookies: true
                    }
                });
            }
        }
        if (props.skipCheckCookies === true) ;
        else if (currentPath.includes("admin")) {
            if (cookies.rp_user_data?.userType !== "admin") navigate(`/404?msgType=UnAuthorizedAdmin`);
        } else if (!currentPath.includes("choose-template") && !currentPath.includes("preview")) checkCookies();
    // console.log(
    //   "currentPath",
    //   currentPath,
    //   !currentPath.includes("choose-template") &&
    //     !currentPath.includes("preview")
    // );
    }, []);
    const [anchorEl, setAnchorEl] = $8FY87.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const handleLogout = ()=>{
        setAnchorEl(null);
        async function logoutUser() {
            try {
                // console.log("before.remove.cookies");
                // removeCookie("rp_user_data");
                // console.log("remove.rp_user_data",)
                // removeCookie("rp_user_id");
                // console.log("remove.rp_user_id",)
                setCookie("rp_user_data", "", {
                    maxAge: 0,
                    domain: ".rocketpages.io"
                });
                setCookie("rp_loggedin", false, {
                    maxAge: 0,
                    domain: window.location.hostname.split(".").slice(1).join(".")
                });
                setCookie("rp_user_id", "", {
                    maxAge: 0,
                    domain: ".rocketpages.io"
                });
                await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post("/api/logout", {}, {
                    withCredentials: true
                });
            } catch (err) {
                console.log(err);
            }
        }
        logoutUser();
        // removeCookie("rp_access_token");
        navigate("/login", {
            state: {
                removeCookies: true
            }
        });
    // removeCookie_userData("rp_user_data");
    };
    return /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex h-[72px] sm:h-[64px] border-b border-neutral-300 top-0 bg-white py-2 px-2 items-center justify-between z-40 fixed w-full"
    }, /*#__PURE__*/ $8FY87.createElement((0, $d2986c5e52453edd$export$2e2bcd8739ae039), {
        isOpen: cookies.rp_internal_login !== "true" && false,
        onSuccess: ()=>{
            setCookie("rp_internal_login", "true", {
                maxAge: 604800,
                domain: ".rocketpages.io"
            });
        }
    }), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "w-full flex flex-row justify-between"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "app-header flex flex-row items-center w-full"
    }, /*#__PURE__*/ $8FY87.createElement("img", {
        className: "w-[172px] mr-5 hover:cursor-pointer hidden md:block site-logo-lg",
        src: (parcelRequire("f1BG0")),
        alt: "",
        onClick: ()=>{
            navigate("/dashboard");
        }
    }), /*#__PURE__*/ $8FY87.createElement("img", {
        className: "mr-2 md:mr-5 hover:cursor-pointer block md:hidden site-logo-sm",
        src: (parcelRequire("2ATL3")),
        alt: "",
        onClick: ()=>{
            navigate("/dashboard");
        }
    }), props.title !== undefined && /*#__PURE__*/ $8FY87.createElement((0, $30a538faf9a95dbb$export$2e2bcd8739ae039), {
        orientation: "vertical",
        flexItem: true
    }), props.title && props.title.startsWith("Preview") && /*#__PURE__*/ $8FY87.createElement((0, $8765ef9b64e3c3e6$export$2e2bcd8739ae039), {
        sx: {
            backgroundColor: "#243060",
            color: "#fff",
            borderRadius: "4px",
            height: "32px",
            width: "32px",
            "&:hover": {
                backgroundColor: "#243060",
                color: "#fff"
            }
        },
        onClick: ()=>navigate("/choose-template"),
        className: "ml-2 back-to-templates"
    }, /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($33d3aaa52a311a31$exports))), {
        sx: {
            height: "20px",
            width: "20px"
        }
    })), props.title && props.title.startsWith("Choose template") && /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        variant: "contained",
        sx: {
            backgroundColor: "#243060",
            color: "#fff",
            borderRadius: "4px",
            height: "32px",
            width: "32px",
            "&:hover": {
                backgroundColor: "#243060",
                color: "#fff"
            }
        },
        onClick: ()=>navigate("/dashboard"),
        className: `ml-2 back-to-dashboard ${!cookies.rp_user_data ? "hidden" : ""}`,
        startIcon: /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($33d3aaa52a311a31$exports))), {
            sx: {
                height: "20px",
                width: "20px"
            }
        })
    }, /*#__PURE__*/ $8FY87.createElement((0, $9e9a2c609bdcf2f0$export$2e2bcd8739ae039), {
        variant: "body2",
        sx: {
            fontWeight: "bold"
        }
    }, "Dashboard")), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex  site-name-wrapper items-center"
    }, /*#__PURE__*/ $8FY87.createElement("h1", {
        className: `${props.title === "Choose template" ? "choose-temp" : ""} ml-2 md:ml-5 text-catelina-blue text-lg truncate mb-0 mt-0 site-title-name `
    }, props.title), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-row"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "mr-2"
    }, !props.isPreview && !!props.siteId && /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, null, /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        variant: "contained",
        size: "small",
        sx: {
            backgroundColor: "#243060",
            color: "#fff",
            textTransform: "none",
            minWidth: "unset",
            "&:hover": {
                backgroundColor: "#fff",
                color: "#243060"
            }
        },
        onClick: ()=>{
            let _pageId = getQueryParam("pageId");
            let _url = `${"http://editor.rocketpages.io"}/${props.siteId}`;
            if (_pageId) _url += `/${_pageId}`;
            window.open(_url, "_self")?.focus();
        },
        className: "ml-2 mr-2 editsite",
        startIcon: /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7c8f2ac2998e8e4d$exports))), null)
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: "hidden lg:block"
    }, "Edit site")), props.isPublished && /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        variant: "contained",
        size: "small",
        sx: {
            backgroundColor: "#243060",
            color: "#fff",
            textTransform: "none",
            minWidth: "unset",
            "&:hover": {
                backgroundColor: "#fff",
                color: "#243060"
            }
        },
        onClick: ()=>{
            const url = currentPath.includes("site-settings") ? props.siteUrl : `/preview/${props.siteId}`;
            window.open(url, "_blank");
        },
        className: "previewsite",
        startIcon: /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3b2767003d20258a$exports))), null)
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: "hidden lg:block"
    }, "Preview")))), props.isPreview && /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-row items-center"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-row"
    }, props.colorPallets && props.selectedColorPallet && props.colorPallets.map((row)=>{
        let colorPallet = props.colorPallets.length > 0 && props.colorPallets.find((oo)=>oo.id === row.id) || null;
        // console.log("for each", colorPallet.colors);
        return colorPallet ? /*#__PURE__*/ $8FY87.createElement("div", {
            onClick: ()=>props.onColorPaletteChange(row),
            key: row.id,
            className: `flex flex-row  hover:cursor-pointer`,
            "data-test": "pallete-button",
            "data-colors": row.colors
        }, /*#__PURE__*/ $8FY87.createElement("span", {
            className: `h-g w-3 md:h-6 md:w-3 block rounded-l-full ${props.selectedColorPallet.id === row.id ? "border-y border-l border-black" : "border-y border-l border-gray-100"} `,
            style: {
                backgroundColor: colorPallet ? colorPallet.colors[0].toLowerCase() : ""
            }
        }), /*#__PURE__*/ $8FY87.createElement("div", {
            className: "flex flex-col"
        }, /*#__PURE__*/ $8FY87.createElement("span", {
            className: `h-3 w-3 block rounded-tr-full ${props.selectedColorPallet.id === row.id ? "border-t border-r border-black" : "border-t border-r border-gray-100"} `,
            style: {
                backgroundColor: colorPallet ? colorPallet.colors[1].toLowerCase() : ""
            }
        }), /*#__PURE__*/ $8FY87.createElement("span", {
            className: `h-3 w-3 block rounded-br-full ${props.selectedColorPallet.id === row.id ? "border-b border-r border-black" : "border-b border-r border-gray-100"} `,
            style: {
                backgroundColor: colorPallet ? colorPallet.colors[3].toLowerCase() : ""
            }
        }))) : null;
    })), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "mx-1 md:mx-2 flex flex-row"
    }, /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        variant: "contained",
        size: "small",
        sx: {
            backgroundColor: "#243060",
            color: "#fff",
            textTransform: "none",
            "&:hover": {
                backgroundColor: "#fff",
                color: "#243060"
            }
        },
        onClick: ()=>{
            window.location.href = props.editUrl;
        // window.location.reload();
        },
        className: "hidden lg:flex edit-site",
        startIcon: /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7c8f2ac2998e8e4d$exports))), null)
    }, /*#__PURE__*/ $8FY87.createElement("span", null, "Edit site")), /*#__PURE__*/ $8FY87.createElement((0, $8765ef9b64e3c3e6$export$2e2bcd8739ae039), {
        color: "primary",
        size: "small",
        onClick: ()=>{
            window.location.href = props.editUrl;
        // window.location.reload();
        },
        className: "p-0"
    }, /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7c8f2ac2998e8e4d$exports))), {
        sx: {
            color: "#243060",
            fontSize: 30
        },
        className: "flex lg:hidden"
    })))), /*#__PURE__*/ $8FY87.createElement("div", {
        onClick: handleClick,
        className: `w-[30px] md:w-[36px] self-center hover:cursor-pointer ${!cookies.rp_user_data ? "hidden" : ""}`
    }, /*#__PURE__*/ $8FY87.createElement("img", {
        className: "userprofile",
        src: (parcelRequire("h3Dbm")),
        alt: ""
    })), /*#__PURE__*/ $8FY87.createElement("div", {
        onClick: handleClick,
        className: `self-center ${cookies.rp_user_data ? "hidden" : ""}`
    }, /*#__PURE__*/ $8FY87.createElement((0, $89a5149760fde35d$export$2e2bcd8739ae039), {
        onClick: ()=>{
            navigate("/login");
        },
        className: "md:flex hidden no-user",
        sx: {
            fontSize: "14px",
            color: "#243060",
            textDecoration: "none",
            cursor: "pointer",
            "&:hover": {
                color: "#fe7165",
                textDecoration: "none"
            }
        }
    }, "LOGIN"), /*#__PURE__*/ $8FY87.createElement((0, $89a5149760fde35d$export$2e2bcd8739ae039), {
        onClick: ()=>{
            navigate("/login");
        }
    }, /*#__PURE__*/ $8FY87.createElement("img", {
        style: {
            width: "30px",
            maxWidth: "30px"
        },
        className: "userprofile md:hidden",
        src: (parcelRequire("h3Dbm")),
        alt: ""
    })))))), /*#__PURE__*/ $8FY87.createElement((0, $0b320025c1b3a544$export$2e2bcd8739ae039), {
        id: "demo-positioned-menu",
        "aria-labelledby": "demo-positioned-button",
        anchorEl: anchorEl,
        open: open,
        onClose: handleClose,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "left"
        },
        transformOrigin: {
            vertical: "top",
            horizontal: "left"
        },
        className: "app-header-menu w-60, p-0",
        sx: {
            "& .MuiPaper-root": {
                minWidth: "258px",
                width: "258px",
                border: "1px solid rgba(36, 48, 96, 0.20)",
                boxShadow: "2px 2px 8px 0px rgba(0, 0, 0, 0.25)"
            },
            "& .MuiList-root": {
                padding: 0
            }
        }
    }, /*#__PURE__*/ $8FY87.createElement((0, $ee9f19037253b32c$export$2e2bcd8739ae039), {
        className: "app-header-menu-email",
        sx: {
            fontSize: "14px",
            padding: "10px",
            borderBottom: "1px solid rgba(36, 48, 96, 0.20)",
            backgroundColor: "#e9eaef",
            whiteSpace: "break-spaces",
            lineBreak: "anywhere",
            color: "#243060",
            lineHeight: "28px",
            "&:hover": {
                color: "#243060",
                fontWeight: 700,
                backgroundColor: "#e9eaef"
            },
            "&:focus": {
                backgroundColor: "#e9eaef"
            },
            cursor: "auto"
        }
    }, cookies.rp_user_data ? cookies.rp_user_data.email : ""), /*#__PURE__*/ $8FY87.createElement((0, $ee9f19037253b32c$export$2e2bcd8739ae039), {
        sx: [
            {
                fontSize: "14px",
                padding: "10px",
                borderBottom: "1px solid rgba(36, 48, 96, 0.20)",
                whiteSpace: "break-spaces",
                lineBreak: "anywhere",
                color: "#243060",
                lineHeight: "28px"
            },
            {
                "&:hover": {
                    color: "#243060",
                    fontWeight: 700,
                    backgroundColor: "transparent"
                }
            }
        ],
        onClick: ()=>{
            navigate("/dashboard");
        },
        className: currentPath === "/dashboard" ? "active app-header-menu-dashboard" : "app-header-menu-dashboard"
    }, "My websites"), /*#__PURE__*/ $8FY87.createElement((0, $ee9f19037253b32c$export$2e2bcd8739ae039), {
        sx: [
            {
                fontSize: "14px",
                padding: "10px",
                borderBottom: "1px solid rgba(36, 48, 96, 0.20)",
                whiteSpace: "break-spaces",
                lineBreak: "anywhere",
                color: "#243060",
                lineHeight: "28px"
            },
            {
                "&:hover": {
                    color: "#243060",
                    fontWeight: 700,
                    backgroundColor: "transparent"
                }
            }
        ],
        onClick: ()=>{
            navigate("/account-settings");
        },
        className: currentPath === "/account-settings" ? "active app-header-menu-account" : "app-header-menu-account"
    }, "Account settings"), cookies.rp_user_data?.userType === "admin" && /*#__PURE__*/ $8FY87.createElement((0, $ee9f19037253b32c$export$2e2bcd8739ae039), {
        sx: [
            {
                fontSize: "14px",
                padding: "10px",
                borderBottom: "1px solid rgba(36, 48, 96, 0.20)",
                whiteSpace: "break-spaces",
                lineBreak: "anywhere",
                color: "#243060",
                lineHeight: "28px"
            },
            {
                "&:hover": {
                    color: "#243060",
                    fontWeight: 700,
                    backgroundColor: "transparent"
                }
            }
        ],
        onClick: ()=>{
            navigate("/admin");
        },
        className: currentPath === "/admin" ? "active" : ""
    }, "Admin Panel"), /*#__PURE__*/ $8FY87.createElement((0, $ee9f19037253b32c$export$2e2bcd8739ae039), {
        className: "app-header-menu-signout",
        sx: [
            {
                fontSize: "14px",
                padding: "10px",
                whiteSpace: "break-spaces",
                lineBreak: "anywhere",
                color: "#243060",
                lineHeight: "28px"
            },
            {
                "&:hover": {
                    color: "#243060",
                    fontWeight: 700,
                    backgroundColor: "transparent"
                }
            }
        ],
        onClick: handleLogout
    }, "Sign out"))));
};




var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");


var $lXBIJ = parcelRequire("lXBIJ");

var $icSEh = parcelRequire("icSEh");

var $ifmKX = parcelRequire("ifmKX");

var $6lkQ3 = parcelRequire("6lkQ3");

var $lbp1P = parcelRequire("lbp1P");

var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $e999830641e1001a$export$29cad1383b3f235d(slot) {
    return (0, $jP65K.default)('MuiCircularProgress', slot);
}
const $e999830641e1001a$var$circularProgressClasses = (0, $cOYaX.default)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $e999830641e1001a$export$2e2bcd8739ae039 = $e999830641e1001a$var$circularProgressClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $b391f94ee7b6de9b$var$_excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let $b391f94ee7b6de9b$var$_ = (t)=>t, $b391f94ee7b6de9b$var$_t, $b391f94ee7b6de9b$var$_t2, $b391f94ee7b6de9b$var$_t3, $b391f94ee7b6de9b$var$_t4;
const $b391f94ee7b6de9b$var$SIZE = 44;
const $b391f94ee7b6de9b$var$circularRotateKeyframe = (0, $icSEh.keyframes)($b391f94ee7b6de9b$var$_t || ($b391f94ee7b6de9b$var$_t = $b391f94ee7b6de9b$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const $b391f94ee7b6de9b$var$circularDashKeyframe = (0, $icSEh.keyframes)($b391f94ee7b6de9b$var$_t2 || ($b391f94ee7b6de9b$var$_t2 = $b391f94ee7b6de9b$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));
const $b391f94ee7b6de9b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $ifmKX.default)(color)}`
        ],
        svg: [
            'svg'
        ],
        circle: [
            'circle',
            `circle${(0, $ifmKX.default)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $e999830641e1001a$export$29cad1383b3f235d), classes);
};
const $b391f94ee7b6de9b$var$CircularProgressRoot = (0, $lbp1P.default)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $ifmKX.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $zgVxD.default)({
        display: 'inline-block'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('transform')
    }, ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }), ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && (0, $icSEh.css)($b391f94ee7b6de9b$var$_t3 || ($b391f94ee7b6de9b$var$_t3 = $b391f94ee7b6de9b$var$_`
      animation: ${0} 1.4s linear infinite;
    `), $b391f94ee7b6de9b$var$circularRotateKeyframe));
const $b391f94ee7b6de9b$var$CircularProgressSVG = (0, $lbp1P.default)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg',
    overridesResolver: (props, styles)=>styles.svg
})({
    display: 'block' // Keeps the progress centered
});
const $b391f94ee7b6de9b$var$CircularProgressCircle = (0, $lbp1P.default)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $ifmKX.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $zgVxD.default)({
        stroke: 'currentColor'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('stroke-dashoffset')
    }, ownerState.variant === 'indeterminate' && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: '80px, 200px',
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink && (0, $icSEh.css)($b391f94ee7b6de9b$var$_t4 || ($b391f94ee7b6de9b$var$_t4 = $b391f94ee7b6de9b$var$_`
      animation: ${0} 1.4s ease-in-out infinite;
    `), $b391f94ee7b6de9b$var$circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $b391f94ee7b6de9b$var$CircularProgress = /*#__PURE__*/ $8FY87.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate' } = props, other = (0, $93aRW.default)(props, $b391f94ee7b6de9b$var$_excluded);
    const ownerState = (0, $zgVxD.default)({}, props, {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    const classes = $b391f94ee7b6de9b$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($b391f94ee7b6de9b$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $2PPWI.jsx)($b391f94ee7b6de9b$var$CircularProgressRoot, (0, $zgVxD.default)({
        className: (0, $efJYy.default)(classes.root, className),
        style: (0, $zgVxD.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, $2PPWI.jsx)($b391f94ee7b6de9b$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$b391f94ee7b6de9b$var$SIZE / 2} ${$b391f94ee7b6de9b$var$SIZE / 2} ${$b391f94ee7b6de9b$var$SIZE} ${$b391f94ee7b6de9b$var$SIZE}`,
            children: /*#__PURE__*/ (0, $2PPWI.jsx)($b391f94ee7b6de9b$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $b391f94ee7b6de9b$var$SIZE,
                cy: $b391f94ee7b6de9b$var$SIZE,
                r: ($b391f94ee7b6de9b$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
var $b391f94ee7b6de9b$export$2e2bcd8739ae039 = $b391f94ee7b6de9b$var$CircularProgress;




var $8FY87 = parcelRequire("8FY87");

var $0d91efdf621c0fba$exports = {};

$parcel$export($0d91efdf621c0fba$exports, "container", function () { return $0d91efdf621c0fba$export$34e0f9847d4c02dd; }, function (v) { return $0d91efdf621c0fba$export$34e0f9847d4c02dd = v; });
$parcel$export($0d91efdf621c0fba$exports, "content", function () { return $0d91efdf621c0fba$export$a7db06668cad9adb; }, function (v) { return $0d91efdf621c0fba$export$a7db06668cad9adb = v; });
$parcel$export($0d91efdf621c0fba$exports, "contentContaienr", function () { return $0d91efdf621c0fba$export$e1d13a6871dc315e; }, function (v) { return $0d91efdf621c0fba$export$e1d13a6871dc315e = v; });
$parcel$export($0d91efdf621c0fba$exports, "desktopHeader", function () { return $0d91efdf621c0fba$export$4c1406428c28b179; }, function (v) { return $0d91efdf621c0fba$export$4c1406428c28b179 = v; });
$parcel$export($0d91efdf621c0fba$exports, "dontHaveAccount", function () { return $0d91efdf621c0fba$export$f8fc567f5297adca; }, function (v) { return $0d91efdf621c0fba$export$f8fc567f5297adca = v; });
$parcel$export($0d91efdf621c0fba$exports, "emailRow", function () { return $0d91efdf621c0fba$export$bc43f15dd5cb8a0f; }, function (v) { return $0d91efdf621c0fba$export$bc43f15dd5cb8a0f = v; });
$parcel$export($0d91efdf621c0fba$exports, "errorLabelForm", function () { return $0d91efdf621c0fba$export$3f39c3e5ae9bc769; }, function (v) { return $0d91efdf621c0fba$export$3f39c3e5ae9bc769 = v; });
$parcel$export($0d91efdf621c0fba$exports, "errorLabels", function () { return $0d91efdf621c0fba$export$91543e1095df11db; }, function (v) { return $0d91efdf621c0fba$export$91543e1095df11db = v; });
$parcel$export($0d91efdf621c0fba$exports, "footer", function () { return $0d91efdf621c0fba$export$adb608be33961c98; }, function (v) { return $0d91efdf621c0fba$export$adb608be33961c98 = v; });
$parcel$export($0d91efdf621c0fba$exports, "footerContent", function () { return $0d91efdf621c0fba$export$a65ca8467dbb209e; }, function (v) { return $0d91efdf621c0fba$export$a65ca8467dbb209e = v; });
$parcel$export($0d91efdf621c0fba$exports, "footerLogo", function () { return $0d91efdf621c0fba$export$185e4800edb7da70; }, function (v) { return $0d91efdf621c0fba$export$185e4800edb7da70 = v; });
$parcel$export($0d91efdf621c0fba$exports, "footerText", function () { return $0d91efdf621c0fba$export$28ad24793e431919; }, function (v) { return $0d91efdf621c0fba$export$28ad24793e431919 = v; });
$parcel$export($0d91efdf621c0fba$exports, "forgotPassword", function () { return $0d91efdf621c0fba$export$66791fb2cfeec3e; }, function (v) { return $0d91efdf621c0fba$export$66791fb2cfeec3e = v; });
$parcel$export($0d91efdf621c0fba$exports, "formContainer", function () { return $0d91efdf621c0fba$export$231ba5fc42c01d86; }, function (v) { return $0d91efdf621c0fba$export$231ba5fc42c01d86 = v; });
$parcel$export($0d91efdf621c0fba$exports, "googleIcon", function () { return $0d91efdf621c0fba$export$51f021792e6b0ae7; }, function (v) { return $0d91efdf621c0fba$export$51f021792e6b0ae7 = v; });
$parcel$export($0d91efdf621c0fba$exports, "googleIframeOverlay", function () { return $0d91efdf621c0fba$export$93477d4076a6e41d; }, function (v) { return $0d91efdf621c0fba$export$93477d4076a6e41d = v; });
$parcel$export($0d91efdf621c0fba$exports, "headerMobile", function () { return $0d91efdf621c0fba$export$e8d3a92df831420a; }, function (v) { return $0d91efdf621c0fba$export$e8d3a92df831420a = v; });
$parcel$export($0d91efdf621c0fba$exports, "heading", function () { return $0d91efdf621c0fba$export$46e4a324ac90507f; }, function (v) { return $0d91efdf621c0fba$export$46e4a324ac90507f = v; });
$parcel$export($0d91efdf621c0fba$exports, "iframecontainer", function () { return $0d91efdf621c0fba$export$c90f26f7157563c6; }, function (v) { return $0d91efdf621c0fba$export$c90f26f7157563c6 = v; });
$parcel$export($0d91efdf621c0fba$exports, "inputMessage", function () { return $0d91efdf621c0fba$export$e5d20dbf71f30862; }, function (v) { return $0d91efdf621c0fba$export$e5d20dbf71f30862 = v; });
$parcel$export($0d91efdf621c0fba$exports, "leftContent", function () { return $0d91efdf621c0fba$export$4efd386ebdb1e61c; }, function (v) { return $0d91efdf621c0fba$export$4efd386ebdb1e61c = v; });
$parcel$export($0d91efdf621c0fba$exports, "loginBtn", function () { return $0d91efdf621c0fba$export$6167bc8f980fa2a0; }, function (v) { return $0d91efdf621c0fba$export$6167bc8f980fa2a0 = v; });
$parcel$export($0d91efdf621c0fba$exports, "loginForm", function () { return $0d91efdf621c0fba$export$56c2ba9e13461f38; }, function (v) { return $0d91efdf621c0fba$export$56c2ba9e13461f38 = v; });
$parcel$export($0d91efdf621c0fba$exports, "loginHeading", function () { return $0d91efdf621c0fba$export$275c58be776b131a; }, function (v) { return $0d91efdf621c0fba$export$275c58be776b131a = v; });
$parcel$export($0d91efdf621c0fba$exports, "loginPage", function () { return $0d91efdf621c0fba$export$fb614e1a95434ae; }, function (v) { return $0d91efdf621c0fba$export$fb614e1a95434ae = v; });
$parcel$export($0d91efdf621c0fba$exports, "logoDark", function () { return $0d91efdf621c0fba$export$806275bf4bba79fb; }, function (v) { return $0d91efdf621c0fba$export$806275bf4bba79fb = v; });
$parcel$export($0d91efdf621c0fba$exports, "logoLight", function () { return $0d91efdf621c0fba$export$a664e2c7f2d9e237; }, function (v) { return $0d91efdf621c0fba$export$a664e2c7f2d9e237 = v; });
$parcel$export($0d91efdf621c0fba$exports, "nopadding", function () { return $0d91efdf621c0fba$export$c87af986af1e6201; }, function (v) { return $0d91efdf621c0fba$export$c87af986af1e6201 = v; });
$parcel$export($0d91efdf621c0fba$exports, "normalLink", function () { return $0d91efdf621c0fba$export$29b013babe0a235d; }, function (v) { return $0d91efdf621c0fba$export$29b013babe0a235d = v; });
$parcel$export($0d91efdf621c0fba$exports, "passwordEye", function () { return $0d91efdf621c0fba$export$afbd2570c0232e96; }, function (v) { return $0d91efdf621c0fba$export$afbd2570c0232e96 = v; });
$parcel$export($0d91efdf621c0fba$exports, "passwordRow", function () { return $0d91efdf621c0fba$export$d345983e88cc494a; }, function (v) { return $0d91efdf621c0fba$export$d345983e88cc494a = v; });
$parcel$export($0d91efdf621c0fba$exports, "primaryBtn", function () { return $0d91efdf621c0fba$export$1ffc6f0e16fd19e; }, function (v) { return $0d91efdf621c0fba$export$1ffc6f0e16fd19e = v; });
$parcel$export($0d91efdf621c0fba$exports, "rememberMeRow", function () { return $0d91efdf621c0fba$export$1d39e4c3f850a90a; }, function (v) { return $0d91efdf621c0fba$export$1d39e4c3f850a90a = v; });
$parcel$export($0d91efdf621c0fba$exports, "seperatorLine", function () { return $0d91efdf621c0fba$export$f9e47c0b06da0081; }, function (v) { return $0d91efdf621c0fba$export$f9e47c0b06da0081 = v; });
$parcel$export($0d91efdf621c0fba$exports, "seperatorText", function () { return $0d91efdf621c0fba$export$6bfc5a75cf565371; }, function (v) { return $0d91efdf621c0fba$export$6bfc5a75cf565371 = v; });
$parcel$export($0d91efdf621c0fba$exports, "signUpBtn", function () { return $0d91efdf621c0fba$export$b27644354e184a81; }, function (v) { return $0d91efdf621c0fba$export$b27644354e184a81 = v; });
$parcel$export($0d91efdf621c0fba$exports, "signUpText", function () { return $0d91efdf621c0fba$export$1c64df6ef9dd6fff; }, function (v) { return $0d91efdf621c0fba$export$1c64df6ef9dd6fff = v; });
$parcel$export($0d91efdf621c0fba$exports, "signup", function () { return $0d91efdf621c0fba$export$7200a869094fec36; }, function (v) { return $0d91efdf621c0fba$export$7200a869094fec36 = v; });
$parcel$export($0d91efdf621c0fba$exports, "socialIcons", function () { return $0d91efdf621c0fba$export$fc1c8ad213f4f5c0; }, function (v) { return $0d91efdf621c0fba$export$fc1c8ad213f4f5c0 = v; });
$parcel$export($0d91efdf621c0fba$exports, "socialSection", function () { return $0d91efdf621c0fba$export$fafcfcc0f83b9fbc; }, function (v) { return $0d91efdf621c0fba$export$fafcfcc0f83b9fbc = v; });
$parcel$export($0d91efdf621c0fba$exports, "subHeading", function () { return $0d91efdf621c0fba$export$628dc1c0324367d; }, function (v) { return $0d91efdf621c0fba$export$628dc1c0324367d = v; });
var $0d91efdf621c0fba$export$34e0f9847d4c02dd;
var $0d91efdf621c0fba$export$a7db06668cad9adb;
var $0d91efdf621c0fba$export$e1d13a6871dc315e;
var $0d91efdf621c0fba$export$4c1406428c28b179;
var $0d91efdf621c0fba$export$f8fc567f5297adca;
var $0d91efdf621c0fba$export$bc43f15dd5cb8a0f;
var $0d91efdf621c0fba$export$3f39c3e5ae9bc769;
var $0d91efdf621c0fba$export$91543e1095df11db;
var $0d91efdf621c0fba$export$adb608be33961c98;
var $0d91efdf621c0fba$export$a65ca8467dbb209e;
var $0d91efdf621c0fba$export$185e4800edb7da70;
var $0d91efdf621c0fba$export$28ad24793e431919;
var $0d91efdf621c0fba$export$66791fb2cfeec3e;
var $0d91efdf621c0fba$export$231ba5fc42c01d86;
var $0d91efdf621c0fba$export$51f021792e6b0ae7;
var $0d91efdf621c0fba$export$93477d4076a6e41d;
var $0d91efdf621c0fba$export$e8d3a92df831420a;
var $0d91efdf621c0fba$export$46e4a324ac90507f;
var $0d91efdf621c0fba$export$c90f26f7157563c6;
var $0d91efdf621c0fba$export$e5d20dbf71f30862;
var $0d91efdf621c0fba$export$4efd386ebdb1e61c;
var $0d91efdf621c0fba$export$6167bc8f980fa2a0;
var $0d91efdf621c0fba$export$56c2ba9e13461f38;
var $0d91efdf621c0fba$export$275c58be776b131a;
var $0d91efdf621c0fba$export$fb614e1a95434ae;
var $0d91efdf621c0fba$export$806275bf4bba79fb;
var $0d91efdf621c0fba$export$a664e2c7f2d9e237;
var $0d91efdf621c0fba$export$c87af986af1e6201;
var $0d91efdf621c0fba$export$29b013babe0a235d;
var $0d91efdf621c0fba$export$afbd2570c0232e96;
var $0d91efdf621c0fba$export$d345983e88cc494a;
var $0d91efdf621c0fba$export$1ffc6f0e16fd19e;
var $0d91efdf621c0fba$export$1d39e4c3f850a90a;
var $0d91efdf621c0fba$export$f9e47c0b06da0081;
var $0d91efdf621c0fba$export$6bfc5a75cf565371;
var $0d91efdf621c0fba$export$b27644354e184a81;
var $0d91efdf621c0fba$export$1c64df6ef9dd6fff;
var $0d91efdf621c0fba$export$7200a869094fec36;
var $0d91efdf621c0fba$export$fc1c8ad213f4f5c0;
var $0d91efdf621c0fba$export$fafcfcc0f83b9fbc;
var $0d91efdf621c0fba$export$628dc1c0324367d;
$0d91efdf621c0fba$export$34e0f9847d4c02dd = `GWlAxG_container`;
$0d91efdf621c0fba$export$a7db06668cad9adb = `GWlAxG_content`;
$0d91efdf621c0fba$export$e1d13a6871dc315e = `GWlAxG_contentContaienr`;
$0d91efdf621c0fba$export$4c1406428c28b179 = `GWlAxG_desktopHeader`;
$0d91efdf621c0fba$export$f8fc567f5297adca = `GWlAxG_dontHaveAccount`;
$0d91efdf621c0fba$export$bc43f15dd5cb8a0f = `GWlAxG_emailRow`;
$0d91efdf621c0fba$export$3f39c3e5ae9bc769 = `GWlAxG_errorLabelForm`;
$0d91efdf621c0fba$export$91543e1095df11db = `GWlAxG_errorLabels`;
$0d91efdf621c0fba$export$adb608be33961c98 = `GWlAxG_footer`;
$0d91efdf621c0fba$export$a65ca8467dbb209e = `GWlAxG_footerContent`;
$0d91efdf621c0fba$export$185e4800edb7da70 = `GWlAxG_footerLogo`;
$0d91efdf621c0fba$export$28ad24793e431919 = `GWlAxG_footerText`;
$0d91efdf621c0fba$export$66791fb2cfeec3e = `GWlAxG_forgotPassword`;
$0d91efdf621c0fba$export$231ba5fc42c01d86 = `GWlAxG_formContainer`;
$0d91efdf621c0fba$export$51f021792e6b0ae7 = `GWlAxG_googleIcon`;
$0d91efdf621c0fba$export$93477d4076a6e41d = `GWlAxG_googleIframeOverlay`;
$0d91efdf621c0fba$export$e8d3a92df831420a = `GWlAxG_headerMobile`;
$0d91efdf621c0fba$export$46e4a324ac90507f = `GWlAxG_heading`;
$0d91efdf621c0fba$export$c90f26f7157563c6 = `GWlAxG_iframecontainer`;
$0d91efdf621c0fba$export$e5d20dbf71f30862 = `GWlAxG_inputMessage`;
$0d91efdf621c0fba$export$4efd386ebdb1e61c = `GWlAxG_leftContent`;
$0d91efdf621c0fba$export$6167bc8f980fa2a0 = `GWlAxG_loginBtn`;
$0d91efdf621c0fba$export$56c2ba9e13461f38 = `GWlAxG_loginForm`;
$0d91efdf621c0fba$export$275c58be776b131a = `GWlAxG_loginHeading`;
$0d91efdf621c0fba$export$fb614e1a95434ae = `GWlAxG_loginPage`;
$0d91efdf621c0fba$export$806275bf4bba79fb = `GWlAxG_logoDark`;
$0d91efdf621c0fba$export$a664e2c7f2d9e237 = `GWlAxG_logoLight`;
$0d91efdf621c0fba$export$c87af986af1e6201 = `GWlAxG_nopadding`;
$0d91efdf621c0fba$export$29b013babe0a235d = `GWlAxG_normalLink`;
$0d91efdf621c0fba$export$afbd2570c0232e96 = `GWlAxG_passwordEye`;
$0d91efdf621c0fba$export$d345983e88cc494a = `GWlAxG_passwordRow`;
$0d91efdf621c0fba$export$1ffc6f0e16fd19e = `GWlAxG_primaryBtn`;
$0d91efdf621c0fba$export$1d39e4c3f850a90a = `GWlAxG_rememberMeRow`;
$0d91efdf621c0fba$export$f9e47c0b06da0081 = `GWlAxG_seperatorLine`;
$0d91efdf621c0fba$export$6bfc5a75cf565371 = `GWlAxG_seperatorText`;
$0d91efdf621c0fba$export$b27644354e184a81 = `GWlAxG_signUpBtn`;
$0d91efdf621c0fba$export$1c64df6ef9dd6fff = `GWlAxG_signUpText`;
$0d91efdf621c0fba$export$7200a869094fec36 = `GWlAxG_signup`;
$0d91efdf621c0fba$export$fc1c8ad213f4f5c0 = `GWlAxG_socialIcons`;
$0d91efdf621c0fba$export$fafcfcc0f83b9fbc = `GWlAxG_socialSection`;
$0d91efdf621c0fba$export$628dc1c0324367d = `GWlAxG_subHeading`;


function $0a87a32205fa1e51$var$checkIsInFrame() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}





const $0a87a32205fa1e51$var$Footer = ()=>{
    const isInIframe = $0a87a32205fa1e51$var$checkIsInFrame();
    const date = new Date();
    return /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, null, /*#__PURE__*/ $8FY87.createElement("footer", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).footer}`
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).footerContent} flex justify-between flex-col`
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: `flex justify-between items-center mb-4 lg:mb-0 flex-row`
    }, /*#__PURE__*/ $8FY87.createElement((0, $734169eef5d6795a$export$a6c7ac8248d6e38a), {
        to: "/",
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).footerLogo}`,
        onClick: (e)=>{
            if (isInIframe) {
                e.preventDefault();
                window.open("/", "_blank");
            }
        }
    }, /*#__PURE__*/ $8FY87.createElement("img", {
        src: (parcelRequire("eMfMQ")),
        alt: "",
        className: "hidden sm:block"
    }), /*#__PURE__*/ $8FY87.createElement("img", {
        src: (parcelRequire("1G3w8")),
        alt: "",
        className: "block sm:hidden w-full h-full"
    })), /*#__PURE__*/ $8FY87.createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).footerText} hidden lg:block px-4`
    }, /*#__PURE__*/ $8FY87.createElement("span", null, " ", "\xa9 ", date.getFullYear(), " RocketPages. All Rights Reserved"), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "hidden md:inline mx-2"
    }, "|"), /*#__PURE__*/ $8FY87.createElement((0, $734169eef5d6795a$export$a6c7ac8248d6e38a), {
        to: "https://rocketpages.io/terms-and-conditions",
        className: "text-white no-underline",
        onClick: (e)=>{
            if (isInIframe) {
                e.preventDefault();
                window.open("https://rocketpages.io/terms-and-conditions", "_blank");
            }
        }
    }, "Terms And Conditions"), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "hidden md:inline mx-2"
    }, "|"), /*#__PURE__*/ $8FY87.createElement((0, $734169eef5d6795a$export$a6c7ac8248d6e38a), {
        to: "https://rocketpages.io/privacy-policy",
        className: "text-white no-underline",
        onClick: (e)=>{
            if (isInIframe) {
                e.preventDefault();
                window.open("https://rocketpages.io/privacy-policy", "_blank");
            }
        }
    }, "Privacy Policy")), /*#__PURE__*/ $8FY87.createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).footerSocials} flex`
    }, /*#__PURE__*/ $8FY87.createElement((0, $734169eef5d6795a$export$a6c7ac8248d6e38a), {
        to: "https://www.facebook.com/RocketPagesIO",
        target: "_blank",
        className: "mr-2"
    }, /*#__PURE__*/ $8FY87.createElement("img", {
        src: (parcelRequire("1wv3p")),
        className: "h-[16px]",
        alt: "facebook"
    })), /*#__PURE__*/ $8FY87.createElement((0, $734169eef5d6795a$export$a6c7ac8248d6e38a), {
        to: "https://twitter.com/RocketPagesIO",
        target: "_blank",
        className: "mr-2"
    }, /*#__PURE__*/ $8FY87.createElement("img", {
        src: (parcelRequire("d8mEN")),
        className: "h-[16px]",
        alt: "twitter"
    })), /*#__PURE__*/ $8FY87.createElement((0, $734169eef5d6795a$export$a6c7ac8248d6e38a), {
        to: "https://www.linkedin.com/company/rocketpages",
        target: "_blank"
    }, /*#__PURE__*/ $8FY87.createElement("img", {
        src: (parcelRequire("hGbt5")),
        className: "h-[16px]",
        alt: "linkedin"
    })))), /*#__PURE__*/ $8FY87.createElement("div", {
        className: `GWlAxG_footerText flex justify-center items-center flex-wrap footer-div lg:hidden md:flex`
    }, /*#__PURE__*/ $8FY87.createElement("span", null, "\xa9 ", date.getFullYear(), " RocketPages. All Rights Reserved"), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "mx-2 pipe-1"
    }, "|"), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "flex justify-center"
    }, /*#__PURE__*/ $8FY87.createElement((0, $734169eef5d6795a$export$a6c7ac8248d6e38a), {
        to: "https://rocketpages.io/terms-and-conditions",
        className: "text-white",
        onClick: (e)=>{
            if (isInIframe) {
                e.preventDefault();
                window.open("https://rocketpages.io/terms-and-conditions", "_blank");
            }
        }
    }, "Terms And Conditions"), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "mx-2"
    }, "|"), /*#__PURE__*/ $8FY87.createElement((0, $734169eef5d6795a$export$a6c7ac8248d6e38a), {
        to: "https://rocketpages.io/privacy-policy",
        className: "text-white",
        onClick: (e)=>{
            if (isInIframe) {
                e.preventDefault();
                window.open("https://rocketpages.io/privacy-policy", "_blank");
            }
        }
    }, "Privacy Policy"))))));
};
var $0a87a32205fa1e51$export$2e2bcd8739ae039 = $0a87a32205fa1e51$var$Footer;




var $8FY87 = parcelRequire("8FY87");

var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $lXBIJ = parcelRequire("lXBIJ");

var $8FY87 = parcelRequire("8FY87");
'use client';
/**
 * @ignore - internal component.
 */ const $1ac7ca4248f52a42$var$TableContext = /*#__PURE__*/ $8FY87.createContext();
var $1ac7ca4248f52a42$export$2e2bcd8739ae039 = $1ac7ca4248f52a42$var$TableContext;



var $6lkQ3 = parcelRequire("6lkQ3");

var $lbp1P = parcelRequire("lbp1P");

var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $58dd74d4ffad05f2$export$315cb19215f77ce0(slot) {
    return (0, $jP65K.default)('MuiTable', slot);
}
const $58dd74d4ffad05f2$var$tableClasses = (0, $cOYaX.default)('MuiTable', [
    'root',
    'stickyHeader'
]);
var $58dd74d4ffad05f2$export$2e2bcd8739ae039 = $58dd74d4ffad05f2$var$tableClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $423aebbc6a7fa906$var$_excluded = [
    "className",
    "component",
    "padding",
    "size",
    "stickyHeader"
];
const $423aebbc6a7fa906$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            stickyHeader && 'stickyHeader'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $58dd74d4ffad05f2$export$315cb19215f77ce0), classes);
};
const $423aebbc6a7fa906$var$TableRoot = (0, $lbp1P.default)('table', {
    name: 'MuiTable',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $zgVxD.default)({
        display: 'table',
        width: '100%',
        borderCollapse: 'collapse',
        borderSpacing: 0,
        '& caption': (0, $zgVxD.default)({}, theme.typography.body2, {
            padding: theme.spacing(2),
            color: (theme.vars || theme).palette.text.secondary,
            textAlign: 'left',
            captionSide: 'bottom'
        })
    }, ownerState.stickyHeader && {
        borderCollapse: 'separate'
    }));
const $423aebbc6a7fa906$var$defaultComponent = 'table';
const $423aebbc6a7fa906$var$Table = /*#__PURE__*/ $8FY87.forwardRef(function Table(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiTable'
    });
    const { className: className, component: component = $423aebbc6a7fa906$var$defaultComponent, padding: padding = 'normal', size: size = 'medium', stickyHeader: stickyHeader = false } = props, other = (0, $93aRW.default)(props, $423aebbc6a7fa906$var$_excluded);
    const ownerState = (0, $zgVxD.default)({}, props, {
        component: component,
        padding: padding,
        size: size,
        stickyHeader: stickyHeader
    });
    const classes = $423aebbc6a7fa906$var$useUtilityClasses(ownerState);
    const table = $8FY87.useMemo(()=>({
            padding: padding,
            size: size,
            stickyHeader: stickyHeader
        }), [
        padding,
        size,
        stickyHeader
    ]);
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $1ac7ca4248f52a42$export$2e2bcd8739ae039).Provider, {
        value: table,
        children: /*#__PURE__*/ (0, $2PPWI.jsx)($423aebbc6a7fa906$var$TableRoot, (0, $zgVxD.default)({
            as: component,
            role: component === $423aebbc6a7fa906$var$defaultComponent ? null : 'table',
            ref: ref,
            className: (0, $efJYy.default)(classes.root, className),
            ownerState: ownerState
        }, other))
    });
});
var $423aebbc6a7fa906$export$2e2bcd8739ae039 = $423aebbc6a7fa906$var$Table;



var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $lXBIJ = parcelRequire("lXBIJ");

var $8FY87 = parcelRequire("8FY87");
/**
 * @ignore - internal component.
 */ const $1253697f6896b0d3$var$Tablelvl2Context = /*#__PURE__*/ $8FY87.createContext();
var $1253697f6896b0d3$export$2e2bcd8739ae039 = $1253697f6896b0d3$var$Tablelvl2Context;



var $6lkQ3 = parcelRequire("6lkQ3");

var $lbp1P = parcelRequire("lbp1P");

var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $806baf624e7c8855$export$98bd2a9b566ec665(slot) {
    return (0, $jP65K.default)('MuiTableBody', slot);
}
const $806baf624e7c8855$var$tableBodyClasses = (0, $cOYaX.default)('MuiTableBody', [
    'root'
]);
var $806baf624e7c8855$export$2e2bcd8739ae039 = $806baf624e7c8855$var$tableBodyClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $31f4d7fca07191f6$var$_excluded = [
    "className",
    "component"
];
const $31f4d7fca07191f6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $806baf624e7c8855$export$98bd2a9b566ec665), classes);
};
const $31f4d7fca07191f6$var$TableBodyRoot = (0, $lbp1P.default)('tbody', {
    name: 'MuiTableBody',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'table-row-group'
});
const $31f4d7fca07191f6$var$tablelvl2 = {
    variant: 'body'
};
const $31f4d7fca07191f6$var$defaultComponent = 'tbody';
const $31f4d7fca07191f6$var$TableBody = /*#__PURE__*/ $8FY87.forwardRef(function TableBody(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiTableBody'
    });
    const { className: className, component: component = $31f4d7fca07191f6$var$defaultComponent } = props, other = (0, $93aRW.default)(props, $31f4d7fca07191f6$var$_excluded);
    const ownerState = (0, $zgVxD.default)({}, props, {
        component: component
    });
    const classes = $31f4d7fca07191f6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $1253697f6896b0d3$export$2e2bcd8739ae039).Provider, {
        value: $31f4d7fca07191f6$var$tablelvl2,
        children: /*#__PURE__*/ (0, $2PPWI.jsx)($31f4d7fca07191f6$var$TableBodyRoot, (0, $zgVxD.default)({
            className: (0, $efJYy.default)(classes.root, className),
            as: component,
            ref: ref,
            role: component === $31f4d7fca07191f6$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState
        }, other))
    });
});
var $31f4d7fca07191f6$export$2e2bcd8739ae039 = $31f4d7fca07191f6$var$TableBody;



var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $lXBIJ = parcelRequire("lXBIJ");

var $1r55V = parcelRequire("1r55V");

var $ifmKX = parcelRequire("ifmKX");



var $6lkQ3 = parcelRequire("6lkQ3");

var $lbp1P = parcelRequire("lbp1P");

var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $bb31d6dda008ea0e$export$33a0f07a16a10b1b(slot) {
    return (0, $jP65K.default)('MuiTableCell', slot);
}
const $bb31d6dda008ea0e$var$tableCellClasses = (0, $cOYaX.default)('MuiTableCell', [
    'root',
    'head',
    'body',
    'footer',
    'sizeSmall',
    'sizeMedium',
    'paddingCheckbox',
    'paddingNone',
    'alignLeft',
    'alignCenter',
    'alignRight',
    'alignJustify',
    'stickyHeader'
]);
var $bb31d6dda008ea0e$export$2e2bcd8739ae039 = $bb31d6dda008ea0e$var$tableCellClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $8f2ac4889b244103$var$_excluded = [
    "align",
    "className",
    "component",
    "padding",
    "scope",
    "size",
    "sortDirection",
    "variant"
];
const $8f2ac4889b244103$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, align: align, padding: padding, size: size, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            stickyHeader && 'stickyHeader',
            align !== 'inherit' && `align${(0, $ifmKX.default)(align)}`,
            padding !== 'normal' && `padding${(0, $ifmKX.default)(padding)}`,
            `size${(0, $ifmKX.default)(size)}`
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $bb31d6dda008ea0e$export$33a0f07a16a10b1b), classes);
};
const $8f2ac4889b244103$var$TableCellRoot = (0, $lbp1P.default)('td', {
    name: 'MuiTableCell',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $ifmKX.default)(ownerState.size)}`],
            ownerState.padding !== 'normal' && styles[`padding${(0, $ifmKX.default)(ownerState.padding)}`],
            ownerState.align !== 'inherit' && styles[`align${(0, $ifmKX.default)(ownerState.align)}`],
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $zgVxD.default)({}, theme.typography.body2, {
        display: 'table-cell',
        verticalAlign: 'inherit',
        // Workaround for a rendering bug with spanned columns in Chrome 62.0.
        // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
        borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === 'light' ? (0, $1r55V.lighten)((0, $1r55V.alpha)(theme.palette.divider, 1), 0.88) : (0, $1r55V.darken)((0, $1r55V.alpha)(theme.palette.divider, 1), 0.68)}`,
        textAlign: 'left',
        padding: 16
    }, ownerState.variant === 'head' && {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: theme.typography.pxToRem(24),
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.variant === 'body' && {
        color: (theme.vars || theme).palette.text.primary
    }, ownerState.variant === 'footer' && {
        color: (theme.vars || theme).palette.text.secondary,
        lineHeight: theme.typography.pxToRem(21),
        fontSize: theme.typography.pxToRem(12)
    }, ownerState.size === 'small' && {
        padding: '6px 16px',
        [`&.${(0, $bb31d6dda008ea0e$export$2e2bcd8739ae039).paddingCheckbox}`]: {
            width: 24,
            // prevent the checkbox column from growing
            padding: '0 12px 0 16px',
            '& > *': {
                padding: 0
            }
        }
    }, ownerState.padding === 'checkbox' && {
        width: 48,
        // prevent the checkbox column from growing
        padding: '0 0 0 4px'
    }, ownerState.padding === 'none' && {
        padding: 0
    }, ownerState.align === 'left' && {
        textAlign: 'left'
    }, ownerState.align === 'center' && {
        textAlign: 'center'
    }, ownerState.align === 'right' && {
        textAlign: 'right',
        flexDirection: 'row-reverse'
    }, ownerState.align === 'justify' && {
        textAlign: 'justify'
    }, ownerState.stickyHeader && {
        position: 'sticky',
        top: 0,
        zIndex: 2,
        backgroundColor: (theme.vars || theme).palette.background.default
    }));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ const $8f2ac4889b244103$var$TableCell = /*#__PURE__*/ $8FY87.forwardRef(function TableCell(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiTableCell'
    });
    const { align: align = 'inherit', className: className, component: componentProp, padding: paddingProp, scope: scopeProp, size: sizeProp, sortDirection: sortDirection, variant: variantProp } = props, other = (0, $93aRW.default)(props, $8f2ac4889b244103$var$_excluded);
    const table = $8FY87.useContext((0, $1ac7ca4248f52a42$export$2e2bcd8739ae039));
    const tablelvl2 = $8FY87.useContext((0, $1253697f6896b0d3$export$2e2bcd8739ae039));
    const isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
    let component;
    if (componentProp) component = componentProp;
    else component = isHeadCell ? 'th' : 'td';
    let scope = scopeProp;
    // scope is not a valid attribute for <td/> elements.
    // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
    if (component === 'td') scope = undefined;
    else if (!scope && isHeadCell) scope = 'col';
    const variant = variantProp || tablelvl2 && tablelvl2.variant;
    const ownerState = (0, $zgVxD.default)({}, props, {
        align: align,
        component: component,
        padding: paddingProp || (table && table.padding ? table.padding : 'normal'),
        size: sizeProp || (table && table.size ? table.size : 'medium'),
        sortDirection: sortDirection,
        stickyHeader: variant === 'head' && table && table.stickyHeader,
        variant: variant
    });
    const classes = $8f2ac4889b244103$var$useUtilityClasses(ownerState);
    let ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
    return /*#__PURE__*/ (0, $2PPWI.jsx)($8f2ac4889b244103$var$TableCellRoot, (0, $zgVxD.default)({
        as: component,
        ref: ref,
        className: (0, $efJYy.default)(classes.root, className),
        "aria-sort": ariaSort,
        scope: scope,
        ownerState: ownerState
    }, other));
});
var $8f2ac4889b244103$export$2e2bcd8739ae039 = $8f2ac4889b244103$var$TableCell;



var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $lXBIJ = parcelRequire("lXBIJ");

var $6lkQ3 = parcelRequire("6lkQ3");

var $lbp1P = parcelRequire("lbp1P");

var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $86587b132241ef5d$export$eed427986a7abdf9(slot) {
    return (0, $jP65K.default)('MuiTableContainer', slot);
}
const $86587b132241ef5d$var$tableContainerClasses = (0, $cOYaX.default)('MuiTableContainer', [
    'root'
]);
var $86587b132241ef5d$export$2e2bcd8739ae039 = $86587b132241ef5d$var$tableContainerClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $b40bc546cf048f9f$var$_excluded = [
    "className",
    "component"
];
const $b40bc546cf048f9f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $86587b132241ef5d$export$eed427986a7abdf9), classes);
};
const $b40bc546cf048f9f$var$TableContainerRoot = (0, $lbp1P.default)('div', {
    name: 'MuiTableContainer',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    width: '100%',
    overflowX: 'auto'
});
const $b40bc546cf048f9f$var$TableContainer = /*#__PURE__*/ $8FY87.forwardRef(function TableContainer(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiTableContainer'
    });
    const { className: className, component: component = 'div' } = props, other = (0, $93aRW.default)(props, $b40bc546cf048f9f$var$_excluded);
    const ownerState = (0, $zgVxD.default)({}, props, {
        component: component
    });
    const classes = $b40bc546cf048f9f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2PPWI.jsx)($b40bc546cf048f9f$var$TableContainerRoot, (0, $zgVxD.default)({
        ref: ref,
        as: component,
        className: (0, $efJYy.default)(classes.root, className),
        ownerState: ownerState
    }, other));
});
var $b40bc546cf048f9f$export$2e2bcd8739ae039 = $b40bc546cf048f9f$var$TableContainer;



var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $lXBIJ = parcelRequire("lXBIJ");


var $6lkQ3 = parcelRequire("6lkQ3");

var $lbp1P = parcelRequire("lbp1P");

var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $8777a74396344381$export$2e731cea2d1c2392(slot) {
    return (0, $jP65K.default)('MuiTableHead', slot);
}
const $8777a74396344381$var$tableHeadClasses = (0, $cOYaX.default)('MuiTableHead', [
    'root'
]);
var $8777a74396344381$export$2e2bcd8739ae039 = $8777a74396344381$var$tableHeadClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $ea8456a9f35d1365$var$_excluded = [
    "className",
    "component"
];
const $ea8456a9f35d1365$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $8777a74396344381$export$2e731cea2d1c2392), classes);
};
const $ea8456a9f35d1365$var$TableHeadRoot = (0, $lbp1P.default)('thead', {
    name: 'MuiTableHead',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'table-header-group'
});
const $ea8456a9f35d1365$var$tablelvl2 = {
    variant: 'head'
};
const $ea8456a9f35d1365$var$defaultComponent = 'thead';
const $ea8456a9f35d1365$var$TableHead = /*#__PURE__*/ $8FY87.forwardRef(function TableHead(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiTableHead'
    });
    const { className: className, component: component = $ea8456a9f35d1365$var$defaultComponent } = props, other = (0, $93aRW.default)(props, $ea8456a9f35d1365$var$_excluded);
    const ownerState = (0, $zgVxD.default)({}, props, {
        component: component
    });
    const classes = $ea8456a9f35d1365$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $1253697f6896b0d3$export$2e2bcd8739ae039).Provider, {
        value: $ea8456a9f35d1365$var$tablelvl2,
        children: /*#__PURE__*/ (0, $2PPWI.jsx)($ea8456a9f35d1365$var$TableHeadRoot, (0, $zgVxD.default)({
            as: component,
            className: (0, $efJYy.default)(classes.root, className),
            ref: ref,
            role: component === $ea8456a9f35d1365$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState
        }, other))
    });
});
var $ea8456a9f35d1365$export$2e2bcd8739ae039 = $ea8456a9f35d1365$var$TableHead;



var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $lXBIJ = parcelRequire("lXBIJ");

var $1r55V = parcelRequire("1r55V");


var $6lkQ3 = parcelRequire("6lkQ3");

var $lbp1P = parcelRequire("lbp1P");

var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $543572f889f80a95$export$ba0a6d6c28940107(slot) {
    return (0, $jP65K.default)('MuiTableRow', slot);
}
const $543572f889f80a95$var$tableRowClasses = (0, $cOYaX.default)('MuiTableRow', [
    'root',
    'selected',
    'hover',
    'head',
    'footer'
]);
var $543572f889f80a95$export$2e2bcd8739ae039 = $543572f889f80a95$var$tableRowClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $aceff834f1a65851$var$_excluded = [
    "className",
    "component",
    "hover",
    "selected"
];
const $aceff834f1a65851$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, hover: hover, head: head, footer: footer } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            hover && 'hover',
            head && 'head',
            footer && 'footer'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $543572f889f80a95$export$ba0a6d6c28940107), classes);
};
const $aceff834f1a65851$var$TableRowRoot = (0, $lbp1P.default)('tr', {
    name: 'MuiTableRow',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.head && styles.head,
            ownerState.footer && styles.footer
        ];
    }
})(({ theme: theme })=>({
        color: 'inherit',
        display: 'table-row',
        verticalAlign: 'middle',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        [`&.${(0, $543572f889f80a95$export$2e2bcd8739ae039).hover}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $543572f889f80a95$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $1r55V.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $1r55V.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
            }
        }
    }));
const $aceff834f1a65851$var$defaultComponent = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ const $aceff834f1a65851$var$TableRow = /*#__PURE__*/ $8FY87.forwardRef(function TableRow(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiTableRow'
    });
    const { className: className, component: component = $aceff834f1a65851$var$defaultComponent, hover: hover = false, selected: selected = false } = props, other = (0, $93aRW.default)(props, $aceff834f1a65851$var$_excluded);
    const tablelvl2 = $8FY87.useContext((0, $1253697f6896b0d3$export$2e2bcd8739ae039));
    const ownerState = (0, $zgVxD.default)({}, props, {
        component: component,
        hover: hover,
        selected: selected,
        head: tablelvl2 && tablelvl2.variant === 'head',
        footer: tablelvl2 && tablelvl2.variant === 'footer'
    });
    const classes = $aceff834f1a65851$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2PPWI.jsx)($aceff834f1a65851$var$TableRowRoot, (0, $zgVxD.default)({
        as: component,
        ref: ref,
        className: (0, $efJYy.default)(classes.root, className),
        role: component === $aceff834f1a65851$var$defaultComponent ? null : 'row',
        ownerState: ownerState
    }, other));
});
var $aceff834f1a65851$export$2e2bcd8739ae039 = $aceff834f1a65851$var$TableRow;






var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");

var $8FY87 = parcelRequire("8FY87");
function $8bcfdb8fb9b51cc8$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $8bcfdb8fb9b51cc8$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $8bcfdb8fb9b51cc8$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $8bcfdb8fb9b51cc8$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $8bcfdb8fb9b51cc8$export$2e2bcd8739ae039 = $8bcfdb8fb9b51cc8$export$4f5d2d50c9deca37;



var $hDbmX = parcelRequire("hDbmX");

var $lqCXV = parcelRequire("lqCXV");
var $bZmXB = parcelRequire("bZmXB");


var $2PPWI = parcelRequire("2PPWI");
'use client';
const $8736378712da465e$var$_excluded = [
    "className",
    "component"
];
function $8736378712da465e$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $hDbmX.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, $lqCXV.default));
    const Box = /*#__PURE__*/ $8FY87.forwardRef(function Box(inProps, ref) {
        const theme = (0, $4ec357bcdd79021e$export$2e2bcd8739ae039)(defaultTheme);
        const _extendSxProp = (0, $bZmXB.default)(inProps), { className: className, component: component = 'div' } = _extendSxProp, other = (0, $93aRW.default)(_extendSxProp, $8736378712da465e$var$_excluded);
        return /*#__PURE__*/ (0, $2PPWI.jsx)(BoxRoot, (0, $zgVxD.default)({
            as: component,
            ref: ref,
            className: (0, $8bcfdb8fb9b51cc8$export$2e2bcd8739ae039)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}




var $9Wg9x = parcelRequire("9Wg9x");

var $ccfLL = parcelRequire("ccfLL");

var $ab2pD = parcelRequire("ab2pD");

var $cOYaX = parcelRequire("cOYaX");
const $c0bca43c1312e297$var$boxClasses = (0, $cOYaX.default)('MuiBox', [
    'root'
]);
var $c0bca43c1312e297$export$2e2bcd8739ae039 = $c0bca43c1312e297$var$boxClasses;


'use client';
const $b19176bd78e1869f$var$defaultTheme = (0, $ccfLL.default)();
const $b19176bd78e1869f$var$Box = (0, $8736378712da465e$export$2e2bcd8739ae039)({
    themeId: (0, $ab2pD.default),
    defaultTheme: $b19176bd78e1869f$var$defaultTheme,
    defaultClassName: (0, $c0bca43c1312e297$export$2e2bcd8739ae039).root,
    generateClassName: (0, $9Wg9x.default).generate
});
var $b19176bd78e1869f$export$2e2bcd8739ae039 = $b19176bd78e1869f$var$Box;




var $8FY87 = parcelRequire("8FY87");

function $68aee9bbbc0e9b6d$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $68aee9bbbc0e9b6d$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $68aee9bbbc0e9b6d$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $68aee9bbbc0e9b6d$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $68aee9bbbc0e9b6d$export$2e2bcd8739ae039 = $68aee9bbbc0e9b6d$export$4f5d2d50c9deca37;


let $d29d2f64505cf8b8$var$e = {
    data: ""
}, $d29d2f64505cf8b8$var$t = (t)=>{
    if ("object" == typeof window) {
        let e = (t ? t.querySelector("#_goober") : window._goober) || Object.assign(document.createElement("style"), {
            innerHTML: " ",
            id: "_goober"
        });
        return e.nonce = window.__nonce__, e.parentNode || (t || document.head).appendChild(e), e.firstChild;
    }
    return t || $d29d2f64505cf8b8$var$e;
}, $d29d2f64505cf8b8$export$54aba348a7896325 = (e)=>{
    let r = $d29d2f64505cf8b8$var$t(e), l = r.data;
    return r.data = "", l;
}, $d29d2f64505cf8b8$var$l = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, $d29d2f64505cf8b8$var$a = /\/\*[^]*?\*\/|  +/g, $d29d2f64505cf8b8$var$n = /\n+/g, $d29d2f64505cf8b8$var$o = (e, t)=>{
    let r = "", l = "", a = "";
    for(let n in e){
        let c = e[n];
        "@" == n[0] ? "i" == n[1] ? r = n + " " + c + ";" : l += "f" == n[1] ? $d29d2f64505cf8b8$var$o(c, n) : n + "{" + $d29d2f64505cf8b8$var$o(c, "k" == n[1] ? "" : t) + "}" : "object" == typeof c ? l += $d29d2f64505cf8b8$var$o(c, t ? t.replace(/([^,])+/g, (e)=>n.replace(/([^,]*:\S+\([^)]*\))|([^,])+/g, (t)=>/&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t)) : n) : null != c && (n = /^--/.test(n) ? n : n.replace(/[A-Z]/g, "-$&").toLowerCase(), a += $d29d2f64505cf8b8$var$o.p ? $d29d2f64505cf8b8$var$o.p(n, c) : n + ":" + c + ";");
    }
    return r + (t && a ? t + "{" + a + "}" : a) + l;
}, $d29d2f64505cf8b8$var$c = {}, $d29d2f64505cf8b8$var$s = (e)=>{
    if ("object" == typeof e) {
        let t = "";
        for(let r in e)t += r + $d29d2f64505cf8b8$var$s(e[r]);
        return t;
    }
    return e;
}, $d29d2f64505cf8b8$var$i = (e, t, r, i, p)=>{
    let u = $d29d2f64505cf8b8$var$s(e), d = $d29d2f64505cf8b8$var$c[u] || ($d29d2f64505cf8b8$var$c[u] = ((e)=>{
        let t = 0, r = 11;
        for(; t < e.length;)r = 101 * r + e.charCodeAt(t++) >>> 0;
        return "go" + r;
    })(u));
    if (!$d29d2f64505cf8b8$var$c[d]) {
        let t = u !== e ? e : ((e)=>{
            let t, r, o = [
                {}
            ];
            for(; t = $d29d2f64505cf8b8$var$l.exec(e.replace($d29d2f64505cf8b8$var$a, ""));)t[4] ? o.shift() : t[3] ? (r = t[3].replace($d29d2f64505cf8b8$var$n, " ").trim(), o.unshift(o[0][r] = o[0][r] || {})) : o[0][t[1]] = t[2].replace($d29d2f64505cf8b8$var$n, " ").trim();
            return o[0];
        })(e);
        $d29d2f64505cf8b8$var$c[d] = $d29d2f64505cf8b8$var$o(p ? {
            ["@keyframes " + d]: t
        } : t, r ? "" : "." + d);
    }
    let f = r && $d29d2f64505cf8b8$var$c.g ? $d29d2f64505cf8b8$var$c.g : null;
    return r && ($d29d2f64505cf8b8$var$c.g = $d29d2f64505cf8b8$var$c[d]), ((e, t, r, l)=>{
        l ? t.data = t.data.replace(l, e) : -1 === t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
    })($d29d2f64505cf8b8$var$c[d], t, i, f), d;
}, $d29d2f64505cf8b8$var$p = (e, t, r)=>e.reduce((e, l, a)=>{
        let n = t[a];
        if (n && n.call) {
            let e = n(r), t = e && e.props && e.props.className || /^go/.test(e) && e;
            n = t ? "." + t : e && "object" == typeof e ? e.props ? "" : $d29d2f64505cf8b8$var$o(e, "") : !1 === e ? "" : e;
        }
        return e + l + (null == n ? "" : n);
    }, "");
function $d29d2f64505cf8b8$export$dbf350e5966cf602(e) {
    let r = this || {}, l = e.call ? e(r.p) : e;
    return $d29d2f64505cf8b8$var$i(l.unshift ? l.raw ? $d29d2f64505cf8b8$var$p(l, [].slice.call(arguments, 1), r.p) : l.reduce((e, t)=>Object.assign(e, t && t.call ? t(r.p) : t), {}) : l, $d29d2f64505cf8b8$var$t(r.target), r.g, r.o, r.k);
}
let $d29d2f64505cf8b8$var$d, $d29d2f64505cf8b8$var$f, $d29d2f64505cf8b8$var$g, $d29d2f64505cf8b8$export$442f1a04865e4790 = $d29d2f64505cf8b8$export$dbf350e5966cf602.bind({
    g: 1
}), $d29d2f64505cf8b8$export$d25ddfdf17c3ad3e = $d29d2f64505cf8b8$export$dbf350e5966cf602.bind({
    k: 1
});
function $d29d2f64505cf8b8$export$de27182ff8187d6c(e, t, r, l) {
    $d29d2f64505cf8b8$var$o.p = t, $d29d2f64505cf8b8$var$d = e, $d29d2f64505cf8b8$var$f = r, $d29d2f64505cf8b8$var$g = l;
}
function $d29d2f64505cf8b8$export$3817b7a54a07cec7(e, t) {
    let r = this || {};
    return function() {
        let l = arguments;
        function a(n, o) {
            let c = Object.assign({}, n), s = c.className || a.className;
            r.p = Object.assign({
                theme: $d29d2f64505cf8b8$var$f && $d29d2f64505cf8b8$var$f()
            }, c), r.o = / *go\d+/.test(s), c.className = $d29d2f64505cf8b8$export$dbf350e5966cf602.apply(r, l) + (s ? " " + s : ""), t && (c.ref = o);
            let i = e;
            return e[0] && (i = c.as || e, delete c.as), $d29d2f64505cf8b8$var$g && i[0] && $d29d2f64505cf8b8$var$g(c), $d29d2f64505cf8b8$var$d(i, c);
        }
        return t ? t(a) : a;
    };
}


function $5e19452f9528802f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5e19452f9528802f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5e19452f9528802f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5e19452f9528802f$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $5e19452f9528802f$var$_extends() {
    $5e19452f9528802f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5e19452f9528802f$var$_extends.apply(this, arguments);
}
function $5e19452f9528802f$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $5e19452f9528802f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $5e19452f9528802f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var $5e19452f9528802f$var$noOp = function noOp() {
    return '';
};
var $5e19452f9528802f$var$SnackbarContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createContext({
    enqueueSnackbar: $5e19452f9528802f$var$noOp,
    closeSnackbar: $5e19452f9528802f$var$noOp
});
var $5e19452f9528802f$var$breakpoints = {
    downXs: '@media (max-width:599.95px)',
    upSm: '@media (min-width:600px)'
};
var $5e19452f9528802f$var$capitalise = function capitalise(text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
};
var $5e19452f9528802f$var$originKeyExtractor = function originKeyExtractor(anchor) {
    return "" + $5e19452f9528802f$var$capitalise(anchor.vertical) + $5e19452f9528802f$var$capitalise(anchor.horizontal);
};
var $5e19452f9528802f$var$isDefined = function isDefined(value) {
    return !!value || value === 0;
};
var $5e19452f9528802f$var$UNMOUNTED = 'unmounted';
var $5e19452f9528802f$var$EXITED = 'exited';
var $5e19452f9528802f$var$ENTERING = 'entering';
var $5e19452f9528802f$var$ENTERED = 'entered';
var $5e19452f9528802f$var$EXITING = 'exiting';
var $5e19452f9528802f$export$be58926105124dd4 = /*#__PURE__*/ function(_React$Component) {
    $5e19452f9528802f$var$_inheritsLoose(Transition, _React$Component);
    function Transition(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        var appear = props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props["in"]) {
            if (appear) {
                initialStatus = $5e19452f9528802f$var$EXITED;
                _this.appearStatus = $5e19452f9528802f$var$ENTERING;
            } else initialStatus = $5e19452f9528802f$var$ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $5e19452f9528802f$var$UNMOUNTED;
        else initialStatus = $5e19452f9528802f$var$EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref["in"];
        if (nextIn && prevState.status === $5e19452f9528802f$var$UNMOUNTED) return {
            status: $5e19452f9528802f$var$EXITED
        };
        return null;
    };
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props["in"]) {
                if (status !== $5e19452f9528802f$var$ENTERING && status !== $5e19452f9528802f$var$ENTERED) nextStatus = $5e19452f9528802f$var$ENTERING;
            } else if (status === $5e19452f9528802f$var$ENTERING || status === $5e19452f9528802f$var$ENTERED) nextStatus = $5e19452f9528802f$var$EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var enter = timeout;
        var exit = timeout;
        if (timeout != null && typeof timeout !== 'number' && typeof timeout !== 'string') {
            exit = timeout.exit;
            enter = timeout.enter;
        }
        return {
            exit: exit,
            enter: enter
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            this.cancelNextCallback();
            if (nextStatus === $5e19452f9528802f$var$ENTERING) this.performEnter(mounting);
            else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $5e19452f9528802f$var$EXITED) this.setState({
            status: $5e19452f9528802f$var$UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var isAppearing = mounting;
        var timeouts = this.getTimeouts();
        if (!mounting && !enter) {
            this.safeSetState({
                status: $5e19452f9528802f$var$ENTERED
            }, function() {
                if (_this2.props.onEntered) _this2.props.onEntered(_this2.node, isAppearing);
            });
            return;
        }
        if (this.props.onEnter) this.props.onEnter(this.node, isAppearing);
        this.safeSetState({
            status: $5e19452f9528802f$var$ENTERING
        }, function() {
            if (_this2.props.onEntering) _this2.props.onEntering(_this2.node, isAppearing);
            _this2.onTransitionEnd(timeouts.enter, function() {
                _this2.safeSetState({
                    status: $5e19452f9528802f$var$ENTERED
                }, function() {
                    if (_this2.props.onEntered) _this2.props.onEntered(_this2.node, isAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
        if (!exit) {
            this.safeSetState({
                status: $5e19452f9528802f$var$EXITED
            }, function() {
                if (_this3.props.onExited) _this3.props.onExited(_this3.node);
            });
            return;
        }
        if (this.props.onExit) this.props.onExit(this.node);
        this.safeSetState({
            status: $5e19452f9528802f$var$EXITING
        }, function() {
            if (_this3.props.onExiting) _this3.props.onExiting(_this3.node);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $5e19452f9528802f$var$EXITED
                }, function() {
                    if (_this3.props.onExited) _this3.props.onExited(_this3.node);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null && this.nextCallback.cancel) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function() {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback();
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!this.node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) this.props.addEndListener(this.node, this.nextCallback);
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $5e19452f9528802f$var$UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, childProps = $5e19452f9528802f$var$_objectWithoutPropertiesLoose(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return children(status, childProps);
    };
    $5e19452f9528802f$var$_createClass(Transition, [
        {
            key: "node",
            get: function get() {
                var _this$props$nodeRef;
                var node = (_this$props$nodeRef = this.props.nodeRef) === null || _this$props$nodeRef === void 0 ? void 0 : _this$props$nodeRef.current;
                if (!node) throw new Error('notistack - Custom snackbar is not refForwarding');
                return node;
            }
        }
    ]);
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).Component);
function $5e19452f9528802f$var$noop() {}
$5e19452f9528802f$export$be58926105124dd4.defaultProps = {
    "in": false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $5e19452f9528802f$var$noop,
    onEntering: $5e19452f9528802f$var$noop,
    onEntered: $5e19452f9528802f$var$noop,
    onExit: $5e19452f9528802f$var$noop,
    onExiting: $5e19452f9528802f$var$noop,
    onExited: $5e19452f9528802f$var$noop
};
/**
 * Credit to MUI team @ https://mui.com
 */ /**
 * passes {value} to {ref}
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $5e19452f9528802f$var$setRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}
function $5e19452f9528802f$var$useForkRef(refA, refB) {
    /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return (0, $8FY87.useMemo)(function() {
        if (refA == null && refB == null) return null;
        return function(refValue) {
            $5e19452f9528802f$var$setRef(refA, refValue);
            $5e19452f9528802f$var$setRef(refB, refValue);
        };
    }, [
        refA,
        refB
    ]);
}
function $5e19452f9528802f$var$getTransitionProps(props) {
    var timeout = props.timeout, _props$style = props.style, style = _props$style === void 0 ? {} : _props$style, mode = props.mode;
    return {
        duration: typeof timeout === 'object' ? timeout[mode] || 0 : timeout,
        easing: style.transitionTimingFunction,
        delay: style.transitionDelay
    };
}
/**
 * Credit to MUI team @ https://mui.com
 */ var $5e19452f9528802f$var$defaultEasing = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
/**
 * CSS hack to force a repaint
 */ var $5e19452f9528802f$var$reflow = function reflow(node) {
    // We have to do something with node.scrollTop.
    // Otherwise it's removed from the compiled code by optimisers
    // eslint-disable-next-line no-self-assign
    node.scrollTop = node.scrollTop;
};
var $5e19452f9528802f$var$formatMs = function formatMs(milliseconds) {
    return Math.round(milliseconds) + "ms";
};
function $5e19452f9528802f$var$createTransition(props, options) {
    if (props === void 0) props = [
        'all'
    ];
    var _ref = options || {}, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 300 : _ref$duration, _ref$easing = _ref.easing, easing = _ref$easing === void 0 ? $5e19452f9528802f$var$defaultEasing.easeInOut : _ref$easing, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay;
    var properties = Array.isArray(props) ? props : [
        props
    ];
    return properties.map(function(animatedProp) {
        var formattedDuration = typeof duration === 'string' ? duration : $5e19452f9528802f$var$formatMs(duration);
        var formattedDelay = typeof delay === 'string' ? delay : $5e19452f9528802f$var$formatMs(delay);
        return animatedProp + " " + formattedDuration + " " + easing + " " + formattedDelay;
    }).join(',');
}
function $5e19452f9528802f$var$ownerDocument(node) {
    return node && node.ownerDocument || document;
}
function $5e19452f9528802f$var$ownerWindow(node) {
    var doc = $5e19452f9528802f$var$ownerDocument(node);
    return doc.defaultView || window;
}
/**
 * Corresponds to 10 frames at 60 Hz.
 * A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
 */ function $5e19452f9528802f$var$debounce(func, wait) {
    if (wait === void 0) wait = 166;
    var timeout;
    function debounced() {
        var _this = this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var later = function later() {
            // @ts-ignore
            func.apply(_this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = function() {
        clearTimeout(timeout);
    };
    return debounced;
}
/**
 * Translate the node so it can't be seen on the screen.
 * Later, we're going to translate the node back to its original location with `none`.
 */ function $5e19452f9528802f$var$getTranslateValue(direction, node) {
    var rect = node.getBoundingClientRect();
    var containerWindow = $5e19452f9528802f$var$ownerWindow(node);
    var transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        var computedStyle = containerWindow.getComputedStyle(node);
        transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
    }
    var offsetX = 0;
    var offsetY = 0;
    if (transform && transform !== 'none' && typeof transform === 'string') {
        var transformValues = transform.split('(')[1].split(')')[0].split(',');
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    switch(direction){
        case 'left':
            return "translateX(" + (containerWindow.innerWidth + offsetX - rect.left) + "px)";
        case 'right':
            return "translateX(-" + (rect.left + rect.width - offsetX) + "px)";
        case 'up':
            return "translateY(" + (containerWindow.innerHeight + offsetY - rect.top) + "px)";
        default:
            // down
            return "translateY(-" + (rect.top + rect.height - offsetY) + "px)";
    }
}
function $5e19452f9528802f$var$setTranslateValue(direction, node) {
    if (!node) return;
    var transform = $5e19452f9528802f$var$getTranslateValue(direction, node);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
var $5e19452f9528802f$var$Slide = /*#__PURE__*/ (0, $8FY87.forwardRef)(function(props, ref) {
    var children = props.children, _props$direction = props.direction, direction = _props$direction === void 0 ? 'down' : _props$direction, inProp = props["in"], style = props.style, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? 0 : _props$timeout, onEnter = props.onEnter, onEntered = props.onEntered, onExit = props.onExit, onExited = props.onExited, other = $5e19452f9528802f$var$_objectWithoutPropertiesLoose(props, [
        "children",
        "direction",
        "in",
        "style",
        "timeout",
        "onEnter",
        "onEntered",
        "onExit",
        "onExited"
    ]);
    var nodeRef = (0, $8FY87.useRef)(null);
    var handleRefIntermediary = $5e19452f9528802f$var$useForkRef(children.ref, nodeRef);
    var handleRef = $5e19452f9528802f$var$useForkRef(handleRefIntermediary, ref);
    var handleEnter = function handleEnter(node, isAppearing) {
        $5e19452f9528802f$var$setTranslateValue(direction, node);
        $5e19452f9528802f$var$reflow(node);
        if (onEnter) onEnter(node, isAppearing);
    };
    var handleEntering = function handleEntering(node) {
        var easing = (style === null || style === void 0 ? void 0 : style.transitionTimingFunction) || $5e19452f9528802f$var$defaultEasing.easeOut;
        var transitionProps = $5e19452f9528802f$var$getTransitionProps({
            timeout: timeout,
            mode: 'enter',
            style: $5e19452f9528802f$var$_extends({}, style, {
                transitionTimingFunction: easing
            })
        });
        node.style.webkitTransition = $5e19452f9528802f$var$createTransition('-webkit-transform', transitionProps);
        node.style.transition = $5e19452f9528802f$var$createTransition('transform', transitionProps);
        node.style.webkitTransform = 'none';
        node.style.transform = 'none';
    };
    var handleExit = function handleExit(node) {
        var easing = (style === null || style === void 0 ? void 0 : style.transitionTimingFunction) || $5e19452f9528802f$var$defaultEasing.sharp;
        var transitionProps = $5e19452f9528802f$var$getTransitionProps({
            timeout: timeout,
            mode: 'exit',
            style: $5e19452f9528802f$var$_extends({}, style, {
                transitionTimingFunction: easing
            })
        });
        node.style.webkitTransition = $5e19452f9528802f$var$createTransition('-webkit-transform', transitionProps);
        node.style.transition = $5e19452f9528802f$var$createTransition('transform', transitionProps);
        $5e19452f9528802f$var$setTranslateValue(direction, node);
        if (onExit) onExit(node);
    };
    var handleExited = function handleExited(node) {
        // No need for transitions when the component is hidden
        node.style.webkitTransition = '';
        node.style.transition = '';
        if (onExited) onExited(node);
    };
    var updatePosition = (0, $8FY87.useCallback)(function() {
        if (nodeRef.current) $5e19452f9528802f$var$setTranslateValue(direction, nodeRef.current);
    }, [
        direction
    ]);
    (0, $8FY87.useEffect)(function() {
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === 'down' || direction === 'right') return undefined;
        var handleResize = $5e19452f9528802f$var$debounce(function() {
            if (nodeRef.current) $5e19452f9528802f$var$setTranslateValue(direction, nodeRef.current);
        });
        var containerWindow = $5e19452f9528802f$var$ownerWindow(nodeRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return function() {
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        direction,
        inProp
    ]);
    (0, $8FY87.useEffect)(function() {
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return (0, $8FY87.createElement)($5e19452f9528802f$export$be58926105124dd4, Object.assign({
        appear: true,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: onEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        "in": inProp,
        timeout: timeout
    }, other), function(state, childProps) {
        return (0, $8FY87.cloneElement)(children, $5e19452f9528802f$var$_extends({
            ref: handleRef,
            style: $5e19452f9528802f$var$_extends({
                visibility: state === 'exited' && !inProp ? 'hidden' : undefined
            }, style, {}, children.props.style)
        }, childProps));
    });
});
$5e19452f9528802f$var$Slide.displayName = 'Slide';
var $5e19452f9528802f$var$SvgIcon = function SvgIcon(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("svg", Object.assign({
        viewBox: "0 0 24 24",
        focusable: "false",
        style: {
            fontSize: 20,
            marginInlineEnd: 8,
            userSelect: 'none',
            width: '1em',
            height: '1em',
            display: 'inline-block',
            fill: 'currentColor',
            flexShrink: 0
        }
    }, props));
};
var $5e19452f9528802f$var$CheckIcon = function CheckIcon() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement($5e19452f9528802f$var$SvgIcon, null, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("path", {
        d: "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41\n        10.59L10 14.17L17.59 6.58L19 8L10 17Z"
    }));
};
var $5e19452f9528802f$var$WarningIcon = function WarningIcon() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement($5e19452f9528802f$var$SvgIcon, null, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("path", {
        d: "M13,14H11V10H13M13,18H11V16H13M1,21H23L12,2L1,21Z"
    }));
};
var $5e19452f9528802f$var$ErrorIcon = function ErrorIcon() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement($5e19452f9528802f$var$SvgIcon, null, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("path", {
        d: "M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,\n        6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,\n        13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z"
    }));
};
var $5e19452f9528802f$var$InfoIcon = function InfoIcon() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement($5e19452f9528802f$var$SvgIcon, null, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("path", {
        d: "M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,\n        0 22,12A10,10 0 0,0 12,2Z"
    }));
};
var $5e19452f9528802f$var$defaultIconVariants = {
    "default": undefined,
    success: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement($5e19452f9528802f$var$CheckIcon, null),
    warning: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement($5e19452f9528802f$var$WarningIcon, null),
    error: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement($5e19452f9528802f$var$ErrorIcon, null),
    info: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement($5e19452f9528802f$var$InfoIcon, null)
};
var $5e19452f9528802f$var$defaults = {
    maxSnack: 3,
    persist: false,
    hideIconVariant: false,
    disableWindowBlurListener: false,
    variant: 'default',
    autoHideDuration: 5000,
    iconVariant: $5e19452f9528802f$var$defaultIconVariants,
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
    },
    TransitionComponent: $5e19452f9528802f$var$Slide,
    transitionDuration: {
        enter: 225,
        exit: 195
    }
};
/**
 * Derives the right autoHideDuration taking into account the following
 * prority order: 1: Options, 2: Props, 3: default fallback
 */ var $5e19452f9528802f$var$getAutoHideDuration = function getAutoHideDuration(optionsDuration, propsDuration) {
    var isNumberOrNull = function isNumberOrNull(numberish) {
        return typeof numberish === 'number' || numberish === null;
    };
    if (isNumberOrNull(optionsDuration)) return optionsDuration;
    if (isNumberOrNull(propsDuration)) return propsDuration;
    return $5e19452f9528802f$var$defaults.autoHideDuration;
};
/**
 * Derives the right transitionDuration taking into account the following
 * prority order: 1: Options, 2: Props, 3: default fallback
 */ var $5e19452f9528802f$var$getTransitionDuration = function getTransitionDuration(optionsDuration, propsDuration) {
    var is = function is(item, types) {
        return types.some(function(t) {
            return typeof item === t;
        });
    };
    if (is(optionsDuration, [
        'string',
        'number'
    ])) return optionsDuration;
    if (is(optionsDuration, [
        'object'
    ])) return $5e19452f9528802f$var$_extends({}, $5e19452f9528802f$var$defaults.transitionDuration, {}, is(propsDuration, [
        'object'
    ]) && propsDuration, {}, optionsDuration);
    if (is(propsDuration, [
        'string',
        'number'
    ])) return propsDuration;
    if (is(propsDuration, [
        'object'
    ])) return $5e19452f9528802f$var$_extends({}, $5e19452f9528802f$var$defaults.transitionDuration, {}, propsDuration);
    return $5e19452f9528802f$var$defaults.transitionDuration;
};
var $5e19452f9528802f$var$merge = function merge(options, props) {
    return function(name, shouldObjectMerge) {
        if (shouldObjectMerge === void 0) shouldObjectMerge = false;
        if (shouldObjectMerge) return $5e19452f9528802f$var$_extends({}, $5e19452f9528802f$var$defaults[name], {}, props[name], {}, options[name]);
        if (name === 'autoHideDuration') return $5e19452f9528802f$var$getAutoHideDuration(options.autoHideDuration, props.autoHideDuration);
        if (name === 'transitionDuration') return $5e19452f9528802f$var$getTransitionDuration(options.transitionDuration, props.transitionDuration);
        return options[name] || props[name] || $5e19452f9528802f$var$defaults[name];
    };
};
function $5e19452f9528802f$var$makeStyles(styles) {
    return Object.entries(styles).reduce(function(acc, _ref) {
        var _extends2;
        var key = _ref[0], value = _ref[1];
        return $5e19452f9528802f$var$_extends({}, acc, (_extends2 = {}, _extends2[key] = (0, $d29d2f64505cf8b8$export$dbf350e5966cf602)(value), _extends2));
    }, {});
}
var $5e19452f9528802f$var$ComponentClasses = {
    SnackbarContainer: 'notistack-SnackbarContainer',
    Snackbar: 'notistack-Snackbar',
    CollapseWrapper: 'notistack-CollapseWrapper',
    MuiContent: 'notistack-MuiContent',
    MuiContentVariant: function MuiContentVariant(variant) {
        return "notistack-MuiContent-" + variant;
    }
};
var $5e19452f9528802f$var$classes = /*#__PURE__*/ $5e19452f9528802f$var$makeStyles({
    root: {
        height: 0
    },
    entered: {
        height: 'auto'
    }
});
var $5e19452f9528802f$var$collapsedSize = '0px';
var $5e19452f9528802f$var$timeout = 175;
var $5e19452f9528802f$var$Collapse = /*#__PURE__*/ (0, $8FY87.forwardRef)(function(props, ref) {
    var children = props.children, inProp = props["in"], onExited = props.onExited;
    var wrapperRef = (0, $8FY87.useRef)(null);
    var nodeRef = (0, $8FY87.useRef)(null);
    var handleRef = $5e19452f9528802f$var$useForkRef(ref, nodeRef);
    var getWrapperSize = function getWrapperSize() {
        return wrapperRef.current ? wrapperRef.current.clientHeight : 0;
    };
    var handleEnter = function handleEnter(node) {
        node.style.height = $5e19452f9528802f$var$collapsedSize;
    };
    var handleEntering = function handleEntering(node) {
        var wrapperSize = getWrapperSize();
        var _getTransitionProps = $5e19452f9528802f$var$getTransitionProps({
            timeout: $5e19452f9528802f$var$timeout,
            mode: 'enter'
        }), transitionDuration = _getTransitionProps.duration, easing = _getTransitionProps.easing;
        node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : transitionDuration + "ms";
        node.style.height = wrapperSize + "px";
        node.style.transitionTimingFunction = easing || '';
    };
    var handleEntered = function handleEntered(node) {
        node.style.height = 'auto';
    };
    var handleExit = function handleExit(node) {
        node.style.height = getWrapperSize() + "px";
    };
    var handleExiting = function handleExiting(node) {
        $5e19452f9528802f$var$reflow(node);
        var _getTransitionProps2 = $5e19452f9528802f$var$getTransitionProps({
            timeout: $5e19452f9528802f$var$timeout,
            mode: 'exit'
        }), transitionDuration = _getTransitionProps2.duration, easing = _getTransitionProps2.easing;
        node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : transitionDuration + "ms";
        node.style.height = $5e19452f9528802f$var$collapsedSize;
        node.style.transitionTimingFunction = easing || '';
    };
    return (0, $8FY87.createElement)($5e19452f9528802f$export$be58926105124dd4, {
        "in": inProp,
        unmountOnExit: true,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: onExited,
        onExiting: handleExiting,
        nodeRef: nodeRef,
        timeout: $5e19452f9528802f$var$timeout
    }, function(state, childProps) {
        return (0, $8FY87.createElement)("div", Object.assign({
            ref: handleRef,
            className: (0, $68aee9bbbc0e9b6d$export$2e2bcd8739ae039)($5e19452f9528802f$var$classes.root, state === 'entered' && $5e19452f9528802f$var$classes.entered),
            style: $5e19452f9528802f$var$_extends({
                pointerEvents: 'all',
                overflow: 'hidden',
                minHeight: $5e19452f9528802f$var$collapsedSize,
                transition: $5e19452f9528802f$var$createTransition('height')
            }, state === 'entered' && {
                overflow: 'visible'
            }, {}, state === 'exited' && !inProp && {
                visibility: 'hidden'
            })
        }, childProps), (0, $8FY87.createElement)("div", {
            ref: wrapperRef,
            className: $5e19452f9528802f$var$ComponentClasses.CollapseWrapper,
            // Hack to get children with a negative margin to not falsify the height computation.
            style: {
                display: 'flex',
                width: '100%'
            }
        }, children));
    });
});
$5e19452f9528802f$var$Collapse.displayName = 'Collapse';
var $5e19452f9528802f$var$direction = {
    right: 'left',
    left: 'right',
    bottom: 'up',
    top: 'down'
};
var $5e19452f9528802f$var$getSlideDirection = function getSlideDirection(anchorOrigin) {
    if (anchorOrigin.horizontal !== 'center') return $5e19452f9528802f$var$direction[anchorOrigin.horizontal];
    return $5e19452f9528802f$var$direction[anchorOrigin.vertical];
};
/** Tranforms classes name */ var $5e19452f9528802f$var$toSnackbarAnchorOrigin = function toSnackbarAnchorOrigin(anchorOrigin) {
    return "anchorOrigin" + $5e19452f9528802f$var$originKeyExtractor(anchorOrigin);
};
/**
 * Omit SnackbarContainer class keys that are not needed for SnackbarItem
 */ var $5e19452f9528802f$var$keepSnackbarClassKeys = function keepSnackbarClassKeys(classes) {
    if (classes === void 0) classes = {};
    var containerClasses = {
        containerRoot: true,
        containerAnchorOriginTopCenter: true,
        containerAnchorOriginBottomCenter: true,
        containerAnchorOriginTopRight: true,
        containerAnchorOriginBottomRight: true,
        containerAnchorOriginTopLeft: true,
        containerAnchorOriginBottomLeft: true
    };
    return Object.keys(classes).filter(function(key) {
        return !containerClasses[key];
    }).reduce(function(obj, key) {
        var _extends2;
        return $5e19452f9528802f$var$_extends({}, obj, (_extends2 = {}, _extends2[key] = classes[key], _extends2));
    }, {});
};
var $5e19452f9528802f$var$noOp$1 = function noOp() {
/* */ };
/**
 * Credit to MUI team @ https://mui.com
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $5e19452f9528802f$var$createChainedFunction(funcs, snackbarId) {
    // @ts-ignore
    return funcs.reduce(function(acc, func) {
        if (func === null || func === undefined) return acc;
        return function chainedFunction() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var argums = [].concat(args);
            if (snackbarId && argums.indexOf(snackbarId) === -1) argums.push(snackbarId);
             // @ts-ignore
            acc.apply(this, argums);
            func.apply(this, argums);
        };
    }, $5e19452f9528802f$var$noOp$1);
}
/**
 * Credit to MUI team @ https://mui.com
 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
 */ var $5e19452f9528802f$var$useEnhancedEffect = typeof window !== 'undefined' ? (0, $8FY87.useLayoutEffect) : (0, $8FY87.useEffect);
function $5e19452f9528802f$var$useEventCallback(fn) {
    var ref = (0, $8FY87.useRef)(fn);
    $5e19452f9528802f$var$useEnhancedEffect(function() {
        ref.current = fn;
    });
    return (0, $8FY87.useCallback)(function() {
        return ref.current.apply(void 0, arguments);
    }, []);
}
/**
 * Credit to MUI team @ https://mui.com
 */ var $5e19452f9528802f$var$Snackbar = /*#__PURE__*/ (0, $8FY87.forwardRef)(function(props, ref) {
    var children = props.children, className = props.className, autoHideDuration = props.autoHideDuration, _props$disableWindowB = props.disableWindowBlurListener, disableWindowBlurListener = _props$disableWindowB === void 0 ? false : _props$disableWindowB, onClose = props.onClose, id = props.id, open = props.open, _props$SnackbarProps = props.SnackbarProps, SnackbarProps = _props$SnackbarProps === void 0 ? {} : _props$SnackbarProps;
    var timerAutoHide = (0, $8FY87.useRef)();
    var handleClose = $5e19452f9528802f$var$useEventCallback(function() {
        if (onClose) onClose.apply(void 0, arguments);
    });
    var setAutoHideTimer = $5e19452f9528802f$var$useEventCallback(function(autoHideDurationParam) {
        if (!onClose || autoHideDurationParam == null) return;
        if (timerAutoHide.current) clearTimeout(timerAutoHide.current);
        timerAutoHide.current = setTimeout(function() {
            handleClose(null, 'timeout', id);
        }, autoHideDurationParam);
    });
    (0, $8FY87.useEffect)(function() {
        if (open) setAutoHideTimer(autoHideDuration);
        return function() {
            if (timerAutoHide.current) clearTimeout(timerAutoHide.current);
        };
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer
    ]);
    /**
   * Pause the timer when the user is interacting with the Snackbar
   * or when the user hide the window.
   */ var handlePause = function handlePause() {
        if (timerAutoHide.current) clearTimeout(timerAutoHide.current);
    };
    /**
   * Restart the timer when the user is no longer interacting with the Snackbar
   * or when the window is shown back.
   */ var handleResume = (0, $8FY87.useCallback)(function() {
        if (autoHideDuration != null) setAutoHideTimer(autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        setAutoHideTimer
    ]);
    var handleMouseEnter = function handleMouseEnter(event) {
        if (SnackbarProps.onMouseEnter) SnackbarProps.onMouseEnter(event);
        handlePause();
    };
    var handleMouseLeave = function handleMouseLeave(event) {
        if (SnackbarProps.onMouseLeave) SnackbarProps.onMouseLeave(event);
        handleResume();
    };
    (0, $8FY87.useEffect)(function() {
        if (!disableWindowBlurListener && open) {
            window.addEventListener('focus', handleResume);
            window.addEventListener('blur', handlePause);
            return function() {
                window.removeEventListener('focus', handleResume);
                window.removeEventListener('blur', handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        handleResume,
        open
    ]);
    return (0, $8FY87.createElement)("div", Object.assign({
        ref: ref
    }, SnackbarProps, {
        className: (0, $68aee9bbbc0e9b6d$export$2e2bcd8739ae039)($5e19452f9528802f$var$ComponentClasses.Snackbar, className),
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave
    }), children);
});
$5e19452f9528802f$var$Snackbar.displayName = 'Snackbar';
var $5e19452f9528802f$var$_root;
var $5e19452f9528802f$var$classes$1 = /*#__PURE__*/ $5e19452f9528802f$var$makeStyles({
    root: ($5e19452f9528802f$var$_root = {
        display: 'flex',
        flexWrap: 'wrap',
        flexGrow: 1
    }, $5e19452f9528802f$var$_root[$5e19452f9528802f$var$breakpoints.upSm] = {
        flexGrow: 'initial',
        minWidth: '288px'
    }, $5e19452f9528802f$var$_root)
});
var $5e19452f9528802f$export$860cef82710cac7 = /*#__PURE__*/ (0, $8FY87.forwardRef)(function(_ref, ref) {
    var className = _ref.className, props = $5e19452f9528802f$var$_objectWithoutPropertiesLoose(_ref, [
        "className"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", Object.assign({
        ref: ref,
        className: (0, $68aee9bbbc0e9b6d$export$2e2bcd8739ae039)($5e19452f9528802f$var$classes$1.root, className)
    }, props));
});
$5e19452f9528802f$export$860cef82710cac7.displayName = 'SnackbarContent';
var $5e19452f9528802f$var$classes$2 = /*#__PURE__*/ $5e19452f9528802f$var$makeStyles({
    root: {
        backgroundColor: '#313131',
        fontSize: '0.875rem',
        lineHeight: 1.43,
        letterSpacing: '0.01071em',
        color: '#fff',
        alignItems: 'center',
        padding: '6px 16px',
        borderRadius: '4px',
        boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)'
    },
    lessPadding: {
        paddingLeft: "20px"
    },
    "default": {
        backgroundColor: '#313131'
    },
    success: {
        backgroundColor: '#43a047'
    },
    error: {
        backgroundColor: '#d32f2f'
    },
    warning: {
        backgroundColor: '#ff9800'
    },
    info: {
        backgroundColor: '#2196f3'
    },
    message: {
        display: 'flex',
        alignItems: 'center',
        padding: '8px 0'
    },
    action: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 'auto',
        paddingLeft: '16px',
        marginRight: '-8px'
    }
});
var $5e19452f9528802f$var$ariaDescribedby = 'notistack-snackbar';
var $5e19452f9528802f$var$MaterialDesignContent = /*#__PURE__*/ (0, $8FY87.forwardRef)(function(props, forwardedRef) {
    var id = props.id, message = props.message, componentOrFunctionAction = props.action, iconVariant = props.iconVariant, variant = props.variant, hideIconVariant = props.hideIconVariant, style = props.style, className = props.className;
    var icon = iconVariant[variant];
    var action = componentOrFunctionAction;
    if (typeof action === 'function') action = action(id);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement($5e19452f9528802f$export$860cef82710cac7, {
        ref: forwardedRef,
        role: "alert",
        "aria-describedby": $5e19452f9528802f$var$ariaDescribedby,
        style: style,
        className: (0, $68aee9bbbc0e9b6d$export$2e2bcd8739ae039)($5e19452f9528802f$var$ComponentClasses.MuiContent, $5e19452f9528802f$var$ComponentClasses.MuiContentVariant(variant), $5e19452f9528802f$var$classes$2.root, $5e19452f9528802f$var$classes$2[variant], className, !hideIconVariant && icon && $5e19452f9528802f$var$classes$2.lessPadding)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        id: $5e19452f9528802f$var$ariaDescribedby,
        className: $5e19452f9528802f$var$classes$2.message
    }, !hideIconVariant ? icon : null, message), action && (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: $5e19452f9528802f$var$classes$2.action
    }, action));
});
$5e19452f9528802f$var$MaterialDesignContent.displayName = 'MaterialDesignContent';
var $5e19452f9528802f$export$407b0b907b65dfeb = /*#__PURE__*/ (0, $8FY87.memo)($5e19452f9528802f$var$MaterialDesignContent);
var $5e19452f9528802f$var$styles = /*#__PURE__*/ $5e19452f9528802f$var$makeStyles({
    wrappedRoot: {
        width: '100%',
        position: 'relative',
        transform: 'translateX(0)',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        minWidth: '288px'
    }
});
var $5e19452f9528802f$var$SnackbarItem = function SnackbarItem(props) {
    var timeout = (0, $8FY87.useRef)();
    var _useState = (0, $8FY87.useState)(true), collapsed = _useState[0], setCollapsed = _useState[1];
    var handleClose = $5e19452f9528802f$var$createChainedFunction([
        props.snack.onClose,
        props.onClose
    ]);
    var handleEntered = function handleEntered() {
        if (props.snack.requestClose) handleClose(null, 'instructed', props.snack.id);
    };
    var handleExitedScreen = (0, $8FY87.useCallback)(function() {
        timeout.current = setTimeout(function() {
            setCollapsed(function(col) {
                return !col;
            });
        }, 125);
    }, []);
    (0, $8FY87.useEffect)(function() {
        return function() {
            if (timeout.current) clearTimeout(timeout.current);
        };
    }, []);
    var snack = props.snack, allClasses = props.classes, _props$Component = props.Component, Component = _props$Component === void 0 ? $5e19452f9528802f$export$407b0b907b65dfeb : _props$Component;
    var classes = (0, $8FY87.useMemo)(function() {
        return $5e19452f9528802f$var$keepSnackbarClassKeys(allClasses);
    }, [
        allClasses
    ]);
    var open = snack.open, SnackbarProps = snack.SnackbarProps, TransitionComponent = snack.TransitionComponent, TransitionProps = snack.TransitionProps, transitionDuration = snack.transitionDuration, disableWindowBlurListener = snack.disableWindowBlurListener, componentOrFunctionContent = snack.content, otherSnack = $5e19452f9528802f$var$_objectWithoutPropertiesLoose(snack, [
        "open",
        "SnackbarProps",
        "TransitionComponent",
        "TransitionProps",
        "transitionDuration",
        "disableWindowBlurListener",
        "content",
        "entered",
        "requestClose",
        "onEnter",
        "onEntered",
        "onExit",
        "onExited"
    ]);
    var transitionProps = $5e19452f9528802f$var$_extends({
        direction: $5e19452f9528802f$var$getSlideDirection(otherSnack.anchorOrigin),
        timeout: transitionDuration
    }, TransitionProps);
    var content = componentOrFunctionContent;
    if (typeof content === 'function') content = content(otherSnack.id, otherSnack.message);
    var callbacks = [
        'onEnter',
        'onEntered',
        'onExit',
        'onExited'
    ].reduce(function(acc, cbName) {
        var _extends2;
        return $5e19452f9528802f$var$_extends({}, acc, (_extends2 = {}, _extends2[cbName] = $5e19452f9528802f$var$createChainedFunction([
            props.snack[cbName],
            props[cbName]
        ], otherSnack.id), _extends2));
    }, {});
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement($5e19452f9528802f$var$Collapse, {
        "in": collapsed,
        onExited: callbacks.onExited
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement($5e19452f9528802f$var$Snackbar, {
        open: open,
        id: otherSnack.id,
        disableWindowBlurListener: disableWindowBlurListener,
        autoHideDuration: otherSnack.autoHideDuration,
        className: (0, $68aee9bbbc0e9b6d$export$2e2bcd8739ae039)($5e19452f9528802f$var$styles.wrappedRoot, classes.root, classes[$5e19452f9528802f$var$toSnackbarAnchorOrigin(otherSnack.anchorOrigin)]),
        SnackbarProps: SnackbarProps,
        onClose: handleClose
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement(TransitionComponent, Object.assign({}, transitionProps, {
        appear: true,
        "in": open,
        onExit: callbacks.onExit,
        onExited: handleExitedScreen,
        onEnter: callbacks.onEnter,
        // order matters. first callbacks.onEntered to set entered: true,
        // then handleEntered to check if there's a request for closing
        onEntered: $5e19452f9528802f$var$createChainedFunction([
            callbacks.onEntered,
            handleEntered
        ], otherSnack.id)
    }), content || (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement(Component, Object.assign({}, otherSnack)))));
};
var $5e19452f9528802f$var$_root$1, $5e19452f9528802f$var$_rootDense, $5e19452f9528802f$var$_left, $5e19452f9528802f$var$_right, $5e19452f9528802f$var$_center;
var $5e19452f9528802f$var$indents = {
    view: {
        "default": 20,
        dense: 4
    },
    snackbar: {
        "default": 6,
        dense: 2
    }
};
var $5e19452f9528802f$var$collapseWrapper = "." + $5e19452f9528802f$var$ComponentClasses.CollapseWrapper;
var $5e19452f9528802f$var$xsWidthMargin = 16;
var $5e19452f9528802f$var$styles$1 = /*#__PURE__*/ $5e19452f9528802f$var$makeStyles({
    root: ($5e19452f9528802f$var$_root$1 = {
        boxSizing: 'border-box',
        display: 'flex',
        maxHeight: '100%',
        position: 'fixed',
        zIndex: 1400,
        height: 'auto',
        width: 'auto',
        transition: /*#__PURE__*/ $5e19452f9528802f$var$createTransition([
            'top',
            'right',
            'bottom',
            'left',
            'max-width'
        ], {
            duration: 300,
            easing: 'ease'
        }),
        // container itself is invisible and should not block clicks, clicks should be passed to its children
        // a pointerEvents: all is applied in the collapse component
        pointerEvents: 'none'
    }, $5e19452f9528802f$var$_root$1[$5e19452f9528802f$var$collapseWrapper] = {
        padding: $5e19452f9528802f$var$indents.snackbar["default"] + "px 0px",
        transition: 'padding 300ms ease 0ms'
    }, $5e19452f9528802f$var$_root$1.maxWidth = "calc(100% - " + $5e19452f9528802f$var$indents.view["default"] * 2 + "px)", $5e19452f9528802f$var$_root$1[$5e19452f9528802f$var$breakpoints.downXs] = {
        width: '100%',
        maxWidth: "calc(100% - " + $5e19452f9528802f$var$xsWidthMargin * 2 + "px)"
    }, $5e19452f9528802f$var$_root$1),
    rootDense: ($5e19452f9528802f$var$_rootDense = {}, $5e19452f9528802f$var$_rootDense[$5e19452f9528802f$var$collapseWrapper] = {
        padding: $5e19452f9528802f$var$indents.snackbar.dense + "px 0px"
    }, $5e19452f9528802f$var$_rootDense),
    top: {
        top: $5e19452f9528802f$var$indents.view["default"] - $5e19452f9528802f$var$indents.snackbar["default"] + "px",
        flexDirection: 'column'
    },
    bottom: {
        bottom: $5e19452f9528802f$var$indents.view["default"] - $5e19452f9528802f$var$indents.snackbar["default"] + "px",
        flexDirection: 'column-reverse'
    },
    left: ($5e19452f9528802f$var$_left = {
        left: $5e19452f9528802f$var$indents.view["default"] + "px"
    }, $5e19452f9528802f$var$_left[$5e19452f9528802f$var$breakpoints.upSm] = {
        alignItems: 'flex-start'
    }, $5e19452f9528802f$var$_left[$5e19452f9528802f$var$breakpoints.downXs] = {
        left: $5e19452f9528802f$var$xsWidthMargin + "px"
    }, $5e19452f9528802f$var$_left),
    right: ($5e19452f9528802f$var$_right = {
        right: $5e19452f9528802f$var$indents.view["default"] + "px"
    }, $5e19452f9528802f$var$_right[$5e19452f9528802f$var$breakpoints.upSm] = {
        alignItems: 'flex-end'
    }, $5e19452f9528802f$var$_right[$5e19452f9528802f$var$breakpoints.downXs] = {
        right: $5e19452f9528802f$var$xsWidthMargin + "px"
    }, $5e19452f9528802f$var$_right),
    center: ($5e19452f9528802f$var$_center = {
        left: '50%',
        transform: 'translateX(-50%)'
    }, $5e19452f9528802f$var$_center[$5e19452f9528802f$var$breakpoints.upSm] = {
        alignItems: 'center'
    }, $5e19452f9528802f$var$_center)
});
var $5e19452f9528802f$var$SnackbarContainer = function SnackbarContainer(props) {
    var _props$classes = props.classes, classes = _props$classes === void 0 ? {} : _props$classes, anchorOrigin = props.anchorOrigin, dense = props.dense, children = props.children;
    var combinedClassname = (0, $68aee9bbbc0e9b6d$export$2e2bcd8739ae039)($5e19452f9528802f$var$ComponentClasses.SnackbarContainer, $5e19452f9528802f$var$styles$1[anchorOrigin.vertical], $5e19452f9528802f$var$styles$1[anchorOrigin.horizontal], $5e19452f9528802f$var$styles$1.root, classes.containerRoot, classes["containerAnchorOrigin" + $5e19452f9528802f$var$originKeyExtractor(anchorOrigin)], dense && $5e19452f9528802f$var$styles$1.rootDense);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: combinedClassname
    }, children);
};
var $5e19452f9528802f$var$SnackbarContainer$1 = /*#__PURE__*/ (0, $8FY87.memo)($5e19452f9528802f$var$SnackbarContainer);
/* eslint-disable */ var $5e19452f9528802f$var$__DEV__ = false;
var $5e19452f9528802f$var$messages = {
    NO_PERSIST_ALL: "Reached maxSnack while all enqueued snackbars have 'persist' flag. Notistack will dismiss the oldest snackbar anyway to allow other ones in the queue to be presented."
};
var $5e19452f9528802f$var$warning = function(messageKey) {
    if (!$5e19452f9528802f$var$__DEV__) return;
    var message = $5e19452f9528802f$var$messages[messageKey];
    if (typeof console !== 'undefined') console.error("WARNING - notistack: " + message);
    try {
        throw new Error(message);
    } catch (x) {}
};
var $5e19452f9528802f$var$isOptions = function isOptions(messageOrOptions) {
    var isMessage = typeof messageOrOptions === 'string' || (0, $8FY87.isValidElement)(messageOrOptions);
    return !isMessage;
};
var $5e19452f9528802f$export$9d70c354f0150b1b;
var $5e19452f9528802f$export$823cdc5238933767;
var $5e19452f9528802f$export$d1e619fddc3508ce = /*#__PURE__*/ function(_Component) {
    $5e19452f9528802f$var$_inheritsLoose(SnackbarProvider, _Component);
    function SnackbarProvider(props) {
        var _this;
        _this = _Component.call(this, props) || this;
        /**
     * Adds a new snackbar to the queue to be presented.
     * Returns generated or user defined key referencing the new snackbar or null
     */ _this.enqueueSnackbar = function(messageOrOptions, optsOrUndefined) {
            if (optsOrUndefined === void 0) optsOrUndefined = {};
            if (messageOrOptions === undefined || messageOrOptions === null) throw new Error('enqueueSnackbar called with invalid argument');
            var opts = $5e19452f9528802f$var$isOptions(messageOrOptions) ? messageOrOptions : optsOrUndefined;
            var message = $5e19452f9528802f$var$isOptions(messageOrOptions) ? messageOrOptions.message : messageOrOptions;
            var key = opts.key, preventDuplicate = opts.preventDuplicate, options = $5e19452f9528802f$var$_objectWithoutPropertiesLoose(opts, [
                "key",
                "preventDuplicate"
            ]);
            var hasSpecifiedKey = $5e19452f9528802f$var$isDefined(key);
            var id = hasSpecifiedKey ? key : new Date().getTime() + Math.random();
            var merger = $5e19452f9528802f$var$merge(options, _this.props);
            var snack = $5e19452f9528802f$var$_extends({
                id: id
            }, options, {
                message: message,
                open: true,
                entered: false,
                requestClose: false,
                persist: merger('persist'),
                action: merger('action'),
                content: merger('content'),
                variant: merger('variant'),
                anchorOrigin: merger('anchorOrigin'),
                disableWindowBlurListener: merger('disableWindowBlurListener'),
                autoHideDuration: merger('autoHideDuration'),
                hideIconVariant: merger('hideIconVariant'),
                TransitionComponent: merger('TransitionComponent'),
                transitionDuration: merger('transitionDuration'),
                TransitionProps: merger('TransitionProps', true),
                iconVariant: merger('iconVariant', true),
                style: merger('style', true),
                SnackbarProps: merger('SnackbarProps', true),
                className: (0, $68aee9bbbc0e9b6d$export$2e2bcd8739ae039)(_this.props.className, options.className)
            });
            if (snack.persist) snack.autoHideDuration = undefined;
            _this.setState(function(state) {
                if (preventDuplicate === undefined && _this.props.preventDuplicate || preventDuplicate) {
                    var compareFunction = function compareFunction(item) {
                        return hasSpecifiedKey ? item.id === id : item.message === message;
                    };
                    var inQueue = state.queue.findIndex(compareFunction) > -1;
                    var inView = state.snacks.findIndex(compareFunction) > -1;
                    if (inQueue || inView) return state;
                }
                return _this.handleDisplaySnack($5e19452f9528802f$var$_extends({}, state, {
                    queue: [].concat(state.queue, [
                        snack
                    ])
                }));
            });
            return id;
        };
        /**
     * Reducer: Display snack if there's space for it. Otherwise, immediately
     * begin dismissing the oldest message to start showing the new one.
     */ _this.handleDisplaySnack = function(state) {
            var snacks = state.snacks;
            if (snacks.length >= _this.maxSnack) return _this.handleDismissOldest(state);
            return _this.processQueue(state);
        };
        /**
     * Reducer: Display items (notifications) in the queue if there's space for them.
     */ _this.processQueue = function(state) {
            var queue = state.queue, snacks = state.snacks;
            if (queue.length > 0) return $5e19452f9528802f$var$_extends({}, state, {
                snacks: [].concat(snacks, [
                    queue[0]
                ]),
                queue: queue.slice(1, queue.length)
            });
            return state;
        };
        /**
     * Reducer: Hide oldest snackbar on the screen because there exists a new one which we have to display.
     * (ignoring the one with 'persist' flag. i.e. explicitly told by user not to get dismissed).
     *
     * Note 1: If there is already a message leaving the screen, no new messages are dismissed.
     * Note 2: If the oldest message has not yet entered the screen, only a request to close the
     *         snackbar is made. Once it entered the screen, it will be immediately dismissed.
     */ _this.handleDismissOldest = function(state) {
            if (state.snacks.some(function(item) {
                return !item.open || item.requestClose;
            })) return state;
            var popped = false;
            var ignore = false;
            var persistentCount = state.snacks.reduce(function(acc, current) {
                return acc + (current.open && current.persist ? 1 : 0);
            }, 0);
            if (persistentCount === _this.maxSnack) ignore = true;
            var snacks = state.snacks.map(function(item) {
                if (!popped && (!item.persist || ignore)) {
                    popped = true;
                    if (!item.entered) return $5e19452f9528802f$var$_extends({}, item, {
                        requestClose: true
                    });
                    if (item.onClose) item.onClose(null, 'maxsnack', item.id);
                    if (_this.props.onClose) _this.props.onClose(null, 'maxsnack', item.id);
                    return $5e19452f9528802f$var$_extends({}, item, {
                        open: false
                    });
                }
                return $5e19452f9528802f$var$_extends({}, item);
            });
            return $5e19452f9528802f$var$_extends({}, state, {
                snacks: snacks
            });
        };
        /**
     * Set the entered state of the snackbar with the given key.
     */ _this.handleEnteredSnack = function(node, isAppearing, key) {
            if (!$5e19452f9528802f$var$isDefined(key)) throw new Error('handleEnteredSnack Cannot be called with undefined key');
            _this.setState(function(_ref) {
                var snacks = _ref.snacks;
                return {
                    snacks: snacks.map(function(item) {
                        return item.id === key ? $5e19452f9528802f$var$_extends({}, item, {
                            entered: true
                        }) : $5e19452f9528802f$var$_extends({}, item);
                    })
                };
            });
        };
        /**
     * Hide a snackbar after its timeout.
     */ _this.handleCloseSnack = function(event, reason, key) {
            // should not use createChainedFunction for onClose.
            // because this.closeSnackbar called this function
            if (_this.props.onClose) _this.props.onClose(event, reason, key);
            var shouldCloseAll = key === undefined;
            _this.setState(function(_ref2) {
                var snacks = _ref2.snacks, queue = _ref2.queue;
                return {
                    snacks: snacks.map(function(item) {
                        if (!shouldCloseAll && item.id !== key) return $5e19452f9528802f$var$_extends({}, item);
                        return item.entered ? $5e19452f9528802f$var$_extends({}, item, {
                            open: false
                        }) : $5e19452f9528802f$var$_extends({}, item, {
                            requestClose: true
                        });
                    }),
                    queue: queue.filter(function(item) {
                        return item.id !== key;
                    })
                };
            });
        };
        /**
     * Close snackbar with the given key
     */ _this.closeSnackbar = function(key) {
            // call individual snackbar onClose callback passed through options parameter
            var toBeClosed = _this.state.snacks.find(function(item) {
                return item.id === key;
            });
            if ($5e19452f9528802f$var$isDefined(key) && toBeClosed && toBeClosed.onClose) toBeClosed.onClose(null, 'instructed', key);
            _this.handleCloseSnack(null, 'instructed', key);
        };
        /**
     * When we set open attribute of a snackbar to false (i.e. after we hide a snackbar),
     * it leaves the screen and immediately after leaving animation is done, this method
     * gets called. We remove the hidden snackbar from state and then display notifications
     * waiting in the queue (if any). If after this process the queue is not empty, the
     * oldest message is dismissed.
     */ _this.handleExitedSnack = function(node, key) {
            if (!$5e19452f9528802f$var$isDefined(key)) throw new Error('handleExitedSnack Cannot be called with undefined key');
            _this.setState(function(state) {
                var newState = _this.processQueue($5e19452f9528802f$var$_extends({}, state, {
                    snacks: state.snacks.filter(function(item) {
                        return item.id !== key;
                    })
                }));
                if (newState.queue.length === 0) return newState;
                return _this.handleDismissOldest(newState);
            });
        };
        $5e19452f9528802f$export$9d70c354f0150b1b = _this.enqueueSnackbar;
        $5e19452f9528802f$export$823cdc5238933767 = _this.closeSnackbar;
        _this.state = {
            snacks: [],
            queue: [],
            contextValue: {
                enqueueSnackbar: _this.enqueueSnackbar.bind($5e19452f9528802f$var$_assertThisInitialized(_this)),
                closeSnackbar: _this.closeSnackbar.bind($5e19452f9528802f$var$_assertThisInitialized(_this))
            }
        };
        return _this;
    }
    var _proto = SnackbarProvider.prototype;
    _proto.render = function render() {
        var _this2 = this;
        var contextValue = this.state.contextValue;
        var _this$props = this.props, domRoot = _this$props.domRoot, children = _this$props.children, _this$props$dense = _this$props.dense, dense = _this$props$dense === void 0 ? false : _this$props$dense, _this$props$Component = _this$props.Components, Components = _this$props$Component === void 0 ? {} : _this$props$Component, classes = _this$props.classes;
        var categ = this.state.snacks.reduce(function(acc, current) {
            var _extends2;
            var category = $5e19452f9528802f$var$originKeyExtractor(current.anchorOrigin);
            var existingOfCategory = acc[category] || [];
            return $5e19452f9528802f$var$_extends({}, acc, (_extends2 = {}, _extends2[category] = [].concat(existingOfCategory, [
                current
            ]), _extends2));
        }, {});
        var snackbars = Object.keys(categ).map(function(origin) {
            var snacks = categ[origin];
            var nomineeSnack = snacks[0];
            return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement($5e19452f9528802f$var$SnackbarContainer$1, {
                key: origin,
                dense: dense,
                anchorOrigin: nomineeSnack.anchorOrigin,
                classes: classes
            }, snacks.map(function(snack) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement($5e19452f9528802f$var$SnackbarItem, {
                    key: snack.id,
                    snack: snack,
                    classes: classes,
                    Component: Components[snack.variant],
                    onClose: _this2.handleCloseSnack,
                    onEnter: _this2.props.onEnter,
                    onExit: _this2.props.onExit,
                    onExited: $5e19452f9528802f$var$createChainedFunction([
                        _this2.handleExitedSnack,
                        _this2.props.onExited
                    ], snack.id),
                    onEntered: $5e19452f9528802f$var$createChainedFunction([
                        _this2.handleEnteredSnack,
                        _this2.props.onEntered
                    ], snack.id)
                });
            }));
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement($5e19452f9528802f$var$SnackbarContext.Provider, {
            value: contextValue
        }, children, domRoot ? (0, $69d169f7fc8722a7$exports.createPortal)(snackbars, domRoot) : snackbars);
    };
    $5e19452f9528802f$var$_createClass(SnackbarProvider, [
        {
            key: "maxSnack",
            get: function get() {
                return this.props.maxSnack || $5e19452f9528802f$var$defaults.maxSnack;
            }
        }
    ]);
    return SnackbarProvider;
}((0, $8FY87.Component));
var $5e19452f9528802f$export$1c97ac2c9a6e7c09 = function() {
    return (0, $8FY87.useContext)($5e19452f9528802f$var$SnackbarContext);
};



var $8FY87 = parcelRequire("8FY87");


const $735f5d6f6bc5f30c$var$AddEditColorPallets = (props)=>{
    const { enqueueSnackbar: enqueueSnackbar } = (0, $5e19452f9528802f$export$1c97ac2c9a6e7c09)();
    const [isEditMode] = $8FY87.useState(props.currFormData ? true : false);
    const [formData, setFormData] = $8FY87.useState(props.currFormData || {
        id: "",
        category: "",
        colors: [
            "",
            "",
            "",
            "",
            "",
            ""
        ]
    });
    const [errors, setErrors] = $8FY87.useState({
        colors: [
            false,
            false,
            false,
            false,
            false,
            false
        ]
    });
    const handleInputChange = (e)=>{
        const { name: name, value: value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };
    const handleColorChange = (index, value)=>{
        const newColors = [
            ...formData.colors
        ];
        newColors[index] = value;
        const newErrors = [
            ...errors.colors
        ];
        newErrors[index] = !isValidHexColor(value);
        setFormData({
            ...formData,
            colors: newColors
        });
        setErrors({
            ...errors,
            colors: newErrors
        });
    };
    const handleSave = async ()=>{
        // Handle save logic here
        if (formData.id === "" || formData.id === null || formData.id === undefined) {
            enqueueSnackbar("Id can't be empty", {
                variant: "error"
            });
            return;
        }
        if (formData.category === "" || formData.category === null || formData.category === undefined) {
            enqueueSnackbar("Category can't be empty", {
                variant: "error"
            });
            return;
        }
        let hasEmptyColors = false;
        formData.colors.map((oo, idx)=>{
            if (oo === "" || oo === undefined || oo === null) hasEmptyColors = true;
        });
        const hasErrors = errors.colors.some((error)=>error);
        if (hasErrors || hasEmptyColors) {
            enqueueSnackbar("Color codes can't be empty or invalid", {
                variant: "error"
            });
            return;
        }
        if (!isEditMode && props.data.find((jj)=>jj.id === formData.id)) {
            enqueueSnackbar("Id already exists. please enter unique one", {
                variant: "error"
            });
            return;
        }
        try {
            let res = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).put("/api/configs/template-color-theme", formData);
            if (res.status === 200) props.onSave();
            else enqueueSnackbar("something went wrong...!", {
                variant: "error"
            });
        } catch (err) {
            console.log(err);
        }
    };
    const handleCancel = ()=>{
        // Handle cancel logic here
        setFormData({
            id: "",
            category: "",
            colors: [
                "",
                "",
                "",
                "",
                "",
                ""
            ]
        });
        setErrors({
            colors: [
                false,
                false,
                false,
                false,
                false,
                false
            ]
        });
        props.onCancel();
    };
    const isValidHexColor = (hex)=>{
        const hexRegex = /^#([0-9A-Fa-f]{3}){1,2}$/;
        return hexRegex.test(hex);
    };
    return /*#__PURE__*/ $8FY87.createElement("div", {
        className: "max-w-md mx-auto p-4"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "mb-4  flex flex-row justify-between"
    }, /*#__PURE__*/ $8FY87.createElement("label", {
        className: "block text-gray-700 text-sm font-bold mb-2 w-40",
        htmlFor: "id"
    }, "ID"), /*#__PURE__*/ $8FY87.createElement("input", {
        type: "text",
        name: "id",
        disabled: isEditMode,
        value: formData.id,
        onChange: handleInputChange,
        className: "shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline",
        id: "id"
    })), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "mb-4 flex flex-row justify-between"
    }, /*#__PURE__*/ $8FY87.createElement("label", {
        className: "block text-gray-700 text-sm font-bold mb-2 w-40",
        htmlFor: "category"
    }, "Category"), /*#__PURE__*/ $8FY87.createElement("select", {
        name: "category",
        value: formData.category,
        onChange: handleInputChange,
        className: "shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline",
        id: "category"
    }, /*#__PURE__*/ $8FY87.createElement("option", {
        value: ""
    }, "Select a category"), /*#__PURE__*/ $8FY87.createElement("option", {
        value: "Bright"
    }, "Bright"), /*#__PURE__*/ $8FY87.createElement("option", {
        value: "Dark"
    }, "Dark"), /*#__PURE__*/ $8FY87.createElement("option", {
        value: "Pastel"
    }, "Pastel"))), formData.colors.map((color, index)=>/*#__PURE__*/ $8FY87.createElement("div", {
            className: "mb-4 flex flex-row",
            key: index
        }, /*#__PURE__*/ $8FY87.createElement("label", {
            className: "block text-gray-700 text-sm font-bold mb-2 w-40",
            htmlFor: `color-${index}`
        }, "Color ", index + 1), /*#__PURE__*/ $8FY87.createElement("div", {
            className: "flex flex-col w-full"
        }, /*#__PURE__*/ $8FY87.createElement("input", {
            type: "text",
            value: color,
            onChange: (e)=>handleColorChange(index, e.target.value),
            className: "shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline",
            id: `color-${index}`
        }), errors.colors[index] && /*#__PURE__*/ $8FY87.createElement("span", {
            className: "text-red-500 text-sm italic"
        }, "Invalid hex color code.")))), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex items-center justify-end"
    }, /*#__PURE__*/ $8FY87.createElement("button", {
        onClick: handleCancel,
        className: "bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline mr-4",
        type: "button"
    }, "Cancel"), /*#__PURE__*/ $8FY87.createElement("button", {
        onClick: handleSave,
        className: "bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline",
        type: "button"
    }, "Save")));
};
var $735f5d6f6bc5f30c$export$2e2bcd8739ae039 = $735f5d6f6bc5f30c$var$AddEditColorPallets;


const $6df8b1b5d77ec736$var$ColorPalletsList = (props)=>{
    const { enqueueSnackbar: enqueueSnackbar } = (0, $5e19452f9528802f$export$1c97ac2c9a6e7c09)();
    const [data, setData] = $8FY87.useState([]);
    const [open, setOpen] = $8FY87.useState(false);
    const [currFormData, setCurrFormData] = $8FY87.useState(null);
    async function fetchData() {
        try {
            let response = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).get(`/api/configs/all-template-color-theme`);
            // console.log("//", response.data.data);
            setData(response.data.data);
        } catch (err) {}
    }
    $8FY87.useEffect(()=>{
        fetchData();
    }, []);
    const handleCancel = ()=>{
        setOpen(false);
    };
    const handleSave = ()=>{
        fetchData();
        setOpen(false);
    };
    const handleDelete = async (id)=>{
        let res = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).delete(`/api/configs/template-color-theme?id=${id}`, id);
        if (res.status === 200) fetchData();
        else enqueueSnackbar("something went wrong...!", {
            variant: "error"
        });
    };
    return /*#__PURE__*/ $8FY87.createElement("div", {
        className: "p-4 bg-white  w-auto max-w-xl"
    }, open && /*#__PURE__*/ $8FY87.createElement("div", {
        className: "fixed inset-0 flex items-center justify-center z-50"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "absolute inset-0 bg-gray-900 opacity-50",
        onClick: ()=>setOpen(false)
    }), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "bg-white rounded-lg shadow-lg max-w-md w-full p-6 z-50"
    }, /*#__PURE__*/ $8FY87.createElement((0, $735f5d6f6bc5f30c$export$2e2bcd8739ae039), {
        data: data,
        currFormData: currFormData,
        onCancel: handleCancel,
        onSave: handleSave
    }))), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "text-black flex flex-row justify-between mb-4"
    }, /*#__PURE__*/ $8FY87.createElement("span", null, "List of color pallets"), /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        sx: {
            textTransform: "none"
        },
        size: "small",
        variant: "contained",
        onClick: ()=>{
            setCurrFormData(null);
            setOpen(true);
        }
    }, "Add new color pallet")), /*#__PURE__*/ $8FY87.createElement((0, $b40bc546cf048f9f$export$2e2bcd8739ae039), {
        component: (0, $d9c49ac25a55e29d$export$2e2bcd8739ae039)
    }, /*#__PURE__*/ $8FY87.createElement((0, $423aebbc6a7fa906$export$2e2bcd8739ae039), {
        sx: {
            minWidth: 650
        },
        size: "small",
        "aria-label": "a dense table"
    }, /*#__PURE__*/ $8FY87.createElement((0, $ea8456a9f35d1365$export$2e2bcd8739ae039), null, /*#__PURE__*/ $8FY87.createElement((0, $aceff834f1a65851$export$2e2bcd8739ae039), {
        className: "p-2 "
    }, /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), null, "id"), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), null, "Category"), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), null, "Colors"), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), null))), /*#__PURE__*/ $8FY87.createElement((0, $31f4d7fca07191f6$export$2e2bcd8739ae039), null, data.map((row)=>/*#__PURE__*/ $8FY87.createElement((0, $aceff834f1a65851$export$2e2bcd8739ae039), {
            key: row.id,
            sx: {
                "&:last-child td, &:last-child th": {
                    border: 0
                }
            }
        }, /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row"
        }, row.id), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row"
        }, row.category), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), {
            align: "right"
        }, /*#__PURE__*/ $8FY87.createElement("div", {
            className: "flex flex-row"
        }, row.colors.map((ii)=>{
            return /*#__PURE__*/ $8FY87.createElement("div", {
                key: ii,
                className: `h-8 w-8 rounded-md mr-1 border border-grey`,
                style: {
                    backgroundColor: ii
                }
            }, " ");
        }), " ")), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), {
            align: "right"
        }, /*#__PURE__*/ $8FY87.createElement((0, $b19176bd78e1869f$export$2e2bcd8739ae039), {
            sx: {
                display: "flex",
                gap: 1
            }
        }, /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
            sx: {
                textTransform: "none"
            },
            size: "small",
            variant: "outlined",
            onClick: ()=>{
                setCurrFormData(row);
                setOpen(true);
            }
        }, "Edit"), /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
            sx: {
                textTransform: "none"
            },
            size: "small",
            variant: "outlined",
            color: "error",
            onClick: ()=>{
                handleDelete(row.id);
            }
        }, "Delete")))))))));
};
var $6df8b1b5d77ec736$export$2e2bcd8739ae039 = $6df8b1b5d77ec736$var$ColorPalletsList;



var $8FY87 = parcelRequire("8FY87");












var $8FY87 = parcelRequire("8FY87");


const $68db53637e12f305$var$AddEdittemplateCategory = (props)=>{
    const { enqueueSnackbar: enqueueSnackbar } = (0, $5e19452f9528802f$export$1c97ac2c9a6e7c09)();
    const [isEditMode] = $8FY87.useState(props.currCategory ? true : false);
    const [formData, setFormData] = $8FY87.useState({
        name: props.currCategory || ""
    });
    const handleInputChange = (e)=>{
        const { name: name, value: value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };
    const handleSave = async ()=>{
        // Handle save logic here
        if (formData.name === "" || formData.name === null || formData.name === undefined) {
            enqueueSnackbar("Category name can't be empty", {
                variant: "error"
            });
            return;
        }
        // if (!isEditMode && props.data.find((jj) => jj.name === formData.name)) {
        //   enqueueSnackbar("Duplicate category name.", {
        //     variant: "error",
        //   });
        //   return;
        // }
        // if (isEditMode && props.data.find((jj) => jj.name === formData.name)) {
        //   enqueueSnackbar("Duplicate category name.", {
        //     variant: "error",
        //   });
        //   return;
        // }
        // return;
        try {
            await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).delete(`/api/configs/site-categories?name=${props.currCategory}`);
            let res = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).put("/api/configs/site-categories", formData);
            if (res.status === 200) props.onSave();
            else enqueueSnackbar("something went wrong...!", {
                variant: "error"
            });
        } catch (err) {
            console.log(err);
        }
    };
    const handleCancel = ()=>{
        // Handle cancel logic here
        setFormData({
            name: ""
        });
        props.onCancel();
    };
    return /*#__PURE__*/ $8FY87.createElement("div", {
        className: "max-w-md mx-auto p-4"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "mb-4  flex flex-row justify-between"
    }, /*#__PURE__*/ $8FY87.createElement("label", {
        className: "block text-gray-700 text-sm font-bold mb-2 w-40",
        htmlFor: "id"
    }, "Category Name"), /*#__PURE__*/ $8FY87.createElement("input", {
        type: "text",
        name: "name",
        // disabled={isEditMode}
        value: formData.name,
        onChange: handleInputChange,
        className: "shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline",
        id: "name"
    })), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex items-center justify-end"
    }, /*#__PURE__*/ $8FY87.createElement("button", {
        onClick: handleCancel,
        className: "bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline mr-4",
        type: "button"
    }, "Cancel"), /*#__PURE__*/ $8FY87.createElement("button", {
        onClick: handleSave,
        className: "bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline",
        type: "button"
    }, "Save")));
};
var $68db53637e12f305$export$2e2bcd8739ae039 = $68db53637e12f305$var$AddEdittemplateCategory;


const $4097af1941d87f88$var$TemplateCategoryList = (props)=>{
    const { enqueueSnackbar: enqueueSnackbar } = (0, $5e19452f9528802f$export$1c97ac2c9a6e7c09)();
    const [open, setOpen] = $8FY87.useState(false);
    const [currCategory, setCurrCategory] = $8FY87.useState(null);
    const [data, setData] = $8FY87.useState([]);
    async function fetchData() {
        try {
            let response = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).get(`/api/configs/all-site-category`);
            setData(response.data.data.sort((a, b)=>a.name.localeCompare(b.name, undefined, {
                    numeric: true,
                    sensitivity: "base"
                })));
        } catch (err) {}
    }
    $8FY87.useEffect(()=>{
        fetchData();
    }, []);
    const handleCancel = ()=>{
        setOpen(false);
    };
    const handleSave = ()=>{
        fetchData();
        setOpen(false);
    };
    const handleDelete = async (id)=>{
        let res = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).delete(`/api/configs/site-categories?name=${id}`);
        if (res.status === 200) fetchData();
        else enqueueSnackbar("something went wrong...!", {
            variant: "error"
        });
    };
    return /*#__PURE__*/ $8FY87.createElement("div", {
        className: "p-4 bg-white w-auto max-w-md"
    }, open && /*#__PURE__*/ $8FY87.createElement("div", {
        className: "fixed inset-0 flex items-center justify-center z-50"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "absolute inset-0 bg-gray-900 opacity-50",
        onClick: ()=>setOpen(false)
    }), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "bg-white rounded-lg shadow-lg max-w-md w-full p-6 z-50"
    }, /*#__PURE__*/ $8FY87.createElement((0, $68db53637e12f305$export$2e2bcd8739ae039), {
        data: data,
        currCategory: currCategory,
        onCancel: handleCancel,
        onSave: handleSave
    }))), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "text-black flex flex-row justify-between mb-4"
    }, /*#__PURE__*/ $8FY87.createElement("span", null, "List of template categories"), /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        sx: {
            textTransform: "none"
        },
        size: "small",
        variant: "contained",
        onClick: ()=>{
            setCurrCategory(null);
            setOpen(true);
        }
    }, "Add template category")), /*#__PURE__*/ $8FY87.createElement((0, $b40bc546cf048f9f$export$2e2bcd8739ae039), {
        component: (0, $d9c49ac25a55e29d$export$2e2bcd8739ae039)
    }, /*#__PURE__*/ $8FY87.createElement((0, $423aebbc6a7fa906$export$2e2bcd8739ae039), {
        sx: {
            minWidth: 650
        },
        size: "small",
        "aria-label": "a dense table"
    }, /*#__PURE__*/ $8FY87.createElement((0, $ea8456a9f35d1365$export$2e2bcd8739ae039), null, /*#__PURE__*/ $8FY87.createElement((0, $aceff834f1a65851$export$2e2bcd8739ae039), {
        className: "p-2"
    }, /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), null, "Category Name"), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), null))), /*#__PURE__*/ $8FY87.createElement((0, $31f4d7fca07191f6$export$2e2bcd8739ae039), null, data.map((row, idx)=>/*#__PURE__*/ $8FY87.createElement((0, $aceff834f1a65851$export$2e2bcd8739ae039), {
            key: idx,
            sx: {
                "&:last-child td, &:last-child th": {
                    border: 0
                }
            }
        }, /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row"
        }, row.name), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), {
            align: "right"
        }, /*#__PURE__*/ $8FY87.createElement((0, $b19176bd78e1869f$export$2e2bcd8739ae039), {
            sx: {
                display: "flex",
                gap: 1
            }
        }, /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
            sx: {
                textTransform: "none"
            },
            size: "small",
            variant: "outlined",
            onClick: ()=>{
                setCurrCategory(row.name);
                setOpen(true);
            }
        }, "Edit"), /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
            sx: {
                textTransform: "none"
            },
            size: "small",
            variant: "outlined",
            color: "error",
            onClick: ()=>{
                handleDelete(row.name);
            }
        }, "Delete")))))))));
};
var $4097af1941d87f88$export$2e2bcd8739ae039 = $4097af1941d87f88$var$TemplateCategoryList;



var $8FY87 = parcelRequire("8FY87");







var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");


var $lXBIJ = parcelRequire("lXBIJ");

var $1r55V = parcelRequire("1r55V");

var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");


var $lXBIJ = parcelRequire("lXBIJ");

var $ifmKX = parcelRequire("ifmKX");

var $lbp1P = parcelRequire("lbp1P");
var $awHZI = parcelRequire("awHZI");

var $8FY87 = parcelRequire("8FY87");
'use client';
function $0c786808b2800672$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = 'value' }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $8FY87.useRef(controlled !== undefined);
    const [valueState, setValue] = $8FY87.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $8FY87.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


'use client';
var $a49df1dad2760ffc$export$2e2bcd8739ae039 = (0, $0c786808b2800672$export$2e2bcd8739ae039);



var $8FY87 = parcelRequire("8FY87");

var $8FY87 = parcelRequire("8FY87");
/**
 * @ignore - internal component.
 */ const $c160e42eeb24b8ef$var$FormControlContext = /*#__PURE__*/ $8FY87.createContext(undefined);
var $c160e42eeb24b8ef$export$2e2bcd8739ae039 = $c160e42eeb24b8ef$var$FormControlContext;


'use client';
function $e2bd92ffd10d5f17$export$2e2bcd8739ae039() {
    return $8FY87.useContext((0, $c160e42eeb24b8ef$export$2e2bcd8739ae039));
}




var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $4118285bdc77ec91$export$baa0faa0c7ad8085(slot) {
    return (0, $jP65K.default)('PrivateSwitchBase', slot);
}
const $4118285bdc77ec91$var$switchBaseClasses = (0, $cOYaX.default)('PrivateSwitchBase', [
    'root',
    'checked',
    'disabled',
    'input',
    'edgeStart',
    'edgeEnd'
]);
var $4118285bdc77ec91$export$2e2bcd8739ae039 = $4118285bdc77ec91$var$switchBaseClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $4abd5c88c4f9e648$var$_excluded = [
    "autoFocus",
    "checked",
    "checkedIcon",
    "className",
    "defaultChecked",
    "disabled",
    "disableFocusRipple",
    "edge",
    "icon",
    "id",
    "inputProps",
    "inputRef",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value"
];
const $4abd5c88c4f9e648$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            'root',
            checked && 'checked',
            disabled && 'disabled',
            edge && `edge${(0, $ifmKX.default)(edge)}`
        ],
        input: [
            'input'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $4118285bdc77ec91$export$baa0faa0c7ad8085), classes);
};
const $4abd5c88c4f9e648$var$SwitchBaseRoot = (0, $lbp1P.default)((0, $21281888ae95b2bd$export$2e2bcd8739ae039), {
    name: 'MuiSwitchBase'
})(({ ownerState: ownerState })=>(0, $zgVxD.default)({
        padding: 9,
        borderRadius: '50%'
    }, ownerState.edge === 'start' && {
        marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
        marginRight: ownerState.size === 'small' ? -3 : -12
    }));
const $4abd5c88c4f9e648$var$SwitchBaseInput = (0, $lbp1P.default)('input', {
    name: 'MuiSwitchBase',
    shouldForwardProp: (0, $awHZI.default)
})({
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $4abd5c88c4f9e648$var$SwitchBase = /*#__PURE__*/ $8FY87.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, className: className, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value } = props, other = (0, $93aRW.default)(props, $4abd5c88c4f9e648$var$_excluded);
    const [checked, setCheckedState] = (0, $a49df1dad2760ffc$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    });
    const muiFormControl = (0, $e2bd92ffd10d5f17$export$2e2bcd8739ae039)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === 'checkbox' || type === 'radio';
    const ownerState = (0, $zgVxD.default)({}, props, {
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    });
    const classes = $4abd5c88c4f9e648$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2PPWI.jsxs)($4abd5c88c4f9e648$var$SwitchBaseRoot, (0, $zgVxD.default)({
        component: "span",
        className: (0, $efJYy.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)($4abd5c88c4f9e648$var$SwitchBaseInput, (0, $zgVxD.default)({
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor ? id : undefined,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type
            }, type === 'checkbox' && value === undefined ? {} : {
                value: value
            }, inputProps)),
            checked ? checkedIcon : icon
        ]
    }));
});
var $4abd5c88c4f9e648$export$2e2bcd8739ae039 = $4abd5c88c4f9e648$var$SwitchBase;


parcelRequire("8FY87");

var $cHXYB = parcelRequire("cHXYB");

var $2PPWI = parcelRequire("2PPWI");
'use client';
var $13485a991e529985$export$2e2bcd8739ae039 = (0, $cHXYB.default)(/*#__PURE__*/ (0, $2PPWI.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');


parcelRequire("8FY87");

var $cHXYB = parcelRequire("cHXYB");

var $2PPWI = parcelRequire("2PPWI");
'use client';
var $2ebffc0717e5f8e7$export$2e2bcd8739ae039 = (0, $cHXYB.default)(/*#__PURE__*/ (0, $2PPWI.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');


parcelRequire("8FY87");

var $cHXYB = parcelRequire("cHXYB");

var $2PPWI = parcelRequire("2PPWI");
'use client';
var $54a7c54d7df5aa9f$export$2e2bcd8739ae039 = (0, $cHXYB.default)(/*#__PURE__*/ (0, $2PPWI.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');



var $ifmKX = parcelRequire("ifmKX");

var $6lkQ3 = parcelRequire("6lkQ3");

var $lbp1P = parcelRequire("lbp1P");
var $awHZI = parcelRequire("awHZI");

var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $1c18a8926a7d86ab$export$6c57c6e16b4063b(slot) {
    return (0, $jP65K.default)('MuiCheckbox', slot);
}
const $1c18a8926a7d86ab$var$checkboxClasses = (0, $cOYaX.default)('MuiCheckbox', [
    'root',
    'checked',
    'disabled',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium'
]);
var $1c18a8926a7d86ab$export$2e2bcd8739ae039 = $1c18a8926a7d86ab$var$checkboxClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $0bade2783a449747$var$_excluded = [
    "checkedIcon",
    "color",
    "icon",
    "indeterminate",
    "indeterminateIcon",
    "inputProps",
    "size",
    "className"
];
const $0bade2783a449747$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            indeterminate && 'indeterminate',
            `color${(0, $ifmKX.default)(color)}`,
            `size${(0, $ifmKX.default)(size)}`
        ]
    };
    const composedClasses = (0, $lXBIJ.default)(slots, (0, $1c18a8926a7d86ab$export$6c57c6e16b4063b), classes);
    return (0, $zgVxD.default)({}, classes, composedClasses);
};
const $0bade2783a449747$var$CheckboxRoot = (0, $lbp1P.default)((0, $4abd5c88c4f9e648$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $awHZI.default)(prop) || prop === 'classes',
    name: 'MuiCheckbox',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            styles[`size${(0, $ifmKX.default)(ownerState.size)}`],
            ownerState.color !== 'default' && styles[`color${(0, $ifmKX.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $zgVxD.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === 'default' ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $1r55V.alpha)(ownerState.color === 'default' ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.color !== 'default' && {
        [`&.${(0, $1c18a8926a7d86ab$export$2e2bcd8739ae039).checked}, &.${(0, $1c18a8926a7d86ab$export$2e2bcd8739ae039).indeterminate}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $1c18a8926a7d86ab$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
const $0bade2783a449747$var$defaultCheckedIcon = /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2ebffc0717e5f8e7$export$2e2bcd8739ae039), {});
const $0bade2783a449747$var$defaultIcon = /*#__PURE__*/ (0, $2PPWI.jsx)((0, $13485a991e529985$export$2e2bcd8739ae039), {});
const $0bade2783a449747$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $2PPWI.jsx)((0, $54a7c54d7df5aa9f$export$2e2bcd8739ae039), {});
const $0bade2783a449747$var$Checkbox = /*#__PURE__*/ $8FY87.forwardRef(function Checkbox(inProps, ref) {
    var _icon$props$fontSize, _indeterminateIcon$pr;
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiCheckbox'
    });
    const { checkedIcon: checkedIcon = $0bade2783a449747$var$defaultCheckedIcon, color: color = 'primary', icon: iconProp = $0bade2783a449747$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $0bade2783a449747$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = 'medium', className: className } = props, other = (0, $93aRW.default)(props, $0bade2783a449747$var$_excluded);
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = (0, $zgVxD.default)({}, props, {
        color: color,
        indeterminate: indeterminate,
        size: size
    });
    const classes = $0bade2783a449747$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2PPWI.jsx)($0bade2783a449747$var$CheckboxRoot, (0, $zgVxD.default)({
        type: "checkbox",
        inputProps: (0, $zgVxD.default)({
            'data-indeterminate': indeterminate
        }, inputProps),
        icon: /*#__PURE__*/ $8FY87.cloneElement(icon, {
            fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
        }),
        checkedIcon: /*#__PURE__*/ $8FY87.cloneElement(indeterminateIcon, {
            fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
        }),
        ownerState: ownerState,
        ref: ref,
        className: (0, $efJYy.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $0bade2783a449747$export$2e2bcd8739ae039 = $0bade2783a449747$var$Checkbox;








// import Modal from "@mui/material/Modal";
// import AddEditColorPallets from "./AddEditColorPallets";
const $0eef4ad34e95f805$var$PublishableTemplatesList = (props)=>{
    const { enqueueSnackbar: enqueueSnackbar } = (0, $5e19452f9528802f$export$1c97ac2c9a6e7c09)();
    const [data, setData] = $8FY87.useState([]);
    const [selectAll, setSelectAll] = $8FY87.useState(false);
    async function fetchData() {
        try {
            let response = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).get(`/api/configs/template-site-configs`);
            console.log("//", response.data.data);
            setData(response.data.data);
        } catch (err) {}
    }
    $8FY87.useEffect(()=>{
        fetchData();
    }, []);
    const handlePublish = async (id)=>{
        let res = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post(`/api/configs/publish`, {
            siteId: id,
            publishAllPages: true
        });
        if (res.status === 200) enqueueSnackbar("Publishing in progress!", {
            variant: "warning"
        });
        else enqueueSnackbar("something went wrong...!", {
            variant: "error"
        });
    };
    return /*#__PURE__*/ $8FY87.createElement("div", {
        className: "p-4 bg-white  w-auto max-w-xxl"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "text-black flex flex-row justify-between mb-4"
    }, /*#__PURE__*/ $8FY87.createElement("span", null, "List of templates"), /*#__PURE__*/ $8FY87.createElement((0, $b19176bd78e1869f$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            gap: 1
        }
    }, /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        sx: {
            textTransform: "none"
        },
        disabled: !data.filter((kk)=>kk.selected === true).length > 0,
        size: "small",
        variant: "contained",
        onClick: async ()=>{
            try {
                const promises = [];
                data.filter((kk)=>kk.selected === true).forEach((row)=>{
                    promises.push((0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post(`/api/configs/update-page-count`, {
                        siteId: row.siteId
                    }));
                });
                let res = await Promise.all(promises);
                enqueueSnackbar(`Updating page count for ${res.length} site(s)!`, {
                    variant: "success"
                });
                setData((old)=>{
                    let _old = [
                        ...old
                    ];
                    for(let ii = 0; ii < _old.length; ii++)_old[ii].selected = false;
                    return _old;
                });
                setSelectAll(false);
                fetchData();
            } catch (error) {
                console.error("Error updating page count", error);
                enqueueSnackbar("Something went wrong!", {
                    variant: "error"
                });
            }
        }
    }, data.filter((kk)=>kk.selected === true).length === 0 ? "Update Page Count" : `Update Page Count (${data.filter((kk)=>kk.selected === true).length})`), /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        sx: {
            textTransform: "none"
        },
        disabled: !data.filter((kk)=>kk.selected === true).length > 0,
        size: "small",
        variant: "contained",
        onClick: async ()=>{
            try {
                const promises = [];
                data.filter((kk)=>kk.selected === true).forEach((row)=>{
                    // Push promises without awaiting them individually
                    promises.push((0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post(`/api/configs/publish`, {
                        siteId: row.siteId,
                        publishAllPages: true
                    }));
                });
                // Await Promise.all to resolve all promises
                let res = await Promise.all(promises);
                enqueueSnackbar(`Publishing ${res.length} sites in progress!`, {
                    variant: "warning"
                });
                setData((old)=>{
                    let _old = [
                        ...old
                    ];
                    for(let ii = 0; ii < _old.length; ii++)_old[ii].selected = false;
                    return _old;
                });
                setSelectAll(false);
                console.log("ressss", res); // You can now access the resolved promises
            } catch (error) {
                console.error("Error during publishing", error);
            }
        }
    }, data.filter((kk)=>kk.selected === true).length === 0 ? "Publish Site" : `Publish ${data.filter((kk)=>kk.selected === true).length} sites`))), /*#__PURE__*/ $8FY87.createElement((0, $b40bc546cf048f9f$export$2e2bcd8739ae039), {
        component: (0, $d9c49ac25a55e29d$export$2e2bcd8739ae039)
    }, /*#__PURE__*/ $8FY87.createElement((0, $423aebbc6a7fa906$export$2e2bcd8739ae039), {
        sx: {
            minWidth: 650
        },
        size: "small",
        "aria-label": "a dense table"
    }, /*#__PURE__*/ $8FY87.createElement((0, $ea8456a9f35d1365$export$2e2bcd8739ae039), null, /*#__PURE__*/ $8FY87.createElement((0, $aceff834f1a65851$export$2e2bcd8739ae039), {
        className: "p-2 "
    }, /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), null, /*#__PURE__*/ $8FY87.createElement((0, $0bade2783a449747$export$2e2bcd8739ae039), {
        checked: selectAll,
        size: "small",
        onChange: (event)=>{
            setData((old)=>{
                let _old = [
                    ...old
                ];
                for(let ii = 0; ii < _old.length; ii++)_old[ii].selected = event.target.checked ? true : false; // Fix this line to toggle selected
                return _old;
            });
            setSelectAll(!selectAll);
        }
    })), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), null, "Sr.No."), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), null, "Site Id"), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), null, "Template Name (Site Name)"), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), null, "Page Count"), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), null, "Last modified on"), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), null))), /*#__PURE__*/ $8FY87.createElement((0, $31f4d7fca07191f6$export$2e2bcd8739ae039), null, data.map((row, _idx)=>/*#__PURE__*/ $8FY87.createElement((0, $aceff834f1a65851$export$2e2bcd8739ae039), {
            key: row.siteId,
            sx: {
                "&:last-child td, &:last-child th": {
                    border: 0
                }
            }
        }, /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row"
        }, /*#__PURE__*/ $8FY87.createElement((0, $0bade2783a449747$export$2e2bcd8739ae039), {
            checked: row?.selected === true ? true : false,
            size: "small",
            onChange: (event)=>{
                setData((old)=>{
                    let _old = [
                        ...old
                    ];
                    let ii = _old.findIndex((kk)=>kk.siteId === row.siteId); // Corrected
                    if (ii !== -1) _old[ii].selected = event.target.checked ? true : false; // Fix this line to toggle selected
                    return _old;
                });
            }
        })), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row"
        }, _idx), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row"
        }, row.siteId), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row"
        }, row.templateName, " (", row.siteName, ")"), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), {
            align: "right"
        }, row.pageCount), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), {
            align: "left"
        }, new Date(row.updatedAt).toLocaleString()), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), {
            align: "right"
        }, /*#__PURE__*/ $8FY87.createElement((0, $b19176bd78e1869f$export$2e2bcd8739ae039), {
            sx: {
                display: "flex",
                gap: 1
            }
        }, /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
            sx: {
                textTransform: "none"
            },
            size: "small",
            variant: "outlined",
            onClick: ()=>{
                handlePublish(row.siteId);
            }
        }, "Publish")))))))));
};
var $0eef4ad34e95f805$export$2e2bcd8739ae039 = $0eef4ad34e95f805$var$PublishableTemplatesList;



var $8FY87 = parcelRequire("8FY87");











const $7ca05f192383150d$var$UserAcquisitionLogs = (props)=>{
    const { enqueueSnackbar: enqueueSnackbar } = (0, $5e19452f9528802f$export$1c97ac2c9a6e7c09)();
    const [data, setData] = $8FY87.useState([]);
    const [showSiteData, setShowSiteData] = $8FY87.useState([]);
    async function fetchData() {
        try {
            let response = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).get(`/api/admin/user-acqusition-logs`);
            setData(response.data.data);
        // console.log(response.data);
        } catch (err) {}
    }
    $8FY87.useEffect(()=>{
        fetchData();
    }, []);
    return /*#__PURE__*/ $8FY87.createElement("div", {
        className: "w-full p-4 flex flex-row"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: " bg-white w-7/12 overflow-x-auto h-[calc(100vh-100px)]"
    }, /*#__PURE__*/ $8FY87.createElement((0, $b40bc546cf048f9f$export$2e2bcd8739ae039), {
        component: (0, $d9c49ac25a55e29d$export$2e2bcd8739ae039)
    }, /*#__PURE__*/ $8FY87.createElement((0, $423aebbc6a7fa906$export$2e2bcd8739ae039), {
        sx: {
            minWidth: 650
        },
        size: "small",
        "aria-label": "a dense table"
    }, /*#__PURE__*/ $8FY87.createElement((0, $ea8456a9f35d1365$export$2e2bcd8739ae039), null, /*#__PURE__*/ $8FY87.createElement((0, $aceff834f1a65851$export$2e2bcd8739ae039), {
        className: "p-2"
    }, /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), null, "User email"), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), null, "Source"), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), null, "Created On"), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), null))), /*#__PURE__*/ $8FY87.createElement((0, $31f4d7fca07191f6$export$2e2bcd8739ae039), null, data.map((row, idx)=>{
        const date = new Date(row.createdOn);
        return /*#__PURE__*/ $8FY87.createElement((0, $aceff834f1a65851$export$2e2bcd8739ae039), {
            key: idx,
            sx: {
                "&:last-child td, &:last-child th": {
                    border: 0
                }
            }
        }, /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row",
            className: "break-all"
        }, row.email), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row"
        }, row.googleSource === true ? "Google" : row.linkedInSource === true ? "LinkedIn" : "-"), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row"
        }, date.toLocaleString()), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), {
            align: "right"
        }, /*#__PURE__*/ $8FY87.createElement((0, $b19176bd78e1869f$export$2e2bcd8739ae039), {
            sx: {
                display: "flex",
                gap: 1
            }
        }, /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
            sx: {
                textTransform: "none"
            },
            size: "small",
            variant: "outlined",
            onClick: ()=>{
                setShowSiteData(row.sites);
            }
        }, "View Sites"))));
    }))))), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "w-5/12 pl-4"
    }, showSiteData && showSiteData.map((ee)=>{
        const _date = new Date(ee.updatedAt);
        const { siteUrl: siteUrl, subDomain: subDomain } = ee;
        let updatedUrl = siteUrl;
        // if (siteUrl && subDomain) {
        //   const parts = siteUrl.split(".");
        //   if (parts.length >= 1 && parts[0] !== subDomain) {
        //     parts[0] = subDomain;
        //     updatedUrl = parts.join(".");
        //   }
        // }
        return /*#__PURE__*/ $8FY87.createElement("div", {
            className: "bg-white p-2 m-1 rounded-lg",
            key: ee.siteId
        }, /*#__PURE__*/ $8FY87.createElement("div", {
            className: "flex flex-row"
        }, /*#__PURE__*/ $8FY87.createElement("span", {
            className: "pr-2"
        }, "Site Name: "), /*#__PURE__*/ $8FY87.createElement("span", null, ee.siteName)), /*#__PURE__*/ $8FY87.createElement("div", {
            className: "flex flex-row"
        }, /*#__PURE__*/ $8FY87.createElement("span", {
            className: "pr-2"
        }, "Last modified On: "), /*#__PURE__*/ $8FY87.createElement("span", null, _date.toLocaleString())), /*#__PURE__*/ $8FY87.createElement("div", {
            className: "flex flex-row"
        }, /*#__PURE__*/ $8FY87.createElement("span", {
            className: "pr-2"
        }, "Publish Status: "), /*#__PURE__*/ $8FY87.createElement("span", null, ee.isPublished ? "true" : "false")), ee.source && /*#__PURE__*/ $8FY87.createElement("div", {
            className: "flex flex-row"
        }, /*#__PURE__*/ $8FY87.createElement("span", {
            className: "pr-2"
        }, "AI Source: "), /*#__PURE__*/ $8FY87.createElement("span", null, ee.source)), /*#__PURE__*/ $8FY87.createElement("div", {
            className: "flex flex-row"
        }, /*#__PURE__*/ $8FY87.createElement("span", {
            className: "pr-2"
        }, "Site URL: "), /*#__PURE__*/ $8FY87.createElement("a", {
            href: `https://${updatedUrl}`,
            target: "_blank"
        }, updatedUrl)), /*#__PURE__*/ $8FY87.createElement("div", {
            className: "flex flex-row"
        }, /*#__PURE__*/ $8FY87.createElement("span", {
            className: "pr-2"
        }, "Editor URL: "), /*#__PURE__*/ $8FY87.createElement("a", {
            href: `${"http://editor.rocketpages.io"}/${ee.siteId}`,
            target: "_blank"
        }, `${"http://editor.rocketpages.io"}/${ee.siteId}`)));
    })));
};
var $7ca05f192383150d$export$2e2bcd8739ae039 = $7ca05f192383150d$var$UserAcquisitionLogs;



var $8FY87 = parcelRequire("8FY87");









const $db4339edd256fd41$var$SitesList = (props)=>{
    const { enqueueSnackbar: enqueueSnackbar } = (0, $5e19452f9528802f$export$1c97ac2c9a6e7c09)();
    const [data, setData] = $8FY87.useState([]);
    const [showSiteData, setShowSiteData] = $8FY87.useState([]);
    async function fetchData() {
        try {
            let response = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).get(`/api/admin/all-sites`);
            setData(response.data.data);
        // console.log(response.data);
        } catch (err) {}
    }
    $8FY87.useEffect(()=>{
        fetchData();
    }, []);
    return /*#__PURE__*/ $8FY87.createElement("div", {
        className: "w-full p-4 flex flex-row"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: " font-medium bg-white overflow-x-auto h-[calc(100vh-100px)]"
    }, /*#__PURE__*/ $8FY87.createElement((0, $b40bc546cf048f9f$export$2e2bcd8739ae039), {
        component: (0, $d9c49ac25a55e29d$export$2e2bcd8739ae039)
    }, /*#__PURE__*/ $8FY87.createElement((0, $423aebbc6a7fa906$export$2e2bcd8739ae039), {
        sx: {
            minWidth: 650
        },
        size: "small",
        "aria-label": "a dense table"
    }, /*#__PURE__*/ $8FY87.createElement((0, $ea8456a9f35d1365$export$2e2bcd8739ae039), null, /*#__PURE__*/ $8FY87.createElement((0, $aceff834f1a65851$export$2e2bcd8739ae039), {
        className: "p-2"
    }, /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), null, "Site Id"), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), null, "Site Url"), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), null, "User"), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), null, "Custom Code"), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), null, "Subscription"), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), null, "Created On"), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), null, "Updategd On"), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), null, "isPublished"), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), null))), /*#__PURE__*/ $8FY87.createElement((0, $31f4d7fca07191f6$export$2e2bcd8739ae039), null, data.map((row, idx)=>{
        const created_date = new Date(row.createdAt);
        const updated_date = new Date(row.updatedAt);
        const { siteUrl: siteUrl, subDomain: subDomain } = row;
        let updatedUrl = siteUrl;
        if (siteUrl && subDomain) {
            const parts = siteUrl.split(".");
            if (parts.length >= 1 && parts[0] !== subDomain) {
                parts[0] = subDomain;
                updatedUrl = parts.join(".");
            }
        }
        return /*#__PURE__*/ $8FY87.createElement((0, $aceff834f1a65851$export$2e2bcd8739ae039), {
            key: idx,
            sx: {
                "&:last-child td, &:last-child th": {
                    border: 0
                }
            }
        }, /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row"
        }, row.siteId), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row"
        }, /*#__PURE__*/ $8FY87.createElement("a", {
            href: `https://${updatedUrl}`,
            target: "_blank"
        }, updatedUrl)), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row"
        }, row.email), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row"
        }, row.customCode), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row"
        }, row.subscriptionStatus), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row"
        }, created_date.toLocaleString()), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row"
        }, updated_date.toLocaleString()), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row"
        }, row.isPublished ? "true" : "false"));
    }))))));
};
var $db4339edd256fd41$export$2e2bcd8739ae039 = $db4339edd256fd41$var$SitesList;



var $8FY87 = parcelRequire("8FY87");










// import Modal from "@mui/material/Modal";
// import AddEditColorPallets from "./AddEditColorPallets";
const $12cd7a37206e0f90$var$AITemplates = (props)=>{
    const { enqueueSnackbar: enqueueSnackbar } = (0, $5e19452f9528802f$export$1c97ac2c9a6e7c09)();
    const [data, setData] = $8FY87.useState([]);
    const [selectAll, setSelectAll] = $8FY87.useState(false);
    async function fetchData() {
        try {
            let response = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).get(`/api/configs/aiTemplates`);
            console.log("//", response.data.data);
            setData(response.data.data);
        } catch (err) {}
    }
    $8FY87.useEffect(()=>{
        fetchData();
    }, []);
    return /*#__PURE__*/ $8FY87.createElement("div", {
        className: "p-4 bg-white  w-auto max-w-xxl"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "text-black flex flex-row justify-between mb-4"
    }, /*#__PURE__*/ $8FY87.createElement("span", null, "List of templates")), /*#__PURE__*/ $8FY87.createElement((0, $b40bc546cf048f9f$export$2e2bcd8739ae039), {
        component: (0, $d9c49ac25a55e29d$export$2e2bcd8739ae039)
    }, /*#__PURE__*/ $8FY87.createElement((0, $423aebbc6a7fa906$export$2e2bcd8739ae039), {
        sx: {
            minWidth: 650
        },
        size: "small",
        "aria-label": "a dense table"
    }, /*#__PURE__*/ $8FY87.createElement((0, $ea8456a9f35d1365$export$2e2bcd8739ae039), null, /*#__PURE__*/ $8FY87.createElement((0, $aceff834f1a65851$export$2e2bcd8739ae039), {
        className: "p-2 "
    }, /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), null, "Template Name (Site Name)"), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), null, "Page Count"), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), null, "Last modified on"), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), null))), /*#__PURE__*/ $8FY87.createElement((0, $31f4d7fca07191f6$export$2e2bcd8739ae039), null, data.map((row)=>/*#__PURE__*/ $8FY87.createElement((0, $aceff834f1a65851$export$2e2bcd8739ae039), {
            key: row.siteId,
            sx: {
                "&:last-child td, &:last-child th": {
                    border: 0
                }
            }
        }, /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), {
            component: "th",
            scope: "row"
        }, row.templateName, " (", row.siteName, ")"), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), {
            align: "right"
        }, row.pageCount), /*#__PURE__*/ $8FY87.createElement((0, $8f2ac4889b244103$export$2e2bcd8739ae039), {
            align: "left"
        }, new Date(row.updatedAt).toLocaleString())))))));
};
var $12cd7a37206e0f90$export$2e2bcd8739ae039 = $12cd7a37206e0f90$var$AITemplates;




const $9d2bfff234f9d017$var$AdminPage = ()=>{
    const navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    const [isLoading, setIsLoading] = (0, $8FY87.useState)(false);
    const [cookies] = (0, $1f373de1ceea6eb7$export$2e2bcd8739ae039)([
        "rp_user_data"
    ]);
    const location = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)();
    const stateData = location.state;
    // Marketing site id (fixed)
    const marketingSiteId = "2e2b85c5-1b76-4e74-8e39-c82749386c53";
    // Publish status for smart button
    const [publishInfo, setPublishInfo] = (0, $8FY87.useState)({
        status: "Unknown",
        stuck: false,
        publishBatchStart: 0
    });
    const query = (0, $8FY87.useMemo)(()=>new URLSearchParams(location.search), [
        location.search
    ]);
    const l_menu = query.get("menu");
    // Polling interval ref so we can stop polling when publish is terminal
    const pollRef = (0, $8FY87.useRef)(null);
    const normalizeStatus = (value)=>String(value || "").trim().toLowerCase();
    const extractStatusPayload = (response)=>{
        const envelope = response?.data ?? response;
        const raw = envelope?.data ?? envelope;
        return raw?.data ?? raw;
    };
    const fetchPublishInfo = async ()=>{
        try {
            const resp = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).get("/api/configs/check-publish-status", {
                params: {
                    siteId: marketingSiteId
                }
            });
            const statusPayload = extractStatusPayload(resp);
            setPublishInfo({
                status: normalizeStatus(statusPayload?.status) || "unknown",
                stuck: !!statusPayload?.stuck,
                publishBatchStart: Number(statusPayload?.publishBatchStart || 0)
            });
        } catch (e) {
        // Best effort. Don't spam errors in admin UI.
        // Keep previous publishInfo so button doesn't flicker.
        }
    };
    (0, $8FY87.useEffect)(()=>{
        // Only poll when admin home is shown (where the button exists)
        if (l_menu !== null) return;
        fetchPublishInfo();
        // Start polling
        pollRef.current = window.setInterval(fetchPublishInfo, 15000);
        return ()=>{
            if (pollRef.current !== null) {
                window.clearInterval(pollRef.current);
                pollRef.current = null;
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        l_menu
    ]);
    (0, $8FY87.useEffect)(()=>{
        // Stop polling once publish reaches a terminal state
        const terminal = publishInfo.status === "completed" || publishInfo.status === "failed";
        if (terminal && pollRef.current !== null) {
            window.clearInterval(pollRef.current);
            pollRef.current = null;
        }
    }, [
        publishInfo.status
    ]);
    const handleMarketingSiteRepublish = async ()=>{
        try {
            // Refresh current status just before action
            const statusRes = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).get("/api/configs/check-publish-status", {
                params: {
                    siteId: marketingSiteId
                }
            });
            const statusPayload = extractStatusPayload(statusRes);
            const status = normalizeStatus(statusPayload?.status);
            const stuck = !!statusPayload?.stuck;
            const publishBatchStart = Number(statusPayload?.publishBatchStart || 0);
            // If stuck -> resume
            if (status === "running" && stuck) {
                // Resume continues from the server's last saved batch/progress (publishBatchStart from status API),
                // not from any client-side split/halve calculation.
                await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post("/api/configs/publish/resume", {
                    siteId: marketingSiteId
                });
                (0, $5e19452f9528802f$export$9d70c354f0150b1b)(`Publish was stuck. Resuming from batch ${Number(publishBatchStart || 0)}\u{2026}`, {
                    variant: "warning"
                });
                fetchPublishInfo();
                return;
            }
            // If running (fresh) -> do nothing
            if (status === "running") {
                (0, $5e19452f9528802f$export$9d70c354f0150b1b)("Publish is already running\u2026", {
                    variant: "info"
                });
                return;
            }
            // Otherwise -> start publish
            const res = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post("/api/configs/publish", {
                siteId: marketingSiteId,
                publishAllPages: true
            });
            if (res.status === 200) {
                (0, $5e19452f9528802f$export$9d70c354f0150b1b)("Publishing in progress!", {
                    variant: "warning"
                });
                fetchPublishInfo();
            } else (0, $5e19452f9528802f$export$9d70c354f0150b1b)("Could not start publish.", {
                variant: "error"
            });
        } catch (error) {
            console.error("Marketing republish/resume error", error);
            (0, $5e19452f9528802f$export$9d70c354f0150b1b)("Something went wrong while publishing.", {
                variant: "error"
            });
        }
    };
    const marketingButtonText = publishInfo.status === "running" && publishInfo.stuck ? `Resume Marketing Publish (batch ${publishInfo.publishBatchStart})` : publishInfo.status === "running" ? "Publishing\u2026" : "Republish Marketing Site";
    const marketingButtonDisabled = publishInfo.status === "running" && !publishInfo.stuck;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $33586719f2f33a17$export$dcef8f9bb9a41431), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("title", null, "RocketPages - Admin Panel"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("meta", {
        name: "robots",
        content: "noindex, nofollow"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "font-body text-base font-medium"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $56dcde36b8493878$export$2e2bcd8739ae039), {
        sx: {
            color: "#fff",
            zIndex: (theme)=>theme.zIndex.drawer + 1
        },
        open: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $b391f94ee7b6de9b$export$2e2bcd8739ae039), {
        color: "inherit"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $c0f0a0f6efad2fa3$export$42cfbb80f7861e77), {
        ...stateData,
        title: `Admin Panel ${l_menu === "templateCategory" ? " | Template Category" : l_menu === "colorPallets" ? " | Color Pallets" : l_menu === "publishTemplates" ? " | Publish Templates" : l_menu === "userLogs" ? " | User acquisition logs" : l_menu === "allSites" ? " | Sites List" : l_menu === "aiTemplates" ? " | AI Templates" : ""}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "font-body text-base font-medium bg-gray-100 w-full pt-[64px] flex flex-col min-h-screen-minus-100"
    }, l_menu === "colorPallets" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $6df8b1b5d77ec736$export$2e2bcd8739ae039), null), l_menu === "templateCategory" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $4097af1941d87f88$export$2e2bcd8739ae039), null), l_menu === "publishTemplates" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $0eef4ad34e95f805$export$2e2bcd8739ae039), null), l_menu === "userLogs" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $7ca05f192383150d$export$2e2bcd8739ae039), null), l_menu === "allSites" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $db4339edd256fd41$export$2e2bcd8739ae039), null), l_menu === "aiTemplates" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $12cd7a37206e0f90$export$2e2bcd8739ae039), null), l_menu === null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex flex-row m-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        id: "save",
        className: "min-w-[6rem] px-4 py-1 capitalize mr-2",
        sx: {
            textTransform: "none"
        },
        size: "small",
        variant: "contained",
        onClick: ()=>navigate(`/admin?menu=colorPallets`)
    }, "Color Pallets"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        id: "save",
        className: "min-w-[6rem] px-4 py-1 capitalize mr-2",
        sx: {
            textTransform: "none"
        },
        size: "small",
        variant: "contained",
        onClick: ()=>navigate(`/admin?menu=templateCategory`)
    }, "Template Category"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        id: "save",
        className: "min-w-[6rem] px-4 py-1 capitalize mr-2",
        sx: {
            textTransform: "none"
        },
        size: "small",
        variant: "contained",
        onClick: ()=>navigate(`/admin?menu=publishTemplates`)
    }, "Publish Templates"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        id: "save",
        className: "min-w-[6rem] px-4 py-1 capitalize mr-2",
        sx: {
            textTransform: "none"
        },
        size: "small",
        variant: "contained",
        onClick: ()=>navigate(`/admin?menu=userLogs`)
    }, "User acquisition logs"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        id: "save",
        className: "min-w-[6rem] px-4 py-1 capitalize mr-2",
        sx: {
            textTransform: "none"
        },
        size: "small",
        variant: "contained",
        onClick: ()=>navigate(`/admin?menu=allSites`)
    }, "Sites List"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        id: "save",
        className: "min-w-[6rem] px-4 py-1 capitalize mr-2",
        sx: {
            textTransform: "none"
        },
        size: "small",
        variant: "contained",
        onClick: ()=>navigate(`/admin?menu=aiTemplates`)
    }, "AI Templates"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        id: "save",
        className: "min-w-[6rem] px-4 py-1 capitalize mr-2",
        sx: {
            textTransform: "none"
        },
        size: "small",
        variant: "contained",
        disabled: marketingButtonDisabled,
        onClick: handleMarketingSiteRepublish
    }, marketingButtonText)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "w-full"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $0a87a32205fa1e51$export$2e2bcd8739ae039), null)));
};
var $9d2bfff234f9d017$export$2e2bcd8739ae039 = $9d2bfff234f9d017$var$AdminPage;


var $c1e8e05b22d2e795$exports = {};
"use strict";
"use client";

var $bcBLN = parcelRequire("bcBLN");
Object.defineProperty($c1e8e05b22d2e795$exports, "__esModule", {
    value: true
});
$c1e8e05b22d2e795$exports.default = void 0;

var $c1e8e05b22d2e795$var$_createSvgIcon = $bcBLN((parcelRequire("485sq")));

var $2PPWI = parcelRequire("2PPWI");
var $c1e8e05b22d2e795$var$_default = $c1e8e05b22d2e795$exports.default = (0, $c1e8e05b22d2e795$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2PPWI.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Clear');





var $8FY87 = parcelRequire("8FY87");


var $4VW2f = parcelRequire("4VW2f");
var $af58b94c7be16602$exports = {};
'use strict';
function $af58b94c7be16602$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $8FY87 = parcelRequire("8FY87");
var $af58b94c7be16602$var$React__default = $af58b94c7be16602$var$_interopDefault($8FY87);
function $af58b94c7be16602$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $af58b94c7be16602$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $af58b94c7be16602$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $af58b94c7be16602$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== 'function') throw new Error('Expected reducePropsToState to be a function.');
    if (typeof handleStateChangeOnClient !== 'function') throw new Error('Expected handleStateChangeOnClient to be a function.');
    if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') throw new Error('Expected mapStateOnServer to either be undefined or a function.');
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== 'function') throw new Error('Expected WrappedComponent to be a React component.');
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            $af58b94c7be16602$var$_inheritsLoose(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $af58b94c7be16602$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($8FY87.PureComponent);
        $af58b94c7be16602$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $af58b94c7be16602$var$_defineProperty(SideEffect, "canUseDOM", $af58b94c7be16602$var$canUseDOM);
        return SideEffect;
    };
}
$af58b94c7be16602$exports = $af58b94c7be16602$var$withSideEffect;




var $8FY87 = parcelRequire("8FY87");
var $114e5b3b2823c837$exports = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $114e5b3b2823c837$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $114e5b3b2823c837$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $114e5b3b2823c837$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $114e5b3b2823c837$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $114e5b3b2823c837$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
$114e5b3b2823c837$exports = $114e5b3b2823c837$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $114e5b3b2823c837$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($114e5b3b2823c837$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($114e5b3b2823c837$var$getOwnPropertySymbols) {
            symbols = $114e5b3b2823c837$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($114e5b3b2823c837$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};


var $274ffc8236991365$var$ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};
var $274ffc8236991365$var$TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};
var $274ffc8236991365$var$VALID_TAG_NAMES = Object.keys($274ffc8236991365$var$TAG_NAMES).map(function(name) {
    return $274ffc8236991365$var$TAG_NAMES[name];
});
var $274ffc8236991365$var$TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};
var $274ffc8236991365$var$REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $274ffc8236991365$var$HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};
var $274ffc8236991365$var$HTML_TAG_MAP = Object.keys($274ffc8236991365$var$REACT_TAG_MAP).reduce(function(obj, key) {
    obj[$274ffc8236991365$var$REACT_TAG_MAP[key]] = key;
    return obj;
}, {});
var $274ffc8236991365$var$SELF_CLOSING_TAGS = [
    $274ffc8236991365$var$TAG_NAMES.NOSCRIPT,
    $274ffc8236991365$var$TAG_NAMES.SCRIPT,
    $274ffc8236991365$var$TAG_NAMES.STYLE
];
var $274ffc8236991365$var$HELMET_ATTRIBUTE = "data-react-helmet";
var $274ffc8236991365$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $274ffc8236991365$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $274ffc8236991365$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $274ffc8236991365$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $274ffc8236991365$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $274ffc8236991365$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $274ffc8236991365$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $274ffc8236991365$var$encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $274ffc8236991365$var$getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = $274ffc8236991365$var$getInnermostProperty(propsList, $274ffc8236991365$var$TAG_NAMES.TITLE);
    var innermostTemplate = $274ffc8236991365$var$getInnermostProperty(propsList, $274ffc8236991365$var$HELMET_PROPS.TITLE_TEMPLATE);
    if (innermostTemplate && innermostTitle) // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function() {
        return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
    });
    var innermostDefaultTitle = $274ffc8236991365$var$getInnermostProperty(propsList, $274ffc8236991365$var$HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || undefined;
};
var $274ffc8236991365$var$getOnChangeClientState = function getOnChangeClientState(propsList) {
    return $274ffc8236991365$var$getInnermostProperty(propsList, $274ffc8236991365$var$HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function() {};
};
var $274ffc8236991365$var$getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function(props) {
        return typeof props[tagType] !== "undefined";
    }).map(function(props) {
        return props[tagType];
    }).reduce(function(tagAttrs, current) {
        return $274ffc8236991365$var$_extends({}, tagAttrs, current);
    }, {});
};
var $274ffc8236991365$var$getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function(props) {
        return typeof props[$274ffc8236991365$var$TAG_NAMES.BASE] !== "undefined";
    }).map(function(props) {
        return props[$274ffc8236991365$var$TAG_NAMES.BASE];
    }).reverse().reduce(function(innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
};
var $274ffc8236991365$var$getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};
    return propsList.filter(function(props) {
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $274ffc8236991365$var$warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + $274ffc8236991365$var$_typeof(props[tagName]) + "\"");
        return false;
    }).map(function(props) {
        return props[tagName];
    }).reverse().reduce(function(approvedTags, instanceTags) {
        var instanceSeenTags = {};
        instanceTags.filter(function(tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === $274ffc8236991365$var$TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === $274ffc8236991365$var$TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === $274ffc8236991365$var$TAG_PROPERTIES.INNER_HTML || attributeKey === $274ffc8236991365$var$TAG_PROPERTIES.CSS_TEXT || attributeKey === $274ffc8236991365$var$TAG_PROPERTIES.ITEM_PROP)) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            var value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach(function(tag) {
            return approvedTags.push(tag);
        });
        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for(var i = 0; i < keys.length; i++){
            var attributeKey = keys[i];
            var tagUnion = (0, (/*@__PURE__*/$parcel$interopDefault($114e5b3b2823c837$exports)))({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $274ffc8236991365$var$getInnermostProperty = function getInnermostProperty(propsList, property) {
    for(var i = propsList.length - 1; i >= 0; i--){
        var props = propsList[i];
        if (props.hasOwnProperty(property)) return props[property];
    }
    return null;
};
var $274ffc8236991365$var$reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: $274ffc8236991365$var$getBaseTagFromPropsList([
            $274ffc8236991365$var$TAG_PROPERTIES.HREF,
            $274ffc8236991365$var$TAG_PROPERTIES.TARGET
        ], propsList),
        bodyAttributes: $274ffc8236991365$var$getAttributesFromPropsList($274ffc8236991365$var$ATTRIBUTE_NAMES.BODY, propsList),
        defer: $274ffc8236991365$var$getInnermostProperty(propsList, $274ffc8236991365$var$HELMET_PROPS.DEFER),
        encode: $274ffc8236991365$var$getInnermostProperty(propsList, $274ffc8236991365$var$HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $274ffc8236991365$var$getAttributesFromPropsList($274ffc8236991365$var$ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: $274ffc8236991365$var$getTagsFromPropsList($274ffc8236991365$var$TAG_NAMES.LINK, [
            $274ffc8236991365$var$TAG_PROPERTIES.REL,
            $274ffc8236991365$var$TAG_PROPERTIES.HREF
        ], propsList),
        metaTags: $274ffc8236991365$var$getTagsFromPropsList($274ffc8236991365$var$TAG_NAMES.META, [
            $274ffc8236991365$var$TAG_PROPERTIES.NAME,
            $274ffc8236991365$var$TAG_PROPERTIES.CHARSET,
            $274ffc8236991365$var$TAG_PROPERTIES.HTTPEQUIV,
            $274ffc8236991365$var$TAG_PROPERTIES.PROPERTY,
            $274ffc8236991365$var$TAG_PROPERTIES.ITEM_PROP
        ], propsList),
        noscriptTags: $274ffc8236991365$var$getTagsFromPropsList($274ffc8236991365$var$TAG_NAMES.NOSCRIPT, [
            $274ffc8236991365$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        onChangeClientState: $274ffc8236991365$var$getOnChangeClientState(propsList),
        scriptTags: $274ffc8236991365$var$getTagsFromPropsList($274ffc8236991365$var$TAG_NAMES.SCRIPT, [
            $274ffc8236991365$var$TAG_PROPERTIES.SRC,
            $274ffc8236991365$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        styleTags: $274ffc8236991365$var$getTagsFromPropsList($274ffc8236991365$var$TAG_NAMES.STYLE, [
            $274ffc8236991365$var$TAG_PROPERTIES.CSS_TEXT
        ], propsList),
        title: $274ffc8236991365$var$getTitleFromPropsList(propsList),
        titleAttributes: $274ffc8236991365$var$getAttributesFromPropsList($274ffc8236991365$var$ATTRIBUTE_NAMES.TITLE, propsList)
    };
};
var $274ffc8236991365$var$rafPolyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            $274ffc8236991365$var$rafPolyfill(callback);
        }, 0);
    };
}();
var $274ffc8236991365$var$cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};
var $274ffc8236991365$var$requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || $274ffc8236991365$var$rafPolyfill : $parcel$global.requestAnimationFrame || $274ffc8236991365$var$rafPolyfill;
var $274ffc8236991365$var$cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || $274ffc8236991365$var$cafPolyfill : $parcel$global.cancelAnimationFrame || $274ffc8236991365$var$cafPolyfill;
var $274ffc8236991365$var$warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};
var $274ffc8236991365$var$_helmetCallback = null;
var $274ffc8236991365$var$handleClientStateChange = function handleClientStateChange(newState) {
    if ($274ffc8236991365$var$_helmetCallback) $274ffc8236991365$var$cancelAnimationFrame($274ffc8236991365$var$_helmetCallback);
    if (newState.defer) $274ffc8236991365$var$_helmetCallback = $274ffc8236991365$var$requestAnimationFrame(function() {
        $274ffc8236991365$var$commitTagChanges(newState, function() {
            $274ffc8236991365$var$_helmetCallback = null;
        });
    });
    else {
        $274ffc8236991365$var$commitTagChanges(newState);
        $274ffc8236991365$var$_helmetCallback = null;
    }
};
var $274ffc8236991365$var$commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
    $274ffc8236991365$var$updateAttributes($274ffc8236991365$var$TAG_NAMES.BODY, bodyAttributes);
    $274ffc8236991365$var$updateAttributes($274ffc8236991365$var$TAG_NAMES.HTML, htmlAttributes);
    $274ffc8236991365$var$updateTitle(title, titleAttributes);
    var tagUpdates = {
        baseTag: $274ffc8236991365$var$updateTags($274ffc8236991365$var$TAG_NAMES.BASE, baseTag),
        linkTags: $274ffc8236991365$var$updateTags($274ffc8236991365$var$TAG_NAMES.LINK, linkTags),
        metaTags: $274ffc8236991365$var$updateTags($274ffc8236991365$var$TAG_NAMES.META, metaTags),
        noscriptTags: $274ffc8236991365$var$updateTags($274ffc8236991365$var$TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: $274ffc8236991365$var$updateTags($274ffc8236991365$var$TAG_NAMES.SCRIPT, scriptTags),
        styleTags: $274ffc8236991365$var$updateTags($274ffc8236991365$var$TAG_NAMES.STYLE, styleTags)
    };
    var addedTags = {};
    var removedTags = {};
    Object.keys(tagUpdates).forEach(function(tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    cb && cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $274ffc8236991365$var$flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var $274ffc8236991365$var$updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) document.title = $274ffc8236991365$var$flattenArray(title);
    $274ffc8236991365$var$updateAttributes($274ffc8236991365$var$TAG_NAMES.TITLE, attributes);
};
var $274ffc8236991365$var$updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    var helmetAttributeString = elementTag.getAttribute($274ffc8236991365$var$HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);
    for(var i = 0; i < attributeKeys.length; i++){
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(var _i = attributesToRemove.length - 1; _i >= 0; _i--)elementTag.removeAttribute(attributesToRemove[_i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($274ffc8236991365$var$HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($274ffc8236991365$var$HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($274ffc8236991365$var$HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $274ffc8236991365$var$updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector($274ffc8236991365$var$TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + $274ffc8236991365$var$HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;
    if (tags && tags.length) tags.forEach(function(tag) {
        var newElement = document.createElement(type);
        for(var attribute in tag)if (tag.hasOwnProperty(attribute)) {
            if (attribute === $274ffc8236991365$var$TAG_PROPERTIES.INNER_HTML) newElement.innerHTML = tag.innerHTML;
            else if (attribute === $274ffc8236991365$var$TAG_PROPERTIES.CSS_TEXT) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($274ffc8236991365$var$HELMET_ATTRIBUTE, "true");
        // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
        if (oldTags.some(function(existingTag, index) {
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach(function(tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function(tag) {
        return headElement.appendChild(tag);
    });
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $274ffc8236991365$var$generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function(str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};
var $274ffc8236991365$var$generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = $274ffc8236991365$var$generateElementAttributesAsString(attributes);
    var flattenedTitle = $274ffc8236991365$var$flattenArray(title);
    return attributeString ? "<" + type + " " + $274ffc8236991365$var$HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + $274ffc8236991365$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + $274ffc8236991365$var$HELMET_ATTRIBUTE + "=\"true\">" + $274ffc8236991365$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};
var $274ffc8236991365$var$generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function(str, tag) {
        var attributeHtml = Object.keys(tag).filter(function(attribute) {
            return !(attribute === $274ffc8236991365$var$TAG_PROPERTIES.INNER_HTML || attribute === $274ffc8236991365$var$TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function(string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + $274ffc8236991365$var$encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");
        var tagContent = tag.innerHTML || tag.cssText || "";
        var isSelfClosing = $274ffc8236991365$var$SELF_CLOSING_TAGS.indexOf(type) === -1;
        return str + "<" + type + " " + $274ffc8236991365$var$HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};
var $274ffc8236991365$var$convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(attributes).reduce(function(obj, key) {
        obj[$274ffc8236991365$var$REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};
var $274ffc8236991365$var$convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(props).reduce(function(obj, key) {
        obj[$274ffc8236991365$var$HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};
var $274ffc8236991365$var$generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;
    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[$274ffc8236991365$var$HELMET_ATTRIBUTE] = true, _initProps);
    var props = $274ffc8236991365$var$convertElementAttributestoReactProps(attributes, initProps);
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement($274ffc8236991365$var$TAG_NAMES.TITLE, props, title)
    ];
};
var $274ffc8236991365$var$generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function(tag, i) {
        var _mappedTag;
        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[$274ffc8236991365$var$HELMET_ATTRIBUTE] = true, _mappedTag);
        Object.keys(tag).forEach(function(attribute) {
            var mappedAttribute = $274ffc8236991365$var$REACT_TAG_MAP[attribute] || attribute;
            if (mappedAttribute === $274ffc8236991365$var$TAG_PROPERTIES.INNER_HTML || mappedAttribute === $274ffc8236991365$var$TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement(type, mappedTag);
    });
};
var $274ffc8236991365$var$getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch(type){
        case $274ffc8236991365$var$TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return $274ffc8236991365$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return $274ffc8236991365$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case $274ffc8236991365$var$ATTRIBUTE_NAMES.BODY:
        case $274ffc8236991365$var$ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return $274ffc8236991365$var$convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return $274ffc8236991365$var$generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return $274ffc8236991365$var$generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return $274ffc8236991365$var$generateTagsAsString(type, tags, encode);
                }
            };
    }
};
var $274ffc8236991365$var$mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === undefined ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
    return {
        base: $274ffc8236991365$var$getMethodsForTag($274ffc8236991365$var$TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: $274ffc8236991365$var$getMethodsForTag($274ffc8236991365$var$ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: $274ffc8236991365$var$getMethodsForTag($274ffc8236991365$var$ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: $274ffc8236991365$var$getMethodsForTag($274ffc8236991365$var$TAG_NAMES.LINK, linkTags, encode),
        meta: $274ffc8236991365$var$getMethodsForTag($274ffc8236991365$var$TAG_NAMES.META, metaTags, encode),
        noscript: $274ffc8236991365$var$getMethodsForTag($274ffc8236991365$var$TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: $274ffc8236991365$var$getMethodsForTag($274ffc8236991365$var$TAG_NAMES.SCRIPT, scriptTags, encode),
        style: $274ffc8236991365$var$getMethodsForTag($274ffc8236991365$var$TAG_NAMES.STYLE, styleTags, encode),
        title: $274ffc8236991365$var$getMethodsForTag($274ffc8236991365$var$TAG_NAMES.TITLE, {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var $274ffc8236991365$var$Helmet = function Helmet(Component) {
    var _class, _temp;
    return _temp = _class = function(_React$Component) {
        $274ffc8236991365$var$inherits(HelmetWrapper, _React$Component);
        function HelmetWrapper() {
            $274ffc8236991365$var$classCallCheck(this, HelmetWrapper);
            return $274ffc8236991365$var$possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($a0e0aea147ee92d4$exports)))(this.props, nextProps);
        };
        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) return null;
            switch(child.type){
                case $274ffc8236991365$var$TAG_NAMES.SCRIPT:
                case $274ffc8236991365$var$TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };
                case $274ffc8236991365$var$TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }
            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };
        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;
            var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
            return $274ffc8236991365$var$_extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [
                $274ffc8236991365$var$_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))
            ]), _babelHelpers$extends));
        };
        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;
            var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
            switch(child.type){
                case $274ffc8236991365$var$TAG_NAMES.TITLE:
                    return $274ffc8236991365$var$_extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = $274ffc8236991365$var$_extends({}, newChildProps), _babelHelpers$extends2));
                case $274ffc8236991365$var$TAG_NAMES.BODY:
                    return $274ffc8236991365$var$_extends({}, newProps, {
                        bodyAttributes: $274ffc8236991365$var$_extends({}, newChildProps)
                    });
                case $274ffc8236991365$var$TAG_NAMES.HTML:
                    return $274ffc8236991365$var$_extends({}, newProps, {
                        htmlAttributes: $274ffc8236991365$var$_extends({}, newChildProps)
                    });
            }
            return $274ffc8236991365$var$_extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = $274ffc8236991365$var$_extends({}, newChildProps), _babelHelpers$extends3));
        };
        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = $274ffc8236991365$var$_extends({}, newProps);
            Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
                var _babelHelpers$extends4;
                newFlattenedProps = $274ffc8236991365$var$_extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });
            return newFlattenedProps;
        };
        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            return true;
        };
        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;
            var arrayTypeChildren = {};
            (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).Children.forEach(children, function(child) {
                if (!child || !child.props) return;
                var _child$props = child.props, nestedChildren = _child$props.children, childProps = $274ffc8236991365$var$objectWithoutProperties(_child$props, [
                    "children"
                ]);
                var newChildProps = $274ffc8236991365$var$convertReactPropstoHtmlAttributes(childProps);
                _this2.warnOnInvalidChildren(child, nestedChildren);
                switch(child.type){
                    case $274ffc8236991365$var$TAG_NAMES.LINK:
                    case $274ffc8236991365$var$TAG_NAMES.META:
                    case $274ffc8236991365$var$TAG_NAMES.NOSCRIPT:
                    case $274ffc8236991365$var$TAG_NAMES.SCRIPT:
                    case $274ffc8236991365$var$TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });
            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };
        HelmetWrapper.prototype.render = function render() {
            var _props = this.props, children = _props.children, props = $274ffc8236991365$var$objectWithoutProperties(_props, [
                "children"
            ]);
            var newProps = $274ffc8236991365$var$_extends({}, props);
            if (children) newProps = this.mapChildrenToProps(children, newProps);
            return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement(Component, newProps);
        };
        $274ffc8236991365$var$createClass(HelmetWrapper, null, [
            {
                key: "canUseDOM",
                // Component.peek comes from react-side-effect:
                // For testing, you may use a static peek() method available on the returned component.
                // It lets you get the current state without resetting the mounted instance stack.
                // Don’t use it for anything other than testing.
                /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */ set: function set$$1(canUseDOM) {
                    Component.canUseDOM = canUseDOM;
                }
            }
        ]);
        return HelmetWrapper;
    }((0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).Component), _class.propTypes = {
        base: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).object,
        bodyAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).object,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).node),
            (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).node
        ]),
        defaultTitle: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).string,
        defer: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).bool,
        encodeSpecialCharacters: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).bool,
        htmlAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).object,
        link: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).object),
        meta: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).object),
        noscript: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).object),
        onChangeClientState: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).func,
        script: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).object),
        style: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).object),
        title: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).string,
        titleAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).object,
        titleTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function() {
        var mappedState = Component.rewind();
        if (!mappedState) // provide fallback if mappedState is undefined
        mappedState = $274ffc8236991365$var$mapStateOnServer({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
        return mappedState;
    }, _temp;
};
var $274ffc8236991365$var$NullComponent = function NullComponent() {
    return null;
};
var $274ffc8236991365$var$HelmetSideEffects = (0, (/*@__PURE__*/$parcel$interopDefault($af58b94c7be16602$exports)))($274ffc8236991365$var$reducePropsToState, $274ffc8236991365$var$handleClientStateChange, $274ffc8236991365$var$mapStateOnServer)($274ffc8236991365$var$NullComponent);
var $274ffc8236991365$export$dcef8f9bb9a41431 = $274ffc8236991365$var$Helmet($274ffc8236991365$var$HelmetSideEffects);
$274ffc8236991365$export$dcef8f9bb9a41431.renderStatic = $274ffc8236991365$export$dcef8f9bb9a41431.rewind;
var $274ffc8236991365$export$2e2bcd8739ae039 = $274ffc8236991365$export$dcef8f9bb9a41431;






var $8FY87 = parcelRequire("8FY87");

const $15f843926e6efc0a$var$CategoryItem = (props)=>{
    // const [isChecked, setIsChecked] = React.useState(props.isChecked);
    const onCheckChange = ()=>{
        // setIsChecked(!isChecked);
        props.onCheckChanged(!props.isChecked);
    };
    const screenWidth = screen.width;
    return /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex w-full flex-row md:text-white text-sm font-body",
        "data-test": props['data-test']
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: ""
    }, /*#__PURE__*/ $8FY87.createElement((0, $0bade2783a449747$export$2e2bcd8739ae039), {
        className: "md:hidden",
        checked: props.isChecked,
        onChange: onCheckChange,
        size: "small",
        sx: {
            color: '#3B3B3B',
            fontSize: "14px",
            "&.Mui-checked": {
                color: '#3B3B3B'
            }
        }
    }), /*#__PURE__*/ $8FY87.createElement((0, $0bade2783a449747$export$2e2bcd8739ae039), {
        className: "hidden md:inline-flex",
        checked: props.isChecked,
        onChange: (e)=>{
            onCheckChange();
        },
        size: "small",
        sx: {
            color: 'white',
            fontSize: "14px",
            "&.Mui-checked": {
                color: 'white'
            }
        }
    })), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "w-full self-center hover:cursor-pointer text-grey-primary md:text-white",
        onClick: ()=>onCheckChange()
    }, props.item.category), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "w-8 self-center"
    }, props.item.cnt));
};
var $15f843926e6efc0a$export$2e2bcd8739ae039 = $15f843926e6efc0a$var$CategoryItem;



var $8FY87 = parcelRequire("8FY87");

const $4be3312f074019e3$var$TemplateTypeItem = (props)=>{
    // const [isChecked, setIsChecked] = React.useState(props.isChecked);
    const onCheckFilterTypeChange = ()=>{
        // setIsChecked(!isChecked);
        props.onCheckFilterTypeChanged(!props.isChecked);
    };
    // console.log(props.item)
    const screenWidth = screen.width;
    return /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex w-full flex-row md:text-white text-sm font-body",
        "data-test": props['data-test']
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: ""
    }, /*#__PURE__*/ $8FY87.createElement((0, $0bade2783a449747$export$2e2bcd8739ae039), {
        className: "md:hidden",
        checked: props.isChecked,
        onChange: (e)=>{
            onCheckFilterTypeChange();
        },
        size: "small",
        sx: {
            color: '#3B3B3B',
            fontSize: "14px",
            "&.Mui-checked": {
                color: '#3B3B3B'
            }
        }
    }), /*#__PURE__*/ $8FY87.createElement((0, $0bade2783a449747$export$2e2bcd8739ae039), {
        className: "hidden md:inline-flex",
        checked: props.isChecked,
        onChange: (e)=>{
            onCheckFilterTypeChange();
        },
        size: "small",
        sx: {
            color: 'white',
            fontSize: "14px",
            "&.Mui-checked": {
                color: 'white'
            }
        }
    })), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "w-full self-center hover:cursor-pointer text-grey-primary md:text-white",
        onClick: ()=>onCheckFilterTypeChange()
    }, props.item.category), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "w-8 self-center hidden"
    }, props.item.cnt));
};
var $4be3312f074019e3$export$2e2bcd8739ae039 = $4be3312f074019e3$var$TemplateTypeItem;



var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $bvo1Q = parcelRequire("bvo1Q");

var $bZmXB = parcelRequire("bZmXB");

var $lXBIJ = parcelRequire("lXBIJ");


var $lbp1P = parcelRequire("lbp1P");

var $6lkQ3 = parcelRequire("6lkQ3");


var $8FY87 = parcelRequire("8FY87");
'use client';
/**
 * @ignore - internal component.
 */ const $f5773f918d303110$var$GridContext = /*#__PURE__*/ $8FY87.createContext();
var $f5773f918d303110$export$2e2bcd8739ae039 = $f5773f918d303110$var$GridContext;



var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $e32bb39b974b226a$export$9973ac5fd0181f33(slot) {
    return (0, $jP65K.default)('MuiGrid', slot);
}
const $e32bb39b974b226a$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $e32bb39b974b226a$var$DIRECTIONS = [
    'column-reverse',
    'column',
    'row-reverse',
    'row'
];
const $e32bb39b974b226a$var$WRAPS = [
    'nowrap',
    'wrap-reverse',
    'wrap'
];
const $e32bb39b974b226a$var$GRID_SIZES = [
    'auto',
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $e32bb39b974b226a$var$gridClasses = (0, $cOYaX.default)('MuiGrid', [
    'root',
    'container',
    'item',
    'zeroMinWidth',
    // spacings
    ...$e32bb39b974b226a$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$e32bb39b974b226a$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$e32bb39b974b226a$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$e32bb39b974b226a$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$e32bb39b974b226a$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$e32bb39b974b226a$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$e32bb39b974b226a$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$e32bb39b974b226a$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $e32bb39b974b226a$export$2e2bcd8739ae039 = $e32bb39b974b226a$var$gridClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $cd77759458271780$var$_excluded = [
    "className",
    "columns",
    "columnSpacing",
    "component",
    "container",
    "direction",
    "item",
    "rowSpacing",
    "spacing",
    "wrap",
    "zeroMinWidth"
];
function $cd77759458271780$var$getOffset(val) {
    const parse = parseFloat(val);
    return `${parse}${String(val).replace(String(parse), '') || 'px'}`;
}
function $cd77759458271780$export$ca2a698f6020fda({ theme: theme, ownerState: ownerState }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        else if (size === 'auto') styles = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        else {
            const columnsBreakpointValues = (0, $bvo1Q.resolveBreakpointValues)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === 'object' ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
            // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== '0px') {
                    const fullWidth = `calc(${width} + ${$cd77759458271780$var$getOffset(themeSpacing)})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            }
            // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = (0, $zgVxD.default)({
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width
            }, more);
        }
        // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function $cd77759458271780$export$71d4225eeb1bc13e({ theme: theme, ownerState: ownerState }) {
    const directionValues = (0, $bvo1Q.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, $bvo1Q.handleBreakpoints)({
        theme: theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.indexOf('column') === 0) output[`& > .${(0, $e32bb39b974b226a$export$2e2bcd8739ae039).item}`] = {
            maxWidth: 'none'
        };
        return output;
    });
}
/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */ function $cd77759458271780$var$extractZeroValueBreakpointKeys({ breakpoints: breakpoints, values: values }) {
    let nonZeroKey = '';
    Object.keys(values).forEach((key)=>{
        if (nonZeroKey !== '') return;
        if (values[key] !== 0) nonZeroKey = key;
    });
    const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a, b)=>{
        return breakpoints[a] - breakpoints[b];
    });
    return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function $cd77759458271780$export$380604d7c79f9e8f({ theme: theme, ownerState: ownerState }) {
    const { container: container, rowSpacing: rowSpacing } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, $bvo1Q.resolveBreakpointValues)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof rowSpacingValues === 'object') zeroValueBreakpointKeys = $cd77759458271780$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: rowSpacingValues
        });
        styles = (0, $bvo1Q.handleBreakpoints)({
            theme: theme
        }, rowSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') return {
                marginTop: `-${$cd77759458271780$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $e32bb39b974b226a$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: $cd77759458271780$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK.includes(breakpoint)) return {};
            return {
                marginTop: 0,
                [`& > .${(0, $e32bb39b974b226a$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: 0
                }
            };
        });
    }
    return styles;
}
function $cd77759458271780$export$4315fba5128fb4a1({ theme: theme, ownerState: ownerState }) {
    const { container: container, columnSpacing: columnSpacing } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, $bvo1Q.resolveBreakpointValues)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof columnSpacingValues === 'object') zeroValueBreakpointKeys = $cd77759458271780$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: columnSpacingValues
        });
        styles = (0, $bvo1Q.handleBreakpoints)({
            theme: theme
        }, columnSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK2;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') return {
                width: `calc(100% + ${$cd77759458271780$var$getOffset(themeSpacing)})`,
                marginLeft: `-${$cd77759458271780$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $e32bb39b974b226a$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: $cd77759458271780$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK2 = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK2.includes(breakpoint)) return {};
            return {
                width: '100%',
                marginLeft: 0,
                [`& > .${(0, $e32bb39b974b226a$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: 0
                }
            };
        });
    }
    return styles;
}
function $cd77759458271780$export$4ffcd0b3420424d2(spacing, breakpoints, styles = {}) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        styles[`spacing-xs-${String(spacing)}`]
    ];
    // in case of object `spacing`
    const spacingStyles = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) spacingStyles.push(styles[`spacing-${breakpoint}-${String(value)}`]);
    });
    return spacingStyles;
}
// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const $cd77759458271780$var$GridRoot = (0, $lbp1P.default)('div', {
    name: 'MuiGrid',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
        let spacingStyles = [];
        // in case of grid item
        if (container) spacingStyles = $cd77759458271780$export$4ffcd0b3420424d2(spacing, breakpoints, styles);
        const breakpointsStyles = [];
        breakpoints.forEach((breakpoint)=>{
            const value = ownerState[breakpoint];
            if (value) breakpointsStyles.push(styles[`grid-${breakpoint}-${String(value)}`]);
        });
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...spacingStyles,
            direction !== 'row' && styles[`direction-xs-${String(direction)}`],
            wrap !== 'wrap' && styles[`wrap-xs-${String(wrap)}`],
            ...breakpointsStyles
        ];
    }
})(({ ownerState: ownerState })=>(0, $zgVxD.default)({
        boxSizing: 'border-box'
    }, ownerState.container && {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%'
    }, ownerState.item && {
        margin: 0 // For instance, it's useful when used with a `figure` element.
    }, ownerState.zeroMinWidth && {
        minWidth: 0
    }, ownerState.wrap !== 'wrap' && {
        flexWrap: ownerState.wrap
    }), $cd77759458271780$export$71d4225eeb1bc13e, $cd77759458271780$export$380604d7c79f9e8f, $cd77759458271780$export$4315fba5128fb4a1, $cd77759458271780$export$ca2a698f6020fda);
function $cd77759458271780$export$2d1097e8e67cf24b(spacing, breakpoints) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        `spacing-xs-${String(spacing)}`
    ];
    // in case of object `spacing`
    const classes = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) {
            const className = `spacing-${breakpoint}-${String(value)}`;
            classes.push(className);
        }
    });
    return classes;
}
const $cd77759458271780$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
    let spacingClasses = [];
    // in case of grid item
    if (container) spacingClasses = $cd77759458271780$export$2d1097e8e67cf24b(spacing, breakpoints);
    const breakpointsClasses = [];
    breakpoints.forEach((breakpoint)=>{
        const value = ownerState[breakpoint];
        if (value) breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    });
    const slots = {
        root: [
            'root',
            container && 'container',
            item && 'item',
            zeroMinWidth && 'zeroMinWidth',
            ...spacingClasses,
            direction !== 'row' && `direction-xs-${String(direction)}`,
            wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
            ...breakpointsClasses
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $e32bb39b974b226a$export$9973ac5fd0181f33), classes);
};
const $cd77759458271780$var$Grid = /*#__PURE__*/ $8FY87.forwardRef(function Grid(inProps, ref) {
    const themeProps = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiGrid'
    });
    const { breakpoints: breakpoints } = (0, $0f82922e8f0d344d$export$2e2bcd8739ae039)();
    const props = (0, $bZmXB.default)(themeProps);
    const { className: className, columns: columnsProp, columnSpacing: columnSpacingProp, component: component = 'div', container: container = false, direction: direction = 'row', item: item = false, rowSpacing: rowSpacingProp, spacing: spacing = 0, wrap: wrap = 'wrap', zeroMinWidth: zeroMinWidth = false } = props, other = (0, $93aRW.default)(props, $cd77759458271780$var$_excluded);
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = $8FY87.useContext((0, $f5773f918d303110$export$2e2bcd8739ae039));
    // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const breakpointsValues = {};
    const otherFiltered = (0, $zgVxD.default)({}, other);
    breakpoints.keys.forEach((breakpoint)=>{
        if (other[breakpoint] != null) {
            breakpointsValues[breakpoint] = other[breakpoint];
            delete otherFiltered[breakpoint];
        }
    });
    const ownerState = (0, $zgVxD.default)({}, props, {
        columns: columns,
        container: container,
        direction: direction,
        item: item,
        rowSpacing: rowSpacing,
        columnSpacing: columnSpacing,
        wrap: wrap,
        zeroMinWidth: zeroMinWidth,
        spacing: spacing
    }, breakpointsValues, {
        breakpoints: breakpoints.keys
    });
    const classes = $cd77759458271780$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $f5773f918d303110$export$2e2bcd8739ae039).Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, $2PPWI.jsx)($cd77759458271780$var$GridRoot, (0, $zgVxD.default)({
            ownerState: ownerState,
            className: (0, $efJYy.default)(classes.root, className),
            as: component,
            ref: ref
        }, otherFiltered))
    });
});
var $cd77759458271780$export$2e2bcd8739ae039 = $cd77759458271780$var$Grid;




var $8FY87 = parcelRequire("8FY87");

var $8FY87 = parcelRequire("8FY87");







var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");



var $d5ARM = parcelRequire("d5ARM");

var $jP65K = parcelRequire("jP65K");

var $lXBIJ = parcelRequire("lXBIJ");

var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");

var $hDbmX = parcelRequire("hDbmX");

var $d5ARM = parcelRequire("d5ARM");



var $1BEIC = parcelRequire("1BEIC");

var $lqCXV = parcelRequire("lqCXV");
const $3622a77d93097dd5$var$_excluded = [
    "ownerState"
], $3622a77d93097dd5$var$_excluded2 = [
    "variants"
], $3622a77d93097dd5$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $3622a77d93097dd5$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $3622a77d93097dd5$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $3622a77d93097dd5$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $3622a77d93097dd5$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
const $3622a77d93097dd5$export$35e57303dbd8a66 = (0, $1BEIC.default)();
const $3622a77d93097dd5$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $3622a77d93097dd5$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $3622a77d93097dd5$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $3622a77d93097dd5$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $3622a77d93097dd5$var$processStyleArg(callableStyle, _ref, layerName) {
    let { ownerState: ownerState } = _ref, props = (0, $93aRW.default)(_ref, $3622a77d93097dd5$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, $zgVxD.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$3622a77d93097dd5$var$processStyleArg(resolvedStyle, (0, $zgVxD.default)({
            ownerState: ownerState
        }, props), layerName));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $93aRW.default)(resolvedStylesArg, $3622a77d93097dd5$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, $zgVxD.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                const variantStyle = typeof variant.style === 'function' ? variant.style((0, $zgVxD.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style;
                result.push(layerName ? $3622a77d93097dd5$var$shallowLayer((0, $hDbmX.internal_serializeStyles)(variantStyle), layerName) : variantStyle);
            }
        });
        return result;
    }
    return layerName ? $3622a77d93097dd5$var$shallowLayer((0, $hDbmX.internal_serializeStyles)(resolvedStylesArg), layerName) : resolvedStylesArg;
}
function $3622a77d93097dd5$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $3622a77d93097dd5$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $3622a77d93097dd5$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $3622a77d93097dd5$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $lqCXV.default)((0, $zgVxD.default)({}, props, {
            theme: $3622a77d93097dd5$var$resolveTheme((0, $zgVxD.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $hDbmX.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $3622a77d93097dd5$var$defaultOverridesResolver($3622a77d93097dd5$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $93aRW.default)(inputOptions, $3622a77d93097dd5$var$_excluded3);
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $3622a77d93097dd5$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($3622a77d93097dd5$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $hDbmX.default)(tag, (0, $zgVxD.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, $d5ARM.isPlainObject)(stylesArg)) return (props)=>{
                const theme = $3622a77d93097dd5$var$resolveTheme({
                    theme: props.theme,
                    defaultTheme: defaultTheme,
                    themeId: themeId
                });
                return $3622a77d93097dd5$var$processStyleArg(stylesArg, (0, $zgVxD.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? layerName : undefined);
            };
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $3622a77d93097dd5$var$resolveTheme((0, $zgVxD.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $3622a77d93097dd5$var$processStyleArg(slotStyle, (0, $zgVxD.default)({}, props, {
                        theme: theme
                    }), theme.modularCssLayers ? 'theme' : undefined);
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $3622a77d93097dd5$var$resolveTheme((0, $zgVxD.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $3622a77d93097dd5$var$processStyleArg({
                    variants: themeVariants
                }, (0, $zgVxD.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}


const $1d6de6ddc483a5d0$var$styled = (0, $3622a77d93097dd5$export$2e2bcd8739ae039)();
var $1d6de6ddc483a5d0$export$2e2bcd8739ae039 = $1d6de6ddc483a5d0$var$styled;



var $1p637 = parcelRequire("1p637");
function $df8eefd5287561a6$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $1p637.default)(theme.components[name].defaultProps, props);
}



'use client';
function $6ead70688dfc969e$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $4ec357bcdd79021e$export$2e2bcd8739ae039)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $df8eefd5287561a6$export$2e2bcd8739ae039)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}



var $bZmXB = parcelRequire("bZmXB");

var $1BEIC = parcelRequire("1BEIC");

var $bvo1Q = parcelRequire("bvo1Q");

var $keZWu = parcelRequire("keZWu");

var $2PPWI = parcelRequire("2PPWI");
const $c7f70716f1cb02a1$var$_excluded = [
    "component",
    "direction",
    "spacing",
    "divider",
    "children",
    "className",
    "useFlexGap"
];
const $c7f70716f1cb02a1$var$defaultTheme = (0, $1BEIC.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $c7f70716f1cb02a1$var$defaultCreateStyledComponent = (0, $1d6de6ddc483a5d0$export$2e2bcd8739ae039)('div', {
    name: 'MuiStack',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
});
function $c7f70716f1cb02a1$var$useThemePropsDefault(props) {
    return (0, $6ead70688dfc969e$export$2e2bcd8739ae039)({
        props: props,
        name: 'MuiStack',
        defaultTheme: $c7f70716f1cb02a1$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $c7f70716f1cb02a1$var$joinChildren(children, separator) {
    const childrenArray = $8FY87.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $8FY87.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $c7f70716f1cb02a1$var$getSideFromDirection = (direction)=>{
    return ({
        row: 'Left',
        'row-reverse': 'Right',
        column: 'Top',
        'column-reverse': 'Bottom'
    })[direction];
};
const $c7f70716f1cb02a1$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = (0, $zgVxD.default)({
        display: 'flex',
        flexDirection: 'column'
    }, (0, $bvo1Q.handleBreakpoints)({
        theme: theme
    }, (0, $bvo1Q.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    }), (propValue)=>({
            flexDirection: propValue
        })));
    if (ownerState.spacing) {
        const transformer = (0, $keZWu.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $bvo1Q.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $bvo1Q.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === 'object') Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $keZWu.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                '& > :not(style):not(style)': {
                    margin: 0
                },
                '& > :not(style) ~ :not(style)': {
                    [`margin${$c7f70716f1cb02a1$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $keZWu.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $d5ARM.default)(styles, (0, $bvo1Q.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $bvo1Q.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $c7f70716f1cb02a1$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $c7f70716f1cb02a1$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $c7f70716f1cb02a1$var$useThemePropsDefault, componentName: componentName = 'MuiStack' } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                'root'
            ]
        };
        return (0, $lXBIJ.default)(slots, (slot)=>(0, $jP65K.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($c7f70716f1cb02a1$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $8FY87.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $bZmXB.default)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = 'div', direction: direction = 'column', spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false } = props, other = (0, $93aRW.default)(props, $c7f70716f1cb02a1$var$_excluded);
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $2PPWI.jsx)(StackRoot, (0, $zgVxD.default)({
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $8bcfdb8fb9b51cc8$export$2e2bcd8739ae039)(classes.root, className)
        }, other, {
            children: divider ? $c7f70716f1cb02a1$var$joinChildren(children, divider) : children
        }));
    });
    return Stack;
}



var $lbp1P = parcelRequire("lbp1P");

var $6lkQ3 = parcelRequire("6lkQ3");
'use client';
const $d867c99355c0715a$var$Stack = (0, $c7f70716f1cb02a1$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $lbp1P.default)('div', {
        name: 'MuiStack',
        slot: 'Root',
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $6lkQ3.useDefaultProps)({
            props: inProps,
            name: 'MuiStack'
        })
});
var $d867c99355c0715a$export$2e2bcd8739ae039 = $d867c99355c0715a$var$Stack;



const $6f2f2649fb3fde09$var$TemplateItem = (props)=>{
    const navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    // console.log("TemplateItem", props);
    const [showOption, setShowOption] = $8FY87.useState(false);
    const [isLoading, setIsLoading] = $8FY87.useState(true);
    const [selectedColorPallet, setSelectedColorPallet] = $8FY87.useState({
        ...props.templateColorPalettes[0],
        initial: true
    });
    $8FY87.useEffect(()=>{}, [
        selectedColorPallet
    ]);
    const handleImageLoad = ()=>{
        setIsLoading(false);
    };
    return /*#__PURE__*/ $8FY87.createElement((0, $cd77759458271780$export$2e2bcd8739ae039), {
        justifyContent: "space-between",
        item: true,
        lg: 4,
        md: 6,
        sm: 6,
        xs: 12,
        "data-test": "template",
        "data-page-count": props.pageCount,
        "data-categories": props.templateCategories
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-row justify-between items-center text-black text-sm py-2"
    }, /*#__PURE__*/ $8FY87.createElement("span", null, props.templateName), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-row items-center"
    }, props.templateColorPalettes.map((row)=>{
        let colorPallet = props.colorPallets.length > 0 && props.colorPallets.find((oo)=>oo.id === row.id) || null;
        // console.log("for each", colorPallet.colors);
        return colorPallet ? /*#__PURE__*/ $8FY87.createElement("div", {
            onClick: ()=>setSelectedColorPallet(row),
            key: row.id,
            className: `flex flex-row  color-icon relative  hover:cursor-pointer`
        }, /*#__PURE__*/ $8FY87.createElement("span", {
            className: `h-6 w-3 block rounded-l-full ${selectedColorPallet.id === row.id ? "border-y border-l border-black" : "border-y border-l border-gray-100"} `,
            style: {
                backgroundColor: colorPallet ? colorPallet.colors[0].toLowerCase() : ""
            }
        }), /*#__PURE__*/ $8FY87.createElement("span", {
            className: "icon-tooltip-text brand-color-tooltip"
        }, "Select brand colors"), /*#__PURE__*/ $8FY87.createElement("div", {
            className: "flex flex-col"
        }, /*#__PURE__*/ $8FY87.createElement("span", {
            className: `h-3 w-3 block rounded-tr-full ${selectedColorPallet.id === row.id ? "border-t border-r border-black" : "border-t border-r border-gray-100"} `,
            style: {
                backgroundColor: colorPallet ? colorPallet.colors[1].toLowerCase() : ""
            }
        }), /*#__PURE__*/ $8FY87.createElement("span", {
            className: `h-3 w-3 block rounded-br-full ${selectedColorPallet.id === row.id ? "border-b border-r border-black" : "border-b border-r border-gray-100"} `,
            style: {
                backgroundColor: colorPallet ? colorPallet.colors[3].toLowerCase() : ""
            }
        }))) : /*#__PURE__*/ $8FY87.createElement("div", {
            key: row.id,
            className: `flex flex-row relative`
        }, /*#__PURE__*/ $8FY87.createElement("span", {
            className: `h-6 w-3 block rounded-l-full`
        }));
    }))), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col hover:cursor-pointer relative shadow-lg",
        "data-test": "template-image",
        onMouseOver: ()=>setShowOption(true),
        onMouseLeave: ()=>setShowOption(false)
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "upper-block flex flex-col "
    }, /*#__PURE__*/ $8FY87.createElement("img", {
        src: (parcelRequire("8DHux"))
    }), isLoading && /*#__PURE__*/ $8FY87.createElement("div", {
        className: "inner-block flex flex-col"
    }), selectedColorPallet.imageUrl ? /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, null, /*#__PURE__*/ $8FY87.createElement("img", {
        className: `${showOption && !isLoading ? "bg-black opacity-30" : ""} ${isLoading ? "hidden" : "block"} image-template`,
        src: `${selectedColorPallet.imageUrl}?w=162&auto=format`,
        srcSet: `${selectedColorPallet.imageUrl}?w=162&auto=format&dpr=2 2x`,
        alt: props.templateName,
        loading: "lazy",
        onLoad: handleImageLoad,
        onError: handleImageLoad,
        style: {
            borderBottomLeftRadius: 4,
            borderBottomRightRadius: 4,
            display: "block",
            boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.2)"
        }
    })) : /*#__PURE__*/ $8FY87.createElement("div", {
        className: "min-h-96 flex items-center justify-center",
        style: {
            minHeight: "700px"
        }
    }, /*#__PURE__*/ $8FY87.createElement("svg", {
        className: "animate-spin -ml-1 mr-3 h-5 w-5 text-red",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ $8FY87.createElement("circle", {
        className: "opacity-25",
        cx: "12",
        cy: "12",
        r: "10",
        stroke: "currentColor",
        strokeWidth: "4"
    }), /*#__PURE__*/ $8FY87.createElement("path", {
        className: "opacity-75",
        fill: "currentColor",
        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    })), " ", "Loading"), showOption && !isLoading && /*#__PURE__*/ $8FY87.createElement("div", {
        className: "absolute w-full h-full  flex justify-center items-center"
    }, /*#__PURE__*/ $8FY87.createElement((0, $d867c99355c0715a$export$2e2bcd8739ae039), {
        direction: "column",
        spacing: 1
    }, /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        variant: "contained",
        size: "small",
        sx: {
            backgroundColor: "#fff",
            color: "#243060",
            textTransform: "none",
            "&:hover": {
                backgroundColor: "#243060",
                color: "#fff"
            }
        },
        onClick: ()=>{
            // console.log("on edit", props);
            window.location.href = `${"http://editor.rocketpages.io"}/?tid=${props.siteId}&theme=${selectedColorPallet ? selectedColorPallet.id : ""}`;
        // window.location.reload();
        },
        startIcon: /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7c8f2ac2998e8e4d$exports))), null)
    }, "Edit site"), /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        variant: "contained",
        size: "small",
        sx: {
            backgroundColor: "#fff",
            color: "#243060",
            textTransform: "none",
            "&:hover": {
                backgroundColor: "#243060",
                color: "#fff"
            }
        },
        onClick: ()=>{
            // window.location.href = props.previewUrl
            // navigate(`/preview/${props.siteId}`, {
            //   state: { selectedColorPallet },
            // });
            const url = `/preview/${props.siteId}?id=${selectedColorPallet.id}`;
            window.open(url, "_blank");
        },
        startIcon: /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3b2767003d20258a$exports))), null)
    }, "Preview"))))));
};
var $6f2f2649fb3fde09$export$2e2bcd8739ae039 = $6f2f2649fb3fde09$var$TemplateItem;


const $91b59757eee8adac$var$TemplateBody = (props)=>{
    // console.log('TemplateBody',props);
    const heights = [
        150,
        30,
        90,
        70,
        110,
        150,
        130,
        80,
        50,
        90,
        100,
        150,
        30,
        50,
        80
    ];
    return /*#__PURE__*/ $8FY87.createElement((0, $b19176bd78e1869f$export$2e2bcd8739ae039), {
        sx: {
            minHeight: 829
        }
    }, /*#__PURE__*/ $8FY87.createElement((0, $cd77759458271780$export$2e2bcd8739ae039), {
        container: true,
        rowSpacing: {
            lg: 8,
            md: 6,
            sm: 6,
            xs: 5
        },
        columnSpacing: 2.5,
        style: {
            marginTop: 0
        },
        sx: {
            '& .MuiGrid-root': {
                paddingTop: 0,
                marginTop: 0,
                marginBottom: '64px',
                // Add media queries here
                '@media (max-width: 600px)': {
                    marginBottom: '32px'
                }
            },
            '& .MuiGrid-container': {
                marginTop: 0
            }
        }
    }, props.templateData.map((item, index)=>/*#__PURE__*/ $8FY87.createElement((0, $6f2f2649fb3fde09$export$2e2bcd8739ae039), {
            key: item.siteId,
            ...item,
            colorPallets: props.colorPallets,
            sx: {
                height: heights[index]
            },
            index: index
        }))));
};
const $91b59757eee8adac$var$itemData = [
    {
        img: "https://images.unsplash.com/photo-1518756131217-31eb79b20e8f",
        title: "Fern"
    },
    {
        img: "https://images.unsplash.com/photo-1627308595229-7830a5c91f9f",
        title: "Snacks"
    },
    {
        img: "https://images.unsplash.com/photo-1597645587822-e99fa5d45d25",
        title: "Mushrooms"
    },
    {
        img: "https://images.unsplash.com/photo-1529655683826-aba9b3e77383",
        title: "Tower"
    },
    {
        img: "https://images.unsplash.com/photo-1471357674240-e1a485acb3e1",
        title: "Sea star"
    },
    {
        img: "https://images.unsplash.com/photo-1558642452-9d2a7deb7f62",
        title: "Honey"
    },
    {
        img: "https://images.unsplash.com/photo-1516802273409-68526ee1bdd6",
        title: "Basketball"
    },
    {
        img: "https://images.unsplash.com/photo-1551963831-b3b1ca40c98e",
        title: "Breakfast"
    },
    {
        img: "https://images.unsplash.com/photo-1627328715728-7bcc1b5db87d",
        title: "Tree"
    },
    {
        img: "https://images.unsplash.com/photo-1551782450-a2132b4ba21d",
        title: "Burger"
    },
    {
        img: "https://images.unsplash.com/photo-1522770179533-24471fcdba45",
        title: "Camera"
    },
    {
        img: "https://images.unsplash.com/photo-1444418776041-9c7e33cc5a9c",
        title: "Coffee"
    },
    {
        img: "https://images.unsplash.com/photo-1627000086207-76eabf23aa2e",
        title: "Camping Car"
    },
    {
        img: "https://images.unsplash.com/photo-1533827432537-70133748f5c8",
        title: "Hats"
    },
    {
        img: "https://images.unsplash.com/photo-1567306301408-9b74779a11af",
        title: "Tomato basil"
    },
    {
        img: "https://images.unsplash.com/photo-1627328561499-a3584d4ee4f7",
        title: "Mountain"
    },
    {
        img: "https://images.unsplash.com/photo-1589118949245-7d38baf380d6",
        title: "Bike"
    }
];
var $91b59757eee8adac$export$2e2bcd8739ae039 = $91b59757eee8adac$var$TemplateBody;




var $8FY87 = parcelRequire("8FY87");


const $fdcc8de0ec44fdd8$var$CookieConsent = (props)=>{
    const [cookies, setCookie, removeCookie] = (0, $1f373de1ceea6eb7$export$2e2bcd8739ae039)([
        "rp_consent"
    ]);
    const acceptCookieConsent = ()=>{
        removeCookie('rp_consent');
        const datestamp = new Date().toString();
        const cookieValue = JSON.stringify({
            consent: true,
            datestamp: datestamp
        });
        setCookie('rp_consent', cookieValue, {
            maxAge: 2592000
        }); // expires in 30 days
        document.getElementById("cookieNotice").style.display = "none";
    };
    const deniedCookieConsent = ()=>{
        removeCookie('rp_consent');
        const datestamp = new Date().toString();
        const cookieValue = JSON.stringify({
            consent: false,
            datestamp: datestamp
        });
        setCookie('rp_consent', cookieValue, {
            maxAge: 2592000
        }); // expires in 30 days
        document.getElementById("cookieNotice").style.display = "none";
    };
    (0, $8FY87.useEffect)(()=>{
        initCookieConsent();
    }, []);
    const initCookieConsent = ()=>{
        const cookieConsent = cookies.rp_consent;
        const cookieNotice = document.getElementById("cookieNotice");
        if (cookieConsent !== undefined) cookieNotice.style.display = "none";
        else cookieNotice.style.display = "flex";
    };
    const cookieConsentTemplate = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
            id: "cookieNotice",
            className: "cookieNotice fixed bottom-0 left-0 right-0 mx-auto z-50 px-5 py-5 text-white"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
            className: "w-full flex flex-col md:flex-row justify-between gap-4 mx-auto",
            style: {
                maxWidth: '1440px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
            className: "flex flex-col"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
            className: "title-wrap text-base font-semibold"
        }, "Your privacy"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
            className: "content-wrap"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
            className: "msg-wrap justify-between flex gap-4"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
            className: "text-sm"
        }, 'By clicking "Accept all cookies", you agree RocketPages can store cookies on your device and disclose information in accordance with our ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("a", {
            href: "https://rocketpages.io/privacy-policy",
            className: "underline text-white"
        }, "Cookie Policy"))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
            className: "btn-wrap items-center gap-15 flex"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("button", {
            className: "btn-accept btn cursor-pointer rounded inline-block font-semibold text-sm leading-4 bg-white",
            onClick: acceptCookieConsent
        }, "Accept all cookies"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("button", {
            className: "btn-denied btn cursor-pointer rounded inline-block font-semibold text-sm leading-4 text-white",
            onClick: deniedCookieConsent
        }, "Cancel"))));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).Fragment, null, cookieConsentTemplate());
};
var $fdcc8de0ec44fdd8$export$2e2bcd8739ae039 = $fdcc8de0ec44fdd8$var$CookieConsent;



var $8FY87 = parcelRequire("8FY87");

const $9ada84cce5691847$var$GoogleAnalytics = ()=>{
    const trackingId = "G-QZGPR1ZR8L";
    if (!trackingId) {
        console.warn("Google Analytics tracking ID is missing.");
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $274ffc8236991365$export$dcef8f9bb9a41431), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("script", {
        async: true,
        src: `https://www.googletagmanager.com/gtag/js?id=${trackingId}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("script", null, `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${trackingId}');
        `));
};
var $9ada84cce5691847$export$2e2bcd8739ae039 = $9ada84cce5691847$var$GoogleAnalytics;



var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");

var $8FY87 = parcelRequire("8FY87");



var $efJYy = parcelRequire("efJYy");


var $lXBIJ = parcelRequire("lXBIJ");

var $lbp1P = parcelRequire("lbp1P");

var $6lkQ3 = parcelRequire("6lkQ3");

var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");

var $efJYy = parcelRequire("efJYy");





var $lXBIJ = parcelRequire("lXBIJ");

var $lbp1P = parcelRequire("lbp1P");

var $6lkQ3 = parcelRequire("6lkQ3");

var $cydtL = parcelRequire("cydtL");




var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $c0cfd09b50167a39$export$5162da8f798e0959(slot) {
    return (0, $jP65K.default)('MuiCollapse', slot);
}
const $c0cfd09b50167a39$var$collapseClasses = (0, $cOYaX.default)('MuiCollapse', [
    'root',
    'horizontal',
    'vertical',
    'entered',
    'hidden',
    'wrapper',
    'wrapperInner'
]);
var $c0cfd09b50167a39$export$2e2bcd8739ae039 = $c0cfd09b50167a39$var$collapseClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $a16ff6ac5a62ea99$var$_excluded = [
    "addEndListener",
    "children",
    "className",
    "collapsedSize",
    "component",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "orientation",
    "style",
    "timeout",
    "TransitionComponent"
];
const $a16ff6ac5a62ea99$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `${orientation}`
        ],
        entered: [
            'entered'
        ],
        hidden: [
            'hidden'
        ],
        wrapper: [
            'wrapper',
            `${orientation}`
        ],
        wrapperInner: [
            'wrapperInner',
            `${orientation}`
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $c0cfd09b50167a39$export$5162da8f798e0959), classes);
};
const $a16ff6ac5a62ea99$var$CollapseRoot = (0, $lbp1P.default)('div', {
    name: 'MuiCollapse',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === 'entered' && styles.entered,
            ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $zgVxD.default)({
        height: 0,
        overflow: 'hidden',
        transition: theme.transitions.create('height')
    }, ownerState.orientation === 'horizontal' && {
        height: 'auto',
        width: 0,
        transition: theme.transitions.create('width')
    }, ownerState.state === 'entered' && (0, $zgVxD.default)({
        height: 'auto',
        overflow: 'visible'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto'
    }), ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && {
        visibility: 'hidden'
    }));
const $a16ff6ac5a62ea99$var$CollapseWrapper = (0, $lbp1P.default)('div', {
    name: 'MuiCollapse',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>styles.wrapper
})(({ ownerState: ownerState })=>(0, $zgVxD.default)({
        // Hack to get children with a negative margin to not falsify the height computation.
        display: 'flex',
        width: '100%'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto',
        height: '100%'
    }));
const $a16ff6ac5a62ea99$var$CollapseWrapperInner = (0, $lbp1P.default)('div', {
    name: 'MuiCollapse',
    slot: 'WrapperInner',
    overridesResolver: (props, styles)=>styles.wrapperInner
})(({ ownerState: ownerState })=>(0, $zgVxD.default)({
        width: '100%'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto',
        height: '100%'
    }));
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $a16ff6ac5a62ea99$var$Collapse = /*#__PURE__*/ $8FY87.forwardRef(function Collapse(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiCollapse'
    });
    const { addEndListener: addEndListener, children: children, className: className, collapsedSize: collapsedSizeProp = '0px', component: component, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, orientation: orientation = 'vertical', style: style, timeout: timeout = (0, $cydtL.duration).standard, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $f56d5c528e530759$export$2e2bcd8739ae039) } = props, other = (0, $93aRW.default)(props, $a16ff6ac5a62ea99$var$_excluded);
    const ownerState = (0, $zgVxD.default)({}, props, {
        orientation: orientation,
        collapsedSize: collapsedSizeProp
    });
    const classes = $a16ff6ac5a62ea99$var$useUtilityClasses(ownerState);
    const theme = (0, $0f82922e8f0d344d$export$2e2bcd8739ae039)();
    const timer = (0, $d5603345799722cb$export$2e2bcd8739ae039)();
    const wrapperRef = $8FY87.useRef(null);
    const autoTransitionDuration = $8FY87.useRef();
    const collapsedSize = typeof collapsedSizeProp === 'number' ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === 'horizontal';
    const size = isHorizontal ? 'width' : 'height';
    const nodeRef = $8FY87.useRef(null);
    const handleRef = (0, $520629ff5b0e6bac$export$2e2bcd8739ae039)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? 'clientWidth' : 'clientHeight'] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = 'absolute';
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = '';
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $b705961e7d923fdf$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        if (timeout === 'auto') {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = 'auto';
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $b705961e7d923fdf$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        if (timeout === 'auto') {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTransitionDuration.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $2PPWI.jsx)(TransitionComponent, (0, $zgVxD.default)({
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === 'auto' ? null : timeout
    }, other, {
        children: (state, childProps)=>/*#__PURE__*/ (0, $2PPWI.jsx)($a16ff6ac5a62ea99$var$CollapseRoot, (0, $zgVxD.default)({
                as: component,
                className: (0, $efJYy.default)(classes.root, className, {
                    'entered': classes.entered,
                    'exited': !inProp && collapsedSize === '0px' && classes.hidden
                }[state]),
                style: (0, $zgVxD.default)({
                    [isHorizontal ? 'minWidth' : 'minHeight']: collapsedSize
                }, style),
                ref: handleRef
            }, childProps, {
                // `ownerState` is set after `childProps` to override any existing `ownerState` property in `childProps`
                // that might have been forwarded from the Transition component.
                ownerState: (0, $zgVxD.default)({}, ownerState, {
                    state: state
                }),
                children: /*#__PURE__*/ (0, $2PPWI.jsx)($a16ff6ac5a62ea99$var$CollapseWrapper, {
                    ownerState: (0, $zgVxD.default)({}, ownerState, {
                        state: state
                    }),
                    className: classes.wrapper,
                    ref: wrapperRef,
                    children: /*#__PURE__*/ (0, $2PPWI.jsx)($a16ff6ac5a62ea99$var$CollapseWrapperInner, {
                        ownerState: (0, $zgVxD.default)({}, ownerState, {
                            state: state
                        }),
                        className: classes.wrapperInner,
                        children: children
                    })
                })
            }))
    }));
});
$a16ff6ac5a62ea99$var$Collapse.muiSupportAuto = true;
var $a16ff6ac5a62ea99$export$2e2bcd8739ae039 = $a16ff6ac5a62ea99$var$Collapse;




var $8FY87 = parcelRequire("8FY87");
'use client';
/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */ const $4dbf09b2da9f3e6d$var$AccordionContext = /*#__PURE__*/ $8FY87.createContext({});
var $4dbf09b2da9f3e6d$export$2e2bcd8739ae039 = $4dbf09b2da9f3e6d$var$AccordionContext;




var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");




'use client';
const $eaef84e42ea8d97c$var$_excluded = [
    "className",
    "elementType",
    "ownerState",
    "externalForwardedProps",
    "getSlotOwnerState",
    "internalForwardedProps"
], $eaef84e42ea8d97c$var$_excluded2 = [
    "component",
    "slots",
    "slotProps"
], $eaef84e42ea8d97c$var$_excluded3 = [
    "component"
];
function $eaef84e42ea8d97c$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, getSlotOwnerState: getSlotOwnerState, internalForwardedProps: internalForwardedProps } = parameters, useSlotPropsParams = (0, $93aRW.default)(parameters, $eaef84e42ea8d97c$var$_excluded);
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    } } = externalForwardedProps, other = (0, $93aRW.default)(externalForwardedProps, $eaef84e42ea8d97c$var$_excluded2);
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $97eef028f0359e85$export$2e2bcd8739ae039)(slotProps[name], ownerState);
    const _mergeSlotProps = (0, $7f9025fe45817926$export$2e2bcd8739ae039)((0, $zgVxD.default)({
        className: className
    }, useSlotPropsParams, {
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    })), { props: { component: slotComponent }, internalRef: internalRef } = _mergeSlotProps, mergedProps = (0, $93aRW.default)(_mergeSlotProps.props, $eaef84e42ea8d97c$var$_excluded3);
    const ref = (0, $a44e6282d60cc47f$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, parameters.ref);
    const slotOwnerState = getSlotOwnerState ? getSlotOwnerState(mergedProps) : {};
    const finalOwnerState = (0, $zgVxD.default)({}, ownerState, slotOwnerState);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, $1b27d471dcde43d6$export$2e2bcd8739ae039)(elementType, (0, $zgVxD.default)({}, name === 'root' && !rootComponent && !slots[name] && internalForwardedProps, name !== 'root' && !slots[name] && internalForwardedProps, mergedProps, LeafComponent && {
        as: LeafComponent
    }, {
        ref: ref
    }), finalOwnerState);
    Object.keys(slotOwnerState).forEach((propName)=>{
        delete props[propName];
    });
    return [
        elementType,
        props
    ];
}



var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $d8c2762bef64c9d3$export$80fb6a2cb3f13b8b(slot) {
    return (0, $jP65K.default)('MuiAccordion', slot);
}
const $d8c2762bef64c9d3$var$accordionClasses = (0, $cOYaX.default)('MuiAccordion', [
    'root',
    'rounded',
    'expanded',
    'disabled',
    'gutters',
    'region'
]);
var $d8c2762bef64c9d3$export$2e2bcd8739ae039 = $d8c2762bef64c9d3$var$accordionClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $136410865e81e680$var$_excluded = [
    "children",
    "className",
    "defaultExpanded",
    "disabled",
    "disableGutters",
    "expanded",
    "onChange",
    "square",
    "slots",
    "slotProps",
    "TransitionComponent",
    "TransitionProps"
];
const $136410865e81e680$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, square: square, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            'root',
            !square && 'rounded',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        region: [
            'region'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $d8c2762bef64c9d3$export$80fb6a2cb3f13b8b), classes);
};
const $136410865e81e680$var$AccordionRoot = (0, $lbp1P.default)((0, $d9c49ac25a55e29d$export$2e2bcd8739ae039), {
    name: 'MuiAccordion',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $d8c2762bef64c9d3$export$2e2bcd8739ae039).region}`]: styles.region
            },
            styles.root,
            !ownerState.square && styles.rounded,
            !ownerState.disableGutters && styles.gutters
        ];
    }
})(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        position: 'relative',
        transition: theme.transitions.create([
            'margin'
        ], transition),
        overflowAnchor: 'none',
        // Keep the same scrolling position
        '&::before': {
            position: 'absolute',
            left: 0,
            top: -1,
            right: 0,
            height: 1,
            content: '""',
            opacity: 1,
            backgroundColor: (theme.vars || theme).palette.divider,
            transition: theme.transitions.create([
                'opacity',
                'background-color'
            ], transition)
        },
        '&:first-of-type': {
            '&::before': {
                display: 'none'
            }
        },
        [`&.${(0, $d8c2762bef64c9d3$export$2e2bcd8739ae039).expanded}`]: {
            '&::before': {
                opacity: 0
            },
            '&:first-of-type': {
                marginTop: 0
            },
            '&:last-of-type': {
                marginBottom: 0
            },
            '& + &': {
                '&::before': {
                    display: 'none'
                }
            }
        },
        [`&.${(0, $d8c2762bef64c9d3$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    };
}, ({ theme: theme })=>({
        variants: [
            {
                props: (props)=>!props.square,
                style: {
                    borderRadius: 0,
                    '&:first-of-type': {
                        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
                        borderTopRightRadius: (theme.vars || theme).shape.borderRadius
                    },
                    '&:last-of-type': {
                        borderBottomLeftRadius: (theme.vars || theme).shape.borderRadius,
                        borderBottomRightRadius: (theme.vars || theme).shape.borderRadius,
                        // Fix a rendering issue on Edge
                        '@supports (-ms-ime-align: auto)': {
                            borderBottomLeftRadius: 0,
                            borderBottomRightRadius: 0
                        }
                    }
                }
            },
            {
                props: (props)=>!props.disableGutters,
                style: {
                    [`&.${(0, $d8c2762bef64c9d3$export$2e2bcd8739ae039).expanded}`]: {
                        margin: '16px 0'
                    }
                }
            }
        ]
    }));
const $136410865e81e680$var$Accordion = /*#__PURE__*/ $8FY87.forwardRef(function Accordion(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordion'
    });
    const { children: childrenProp, className: className, defaultExpanded: defaultExpanded = false, disabled: disabled = false, disableGutters: disableGutters = false, expanded: expandedProp, onChange: onChange, square: square = false, slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponentProp, TransitionProps: TransitionPropsProp } = props, other = (0, $93aRW.default)(props, $136410865e81e680$var$_excluded);
    const [expanded, setExpandedState] = (0, $a49df1dad2760ffc$export$2e2bcd8739ae039)({
        controlled: expandedProp,
        default: defaultExpanded,
        name: 'Accordion',
        state: 'expanded'
    });
    const handleChange = $8FY87.useCallback((event)=>{
        setExpandedState(!expanded);
        if (onChange) onChange(event, !expanded);
    }, [
        expanded,
        onChange,
        setExpandedState
    ]);
    const [summary, ...children] = $8FY87.Children.toArray(childrenProp);
    const contextValue = $8FY87.useMemo(()=>({
            expanded: expanded,
            disabled: disabled,
            disableGutters: disableGutters,
            toggle: handleChange
        }), [
        expanded,
        disabled,
        disableGutters,
        handleChange
    ]);
    const ownerState = (0, $zgVxD.default)({}, props, {
        square: square,
        disabled: disabled,
        disableGutters: disableGutters,
        expanded: expanded
    });
    const classes = $136410865e81e680$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = (0, $zgVxD.default)({
        transition: TransitionComponentProp
    }, slots);
    const backwardCompatibleSlotProps = (0, $zgVxD.default)({
        transition: TransitionPropsProp
    }, slotProps);
    const [TransitionSlot, transitionProps] = (0, $eaef84e42ea8d97c$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $a16ff6ac5a62ea99$export$2e2bcd8739ae039),
        externalForwardedProps: {
            slots: backwardCompatibleSlots,
            slotProps: backwardCompatibleSlotProps
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $2PPWI.jsxs)($136410865e81e680$var$AccordionRoot, (0, $zgVxD.default)({
        className: (0, $efJYy.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        square: square
    }, other, {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4dbf09b2da9f3e6d$export$2e2bcd8739ae039).Provider, {
                value: contextValue,
                children: summary
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)(TransitionSlot, (0, $zgVxD.default)({
                in: expanded,
                timeout: "auto"
            }, transitionProps, {
                children: /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                    "aria-labelledby": summary.props.id,
                    id: summary.props['aria-controls'],
                    role: "region",
                    className: classes.region,
                    children: children
                })
            }))
        ]
    }));
});
var $136410865e81e680$export$2e2bcd8739ae039 = $136410865e81e680$var$Accordion;



var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $lXBIJ = parcelRequire("lXBIJ");

var $lbp1P = parcelRequire("lbp1P");

var $6lkQ3 = parcelRequire("6lkQ3");



var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $f4106c8be7bdee4c$export$282216ad123d6580(slot) {
    return (0, $jP65K.default)('MuiAccordionSummary', slot);
}
const $f4106c8be7bdee4c$var$accordionSummaryClasses = (0, $cOYaX.default)('MuiAccordionSummary', [
    'root',
    'expanded',
    'focusVisible',
    'disabled',
    'gutters',
    'contentGutters',
    'content',
    'expandIconWrapper'
]);
var $f4106c8be7bdee4c$export$2e2bcd8739ae039 = $f4106c8be7bdee4c$var$accordionSummaryClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $5820abdea582d852$var$_excluded = [
    "children",
    "className",
    "expandIcon",
    "focusVisibleClassName",
    "onClick"
];
const $5820abdea582d852$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        focusVisible: [
            'focusVisible'
        ],
        content: [
            'content',
            expanded && 'expanded',
            !disableGutters && 'contentGutters'
        ],
        expandIconWrapper: [
            'expandIconWrapper',
            expanded && 'expanded'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $f4106c8be7bdee4c$export$282216ad123d6580), classes);
};
const $5820abdea582d852$var$AccordionSummaryRoot = (0, $lbp1P.default)((0, $21281888ae95b2bd$export$2e2bcd8739ae039), {
    name: 'MuiAccordionSummary',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        display: 'flex',
        minHeight: 48,
        padding: theme.spacing(0, 2),
        transition: theme.transitions.create([
            'min-height',
            'background-color'
        ], transition),
        [`&.${(0, $f4106c8be7bdee4c$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $f4106c8be7bdee4c$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`&:hover:not(.${(0, $f4106c8be7bdee4c$export$2e2bcd8739ae039).disabled})`]: {
            cursor: 'pointer'
        },
        variants: [
            {
                props: (props)=>!props.disableGutters,
                style: {
                    [`&.${(0, $f4106c8be7bdee4c$export$2e2bcd8739ae039).expanded}`]: {
                        minHeight: 64
                    }
                }
            }
        ]
    };
});
const $5820abdea582d852$var$AccordionSummaryContent = (0, $lbp1P.default)('div', {
    name: 'MuiAccordionSummary',
    slot: 'Content',
    overridesResolver: (props, styles)=>styles.content
})(({ theme: theme })=>({
        display: 'flex',
        flexGrow: 1,
        margin: '12px 0',
        variants: [
            {
                props: (props)=>!props.disableGutters,
                style: {
                    transition: theme.transitions.create([
                        'margin'
                    ], {
                        duration: theme.transitions.duration.shortest
                    }),
                    [`&.${(0, $f4106c8be7bdee4c$export$2e2bcd8739ae039).expanded}`]: {
                        margin: '20px 0'
                    }
                }
            }
        ]
    }));
const $5820abdea582d852$var$AccordionSummaryExpandIconWrapper = (0, $lbp1P.default)('div', {
    name: 'MuiAccordionSummary',
    slot: 'ExpandIconWrapper',
    overridesResolver: (props, styles)=>styles.expandIconWrapper
})(({ theme: theme })=>({
        display: 'flex',
        color: (theme.vars || theme).palette.action.active,
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $f4106c8be7bdee4c$export$2e2bcd8739ae039).expanded}`]: {
            transform: 'rotate(180deg)'
        }
    }));
const $5820abdea582d852$var$AccordionSummary = /*#__PURE__*/ $8FY87.forwardRef(function AccordionSummary(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordionSummary'
    });
    const { children: children, className: className, expandIcon: expandIcon, focusVisibleClassName: focusVisibleClassName, onClick: onClick } = props, other = (0, $93aRW.default)(props, $5820abdea582d852$var$_excluded);
    const { disabled: disabled = false, disableGutters: disableGutters, expanded: expanded, toggle: toggle } = $8FY87.useContext((0, $4dbf09b2da9f3e6d$export$2e2bcd8739ae039));
    const handleChange = (event)=>{
        if (toggle) toggle(event);
        if (onClick) onClick(event);
    };
    const ownerState = (0, $zgVxD.default)({}, props, {
        expanded: expanded,
        disabled: disabled,
        disableGutters: disableGutters
    });
    const classes = $5820abdea582d852$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2PPWI.jsxs)($5820abdea582d852$var$AccordionSummaryRoot, (0, $zgVxD.default)({
        focusRipple: false,
        disableRipple: true,
        disabled: disabled,
        component: "div",
        "aria-expanded": expanded,
        className: (0, $efJYy.default)(classes.root, className),
        focusVisibleClassName: (0, $efJYy.default)(classes.focusVisible, focusVisibleClassName),
        onClick: handleChange,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)($5820abdea582d852$var$AccordionSummaryContent, {
                className: classes.content,
                ownerState: ownerState,
                children: children
            }),
            expandIcon && /*#__PURE__*/ (0, $2PPWI.jsx)($5820abdea582d852$var$AccordionSummaryExpandIconWrapper, {
                className: classes.expandIconWrapper,
                ownerState: ownerState,
                children: expandIcon
            })
        ]
    }));
});
var $5820abdea582d852$export$2e2bcd8739ae039 = $5820abdea582d852$var$AccordionSummary;



var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $lXBIJ = parcelRequire("lXBIJ");

var $lbp1P = parcelRequire("lbp1P");

var $6lkQ3 = parcelRequire("6lkQ3");

var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $9b5421bb36813ff0$export$a6afb527becfac26(slot) {
    return (0, $jP65K.default)('MuiAccordionDetails', slot);
}
const $9b5421bb36813ff0$var$accordionDetailsClasses = (0, $cOYaX.default)('MuiAccordionDetails', [
    'root'
]);
var $9b5421bb36813ff0$export$2e2bcd8739ae039 = $9b5421bb36813ff0$var$accordionDetailsClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $09e6d2c3e54a606b$var$_excluded = [
    "className"
];
const $09e6d2c3e54a606b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $9b5421bb36813ff0$export$a6afb527becfac26), classes);
};
const $09e6d2c3e54a606b$var$AccordionDetailsRoot = (0, $lbp1P.default)('div', {
    name: 'MuiAccordionDetails',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        padding: theme.spacing(1, 2, 2)
    }));
const $09e6d2c3e54a606b$var$AccordionDetails = /*#__PURE__*/ $8FY87.forwardRef(function AccordionDetails(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordionDetails'
    });
    const { className: className } = props, other = (0, $93aRW.default)(props, $09e6d2c3e54a606b$var$_excluded);
    const ownerState = props;
    const classes = $09e6d2c3e54a606b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2PPWI.jsx)($09e6d2c3e54a606b$var$AccordionDetailsRoot, (0, $zgVxD.default)({
        className: (0, $efJYy.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $09e6d2c3e54a606b$export$2e2bcd8739ae039 = $09e6d2c3e54a606b$var$AccordionDetails;


var $1401b6f80f1b3ee6$exports = {};
"use strict";
"use client";

var $bcBLN = parcelRequire("bcBLN");
Object.defineProperty($1401b6f80f1b3ee6$exports, "__esModule", {
    value: true
});
$1401b6f80f1b3ee6$exports.default = void 0;

var $1401b6f80f1b3ee6$var$_createSvgIcon = $bcBLN((parcelRequire("485sq")));

var $2PPWI = parcelRequire("2PPWI");
var $1401b6f80f1b3ee6$var$_default = $1401b6f80f1b3ee6$exports.default = (0, $1401b6f80f1b3ee6$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2PPWI.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');




const $4ce06e48c5f9d768$export$d26f610c9dea7073 = ()=>{
    const location = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)();
    const stateData = location.state;
    const [categoryData, setCategoryData] = (0, $8FY87.useState)([]);
    const [templateData, setTemplateData] = (0, $8FY87.useState)([]);
    const [templateDataFiltered, setTemplateDataFiltered] = (0, $8FY87.useState)([]);
    const [selectedTemplateFilter, setSelectedTemplateFilter] = (0, $8FY87.useState)("all");
    const [filterToggle, setFilterToggle] = (0, $8FY87.useState)(false);
    const [colorPallets, setColorPallets] = (0, $8FY87.useState)([]);
    const [isLoading, setIsLoading] = (0, $8FY87.useState)(false);
    const [cookies, setCookie] = (0, $1f373de1ceea6eb7$export$2e2bcd8739ae039)([
        "userSelectedFilters"
    ]);
    const encodeData = (data)=>(0, $688cc5ea2aa0f73b$export$a143d493d941bafc).from(JSON.stringify(data), 'utf8').toString('base64');
    const decodeData = (encodedData)=>JSON.parse((0, $688cc5ea2aa0f73b$export$a143d493d941bafc).from(encodedData, 'base64').toString('utf8'));
    const setSortedCategoryData = (data, action = '')=>{
        let tTypes = categoryData.filter((oo)=>oo.isChecked === true && oo.type === "main");
        const updateCategoryCount = (pageCondition)=>{
            return data.map((cat)=>{
                let tmpCount = 0;
                if (templateData.length > 0) {
                    templateData.forEach((row)=>{
                        if (row.templateCategories.includes(cat.category) && pageCondition(row.pageCount)) tmpCount++;
                    });
                    return {
                        ...cat,
                        cnt: tmpCount
                    };
                }
            });
        };
        if (tTypes.length === 1) {
            if (tTypes[0].category === "Single Page") data = updateCategoryCount((pageCount)=>pageCount < 2);
            else if (tTypes[0].category === "Multi Page") data = updateCategoryCount((pageCount)=>pageCount > 1);
        } else if (tTypes.length === 2 || tTypes.length === 0) // console.log('tTypes, templateData, data', tTypes, templateData, data);
        {
            if (templateData.length > 0) data = data.map((cat)=>{
                const tmpCount = templateData.reduce((count, row)=>{
                    if (cat.category === 'Blank') return 1;
                    else return row.templateCategories.includes(cat.category) ? count + 1 : count;
                }, 0);
                return {
                    ...cat,
                    cnt: tmpCount
                };
            });
        }
        // Now `data` has been correctly updated, so you can proceed with filtering and sorting.
        const blankCat = data.filter((c)=>c.category.toLowerCase() === "blank");
        const nonBlankCat = data.filter((c)=>c.category.trim().toLowerCase() !== "blank").sort((a, b)=>a.category.trim().toLowerCase().localeCompare(b.category.trim().toLowerCase()));
        let allCategories = [
            ...blankCat,
            ...nonBlankCat
        ];
        setCategoryData(allCategories);
        if (action === 'reset') setCookie("userSelectedFilters", "", {
            path: "/",
            expires: new Date(0)
        });
        if (action === 'click' || action === 'param') {
            const encoded = encodeData(allCategories);
            setCookie("userSelectedFilters", encoded, {
                path: "/",
                maxAge: 3600 // 1 hr
            });
        }
    };
    (0, $8FY87.useEffect)(()=>{
        async function fetchData() {
            let response = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).get(`/api/configs/template-site-configs`);
            setTemplateData(response.data.data);
            console.log("all data", response.data.data);
            let _singlePageSitesCount = 0;
            let _multiPageSitesCount = 0;
            let tmpData = [];
            response.data.data.forEach((row)=>{
                row.templateCategories.forEach((cat)=>{
                    let ii = tmpData.findIndex((oo)=>oo.category === cat);
                    if (ii >= 0) {
                        if (cat === 'Blank') // For Blank count should be always be 1
                        tmpData[ii].cnt = tmpData[ii].cnt;
                        else tmpData[ii].cnt = tmpData[ii].cnt + 1;
                    } else tmpData.push({
                        type: "cat",
                        category: cat,
                        cnt: 1,
                        isChecked: false
                    });
                });
                if (row.pageCount > 1) _multiPageSitesCount += 1;
                else _singlePageSitesCount += 1;
            });
            tmpData.push({
                type: "main",
                category: "Single Page",
                cnt: _singlePageSitesCount,
                isChecked: true
            });
            tmpData.push({
                type: "main",
                category: "Multi Page",
                cnt: _multiPageSitesCount,
                isChecked: true
            });
            const categoryQuery = getQueryVariable("cat");
            let decoded = cookies.userSelectedFilters && cookies.userSelectedFilters.length > 0 ? decodeData(cookies.userSelectedFilters) : null;
            let finalData = decoded || tmpData; // by default
            let catParam = '';
            if (categoryQuery) {
                // Split multiple comma-separated categories and normalize to lowercase
                const categoryList = categoryQuery.split(',').map((cat)=>cat.trim().toLowerCase());
                tmpData.forEach((obj)=>{
                    const encodedCategory = encodeURIComponent(obj.category.toLowerCase());
                    if (categoryList.includes(encodedCategory) || categoryList.includes(obj.category.toLowerCase())) {
                        obj.isChecked = true;
                        setFilterToggle(true);
                    }
                });
                if (decoded) {
                    decoded.forEach((obj)=>{
                        const encodedCategory = encodeURIComponent(obj.category.toLowerCase());
                        if (categoryList.includes(encodedCategory) || categoryList.includes(obj.category.toLowerCase())) obj.isChecked = true;
                    });
                    finalData = decoded;
                } else finalData = tmpData;
                catParam = 'param';
            }
            // Set data only once
            setSortedCategoryData(finalData, catParam);
            let responseAllPallets = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).get(`/api/configs/all-template-color-theme`);
            setColorPallets(responseAllPallets.data.data);
            setIsLoading(false);
        }
        setIsLoading(true);
        fetchData();
    }, []);
    (0, $8FY87.useEffect)(()=>{
        let gg = [];
        let cats = categoryData.filter((oo)=>oo.isChecked === true && oo.type === "cat");
        let typeMains = categoryData.filter((oo)=>oo.isChecked === true && oo.type === "main");
        //console.log(cats);
        if (cats.length === 0) gg = [
            ...templateData
        ];
        templateData.forEach((row)=>{
            let inc = false;
            cats.forEach((cat)=>{
                if (row.templateCategories.includes(cat.category)) inc = true;
            });
            if (inc) gg.push(row);
        });
        const blankTemplates = gg.filter((t)=>t.templateCategories.includes("Blank"));
        // Prevent two blank templates
        if (typeMains.length == 2 || typeMains.length == 0) {
            if (blankTemplates.length > 1) blankTemplates.splice(-1, 1);
        }
        // const nonBlankTemplates = gg
        //   .filter((t) => !t.templateCategories.includes("Blank"))
        //   .sort((a, b) => {
        //     if (a.templateName < b.templateName) return -1;
        //     return 0;
        //   });
        const nonBlankTemplates = gg.filter((t)=>!t.templateCategories.includes("Blank")).sort((a, b)=>a.templateName.localeCompare(b.templateName));
        let filteredTemplates = [
            ...blankTemplates,
            ...nonBlankTemplates
        ];
        let tTypes = categoryData.filter((oo)=>oo.isChecked === true && oo.type === "main");
        if (tTypes.length === 1) {
            //   //gg = [...templateData];
            // }
            // else {
            let filteredSinglePageTemplates = [];
            let filteredMultiPageTemplates = [];
            let selectedType;
            filteredTemplates.forEach((row)=>{
                tTypes.forEach((tType)=>{
                    // filteredTypeTemplates[tType.category].push(row);
                    selectedType = tType.category;
                    if (tType.category === "Multi Page" && row.pageCount > 1) filteredMultiPageTemplates.push(row);
                    if (tType.category === "Single Page" && (row.pageCount === 1 || row.pageCount === 0)) filteredSinglePageTemplates.push(row);
                });
            });
            filteredTemplates = selectedType === "Multi Page" ? filteredMultiPageTemplates : filteredSinglePageTemplates;
        }
        setTemplateDataFiltered(filteredTemplates);
        //setTemplateDataFiltered([...blankTemplates, ...nonBlankTemplates]);
        handleSetFilterToggle(categoryData, "cat");
        handleSetFilterToggle(categoryData, "main");
    }, [
        categoryData
    ]);
    const handleSetFilterToggle = (newArray, type)=>{
        //let isAllPagesTrue = true;
        let tTypes = categoryData.filter((oo)=>oo.isChecked === true && oo.type === "main");
        let cTypes = categoryData.filter((oo)=>oo.isChecked === true && oo.type === "cat");
        if (tTypes.length == 2 && cTypes.length == 0) setFilterToggle(false);
        else if (tTypes.length == 0 && cTypes.length == 0) setFilterToggle(false);
        else setFilterToggle(true);
    };
    const getQueryVariable = (variable)=>{
        var query = window.location.search.substring(1);
        // console.log(query)//"app=article&act=news_content&aid=160990"
        var vars = query.split("&");
        // console.log(vars) //[ 'app=article', 'act=news_content', 'aid=160990' ]
        for(var i = 0; i < vars.length; i++){
            var pair = vars[i].split("=");
            //console.log(pair)//[ 'app', 'article' ][ 'act', 'news_content' ][ 'aid', '160990' ]
            if (pair[0] == variable) return pair[1];
        }
        return false;
    };
    const catQuery = getQueryVariable("cat");
    // Build meta info dynamically
    const title = catQuery ? `RocketPages - ${catQuery} templates` : "RocketPages - Choose Template";
    const description = catQuery ? `Discover customizable ${catQuery} website templates on RocketPages. Build, launch & grow your site with designs made for ${catQuery} communities.` : "Build and Launch Your Free Website in Just 15 Minutes";
    const canonical = catQuery ? `https://app.rocketpages.io/choose-template?cat=${catQuery}` : "https://app.rocketpages.io/choose-template";
    return /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, null, /*#__PURE__*/ $8FY87.createElement((0, $274ffc8236991365$export$dcef8f9bb9a41431), null, /*#__PURE__*/ $8FY87.createElement("title", null, title), /*#__PURE__*/ $8FY87.createElement("meta", {
        name: "description",
        content: description
    }), /*#__PURE__*/ $8FY87.createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "preload",
        href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap",
        as: "font",
        type: "font/woff2"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap",
        rel: "stylesheet"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "canonical",
        href: canonical
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "icon",
        href: "/favicon.ico"
    }), false), /*#__PURE__*/ $8FY87.createElement((0, $9ada84cce5691847$export$2e2bcd8739ae039), null), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "font-body text-base font-medium"
    }, /*#__PURE__*/ $8FY87.createElement((0, $56dcde36b8493878$export$2e2bcd8739ae039), {
        sx: {
            color: "#fff",
            zIndex: (theme)=>theme.zIndex.drawer + 1
        },
        open: isLoading
    }, /*#__PURE__*/ $8FY87.createElement((0, $b391f94ee7b6de9b$export$2e2bcd8739ae039), {
        color: "inherit"
    })), /*#__PURE__*/ $8FY87.createElement((0, $c0f0a0f6efad2fa3$export$42cfbb80f7861e77), {
        ...stateData,
        title: "Choose template"
    }), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "bg-gray-100 flex-row fixed h-screen w-48 xl:w-64 top-[64px] hidden md:flex"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "pb-16 overflow-y-auto w-full h-full bg-catelina-blue text-white flex flex-col py-2"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "px-2"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "sticky top-0 bg-catelina-blue z-10"
    }, " ", /*#__PURE__*/ $8FY87.createElement("span", {
        className: "px-2 py-2 flex"
    }, "Page(s):"), categoryData.filter((obj)=>obj.type == "main").map((row)=>{
        return /*#__PURE__*/ $8FY87.createElement((0, $4be3312f074019e3$export$2e2bcd8739ae039), {
            key: row.category,
            item: row,
            isChecked: row.isChecked,
            onCheckFilterTypeChanged: (val)=>{
                let newArray = [
                    ...categoryData
                ];
                let idx = newArray.findIndex((kk)=>kk.category === row.category);
                newArray[idx].isChecked = val;
                setSortedCategoryData(newArray, 'click');
                handleSetFilterToggle(newArray, "main");
            // setFilterToggle(true)
            },
            "data-test": "page-checkbox"
        });
    }), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "border-b border-white mx-2 mt-4 mb-3 flex"
    })), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "overflow-y-auto max-h-[calc(100vh-200px)]"
    }, " ", /*#__PURE__*/ $8FY87.createElement("span", {
        className: "px-2 py-2 flex"
    }, "Categories:"), categoryData.filter((obj)=>obj.type == "cat").map((row)=>{
        return /*#__PURE__*/ $8FY87.createElement((0, $15f843926e6efc0a$export$2e2bcd8739ae039), {
            key: row.category,
            item: row,
            isChecked: row.isChecked,
            onCheckChanged: (val)=>{
                let newArray = [
                    ...categoryData
                ];
                let idx = newArray.findIndex((kk)=>kk.category === row.category);
                newArray[idx].isChecked = val;
                setSortedCategoryData(newArray, 'click');
                handleSetFilterToggle(newArray, "cat");
            //removeQueryParam();
            // setFilterToggle(true)
            },
            "data-test": "category-checkbox"
        });
    }))))), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col w-full my-4 pl-[20px] md:pl-[260px] xl:pl-[340px] pb-10 pt-[64px] bg-white-smoke pr-[20px]"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "md:hidden"
    }, /*#__PURE__*/ $8FY87.createElement((0, $136410865e81e680$export$2e2bcd8739ae039), {
        disableGutters: true
    }, /*#__PURE__*/ $8FY87.createElement((0, $5820abdea582d852$export$2e2bcd8739ae039), {
        expandIcon: /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1401b6f80f1b3ee6$exports))), null),
        "aria-controls": "panel2-content",
        id: "panel2-header",
        sx: {
            p: 0,
            mx: 1.2,
            mb: 0,
            "& .MuiAccordionSummary-content": {
                alignItems: "center"
            }
        },
        style: {
            alignItems: "center"
        },
        "data-test": "filters"
    }, /*#__PURE__*/ $8FY87.createElement("img", {
        src: (parcelRequire("gOCEf")),
        alt: "",
        className: "px-2"
    }), "Filters"), /*#__PURE__*/ $8FY87.createElement((0, $09e6d2c3e54a606b$export$2e2bcd8739ae039), {
        sx: {
            p: 0
        }
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: "border-b border-gray flex mx-2 mt-1 mb-1.5"
    }), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "pb-2 text-catelina-blue pt-1"
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: "px-2 py-2",
        style: {
            color: "#3B3B3B66"
        }
    }, "Page(s):"), categoryData.filter((obj)=>obj.type == "main").map((row)=>{
        return /*#__PURE__*/ $8FY87.createElement((0, $4be3312f074019e3$export$2e2bcd8739ae039), {
            key: row.category,
            item: row,
            isChecked: row.isChecked,
            onCheckFilterTypeChanged: (val)=>{
                let newArray = [
                    ...categoryData
                ];
                let idx = newArray.findIndex((kk)=>kk.category === row.category);
                newArray[idx].isChecked = val;
                // console.log(newArray);
                setSortedCategoryData(newArray, 'click');
            },
            "data-test": "page-checkbox-mobile"
        });
    }), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "border-b border-gray flex mx-2 mt-1 mb-1.5"
    }), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "px-2 py-2 ",
        style: {
            color: "#3B3B3B66"
        }
    }, "Categories:"), categoryData.filter((obj)=>obj.type == "cat").map((row)=>{
        return /*#__PURE__*/ $8FY87.createElement((0, $15f843926e6efc0a$export$2e2bcd8739ae039), {
            key: row.category,
            item: row,
            isChecked: row.isChecked,
            onCheckChanged: (val)=>{
                let newArray = [
                    ...categoryData
                ];
                let idx = newArray.findIndex((kk)=>kk.category === row.category);
                newArray[idx].isChecked = val;
                setSortedCategoryData(newArray, 'click');
            },
            "data-test": "category-checkbox-mobile"
        });
    }))))), !filterToggle ? /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-row mb-2"
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-catelina-blue py-1"
    }, "All Templates (", templateDataFiltered.length, ")")) : /*#__PURE__*/ $8FY87.createElement("div", {
        className: "template-filter"
    }, /*#__PURE__*/ $8FY87.createElement((0, $136410865e81e680$export$2e2bcd8739ae039), {
        disableGutters: true
    }, /*#__PURE__*/ $8FY87.createElement((0, $5820abdea582d852$export$2e2bcd8739ae039), {
        expandIcon: /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1401b6f80f1b3ee6$exports))), null),
        "aria-controls": "panel2-content",
        id: "panel2-header",
        sx: {
            "& .MuiAccordionSummary-content": {
                alignItems: "center"
            }
        },
        style: {
            alignItems: "center"
        }
    }, /*#__PURE__*/ $8FY87.createElement("img", {
        src: (parcelRequire("gOCEf")),
        alt: "",
        className: "pr-2"
    }), "Filters"), /*#__PURE__*/ $8FY87.createElement((0, $09e6d2c3e54a606b$export$2e2bcd8739ae039), {
        sx: {
            pt: 0
        }
    }, /*#__PURE__*/ $8FY87.createElement("div", null, categoryData.filter((kk)=>kk.isChecked === true && kk.type === "main").length > 0 && /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-row flex-wrap  pt-2 border-grey-500 border-t"
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: "py-2 font-normal pageLabel"
    }, "Page(s):"), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-wrap pageValue"
    }, categoryData.filter((kk)=>kk.isChecked === true && kk.type === "main").map((jjj)=>{
        return /*#__PURE__*/ $8FY87.createElement("div", {
            key: jjj.category,
            className: "border border-slate-300 rounded tex-grey-primary flex items-center pr-1 mr-2 mt-1 mb-2 font-normal grey-primary",
            style: {
                backgroundColor: "#FAFAFA"
            },
            "data-test": "page-filter",
            "data-filter": jjj.category
        }, /*#__PURE__*/ $8FY87.createElement("span", {
            className: "px-2"
        }, jjj.category), /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($c1e8e05b22d2e795$exports))), {
            onClick: ()=>{
                let newArray = [
                    ...categoryData
                ];
                let idx = newArray.findIndex((kk)=>kk.category === jjj.category);
                newArray[idx].isChecked = false;
                setSortedCategoryData(newArray, 'reset');
            },
            className: "hover:cursor-pointer",
            fontSize: "small",
            sx: {
                color: "#3B3B3B66"
            }
        }));
    }))), categoryData.filter((kk)=>kk.isChecked === true && kk.type === "cat").length > 0 && /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-row flex-wrap"
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: "py-2 font-normal pageLabel"
    }, "Categories:"), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-wrap pageValue"
    }, categoryData.filter((kk)=>kk.isChecked === true && kk.type === "cat").map((jjj)=>{
        return /*#__PURE__*/ $8FY87.createElement("div", {
            key: jjj.category,
            className: "border border-slate-300 rounded flex items-center pr-1 mr-2 mt-1 mb-2 font-normal tex-grey-primary",
            style: {
                backgroundColor: "#FAFAFA"
            },
            "data-test": "category-filter",
            "data-filter": jjj.category
        }, /*#__PURE__*/ $8FY87.createElement("span", {
            className: "px-2"
        }, jjj.category), /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($c1e8e05b22d2e795$exports))), {
            onClick: ()=>{
                let newArray = [
                    ...categoryData
                ];
                let idx = newArray.findIndex((kk)=>kk.category === jjj.category);
                newArray[idx].isChecked = false;
                setSortedCategoryData(newArray, 'reset');
            },
            className: "hover:cursor-pointer",
            fontSize: "small",
            sx: {
                color: "#3B3B3B66"
            }
        }));
    }), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-catelina-blue py-1 pl-1 hover:cursor-pointer self-center underline font-normal",
        onClick: ()=>{
            let newArray = [
                ...categoryData
            ];
            for(let iii = 0; iii < newArray.length; iii++)// console.log(newArray[iii]);
            if (newArray[iii].type === "cat") newArray[iii].isChecked = false;
            setSortedCategoryData(newArray, 'reset');
        }
    }, "Clear all"), " ")))))), /*#__PURE__*/ $8FY87.createElement((0, $91b59757eee8adac$export$2e2bcd8739ae039), {
        templateData: templateDataFiltered,
        colorPallets: colorPallets
    }))), /*#__PURE__*/ $8FY87.createElement((0, $fdcc8de0ec44fdd8$export$2e2bcd8739ae039), null));
};



var $8FY87 = parcelRequire("8FY87");




var $8FY87 = parcelRequire("8FY87");

var $ec74df1fc55deeea$exports = {};
"use strict";
"use client";

var $bcBLN = parcelRequire("bcBLN");
Object.defineProperty($ec74df1fc55deeea$exports, "__esModule", {
    value: true
});
$ec74df1fc55deeea$exports.default = void 0;

var $ec74df1fc55deeea$var$_createSvgIcon = $bcBLN((parcelRequire("485sq")));

var $2PPWI = parcelRequire("2PPWI");
var $ec74df1fc55deeea$var$_default = $ec74df1fc55deeea$exports.default = (0, $ec74df1fc55deeea$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2PPWI.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m5 11h-4v4h-2v-4H7v-2h4V7h2v4h4z"
}), 'AddCircle');



const $fe8cd0ba0f54f349$var$NoSiteExists = (props)=>{
    return /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex justify-center py-24 flex-col items-center"
    }, /*#__PURE__*/ $8FY87.createElement("img", {
        className: "h-20",
        src: (parcelRequire("4C3P5"))
    }), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-center"
    }, "You don\u2019t have any website yet"), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-center py-4"
    }, /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        size: "small",
        variant: "contained",
        sx: {
            backgroundColor: "#243060",
            textTransform: "none"
        },
        startIcon: /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ec74df1fc55deeea$exports))), {
            sx: {
                color: "#fff"
            }
        }),
        onClick: props.onNewWebsiteClick
    }, "Create new website")));
};
var $fe8cd0ba0f54f349$export$2e2bcd8739ae039 = $fe8cd0ba0f54f349$var$NoSiteExists;





var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");


var $lXBIJ = parcelRequire("lXBIJ");

var $lbp1P = parcelRequire("lbp1P");

var $6lkQ3 = parcelRequire("6lkQ3");


var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $c80f20a2e1a3d75c$export$f3b76d2cce458caa(slot) {
    return (0, $jP65K.default)('MuiCard', slot);
}
const $c80f20a2e1a3d75c$var$cardClasses = (0, $cOYaX.default)('MuiCard', [
    'root'
]);
var $c80f20a2e1a3d75c$export$2e2bcd8739ae039 = $c80f20a2e1a3d75c$var$cardClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $70b2c7bd1b8d5210$var$_excluded = [
    "className",
    "raised"
];
const $70b2c7bd1b8d5210$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $c80f20a2e1a3d75c$export$f3b76d2cce458caa), classes);
};
const $70b2c7bd1b8d5210$var$CardRoot = (0, $lbp1P.default)((0, $d9c49ac25a55e29d$export$2e2bcd8739ae039), {
    name: 'MuiCard',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        overflow: 'hidden'
    };
});
const $70b2c7bd1b8d5210$var$Card = /*#__PURE__*/ $8FY87.forwardRef(function Card(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiCard'
    });
    const { className: className, raised: raised = false } = props, other = (0, $93aRW.default)(props, $70b2c7bd1b8d5210$var$_excluded);
    const ownerState = (0, $zgVxD.default)({}, props, {
        raised: raised
    });
    const classes = $70b2c7bd1b8d5210$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2PPWI.jsx)($70b2c7bd1b8d5210$var$CardRoot, (0, $zgVxD.default)({
        className: (0, $efJYy.default)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $70b2c7bd1b8d5210$export$2e2bcd8739ae039 = $70b2c7bd1b8d5210$var$Card;



var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $lXBIJ = parcelRequire("lXBIJ");

var $lbp1P = parcelRequire("lbp1P");

var $6lkQ3 = parcelRequire("6lkQ3");

var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $4b4b0e75c5908778$export$2a5c27c211442e3c(slot) {
    return (0, $jP65K.default)('MuiCardActions', slot);
}
const $4b4b0e75c5908778$var$cardActionsClasses = (0, $cOYaX.default)('MuiCardActions', [
    'root',
    'spacing'
]);
var $4b4b0e75c5908778$export$2e2bcd8739ae039 = $4b4b0e75c5908778$var$cardActionsClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $2176c70dc036ba55$var$_excluded = [
    "disableSpacing",
    "className"
];
const $2176c70dc036ba55$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $4b4b0e75c5908778$export$2a5c27c211442e3c), classes);
};
const $2176c70dc036ba55$var$CardActionsRoot = (0, $lbp1P.default)('div', {
    name: 'MuiCardActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $zgVxD.default)({
        display: 'flex',
        alignItems: 'center',
        padding: 8
    }, !ownerState.disableSpacing && {
        '& > :not(style) ~ :not(style)': {
            marginLeft: 8
        }
    }));
const $2176c70dc036ba55$var$CardActions = /*#__PURE__*/ $8FY87.forwardRef(function CardActions(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiCardActions'
    });
    const { disableSpacing: disableSpacing = false, className: className } = props, other = (0, $93aRW.default)(props, $2176c70dc036ba55$var$_excluded);
    const ownerState = (0, $zgVxD.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $2176c70dc036ba55$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2PPWI.jsx)($2176c70dc036ba55$var$CardActionsRoot, (0, $zgVxD.default)({
        className: (0, $efJYy.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $2176c70dc036ba55$export$2e2bcd8739ae039 = $2176c70dc036ba55$var$CardActions;



var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $lXBIJ = parcelRequire("lXBIJ");

var $lbp1P = parcelRequire("lbp1P");

var $6lkQ3 = parcelRequire("6lkQ3");

var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $55f3c125f9a28135$export$964336739a8c7119(slot) {
    return (0, $jP65K.default)('MuiCardContent', slot);
}
const $55f3c125f9a28135$var$cardContentClasses = (0, $cOYaX.default)('MuiCardContent', [
    'root'
]);
var $55f3c125f9a28135$export$2e2bcd8739ae039 = $55f3c125f9a28135$var$cardContentClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $554c427c007750bc$var$_excluded = [
    "className",
    "component"
];
const $554c427c007750bc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $55f3c125f9a28135$export$964336739a8c7119), classes);
};
const $554c427c007750bc$var$CardContentRoot = (0, $lbp1P.default)('div', {
    name: 'MuiCardContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        padding: 16,
        '&:last-child': {
            paddingBottom: 24
        }
    };
});
const $554c427c007750bc$var$CardContent = /*#__PURE__*/ $8FY87.forwardRef(function CardContent(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiCardContent'
    });
    const { className: className, component: component = 'div' } = props, other = (0, $93aRW.default)(props, $554c427c007750bc$var$_excluded);
    const ownerState = (0, $zgVxD.default)({}, props, {
        component: component
    });
    const classes = $554c427c007750bc$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2PPWI.jsx)($554c427c007750bc$var$CardContentRoot, (0, $zgVxD.default)({
        as: component,
        className: (0, $efJYy.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $554c427c007750bc$export$2e2bcd8739ae039 = $554c427c007750bc$var$CardContent;



var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $lXBIJ = parcelRequire("lXBIJ");

var $8FY87 = parcelRequire("8FY87");
'use client';
let $a3608bb1fb347cd9$var$globalId = 0;
function $a3608bb1fb347cd9$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $8FY87.useState(idOverride);
    const id = idOverride || defaultId;
    $8FY87.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $a3608bb1fb347cd9$var$globalId += 1;
            setDefaultId(`mui-${$a3608bb1fb347cd9$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $a3608bb1fb347cd9$var$maybeReactUseId = $8FY87['useId'.toString()];
function $a3608bb1fb347cd9$export$2e2bcd8739ae039(idOverride) {
    if ($a3608bb1fb347cd9$var$maybeReactUseId !== undefined) {
        const reactId = $a3608bb1fb347cd9$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $a3608bb1fb347cd9$var$useGlobalId(idOverride);
}




var $lbp1P = parcelRequire("lbp1P");

var $6lkQ3 = parcelRequire("6lkQ3");

var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $lXBIJ = parcelRequire("lXBIJ");

var $d5ARM = parcelRequire("d5ARM");


var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $9wLPa = parcelRequire("9wLPa");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");



var $lXBIJ = parcelRequire("lXBIJ");


var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");

var $8FY87 = parcelRequire("8FY87");



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $8381476ebc81e310$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $8381476ebc81e310$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $8381476ebc81e310$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function $8381476ebc81e310$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
function $8381476ebc81e310$var$isEmpty(obj) {
    return $8381476ebc81e310$var$isObjectEmpty(obj) || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/material-ui/api/textarea-autosize/)
 */ const $8381476ebc81e310$var$TextareaAutosize = /*#__PURE__*/ $8FY87.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $93aRW.default)(props, $8381476ebc81e310$var$_excluded);
    const { current: isControlled } = $8FY87.useRef(value != null);
    const textareaRef = $8FY87.useRef(null);
    const handleRef = (0, $a44e6282d60cc47f$export$2e2bcd8739ae039)(forwardedRef, textareaRef);
    const heightRef = $8FY87.useRef(null);
    const hiddenTextareaRef = $8FY87.useRef(null);
    const calculateTextareaStyles = $8FY87.useCallback(()=>{
        const textarea = textareaRef.current;
        const hiddenTextarea = hiddenTextareaRef.current;
        if (!textarea || !hiddenTextarea) return undefined;
        const containerWindow = (0, $82824f79fb738506$export$2e2bcd8739ae039)(textarea);
        const computedStyle = containerWindow.getComputedStyle(textarea);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0,
            overflowing: false
        };
        hiddenTextarea.style.width = computedStyle.width;
        hiddenTextarea.value = textarea.value || props.placeholder || 'x';
        if (hiddenTextarea.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        hiddenTextarea.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = $8381476ebc81e310$var$getStyleValue(computedStyle.paddingBottom) + $8381476ebc81e310$var$getStyleValue(computedStyle.paddingTop);
        const border = $8381476ebc81e310$var$getStyleValue(computedStyle.borderBottomWidth) + $8381476ebc81e310$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = hiddenTextarea.scrollHeight;
        // Measure height of a textarea with a single row
        hiddenTextarea.value = 'x';
        const singleRowHeight = hiddenTextarea.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const didHeightChange = (0, $3e2c5a2d96ce42f9$export$2e2bcd8739ae039)(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $8381476ebc81e310$var$isEmpty(textareaStyles)) return false;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        return heightRef.current != null && heightRef.current !== outerHeightStyle;
    });
    const syncHeight = $8FY87.useCallback(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $8381476ebc81e310$var$isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            textarea.style.height = `${outerHeightStyle}px`;
        }
        textarea.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
    }, [
        calculateTextareaStyles
    ]);
    const frameRef = $8FY87.useRef(-1);
    (0, $1eb4765744b30085$export$2e2bcd8739ae039)(()=>{
        const debouncedHandleResize = (0, $a303c833c3709ce4$export$2e2bcd8739ae039)(syncHeight);
        const textarea = textareaRef == null ? void 0 : textareaRef.current;
        if (!textarea) return undefined;
        const containerWindow = (0, $82824f79fb738506$export$2e2bcd8739ae039)(textarea);
        containerWindow.addEventListener('resize', debouncedHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(()=>{
                if (didHeightChange()) {
                    // avoid "ResizeObserver loop completed with undelivered notifications" error
                    // by temporarily unobserving the textarea element while manipulating the height
                    // and reobserving one frame later
                    resizeObserver.unobserve(textarea);
                    cancelAnimationFrame(frameRef.current);
                    syncHeight();
                    frameRef.current = requestAnimationFrame(()=>{
                        resizeObserver.observe(textarea);
                    });
                }
            });
            resizeObserver.observe(textarea);
        }
        return ()=>{
            debouncedHandleResize.clear();
            cancelAnimationFrame(frameRef.current);
            containerWindow.removeEventListener('resize', debouncedHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight,
        didHeightChange
    ]);
    (0, $1eb4765744b30085$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $2PPWI.jsxs)($8FY87.Fragment, {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("textarea", (0, $zgVxD.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style
            }, other)),
            /*#__PURE__*/ (0, $2PPWI.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: hiddenTextareaRef,
                tabIndex: -1,
                style: (0, $zgVxD.default)({}, $8381476ebc81e310$var$styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});
var $8381476ebc81e310$export$2e2bcd8739ae039 = $8381476ebc81e310$var$TextareaAutosize;


function $7e569f38365baceb$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}





var $lbp1P = parcelRequire("lbp1P");

var $6lkQ3 = parcelRequire("6lkQ3");

var $ifmKX = parcelRequire("ifmKX");



var $zgVxD = parcelRequire("zgVxD");
parcelRequire("8FY87");

parcelRequire("8FY87");


var $jr996 = parcelRequire("jr996");
var $hDbmX = parcelRequire("hDbmX");


var $2PPWI = parcelRequire("2PPWI");
'use client';
function $b9e15c80096b23eb$var$wrapGlobalLayer(styles) {
    const serialized = (0, $hDbmX.internal_serializeStyles)(styles);
    if (styles !== serialized && serialized.styles) {
        if (!serialized.styles.match(/^@layer\s+[^{]*$/)) // If the styles are not already wrapped in a layer, wrap them in a global layer.
        serialized.styles = `@layer global{${serialized.styles}}`;
        return serialized;
    }
    return styles;
}
function $b9e15c80096b23eb$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $4ec357bcdd79021e$export$2e2bcd8739ae039)(defaultTheme);
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    let globalStyles = typeof styles === 'function' ? styles(resolvedTheme) : styles;
    if (resolvedTheme.modularCssLayers) {
        if (Array.isArray(globalStyles)) globalStyles = globalStyles.map((styleArg)=>{
            if (typeof styleArg === 'function') return $b9e15c80096b23eb$var$wrapGlobalLayer(styleArg(resolvedTheme));
            return $b9e15c80096b23eb$var$wrapGlobalLayer(styleArg);
        });
        else globalStyles = $b9e15c80096b23eb$var$wrapGlobalLayer(globalStyles);
    }
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $jr996.default), {
        styles: globalStyles
    });
}
var $b9e15c80096b23eb$export$2e2bcd8739ae039 = $b9e15c80096b23eb$var$GlobalStyles;



var $jyLqM = parcelRequire("jyLqM");

var $ab2pD = parcelRequire("ab2pD");

var $2PPWI = parcelRequire("2PPWI");
'use client';
function $cb4e4df70e93cdd6$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $b9e15c80096b23eb$export$2e2bcd8739ae039), (0, $zgVxD.default)({}, props, {
        defaultTheme: (0, $jyLqM.default),
        themeId: (0, $ab2pD.default)
    }));
}
var $cb4e4df70e93cdd6$export$2e2bcd8739ae039 = $cb4e4df70e93cdd6$var$GlobalStyles;


// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $fa8abd2c4b0246ae$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $fa8abd2c4b0246ae$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($fa8abd2c4b0246ae$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $fa8abd2c4b0246ae$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
}
function $fa8abd2c4b0246ae$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}



var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $4996001a5737cbf8$export$ef57d5c8ca2278f6(slot) {
    return (0, $jP65K.default)('MuiInputBase', slot);
}
const $4996001a5737cbf8$var$inputBaseClasses = (0, $cOYaX.default)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
var $4996001a5737cbf8$export$2e2bcd8739ae039 = $4996001a5737cbf8$var$inputBaseClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $77ce8cbc44e76caa$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const $77ce8cbc44e76caa$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $ifmKX.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $77ce8cbc44e76caa$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $77ce8cbc44e76caa$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $ifmKX.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, $ifmKX.default)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $4996001a5737cbf8$export$ef57d5c8ca2278f6), classes);
};
const $77ce8cbc44e76caa$export$298a043133d72a38 = (0, $lbp1P.default)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: $77ce8cbc44e76caa$export$965edad20a84fa75
})(({ theme: theme, ownerState: ownerState })=>(0, $zgVxD.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${(0, $4996001a5737cbf8$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        }
    }, ownerState.multiline && (0, $zgVxD.default)({
        padding: '4px 0 5px'
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: '100%'
    }));
const $77ce8cbc44e76caa$export$a1ad29c901026019 = (0, $lbp1P.default)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: $77ce8cbc44e76caa$export$cf507b112810e72d
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = (0, $zgVxD.default)({
        color: 'currentColor'
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $zgVxD.default)({
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        // Fix IE11 width issue
        animationName: 'mui-auto-fill-cancel',
        animationDuration: '10ms',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&:-ms-input-placeholder': placeholder,
        // IE11
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $4996001a5737cbf8$export$2e2bcd8739ae039).formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&:-ms-input-placeholder': placeholderHidden,
            // IE11
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus:-ms-input-placeholder': placeholderVisible,
            // IE11
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${(0, $4996001a5737cbf8$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        '&:-webkit-autofill': {
            animationDuration: '5000s',
            animationName: 'mui-auto-fill'
        }
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: 'auto',
        resize: 'none',
        padding: 0,
        paddingTop: 0
    }, ownerState.type === 'search' && {
        // Improve type search style.
        MozAppearance: 'textfield'
    });
});
const $77ce8cbc44e76caa$var$inputGlobalStyles = /*#__PURE__*/ (0, $2PPWI.jsx)((0, $cb4e4df70e93cdd6$export$2e2bcd8739ae039), {
    styles: {
        '@keyframes mui-auto-fill': {
            from: {
                display: 'block'
            }
        },
        '@keyframes mui-auto-fill-cancel': {
            from: {
                display: 'block'
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $77ce8cbc44e76caa$var$InputBase = /*#__PURE__*/ $8FY87.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = 'text', value: valueProp } = props, other = (0, $93aRW.default)(props, $77ce8cbc44e76caa$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $8FY87.useRef(value != null);
    const inputRef = $8FY87.useRef();
    const handleInputRefWarning = $8FY87.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $520629ff5b0e6bac$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $8FY87.useState(false);
    const muiFormControl = (0, $e2bd92ffd10d5f17$export$2e2bcd8739ae039)();
    const fcs = (0, $7e569f38365baceb$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $8FY87.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $8FY87.useCallback((obj)=>{
        if ((0, $fa8abd2c4b0246ae$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $fb693b740ef0e8ff$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $9wLPa.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $8FY87.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) inputProps = (0, $zgVxD.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $zgVxD.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $8381476ebc81e310$export$2e2bcd8739ae039);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $8FY87.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $zgVxD.default)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $77ce8cbc44e76caa$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $77ce8cbc44e76caa$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $77ce8cbc44e76caa$export$a1ad29c901026019;
    inputProps = (0, $zgVxD.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $2PPWI.jsxs)($8FY87.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $77ce8cbc44e76caa$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $2PPWI.jsxs)(Root, (0, $zgVxD.default)({}, rootProps, !(0, $31cee6df5efff63b$export$2e2bcd8739ae039)(Root) && {
                ownerState: (0, $zgVxD.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $efJYy.default)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $c160e42eeb24b8ef$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)(Input, (0, $zgVxD.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $31cee6df5efff63b$export$2e2bcd8739ae039)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $zgVxD.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $efJYy.default)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $zgVxD.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $77ce8cbc44e76caa$export$2e2bcd8739ae039 = $77ce8cbc44e76caa$var$InputBase;



var $lbp1P = parcelRequire("lbp1P");
var $awHZI = parcelRequire("awHZI");

var $6lkQ3 = parcelRequire("6lkQ3");

var $zgVxD = parcelRequire("zgVxD");

var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");

function $05dc7927f42dda83$export$cdb270390122322b(slot) {
    return (0, $jP65K.default)('MuiInput', slot);
}
const $05dc7927f42dda83$var$inputClasses = (0, $zgVxD.default)({}, (0, $4996001a5737cbf8$export$2e2bcd8739ae039), (0, $cOYaX.default)('MuiInput', [
    'root',
    'underline',
    'input'
]));
var $05dc7927f42dda83$export$2e2bcd8739ae039 = $05dc7927f42dda83$var$inputClasses;




var $2PPWI = parcelRequire("2PPWI");
'use client';
const $3247b0fca8a83d17$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $3247b0fca8a83d17$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $lXBIJ.default)(slots, (0, $05dc7927f42dda83$export$cdb270390122322b), classes);
    return (0, $zgVxD.default)({}, classes, composedClasses);
};
const $3247b0fca8a83d17$var$InputRoot = (0, $lbp1P.default)((0, $77ce8cbc44e76caa$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $awHZI.default)(prop) || prop === 'classes',
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $77ce8cbc44e76caa$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $zgVxD.default)({
        position: 'relative'
    }, ownerState.formControl && {
        'label + &': {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        '&::after': {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(0)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&.${(0, $05dc7927f42dda83$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: 'scaleX(1) translateX(0)'
        },
        [`&.${(0, $05dc7927f42dda83$export$2e2bcd8739ae039).error}`]: {
            '&::before, &::after': {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        '&::before': {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: 'absolute',
            right: 0,
            transition: theme.transitions.create('border-bottom-color', {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $05dc7927f42dda83$export$2e2bcd8739ae039).disabled}, .${(0, $05dc7927f42dda83$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $05dc7927f42dda83$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: 'dotted'
        }
    });
});
const $3247b0fca8a83d17$var$InputInput = (0, $lbp1P.default)((0, $77ce8cbc44e76caa$export$a1ad29c901026019), {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: (0, $77ce8cbc44e76caa$export$cf507b112810e72d)
})({});
const $3247b0fca8a83d17$var$Input = /*#__PURE__*/ $8FY87.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiInput'
    });
    const { disableUnderline: disableUnderline, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text' } = props, other = (0, $93aRW.default)(props, $3247b0fca8a83d17$var$_excluded);
    const classes = $3247b0fca8a83d17$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $d5ARM.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $3247b0fca8a83d17$var$InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $3247b0fca8a83d17$var$InputInput;
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $77ce8cbc44e76caa$export$2e2bcd8739ae039), (0, $zgVxD.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$3247b0fca8a83d17$var$Input.muiName = 'Input';
var $3247b0fca8a83d17$export$2e2bcd8739ae039 = $3247b0fca8a83d17$var$Input;



var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");

var $d5ARM = parcelRequire("d5ARM");



var $lXBIJ = parcelRequire("lXBIJ");


var $lbp1P = parcelRequire("lbp1P");
var $awHZI = parcelRequire("awHZI");

var $6lkQ3 = parcelRequire("6lkQ3");

var $zgVxD = parcelRequire("zgVxD");

var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");

function $76cb5ee87fa19c67$export$3331e419f1a48437(slot) {
    return (0, $jP65K.default)('MuiFilledInput', slot);
}
const $76cb5ee87fa19c67$var$filledInputClasses = (0, $zgVxD.default)({}, (0, $4996001a5737cbf8$export$2e2bcd8739ae039), (0, $cOYaX.default)('MuiFilledInput', [
    'root',
    'underline',
    'input'
]));
var $76cb5ee87fa19c67$export$2e2bcd8739ae039 = $76cb5ee87fa19c67$var$filledInputClasses;




var $2PPWI = parcelRequire("2PPWI");
'use client';
const $19e9f501673fc037$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $19e9f501673fc037$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $lXBIJ.default)(slots, (0, $76cb5ee87fa19c67$export$3331e419f1a48437), classes);
    return (0, $zgVxD.default)({}, classes, composedClasses);
};
const $19e9f501673fc037$var$FilledInputRoot = (0, $lbp1P.default)((0, $77ce8cbc44e76caa$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $awHZI.default)(prop) || prop === 'classes',
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $77ce8cbc44e76caa$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return (0, $zgVxD.default)({
        position: 'relative',
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $76cb5ee87fa19c67$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $76cb5ee87fa19c67$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        '&::after': {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || 'primary']) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(0)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&.${(0, $76cb5ee87fa19c67$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: 'scaleX(1) translateX(0)'
        },
        [`&.${(0, $76cb5ee87fa19c67$export$2e2bcd8739ae039).error}`]: {
            '&::before, &::after': {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        '&::before': {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: 'absolute',
            right: 0,
            transition: theme.transitions.create('border-bottom-color', {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $76cb5ee87fa19c67$export$2e2bcd8739ae039).disabled}, .${(0, $76cb5ee87fa19c67$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $76cb5ee87fa19c67$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: 'dotted'
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $zgVxD.default)({
        padding: '25px 12px 8px'
    }, ownerState.size === 'small' && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.hiddenLabel && ownerState.size === 'small' && {
        paddingTop: 8,
        paddingBottom: 9
    }));
});
const $19e9f501673fc037$var$FilledInputInput = (0, $lbp1P.default)((0, $77ce8cbc44e76caa$export$a1ad29c901026019), {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: (0, $77ce8cbc44e76caa$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $zgVxD.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        }
    }, theme.vars && {
        '&:-webkit-autofill': {
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        },
        [theme.getColorSchemeSelector('dark')]: {
            '&:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #266798 inset',
                WebkitTextFillColor: '#fff',
                caretColor: '#fff'
            }
        }
    }, ownerState.size === 'small' && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === 'small' && {
        paddingTop: 8,
        paddingBottom: 9
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }));
const $19e9f501673fc037$var$FilledInput = /*#__PURE__*/ $8FY87.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiFilledInput'
    });
    const { components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text' } = props, other = (0, $93aRW.default)(props, $19e9f501673fc037$var$_excluded);
    const ownerState = (0, $zgVxD.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $19e9f501673fc037$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $d5ARM.default)(filledInputComponentsProps, slotProps != null ? slotProps : componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $19e9f501673fc037$var$FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $19e9f501673fc037$var$FilledInputInput;
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $77ce8cbc44e76caa$export$2e2bcd8739ae039), (0, $zgVxD.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$19e9f501673fc037$var$FilledInput.muiName = 'Input';
var $19e9f501673fc037$export$2e2bcd8739ae039 = $19e9f501673fc037$var$FilledInput;



var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");



var $lXBIJ = parcelRequire("lXBIJ");

var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");
parcelRequire("8FY87");


var $lbp1P = parcelRequire("lbp1P");
var $awHZI = parcelRequire("awHZI");

var $2PPWI = parcelRequire("2PPWI");
'use client';
var $1b24cc6b7364b425$var$_span;
const $1b24cc6b7364b425$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $1b24cc6b7364b425$var$NotchedOutlineRoot = (0, $lbp1P.default)('fieldset', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: (0, $awHZI.default)
})({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
});
const $1b24cc6b7364b425$var$NotchedOutlineLegend = (0, $lbp1P.default)('legend', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: (0, $awHZI.default)
})(({ ownerState: ownerState, theme: theme })=>(0, $zgVxD.default)({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden'
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: '11px',
        // sync with `height` in `legend` styles
        transition: theme.transitions.create('width', {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $zgVxD.default)({
        display: 'block',
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: '0.75em',
        visibility: 'hidden',
        maxWidth: 0.01,
        transition: theme.transitions.create('max-width', {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: 'nowrap',
        '& > span': {
            paddingLeft: 5,
            paddingRight: 5,
            display: 'inline-block',
            opacity: 0,
            visibility: 'visible'
        }
    }, ownerState.notched && {
        maxWidth: '100%',
        transition: theme.transitions.create('max-width', {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $1b24cc6b7364b425$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $93aRW.default)(props, $1b24cc6b7364b425$var$_excluded);
    const withLabel = label != null && label !== '';
    const ownerState = (0, $zgVxD.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $2PPWI.jsx)($1b24cc6b7364b425$var$NotchedOutlineRoot, (0, $zgVxD.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $2PPWI.jsx)($1b24cc6b7364b425$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                children: label
            }) : $1b24cc6b7364b425$var$_span || ($1b24cc6b7364b425$var$_span = /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                className: "notranslate",
                children: "\u200B"
            }))
        })
    }));
}





var $lbp1P = parcelRequire("lbp1P");
var $awHZI = parcelRequire("awHZI");

var $zgVxD = parcelRequire("zgVxD");

var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");

function $09a963ec1808cf15$export$89922944c7227687(slot) {
    return (0, $jP65K.default)('MuiOutlinedInput', slot);
}
const $09a963ec1808cf15$var$outlinedInputClasses = (0, $zgVxD.default)({}, (0, $4996001a5737cbf8$export$2e2bcd8739ae039), (0, $cOYaX.default)('MuiOutlinedInput', [
    'root',
    'notchedOutline',
    'input'
]));
var $09a963ec1808cf15$export$2e2bcd8739ae039 = $09a963ec1808cf15$var$outlinedInputClasses;




var $6lkQ3 = parcelRequire("6lkQ3");

var $2PPWI = parcelRequire("2PPWI");
'use client';
const $47a1d1d34a2285f2$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const $47a1d1d34a2285f2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $lXBIJ.default)(slots, (0, $09a963ec1808cf15$export$89922944c7227687), classes);
    return (0, $zgVxD.default)({}, classes, composedClasses);
};
const $47a1d1d34a2285f2$var$OutlinedInputRoot = (0, $lbp1P.default)((0, $77ce8cbc44e76caa$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $awHZI.default)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: (0, $77ce8cbc44e76caa$export$965edad20a84fa75)
})(({ theme: theme, ownerState: ownerState })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return (0, $zgVxD.default)({
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $09a963ec1808cf15$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, $09a963ec1808cf15$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $09a963ec1808cf15$export$2e2bcd8739ae039).focused} .${(0, $09a963ec1808cf15$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $09a963ec1808cf15$export$2e2bcd8739ae039).error} .${(0, $09a963ec1808cf15$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $09a963ec1808cf15$export$2e2bcd8739ae039).disabled} .${(0, $09a963ec1808cf15$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $zgVxD.default)({
        padding: '16.5px 14px'
    }, ownerState.size === 'small' && {
        padding: '8.5px 14px'
    }));
});
const $47a1d1d34a2285f2$var$NotchedOutlineRoot = (0, $lbp1P.default)((0, $1b24cc6b7364b425$export$2e2bcd8739ae039), {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline',
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $47a1d1d34a2285f2$var$OutlinedInputInput = (0, $lbp1P.default)((0, $77ce8cbc44e76caa$export$a1ad29c901026019), {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: (0, $77ce8cbc44e76caa$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $zgVxD.default)({
        padding: '16.5px 14px'
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderRadius: 'inherit'
        }
    }, theme.vars && {
        '&:-webkit-autofill': {
            borderRadius: 'inherit'
        },
        [theme.getColorSchemeSelector('dark')]: {
            '&:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #266798 inset',
                WebkitTextFillColor: '#fff',
                caretColor: '#fff'
            }
        }
    }, ownerState.size === 'small' && {
        padding: '8.5px 14px'
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $47a1d1d34a2285f2$var$OutlinedInput = /*#__PURE__*/ $8FY87.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = 'text' } = props, other = (0, $93aRW.default)(props, $47a1d1d34a2285f2$var$_excluded);
    const classes = $47a1d1d34a2285f2$var$useUtilityClasses(props);
    const muiFormControl = (0, $e2bd92ffd10d5f17$export$2e2bcd8739ae039)();
    const fcs = (0, $7e569f38365baceb$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    const ownerState = (0, $zgVxD.default)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $47a1d1d34a2285f2$var$OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $47a1d1d34a2285f2$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $77ce8cbc44e76caa$export$2e2bcd8739ae039), (0, $zgVxD.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $2PPWI.jsx)($47a1d1d34a2285f2$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== '' && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $2PPWI.jsxs)($8FY87.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        '*'
                    ]
                })) : label,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $zgVxD.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$47a1d1d34a2285f2$var$OutlinedInput.muiName = 'Input';
var $47a1d1d34a2285f2$export$2e2bcd8739ae039 = $47a1d1d34a2285f2$var$OutlinedInput;



var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $lXBIJ = parcelRequire("lXBIJ");

var $efJYy = parcelRequire("efJYy");



var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $lXBIJ = parcelRequire("lXBIJ");



var $ifmKX = parcelRequire("ifmKX");

var $6lkQ3 = parcelRequire("6lkQ3");

var $lbp1P = parcelRequire("lbp1P");

var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $9b97b34149a254bc$export$f7d501e40371cd17(slot) {
    return (0, $jP65K.default)('MuiFormLabel', slot);
}
const $9b97b34149a254bc$var$formLabelClasses = (0, $cOYaX.default)('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
var $9b97b34149a254bc$export$2e2bcd8739ae039 = $9b97b34149a254bc$var$formLabelClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $05dd76edb13db5ad$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $05dd76edb13db5ad$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $ifmKX.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            filled && 'filled',
            focused && 'focused',
            required && 'required'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $9b97b34149a254bc$export$f7d501e40371cd17), classes);
};
const $05dd76edb13db5ad$export$aa5bc7f8a4705b27 = (0, $lbp1P.default)('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $zgVxD.default)({}, styles.root, ownerState.color === 'secondary' && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $zgVxD.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: '1.4375em',
        padding: 0,
        position: 'relative',
        [`&.${(0, $9b97b34149a254bc$export$2e2bcd8739ae039).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $9b97b34149a254bc$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $9b97b34149a254bc$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $05dd76edb13db5ad$var$AsteriskComponent = (0, $lbp1P.default)('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $9b97b34149a254bc$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $05dd76edb13db5ad$var$FormLabel = /*#__PURE__*/ $8FY87.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiFormLabel'
    });
    const { children: children, className: className, component: component = 'label' } = props, other = (0, $93aRW.default)(props, $05dd76edb13db5ad$var$_excluded);
    const muiFormControl = (0, $e2bd92ffd10d5f17$export$2e2bcd8739ae039)();
    const fcs = (0, $7e569f38365baceb$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    const ownerState = (0, $zgVxD.default)({}, props, {
        color: fcs.color || 'primary',
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $05dd76edb13db5ad$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2PPWI.jsxs)($05dd76edb13db5ad$export$aa5bc7f8a4705b27, (0, $zgVxD.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $efJYy.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $2PPWI.jsxs)($05dd76edb13db5ad$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    '*'
                ]
            })
        ]
    }));
});
var $05dd76edb13db5ad$export$2e2bcd8739ae039 = $05dd76edb13db5ad$var$FormLabel;



var $6lkQ3 = parcelRequire("6lkQ3");

var $ifmKX = parcelRequire("ifmKX");

var $lbp1P = parcelRequire("lbp1P");
var $awHZI = parcelRequire("awHZI");

var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $3fc3e0512e7b96b0$export$c1c4b4545ad2ea5f(slot) {
    return (0, $jP65K.default)('MuiInputLabel', slot);
}
const $3fc3e0512e7b96b0$var$inputLabelClasses = (0, $cOYaX.default)('MuiInputLabel', [
    'root',
    'focused',
    'disabled',
    'error',
    'required',
    'asterisk',
    'formControl',
    'sizeSmall',
    'shrink',
    'animated',
    'standard',
    'filled',
    'outlined'
]);
var $3fc3e0512e7b96b0$export$2e2bcd8739ae039 = $3fc3e0512e7b96b0$var$inputLabelClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $3870ce6a881320cb$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
const $3870ce6a881320cb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            formControl && 'formControl',
            !disableAnimation && 'animated',
            shrink && 'shrink',
            size && size !== 'normal' && `size${(0, $ifmKX.default)(size)}`,
            variant
        ],
        asterisk: [
            required && 'asterisk'
        ]
    };
    const composedClasses = (0, $lXBIJ.default)(slots, (0, $3fc3e0512e7b96b0$export$c1c4b4545ad2ea5f), classes);
    return (0, $zgVxD.default)({}, classes, composedClasses);
};
const $3870ce6a881320cb$var$InputLabelRoot = (0, $lbp1P.default)((0, $05dd76edb13db5ad$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $awHZI.default)(prop) || prop === 'classes',
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $9b97b34149a254bc$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === 'small' && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $zgVxD.default)({
        display: 'block',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%'
    }, ownerState.formControl && {
        position: 'absolute',
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: 'translate(0, 20px) scale(1)'
    }, ownerState.size === 'small' && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: 'translate(0, 17px) scale(1)'
    }, ownerState.shrink && {
        transform: 'translate(0, -1.5px) scale(0.75)',
        transformOrigin: 'top left',
        maxWidth: '133%'
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            'color',
            'transform',
            'max-width'
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === 'filled' && (0, $zgVxD.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: 'none',
        transform: 'translate(12px, 16px) scale(1)',
        maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(12px, 13px) scale(1)'
    }, ownerState.shrink && (0, $zgVxD.default)({
        userSelect: 'none',
        pointerEvents: 'auto',
        transform: 'translate(12px, 7px) scale(0.75)',
        maxWidth: 'calc(133% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(12px, 4px) scale(0.75)'
    })), ownerState.variant === 'outlined' && (0, $zgVxD.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: 'none',
        transform: 'translate(14px, 16px) scale(1)',
        maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(14px, 9px) scale(1)'
    }, ownerState.shrink && {
        userSelect: 'none',
        pointerEvents: 'auto',
        // Theoretically, we should have (8+5)*2/0.75 = 34px
        // but it feels a better when it bleeds a bit on the left, so 32px.
        maxWidth: 'calc(133% - 32px)',
        transform: 'translate(14px, -9px) scale(0.75)'
    })));
const $3870ce6a881320cb$var$InputLabel = /*#__PURE__*/ $8FY87.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        name: 'MuiInputLabel',
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, shrink: shrinkProp, className: className } = props, other = (0, $93aRW.default)(props, $3870ce6a881320cb$var$_excluded);
    const muiFormControl = (0, $e2bd92ffd10d5f17$export$2e2bcd8739ae039)();
    let shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $7e569f38365baceb$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'size',
            'variant',
            'required',
            'focused'
        ]
    });
    const ownerState = (0, $zgVxD.default)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    });
    const classes = $3870ce6a881320cb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2PPWI.jsx)($3870ce6a881320cb$var$InputLabelRoot, (0, $zgVxD.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, $efJYy.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $3870ce6a881320cb$export$2e2bcd8739ae039 = $3870ce6a881320cb$var$InputLabel;



var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $lXBIJ = parcelRequire("lXBIJ");

var $6lkQ3 = parcelRequire("6lkQ3");

var $lbp1P = parcelRequire("lbp1P");


var $ifmKX = parcelRequire("ifmKX");

var $8FY87 = parcelRequire("8FY87");
function $d4038869c81c9d34$export$2e2bcd8739ae039(element, muiNames) {
    var _muiName, _element$type;
    return /*#__PURE__*/ $8FY87.isValidElement(element) && muiNames.indexOf(// relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}


var $3e969d15fa9a703a$export$2e2bcd8739ae039 = (0, $d4038869c81c9d34$export$2e2bcd8739ae039);




var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $d6b3c3aab02412f4$export$149c8b8bab2289d1(slot) {
    return (0, $jP65K.default)('MuiFormControl', slot);
}
const $d6b3c3aab02412f4$var$formControlClasses = (0, $cOYaX.default)('MuiFormControl', [
    'root',
    'marginNone',
    'marginNormal',
    'marginDense',
    'fullWidth',
    'disabled'
]);
var $d6b3c3aab02412f4$export$2e2bcd8739ae039 = $d6b3c3aab02412f4$var$formControlClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $1587b7eed37887b9$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $1587b7eed37887b9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            'root',
            margin !== 'none' && `margin${(0, $ifmKX.default)(margin)}`,
            fullWidth && 'fullWidth'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $d6b3c3aab02412f4$export$149c8b8bab2289d1), classes);
};
const $1587b7eed37887b9$var$FormControlRoot = (0, $lbp1P.default)('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $zgVxD.default)({}, styles.root, styles[`margin${(0, $ifmKX.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState })=>(0, $zgVxD.default)({
        display: 'inline-flex',
        flexDirection: 'column',
        position: 'relative',
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: 'top'
    }, ownerState.margin === 'normal' && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === 'dense' && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: '100%'
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $1587b7eed37887b9$var$FormControl = /*#__PURE__*/ $8FY87.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControl'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = 'none', required: required = false, size: size = 'medium', variant: variant = 'outlined' } = props, other = (0, $93aRW.default)(props, $1587b7eed37887b9$var$_excluded);
    const ownerState = (0, $zgVxD.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $1587b7eed37887b9$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $8FY87.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $8FY87.Children.forEach(children, (child)=>{
            if (!(0, $3e969d15fa9a703a$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            const input = (0, $3e969d15fa9a703a$export$2e2bcd8739ae039)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $fa8abd2c4b0246ae$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $8FY87.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $8FY87.Children.forEach(children, (child)=>{
            if (!(0, $3e969d15fa9a703a$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $fa8abd2c4b0246ae$export$d652b828d7fdeff8)(child.props, true) || (0, $fa8abd2c4b0246ae$export$d652b828d7fdeff8)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $8FY87.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const childContext = $8FY87.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $c160e42eeb24b8ef$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $2PPWI.jsx)($1587b7eed37887b9$var$FormControlRoot, (0, $zgVxD.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $efJYy.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
var $1587b7eed37887b9$export$2e2bcd8739ae039 = $1587b7eed37887b9$var$FormControl;



var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $lXBIJ = parcelRequire("lXBIJ");



var $lbp1P = parcelRequire("lbp1P");

var $ifmKX = parcelRequire("ifmKX");

var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $897283f8b4529eca$export$a394fa61b1d583a9(slot) {
    return (0, $jP65K.default)('MuiFormHelperText', slot);
}
const $897283f8b4529eca$var$formHelperTextClasses = (0, $cOYaX.default)('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
var $897283f8b4529eca$export$2e2bcd8739ae039 = $897283f8b4529eca$var$formHelperTextClasses;



var $6lkQ3 = parcelRequire("6lkQ3");

var $2PPWI = parcelRequire("2PPWI");
'use client';
var $00e4f216a849b179$var$_span;
const $00e4f216a849b179$var$_excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const $00e4f216a849b179$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && `size${(0, $ifmKX.default)(size)}`,
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $897283f8b4529eca$export$a394fa61b1d583a9), classes);
};
const $00e4f216a849b179$var$FormHelperTextRoot = (0, $lbp1P.default)('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $ifmKX.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $zgVxD.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, {
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $897283f8b4529eca$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $897283f8b4529eca$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }, ownerState.size === 'small' && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const $00e4f216a849b179$var$FormHelperText = /*#__PURE__*/ $8FY87.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    const { children: children, className: className, component: component = 'p' } = props, other = (0, $93aRW.default)(props, $00e4f216a849b179$var$_excluded);
    const muiFormControl = (0, $e2bd92ffd10d5f17$export$2e2bcd8739ae039)();
    const fcs = (0, $7e569f38365baceb$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    const ownerState = (0, $zgVxD.default)({}, props, {
        component: component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $00e4f216a849b179$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2PPWI.jsx)($00e4f216a849b179$var$FormHelperTextRoot, (0, $zgVxD.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $efJYy.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children === ' ' ? $00e4f216a849b179$var$_span || ($00e4f216a849b179$var$_span = /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
            className: "notranslate",
            children: "\u200B"
        })) : children
    }));
});
var $00e4f216a849b179$export$2e2bcd8739ae039 = $00e4f216a849b179$var$FormHelperText;



var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $d5ARM = parcelRequire("d5ARM");


var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");

var $9wLPa = parcelRequire("9wLPa");

var $8FY87 = parcelRequire("8FY87");



var $efJYy = parcelRequire("efJYy");

var $lXBIJ = parcelRequire("lXBIJ");




var $ifmKX = parcelRequire("ifmKX");


var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");


var $lXBIJ = parcelRequire("lXBIJ");

var $ifmKX = parcelRequire("ifmKX");

var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $f721fcedb254c3dd$export$1ee13051fd9e2ab5(slot) {
    return (0, $jP65K.default)('MuiNativeSelect', slot);
}
const $f721fcedb254c3dd$var$nativeSelectClasses = (0, $cOYaX.default)('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $f721fcedb254c3dd$export$2e2bcd8739ae039 = $f721fcedb254c3dd$var$nativeSelectClasses;



var $lbp1P = parcelRequire("lbp1P");
var $awHZI = parcelRequire("awHZI");

var $2PPWI = parcelRequire("2PPWI");
'use client';
const $deb0d4a830f32778$var$_excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const $deb0d4a830f32778$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $ifmKX.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $f721fcedb254c3dd$export$1ee13051fd9e2ab5), classes);
};
const $deb0d4a830f32778$export$c1eccd1617458c87 = ({ ownerState: ownerState, theme: theme })=>(0, $zgVxD.default)({
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        borderRadius: 0,
        // Reset
        cursor: 'pointer',
        '&:focus': (0, $zgVxD.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)'
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        '&::-ms-expand': {
            display: 'none'
        },
        [`&.${(0, $f721fcedb254c3dd$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        },
        '&[multiple]': {
            height: 'auto'
        },
        '&:not([multiple]) option, &:not([multiple]) optgroup': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        '&&&': {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === 'filled' && {
        '&&&': {
            paddingRight: 32
        }
    }, ownerState.variant === 'outlined' && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        '&:focus': {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        '&&&': {
            paddingRight: 32
        }
    });
const $deb0d4a830f32778$var$NativeSelectSelect = (0, $lbp1P.default)('select', {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: (0, $awHZI.default),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $f721fcedb254c3dd$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})($deb0d4a830f32778$export$c1eccd1617458c87);
const $deb0d4a830f32778$export$e7a817afd12a40d0 = ({ ownerState: ownerState, theme: theme })=>(0, $zgVxD.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        top: 'calc(50% - .5em)',
        // Center vertically, height is 1em
        pointerEvents: 'none',
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $f721fcedb254c3dd$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: 'rotate(180deg)'
    }, ownerState.variant === 'filled' && {
        right: 7
    }, ownerState.variant === 'outlined' && {
        right: 7
    });
const $deb0d4a830f32778$var$NativeSelectIcon = (0, $lbp1P.default)('svg', {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $ifmKX.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($deb0d4a830f32778$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $deb0d4a830f32778$var$NativeSelectInput = /*#__PURE__*/ $8FY87.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = 'standard' } = props, other = (0, $93aRW.default)(props, $deb0d4a830f32778$var$_excluded);
    const ownerState = (0, $zgVxD.default)({}, props, {
        disabled: disabled,
        variant: variant,
        error: error
    });
    const classes = $deb0d4a830f32778$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2PPWI.jsxs)($8FY87.Fragment, {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)($deb0d4a830f32778$var$NativeSelectSelect, (0, $zgVxD.default)({
                ownerState: ownerState,
                className: (0, $efJYy.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $2PPWI.jsx)($deb0d4a830f32778$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $deb0d4a830f32778$export$2e2bcd8739ae039 = $deb0d4a830f32778$var$NativeSelectInput;




var $lbp1P = parcelRequire("lbp1P");
var $jZXCu = parcelRequire("jZXCu");



var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $d6bc704d08bc8400$export$2c0c1ee5a3392e(slot) {
    return (0, $jP65K.default)('MuiSelect', slot);
}
const $d6bc704d08bc8400$var$selectClasses = (0, $cOYaX.default)('MuiSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'focused',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $d6bc704d08bc8400$export$2e2bcd8739ae039 = $d6bc704d08bc8400$var$selectClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
var $60908ddacbb0c5d5$var$_span;
const $60908ddacbb0c5d5$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $60908ddacbb0c5d5$var$SelectSelect = (0, $lbp1P.default)('div', {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $d6bc704d08bc8400$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $d6bc704d08bc8400$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $d6bc704d08bc8400$export$2e2bcd8739ae039).error}`]: styles.error
            },
            {
                [`&.${(0, $d6bc704d08bc8400$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $deb0d4a830f32778$export$c1eccd1617458c87), {
    // Win specificity over the input base
    [`&.${(0, $d6bc704d08bc8400$export$2e2bcd8739ae039).select}`]: {
        height: 'auto',
        // Resets for multiple select with chips
        minHeight: '1.4375em',
        // Required for select\text-field height consistency
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
});
const $60908ddacbb0c5d5$var$SelectIcon = (0, $lbp1P.default)('svg', {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $ifmKX.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $deb0d4a830f32778$export$e7a817afd12a40d0));
const $60908ddacbb0c5d5$var$SelectNativeInput = (0, $lbp1P.default)('input', {
    shouldForwardProp: (prop)=>(0, $jZXCu.default)(prop) && prop !== 'classes',
    name: 'MuiSelect',
    slot: 'NativeInput',
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
});
function $60908ddacbb0c5d5$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $60908ddacbb0c5d5$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
const $60908ddacbb0c5d5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $ifmKX.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ],
        nativeInput: [
            'nativeInput'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $d6bc704d08bc8400$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $60908ddacbb0c5d5$var$SelectInput = /*#__PURE__*/ $8FY87.forwardRef(function SelectInput(props, ref) {
    var _MenuProps$slotProps;
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant: variant = 'standard' } = props, other = (0, $93aRW.default)(props, $60908ddacbb0c5d5$var$_excluded);
    const [value, setValueState] = (0, $a49df1dad2760ffc$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    });
    const [openState, setOpenState] = (0, $a49df1dad2760ffc$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select'
    });
    const inputRef = $8FY87.useRef(null);
    const displayRef = $8FY87.useRef(null);
    const [displayNode, setDisplayNode] = $8FY87.useState(null);
    const { current: isOpenControlled } = $8FY87.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $8FY87.useState();
    const handleRef = (0, $520629ff5b0e6bac$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $8FY87.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    $8FY87.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $8FY87.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $8FY87.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $8FY87.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $dd645d3436d5a245$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener('click', handler);
            return ()=>{
                label.removeEventListener('click', handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $8FY87.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute('tabindex')) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, 'target', {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                'Enter'
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $fa8abd2c4b0246ae$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $8FY87.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $9wLPa.default)(2));
            selected = value.some((v)=>$60908ddacbb0c5d5$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $60908ddacbb0c5d5$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $8FY87.cloneElement(child, {
            'aria-selected': selected ? 'true' : 'false',
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(', ');
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $zgVxD.default)({}, props, {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    const classes = $60908ddacbb0c5d5$var$useUtilityClasses(ownerState);
    const paperProps = (0, $zgVxD.default)({}, MenuProps.PaperProps, (_MenuProps$slotProps = MenuProps.slotProps) == null ? void 0 : _MenuProps$slotProps.paper);
    const listboxId = (0, $a3608bb1fb347cd9$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $2PPWI.jsxs)($8FY87.Fragment, {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)($60908ddacbb0c5d5$var$SelectSelect, (0, $zgVxD.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": listboxId,
                "aria-disabled": disabled ? 'true' : undefined,
                "aria-expanded": open ? 'true' : 'false',
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(' ') || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $efJYy.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $60908ddacbb0c5d5$var$isEmpty(display) ? $60908ddacbb0c5d5$var$_span || ($60908ddacbb0c5d5$var$_span = /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                    className: "notranslate",
                    children: "\u200B"
                })) : display
            })),
            /*#__PURE__*/ (0, $2PPWI.jsx)($60908ddacbb0c5d5$var$SelectNativeInput, (0, $zgVxD.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(',') : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $2PPWI.jsx)($60908ddacbb0c5d5$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $0b320025c1b3a544$export$2e2bcd8739ae039), (0, $zgVxD.default)({
                id: `menu-${name || ''}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                }
            }, MenuProps, {
                MenuListProps: (0, $zgVxD.default)({
                    'aria-labelledby': labelId,
                    role: 'listbox',
                    'aria-multiselectable': multiple ? 'true' : undefined,
                    disableListWrap: true,
                    id: listboxId
                }, MenuProps.MenuListProps),
                slotProps: (0, $zgVxD.default)({}, MenuProps.slotProps, {
                    paper: (0, $zgVxD.default)({}, paperProps, {
                        style: (0, $zgVxD.default)({
                            minWidth: menuMinWidth
                        }, paperProps != null ? paperProps.style : null)
                    })
                }),
                children: items
            }))
        ]
    });
});
var $60908ddacbb0c5d5$export$2e2bcd8739ae039 = $60908ddacbb0c5d5$var$SelectInput;




parcelRequire("8FY87");

var $cHXYB = parcelRequire("cHXYB");

var $2PPWI = parcelRequire("2PPWI");
'use client';
var $51b76255fe6dc684$export$2e2bcd8739ae039 = (0, $cHXYB.default)(/*#__PURE__*/ (0, $2PPWI.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');







var $6lkQ3 = parcelRequire("6lkQ3");


var $lbp1P = parcelRequire("lbp1P");
var $awHZI = parcelRequire("awHZI");

var $2PPWI = parcelRequire("2PPWI");
'use client';
const $5fa08250992d1a88$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
], $5fa08250992d1a88$var$_excluded2 = [
    "root"
];
const $5fa08250992d1a88$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $5fa08250992d1a88$var$styledRootConfig = {
    name: 'MuiSelect',
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $awHZI.default)(prop) && prop !== 'variant',
    slot: 'Root'
};
const $5fa08250992d1a88$var$StyledInput = (0, $lbp1P.default)((0, $3247b0fca8a83d17$export$2e2bcd8739ae039), $5fa08250992d1a88$var$styledRootConfig)('');
const $5fa08250992d1a88$var$StyledOutlinedInput = (0, $lbp1P.default)((0, $47a1d1d34a2285f2$export$2e2bcd8739ae039), $5fa08250992d1a88$var$styledRootConfig)('');
const $5fa08250992d1a88$var$StyledFilledInput = (0, $lbp1P.default)((0, $19e9f501673fc037$export$2e2bcd8739ae039), $5fa08250992d1a88$var$styledRootConfig)('');
const $5fa08250992d1a88$var$Select = /*#__PURE__*/ $8FY87.forwardRef(function Select(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        name: 'MuiSelect',
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $51b76255fe6dc684$export$2e2bcd8739ae039), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = 'outlined' } = props, other = (0, $93aRW.default)(props, $5fa08250992d1a88$var$_excluded);
    const inputComponent = native ? (0, $deb0d4a830f32778$export$2e2bcd8739ae039) : (0, $60908ddacbb0c5d5$export$2e2bcd8739ae039);
    const muiFormControl = (0, $e2bd92ffd10d5f17$export$2e2bcd8739ae039)();
    const fcs = (0, $7e569f38365baceb$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'error'
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, $zgVxD.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $5fa08250992d1a88$var$useUtilityClasses(ownerState);
    const restOfClasses = (0, $93aRW.default)(classes, $5fa08250992d1a88$var$_excluded2);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $2PPWI.jsx)($5fa08250992d1a88$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $2PPWI.jsx)($5fa08250992d1a88$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $2PPWI.jsx)($5fa08250992d1a88$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $520629ff5b0e6bac$export$2e2bcd8739ae039)(ref, (0, $d993a907c028af13$export$2e2bcd8739ae039)(InputComponent));
    return /*#__PURE__*/ (0, $2PPWI.jsx)($8FY87.Fragment, {
        children: /*#__PURE__*/ $8FY87.cloneElement(InputComponent, (0, $zgVxD.default)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $zgVxD.default)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $zgVxD.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $d5ARM.default)(restOfClasses, inputProps.classes) : restOfClasses
            }, input ? input.props.inputProps : {})
        }, (multiple && native || displayEmpty) && variant === 'outlined' ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $efJYy.default)(InputComponent.props.className, className, classes.root)
        }, !input && {
            variant: variant
        }, other))
    });
});
$5fa08250992d1a88$var$Select.muiName = 'Select';
var $5fa08250992d1a88$export$2e2bcd8739ae039 = $5fa08250992d1a88$var$Select;



var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $2e2fdbb68748d0c2$export$c1bdcbaf0596aeda(slot) {
    return (0, $jP65K.default)('MuiTextField', slot);
}
const $2e2fdbb68748d0c2$var$textFieldClasses = (0, $cOYaX.default)('MuiTextField', [
    'root'
]);
var $2e2fdbb68748d0c2$export$2e2bcd8739ae039 = $2e2fdbb68748d0c2$var$textFieldClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $c377b489c6c5df10$var$_excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const $c377b489c6c5df10$var$variantComponent = {
    standard: (0, $3247b0fca8a83d17$export$2e2bcd8739ae039),
    filled: (0, $19e9f501673fc037$export$2e2bcd8739ae039),
    outlined: (0, $47a1d1d34a2285f2$export$2e2bcd8739ae039)
};
const $c377b489c6c5df10$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $2e2fdbb68748d0c2$export$c1bdcbaf0596aeda), classes);
};
const $c377b489c6c5df10$var$TextFieldRoot = (0, $lbp1P.default)((0, $1587b7eed37887b9$export$2e2bcd8739ae039), {
    name: 'MuiTextField',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $c377b489c6c5df10$var$TextField = /*#__PURE__*/ $8FY87.forwardRef(function TextField(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiTextField'
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = 'primary', defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextProps, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelProps, inputProps: inputProps, InputProps: InputProps, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectProps, type: type, value: value, variant: variant = 'outlined' } = props, other = (0, $93aRW.default)(props, $c377b489c6c5df10$var$_excluded);
    const ownerState = (0, $zgVxD.default)({}, props, {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    const classes = $c377b489c6c5df10$var$useUtilityClasses(ownerState);
    const InputMore = {};
    if (variant === 'outlined') {
        if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore['aria-describedby'] = undefined;
    }
    const id = (0, $a3608bb1fb347cd9$export$2e2bcd8739ae039)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $c377b489c6c5df10$var$variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, $2PPWI.jsx)(InputComponent, (0, $zgVxD.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, $2PPWI.jsxs)($c377b489c6c5df10$var$TextFieldRoot, (0, $zgVxD.default)({
        className: (0, $efJYy.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3870ce6a881320cb$export$2e2bcd8739ae039), (0, $zgVxD.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $5fa08250992d1a88$export$2e2bcd8739ae039), (0, $zgVxD.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $00e4f216a849b179$export$2e2bcd8739ae039), (0, $zgVxD.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
var $c377b489c6c5df10$export$2e2bcd8739ae039 = $c377b489c6c5df10$var$TextField;





var $8FY87 = parcelRequire("8FY87");

var $80cdb5096bdf46ee$exports = {};
"use strict";
"use client";

var $bcBLN = parcelRequire("bcBLN");
Object.defineProperty($80cdb5096bdf46ee$exports, "__esModule", {
    value: true
});
$80cdb5096bdf46ee$exports.default = void 0;

var $80cdb5096bdf46ee$var$_createSvgIcon = $bcBLN((parcelRequire("485sq")));

var $2PPWI = parcelRequire("2PPWI");
var $80cdb5096bdf46ee$var$_default = $80cdb5096bdf46ee$exports.default = (0, $80cdb5096bdf46ee$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2PPWI.jsx)("path", {
    d: "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), 'InfoOutlined');


var $ccface632907bed5$exports = {};
"use strict";
"use client";

var $bcBLN = parcelRequire("bcBLN");
Object.defineProperty($ccface632907bed5$exports, "__esModule", {
    value: true
});
$ccface632907bed5$exports.default = void 0;

var $ccface632907bed5$var$_createSvgIcon = $bcBLN((parcelRequire("485sq")));

var $2PPWI = parcelRequire("2PPWI");
var $ccface632907bed5$var$_default = $ccface632907bed5$exports.default = (0, $ccface632907bed5$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2PPWI.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'CloseOutlined');


var $705f712a797bf357$exports = {};
"use strict";
"use client";

var $bcBLN = parcelRequire("bcBLN");
Object.defineProperty($705f712a797bf357$exports, "__esModule", {
    value: true
});
$705f712a797bf357$exports.default = void 0;

var $705f712a797bf357$var$_createSvgIcon = $bcBLN((parcelRequire("485sq")));

var $2PPWI = parcelRequire("2PPWI");
var $705f712a797bf357$var$_default = $705f712a797bf357$exports.default = (0, $705f712a797bf357$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2PPWI.jsx)("path", {
    d: "M15 20H5V7c0-.55-.45-1-1-1s-1 .45-1 1v13c0 1.1.9 2 2 2h10c.55 0 1-.45 1-1s-.45-1-1-1m5-4V4c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9c1.1 0 2-.9 2-2m-2 0H9V4h9z"
}), 'ContentCopyRounded');


var $cdf61693620224dc$exports = {};
"use strict";
"use client";

var $bcBLN = parcelRequire("bcBLN");
Object.defineProperty($cdf61693620224dc$exports, "__esModule", {
    value: true
});
$cdf61693620224dc$exports.default = void 0;

var $cdf61693620224dc$var$_createSvgIcon = $bcBLN((parcelRequire("485sq")));

var $2PPWI = parcelRequire("2PPWI");
var $cdf61693620224dc$var$_default = $cdf61693620224dc$exports.default = (0, $cdf61693620224dc$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2PPWI.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM8 9h8v10H8zm7.5-5-1-1h-5l-1 1H5v2h14V4z"
}), 'DeleteOutlineOutlined');


var $6732f6b652a82767$exports = {};
"use strict";
"use client";

var $bcBLN = parcelRequire("bcBLN");
Object.defineProperty($6732f6b652a82767$exports, "__esModule", {
    value: true
});
$6732f6b652a82767$exports.default = void 0;

var $6732f6b652a82767$var$_createSvgIcon = $bcBLN((parcelRequire("485sq")));

var $2PPWI = parcelRequire("2PPWI");
var $6732f6b652a82767$var$_default = $6732f6b652a82767$exports.default = (0, $6732f6b652a82767$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2PPWI.jsx)("path", {
    d: "m15 16-4 4h10v-4zm-2.94-8.81L3 16.25V20h3.75l9.06-9.06zM5.92 18H5v-.92l7.06-7.06.92.92zm12.79-9.96c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75z"
}), 'DriveFileRenameOutlineOutlined');


var $ced996d0c0e0e7f1$exports = {};
"use strict";
"use client";

var $bcBLN = parcelRequire("bcBLN");
Object.defineProperty($ced996d0c0e0e7f1$exports, "__esModule", {
    value: true
});
$ced996d0c0e0e7f1$exports.default = void 0;

var $ced996d0c0e0e7f1$var$_createSvgIcon = $bcBLN((parcelRequire("485sq")));

var $2PPWI = parcelRequire("2PPWI");
var $ced996d0c0e0e7f1$var$_default = $ced996d0c0e0e7f1$exports.default = (0, $ced996d0c0e0e7f1$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2PPWI.jsx)("path", {
    d: "M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4m0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7"
}), 'VisibilityOutlined');



var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $lXBIJ = parcelRequire("lXBIJ");

var $lbp1P = parcelRequire("lbp1P");

var $6lkQ3 = parcelRequire("6lkQ3");



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $60d251a0aa2b35bf$var$_excluded = [
    "className"
];
const $60d251a0aa2b35bf$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            alignItems === 'flex-start' && 'alignItemsFlexStart'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $e7081451187db0ff$export$81478e24460c57f2), classes);
};
const $60d251a0aa2b35bf$var$ListItemIconRoot = (0, $lbp1P.default)('div', {
    name: 'MuiListItemIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $zgVxD.default)({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: 'inline-flex'
    }, ownerState.alignItems === 'flex-start' && {
        marginTop: 8
    }));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const $60d251a0aa2b35bf$var$ListItemIcon = /*#__PURE__*/ $8FY87.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemIcon'
    });
    const { className: className } = props, other = (0, $93aRW.default)(props, $60d251a0aa2b35bf$var$_excluded);
    const context = $8FY87.useContext((0, $5387b76bde865f68$export$2e2bcd8739ae039));
    const ownerState = (0, $zgVxD.default)({}, props, {
        alignItems: context.alignItems
    });
    const classes = $60d251a0aa2b35bf$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2PPWI.jsx)($60d251a0aa2b35bf$var$ListItemIconRoot, (0, $zgVxD.default)({
        className: (0, $efJYy.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $60d251a0aa2b35bf$export$2e2bcd8739ae039 = $60d251a0aa2b35bf$var$ListItemIcon;






const $df5cb81582703dc6$var$SanitizeTextboxInput = (input)=>{
    let sanitized = input;
    // 1. Remove non-printable/control characters
    sanitized = sanitized.replace(/[\u0000-\u001F\u007F-\u009F]/g, "");
    // 2. Decode percent-encoded octets like %3C, %7B, etc.
    sanitized = sanitized.replace(/%[a-f0-9]{2}/gi, "");
    // 3. Strip all HTML tags
    sanitized = sanitized.replace(/<\/?[^>]+(>|$)/g, "");
    // 4. Remove angle brackets
    sanitized = sanitized.replace(/</g, "");
    sanitized = sanitized.replace(/>/g, "");
    // 5. Remove line breaks and tabs
    sanitized = sanitized.replace(/[\r\n\t]/g, " ");
    // 6. Replace multiple spaces with a single space
    // sanitized = sanitized.replace(/\s+/g, " ");
    // 7. Trim leading and trailing whitespace
    sanitized = sanitized.replace(/^\s+/, "");
    return sanitized;
};
var $df5cb81582703dc6$export$2e2bcd8739ae039 = $df5cb81582703dc6$var$SanitizeTextboxInput;




const $f41526a41ad60ac1$var$SiteItem = (props)=>{
    // --- DEBUG HELPERS ---
    const __DBG__ = (msg, data)=>{
        // Toggle verbose logs by setting window.__RP_DEBUG__ = true in DevTools console
        const enabled = typeof window !== "undefined" && window.__RP_DEBUG__ === true;
        if (!enabled) return;
        try {
            // eslint-disable-next-line no-console
            console.log(`[SiteItem] ${msg}`, data ?? "");
        } catch  {
        // ignore
        }
    };
    __DBG__("render", {
        siteId: props?.data?.siteId,
        pageId: props?.data?.pageId,
        siteUrl: props?.data?.siteUrl
    });
    const { enqueueSnackbar: enqueueSnackbar, closeSnackbar: closeSnackbar } = (0, $5e19452f9528802f$export$1c97ac2c9a6e7c09)();
    const publishingSnackKeyRef = $8FY87.useRef(null);
    const [anchorEl, setAnchorEl] = $8FY87.useState(null);
    const open = Boolean(anchorEl);
    const [showConfirmation, setShowConfirmation] = $8FY87.useState(false);
    const [showPublishConfirmation, setShowPublishConfirmation] = $8FY87.useState(false);
    const [showRename, setShowRename] = $8FY87.useState(false);
    const [renameError, setRenameError] = $8FY87.useState("");
    const [newSiteName, setNewSiteName] = $8FY87.useState("");
    const [isLoading, setIsLoading] = $8FY87.useState(false);
    const [isPublishing, setIsPublishing] = $8FY87.useState(false);
    const [cookie_userData, setCookie_userData, removeCookie_userData] = (0, $1f373de1ceea6eb7$export$2e2bcd8739ae039)([
        "rp_user_data"
    ]);
    // --- Publish status polling (singleton) ---
    const publishPollRef = $8FY87.useRef({
        intervalId: null,
        timeoutId: null,
        inFlight: false
    });
    const stopPublishPolling = $8FY87.useCallback(()=>{
        // Stop any active publish status polling
        __DBG__("stopPublishPolling");
        if (publishPollRef.current.intervalId) clearInterval(publishPollRef.current.intervalId);
        if (publishPollRef.current.timeoutId) clearTimeout(publishPollRef.current.timeoutId);
        publishPollRef.current.intervalId = null;
        publishPollRef.current.timeoutId = null;
        publishPollRef.current.inFlight = false;
    }, []);
    (0, $8FY87.useEffect)(()=>{
        return ()=>{
            // Cleanup on unmount
            stopPublishPolling();
        };
    }, [
        stopPublishPolling
    ]);
    const normalizeStatus = (raw)=>{
        const s = raw?.status ?? raw?.publishStatus ?? raw?.pageStatus ?? raw?.publishingStatus ?? raw;
        const out = String(s || "").trim().toLowerCase();
        __DBG__("normalizeStatus", {
            raw: raw,
            out: out
        });
        return out;
    };
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const [textClassObj] = $8FY87.useState([
        {
            fontSize: "14px",
            color: "#243060",
            minHeight: "auto"
        },
        {
            "&:hover": {
                fontWeight: 700
            }
        }
    ]);
    function calculateTimeRemaining(timestamp) {
        // Convert the timestamp to a Date object
        const originalDate = new Date(timestamp);
        // Add 72 hours (72 * 60 * 60 * 1000 milliseconds)
        const futureDate = new Date(originalDate.getTime() + 259200000);
        // Get the current time
        const currentDate = new Date();
        // Calculate the difference in milliseconds
        const diffMs = futureDate.getTime() - currentDate.getTime();
        // If the future date has passed, return that it's already deleted
        if (diffMs <= 0) return "The site will be deleted soon.";
        // Calculate the difference in days and hours
        const diffDays = Math.floor(diffMs / 86400000);
        const diffHours = Math.floor(diffMs % 86400000 / 3600000);
        // Return the remaining time in a readable format
        if (diffDays > 0) return `Update or save with in ${diffDays} day(s) to avoid deletion.`;
        else return `Update or save with in ${diffHours} hour(s) to avoid deletion.`;
    }
    const handleDelete = ()=>{
        // onCancelSubs(existingSubs[0].subscriptionId); // Call the delete function passed as a prop
        setShowConfirmation(false); // Close the confirmation dialog after delete
        props.onSiteDelete(props.data.siteId);
    };
    const publishSite = async ()=>{
        setIsLoading(true);
        try {
            const response = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post("/api/configs/publish", {
                siteId: props.data.siteId,
                fullSite: true,
                pageId: null,
                publishAllPages: true
            });
            __DBG__("publish API success", {
                status: response?.status,
                data: response?.data
            });
            setIsLoading(false);
            publishingSnackKeyRef.current = enqueueSnackbar("Your website is being published. We'll notify you when it's ready.", {
                variant: "success",
                className: "bg-catelina-blue",
                persist: true
            });
            if (typeof window.__RP_DEBUG__ !== "undefined" && window.__RP_DEBUG__) {
                console.log("[publish] starting status poll", {
                    siteId: props?.data?.siteId,
                    pageId: props?.data?.pageId,
                    siteUrl: props?.data?.siteUrl
                });
                enqueueSnackbar("DEBUG: started publish polling", {
                    variant: "info"
                });
            }
            checkPublishStatus();
            return response;
        } catch (error) {
            console.error("Error while publishing site:", error);
            __DBG__("publish API error", error);
            setIsLoading(false);
        }
    };
    const onPublishViewClick = async ()=>{
        __DBG__("onPublishViewClick", {
            isPublished: props?.data?.isPublished,
            isPublishing: isPublishing
        });
        setShowPublishConfirmation(false);
        if (!props.data.isPublished) {
            setIsPublishing(true);
            const resp = await publishSite();
        // if (!!resp?.data?.data?.url) {
        //   window.open(`https://${resp?.data?.data?.url}`, '_blank')?.focus();
        // } else {
        //   console.log('Error while publishing site');
        // }
        } else window.open(props.data.siteUrl, "_blank")?.focus();
    };
    const getPublishStatus = async ()=>{
        try {
            const siteId = props?.data?.siteId;
            const pageId = props?.data?.pageId;
            if (!pageId && !siteId) {
                console.error("getPublishStatus: missing pageId/siteId", props?.data);
                return null;
            }
            /**
     * Constructs a query string parameter based on the presence of pageId.
     * If pageId exists, creates a pageId query parameter; otherwise, creates a siteId query parameter.
     * Both values are URL-encoded to ensure safe transmission.
     * 
     * @remarks
     * The query string will be in the format "pageId=<encoded-value>" or "siteId=<encoded-value>".
     */ const qs = pageId ? `pageId=${encodeURIComponent(pageId)}` : `siteId=${encodeURIComponent(siteId)}`;
            const response = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).get(`/api/configs/check-publish-status?${qs}`);
            return response.data;
        } catch (error) {
            console.error("Error while getting publish status:", error);
            setIsLoading(false);
            return null;
        }
    };
    const checkSSL = async (url)=>{
        try {
            const response = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).get(`/api/configs/check-ssl?url=${url}`);
            return response.status;
        } catch (error) {
            console.error("Error while checking SSL:", error);
            setIsLoading(false);
        }
    };
    /**
 * Initiates polling to check the publish status of a site.
 * 
 * Polls the publish status every 5 seconds until the status is either "completed" or "failed",
 * or until a 5-minute timeout is reached. Ensures only one poller instance is active at a time
 * by stopping any existing polling before starting.
 * 
 * @remarks
 * - On successful completion, unblocks the UI, triggers the parent's `onPublishComplete` callback,
 *   and shows a success notification.
 * - For custom domains (not ending with `SERVER_DOMAIN`), initiates a separate SSL readiness check
 *   that polls every 5 seconds up to 60 times (5 minutes).
 * - On failure or timeout, stops polling, unblocks the UI, and displays an error notification.
 * - Uses a ref-based flag (`publishPollRef.current.inFlight`) to prevent concurrent poll requests.
 * 
 * @throws Does not throw directly, but catches and handles exceptions internally by stopping the
 * poller and showing an error notification.
 */ const checkPublishStatus = ()=>{
        __DBG__("checkPublishStatus START");
        // Ensure there is only one active poller at a time.
        stopPublishPolling();
        publishPollRef.current.intervalId = setInterval(async ()=>{
            if (publishPollRef.current.inFlight) return;
            publishPollRef.current.inFlight = true;
            try {
                __DBG__("poll tick", {
                    inFlight: publishPollRef.current.inFlight
                });
                const publishResponse = await getPublishStatus();
                const envelope = publishResponse?.data ?? publishResponse;
                const raw = envelope?.data ?? envelope;
                const raw2 = raw?.data ?? raw;
                __DBG__("unwrap", {
                    envelopeKeys: envelope && typeof envelope === 'object' ? Object.keys(envelope) : null,
                    rawKeys: raw && typeof raw === 'object' ? Object.keys(raw) : null,
                    raw2Keys: raw2 && typeof raw2 === 'object' ? Object.keys(raw2) : null
                });
                const status = normalizeStatus(raw2);
                if (status === "completed") {
                    __DBG__("status=completed");
                    stopPublishPolling();
                    // Unblock UI immediately
                    setIsLoading(false);
                    setIsPublishing(false);
                    setShowPublishConfirmation(false);
                    // Let parent refresh its data so "Published" flips in the list.
                    if (typeof props?.onPublishComplete === "function") props.onPublishComplete(props.data.siteId);
                    // Show completion immediately (do NOT wait for SSL).
                    showPublishNotification(props.data.siteUrl);
                    // For custom domains, check SSL readiness separately and notify (optional)
                    if (!props.data.siteUrl.endsWith(".rocketpagesweb.com")) {
                        let sslTries = 0;
                        const sslInterval = setInterval(async ()=>{
                            sslTries += 1;
                            const sslResponse = await checkSSL(`${props.data.siteUrl}`);
                            if (sslResponse === 200) {
                                clearInterval(sslInterval);
                                enqueueSnackbar("SSL is ready for your domain.", {
                                    variant: "success",
                                    className: "bg-catelina-blue"
                                });
                            } else if (sslResponse === 500 || sslTries >= 60) {
                                clearInterval(sslInterval);
                                enqueueSnackbar("Your site is published, but SSL is still being provisioned for the domain.", {
                                    variant: "info"
                                });
                            }
                        }, 5000);
                    }
                } else if (status === "failed") {
                    __DBG__("status=failed", raw);
                    stopPublishPolling();
                    setIsLoading(false);
                    setIsPublishing(false);
                    setShowPublishConfirmation(false);
                    showErrorNotification(raw?.publishError || undefined);
                }
            } catch (e) {
                __DBG__("poller exception", e);
                stopPublishPolling();
                setIsLoading(false);
                setIsPublishing(false);
                setShowPublishConfirmation(false);
                showErrorNotification("Failed while checking publish status.");
            } finally{
                publishPollRef.current.inFlight = false;
            }
        }, 5000);
        publishPollRef.current.timeoutId = setTimeout(()=>{
            __DBG__("poller timeout");
            if (publishPollRef.current.intervalId) {
                stopPublishPolling();
                setIsLoading(false);
                setIsPublishing(false);
                setShowPublishConfirmation(false);
                showErrorNotification();
            }
        }, 300000);
    };
    /**
 * Displays a success notification when publishing is completed.
 * 
 * The notification includes a link to visit the published website and persists
 * until manually dismissed. This function also handles cleanup of any existing
 * snackbars, including the "publishing..." notification.
 * 
 * @param domain - The URL of the published website. Defaults to an empty string.
 * 
 * @remarks
 * - Sets `isPublishing` state to `false`
 * - Closes all existing snackbars before showing the new one
 * - Clears the `publishingSnackKeyRef` reference
 * - The notification can be dismissed by clicking anywhere on it
 * - The notification uses a persistent variant that won't auto-dismiss
 */ const showPublishNotification = (domain = "")=>{
        __DBG__("showPublishNotification", {
            domain: domain
        });
        setIsPublishing(false);
        // Close the earlier "publishing..." snackbar (if any)
        if (publishingSnackKeyRef.current) {
            closeSnackbar(publishingSnackKeyRef.current);
            publishingSnackKeyRef.current = null;
        }
        enqueueSnackbar(/*#__PURE__*/ $8FY87.createElement("div", {
            className: "flex flex-col",
            onClick: ()=>{
                closeSnackbar();
            }
        }, /*#__PURE__*/ $8FY87.createElement("span", null, "Publishing Completed!"), /*#__PURE__*/ $8FY87.createElement("a", {
            className: "text-white underline",
            href: `${domain}`,
            target: "_blank",
            rel: "noreferrer"
        }, "Visit website")), {
            variant: "success",
            className: "bg-catelina-blue",
            persist: true
        });
    };
    /**
 * Displays an error notification to the user when site publishing fails.
 * 
 * This function performs the following actions:
 * 1. Sets the publishing state to false
 * 2. Logs the error message for debugging
 * 3. Closes the specific "publishing..." snackbar if it exists
 * 4. Displays a new error snackbar with the provided message
 * 
 * @param msg - The error message to display. Defaults to "Something went wrong while publishing your site"
 * @returns void
 */ const showErrorNotification = (msg = "Something went wrong while publishing your site")=>{
        setIsPublishing(false);
        __DBG__("showErrorNotification", {
            msg: msg
        });
        // Close the earlier "publishing..." snackbar (if any)
        if (publishingSnackKeyRef.current) {
            closeSnackbar(publishingSnackKeyRef.current);
            publishingSnackKeyRef.current = null;
        }
        enqueueSnackbar(msg, {
            variant: "error"
        });
    };
    /**
 * Handles the site rename operation.
 * Validates the new site name by checking if it's not blank and doesn't already exist
 * (case-insensitive comparison) among other sites.
 * If validation passes, hides the rename dialog and triggers the rename callback.
 * 
 * @remarks
 * - Sets a "Site name can't be blank" error if the new name is empty
 * - Sets an "Entered site name already exists" error if the name conflicts with another site
 * - Excludes the current site from the duplicate name check using siteId comparison
 * 
 * @returns {void}
 */ const handleRename = ()=>{
        // console.log("rename", props.sitesData, newSiteName);
        if (newSiteName === "") {
            setRenameError("Site name can't be blank");
            return;
        } else {
            let idx = props.sitesData.findIndex((kk)=>kk.siteName.toLowerCase() === newSiteName.toLowerCase() && kk.siteId !== props.data.siteId);
            if (idx >= 0) {
                setRenameError("Entered site name already exists");
                return;
            }
        }
        setShowRename(false);
        props.onSiteRename(props.data.siteId, newSiteName);
    };
    /**
 * Array of menu items for site actions.
 * 
 * @remarks
 * Contains two menu items:
 * 1. Publish & View - Conditionally publishes and/or views the site
 *    - If site is published: navigates to view
 *    - If site is not published and not currently publishing: shows publish confirmation dialog
 *    - If publishing is in progress: shows a warning notification
 * 
 * 2. Rename - Opens the rename dialog for the site
 *    - Disabled for site with ID "2e2b85c5-1b76-4e74-8e39-c82749386c53"
 *    - Resets the new site name state before showing the dialog
 * 
 * @see {@link onPublishViewClick} - Handler for viewing published sites
 * @see {@link setShowPublishConfirmation} - State setter for publish confirmation dialog
 * @see {@link setShowRename} - State setter for rename dialog
 */ const menuItems = [
        /*#__PURE__*/ $8FY87.createElement((0, $ee9f19037253b32c$export$2e2bcd8739ae039), {
            key: "publish-view",
            onClick: ()=>{
                if (props.data.isPublished) onPublishViewClick();
                else {
                    if (isPublishing) {
                        enqueueSnackbar("Publishing already in progress!", {
                            variant: "warning"
                        });
                        return;
                    }
                    setShowPublishConfirmation(true);
                }
            },
            sx: textClassObj
        }, /*#__PURE__*/ $8FY87.createElement((0, $60d251a0aa2b35bf$export$2e2bcd8739ae039), null, /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ced996d0c0e0e7f1$exports))), {
            sx: textClassObj
        })), !props.data.isPublished && "Publish & ", "View"),
        /*#__PURE__*/ $8FY87.createElement((0, $ee9f19037253b32c$export$2e2bcd8739ae039), {
            key: "rename",
            onClick: ()=>{
                setNewSiteName("");
                setShowRename(true);
            },
            sx: textClassObj,
            disabled: props.data.siteId === "2e2b85c5-1b76-4e74-8e39-c82749386c53"
        }, /*#__PURE__*/ $8FY87.createElement((0, $60d251a0aa2b35bf$export$2e2bcd8739ae039), null, /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6732f6b652a82767$exports))), {
            fontSize: "small",
            sx: textClassObj
        })), "Rename")
    ];
    if (cookie_userData?.rp_user_data?.userId && props.data.siteOwnerUserId === cookie_userData.rp_user_data.userId) menuItems.push(/*#__PURE__*/ $8FY87.createElement((0, $ee9f19037253b32c$export$2e2bcd8739ae039), {
        key: "duplicate",
        onClick: ()=>{
            props.onSiteDuplicate(props.data.siteId);
        },
        sx: textClassObj
    }, /*#__PURE__*/ $8FY87.createElement((0, $60d251a0aa2b35bf$export$2e2bcd8739ae039), null, /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($705f712a797bf357$exports))), {
        sx: textClassObj
    })), "Duplicate"), /*#__PURE__*/ $8FY87.createElement((0, $ee9f19037253b32c$export$2e2bcd8739ae039), {
        key: "delete",
        onClick: ()=>setShowConfirmation(true),
        sx: [
            ...textClassObj,
            {
                color: "#F00"
            }
        ],
        disabled: props.data.isTemplate === "true" || props.data.siteId === "2e2b85c5-1b76-4e74-8e39-c82749386c53"
    }, /*#__PURE__*/ $8FY87.createElement((0, $60d251a0aa2b35bf$export$2e2bcd8739ae039), null, /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cdf61693620224dc$exports))), {
        sx: [
            ...textClassObj,
            {
                color: "#F00"
            }
        ]
    })), "Delete"));
    props.data.isDirty || props.data.disabled;
    return /*#__PURE__*/ $8FY87.createElement((0, $70b2c7bd1b8d5210$export$2e2bcd8739ae039), {
        className: `relative site-card ${props.data.isDirty === "true" ? "bg-[#FFF3F6]" : "bg-white"}`
    }, showConfirmation && /*#__PURE__*/ $8FY87.createElement("div", {
        className: "fixed inset-0 overflow-y-auto flex justify-center items-center z-10"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "fixed inset-0"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "absolute inset-0 bg-gray-500 opacity-75"
    })), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "bg-white rounded card-delete p-8 max-w-md w-11/12 md:w-full mx-auto z-50"
    }, /*#__PURE__*/ $8FY87.createElement("p", {
        className: "text-gray-800 mb-4"
    }, "Are you sure you want to delete this website?"), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex justify-end flex-col sm:flex-row"
    }, /*#__PURE__*/ $8FY87.createElement("button", {
        className: "bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded mr-2 focus:outline-none focus:shadow-outline w-full sm:w-auto mb-2.5 sm:mb-0",
        onClick: ()=>setShowConfirmation(false)
    }, "Cancel"), /*#__PURE__*/ $8FY87.createElement("button", {
        className: "bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline",
        onClick: handleDelete
    }, "Delete")))), showPublishConfirmation && /*#__PURE__*/ $8FY87.createElement("div", {
        className: "fixed inset-0 overflow-y-auto flex justify-center items-center z-10 card-publish"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "fixed inset-0"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "absolute inset-0 bg-gray-500 opacity-75"
    })), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "bg-white rounded p-8 max-w-md w-11/12 md:w-full mx-auto z-50"
    }, /*#__PURE__*/ $8FY87.createElement("p", {
        className: "text-gray-800 mb-4"
    }, "This will publish all the pages. Are you sure?"), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex justify-end flex-col sm:flex-row"
    }, /*#__PURE__*/ $8FY87.createElement("button", {
        className: "bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded mr-2 focus:outline-none focus:shadow-outline w-full sm:w-auto mb-2.5 sm:mb-0",
        onClick: ()=>setShowPublishConfirmation(false)
    }, "Cancel"), /*#__PURE__*/ $8FY87.createElement("button", {
        className: "bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline",
        onClick: onPublishViewClick
    }, "Publish")))), showRename && /*#__PURE__*/ $8FY87.createElement("div", {
        className: "fixed inset-0 overflow-y-auto flex justify-center items-center z-10"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "fixed inset-0"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "absolute inset-0 bg-gray-500 opacity-75"
    })), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "bg-white card-rename rounded p-2 max-w-md w-11/12 md:w-full mx-auto z-50"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex justify-end"
    }, /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ccface632907bed5$exports))), {
        className: "hover:cursor-pointer",
        onClick: ()=>setShowRename(false)
    })), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex pt-2 px-4 sm:px-8 pb-4 flex-col justify-between md:flex-row"
    }, /*#__PURE__*/ $8FY87.createElement((0, $c377b489c6c5df10$export$2e2bcd8739ae039), {
        id: "outlined-basic",
        // label={renameError !== "" ? renameError : "New website name"}
        label: "New website name",
        variant: "outlined",
        size: "small",
        defaultValue: props.data.siteName,
        onChange: (e)=>{
            const sanitizedValue = (0, $df5cb81582703dc6$export$2e2bcd8739ae039)(e.target.value);
            setRenameError("");
            setNewSiteName(sanitizedValue);
        },
        onKeyDown: (e)=>{
            if ([
                "<",
                ">"
            ].includes(e.key)) {
                e.preventDefault();
                setRenameError("Characters < and > are not allowed.");
            }
        },
        onBlur: (e)=>{
            const sanitizedValue = (0, $df5cb81582703dc6$export$2e2bcd8739ae039)(e.target.value);
            setNewSiteName(sanitizedValue);
        },
        // error={renameError !== ""}
        className: "w-full mb-4 md:w-64 md:mb-0"
    }), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "self-center"
    }, /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        variant: "contained",
        size: "small",
        sx: {
            height: 44,
            width: 144
        },
        className: "w-20 mr-2 capitalize",
        onClick: handleRename
    }, "Save"))), renameError !== "" ? /*#__PURE__*/ $8FY87.createElement("p", {
        className: `text-red-500 pl-3`
    }, renameError) : null)), /*#__PURE__*/ $8FY87.createElement("img", {
        onClick: ()=>window.open(`${"http://editor.rocketpages.io"}/${props.data.siteId}`, "_self"),
        className: "w-full siteImageUrl md:min-h-0 md:h-[200px] object-cover cursor-pointer",
        src: props.data.siteImageURL
    }), /*#__PURE__*/ $8FY87.createElement((0, $554c427c007750bc$export$2e2bcd8739ae039), null, /*#__PURE__*/ $8FY87.createElement((0, $9e9a2c609bdcf2f0$export$2e2bcd8739ae039), {
        gutterBottom: true,
        component: "div",
        className: "text-base-2",
        display: "inline"
    }), props.data.siteName, props.data.isTemplate === "true" ? " (Template)" : "", (props.data?.isDirty === "true" || props.data?.disabled === "true") && /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, null, /*#__PURE__*/ $8FY87.createElement((0, $9e9a2c609bdcf2f0$export$2e2bcd8739ae039), {
        display: "inline",
        whiteSpace: "nowrap",
        sx: {
            fontSize: "0.7rem",
            color: "#fff",
            background: "#f94343",
            borderRadius: "0.75rem",
            overflowWrap: "break-word",
            paddingX: "0.4rem",
            paddingY: "0.06125rem",
            marginLeft: "0.4rem"
        }
    }, props.data.isDirty ? "Expires soon" : "Disabled")), /*#__PURE__*/ $8FY87.createElement((0, $9e9a2c609bdcf2f0$export$2e2bcd8739ae039), {
        sx: {
            fontSize: "0.7rem",
            color: "#243060",
            opacity: props.data.isPublished ? 1 : 0.6,
            overflowWrap: "break-word"
        }
    }, props.data.isPublished ? /*#__PURE__*/ $8FY87.createElement((0, $89a5149760fde35d$export$2e2bcd8739ae039), {
        href: props.data.siteUrl,
        underline: "none",
        target: "_blank"
    }, props.data.siteUrl.replace(/^https?:\/\//, "")) : "Not published"), props.data.isDirty === "true" && /*#__PURE__*/ $8FY87.createElement((0, $9e9a2c609bdcf2f0$export$2e2bcd8739ae039), {
        sx: {
            fontSize: "0.7rem",
            color: "red",
            marginTop: "6px",
            opacity: props.data.isPublished ? 1 : 0.6,
            overflowWrap: "break-word"
        }
    }, /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($80cdb5096bdf46ee$exports))), {
        fontSize: "small",
        sx: {
            marginRight: "6px"
        }
    }), calculateTimeRemaining(props.data.createdAt))), /*#__PURE__*/ $8FY87.createElement((0, $2176c70dc036ba55$export$2e2bcd8739ae039), null, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "w-full flex flex-row justify-between"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-row"
    }, /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        size: "small",
        variant: "outlined",
        sx: {
            textTransform: "none",
            marginRight: "6px",
            backgroundColor: "white"
        },
        startIcon: /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7c8f2ac2998e8e4d$exports))), null),
        onClick: props.onEditSite
    }, "Edit site"), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "relative setting-icon"
    }, /*#__PURE__*/ $8FY87.createElement("img", {
        onClick: // props.data.siteId === "2e2b85c5-1b76-4e74-8e39-c82749386c53"
        //   ? null
        //   :
        props.onSettingClick,
        className: "w-[36px] hover:cursor-pointer",
        src: (parcelRequire("czwuE")),
        alt: ""
    }), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "icon-tooltip-text"
    }, "Site Setting"))), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "relative site-menu",
        onClick: handleClick
    }, /*#__PURE__*/ $8FY87.createElement("img", {
        onClick: props.onMoreOptionClick,
        className: "w-[36px] hover:cursor-pointer",
        src: (parcelRequire("jzVBy")),
        alt: ""
    }), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "icon-tooltip-text"
    }, "Site Menu")))), /*#__PURE__*/ $8FY87.createElement((0, $0b320025c1b3a544$export$2e2bcd8739ae039), {
        className: "siteMenuOptions",
        anchorEl: anchorEl,
        id: "account-menu",
        open: open,
        onClose: handleClose,
        onClick: handleClose,
        PaperProps: {
            elevation: 0,
            sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                mt: 1.5,
                "& .MuiAvatar-root": {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1
                },
                "&::before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: "background.paper",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0
                }
            }
        },
        transformOrigin: {
            horizontal: "right",
            vertical: "top"
        },
        anchorOrigin: {
            horizontal: "right",
            vertical: "bottom"
        }
    }, menuItems));
};
var $f41526a41ad60ac1$export$2e2bcd8739ae039 = $f41526a41ad60ac1$var$SiteItem;













const $1bdb4b0e6d203096$export$fedd53519a0e2bce = (props)=>{
    const { enqueueSnackbar: enqueueSnackbar } = (0, $5e19452f9528802f$export$1c97ac2c9a6e7c09)();
    const navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    const location = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)();
    const stateData = location.state;
    const [isLoading, setIsLoading] = (0, $8FY87.useState)(false);
    const [showIsDirtySites, setShowIsDirtySites] = (0, $8FY87.useState)(false);
    const [sitesData, setSitesData] = (0, $8FY87.useState)([]);
    const [cookie_userData, setCookie_userData, removeCookie_userData] = (0, $1f373de1ceea6eb7$export$2e2bcd8739ae039)([
        "rp_user_data"
    ]);
    async function fetchData() {
        // let user: any = localStorage.getItem("userData") || "";
        // console.log('fetchData', ,cookie_userData.rp_user_data)
        setIsLoading(true);
        try {
            let user = cookie_userData.rp_user_data || location.state && location.state.user.data;
            // user = JSON.parse(user);
            if (user) {
                let response = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).get(`/api/configs/users-site-configs?userId=${user.userId}`);
                setSitesData(response.data.data);
                setShowIsDirtySites(response.data.data.filter((oo)=>oo.isDirty === "true").length > 0 || response.data.data.filter((oo)=>oo.disabled).length > 0);
            // console.log("response", response.data.data);
            }
        } catch (e) {} finally{
            setIsLoading(false);
        }
    }
    $8FY87.useEffect(()=>{
        fetchData();
    }, []);
    const onCreateNewWebsite = ()=>{
        navigate(`/choose-template`);
    };
    const onSiteRename = async (siteId, newSiteName)=>{
        try {
            setIsLoading(true);
            await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post(`/api/configs/append-site-config`, {
                siteId: siteId,
                siteName: newSiteName
            });
            fetchData();
        } catch (e) {
            console.error("onSiteRename", e);
        } finally{
            setIsLoading(false);
        }
    };
    const onSiteDelete = async (siteId)=>{
        try {
            setIsLoading(true);
            await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post(`/api/configs/delete-site`, {
                siteId: siteId
            });
            enqueueSnackbar("Site deleted successfully!", {
                variant: "info",
                className: "bg-grey-400"
            });
            fetchData();
        } catch (e) {
            console.error("onSiteDelete", e);
        } finally{
            setIsLoading(false);
        }
    };
    const onSiteDuplicate = async (siteId)=>{
        setIsLoading(true);
        try {
            setIsLoading(true);
            await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post(`/api/configs/duplicate-site`, {
                siteId: siteId
            });
            enqueueSnackbar("Site duplicated successfully!", {
                variant: "success",
                className: "bg-grey-400"
            });
            fetchData();
        } catch (e) {
            console.error("onSiteDuplicate", e);
        } finally{
            setIsLoading(false);
        }
    };
    return /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, null, /*#__PURE__*/ $8FY87.createElement((0, $274ffc8236991365$export$dcef8f9bb9a41431), null, /*#__PURE__*/ $8FY87.createElement("title", null, "RocketPages - Dashboard"), /*#__PURE__*/ $8FY87.createElement("meta", {
        name: "description",
        content: "Build and Launch Your Free Website in Just 15 Minutes"
    }), /*#__PURE__*/ $8FY87.createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap",
        rel: "stylesheet"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "icon",
        href: "/favicon.ico"
    }), false), /*#__PURE__*/ $8FY87.createElement((0, $9ada84cce5691847$export$2e2bcd8739ae039), null), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "font-body text-base font-medium"
    }, /*#__PURE__*/ $8FY87.createElement((0, $56dcde36b8493878$export$2e2bcd8739ae039), {
        sx: {
            color: "#fff",
            zIndex: (theme)=>theme.zIndex.drawer + 1
        },
        open: isLoading
    }, /*#__PURE__*/ $8FY87.createElement((0, $b391f94ee7b6de9b$export$2e2bcd8739ae039), {
        color: "inherit"
    })), /*#__PURE__*/ $8FY87.createElement((0, $c0f0a0f6efad2fa3$export$42cfbb80f7861e77), {
        ...stateData,
        title: "My websites"
    }), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "bg-gray-100 flex absolute flex-col top-[64px] w-full"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "w-full"
    }, sitesData.length > 0 && /*#__PURE__*/ $8FY87.createElement("div", {
        className: "py-3 px-4 flex md:justify-end"
    }, /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        size: "small",
        variant: "contained",
        sx: {
            backgroundColor: "#243060",
            textTransform: "none"
        },
        startIcon: /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ec74df1fc55deeea$exports))), {
            sx: {
                color: "#fff"
            }
        }),
        onClick: onCreateNewWebsite
    }, "Create new website")), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "bg-gray-100 min-h-screen p-4"
    }, showIsDirtySites && /*#__PURE__*/ $8FY87.createElement("div", {
        className: "fixed action-popup inset-0 overflow-y-auto flex justify-center items-center z-10 "
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "fixed inset-0"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "absolute inset-0 bg-gray-500 opacity-75"
    })), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "bg-[#FAFAFA] rounded-xl p-2 w-11/12 mx-auto z-50 border-2 border-red-600 m-4 absolute lg:top-auto top-20 "
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex justify-end"
    }, /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ccface632907bed5$exports))), {
        className: "hover:cursor-pointer absolute",
        onClick: ()=>setShowIsDirtySites(false)
    })), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex pt-2 px-4 sm:px-2 pb-4 flex-col justify-center text-black items-center"
    }, /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($80cdb5096bdf46ee$exports))), {
        sx: {
            color: "red"
        }
    }), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-red-500 font-medium mt-1.5 mb-1.5"
    }, "Actions Required"), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-base font-normal text-center"
    }, "Some of your sites need your immediate attention."), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex h-[60vh] w-full mt-4 lg:flex-row flex-col"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: `border md:h-full unsaved-sites  h-1/2 overflow-y-auto border-color-red w-full lg:w-1/2 lg:mr-2 mr-0 p-2 mb-4 rounded-md bg-white flex-1 ${sitesData.filter((oo)=>oo.isDirty === "true").length === 0 ? "hidden" : ""}`
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-row items-center justify-between w-full mt-1"
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-red-500"
    }, sitesData.filter((oo)=>oo.isDirty === "true").length, " ", sitesData.filter((oo)=>oo.isDirty === "true").length === 1 ? "Site" : "Sites", " ", "at Risk of Deletion:"), /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        size: "small",
        variant: "contained",
        className: "",
        sx: {
            backgroundColor: "#243060",
            textTransform: "none",
            width: "85px"
        },
        onClick: async ()=>{
            setIsLoading(true);
            let _jjjj = [];
            sitesData.filter((oo)=>oo.isDirty === "true").map((oo)=>_jjjj.push(oo.siteId));
            let res = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post(`/api/configs/retain-sites`, {
                siteIds: _jjjj
            });
            if (res.status === 200) fetchData();
        }
    }, "Save all")), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col rounded-md h-8/12 overflow-y-auto w-full mt-4"
    }, sitesData.filter((oo)=>oo.isDirty === "true").map((itm, _idx)=>{
        return /*#__PURE__*/ $8FY87.createElement("div", {
            className: `flex flex-row items-center md:gap-0 gap-2 justify-between md:mx-4 mx-1 py-2 border-b`,
            key: itm.siteId
        }, /*#__PURE__*/ $8FY87.createElement("span", {
            className: "flex items-center"
        }, /*#__PURE__*/ $8FY87.createElement("span", {
            className: "mr-4"
        }, _idx + 1), /*#__PURE__*/ $8FY87.createElement("span", {
            className: "text-left"
        }, itm.siteName)), /*#__PURE__*/ $8FY87.createElement("span", {
            className: "flex"
        }, /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
            size: "small",
            variant: "outlined",
            sx: {
                // backgroundColor: "#243060",
                marginRight: "8px",
                textTransform: "none"
            },
            onClick: async ()=>{
                let res = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post(`/api/configs/retain-sites`, {
                    siteIds: [
                        itm.siteId
                    ]
                });
                if (res.status === 200) fetchData();
            }
        }, "Save"), /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
            size: "small",
            variant: "outlined",
            sx: {
                // backgroundColor: "#243060",
                textTransform: "none"
            },
            onClick: ()=>{
                let _url = `${"http://editor.rocketpages.io"}/${itm.siteId}`;
                window.open(_url, "_self")?.focus();
            }
        }, "Edit")));
    }))), /*#__PURE__*/ $8FY87.createElement("div", {
        className: `border md:h-full visitor-limit-exide-sites  h-1/2 overflow-y-auto border-color-red w-full lg:w-1/2 lg:ml-2 ml-0 p-2 rounded-md bg-white flex-1 ${sitesData.filter((oo)=>oo.disabled).length === 0 ? "hidden" : ""}`
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-row md:text-left justify-between w-full mt-2.5"
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-red-500"
    }, sitesData.filter((oo)=>oo.disabled === "true").length, " ", sitesData.filter((oo)=>oo.disabled === "true").length === 1 ? "Site" : "Sites", " ", "hit visitor limit and are now disabled. Upgrade to keep live.")), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col  rounded-md h-8/12 overflow-y-auto w-full mt-6"
    }, sitesData.filter((oo)=>oo.disabled).map((itm, _idx)=>{
        return /*#__PURE__*/ $8FY87.createElement("div", {
            key: itm.siteId,
            className: `flex flex-row items-center md:gap-0 gap-2 justify-between md:mx-4 mx-1 py-2 border-b`
        }, /*#__PURE__*/ $8FY87.createElement("span", {
            className: "flex"
        }, /*#__PURE__*/ $8FY87.createElement("span", {
            className: "mr-4 items-center flex"
        }, _idx + 1), /*#__PURE__*/ $8FY87.createElement("span", null, itm.siteName)), /*#__PURE__*/ $8FY87.createElement("span", null, /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
            size: "small",
            variant: "outlined",
            className: "w-max ",
            sx: {
                // backgroundColor: "#243060",
                textTransform: "none"
            },
            onClick: ()=>{
                navigate(`/site-settings/${itm.siteId}?section=Subscriptions&tab=pricing`);
            }
        }, "Upgrade Plan")));
    }))))))), sitesData.length === 0 && /*#__PURE__*/ $8FY87.createElement((0, $fe8cd0ba0f54f349$export$2e2bcd8739ae039), {
        onNewWebsiteClick: onCreateNewWebsite
    }), sitesData.length > 0 && /*#__PURE__*/ $8FY87.createElement("div", {
        className: "bg-[#FFD970] flex justify-center py-2 text-black mx-4"
    }, /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($80cdb5096bdf46ee$exports))), null), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "ml-2 flex items-center"
    }, "Your websites will be deleted if not saved or updated within 3 days.")), sitesData.length > 0 && /*#__PURE__*/ $8FY87.createElement("div", {
        className: "px-4 grid grid-cols-1 gap-8 py-4 md:grid-cols-2 lg:grid-cols-3"
    }, sitesData.map((item)=>{
        return /*#__PURE__*/ $8FY87.createElement((0, $f41526a41ad60ac1$export$2e2bcd8739ae039), {
            key: item.siteId,
            data: item,
            sitesData: sitesData,
            onSettingClick: ()=>{
                navigate(`/site-settings/${item.siteId}`);
            },
            onEditSite: ()=>{
                window.location.href = `${"http://editor.rocketpages.io"}/${item.siteId}/`;
            // window.location.reload();
            },
            onSiteRename: (siteId, newSiteName)=>{
                onSiteRename(siteId, newSiteName);
            // console.log(`Rename ${siteId} to ${newSiteName}`);
            },
            onSiteDelete: (siteId)=>{
                onSiteDelete(siteId);
            // console.log(`delete ${siteId}`);
            },
            onSiteDuplicate: (siteId)=>{
                onSiteDuplicate(siteId);
            // console.log(`duplicate ${siteId}`);
            }
        });
    })))))), /*#__PURE__*/ $8FY87.createElement((0, $fdcc8de0ec44fdd8$export$2e2bcd8739ae039), null));
};



var $8FY87 = parcelRequire("8FY87");





const $f721fe497a6e5e78$export$a76a49cc6daba0ed = (props)=>{
    const location = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)();
    const stateData = location.state;
    return /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, null, /*#__PURE__*/ $8FY87.createElement((0, $274ffc8236991365$export$dcef8f9bb9a41431), null, /*#__PURE__*/ $8FY87.createElement("title", null, "RocketPages - DNS Service Providers"), /*#__PURE__*/ $8FY87.createElement("meta", {
        name: "description",
        content: "Build and Launch Your Free Website in Just 15 Minutes"
    }), /*#__PURE__*/ $8FY87.createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap",
        rel: "stylesheet"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "icon",
        href: "/favicon.ico"
    }), false), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "font-body text-base font-medium dns-service-providers"
    }, /*#__PURE__*/ $8FY87.createElement((0, $c0f0a0f6efad2fa3$export$42cfbb80f7861e77), {
        ...stateData,
        title: "DNS Service Providers"
    }), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "my-4 pl-[20px]  pb-10 pt-[64px] bg-white-smoke pr-[20px] text-black font-normal"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "lg:w-auto xl:w-8/12 m-auto bg-white px-4 lg:px-24 py-8"
    }, /*#__PURE__*/ $8FY87.createElement("h3", null, "GoDaddy"), /*#__PURE__*/ $8FY87.createElement("ol", null, /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Sign In to GoDaddy:"), /*#__PURE__*/ $8FY87.createElement("ul", null, /*#__PURE__*/ $8FY87.createElement("li", null, "Log in to your GoDaddy account."))), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Access Domain Settings:"), /*#__PURE__*/ $8FY87.createElement("ul", null, /*#__PURE__*/ $8FY87.createElement("li", null, 'Navigate to "My Products."'), /*#__PURE__*/ $8FY87.createElement("li", null, 'Find your domain and click on "DNS" or "Manage."'))), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Add a New A Record:"), /*#__PURE__*/ $8FY87.createElement("ul", null, /*#__PURE__*/ $8FY87.createElement("li", null, 'Scroll down to the "Records" section.'), /*#__PURE__*/ $8FY87.createElement("li", null, 'Click "Add" to create a new DNS record.'), /*#__PURE__*/ $8FY87.createElement("li", null, 'Select "A" as the record type.'), /*#__PURE__*/ $8FY87.createElement("li", null, "Enter the following details:", /*#__PURE__*/ $8FY87.createElement("ul", {
        className: "list-square"
    }, /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Name:"), ' "[YourDomainName]"'), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Value:"), " 146.190.156.136"), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "TTL:"), " Default"))))), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Update an Existing A Record:"), /*#__PURE__*/ $8FY87.createElement("ul", null, /*#__PURE__*/ $8FY87.createElement("li", null, "Find the existing A record you want to update."), /*#__PURE__*/ $8FY87.createElement("li", null, "Click the pencil icon next to the record to edit it."), /*#__PURE__*/ $8FY87.createElement("li", null, 'Update the details as needed (e.g., change the IP address in the "Value" field to 146.190.156.136).'), /*#__PURE__*/ $8FY87.createElement("li", null, 'Click "Save."')))), /*#__PURE__*/ $8FY87.createElement("h3", null, "Cloudflare"), /*#__PURE__*/ $8FY87.createElement("ol", null, /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Sign In to Cloudflare:"), /*#__PURE__*/ $8FY87.createElement("ul", null, /*#__PURE__*/ $8FY87.createElement("li", null, "Log in to your Cloudflare account."))), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Access DNS Settings:"), /*#__PURE__*/ $8FY87.createElement("ul", null, /*#__PURE__*/ $8FY87.createElement("li", null, "Select the domain you want to manage."), /*#__PURE__*/ $8FY87.createElement("li", null, 'Click on the "DNS" tab.'))), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Add a New A Record:"), /*#__PURE__*/ $8FY87.createElement("ul", null, /*#__PURE__*/ $8FY87.createElement("li", null, 'Click "Add record."'), /*#__PURE__*/ $8FY87.createElement("li", null, 'Select "A" as the record type.'), /*#__PURE__*/ $8FY87.createElement("li", null, "Enter the following details:", /*#__PURE__*/ $8FY87.createElement("ul", {
        className: "list-square"
    }, /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Name:"), " [YourDomainName]"), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "IPv4 address:"), " 146.190.156.136"), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "TTL:"), " Auto"))))), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Update an Existing A Record:"), /*#__PURE__*/ $8FY87.createElement("ul", null, /*#__PURE__*/ $8FY87.createElement("li", null, "Find the existing A record you want to update."), /*#__PURE__*/ $8FY87.createElement("li", null, "Click on the record to edit it."), /*#__PURE__*/ $8FY87.createElement("li", null, 'Update the details as needed (e.g., change the IP address in the "IPv4 address" field to 146.190.156.136).'), /*#__PURE__*/ $8FY87.createElement("li", null, 'Click "Save."')))), /*#__PURE__*/ $8FY87.createElement("h3", null, "Amazon Route 53"), /*#__PURE__*/ $8FY87.createElement("ol", null, /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Sign In to AWS Management Console:"), /*#__PURE__*/ $8FY87.createElement("ul", null, /*#__PURE__*/ $8FY87.createElement("li", null, "Go to the AWS Management Console and log in."))), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Access Route 53:"), /*#__PURE__*/ $8FY87.createElement("ul", null, /*#__PURE__*/ $8FY87.createElement("li", null, "Navigate to Amazon Route 53."), /*#__PURE__*/ $8FY87.createElement("li", null, 'Click on "Hosted Zones."'))), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Select Domain:"), /*#__PURE__*/ $8FY87.createElement("ul", null, /*#__PURE__*/ $8FY87.createElement("li", null, "Choose the domain you want to manage."))), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Add a New A Record:"), /*#__PURE__*/ $8FY87.createElement("ul", null, /*#__PURE__*/ $8FY87.createElement("li", null, 'Click "Create Record Set."'), /*#__PURE__*/ $8FY87.createElement("li", null, "Enter the following details:", /*#__PURE__*/ $8FY87.createElement("ul", {
        className: "list-square"
    }, /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Name:"), " [YourDomainName]"), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Type:"), " A - IPv4 address"), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Value:"), " 146.190.156.136"))))), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Update an Existing A Record:"), /*#__PURE__*/ $8FY87.createElement("ul", null, /*#__PURE__*/ $8FY87.createElement("li", null, "Find the existing A record you want to update."), /*#__PURE__*/ $8FY87.createElement("li", null, "Click on the record to edit it."), /*#__PURE__*/ $8FY87.createElement("li", null, 'Update the details as needed (e.g., change the IP address in the "Value" field to 146.190.156.136).'), /*#__PURE__*/ $8FY87.createElement("li", null, 'Click "Save Record Set."')))), /*#__PURE__*/ $8FY87.createElement("h3", null, "Google Domains"), /*#__PURE__*/ $8FY87.createElement("ol", null, /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Sign In to Google Domains:"), /*#__PURE__*/ $8FY87.createElement("ul", null, /*#__PURE__*/ $8FY87.createElement("li", null, "Go to Google Domains and log in to your account."))), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Manage Domain:"), /*#__PURE__*/ $8FY87.createElement("ul", null, /*#__PURE__*/ $8FY87.createElement("li", null, 'Locate your domain and click on "Manage" or "DNS."'))), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Add a New A Record:"), /*#__PURE__*/ $8FY87.createElement("ul", null, /*#__PURE__*/ $8FY87.createElement("li", null, 'Scroll down to the "Custom resource records" section.'), /*#__PURE__*/ $8FY87.createElement("li", null, "Enter the following details:", /*#__PURE__*/ $8FY87.createElement("ul", {
        className: "list-square"
    }, /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Name:"), " [YourDomainName]"), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Type:"), " A"), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "TTL:"), " 1h"), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Data:"), " 146.190.156.136"))))), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Update an Existing A Record:"), /*#__PURE__*/ $8FY87.createElement("ul", null, /*#__PURE__*/ $8FY87.createElement("li", null, "Find the existing A record you want to update."), /*#__PURE__*/ $8FY87.createElement("li", null, "Click on the pencil icon next to the record to edit it."), /*#__PURE__*/ $8FY87.createElement("li", null, 'Update the details as needed (e.g., change the IP address in the "Data" field to 146.190.156.136).'), /*#__PURE__*/ $8FY87.createElement("li", null, 'Click "Save."')))), /*#__PURE__*/ $8FY87.createElement("h3", null, "Namecheap"), /*#__PURE__*/ $8FY87.createElement("ol", null, /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Sign In to Namecheap:"), /*#__PURE__*/ $8FY87.createElement("ul", null, /*#__PURE__*/ $8FY87.createElement("li", null, "Log in to your Namecheap account."))), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Manage Domain:"), /*#__PURE__*/ $8FY87.createElement("ul", null, /*#__PURE__*/ $8FY87.createElement("li", null, "Select the domain you want to manage."), /*#__PURE__*/ $8FY87.createElement("li", null, 'Click on "Manage" next to the domain.'))), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Access Advanced DNS:"), /*#__PURE__*/ $8FY87.createElement("ul", null, /*#__PURE__*/ $8FY87.createElement("li", null, 'Click on the "Advanced DNS" tab.'))), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Add a New A Record:"), /*#__PURE__*/ $8FY87.createElement("ul", null, /*#__PURE__*/ $8FY87.createElement("li", null, 'Scroll down to the "Host Records" section.'), /*#__PURE__*/ $8FY87.createElement("li", null, 'Click "Add New Record."'), /*#__PURE__*/ $8FY87.createElement("li", null, 'Select "A Record" as the type.'), /*#__PURE__*/ $8FY87.createElement("li", null, "Enter the following details:", /*#__PURE__*/ $8FY87.createElement("ul", {
        className: "list-square"
    }, /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Host Record:"), " [YourDomainName]"), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Points To:"), " 146.190.156.136"), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "TTL:"), " Automatic"))), /*#__PURE__*/ $8FY87.createElement("li", null, "Click the checkmark to save."))), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Update an Existing A Record:"), /*#__PURE__*/ $8FY87.createElement("ul", null, /*#__PURE__*/ $8FY87.createElement("li", null, "Find the existing A record you want to update."), /*#__PURE__*/ $8FY87.createElement("li", null, "Click on the pencil icon next to the record to edit it."), /*#__PURE__*/ $8FY87.createElement("li", null, 'Update the details as needed (e.g., change the IP address in the "IP Address" field to 146.190.156.136).'), /*#__PURE__*/ $8FY87.createElement("li", null, "Click the checkmark to save.")))), /*#__PURE__*/ $8FY87.createElement("h3", null, "Bluehost"), /*#__PURE__*/ $8FY87.createElement("ol", null, /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Sign In to Namecheap:"), /*#__PURE__*/ $8FY87.createElement("ul", null, /*#__PURE__*/ $8FY87.createElement("li", null, "Log in to your Bluehost account."))), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Access Domain Manager:"), /*#__PURE__*/ $8FY87.createElement("ul", null, /*#__PURE__*/ $8FY87.createElement("li", null, 'From the Bluehost dashboard, click on "Domains" and then "My Domains."'))), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Manage DNS:"), /*#__PURE__*/ $8FY87.createElement("ul", null, /*#__PURE__*/ $8FY87.createElement("li", null, 'Click the "Manage" button next to the domain you want to update.'))), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Add a New A Record:"), /*#__PURE__*/ $8FY87.createElement("ul", null, /*#__PURE__*/ $8FY87.createElement("li", null, 'Go to the "DNS" tab.'), /*#__PURE__*/ $8FY87.createElement("li", null, 'Scroll down to the "Add DNS Record" section.'), /*#__PURE__*/ $8FY87.createElement("li", null, 'Select "A" as the record type.'), /*#__PURE__*/ $8FY87.createElement("li", null, "Enter the following details:", /*#__PURE__*/ $8FY87.createElement("ul", {
        className: "list-square"
    }, /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Host Record:"), " [YourDomainName]"), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Points To:"), " 146.190.156.136"), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "TTL:"), " Default"))), /*#__PURE__*/ $8FY87.createElement("li", null, 'Click "Save."'))), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Update an Existing A Record:"), /*#__PURE__*/ $8FY87.createElement("ul", null, /*#__PURE__*/ $8FY87.createElement("li", null, "Find the existing A record you want to update."), /*#__PURE__*/ $8FY87.createElement("li", null, 'Click "Edit" next to the record.'), /*#__PURE__*/ $8FY87.createElement("li", null, 'Update the details as needed (e.g., change the IP address in the "Points To" field to 146.190.156.136).'), /*#__PURE__*/ $8FY87.createElement("li", null, 'Click "Save."')))), /*#__PURE__*/ $8FY87.createElement("h3", null, "HostGator"), /*#__PURE__*/ $8FY87.createElement("ol", null, /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Sign In to HostGator:"), /*#__PURE__*/ $8FY87.createElement("ul", null, /*#__PURE__*/ $8FY87.createElement("li", null, "Log in to your HostGator account."))), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Access Domain Manager:"), /*#__PURE__*/ $8FY87.createElement("ul", null, /*#__PURE__*/ $8FY87.createElement("li", null, 'From the HostGator dashboard, click on "Domains" and then "My Domains."'))), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Manage DNS:"), /*#__PURE__*/ $8FY87.createElement("ul", null, /*#__PURE__*/ $8FY87.createElement("li", null, 'Click the "Manage" button next to the domain you want to update.'))), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Add a New A Record:"), /*#__PURE__*/ $8FY87.createElement("ul", null, /*#__PURE__*/ $8FY87.createElement("li", null, 'Go to the "DNS" tab.'), /*#__PURE__*/ $8FY87.createElement("li", null, 'Scroll down to the "Add DNS Record" section.'), /*#__PURE__*/ $8FY87.createElement("li", null, 'Select "A" as the record type.'), /*#__PURE__*/ $8FY87.createElement("li", null, "Enter the following details:", /*#__PURE__*/ $8FY87.createElement("ul", {
        className: "list-square"
    }, /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Host Record:"), " [YourDomainName]"), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Points To:"), " 146.190.156.136"), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "TTL:"), " Default"))), /*#__PURE__*/ $8FY87.createElement("li", null, 'Click "Save."'))), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Update an Existing A Record:"), /*#__PURE__*/ $8FY87.createElement("ul", null, /*#__PURE__*/ $8FY87.createElement("li", null, "Find the existing A record you want to update."), /*#__PURE__*/ $8FY87.createElement("li", null, 'Click "Edit" next to the record.'), /*#__PURE__*/ $8FY87.createElement("li", null, 'Update the details as needed (e.g., change the IP address in the "Points To" field to 146.190.156.136).'), /*#__PURE__*/ $8FY87.createElement("li", null, 'Click "Save."')))), /*#__PURE__*/ $8FY87.createElement("h3", null, "Final Steps for All Providers"), /*#__PURE__*/ $8FY87.createElement("ul", null, /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Wait for Propagation:"), /*#__PURE__*/ $8FY87.createElement("ul", {
        className: "list-square"
    }, /*#__PURE__*/ $8FY87.createElement("li", null, "Allow up to 24-48 hours for DNS changes to propagate."))), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement("b", null, "Test Your Domain:"), /*#__PURE__*/ $8FY87.createElement("ul", {
        className: "list-square"
    }, /*#__PURE__*/ $8FY87.createElement("li", null, "Visit your domain to ensure it is correctly pointing to your hosting provider."))))))), /*#__PURE__*/ $8FY87.createElement((0, $fdcc8de0ec44fdd8$export$2e2bcd8739ae039), null));
};



var $8FY87 = parcelRequire("8FY87");




var $8FY87 = parcelRequire("8FY87");




var $8FY87 = parcelRequire("8FY87");

var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $lXBIJ = parcelRequire("lXBIJ");

var $lbp1P = parcelRequire("lbp1P");

var $6lkQ3 = parcelRequire("6lkQ3");

var $ifmKX = parcelRequire("ifmKX");


var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $194a91f7902427b5$export$47a2da616e55e8e9(slot) {
    return (0, $jP65K.default)('MuiAppBar', slot);
}
const $194a91f7902427b5$var$appBarClasses = (0, $cOYaX.default)('MuiAppBar', [
    'root',
    'positionFixed',
    'positionAbsolute',
    'positionSticky',
    'positionStatic',
    'positionRelative',
    'colorDefault',
    'colorPrimary',
    'colorSecondary',
    'colorInherit',
    'colorTransparent',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning'
]);
var $194a91f7902427b5$export$2e2bcd8739ae039 = $194a91f7902427b5$var$appBarClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $2af46c77336007a5$var$_excluded = [
    "className",
    "color",
    "enableColorOnDark",
    "position"
];
const $2af46c77336007a5$var$useUtilityClasses = (ownerState)=>{
    const { color: color, position: position, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $ifmKX.default)(color)}`,
            `position${(0, $ifmKX.default)(position)}`
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $194a91f7902427b5$export$47a2da616e55e8e9), classes);
};
// var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'
const $2af46c77336007a5$var$joinVars = (var1, var2)=>var1 ? `${var1 == null ? void 0 : var1.replace(')', '')}, ${var2})` : var2;
const $2af46c77336007a5$var$AppBarRoot = (0, $lbp1P.default)((0, $d9c49ac25a55e29d$export$2e2bcd8739ae039), {
    name: 'MuiAppBar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $ifmKX.default)(ownerState.position)}`],
            styles[`color${(0, $ifmKX.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const backgroundColorDefault = theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
    return (0, $zgVxD.default)({
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        boxSizing: 'border-box',
        // Prevent padding issue with the Modal and fixed positioned AppBar.
        flexShrink: 0
    }, ownerState.position === 'fixed' && {
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: 'auto',
        right: 0,
        '@media print': {
            // Prevent the app bar to be visible on each printed page.
            position: 'absolute'
        }
    }, ownerState.position === 'absolute' && {
        position: 'absolute',
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: 'auto',
        right: 0
    }, ownerState.position === 'sticky' && {
        // ⚠️ sticky is not supported by IE11.
        position: 'sticky',
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: 'auto',
        right: 0
    }, ownerState.position === 'static' && {
        position: 'static'
    }, ownerState.position === 'relative' && {
        position: 'relative'
    }, !theme.vars && (0, $zgVxD.default)({}, ownerState.color === 'default' && {
        backgroundColor: backgroundColorDefault,
        color: theme.palette.getContrastText(backgroundColorDefault)
    }, ownerState.color && ownerState.color !== 'default' && ownerState.color !== 'inherit' && ownerState.color !== 'transparent' && {
        backgroundColor: theme.palette[ownerState.color].main,
        color: theme.palette[ownerState.color].contrastText
    }, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, theme.palette.mode === 'dark' && !ownerState.enableColorOnDark && {
        backgroundColor: null,
        color: null
    }, ownerState.color === 'transparent' && (0, $zgVxD.default)({
        backgroundColor: 'transparent',
        color: 'inherit'
    }, theme.palette.mode === 'dark' && {
        backgroundImage: 'none'
    })), theme.vars && (0, $zgVxD.default)({}, ownerState.color === 'default' && {
        '--AppBar-background': ownerState.enableColorOnDark ? theme.vars.palette.AppBar.defaultBg : $2af46c77336007a5$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette.AppBar.defaultBg),
        '--AppBar-color': ownerState.enableColorOnDark ? theme.vars.palette.text.primary : $2af46c77336007a5$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette.text.primary)
    }, ownerState.color && !ownerState.color.match(/^(default|inherit|transparent)$/) && {
        '--AppBar-background': ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].main : $2af46c77336007a5$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette[ownerState.color].main),
        '--AppBar-color': ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].contrastText : $2af46c77336007a5$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette[ownerState.color].contrastText)
    }, ![
        'inherit',
        'transparent'
    ].includes(ownerState.color) && {
        backgroundColor: 'var(--AppBar-background)'
    }, {
        color: ownerState.color === 'inherit' ? 'inherit' : 'var(--AppBar-color)'
    }, ownerState.color === 'transparent' && {
        backgroundImage: 'none',
        backgroundColor: 'transparent',
        color: 'inherit'
    }));
});
const $2af46c77336007a5$var$AppBar = /*#__PURE__*/ $8FY87.forwardRef(function AppBar(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiAppBar'
    });
    const { className: className, color: color = 'primary', enableColorOnDark: enableColorOnDark = false, position: position = 'fixed' } = props, other = (0, $93aRW.default)(props, $2af46c77336007a5$var$_excluded);
    const ownerState = (0, $zgVxD.default)({}, props, {
        color: color,
        position: position,
        enableColorOnDark: enableColorOnDark
    });
    const classes = $2af46c77336007a5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2PPWI.jsx)($2af46c77336007a5$var$AppBarRoot, (0, $zgVxD.default)({
        square: true,
        component: "header",
        ownerState: ownerState,
        elevation: 4,
        className: (0, $efJYy.default)(classes.root, className, position === 'fixed' && 'mui-fixed'),
        ref: ref
    }, other));
});
var $2af46c77336007a5$export$2e2bcd8739ae039 = $2af46c77336007a5$var$AppBar;




var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $lXBIJ = parcelRequire("lXBIJ");

var $6lkQ3 = parcelRequire("6lkQ3");

var $lbp1P = parcelRequire("lbp1P");

var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $ce10e4f33dc37979$export$b12cb262231eef32(slot) {
    return (0, $jP65K.default)('MuiToolbar', slot);
}
const $ce10e4f33dc37979$var$toolbarClasses = (0, $cOYaX.default)('MuiToolbar', [
    'root',
    'gutters',
    'regular',
    'dense'
]);
var $ce10e4f33dc37979$export$2e2bcd8739ae039 = $ce10e4f33dc37979$var$toolbarClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $a60f3197d9f0bd53$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "variant"
];
const $a60f3197d9f0bd53$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            !disableGutters && 'gutters',
            variant
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $ce10e4f33dc37979$export$b12cb262231eef32), classes);
};
const $a60f3197d9f0bd53$var$ToolbarRoot = (0, $lbp1P.default)('div', {
    name: 'MuiToolbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $zgVxD.default)({
        position: 'relative',
        display: 'flex',
        alignItems: 'center'
    }, !ownerState.disableGutters && {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }
    }, ownerState.variant === 'dense' && {
        minHeight: 48
    }), ({ theme: theme, ownerState: ownerState })=>ownerState.variant === 'regular' && theme.mixins.toolbar);
const $a60f3197d9f0bd53$var$Toolbar = /*#__PURE__*/ $8FY87.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiToolbar'
    });
    const { className: className, component: component = 'div', disableGutters: disableGutters = false, variant: variant = 'regular' } = props, other = (0, $93aRW.default)(props, $a60f3197d9f0bd53$var$_excluded);
    const ownerState = (0, $zgVxD.default)({}, props, {
        component: component,
        disableGutters: disableGutters,
        variant: variant
    });
    const classes = $a60f3197d9f0bd53$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2PPWI.jsx)($a60f3197d9f0bd53$var$ToolbarRoot, (0, $zgVxD.default)({
        as: component,
        className: (0, $efJYy.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $a60f3197d9f0bd53$export$2e2bcd8739ae039 = $a60f3197d9f0bd53$var$Toolbar;





var $238cad0c90e1fe0b$exports = {};
"use strict";
"use client";

var $bcBLN = parcelRequire("bcBLN");
Object.defineProperty($238cad0c90e1fe0b$exports, "__esModule", {
    value: true
});
$238cad0c90e1fe0b$exports.default = void 0;

var $238cad0c90e1fe0b$var$_createSvgIcon = $bcBLN((parcelRequire("485sq")));

var $2PPWI = parcelRequire("2PPWI");
var $238cad0c90e1fe0b$var$_default = $238cad0c90e1fe0b$exports.default = (0, $238cad0c90e1fe0b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2PPWI.jsx)("path", {
    d: "M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z"
}), 'Menu');




var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");



var $jP65K = parcelRequire("jP65K");

var $lXBIJ = parcelRequire("lXBIJ");

var $d1bCP = parcelRequire("d1bCP");



var $1BEIC = parcelRequire("1BEIC");

var $2PPWI = parcelRequire("2PPWI");
const $767b1e199314b8b8$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "fixed",
    "maxWidth",
    "classes"
];
const $767b1e199314b8b8$var$defaultTheme = (0, $1BEIC.default)();
const $767b1e199314b8b8$var$defaultCreateStyledComponent = (0, $1d6de6ddc483a5d0$export$2e2bcd8739ae039)('div', {
    name: 'MuiContainer',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`maxWidth${(0, $d1bCP.default)(String(ownerState.maxWidth))}`],
            ownerState.fixed && styles.fixed,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
});
const $767b1e199314b8b8$var$useThemePropsDefault = (inProps)=>(0, $6ead70688dfc969e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiContainer',
        defaultTheme: $767b1e199314b8b8$var$defaultTheme
    });
const $767b1e199314b8b8$var$useUtilityClasses = (ownerState, componentName)=>{
    const getContainerUtilityClass = (slot)=>{
        return (0, $jP65K.default)(componentName, slot);
    };
    const { classes: classes, fixed: fixed, disableGutters: disableGutters, maxWidth: maxWidth } = ownerState;
    const slots = {
        root: [
            'root',
            maxWidth && `maxWidth${(0, $d1bCP.default)(String(maxWidth))}`,
            fixed && 'fixed',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $lXBIJ.default)(slots, getContainerUtilityClass, classes);
};
function $767b1e199314b8b8$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $767b1e199314b8b8$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $767b1e199314b8b8$var$useThemePropsDefault, componentName: componentName = 'MuiContainer' } = options;
    const ContainerRoot = createStyledComponent(({ theme: theme, ownerState: ownerState })=>(0, $zgVxD.default)({
            width: '100%',
            marginLeft: 'auto',
            boxSizing: 'border-box',
            marginRight: 'auto',
            display: 'block'
        }, !ownerState.disableGutters && {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up('sm')]: {
                paddingLeft: theme.spacing(3),
                paddingRight: theme.spacing(3)
            }
        }), ({ theme: theme, ownerState: ownerState })=>ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey)=>{
            const breakpoint = breakpointValueKey;
            const value = theme.breakpoints.values[breakpoint];
            if (value !== 0) // @ts-ignore
            acc[theme.breakpoints.up(breakpoint)] = {
                maxWidth: `${value}${theme.breakpoints.unit}`
            };
            return acc;
        }, {}), ({ theme: theme, ownerState: ownerState })=>(0, $zgVxD.default)({}, ownerState.maxWidth === 'xs' && {
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up('xs')]: {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                maxWidth: Math.max(theme.breakpoints.values.xs, 444)
            }
        }, ownerState.maxWidth && // @ts-ignore module augmentation fails if custom breakpoints are used
        ownerState.maxWidth !== 'xs' && {
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up(ownerState.maxWidth)]: {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
            }
        }));
    const Container = /*#__PURE__*/ $8FY87.forwardRef(function Container(inProps, ref) {
        const props = useThemeProps(inProps);
        const { className: className, component: component = 'div', disableGutters: disableGutters = false, fixed: fixed = false, maxWidth: maxWidth = 'lg' } = props, other = (0, $93aRW.default)(props, $767b1e199314b8b8$var$_excluded);
        const ownerState = (0, $zgVxD.default)({}, props, {
            component: component,
            disableGutters: disableGutters,
            fixed: fixed,
            maxWidth: maxWidth
        });
        // @ts-ignore module augmentation fails if custom breakpoints are used
        const classes = $767b1e199314b8b8$var$useUtilityClasses(ownerState, componentName);
        return(/*#__PURE__*/ // @ts-ignore theme is injected by the styled util
        (0, $2PPWI.jsx)(ContainerRoot, (0, $zgVxD.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $8bcfdb8fb9b51cc8$export$2e2bcd8739ae039)(classes.root, className),
            ref: ref
        }, other)));
    });
    return Container;
}



var $ifmKX = parcelRequire("ifmKX");

var $lbp1P = parcelRequire("lbp1P");

var $6lkQ3 = parcelRequire("6lkQ3");
'use client';
const $d636f7beeed426bc$var$Container = (0, $767b1e199314b8b8$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $lbp1P.default)('div', {
        name: 'MuiContainer',
        slot: 'Root',
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState } = props;
            return [
                styles.root,
                styles[`maxWidth${(0, $ifmKX.default)(String(ownerState.maxWidth))}`],
                ownerState.fixed && styles.fixed,
                ownerState.disableGutters && styles.disableGutters
            ];
        }
    }),
    useThemeProps: (inProps)=>(0, $6lkQ3.useDefaultProps)({
            props: inProps,
            name: 'MuiContainer'
        })
});
var $d636f7beeed426bc$export$2e2bcd8739ae039 = $d636f7beeed426bc$var$Container;






function $74b90a6f08eb2e78$var$useQuery() {
    const { search: search } = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)();
    return $8FY87.useMemo(()=>new URLSearchParams(search), [
        search
    ]);
}


const $74b90a6f08eb2e78$export$8b251419efc915eb = ()=>{
    const [anchorElNav, setAnchorElNav] = $8FY87.useState(null);
    const navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    const { pathname: pathname, search: search } = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)();
    const pages = [
        "TEMPLATES",
        "PRICING",
        "CONTACT",
        "SIGN UP"
    ];
    const pageRoutes = {
        TEMPLATES: "/choose-template",
        PRICING: "https://rocketpages.io/pricing",
        CONTACT: "https://rocketpages.io/contact",
        "SIGN UP": `/signup${search}`
    };
    const handleOpenNavMenu = (event)=>{
        setAnchorElNav(event.currentTarget);
    };
    const handleCloseNavMenu = ()=>{
        setAnchorElNav(null);
    };
    const handlePageNavigation = (page)=>{
        const route = pageRoutes[page];
        if (route.startsWith("http")) window.open(route, "_blank"); // For external links
        else navigate(route); // For internal links
        handleCloseNavMenu();
    };
    const checkIsInFrame = ()=>{
        try {
            return window.self !== window.top; // Returns true if in an iframe
        } catch (e) {
            return true; // Fallback in case of security restrictions
        }
    };
    const isLoginPage = pathname === "/login"; // Check if on the signup page
    const isInIframe = checkIsInFrame();
    let query = $74b90a6f08eb2e78$var$useQuery();
    let l_userId = query.get("userId");
    let l_siteId = query.get("siteId");
    return /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex items-center sm:justify-between justify-center py-2 px-5 sticky top-0 z-50 bg-white/80 backdrop-blur-sm"
    }, /*#__PURE__*/ $8FY87.createElement((0, $2af46c77336007a5$export$2e2bcd8739ae039), {
        position: "sticky",
        className: `bg-transparent flex justify-between items-center shadow-none px-0`
    }, /*#__PURE__*/ $8FY87.createElement((0, $d636f7beeed426bc$export$2e2bcd8739ae039), {
        disableGutters: true,
        maxWidth: false,
        sx: {
            maxWidth: '1470px'
        }
    }, /*#__PURE__*/ $8FY87.createElement((0, $a60f3197d9f0bd53$export$2e2bcd8739ae039), {
        disableGutters: true,
        className: `flex justify-between`
    }, /*#__PURE__*/ $8FY87.createElement((0, $734169eef5d6795a$export$a6c7ac8248d6e38a), {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).logoLight} mr-2 md:mr-5 w-8 md:w-52`,
        to: "/",
        onClick: (e)=>{
            e.preventDefault();
            window.open("/", "_blank");
        }
    }, /*#__PURE__*/ $8FY87.createElement("img", {
        className: "w-full hover:cursor-pointer hidden md:block",
        src: (parcelRequire("f1BG0")),
        alt: "Log In"
    }), /*#__PURE__*/ $8FY87.createElement("img", {
        className: "w-full hover:cursor-pointer md:hidden",
        src: (parcelRequire("2ATL3")),
        alt: "Log In"
    })), !isInIframe && /*#__PURE__*/ $8FY87.createElement((0, $b19176bd78e1869f$export$2e2bcd8739ae039), {
        sx: {
            flexGrow: 1,
            justifyContent: "flex-end",
            display: {
                xs: "flex",
                lg: "none"
            }
        }
    }, /*#__PURE__*/ $8FY87.createElement((0, $8765ef9b64e3c3e6$export$2e2bcd8739ae039), {
        size: "large",
        "aria-label": "account of current user",
        "aria-controls": "menu-appbar",
        "aria-haspopup": "true",
        onClick: handleOpenNavMenu,
        sx: {
            color: "#243460"
        }
    }, /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($238cad0c90e1fe0b$exports))), null)), /*#__PURE__*/ $8FY87.createElement((0, $0b320025c1b3a544$export$2e2bcd8739ae039), {
        id: "menu-appbar",
        anchorEl: anchorElNav,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "left"
        },
        keepMounted: true,
        transformOrigin: {
            vertical: "top",
            horizontal: "left"
        },
        open: Boolean(anchorElNav),
        onClose: handleCloseNavMenu,
        sx: {
            display: {
                xs: "block",
                lg: "none"
            }
        },
        PaperProps: {
            sx: {
                backgroundColor: "#fff",
                width: "336px",
                height: "unset",
                boxShadow: "1px 1px 12.3px 0px #00000040",
                padding: "24px 8px",
                top: "85px !important",
                right: "0px !important",
                left: "unset !important"
            }
        }
    }, pages.slice(0, 3).map((page)=>/*#__PURE__*/ $8FY87.createElement((0, $ee9f19037253b32c$export$2e2bcd8739ae039), {
            key: page,
            onClick: ()=>handlePageNavigation(page),
            sx: {
                backgroundColor: "transparent",
                "&:hover": {
                    backgroundColor: "transparent"
                }
            }
        }, /*#__PURE__*/ $8FY87.createElement((0, $9e9a2c609bdcf2f0$export$2e2bcd8739ae039), {
            sx: {
                textAlign: "center",
                fontSize: "14px",
                lineHeight: "28px",
                color: "#243060",
                fontWeight: 600,
                "&:hover": {
                    color: "#FE7165",
                    backgroundColor: "transparent"
                }
            }
        }, page))), /*#__PURE__*/ $8FY87.createElement((0, $30a538faf9a95dbb$export$2e2bcd8739ae039), {
        sx: {
            margin: "30px 16px !important"
        }
    }), /*#__PURE__*/ $8FY87.createElement((0, $b19176bd78e1869f$export$2e2bcd8739ae039), {
        sx: {
            paddingX: "16px"
        }
    }, isInIframe ? /*#__PURE__*/ $8FY87.createElement((0, $734169eef5d6795a$export$a6c7ac8248d6e38a), {
        to: {
            pathname: isLoginPage ? `/signup` : "/login",
            search: `?userId=${l_userId}&siteId=${l_siteId}`
        }
    }, /*#__PURE__*/ $8FY87.createElement("button", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).signUpText}`
    }, isLoginPage ? "SIGNUP" : "LOGIN")) : /*#__PURE__*/ $8FY87.createElement((0, $734169eef5d6795a$export$a6c7ac8248d6e38a), {
        to: isLoginPage ? `/signup${search}` : "/login"
    }, /*#__PURE__*/ $8FY87.createElement("button", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).signUpText}`
    }, isLoginPage ? "SIGNUP" : "LOGIN"))))), /*#__PURE__*/ $8FY87.createElement((0, $b19176bd78e1869f$export$2e2bcd8739ae039), {
        sx: {
            alignItems: "center",
            justifyContent: "center",
            gap: "54px",
            flexGrow: 1,
            display: {
                xs: "none",
                lg: "flex"
            }
        }
    }, !isInIframe && pages.slice(0, 3).map((page)=>/*#__PURE__*/ $8FY87.createElement((0, $ee9f19037253b32c$export$2e2bcd8739ae039), {
            key: page,
            onClick: ()=>handlePageNavigation(page),
            sx: {
                backgroundColor: "transparent",
                "&:hover": {
                    backgroundColor: "transparent"
                }
            }
        }, /*#__PURE__*/ $8FY87.createElement((0, $9e9a2c609bdcf2f0$export$2e2bcd8739ae039), {
            sx: {
                textAlign: "center",
                fontSize: "14px",
                lineHeight: "28px",
                color: "#243060",
                fontWeight: 600,
                "&:hover": {
                    color: "#FE7165",
                    backgroundColor: "transparent"
                }
            }
        }, page)))), /*#__PURE__*/ $8FY87.createElement((0, $b19176bd78e1869f$export$2e2bcd8739ae039), {
        sx: {
            alignItems: "center",
            justifyContent: "center",
            gap: "16px",
            flexGrow: 0,
            marginRight: "4px",
            display: {
                xs: "none",
                lg: "flex"
            }
        }
    }, isInIframe ? /*#__PURE__*/ $8FY87.createElement((0, $734169eef5d6795a$export$a6c7ac8248d6e38a), {
        to: {
            pathname: isLoginPage ? `/signup` : "/login",
            search: `?userId=${l_userId}&siteId=${l_siteId}`
        }
    }, /*#__PURE__*/ $8FY87.createElement("button", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).signUpText}`
    }, isLoginPage ? "SIGNUP" : "LOGIN")) : /*#__PURE__*/ $8FY87.createElement((0, $734169eef5d6795a$export$a6c7ac8248d6e38a), {
        to: isLoginPage ? `/signup${search}` : "/login"
    }, /*#__PURE__*/ $8FY87.createElement("button", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).signUpText}`
    }, isLoginPage ? "SIGNUP" : "LOGIN"))), /*#__PURE__*/ $8FY87.createElement((0, $b19176bd78e1869f$export$2e2bcd8739ae039), {
        sx: {
            flexGrow: 0,
            display: "flex",
            alignItems: "center",
            gap: "25px"
        }
    }, isInIframe ? /*#__PURE__*/ $8FY87.createElement((0, $734169eef5d6795a$export$a6c7ac8248d6e38a), {
        to: isLoginPage ? `/signup${search}` : `/login${search}`
    }, /*#__PURE__*/ $8FY87.createElement("button", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).primaryBtn} ${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).signUpBtn}`
    }, isLoginPage ? "SIGNUP" : "LOGIN")) : /*#__PURE__*/ $8FY87.createElement("button", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).primaryBtn} ${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).signUpBtn}`,
        onClick: ()=>{
            navigate(`/choose-template`);
        }
    }, "GET STARTED"))))));
};






function $67648097e661867f$var$checkIsInFrame() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}


const $67648097e661867f$var$ForgotPassword = ()=>{
    const [cookies] = (0, $1f373de1ceea6eb7$export$2e2bcd8739ae039)([
        "rp_loggedin"
    ]); // Access cookies
    const { enqueueSnackbar: enqueueSnackbar } = (0, $5e19452f9528802f$export$1c97ac2c9a6e7c09)();
    const isInIframe = $67648097e661867f$var$checkIsInFrame();
    const [errorMessage, setErrorMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useState("");
    const navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    const location = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)();
    const [isLoading, setIsLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useState(false);
    const [formData, setFormData] = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useState({
        email: ""
    });
    const [formErrors, setFormErrors] = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useState({
        email: ""
    });
    const { search: search } = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)();
    const query = new URLSearchParams(location.search);
    const l_userId = query.get("userId");
    const l_siteId = query.get("siteId");
    function handleChange(event) {
        setFormErrors({
            email: ""
        });
        setFormData((old)=>{
            return {
                ...old,
                [event.target.id]: event.target.value
            };
        });
        setErrorMessage("");
    }
    function isValidEmail(email) {
        // Regular expression for basic email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }
    function validateForm(formData) {
        try {
            setFormErrors({
                email: ""
            });
            if (formData.email === "") {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        email: "Email can not be empty."
                    };
                });
                return false;
            }
            if (!isValidEmail(formData.email)) {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        email: "Invalid email address."
                    };
                });
                return false;
            }
            return true;
        } catch (err) {
            return false;
        }
    }
    async function onSubmit(event) {
        event.preventDefault();
        if (!validateForm(formData)) return;
        try {
            let data = {
                email: formData.email
            };
            await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post("api/gen-reset-password-link", data);
            localStorage.setItem("rp_reset_email", formData.email);
            setIsLoading(false);
            enqueueSnackbar("Password reset link sent to your email address!", {
                variant: "info",
                className: "bg-grey-400"
            });
            navigate("/login", {
                state: {
                    userId: l_userId,
                    siteId: l_siteId
                }
            });
        } catch (err) {
            setIsLoading(false);
            setErrorMessage(err.response.data.message);
            enqueueSnackbar(err.response.data.message, {
                variant: "error"
            });
        }
    }
    const isFormInvalid = formErrors.email !== "" || formData.email === "";
    (0, $8FY87.useEffect)(()=>{
        // Redirect if user is already logged in
        if (cookies.rp_loggedin) navigate("/choose-template"); // Redirect to the dashboard
    }, [
        cookies.rp_loggedin,
        navigate
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("main", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).forgotPassword}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $56dcde36b8493878$export$2e2bcd8739ae039), {
        sx: {
            color: "#fff",
            zIndex: (theme)=>theme.zIndex.drawer + 1
        },
        open: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $b391f94ee7b6de9b$export$2e2bcd8739ae039), {
        color: "inherit"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $74b90a6f08eb2e78$export$8b251419efc915eb), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("section", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).contentContaienr} flex justify-start`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).leftContent} hidden md:inline-block`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("img", {
        src: (parcelRequire("3DtD5")),
        className: "hidden xl:block"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("img", {
        src: (parcelRequire("3DtD5")),
        className: "small-img xl:hidden"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).content} md:flex md:flex-col ${isInIframe ? (0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).nopadding : ""}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).formContainer}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("h1", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).heading} mt-1 md:mt-8 lg:mt-16 mb-2`
    }, "Forgot password?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("h4", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).subHeading} mt-0.5`
    }, "Enter your email address and we\u2019ll send you a link to reset your password."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("form", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).loginForm}`,
        onSubmit: onSubmit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).emailRow} flex flex-col`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        htmlFor: "email"
    }, "Email"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("input", {
        type: "email",
        id: "email",
        value: formData.email,
        onChange: handleChange,
        placeholder: "Enter email address",
        className: `${formErrors.email !== "" ? "border-red-500" : ""}`
    }), formErrors.email !== "" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).errorLabels}`
    }, formErrors.email)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("button", {
        type: "submit",
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).primaryBtn} ${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).loginBtn} ${isFormInvalid ? "opacity-50 cursor-not-allowed" : ""} `,
        disabled: isFormInvalid
    }, "Send Link"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        style: {
            textAlign: "center",
            marginTop: "16px"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $734169eef5d6795a$export$a6c7ac8248d6e38a), {
        to: isInIframe ? {
            pathname: "/login",
            search: `?userId=${l_userId}&siteId=${l_siteId}`
        } : `/login${search}`,
        className: "text-sm text-[#243460] font-semibold",
        style: {
            textDecoration: "none"
        }
    }, "Try a different login method"))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $0a87a32205fa1e51$export$2e2bcd8739ae039), null)), !isInIframe && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $fdcc8de0ec44fdd8$export$2e2bcd8739ae039), null));
};
var $67648097e661867f$export$2e2bcd8739ae039 = $67648097e661867f$var$ForgotPassword;



const $d0889cc1565a9695$export$c7a55480dba6f1f1 = ()=>{
    return /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, null, /*#__PURE__*/ $8FY87.createElement((0, $274ffc8236991365$export$dcef8f9bb9a41431), null, /*#__PURE__*/ $8FY87.createElement("title", null, "RocketPages - Forgot Password"), /*#__PURE__*/ $8FY87.createElement("meta", {
        name: "description",
        content: "Build and Launch Your Free Website in Just 15 Minutes"
    }), /*#__PURE__*/ $8FY87.createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap",
        rel: "stylesheet"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "icon",
        href: "/favicon.ico"
    }), false), /*#__PURE__*/ $8FY87.createElement((0, $9ada84cce5691847$export$2e2bcd8739ae039), null), /*#__PURE__*/ $8FY87.createElement((0, $67648097e661867f$export$2e2bcd8739ae039), null));
};



var $8FY87 = parcelRequire("8FY87");



var $8FY87 = parcelRequire("8FY87");

// https://kentcdodds.com/blog/replace-axios-with-a-simple-custom-fetch-wrapper/
// https://swr.vercel.app/docs/error-handling
// import { signOut } from "next-auth/react"
function $fdc0ba63e241c9d3$export$2e2bcd8739ae039(endpoint, customConfig = {}) {
    const { body: body, form: form, ...configWithoutBody } = customConfig;
    const headers = form ? {} : {
        "content-type": "application/json"
    };
    const config = {
        ...configWithoutBody,
        method: configWithoutBody.method || (body || form ? "POST" : "GET"),
        headers: {
            ...headers,
            ...customConfig.headers
        }
    };
    if (body) config.body = JSON.stringify(body);
    else if (form) config.body = form;
    return window.fetch(endpoint, config).then(async (res)=>{
        if (res.status === 401) return;
        if (res.ok) return await res.json();
        // If the status code is not in the range 200-299,
        // we still try to parse and throw it.
        const error = new Error("An error occurred while fetching the data.");
        // Attach extra info to the error object.
        error.info = await res.json();
        error.status = res.status;
        throw error;
    });
}
const $fdc0ba63e241c9d3$export$ef8ee90e6d704faf = (endpoint, customConfig)=>$fdc0ba63e241c9d3$export$2e2bcd8739ae039(endpoint, customConfig).catch((error)=>({
            error: error
        }));


const $2e9ffb0fc2e0896d$export$adaa4cf7ef1b65be = async (key, value)=>{
    try {
        window.localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
        console.error(`error setting localstorage ${key}: ${e}`);
    }
};
const $2e9ffb0fc2e0896d$export$3988ae62b71be9a3 = async (key)=>{
    try {
        const item = window.localStorage.getItem(key);
        return item ? JSON.parse(item) : null;
    } catch (e) {
        console.error(`error getting localstorage ${key}: ${e}`);
    }
};
const $2e9ffb0fc2e0896d$export$cd7f480d6b8286c3 = async (key)=>{
    try {
        return window.localStorage.removeItem(key);
    } catch (e) {
        console.error(`error deleting localstorage ${key}: ${e}`);
    }
};


var $058aa4431a6df0b9$exports = {};
Object.defineProperty($058aa4431a6df0b9$exports, '__esModule', {
    value: true
});

var $8FY87 = parcelRequire("8FY87");
function $058aa4431a6df0b9$var$_interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) Object.keys(e).forEach(function(k) {
        if (k !== 'default') {
            var d = Object.getOwnPropertyDescriptor(e, k);
            Object.defineProperty(n, k, d.get ? d : {
                enumerable: true,
                get: function() {
                    return e[k];
                }
            });
        }
    });
    n.default = e;
    return Object.freeze(n);
}
var $058aa4431a6df0b9$var$React__namespace = /*#__PURE__*/ $058aa4431a6df0b9$var$_interopNamespaceDefault($8FY87);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $058aa4431a6df0b9$var$__assign = function() {
    $058aa4431a6df0b9$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $058aa4431a6df0b9$var$__assign.apply(this, arguments);
};
typeof SuppressedError === "function" && SuppressedError;
function $058aa4431a6df0b9$var$ProgressBar(_a) {
    var _b = _a.bgColor, bgColor = _b === void 0 ? "#6a1b9a" : _b, _c = _a.height, height = _c === void 0 ? "20px" : _c, _d = _a.width, width = _d === void 0 ? "100%" : _d, _e = _a.borderRadius, borderRadius = _e === void 0 ? "50px" : _e, _f = _a.labelAlignment, labelAlignment = _f === void 0 ? "right" : _f, _g = _a.baseBgColor, baseBgColor = _g === void 0 ? "#e0e0de" : _g, _h = _a.labelColor, labelColor = _h === void 0 ? "#fff" : _h, _j = _a.labelSize, labelSize = _j === void 0 ? "15px" : _j, _k = _a.isLabelVisible, isLabelVisible = _k === void 0 ? true : _k, _l = _a.dir, dir = _l === void 0 ? "ltr" : _l, _m = _a.ariaValuemin, ariaValuemin = _m === void 0 ? 0 : _m, _o = _a.ariaValuemax, ariaValuemax = _o === void 0 ? 100 : _o, _p = _a.ariaValuetext, ariaValuetext = _p === void 0 ? null : _p, _q = _a.maxCompleted, maxCompleted = _q === void 0 ? 100 : _q, _r = _a.animateOnRender, animateOnRender = _r === void 0 ? false : _r, _s = _a.initCompletedOnAnimation, initCompletedOnAnimation = _s === void 0 ? 0 : _s, _t = _a.isIndeterminate, isIndeterminate = _t === void 0 ? false : _t, completed = _a.completed, margin = _a.margin, padding = _a.padding, customLabelStyles = _a.customLabelStyles, transitionDuration = _a.transitionDuration, transitionTimingFunction = _a.transitionTimingFunction, className = _a.className, customLabel = _a.customLabel, barContainerClassName = _a.barContainerClassName, completedClassName = _a.completedClassName, labelClassName = _a.labelClassName;
    var getAlignment = function(alignmentOption) {
        if (alignmentOption === "left") return "flex-start";
        else if (alignmentOption === "center") return "center";
        else if (alignmentOption === "right") return "flex-end";
        else return null;
    };
    var alignment = getAlignment(labelAlignment);
    var initCompletedOnAnimationStr = typeof initCompletedOnAnimation === "number" ? "".concat(initCompletedOnAnimation, "%") : initCompletedOnAnimation;
    var getFillerWidth = function(maxCompletedValue, completedValue) {
        if (maxCompletedValue) {
            var ratio = Number(completedValue) / maxCompletedValue;
            return ratio > 1 ? "100%" : "".concat(ratio * 100, "%");
        }
        return initCompletedOnAnimationStr;
    };
    var fillerWidth = getFillerWidth(maxCompleted, completed);
    var _u = $058aa4431a6df0b9$var$React__namespace.useState(initCompletedOnAnimationStr), initWidth = _u[0], setInitWidth = _u[1];
    var containerStyles = {
        height: height,
        background: baseBgColor,
        borderRadius: borderRadius,
        padding: padding,
        width: width,
        margin: margin,
        overflow: "hidden"
    };
    var fillerStyles = {
        height: height,
        width: isIndeterminate ? "100%" : animateOnRender ? initWidth : fillerWidth,
        background: bgColor,
        transition: isIndeterminate ? "none" : "width ".concat(transitionDuration || "1s", " ").concat(transitionTimingFunction || "ease-in-out"),
        borderRadius: "inherit",
        display: "flex",
        alignItems: "center",
        justifyContent: labelAlignment !== "outside" && alignment ? alignment : "normal",
        animation: isIndeterminate ? "indeterminate 1.5s infinite linear" : "none"
    };
    var labelStyles = $058aa4431a6df0b9$var$__assign({
        padding: labelAlignment === "outside" ? "0 0 0 5px" : "5px",
        color: labelColor,
        fontWeight: "bold",
        fontSize: labelSize,
        display: !isLabelVisible ? "none" : "initial"
    }, customLabelStyles);
    var outsideStyles = {
        display: labelAlignment === "outside" ? "flex" : "initial",
        alignItems: labelAlignment === "outside" ? "center" : "initial"
    };
    var completedStr = typeof completed === "number" ? "".concat(completed, "%") : "".concat(completed);
    var labelStr = customLabel ? customLabel : completedStr;
    $058aa4431a6df0b9$var$React__namespace.useEffect(function() {
        if (animateOnRender && !isIndeterminate) requestAnimationFrame(function() {
            return setInitWidth(fillerWidth);
        });
    }, [
        fillerWidth,
        animateOnRender,
        isIndeterminate
    ]);
    return $058aa4431a6df0b9$var$React__namespace.createElement("div", {
        style: className ? undefined : outsideStyles,
        className: className,
        dir: dir,
        role: "progressbar",
        "aria-valuenow": isIndeterminate ? undefined : parseFloat(labelStr),
        "aria-valuemin": ariaValuemin,
        "aria-valuemax": ariaValuemax,
        "aria-valuetext": "".concat(ariaValuetext === null ? labelStr : ariaValuetext)
    }, $058aa4431a6df0b9$var$React__namespace.createElement("div", {
        style: barContainerClassName ? undefined : containerStyles,
        className: barContainerClassName
    }, $058aa4431a6df0b9$var$React__namespace.createElement("div", {
        style: completedClassName ? undefined : fillerStyles,
        className: completedClassName
    }, labelAlignment !== "outside" && $058aa4431a6df0b9$var$React__namespace.createElement("span", {
        style: labelClassName ? undefined : labelStyles,
        className: labelClassName
    }, labelStr))), labelAlignment === "outside" && $058aa4431a6df0b9$var$React__namespace.createElement("span", {
        style: labelClassName ? undefined : labelStyles,
        className: labelClassName
    }, labelStr), $058aa4431a6df0b9$var$React__namespace.createElement("style", null, "\n          @keyframes indeterminate {\n            0% {\n              width: 30%;\n              transform: translateX(-50%);\n            }\n            50% {\n              width: 30%;\n              transform: translateX(250%);\n            }\n            100% {\n              width: 30%;\n              transform: translateX(-50%);\n            }\n          }\n        "));
}
$058aa4431a6df0b9$exports.default = $058aa4431a6df0b9$var$ProgressBar;


const $7a4f89720d178808$var$PROGRESS_TIME = 120 //SECONDS
;
const $7a4f89720d178808$var$FORM_ID = "queryForm";
const $7a4f89720d178808$var$StepForm = ({ toggleForm: toggleForm })=>{
    // const router = useRouter()
    const [activeStep, setActiveStep] = (0, $8FY87.useState)(0);
    const [errorMessage, setErrorMessage] = (0, $8FY87.useState)("");
    const [formData, setFormData] = (0, $8FY87.useState)({
        name: "",
        business_type: "",
        customer_type: "",
        products: "",
        purpose: "",
        services: ""
    });
    const [isFormSubmitted, setIsFormSubmitted] = (0, $8FY87.useState)(false);
    const [progress, setProgress] = (0, $8FY87.useState)(0);
    const handleInputChange = (e, name)=>{
        setFormData((formData)=>{
            return {
                ...formData,
                [name]: e.target.value
            };
        });
    };
    const nextPrev = (n)=>{
        if (n === 1 && activeStep < 2) {
            const isValidated = validateFields(activeStep);
            if (!isValidated) return false;
        }
        if (activeStep + n > 2) {
            setIsFormSubmitted(true);
            startProgress();
            submitForm();
        }
        setActiveStep(activeStep + n);
    };
    const validateFields = (step)=>{
        if (step == 0) {
            if (formData.name === "" || formData.business_type === "") {
                setErrorMessage("Please answer all queries.");
                return false;
            } else {
                setErrorMessage("");
                return true;
            }
        }
        if (step == 1) {
            if (formData.purpose === "" || formData.customer_type === "") {
                setErrorMessage("Please answer all queries.");
                return false;
            } else {
                setErrorMessage("");
                return true;
            }
        }
    };
    const startProgress = ()=>{
        let intervalHandle = window.setInterval(()=>{
            setProgress((progress)=>{
                if (progress === $7a4f89720d178808$var$PROGRESS_TIME) window.clearInterval(intervalHandle);
                return Math.min(progress + 1, $7a4f89720d178808$var$PROGRESS_TIME);
            });
        }, 1000);
    };
    const submitForm = async ()=>{
        const websiteInfo = {
            name: formData.name.trim(),
            organization: formData.business_type === "organization",
            objective: formData.purpose?.trim(),
            target: formData.customer_type?.trim(),
            services: formData.services?.trim(),
            products: formData.products?.trim()
        };
        const websiteCopy = await (0, $fdc0ba63e241c9d3$export$2e2bcd8739ae039)("/api/generate-copy", {
            body: websiteInfo
        });
        (0, $2e9ffb0fc2e0896d$export$adaa4cf7ef1b65be)("websiteInfo", websiteInfo);
        (0, $2e9ffb0fc2e0896d$export$adaa4cf7ef1b65be)("websiteCopy", websiteCopy);
    // router.push("/editor")
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("form", {
        id: $7a4f89720d178808$var$FORM_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("i", {
        className: "fa-solid fa-xmark text-[24px] font-bold closeForm",
        onClick: toggleForm
    }), !isFormSubmitted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "progress"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
        className: (0, $68aee9bbbc0e9b6d$export$2e2bcd8739ae039)("step", {
            active: activeStep == 0
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
        className: (0, $68aee9bbbc0e9b6d$export$2e2bcd8739ae039)("step", {
            active: activeStep == 1
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
        className: (0, $68aee9bbbc0e9b6d$export$2e2bcd8739ae039)("step", {
            active: activeStep == 2
        })
    })), errorMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "error-message"
    }, errorMessage), activeStep === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "tab"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "question"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", null, "What is the name of your website?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "input-field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("input", {
        placeholder: "Type here...",
        name: "name",
        type: "text",
        value: formData?.name,
        onChange: (e)=>handleInputChange(e, "name")
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "question"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", null, "Are you operating as an individual or an organization?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "input-field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("input", {
        id: "individual",
        value: "individual",
        type: "radio",
        checked: formData?.business_type === "individual",
        name: "business_type",
        onChange: (e)=>handleInputChange(e, "business_type")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        htmlFor: "individual"
    }, "Individual")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "input-field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("input", {
        id: "organization",
        value: "organization",
        type: "radio",
        checked: formData?.business_type === "organization",
        name: "business_type",
        onChange: (e)=>handleInputChange(e, "business_type")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        htmlFor: "organization"
    }, "Organization")))), activeStep === 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "tab"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "question"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", null, "What is the main purpose or objective of your website?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "input-field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("textarea", {
        placeholder: "Type here...",
        name: "purpose",
        value: formData?.purpose,
        onChange: (e)=>handleInputChange(e, "purpose"),
        rows: 5
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "question"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", null, "Who is your target audience? Please describe your ideal customer or visitor?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "input-field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("textarea", {
        placeholder: "Type here...",
        name: "customer_type",
        value: formData?.customer_type,
        onChange: (e)=>handleInputChange(e, "customer_type"),
        rows: 5
    })))), activeStep === 2 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "tab"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "question"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", null, "Do you offer any services? If yes, please describe them."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "input-field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("textarea", {
        placeholder: "Type here...",
        name: "services",
        value: formData?.services,
        onChange: (e)=>handleInputChange(e, "services"),
        rows: 5
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "question"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", null, "Do you offer any products? If yes, please describe them"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "input-field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("textarea", {
        placeholder: "Type here...",
        name: "products",
        value: formData?.products,
        onChange: (e)=>handleInputChange(e, "products"),
        rows: 5
    })))), !isFormSubmitted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "actions"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        style: {
            display: "flex",
            justifyContent: "flex-end"
        }
    }, activeStep > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("button", {
        className: "btn-info",
        type: "button",
        id: "prevBtn",
        onClick: ()=>nextPrev(-1)
    }, "Previous"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("button", {
        className: "btn-info",
        type: "button",
        id: "nextBtn",
        onClick: ()=>nextPrev(1)
    }, activeStep === 2 ? "Submit" : "Next"))), isFormSubmitted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "info-message"
    }, "Generating your website..."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($058aa4431a6df0b9$exports))), {
        completed: Math.round(progress / $7a4f89720d178808$var$PROGRESS_TIME * 100)
    }))));
};
var $7a4f89720d178808$export$2e2bcd8739ae039 = $7a4f89720d178808$var$StepForm;










const $75db671276d04424$export$74ba1212fd768fa5 = ()=>{
    let [isFormVisible, setIsFormVisible] = (0, $8FY87.useState)(false);
    const navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    // Get the current year dynamically
    const currentYear = new Date().getFullYear();
    (0, $8FY87.useEffect)(()=>{
        navigate("/choose-template");
    }, []);
    return /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, null, /*#__PURE__*/ $8FY87.createElement((0, $274ffc8236991365$export$dcef8f9bb9a41431), null, /*#__PURE__*/ $8FY87.createElement("title", null, "RocketPages"), /*#__PURE__*/ $8FY87.createElement("meta", {
        name: "description",
        content: "Build and Launch Your Free Website in Just 15 Minutes"
    }), /*#__PURE__*/ $8FY87.createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap",
        rel: "stylesheet"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "icon",
        href: "/favicon.ico"
    }), false), /*#__PURE__*/ $8FY87.createElement((0, $9ada84cce5691847$export$2e2bcd8739ae039), null), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "is-boxed has-animations is-loaded",
        style: {
            height: "100%"
        }
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: `body-wrap boxed-container ${isFormVisible ? "wrapper-blur" : ""}`
    }, /*#__PURE__*/ $8FY87.createElement("header", {
        className: "site-header"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "container"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "site-header-inner"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "brand header-brand"
    }, /*#__PURE__*/ $8FY87.createElement("h1", {
        className: "m-0"
    }, /*#__PURE__*/ $8FY87.createElement("a", {
        href: "#"
    }, /*#__PURE__*/ $8FY87.createElement("img", {
        className: "header-logo-image asset-light",
        src: (parcelRequire("9IpHO")),
        width: 200,
        height: 30,
        alt: "Logo"
    }))))))), /*#__PURE__*/ $8FY87.createElement("main", null, /*#__PURE__*/ $8FY87.createElement("section", {
        className: "hero"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "container"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "hero-inner"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "hero-copy"
    }, /*#__PURE__*/ $8FY87.createElement("h1", {
        className: "hero-title mt-0"
    }, "Build and Launch Your Free Website in Just 15 Minutes"), /*#__PURE__*/ $8FY87.createElement("p", {
        className: "hero-paragraph"
    }, "With our free website building platform, you can create a stunning website Rocket fast, complete with high-quality content generated automatically by our powerful ChatGPT integration."), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "hero-cta"
    }, /*#__PURE__*/ $8FY87.createElement("a", {
        className: "button button-primary",
        onClick: ()=>setIsFormVisible(!isFormVisible)
    }, "Build My Free Website Now!"), /*#__PURE__*/ $8FY87.createElement("a", {
        className: "button button-primary",
        href: "/choose-template"
    }, "Choose Template"))), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "hero-media"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "header-illustration"
    }, /*#__PURE__*/ $8FY87.createElement("img", {
        className: "header-illustration-image asset-light",
        src: (parcelRequire("bUg1X")),
        width: 1440,
        height: 324,
        alt: "Header illustration"
    })), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "hero-media-illustration"
    }, /*#__PURE__*/ $8FY87.createElement("img", {
        className: "hero-media-illustration-image asset-light",
        src: (parcelRequire("4RZke")),
        width: 733,
        height: 749,
        alt: "Hero media illustration"
    })), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "hero-media-container"
    }, /*#__PURE__*/ $8FY87.createElement("img", {
        className: "hero-media-image asset-light",
        src: (parcelRequire("fRZd1")),
        width: 1,
        height: 1,
        alt: "Hero media"
    }), /*#__PURE__*/ $8FY87.createElement("img", {
        className: "hero-media-image asset-dark",
        src: (parcelRequire("7dcuj")),
        width: 1,
        height: 1,
        alt: "Hero media"
    })))))), /*#__PURE__*/ $8FY87.createElement("section", {
        className: "features section"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "container"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "features-inner section-inner has-bottom-divider"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "features-header text-center"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "container-sm"
    }, /*#__PURE__*/ $8FY87.createElement("h2", {
        className: "section-title mt-0"
    }, "Simple 2-Step Process"), /*#__PURE__*/ $8FY87.createElement("ul", null, /*#__PURE__*/ $8FY87.createElement("li", {
        className: "step-list"
    }, /*#__PURE__*/ $8FY87.createElement("p", null, "Fill in the 5 question Wizard and click on \u201CGenerate Website\u201D")), /*#__PURE__*/ $8FY87.createElement("li", {
        className: "step-list"
    }, /*#__PURE__*/ $8FY87.createElement("p", null, "Customize the website template to your needs"))))), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "features-header section-inner second-feature-header text-center"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "container-sm"
    }, /*#__PURE__*/ $8FY87.createElement("h2", {
        className: "section-title mt-0"
    }, "The Easiest Way to Build a Website for Free"))), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "features-wrap"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "feature is-revealing"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "feature-inner"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "feature-content"
    }, /*#__PURE__*/ $8FY87.createElement("h3", {
        className: "feature-title mt-0"
    }, "Easy to Use"), /*#__PURE__*/ $8FY87.createElement("p", {
        className: "text-sm mb-0"
    }, "It's no rocket science! Create your website quickly with our user-friendly editor & ChatGPT integration that generates content fast.", " ")))), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "feature is-revealing"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "feature-inner"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "feature-content"
    }, /*#__PURE__*/ $8FY87.createElement("h3", {
        className: "feature-title mt-0"
    }, "Rocket Fast"), /*#__PURE__*/ $8FY87.createElement("p", {
        className: "text-sm mb-0"
    }, "Create your website in no time - our platform promises fast loading speed and a hassle-free website building process.")))), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "feature is-revealing"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "feature-inner"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "feature-content"
    }, /*#__PURE__*/ $8FY87.createElement("h3", {
        className: "feature-title mt-0"
    }, "Unique Automated Content"), /*#__PURE__*/ $8FY87.createElement("p", {
        className: "text-sm mb-0"
    }, "Say goodbye to generic website content. Our platform creates unique content every time, ensuring that your site stands out!")))), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "feature is-revealing"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "feature-inner"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "feature-content"
    }, /*#__PURE__*/ $8FY87.createElement("h3", {
        className: "feature-title mt-0"
    }, "SEO Optimized"), /*#__PURE__*/ $8FY87.createElement("p", {
        className: "text-sm mb-0"
    }, "Get discovered easily on search engines! Our platform creates websites that are optimized for SEO.")))), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "feature is-revealing"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "feature-inner"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "feature-content"
    }, /*#__PURE__*/ $8FY87.createElement("h3", {
        className: "feature-title mt-0"
    }, "Customizable Templates"), /*#__PURE__*/ $8FY87.createElement("p", {
        className: "text-sm mb-0"
    }, "Choose from a wide range of customizable templates to create a website that truly reflects your brand and personality.")))), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "feature is-revealing"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "feature-inner"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "feature-content"
    }, /*#__PURE__*/ $8FY87.createElement("h3", {
        className: "feature-title mt-0"
    }, "Mobile-Optimized Design"), /*#__PURE__*/ $8FY87.createElement("p", {
        className: "text-sm mb-0"
    }, "Our templates are optimized for mobile devices, ensuring that your website looks great on any device, anywhere, anytime.")))))))), /*#__PURE__*/ $8FY87.createElement("section", {
        className: "cta section"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "container-sm"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "cta-inner section-inner"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "cta-header text-center"
    }, /*#__PURE__*/ $8FY87.createElement("h2", {
        className: "section-title mt-0"
    }, "Ready to Start?"), /*#__PURE__*/ $8FY87.createElement("p", {
        className: "section-paragraph"
    }, "Don't wait any longer to create your online presence. Start building your website for free now!"), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "cta-cta"
    }, /*#__PURE__*/ $8FY87.createElement("a", {
        className: "button button-primary",
        onClick: ()=>setIsFormVisible(!isFormVisible)
    }, "Start Building My Free Website Now!"))))))), /*#__PURE__*/ $8FY87.createElement("footer", {
        className: "site-footer has-top-divider"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "container"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "site-footer-inner"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "brand footer-brand"
    }, /*#__PURE__*/ $8FY87.createElement("a", {
        href: "#"
    }, /*#__PURE__*/ $8FY87.createElement("img", {
        className: "asset-light",
        src: (parcelRequire("cU9P7")),
        width: 200,
        height: 30,
        alt: "RocketPages"
    }))), /*#__PURE__*/ $8FY87.createElement("ul", {
        className: "footer-social-links list-reset"
    }, /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement((0, $734169eef5d6795a$export$a6c7ac8248d6e38a), {
        to: "https://www.facebook.com/RocketPagesIO",
        target: "_blank",
        className: "mx-2"
    }, /*#__PURE__*/ $8FY87.createElement("i", {
        className: "fa-brands fa-square-facebook text-[20px] text-[white]"
    }))), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement((0, $734169eef5d6795a$export$a6c7ac8248d6e38a), {
        to: "https://twitter.com/RocketPagesIO",
        target: "_blank",
        className: "mx-2"
    }, /*#__PURE__*/ $8FY87.createElement("i", {
        className: "fa-brands fa-twitter text-[20px] text-[white]"
    }))), /*#__PURE__*/ $8FY87.createElement("li", null, /*#__PURE__*/ $8FY87.createElement((0, $734169eef5d6795a$export$a6c7ac8248d6e38a), {
        to: "https://www.linkedin.com/company/rocketpages",
        target: "_blank",
        className: "mx-2"
    }, /*#__PURE__*/ $8FY87.createElement("i", {
        className: "fa-brands fa-linkedin text-[20px] text-[white]"
    })))), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "footer-copyright"
    }, "\xa9 ", currentYear, " RocketPages. All Rights Reserved.")))))), isFormVisible && /*#__PURE__*/ $8FY87.createElement("div", {
        className: "stepform-wrapper"
    }, /*#__PURE__*/ $8FY87.createElement((0, $7a4f89720d178808$export$2e2bcd8739ae039), {
        toggleForm: ()=>{
            setIsFormVisible(!isFormVisible);
        }
    })), /*#__PURE__*/ $8FY87.createElement((0, $fdcc8de0ec44fdd8$export$2e2bcd8739ae039), null));
};



var $8FY87 = parcelRequire("8FY87");


var $138013025876eded$exports = {};
"use strict";
"use client";

var $bcBLN = parcelRequire("bcBLN");
Object.defineProperty($138013025876eded$exports, "__esModule", {
    value: true
});
$138013025876eded$exports.default = void 0;

var $138013025876eded$var$_createSvgIcon = $bcBLN((parcelRequire("485sq")));

var $2PPWI = parcelRequire("2PPWI");
var $138013025876eded$var$_default = $138013025876eded$exports.default = (0, $138013025876eded$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2PPWI.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');


var $4c5cf14ed582dae7$exports = {};
"use strict";
"use client";

var $bcBLN = parcelRequire("bcBLN");
Object.defineProperty($4c5cf14ed582dae7$exports, "__esModule", {
    value: true
});
$4c5cf14ed582dae7$exports.default = void 0;

var $4c5cf14ed582dae7$var$_createSvgIcon = $bcBLN((parcelRequire("485sq")));

var $2PPWI = parcelRequire("2PPWI");
var $4c5cf14ed582dae7$var$_default = $4c5cf14ed582dae7$exports.default = (0, $4c5cf14ed582dae7$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2PPWI.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"
}), 'Delete');


var $a21539592a8d5049$exports = {};
"use strict";
"use client";

var $bcBLN = parcelRequire("bcBLN");
Object.defineProperty($a21539592a8d5049$exports, "__esModule", {
    value: true
});
$a21539592a8d5049$exports.default = void 0;

var $a21539592a8d5049$var$_createSvgIcon = $bcBLN((parcelRequire("485sq")));

var $2PPWI = parcelRequire("2PPWI");
var $a21539592a8d5049$var$_default = $a21539592a8d5049$exports.default = (0, $a21539592a8d5049$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2PPWI.jsx)("path", {
    d: "M3 10h11v2H3zm0-2h11V6H3zm0 8h7v-2H3zm15.01-3.13.71-.71c.39-.39 1.02-.39 1.41 0l.71.71c.39.39.39 1.02 0 1.41l-.71.71zm-.71.71-5.3 5.3V21h2.12l5.3-5.3z"
}), 'EditNoteOutlined');


var $cfd065ce0a260224$exports = {};
"use strict";
"use client";

var $bcBLN = parcelRequire("bcBLN");
Object.defineProperty($cfd065ce0a260224$exports, "__esModule", {
    value: true
});
$cfd065ce0a260224$exports.default = void 0;

var $cfd065ce0a260224$var$_createSvgIcon = $bcBLN((parcelRequire("485sq")));

var $2PPWI = parcelRequire("2PPWI");
var $cfd065ce0a260224$var$_default = $cfd065ce0a260224$exports.default = (0, $cfd065ce0a260224$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2PPWI.jsx)("path", {
    d: "m21.9 21.9-8.49-8.49-9.82-9.82L2.1 2.1.69 3.51 3 5.83V19c0 1.1.9 2 2 2h13.17l2.31 2.31zM5 18l3.5-4.5 2.5 3.01L12.17 15l3 3zm16 .17L5.83 3H19c1.1 0 2 .9 2 2z"
}), 'ImageNotSupported');









var $dxgjV = parcelRequire("dxgjV");

var $8FY87 = parcelRequire("8FY87");


var $8FY87 = parcelRequire("8FY87");

var $4VW2f = parcelRequire("4VW2f");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $e096d269e55ec3c9$var$extendStatics = function(d, b) {
    $e096d269e55ec3c9$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $e096d269e55ec3c9$var$extendStatics(d, b);
};
function $e096d269e55ec3c9$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $e096d269e55ec3c9$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $e096d269e55ec3c9$export$18ce0697a983be9b = function() {
    $e096d269e55ec3c9$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e096d269e55ec3c9$export$18ce0697a983be9b.apply(this, arguments);
};
function $e096d269e55ec3c9$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $e096d269e55ec3c9$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $e096d269e55ec3c9$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $e096d269e55ec3c9$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $e096d269e55ec3c9$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $e096d269e55ec3c9$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $e096d269e55ec3c9$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $e096d269e55ec3c9$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $e096d269e55ec3c9$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $e096d269e55ec3c9$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $e096d269e55ec3c9$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $e096d269e55ec3c9$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $e096d269e55ec3c9$export$45d3717a4c69092e(o, m, p);
}
function $e096d269e55ec3c9$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $e096d269e55ec3c9$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $e096d269e55ec3c9$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($e096d269e55ec3c9$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $e096d269e55ec3c9$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $e096d269e55ec3c9$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $e096d269e55ec3c9$export$10c90e4f7922046c(v) {
    return this instanceof $e096d269e55ec3c9$export$10c90e4f7922046c ? (this.v = v, this) : new $e096d269e55ec3c9$export$10c90e4f7922046c(v);
}
function $e096d269e55ec3c9$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $e096d269e55ec3c9$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $e096d269e55ec3c9$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $e096d269e55ec3c9$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $e096d269e55ec3c9$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $e096d269e55ec3c9$export$19a8beecd37a4c45 === "function" ? $e096d269e55ec3c9$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $e096d269e55ec3c9$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $e096d269e55ec3c9$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $e096d269e55ec3c9$var$ownKeys = function(o) {
    $e096d269e55ec3c9$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $e096d269e55ec3c9$var$ownKeys(o);
};
function $e096d269e55ec3c9$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $e096d269e55ec3c9$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $e096d269e55ec3c9$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $e096d269e55ec3c9$var$__setModuleDefault(result, mod);
    return result;
}
function $e096d269e55ec3c9$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $e096d269e55ec3c9$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $e096d269e55ec3c9$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $e096d269e55ec3c9$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $e096d269e55ec3c9$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $e096d269e55ec3c9$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $e096d269e55ec3c9$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $e096d269e55ec3c9$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $e096d269e55ec3c9$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $e096d269e55ec3c9$export$2e2bcd8739ae039 = {
    __extends: $e096d269e55ec3c9$export$a8ba968b8961cb8a,
    __assign: $e096d269e55ec3c9$export$18ce0697a983be9b,
    __rest: $e096d269e55ec3c9$export$3c9a16f847548506,
    __decorate: $e096d269e55ec3c9$export$29e00dfd3077644b,
    __param: $e096d269e55ec3c9$export$d5ad3fd78186038f,
    __esDecorate: $e096d269e55ec3c9$export$3a84e1ae4e97e9b0,
    __runInitializers: $e096d269e55ec3c9$export$d831c04e792af3d,
    __propKey: $e096d269e55ec3c9$export$6a2a36740a146cb8,
    __setFunctionName: $e096d269e55ec3c9$export$d1a06452d3489bc7,
    __metadata: $e096d269e55ec3c9$export$f1db080c865becb9,
    __awaiter: $e096d269e55ec3c9$export$1050f835b63b671e,
    __generator: $e096d269e55ec3c9$export$67ebef60e6f28a6,
    __createBinding: $e096d269e55ec3c9$export$45d3717a4c69092e,
    __exportStar: $e096d269e55ec3c9$export$f33643c0debef087,
    __values: $e096d269e55ec3c9$export$19a8beecd37a4c45,
    __read: $e096d269e55ec3c9$export$8d051b38c9118094,
    __spread: $e096d269e55ec3c9$export$afc72e2116322959,
    __spreadArrays: $e096d269e55ec3c9$export$6388937ca91ccae8,
    __spreadArray: $e096d269e55ec3c9$export$1216008129fb82ed,
    __await: $e096d269e55ec3c9$export$10c90e4f7922046c,
    __asyncGenerator: $e096d269e55ec3c9$export$e427f37a30a4de9b,
    __asyncDelegator: $e096d269e55ec3c9$export$bbd80228419bb833,
    __asyncValues: $e096d269e55ec3c9$export$e3b29a3d6162315f,
    __makeTemplateObject: $e096d269e55ec3c9$export$4fb47efe1390b86f,
    __importStar: $e096d269e55ec3c9$export$c21735bcef00d192,
    __importDefault: $e096d269e55ec3c9$export$da59b14a69baef04,
    __classPrivateFieldGet: $e096d269e55ec3c9$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $e096d269e55ec3c9$export$d40a35129aaff81f,
    __classPrivateFieldIn: $e096d269e55ec3c9$export$81fdc39f203e4e04,
    __addDisposableResource: $e096d269e55ec3c9$export$88ac25d8e944e405,
    __disposeResources: $e096d269e55ec3c9$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $e096d269e55ec3c9$export$889dfb5d17574b0b
};


const $042e8f065ad6cff3$export$db0345794bfc14ed = new Map([
    // https://github.com/guzzle/psr7/blob/2d9260799e713f1c475d3c5fdc3d6561ff7441b2/src/MimeType.php
    [
        '1km',
        'application/vnd.1000minds.decision-model+xml'
    ],
    [
        '3dml',
        'text/vnd.in3d.3dml'
    ],
    [
        '3ds',
        'image/x-3ds'
    ],
    [
        '3g2',
        'video/3gpp2'
    ],
    [
        '3gp',
        'video/3gp'
    ],
    [
        '3gpp',
        'video/3gpp'
    ],
    [
        '3mf',
        'model/3mf'
    ],
    [
        '7z',
        'application/x-7z-compressed'
    ],
    [
        '7zip',
        'application/x-7z-compressed'
    ],
    [
        '123',
        'application/vnd.lotus-1-2-3'
    ],
    [
        'aab',
        'application/x-authorware-bin'
    ],
    [
        'aac',
        'audio/x-acc'
    ],
    [
        'aam',
        'application/x-authorware-map'
    ],
    [
        'aas',
        'application/x-authorware-seg'
    ],
    [
        'abw',
        'application/x-abiword'
    ],
    [
        'ac',
        'application/vnd.nokia.n-gage.ac+xml'
    ],
    [
        'ac3',
        'audio/ac3'
    ],
    [
        'acc',
        'application/vnd.americandynamics.acc'
    ],
    [
        'ace',
        'application/x-ace-compressed'
    ],
    [
        'acu',
        'application/vnd.acucobol'
    ],
    [
        'acutc',
        'application/vnd.acucorp'
    ],
    [
        'adp',
        'audio/adpcm'
    ],
    [
        'aep',
        'application/vnd.audiograph'
    ],
    [
        'afm',
        'application/x-font-type1'
    ],
    [
        'afp',
        'application/vnd.ibm.modcap'
    ],
    [
        'ahead',
        'application/vnd.ahead.space'
    ],
    [
        'ai',
        'application/pdf'
    ],
    [
        'aif',
        'audio/x-aiff'
    ],
    [
        'aifc',
        'audio/x-aiff'
    ],
    [
        'aiff',
        'audio/x-aiff'
    ],
    [
        'air',
        'application/vnd.adobe.air-application-installer-package+zip'
    ],
    [
        'ait',
        'application/vnd.dvb.ait'
    ],
    [
        'ami',
        'application/vnd.amiga.ami'
    ],
    [
        'amr',
        'audio/amr'
    ],
    [
        'apk',
        'application/vnd.android.package-archive'
    ],
    [
        'apng',
        'image/apng'
    ],
    [
        'appcache',
        'text/cache-manifest'
    ],
    [
        'application',
        'application/x-ms-application'
    ],
    [
        'apr',
        'application/vnd.lotus-approach'
    ],
    [
        'arc',
        'application/x-freearc'
    ],
    [
        'arj',
        'application/x-arj'
    ],
    [
        'asc',
        'application/pgp-signature'
    ],
    [
        'asf',
        'video/x-ms-asf'
    ],
    [
        'asm',
        'text/x-asm'
    ],
    [
        'aso',
        'application/vnd.accpac.simply.aso'
    ],
    [
        'asx',
        'video/x-ms-asf'
    ],
    [
        'atc',
        'application/vnd.acucorp'
    ],
    [
        'atom',
        'application/atom+xml'
    ],
    [
        'atomcat',
        'application/atomcat+xml'
    ],
    [
        'atomdeleted',
        'application/atomdeleted+xml'
    ],
    [
        'atomsvc',
        'application/atomsvc+xml'
    ],
    [
        'atx',
        'application/vnd.antix.game-component'
    ],
    [
        'au',
        'audio/x-au'
    ],
    [
        'avi',
        'video/x-msvideo'
    ],
    [
        'avif',
        'image/avif'
    ],
    [
        'aw',
        'application/applixware'
    ],
    [
        'azf',
        'application/vnd.airzip.filesecure.azf'
    ],
    [
        'azs',
        'application/vnd.airzip.filesecure.azs'
    ],
    [
        'azv',
        'image/vnd.airzip.accelerator.azv'
    ],
    [
        'azw',
        'application/vnd.amazon.ebook'
    ],
    [
        'b16',
        'image/vnd.pco.b16'
    ],
    [
        'bat',
        'application/x-msdownload'
    ],
    [
        'bcpio',
        'application/x-bcpio'
    ],
    [
        'bdf',
        'application/x-font-bdf'
    ],
    [
        'bdm',
        'application/vnd.syncml.dm+wbxml'
    ],
    [
        'bdoc',
        'application/x-bdoc'
    ],
    [
        'bed',
        'application/vnd.realvnc.bed'
    ],
    [
        'bh2',
        'application/vnd.fujitsu.oasysprs'
    ],
    [
        'bin',
        'application/octet-stream'
    ],
    [
        'blb',
        'application/x-blorb'
    ],
    [
        'blorb',
        'application/x-blorb'
    ],
    [
        'bmi',
        'application/vnd.bmi'
    ],
    [
        'bmml',
        'application/vnd.balsamiq.bmml+xml'
    ],
    [
        'bmp',
        'image/bmp'
    ],
    [
        'book',
        'application/vnd.framemaker'
    ],
    [
        'box',
        'application/vnd.previewsystems.box'
    ],
    [
        'boz',
        'application/x-bzip2'
    ],
    [
        'bpk',
        'application/octet-stream'
    ],
    [
        'bpmn',
        'application/octet-stream'
    ],
    [
        'bsp',
        'model/vnd.valve.source.compiled-map'
    ],
    [
        'btif',
        'image/prs.btif'
    ],
    [
        'buffer',
        'application/octet-stream'
    ],
    [
        'bz',
        'application/x-bzip'
    ],
    [
        'bz2',
        'application/x-bzip2'
    ],
    [
        'c',
        'text/x-c'
    ],
    [
        'c4d',
        'application/vnd.clonk.c4group'
    ],
    [
        'c4f',
        'application/vnd.clonk.c4group'
    ],
    [
        'c4g',
        'application/vnd.clonk.c4group'
    ],
    [
        'c4p',
        'application/vnd.clonk.c4group'
    ],
    [
        'c4u',
        'application/vnd.clonk.c4group'
    ],
    [
        'c11amc',
        'application/vnd.cluetrust.cartomobile-config'
    ],
    [
        'c11amz',
        'application/vnd.cluetrust.cartomobile-config-pkg'
    ],
    [
        'cab',
        'application/vnd.ms-cab-compressed'
    ],
    [
        'caf',
        'audio/x-caf'
    ],
    [
        'cap',
        'application/vnd.tcpdump.pcap'
    ],
    [
        'car',
        'application/vnd.curl.car'
    ],
    [
        'cat',
        'application/vnd.ms-pki.seccat'
    ],
    [
        'cb7',
        'application/x-cbr'
    ],
    [
        'cba',
        'application/x-cbr'
    ],
    [
        'cbr',
        'application/x-cbr'
    ],
    [
        'cbt',
        'application/x-cbr'
    ],
    [
        'cbz',
        'application/x-cbr'
    ],
    [
        'cc',
        'text/x-c'
    ],
    [
        'cco',
        'application/x-cocoa'
    ],
    [
        'cct',
        'application/x-director'
    ],
    [
        'ccxml',
        'application/ccxml+xml'
    ],
    [
        'cdbcmsg',
        'application/vnd.contact.cmsg'
    ],
    [
        'cda',
        'application/x-cdf'
    ],
    [
        'cdf',
        'application/x-netcdf'
    ],
    [
        'cdfx',
        'application/cdfx+xml'
    ],
    [
        'cdkey',
        'application/vnd.mediastation.cdkey'
    ],
    [
        'cdmia',
        'application/cdmi-capability'
    ],
    [
        'cdmic',
        'application/cdmi-container'
    ],
    [
        'cdmid',
        'application/cdmi-domain'
    ],
    [
        'cdmio',
        'application/cdmi-object'
    ],
    [
        'cdmiq',
        'application/cdmi-queue'
    ],
    [
        'cdr',
        'application/cdr'
    ],
    [
        'cdx',
        'chemical/x-cdx'
    ],
    [
        'cdxml',
        'application/vnd.chemdraw+xml'
    ],
    [
        'cdy',
        'application/vnd.cinderella'
    ],
    [
        'cer',
        'application/pkix-cert'
    ],
    [
        'cfs',
        'application/x-cfs-compressed'
    ],
    [
        'cgm',
        'image/cgm'
    ],
    [
        'chat',
        'application/x-chat'
    ],
    [
        'chm',
        'application/vnd.ms-htmlhelp'
    ],
    [
        'chrt',
        'application/vnd.kde.kchart'
    ],
    [
        'cif',
        'chemical/x-cif'
    ],
    [
        'cii',
        'application/vnd.anser-web-certificate-issue-initiation'
    ],
    [
        'cil',
        'application/vnd.ms-artgalry'
    ],
    [
        'cjs',
        'application/node'
    ],
    [
        'cla',
        'application/vnd.claymore'
    ],
    [
        'class',
        'application/octet-stream'
    ],
    [
        'clkk',
        'application/vnd.crick.clicker.keyboard'
    ],
    [
        'clkp',
        'application/vnd.crick.clicker.palette'
    ],
    [
        'clkt',
        'application/vnd.crick.clicker.template'
    ],
    [
        'clkw',
        'application/vnd.crick.clicker.wordbank'
    ],
    [
        'clkx',
        'application/vnd.crick.clicker'
    ],
    [
        'clp',
        'application/x-msclip'
    ],
    [
        'cmc',
        'application/vnd.cosmocaller'
    ],
    [
        'cmdf',
        'chemical/x-cmdf'
    ],
    [
        'cml',
        'chemical/x-cml'
    ],
    [
        'cmp',
        'application/vnd.yellowriver-custom-menu'
    ],
    [
        'cmx',
        'image/x-cmx'
    ],
    [
        'cod',
        'application/vnd.rim.cod'
    ],
    [
        'coffee',
        'text/coffeescript'
    ],
    [
        'com',
        'application/x-msdownload'
    ],
    [
        'conf',
        'text/plain'
    ],
    [
        'cpio',
        'application/x-cpio'
    ],
    [
        'cpp',
        'text/x-c'
    ],
    [
        'cpt',
        'application/mac-compactpro'
    ],
    [
        'crd',
        'application/x-mscardfile'
    ],
    [
        'crl',
        'application/pkix-crl'
    ],
    [
        'crt',
        'application/x-x509-ca-cert'
    ],
    [
        'crx',
        'application/x-chrome-extension'
    ],
    [
        'cryptonote',
        'application/vnd.rig.cryptonote'
    ],
    [
        'csh',
        'application/x-csh'
    ],
    [
        'csl',
        'application/vnd.citationstyles.style+xml'
    ],
    [
        'csml',
        'chemical/x-csml'
    ],
    [
        'csp',
        'application/vnd.commonspace'
    ],
    [
        'csr',
        'application/octet-stream'
    ],
    [
        'css',
        'text/css'
    ],
    [
        'cst',
        'application/x-director'
    ],
    [
        'csv',
        'text/csv'
    ],
    [
        'cu',
        'application/cu-seeme'
    ],
    [
        'curl',
        'text/vnd.curl'
    ],
    [
        'cww',
        'application/prs.cww'
    ],
    [
        'cxt',
        'application/x-director'
    ],
    [
        'cxx',
        'text/x-c'
    ],
    [
        'dae',
        'model/vnd.collada+xml'
    ],
    [
        'daf',
        'application/vnd.mobius.daf'
    ],
    [
        'dart',
        'application/vnd.dart'
    ],
    [
        'dataless',
        'application/vnd.fdsn.seed'
    ],
    [
        'davmount',
        'application/davmount+xml'
    ],
    [
        'dbf',
        'application/vnd.dbf'
    ],
    [
        'dbk',
        'application/docbook+xml'
    ],
    [
        'dcr',
        'application/x-director'
    ],
    [
        'dcurl',
        'text/vnd.curl.dcurl'
    ],
    [
        'dd2',
        'application/vnd.oma.dd2+xml'
    ],
    [
        'ddd',
        'application/vnd.fujixerox.ddd'
    ],
    [
        'ddf',
        'application/vnd.syncml.dmddf+xml'
    ],
    [
        'dds',
        'image/vnd.ms-dds'
    ],
    [
        'deb',
        'application/x-debian-package'
    ],
    [
        'def',
        'text/plain'
    ],
    [
        'deploy',
        'application/octet-stream'
    ],
    [
        'der',
        'application/x-x509-ca-cert'
    ],
    [
        'dfac',
        'application/vnd.dreamfactory'
    ],
    [
        'dgc',
        'application/x-dgc-compressed'
    ],
    [
        'dic',
        'text/x-c'
    ],
    [
        'dir',
        'application/x-director'
    ],
    [
        'dis',
        'application/vnd.mobius.dis'
    ],
    [
        'disposition-notification',
        'message/disposition-notification'
    ],
    [
        'dist',
        'application/octet-stream'
    ],
    [
        'distz',
        'application/octet-stream'
    ],
    [
        'djv',
        'image/vnd.djvu'
    ],
    [
        'djvu',
        'image/vnd.djvu'
    ],
    [
        'dll',
        'application/octet-stream'
    ],
    [
        'dmg',
        'application/x-apple-diskimage'
    ],
    [
        'dmn',
        'application/octet-stream'
    ],
    [
        'dmp',
        'application/vnd.tcpdump.pcap'
    ],
    [
        'dms',
        'application/octet-stream'
    ],
    [
        'dna',
        'application/vnd.dna'
    ],
    [
        'doc',
        'application/msword'
    ],
    [
        'docm',
        'application/vnd.ms-word.template.macroEnabled.12'
    ],
    [
        'docx',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ],
    [
        'dot',
        'application/msword'
    ],
    [
        'dotm',
        'application/vnd.ms-word.template.macroEnabled.12'
    ],
    [
        'dotx',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template'
    ],
    [
        'dp',
        'application/vnd.osgi.dp'
    ],
    [
        'dpg',
        'application/vnd.dpgraph'
    ],
    [
        'dra',
        'audio/vnd.dra'
    ],
    [
        'drle',
        'image/dicom-rle'
    ],
    [
        'dsc',
        'text/prs.lines.tag'
    ],
    [
        'dssc',
        'application/dssc+der'
    ],
    [
        'dtb',
        'application/x-dtbook+xml'
    ],
    [
        'dtd',
        'application/xml-dtd'
    ],
    [
        'dts',
        'audio/vnd.dts'
    ],
    [
        'dtshd',
        'audio/vnd.dts.hd'
    ],
    [
        'dump',
        'application/octet-stream'
    ],
    [
        'dvb',
        'video/vnd.dvb.file'
    ],
    [
        'dvi',
        'application/x-dvi'
    ],
    [
        'dwd',
        'application/atsc-dwd+xml'
    ],
    [
        'dwf',
        'model/vnd.dwf'
    ],
    [
        'dwg',
        'image/vnd.dwg'
    ],
    [
        'dxf',
        'image/vnd.dxf'
    ],
    [
        'dxp',
        'application/vnd.spotfire.dxp'
    ],
    [
        'dxr',
        'application/x-director'
    ],
    [
        'ear',
        'application/java-archive'
    ],
    [
        'ecelp4800',
        'audio/vnd.nuera.ecelp4800'
    ],
    [
        'ecelp7470',
        'audio/vnd.nuera.ecelp7470'
    ],
    [
        'ecelp9600',
        'audio/vnd.nuera.ecelp9600'
    ],
    [
        'ecma',
        'application/ecmascript'
    ],
    [
        'edm',
        'application/vnd.novadigm.edm'
    ],
    [
        'edx',
        'application/vnd.novadigm.edx'
    ],
    [
        'efif',
        'application/vnd.picsel'
    ],
    [
        'ei6',
        'application/vnd.pg.osasli'
    ],
    [
        'elc',
        'application/octet-stream'
    ],
    [
        'emf',
        'image/emf'
    ],
    [
        'eml',
        'message/rfc822'
    ],
    [
        'emma',
        'application/emma+xml'
    ],
    [
        'emotionml',
        'application/emotionml+xml'
    ],
    [
        'emz',
        'application/x-msmetafile'
    ],
    [
        'eol',
        'audio/vnd.digital-winds'
    ],
    [
        'eot',
        'application/vnd.ms-fontobject'
    ],
    [
        'eps',
        'application/postscript'
    ],
    [
        'epub',
        'application/epub+zip'
    ],
    [
        'es',
        'application/ecmascript'
    ],
    [
        'es3',
        'application/vnd.eszigno3+xml'
    ],
    [
        'esa',
        'application/vnd.osgi.subsystem'
    ],
    [
        'esf',
        'application/vnd.epson.esf'
    ],
    [
        'et3',
        'application/vnd.eszigno3+xml'
    ],
    [
        'etx',
        'text/x-setext'
    ],
    [
        'eva',
        'application/x-eva'
    ],
    [
        'evy',
        'application/x-envoy'
    ],
    [
        'exe',
        'application/octet-stream'
    ],
    [
        'exi',
        'application/exi'
    ],
    [
        'exp',
        'application/express'
    ],
    [
        'exr',
        'image/aces'
    ],
    [
        'ext',
        'application/vnd.novadigm.ext'
    ],
    [
        'ez',
        'application/andrew-inset'
    ],
    [
        'ez2',
        'application/vnd.ezpix-album'
    ],
    [
        'ez3',
        'application/vnd.ezpix-package'
    ],
    [
        'f',
        'text/x-fortran'
    ],
    [
        'f4v',
        'video/mp4'
    ],
    [
        'f77',
        'text/x-fortran'
    ],
    [
        'f90',
        'text/x-fortran'
    ],
    [
        'fbs',
        'image/vnd.fastbidsheet'
    ],
    [
        'fcdt',
        'application/vnd.adobe.formscentral.fcdt'
    ],
    [
        'fcs',
        'application/vnd.isac.fcs'
    ],
    [
        'fdf',
        'application/vnd.fdf'
    ],
    [
        'fdt',
        'application/fdt+xml'
    ],
    [
        'fe_launch',
        'application/vnd.denovo.fcselayout-link'
    ],
    [
        'fg5',
        'application/vnd.fujitsu.oasysgp'
    ],
    [
        'fgd',
        'application/x-director'
    ],
    [
        'fh',
        'image/x-freehand'
    ],
    [
        'fh4',
        'image/x-freehand'
    ],
    [
        'fh5',
        'image/x-freehand'
    ],
    [
        'fh7',
        'image/x-freehand'
    ],
    [
        'fhc',
        'image/x-freehand'
    ],
    [
        'fig',
        'application/x-xfig'
    ],
    [
        'fits',
        'image/fits'
    ],
    [
        'flac',
        'audio/x-flac'
    ],
    [
        'fli',
        'video/x-fli'
    ],
    [
        'flo',
        'application/vnd.micrografx.flo'
    ],
    [
        'flv',
        'video/x-flv'
    ],
    [
        'flw',
        'application/vnd.kde.kivio'
    ],
    [
        'flx',
        'text/vnd.fmi.flexstor'
    ],
    [
        'fly',
        'text/vnd.fly'
    ],
    [
        'fm',
        'application/vnd.framemaker'
    ],
    [
        'fnc',
        'application/vnd.frogans.fnc'
    ],
    [
        'fo',
        'application/vnd.software602.filler.form+xml'
    ],
    [
        'for',
        'text/x-fortran'
    ],
    [
        'fpx',
        'image/vnd.fpx'
    ],
    [
        'frame',
        'application/vnd.framemaker'
    ],
    [
        'fsc',
        'application/vnd.fsc.weblaunch'
    ],
    [
        'fst',
        'image/vnd.fst'
    ],
    [
        'ftc',
        'application/vnd.fluxtime.clip'
    ],
    [
        'fti',
        'application/vnd.anser-web-funds-transfer-initiation'
    ],
    [
        'fvt',
        'video/vnd.fvt'
    ],
    [
        'fxp',
        'application/vnd.adobe.fxp'
    ],
    [
        'fxpl',
        'application/vnd.adobe.fxp'
    ],
    [
        'fzs',
        'application/vnd.fuzzysheet'
    ],
    [
        'g2w',
        'application/vnd.geoplan'
    ],
    [
        'g3',
        'image/g3fax'
    ],
    [
        'g3w',
        'application/vnd.geospace'
    ],
    [
        'gac',
        'application/vnd.groove-account'
    ],
    [
        'gam',
        'application/x-tads'
    ],
    [
        'gbr',
        'application/rpki-ghostbusters'
    ],
    [
        'gca',
        'application/x-gca-compressed'
    ],
    [
        'gdl',
        'model/vnd.gdl'
    ],
    [
        'gdoc',
        'application/vnd.google-apps.document'
    ],
    [
        'geo',
        'application/vnd.dynageo'
    ],
    [
        'geojson',
        'application/geo+json'
    ],
    [
        'gex',
        'application/vnd.geometry-explorer'
    ],
    [
        'ggb',
        'application/vnd.geogebra.file'
    ],
    [
        'ggt',
        'application/vnd.geogebra.tool'
    ],
    [
        'ghf',
        'application/vnd.groove-help'
    ],
    [
        'gif',
        'image/gif'
    ],
    [
        'gim',
        'application/vnd.groove-identity-message'
    ],
    [
        'glb',
        'model/gltf-binary'
    ],
    [
        'gltf',
        'model/gltf+json'
    ],
    [
        'gml',
        'application/gml+xml'
    ],
    [
        'gmx',
        'application/vnd.gmx'
    ],
    [
        'gnumeric',
        'application/x-gnumeric'
    ],
    [
        'gpg',
        'application/gpg-keys'
    ],
    [
        'gph',
        'application/vnd.flographit'
    ],
    [
        'gpx',
        'application/gpx+xml'
    ],
    [
        'gqf',
        'application/vnd.grafeq'
    ],
    [
        'gqs',
        'application/vnd.grafeq'
    ],
    [
        'gram',
        'application/srgs'
    ],
    [
        'gramps',
        'application/x-gramps-xml'
    ],
    [
        'gre',
        'application/vnd.geometry-explorer'
    ],
    [
        'grv',
        'application/vnd.groove-injector'
    ],
    [
        'grxml',
        'application/srgs+xml'
    ],
    [
        'gsf',
        'application/x-font-ghostscript'
    ],
    [
        'gsheet',
        'application/vnd.google-apps.spreadsheet'
    ],
    [
        'gslides',
        'application/vnd.google-apps.presentation'
    ],
    [
        'gtar',
        'application/x-gtar'
    ],
    [
        'gtm',
        'application/vnd.groove-tool-message'
    ],
    [
        'gtw',
        'model/vnd.gtw'
    ],
    [
        'gv',
        'text/vnd.graphviz'
    ],
    [
        'gxf',
        'application/gxf'
    ],
    [
        'gxt',
        'application/vnd.geonext'
    ],
    [
        'gz',
        'application/gzip'
    ],
    [
        'gzip',
        'application/gzip'
    ],
    [
        'h',
        'text/x-c'
    ],
    [
        'h261',
        'video/h261'
    ],
    [
        'h263',
        'video/h263'
    ],
    [
        'h264',
        'video/h264'
    ],
    [
        'hal',
        'application/vnd.hal+xml'
    ],
    [
        'hbci',
        'application/vnd.hbci'
    ],
    [
        'hbs',
        'text/x-handlebars-template'
    ],
    [
        'hdd',
        'application/x-virtualbox-hdd'
    ],
    [
        'hdf',
        'application/x-hdf'
    ],
    [
        'heic',
        'image/heic'
    ],
    [
        'heics',
        'image/heic-sequence'
    ],
    [
        'heif',
        'image/heif'
    ],
    [
        'heifs',
        'image/heif-sequence'
    ],
    [
        'hej2',
        'image/hej2k'
    ],
    [
        'held',
        'application/atsc-held+xml'
    ],
    [
        'hh',
        'text/x-c'
    ],
    [
        'hjson',
        'application/hjson'
    ],
    [
        'hlp',
        'application/winhlp'
    ],
    [
        'hpgl',
        'application/vnd.hp-hpgl'
    ],
    [
        'hpid',
        'application/vnd.hp-hpid'
    ],
    [
        'hps',
        'application/vnd.hp-hps'
    ],
    [
        'hqx',
        'application/mac-binhex40'
    ],
    [
        'hsj2',
        'image/hsj2'
    ],
    [
        'htc',
        'text/x-component'
    ],
    [
        'htke',
        'application/vnd.kenameaapp'
    ],
    [
        'htm',
        'text/html'
    ],
    [
        'html',
        'text/html'
    ],
    [
        'hvd',
        'application/vnd.yamaha.hv-dic'
    ],
    [
        'hvp',
        'application/vnd.yamaha.hv-voice'
    ],
    [
        'hvs',
        'application/vnd.yamaha.hv-script'
    ],
    [
        'i2g',
        'application/vnd.intergeo'
    ],
    [
        'icc',
        'application/vnd.iccprofile'
    ],
    [
        'ice',
        'x-conference/x-cooltalk'
    ],
    [
        'icm',
        'application/vnd.iccprofile'
    ],
    [
        'ico',
        'image/x-icon'
    ],
    [
        'ics',
        'text/calendar'
    ],
    [
        'ief',
        'image/ief'
    ],
    [
        'ifb',
        'text/calendar'
    ],
    [
        'ifm',
        'application/vnd.shana.informed.formdata'
    ],
    [
        'iges',
        'model/iges'
    ],
    [
        'igl',
        'application/vnd.igloader'
    ],
    [
        'igm',
        'application/vnd.insors.igm'
    ],
    [
        'igs',
        'model/iges'
    ],
    [
        'igx',
        'application/vnd.micrografx.igx'
    ],
    [
        'iif',
        'application/vnd.shana.informed.interchange'
    ],
    [
        'img',
        'application/octet-stream'
    ],
    [
        'imp',
        'application/vnd.accpac.simply.imp'
    ],
    [
        'ims',
        'application/vnd.ms-ims'
    ],
    [
        'in',
        'text/plain'
    ],
    [
        'ini',
        'text/plain'
    ],
    [
        'ink',
        'application/inkml+xml'
    ],
    [
        'inkml',
        'application/inkml+xml'
    ],
    [
        'install',
        'application/x-install-instructions'
    ],
    [
        'iota',
        'application/vnd.astraea-software.iota'
    ],
    [
        'ipfix',
        'application/ipfix'
    ],
    [
        'ipk',
        'application/vnd.shana.informed.package'
    ],
    [
        'irm',
        'application/vnd.ibm.rights-management'
    ],
    [
        'irp',
        'application/vnd.irepository.package+xml'
    ],
    [
        'iso',
        'application/x-iso9660-image'
    ],
    [
        'itp',
        'application/vnd.shana.informed.formtemplate'
    ],
    [
        'its',
        'application/its+xml'
    ],
    [
        'ivp',
        'application/vnd.immervision-ivp'
    ],
    [
        'ivu',
        'application/vnd.immervision-ivu'
    ],
    [
        'jad',
        'text/vnd.sun.j2me.app-descriptor'
    ],
    [
        'jade',
        'text/jade'
    ],
    [
        'jam',
        'application/vnd.jam'
    ],
    [
        'jar',
        'application/java-archive'
    ],
    [
        'jardiff',
        'application/x-java-archive-diff'
    ],
    [
        'java',
        'text/x-java-source'
    ],
    [
        'jhc',
        'image/jphc'
    ],
    [
        'jisp',
        'application/vnd.jisp'
    ],
    [
        'jls',
        'image/jls'
    ],
    [
        'jlt',
        'application/vnd.hp-jlyt'
    ],
    [
        'jng',
        'image/x-jng'
    ],
    [
        'jnlp',
        'application/x-java-jnlp-file'
    ],
    [
        'joda',
        'application/vnd.joost.joda-archive'
    ],
    [
        'jp2',
        'image/jp2'
    ],
    [
        'jpe',
        'image/jpeg'
    ],
    [
        'jpeg',
        'image/jpeg'
    ],
    [
        'jpf',
        'image/jpx'
    ],
    [
        'jpg',
        'image/jpeg'
    ],
    [
        'jpg2',
        'image/jp2'
    ],
    [
        'jpgm',
        'video/jpm'
    ],
    [
        'jpgv',
        'video/jpeg'
    ],
    [
        'jph',
        'image/jph'
    ],
    [
        'jpm',
        'video/jpm'
    ],
    [
        'jpx',
        'image/jpx'
    ],
    [
        'js',
        'application/javascript'
    ],
    [
        'json',
        'application/json'
    ],
    [
        'json5',
        'application/json5'
    ],
    [
        'jsonld',
        'application/ld+json'
    ],
    // https://jsonlines.org/
    [
        'jsonl',
        'application/jsonl'
    ],
    [
        'jsonml',
        'application/jsonml+json'
    ],
    [
        'jsx',
        'text/jsx'
    ],
    [
        'jxr',
        'image/jxr'
    ],
    [
        'jxra',
        'image/jxra'
    ],
    [
        'jxrs',
        'image/jxrs'
    ],
    [
        'jxs',
        'image/jxs'
    ],
    [
        'jxsc',
        'image/jxsc'
    ],
    [
        'jxsi',
        'image/jxsi'
    ],
    [
        'jxss',
        'image/jxss'
    ],
    [
        'kar',
        'audio/midi'
    ],
    [
        'karbon',
        'application/vnd.kde.karbon'
    ],
    [
        'kdb',
        'application/octet-stream'
    ],
    [
        'kdbx',
        'application/x-keepass2'
    ],
    [
        'key',
        'application/x-iwork-keynote-sffkey'
    ],
    [
        'kfo',
        'application/vnd.kde.kformula'
    ],
    [
        'kia',
        'application/vnd.kidspiration'
    ],
    [
        'kml',
        'application/vnd.google-earth.kml+xml'
    ],
    [
        'kmz',
        'application/vnd.google-earth.kmz'
    ],
    [
        'kne',
        'application/vnd.kinar'
    ],
    [
        'knp',
        'application/vnd.kinar'
    ],
    [
        'kon',
        'application/vnd.kde.kontour'
    ],
    [
        'kpr',
        'application/vnd.kde.kpresenter'
    ],
    [
        'kpt',
        'application/vnd.kde.kpresenter'
    ],
    [
        'kpxx',
        'application/vnd.ds-keypoint'
    ],
    [
        'ksp',
        'application/vnd.kde.kspread'
    ],
    [
        'ktr',
        'application/vnd.kahootz'
    ],
    [
        'ktx',
        'image/ktx'
    ],
    [
        'ktx2',
        'image/ktx2'
    ],
    [
        'ktz',
        'application/vnd.kahootz'
    ],
    [
        'kwd',
        'application/vnd.kde.kword'
    ],
    [
        'kwt',
        'application/vnd.kde.kword'
    ],
    [
        'lasxml',
        'application/vnd.las.las+xml'
    ],
    [
        'latex',
        'application/x-latex'
    ],
    [
        'lbd',
        'application/vnd.llamagraphics.life-balance.desktop'
    ],
    [
        'lbe',
        'application/vnd.llamagraphics.life-balance.exchange+xml'
    ],
    [
        'les',
        'application/vnd.hhe.lesson-player'
    ],
    [
        'less',
        'text/less'
    ],
    [
        'lgr',
        'application/lgr+xml'
    ],
    [
        'lha',
        'application/octet-stream'
    ],
    [
        'link66',
        'application/vnd.route66.link66+xml'
    ],
    [
        'list',
        'text/plain'
    ],
    [
        'list3820',
        'application/vnd.ibm.modcap'
    ],
    [
        'listafp',
        'application/vnd.ibm.modcap'
    ],
    [
        'litcoffee',
        'text/coffeescript'
    ],
    [
        'lnk',
        'application/x-ms-shortcut'
    ],
    [
        'log',
        'text/plain'
    ],
    [
        'lostxml',
        'application/lost+xml'
    ],
    [
        'lrf',
        'application/octet-stream'
    ],
    [
        'lrm',
        'application/vnd.ms-lrm'
    ],
    [
        'ltf',
        'application/vnd.frogans.ltf'
    ],
    [
        'lua',
        'text/x-lua'
    ],
    [
        'luac',
        'application/x-lua-bytecode'
    ],
    [
        'lvp',
        'audio/vnd.lucent.voice'
    ],
    [
        'lwp',
        'application/vnd.lotus-wordpro'
    ],
    [
        'lzh',
        'application/octet-stream'
    ],
    [
        'm1v',
        'video/mpeg'
    ],
    [
        'm2a',
        'audio/mpeg'
    ],
    [
        'm2v',
        'video/mpeg'
    ],
    [
        'm3a',
        'audio/mpeg'
    ],
    [
        'm3u',
        'text/plain'
    ],
    [
        'm3u8',
        'application/vnd.apple.mpegurl'
    ],
    [
        'm4a',
        'audio/x-m4a'
    ],
    [
        'm4p',
        'application/mp4'
    ],
    [
        'm4s',
        'video/iso.segment'
    ],
    [
        'm4u',
        'application/vnd.mpegurl'
    ],
    [
        'm4v',
        'video/x-m4v'
    ],
    [
        'm13',
        'application/x-msmediaview'
    ],
    [
        'm14',
        'application/x-msmediaview'
    ],
    [
        'm21',
        'application/mp21'
    ],
    [
        'ma',
        'application/mathematica'
    ],
    [
        'mads',
        'application/mads+xml'
    ],
    [
        'maei',
        'application/mmt-aei+xml'
    ],
    [
        'mag',
        'application/vnd.ecowin.chart'
    ],
    [
        'maker',
        'application/vnd.framemaker'
    ],
    [
        'man',
        'text/troff'
    ],
    [
        'manifest',
        'text/cache-manifest'
    ],
    [
        'map',
        'application/json'
    ],
    [
        'mar',
        'application/octet-stream'
    ],
    [
        'markdown',
        'text/markdown'
    ],
    [
        'mathml',
        'application/mathml+xml'
    ],
    [
        'mb',
        'application/mathematica'
    ],
    [
        'mbk',
        'application/vnd.mobius.mbk'
    ],
    [
        'mbox',
        'application/mbox'
    ],
    [
        'mc1',
        'application/vnd.medcalcdata'
    ],
    [
        'mcd',
        'application/vnd.mcd'
    ],
    [
        'mcurl',
        'text/vnd.curl.mcurl'
    ],
    [
        'md',
        'text/markdown'
    ],
    [
        'mdb',
        'application/x-msaccess'
    ],
    [
        'mdi',
        'image/vnd.ms-modi'
    ],
    [
        'mdx',
        'text/mdx'
    ],
    [
        'me',
        'text/troff'
    ],
    [
        'mesh',
        'model/mesh'
    ],
    [
        'meta4',
        'application/metalink4+xml'
    ],
    [
        'metalink',
        'application/metalink+xml'
    ],
    [
        'mets',
        'application/mets+xml'
    ],
    [
        'mfm',
        'application/vnd.mfmp'
    ],
    [
        'mft',
        'application/rpki-manifest'
    ],
    [
        'mgp',
        'application/vnd.osgeo.mapguide.package'
    ],
    [
        'mgz',
        'application/vnd.proteus.magazine'
    ],
    [
        'mid',
        'audio/midi'
    ],
    [
        'midi',
        'audio/midi'
    ],
    [
        'mie',
        'application/x-mie'
    ],
    [
        'mif',
        'application/vnd.mif'
    ],
    [
        'mime',
        'message/rfc822'
    ],
    [
        'mj2',
        'video/mj2'
    ],
    [
        'mjp2',
        'video/mj2'
    ],
    [
        'mjs',
        'application/javascript'
    ],
    [
        'mk3d',
        'video/x-matroska'
    ],
    [
        'mka',
        'audio/x-matroska'
    ],
    [
        'mkd',
        'text/x-markdown'
    ],
    [
        'mks',
        'video/x-matroska'
    ],
    [
        'mkv',
        'video/x-matroska'
    ],
    [
        'mlp',
        'application/vnd.dolby.mlp'
    ],
    [
        'mmd',
        'application/vnd.chipnuts.karaoke-mmd'
    ],
    [
        'mmf',
        'application/vnd.smaf'
    ],
    [
        'mml',
        'text/mathml'
    ],
    [
        'mmr',
        'image/vnd.fujixerox.edmics-mmr'
    ],
    [
        'mng',
        'video/x-mng'
    ],
    [
        'mny',
        'application/x-msmoney'
    ],
    [
        'mobi',
        'application/x-mobipocket-ebook'
    ],
    [
        'mods',
        'application/mods+xml'
    ],
    [
        'mov',
        'video/quicktime'
    ],
    [
        'movie',
        'video/x-sgi-movie'
    ],
    [
        'mp2',
        'audio/mpeg'
    ],
    [
        'mp2a',
        'audio/mpeg'
    ],
    [
        'mp3',
        'audio/mpeg'
    ],
    [
        'mp4',
        'video/mp4'
    ],
    [
        'mp4a',
        'audio/mp4'
    ],
    [
        'mp4s',
        'application/mp4'
    ],
    [
        'mp4v',
        'video/mp4'
    ],
    [
        'mp21',
        'application/mp21'
    ],
    [
        'mpc',
        'application/vnd.mophun.certificate'
    ],
    [
        'mpd',
        'application/dash+xml'
    ],
    [
        'mpe',
        'video/mpeg'
    ],
    [
        'mpeg',
        'video/mpeg'
    ],
    [
        'mpg',
        'video/mpeg'
    ],
    [
        'mpg4',
        'video/mp4'
    ],
    [
        'mpga',
        'audio/mpeg'
    ],
    [
        'mpkg',
        'application/vnd.apple.installer+xml'
    ],
    [
        'mpm',
        'application/vnd.blueice.multipass'
    ],
    [
        'mpn',
        'application/vnd.mophun.application'
    ],
    [
        'mpp',
        'application/vnd.ms-project'
    ],
    [
        'mpt',
        'application/vnd.ms-project'
    ],
    [
        'mpy',
        'application/vnd.ibm.minipay'
    ],
    [
        'mqy',
        'application/vnd.mobius.mqy'
    ],
    [
        'mrc',
        'application/marc'
    ],
    [
        'mrcx',
        'application/marcxml+xml'
    ],
    [
        'ms',
        'text/troff'
    ],
    [
        'mscml',
        'application/mediaservercontrol+xml'
    ],
    [
        'mseed',
        'application/vnd.fdsn.mseed'
    ],
    [
        'mseq',
        'application/vnd.mseq'
    ],
    [
        'msf',
        'application/vnd.epson.msf'
    ],
    [
        'msg',
        'application/vnd.ms-outlook'
    ],
    [
        'msh',
        'model/mesh'
    ],
    [
        'msi',
        'application/x-msdownload'
    ],
    [
        'msl',
        'application/vnd.mobius.msl'
    ],
    [
        'msm',
        'application/octet-stream'
    ],
    [
        'msp',
        'application/octet-stream'
    ],
    [
        'msty',
        'application/vnd.muvee.style'
    ],
    [
        'mtl',
        'model/mtl'
    ],
    [
        'mts',
        'model/vnd.mts'
    ],
    [
        'mus',
        'application/vnd.musician'
    ],
    [
        'musd',
        'application/mmt-usd+xml'
    ],
    [
        'musicxml',
        'application/vnd.recordare.musicxml+xml'
    ],
    [
        'mvb',
        'application/x-msmediaview'
    ],
    [
        'mvt',
        'application/vnd.mapbox-vector-tile'
    ],
    [
        'mwf',
        'application/vnd.mfer'
    ],
    [
        'mxf',
        'application/mxf'
    ],
    [
        'mxl',
        'application/vnd.recordare.musicxml'
    ],
    [
        'mxmf',
        'audio/mobile-xmf'
    ],
    [
        'mxml',
        'application/xv+xml'
    ],
    [
        'mxs',
        'application/vnd.triscape.mxs'
    ],
    [
        'mxu',
        'video/vnd.mpegurl'
    ],
    [
        'n-gage',
        'application/vnd.nokia.n-gage.symbian.install'
    ],
    [
        'n3',
        'text/n3'
    ],
    [
        'nb',
        'application/mathematica'
    ],
    [
        'nbp',
        'application/vnd.wolfram.player'
    ],
    [
        'nc',
        'application/x-netcdf'
    ],
    [
        'ncx',
        'application/x-dtbncx+xml'
    ],
    [
        'nfo',
        'text/x-nfo'
    ],
    [
        'ngdat',
        'application/vnd.nokia.n-gage.data'
    ],
    [
        'nitf',
        'application/vnd.nitf'
    ],
    [
        'nlu',
        'application/vnd.neurolanguage.nlu'
    ],
    [
        'nml',
        'application/vnd.enliven'
    ],
    [
        'nnd',
        'application/vnd.noblenet-directory'
    ],
    [
        'nns',
        'application/vnd.noblenet-sealer'
    ],
    [
        'nnw',
        'application/vnd.noblenet-web'
    ],
    [
        'npx',
        'image/vnd.net-fpx'
    ],
    [
        'nq',
        'application/n-quads'
    ],
    [
        'nsc',
        'application/x-conference'
    ],
    [
        'nsf',
        'application/vnd.lotus-notes'
    ],
    [
        'nt',
        'application/n-triples'
    ],
    [
        'ntf',
        'application/vnd.nitf'
    ],
    [
        'numbers',
        'application/x-iwork-numbers-sffnumbers'
    ],
    [
        'nzb',
        'application/x-nzb'
    ],
    [
        'oa2',
        'application/vnd.fujitsu.oasys2'
    ],
    [
        'oa3',
        'application/vnd.fujitsu.oasys3'
    ],
    [
        'oas',
        'application/vnd.fujitsu.oasys'
    ],
    [
        'obd',
        'application/x-msbinder'
    ],
    [
        'obgx',
        'application/vnd.openblox.game+xml'
    ],
    [
        'obj',
        'model/obj'
    ],
    [
        'oda',
        'application/oda'
    ],
    [
        'odb',
        'application/vnd.oasis.opendocument.database'
    ],
    [
        'odc',
        'application/vnd.oasis.opendocument.chart'
    ],
    [
        'odf',
        'application/vnd.oasis.opendocument.formula'
    ],
    [
        'odft',
        'application/vnd.oasis.opendocument.formula-template'
    ],
    [
        'odg',
        'application/vnd.oasis.opendocument.graphics'
    ],
    [
        'odi',
        'application/vnd.oasis.opendocument.image'
    ],
    [
        'odm',
        'application/vnd.oasis.opendocument.text-master'
    ],
    [
        'odp',
        'application/vnd.oasis.opendocument.presentation'
    ],
    [
        'ods',
        'application/vnd.oasis.opendocument.spreadsheet'
    ],
    [
        'odt',
        'application/vnd.oasis.opendocument.text'
    ],
    [
        'oga',
        'audio/ogg'
    ],
    [
        'ogex',
        'model/vnd.opengex'
    ],
    [
        'ogg',
        'audio/ogg'
    ],
    [
        'ogv',
        'video/ogg'
    ],
    [
        'ogx',
        'application/ogg'
    ],
    [
        'omdoc',
        'application/omdoc+xml'
    ],
    [
        'onepkg',
        'application/onenote'
    ],
    [
        'onetmp',
        'application/onenote'
    ],
    [
        'onetoc',
        'application/onenote'
    ],
    [
        'onetoc2',
        'application/onenote'
    ],
    [
        'opf',
        'application/oebps-package+xml'
    ],
    [
        'opml',
        'text/x-opml'
    ],
    [
        'oprc',
        'application/vnd.palm'
    ],
    [
        'opus',
        'audio/ogg'
    ],
    [
        'org',
        'text/x-org'
    ],
    [
        'osf',
        'application/vnd.yamaha.openscoreformat'
    ],
    [
        'osfpvg',
        'application/vnd.yamaha.openscoreformat.osfpvg+xml'
    ],
    [
        'osm',
        'application/vnd.openstreetmap.data+xml'
    ],
    [
        'otc',
        'application/vnd.oasis.opendocument.chart-template'
    ],
    [
        'otf',
        'font/otf'
    ],
    [
        'otg',
        'application/vnd.oasis.opendocument.graphics-template'
    ],
    [
        'oth',
        'application/vnd.oasis.opendocument.text-web'
    ],
    [
        'oti',
        'application/vnd.oasis.opendocument.image-template'
    ],
    [
        'otp',
        'application/vnd.oasis.opendocument.presentation-template'
    ],
    [
        'ots',
        'application/vnd.oasis.opendocument.spreadsheet-template'
    ],
    [
        'ott',
        'application/vnd.oasis.opendocument.text-template'
    ],
    [
        'ova',
        'application/x-virtualbox-ova'
    ],
    [
        'ovf',
        'application/x-virtualbox-ovf'
    ],
    [
        'owl',
        'application/rdf+xml'
    ],
    [
        'oxps',
        'application/oxps'
    ],
    [
        'oxt',
        'application/vnd.openofficeorg.extension'
    ],
    [
        'p',
        'text/x-pascal'
    ],
    [
        'p7a',
        'application/x-pkcs7-signature'
    ],
    [
        'p7b',
        'application/x-pkcs7-certificates'
    ],
    [
        'p7c',
        'application/pkcs7-mime'
    ],
    [
        'p7m',
        'application/pkcs7-mime'
    ],
    [
        'p7r',
        'application/x-pkcs7-certreqresp'
    ],
    [
        'p7s',
        'application/pkcs7-signature'
    ],
    [
        'p8',
        'application/pkcs8'
    ],
    [
        'p10',
        'application/x-pkcs10'
    ],
    [
        'p12',
        'application/x-pkcs12'
    ],
    [
        'pac',
        'application/x-ns-proxy-autoconfig'
    ],
    [
        'pages',
        'application/x-iwork-pages-sffpages'
    ],
    [
        'pas',
        'text/x-pascal'
    ],
    [
        'paw',
        'application/vnd.pawaafile'
    ],
    [
        'pbd',
        'application/vnd.powerbuilder6'
    ],
    [
        'pbm',
        'image/x-portable-bitmap'
    ],
    [
        'pcap',
        'application/vnd.tcpdump.pcap'
    ],
    [
        'pcf',
        'application/x-font-pcf'
    ],
    [
        'pcl',
        'application/vnd.hp-pcl'
    ],
    [
        'pclxl',
        'application/vnd.hp-pclxl'
    ],
    [
        'pct',
        'image/x-pict'
    ],
    [
        'pcurl',
        'application/vnd.curl.pcurl'
    ],
    [
        'pcx',
        'image/x-pcx'
    ],
    [
        'pdb',
        'application/x-pilot'
    ],
    [
        'pde',
        'text/x-processing'
    ],
    [
        'pdf',
        'application/pdf'
    ],
    [
        'pem',
        'application/x-x509-user-cert'
    ],
    [
        'pfa',
        'application/x-font-type1'
    ],
    [
        'pfb',
        'application/x-font-type1'
    ],
    [
        'pfm',
        'application/x-font-type1'
    ],
    [
        'pfr',
        'application/font-tdpfr'
    ],
    [
        'pfx',
        'application/x-pkcs12'
    ],
    [
        'pgm',
        'image/x-portable-graymap'
    ],
    [
        'pgn',
        'application/x-chess-pgn'
    ],
    [
        'pgp',
        'application/pgp'
    ],
    [
        'php',
        'application/x-httpd-php'
    ],
    [
        'php3',
        'application/x-httpd-php'
    ],
    [
        'php4',
        'application/x-httpd-php'
    ],
    [
        'phps',
        'application/x-httpd-php-source'
    ],
    [
        'phtml',
        'application/x-httpd-php'
    ],
    [
        'pic',
        'image/x-pict'
    ],
    [
        'pkg',
        'application/octet-stream'
    ],
    [
        'pki',
        'application/pkixcmp'
    ],
    [
        'pkipath',
        'application/pkix-pkipath'
    ],
    [
        'pkpass',
        'application/vnd.apple.pkpass'
    ],
    [
        'pl',
        'application/x-perl'
    ],
    [
        'plb',
        'application/vnd.3gpp.pic-bw-large'
    ],
    [
        'plc',
        'application/vnd.mobius.plc'
    ],
    [
        'plf',
        'application/vnd.pocketlearn'
    ],
    [
        'pls',
        'application/pls+xml'
    ],
    [
        'pm',
        'application/x-perl'
    ],
    [
        'pml',
        'application/vnd.ctc-posml'
    ],
    [
        'png',
        'image/png'
    ],
    [
        'pnm',
        'image/x-portable-anymap'
    ],
    [
        'portpkg',
        'application/vnd.macports.portpkg'
    ],
    [
        'pot',
        'application/vnd.ms-powerpoint'
    ],
    [
        'potm',
        'application/vnd.ms-powerpoint.presentation.macroEnabled.12'
    ],
    [
        'potx',
        'application/vnd.openxmlformats-officedocument.presentationml.template'
    ],
    [
        'ppa',
        'application/vnd.ms-powerpoint'
    ],
    [
        'ppam',
        'application/vnd.ms-powerpoint.addin.macroEnabled.12'
    ],
    [
        'ppd',
        'application/vnd.cups-ppd'
    ],
    [
        'ppm',
        'image/x-portable-pixmap'
    ],
    [
        'pps',
        'application/vnd.ms-powerpoint'
    ],
    [
        'ppsm',
        'application/vnd.ms-powerpoint.slideshow.macroEnabled.12'
    ],
    [
        'ppsx',
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow'
    ],
    [
        'ppt',
        'application/powerpoint'
    ],
    [
        'pptm',
        'application/vnd.ms-powerpoint.presentation.macroEnabled.12'
    ],
    [
        'pptx',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation'
    ],
    [
        'pqa',
        'application/vnd.palm'
    ],
    [
        'prc',
        'application/x-pilot'
    ],
    [
        'pre',
        'application/vnd.lotus-freelance'
    ],
    [
        'prf',
        'application/pics-rules'
    ],
    [
        'provx',
        'application/provenance+xml'
    ],
    [
        'ps',
        'application/postscript'
    ],
    [
        'psb',
        'application/vnd.3gpp.pic-bw-small'
    ],
    [
        'psd',
        'application/x-photoshop'
    ],
    [
        'psf',
        'application/x-font-linux-psf'
    ],
    [
        'pskcxml',
        'application/pskc+xml'
    ],
    [
        'pti',
        'image/prs.pti'
    ],
    [
        'ptid',
        'application/vnd.pvi.ptid1'
    ],
    [
        'pub',
        'application/x-mspublisher'
    ],
    [
        'pvb',
        'application/vnd.3gpp.pic-bw-var'
    ],
    [
        'pwn',
        'application/vnd.3m.post-it-notes'
    ],
    [
        'pya',
        'audio/vnd.ms-playready.media.pya'
    ],
    [
        'pyv',
        'video/vnd.ms-playready.media.pyv'
    ],
    [
        'qam',
        'application/vnd.epson.quickanime'
    ],
    [
        'qbo',
        'application/vnd.intu.qbo'
    ],
    [
        'qfx',
        'application/vnd.intu.qfx'
    ],
    [
        'qps',
        'application/vnd.publishare-delta-tree'
    ],
    [
        'qt',
        'video/quicktime'
    ],
    [
        'qwd',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qwt',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qxb',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qxd',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qxl',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qxt',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'ra',
        'audio/x-realaudio'
    ],
    [
        'ram',
        'audio/x-pn-realaudio'
    ],
    [
        'raml',
        'application/raml+yaml'
    ],
    [
        'rapd',
        'application/route-apd+xml'
    ],
    [
        'rar',
        'application/x-rar'
    ],
    [
        'ras',
        'image/x-cmu-raster'
    ],
    [
        'rcprofile',
        'application/vnd.ipunplugged.rcprofile'
    ],
    [
        'rdf',
        'application/rdf+xml'
    ],
    [
        'rdz',
        'application/vnd.data-vision.rdz'
    ],
    [
        'relo',
        'application/p2p-overlay+xml'
    ],
    [
        'rep',
        'application/vnd.businessobjects'
    ],
    [
        'res',
        'application/x-dtbresource+xml'
    ],
    [
        'rgb',
        'image/x-rgb'
    ],
    [
        'rif',
        'application/reginfo+xml'
    ],
    [
        'rip',
        'audio/vnd.rip'
    ],
    [
        'ris',
        'application/x-research-info-systems'
    ],
    [
        'rl',
        'application/resource-lists+xml'
    ],
    [
        'rlc',
        'image/vnd.fujixerox.edmics-rlc'
    ],
    [
        'rld',
        'application/resource-lists-diff+xml'
    ],
    [
        'rm',
        'audio/x-pn-realaudio'
    ],
    [
        'rmi',
        'audio/midi'
    ],
    [
        'rmp',
        'audio/x-pn-realaudio-plugin'
    ],
    [
        'rms',
        'application/vnd.jcp.javame.midlet-rms'
    ],
    [
        'rmvb',
        'application/vnd.rn-realmedia-vbr'
    ],
    [
        'rnc',
        'application/relax-ng-compact-syntax'
    ],
    [
        'rng',
        'application/xml'
    ],
    [
        'roa',
        'application/rpki-roa'
    ],
    [
        'roff',
        'text/troff'
    ],
    [
        'rp9',
        'application/vnd.cloanto.rp9'
    ],
    [
        'rpm',
        'audio/x-pn-realaudio-plugin'
    ],
    [
        'rpss',
        'application/vnd.nokia.radio-presets'
    ],
    [
        'rpst',
        'application/vnd.nokia.radio-preset'
    ],
    [
        'rq',
        'application/sparql-query'
    ],
    [
        'rs',
        'application/rls-services+xml'
    ],
    [
        'rsa',
        'application/x-pkcs7'
    ],
    [
        'rsat',
        'application/atsc-rsat+xml'
    ],
    [
        'rsd',
        'application/rsd+xml'
    ],
    [
        'rsheet',
        'application/urc-ressheet+xml'
    ],
    [
        'rss',
        'application/rss+xml'
    ],
    [
        'rtf',
        'text/rtf'
    ],
    [
        'rtx',
        'text/richtext'
    ],
    [
        'run',
        'application/x-makeself'
    ],
    [
        'rusd',
        'application/route-usd+xml'
    ],
    [
        'rv',
        'video/vnd.rn-realvideo'
    ],
    [
        's',
        'text/x-asm'
    ],
    [
        's3m',
        'audio/s3m'
    ],
    [
        'saf',
        'application/vnd.yamaha.smaf-audio'
    ],
    [
        'sass',
        'text/x-sass'
    ],
    [
        'sbml',
        'application/sbml+xml'
    ],
    [
        'sc',
        'application/vnd.ibm.secure-container'
    ],
    [
        'scd',
        'application/x-msschedule'
    ],
    [
        'scm',
        'application/vnd.lotus-screencam'
    ],
    [
        'scq',
        'application/scvp-cv-request'
    ],
    [
        'scs',
        'application/scvp-cv-response'
    ],
    [
        'scss',
        'text/x-scss'
    ],
    [
        'scurl',
        'text/vnd.curl.scurl'
    ],
    [
        'sda',
        'application/vnd.stardivision.draw'
    ],
    [
        'sdc',
        'application/vnd.stardivision.calc'
    ],
    [
        'sdd',
        'application/vnd.stardivision.impress'
    ],
    [
        'sdkd',
        'application/vnd.solent.sdkm+xml'
    ],
    [
        'sdkm',
        'application/vnd.solent.sdkm+xml'
    ],
    [
        'sdp',
        'application/sdp'
    ],
    [
        'sdw',
        'application/vnd.stardivision.writer'
    ],
    [
        'sea',
        'application/octet-stream'
    ],
    [
        'see',
        'application/vnd.seemail'
    ],
    [
        'seed',
        'application/vnd.fdsn.seed'
    ],
    [
        'sema',
        'application/vnd.sema'
    ],
    [
        'semd',
        'application/vnd.semd'
    ],
    [
        'semf',
        'application/vnd.semf'
    ],
    [
        'senmlx',
        'application/senml+xml'
    ],
    [
        'sensmlx',
        'application/sensml+xml'
    ],
    [
        'ser',
        'application/java-serialized-object'
    ],
    [
        'setpay',
        'application/set-payment-initiation'
    ],
    [
        'setreg',
        'application/set-registration-initiation'
    ],
    [
        'sfd-hdstx',
        'application/vnd.hydrostatix.sof-data'
    ],
    [
        'sfs',
        'application/vnd.spotfire.sfs'
    ],
    [
        'sfv',
        'text/x-sfv'
    ],
    [
        'sgi',
        'image/sgi'
    ],
    [
        'sgl',
        'application/vnd.stardivision.writer-global'
    ],
    [
        'sgm',
        'text/sgml'
    ],
    [
        'sgml',
        'text/sgml'
    ],
    [
        'sh',
        'application/x-sh'
    ],
    [
        'shar',
        'application/x-shar'
    ],
    [
        'shex',
        'text/shex'
    ],
    [
        'shf',
        'application/shf+xml'
    ],
    [
        'shtml',
        'text/html'
    ],
    [
        'sid',
        'image/x-mrsid-image'
    ],
    [
        'sieve',
        'application/sieve'
    ],
    [
        'sig',
        'application/pgp-signature'
    ],
    [
        'sil',
        'audio/silk'
    ],
    [
        'silo',
        'model/mesh'
    ],
    [
        'sis',
        'application/vnd.symbian.install'
    ],
    [
        'sisx',
        'application/vnd.symbian.install'
    ],
    [
        'sit',
        'application/x-stuffit'
    ],
    [
        'sitx',
        'application/x-stuffitx'
    ],
    [
        'siv',
        'application/sieve'
    ],
    [
        'skd',
        'application/vnd.koan'
    ],
    [
        'skm',
        'application/vnd.koan'
    ],
    [
        'skp',
        'application/vnd.koan'
    ],
    [
        'skt',
        'application/vnd.koan'
    ],
    [
        'sldm',
        'application/vnd.ms-powerpoint.slide.macroenabled.12'
    ],
    [
        'sldx',
        'application/vnd.openxmlformats-officedocument.presentationml.slide'
    ],
    [
        'slim',
        'text/slim'
    ],
    [
        'slm',
        'text/slim'
    ],
    [
        'sls',
        'application/route-s-tsid+xml'
    ],
    [
        'slt',
        'application/vnd.epson.salt'
    ],
    [
        'sm',
        'application/vnd.stepmania.stepchart'
    ],
    [
        'smf',
        'application/vnd.stardivision.math'
    ],
    [
        'smi',
        'application/smil'
    ],
    [
        'smil',
        'application/smil'
    ],
    [
        'smv',
        'video/x-smv'
    ],
    [
        'smzip',
        'application/vnd.stepmania.package'
    ],
    [
        'snd',
        'audio/basic'
    ],
    [
        'snf',
        'application/x-font-snf'
    ],
    [
        'so',
        'application/octet-stream'
    ],
    [
        'spc',
        'application/x-pkcs7-certificates'
    ],
    [
        'spdx',
        'text/spdx'
    ],
    [
        'spf',
        'application/vnd.yamaha.smaf-phrase'
    ],
    [
        'spl',
        'application/x-futuresplash'
    ],
    [
        'spot',
        'text/vnd.in3d.spot'
    ],
    [
        'spp',
        'application/scvp-vp-response'
    ],
    [
        'spq',
        'application/scvp-vp-request'
    ],
    [
        'spx',
        'audio/ogg'
    ],
    [
        'sql',
        'application/x-sql'
    ],
    [
        'src',
        'application/x-wais-source'
    ],
    [
        'srt',
        'application/x-subrip'
    ],
    [
        'sru',
        'application/sru+xml'
    ],
    [
        'srx',
        'application/sparql-results+xml'
    ],
    [
        'ssdl',
        'application/ssdl+xml'
    ],
    [
        'sse',
        'application/vnd.kodak-descriptor'
    ],
    [
        'ssf',
        'application/vnd.epson.ssf'
    ],
    [
        'ssml',
        'application/ssml+xml'
    ],
    [
        'sst',
        'application/octet-stream'
    ],
    [
        'st',
        'application/vnd.sailingtracker.track'
    ],
    [
        'stc',
        'application/vnd.sun.xml.calc.template'
    ],
    [
        'std',
        'application/vnd.sun.xml.draw.template'
    ],
    [
        'stf',
        'application/vnd.wt.stf'
    ],
    [
        'sti',
        'application/vnd.sun.xml.impress.template'
    ],
    [
        'stk',
        'application/hyperstudio'
    ],
    [
        'stl',
        'model/stl'
    ],
    [
        'stpx',
        'model/step+xml'
    ],
    [
        'stpxz',
        'model/step-xml+zip'
    ],
    [
        'stpz',
        'model/step+zip'
    ],
    [
        'str',
        'application/vnd.pg.format'
    ],
    [
        'stw',
        'application/vnd.sun.xml.writer.template'
    ],
    [
        'styl',
        'text/stylus'
    ],
    [
        'stylus',
        'text/stylus'
    ],
    [
        'sub',
        'text/vnd.dvb.subtitle'
    ],
    [
        'sus',
        'application/vnd.sus-calendar'
    ],
    [
        'susp',
        'application/vnd.sus-calendar'
    ],
    [
        'sv4cpio',
        'application/x-sv4cpio'
    ],
    [
        'sv4crc',
        'application/x-sv4crc'
    ],
    [
        'svc',
        'application/vnd.dvb.service'
    ],
    [
        'svd',
        'application/vnd.svd'
    ],
    [
        'svg',
        'image/svg+xml'
    ],
    [
        'svgz',
        'image/svg+xml'
    ],
    [
        'swa',
        'application/x-director'
    ],
    [
        'swf',
        'application/x-shockwave-flash'
    ],
    [
        'swi',
        'application/vnd.aristanetworks.swi'
    ],
    [
        'swidtag',
        'application/swid+xml'
    ],
    [
        'sxc',
        'application/vnd.sun.xml.calc'
    ],
    [
        'sxd',
        'application/vnd.sun.xml.draw'
    ],
    [
        'sxg',
        'application/vnd.sun.xml.writer.global'
    ],
    [
        'sxi',
        'application/vnd.sun.xml.impress'
    ],
    [
        'sxm',
        'application/vnd.sun.xml.math'
    ],
    [
        'sxw',
        'application/vnd.sun.xml.writer'
    ],
    [
        't',
        'text/troff'
    ],
    [
        't3',
        'application/x-t3vm-image'
    ],
    [
        't38',
        'image/t38'
    ],
    [
        'taglet',
        'application/vnd.mynfc'
    ],
    [
        'tao',
        'application/vnd.tao.intent-module-archive'
    ],
    [
        'tap',
        'image/vnd.tencent.tap'
    ],
    [
        'tar',
        'application/x-tar'
    ],
    [
        'tcap',
        'application/vnd.3gpp2.tcap'
    ],
    [
        'tcl',
        'application/x-tcl'
    ],
    [
        'td',
        'application/urc-targetdesc+xml'
    ],
    [
        'teacher',
        'application/vnd.smart.teacher'
    ],
    [
        'tei',
        'application/tei+xml'
    ],
    [
        'teicorpus',
        'application/tei+xml'
    ],
    [
        'tex',
        'application/x-tex'
    ],
    [
        'texi',
        'application/x-texinfo'
    ],
    [
        'texinfo',
        'application/x-texinfo'
    ],
    [
        'text',
        'text/plain'
    ],
    [
        'tfi',
        'application/thraud+xml'
    ],
    [
        'tfm',
        'application/x-tex-tfm'
    ],
    [
        'tfx',
        'image/tiff-fx'
    ],
    [
        'tga',
        'image/x-tga'
    ],
    [
        'tgz',
        'application/x-tar'
    ],
    [
        'thmx',
        'application/vnd.ms-officetheme'
    ],
    [
        'tif',
        'image/tiff'
    ],
    [
        'tiff',
        'image/tiff'
    ],
    [
        'tk',
        'application/x-tcl'
    ],
    [
        'tmo',
        'application/vnd.tmobile-livetv'
    ],
    [
        'toml',
        'application/toml'
    ],
    [
        'torrent',
        'application/x-bittorrent'
    ],
    [
        'tpl',
        'application/vnd.groove-tool-template'
    ],
    [
        'tpt',
        'application/vnd.trid.tpt'
    ],
    [
        'tr',
        'text/troff'
    ],
    [
        'tra',
        'application/vnd.trueapp'
    ],
    [
        'trig',
        'application/trig'
    ],
    [
        'trm',
        'application/x-msterminal'
    ],
    [
        'ts',
        'video/mp2t'
    ],
    [
        'tsd',
        'application/timestamped-data'
    ],
    [
        'tsv',
        'text/tab-separated-values'
    ],
    [
        'ttc',
        'font/collection'
    ],
    [
        'ttf',
        'font/ttf'
    ],
    [
        'ttl',
        'text/turtle'
    ],
    [
        'ttml',
        'application/ttml+xml'
    ],
    [
        'twd',
        'application/vnd.simtech-mindmapper'
    ],
    [
        'twds',
        'application/vnd.simtech-mindmapper'
    ],
    [
        'txd',
        'application/vnd.genomatix.tuxedo'
    ],
    [
        'txf',
        'application/vnd.mobius.txf'
    ],
    [
        'txt',
        'text/plain'
    ],
    [
        'u8dsn',
        'message/global-delivery-status'
    ],
    [
        'u8hdr',
        'message/global-headers'
    ],
    [
        'u8mdn',
        'message/global-disposition-notification'
    ],
    [
        'u8msg',
        'message/global'
    ],
    [
        'u32',
        'application/x-authorware-bin'
    ],
    [
        'ubj',
        'application/ubjson'
    ],
    [
        'udeb',
        'application/x-debian-package'
    ],
    [
        'ufd',
        'application/vnd.ufdl'
    ],
    [
        'ufdl',
        'application/vnd.ufdl'
    ],
    [
        'ulx',
        'application/x-glulx'
    ],
    [
        'umj',
        'application/vnd.umajin'
    ],
    [
        'unityweb',
        'application/vnd.unity'
    ],
    [
        'uoml',
        'application/vnd.uoml+xml'
    ],
    [
        'uri',
        'text/uri-list'
    ],
    [
        'uris',
        'text/uri-list'
    ],
    [
        'urls',
        'text/uri-list'
    ],
    [
        'usdz',
        'model/vnd.usdz+zip'
    ],
    [
        'ustar',
        'application/x-ustar'
    ],
    [
        'utz',
        'application/vnd.uiq.theme'
    ],
    [
        'uu',
        'text/x-uuencode'
    ],
    [
        'uva',
        'audio/vnd.dece.audio'
    ],
    [
        'uvd',
        'application/vnd.dece.data'
    ],
    [
        'uvf',
        'application/vnd.dece.data'
    ],
    [
        'uvg',
        'image/vnd.dece.graphic'
    ],
    [
        'uvh',
        'video/vnd.dece.hd'
    ],
    [
        'uvi',
        'image/vnd.dece.graphic'
    ],
    [
        'uvm',
        'video/vnd.dece.mobile'
    ],
    [
        'uvp',
        'video/vnd.dece.pd'
    ],
    [
        'uvs',
        'video/vnd.dece.sd'
    ],
    [
        'uvt',
        'application/vnd.dece.ttml+xml'
    ],
    [
        'uvu',
        'video/vnd.uvvu.mp4'
    ],
    [
        'uvv',
        'video/vnd.dece.video'
    ],
    [
        'uvva',
        'audio/vnd.dece.audio'
    ],
    [
        'uvvd',
        'application/vnd.dece.data'
    ],
    [
        'uvvf',
        'application/vnd.dece.data'
    ],
    [
        'uvvg',
        'image/vnd.dece.graphic'
    ],
    [
        'uvvh',
        'video/vnd.dece.hd'
    ],
    [
        'uvvi',
        'image/vnd.dece.graphic'
    ],
    [
        'uvvm',
        'video/vnd.dece.mobile'
    ],
    [
        'uvvp',
        'video/vnd.dece.pd'
    ],
    [
        'uvvs',
        'video/vnd.dece.sd'
    ],
    [
        'uvvt',
        'application/vnd.dece.ttml+xml'
    ],
    [
        'uvvu',
        'video/vnd.uvvu.mp4'
    ],
    [
        'uvvv',
        'video/vnd.dece.video'
    ],
    [
        'uvvx',
        'application/vnd.dece.unspecified'
    ],
    [
        'uvvz',
        'application/vnd.dece.zip'
    ],
    [
        'uvx',
        'application/vnd.dece.unspecified'
    ],
    [
        'uvz',
        'application/vnd.dece.zip'
    ],
    [
        'vbox',
        'application/x-virtualbox-vbox'
    ],
    [
        'vbox-extpack',
        'application/x-virtualbox-vbox-extpack'
    ],
    [
        'vcard',
        'text/vcard'
    ],
    [
        'vcd',
        'application/x-cdlink'
    ],
    [
        'vcf',
        'text/x-vcard'
    ],
    [
        'vcg',
        'application/vnd.groove-vcard'
    ],
    [
        'vcs',
        'text/x-vcalendar'
    ],
    [
        'vcx',
        'application/vnd.vcx'
    ],
    [
        'vdi',
        'application/x-virtualbox-vdi'
    ],
    [
        'vds',
        'model/vnd.sap.vds'
    ],
    [
        'vhd',
        'application/x-virtualbox-vhd'
    ],
    [
        'vis',
        'application/vnd.visionary'
    ],
    [
        'viv',
        'video/vnd.vivo'
    ],
    [
        'vlc',
        'application/videolan'
    ],
    [
        'vmdk',
        'application/x-virtualbox-vmdk'
    ],
    [
        'vob',
        'video/x-ms-vob'
    ],
    [
        'vor',
        'application/vnd.stardivision.writer'
    ],
    [
        'vox',
        'application/x-authorware-bin'
    ],
    [
        'vrml',
        'model/vrml'
    ],
    [
        'vsd',
        'application/vnd.visio'
    ],
    [
        'vsf',
        'application/vnd.vsf'
    ],
    [
        'vss',
        'application/vnd.visio'
    ],
    [
        'vst',
        'application/vnd.visio'
    ],
    [
        'vsw',
        'application/vnd.visio'
    ],
    [
        'vtf',
        'image/vnd.valve.source.texture'
    ],
    [
        'vtt',
        'text/vtt'
    ],
    [
        'vtu',
        'model/vnd.vtu'
    ],
    [
        'vxml',
        'application/voicexml+xml'
    ],
    [
        'w3d',
        'application/x-director'
    ],
    [
        'wad',
        'application/x-doom'
    ],
    [
        'wadl',
        'application/vnd.sun.wadl+xml'
    ],
    [
        'war',
        'application/java-archive'
    ],
    [
        'wasm',
        'application/wasm'
    ],
    [
        'wav',
        'audio/x-wav'
    ],
    [
        'wax',
        'audio/x-ms-wax'
    ],
    [
        'wbmp',
        'image/vnd.wap.wbmp'
    ],
    [
        'wbs',
        'application/vnd.criticaltools.wbs+xml'
    ],
    [
        'wbxml',
        'application/wbxml'
    ],
    [
        'wcm',
        'application/vnd.ms-works'
    ],
    [
        'wdb',
        'application/vnd.ms-works'
    ],
    [
        'wdp',
        'image/vnd.ms-photo'
    ],
    [
        'weba',
        'audio/webm'
    ],
    [
        'webapp',
        'application/x-web-app-manifest+json'
    ],
    [
        'webm',
        'video/webm'
    ],
    [
        'webmanifest',
        'application/manifest+json'
    ],
    [
        'webp',
        'image/webp'
    ],
    [
        'wg',
        'application/vnd.pmi.widget'
    ],
    [
        'wgt',
        'application/widget'
    ],
    [
        'wks',
        'application/vnd.ms-works'
    ],
    [
        'wm',
        'video/x-ms-wm'
    ],
    [
        'wma',
        'audio/x-ms-wma'
    ],
    [
        'wmd',
        'application/x-ms-wmd'
    ],
    [
        'wmf',
        'image/wmf'
    ],
    [
        'wml',
        'text/vnd.wap.wml'
    ],
    [
        'wmlc',
        'application/wmlc'
    ],
    [
        'wmls',
        'text/vnd.wap.wmlscript'
    ],
    [
        'wmlsc',
        'application/vnd.wap.wmlscriptc'
    ],
    [
        'wmv',
        'video/x-ms-wmv'
    ],
    [
        'wmx',
        'video/x-ms-wmx'
    ],
    [
        'wmz',
        'application/x-msmetafile'
    ],
    [
        'woff',
        'font/woff'
    ],
    [
        'woff2',
        'font/woff2'
    ],
    [
        'word',
        'application/msword'
    ],
    [
        'wpd',
        'application/vnd.wordperfect'
    ],
    [
        'wpl',
        'application/vnd.ms-wpl'
    ],
    [
        'wps',
        'application/vnd.ms-works'
    ],
    [
        'wqd',
        'application/vnd.wqd'
    ],
    [
        'wri',
        'application/x-mswrite'
    ],
    [
        'wrl',
        'model/vrml'
    ],
    [
        'wsc',
        'message/vnd.wfa.wsc'
    ],
    [
        'wsdl',
        'application/wsdl+xml'
    ],
    [
        'wspolicy',
        'application/wspolicy+xml'
    ],
    [
        'wtb',
        'application/vnd.webturbo'
    ],
    [
        'wvx',
        'video/x-ms-wvx'
    ],
    [
        'x3d',
        'model/x3d+xml'
    ],
    [
        'x3db',
        'model/x3d+fastinfoset'
    ],
    [
        'x3dbz',
        'model/x3d+binary'
    ],
    [
        'x3dv',
        'model/x3d-vrml'
    ],
    [
        'x3dvz',
        'model/x3d+vrml'
    ],
    [
        'x3dz',
        'model/x3d+xml'
    ],
    [
        'x32',
        'application/x-authorware-bin'
    ],
    [
        'x_b',
        'model/vnd.parasolid.transmit.binary'
    ],
    [
        'x_t',
        'model/vnd.parasolid.transmit.text'
    ],
    [
        'xaml',
        'application/xaml+xml'
    ],
    [
        'xap',
        'application/x-silverlight-app'
    ],
    [
        'xar',
        'application/vnd.xara'
    ],
    [
        'xav',
        'application/xcap-att+xml'
    ],
    [
        'xbap',
        'application/x-ms-xbap'
    ],
    [
        'xbd',
        'application/vnd.fujixerox.docuworks.binder'
    ],
    [
        'xbm',
        'image/x-xbitmap'
    ],
    [
        'xca',
        'application/xcap-caps+xml'
    ],
    [
        'xcs',
        'application/calendar+xml'
    ],
    [
        'xdf',
        'application/xcap-diff+xml'
    ],
    [
        'xdm',
        'application/vnd.syncml.dm+xml'
    ],
    [
        'xdp',
        'application/vnd.adobe.xdp+xml'
    ],
    [
        'xdssc',
        'application/dssc+xml'
    ],
    [
        'xdw',
        'application/vnd.fujixerox.docuworks'
    ],
    [
        'xel',
        'application/xcap-el+xml'
    ],
    [
        'xenc',
        'application/xenc+xml'
    ],
    [
        'xer',
        'application/patch-ops-error+xml'
    ],
    [
        'xfdf',
        'application/vnd.adobe.xfdf'
    ],
    [
        'xfdl',
        'application/vnd.xfdl'
    ],
    [
        'xht',
        'application/xhtml+xml'
    ],
    [
        'xhtml',
        'application/xhtml+xml'
    ],
    [
        'xhvml',
        'application/xv+xml'
    ],
    [
        'xif',
        'image/vnd.xiff'
    ],
    [
        'xl',
        'application/excel'
    ],
    [
        'xla',
        'application/vnd.ms-excel'
    ],
    [
        'xlam',
        'application/vnd.ms-excel.addin.macroEnabled.12'
    ],
    [
        'xlc',
        'application/vnd.ms-excel'
    ],
    [
        'xlf',
        'application/xliff+xml'
    ],
    [
        'xlm',
        'application/vnd.ms-excel'
    ],
    [
        'xls',
        'application/vnd.ms-excel'
    ],
    [
        'xlsb',
        'application/vnd.ms-excel.sheet.binary.macroEnabled.12'
    ],
    [
        'xlsm',
        'application/vnd.ms-excel.sheet.macroEnabled.12'
    ],
    [
        'xlsx',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ],
    [
        'xlt',
        'application/vnd.ms-excel'
    ],
    [
        'xltm',
        'application/vnd.ms-excel.template.macroEnabled.12'
    ],
    [
        'xltx',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.template'
    ],
    [
        'xlw',
        'application/vnd.ms-excel'
    ],
    [
        'xm',
        'audio/xm'
    ],
    [
        'xml',
        'application/xml'
    ],
    [
        'xns',
        'application/xcap-ns+xml'
    ],
    [
        'xo',
        'application/vnd.olpc-sugar'
    ],
    [
        'xop',
        'application/xop+xml'
    ],
    [
        'xpi',
        'application/x-xpinstall'
    ],
    [
        'xpl',
        'application/xproc+xml'
    ],
    [
        'xpm',
        'image/x-xpixmap'
    ],
    [
        'xpr',
        'application/vnd.is-xpr'
    ],
    [
        'xps',
        'application/vnd.ms-xpsdocument'
    ],
    [
        'xpw',
        'application/vnd.intercon.formnet'
    ],
    [
        'xpx',
        'application/vnd.intercon.formnet'
    ],
    [
        'xsd',
        'application/xml'
    ],
    [
        'xsl',
        'application/xml'
    ],
    [
        'xslt',
        'application/xslt+xml'
    ],
    [
        'xsm',
        'application/vnd.syncml+xml'
    ],
    [
        'xspf',
        'application/xspf+xml'
    ],
    [
        'xul',
        'application/vnd.mozilla.xul+xml'
    ],
    [
        'xvm',
        'application/xv+xml'
    ],
    [
        'xvml',
        'application/xv+xml'
    ],
    [
        'xwd',
        'image/x-xwindowdump'
    ],
    [
        'xyz',
        'chemical/x-xyz'
    ],
    [
        'xz',
        'application/x-xz'
    ],
    [
        'yaml',
        'text/yaml'
    ],
    [
        'yang',
        'application/yang'
    ],
    [
        'yin',
        'application/yin+xml'
    ],
    [
        'yml',
        'text/yaml'
    ],
    [
        'ymp',
        'text/x-suse-ymp'
    ],
    [
        'z',
        'application/x-compress'
    ],
    [
        'z1',
        'application/x-zmachine'
    ],
    [
        'z2',
        'application/x-zmachine'
    ],
    [
        'z3',
        'application/x-zmachine'
    ],
    [
        'z4',
        'application/x-zmachine'
    ],
    [
        'z5',
        'application/x-zmachine'
    ],
    [
        'z6',
        'application/x-zmachine'
    ],
    [
        'z7',
        'application/x-zmachine'
    ],
    [
        'z8',
        'application/x-zmachine'
    ],
    [
        'zaz',
        'application/vnd.zzazz.deck+xml'
    ],
    [
        'zip',
        'application/zip'
    ],
    [
        'zir',
        'application/vnd.zul'
    ],
    [
        'zirz',
        'application/vnd.zul'
    ],
    [
        'zmm',
        'application/vnd.handheld-entertainment+xml'
    ],
    [
        'zsh',
        'text/x-scriptzsh'
    ]
]);
function $042e8f065ad6cff3$export$8cc09085015f0dc7(file, path, h) {
    const f = $042e8f065ad6cff3$var$withMimeType(file);
    const { webkitRelativePath: webkitRelativePath } = file;
    const p = typeof path === 'string' ? path : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0 ? webkitRelativePath : `./${file.name}`;
    if (typeof f.path !== 'string') $042e8f065ad6cff3$var$setObjProp(f, 'path', p);
    if (h !== undefined) Object.defineProperty(f, 'handle', {
        value: h,
        writable: false,
        configurable: false,
        enumerable: true
    });
    // Always populate a relative path so that even electron apps have access to a relativePath value
    $042e8f065ad6cff3$var$setObjProp(f, 'relativePath', p);
    return f;
}
function $042e8f065ad6cff3$var$withMimeType(file) {
    const { name: name } = file;
    const hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        const ext = name.split('.').pop().toLowerCase();
        const type = $042e8f065ad6cff3$export$db0345794bfc14ed.get(ext);
        if (type) Object.defineProperty(file, 'type', {
            value: type,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return file;
}
function $042e8f065ad6cff3$var$setObjProp(f, key, value) {
    Object.defineProperty(f, key, {
        value: value,
        writable: false,
        configurable: false,
        enumerable: true
    });
}


const $c1faf66c1e858631$var$FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
function $c1faf66c1e858631$export$a36e16046ae8f1bb(evt) {
    return (0, $e096d269e55ec3c9$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        if ($c1faf66c1e858631$var$isObject(evt) && $c1faf66c1e858631$var$isDataTransfer(evt.dataTransfer)) return $c1faf66c1e858631$var$getDataTransferFiles(evt.dataTransfer, evt.type);
        else if ($c1faf66c1e858631$var$isChangeEvt(evt)) return $c1faf66c1e858631$var$getInputFiles(evt);
        else if (Array.isArray(evt) && evt.every((item)=>'getFile' in item && typeof item.getFile === 'function')) return $c1faf66c1e858631$var$getFsHandleFiles(evt);
        return [];
    });
}
function $c1faf66c1e858631$var$isDataTransfer(value) {
    return $c1faf66c1e858631$var$isObject(value);
}
function $c1faf66c1e858631$var$isChangeEvt(value) {
    return $c1faf66c1e858631$var$isObject(value) && $c1faf66c1e858631$var$isObject(value.target);
}
function $c1faf66c1e858631$var$isObject(v) {
    return typeof v === 'object' && v !== null;
}
function $c1faf66c1e858631$var$getInputFiles(evt) {
    return $c1faf66c1e858631$var$fromList(evt.target.files).map((file)=>(0, $042e8f065ad6cff3$export$8cc09085015f0dc7)(file));
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function $c1faf66c1e858631$var$getFsHandleFiles(handles) {
    return (0, $e096d269e55ec3c9$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        const files = yield Promise.all(handles.map((h)=>h.getFile()));
        return files.map((file)=>(0, $042e8f065ad6cff3$export$8cc09085015f0dc7)(file));
    });
}
function $c1faf66c1e858631$var$getDataTransferFiles(dt, type) {
    return (0, $e096d269e55ec3c9$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        // IE11 does not support dataTransfer.items
        // See https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/items#Browser_compatibility
        if (dt.items) {
            const items = $c1faf66c1e858631$var$fromList(dt.items).filter((item)=>item.kind === 'file');
            // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
            // only 'dragstart' and 'drop' has access to the data (source node)
            if (type !== 'drop') return items;
            const files = yield Promise.all(items.map($c1faf66c1e858631$var$toFilePromises));
            return $c1faf66c1e858631$var$noIgnoredFiles($c1faf66c1e858631$var$flatten(files));
        }
        return $c1faf66c1e858631$var$noIgnoredFiles($c1faf66c1e858631$var$fromList(dt.files).map((file)=>(0, $042e8f065ad6cff3$export$8cc09085015f0dc7)(file)));
    });
}
function $c1faf66c1e858631$var$noIgnoredFiles(files) {
    return files.filter((file)=>$c1faf66c1e858631$var$FILES_TO_IGNORE.indexOf(file.name) === -1);
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function $c1faf66c1e858631$var$fromList(items) {
    if (items === null) return [];
    const files = [];
    // tslint:disable: prefer-for-of
    for(let i = 0; i < items.length; i++){
        const file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function $c1faf66c1e858631$var$toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') return $c1faf66c1e858631$var$fromDataTransferItem(item);
    const entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) return $c1faf66c1e858631$var$fromDirEntry(entry);
    return $c1faf66c1e858631$var$fromDataTransferItem(item, entry);
}
function $c1faf66c1e858631$var$flatten(items) {
    return items.reduce((acc, files)=>[
            ...acc,
            ...Array.isArray(files) ? $c1faf66c1e858631$var$flatten(files) : [
                files
            ]
        ], []);
}
function $c1faf66c1e858631$var$fromDataTransferItem(item, entry) {
    return (0, $e096d269e55ec3c9$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        var _a;
        // Check if we're in a secure context; due to a bug in Chrome (as far as we know)
        // the browser crashes when calling this API (yet to be confirmed as a consistent behaviour).
        //
        // See:
        // - https://issues.chromium.org/issues/40186242
        // - https://github.com/react-dropzone/react-dropzone/issues/1397
        if (globalThis.isSecureContext && typeof item.getAsFileSystemHandle === 'function') {
            const h = yield item.getAsFileSystemHandle();
            if (h === null) throw new Error(`${item} is not a File`);
            // It seems that the handle can be `undefined` (see https://github.com/react-dropzone/file-selector/issues/120),
            // so we check if it isn't; if it is, the code path continues to the next API (`getAsFile`).
            if (h !== undefined) {
                const file = yield h.getFile();
                file.handle = h;
                return (0, $042e8f065ad6cff3$export$8cc09085015f0dc7)(file);
            }
        }
        const file = item.getAsFile();
        if (!file) throw new Error(`${item} is not a File`);
        const fwp = (0, $042e8f065ad6cff3$export$8cc09085015f0dc7)(file, (_a = entry === null || entry === void 0 ? void 0 : entry.fullPath) !== null && _a !== void 0 ? _a : undefined);
        return fwp;
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function $c1faf66c1e858631$var$fromEntry(entry) {
    return (0, $e096d269e55ec3c9$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        return entry.isDirectory ? $c1faf66c1e858631$var$fromDirEntry(entry) : $c1faf66c1e858631$var$fromFileEntry(entry);
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function $c1faf66c1e858631$var$fromDirEntry(entry) {
    const reader = entry.createReader();
    return new Promise((resolve, reject)=>{
        const entries = [];
        function readEntries() {
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries((batch)=>(0, $e096d269e55ec3c9$export$1050f835b63b671e)(this, void 0, void 0, function*() {
                    if (!batch.length) // Done reading directory
                    try {
                        const files = yield Promise.all(entries);
                        resolve(files);
                    } catch (err) {
                        reject(err);
                    }
                    else {
                        const items = Promise.all(batch.map($c1faf66c1e858631$var$fromEntry));
                        entries.push(items);
                        // Continue reading
                        readEntries();
                    }
                }), (err)=>{
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function $c1faf66c1e858631$var$fromFileEntry(entry) {
    return (0, $e096d269e55ec3c9$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        return new Promise((resolve, reject)=>{
            entry.file((file)=>{
                const fwp = (0, $042e8f065ad6cff3$export$8cc09085015f0dc7)(file, entry.fullPath);
                resolve(fwp);
            }, (err)=>{
                reject(err);
            });
        });
    });
}




var $7dc40b1e4db1c877$export$1e511d4a378977f5;
var $7dc40b1e4db1c877$export$2e2bcd8739ae039;
"use strict";
$7dc40b1e4db1c877$export$1e511d4a378977f5 = true;
$7dc40b1e4db1c877$export$2e2bcd8739ae039 = function(file, acceptedFiles) {
    if (file && acceptedFiles) {
        var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
        if (acceptedFilesArray.length === 0) return true;
        var fileName = file.name || '';
        var mimeType = (file.type || '').toLowerCase();
        var baseMimeType = mimeType.replace(/\/.*$/, '');
        return acceptedFilesArray.some(function(type) {
            var validType = type.trim().toLowerCase();
            if (validType.charAt(0) === '.') return fileName.toLowerCase().endsWith(validType);
            else if (validType.endsWith('/*')) // This is something like a image/* mime type
            return baseMimeType === validType.replace(/\/.*$/, '');
            return mimeType === validType;
        });
    }
    return true;
};


function $25549e1581607727$var$_toConsumableArray(arr) {
    return $25549e1581607727$var$_arrayWithoutHoles(arr) || $25549e1581607727$var$_iterableToArray(arr) || $25549e1581607727$var$_unsupportedIterableToArray(arr) || $25549e1581607727$var$_nonIterableSpread();
}
function $25549e1581607727$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $25549e1581607727$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $25549e1581607727$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $25549e1581607727$var$_arrayLikeToArray(arr);
}
function $25549e1581607727$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $25549e1581607727$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $25549e1581607727$var$ownKeys(Object(source), !0).forEach(function(key) {
            $25549e1581607727$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $25549e1581607727$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $25549e1581607727$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $25549e1581607727$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $25549e1581607727$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $25549e1581607727$var$_typeof(obj);
}
function $25549e1581607727$var$_slicedToArray(arr, i) {
    return $25549e1581607727$var$_arrayWithHoles(arr) || $25549e1581607727$var$_iterableToArrayLimit(arr, i) || $25549e1581607727$var$_unsupportedIterableToArray(arr, i) || $25549e1581607727$var$_nonIterableRest();
}
function $25549e1581607727$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $25549e1581607727$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $25549e1581607727$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $25549e1581607727$var$_arrayLikeToArray(o, minLen);
}
function $25549e1581607727$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $25549e1581607727$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $25549e1581607727$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $25549e1581607727$var$accepts = typeof (0, $7dc40b1e4db1c877$export$2e2bcd8739ae039) === "function" ? (0, $7dc40b1e4db1c877$export$2e2bcd8739ae039) : (0, $7dc40b1e4db1c877$export$2e2bcd8739ae039).default; // Error codes
var $25549e1581607727$export$d2c35cc369247232 = "file-invalid-type";
var $25549e1581607727$export$d7bd1185abe1e87c = "file-too-large";
var $25549e1581607727$export$8bd5ec6ed990dc9 = "file-too-small";
var $25549e1581607727$export$3271ef1d2dd155f9 = "too-many-files";
var $25549e1581607727$export$d4e71bc0b80dc0fb = {
    FileInvalidType: $25549e1581607727$export$d2c35cc369247232,
    FileTooLarge: $25549e1581607727$export$d7bd1185abe1e87c,
    FileTooSmall: $25549e1581607727$export$8bd5ec6ed990dc9,
    TooManyFiles: $25549e1581607727$export$3271ef1d2dd155f9
};
var $25549e1581607727$export$bc0bbda045f09b5a = function getInvalidTypeRejectionErr() {
    var accept = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var acceptArr = accept.split(",");
    var msg = acceptArr.length > 1 ? "one of ".concat(acceptArr.join(", ")) : acceptArr[0];
    return {
        code: $25549e1581607727$export$d2c35cc369247232,
        message: "File type must be ".concat(msg)
    };
};
var $25549e1581607727$export$b70c322af07b9d49 = function getTooLargeRejectionErr(maxSize) {
    return {
        code: $25549e1581607727$export$d7bd1185abe1e87c,
        message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
    };
};
var $25549e1581607727$export$d61cfd6dff5a3e22 = function getTooSmallRejectionErr(minSize) {
    return {
        code: $25549e1581607727$export$8bd5ec6ed990dc9,
        message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
    };
};
var $25549e1581607727$export$1e1e1b6120329fe = {
    code: $25549e1581607727$export$3271ef1d2dd155f9,
    message: "Too many files"
};
function $25549e1581607727$export$2a44042abbda425f(file) {
    return file.type === "" && typeof file.getAsFile === "function";
}
function $25549e1581607727$export$b511db3632effe58(file, accept) {
    var isAcceptable = file.type === "application/x-moz-file" || $25549e1581607727$var$accepts(file, accept) || $25549e1581607727$export$2a44042abbda425f(file);
    return [
        isAcceptable,
        isAcceptable ? null : $25549e1581607727$export$bc0bbda045f09b5a(accept)
    ];
}
function $25549e1581607727$export$860631d45ba43fd9(file, minSize, maxSize) {
    if ($25549e1581607727$var$isDefined(file.size)) {
        if ($25549e1581607727$var$isDefined(minSize) && $25549e1581607727$var$isDefined(maxSize)) {
            if (file.size > maxSize) return [
                false,
                $25549e1581607727$export$b70c322af07b9d49(maxSize)
            ];
            if (file.size < minSize) return [
                false,
                $25549e1581607727$export$d61cfd6dff5a3e22(minSize)
            ];
        } else if ($25549e1581607727$var$isDefined(minSize) && file.size < minSize) return [
            false,
            $25549e1581607727$export$d61cfd6dff5a3e22(minSize)
        ];
        else if ($25549e1581607727$var$isDefined(maxSize) && file.size > maxSize) return [
            false,
            $25549e1581607727$export$b70c322af07b9d49(maxSize)
        ];
    }
    return [
        true,
        null
    ];
}
function $25549e1581607727$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $25549e1581607727$export$6a0bb4322c81a197(_ref) {
    var files = _ref.files, accept = _ref.accept, minSize = _ref.minSize, maxSize = _ref.maxSize, multiple = _ref.multiple, maxFiles = _ref.maxFiles, validator = _ref.validator;
    if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) return false;
    return files.every(function(file) {
        var _fileAccepted = $25549e1581607727$export$b511db3632effe58(file, accept), _fileAccepted2 = $25549e1581607727$var$_slicedToArray(_fileAccepted, 1), accepted = _fileAccepted2[0];
        var _fileMatchSize = $25549e1581607727$export$860631d45ba43fd9(file, minSize, maxSize), _fileMatchSize2 = $25549e1581607727$var$_slicedToArray(_fileMatchSize, 1), sizeMatch = _fileMatchSize2[0];
        var customErrors = validator ? validator(file) : null;
        return accepted && sizeMatch && !customErrors;
    });
} // React's synthetic events has event.isPropagationStopped,
function $25549e1581607727$export$8d6d6472146de265(event) {
    if (typeof event.isPropagationStopped === "function") return event.isPropagationStopped();
    else if (typeof event.cancelBubble !== "undefined") return event.cancelBubble;
    return false;
}
function $25549e1581607727$export$52f1fc875a1e5986(event) {
    if (!event.dataTransfer) return !!event.target && !!event.target.files;
     // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
    // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file
    return Array.prototype.some.call(event.dataTransfer.types, function(type) {
        return type === "Files" || type === "application/x-moz-file";
    });
}
function $25549e1581607727$export$f9006bf02b243736(item) {
    return $25549e1581607727$var$_typeof(item) === "object" && item !== null && item.kind === "file";
} // allow the entire document to be a drag target
function $25549e1581607727$export$2ead263d6635cecc(event) {
    event.preventDefault();
}
function $25549e1581607727$var$isIe(userAgent) {
    return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}
function $25549e1581607727$var$isEdge(userAgent) {
    return userAgent.indexOf("Edge/") !== -1;
}
function $25549e1581607727$export$d3498e653911f962() {
    var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
    return $25549e1581607727$var$isIe(userAgent) || $25549e1581607727$var$isEdge(userAgent);
}
function $25549e1581607727$export$b9ecd428b558ff10() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(event) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return fns.some(function(fn) {
            if (!$25549e1581607727$export$8d6d6472146de265(event) && fn) fn.apply(void 0, [
                event
            ].concat(args));
            return $25549e1581607727$export$8d6d6472146de265(event);
        });
    };
}
function $25549e1581607727$export$858af2af50e1eaf8() {
    return "showOpenFilePicker" in window;
}
function $25549e1581607727$export$8ce4bd13c494743e(accept) {
    if ($25549e1581607727$var$isDefined(accept)) {
        var acceptForPicker = Object.entries(accept).filter(function(_ref2) {
            var _ref3 = $25549e1581607727$var$_slicedToArray(_ref2, 2), mimeType = _ref3[0], ext = _ref3[1];
            var ok = true;
            if (!$25549e1581607727$export$69c8ec3250e1cfbf(mimeType)) {
                console.warn("Skipped \"".concat(mimeType, "\" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types."));
                ok = false;
            }
            if (!Array.isArray(ext) || !ext.every($25549e1581607727$export$42c2be5a6d408120)) {
                console.warn("Skipped \"".concat(mimeType, "\" because an invalid file extension was provided."));
                ok = false;
            }
            return ok;
        }).reduce(function(agg, _ref4) {
            var _ref5 = $25549e1581607727$var$_slicedToArray(_ref4, 2), mimeType = _ref5[0], ext = _ref5[1];
            return $25549e1581607727$var$_objectSpread($25549e1581607727$var$_objectSpread({}, agg), {}, $25549e1581607727$var$_defineProperty({}, mimeType, ext));
        }, {});
        return [
            {
                // description is required due to https://crbug.com/1264708
                description: "Files",
                accept: acceptForPicker
            }
        ];
    }
    return accept;
}
function $25549e1581607727$export$1278288bcefb97b9(accept) {
    if ($25549e1581607727$var$isDefined(accept)) return Object.entries(accept).reduce(function(a, _ref6) {
        var _ref7 = $25549e1581607727$var$_slicedToArray(_ref6, 2), mimeType = _ref7[0], ext = _ref7[1];
        return [].concat($25549e1581607727$var$_toConsumableArray(a), [
            mimeType
        ], $25549e1581607727$var$_toConsumableArray(ext));
    }, []) // Silently discard invalid entries as pickerOptionsFromAccept warns about these
    .filter(function(v) {
        return $25549e1581607727$export$69c8ec3250e1cfbf(v) || $25549e1581607727$export$42c2be5a6d408120(v);
    }).join(",");
    return undefined;
}
function $25549e1581607727$export$72580c77a176a18f(v) {
    return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
function $25549e1581607727$export$c4f82d4432e209a9(v) {
    return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}
function $25549e1581607727$export$69c8ec3250e1cfbf(v) {
    return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || v === "application/*" || /\w+\/[-+.\w]+/g.test(v);
}
function $25549e1581607727$export$42c2be5a6d408120(v) {
    return /^.*\.[\w]+$/.test(v);
} /**
 * @typedef {Object.<string, string[]>} AcceptProp
 */  /**
 * @typedef {object} FileError
 * @property {string} message
 * @property {ErrorCode|string} code
 */  /**
 * @typedef {"file-invalid-type"|"file-too-large"|"file-too-small"|"too-many-files"} ErrorCode
 */ 


var $3b007977aa081624$var$_excluded = [
    "children"
], $3b007977aa081624$var$_excluded2 = [
    "open"
], $3b007977aa081624$var$_excluded3 = [
    "refKey",
    "role",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "onClick",
    "onDragEnter",
    "onDragOver",
    "onDragLeave",
    "onDrop"
], $3b007977aa081624$var$_excluded4 = [
    "refKey",
    "onChange",
    "onClick"
];
function $3b007977aa081624$var$_toConsumableArray(arr) {
    return $3b007977aa081624$var$_arrayWithoutHoles(arr) || $3b007977aa081624$var$_iterableToArray(arr) || $3b007977aa081624$var$_unsupportedIterableToArray(arr) || $3b007977aa081624$var$_nonIterableSpread();
}
function $3b007977aa081624$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3b007977aa081624$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $3b007977aa081624$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $3b007977aa081624$var$_arrayLikeToArray(arr);
}
function $3b007977aa081624$var$_slicedToArray(arr, i) {
    return $3b007977aa081624$var$_arrayWithHoles(arr) || $3b007977aa081624$var$_iterableToArrayLimit(arr, i) || $3b007977aa081624$var$_unsupportedIterableToArray(arr, i) || $3b007977aa081624$var$_nonIterableRest();
}
function $3b007977aa081624$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3b007977aa081624$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3b007977aa081624$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3b007977aa081624$var$_arrayLikeToArray(o, minLen);
}
function $3b007977aa081624$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3b007977aa081624$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $3b007977aa081624$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $3b007977aa081624$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3b007977aa081624$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $3b007977aa081624$var$ownKeys(Object(source), !0).forEach(function(key) {
            $3b007977aa081624$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $3b007977aa081624$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3b007977aa081624$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3b007977aa081624$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3b007977aa081624$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3b007977aa081624$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */ var $3b007977aa081624$var$Dropzone = /*#__PURE__*/ (0, $8FY87.forwardRef)(function(_ref, ref) {
    var children = _ref.children, params = $3b007977aa081624$var$_objectWithoutProperties(_ref, $3b007977aa081624$var$_excluded);
    var _useDropzone = $3b007977aa081624$export$cd49c0ecc5be9f36(params), open = _useDropzone.open, props = $3b007977aa081624$var$_objectWithoutProperties(_useDropzone, $3b007977aa081624$var$_excluded2);
    (0, $8FY87.useImperativeHandle)(ref, function() {
        return {
            open: open
        };
    }, [
        open
    ]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $8FY87.Fragment), null, children($3b007977aa081624$var$_objectSpread($3b007977aa081624$var$_objectSpread({}, props), {}, {
        open: open
    })));
});
$3b007977aa081624$var$Dropzone.displayName = "Dropzone"; // Add default props for react-docgen
var $3b007977aa081624$var$defaultProps = {
    disabled: false,
    getFilesFromEvent: (0, $c1faf66c1e858631$export$a36e16046ae8f1bb),
    maxSize: Infinity,
    minSize: 0,
    multiple: true,
    maxFiles: 0,
    preventDropOnDocument: true,
    noClick: false,
    noKeyboard: false,
    noDrag: false,
    noDragEventsBubbling: false,
    validator: null,
    useFsAccessApi: false,
    autoFocus: false
};
$3b007977aa081624$var$Dropzone.defaultProps = $3b007977aa081624$var$defaultProps;
$3b007977aa081624$var$Dropzone.propTypes = {
    /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {boolean} params.isDragGlobal Files are being dragged anywhere on the document
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).func,
    /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */ accept: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).string)),
    /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).bool,
    /**
   * If false, allow dropped items to take over the current browser window
   */ preventDropOnDocument: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).bool,
    /**
   * If true, disables click to open the native file selection dialog
   */ noClick: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).bool,
    /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */ noKeyboard: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).bool,
    /**
   * If true, disables drag 'n' drop
   */ noDrag: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).bool,
    /**
   * If true, stops drag event propagation to parents
   */ noDragEventsBubbling: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).bool,
    /**
   * Minimum file size (in bytes)
   */ minSize: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).number,
    /**
   * Maximum file size (in bytes)
   */ maxSize: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).number,
    /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */ maxFiles: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).number,
    /**
   * Enable/disable the dropzone
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).bool,
    /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event|Array<FileSystemFileHandle>)} event A drag event or input change event (if files were selected via the file dialog)
   */ getFilesFromEvent: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).func,
    /**
   * Cb for when closing the file dialog with no selection
   */ onFileDialogCancel: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).func,
    /**
   * Cb for when opening the file dialog
   */ onFileDialogOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).func,
    /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */ useFsAccessApi: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).bool,
    /**
   * Set to true to focus the root element on render
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).bool,
    /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */ onDragEnter: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).func,
    /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */ onDragLeave: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).func,
    /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */ onDragOver: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ onDrop: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */ onDropAccepted: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */ onDropRejected: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).func,
    /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).func,
    /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */ validator: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).func
};
var $3b007977aa081624$export$2e2bcd8739ae039 = $3b007977aa081624$var$Dropzone;
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event|Array<FileSystemFileHandle>)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */ /**
 * An object with the current dropzone state.
 *
 * @typedef {object} DropzoneState
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {boolean} isDragGlobal Files are being dragged anywhere on the document
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */ /**
 * An object with the dropzone methods.
 *
 * @typedef {object} DropzoneMethods
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 */ var $3b007977aa081624$var$initialState = {
    isFocused: false,
    isFileDialogActive: false,
    isDragActive: false,
    isDragAccept: false,
    isDragReject: false,
    isDragGlobal: false,
    acceptedFiles: [],
    fileRejections: []
};
function $3b007977aa081624$export$cd49c0ecc5be9f36() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _defaultProps$props = $3b007977aa081624$var$_objectSpread($3b007977aa081624$var$_objectSpread({}, $3b007977aa081624$var$defaultProps), props), accept = _defaultProps$props.accept, disabled = _defaultProps$props.disabled, getFilesFromEvent = _defaultProps$props.getFilesFromEvent, maxSize = _defaultProps$props.maxSize, minSize = _defaultProps$props.minSize, multiple = _defaultProps$props.multiple, maxFiles = _defaultProps$props.maxFiles, onDragEnter = _defaultProps$props.onDragEnter, onDragLeave = _defaultProps$props.onDragLeave, onDragOver = _defaultProps$props.onDragOver, onDrop = _defaultProps$props.onDrop, onDropAccepted = _defaultProps$props.onDropAccepted, onDropRejected = _defaultProps$props.onDropRejected, onFileDialogCancel = _defaultProps$props.onFileDialogCancel, onFileDialogOpen = _defaultProps$props.onFileDialogOpen, useFsAccessApi = _defaultProps$props.useFsAccessApi, autoFocus = _defaultProps$props.autoFocus, preventDropOnDocument = _defaultProps$props.preventDropOnDocument, noClick = _defaultProps$props.noClick, noKeyboard = _defaultProps$props.noKeyboard, noDrag = _defaultProps$props.noDrag, noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling, onError = _defaultProps$props.onError, validator = _defaultProps$props.validator;
    var acceptAttr = (0, $8FY87.useMemo)(function() {
        return (0, $25549e1581607727$export$1278288bcefb97b9)(accept);
    }, [
        accept
    ]);
    var pickerTypes = (0, $8FY87.useMemo)(function() {
        return (0, $25549e1581607727$export$8ce4bd13c494743e)(accept);
    }, [
        accept
    ]);
    var onFileDialogOpenCb = (0, $8FY87.useMemo)(function() {
        return typeof onFileDialogOpen === "function" ? onFileDialogOpen : $3b007977aa081624$var$noop;
    }, [
        onFileDialogOpen
    ]);
    var onFileDialogCancelCb = (0, $8FY87.useMemo)(function() {
        return typeof onFileDialogCancel === "function" ? onFileDialogCancel : $3b007977aa081624$var$noop;
    }, [
        onFileDialogCancel
    ]);
    /**
   * @constant
   * @type {React.MutableRefObject<HTMLElement>}
   */ var rootRef = (0, $8FY87.useRef)(null);
    var inputRef = (0, $8FY87.useRef)(null);
    var _useReducer = (0, $8FY87.useReducer)($3b007977aa081624$var$reducer, $3b007977aa081624$var$initialState), _useReducer2 = $3b007977aa081624$var$_slicedToArray(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
    var isFocused = state.isFocused, isFileDialogActive = state.isFileDialogActive;
    var fsAccessApiWorksRef = (0, $8FY87.useRef)(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && (0, $25549e1581607727$export$858af2af50e1eaf8)()); // Update file dialog active state when the window is focused on
    var onWindowFocus = function onWindowFocus() {
        // Execute the timeout only if the file dialog is opened in the browser
        if (!fsAccessApiWorksRef.current && isFileDialogActive) setTimeout(function() {
            if (inputRef.current) {
                var files = inputRef.current.files;
                if (!files.length) {
                    dispatch({
                        type: "closeDialog"
                    });
                    onFileDialogCancelCb();
                }
            }
        }, 300);
    };
    (0, $8FY87.useEffect)(function() {
        window.addEventListener("focus", onWindowFocus, false);
        return function() {
            window.removeEventListener("focus", onWindowFocus, false);
        };
    }, [
        inputRef,
        isFileDialogActive,
        onFileDialogCancelCb,
        fsAccessApiWorksRef
    ]);
    var dragTargetsRef = (0, $8FY87.useRef)([]);
    var globalDragTargetsRef = (0, $8FY87.useRef)([]);
    var onDocumentDrop = function onDocumentDrop(event) {
        if (rootRef.current && rootRef.current.contains(event.target)) // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
        event.preventDefault();
        dragTargetsRef.current = [];
    };
    (0, $8FY87.useEffect)(function() {
        if (preventDropOnDocument) {
            document.addEventListener("dragover", (0, $25549e1581607727$export$2ead263d6635cecc), false);
            document.addEventListener("drop", onDocumentDrop, false);
        }
        return function() {
            if (preventDropOnDocument) {
                document.removeEventListener("dragover", (0, $25549e1581607727$export$2ead263d6635cecc));
                document.removeEventListener("drop", onDocumentDrop);
            }
        };
    }, [
        rootRef,
        preventDropOnDocument
    ]); // Track global drag state for document-level drag events
    (0, $8FY87.useEffect)(function() {
        var onDocumentDragEnter = function onDocumentDragEnter(event) {
            globalDragTargetsRef.current = [].concat($3b007977aa081624$var$_toConsumableArray(globalDragTargetsRef.current), [
                event.target
            ]);
            if ((0, $25549e1581607727$export$52f1fc875a1e5986)(event)) dispatch({
                isDragGlobal: true,
                type: "setDragGlobal"
            });
        };
        var onDocumentDragLeave = function onDocumentDragLeave(event) {
            // Only deactivate once we've left all children
            globalDragTargetsRef.current = globalDragTargetsRef.current.filter(function(el) {
                return el !== event.target && el !== null;
            });
            if (globalDragTargetsRef.current.length > 0) return;
            dispatch({
                isDragGlobal: false,
                type: "setDragGlobal"
            });
        };
        var onDocumentDragEnd = function onDocumentDragEnd() {
            globalDragTargetsRef.current = [];
            dispatch({
                isDragGlobal: false,
                type: "setDragGlobal"
            });
        };
        var onDocumentDropGlobal = function onDocumentDropGlobal() {
            globalDragTargetsRef.current = [];
            dispatch({
                isDragGlobal: false,
                type: "setDragGlobal"
            });
        };
        document.addEventListener("dragenter", onDocumentDragEnter, false);
        document.addEventListener("dragleave", onDocumentDragLeave, false);
        document.addEventListener("dragend", onDocumentDragEnd, false);
        document.addEventListener("drop", onDocumentDropGlobal, false);
        return function() {
            document.removeEventListener("dragenter", onDocumentDragEnter);
            document.removeEventListener("dragleave", onDocumentDragLeave);
            document.removeEventListener("dragend", onDocumentDragEnd);
            document.removeEventListener("drop", onDocumentDropGlobal);
        };
    }, [
        rootRef
    ]); // Auto focus the root when autoFocus is true
    (0, $8FY87.useEffect)(function() {
        if (!disabled && autoFocus && rootRef.current) rootRef.current.focus();
        return function() {};
    }, [
        rootRef,
        autoFocus,
        disabled
    ]);
    var onErrCb = (0, $8FY87.useCallback)(function(e) {
        if (onError) onError(e);
        else // Let the user know something's gone wrong if they haven't provided the onError cb.
        console.error(e);
    }, [
        onError
    ]);
    var onDragEnterCb = (0, $8FY87.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [].concat($3b007977aa081624$var$_toConsumableArray(dragTargetsRef.current), [
            event.target
        ]);
        if ((0, $25549e1581607727$export$52f1fc875a1e5986)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $25549e1581607727$export$8d6d6472146de265)(event) && !noDragEventsBubbling) return;
            var fileCount = files.length;
            var isDragAccept = fileCount > 0 && (0, $25549e1581607727$export$6a0bb4322c81a197)({
                files: files,
                accept: acceptAttr,
                minSize: minSize,
                maxSize: maxSize,
                multiple: multiple,
                maxFiles: maxFiles,
                validator: validator
            });
            var isDragReject = fileCount > 0 && !isDragAccept;
            dispatch({
                isDragAccept: isDragAccept,
                isDragReject: isDragReject,
                isDragActive: true,
                type: "setDraggedFiles"
            });
            if (onDragEnter) onDragEnter(event);
        }).catch(function(e) {
            return onErrCb(e);
        });
    }, [
        getFilesFromEvent,
        onDragEnter,
        onErrCb,
        noDragEventsBubbling,
        acceptAttr,
        minSize,
        maxSize,
        multiple,
        maxFiles,
        validator
    ]);
    var onDragOverCb = (0, $8FY87.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event);
        var hasFiles = (0, $25549e1581607727$export$52f1fc875a1e5986)(event);
        if (hasFiles && event.dataTransfer) try {
            event.dataTransfer.dropEffect = "copy";
        } catch (_unused) {}
        if (hasFiles && onDragOver) onDragOver(event);
        return false;
    }, [
        onDragOver,
        noDragEventsBubbling
    ]);
    var onDragLeaveCb = (0, $8FY87.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event); // Only deactivate once the dropzone and all children have been left
        var targets = dragTargetsRef.current.filter(function(target) {
            return rootRef.current && rootRef.current.contains(target);
        }); // Make sure to remove a target present multiple times only once
        // (Firefox may fire dragenter/dragleave multiple times on the same element)
        var targetIdx = targets.indexOf(event.target);
        if (targetIdx !== -1) targets.splice(targetIdx, 1);
        dragTargetsRef.current = targets;
        if (targets.length > 0) return;
        dispatch({
            type: "setDraggedFiles",
            isDragActive: false,
            isDragAccept: false,
            isDragReject: false
        });
        if ((0, $25549e1581607727$export$52f1fc875a1e5986)(event) && onDragLeave) onDragLeave(event);
    }, [
        rootRef,
        onDragLeave,
        noDragEventsBubbling
    ]);
    var setFiles = (0, $8FY87.useCallback)(function(files, event) {
        var acceptedFiles = [];
        var fileRejections = [];
        files.forEach(function(file) {
            var _fileAccepted = (0, $25549e1581607727$export$b511db3632effe58)(file, acceptAttr), _fileAccepted2 = $3b007977aa081624$var$_slicedToArray(_fileAccepted, 2), accepted = _fileAccepted2[0], acceptError = _fileAccepted2[1];
            var _fileMatchSize = (0, $25549e1581607727$export$860631d45ba43fd9)(file, minSize, maxSize), _fileMatchSize2 = $3b007977aa081624$var$_slicedToArray(_fileMatchSize, 2), sizeMatch = _fileMatchSize2[0], sizeError = _fileMatchSize2[1];
            var customErrors = validator ? validator(file) : null;
            if (accepted && sizeMatch && !customErrors) acceptedFiles.push(file);
            else {
                var errors = [
                    acceptError,
                    sizeError
                ];
                if (customErrors) errors = errors.concat(customErrors);
                fileRejections.push({
                    file: file,
                    errors: errors.filter(function(e) {
                        return e;
                    })
                });
            }
        });
        if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
            // Reject everything and empty accepted files
            acceptedFiles.forEach(function(file) {
                fileRejections.push({
                    file: file,
                    errors: [
                        (0, $25549e1581607727$export$1e1e1b6120329fe)
                    ]
                });
            });
            acceptedFiles.splice(0);
        }
        dispatch({
            acceptedFiles: acceptedFiles,
            fileRejections: fileRejections,
            isDragReject: fileRejections.length > 0,
            type: "setFiles"
        });
        if (onDrop) onDrop(acceptedFiles, fileRejections, event);
        if (fileRejections.length > 0 && onDropRejected) onDropRejected(fileRejections, event);
        if (acceptedFiles.length > 0 && onDropAccepted) onDropAccepted(acceptedFiles, event);
    }, [
        dispatch,
        multiple,
        acceptAttr,
        minSize,
        maxSize,
        maxFiles,
        onDrop,
        onDropAccepted,
        onDropRejected,
        validator
    ]);
    var onDropCb = (0, $8FY87.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [];
        if ((0, $25549e1581607727$export$52f1fc875a1e5986)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $25549e1581607727$export$8d6d6472146de265)(event) && !noDragEventsBubbling) return;
            setFiles(files, event);
        }).catch(function(e) {
            return onErrCb(e);
        });
        dispatch({
            type: "reset"
        });
    }, [
        getFilesFromEvent,
        setFiles,
        onErrCb,
        noDragEventsBubbling
    ]); // Fn for opening the file dialog programmatically
    var openFileDialog = (0, $8FY87.useCallback)(function() {
        // No point to use FS access APIs if context is not secure
        // https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts#feature_detection
        if (fsAccessApiWorksRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
            var opts = {
                multiple: multiple,
                types: pickerTypes
            };
            window.showOpenFilePicker(opts).then(function(handles) {
                return getFilesFromEvent(handles);
            }).then(function(files) {
                setFiles(files, null);
                dispatch({
                    type: "closeDialog"
                });
            }).catch(function(e) {
                // AbortError means the user canceled
                if ((0, $25549e1581607727$export$72580c77a176a18f)(e)) {
                    onFileDialogCancelCb(e);
                    dispatch({
                        type: "closeDialog"
                    });
                } else if ((0, $25549e1581607727$export$c4f82d4432e209a9)(e)) {
                    fsAccessApiWorksRef.current = false; // CORS, so cannot use this API
                    // Try using the input
                    if (inputRef.current) {
                        inputRef.current.value = null;
                        inputRef.current.click();
                    } else onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
                } else onErrCb(e);
            });
            return;
        }
        if (inputRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb();
            inputRef.current.value = null;
            inputRef.current.click();
        }
    }, [
        dispatch,
        onFileDialogOpenCb,
        onFileDialogCancelCb,
        useFsAccessApi,
        setFiles,
        onErrCb,
        pickerTypes,
        multiple
    ]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone
    var onKeyDownCb = (0, $8FY87.useCallback)(function(event) {
        // Ignore keyboard events bubbling up the DOM tree
        if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) return;
        if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
            event.preventDefault();
            openFileDialog();
        }
    }, [
        rootRef,
        openFileDialog
    ]); // Update focus state for the dropzone
    var onFocusCb = (0, $8FY87.useCallback)(function() {
        dispatch({
            type: "focus"
        });
    }, []);
    var onBlurCb = (0, $8FY87.useCallback)(function() {
        dispatch({
            type: "blur"
        });
    }, []); // Cb to open the file dialog when click occurs on the dropzone
    var onClickCb = (0, $8FY87.useCallback)(function() {
        if (noClick) return;
         // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
        // to ensure React can handle state changes
        // See: https://github.com/react-dropzone/react-dropzone/issues/450
        if ((0, $25549e1581607727$export$d3498e653911f962)()) setTimeout(openFileDialog, 0);
        else openFileDialog();
    }, [
        noClick,
        openFileDialog
    ]);
    var composeHandler = function composeHandler(fn) {
        return disabled ? null : fn;
    };
    var composeKeyboardHandler = function composeKeyboardHandler(fn) {
        return noKeyboard ? null : composeHandler(fn);
    };
    var composeDragHandler = function composeDragHandler(fn) {
        return noDrag ? null : composeHandler(fn);
    };
    var stopPropagation = function stopPropagation(event) {
        if (noDragEventsBubbling) event.stopPropagation();
    };
    var getRootProps = (0, $8FY87.useMemo)(function() {
        return function() {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$refKey = _ref2.refKey, refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey, role = _ref2.role, onKeyDown = _ref2.onKeyDown, onFocus = _ref2.onFocus, onBlur = _ref2.onBlur, onClick = _ref2.onClick, onDragEnter = _ref2.onDragEnter, onDragOver = _ref2.onDragOver, onDragLeave = _ref2.onDragLeave, onDrop = _ref2.onDrop, rest = $3b007977aa081624$var$_objectWithoutProperties(_ref2, $3b007977aa081624$var$_excluded3);
            return $3b007977aa081624$var$_objectSpread($3b007977aa081624$var$_objectSpread($3b007977aa081624$var$_defineProperty({
                onKeyDown: composeKeyboardHandler((0, $25549e1581607727$export$b9ecd428b558ff10)(onKeyDown, onKeyDownCb)),
                onFocus: composeKeyboardHandler((0, $25549e1581607727$export$b9ecd428b558ff10)(onFocus, onFocusCb)),
                onBlur: composeKeyboardHandler((0, $25549e1581607727$export$b9ecd428b558ff10)(onBlur, onBlurCb)),
                onClick: composeHandler((0, $25549e1581607727$export$b9ecd428b558ff10)(onClick, onClickCb)),
                onDragEnter: composeDragHandler((0, $25549e1581607727$export$b9ecd428b558ff10)(onDragEnter, onDragEnterCb)),
                onDragOver: composeDragHandler((0, $25549e1581607727$export$b9ecd428b558ff10)(onDragOver, onDragOverCb)),
                onDragLeave: composeDragHandler((0, $25549e1581607727$export$b9ecd428b558ff10)(onDragLeave, onDragLeaveCb)),
                onDrop: composeDragHandler((0, $25549e1581607727$export$b9ecd428b558ff10)(onDrop, onDropCb)),
                role: typeof role === "string" && role !== "" ? role : "presentation"
            }, refKey, rootRef), !disabled && !noKeyboard ? {
                tabIndex: 0
            } : {}), rest);
        };
    }, [
        rootRef,
        onKeyDownCb,
        onFocusCb,
        onBlurCb,
        onClickCb,
        onDragEnterCb,
        onDragOverCb,
        onDragLeaveCb,
        onDropCb,
        noKeyboard,
        noDrag,
        disabled
    ]);
    var onInputElementClick = (0, $8FY87.useCallback)(function(event) {
        event.stopPropagation();
    }, []);
    var getInputProps = (0, $8FY87.useMemo)(function() {
        return function() {
            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, onChange = _ref3.onChange, onClick = _ref3.onClick, rest = $3b007977aa081624$var$_objectWithoutProperties(_ref3, $3b007977aa081624$var$_excluded4);
            var inputProps = $3b007977aa081624$var$_defineProperty({
                accept: acceptAttr,
                multiple: multiple,
                type: "file",
                style: {
                    border: 0,
                    clip: "rect(0, 0, 0, 0)",
                    clipPath: "inset(50%)",
                    height: "1px",
                    margin: "0 -1px -1px 0",
                    overflow: "hidden",
                    padding: 0,
                    position: "absolute",
                    width: "1px",
                    whiteSpace: "nowrap"
                },
                onChange: composeHandler((0, $25549e1581607727$export$b9ecd428b558ff10)(onChange, onDropCb)),
                onClick: composeHandler((0, $25549e1581607727$export$b9ecd428b558ff10)(onClick, onInputElementClick)),
                tabIndex: -1
            }, refKey, inputRef);
            return $3b007977aa081624$var$_objectSpread($3b007977aa081624$var$_objectSpread({}, inputProps), rest);
        };
    }, [
        inputRef,
        accept,
        multiple,
        onDropCb,
        disabled
    ]);
    return $3b007977aa081624$var$_objectSpread($3b007977aa081624$var$_objectSpread({}, state), {}, {
        isFocused: isFocused && !disabled,
        getRootProps: getRootProps,
        getInputProps: getInputProps,
        rootRef: rootRef,
        inputRef: inputRef,
        open: composeHandler(openFileDialog)
    });
}
/**
 * @param {DropzoneState} state
 * @param {{type: string} & DropzoneState} action
 * @returns {DropzoneState}
 */ function $3b007977aa081624$var$reducer(state, action) {
    /* istanbul ignore next */ switch(action.type){
        case "focus":
            return $3b007977aa081624$var$_objectSpread($3b007977aa081624$var$_objectSpread({}, state), {}, {
                isFocused: true
            });
        case "blur":
            return $3b007977aa081624$var$_objectSpread($3b007977aa081624$var$_objectSpread({}, state), {}, {
                isFocused: false
            });
        case "openDialog":
            return $3b007977aa081624$var$_objectSpread($3b007977aa081624$var$_objectSpread({}, $3b007977aa081624$var$initialState), {}, {
                isFileDialogActive: true
            });
        case "closeDialog":
            return $3b007977aa081624$var$_objectSpread($3b007977aa081624$var$_objectSpread({}, state), {}, {
                isFileDialogActive: false
            });
        case "setDraggedFiles":
            return $3b007977aa081624$var$_objectSpread($3b007977aa081624$var$_objectSpread({}, state), {}, {
                isDragActive: action.isDragActive,
                isDragAccept: action.isDragAccept,
                isDragReject: action.isDragReject
            });
        case "setFiles":
            return $3b007977aa081624$var$_objectSpread($3b007977aa081624$var$_objectSpread({}, state), {}, {
                acceptedFiles: action.acceptedFiles,
                fileRejections: action.fileRejections,
                isDragReject: action.isDragReject
            });
        case "setDragGlobal":
            return $3b007977aa081624$var$_objectSpread($3b007977aa081624$var$_objectSpread({}, state), {}, {
                isDragGlobal: action.isDragGlobal
            });
        case "reset":
            return $3b007977aa081624$var$_objectSpread({}, $3b007977aa081624$var$initialState);
        default:
            return state;
    }
}
function $3b007977aa081624$var$noop() {}


var $de2f67ab7018af66$exports = {};

(()=>{
    var e = {
        296: (e, t, r)=>{
            var o = /^\s+|\s+$/g, n = /^[-+]0x[0-9a-f]+$/i, i = /^0b[01]+$/i, c = /^0o[0-7]+$/i, u = parseInt, s = "object" == typeof r.g && r.g && r.g.Object === Object && r.g, l = "object" == typeof self && self && self.Object === Object && self, a = s || l || Function("return this")(), f = Object.prototype.toString, p = Math.max, y = Math.min, b = function() {
                return a.Date.now();
            };
            function d(e) {
                var t = typeof e;
                return !!e && ("object" == t || "function" == t);
            }
            function h(e) {
                if ("number" == typeof e) return e;
                if (function(e) {
                    return "symbol" == typeof e || function(e) {
                        return !!e && "object" == typeof e;
                    }(e) && "[object Symbol]" == f.call(e);
                }(e)) return NaN;
                if (d(e)) {
                    var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                    e = d(t) ? t + "" : t;
                }
                if ("string" != typeof e) return 0 === e ? e : +e;
                e = e.replace(o, "");
                var r = i.test(e);
                return r || c.test(e) ? u(e.slice(2), r ? 2 : 8) : n.test(e) ? NaN : +e;
            }
            e.exports = function(e, t, r) {
                var o, n, i, c, u, s, l = 0, a = !1, f = !1, v = !0;
                if ("function" != typeof e) throw new TypeError("Expected a function");
                function m(t) {
                    var r = o, i = n;
                    return o = n = void 0, l = t, c = e.apply(i, r);
                }
                function O(e) {
                    var r = e - s;
                    return void 0 === s || r >= t || r < 0 || f && e - l >= i;
                }
                function w() {
                    var e = b();
                    if (O(e)) return g(e);
                    u = setTimeout(w, function(e) {
                        var r = t - (e - s);
                        return f ? y(r, i - (e - l)) : r;
                    }(e));
                }
                function g(e) {
                    return u = void 0, v && o ? m(e) : (o = n = void 0, c);
                }
                function P() {
                    var e = b(), r = O(e);
                    if (o = arguments, n = this, s = e, r) {
                        if (void 0 === u) return function(e) {
                            return l = e, u = setTimeout(w, t), a ? m(e) : c;
                        }(s);
                        if (f) return u = setTimeout(w, t), m(s);
                    }
                    return void 0 === u && (u = setTimeout(w, t)), c;
                }
                return t = h(t) || 0, d(r) && (a = !!r.leading, i = (f = "maxWait" in r) ? p(h(r.maxWait) || 0, t) : i, v = "trailing" in r ? !!r.trailing : v), P.cancel = function() {
                    void 0 !== u && clearTimeout(u), l = 0, o = s = n = u = void 0;
                }, P.flush = function() {
                    return void 0 === u ? c : g(b());
                }, P;
            };
        },
        96: (e, t, r)=>{
            var o = "Expected a function", n = NaN, i = "[object Symbol]", c = /^\s+|\s+$/g, u = /^[-+]0x[0-9a-f]+$/i, s = /^0b[01]+$/i, l = /^0o[0-7]+$/i, a = parseInt, f = "object" == typeof r.g && r.g && r.g.Object === Object && r.g, p = "object" == typeof self && self && self.Object === Object && self, y = f || p || Function("return this")(), b = Object.prototype.toString, d = Math.max, h = Math.min, v = function() {
                return y.Date.now();
            };
            function m(e) {
                var t = typeof e;
                return !!e && ("object" == t || "function" == t);
            }
            function O(e) {
                if ("number" == typeof e) return e;
                if (function(e) {
                    return "symbol" == typeof e || function(e) {
                        return !!e && "object" == typeof e;
                    }(e) && b.call(e) == i;
                }(e)) return n;
                if (m(e)) {
                    var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                    e = m(t) ? t + "" : t;
                }
                if ("string" != typeof e) return 0 === e ? e : +e;
                e = e.replace(c, "");
                var r = s.test(e);
                return r || l.test(e) ? a(e.slice(2), r ? 2 : 8) : u.test(e) ? n : +e;
            }
            e.exports = function(e, t, r) {
                var n = !0, i = !0;
                if ("function" != typeof e) throw new TypeError(o);
                return m(r) && (n = "leading" in r ? !!r.leading : n, i = "trailing" in r ? !!r.trailing : i), function(e, t, r) {
                    var n, i, c, u, s, l, a = 0, f = !1, p = !1, y = !0;
                    if ("function" != typeof e) throw new TypeError(o);
                    function b(t) {
                        var r = n, o = i;
                        return n = i = void 0, a = t, u = e.apply(o, r);
                    }
                    function w(e) {
                        var r = e - l;
                        return void 0 === l || r >= t || r < 0 || p && e - a >= c;
                    }
                    function g() {
                        var e = v();
                        if (w(e)) return P(e);
                        s = setTimeout(g, function(e) {
                            var r = t - (e - l);
                            return p ? h(r, c - (e - a)) : r;
                        }(e));
                    }
                    function P(e) {
                        return s = void 0, y && n ? b(e) : (n = i = void 0, u);
                    }
                    function j() {
                        var e = v(), r = w(e);
                        if (n = arguments, i = this, l = e, r) {
                            if (void 0 === s) return function(e) {
                                return a = e, s = setTimeout(g, t), f ? b(e) : u;
                            }(l);
                            if (p) return s = setTimeout(g, t), b(l);
                        }
                        return void 0 === s && (s = setTimeout(g, t)), u;
                    }
                    return t = O(t) || 0, m(r) && (f = !!r.leading, c = (p = "maxWait" in r) ? d(O(r.maxWait) || 0, t) : c, y = "trailing" in r ? !!r.trailing : y), j.cancel = function() {
                        void 0 !== s && clearTimeout(s), a = 0, n = l = i = s = void 0;
                    }, j.flush = function() {
                        return void 0 === s ? u : P(v());
                    }, j;
                }(e, t, {
                    leading: n,
                    maxWait: t,
                    trailing: i
                });
            };
        },
        703: (e, t, r)=>{
            "use strict";
            var o = r(414);
            function n() {}
            function i() {}
            i.resetWarningCache = n, e.exports = function() {
                function e(e, t, r, n, i, c) {
                    if (c !== o) {
                        var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                        throw u.name = "Invariant Violation", u;
                    }
                }
                function t() {
                    return e;
                }
                e.isRequired = e;
                var r = {
                    array: e,
                    bigint: e,
                    bool: e,
                    func: e,
                    number: e,
                    object: e,
                    string: e,
                    symbol: e,
                    any: e,
                    arrayOf: t,
                    element: e,
                    elementType: e,
                    instanceOf: t,
                    node: e,
                    objectOf: t,
                    oneOf: t,
                    oneOfType: t,
                    shape: t,
                    exact: t,
                    checkPropTypes: i,
                    resetWarningCache: n
                };
                return r.PropTypes = r, r;
            };
        },
        697: (e, t, r)=>{
            e.exports = r(703)();
        },
        414: (e)=>{
            "use strict";
            e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
        }
    }, t = {};
    function r(o) {
        var n = t[o];
        if (void 0 !== n) return n.exports;
        var i = t[o] = {
            exports: {}
        };
        return e[o](i, i.exports, r), i.exports;
    }
    r.n = (e)=>{
        var t = e && e.__esModule ? ()=>e.default : ()=>e;
        return r.d(t, {
            a: t
        }), t;
    }, r.d = (e, t)=>{
        for(var o in t)r.o(t, o) && !r.o(e, o) && Object.defineProperty(e, o, {
            enumerable: !0,
            get: t[o]
        });
    }, r.g = function() {
        if ("object" == typeof globalThis) return globalThis;
        try {
            return this || new Function("return this")();
        } catch (e) {
            if ("object" == typeof window) return window;
        }
    }(), r.o = (e, t)=>Object.prototype.hasOwnProperty.call(e, t), r.r = (e)=>{
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e, "__esModule", {
            value: !0
        });
    };
    var o = {};
    (()=>{
        "use strict";
        r.r(o), r.d(o, {
            LazyLoadComponent: ()=>Y,
            LazyLoadImage: ()=>ne,
            trackWindowScroll: ()=>D
        });
        const e = (parcelRequire("8FY87"));
        var t = r.n(e), n = r(697);
        function i() {
            return "undefined" != typeof window && "IntersectionObserver" in window && "isIntersecting" in window.IntersectionObserverEntry.prototype;
        }
        function c(e) {
            return c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, c(e);
        }
        function u(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                t && (o = o.filter(function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })), r.push.apply(r, o);
            }
            return r;
        }
        function s(e, t, r) {
            return (t = a(t)) in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r, e;
        }
        function l(e, t) {
            for(var r = 0; r < t.length; r++){
                var o = t[r];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, a(o.key), o);
            }
        }
        function a(e) {
            var t = function(e, t) {
                if ("object" !== c(e) || null === e) return e;
                var r = e[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var o = r.call(e, "string");
                    if ("object" !== c(o)) return o;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
            }(e);
            return "symbol" === c(t) ? t : String(t);
        }
        function f(e, t) {
            return f = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            }, f(e, t);
        }
        function p(e) {
            return p = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, p(e);
        }
        var y = function(e) {
            e.forEach(function(e) {
                e.isIntersecting && e.target.onVisible();
            });
        }, b = {}, d = function(e) {
            !function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && f(e, t);
            }(h, e);
            var r, o, n, a, d = (n = h, a = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (e) {
                    return !1;
                }
            }(), function() {
                var e, t = p(n);
                if (a) {
                    var r = p(this).constructor;
                    e = Reflect.construct(t, arguments, r);
                } else e = t.apply(this, arguments);
                return function(e, t) {
                    if (t && ("object" === c(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return function(e) {
                        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e;
                    }(e);
                }(this, e);
            });
            function h(e) {
                var t;
                if (function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, h), (t = d.call(this, e)).supportsObserver = !e.scrollPosition && e.useIntersectionObserver && i(), t.supportsObserver) {
                    var r = e.threshold;
                    t.observer = function(e) {
                        return b[e] = b[e] || new IntersectionObserver(y, {
                            rootMargin: e + "px"
                        }), b[e];
                    }(r);
                }
                return t;
            }
            return r = h, o = [
                {
                    key: "componentDidMount",
                    value: function() {
                        this.placeholder && this.observer && (this.placeholder.onVisible = this.props.onVisible, this.observer.observe(this.placeholder)), this.supportsObserver || this.updateVisibility();
                    }
                },
                {
                    key: "componentWillUnmount",
                    value: function() {
                        this.observer && this.placeholder && this.observer.unobserve(this.placeholder);
                    }
                },
                {
                    key: "componentDidUpdate",
                    value: function() {
                        this.supportsObserver || this.updateVisibility();
                    }
                },
                {
                    key: "getPlaceholderBoundingBox",
                    value: function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.props.scrollPosition, t = this.placeholder.getBoundingClientRect(), r = this.placeholder.style, o = parseInt(r.getPropertyValue("margin-left"), 10) || 0, n = parseInt(r.getPropertyValue("margin-top"), 10) || 0;
                        return {
                            bottom: e.y + t.bottom + n,
                            left: e.x + t.left + o,
                            right: e.x + t.right + o,
                            top: e.y + t.top + n
                        };
                    }
                },
                {
                    key: "isPlaceholderInViewport",
                    value: function() {
                        if ("undefined" == typeof window || !this.placeholder) return !1;
                        var e = this.props, t = e.scrollPosition, r = e.threshold, o = this.getPlaceholderBoundingBox(t), n = t.y + window.innerHeight, i = t.x, c = t.x + window.innerWidth, u = t.y;
                        return Boolean(u - r <= o.bottom && n + r >= o.top && i - r <= o.right && c + r >= o.left);
                    }
                },
                {
                    key: "updateVisibility",
                    value: function() {
                        this.isPlaceholderInViewport() && this.props.onVisible();
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var e = this, r = this.props, o = r.className, n = r.height, i = r.placeholder, c = r.style, l = r.width;
                        if (i && "function" != typeof i.type) return t().cloneElement(i, {
                            ref: function(t) {
                                return e.placeholder = t;
                            }
                        });
                        var a = function(e) {
                            for(var t = 1; t < arguments.length; t++){
                                var r = null != arguments[t] ? arguments[t] : {};
                                t % 2 ? u(Object(r), !0).forEach(function(t) {
                                    s(e, t, r[t]);
                                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : u(Object(r)).forEach(function(t) {
                                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                                });
                            }
                            return e;
                        }({
                            display: "inline-block"
                        }, c);
                        return void 0 !== l && (a.width = l), void 0 !== n && (a.height = n), t().createElement("span", {
                            className: o,
                            ref: function(t) {
                                return e.placeholder = t;
                            },
                            style: a
                        }, i);
                    }
                }
            ], o && l(r.prototype, o), Object.defineProperty(r, "prototype", {
                writable: !1
            }), h;
        }(t().Component);
        d.propTypes = {
            onVisible: n.PropTypes.func.isRequired,
            className: n.PropTypes.string,
            height: n.PropTypes.oneOfType([
                n.PropTypes.number,
                n.PropTypes.string
            ]),
            placeholder: n.PropTypes.element,
            threshold: n.PropTypes.number,
            useIntersectionObserver: n.PropTypes.bool,
            scrollPosition: n.PropTypes.shape({
                x: n.PropTypes.number.isRequired,
                y: n.PropTypes.number.isRequired
            }),
            width: n.PropTypes.oneOfType([
                n.PropTypes.number,
                n.PropTypes.string
            ])
        }, d.defaultProps = {
            className: "",
            placeholder: null,
            threshold: 100,
            useIntersectionObserver: !0
        };
        const h = d;
        var v = r(296), m = r.n(v), O = r(96), w = r.n(O), g = function(e) {
            var t = getComputedStyle(e, null);
            return t.getPropertyValue("overflow") + t.getPropertyValue("overflow-y") + t.getPropertyValue("overflow-x");
        };
        const P = function(e) {
            if (!(e instanceof HTMLElement)) return window;
            for(var t = e; t && t instanceof HTMLElement;){
                if (/(scroll|auto)/.test(g(t))) return t;
                t = t.parentNode;
            }
            return window;
        };
        function j(e) {
            return j = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, j(e);
        }
        var T = [
            "delayMethod",
            "delayTime"
        ];
        function S() {
            return S = Object.assign ? Object.assign.bind() : function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = arguments[t];
                    for(var o in r)Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
                }
                return e;
            }, S.apply(this, arguments);
        }
        function E(e, t) {
            for(var r = 0; r < t.length; r++){
                var o = t[r];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (n = function(e, t) {
                    if ("object" !== j(e) || null === e) return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var o = r.call(e, "string");
                        if ("object" !== j(o)) return o;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(o.key), "symbol" === j(n) ? n : String(n)), o);
            }
            var n;
        }
        function L(e, t) {
            return L = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            }, L(e, t);
        }
        function _(e, t) {
            if (t && ("object" === j(t) || "function" == typeof t)) return t;
            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
            return I(e);
        }
        function I(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
        }
        function x(e) {
            return x = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, x(e);
        }
        var R = function() {
            return "undefined" == typeof window ? 0 : window.scrollX || window.pageXOffset;
        }, k = function() {
            return "undefined" == typeof window ? 0 : window.scrollY || window.pageYOffset;
        };
        const D = function(e) {
            var r = function(r) {
                !function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e,
                            writable: !0,
                            configurable: !0
                        }
                    }), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), t && L(e, t);
                }(l, r);
                var o, n, c, u, s = (c = l, u = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }(), function() {
                    var e, t = x(c);
                    if (u) {
                        var r = x(this).constructor;
                        e = Reflect.construct(t, arguments, r);
                    } else e = t.apply(this, arguments);
                    return _(this, e);
                });
                function l(e) {
                    var r;
                    if (function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, l), (r = s.call(this, e)).useIntersectionObserver = e.useIntersectionObserver && i(), r.useIntersectionObserver) return _(r);
                    var o = r.onChangeScroll.bind(I(r));
                    return "debounce" === e.delayMethod ? r.delayedScroll = m()(o, e.delayTime) : "throttle" === e.delayMethod && (r.delayedScroll = w()(o, e.delayTime)), r.state = {
                        scrollPosition: {
                            x: R(),
                            y: k()
                        }
                    }, r.baseComponentRef = t().createRef(), r;
                }
                return o = l, n = [
                    {
                        key: "componentDidMount",
                        value: function() {
                            this.addListeners();
                        }
                    },
                    {
                        key: "componentWillUnmount",
                        value: function() {
                            this.removeListeners();
                        }
                    },
                    {
                        key: "componentDidUpdate",
                        value: function() {
                            "undefined" == typeof window || this.useIntersectionObserver || P(this.baseComponentRef.current) !== this.scrollElement && (this.removeListeners(), this.addListeners());
                        }
                    },
                    {
                        key: "addListeners",
                        value: function() {
                            "undefined" == typeof window || this.useIntersectionObserver || (this.scrollElement = P(this.baseComponentRef.current), this.scrollElement.addEventListener("scroll", this.delayedScroll, {
                                passive: !0
                            }), window.addEventListener("resize", this.delayedScroll, {
                                passive: !0
                            }), this.scrollElement !== window && window.addEventListener("scroll", this.delayedScroll, {
                                passive: !0
                            }));
                        }
                    },
                    {
                        key: "removeListeners",
                        value: function() {
                            "undefined" == typeof window || this.useIntersectionObserver || (this.scrollElement.removeEventListener("scroll", this.delayedScroll), window.removeEventListener("resize", this.delayedScroll), this.scrollElement !== window && window.removeEventListener("scroll", this.delayedScroll));
                        }
                    },
                    {
                        key: "onChangeScroll",
                        value: function() {
                            this.useIntersectionObserver || this.setState({
                                scrollPosition: {
                                    x: R(),
                                    y: k()
                                }
                            });
                        }
                    },
                    {
                        key: "render",
                        value: function() {
                            var r = this.props, o = (r.delayMethod, r.delayTime, function(e, t) {
                                if (null == e) return {};
                                var r, o, n = function(e, t) {
                                    if (null == e) return {};
                                    var r, o, n = {}, i = Object.keys(e);
                                    for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
                                    return n;
                                }(e, t);
                                if (Object.getOwnPropertySymbols) {
                                    var i = Object.getOwnPropertySymbols(e);
                                    for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
                                }
                                return n;
                            }(r, T)), n = this.useIntersectionObserver ? null : this.state.scrollPosition;
                            return t().createElement(e, S({
                                forwardRef: this.baseComponentRef,
                                scrollPosition: n
                            }, o));
                        }
                    }
                ], E(o.prototype, n), Object.defineProperty(o, "prototype", {
                    writable: !1
                }), l;
            }(t().Component);
            return r.propTypes = {
                delayMethod: n.PropTypes.oneOf([
                    "debounce",
                    "throttle"
                ]),
                delayTime: n.PropTypes.number,
                useIntersectionObserver: n.PropTypes.bool
            }, r.defaultProps = {
                delayMethod: "throttle",
                delayTime: 300,
                useIntersectionObserver: !0
            }, r;
        };
        function C(e) {
            return C = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, C(e);
        }
        function B(e, t) {
            for(var r = 0; r < t.length; r++){
                var o = t[r];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (n = function(e, t) {
                    if ("object" !== C(e) || null === e) return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var o = r.call(e, "string");
                        if ("object" !== C(o)) return o;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(o.key), "symbol" === C(n) ? n : String(n)), o);
            }
            var n;
        }
        function M(e, t) {
            return M = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            }, M(e, t);
        }
        function N(e) {
            return N = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, N(e);
        }
        var V = function(e) {
            !function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && M(e, t);
            }(u, e);
            var r, o, n, i, c = (n = u, i = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (e) {
                    return !1;
                }
            }(), function() {
                var e, t = N(n);
                if (i) {
                    var r = N(this).constructor;
                    e = Reflect.construct(t, arguments, r);
                } else e = t.apply(this, arguments);
                return function(e, t) {
                    if (t && ("object" === C(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return function(e) {
                        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e;
                    }(e);
                }(this, e);
            });
            function u(e) {
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, u), c.call(this, e);
            }
            return r = u, o = [
                {
                    key: "render",
                    value: function() {
                        return t().createElement(h, this.props);
                    }
                }
            ], B(r.prototype, o), Object.defineProperty(r, "prototype", {
                writable: !1
            }), u;
        }(t().Component);
        const W = D(V);
        function z(e) {
            return z = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, z(e);
        }
        function $(e, t) {
            for(var r = 0; r < t.length; r++){
                var o = t[r];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (n = function(e, t) {
                    if ("object" !== z(e) || null === e) return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var o = r.call(e, "string");
                        if ("object" !== z(o)) return o;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(o.key), "symbol" === z(n) ? n : String(n)), o);
            }
            var n;
        }
        function U(e, t) {
            return U = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            }, U(e, t);
        }
        function F(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
        }
        function q(e) {
            return q = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, q(e);
        }
        var H = function(e) {
            !function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && U(e, t);
            }(s, e);
            var r, o, n, c, u = (n = s, c = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (e) {
                    return !1;
                }
            }(), function() {
                var e, t = q(n);
                if (c) {
                    var r = q(this).constructor;
                    e = Reflect.construct(t, arguments, r);
                } else e = t.apply(this, arguments);
                return function(e, t) {
                    if (t && ("object" === z(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return F(e);
                }(this, e);
            });
            function s(e) {
                var t;
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, s), t = u.call(this, e);
                var r = e.afterLoad, o = e.beforeLoad, n = e.scrollPosition, i = e.visibleByDefault;
                return t.state = {
                    visible: i
                }, i && (o(), r()), t.onVisible = t.onVisible.bind(F(t)), t.isScrollTracked = Boolean(n && Number.isFinite(n.x) && n.x >= 0 && Number.isFinite(n.y) && n.y >= 0), t;
            }
            return r = s, o = [
                {
                    key: "componentDidUpdate",
                    value: function(e, t) {
                        t.visible !== this.state.visible && this.props.afterLoad();
                    }
                },
                {
                    key: "onVisible",
                    value: function() {
                        this.props.beforeLoad(), this.setState({
                            visible: !0
                        });
                    }
                },
                {
                    key: "render",
                    value: function() {
                        if (this.state.visible) return this.props.children;
                        var e = this.props, r = e.className, o = e.delayMethod, n = e.delayTime, c = e.height, u = e.placeholder, s = e.scrollPosition, l = e.style, a = e.threshold, f = e.useIntersectionObserver, p = e.width;
                        return this.isScrollTracked || f && i() ? t().createElement(h, {
                            className: r,
                            height: c,
                            onVisible: this.onVisible,
                            placeholder: u,
                            scrollPosition: s,
                            style: l,
                            threshold: a,
                            useIntersectionObserver: f,
                            width: p
                        }) : t().createElement(W, {
                            className: r,
                            delayMethod: o,
                            delayTime: n,
                            height: c,
                            onVisible: this.onVisible,
                            placeholder: u,
                            style: l,
                            threshold: a,
                            width: p
                        });
                    }
                }
            ], $(r.prototype, o), Object.defineProperty(r, "prototype", {
                writable: !1
            }), s;
        }(t().Component);
        H.propTypes = {
            afterLoad: n.PropTypes.func,
            beforeLoad: n.PropTypes.func,
            useIntersectionObserver: n.PropTypes.bool,
            visibleByDefault: n.PropTypes.bool
        }, H.defaultProps = {
            afterLoad: function() {
                return {};
            },
            beforeLoad: function() {
                return {};
            },
            useIntersectionObserver: !0,
            visibleByDefault: !1
        };
        const Y = H;
        function X(e) {
            return X = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, X(e);
        }
        var A = [
            "afterLoad",
            "beforeLoad",
            "delayMethod",
            "delayTime",
            "effect",
            "placeholder",
            "placeholderSrc",
            "scrollPosition",
            "threshold",
            "useIntersectionObserver",
            "visibleByDefault",
            "wrapperClassName",
            "wrapperProps"
        ];
        function G(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                t && (o = o.filter(function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })), r.push.apply(r, o);
            }
            return r;
        }
        function J(e) {
            for(var t = 1; t < arguments.length; t++){
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? G(Object(r), !0).forEach(function(t) {
                    K(e, t, r[t]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : G(Object(r)).forEach(function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                });
            }
            return e;
        }
        function K(e, t, r) {
            return (t = ee(t)) in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r, e;
        }
        function Q() {
            return Q = Object.assign ? Object.assign.bind() : function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = arguments[t];
                    for(var o in r)Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
                }
                return e;
            }, Q.apply(this, arguments);
        }
        function Z(e, t) {
            for(var r = 0; r < t.length; r++){
                var o = t[r];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, ee(o.key), o);
            }
        }
        function ee(e) {
            var t = function(e, t) {
                if ("object" !== X(e) || null === e) return e;
                var r = e[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var o = r.call(e, "string");
                    if ("object" !== X(o)) return o;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
            }(e);
            return "symbol" === X(t) ? t : String(t);
        }
        function te(e, t) {
            return te = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            }, te(e, t);
        }
        function re(e) {
            return re = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, re(e);
        }
        var oe = function(e) {
            !function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && te(e, t);
            }(u, e);
            var r, o, n, i, c = (n = u, i = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (e) {
                    return !1;
                }
            }(), function() {
                var e, t = re(n);
                if (i) {
                    var r = re(this).constructor;
                    e = Reflect.construct(t, arguments, r);
                } else e = t.apply(this, arguments);
                return function(e, t) {
                    if (t && ("object" === X(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return function(e) {
                        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e;
                    }(e);
                }(this, e);
            });
            function u(e) {
                var t;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, u), (t = c.call(this, e)).state = {
                    loaded: !1
                }, t;
            }
            return r = u, o = [
                {
                    key: "onImageLoad",
                    value: function() {
                        var e = this;
                        return this.state.loaded ? null : function(t) {
                            e.props.onLoad(t), e.props.afterLoad(), e.setState({
                                loaded: !0
                            });
                        };
                    }
                },
                {
                    key: "getImg",
                    value: function() {
                        var e = this.props, r = (e.afterLoad, e.beforeLoad, e.delayMethod, e.delayTime, e.effect, e.placeholder, e.placeholderSrc, e.scrollPosition, e.threshold, e.useIntersectionObserver, e.visibleByDefault, e.wrapperClassName, e.wrapperProps, function(e, t) {
                            if (null == e) return {};
                            var r, o, n = function(e, t) {
                                if (null == e) return {};
                                var r, o, n = {}, i = Object.keys(e);
                                for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
                                return n;
                            }(e, t);
                            if (Object.getOwnPropertySymbols) {
                                var i = Object.getOwnPropertySymbols(e);
                                for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
                            }
                            return n;
                        }(e, A));
                        return t().createElement("img", Q({}, r, {
                            onLoad: this.onImageLoad()
                        }));
                    }
                },
                {
                    key: "getLazyLoadImage",
                    value: function() {
                        var e = this.props, r = e.beforeLoad, o = e.className, n = e.delayMethod, i = e.delayTime, c = e.height, u = e.placeholder, s = e.scrollPosition, l = e.style, a = e.threshold, f = e.useIntersectionObserver, p = e.visibleByDefault, y = e.width;
                        return t().createElement(Y, {
                            beforeLoad: r,
                            className: o,
                            delayMethod: n,
                            delayTime: i,
                            height: c,
                            placeholder: u,
                            scrollPosition: s,
                            style: l,
                            threshold: a,
                            useIntersectionObserver: f,
                            visibleByDefault: p,
                            width: y
                        }, this.getImg());
                    }
                },
                {
                    key: "getWrappedLazyLoadImage",
                    value: function(e) {
                        var r = this.props, o = r.effect, n = r.height, i = r.placeholderSrc, c = r.width, u = r.wrapperClassName, s = r.wrapperProps, l = this.state.loaded, a = l ? " lazy-load-image-loaded" : "", f = l || !i ? {} : {
                            backgroundImage: "url(".concat(i, ")"),
                            backgroundSize: "100% 100%"
                        };
                        return t().createElement("span", Q({
                            className: u + " lazy-load-image-background " + o + a,
                            style: J(J({}, f), {}, {
                                color: "transparent",
                                display: "inline-block",
                                height: n,
                                width: c
                            })
                        }, s), e);
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var e = this.props, t = e.effect, r = e.placeholderSrc, o = e.visibleByDefault, n = e.wrapperClassName, i = e.wrapperProps, c = this.getLazyLoadImage();
                        return (t || r) && !o || n || i ? this.getWrappedLazyLoadImage(c) : c;
                    }
                }
            ], Z(r.prototype, o), Object.defineProperty(r, "prototype", {
                writable: !1
            }), u;
        }(t().Component);
        oe.propTypes = {
            onLoad: n.PropTypes.func,
            afterLoad: n.PropTypes.func,
            beforeLoad: n.PropTypes.func,
            delayMethod: n.PropTypes.string,
            delayTime: n.PropTypes.number,
            effect: n.PropTypes.string,
            placeholderSrc: n.PropTypes.string,
            threshold: n.PropTypes.number,
            useIntersectionObserver: n.PropTypes.bool,
            visibleByDefault: n.PropTypes.bool,
            wrapperClassName: n.PropTypes.string,
            wrapperProps: n.PropTypes.object
        }, oe.defaultProps = {
            onLoad: function() {},
            afterLoad: function() {
                return {};
            },
            beforeLoad: function() {
                return {};
            },
            delayMethod: "throttle",
            delayTime: 300,
            effect: "",
            placeholderSrc: null,
            threshold: 100,
            useIntersectionObserver: !0,
            visibleByDefault: !1,
            wrapperClassName: ""
        };
        const ne = oe;
    })(), $de2f67ab7018af66$exports = o;
})();





var $8FY87 = parcelRequire("8FY87");


var $8FY87 = parcelRequire("8FY87");
var $0690e4a5117ab726$exports = {};

$0690e4a5117ab726$exports = (parcelRequire("ckAAE"));


/**
 * Compute the dimension of the crop area based on media size,
 * aspect ratio and optionally rotation
 */ function $a093c7b44363048a$var$getCropSize(mediaWidth, mediaHeight, containerWidth, containerHeight, aspect, rotation) {
    if (rotation === void 0) rotation = 0;
    var _a = $a093c7b44363048a$var$rotateSize(mediaWidth, mediaHeight, rotation), width = _a.width, height = _a.height;
    var fittingWidth = Math.min(width, containerWidth);
    var fittingHeight = Math.min(height, containerHeight);
    if (fittingWidth > fittingHeight * aspect) return {
        width: fittingHeight * aspect,
        height: fittingHeight
    };
    return {
        width: fittingWidth,
        height: fittingWidth / aspect
    };
}
/**
 * Compute media zoom.
 * We fit the media into the container with "max-width: 100%; max-height: 100%;"
 */ function $a093c7b44363048a$var$getMediaZoom(mediaSize) {
    // Take the axis with more pixels to improve accuracy
    return mediaSize.width > mediaSize.height ? mediaSize.width / mediaSize.naturalWidth : mediaSize.height / mediaSize.naturalHeight;
}
/**
 * Ensure a new media position stays in the crop area.
 */ function $a093c7b44363048a$var$restrictPosition(position, mediaSize, cropSize, zoom, rotation) {
    if (rotation === void 0) rotation = 0;
    var _a = $a093c7b44363048a$var$rotateSize(mediaSize.width, mediaSize.height, rotation), width = _a.width, height = _a.height;
    return {
        x: $a093c7b44363048a$var$restrictPositionCoord(position.x, width, cropSize.width, zoom),
        y: $a093c7b44363048a$var$restrictPositionCoord(position.y, height, cropSize.height, zoom)
    };
}
function $a093c7b44363048a$var$restrictPositionCoord(position, mediaSize, cropSize, zoom) {
    var maxPosition = Math.abs(mediaSize * zoom / 2 - cropSize / 2);
    return $a093c7b44363048a$var$clamp(position, -maxPosition, maxPosition);
}
function $a093c7b44363048a$var$getDistanceBetweenPoints(pointA, pointB) {
    return Math.sqrt(Math.pow(pointA.y - pointB.y, 2) + Math.pow(pointA.x - pointB.x, 2));
}
function $a093c7b44363048a$var$getRotationBetweenPoints(pointA, pointB) {
    return Math.atan2(pointB.y - pointA.y, pointB.x - pointA.x) * 180 / Math.PI;
}
/**
 * Compute the output cropped area of the media in percentages and pixels.
 * x/y are the top-left coordinates on the src media
 */ function $a093c7b44363048a$var$computeCroppedArea(crop, mediaSize, cropSize, aspect, zoom, rotation, restrictPosition) {
    if (rotation === void 0) rotation = 0;
    if (restrictPosition === void 0) restrictPosition = true;
    // if the media is rotated by the user, we cannot limit the position anymore
    // as it might need to be negative.
    var limitAreaFn = restrictPosition ? $a093c7b44363048a$var$limitArea : $a093c7b44363048a$var$noOp;
    var mediaBBoxSize = $a093c7b44363048a$var$rotateSize(mediaSize.width, mediaSize.height, rotation);
    var mediaNaturalBBoxSize = $a093c7b44363048a$var$rotateSize(mediaSize.naturalWidth, mediaSize.naturalHeight, rotation);
    // calculate the crop area in percentages
    // in the rotated space
    var croppedAreaPercentages = {
        x: limitAreaFn(100, ((mediaBBoxSize.width - cropSize.width / zoom) / 2 - crop.x / zoom) / mediaBBoxSize.width * 100),
        y: limitAreaFn(100, ((mediaBBoxSize.height - cropSize.height / zoom) / 2 - crop.y / zoom) / mediaBBoxSize.height * 100),
        width: limitAreaFn(100, cropSize.width / mediaBBoxSize.width * 100 / zoom),
        height: limitAreaFn(100, cropSize.height / mediaBBoxSize.height * 100 / zoom)
    };
    // we compute the pixels size naively
    var widthInPixels = Math.round(limitAreaFn(mediaNaturalBBoxSize.width, croppedAreaPercentages.width * mediaNaturalBBoxSize.width / 100));
    var heightInPixels = Math.round(limitAreaFn(mediaNaturalBBoxSize.height, croppedAreaPercentages.height * mediaNaturalBBoxSize.height / 100));
    var isImgWiderThanHigh = mediaNaturalBBoxSize.width >= mediaNaturalBBoxSize.height * aspect;
    // then we ensure the width and height exactly match the aspect (to avoid rounding approximations)
    // if the media is wider than high, when zoom is 0, the crop height will be equals to image height
    // thus we want to compute the width from the height and aspect for accuracy.
    // Otherwise, we compute the height from width and aspect.
    var sizePixels = isImgWiderThanHigh ? {
        width: Math.round(heightInPixels * aspect),
        height: heightInPixels
    } : {
        width: widthInPixels,
        height: Math.round(widthInPixels / aspect)
    };
    var croppedAreaPixels = (0, $e096d269e55ec3c9$export$18ce0697a983be9b)((0, $e096d269e55ec3c9$export$18ce0697a983be9b)({}, sizePixels), {
        x: Math.round(limitAreaFn(mediaNaturalBBoxSize.width - sizePixels.width, croppedAreaPercentages.x * mediaNaturalBBoxSize.width / 100)),
        y: Math.round(limitAreaFn(mediaNaturalBBoxSize.height - sizePixels.height, croppedAreaPercentages.y * mediaNaturalBBoxSize.height / 100))
    });
    return {
        croppedAreaPercentages: croppedAreaPercentages,
        croppedAreaPixels: croppedAreaPixels
    };
}
/**
 * Ensure the returned value is between 0 and max
 */ function $a093c7b44363048a$var$limitArea(max, value) {
    return Math.min(max, Math.max(0, value));
}
function $a093c7b44363048a$var$noOp(_max, value) {
    return value;
}
/**
 * Compute crop and zoom from the croppedAreaPercentages.
 */ function $a093c7b44363048a$export$387444de890e570c(croppedAreaPercentages, mediaSize, rotation, cropSize, minZoom, maxZoom) {
    var mediaBBoxSize = $a093c7b44363048a$var$rotateSize(mediaSize.width, mediaSize.height, rotation);
    // This is the inverse process of computeCroppedArea
    var zoom = $a093c7b44363048a$var$clamp(cropSize.width / mediaBBoxSize.width * (100 / croppedAreaPercentages.width), minZoom, maxZoom);
    var crop = {
        x: zoom * mediaBBoxSize.width / 2 - cropSize.width / 2 - mediaBBoxSize.width * zoom * (croppedAreaPercentages.x / 100),
        y: zoom * mediaBBoxSize.height / 2 - cropSize.height / 2 - mediaBBoxSize.height * zoom * (croppedAreaPercentages.y / 100)
    };
    return {
        crop: crop,
        zoom: zoom
    };
}
/**
 * Compute zoom from the croppedAreaPixels
 */ function $a093c7b44363048a$var$getZoomFromCroppedAreaPixels(croppedAreaPixels, mediaSize, cropSize) {
    var mediaZoom = $a093c7b44363048a$var$getMediaZoom(mediaSize);
    return cropSize.height > cropSize.width ? cropSize.height / (croppedAreaPixels.height * mediaZoom) : cropSize.width / (croppedAreaPixels.width * mediaZoom);
}
/**
 * Compute crop and zoom from the croppedAreaPixels
 */ function $a093c7b44363048a$export$4d2e47bf20e431bb(croppedAreaPixels, mediaSize, rotation, cropSize, minZoom, maxZoom) {
    if (rotation === void 0) rotation = 0;
    var mediaNaturalBBoxSize = $a093c7b44363048a$var$rotateSize(mediaSize.naturalWidth, mediaSize.naturalHeight, rotation);
    var zoom = $a093c7b44363048a$var$clamp($a093c7b44363048a$var$getZoomFromCroppedAreaPixels(croppedAreaPixels, mediaSize, cropSize), minZoom, maxZoom);
    var cropZoom = cropSize.height > cropSize.width ? cropSize.height / croppedAreaPixels.height : cropSize.width / croppedAreaPixels.width;
    var crop = {
        x: ((mediaNaturalBBoxSize.width - croppedAreaPixels.width) / 2 - croppedAreaPixels.x) * cropZoom,
        y: ((mediaNaturalBBoxSize.height - croppedAreaPixels.height) / 2 - croppedAreaPixels.y) * cropZoom
    };
    return {
        crop: crop,
        zoom: zoom
    };
}
/**
 * Return the point that is the center of point a and b
 */ function $a093c7b44363048a$var$getCenter(a, b) {
    return {
        x: (b.x + a.x) / 2,
        y: (b.y + a.y) / 2
    };
}
function $a093c7b44363048a$var$getRadianAngle(degreeValue) {
    return degreeValue * Math.PI / 180;
}
/**
 * Returns the new bounding area of a rotated rectangle.
 */ function $a093c7b44363048a$var$rotateSize(width, height, rotation) {
    var rotRad = $a093c7b44363048a$var$getRadianAngle(rotation);
    return {
        width: Math.abs(Math.cos(rotRad) * width) + Math.abs(Math.sin(rotRad) * height),
        height: Math.abs(Math.sin(rotRad) * width) + Math.abs(Math.cos(rotRad) * height)
    };
}
/**
 * Clamp value between min and max
 */ function $a093c7b44363048a$var$clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}
/**
 * Combine multiple class names into a single string.
 */ function $a093c7b44363048a$var$classNames() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return args.filter(function(value) {
        if (typeof value === 'string' && value.length > 0) return true;
        return false;
    }).join(' ').trim();
}
var $a093c7b44363048a$var$css_248z = ".reactEasyCrop_Container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow: hidden;\n  user-select: none;\n  touch-action: none;\n  cursor: move;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.reactEasyCrop_Image,\n.reactEasyCrop_Video {\n  will-change: transform; /* this improves performances and prevent painting issues on iOS Chrome */\n}\n\n.reactEasyCrop_Contain {\n  max-width: 100%;\n  max-height: 100%;\n  margin: auto;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n.reactEasyCrop_Cover_Horizontal {\n  width: 100%;\n  height: auto;\n}\n.reactEasyCrop_Cover_Vertical {\n  width: auto;\n  height: 100%;\n}\n\n.reactEasyCrop_CropArea {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  box-sizing: border-box;\n  box-shadow: 0 0 0 9999em;\n  color: rgba(0, 0, 0, 0.5);\n  overflow: hidden;\n}\n\n.reactEasyCrop_CropAreaRound {\n  border-radius: 50%;\n}\n\n.reactEasyCrop_CropAreaGrid::before {\n  content: ' ';\n  box-sizing: border-box;\n  position: absolute;\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  top: 0;\n  bottom: 0;\n  left: 33.33%;\n  right: 33.33%;\n  border-top: 0;\n  border-bottom: 0;\n}\n\n.reactEasyCrop_CropAreaGrid::after {\n  content: ' ';\n  box-sizing: border-box;\n  position: absolute;\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  top: 33.33%;\n  bottom: 33.33%;\n  left: 0;\n  right: 0;\n  border-left: 0;\n  border-right: 0;\n}\n";
var $a093c7b44363048a$var$MIN_ZOOM = 1;
var $a093c7b44363048a$var$MAX_ZOOM = 3;
var $a093c7b44363048a$var$KEYBOARD_STEP = 1;
var $a093c7b44363048a$export$2e2bcd8739ae039 = /** @class */ function(_super) {
    (0, $e096d269e55ec3c9$export$a8ba968b8961cb8a)(Cropper, _super);
    function Cropper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cropperRef = $8FY87.createRef();
        _this.imageRef = $8FY87.createRef();
        _this.videoRef = $8FY87.createRef();
        _this.containerPosition = {
            x: 0,
            y: 0
        };
        _this.containerRef = null;
        _this.styleRef = null;
        _this.containerRect = null;
        _this.mediaSize = {
            width: 0,
            height: 0,
            naturalWidth: 0,
            naturalHeight: 0
        };
        _this.dragStartPosition = {
            x: 0,
            y: 0
        };
        _this.dragStartCrop = {
            x: 0,
            y: 0
        };
        _this.gestureZoomStart = 0;
        _this.gestureRotationStart = 0;
        _this.isTouching = false;
        _this.lastPinchDistance = 0;
        _this.lastPinchRotation = 0;
        _this.rafDragTimeout = null;
        _this.rafPinchTimeout = null;
        _this.wheelTimer = null;
        _this.currentDoc = typeof document !== 'undefined' ? document : null;
        _this.currentWindow = typeof window !== 'undefined' ? window : null;
        _this.resizeObserver = null;
        _this.previousCropSize = null;
        _this.isInitialized = false;
        _this.state = {
            cropSize: null,
            hasWheelJustStarted: false,
            mediaObjectFit: undefined
        };
        _this.initResizeObserver = function() {
            if (typeof window.ResizeObserver === 'undefined' || !_this.containerRef) return;
            var isFirstResize = true;
            _this.resizeObserver = new window.ResizeObserver(function(entries) {
                if (isFirstResize) {
                    isFirstResize = false; // observe() is called on mount, we don't want to trigger a recompute on mount
                    return;
                }
                _this.computeSizes();
            });
            _this.resizeObserver.observe(_this.containerRef);
        };
        // this is to prevent Safari on iOS >= 10 to zoom the page
        _this.preventZoomSafari = function(e) {
            return e.preventDefault();
        };
        _this.cleanEvents = function() {
            if (!_this.currentDoc) return;
            _this.currentDoc.removeEventListener('mousemove', _this.onMouseMove);
            _this.currentDoc.removeEventListener('mouseup', _this.onDragStopped);
            _this.currentDoc.removeEventListener('touchmove', _this.onTouchMove);
            _this.currentDoc.removeEventListener('touchend', _this.onDragStopped);
            _this.currentDoc.removeEventListener('gesturechange', _this.onGestureChange);
            _this.currentDoc.removeEventListener('gestureend', _this.onGestureEnd);
            _this.currentDoc.removeEventListener('scroll', _this.onScroll);
        };
        _this.clearScrollEvent = function() {
            if (_this.containerRef) _this.containerRef.removeEventListener('wheel', _this.onWheel);
            if (_this.wheelTimer) clearTimeout(_this.wheelTimer);
        };
        _this.onMediaLoad = function() {
            var cropSize = _this.computeSizes();
            if (cropSize) {
                _this.previousCropSize = cropSize;
                _this.emitCropData();
                _this.setInitialCrop(cropSize);
                _this.isInitialized = true;
            }
            if (_this.props.onMediaLoaded) _this.props.onMediaLoaded(_this.mediaSize);
        };
        _this.setInitialCrop = function(cropSize) {
            if (_this.props.initialCroppedAreaPercentages) {
                var _a = $a093c7b44363048a$export$387444de890e570c(_this.props.initialCroppedAreaPercentages, _this.mediaSize, _this.props.rotation, cropSize, _this.props.minZoom, _this.props.maxZoom), crop = _a.crop, zoom = _a.zoom;
                _this.props.onCropChange(crop);
                _this.props.onZoomChange && _this.props.onZoomChange(zoom);
            } else if (_this.props.initialCroppedAreaPixels) {
                var _b = $a093c7b44363048a$export$4d2e47bf20e431bb(_this.props.initialCroppedAreaPixels, _this.mediaSize, _this.props.rotation, cropSize, _this.props.minZoom, _this.props.maxZoom), crop = _b.crop, zoom = _b.zoom;
                _this.props.onCropChange(crop);
                _this.props.onZoomChange && _this.props.onZoomChange(zoom);
            }
        };
        _this.computeSizes = function() {
            var _a, _b, _c, _d, _e, _f;
            var mediaRef = _this.imageRef.current || _this.videoRef.current;
            if (mediaRef && _this.containerRef) {
                _this.containerRect = _this.containerRef.getBoundingClientRect();
                _this.saveContainerPosition();
                var containerAspect = _this.containerRect.width / _this.containerRect.height;
                var naturalWidth = ((_a = _this.imageRef.current) === null || _a === void 0 ? void 0 : _a.naturalWidth) || ((_b = _this.videoRef.current) === null || _b === void 0 ? void 0 : _b.videoWidth) || 0;
                var naturalHeight = ((_c = _this.imageRef.current) === null || _c === void 0 ? void 0 : _c.naturalHeight) || ((_d = _this.videoRef.current) === null || _d === void 0 ? void 0 : _d.videoHeight) || 0;
                var isMediaScaledDown = mediaRef.offsetWidth < naturalWidth || mediaRef.offsetHeight < naturalHeight;
                var mediaAspect = naturalWidth / naturalHeight;
                // We do not rely on the offsetWidth/offsetHeight if the media is scaled down
                // as the values they report are rounded. That will result in precision losses
                // when calculating zoom. We use the fact that the media is positionned relative
                // to the container. That allows us to use the container's dimensions
                // and natural aspect ratio of the media to calculate accurate media size.
                // However, for this to work, the container should not be rotated
                var renderedMediaSize = void 0;
                if (isMediaScaledDown) switch(_this.state.mediaObjectFit){
                    default:
                    case 'contain':
                        renderedMediaSize = containerAspect > mediaAspect ? {
                            width: _this.containerRect.height * mediaAspect,
                            height: _this.containerRect.height
                        } : {
                            width: _this.containerRect.width,
                            height: _this.containerRect.width / mediaAspect
                        };
                        break;
                    case 'horizontal-cover':
                        renderedMediaSize = {
                            width: _this.containerRect.width,
                            height: _this.containerRect.width / mediaAspect
                        };
                        break;
                    case 'vertical-cover':
                        renderedMediaSize = {
                            width: _this.containerRect.height * mediaAspect,
                            height: _this.containerRect.height
                        };
                        break;
                }
                else renderedMediaSize = {
                    width: mediaRef.offsetWidth,
                    height: mediaRef.offsetHeight
                };
                _this.mediaSize = (0, $e096d269e55ec3c9$export$18ce0697a983be9b)((0, $e096d269e55ec3c9$export$18ce0697a983be9b)({}, renderedMediaSize), {
                    naturalWidth: naturalWidth,
                    naturalHeight: naturalHeight
                });
                // set media size in the parent
                if (_this.props.setMediaSize) _this.props.setMediaSize(_this.mediaSize);
                var cropSize = _this.props.cropSize ? _this.props.cropSize : $a093c7b44363048a$var$getCropSize(_this.mediaSize.width, _this.mediaSize.height, _this.containerRect.width, _this.containerRect.height, _this.props.aspect, _this.props.rotation);
                if (((_e = _this.state.cropSize) === null || _e === void 0 ? void 0 : _e.height) !== cropSize.height || ((_f = _this.state.cropSize) === null || _f === void 0 ? void 0 : _f.width) !== cropSize.width) _this.props.onCropSizeChange && _this.props.onCropSizeChange(cropSize);
                _this.setState({
                    cropSize: cropSize
                }, _this.recomputeCropPosition);
                // pass crop size to parent
                if (_this.props.setCropSize) _this.props.setCropSize(cropSize);
                return cropSize;
            }
        };
        _this.saveContainerPosition = function() {
            if (_this.containerRef) {
                var bounds = _this.containerRef.getBoundingClientRect();
                _this.containerPosition = {
                    x: bounds.left,
                    y: bounds.top
                };
            }
        };
        _this.onMouseDown = function(e) {
            if (!_this.currentDoc) return;
            e.preventDefault();
            _this.currentDoc.addEventListener('mousemove', _this.onMouseMove);
            _this.currentDoc.addEventListener('mouseup', _this.onDragStopped);
            _this.saveContainerPosition();
            _this.onDragStart(Cropper.getMousePoint(e));
        };
        _this.onMouseMove = function(e) {
            return _this.onDrag(Cropper.getMousePoint(e));
        };
        _this.onScroll = function(e) {
            if (!_this.currentDoc) return;
            e.preventDefault();
            _this.saveContainerPosition();
        };
        _this.onTouchStart = function(e) {
            if (!_this.currentDoc) return;
            _this.isTouching = true;
            if (_this.props.onTouchRequest && !_this.props.onTouchRequest(e)) return;
            _this.currentDoc.addEventListener('touchmove', _this.onTouchMove, {
                passive: false
            }); // iOS 11 now defaults to passive: true
            _this.currentDoc.addEventListener('touchend', _this.onDragStopped);
            _this.saveContainerPosition();
            if (e.touches.length === 2) _this.onPinchStart(e);
            else if (e.touches.length === 1) _this.onDragStart(Cropper.getTouchPoint(e.touches[0]));
        };
        _this.onTouchMove = function(e) {
            // Prevent whole page from scrolling on iOS.
            e.preventDefault();
            if (e.touches.length === 2) _this.onPinchMove(e);
            else if (e.touches.length === 1) _this.onDrag(Cropper.getTouchPoint(e.touches[0]));
        };
        _this.onGestureStart = function(e) {
            if (!_this.currentDoc) return;
            e.preventDefault();
            _this.currentDoc.addEventListener('gesturechange', _this.onGestureChange);
            _this.currentDoc.addEventListener('gestureend', _this.onGestureEnd);
            _this.gestureZoomStart = _this.props.zoom;
            _this.gestureRotationStart = _this.props.rotation;
        };
        _this.onGestureChange = function(e) {
            e.preventDefault();
            if (_this.isTouching) // this is to avoid conflict between gesture and touch events
            return;
            var point = Cropper.getMousePoint(e);
            var newZoom = _this.gestureZoomStart - 1 + e.scale;
            _this.setNewZoom(newZoom, point, {
                shouldUpdatePosition: true
            });
            if (_this.props.onRotationChange) {
                var newRotation = _this.gestureRotationStart + e.rotation;
                _this.props.onRotationChange(newRotation);
            }
        };
        _this.onGestureEnd = function(e) {
            _this.cleanEvents();
        };
        _this.onDragStart = function(_a) {
            var _b, _c;
            var x = _a.x, y = _a.y;
            _this.dragStartPosition = {
                x: x,
                y: y
            };
            _this.dragStartCrop = (0, $e096d269e55ec3c9$export$18ce0697a983be9b)({}, _this.props.crop);
            (_c = (_b = _this.props).onInteractionStart) === null || _c === void 0 || _c.call(_b);
        };
        _this.onDrag = function(_a) {
            var x = _a.x, y = _a.y;
            if (!_this.currentWindow) return;
            if (_this.rafDragTimeout) _this.currentWindow.cancelAnimationFrame(_this.rafDragTimeout);
            _this.rafDragTimeout = _this.currentWindow.requestAnimationFrame(function() {
                if (!_this.state.cropSize) return;
                if (x === undefined || y === undefined) return;
                var offsetX = x - _this.dragStartPosition.x;
                var offsetY = y - _this.dragStartPosition.y;
                var requestedPosition = {
                    x: _this.dragStartCrop.x + offsetX,
                    y: _this.dragStartCrop.y + offsetY
                };
                var newPosition = _this.props.restrictPosition ? $a093c7b44363048a$var$restrictPosition(requestedPosition, _this.mediaSize, _this.state.cropSize, _this.props.zoom, _this.props.rotation) : requestedPosition;
                _this.props.onCropChange(newPosition);
            });
        };
        _this.onDragStopped = function() {
            var _a, _b;
            _this.isTouching = false;
            _this.cleanEvents();
            _this.emitCropData();
            (_b = (_a = _this.props).onInteractionEnd) === null || _b === void 0 || _b.call(_a);
        };
        _this.onWheel = function(e) {
            if (!_this.currentWindow) return;
            if (_this.props.onWheelRequest && !_this.props.onWheelRequest(e)) return;
            e.preventDefault();
            var point = Cropper.getMousePoint(e);
            var pixelY = (0, (/*@__PURE__*/$parcel$interopDefault($0690e4a5117ab726$exports)))(e).pixelY;
            var newZoom = _this.props.zoom - pixelY * _this.props.zoomSpeed / 200;
            _this.setNewZoom(newZoom, point, {
                shouldUpdatePosition: true
            });
            if (!_this.state.hasWheelJustStarted) _this.setState({
                hasWheelJustStarted: true
            }, function() {
                var _a, _b;
                return (_b = (_a = _this.props).onInteractionStart) === null || _b === void 0 ? void 0 : _b.call(_a);
            });
            if (_this.wheelTimer) clearTimeout(_this.wheelTimer);
            _this.wheelTimer = _this.currentWindow.setTimeout(function() {
                return _this.setState({
                    hasWheelJustStarted: false
                }, function() {
                    var _a, _b;
                    return (_b = (_a = _this.props).onInteractionEnd) === null || _b === void 0 ? void 0 : _b.call(_a);
                });
            }, 250);
        };
        _this.getPointOnContainer = function(_a, containerTopLeft) {
            var x = _a.x, y = _a.y;
            if (!_this.containerRect) throw new Error('The Cropper is not mounted');
            return {
                x: _this.containerRect.width / 2 - (x - containerTopLeft.x),
                y: _this.containerRect.height / 2 - (y - containerTopLeft.y)
            };
        };
        _this.getPointOnMedia = function(_a) {
            var x = _a.x, y = _a.y;
            var _b = _this.props, crop = _b.crop, zoom = _b.zoom;
            return {
                x: (x + crop.x) / zoom,
                y: (y + crop.y) / zoom
            };
        };
        _this.setNewZoom = function(zoom, point, _a) {
            var _b = _a === void 0 ? {} : _a, _c = _b.shouldUpdatePosition, shouldUpdatePosition = _c === void 0 ? true : _c;
            if (!_this.state.cropSize || !_this.props.onZoomChange) return;
            var newZoom = $a093c7b44363048a$var$clamp(zoom, _this.props.minZoom, _this.props.maxZoom);
            if (shouldUpdatePosition) {
                var zoomPoint = _this.getPointOnContainer(point, _this.containerPosition);
                var zoomTarget = _this.getPointOnMedia(zoomPoint);
                var requestedPosition = {
                    x: zoomTarget.x * newZoom - zoomPoint.x,
                    y: zoomTarget.y * newZoom - zoomPoint.y
                };
                var newPosition = _this.props.restrictPosition ? $a093c7b44363048a$var$restrictPosition(requestedPosition, _this.mediaSize, _this.state.cropSize, newZoom, _this.props.rotation) : requestedPosition;
                _this.props.onCropChange(newPosition);
            }
            _this.props.onZoomChange(newZoom);
        };
        _this.getCropData = function() {
            if (!_this.state.cropSize) return null;
            // this is to ensure the crop is correctly restricted after a zoom back (https://github.com/ValentinH/react-easy-crop/issues/6)
            var restrictedPosition = _this.props.restrictPosition ? $a093c7b44363048a$var$restrictPosition(_this.props.crop, _this.mediaSize, _this.state.cropSize, _this.props.zoom, _this.props.rotation) : _this.props.crop;
            return $a093c7b44363048a$var$computeCroppedArea(restrictedPosition, _this.mediaSize, _this.state.cropSize, _this.getAspect(), _this.props.zoom, _this.props.rotation, _this.props.restrictPosition);
        };
        _this.emitCropData = function() {
            var cropData = _this.getCropData();
            if (!cropData) return;
            var croppedAreaPercentages = cropData.croppedAreaPercentages, croppedAreaPixels = cropData.croppedAreaPixels;
            if (_this.props.onCropComplete) _this.props.onCropComplete(croppedAreaPercentages, croppedAreaPixels);
            if (_this.props.onCropAreaChange) _this.props.onCropAreaChange(croppedAreaPercentages, croppedAreaPixels);
        };
        _this.emitCropAreaChange = function() {
            var cropData = _this.getCropData();
            if (!cropData) return;
            var croppedAreaPercentages = cropData.croppedAreaPercentages, croppedAreaPixels = cropData.croppedAreaPixels;
            if (_this.props.onCropAreaChange) _this.props.onCropAreaChange(croppedAreaPercentages, croppedAreaPixels);
        };
        _this.recomputeCropPosition = function() {
            var _a, _b;
            if (!_this.state.cropSize) return;
            var adjustedCrop = _this.props.crop;
            // Only scale if we're initialized and this is a legitimate resize
            if (_this.isInitialized && ((_a = _this.previousCropSize) === null || _a === void 0 ? void 0 : _a.width) && ((_b = _this.previousCropSize) === null || _b === void 0 ? void 0 : _b.height)) {
                var sizeChanged = Math.abs(_this.previousCropSize.width - _this.state.cropSize.width) > 1e-6 || Math.abs(_this.previousCropSize.height - _this.state.cropSize.height) > 1e-6;
                if (sizeChanged) {
                    var scaleX = _this.state.cropSize.width / _this.previousCropSize.width;
                    var scaleY = _this.state.cropSize.height / _this.previousCropSize.height;
                    adjustedCrop = {
                        x: _this.props.crop.x * scaleX,
                        y: _this.props.crop.y * scaleY
                    };
                }
            }
            var newPosition = _this.props.restrictPosition ? $a093c7b44363048a$var$restrictPosition(adjustedCrop, _this.mediaSize, _this.state.cropSize, _this.props.zoom, _this.props.rotation) : adjustedCrop;
            _this.previousCropSize = _this.state.cropSize;
            _this.props.onCropChange(newPosition);
            _this.emitCropData();
        };
        _this.onKeyDown = function(event) {
            var _a, _b;
            var _c = _this.props, crop = _c.crop, onCropChange = _c.onCropChange, keyboardStep = _c.keyboardStep, zoom = _c.zoom, rotation = _c.rotation;
            var step = keyboardStep;
            if (!_this.state.cropSize) return;
            // if the shift key is pressed, reduce the step to allow finer control
            if (event.shiftKey) step *= 0.2;
            var newCrop = (0, $e096d269e55ec3c9$export$18ce0697a983be9b)({}, crop);
            switch(event.key){
                case 'ArrowUp':
                    newCrop.y -= step;
                    event.preventDefault();
                    break;
                case 'ArrowDown':
                    newCrop.y += step;
                    event.preventDefault();
                    break;
                case 'ArrowLeft':
                    newCrop.x -= step;
                    event.preventDefault();
                    break;
                case 'ArrowRight':
                    newCrop.x += step;
                    event.preventDefault();
                    break;
                default:
                    return;
            }
            if (_this.props.restrictPosition) newCrop = $a093c7b44363048a$var$restrictPosition(newCrop, _this.mediaSize, _this.state.cropSize, zoom, rotation);
            if (!event.repeat) (_b = (_a = _this.props).onInteractionStart) === null || _b === void 0 || _b.call(_a);
            onCropChange(newCrop);
        };
        _this.onKeyUp = function(event) {
            var _a, _b;
            switch(event.key){
                case 'ArrowUp':
                case 'ArrowDown':
                case 'ArrowLeft':
                case 'ArrowRight':
                    event.preventDefault();
                    break;
                default:
                    return;
            }
            _this.emitCropData();
            (_b = (_a = _this.props).onInteractionEnd) === null || _b === void 0 || _b.call(_a);
        };
        return _this;
    }
    Cropper.prototype.componentDidMount = function() {
        if (!this.currentDoc || !this.currentWindow) return;
        if (this.containerRef) {
            if (this.containerRef.ownerDocument) this.currentDoc = this.containerRef.ownerDocument;
            if (this.currentDoc.defaultView) this.currentWindow = this.currentDoc.defaultView;
            this.initResizeObserver();
            // only add window resize listener if ResizeObserver is not supported. Otherwise, it would be redundant
            if (typeof window.ResizeObserver === 'undefined') this.currentWindow.addEventListener('resize', this.computeSizes);
            this.props.zoomWithScroll && this.containerRef.addEventListener('wheel', this.onWheel, {
                passive: false
            });
            this.containerRef.addEventListener('gesturestart', this.onGestureStart);
        }
        this.currentDoc.addEventListener('scroll', this.onScroll);
        if (!this.props.disableAutomaticStylesInjection) {
            this.styleRef = this.currentDoc.createElement('style');
            this.styleRef.setAttribute('type', 'text/css');
            if (this.props.nonce) this.styleRef.setAttribute('nonce', this.props.nonce);
            this.styleRef.innerHTML = $a093c7b44363048a$var$css_248z;
            this.currentDoc.head.appendChild(this.styleRef);
        }
        // when rendered via SSR, the image can already be loaded and its onLoad callback will never be called
        if (this.imageRef.current && this.imageRef.current.complete) this.onMediaLoad();
        // set image and video refs in the parent if the callbacks exist
        if (this.props.setImageRef) this.props.setImageRef(this.imageRef);
        if (this.props.setVideoRef) this.props.setVideoRef(this.videoRef);
        if (this.props.setCropperRef) this.props.setCropperRef(this.cropperRef);
    };
    Cropper.prototype.componentWillUnmount = function() {
        var _a, _b;
        if (!this.currentDoc || !this.currentWindow) return;
        if (typeof window.ResizeObserver === 'undefined') this.currentWindow.removeEventListener('resize', this.computeSizes);
        (_a = this.resizeObserver) === null || _a === void 0 || _a.disconnect();
        if (this.containerRef) this.containerRef.removeEventListener('gesturestart', this.preventZoomSafari);
        if (this.styleRef) (_b = this.styleRef.parentNode) === null || _b === void 0 || _b.removeChild(this.styleRef);
        this.cleanEvents();
        this.props.zoomWithScroll && this.clearScrollEvent();
    };
    Cropper.prototype.componentDidUpdate = function(prevProps) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (prevProps.rotation !== this.props.rotation) {
            this.computeSizes();
            this.recomputeCropPosition();
        } else if (prevProps.aspect !== this.props.aspect) this.computeSizes();
        else if (prevProps.objectFit !== this.props.objectFit) this.computeSizes();
        else if (prevProps.zoom !== this.props.zoom) this.recomputeCropPosition();
        else if (((_a = prevProps.cropSize) === null || _a === void 0 ? void 0 : _a.height) !== ((_b = this.props.cropSize) === null || _b === void 0 ? void 0 : _b.height) || ((_c = prevProps.cropSize) === null || _c === void 0 ? void 0 : _c.width) !== ((_d = this.props.cropSize) === null || _d === void 0 ? void 0 : _d.width)) this.computeSizes();
        else if (((_e = prevProps.crop) === null || _e === void 0 ? void 0 : _e.x) !== ((_f = this.props.crop) === null || _f === void 0 ? void 0 : _f.x) || ((_g = prevProps.crop) === null || _g === void 0 ? void 0 : _g.y) !== ((_h = this.props.crop) === null || _h === void 0 ? void 0 : _h.y)) this.emitCropAreaChange();
        if (prevProps.zoomWithScroll !== this.props.zoomWithScroll && this.containerRef) this.props.zoomWithScroll ? this.containerRef.addEventListener('wheel', this.onWheel, {
            passive: false
        }) : this.clearScrollEvent();
        if (prevProps.video !== this.props.video) (_j = this.videoRef.current) === null || _j === void 0 || _j.load();
        var objectFit = this.getObjectFit();
        if (objectFit !== this.state.mediaObjectFit) this.setState({
            mediaObjectFit: objectFit
        }, this.computeSizes);
    };
    Cropper.prototype.getAspect = function() {
        var _a = this.props, cropSize = _a.cropSize, aspect = _a.aspect;
        if (cropSize) return cropSize.width / cropSize.height;
        return aspect;
    };
    Cropper.prototype.getObjectFit = function() {
        var _a, _b, _c, _d;
        if (this.props.objectFit === 'cover') {
            var mediaRef = this.imageRef.current || this.videoRef.current;
            if (mediaRef && this.containerRef) {
                this.containerRect = this.containerRef.getBoundingClientRect();
                var containerAspect = this.containerRect.width / this.containerRect.height;
                var naturalWidth = ((_a = this.imageRef.current) === null || _a === void 0 ? void 0 : _a.naturalWidth) || ((_b = this.videoRef.current) === null || _b === void 0 ? void 0 : _b.videoWidth) || 0;
                var naturalHeight = ((_c = this.imageRef.current) === null || _c === void 0 ? void 0 : _c.naturalHeight) || ((_d = this.videoRef.current) === null || _d === void 0 ? void 0 : _d.videoHeight) || 0;
                var mediaAspect = naturalWidth / naturalHeight;
                return mediaAspect < containerAspect ? 'horizontal-cover' : 'vertical-cover';
            }
            return 'horizontal-cover';
        }
        return this.props.objectFit;
    };
    Cropper.prototype.onPinchStart = function(e) {
        var pointA = Cropper.getTouchPoint(e.touches[0]);
        var pointB = Cropper.getTouchPoint(e.touches[1]);
        this.lastPinchDistance = $a093c7b44363048a$var$getDistanceBetweenPoints(pointA, pointB);
        this.lastPinchRotation = $a093c7b44363048a$var$getRotationBetweenPoints(pointA, pointB);
        this.onDragStart($a093c7b44363048a$var$getCenter(pointA, pointB));
    };
    Cropper.prototype.onPinchMove = function(e) {
        var _this = this;
        if (!this.currentDoc || !this.currentWindow) return;
        var pointA = Cropper.getTouchPoint(e.touches[0]);
        var pointB = Cropper.getTouchPoint(e.touches[1]);
        var center = $a093c7b44363048a$var$getCenter(pointA, pointB);
        this.onDrag(center);
        if (this.rafPinchTimeout) this.currentWindow.cancelAnimationFrame(this.rafPinchTimeout);
        this.rafPinchTimeout = this.currentWindow.requestAnimationFrame(function() {
            var distance = $a093c7b44363048a$var$getDistanceBetweenPoints(pointA, pointB);
            var newZoom = _this.props.zoom * (distance / _this.lastPinchDistance);
            _this.setNewZoom(newZoom, center, {
                shouldUpdatePosition: false
            });
            _this.lastPinchDistance = distance;
            var rotation = $a093c7b44363048a$var$getRotationBetweenPoints(pointA, pointB);
            var newRotation = _this.props.rotation + (rotation - _this.lastPinchRotation);
            _this.props.onRotationChange && _this.props.onRotationChange(newRotation);
            _this.lastPinchRotation = rotation;
        });
    };
    Cropper.prototype.render = function() {
        var _this = this;
        var _a;
        var _b = this.props, image = _b.image, video = _b.video, mediaProps = _b.mediaProps, cropperProps = _b.cropperProps, transform = _b.transform, _c = _b.crop, x = _c.x, y = _c.y, rotation = _b.rotation, zoom = _b.zoom, cropShape = _b.cropShape, showGrid = _b.showGrid, roundCropAreaPixels = _b.roundCropAreaPixels, _d = _b.style, containerStyle = _d.containerStyle, cropAreaStyle = _d.cropAreaStyle, mediaStyle = _d.mediaStyle, _e = _b.classes, containerClassName = _e.containerClassName, cropAreaClassName = _e.cropAreaClassName, mediaClassName = _e.mediaClassName;
        var objectFit = (_a = this.state.mediaObjectFit) !== null && _a !== void 0 ? _a : this.getObjectFit();
        return $8FY87.createElement("div", {
            onMouseDown: this.onMouseDown,
            onTouchStart: this.onTouchStart,
            ref: function ref(el) {
                return _this.containerRef = el;
            },
            "data-testid": "container",
            style: containerStyle,
            className: $a093c7b44363048a$var$classNames('reactEasyCrop_Container', containerClassName)
        }, image ? $8FY87.createElement("img", (0, $e096d269e55ec3c9$export$18ce0697a983be9b)({
            alt: "",
            className: $a093c7b44363048a$var$classNames('reactEasyCrop_Image', objectFit === 'contain' && 'reactEasyCrop_Contain', objectFit === 'horizontal-cover' && 'reactEasyCrop_Cover_Horizontal', objectFit === 'vertical-cover' && 'reactEasyCrop_Cover_Vertical', mediaClassName)
        }, mediaProps, {
            src: image,
            ref: this.imageRef,
            style: (0, $e096d269e55ec3c9$export$18ce0697a983be9b)((0, $e096d269e55ec3c9$export$18ce0697a983be9b)({}, mediaStyle), {
                transform: transform || "translate(".concat(x, "px, ").concat(y, "px) rotate(").concat(rotation, "deg) scale(").concat(zoom, ")")
            }),
            onLoad: this.onMediaLoad
        })) : video && $8FY87.createElement("video", (0, $e096d269e55ec3c9$export$18ce0697a983be9b)({
            autoPlay: true,
            playsInline: true,
            loop: true,
            muted: true,
            className: $a093c7b44363048a$var$classNames('reactEasyCrop_Video', objectFit === 'contain' && 'reactEasyCrop_Contain', objectFit === 'horizontal-cover' && 'reactEasyCrop_Cover_Horizontal', objectFit === 'vertical-cover' && 'reactEasyCrop_Cover_Vertical', mediaClassName)
        }, mediaProps, {
            ref: this.videoRef,
            onLoadedMetadata: this.onMediaLoad,
            style: (0, $e096d269e55ec3c9$export$18ce0697a983be9b)((0, $e096d269e55ec3c9$export$18ce0697a983be9b)({}, mediaStyle), {
                transform: transform || "translate(".concat(x, "px, ").concat(y, "px) rotate(").concat(rotation, "deg) scale(").concat(zoom, ")")
            }),
            controls: false
        }), (Array.isArray(video) ? video : [
            {
                src: video
            }
        ]).map(function(item) {
            return $8FY87.createElement("source", (0, $e096d269e55ec3c9$export$18ce0697a983be9b)({
                key: item.src
            }, item));
        })), this.state.cropSize && $8FY87.createElement("div", (0, $e096d269e55ec3c9$export$18ce0697a983be9b)({
            ref: this.cropperRef,
            style: (0, $e096d269e55ec3c9$export$18ce0697a983be9b)((0, $e096d269e55ec3c9$export$18ce0697a983be9b)({}, cropAreaStyle), {
                width: roundCropAreaPixels ? Math.round(this.state.cropSize.width) : this.state.cropSize.width,
                height: roundCropAreaPixels ? Math.round(this.state.cropSize.height) : this.state.cropSize.height
            }),
            tabIndex: 0,
            onKeyDown: this.onKeyDown,
            onKeyUp: this.onKeyUp,
            "data-testid": "cropper",
            className: $a093c7b44363048a$var$classNames('reactEasyCrop_CropArea', cropShape === 'round' && 'reactEasyCrop_CropAreaRound', showGrid && 'reactEasyCrop_CropAreaGrid', cropAreaClassName)
        }, cropperProps)));
    };
    Cropper.defaultProps = {
        zoom: 1,
        rotation: 0,
        aspect: 4 / 3,
        maxZoom: $a093c7b44363048a$var$MAX_ZOOM,
        minZoom: $a093c7b44363048a$var$MIN_ZOOM,
        cropShape: 'rect',
        objectFit: 'contain',
        showGrid: true,
        style: {},
        classes: {},
        mediaProps: {},
        cropperProps: {},
        zoomSpeed: 1,
        restrictPosition: true,
        zoomWithScroll: true,
        keyboardStep: $a093c7b44363048a$var$KEYBOARD_STEP
    };
    Cropper.getMousePoint = function(e) {
        return {
            x: Number(e.clientX),
            y: Number(e.clientY)
        };
    };
    Cropper.getTouchPoint = function(touch) {
        return {
            x: Number(touch.clientX),
            y: Number(touch.clientY)
        };
    };
    return Cropper;
}($8FY87.Component);



var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");


var $lXBIJ = parcelRequire("lXBIJ");

var $1r55V = parcelRequire("1r55V");




var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");

var $fjFws = parcelRequire("fjFws");const $70ecee573b211e00$var$visuallyHidden = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
};
var $70ecee573b211e00$export$2e2bcd8739ae039 = $70ecee573b211e00$var$visuallyHidden;



function $c77d4abca0eeddbb$var$areArraysEqual(array1, array2, itemComparer = (a, b)=>a === b) {
    return array1.length === array2.length && array1.every((value, index)=>itemComparer(value, array2[index]));
}
var $c77d4abca0eeddbb$export$2e2bcd8739ae039 = $c77d4abca0eeddbb$var$areArraysEqual;


'use client';
const $e3d9fdb952181cf8$var$INTENTIONAL_DRAG_COUNT_THRESHOLD = 2;
function $e3d9fdb952181cf8$var$asc(a, b) {
    return a - b;
}
function $e3d9fdb952181cf8$var$findClosest(values, currentValue) {
    var _values$reduce;
    const { index: closestIndex } = (_values$reduce = values.reduce((acc, value, index)=>{
        const distance = Math.abs(currentValue - value);
        if (acc === null || distance < acc.distance || distance === acc.distance) return {
            distance: distance,
            index: index
        };
        return acc;
    }, null)) != null ? _values$reduce : {};
    return closestIndex;
}
function $e3d9fdb952181cf8$var$trackFinger(event, touchId) {
    // The event is TouchEvent
    if (touchId.current !== undefined && event.changedTouches) {
        const touchEvent = event;
        for(let i = 0; i < touchEvent.changedTouches.length; i += 1){
            const touch = touchEvent.changedTouches[i];
            if (touch.identifier === touchId.current) return {
                x: touch.clientX,
                y: touch.clientY
            };
        }
        return false;
    }
    // The event is MouseEvent
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $e3d9fdb952181cf8$export$83ce4bc8280540e6(value, min, max) {
    return (value - min) * 100 / (max - min);
}
function $e3d9fdb952181cf8$var$percentToValue(percent, min, max) {
    return (max - min) * percent + min;
}
function $e3d9fdb952181cf8$var$getDecimalPrecision(num) {
    // This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
    // When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
    if (Math.abs(num) < 1) {
        const parts = num.toExponential().split('e-');
        const matissaDecimalPart = parts[0].split('.')[1];
        return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
    }
    const decimalPart = num.toString().split('.')[1];
    return decimalPart ? decimalPart.length : 0;
}
function $e3d9fdb952181cf8$var$roundValueToStep(value, step, min) {
    const nearest = Math.round((value - min) / step) * step + min;
    return Number(nearest.toFixed($e3d9fdb952181cf8$var$getDecimalPrecision(step)));
}
function $e3d9fdb952181cf8$var$setValueIndex({ values: values, newValue: newValue, index: index }) {
    const output = values.slice();
    output[index] = newValue;
    return output.sort($e3d9fdb952181cf8$var$asc);
}
function $e3d9fdb952181cf8$var$focusThumb({ sliderRef: sliderRef, activeIndex: activeIndex, setActive: setActive }) {
    var _sliderRef$current, _doc$activeElement;
    const doc = (0, $8c19ca9e1b8eb872$export$2e2bcd8739ae039)(sliderRef.current);
    if (!((_sliderRef$current = sliderRef.current) != null && _sliderRef$current.contains(doc.activeElement)) || Number(doc == null || (_doc$activeElement = doc.activeElement) == null ? void 0 : _doc$activeElement.getAttribute('data-index')) !== activeIndex) {
        var _sliderRef$current2;
        (_sliderRef$current2 = sliderRef.current) == null || _sliderRef$current2.querySelector(`[type="range"][data-index="${activeIndex}"]`).focus();
    }
    if (setActive) setActive(activeIndex);
}
function $e3d9fdb952181cf8$var$areValuesEqual(newValue, oldValue) {
    if (typeof newValue === 'number' && typeof oldValue === 'number') return newValue === oldValue;
    if (typeof newValue === 'object' && typeof oldValue === 'object') return (0, $c77d4abca0eeddbb$export$2e2bcd8739ae039)(newValue, oldValue);
    return false;
}
const $e3d9fdb952181cf8$var$axisProps = {
    horizontal: {
        offset: (percent)=>({
                left: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    'horizontal-reverse': {
        offset: (percent)=>({
                right: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    vertical: {
        offset: (percent)=>({
                bottom: `${percent}%`
            }),
        leap: (percent)=>({
                height: `${percent}%`
            })
    }
};
const $e3d9fdb952181cf8$export$544bf02140fa9a77 = (x)=>x;
// TODO: remove support for Safari < 13.
// https://caniuse.com/#search=touch-action
//
// Safari, on iOS, supports touch action since v13.
// Over 80% of the iOS phones are compatible
// in August 2020.
// Utilizing the CSS.supports method to check if touch-action is supported.
// Since CSS.supports is supported on all but Edge@12 and IE and touch-action
// is supported on both Edge@12 and IE if CSS.supports is not available that means that
// touch-action will be supported
let $e3d9fdb952181cf8$var$cachedSupportsTouchActionNone;
function $e3d9fdb952181cf8$var$doesSupportTouchActionNone() {
    if ($e3d9fdb952181cf8$var$cachedSupportsTouchActionNone === undefined) {
        if (typeof CSS !== 'undefined' && typeof CSS.supports === 'function') $e3d9fdb952181cf8$var$cachedSupportsTouchActionNone = CSS.supports('touch-action', 'none');
        else $e3d9fdb952181cf8$var$cachedSupportsTouchActionNone = true;
    }
    return $e3d9fdb952181cf8$var$cachedSupportsTouchActionNone;
}
function $e3d9fdb952181cf8$export$56b2c08e277f365(parameters) {
    const { 'aria-labelledby': ariaLabelledby, defaultValue: defaultValue, disabled: disabled = false, disableSwap: disableSwap = false, isRtl: isRtl = false, marks: marksProp = false, max: max = 100, min: min = 0, name: name, onChange: onChange, onChangeCommitted: onChangeCommitted, orientation: orientation = 'horizontal', rootRef: ref, scale: scale = $e3d9fdb952181cf8$export$544bf02140fa9a77, step: step = 1, shiftStep: shiftStep = 10, tabIndex: tabIndex, value: valueProp } = parameters;
    const touchId = $8FY87.useRef(undefined);
    // We can't use the :active browser pseudo-classes.
    // - The active state isn't triggered when clicking on the rail.
    // - The active state isn't transferred when inversing a range slider.
    const [active, setActive] = $8FY87.useState(-1);
    const [open, setOpen] = $8FY87.useState(-1);
    const [dragging, setDragging] = $8FY87.useState(false);
    const moveCount = $8FY87.useRef(0);
    const [valueDerived, setValueState] = (0, $0c786808b2800672$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue != null ? defaultValue : min,
        name: 'Slider'
    });
    const handleChange = onChange && ((event, value, thumbIndex)=>{
        // Redefine target to allow name and value to be read.
        // This allows seamless integration with the most popular form libraries.
        // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
        // Clone the event to not override `target` of the original event.
        const nativeEvent = event.nativeEvent || event;
        // @ts-ignore The nativeEvent is function, not object
        const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
        Object.defineProperty(clonedEvent, 'target', {
            writable: true,
            value: {
                value: value,
                name: name
            }
        });
        onChange(clonedEvent, value, thumbIndex);
    });
    const range = Array.isArray(valueDerived);
    let values = range ? valueDerived.slice().sort($e3d9fdb952181cf8$var$asc) : [
        valueDerived
    ];
    values = values.map((value)=>value == null ? min : (0, $fjFws.default)(value, min, max));
    const marks = marksProp === true && step !== null ? [
        ...Array(Math.floor((max - min) / step) + 1)
    ].map((_, index)=>({
            value: min + step * index
        })) : marksProp || [];
    const marksValues = marks.map((mark)=>mark.value);
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $3f033a9a8b6f697d$export$2e2bcd8739ae039)();
    const [focusedThumbIndex, setFocusedThumbIndex] = $8FY87.useState(-1);
    const sliderRef = $8FY87.useRef(null);
    const handleFocusRef = (0, $a44e6282d60cc47f$export$2e2bcd8739ae039)(focusVisibleRef, sliderRef);
    const handleRef = (0, $a44e6282d60cc47f$export$2e2bcd8739ae039)(ref, handleFocusRef);
    const createHandleHiddenInputFocus = (otherHandlers)=>(event)=>{
            var _otherHandlers$onFocu;
            const index = Number(event.currentTarget.getAttribute('data-index'));
            handleFocusVisible(event);
            if (isFocusVisibleRef.current === true) setFocusedThumbIndex(index);
            setOpen(index);
            otherHandlers == null || (_otherHandlers$onFocu = otherHandlers.onFocus) == null || _otherHandlers$onFocu.call(otherHandlers, event);
        };
    const createHandleHiddenInputBlur = (otherHandlers)=>(event)=>{
            var _otherHandlers$onBlur;
            handleBlurVisible(event);
            if (isFocusVisibleRef.current === false) setFocusedThumbIndex(-1);
            setOpen(-1);
            otherHandlers == null || (_otherHandlers$onBlur = otherHandlers.onBlur) == null || _otherHandlers$onBlur.call(otherHandlers, event);
        };
    const changeValue = (event, valueInput)=>{
        const index = Number(event.currentTarget.getAttribute('data-index'));
        const value = values[index];
        const marksIndex = marksValues.indexOf(value);
        let newValue = valueInput;
        if (marks && step == null) {
            const maxMarksValue = marksValues[marksValues.length - 1];
            if (newValue > maxMarksValue) newValue = maxMarksValue;
            else if (newValue < marksValues[0]) newValue = marksValues[0];
            else newValue = newValue < value ? marksValues[marksIndex - 1] : marksValues[marksIndex + 1];
        }
        newValue = (0, $fjFws.default)(newValue, min, max);
        if (range) {
            // Bound the new value to the thumb's neighbours.
            if (disableSwap) newValue = (0, $fjFws.default)(newValue, values[index - 1] || -Infinity, values[index + 1] || Infinity);
            const previousValue = newValue;
            newValue = $e3d9fdb952181cf8$var$setValueIndex({
                values: values,
                newValue: newValue,
                index: index
            });
            let activeIndex = index;
            // Potentially swap the index if needed.
            if (!disableSwap) activeIndex = newValue.indexOf(previousValue);
            $e3d9fdb952181cf8$var$focusThumb({
                sliderRef: sliderRef,
                activeIndex: activeIndex
            });
        }
        setValueState(newValue);
        setFocusedThumbIndex(index);
        if (handleChange && !$e3d9fdb952181cf8$var$areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, index);
        if (onChangeCommitted) onChangeCommitted(event, newValue);
    };
    const createHandleHiddenInputKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            // The Shift + Up/Down keyboard shortcuts for moving the slider makes sense to be supported
            // only if the step is defined. If the step is null, this means tha the marks are used for specifying the valid values.
            if (step !== null) {
                const index = Number(event.currentTarget.getAttribute('data-index'));
                const value = values[index];
                let newValue = null;
                if ((event.key === 'ArrowLeft' || event.key === 'ArrowDown') && event.shiftKey || event.key === 'PageDown') newValue = Math.max(value - shiftStep, min);
                else if ((event.key === 'ArrowRight' || event.key === 'ArrowUp') && event.shiftKey || event.key === 'PageUp') newValue = Math.min(value + shiftStep, max);
                if (newValue !== null) {
                    changeValue(event, newValue);
                    event.preventDefault();
                }
            }
            otherHandlers == null || (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
        };
    (0, $1eb4765744b30085$export$2e2bcd8739ae039)(()=>{
        if (disabled && sliderRef.current.contains(document.activeElement)) {
            var _document$activeEleme;
            // This is necessary because Firefox and Safari will keep focus
            // on a disabled element:
            // https://codesandbox.io/p/sandbox/mui-pr-22247-forked-h151h?file=/src/App.js
            // @ts-ignore
            (_document$activeEleme = document.activeElement) == null || _document$activeEleme.blur();
        }
    }, [
        disabled
    ]);
    if (disabled && active !== -1) setActive(-1);
    if (disabled && focusedThumbIndex !== -1) setFocusedThumbIndex(-1);
    const createHandleHiddenInputChange = (otherHandlers)=>(event)=>{
            var _otherHandlers$onChan;
            (_otherHandlers$onChan = otherHandlers.onChange) == null || _otherHandlers$onChan.call(otherHandlers, event);
            // @ts-ignore
            changeValue(event, event.target.valueAsNumber);
        };
    const previousIndex = $8FY87.useRef(undefined);
    let axis = orientation;
    if (isRtl && orientation === 'horizontal') axis += '-reverse';
    const getFingerNewValue = ({ finger: finger, move: move = false })=>{
        const { current: slider } = sliderRef;
        const { width: width, height: height, bottom: bottom, left: left } = slider.getBoundingClientRect();
        let percent;
        if (axis.indexOf('vertical') === 0) percent = (bottom - finger.y) / height;
        else percent = (finger.x - left) / width;
        if (axis.indexOf('-reverse') !== -1) percent = 1 - percent;
        let newValue;
        newValue = $e3d9fdb952181cf8$var$percentToValue(percent, min, max);
        if (step) newValue = $e3d9fdb952181cf8$var$roundValueToStep(newValue, step, min);
        else {
            const closestIndex = $e3d9fdb952181cf8$var$findClosest(marksValues, newValue);
            newValue = marksValues[closestIndex];
        }
        newValue = (0, $fjFws.default)(newValue, min, max);
        let activeIndex = 0;
        if (range) {
            if (!move) activeIndex = $e3d9fdb952181cf8$var$findClosest(values, newValue);
            else activeIndex = previousIndex.current;
            // Bound the new value to the thumb's neighbours.
            if (disableSwap) newValue = (0, $fjFws.default)(newValue, values[activeIndex - 1] || -Infinity, values[activeIndex + 1] || Infinity);
            const previousValue = newValue;
            newValue = $e3d9fdb952181cf8$var$setValueIndex({
                values: values,
                newValue: newValue,
                index: activeIndex
            });
            // Potentially swap the index if needed.
            if (!(disableSwap && move)) {
                activeIndex = newValue.indexOf(previousValue);
                previousIndex.current = activeIndex;
            }
        }
        return {
            newValue: newValue,
            activeIndex: activeIndex
        };
    };
    const handleTouchMove = (0, $3e2c5a2d96ce42f9$export$2e2bcd8739ae039)((nativeEvent)=>{
        const finger = $e3d9fdb952181cf8$var$trackFinger(nativeEvent, touchId);
        if (!finger) return;
        moveCount.current += 1;
        // Cancel move in case some other element consumed a mouseup event and it was not fired.
        // @ts-ignore buttons doesn't not exists on touch event
        if (nativeEvent.type === 'mousemove' && nativeEvent.buttons === 0) {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            handleTouchEnd(nativeEvent);
            return;
        }
        const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
            finger: finger,
            move: true
        });
        $e3d9fdb952181cf8$var$focusThumb({
            sliderRef: sliderRef,
            activeIndex: activeIndex,
            setActive: setActive
        });
        setValueState(newValue);
        if (!dragging && moveCount.current > $e3d9fdb952181cf8$var$INTENTIONAL_DRAG_COUNT_THRESHOLD) setDragging(true);
        if (handleChange && !$e3d9fdb952181cf8$var$areValuesEqual(newValue, valueDerived)) handleChange(nativeEvent, newValue, activeIndex);
    });
    const handleTouchEnd = (0, $3e2c5a2d96ce42f9$export$2e2bcd8739ae039)((nativeEvent)=>{
        const finger = $e3d9fdb952181cf8$var$trackFinger(nativeEvent, touchId);
        setDragging(false);
        if (!finger) return;
        const { newValue: newValue } = getFingerNewValue({
            finger: finger,
            move: true
        });
        setActive(-1);
        if (nativeEvent.type === 'touchend') setOpen(-1);
        if (onChangeCommitted) onChangeCommitted(nativeEvent, newValue);
        touchId.current = undefined;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        stopListening();
    });
    const handleTouchStart = (0, $3e2c5a2d96ce42f9$export$2e2bcd8739ae039)((nativeEvent)=>{
        if (disabled) return;
        // If touch-action: none; is not supported we need to prevent the scroll manually.
        if (!$e3d9fdb952181cf8$var$doesSupportTouchActionNone()) nativeEvent.preventDefault();
        const touch = nativeEvent.changedTouches[0];
        if (touch != null) // A number that uniquely identifies the current finger in the touch session.
        touchId.current = touch.identifier;
        const finger = $e3d9fdb952181cf8$var$trackFinger(nativeEvent, touchId);
        if (finger !== false) {
            const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
                finger: finger
            });
            $e3d9fdb952181cf8$var$focusThumb({
                sliderRef: sliderRef,
                activeIndex: activeIndex,
                setActive: setActive
            });
            setValueState(newValue);
            if (handleChange && !$e3d9fdb952181cf8$var$areValuesEqual(newValue, valueDerived)) handleChange(nativeEvent, newValue, activeIndex);
        }
        moveCount.current = 0;
        const doc = (0, $8c19ca9e1b8eb872$export$2e2bcd8739ae039)(sliderRef.current);
        doc.addEventListener('touchmove', handleTouchMove, {
            passive: true
        });
        doc.addEventListener('touchend', handleTouchEnd, {
            passive: true
        });
    });
    const stopListening = $8FY87.useCallback(()=>{
        const doc = (0, $8c19ca9e1b8eb872$export$2e2bcd8739ae039)(sliderRef.current);
        doc.removeEventListener('mousemove', handleTouchMove);
        doc.removeEventListener('mouseup', handleTouchEnd);
        doc.removeEventListener('touchmove', handleTouchMove);
        doc.removeEventListener('touchend', handleTouchEnd);
    }, [
        handleTouchEnd,
        handleTouchMove
    ]);
    $8FY87.useEffect(()=>{
        const { current: slider } = sliderRef;
        slider.addEventListener('touchstart', handleTouchStart, {
            passive: $e3d9fdb952181cf8$var$doesSupportTouchActionNone()
        });
        return ()=>{
            slider.removeEventListener('touchstart', handleTouchStart);
            stopListening();
        };
    }, [
        stopListening,
        handleTouchStart
    ]);
    $8FY87.useEffect(()=>{
        if (disabled) stopListening();
    }, [
        disabled,
        stopListening
    ]);
    const createHandleMouseDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onMous;
            (_otherHandlers$onMous = otherHandlers.onMouseDown) == null || _otherHandlers$onMous.call(otherHandlers, event);
            if (disabled) return;
            if (event.defaultPrevented) return;
            // Only handle left clicks
            if (event.button !== 0) return;
            // Avoid text selection
            event.preventDefault();
            const finger = $e3d9fdb952181cf8$var$trackFinger(event, touchId);
            if (finger !== false) {
                const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
                    finger: finger
                });
                $e3d9fdb952181cf8$var$focusThumb({
                    sliderRef: sliderRef,
                    activeIndex: activeIndex,
                    setActive: setActive
                });
                setValueState(newValue);
                if (handleChange && !$e3d9fdb952181cf8$var$areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, activeIndex);
            }
            moveCount.current = 0;
            const doc = (0, $8c19ca9e1b8eb872$export$2e2bcd8739ae039)(sliderRef.current);
            doc.addEventListener('mousemove', handleTouchMove, {
                passive: true
            });
            doc.addEventListener('mouseup', handleTouchEnd);
        };
    const trackOffset = $e3d9fdb952181cf8$export$83ce4bc8280540e6(range ? values[0] : min, min, max);
    const trackLeap = $e3d9fdb952181cf8$export$83ce4bc8280540e6(values[values.length - 1], min, max) - trackOffset;
    const getRootProps = (externalProps = {})=>{
        const externalHandlers = (0, $e5aafd907334d8d3$export$2e2bcd8739ae039)(externalProps);
        const ownEventHandlers = {
            onMouseDown: createHandleMouseDown(externalHandlers || {})
        };
        const mergedEventHandlers = (0, $zgVxD.default)({}, externalHandlers, ownEventHandlers);
        return (0, $zgVxD.default)({}, externalProps, {
            ref: handleRef
        }, mergedEventHandlers);
    };
    const createHandleMouseOver = (otherHandlers)=>(event)=>{
            var _otherHandlers$onMous2;
            (_otherHandlers$onMous2 = otherHandlers.onMouseOver) == null || _otherHandlers$onMous2.call(otherHandlers, event);
            const index = Number(event.currentTarget.getAttribute('data-index'));
            setOpen(index);
        };
    const createHandleMouseLeave = (otherHandlers)=>(event)=>{
            var _otherHandlers$onMous3;
            (_otherHandlers$onMous3 = otherHandlers.onMouseLeave) == null || _otherHandlers$onMous3.call(otherHandlers, event);
            setOpen(-1);
        };
    const getThumbProps = (externalProps = {})=>{
        const externalHandlers = (0, $e5aafd907334d8d3$export$2e2bcd8739ae039)(externalProps);
        const ownEventHandlers = {
            onMouseOver: createHandleMouseOver(externalHandlers || {}),
            onMouseLeave: createHandleMouseLeave(externalHandlers || {})
        };
        return (0, $zgVxD.default)({}, externalProps, externalHandlers, ownEventHandlers);
    };
    const getThumbStyle = (index)=>{
        return {
            // So the non active thumb doesn't show its label on hover.
            pointerEvents: active !== -1 && active !== index ? 'none' : undefined
        };
    };
    const getHiddenInputProps = (externalProps = {})=>{
        var _parameters$step;
        const externalHandlers = (0, $e5aafd907334d8d3$export$2e2bcd8739ae039)(externalProps);
        const ownEventHandlers = {
            onChange: createHandleHiddenInputChange(externalHandlers || {}),
            onFocus: createHandleHiddenInputFocus(externalHandlers || {}),
            onBlur: createHandleHiddenInputBlur(externalHandlers || {}),
            onKeyDown: createHandleHiddenInputKeyDown(externalHandlers || {})
        };
        const mergedEventHandlers = (0, $zgVxD.default)({}, externalHandlers, ownEventHandlers);
        return (0, $zgVxD.default)({
            tabIndex: tabIndex,
            'aria-labelledby': ariaLabelledby,
            'aria-orientation': orientation,
            'aria-valuemax': scale(max),
            'aria-valuemin': scale(min),
            name: name,
            type: 'range',
            min: parameters.min,
            max: parameters.max,
            step: parameters.step === null && parameters.marks ? 'any' : (_parameters$step = parameters.step) != null ? _parameters$step : undefined,
            disabled: disabled
        }, externalProps, mergedEventHandlers, {
            style: (0, $zgVxD.default)({}, (0, $70ecee573b211e00$export$2e2bcd8739ae039), {
                direction: isRtl ? 'rtl' : 'ltr',
                // So that VoiceOver's focus indicator matches the thumb's dimensions
                width: '100%',
                height: '100%'
            })
        });
    };
    return {
        active: active,
        axis: axis,
        axisProps: $e3d9fdb952181cf8$var$axisProps,
        dragging: dragging,
        focusedThumbIndex: focusedThumbIndex,
        getHiddenInputProps: getHiddenInputProps,
        getRootProps: getRootProps,
        getThumbProps: getThumbProps,
        marks: marks,
        open: open,
        range: range,
        rootRef: handleRef,
        trackLeap: trackLeap,
        trackOffset: trackOffset,
        values: values,
        getThumbStyle: getThumbStyle
    };
}



var $lbp1P = parcelRequire("lbp1P");

var $6lkQ3 = parcelRequire("6lkQ3");

var $jZXCu = parcelRequire("jZXCu");

const $f753736c94a3e6c1$var$shouldSpreadAdditionalProps = (Slot)=>{
    return !Slot || !(0, $31cee6df5efff63b$export$2e2bcd8739ae039)(Slot);
};
var $f753736c94a3e6c1$export$2e2bcd8739ae039 = $f753736c94a3e6c1$var$shouldSpreadAdditionalProps;



var $ifmKX = parcelRequire("ifmKX");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $b34e4257e3ecac0a$export$9f59f2622d5cbc2a(slot) {
    return (0, $jP65K.default)('MuiSlider', slot);
}
const $b34e4257e3ecac0a$var$sliderClasses = (0, $cOYaX.default)('MuiSlider', [
    'root',
    'active',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'dragging',
    'focusVisible',
    'mark',
    'markActive',
    'marked',
    'markLabel',
    'markLabelActive',
    'rail',
    'sizeSmall',
    'thumb',
    'thumbColorPrimary',
    'thumbColorSecondary',
    'thumbColorError',
    'thumbColorSuccess',
    'thumbColorInfo',
    'thumbColorWarning',
    'track',
    'trackInverted',
    'trackFalse',
    'thumbSizeSmall',
    'valueLabel',
    'valueLabelOpen',
    'valueLabelCircle',
    'valueLabelLabel',
    'vertical'
]);
var $b34e4257e3ecac0a$export$2e2bcd8739ae039 = $b34e4257e3ecac0a$var$sliderClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $57333201523a17b1$var$useValueLabelClasses = (props)=>{
    const { open: open } = props;
    const utilityClasses = {
        offset: (0, $efJYy.default)(open && (0, $b34e4257e3ecac0a$export$2e2bcd8739ae039).valueLabelOpen),
        circle: (0, $b34e4257e3ecac0a$export$2e2bcd8739ae039).valueLabelCircle,
        label: (0, $b34e4257e3ecac0a$export$2e2bcd8739ae039).valueLabelLabel
    };
    return utilityClasses;
};
function $57333201523a17b1$export$2e2bcd8739ae039(props) {
    const { children: children, className: className, value: value } = props;
    const classes = $57333201523a17b1$var$useValueLabelClasses(props);
    if (!children) return null;
    return /*#__PURE__*/ $8FY87.cloneElement(children, {
        className: (0, $efJYy.default)(children.props.className)
    }, /*#__PURE__*/ (0, $2PPWI.jsxs)($8FY87.Fragment, {
        children: [
            children.props.children,
            /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                className: (0, $efJYy.default)(classes.offset, className),
                "aria-hidden": true,
                children: /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                    className: classes.circle,
                    children: /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                        className: classes.label,
                        children: value
                    })
                })
            })
        ]
    }));
}




var $2PPWI = parcelRequire("2PPWI");
'use client';
const $775c1ad6bc2a67fe$var$_excluded = [
    "aria-label",
    "aria-valuetext",
    "aria-labelledby",
    "component",
    "components",
    "componentsProps",
    "color",
    "classes",
    "className",
    "disableSwap",
    "disabled",
    "getAriaLabel",
    "getAriaValueText",
    "marks",
    "max",
    "min",
    "name",
    "onChange",
    "onChangeCommitted",
    "orientation",
    "shiftStep",
    "size",
    "step",
    "scale",
    "slotProps",
    "slots",
    "tabIndex",
    "track",
    "value",
    "valueLabelDisplay",
    "valueLabelFormat"
];
function $775c1ad6bc2a67fe$var$Identity(x) {
    return x;
}
const $775c1ad6bc2a67fe$export$c1a21b3b4da66aa1 = (0, $lbp1P.default)('span', {
    name: 'MuiSlider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $ifmKX.default)(ownerState.color)}`],
            ownerState.size !== 'medium' && styles[`size${(0, $ifmKX.default)(ownerState.size)}`],
            ownerState.marked && styles.marked,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.track === 'inverted' && styles.trackInverted,
            ownerState.track === false && styles.trackFalse
        ];
    }
})(({ theme: theme })=>{
    var _theme$vars;
    return {
        borderRadius: 12,
        boxSizing: 'content-box',
        display: 'inline-block',
        position: 'relative',
        cursor: 'pointer',
        touchAction: 'none',
        WebkitTapHighlightColor: 'transparent',
        '@media print': {
            colorAdjust: 'exact'
        },
        [`&.${(0, $b34e4257e3ecac0a$export$2e2bcd8739ae039).disabled}`]: {
            pointerEvents: 'none',
            cursor: 'default',
            color: (theme.vars || theme).palette.grey[400]
        },
        [`&.${(0, $b34e4257e3ecac0a$export$2e2bcd8739ae039).dragging}`]: {
            [`& .${(0, $b34e4257e3ecac0a$export$2e2bcd8739ae039).thumb}, & .${(0, $b34e4257e3ecac0a$export$2e2bcd8739ae039).track}`]: {
                transition: 'none'
            }
        },
        variants: [
            ...Object.keys(((_theme$vars = theme.vars) != null ? _theme$vars : theme).palette).filter((key)=>{
                var _theme$vars2;
                return ((_theme$vars2 = theme.vars) != null ? _theme$vars2 : theme).palette[key].main;
            }).map((color)=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 4,
                    width: '100%',
                    padding: '13px 0',
                    // The primary input mechanism of the device includes a pointing device of limited accuracy.
                    '@media (pointer: coarse)': {
                        // Reach 42px touch target, about ~8mm on screen.
                        padding: '20px 0'
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal',
                    size: 'small'
                },
                style: {
                    height: 2
                }
            },
            {
                props: {
                    orientation: 'horizontal',
                    marked: true
                },
                style: {
                    marginBottom: 20
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    height: '100%',
                    width: 4,
                    padding: '0 13px',
                    // The primary input mechanism of the device includes a pointing device of limited accuracy.
                    '@media (pointer: coarse)': {
                        // Reach 42px touch target, about ~8mm on screen.
                        padding: '0 20px'
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    size: 'small'
                },
                style: {
                    width: 2
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    marked: true
                },
                style: {
                    marginRight: 44
                }
            }
        ]
    };
});
const $775c1ad6bc2a67fe$export$b02fde61a3559c2 = (0, $lbp1P.default)('span', {
    name: 'MuiSlider',
    slot: 'Rail',
    overridesResolver: (props, styles)=>styles.rail
})({
    display: 'block',
    position: 'absolute',
    borderRadius: 'inherit',
    backgroundColor: 'currentColor',
    opacity: 0.38,
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: '100%',
                height: 'inherit',
                top: '50%',
                transform: 'translateY(-50%)'
            }
        },
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                height: '100%',
                width: 'inherit',
                left: '50%',
                transform: 'translateX(-50%)'
            }
        },
        {
            props: {
                track: 'inverted'
            },
            style: {
                opacity: 1
            }
        }
    ]
});
const $775c1ad6bc2a67fe$export$105594979f116971 = (0, $lbp1P.default)('span', {
    name: 'MuiSlider',
    slot: 'Track',
    overridesResolver: (props, styles)=>styles.track
})(({ theme: theme })=>{
    var _theme$vars3;
    return {
        display: 'block',
        position: 'absolute',
        borderRadius: 'inherit',
        border: '1px solid currentColor',
        backgroundColor: 'currentColor',
        transition: theme.transitions.create([
            'left',
            'width',
            'bottom',
            'height'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    border: 'none'
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 'inherit',
                    top: '50%',
                    transform: 'translateY(-50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    width: 'inherit',
                    left: '50%',
                    transform: 'translateX(-50%)'
                }
            },
            {
                props: {
                    track: false
                },
                style: {
                    display: 'none'
                }
            },
            ...Object.keys(((_theme$vars3 = theme.vars) != null ? _theme$vars3 : theme).palette).filter((key)=>{
                var _theme$vars4;
                return ((_theme$vars4 = theme.vars) != null ? _theme$vars4 : theme).palette[key].main;
            }).map((color)=>({
                    props: {
                        color: color,
                        track: 'inverted'
                    },
                    style: (0, $zgVxD.default)({}, theme.vars ? {
                        backgroundColor: theme.vars.palette.Slider[`${color}Track`],
                        borderColor: theme.vars.palette.Slider[`${color}Track`]
                    } : (0, $zgVxD.default)({
                        backgroundColor: (0, $1r55V.lighten)(theme.palette[color].main, 0.62),
                        borderColor: (0, $1r55V.lighten)(theme.palette[color].main, 0.62)
                    }, theme.applyStyles('dark', {
                        backgroundColor: (0, $1r55V.darken)(theme.palette[color].main, 0.5)
                    }), theme.applyStyles('dark', {
                        borderColor: (0, $1r55V.darken)(theme.palette[color].main, 0.5)
                    })))
                }))
        ]
    };
});
const $775c1ad6bc2a67fe$export$2c1b491743890dec = (0, $lbp1P.default)('span', {
    name: 'MuiSlider',
    slot: 'Thumb',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.thumb,
            styles[`thumbColor${(0, $ifmKX.default)(ownerState.color)}`],
            ownerState.size !== 'medium' && styles[`thumbSize${(0, $ifmKX.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>{
    var _theme$vars5;
    return {
        position: 'absolute',
        width: 20,
        height: 20,
        boxSizing: 'border-box',
        borderRadius: '50%',
        outline: 0,
        backgroundColor: 'currentColor',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: theme.transitions.create([
            'box-shadow',
            'left',
            'bottom'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        '&::before': {
            position: 'absolute',
            content: '""',
            borderRadius: 'inherit',
            width: '100%',
            height: '100%',
            boxShadow: (theme.vars || theme).shadows[2]
        },
        '&::after': {
            position: 'absolute',
            content: '""',
            borderRadius: '50%',
            // 42px is the hit target
            width: 42,
            height: 42,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        },
        [`&.${(0, $b34e4257e3ecac0a$export$2e2bcd8739ae039).disabled}`]: {
            '&:hover': {
                boxShadow: 'none'
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    width: 12,
                    height: 12,
                    '&::before': {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: '50%',
                    transform: 'translate(-50%, -50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%, 50%)'
                }
            },
            ...Object.keys(((_theme$vars5 = theme.vars) != null ? _theme$vars5 : theme).palette).filter((key)=>{
                var _theme$vars6;
                return ((_theme$vars6 = theme.vars) != null ? _theme$vars6 : theme).palette[key].main;
            }).map((color)=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&:hover, &.${(0, $b34e4257e3ecac0a$export$2e2bcd8739ae039).focusVisible}`]: (0, $zgVxD.default)({}, theme.vars ? {
                            boxShadow: `0px 0px 0px 8px rgba(${theme.vars.palette[color].mainChannel} / 0.16)`
                        } : {
                            boxShadow: `0px 0px 0px 8px ${(0, $1r55V.alpha)(theme.palette[color].main, 0.16)}`
                        }, {
                            '@media (hover: none)': {
                                boxShadow: 'none'
                            }
                        }),
                        [`&.${(0, $b34e4257e3ecac0a$export$2e2bcd8739ae039).active}`]: (0, $zgVxD.default)({}, theme.vars ? {
                            boxShadow: `0px 0px 0px 14px rgba(${theme.vars.palette[color].mainChannel} / 0.16)`
                        } : {
                            boxShadow: `0px 0px 0px 14px ${(0, $1r55V.alpha)(theme.palette[color].main, 0.16)}`
                        })
                    }
                }))
        ]
    };
});
const $775c1ad6bc2a67fe$export$6453176f504d54f0 = (0, $lbp1P.default)((0, $57333201523a17b1$export$2e2bcd8739ae039), {
    name: 'MuiSlider',
    slot: 'ValueLabel',
    overridesResolver: (props, styles)=>styles.valueLabel
})(({ theme: theme })=>(0, $zgVxD.default)({
        zIndex: 1,
        whiteSpace: 'nowrap'
    }, theme.typography.body2, {
        fontWeight: 500,
        transition: theme.transitions.create([
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        position: 'absolute',
        backgroundColor: (theme.vars || theme).palette.grey[600],
        borderRadius: 2,
        color: (theme.vars || theme).palette.common.white,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0.25rem 0.75rem',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    transform: 'translateY(-100%) scale(0)',
                    top: '-10px',
                    transformOrigin: 'bottom center',
                    '&::before': {
                        position: 'absolute',
                        content: '""',
                        width: 8,
                        height: 8,
                        transform: 'translate(-50%, 50%) rotate(45deg)',
                        backgroundColor: 'inherit',
                        bottom: 0,
                        left: '50%'
                    },
                    [`&.${(0, $b34e4257e3ecac0a$export$2e2bcd8739ae039).valueLabelOpen}`]: {
                        transform: 'translateY(-100%) scale(1)'
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    transform: 'translateY(-50%) scale(0)',
                    right: '30px',
                    top: '50%',
                    transformOrigin: 'right center',
                    '&::before': {
                        position: 'absolute',
                        content: '""',
                        width: 8,
                        height: 8,
                        transform: 'translate(-50%, -50%) rotate(45deg)',
                        backgroundColor: 'inherit',
                        right: -8,
                        top: '50%'
                    },
                    [`&.${(0, $b34e4257e3ecac0a$export$2e2bcd8739ae039).valueLabelOpen}`]: {
                        transform: 'translateY(-50%) scale(1)'
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    fontSize: theme.typography.pxToRem(12),
                    padding: '0.25rem 0.5rem'
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    size: 'small'
                },
                style: {
                    right: '20px'
                }
            }
        ]
    }));
const $775c1ad6bc2a67fe$export$6f85f6a3c5da6f62 = (0, $lbp1P.default)('span', {
    name: 'MuiSlider',
    slot: 'Mark',
    shouldForwardProp: (prop)=>(0, $jZXCu.default)(prop) && prop !== 'markActive',
    overridesResolver: (props, styles)=>{
        const { markActive: markActive } = props;
        return [
            styles.mark,
            markActive && styles.markActive
        ];
    }
})(({ theme: theme })=>({
        position: 'absolute',
        width: 2,
        height: 2,
        borderRadius: 1,
        backgroundColor: 'currentColor',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: '50%',
                    transform: 'translate(-1px, -50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%, 1px)'
                }
            },
            {
                props: {
                    markActive: true
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.background.paper,
                    opacity: 0.8
                }
            }
        ]
    }));
const $775c1ad6bc2a67fe$export$e6cd369965e5aa95 = (0, $lbp1P.default)('span', {
    name: 'MuiSlider',
    slot: 'MarkLabel',
    shouldForwardProp: (prop)=>(0, $jZXCu.default)(prop) && prop !== 'markLabelActive',
    overridesResolver: (props, styles)=>styles.markLabel
})(({ theme: theme })=>(0, $zgVxD.default)({}, theme.typography.body2, {
        color: (theme.vars || theme).palette.text.secondary,
        position: 'absolute',
        whiteSpace: 'nowrap',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: 30,
                    transform: 'translateX(-50%)',
                    '@media (pointer: coarse)': {
                        top: 40
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: 36,
                    transform: 'translateY(50%)',
                    '@media (pointer: coarse)': {
                        left: 44
                    }
                }
            },
            {
                props: {
                    markLabelActive: true
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary
                }
            }
        ]
    }));
const $775c1ad6bc2a67fe$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dragging: dragging, marked: marked, orientation: orientation, track: track, classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            dragging && 'dragging',
            marked && 'marked',
            orientation === 'vertical' && 'vertical',
            track === 'inverted' && 'trackInverted',
            track === false && 'trackFalse',
            color && `color${(0, $ifmKX.default)(color)}`,
            size && `size${(0, $ifmKX.default)(size)}`
        ],
        rail: [
            'rail'
        ],
        track: [
            'track'
        ],
        mark: [
            'mark'
        ],
        markActive: [
            'markActive'
        ],
        markLabel: [
            'markLabel'
        ],
        markLabelActive: [
            'markLabelActive'
        ],
        valueLabel: [
            'valueLabel'
        ],
        thumb: [
            'thumb',
            disabled && 'disabled',
            size && `thumbSize${(0, $ifmKX.default)(size)}`,
            color && `thumbColor${(0, $ifmKX.default)(color)}`
        ],
        active: [
            'active'
        ],
        disabled: [
            'disabled'
        ],
        focusVisible: [
            'focusVisible'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $b34e4257e3ecac0a$export$9f59f2622d5cbc2a), classes);
};
const $775c1ad6bc2a67fe$var$Forward = ({ children: children })=>children;
const $775c1ad6bc2a67fe$var$Slider = /*#__PURE__*/ $8FY87.forwardRef(function Slider(inputProps, ref) {
    var _ref, _slots$root, _ref2, _slots$rail, _ref3, _slots$track, _ref4, _slots$thumb, _ref5, _slots$valueLabel, _ref6, _slots$mark, _ref7, _slots$markLabel, _ref8, _slots$input, _slotProps$root, _slotProps$rail, _slotProps$track, _slotProps$thumb, _slotProps$valueLabel, _slotProps$mark, _slotProps$markLabel, _slotProps$input;
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inputProps,
        name: 'MuiSlider'
    });
    const isRtl = (0, $fd8721cf96f8ae09$export$b2dd014b6c321cb)();
    const { 'aria-label': ariaLabel, 'aria-valuetext': ariaValuetext, 'aria-labelledby': ariaLabelledby, component: // eslint-disable-next-line react/prop-types
    component = 'span', components: components = {}, componentsProps: componentsProps = {}, color: color = 'primary', classes: classesProp, className: className, disableSwap: disableSwap = false, disabled: disabled = false, getAriaLabel: getAriaLabel, getAriaValueText: getAriaValueText, marks: marksProp = false, max: max = 100, min: min = 0, orientation: orientation = 'horizontal', shiftStep: shiftStep = 10, size: size = 'medium', step: step = 1, scale: scale = $775c1ad6bc2a67fe$var$Identity, slotProps: slotProps, slots: slots, track: track = 'normal', valueLabelDisplay: valueLabelDisplay = 'off', valueLabelFormat: valueLabelFormat = $775c1ad6bc2a67fe$var$Identity } = props, other = (0, $93aRW.default)(props, $775c1ad6bc2a67fe$var$_excluded);
    const ownerState = (0, $zgVxD.default)({}, props, {
        isRtl: isRtl,
        max: max,
        min: min,
        classes: classesProp,
        disabled: disabled,
        disableSwap: disableSwap,
        orientation: orientation,
        marks: marksProp,
        color: color,
        size: size,
        step: step,
        shiftStep: shiftStep,
        scale: scale,
        track: track,
        valueLabelDisplay: valueLabelDisplay,
        valueLabelFormat: valueLabelFormat
    });
    const { axisProps: axisProps, getRootProps: getRootProps, getHiddenInputProps: getHiddenInputProps, getThumbProps: getThumbProps, open: open, active: active, axis: axis, focusedThumbIndex: focusedThumbIndex, range: range, dragging: dragging, marks: marks, values: values, trackOffset: trackOffset, trackLeap: trackLeap, getThumbStyle: getThumbStyle } = (0, $e3d9fdb952181cf8$export$56b2c08e277f365)((0, $zgVxD.default)({}, ownerState, {
        rootRef: ref
    }));
    ownerState.marked = marks.length > 0 && marks.some((mark)=>mark.label);
    ownerState.dragging = dragging;
    ownerState.focusedThumbIndex = focusedThumbIndex;
    const classes = $775c1ad6bc2a67fe$var$useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $775c1ad6bc2a67fe$export$c1a21b3b4da66aa1;
    const RailSlot = (_ref2 = (_slots$rail = slots == null ? void 0 : slots.rail) != null ? _slots$rail : components.Rail) != null ? _ref2 : $775c1ad6bc2a67fe$export$b02fde61a3559c2;
    const TrackSlot = (_ref3 = (_slots$track = slots == null ? void 0 : slots.track) != null ? _slots$track : components.Track) != null ? _ref3 : $775c1ad6bc2a67fe$export$105594979f116971;
    const ThumbSlot = (_ref4 = (_slots$thumb = slots == null ? void 0 : slots.thumb) != null ? _slots$thumb : components.Thumb) != null ? _ref4 : $775c1ad6bc2a67fe$export$2c1b491743890dec;
    const ValueLabelSlot = (_ref5 = (_slots$valueLabel = slots == null ? void 0 : slots.valueLabel) != null ? _slots$valueLabel : components.ValueLabel) != null ? _ref5 : $775c1ad6bc2a67fe$export$6453176f504d54f0;
    const MarkSlot = (_ref6 = (_slots$mark = slots == null ? void 0 : slots.mark) != null ? _slots$mark : components.Mark) != null ? _ref6 : $775c1ad6bc2a67fe$export$6f85f6a3c5da6f62;
    const MarkLabelSlot = (_ref7 = (_slots$markLabel = slots == null ? void 0 : slots.markLabel) != null ? _slots$markLabel : components.MarkLabel) != null ? _ref7 : $775c1ad6bc2a67fe$export$e6cd369965e5aa95;
    const InputSlot = (_ref8 = (_slots$input = slots == null ? void 0 : slots.input) != null ? _slots$input : components.Input) != null ? _ref8 : 'input';
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const railSlotProps = (_slotProps$rail = slotProps == null ? void 0 : slotProps.rail) != null ? _slotProps$rail : componentsProps.rail;
    const trackSlotProps = (_slotProps$track = slotProps == null ? void 0 : slotProps.track) != null ? _slotProps$track : componentsProps.track;
    const thumbSlotProps = (_slotProps$thumb = slotProps == null ? void 0 : slotProps.thumb) != null ? _slotProps$thumb : componentsProps.thumb;
    const valueLabelSlotProps = (_slotProps$valueLabel = slotProps == null ? void 0 : slotProps.valueLabel) != null ? _slotProps$valueLabel : componentsProps.valueLabel;
    const markSlotProps = (_slotProps$mark = slotProps == null ? void 0 : slotProps.mark) != null ? _slotProps$mark : componentsProps.mark;
    const markLabelSlotProps = (_slotProps$markLabel = slotProps == null ? void 0 : slotProps.markLabel) != null ? _slotProps$markLabel : componentsProps.markLabel;
    const inputSlotProps = (_slotProps$input = slotProps == null ? void 0 : slotProps.input) != null ? _slotProps$input : componentsProps.input;
    const rootProps = (0, $eeee79b1d2d55995$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        getSlotProps: getRootProps,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        additionalProps: (0, $zgVxD.default)({}, (0, $f753736c94a3e6c1$export$2e2bcd8739ae039)(RootSlot) && {
            as: component
        }),
        ownerState: (0, $zgVxD.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
        className: [
            classes.root,
            className
        ]
    });
    const railProps = (0, $eeee79b1d2d55995$export$2e2bcd8739ae039)({
        elementType: RailSlot,
        externalSlotProps: railSlotProps,
        ownerState: ownerState,
        className: classes.rail
    });
    const trackProps = (0, $eeee79b1d2d55995$export$2e2bcd8739ae039)({
        elementType: TrackSlot,
        externalSlotProps: trackSlotProps,
        additionalProps: {
            style: (0, $zgVxD.default)({}, axisProps[axis].offset(trackOffset), axisProps[axis].leap(trackLeap))
        },
        ownerState: (0, $zgVxD.default)({}, ownerState, trackSlotProps == null ? void 0 : trackSlotProps.ownerState),
        className: classes.track
    });
    const thumbProps = (0, $eeee79b1d2d55995$export$2e2bcd8739ae039)({
        elementType: ThumbSlot,
        getSlotProps: getThumbProps,
        externalSlotProps: thumbSlotProps,
        ownerState: (0, $zgVxD.default)({}, ownerState, thumbSlotProps == null ? void 0 : thumbSlotProps.ownerState),
        className: classes.thumb
    });
    const valueLabelProps = (0, $eeee79b1d2d55995$export$2e2bcd8739ae039)({
        elementType: ValueLabelSlot,
        externalSlotProps: valueLabelSlotProps,
        ownerState: (0, $zgVxD.default)({}, ownerState, valueLabelSlotProps == null ? void 0 : valueLabelSlotProps.ownerState),
        className: classes.valueLabel
    });
    const markProps = (0, $eeee79b1d2d55995$export$2e2bcd8739ae039)({
        elementType: MarkSlot,
        externalSlotProps: markSlotProps,
        ownerState: ownerState,
        className: classes.mark
    });
    const markLabelProps = (0, $eeee79b1d2d55995$export$2e2bcd8739ae039)({
        elementType: MarkLabelSlot,
        externalSlotProps: markLabelSlotProps,
        ownerState: ownerState,
        className: classes.markLabel
    });
    const inputSliderProps = (0, $eeee79b1d2d55995$export$2e2bcd8739ae039)({
        elementType: InputSlot,
        getSlotProps: getHiddenInputProps,
        externalSlotProps: inputSlotProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $2PPWI.jsxs)(RootSlot, (0, $zgVxD.default)({}, rootProps, {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)(RailSlot, (0, $zgVxD.default)({}, railProps)),
            /*#__PURE__*/ (0, $2PPWI.jsx)(TrackSlot, (0, $zgVxD.default)({}, trackProps)),
            marks.filter((mark)=>mark.value >= min && mark.value <= max).map((mark, index)=>{
                const percent = (0, $e3d9fdb952181cf8$export$83ce4bc8280540e6)(mark.value, min, max);
                const style = axisProps[axis].offset(percent);
                let markActive;
                if (track === false) markActive = values.indexOf(mark.value) !== -1;
                else markActive = track === 'normal' && (range ? mark.value >= values[0] && mark.value <= values[values.length - 1] : mark.value <= values[0]) || track === 'inverted' && (range ? mark.value <= values[0] || mark.value >= values[values.length - 1] : mark.value >= values[0]);
                return /*#__PURE__*/ (0, $2PPWI.jsxs)($8FY87.Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsx)(MarkSlot, (0, $zgVxD.default)({
                            "data-index": index
                        }, markProps, !(0, $31cee6df5efff63b$export$2e2bcd8739ae039)(MarkSlot) && {
                            markActive: markActive
                        }, {
                            style: (0, $zgVxD.default)({}, style, markProps.style),
                            className: (0, $efJYy.default)(markProps.className, markActive && classes.markActive)
                        })),
                        mark.label != null ? /*#__PURE__*/ (0, $2PPWI.jsx)(MarkLabelSlot, (0, $zgVxD.default)({
                            "aria-hidden": true,
                            "data-index": index
                        }, markLabelProps, !(0, $31cee6df5efff63b$export$2e2bcd8739ae039)(MarkLabelSlot) && {
                            markLabelActive: markActive
                        }, {
                            style: (0, $zgVxD.default)({}, style, markLabelProps.style),
                            className: (0, $efJYy.default)(classes.markLabel, markLabelProps.className, markActive && classes.markLabelActive),
                            children: mark.label
                        })) : null
                    ]
                }, index);
            }),
            values.map((value, index)=>{
                const percent = (0, $e3d9fdb952181cf8$export$83ce4bc8280540e6)(value, min, max);
                const style = axisProps[axis].offset(percent);
                const ValueLabelComponent = valueLabelDisplay === 'off' ? $775c1ad6bc2a67fe$var$Forward : ValueLabelSlot;
                return /*#__PURE__*/ /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */ (0, $2PPWI.jsx)(ValueLabelComponent, (0, $zgVxD.default)({}, !(0, $31cee6df5efff63b$export$2e2bcd8739ae039)(ValueLabelComponent) && {
                    valueLabelFormat: valueLabelFormat,
                    valueLabelDisplay: valueLabelDisplay,
                    value: typeof valueLabelFormat === 'function' ? valueLabelFormat(scale(value), index) : valueLabelFormat,
                    index: index,
                    open: open === index || active === index || valueLabelDisplay === 'on',
                    disabled: disabled
                }, valueLabelProps, {
                    children: /*#__PURE__*/ (0, $2PPWI.jsx)(ThumbSlot, (0, $zgVxD.default)({
                        "data-index": index
                    }, thumbProps, {
                        className: (0, $efJYy.default)(classes.thumb, thumbProps.className, active === index && classes.active, focusedThumbIndex === index && classes.focusVisible),
                        style: (0, $zgVxD.default)({}, style, getThumbStyle(index), thumbProps.style),
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)(InputSlot, (0, $zgVxD.default)({
                            "data-index": index,
                            "aria-label": getAriaLabel ? getAriaLabel(index) : ariaLabel,
                            "aria-valuenow": scale(value),
                            "aria-labelledby": ariaLabelledby,
                            "aria-valuetext": getAriaValueText ? getAriaValueText(scale(value), index) : ariaValuetext,
                            value: values[index]
                        }, inputSliderProps))
                    }))
                }), index);
            })
        ]
    }));
});
var $775c1ad6bc2a67fe$export$2e2bcd8739ae039 = $775c1ad6bc2a67fe$var$Slider;




const $8f82af74f18f1c5f$var$createImage = (url)=>new Promise((resolve, reject)=>{
        const image = new Image();
        image.addEventListener("load", ()=>resolve(image));
        image.addEventListener("error", (error)=>reject(error));
        image.setAttribute("crossOrigin", "anonymous"); // needed to avoid cross-origin issues on CodeSandbox
        // Optionally append cache-busting param to avoid weird caching issues
        image.src = url + (url.includes("?") ? "&" : "?") + "t=" + Date.now();
    });
function $8f82af74f18f1c5f$var$getRadianAngle(degreeValue) {
    return degreeValue * Math.PI / 180;
}
async function $8f82af74f18f1c5f$export$2e2bcd8739ae039(imageSrc, pixelCrop, rotation = 0, horizontal, vertical, contentType) {
    const image = await $8f82af74f18f1c5f$var$createImage(imageSrc);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const radians = $8f82af74f18f1c5f$var$getRadianAngle(rotation);
    let flip = {
        horizontal: horizontal,
        vertical: vertical
    };
    // console.log(
    //   "inputParam",
    //   imageSrc,
    //   pixelCrop,
    //   rotation,
    //   horizontal,
    //   vertical,
    //   contentType
    // );
    // Calculate bounding box of the rotated image
    const rotatedWidth = Math.abs(image.width * Math.cos(radians)) + Math.abs(image.height * Math.sin(radians));
    const rotatedHeight = Math.abs(image.width * Math.sin(radians)) + Math.abs(image.height * Math.cos(radians));
    // Set canvas dimensions to rotated image dimensions
    canvas.width = rotatedWidth;
    canvas.height = rotatedHeight;
    // Apply flip transformations
    ctx.translate(rotatedWidth / 2, rotatedHeight / 2);
    ctx.scale(flip.horizontal ? -1 : 1, flip.vertical ? -1 : 1);
    // Rotate the image around its center
    ctx.rotate(radians);
    ctx.translate(-image.width / 2, -image.height / 2);
    // Draw the transformed image
    ctx.drawImage(image, 0, 0);
    // Create a second canvas to draw the cropped portion
    const croppedCanvas = document.createElement("canvas");
    const croppedCtx = croppedCanvas.getContext("2d");
    // Set dimensions of cropped canvas
    croppedCanvas.width = pixelCrop.width;
    croppedCanvas.height = pixelCrop.height;
    // Draw the cropped area from the rotated and flipped image
    croppedCtx.drawImage(canvas, pixelCrop.x, pixelCrop.y, pixelCrop.width, pixelCrop.height, 0, 0, pixelCrop.width, pixelCrop.height // draw the cropped area to fit the canvas height
    );
    // Extract the file type from the original image source
    //  const fileType = imageSrc.substring(imageSrc.lastIndexOf('.') + 1).toLowerCase();
    let _contentType = contentType;
    //  console.log('fileType: ' + fileType);
    if (_contentType === "image/gif") _contentType = "image/jpeg";
    // setFileType(contentType);
    // console.log('contentType: ' + contentType);
    // Convert cropped canvas to a Blob
    return new Promise((resolve)=>{
        croppedCanvas.toBlob((file)=>{
            resolve(file);
        }, _contentType, 0.80);
    });
}



var $3793a8246b840693$exports = {};
"use strict";
"use client";

var $bcBLN = parcelRequire("bcBLN");
Object.defineProperty($3793a8246b840693$exports, "__esModule", {
    value: true
});
$3793a8246b840693$exports.default = void 0;

var $3793a8246b840693$var$_createSvgIcon = $bcBLN((parcelRequire("485sq")));

var $2PPWI = parcelRequire("2PPWI");
var $3793a8246b840693$var$_default = $3793a8246b840693$exports.default = (0, $3793a8246b840693$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2PPWI.jsx)("path", {
    d: "M14 12c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2m-2-9c-4.97 0-9 4.03-9 9H0l4 4 4-4H5c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.51 0-2.91-.49-4.06-1.3l-1.42 1.44C8.04 20.3 9.94 21 12 21c4.97 0 9-4.03 9-9s-4.03-9-9-9"
}), 'SettingsBackupRestoreSharp');






const $09679f766f58730f$var$ImageCropper = ({ imageSrc: imageSrc, imageName: imageName, onClose: onClose, onSave: onSave })=>{
    const [isLoading, setIsLoading] = (0, $8FY87.useState)(false);
    const [isImageLoading, setIsImageLoading] = (0, $8FY87.useState)(true);
    const [contentType, setContentType] = (0, $8FY87.useState)("");
    const [crop, setCrop] = (0, $8FY87.useState)({
        x: 0,
        y: 0
    });
    const [zoom, setZoom] = (0, $8FY87.useState)(1);
    const [imageDimensions, setImageDimensions] = (0, $8FY87.useState)({
        width: 0,
        height: 0
    });
    const [rotation, setRotation] = (0, $8FY87.useState)(0);
    const [aspectRatio, setAspectRatio] = (0, $8FY87.useState)(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = (0, $8FY87.useState)(null);
    const [flipHorizontal, setFlipHorizontal] = (0, $8FY87.useState)(false);
    const [flipVertical, setFlipVertical] = (0, $8FY87.useState)(false);
    const onCropComplete = (0, $8FY87.useCallback)((croppedArea, croppedAreaPixels)=>{
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useEffect(()=>{
        // Load the image and get its dimensions
        if (imageSrc) {
            const img = new Image();
            img.src = imageSrc;
            img.onload = ()=>{
                const width = img.width;
                const height = img.height;
                setImageDimensions({
                    width: width,
                    height: height
                });
                // Match image ratio to the closest predefined aspect ratio option
                const imageRatio = width / height;
                const predefinedRatios = [
                    1,
                    4 / 3,
                    1.5,
                    16 / 9,
                    5 / 4,
                    2,
                    1.6
                ];
                const closestRatio = predefinedRatios.reduce((prev, curr)=>Math.abs(curr - imageRatio) < Math.abs(prev - imageRatio) ? curr : prev);
                setAspectRatio(closestRatio);
                setIsImageLoading(false);
            };
        }
    }, [
        imageSrc
    ]);
    const showCroppedImage = (0, $8FY87.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            const croppedImage = await (0, $8f82af74f18f1c5f$export$2e2bcd8739ae039)(imageSrc, croppedAreaPixels, rotation, flipHorizontal, flipVertical, contentType);
            onSave(croppedImage);
        } catch (e) {
            console.error(e);
        } finally{
            setIsLoading(false);
        }
    }, [
        croppedAreaPixels,
        rotation,
        flipHorizontal,
        flipVertical
    ]);
    const handleFlipHorizontal = ()=>{
        setFlipHorizontal(!flipHorizontal);
    };
    const handleFlipVertical = ()=>{
        setFlipVertical(!flipVertical);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex flex-col h-full "
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $56dcde36b8493878$export$2e2bcd8739ae039), {
        sx: {
            color: "#fff",
            display: "flex",
            flexDirection: "column",
            zIndex: (theme)=>theme.zIndex.drawer + 1
        },
        open: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $b391f94ee7b6de9b$export$2e2bcd8739ae039), {
        color: "inherit"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
        className: "text-catelina-blue text-sm font-medium"
    }, imageName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex flex-col md:flex-row w-full h-full"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        id: "image-cropper-v2",
        className: "relative w-full md:w-9/12 h-48 md:h-full bg-gray-200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $a093c7b44363048a$export$2e2bcd8739ae039), {
        image: imageSrc,
        crop: crop,
        zoom: zoom,
        rotation: rotation,
        aspect: aspectRatio,
        onCropChange: setCrop,
        onZoomChange: setZoom,
        onCropComplete: onCropComplete,
        transform: `translate(${crop.x}px, ${crop.y}px) rotate(${rotation}deg) scale(${zoom}) scaleX(${flipHorizontal ? -1 : 1}) scaleY(${flipVertical ? -1 : 1})`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `w-full md:w-3/12 md:mx-2 bg-[#FAFAFA] px-2 border rounded-lg border-dashed border-light-purple text-base text-catelina-blue flex flex-col overflow-auto pb-4 md:mt-0 md:mb-0 mt-4 mb-4`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
        className: "font-semibold text-sm text-catelina-blue mb-4"
    }, "Image Editing Options"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "w-full flex flex-col sm:flex-row mb-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "w-full flex flex-col"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        className: "block text-sm font-medium text-catelina-blue"
    }, "Crop ratio"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("select", {
        id: "aspect-ratio",
        className: "block w-full p-1 text-xsm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
        value: aspectRatio,
        onChange: (event)=>{
            setAspectRatio(parseFloat(event.target.value));
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("option", {
        value: 1
    }, "1:1"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("option", {
        value: 4 / 3
    }, "4:3"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("option", {
        value: 1.5
    }, "3:2"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("option", {
        value: 16 / 9
    }, "16:9"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("option", {
        value: 5 / 4
    }, "5:4"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("option", {
        value: 2
    }, "2:1"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("option", {
        value: 1.6
    }, "16:10")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "w-full flex flex-col mb-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        className: "block text-sm font-medium text-catelina-blue"
    }, "Rotate & Flip"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex flex-row justify-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("img", {
        src: (parcelRequire("j3cWe")),
        className: "hover:cursor-pointer hover:shadow-xl",
        onClick: ()=>{
            setRotation(rotation + 90);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", null, "|"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("img", {
        src: (parcelRequire("4RWRe")),
        className: "hover:cursor-pointer hover:shadow-xl",
        onClick: ()=>{
            setRotation(rotation - 90);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", null, "|"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("img", {
        src: (parcelRequire("4INSM")),
        className: "hover:cursor-pointer hover:shadow-xl",
        onClick: handleFlipHorizontal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", null, "|"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("img", {
        src: (parcelRequire("hKl5P")),
        className: "hover:cursor-pointer hover:shadow-xl",
        onClick: handleFlipVertical
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "mt-2 w-full px-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
        className: "font-medium text-sm"
    }, "Zoom"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $775c1ad6bc2a67fe$export$2e2bcd8739ae039), {
        value: zoom,
        min: 1,
        max: 3,
        step: 0.1,
        "aria-labelledby": "Zoom",
        onChange: (e, zoom)=>setZoom(zoom),
        style: {
            '& .MuiSlider-thumb': {
                transform: 'translate(-50%, -50%)'
            }
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex flex-col"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        className: "py-1 mt-6",
        component: "label",
        size: "small",
        variant: "contained",
        tabIndex: -1,
        disabled: isImageLoading,
        sx: {
            textTransform: "none",
            fontSize: 14,
            paddingRight: 4,
            paddingLeft: 4
        },
        // startIcon={<EditNoteOutlinedIcon />}
        onClick: showCroppedImage
    }, "Save"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        className: "py-1 mt-2",
        component: "label",
        size: "small",
        // color="error"
        variant: "outlined",
        tabIndex: -1,
        sx: {
            textTransform: "none",
            fontSize: 14,
            paddingRight: 0,
            paddingLeft: 0
        },
        startIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3793a8246b840693$exports))), null),
        onClick: ()=>{
            setZoom(1);
            setRotation(0);
            setAspectRatio(1);
            setFlipHorizontal(false);
            setFlipVertical(false);
        }
    }, "Revert to orignal")))));
};
var $09679f766f58730f$export$2e2bcd8739ae039 = $09679f766f58730f$var$ImageCropper;


const $4a7775f76d2692f7$var$ImageUploader = (props)=>{
    const [isLoading, setIsLoading] = (0, $8FY87.useState)(false);
    const [showConfirmation, setShowConfirmation] = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useState(false);
    const [showEdit, setShowEdit] = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useState(false);
    const [data, setData] = (0, $8FY87.useState)([]);
    const [subsData, setSubsData] = (0, $8FY87.useState)();
    const [selected, setSelected] = (0, $8FY87.useState)();
    const [totalSize, setTotalSize] = (0, $8FY87.useState)();
    const [currentPageImage, setCurrentPageImage] = (0, $8FY87.useState)();
    // const [imageRefs, setImageRefs] = useState<any>([]);
    const [tab, setTab] = (0, $8FY87.useState)("upload");
    const [cookies] = (0, $1f373de1ceea6eb7$export$2e2bcd8739ae039)([
        "rp_user_id"
    ]);
    const onDrop = (0, $8FY87.useCallback)(async (acceptedFiles)=>{
        // Handle the files
        const fileNames = Array.from(acceptedFiles).map((file)=>file.name);
        const contentTypes = Array.from(acceptedFiles).map((file)=>file.type);
        const fileSizes = Array.from(acceptedFiles).map((file)=>file.size);
        if (contentTypes.length === 0) // console.log('file types', contentTypes)
        return;
        const response = await (0, $bf5b93105d90423b$export$2e2bcd8739ae039).get(`${"https://api.rocketpages.io"}/${"upload/image"?.replace("/image", "/signed-url")}`, {
            params: {
                fileNames: fileNames,
                contentTypes: contentTypes,
                fileSizes: fileSizes,
                siteId: props.siteId
            }
        });
        const signedUrls = response.data;
        // console.log("signedUrls", signedUrls);
        setData((old)=>{
            let _old = [
                ...old
            ];
            signedUrls.map((rr)=>{
                _old.unshift({
                    ...rr,
                    isUploading: true,
                    ref: [],
                    refCount: 0,
                    created_at: Date.now()
                });
            });
            setSelected(_old[0]);
            // reCalculate(_old);
            return _old;
        });
        setTab("library");
        // Upload each file to S3 using the signed URLs
        signedUrls.map((signedUrl, index)=>{
            let _sizeInMegabytes = signedUrl.size / 1024 / 1024;
            // console.log("Uploading size", _sizeInMegabytes)
            let image_name = signedUrl.imageName;
            // Regex to check for special characters except - _ .
            let specialCharRegex = /[^a-zA-Z0-9._-]/;
            if (specialCharRegex.test(image_name)) {
                setData((old)=>{
                    let _old = [
                        ...old
                    ];
                    let idx = _old.findIndex((oo)=>oo.id === signedUrl.id);
                    _old[idx].isUploading = false;
                    _old[idx].hasError = true;
                    _old[idx].errorTitle = `Upload Upload Failed!`;
                    _old[idx].errorDescription = `Image name has special chars.`;
                    _old[idx].thumbnailUrl = ``;
                    return _old;
                });
                return;
            }
            if (_sizeInMegabytes > 200) {
                setData((old)=>{
                    let _old = [
                        ...old
                    ];
                    let idx = _old.findIndex((oo)=>oo.id === signedUrl.id);
                    _old[idx].isUploading = false;
                    _old[idx].hasError = true;
                    _old[idx].errorTitle = `Upload Size limit!`;
                    _old[idx].errorDescription = `Maximum upload limit is 200 MB.`;
                    _old[idx].thumbnailUrl = ``;
                    return _old;
                });
                return;
            }
            let _totalSize = totalSize + signedUrl.size;
            let _totalSizeLimit = 0;
            if (subsData?.storage?.indexOf("GB") >= 0) {
                let _ttt = subsData.storage.split("GB");
                _totalSizeLimit = _ttt[0] * 1073741824;
            } else if (subsData?.storage?.indexOf("MB") >= 0) {
                let _ttt = subsData.storage.split("MB");
                _totalSizeLimit = _ttt[0] * 1048576;
            }
            if (_totalSizeLimit < _totalSize) {
                setData((old)=>{
                    let _old = [
                        ...old
                    ];
                    let idx = _old.findIndex((oo)=>oo.id === signedUrl.id);
                    _old[idx].isUploading = false;
                    _old[idx].hasError = true;
                    _old[idx].errorTitle = `Storage alert!`;
                    _old[idx].errorDescription = `Upload limit reached. Please consider upgrading your plan.`;
                    _old[idx].thumbnailUrl = ``;
                    return _old;
                });
                console.log(`Uploading`, _totalSize, _totalSizeLimit);
                return;
            }
            (0, $bf5b93105d90423b$export$2e2bcd8739ae039).put(signedUrl.uploadURL, acceptedFiles[index], {
                headers: {
                    "Content-Type": acceptedFiles[index].type
                }
            }).then(async (res)=>{
                try {
                    delete signedUrl["uploadURL"];
                    await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post(`/api/assets/add-site-assets`, {
                        userId: cookies.rp_user_id,
                        thumbnailsize: props.thumbnailsize,
                        data: [
                            signedUrl
                        ]
                    });
                } catch (err) {
                    console.log("after upload", err);
                }
                setData((old)=>{
                    let _old = [
                        ...old
                    ];
                    let idx = _old.findIndex((oo)=>oo.id === signedUrl.id);
                    _old[idx].isUploading = false;
                    _old[idx].thumbnailUrl = `${_old[idx].imageUrl}_thumbnail`;
                    reCalculate(_old);
                    return _old;
                });
            }).catch((err)=>{});
        });
    }, []);
    const { getRootProps: getRootProps, getInputProps: getInputProps, isDragActive: isDragActive } = (0, $3b007977aa081624$export$cd49c0ecc5be9f36)({
        onDrop: onDrop,
        accept: {
            "image/png": [],
            "image/jpeg": [],
            "image/jpg": [],
            "image/svg+xml": [],
            "image/webp": [],
            "image/gif": []
        }
    });
    const loadGalleryImages = async ()=>{
        try {
            setIsLoading(true);
            let response = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).get(`/api/assets/site-assets?siteId=${props.siteId}&userId=${cookies.rp_user_id}`);
            let _data = response.data;
            // let _data = imageData; //|| response.data
            // setSelected(_data.data[4]);
            // setShowEdit(true);
            reCalculate(_data.data);
            setData(_data.data);
            setSubsData({
                ..._data.subsDetails
            });
            let data = [];
            _data.data.map((image)=>{
                let _imagesRef = [];
                deepScanFindImageRef(_data.site.header, image.imageUrl, "header~header~Site Header", _imagesRef);
                deepScanFindImageRef(_data.site.footer, image.imageUrl, "footer~footer~Site Footer", _imagesRef);
                for(let iii = 0; iii < _data.pages.length; iii++)if (_data.pages[iii].pageId !== props.pageId) deepScanFindImageRef(_data.pages[iii].configs, image.imageUrl, `page~${_data.pages[iii].pageId}~${_data.pages[iii].pageName}`, _imagesRef);
                let jjj = 0;
                _imagesRef.forEach((lklk)=>jjj += lklk.count);
                data.push({
                    ...image,
                    ref: _imagesRef,
                    refCount: jjj
                });
            });
            // setImageRefs(_imagesRef)
            // console.log("sssss", data);
            setData(data);
        // setIsLoading(false);
        } catch (err) {
            console.error("loadGalleryImages", err);
        } finally{
            setIsLoading(false);
        }
    };
    const reCalculate = (data)=>{
        let _sum = 0;
        let _count = 0;
        data.forEach((rr)=>{
            _sum += rr.size;
            _count += 1;
        });
        setTotalSize(_sum);
    };
    function deepScanFindImageRef(element, imageUrl, type, _items) {
        if (Array.isArray(element)) // console.log("Array found:", element);
        for(let i = 0; i < element.length; i++)deepScanFindImageRef(element[i], imageUrl, type, _items);
        else if (typeof element === "object" && element !== null) {
            // console.log("Object found:", element);
            if (element.i && element.i.id === imageUrl) {
                let _ttt = type.split("~");
                let _index = _items.findIndex((kk)=>kk.imageUrl === imageUrl && kk.type === _ttt[0] && kk.name === _ttt[2]);
                if (_index !== -1) _items[_index].count += 1;
                else _items.push({
                    imageUrl: imageUrl,
                    type: _ttt[0],
                    id: _ttt[1],
                    name: _ttt[2],
                    count: 1
                });
            // element.i.id = newImageUrl;
            }
            for(let key in element)if (element.hasOwnProperty(key)) deepScanFindImageRef(element[key], imageUrl, type, _items);
        }
    }
    (0, $8FY87.useEffect)(()=>{
        inIframe();
        loadGalleryImages();
    }, []);
    (0, $8FY87.useEffect)(()=>{
        if (selected) {
            // Function to handle the message event
            const handleMessage = (event)=>{
                if (event.data.type === "imageCount") {
                    if (event.data.count > 0 && event.data.count !== undefined && event.data.count !== "") setCurrentPageImage({
                        id: event.data.id,
                        ref: "Current page",
                        refCount: event.data.count
                    });
                    else setCurrentPageImage({
                        id: ""
                    }); // Reset if no valid count
                }
            };
            // Post the message to the parent window
            parent.postMessage({
                msgType: "uploader:getCount",
                imgUrl: selected.imageUrl,
                id: selected.id
            }, "*");
            // Add the event listener
            window.addEventListener("message", handleMessage);
            // Cleanup function to remove the event listener
            return ()=>{
                window.removeEventListener("message", handleMessage);
            };
        }
    }, [
        selected
    ]);
    const formatSize = (sizeInBytes)=>{
        if (sizeInBytes < 1024) return `${sizeInBytes} Bytes`;
        else if (sizeInBytes < 1048576) return `${(sizeInBytes / 1024).toFixed(2)} KB`;
        else if (sizeInBytes < 1073741824) return `${(sizeInBytes / 1048576).toFixed(2)} MB`;
        else return `${(sizeInBytes / 1073741824).toFixed(2)} GB`;
    };
    const handleImageDelete = async ()=>{
        setShowConfirmation(false);
        setIsLoading(true);
        try {
            console.log("delete", selected);
            let data = {
                id: selected.id
            };
            if (selected.key) data["key"] = selected.key;
            else data["key"] = `${selected.id}-${selected.imageName}`;
            data["userId"] = cookies.rp_user_id;
            let response = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post(`/api/assets/delete-site-asset`, data);
            // console.log("res", response);
            if (response.status === 200) {
                setData((old)=>{
                    let _old = [
                        ...old.filter((oo)=>oo.id !== selected.id)
                    ];
                    reCalculate(_old);
                    return _old;
                });
                setSelected(null);
            // loadGalleryImages();
            }
        } catch (err) {
            console.log(err);
        } finally{
            setIsLoading(false);
        }
    };
    const [isIniFrame, setIsInIFrame] = (0, $8FY87.useState)();
    function inIframe() {
        try {
            setIsInIFrame(window.self !== window.top);
        // return window.self !== window.top;
        } catch (e) {
            setIsInIFrame(true);
        // return true;
        }
    }
    const onClose = ()=>{
        // console.log("onClose", isIniFrame);
        if (isIniFrame && !props.isBlog) {
            parent.postMessage({
                msgType: "uploader:close"
            }, "*");
            return;
        } else props.onClose && props.onClose();
    };
    const onSelect = ()=>{
        // console.log("onSelect", isIniFrame);
        var image_upload_popup = checkIfButtonIsInIframe();
        if (isIniFrame && !props.isBlog && image_upload_popup === true) {
            parent.postMessage({
                msgType: "uploader:select",
                imgUrl: selected.imageUrl,
                siteId: props.siteId,
                eid: props.eid
            }, "*");
            return;
        } else {
            props.onSelect && props.onSelect(selected.imageUrl);
            props.onChange && props.onChange(selected.imageUrl);
        }
    };
    function checkIfButtonIsInIframe() {
        return window.self.location.href.includes("image-uploder");
    }
    const showHistory = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", null, selected.ref && selected.ref.map((rr, idx)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
                key: rr.id,
                className: "flex flex-row justify-between leading-relaxed "
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", null, rr.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
                className: "pr-2"
            }, `(${rr.count})`));
        }), currentPageImage && currentPageImage.id !== "" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
            key: currentPageImage.id,
            className: "flex flex-row justify-between leading-relaxed"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", null, "Current Page"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
            className: "pr-2"
        }, `(${currentPageImage.refCount})`)));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "h-full flex flex-col justify-between bg-white shadow-lg px-2 pt-2 pb-6 font-body image-upload"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $56dcde36b8493878$export$2e2bcd8739ae039), {
        sx: {
            color: "#fff",
            display: "flex",
            flexDirection: "column",
            zIndex: (theme)=>theme.zIndex.drawer + 1
        },
        open: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $b391f94ee7b6de9b$export$2e2bcd8739ae039), {
        color: "inherit"
    })), showConfirmation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "fixed inset-0 overflow-y-auto flex justify-center items-center z-10"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "fixed inset-0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "absolute inset-0 bg-gray-500 opacity-75"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "bg-white rounded p-8 max-w-md w-11/12 md:w-full mx-auto z-50"
    }, (selected.ref && selected.ref.length > 0 || currentPageImage && currentPageImage.id !== "") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "text-gray-800 mb-4 text-sm"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", {
        className: "mb-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("strong", null, "Images used on the following pages: ")), showHistory()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", {
        className: "text-gray-800 mb-4"
    }, "Are you sure you want to delete this image?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex justify-end flex-col sm:flex-row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("button", {
        className: "bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded mr-2 focus:outline-none focus:shadow-outline w-full sm:w-auto mb-2.5 sm:mb-0",
        onClick: ()=>setShowConfirmation(false)
    }, "Cancel"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("button", {
        className: "bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline",
        onClick: handleImageDelete
    }, "Delete")))), selected && showEdit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex flex-col flex-1 justify-center h-full"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "text-sm font-medium text-center text-gray-500  border-gray-200 dark:text-gray-400 dark:border-gray-700"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex flex-wrap -mb-px md:mt-0 mt-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
        className: `hover:cursor-pointer text-catelina-blue text-sm`,
        onClick: ()=>setShowEdit(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($33d3aaa52a311a31$exports))), {
        sx: {
            fontSize: 18
        }
    }), "Back"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex flex-row justify-between flex-1 items-center relative"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
        className: "absolute flex flex-row justify-between top-0 right-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $8765ef9b64e3c3e6$export$2e2bcd8739ae039), {
        size: "small",
        "aria-label": "close",
        onClick: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($138013025876eded$exports))), {
        fontSize: "inherit"
    })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $09679f766f58730f$export$2e2bcd8739ae039), {
        imageSrc: selected.imageUrl,
        imageName: selected.imageName,
        onClose: ()=>{
            setShowEdit(false);
        },
        onSave: (img)=>{
            setShowEdit(false);
            const originalName = selected.imageName;
            const extension = originalName.substring(originalName.lastIndexOf('.'));
            const baseName = originalName.substring(0, originalName.lastIndexOf('.'));
            const file = new File([
                img
            ], `${baseName}-${Date.now()}${extension}`, {
                type: img.type
            });
            onDrop([
                file
            ]);
        }
    })), !showEdit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `flex flex-col mb-2`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "text-sm font-medium text-center text-gray-500  border-gray-200 dark:text-gray-400 dark:border-gray-700"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex flex-wrap -mb-px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
        className: `inline-block px-4 py-1 ${tab === "upload" ? "text-catelina-blue border-b-2 border-catelina-blue active rounded-t-lg  dark:text-catelina-blue dark:border-catelina-blue" : "border-b-2 border-gray-300 rounded-t-lg hover:text-gray-600 hover:border-gray-400 dark:hover:text-gray-300"}  hover:cursor-pointer`,
        onClick: ()=>setTab("upload")
    }, "Upload files"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
        className: `inline-block px-4 py-1 ${tab === "library" ? "text-catelina-blue border-b-2 border-catelina-blue active rounded-t-lg  dark:text-catelina-blue dark:border-catelina-blue" : "border-b-2 border-gray-300 rounded-t-lg hover:text-gray-600 hover:border-gray-400 dark:hover:text-gray-300"} hover:cursor-pointer`,
        onClick: ()=>setTab("library")
    }, "Media library"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex flex-row justify-between flex-1 items-center relative"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
        className: "absolute flex flex-row justify-between top-2 right-2"
    }, !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
        className: "px-4 text-xxsm font-semibold text-catelina-blue hidden sm:block"
    }, formatSize(totalSize), " /", " ", subsData?.storage?.replace("GB", " GB")?.replace("MB", " MB"), props.thumbnailsize ? `Thumbnail size: ${props.thumbnailsize} px` : ""), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $8765ef9b64e3c3e6$export$2e2bcd8739ae039), {
        size: "small",
        "aria-label": "close",
        onClick: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($138013025876eded$exports))), {
        fontSize: "inherit"
    }))))))), !showEdit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex flex-col flex-1 h-[calc(100%-32px)] image-library"
    }, tab === "library" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).Fragment, null, data && data.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex flex-row justify-center relative md:h-full h-[calc(100%-40px)]"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "w-full"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "w-full overflow-auto h-full "
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "grid grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-2 mb-4 p-2"
    }, data && data.map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
            key: _.id,
            className: `w-full relative max-h-36 lg:max-h-24 bg-gray-200 hover:cursor-pointer border ${selected && _.id === selected.id ? "ring-offset-2 ring-4 ring-catelina-blue" : ""} `,
            onClick: ()=>{
                // console.log("selected", _);
                setSelected(_);
            }
        }, _.isUploading && _.isUploading === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $b19176bd78e1869f$export$2e2bcd8739ae039), {
            sx: {
                display: "flex",
                padding: "16px",
                justifyContent: "center"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $b391f94ee7b6de9b$export$2e2bcd8739ae039), null)) : // <img
        //   src={_.imageUrl}
        //   alt={_.imageName}
        //   className="inset-0 w-full h-full object-cover"
        // />
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $de2f67ab7018af66$exports.LazyLoadImage), {
            src: _.thumbnailUrl || _.imageUrl,
            alt: _.imageName,
            // effect="blur"
            wrapperProps: {
                // If you need to, you can tweak the effect transition using the wrapper style.
                style: {
                    transitionDelay: "1s"
                }
            },
            className: "inset-0 w-full h-full object-cover"
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex md:hidden flex-col mx-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        className: "w-full my-2",
        component: "label",
        size: "small",
        disabled: !selected || selected.isUploading || selected.hasError,
        role: undefined,
        variant: "contained",
        onClick: onSelect,
        tabIndex: -1,
        sx: {
            textTransform: "none",
            paddingRight: 4,
            paddingLeft: 4
        }
    }, "Use media"))), selected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex flex-col justify-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `w-48 h-[90%] md:h-[100%] md:mx-2 bg-[#FAFAFA] px-2 border border-light-purple rounded-lg border-dashed absolute inset-y-0 left-0 top-0 md:static md:w-64 transform transition-transform duration-300 ease-in-out text-base text-catelina-blue flex flex-col overflow-auto md:shadow-none shadow-lg shadow-gray-300`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
        className: "absolute flex flex-row justify-between top-0 right-2 md:hidden"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $8765ef9b64e3c3e6$export$2e2bcd8739ae039), {
        size: "small",
        "aria-label": "close",
        onClick: ()=>setSelected(null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($138013025876eded$exports))), {
        fontSize: "inherit"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
        className: "font-bold text-xsm text-catelina-blue"
    }, "Media details"), selected.hasError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex items-center p-4 mb-4 text-sm text-red-800 border border-red-300 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400 dark:border-red-800",
        role: "alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("svg", {
        className: "flex-shrink-0 inline w-4 h-4 me-3",
        "aria-hidden": "true",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        viewBox: "0 0 20 20"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("path", {
        d: "M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
        className: "sr-only"
    }, "Info"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
        className: "font-medium"
    }, selected.errorTitle, " "), selected.errorDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "border-2 max-h-48 w-full bg-grey-300 flex justify-center blank-image-bg"
    }, selected.isUploading && selected.isUploading === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $b19176bd78e1869f$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            padding: "16px",
            justifyContent: "center"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $b391f94ee7b6de9b$export$2e2bcd8739ae039), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $de2f67ab7018af66$exports.LazyLoadImage), {
        src: selected.thumbnailUrl || selected.imageUrl,
        alt: selected.imageName,
        className: "inset-0  object-cover max-h-40",
        // effect="blur"
        wrapperProps: {
            // If you need to, you can tweak the effect transition using the wrapper style.
            style: {
                transitionDelay: "1s"
            }
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
        className: "text-xsm leading-normal md:text-sm pt-2 w-full"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", {
        className: "break-words mb-2"
    }, selected.imageName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
        className: "text-xxsm leading-normal md:text-xsm"
    }, formatSize(selected.size)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
        className: "text-xxsm leading-normal md:text-xsm flex flex-row justify-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", null, (0, (/*@__PURE__*/$parcel$interopDefault($dxgjV)))(selected.created_at).format("MMMM, DD YYYY")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", null, "|"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", null, (0, (/*@__PURE__*/$parcel$interopDefault($dxgjV)))(selected.created_at).format("HH:mm"))), !selected.hasError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "md:mx-4 flex flex-col"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        className: "py-2 mt-6",
        component: "label",
        size: "small",
        variant: "contained",
        tabIndex: -1,
        disabled: selected.isUploading,
        sx: {
            textTransform: "none",
            fontSize: 14,
            paddingRight: 4,
            paddingLeft: 4
        },
        startIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a21539592a8d5049$exports))), null),
        onClick: ()=>{
            setShowEdit(true);
        // console.log(selected);
        }
    }, "Edit image"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        className: "py-2 mt-2",
        component: "label",
        size: "small",
        color: "error",
        variant: "outlined",
        disabled: selected.isUploading,
        tabIndex: -1,
        sx: {
            textTransform: "none",
            fontSize: 14,
            paddingRight: 4,
            paddingLeft: 4
        },
        startIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4c5cf14ed582dae7$exports))), null),
        onClick: ()=>setShowConfirmation(true)
    }, "Delete image")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
        className: "text-xxsm leading-normal md:text-xsm mb-4 mt-2"
    }, selected.refCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
        className: "text-catelina-blue font-bold leading-normal "
    }, "Image history ", "(", selected.refCount, ")", " ") : null, showHistory())), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "md:flex hidden flex-col mx-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        className: "w-full my-2",
        component: "label",
        size: "small",
        disabled: !selected || selected.isUploading || selected.hasError,
        role: undefined,
        variant: "contained",
        onClick: onSelect,
        tabIndex: -1,
        sx: {
            textTransform: "none",
            paddingRight: 4,
            paddingLeft: 4
        }
    }, "Use media")))), !data || data.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex justify-center h-full items-center border rounded-lg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cfd065ce0a260224$exports))), {
        fontSize: "large"
    }))), tab === "upload" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex flex-row justify-center h-full"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        ...getRootProps(),
        className: `flex items-center justify-center w-full h-full border-2 border-dotted border-gray-300 rounded-lg p-4 ${isDragActive ? "bg-gray-100" : "bg-[#FAFAFA]"}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("input", getInputProps()), isDragActive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", {
        className: "text-gray-500"
    }, "Drop the files here ...") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex flex-col items-center  justify-center text-lg text-catelina-blue"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
        className: "font-bold"
    }, "Drag & Drop files"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
        className: "font-bold"
    }, "Or"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        className: "py-2 mt-2 mb-4",
        component: "label",
        size: "small",
        variant: "contained",
        tabIndex: -1,
        sx: {
            textTransform: "none",
            fontSize: 14,
            paddingRight: 4,
            paddingLeft: 4
        }
    }, "Choose a local file"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
        className: "text-xsm"
    }, "Maximum upload file size: 200mb"))))));
};
var $4a7775f76d2692f7$export$2e2bcd8739ae039 = $4a7775f76d2692f7$var$ImageUploader;


const $1d242ce450cfc6aa$var$ImageUploaderPage = ()=>{
    const [searchParams] = (0, $734169eef5d6795a$export$f1a78c17382fe22a)();
    const getQueryParam = (key)=>{
        return searchParams.get(key);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex items-center justify-center min-h-screen bg-slate-400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "w-full h-screen"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $4a7775f76d2692f7$export$2e2bcd8739ae039), {
        siteId: getQueryParam("siteId"),
        eid: getQueryParam("eid"),
        thumbnailsize: getQueryParam("thumbnailsize"),
        pageId: getQueryParam("pageId")
    })));
};
var $1d242ce450cfc6aa$export$2e2bcd8739ae039 = $1d242ce450cfc6aa$var$ImageUploaderPage;



var $8FY87 = parcelRequire("8FY87");






var $8FY87 = parcelRequire("8FY87");
function $e7ed5c4b4f4b44fc$var$useLoadGsiScript(options = {}) {
    const { nonce: nonce, onScriptLoadSuccess: onScriptLoadSuccess, onScriptLoadError: onScriptLoadError } = options;
    const [scriptLoadedSuccessfully, setScriptLoadedSuccessfully] = (0, $8FY87.useState)(false);
    const onScriptLoadSuccessRef = (0, $8FY87.useRef)(onScriptLoadSuccess);
    onScriptLoadSuccessRef.current = onScriptLoadSuccess;
    const onScriptLoadErrorRef = (0, $8FY87.useRef)(onScriptLoadError);
    onScriptLoadErrorRef.current = onScriptLoadError;
    (0, $8FY87.useEffect)(()=>{
        const scriptTag = document.createElement('script');
        scriptTag.src = 'https://accounts.google.com/gsi/client';
        scriptTag.async = true;
        scriptTag.defer = true;
        scriptTag.nonce = nonce;
        scriptTag.onload = ()=>{
            var _a;
            setScriptLoadedSuccessfully(true);
            (_a = onScriptLoadSuccessRef.current) === null || _a === void 0 || _a.call(onScriptLoadSuccessRef);
        };
        scriptTag.onerror = ()=>{
            var _a;
            setScriptLoadedSuccessfully(false);
            (_a = onScriptLoadErrorRef.current) === null || _a === void 0 || _a.call(onScriptLoadErrorRef);
        };
        document.body.appendChild(scriptTag);
        return ()=>{
            document.body.removeChild(scriptTag);
        };
    }, [
        nonce
    ]);
    return scriptLoadedSuccessfully;
}
const $e7ed5c4b4f4b44fc$var$GoogleOAuthContext = (0, $8FY87.createContext)(null);
function $e7ed5c4b4f4b44fc$export$a325976a38f291f5({ clientId: clientId, nonce: nonce, onScriptLoadSuccess: onScriptLoadSuccess, onScriptLoadError: onScriptLoadError, children: children }) {
    const scriptLoadedSuccessfully = $e7ed5c4b4f4b44fc$var$useLoadGsiScript({
        nonce: nonce,
        onScriptLoadSuccess: onScriptLoadSuccess,
        onScriptLoadError: onScriptLoadError
    });
    const contextValue = (0, $8FY87.useMemo)(()=>({
            clientId: clientId,
            scriptLoadedSuccessfully: scriptLoadedSuccessfully
        }), [
        clientId,
        scriptLoadedSuccessfully
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement($e7ed5c4b4f4b44fc$var$GoogleOAuthContext.Provider, {
        value: contextValue
    }, children);
}
function $e7ed5c4b4f4b44fc$var$useGoogleOAuth() {
    const context = (0, $8FY87.useContext)($e7ed5c4b4f4b44fc$var$GoogleOAuthContext);
    if (!context) throw new Error('Google OAuth components must be used within GoogleOAuthProvider');
    return context;
}
function $e7ed5c4b4f4b44fc$var$extractClientId(credentialResponse) {
    var _a;
    const clientId = (_a = credentialResponse === null || credentialResponse === void 0 ? void 0 : credentialResponse.clientId) !== null && _a !== void 0 ? _a : credentialResponse === null || credentialResponse === void 0 ? void 0 : credentialResponse.client_id;
    return clientId;
}
const $e7ed5c4b4f4b44fc$var$containerHeightMap = {
    large: 40,
    medium: 32,
    small: 20
};
function $e7ed5c4b4f4b44fc$export$a795a627e512102a({ onSuccess: onSuccess, onError: onError, useOneTap: useOneTap, promptMomentNotification: promptMomentNotification, type: type = 'standard', theme: theme = 'outline', size: size = 'large', text: text, shape: shape, logo_alignment: logo_alignment, width: width, locale: locale, click_listener: click_listener, containerProps: containerProps, ...props }) {
    const btnContainerRef = (0, $8FY87.useRef)(null);
    const { clientId: clientId, scriptLoadedSuccessfully: scriptLoadedSuccessfully } = $e7ed5c4b4f4b44fc$var$useGoogleOAuth();
    const onSuccessRef = (0, $8FY87.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $8FY87.useRef)(onError);
    onErrorRef.current = onError;
    const promptMomentNotificationRef = (0, $8FY87.useRef)(promptMomentNotification);
    promptMomentNotificationRef.current = promptMomentNotification;
    (0, $8FY87.useEffect)(()=>{
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (!scriptLoadedSuccessfully) return;
        (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 || _c.initialize({
            client_id: clientId,
            callback: (credentialResponse)=>{
                var _a;
                if (!(credentialResponse === null || credentialResponse === void 0 ? void 0 : credentialResponse.credential)) return (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef);
                const { credential: credential, select_by: select_by } = credentialResponse;
                onSuccessRef.current({
                    credential: credential,
                    clientId: $e7ed5c4b4f4b44fc$var$extractClientId(credentialResponse),
                    select_by: select_by
                });
            },
            ...props
        });
        (_f = (_e = (_d = window === null || window === void 0 ? void 0 : window.google) === null || _d === void 0 ? void 0 : _d.accounts) === null || _e === void 0 ? void 0 : _e.id) === null || _f === void 0 || _f.renderButton(btnContainerRef.current, {
            type: type,
            theme: theme,
            size: size,
            text: text,
            shape: shape,
            logo_alignment: logo_alignment,
            width: width,
            locale: locale,
            click_listener: click_listener
        });
        if (useOneTap) (_j = (_h = (_g = window === null || window === void 0 ? void 0 : window.google) === null || _g === void 0 ? void 0 : _g.accounts) === null || _h === void 0 ? void 0 : _h.id) === null || _j === void 0 || _j.prompt(promptMomentNotificationRef.current);
        return ()=>{
            var _a, _b, _c;
            if (useOneTap) (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 || _c.cancel();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        clientId,
        scriptLoadedSuccessfully,
        useOneTap,
        type,
        theme,
        size,
        text,
        shape,
        logo_alignment,
        width,
        locale
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        ...containerProps,
        ref: btnContainerRef,
        style: {
            height: $e7ed5c4b4f4b44fc$var$containerHeightMap[size],
            ...containerProps === null || containerProps === void 0 ? void 0 : containerProps.style
        }
    });
}
function $e7ed5c4b4f4b44fc$export$64c51800d55c1202() {
    var _a, _b, _c;
    (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 || _c.disableAutoSelect();
}
/* eslint-disable import/export */ function $e7ed5c4b4f4b44fc$export$6ca4c5d94f9e170b({ flow: flow = 'implicit', scope: scope = '', onSuccess: onSuccess, onError: onError, onNonOAuthError: onNonOAuthError, overrideScope: overrideScope, state: state, ...props }) {
    const { clientId: clientId, scriptLoadedSuccessfully: scriptLoadedSuccessfully } = $e7ed5c4b4f4b44fc$var$useGoogleOAuth();
    const clientRef = (0, $8FY87.useRef)();
    const onSuccessRef = (0, $8FY87.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $8FY87.useRef)(onError);
    onErrorRef.current = onError;
    const onNonOAuthErrorRef = (0, $8FY87.useRef)(onNonOAuthError);
    onNonOAuthErrorRef.current = onNonOAuthError;
    (0, $8FY87.useEffect)(()=>{
        var _a;
        if (!scriptLoadedSuccessfully) return;
        const clientMethod = flow === 'implicit' ? 'initTokenClient' : 'initCodeClient';
        const client = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts.oauth2[clientMethod]({
            client_id: clientId,
            scope: overrideScope ? scope : `openid profile email ${scope}`,
            callback: (response)=>{
                var _a, _b;
                if (response.error) return (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef, response);
                (_b = onSuccessRef.current) === null || _b === void 0 || _b.call(onSuccessRef, response);
            },
            error_callback: (nonOAuthError)=>{
                var _a;
                (_a = onNonOAuthErrorRef.current) === null || _a === void 0 || _a.call(onNonOAuthErrorRef, nonOAuthError);
            },
            state: state,
            ...props
        });
        clientRef.current = client;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        clientId,
        scriptLoadedSuccessfully,
        flow,
        scope,
        state
    ]);
    const loginImplicitFlow = (0, $8FY87.useCallback)((overrideConfig)=>{
        var _a;
        return (_a = clientRef.current) === null || _a === void 0 ? void 0 : _a.requestAccessToken(overrideConfig);
    }, []);
    const loginAuthCodeFlow = (0, $8FY87.useCallback)(()=>{
        var _a;
        return (_a = clientRef.current) === null || _a === void 0 ? void 0 : _a.requestCode();
    }, []);
    return flow === 'implicit' ? loginImplicitFlow : loginAuthCodeFlow;
}
function $e7ed5c4b4f4b44fc$export$7ab2d3f76b55c251({ onSuccess: onSuccess, onError: onError, promptMomentNotification: promptMomentNotification, cancel_on_tap_outside: cancel_on_tap_outside, prompt_parent_id: prompt_parent_id, state_cookie_domain: state_cookie_domain, hosted_domain: hosted_domain, disabled: disabled }) {
    const { clientId: clientId, scriptLoadedSuccessfully: scriptLoadedSuccessfully } = $e7ed5c4b4f4b44fc$var$useGoogleOAuth();
    const onSuccessRef = (0, $8FY87.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $8FY87.useRef)(onError);
    onErrorRef.current = onError;
    const promptMomentNotificationRef = (0, $8FY87.useRef)(promptMomentNotification);
    promptMomentNotificationRef.current = promptMomentNotification;
    (0, $8FY87.useEffect)(()=>{
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (!scriptLoadedSuccessfully) return;
        if (disabled) {
            (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 || _c.cancel();
            return;
        }
        (_f = (_e = (_d = window === null || window === void 0 ? void 0 : window.google) === null || _d === void 0 ? void 0 : _d.accounts) === null || _e === void 0 ? void 0 : _e.id) === null || _f === void 0 || _f.initialize({
            client_id: clientId,
            callback: (credentialResponse)=>{
                var _a;
                if (!(credentialResponse === null || credentialResponse === void 0 ? void 0 : credentialResponse.credential)) return (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef);
                const { credential: credential, select_by: select_by } = credentialResponse;
                onSuccessRef.current({
                    credential: credential,
                    clientId: $e7ed5c4b4f4b44fc$var$extractClientId(credentialResponse),
                    select_by: select_by
                });
            },
            hosted_domain: hosted_domain,
            cancel_on_tap_outside: cancel_on_tap_outside,
            prompt_parent_id: prompt_parent_id,
            state_cookie_domain: state_cookie_domain
        });
        (_j = (_h = (_g = window === null || window === void 0 ? void 0 : window.google) === null || _g === void 0 ? void 0 : _g.accounts) === null || _h === void 0 ? void 0 : _h.id) === null || _j === void 0 || _j.prompt(promptMomentNotificationRef.current);
        return ()=>{
            var _a, _b, _c;
            (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 || _c.cancel();
        };
    }, [
        clientId,
        scriptLoadedSuccessfully,
        cancel_on_tap_outside,
        prompt_parent_id,
        state_cookie_domain,
        hosted_domain,
        disabled
    ]);
}
/**
 * Checks if the user granted all the specified scope or scopes
 * @returns True if all the scopes are granted
 */ function $e7ed5c4b4f4b44fc$export$dfe7cd07eac17bc5(tokenResponse, firstScope, ...restScopes) {
    var _a, _b, _c;
    if (!(window === null || window === void 0 ? void 0 : window.google)) return false;
    return ((_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.oauth2) === null || _c === void 0 ? void 0 : _c.hasGrantedAllScopes(tokenResponse, firstScope, ...restScopes)) || false;
}
/**
 * Checks if the user granted any of the specified scope or scopes.
 * @returns True if any of the scopes are granted
 */ function $e7ed5c4b4f4b44fc$export$3413c85423c3f1d0(tokenResponse, firstScope, ...restScopes) {
    var _a, _b, _c;
    if (!(window === null || window === void 0 ? void 0 : window.google)) return false;
    return ((_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.oauth2) === null || _c === void 0 ? void 0 : _c.hasGrantedAnyScope(tokenResponse, firstScope, ...restScopes)) || false;
}



var $8FY87 = parcelRequire("8FY87");


var $8FY87 = parcelRequire("8FY87");

var $2PPWI = parcelRequire("2PPWI");
function $c87118bc1c828d28$export$798996ac402ec5d0(t) {
    var o = t.redirectUri, i = t.clientId, c = t.onSuccess, a = t.onError, s = t.scope, d = void 0 === s ? "r_emailaddress" : s, u = t.state, l = void 0 === u ? "" : u, w = t.closePopupMessage, p = void 0 === w ? "User closed the popup" : w, g = (0, $8FY87.useRef)(null), v = (0, $8FY87.useRef)(null), f = (0, $8FY87.useCallback)(function(e) {
        var r = localStorage.getItem("linkedin_oauth2_state");
        if (e.origin === window.location.origin) {
            if (e.data.errorMessage && "Linked In" === e.data.from) {
                if (e.data.state !== r) return void (g.current && g.current.close());
                a && a(e.data), g.current && g.current.close();
            } else if (e.data.code && "Linked In" === e.data.from) {
                if (e.data.state !== r) return void (g.current && g.current.close());
                c && c(e.data.code), g.current && g.current.close();
            }
        }
    }, [
        a,
        c
    ]);
    (0, $8FY87.useEffect)(function() {
        return function() {
            window.removeEventListener("message", f, !1), g.current && (g.current.close(), g.current = null), v.current && (window.clearInterval(v.current), v.current = null);
        };
    }, [
        f
    ]), (0, $8FY87.useEffect)(function() {
        return window.addEventListener("message", f, !1), function() {
            window.removeEventListener("message", f, !1);
        };
    }, [
        f
    ]);
    var h = function() {
        var e = "&scope=" + encodeURI(d), r = l || function(e) {
            void 0 === e && (e = 20);
            for(var r = "", n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", t = n.length, o = 0; o < e; o++)r += n.charAt(Math.floor(Math.random() * t));
            return r;
        }();
        return localStorage.setItem("linkedin_oauth2_state", r), "https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=" + i + "&redirect_uri=" + o + e + "&state=" + r;
    };
    return {
        linkedInLogin: function() {
            var e;
            null === (e = g.current) || void 0 === e || e.close(), g.current = window.open(h(), "_blank", function(e) {
                var r = e.width, n = void 0 === r ? 600 : r, t = e.height, o = void 0 === t ? 600 : t;
                return "left=" + (screen.width / 2 - n / 2) + ",top=" + (screen.height / 2 - o / 2) + ",width=" + n + ",height=" + o;
            }({
                width: 600,
                height: 600
            })), v.current && (window.clearInterval(v.current), v.current = null), v.current = window.setInterval(function() {
                try {
                    g.current && g.current.closed && (window.clearInterval(v.current), v.current = null, a && a({
                        error: "user_closed_popup",
                        errorMessage: p
                    }));
                } catch (e) {
                    window.clearInterval(v.current), v.current = null;
                }
            }, 1e3);
        }
    };
}
function $c87118bc1c828d28$export$60f7169f5ee875bc(e) {
    return (0, e.children)({
        linkedInLogin: $c87118bc1c828d28$export$798996ac402ec5d0({
            redirectUri: e.redirectUri,
            clientId: e.clientId,
            onSuccess: e.onSuccess,
            onError: e.onError,
            state: e.state,
            scope: e.scope,
            closePopupMessage: e.closePopupMessage
        }).linkedInLogin
    });
}
function $c87118bc1c828d28$export$4eba75a127a285cf() {
    var e = (0, $8FY87.useState)(""), r = e[0], i = e[1];
    return (0, $8FY87.useEffect)(function() {
        var e = function(e) {
            for(var r = e.substring(1).split("&"), n = {}, t = 0; t < r.length; t++){
                var o = r[t].split("=");
                o.length > 1 && (n[decodeURIComponent(o[0])] = decodeURIComponent(o[1]));
            }
            return n;
        }(window.location.search);
        if (e.state !== localStorage.getItem("linkedin_oauth2_state")) i("State does not match");
        else if (e.error) {
            var r = e.error_description || "Login failed. Please try again.";
            window.opener && window.opener.postMessage({
                error: e.error,
                state: e.state,
                errorMessage: r,
                from: "Linked In"
            }, window.location.origin), "user_cancelled_login" === e.error && window.close();
        }
        e.code && window.opener && window.opener.postMessage({
            code: e.code,
            state: e.state,
            from: "Linked In"
        }, window.location.origin);
    }, []), (0, $2PPWI.jsx)("div", {
        children: r
    }, void 0);
}







var $a1c1878fa3817abc$exports = {};
"use strict";
"use client";

var $bcBLN = parcelRequire("bcBLN");
Object.defineProperty($a1c1878fa3817abc$exports, "__esModule", {
    value: true
});
$a1c1878fa3817abc$exports.default = void 0;

var $a1c1878fa3817abc$var$_createSvgIcon = $bcBLN((parcelRequire("485sq")));

var $2PPWI = parcelRequire("2PPWI");
var $a1c1878fa3817abc$var$_default = $a1c1878fa3817abc$exports.default = (0, $a1c1878fa3817abc$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2PPWI.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), 'ErrorOutline');





var $771c5082acf6b713$exports = {};

$771c5082acf6b713$exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "eye-open.4ceb8078.svg";


var $a0b75bc48280325d$exports = {};

$a0b75bc48280325d$exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "eye-closed.6711f686.svg";




function $3d48bda3acf8b90c$var$useQuery() {
    const { search: search } = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useMemo(()=>new URLSearchParams(search), [
        search
    ]);
}
function $3d48bda3acf8b90c$var$checkIsInFrame() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}




const $3d48bda3acf8b90c$var$Login = (props)=>{
    const [showPassword, setShowPassword] = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useState(false);
    const handleClickShowPassword = ()=>setShowPassword((show)=>!show);
    const isInIframe = $3d48bda3acf8b90c$var$checkIsInFrame();
    const [errorMessage, setErrorMessage] = (0, $8FY87.useState)("");
    const [errorMessageSocial, setErrorMessageSocial] = (0, $8FY87.useState)("");
    const { search: search } = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)();
    let query = $3d48bda3acf8b90c$var$useQuery();
    let l_redirecturl = query.get("redirecturl");
    const l_userIdFromQuery = query.get("userId");
    const l_siteIdFromQuery = query.get("siteId");
    const location = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)();
    const { userId: userId, siteId: siteId } = location.state || {};
    // Use either query or state data based on preference
    const l_userId = l_userIdFromQuery || userId;
    const l_siteId = l_siteIdFromQuery || siteId;
    const navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    const [cookies, setCookie, removeCookie] = (0, $1f373de1ceea6eb7$export$2e2bcd8739ae039)([
        "rp_access_token",
        "rp_refresh_token"
    ]);
    const [isLoading, setIsLoading] = (0, $8FY87.useState)(false);
    const { linkedInLogin: linkedInLogin } = (0, $c87118bc1c828d28$export$798996ac402ec5d0)({
        clientId: "86q0502we7bi54",
        scope: "email profile openid",
        redirectUri: "https://app.rocketpages.io/linkedin",
        onSuccess: (code)=>{
            onLoginViaLinkedIn(code);
        },
        onError: (error)=>{
            console.log(error);
        }
    });
    const [formData, setFormData] = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useState({
        email: "",
        password: ""
    });
    const [formErrors, setFormErrors] = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useState({
        email: "",
        password: ""
    });
    function isValidEmail(email) {
        // Regular expression for basic email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }
    function validateForm(formData) {
        try {
            // console.log("formData", formData);
            setFormErrors({
                email: "",
                password: ""
            });
            if (formData.email === "") {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        email: "Email can not be empty."
                    };
                });
                return false;
            }
            if (!isValidEmail(formData.email)) {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        email: "Invalid email address."
                    };
                });
                return false;
            }
            if (formData.password === "") {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        password: "Password is empty."
                    };
                });
                return false;
            }
            return true;
        } catch (err) {
            return false;
        }
    }
    async function onLogin(e) {
        e.preventDefault();
        if (!validateForm(formData)) return;
        setIsLoading(true);
        try {
            let data = {
                email: formData.email,
                password: formData.password,
                rp_site_id: l_siteId,
                rp_user_id: l_userId
            };
            let res = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post("api/login", data);
            setIsLoading(false);
            // send reload message to parent
            if (isInIframe) {
                parent.postMessage("auth:reload", "*");
                return;
            }
            if (l_redirecturl !== undefined && l_redirecturl !== "" && l_redirecturl !== null) window.location.href = `${l_redirecturl}`;
            else navigate("/dashboard", {
                state: {
                    token: res.data.token,
                    user: res.data
                }
            });
        } catch (err) {
            setIsLoading(false);
            setErrorMessage(err.response.data.message);
        }
    }
    async function onLoginViaGoogle(googleCred) {
        setIsLoading(true);
        try {
            let data = {
                signupMode: "google",
                token: googleCred.credential,
                rp_user_id: l_userId,
                rp_site_id: l_siteId
            };
            let res = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post("api/signup", data, {
                withCredentials: true
            });
            // console.log("on login", res);
            setIsLoading(false);
            // console.log('rp_site_id', cookies.rp_page_id)
            if (isInIframe) {
                parent.postMessage("auth:reload", "*");
                return;
            }
            if (l_redirecturl !== undefined && l_redirecturl !== "" && l_redirecturl !== null) window.location.href = `${l_redirecturl}`;
            else navigate("/dashboard", {
                state: {
                    token: res.data.token,
                    user: res.data
                }
            });
        } catch (err) {
            setIsLoading(false);
            setErrorMessageSocial(err.response.data.message);
        }
    }
    async function onLoginViaLinkedIn(authCode) {
        setIsLoading(true);
        try {
            let data = {
                signupMode: "linkedIn",
                authCode: authCode,
                rp_user_id: l_userId,
                rp_site_id: l_siteId
            };
            let res = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post("api/signup", data);
            setIsLoading(false);
            if (isInIframe) {
                parent.postMessage("auth:reload", "*");
                return;
            }
            if (l_redirecturl !== undefined && l_redirecturl !== "" && l_redirecturl !== null) window.location.href = `${l_redirecturl}`;
            else navigate("/dashboard", {
                state: {
                    token: res.data.token,
                    user: res.data
                }
            });
        } catch (err) {
            setIsLoading(false);
            setErrorMessageSocial(err.response.data.message);
        }
    }
    function handleChange(event) {
        setFormData((old)=>{
            return {
                ...old,
                [event.target.id]: event.target.value.trim()
            };
        });
        setErrorMessage("");
        setErrorMessageSocial("");
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("main", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).loginPage}`
    }, isInIframe && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $56dcde36b8493878$export$2e2bcd8739ae039), {
        sx: {
            color: "#fff",
            zIndex: (theme)=>theme.zIndex.drawer + 1
        },
        open: isLoading,
        invisible: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $b391f94ee7b6de9b$export$2e2bcd8739ae039), {
        color: "info"
    })), !isInIframe && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $56dcde36b8493878$export$2e2bcd8739ae039), {
        sx: {
            color: "#fff",
            zIndex: (theme)=>theme.zIndex.drawer + 1
        },
        open: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $b391f94ee7b6de9b$export$2e2bcd8739ae039), {
        color: "inherit"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $74b90a6f08eb2e78$export$8b251419efc915eb), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("section", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).contentContaienr} login-section flex justify-start`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).leftContent} hidden md:inline-block`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("img", {
        src: (parcelRequire("3DtD5")),
        className: "hidden xl:block"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("img", {
        src: (parcelRequire("3DtD5")),
        className: "small-img xl:hidden"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).content} md:flex md:flex-col max-w-full ${isInIframe ? (0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).nopadding : ""}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).formContainer}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("h1", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).loginHeading} mt-1 md:mt-8 lg:mt-16 mb-8`
    }, "Log into RocketPages"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("form", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).loginForm}`,
        onSubmit: onLogin
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).emailRow} flex flex-col`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        htmlFor: "email"
    }, "Email"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("input", {
        type: "email",
        id: "email",
        placeholder: "Enter email address",
        value: formData.email,
        onChange: handleChange,
        className: `${formErrors.email !== "" ? "border-red-500" : ""}`
    }), formErrors.email !== "" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).errorLabels}`
    }, formErrors.email)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).passwordRow} flex flex-col`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        htmlFor: "password"
    }, "Password"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $1587b7eed37887b9$export$2e2bcd8739ae039), {
        sx: {
            position: "relative"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $3247b0fca8a83d17$export$2e2bcd8739ae039), {
        type: showPassword ? "text" : "password",
        id: "password",
        placeholder: "Enter password",
        value: formData.password,
        onChange: handleChange,
        endAdornment: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $8765ef9b64e3c3e6$export$2e2bcd8739ae039), {
            className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).passwordEye}`,
            sx: {
                position: "absolute",
                right: "20px",
                width: "20px",
                padding: "0px",
                top: "13px"
            },
            "aria-label": showPassword ? "hide the password" : "display the password",
            onClick: handleClickShowPassword,
            onMouseDown: (event)=>event.preventDefault(),
            onMouseUp: (event)=>event.preventDefault(),
            edge: "end"
        }, showPassword ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($a0b75bc48280325d$exports))),
            alt: "hide password"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($771c5082acf6b713$exports))),
            alt: "show password"
        })),
        sx: {
            "&:before": {
                borderBottom: "none"
            },
            "&:after": {
                borderBottom: "none"
            },
            "&:hover:not(.Mui-disabled):before": {
                borderBottom: "none"
            },
            // Placeholder styling
            "& input::placeholder": {
                color: "#3B3B3B99",
                fontWeight: "300",
                opacity: 1
            },
            ...formErrors.password !== "" && {
                "& input": {
                    borderColor: "#ef4444"
                }
            }
        }
    })), formErrors.password !== "" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).errorLabels}`
    }, formErrors.password)), errorMessage !== "" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
        className: "flex text-center mb-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1c1878fa3817abc$exports))), {
        fontSize: "small",
        sx: {
            color: "red"
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).errorLabelForm} `
    }, errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("button", {
        type: "submit",
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).primaryBtn} ${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).loginBtn}`
    }, "Login")), isInIframe ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $734169eef5d6795a$export$a6c7ac8248d6e38a), {
        to: {
            pathname: "/forgot-password",
            search: `?userId=${l_userId}&siteId=${l_siteId}`
        },
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).normalLink} inline-block my-1 text-[16px] font-semibold`
    }, "Forgot password?") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $734169eef5d6795a$export$a6c7ac8248d6e38a), {
        to: "/forgot-password",
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).normalLink} inline-block my-1 text-[16px] font-semibold`
    }, "Forgot password?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).seperator} flex items-center pt-8`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).seperatorLine}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).seperatorText}`
    }, "Or Login with", " "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).seperatorLine}`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).socialSection} flex justify-center gap-8`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).googleIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("img", {
        src: (parcelRequire("inEQW")),
        alt: "Google",
        style: {
            width: 32,
            height: 32,
            pointerEvents: "none"
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).googleIframeOverlay
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $e7ed5c4b4f4b44fc$export$a795a627e512102a), {
        onSuccess: async (credentialResponse)=>{
            onLoginViaGoogle(credentialResponse);
        },
        onError: ()=>{
            console.log("Login Failed");
        },
        type: "icon"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).socialIcons}`,
        onClick: linkedInLogin
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("img", {
        src: (parcelRequire("gl0e6"))
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex justify-center py-2"
    }, errorMessageSocial !== "" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
        className: "flex text-center mb-2 items-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1c1878fa3817abc$exports))), {
        fontSize: "small",
        sx: {
            color: "red"
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).errorLabelForm} `
    }, errorMessageSocial))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $b19176bd78e1869f$export$2e2bcd8739ae039), {
        sx: {
            justifyContent: "center",
            display: {
                xs: "flex",
                lg: "none"
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).dontHaveAccount} font-normal mr-1`
    }, "Don't have an account?"), isInIframe ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $734169eef5d6795a$export$a6c7ac8248d6e38a), {
        to: {
            pathname: "/signup",
            search: `?userId=${l_userId}&siteId=${l_siteId}`
        },
        className: "text-sm text-[#243460] font-semibold"
    }, "Signup") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $734169eef5d6795a$export$a6c7ac8248d6e38a), {
        to: `/signup${search}`,
        className: "text-sm text-[#243460] font-semibold"
    }, "Signup"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).dontHaveAccount} font-normal ml-1`
    }, "for free!")))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $0a87a32205fa1e51$export$2e2bcd8739ae039), null)), !isInIframe && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $fdcc8de0ec44fdd8$export$2e2bcd8739ae039), null));
};
var $3d48bda3acf8b90c$export$2e2bcd8739ae039 = $3d48bda3acf8b90c$var$Login;



const $34e9424c20ddd47f$export$f14c0e3f98d164c0 = (props)=>{
    const navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    const location = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)();
    const [cookie, setCookie, removeCookie] = (0, $1f373de1ceea6eb7$export$2e2bcd8739ae039)([
        "rp_user_data"
    ]);
    (0, $8FY87.useEffect)(()=>{
        // console.log('env API_ENDPOINT', process.env.API_ENDPOINT)
        // console.log('env LINKEDIN_CLIENT_ID', process.env.LINKEDIN_CLIENT_ID)
        // console.log('env LINKEDIN_REDIRECT_URI', process.env.LINKEDIN_REDIRECT_URI)
        // console.log('env GOOGLE_CLEINT_ID', process.env.GOOGLE_CLEINT_ID)
        // console.log('env STRIPE_KEY', process.env.STRIPE_KEY)
        if (location.state && location.state.removeCookies) removeCookie("rp_user_data");
        else if (cookie.rp_user_data) navigate("/dashboard");
    // console.log('LoginPage -> props.removeCookies',location.state)
    }, []);
    return /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, null, /*#__PURE__*/ $8FY87.createElement((0, $274ffc8236991365$export$dcef8f9bb9a41431), null, /*#__PURE__*/ $8FY87.createElement("title", null, "RocketPages - Login"), /*#__PURE__*/ $8FY87.createElement("meta", {
        name: "description",
        content: "Build and Launch Your Free Website in Just 15 Minutes"
    }), /*#__PURE__*/ $8FY87.createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap",
        rel: "stylesheet"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "icon",
        href: "/favicon.ico"
    }), false), /*#__PURE__*/ $8FY87.createElement((0, $9ada84cce5691847$export$2e2bcd8739ae039), null), /*#__PURE__*/ $8FY87.createElement((0, $3d48bda3acf8b90c$export$2e2bcd8739ae039), null));
};


var $17b94442430ee2e4$exports = {};
"use strict";
"use client";

var $bcBLN = parcelRequire("bcBLN");
Object.defineProperty($17b94442430ee2e4$exports, "__esModule", {
    value: true
});
$17b94442430ee2e4$exports.default = void 0;

var $17b94442430ee2e4$var$_createSvgIcon = $bcBLN((parcelRequire("485sq")));

var $2PPWI = parcelRequire("2PPWI");
var $17b94442430ee2e4$var$_default = $17b94442430ee2e4$exports.default = (0, $17b94442430ee2e4$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2PPWI.jsx)("path", {
    d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m0 16H8V7h11z"
}), 'ContentCopy');





var $ce44e4ac29f59b64$var$V3_URL = 'https://js.stripe.com/v3';
var $ce44e4ac29f59b64$var$V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var $ce44e4ac29f59b64$var$EXISTING_SCRIPT_MESSAGE = 'loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used';
var $ce44e4ac29f59b64$var$findScript = function findScript() {
    var scripts = document.querySelectorAll("script[src^=\"".concat($ce44e4ac29f59b64$var$V3_URL, "\"]"));
    for(var i = 0; i < scripts.length; i++){
        var script = scripts[i];
        if (!$ce44e4ac29f59b64$var$V3_URL_REGEX.test(script.src)) continue;
        return script;
    }
    return null;
};
var $ce44e4ac29f59b64$var$injectScript = function injectScript(params) {
    var queryString = params && !params.advancedFraudSignals ? '?advancedFraudSignals=false' : '';
    var script = document.createElement('script');
    script.src = "".concat($ce44e4ac29f59b64$var$V3_URL).concat(queryString);
    var headOrBody = document.head || document.body;
    if (!headOrBody) throw new Error('Expected document.body not to be null. Stripe.js requires a <body> element.');
    headOrBody.appendChild(script);
    return script;
};
var $ce44e4ac29f59b64$var$registerWrapper = function registerWrapper(stripe, startTime) {
    if (!stripe || !stripe._registerWrapper) return;
    stripe._registerWrapper({
        name: 'stripe-js',
        version: "1.54.2",
        startTime: startTime
    });
};
var $ce44e4ac29f59b64$var$stripePromise = null;
var $ce44e4ac29f59b64$var$loadScript = function loadScript(params) {
    // Ensure that we only attempt to load Stripe.js at most once
    if ($ce44e4ac29f59b64$var$stripePromise !== null) return $ce44e4ac29f59b64$var$stripePromise;
    $ce44e4ac29f59b64$var$stripePromise = new Promise(function(resolve, reject) {
        if (typeof window === 'undefined' || typeof document === 'undefined') {
            // Resolve to null when imported server side. This makes the module
            // safe to import in an isomorphic code base.
            resolve(null);
            return;
        }
        if (window.Stripe && params) console.warn($ce44e4ac29f59b64$var$EXISTING_SCRIPT_MESSAGE);
        if (window.Stripe) {
            resolve(window.Stripe);
            return;
        }
        try {
            var script = $ce44e4ac29f59b64$var$findScript();
            if (script && params) console.warn($ce44e4ac29f59b64$var$EXISTING_SCRIPT_MESSAGE);
            else if (!script) script = $ce44e4ac29f59b64$var$injectScript(params);
            script.addEventListener('load', function() {
                if (window.Stripe) resolve(window.Stripe);
                else reject(new Error('Stripe.js not available'));
            });
            script.addEventListener('error', function() {
                reject(new Error('Failed to load Stripe.js'));
            });
        } catch (error) {
            reject(error);
            return;
        }
    });
    return $ce44e4ac29f59b64$var$stripePromise;
};
var $ce44e4ac29f59b64$var$initStripe = function initStripe(maybeStripe, args, startTime) {
    if (maybeStripe === null) return null;
    var stripe = maybeStripe.apply(undefined, args);
    $ce44e4ac29f59b64$var$registerWrapper(stripe, startTime);
    return stripe;
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
// own script injection.
var $ce44e4ac29f59b64$var$stripePromise$1 = Promise.resolve().then(function() {
    return $ce44e4ac29f59b64$var$loadScript(null);
});
var $ce44e4ac29f59b64$var$loadCalled = false;
$ce44e4ac29f59b64$var$stripePromise$1["catch"](function(err) {
    if (!$ce44e4ac29f59b64$var$loadCalled) console.warn(err);
});
var $ce44e4ac29f59b64$export$de80f7562c3fd6b1 = function loadStripe() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $ce44e4ac29f59b64$var$loadCalled = true;
    var startTime = Date.now();
    return $ce44e4ac29f59b64$var$stripePromise$1.then(function(maybeStripe) {
        return $ce44e4ac29f59b64$var$initStripe(maybeStripe, args, startTime);
    });
};





var $8FY87 = parcelRequire("8FY87");




const $c9be578d1e08ddaa$var$stripePromise = (0, $ce44e4ac29f59b64$export$de80f7562c3fd6b1)("pk_test_51NY0p7H46TpgZNWbmag72Jg49hDMFFwx2nzIo2302UWypkQ6DRHL8G8sqLElnyvgtxvIU1JolosEIv9YliAaRoQy00lQJMGEeW");

const $c9be578d1e08ddaa$export$d1fd69b62921db79 = ()=>{
    const { enqueueSnackbar: enqueueSnackbar } = (0, $5e19452f9528802f$export$1c97ac2c9a6e7c09)();
    const { siteId: siteId } = (0, $d5fb2d3e42b0c581$export$99eaa27ddbbb95ef)();
    const navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    const location = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)();
    const stateData = location.state;
    const [isLoading, setIsLoading] = (0, $8FY87.useState)(false);
    // const [data, setData] = useState();
    const [subsRes, setSubsRes] = (0, $8FY87.useState)(null);
    const search = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)().search;
    const session_id = new URLSearchParams(search).get("session_id");
    $8FY87.useEffect(()=>{
        async function fetchData() {
            setIsLoading(true);
            try {
                let config = {
                    method: "get",
                    url: `${"https://api.rocketpages.io"}/api/configs/stripe-subscription-from-session?sessionId=${session_id}`,
                    withCredentials: true
                };
                let res = await (0, $bf5b93105d90423b$export$2e2bcd8739ae039).request(config);
                // console.log("kk", res.data);
                if (!res.data.subscription && res.data.error) {
                    enqueueSnackbar(res.data.error, {
                        variant: "error",
                        className: "bg-catelina-blue"
                    });
                    setIsLoading(false);
                    return;
                }
                setSubsRes(res.data.subscription);
                // setData(rs.data);
                setIsLoading(false);
            } catch (err) {
                console.log(err);
                setIsLoading(false);
            }
        // console.log("session_id", session_id);
        // window.location.href = res.data.sessionUrl
        }
        // setIsLoading(true);
        fetchData();
    // setIsLoading(false);
    }, []);
    // Function to convert timestamp to month/date/year format
    function timestampToDateString(timestamp) {
        // Create a new Date object using the timestamp
        const date = new Date(timestamp);
        const monthNames = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ];
        // Get the individual components (month, day, year)
        const month = monthNames[date.getMonth()];
        const day = date.getDate();
        const year = date.getFullYear();
        // Create the formatted string
        const formattedDate = `${month} ${day}, ${year}`;
        return formattedDate;
    }
    return /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, null, /*#__PURE__*/ $8FY87.createElement((0, $274ffc8236991365$export$dcef8f9bb9a41431), null, /*#__PURE__*/ $8FY87.createElement("title", null, "RocketPages - Dashboard"), /*#__PURE__*/ $8FY87.createElement("meta", {
        name: "description",
        content: "Build and Launch Your Free Website in Just 15 Minutes"
    }), /*#__PURE__*/ $8FY87.createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap",
        rel: "stylesheet"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "icon",
        href: "/favicon.ico"
    }), false), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "font-body text-base font-medium"
    }, /*#__PURE__*/ $8FY87.createElement((0, $56dcde36b8493878$export$2e2bcd8739ae039), {
        sx: {
            color: "#fff",
            zIndex: (theme)=>theme.zIndex.drawer + 1
        },
        open: isLoading
    }, /*#__PURE__*/ $8FY87.createElement((0, $b391f94ee7b6de9b$export$2e2bcd8739ae039), {
        color: "inherit"
    })), /*#__PURE__*/ $8FY87.createElement((0, $c0f0a0f6efad2fa3$export$42cfbb80f7861e77), null), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "bg-[#FAFAFA] absolute top-[64px] w-full h-screen"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: " max-w-2xl bg-white my-12 m-auto rounded-lg px-2 md:px-16 py-6"
    }, subsRes && /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col text-grey-primary"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col justify-center text-xl font-semibold mb-10 text-center md:mx-20 items-center"
    }, /*#__PURE__*/ $8FY87.createElement("img", {
        className: "mb-4",
        src: (parcelRequire("6ssOa")),
        width: 64,
        alt: ""
    }), "You\u2019ve successfully subscribed to the", " ", subsRes.plan_desc && subsRes.plan_desc.replace("Rocket Pages IO", ""), "!"), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex justify-between my-2 flex-col md:flex-row"
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-base"
    }, "Subscription ID"), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-sm"
    }, subsRes.subscription ?? subsRes.subscriptionId)), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex justify-between my-2 flex-col md:flex-row"
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-base"
    }, "Plan Desc"), " ", /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-sm"
    }, subsRes.plan_desc)), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex justify-between my-2 flex-col md:flex-row"
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-base"
    }, "Subscription Start"), " ", /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-sm"
    }, timestampToDateString(subsRes.subscription_start * 1000))), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex justify-between my-2 flex-col md:flex-row"
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-base"
    }, "Subscription End"), " ", /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-sm"
    }, timestampToDateString(subsRes.subscription_end * 1000))), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex justify-between my-2"
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-base"
    }, "Invoice URL ", /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($17b94442430ee2e4$exports))), {
        onClick: ()=>{
            navigator.clipboard.writeText(subsRes.invoice_url);
            enqueueSnackbar("Invoice url copied", {
                variant: "info",
                className: "bg-catelina-blue"
            });
        },
        className: "mx-2 cursor-pointer",
        sx: {
            color: "#243060",
            fontSize: "16px"
        }
    }))), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex justify-center"
    }, /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        variant: "contained",
        size: "small",
        sx: {
            backgroundColor: "#243060",
            color: "#fff",
            textTransform: "none",
            "&:hover": {
                backgroundColor: "#fff",
                color: "#243060"
            }
        },
        onClick: ()=>navigate(`/site-settings/${siteId}?section=General`),
        className: "ml-2"
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: "lg:block"
    }, "Site Dashboard")), /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        variant: "contained",
        size: "small",
        sx: {
            backgroundColor: "#243060",
            color: "#fff",
            textTransform: "none",
            "&:hover": {
                backgroundColor: "#fff",
                color: "#243060"
            }
        },
        onClick: ()=>{
            window.location.href = `${"http://editor.rocketpages.io"}/${siteId}`;
        // window.location.reload();
        },
        className: "ml-2"
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: "lg:block"
    }, "Edit site"))))))), /*#__PURE__*/ $8FY87.createElement((0, $fdcc8de0ec44fdd8$export$2e2bcd8739ae039), null));
};



var $8FY87 = parcelRequire("8FY87");








const $ec102dcec4aad640$export$2d07bc60194ed90c = ()=>{
    const location = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)();
    const navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    // const stateData = location.state;
    const { enqueueSnackbar: enqueueSnackbar } = (0, $5e19452f9528802f$export$1c97ac2c9a6e7c09)();
    const { id: id } = (0, $d5fb2d3e42b0c581$export$99eaa27ddbbb95ef)();
    const [isLoading, setIsLoading] = (0, $8FY87.useState)(false);
    const search = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)().search;
    const [previewData, setPreviewData] = (0, $8FY87.useState)();
    const [colorPallets, setColorPallets] = (0, $8FY87.useState)([]);
    // console.log("asasasasa", location.state.selectedColorPallet);
    const [selectedColorPallet, setSelectedColorPallet] = $8FY87.useState();
    const [searchParams] = (0, $734169eef5d6795a$export$f1a78c17382fe22a)();
    const getQueryParam = (key)=>{
        return searchParams.get(key);
    };
    $8FY87.useEffect(()=>{
        async function fetchData() {
            try {
                let response = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).get(`/api/preview?siteId=${id}`);
                // Redirect to /choose-template if response.data is blank
                if (!response.data) {
                    navigate("/choose-template");
                    return;
                }
                setPreviewData(response.data.data);
                let responseAllPallets = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).get(`/api/configs/all-template-color-theme`);
                let rrr = [];
                response.data.data.templateColorPalettes.forEach((row)=>{
                    let gg = responseAllPallets.data.data.find((kk)=>kk.id === row.id);
                    if (gg) rrr.push(gg);
                });
                setColorPallets(rrr);
                let _tmplId = getQueryParam("id");
                // console.log('location.state.selectedColorPallet', location.state.selectedColorPallet)
                if (!location.state?.selectedColorPallet && !_tmplId) setSelectedColorPallet(rrr[0]);
                else {
                    let pp = responseAllPallets.data.data.find((kk)=>kk.id === _tmplId ? _tmplId : location.state?.selectedColorPallet?.id);
                    // console.log('debug4.state.selectedColorPallet', pp)
                    setSelectedColorPallet(pp);
                    // setTimeout(() => {
                    let iframe = document.getElementById("previewFrame");
                    if (iframe) {
                        let iframeWindow = iframe.contentWindow;
                        // let documentElement = iframeWindow.document.documentElement;
                        iframeWindow.postMessage({
                            msgType: "colorPalleteChange",
                            color: pp
                        }, "*");
                    }
                // }, 500);
                }
            } catch (err) {
                console.log(err);
            }
        }
        setIsLoading(true);
        fetchData();
        setIsLoading(false);
    }, []);
    $8FY87.useEffect(()=>{
        let iframe = document.getElementById("previewFrame");
        if (iframe) {
            let iframeWindow = iframe.contentWindow;
            // let documentElement = iframeWindow.document.documentElement;
            iframeWindow.postMessage({
                msgType: "colorPalleteChange",
                color: selectedColorPallet
            }, "*");
        }
    // console.log("sss", selectedColorPallet);
    }, [
        selectedColorPallet
    ]);
    // To hide sitename of preview on mobile view
    const useMobileView = ()=>{
        const [isMobileView, setIsMobile] = (0, $8FY87.useState)(window.innerWidth <= 601);
        $8FY87.useEffect(()=>{
            const mediaQuery = window.matchMedia("(max-width: 601px)");
            const handleMediaChange = ()=>setIsMobile(mediaQuery.matches);
            handleMediaChange(); // Initial check
            mediaQuery.addEventListener("change", handleMediaChange); // Listen for changes
            return ()=>mediaQuery.removeEventListener("change", handleMediaChange); // Cleanup
        }, []);
        return isMobileView;
    };
    let isMobile = useMobileView();
    return /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, null, /*#__PURE__*/ $8FY87.createElement((0, $274ffc8236991365$export$dcef8f9bb9a41431), null, /*#__PURE__*/ $8FY87.createElement("title", null, "RocketPages - Preview"), /*#__PURE__*/ $8FY87.createElement("meta", {
        name: "description",
        content: "Build and Launch Your Free Website in Just 15 Minutes"
    }), /*#__PURE__*/ $8FY87.createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap",
        rel: "stylesheet"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "icon",
        href: "/favicon.ico"
    }), false), previewData && /*#__PURE__*/ $8FY87.createElement("div", {
        className: "font-body text-base font-medium"
    }, /*#__PURE__*/ $8FY87.createElement((0, $56dcde36b8493878$export$2e2bcd8739ae039), {
        sx: {
            color: "#fff",
            zIndex: (theme)=>theme.zIndex.drawer + 1
        },
        open: isLoading
    }, /*#__PURE__*/ $8FY87.createElement((0, $b391f94ee7b6de9b$export$2e2bcd8739ae039), {
        color: "inherit"
    })), /*#__PURE__*/ $8FY87.createElement((0, $c0f0a0f6efad2fa3$export$42cfbb80f7861e77), {
        title: `Preview${!isMobile ? ` : ${previewData.templateName}` : ""}`,
        colorPallets: colorPallets,
        selectedColorPallet: selectedColorPallet,
        editUrl: `${"http://editor.rocketpages.io"}?tid=${previewData.siteId}&theme=${selectedColorPallet ? selectedColorPallet.id : ""}`,
        isPreview: true,
        onColorPaletteChange: (color)=>{
            setSelectedColorPallet(color);
        // let iframe = document.getElementById("previewFrame");
        // let iframeWindow = iframe.contentWindow;
        // // let documentElement = iframeWindow.document.documentElement;
        // iframeWindow.postMessage(
        //   {
        //     msgType: "colorPalleteChange",
        //     color,
        //   },
        //   "*"
        // );
        }
    }), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "bg-[#FAFAFA] absolute top-[64px] w-full h-screen"
    }, /*#__PURE__*/ $8FY87.createElement("iframe", {
        id: "previewFrame",
        className: "w-full h-[96%]",
        src: previewData.previewUrl,
        // src="https://preview-test-1.rocketpages.io"
        onLoad: (e)=>{
            // console.log("onLoad.iframe.", selectedColorPallet);
            let iframe = document.getElementById("previewFrame");
            let iframeWindow = iframe.contentWindow;
            iframeWindow.postMessage({
                msgType: "colorPalleteChange",
                color: selectedColorPallet
            }, "*");
        }
    }))), /*#__PURE__*/ $8FY87.createElement((0, $fdcc8de0ec44fdd8$export$2e2bcd8739ae039), null));
};



var $8FY87 = parcelRequire("8FY87");




var $8FY87 = parcelRequire("8FY87");


var $a8bf90d2d4c0cd11$exports = {};

$parcel$export($a8bf90d2d4c0cd11$exports, "contentWrapper", function () { return $a8bf90d2d4c0cd11$export$2a82ddc22e8c7fbb; }, function (v) { return $a8bf90d2d4c0cd11$export$2a82ddc22e8c7fbb = v; });
$parcel$export($a8bf90d2d4c0cd11$exports, "description", function () { return $a8bf90d2d4c0cd11$export$6d59db4903f20f7d; }, function (v) { return $a8bf90d2d4c0cd11$export$6d59db4903f20f7d = v; });
$parcel$export($a8bf90d2d4c0cd11$exports, "fsmd", function () { return $a8bf90d2d4c0cd11$export$d0a6875c18a6e138; }, function (v) { return $a8bf90d2d4c0cd11$export$d0a6875c18a6e138 = v; });
$parcel$export($a8bf90d2d4c0cd11$exports, "h1", function () { return $a8bf90d2d4c0cd11$export$448e4850cad7c7b0; }, function (v) { return $a8bf90d2d4c0cd11$export$448e4850cad7c7b0 = v; });
$parcel$export($a8bf90d2d4c0cd11$exports, "spacing", function () { return $a8bf90d2d4c0cd11$export$5458b64234d1333c; }, function (v) { return $a8bf90d2d4c0cd11$export$5458b64234d1333c = v; });
$parcel$export($a8bf90d2d4c0cd11$exports, "title", function () { return $a8bf90d2d4c0cd11$export$fb184b623420d9be; }, function (v) { return $a8bf90d2d4c0cd11$export$fb184b623420d9be = v; });
var $a8bf90d2d4c0cd11$export$2a82ddc22e8c7fbb;
var $a8bf90d2d4c0cd11$export$6d59db4903f20f7d;
var $a8bf90d2d4c0cd11$export$d0a6875c18a6e138;
var $a8bf90d2d4c0cd11$export$448e4850cad7c7b0;
var $a8bf90d2d4c0cd11$export$5458b64234d1333c;
var $a8bf90d2d4c0cd11$export$fb184b623420d9be;
$a8bf90d2d4c0cd11$export$2a82ddc22e8c7fbb = `Uxi7mG_contentWrapper`;
$a8bf90d2d4c0cd11$export$6d59db4903f20f7d = `Uxi7mG_description`;
$a8bf90d2d4c0cd11$export$d0a6875c18a6e138 = `Uxi7mG_fsmd`;
$a8bf90d2d4c0cd11$export$448e4850cad7c7b0 = `Uxi7mG_h1`;
$a8bf90d2d4c0cd11$export$5458b64234d1333c = `Uxi7mG_spacing`;
$a8bf90d2d4c0cd11$export$fb184b623420d9be = `Uxi7mG_title`;


const $44dc3b0d7bc1d952$var$PrivacyPolicy = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("main", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).contentWrapper}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).spacing} mt-8`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("h1", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).h1}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("strong", null, "RocketPages Privacy Policy"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).description}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("strong", null, "Last updated: May 17, 2024")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", null, 'RocketPages ("us", "we", or "our") operates ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("strong", null, '[your website URL] (the "Site"). '), "This page informs you of our policies regarding the collection, use, and disclosure of Personal Information we receive from users of the Site.We use your Personal Information only for providing and improving the Site. By using the Site, you agree to the collection and use of information in accordance with this policy.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("strong", null, "Information Collection and Use"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", null, "While using our Site, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you. Personally identifiable information may include but is not limited to your name ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("strong", null, '("Personal Information")'), ".")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("strong", null, "Log Data"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", null, "Like many site operators, we collect information that your browser sends whenever you visit our Site ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("strong", null, '("Log Data")'), "."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", null, "This Log Data may include information such as your computer's Internet Protocol ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("strong", null, '("IP")'), " address, browser type, browser version, the pages of our Site that you visit, the time and date of your visit, the time spent on those pages, and other statistics."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", null, "In addition, we may use third-party services such as Google Analytics that collect, monitor, and analyze this data.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("strong", null, "Communications"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", null, "We may use your Personal Information to contact you with newsletters, marketing, or promotional materials and other information that may be of interest to you. You may opt-out of receiving any, or all, of these communications from us by following the unsubscribe link or instructions provided in any email we send.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("strong", null, "Cookies"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", null, "Cookies are files with a small amount of data, which may include an anonymous unique identifier. Cookies are sent to your browser from a web site and stored on your computer's hard drive."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", null, "Like many sites, we use ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("strong", null, '"cookies"'), " to collect information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Site.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("strong", null, "Security"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", null, "The security of your Personal Information is important to us, but remember that no method of transmission over the Internet, or method of electronic storage, is 100% secure. While we strive to use commercially acceptable means to protect your Personal Information, we cannot guarantee its absolute security.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("strong", null, "Changes to This Privacy Policy"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", null, "This Privacy Policy is effective as of [Date] and will remain in effect except with respect to any changes in its provisions in the future, which will be in effect immediately after being posted on this page."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", null, "We reserve the right to update or change our Privacy Policy at any time, and you should check this Privacy Policy periodically. Your continued use of the Service after we post any modifications to the Privacy Policy on this page will constitute your acknowledgment of the modifications and your consent to abide and be bound by the modified Privacy Policy."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", null, "If we make any material changes to this Privacy Policy, we will notify you either through the email address you have provided us or by placing a prominent notice on our website.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("strong", null, "Contact Us"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", null, "If you have any questions about this Privacy Policy, please contact us at ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("a", {
        href: "mailto:info@rocketpages.io",
        target: "_blank",
        className: "editor-link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("strong", null, "info@rocketpages.io")), "."))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $0a87a32205fa1e51$export$2e2bcd8739ae039), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $fdcc8de0ec44fdd8$export$2e2bcd8739ae039), null));
};
var $44dc3b0d7bc1d952$export$2e2bcd8739ae039 = $44dc3b0d7bc1d952$var$PrivacyPolicy;




const $53d5cc9f6d337e44$export$d5a29154259e944d = (props)=>{
    const navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    const location = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)();
    const stateData = location.state;
    const [cookie, setCookie, removeCookie] = (0, $1f373de1ceea6eb7$export$2e2bcd8739ae039)([
        "rp_user_data"
    ]);
    return /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, null, /*#__PURE__*/ $8FY87.createElement((0, $274ffc8236991365$export$dcef8f9bb9a41431), null, /*#__PURE__*/ $8FY87.createElement("title", null, "RocketPages - Privacy policy"), /*#__PURE__*/ $8FY87.createElement("meta", {
        name: "description",
        content: "Build and Launch Your Free Website in Just 15 Minutes"
    }), /*#__PURE__*/ $8FY87.createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap",
        rel: "stylesheet"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "icon",
        href: "/favicon.ico"
    }), false), /*#__PURE__*/ $8FY87.createElement((0, $9ada84cce5691847$export$2e2bcd8739ae039), null), /*#__PURE__*/ $8FY87.createElement((0, $c0f0a0f6efad2fa3$export$42cfbb80f7861e77), {
        ...stateData,
        skipCheckCookies: true
    }), /*#__PURE__*/ $8FY87.createElement((0, $44dc3b0d7bc1d952$export$2e2bcd8739ae039), null));
};



var $8FY87 = parcelRequire("8FY87");


var $8FY87 = parcelRequire("8FY87");
















function $80eda53f5bf416c9$var$getResetEmail() {
    try {
        return localStorage.getItem("rp_reset_email") || "";
    } catch  {
        return "";
    }
}


const $80eda53f5bf416c9$var$ResetPassword = ()=>{
    const [errorMessage, setErrorMessage] = $8FY87.useState("");
    const navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    const location = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)();
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get("token");
    const userEmail = $80eda53f5bf416c9$var$getResetEmail();
    const [cookies, setCookie] = (0, $1f373de1ceea6eb7$export$2e2bcd8739ae039)([
        "rp_access_token"
    ]);
    const [isLoading, setIsLoading] = $8FY87.useState(false);
    const { enqueueSnackbar: enqueueSnackbar } = (0, $5e19452f9528802f$export$1c97ac2c9a6e7c09)();
    const [formData, setFormData] = $8FY87.useState({
        password: "",
        rePassword: ""
    });
    const [formErrors, setFormErrors] = $8FY87.useState({
        password: "",
        rePassword: ""
    });
    const isFormInvalid = formErrors.password !== "" || formErrors.rePassword !== "" || formData.password === "" || formData.rePassword === "";
    function validateForm(formData) {
        try {
            setFormErrors({
                password: "",
                rePassword: ""
            });
            if (formData.password === "") {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        password: "New password can not be empty"
                    };
                });
                return false;
            }
            if (formData.rePassword === "") {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        rePassword: "Confirm password can not be empty"
                    };
                });
                return false;
            }
            if (formData.password.length < 8) {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        password: "New password length can not be less than 8 chars."
                    };
                });
                return false;
            }
            if (formData.rePassword.length < 8) {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        rePassword: "Confirm password length can not be less than 8 chars."
                    };
                });
                return false;
            }
            if (formData.rePassword.length < 8) {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        rePassword: "Confirm password length can not be less than 8 chars."
                    };
                });
                return false;
            }
            if (formData.password !== formData.rePassword) {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        rePassword: "Confirm password does not match password."
                    };
                });
                return false;
            }
            return true;
        } catch (err) {
            return false;
        }
    }
    async function onUpdatePassword(e, formData) {
        e.preventDefault();
        if (!validateForm(formData)) return;
        setIsLoading(true);
        let accessToken = cookies.rp_access_token || token;
        try {
            let data = {
                password: formData.password
            };
            let res = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post("api/update-password", data, {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            });
            localStorage.removeItem("rp_reset_email");
            setIsLoading(true);
            enqueueSnackbar("Password has been updated! Please login again", {
                variant: "info",
                className: "bg-grey-400"
            });
            navigate("/login", {
                state: {
                    token: res.data.token
                }
            });
        } catch (err) {
            setErrorMessage(err.message);
            setIsLoading(false);
        }
    }
    function handleChange(event) {
        setFormData((old)=>{
            return {
                ...old,
                [event.target.id]: event.target.value.trim()
            };
        });
        setFormErrors({
            password: "",
            rePassword: ""
        });
        setErrorMessage("");
    }
    const [showPassword, setShowPassword] = $8FY87.useState(false);
    const [showRePassword, setShowRePassword] = $8FY87.useState(false);
    const handleClickShowPassword = ()=>setShowPassword((show)=>!show);
    const handleClickShowRePassword = ()=>setShowRePassword((show)=>!show);
    (0, $8FY87.useEffect)(()=>{
        // Redirect if user is already logged in
        if (cookies.rp_loggedin) navigate("/choose-template"); // Redirect to the dashboard
    }, [
        cookies.rp_loggedin,
        navigate
    ]);
    return /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, null, /*#__PURE__*/ $8FY87.createElement("main", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).forgotPassword}`
    }, /*#__PURE__*/ $8FY87.createElement((0, $56dcde36b8493878$export$2e2bcd8739ae039), {
        sx: {
            color: "#fff",
            zIndex: (theme)=>theme.zIndex.drawer + 1
        },
        open: isLoading
    }, /*#__PURE__*/ $8FY87.createElement((0, $b391f94ee7b6de9b$export$2e2bcd8739ae039), {
        color: "inherit"
    })), /*#__PURE__*/ $8FY87.createElement((0, $74b90a6f08eb2e78$export$8b251419efc915eb), null), /*#__PURE__*/ $8FY87.createElement("section", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).contentContaienr} flex justify-start`
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).leftContent} hidden md:inline-block`
    }, /*#__PURE__*/ $8FY87.createElement("img", {
        src: (parcelRequire("3DtD5")),
        className: "hidden xl:block"
    }), /*#__PURE__*/ $8FY87.createElement("img", {
        src: (parcelRequire("3DtD5")),
        className: "small-img xl:hidden"
    })), /*#__PURE__*/ $8FY87.createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).content} md:flex md:flex-col`
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).formContainer}`
    }, /*#__PURE__*/ $8FY87.createElement("h1", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).loginHeading} mt-1 md:mt-8 lg:mt-16 mb-8`
    }, "Reset password", " "), /*#__PURE__*/ $8FY87.createElement("p", {
        className: "text-base font-normal max-w-80"
    }, "Enter a new password for your account", userEmail ? ` ${userEmail}` : "."), /*#__PURE__*/ $8FY87.createElement("div", null, /*#__PURE__*/ $8FY87.createElement("form", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).loginForm}`,
        onSubmit: (e)=>{
            onUpdatePassword(e, formData);
        }
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).emailRow} flex flex-col`
    }, /*#__PURE__*/ $8FY87.createElement("label", {
        htmlFor: "email"
    }, "Password"), /*#__PURE__*/ $8FY87.createElement((0, $1587b7eed37887b9$export$2e2bcd8739ae039), {
        sx: {
            position: "relative"
        }
    }, /*#__PURE__*/ $8FY87.createElement((0, $3247b0fca8a83d17$export$2e2bcd8739ae039), {
        type: showPassword ? "text" : "password",
        id: "password",
        placeholder: "Enter password",
        value: formData.password,
        onChange: handleChange,
        endAdornment: /*#__PURE__*/ $8FY87.createElement((0, $8765ef9b64e3c3e6$export$2e2bcd8739ae039), {
            className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).passwordEye}`,
            sx: {
                position: "absolute",
                right: "20px",
                width: "20px",
                padding: "0px",
                top: "13px"
            },
            "aria-label": showPassword ? "hide the password" : "display the password",
            onClick: handleClickShowPassword,
            onMouseDown: (event)=>event.preventDefault(),
            onMouseUp: (event)=>event.preventDefault(),
            edge: "end"
        }, showPassword ? /*#__PURE__*/ $8FY87.createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($a0b75bc48280325d$exports))),
            alt: "hide password"
        }) : /*#__PURE__*/ $8FY87.createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($771c5082acf6b713$exports))),
            alt: "show password"
        })),
        sx: {
            "&:before": {
                borderBottom: "none"
            },
            "&:after": {
                borderBottom: "none"
            },
            "&:hover:not(.Mui-disabled):before": {
                borderBottom: "none"
            },
            // Placeholder styling
            "& input::placeholder": {
                color: "#3B3B3B99",
                fontWeight: "300",
                opacity: 1
            },
            ...formErrors.password !== "" && {
                "& input": {
                    borderColor: "#ef4444"
                }
            }
        }
    })), formErrors.password !== "" && /*#__PURE__*/ $8FY87.createElement("label", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).errorLabels}`
    }, formErrors.password)), /*#__PURE__*/ $8FY87.createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).emailRow} flex flex-col`
    }, /*#__PURE__*/ $8FY87.createElement("label", {
        htmlFor: "email"
    }, "Confirm password"), /*#__PURE__*/ $8FY87.createElement((0, $1587b7eed37887b9$export$2e2bcd8739ae039), {
        sx: {
            position: "relative"
        }
    }, /*#__PURE__*/ $8FY87.createElement((0, $3247b0fca8a83d17$export$2e2bcd8739ae039), {
        type: showRePassword ? "text" : "password",
        id: "rePassword",
        placeholder: "Enter password",
        value: formData.rePassword,
        onChange: handleChange,
        endAdornment: /*#__PURE__*/ $8FY87.createElement((0, $8765ef9b64e3c3e6$export$2e2bcd8739ae039), {
            className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).passwordEye}`,
            sx: {
                position: "absolute",
                right: "20px",
                width: "20px",
                padding: "0px",
                top: "13px"
            },
            "aria-label": showRePassword ? "hide the password" : "display the password",
            onClick: handleClickShowRePassword,
            onMouseDown: (event)=>event.preventDefault(),
            onMouseUp: (event)=>event.preventDefault(),
            edge: "end"
        }, showRePassword ? /*#__PURE__*/ $8FY87.createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($a0b75bc48280325d$exports))),
            alt: "hide password"
        }) : /*#__PURE__*/ $8FY87.createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($771c5082acf6b713$exports))),
            alt: "show password"
        })),
        sx: {
            "&:before": {
                borderBottom: "none"
            },
            "&:after": {
                borderBottom: "none"
            },
            "&:hover:not(.Mui-disabled):before": {
                borderBottom: "none"
            },
            // Placeholder styling
            "& input::placeholder": {
                color: "#3B3B3B99",
                fontWeight: "300",
                opacity: 1
            },
            ...formErrors.rePassword !== "" && {
                "& input": {
                    borderColor: "#ef4444"
                }
            }
        }
    })), formErrors.rePassword !== "" && /*#__PURE__*/ $8FY87.createElement("label", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).errorLabels}`
    }, formErrors.rePassword)), errorMessage !== "" && /*#__PURE__*/ $8FY87.createElement("span", {
        className: "flex text-center mb-2"
    }, /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1c1878fa3817abc$exports))), {
        fontSize: "small",
        sx: {
            color: "red"
        }
    }), /*#__PURE__*/ $8FY87.createElement("label", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).errorLabelForm} `
    }, errorMessage)), /*#__PURE__*/ $8FY87.createElement("button", {
        // onClick={onUpdatePassword}
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).primaryBtn} ${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).loginBtn} ${isFormInvalid ? "opacity-50 cursor-not-allowed" : ""}`,
        disabled: isFormInvalid
    }, "RESET PASSWORD"), /*#__PURE__*/ $8FY87.createElement("div", {
        style: {
            textAlign: "center",
            marginTop: "16px"
        }
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).dontHaveAccount} font-normal mr-1`
    }, "Do you remember your password?"), /*#__PURE__*/ $8FY87.createElement((0, $734169eef5d6795a$export$a6c7ac8248d6e38a), {
        to: "/login",
        className: "text-sm text-[#243460] font-semibold",
        style: {
            textDecoration: "none"
        }
    }, "Login"))))))), /*#__PURE__*/ $8FY87.createElement((0, $0a87a32205fa1e51$export$2e2bcd8739ae039), null)), /*#__PURE__*/ $8FY87.createElement((0, $fdcc8de0ec44fdd8$export$2e2bcd8739ae039), null));
};
var $80eda53f5bf416c9$export$2e2bcd8739ae039 = $80eda53f5bf416c9$var$ResetPassword;



const $9bc36596a13505af$export$da4433e8d8a5678 = ()=>{
    return /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, null, /*#__PURE__*/ $8FY87.createElement((0, $274ffc8236991365$export$dcef8f9bb9a41431), null, /*#__PURE__*/ $8FY87.createElement("title", null, "RocketPages - Reset Password"), /*#__PURE__*/ $8FY87.createElement("meta", {
        name: "description",
        content: "Build and Launch Your Free Website in Just 15 Minutes"
    }), /*#__PURE__*/ $8FY87.createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap",
        rel: "stylesheet"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "icon",
        href: "/favicon.ico"
    }), false), /*#__PURE__*/ $8FY87.createElement((0, $9ada84cce5691847$export$2e2bcd8739ae039), null), /*#__PURE__*/ $8FY87.createElement((0, $80eda53f5bf416c9$export$2e2bcd8739ae039), null));
};



var $8FY87 = parcelRequire("8FY87");







var $8FY87 = parcelRequire("8FY87");















function $d0e3ba5864b7e773$var$useQuery() {
    const { search: search } = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useMemo(()=>new URLSearchParams(search), [
        search
    ]);
}
function $d0e3ba5864b7e773$var$checkIsInFrame() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}




const $d0e3ba5864b7e773$var$Signup = ()=>{
    const [showPassword, setShowPassword] = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useState(false);
    const [showRePassword, setShowRePassword] = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useState(false);
    const handleClickShowPassword = ()=>setShowPassword((show)=>!show);
    const handleClickShowRePassword = ()=>setShowRePassword((show)=>!show);
    const isInIframe = $d0e3ba5864b7e773$var$checkIsInFrame();
    const [errorMessage, setErrorMessage] = (0, $8FY87.useState)("");
    const [errorMessageSocial, setErrorMessageSocial] = (0, $8FY87.useState)("");
    const { search: search } = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)();
    let query = $d0e3ba5864b7e773$var$useQuery();
    let l_redirecturl = query.get("redirecturl");
    let l_userId = query.get("userId");
    let l_siteId = query.get("siteId");
    const navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    const [cookies, setCookie, removeCookie] = (0, $1f373de1ceea6eb7$export$2e2bcd8739ae039)([
        "rp_access_token"
    ]);
    const [isLoading, setIsLoading] = (0, $8FY87.useState)(false);
    const { linkedInLogin: linkedInLogin } = (0, $c87118bc1c828d28$export$798996ac402ec5d0)({
        clientId: "86q0502we7bi54",
        scope: "email profile openid",
        redirectUri: "https://app.rocketpages.io/linkedin",
        onSuccess: (code)=>{
            onCreateAccountLinkedIn(code);
        // console.log("onSuccess", code);
        },
        onError: (error)=>{
            console.log(error);
        }
    });
    const [formData, setFormData] = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useState({
        email: "",
        password: "",
        rePassword: ""
    });
    const [formErrors, setFormErrors] = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useState({
        email: "",
        password: "",
        rePassword: ""
    });
    function isValidEmail(email) {
        // Regular expression for basic email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        return emailRegex.test(email);
    }
    function validateForm(formData) {
        try {
            setFormErrors({
                email: "",
                password: "",
                rePassword: ""
            });
            if (formData.email === "") {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        email: "Email can not be empty."
                    };
                });
                return false;
            }
            if (!isValidEmail(formData.email)) {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        email: "Invalid email address."
                    };
                });
                return false;
            }
            if (formData.password.length < 8) {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        password: "Password length can not be less than 8 chars."
                    };
                });
                return false;
            }
            if (formData.password === "") {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        password: "Password can not be empty."
                    };
                });
                return false;
            }
            if (formData.rePassword === "") {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        rePassword: "Confirm password can not be empty."
                    };
                });
                return false;
            }
            if (formData.password !== formData.rePassword) {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        rePassword: "Confirm password does not match password."
                    };
                });
                return false;
            }
            return true;
        } catch (err) {
            return false;
        }
    }
    async function onCreateAccountEmail(e) {
        e.preventDefault();
        if (!validateForm(formData)) return;
        setIsLoading(true);
        try {
            let data = {
                signupMode: "email",
                email: formData.email,
                password: formData.password,
                rp_user_id: l_userId,
                rp_site_id: l_siteId
            };
            let res = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post("api/signup", data);
            setIsLoading(false);
            if (isInIframe) {
                parent.postMessage("auth:reload", "*");
                return;
            }
            if (l_redirecturl !== undefined && l_redirecturl !== "" && l_redirecturl !== null) window.location.href = `${l_redirecturl}`;
            else navigate("/dashboard", {
                state: {
                    token: res.data.token,
                    user: res.data
                }
            });
        } catch (err) {
            setIsLoading(false);
            setErrorMessage(err.response.data.message);
        }
    }
    async function onCreateAccountGoogle(googleCred) {
        setIsLoading(true);
        try {
            let data = {
                signupMode: "google",
                token: googleCred.credential,
                rp_user_id: l_userId,
                rp_site_id: l_siteId
            };
            let res = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post("api/signup", data);
            setIsLoading(false);
            if (isInIframe) {
                parent.postMessage("auth:reload", "*");
                return;
            }
            if (l_redirecturl !== undefined && l_redirecturl !== "" && l_redirecturl !== null) window.location.href = `${l_redirecturl}`;
            else navigate("/dashboard", {
                state: {
                    token: res.data.token,
                    user: res.data
                }
            });
        } catch (err) {
            setIsLoading(false);
            setErrorMessageSocial(err.response.data.message);
        }
    }
    async function onCreateAccountLinkedIn(authCode) {
        setIsLoading(true);
        try {
            let data = {
                signupMode: "linkedIn",
                authCode: authCode,
                rp_user_id: l_userId,
                rp_site_id: l_siteId
            };
            let res = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post("api/signup", data);
            setIsLoading(false);
            if (isInIframe) {
                parent.postMessage("auth:reload", "*");
                return;
            }
            if (l_redirecturl !== undefined && l_redirecturl !== "" && l_redirecturl !== null) window.location.href = `${l_redirecturl}`;
            else navigate("/dashboard", {
                state: {
                    token: res.data.token,
                    user: res.data
                }
            });
        } catch (err) {
            setIsLoading(false);
            setErrorMessageSocial(err.response.data.message);
        }
    }
    function handleChange(event) {
        setFormData((old)=>{
            return {
                ...old,
                [event.target.id]: event.target.value.trim()
            };
        });
        setErrorMessage("");
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("main", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).signup}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $56dcde36b8493878$export$2e2bcd8739ae039), {
        sx: {
            color: "#fff",
            zIndex: (theme)=>theme.zIndex.drawer + 1
        },
        open: isLoading,
        invisible: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $b391f94ee7b6de9b$export$2e2bcd8739ae039), {
        color: "info"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $74b90a6f08eb2e78$export$8b251419efc915eb), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("section", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).contentContaienr} flex justify-start`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).leftContent} hidden md:inline-block`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("img", {
        src: (parcelRequire("3DtD5")),
        className: "hidden xl:block"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("img", {
        src: (parcelRequire("3DtD5")),
        className: "small-img xl:hidden"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).content} md:flex md:flex-col ${isInIframe ? (0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).nopadding : ""}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).formContainer}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("h2", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).loginHeading} mt-1 md:mt-8 lg:mt-16 mb-8`
    }, "Create your account"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("form", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).loginForm}`,
        onSubmit: onCreateAccountEmail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).emailRow} flex flex-col`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        htmlFor: "email"
    }, "Email"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("input", {
        type: "email",
        id: "email",
        placeholder: "Enter email address",
        value: formData.email,
        onChange: handleChange,
        className: `${formErrors.email !== "" ? "border-red-500" : ""}`
    }), formErrors.email !== "" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).errorLabels}`
    }, formErrors.email)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).passwordRow} flex flex-col`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        htmlFor: "password"
    }, "Password"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $1587b7eed37887b9$export$2e2bcd8739ae039), {
        sx: {
            position: "relative"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $3247b0fca8a83d17$export$2e2bcd8739ae039), {
        type: showPassword ? "text" : "password",
        id: "password",
        placeholder: "Enter password",
        value: formData.password,
        onChange: handleChange,
        endAdornment: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $8765ef9b64e3c3e6$export$2e2bcd8739ae039), {
            className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).passwordEye}`,
            sx: {
                position: "absolute",
                right: "20px",
                width: "20px",
                padding: "0px",
                top: "13px"
            },
            "aria-label": showPassword ? "hide the password" : "display the password",
            onClick: handleClickShowPassword,
            onMouseDown: (event)=>event.preventDefault(),
            onMouseUp: (event)=>event.preventDefault(),
            edge: "end"
        }, showPassword ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($a0b75bc48280325d$exports))),
            alt: "hide password"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($771c5082acf6b713$exports))),
            alt: "show password"
        })),
        sx: {
            "&:before": {
                borderBottom: "none"
            },
            "&:after": {
                borderBottom: "none"
            },
            "&:hover:not(.Mui-disabled):before": {
                borderBottom: "none"
            },
            // Placeholder styling
            "& input::placeholder": {
                color: "#3B3B3B99",
                fontWeight: "300",
                opacity: 1
            },
            ...formErrors.password !== "" && {
                "& input": {
                    borderColor: "#ef4444"
                }
            }
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).inputMessage} text-[12px] leading-[14px] mb-0`
    }, "Must have atleast 8 Characters"), formErrors.password !== "" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).errorLabels}`
    }, formErrors.password)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).passwordRow} flex flex-col`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        htmlFor: "rePassword"
    }, "Confirm password"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $1587b7eed37887b9$export$2e2bcd8739ae039), {
        sx: {
            position: "relative"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $3247b0fca8a83d17$export$2e2bcd8739ae039), {
        type: showRePassword ? "text" : "password",
        id: "rePassword",
        placeholder: "Enter password",
        value: formData.rePassword,
        onChange: handleChange,
        endAdornment: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $8765ef9b64e3c3e6$export$2e2bcd8739ae039), {
            className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).passwordEye}`,
            sx: {
                position: "absolute",
                right: "20px",
                width: "20px",
                padding: "0px",
                top: "13px"
            },
            "aria-label": showRePassword ? "hide the password" : "display the password",
            onClick: handleClickShowRePassword,
            onMouseDown: (event)=>event.preventDefault(),
            onMouseUp: (event)=>event.preventDefault(),
            edge: "end"
        }, showRePassword ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($a0b75bc48280325d$exports))),
            alt: "hide password"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($771c5082acf6b713$exports))),
            alt: "show password"
        })),
        sx: {
            "&:before": {
                borderBottom: "none"
            },
            "&:after": {
                borderBottom: "none"
            },
            "&:hover:not(.Mui-disabled):before": {
                borderBottom: "none"
            },
            // Placeholder styling
            "& input::placeholder": {
                color: "#3B3B3B99",
                fontWeight: "300",
                opacity: 1
            },
            ...formErrors.rePassword !== "" && {
                "& input": {
                    borderColor: "#ef4444"
                }
            }
        }
    })), formErrors.rePassword !== "" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).errorLabels}`
    }, formErrors.rePassword)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).inputMessage} text-[12px] leading-[14px] mb-1`
    }, "*By signing up, you agree to the", " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $734169eef5d6795a$export$a6c7ac8248d6e38a), {
        to: "https://rocketpages.io/terms-and-conditions",
        target: "_blank",
        className: "underline text-black"
    }, "terms of service"), " ", "and", " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $734169eef5d6795a$export$a6c7ac8248d6e38a), {
        to: "https://rocketpages.io/privacy-policy",
        target: "_blank",
        className: "underline text-black"
    }, "privacy policy")), errorMessage !== "" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
        className: "flex text-center mb-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1c1878fa3817abc$exports))), {
        fontSize: "small",
        sx: {
            color: "red"
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).errorLabelForm} `
    }, errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("button", {
        type: "submit",
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).primaryBtn} ${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).loginBtn}`
    }, "Create Account")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).seperator} flex items-center pt-8`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).seperatorLine}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).seperatorText}`
    }, "Or Login with", " "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).seperatorLine}`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).socialSection} flex justify-center gap-8`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).googleIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("img", {
        src: (parcelRequire("inEQW")),
        alt: "Google",
        style: {
            width: 32,
            height: 32,
            pointerEvents: "none"
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).googleIframeOverlay
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $e7ed5c4b4f4b44fc$export$a795a627e512102a), {
        onSuccess: async (credentialResponse)=>onCreateAccountGoogle(credentialResponse),
        type: "icon",
        shape: "square",
        size: "large",
        width: "40",
        onError: ()=>{
            console.log("Login Failed");
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).socialIcons}`,
        onClick: linkedInLogin
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("img", {
        src: (parcelRequire("gl0e6"))
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex justify-center py-2"
    }, errorMessageSocial !== "" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
        className: "flex text-center mb-2 items-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1c1878fa3817abc$exports))), {
        fontSize: "small",
        sx: {
            color: "red"
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).errorLabelForm} `
    }, errorMessageSocial))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $b19176bd78e1869f$export$2e2bcd8739ae039), {
        sx: {
            justifyContent: "center",
            display: {
                xs: "flex",
                lg: "none"
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).dontHaveAccount} font-normal mr-1`
    }, "Have an account?"), isInIframe ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $734169eef5d6795a$export$a6c7ac8248d6e38a), {
        to: {
            pathname: "/login",
            search: `?userId=${l_userId}&siteId=${l_siteId}`
        },
        className: "text-sm text-[#243460] font-semibold"
    }, "Login") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $734169eef5d6795a$export$a6c7ac8248d6e38a), {
        to: `/login${search}`,
        className: "text-sm text-[#243460] font-semibold"
    }, "Login"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).dontHaveAccount} font-normal`
    }, ".")))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $0a87a32205fa1e51$export$2e2bcd8739ae039), null)), !isInIframe && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $fdcc8de0ec44fdd8$export$2e2bcd8739ae039), null));
};
var $d0e3ba5864b7e773$export$2e2bcd8739ae039 = $d0e3ba5864b7e773$var$Signup;



const $c7ec45247ad7ac2c$export$a2f4b65ede167ce5 = ()=>{
    const navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    const location = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)();
    const [cookie, setCookie, removeCookie] = (0, $1f373de1ceea6eb7$export$2e2bcd8739ae039)([
        "rp_user_data"
    ]);
    (0, $8FY87.useEffect)(()=>{
        if (location.state && location.state.removeCookies) removeCookie("rp_user_data");
        else if (cookie.rp_user_data) navigate("/dashboard");
    // console.log('LoginPage -> props.removeCookies',location.state)
    }, []);
    return /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, null, /*#__PURE__*/ $8FY87.createElement((0, $274ffc8236991365$export$dcef8f9bb9a41431), null, /*#__PURE__*/ $8FY87.createElement("title", null, "RocketPages - Signup"), /*#__PURE__*/ $8FY87.createElement("meta", {
        name: "description",
        content: "Build and Launch Your Free Website in Just 15 Minutes"
    }), /*#__PURE__*/ $8FY87.createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap",
        rel: "stylesheet"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "icon",
        href: "/favicon.ico"
    }), false), /*#__PURE__*/ $8FY87.createElement((0, $9ada84cce5691847$export$2e2bcd8739ae039), null), /*#__PURE__*/ $8FY87.createElement((0, $d0e3ba5864b7e773$export$2e2bcd8739ae039), null));
};







var $8FY87 = parcelRequire("8FY87");



var $52ca409747836a2e$exports = {};
/**
 * Created by Samuel on 6/4/2016.
 * Simple wrapper functions to produce shorter UUIDs for cookies, maybe everything?
 */ const $3d009f73c3d55c65$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $3d009f73c3d55c65$export$2e2bcd8739ae039 = {
    randomUUID: $3d009f73c3d55c65$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $bd0b1b99a1c4101f$var$getRandomValues;
const $bd0b1b99a1c4101f$var$rnds8 = new Uint8Array(16);
function $bd0b1b99a1c4101f$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$bd0b1b99a1c4101f$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $bd0b1b99a1c4101f$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$bd0b1b99a1c4101f$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $bd0b1b99a1c4101f$var$getRandomValues($bd0b1b99a1c4101f$var$rnds8);
}


var $a2440d684776c94a$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $80288f08856c03d1$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $a2440d684776c94a$export$2e2bcd8739ae039).test(uuid);
}
var $80288f08856c03d1$export$2e2bcd8739ae039 = $80288f08856c03d1$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $dedc62d279de0424$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$dedc62d279de0424$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $dedc62d279de0424$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $dedc62d279de0424$var$byteToHex[arr[offset + 0]] + $dedc62d279de0424$var$byteToHex[arr[offset + 1]] + $dedc62d279de0424$var$byteToHex[arr[offset + 2]] + $dedc62d279de0424$var$byteToHex[arr[offset + 3]] + '-' + $dedc62d279de0424$var$byteToHex[arr[offset + 4]] + $dedc62d279de0424$var$byteToHex[arr[offset + 5]] + '-' + $dedc62d279de0424$var$byteToHex[arr[offset + 6]] + $dedc62d279de0424$var$byteToHex[arr[offset + 7]] + '-' + $dedc62d279de0424$var$byteToHex[arr[offset + 8]] + $dedc62d279de0424$var$byteToHex[arr[offset + 9]] + '-' + $dedc62d279de0424$var$byteToHex[arr[offset + 10]] + $dedc62d279de0424$var$byteToHex[arr[offset + 11]] + $dedc62d279de0424$var$byteToHex[arr[offset + 12]] + $dedc62d279de0424$var$byteToHex[arr[offset + 13]] + $dedc62d279de0424$var$byteToHex[arr[offset + 14]] + $dedc62d279de0424$var$byteToHex[arr[offset + 15]];
}
function $dedc62d279de0424$var$stringify(arr, offset = 0) {
    const uuid = $dedc62d279de0424$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $80288f08856c03d1$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $dedc62d279de0424$export$2e2bcd8739ae039 = $dedc62d279de0424$var$stringify;


function $674b3d77ec11b4a3$var$v4(options, buf, offset) {
    if ((0, $3d009f73c3d55c65$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $3d009f73c3d55c65$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $bd0b1b99a1c4101f$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $dedc62d279de0424$export$8fb373d660548968)(rnds);
}
var $674b3d77ec11b4a3$export$2e2bcd8739ae039 = $674b3d77ec11b4a3$var$v4;


var $52ca409747836a2e$require$uuidV4 = $674b3d77ec11b4a3$export$2e2bcd8739ae039;
var $52ca409747836a2e$require$uuidValidate = $80288f08856c03d1$export$2e2bcd8739ae039;
var $d7a835a3caf44d79$exports = {};
var $04109c4dc0e431f4$exports = {};
'use strict';
/**
 * Converter
 *
 * @param {string|Array} srcAlphabet
 * @param {string|Array} dstAlphabet
 * @constructor
 */ function $04109c4dc0e431f4$var$Converter(srcAlphabet, dstAlphabet) {
    if (!srcAlphabet || !dstAlphabet || !srcAlphabet.length || !dstAlphabet.length) throw new Error('Bad alphabet');
    this.srcAlphabet = srcAlphabet;
    this.dstAlphabet = dstAlphabet;
}
/**
 * Convert number from source alphabet to destination alphabet
 *
 * @param {string|Array} number - number represented as a string or array of points
 *
 * @returns {string|Array}
 */ $04109c4dc0e431f4$var$Converter.prototype.convert = function(number) {
    var i, divide, newlen, numberMap = {}, fromBase = this.srcAlphabet.length, toBase = this.dstAlphabet.length, length = number.length, result = typeof number === 'string' ? '' : [];
    if (!this.isValid(number)) throw new Error('Number "' + number + '" contains of non-alphabetic digits (' + this.srcAlphabet + ')');
    if (this.srcAlphabet === this.dstAlphabet) return number;
    for(i = 0; i < length; i++)numberMap[i] = this.srcAlphabet.indexOf(number[i]);
    do {
        divide = 0;
        newlen = 0;
        for(i = 0; i < length; i++){
            divide = divide * fromBase + numberMap[i];
            if (divide >= toBase) {
                numberMap[newlen++] = parseInt(divide / toBase, 10);
                divide = divide % toBase;
            } else if (newlen > 0) numberMap[newlen++] = 0;
        }
        length = newlen;
        result = this.dstAlphabet.slice(divide, divide + 1).concat(result);
    }while (newlen !== 0);
    return result;
};
/**
 * Valid number with source alphabet
 *
 * @param {number} number
 *
 * @returns {boolean}
 */ $04109c4dc0e431f4$var$Converter.prototype.isValid = function(number) {
    var i = 0;
    for(; i < number.length; ++i){
        if (this.srcAlphabet.indexOf(number[i]) === -1) return false;
    }
    return true;
};
$04109c4dc0e431f4$exports = $04109c4dc0e431f4$var$Converter;


/**
 * Function get source and destination alphabet and return convert function
 *
 * @param {string|Array} srcAlphabet
 * @param {string|Array} dstAlphabet
 *
 * @returns {function(number|Array)}
 */ function $d7a835a3caf44d79$var$anyBase(srcAlphabet, dstAlphabet) {
    var converter = new $04109c4dc0e431f4$exports(srcAlphabet, dstAlphabet);
    /**
     * Convert function
     *
     * @param {string|Array} number
     *
     * @return {string|Array} number
     */ return function(number) {
        return converter.convert(number);
    };
}
$d7a835a3caf44d79$var$anyBase.BIN = '01';
$d7a835a3caf44d79$var$anyBase.OCT = '01234567';
$d7a835a3caf44d79$var$anyBase.DEC = '0123456789';
$d7a835a3caf44d79$var$anyBase.HEX = '0123456789abcdef';
$d7a835a3caf44d79$exports = $d7a835a3caf44d79$var$anyBase;


const $52ca409747836a2e$var$constants = {
    cookieBase90: "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ!#$%&'()*+-./:<=>?@[]^_`{|}~",
    flickrBase58: '123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ',
    uuid25Base36: '0123456789abcdefghijklmnopqrstuvwxyz'
};
const $52ca409747836a2e$var$baseOptions = {
    consistentLength: true
};
// A default generator, instantiated only if used.
let $52ca409747836a2e$var$toFlickr;
/**
 * Takes a UUID, strips the dashes, and translates.
 * @param {string} longId
 * @param {function(string):string} translator
 * @param {Object} [paddingParams]
 * @returns {string}
 */ const $52ca409747836a2e$var$shortenUUID = (longId, translator, paddingParams)=>{
    const translated = translator(longId.toLowerCase().replace(/-/g, ''));
    if (!paddingParams || !paddingParams.consistentLength) return translated;
    return translated.padStart(paddingParams.shortIdLength, paddingParams.paddingChar);
};
/**
 * Translate back to hex and turn back into UUID format, with dashes
 * @param {string} shortId
 * @param {function(string)} translator
 * @returns {string}
 */ const $52ca409747836a2e$var$enlargeUUID = (shortId, translator)=>{
    const uu1 = translator(shortId).padStart(32, '0');
    // Join the zero padding and the UUID and then slice it up with match
    const m = uu1.match(/(\w{8})(\w{4})(\w{4})(\w{4})(\w{12})/);
    // Accumulate the matches and join them.
    return [
        m[1],
        m[2],
        m[3],
        m[4],
        m[5]
    ].join('-');
};
/**
 * Calculate length for the shortened ID
 * @param {number} alphabetLength
 * @returns {number}
 */ const $52ca409747836a2e$var$getShortIdLength = (alphabetLength)=>Math.ceil(Math.log(2 ** 128) / Math.log(alphabetLength));
$52ca409747836a2e$exports = (()=>{
    /**
   * @param {string} toAlphabet
   * @param {{ consistentLength: boolean }} [options]
   * @returns {{
   *  alphabet: string,
   *  fromUUID: (function(*): string),
   *  generate: (function(): string),
   *  maxLength: number,
   *  new: (function(): string),
   *  toUUID: (function(*): string),
   *  uuid: ((function(*, *, *): (*))|*),
   *  validate: ((function(*, boolean=false): (boolean))|*)}}
   */ const makeConvertor = (toAlphabet, options)=>{
        // Default to Flickr 58
        const useAlphabet = toAlphabet || $52ca409747836a2e$var$constants.flickrBase58;
        // Default to baseOptions
        const selectedOptions = {
            ...$52ca409747836a2e$var$baseOptions,
            ...options
        };
        // Check alphabet for duplicate entries
        if ([
            ...new Set(Array.from(useAlphabet))
        ].length !== useAlphabet.length) throw new Error('The provided Alphabet has duplicate characters resulting in unreliable results');
        const shortIdLength = $52ca409747836a2e$var$getShortIdLength(useAlphabet.length);
        // Padding Params
        const paddingParams = {
            shortIdLength: shortIdLength,
            consistentLength: selectedOptions.consistentLength,
            paddingChar: useAlphabet[0]
        };
        // UUIDs are in hex, so we translate to and from.
        const fromHex = $d7a835a3caf44d79$exports($d7a835a3caf44d79$exports.HEX, useAlphabet);
        const toHex = $d7a835a3caf44d79$exports(useAlphabet, $d7a835a3caf44d79$exports.HEX);
        /**
     * @returns {string} - short id
     */ const generate = ()=>$52ca409747836a2e$var$shortenUUID($52ca409747836a2e$require$uuidV4(), fromHex, paddingParams);
        /**
     * Confirm if string is a valid id. Checks length and alphabet.
     * If the second parameter is true it will translate to standard UUID
     *  and check the result for UUID validity.
     * @param {string} shortId - The string to check for validity
     * @param {boolean} [rigorous=false] - If true, also check for a valid UUID
     * @returns {boolean}
     */ const validate = (shortId, rigorous = false)=>{
            if (!shortId || typeof shortId !== 'string') return false;
            const isCorrectLength = selectedOptions.consistentLength ? shortId.length === shortIdLength : shortId.length <= shortIdLength;
            const onlyAlphabet = shortId.split('').every((letter)=>useAlphabet.includes(letter));
            if (rigorous === false) return isCorrectLength && onlyAlphabet;
            return isCorrectLength && onlyAlphabet && $52ca409747836a2e$require$uuidValidate($52ca409747836a2e$var$enlargeUUID(shortId, toHex));
        };
        const translator = {
            alphabet: useAlphabet,
            fromUUID: (uuid)=>$52ca409747836a2e$var$shortenUUID(uuid, fromHex, paddingParams),
            maxLength: shortIdLength,
            generate: generate,
            new: generate,
            toUUID: (shortUuid)=>$52ca409747836a2e$var$enlargeUUID(shortUuid, toHex),
            uuid: $52ca409747836a2e$require$uuidV4,
            validate: validate
        };
        Object.freeze(translator);
        return translator;
    };
    // Expose the constants for other purposes.
    makeConvertor.constants = $52ca409747836a2e$var$constants;
    // Expose the generic v4 UUID generator for convenience
    makeConvertor.uuid = $52ca409747836a2e$require$uuidV4;
    // Provide a generic generator
    makeConvertor.generate = ()=>{
        if (!$52ca409747836a2e$var$toFlickr) // Generate on first use;
        $52ca409747836a2e$var$toFlickr = makeConvertor($52ca409747836a2e$var$constants.flickrBase58).generate;
        return $52ca409747836a2e$var$toFlickr();
    };
    return makeConvertor;
})();






var $8FY87 = parcelRequire("8FY87");




function $e9e435d08b475b0d$export$2e2bcd8739ae039(props) {
    const handleChange = (event)=>{
        const { target: { value: value } } = event;
        props.handleChange(value);
    };
    return /*#__PURE__*/ $8FY87.createElement("div", null, /*#__PURE__*/ $8FY87.createElement((0, $1587b7eed37887b9$export$2e2bcd8739ae039), {
        sx: {
            width: 280
        },
        size: "small"
    }, /*#__PURE__*/ $8FY87.createElement((0, $3870ce6a881320cb$export$2e2bcd8739ae039), {
        id: "demo-simple-select-label",
        className: "text-catelina-blue text-base"
    }, "Sections"), /*#__PURE__*/ $8FY87.createElement((0, $5fa08250992d1a88$export$2e2bcd8739ae039), {
        labelId: "demo-simple-select-label",
        id: "demo-simple-select",
        label: "Sections",
        value: props.category,
        onChange: handleChange,
        className: "text-base text-sm"
    }, props.items.map((item, index)=>/*#__PURE__*/ $8FY87.createElement((0, $ee9f19037253b32c$export$2e2bcd8739ae039), {
            sx: {
                fontSize: '16px'
            },
            value: item,
            key: index
        }, item)))));
}



var $8FY87 = parcelRequire("8FY87");

var $8FY87 = parcelRequire("8FY87");









var $8FY87 = parcelRequire("8FY87");
const $2c4dcb93a6923b62$var$Modal = ({ isOpen: isOpen, onClose: onClose, children: children })=>{
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "fixed inset-0 bg-gray-800 bg-opacity-75 flex justify-center items-center z-[999]"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "bg-white  w-[95vw] h-[95vh] rounded-lg overflow-hidden shadow-xl flex flex-col"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex-grow overflow-auto"
    }, children)));
};
var $2c4dcb93a6923b62$export$2e2bcd8739ae039 = $2c4dcb93a6923b62$var$Modal;







const $4d9d5f5bbbfa7366$var$ImagePicker = (props)=>{
    const [file, setFile] = $8FY87.useState(props.image_url);
    const inputFile = $8FY87.useRef(null);
    const [isLoading, setIsLoading] = $8FY87.useState(false);
    const [isModalOpen, setModalOpen] = $8FY87.useState(false);
    $8FY87.useEffect(()=>{
        setFile(props.image_url);
    // console.log('props.image_url', props.image_url);
    }, [
        props.image_url
    ]);
    const handleChange = async (e)=>{
        setIsLoading(true);
        try {
            let formData = new FormData(); // instantiate it
            // suppose you have your file ready
            formData.set("file", e.target.files[0]);
            formData.set("siteId", props.siteId);
            // formData.set('data1', dataInputField1); // suppose you got dataInputField1 from your HTML5 form input
            // console.log("axiosInstance", axiosInstance);
            // const axiosI = new axios.create({
            //   baseURL: process.env.API_ENDPOINT,
            // });
            let res = await (0, $bf5b93105d90423b$export$2e2bcd8739ae039).post(`${"https://api.rocketpages.io"}/${"upload/image"}`, formData, {
                headers: {
                    "content-type": "multipart/form-data"
                },
                maxRedirects: 200
            });
            setFile(res.data.url);
            setIsLoading(false);
            props.onImageChange(res.data.url);
            e.target.value = "";
        } catch (err) {
            console.log(err);
            setIsLoading(false);
        }
    };
    return /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col text-black"
    }, /*#__PURE__*/ $8FY87.createElement((0, $2c4dcb93a6923b62$export$2e2bcd8739ae039), {
        isOpen: isModalOpen,
        onClose: ()=>setModalOpen(false)
    }, /*#__PURE__*/ $8FY87.createElement((0, $4a7775f76d2692f7$export$2e2bcd8739ae039), {
        isBlog: props.isBlog,
        siteId: props.siteId,
        onClose: ()=>setModalOpen(false),
        onChange: (url)=>{
            setFile(url);
            props.onImageChange(url);
            setModalOpen(false);
        }
    })), props.title && /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-base-2 mb-2"
    }, props.title), props.desc && /*#__PURE__*/ $8FY87.createElement("span", {
        className: "font-normal mb-2"
    }, props.desc), /*#__PURE__*/ $8FY87.createElement("div", {
        className: `w-full border border-catelina-blue/60 rounded flex flex-col ${props.size === "small" ? "h-40 md:w-48" : props.size === "full" ? "w-full" : "h-60 md:w-80"} `
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "border-b border-catelina-blue/60  h-10 flex flex-row justify-end items-center px-2"
    }, /*#__PURE__*/ $8FY87.createElement((0, $56dcde36b8493878$export$2e2bcd8739ae039), {
        sx: {
            color: "#fff",
            zIndex: (theme)=>theme.zIndex.drawer + 1
        },
        open: isLoading
    }, /*#__PURE__*/ $8FY87.createElement((0, $b391f94ee7b6de9b$export$2e2bcd8739ae039), {
        color: "inherit"
    })), /*#__PURE__*/ $8FY87.createElement("input", {
        className: "hidden",
        type: "file",
        onChange: handleChange,
        ref: inputFile
    }), /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($a21539592a8d5049$exports))), {
        className: "text-catelina-blue mr-2 hover:cursor-pointer edit-image",
        fontSize: "small",
        onClick: ()=>{
            setModalOpen(true);
        // inputFile.current.click()
        }
    }), /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cdf61693620224dc$exports))), {
        className: "text-catelina-blue hover:cursor-pointer",
        fontSize: "small",
        onClick: ()=>{
            setFile("");
            props.onImageChange && props.onImageChange("");
        }
    }), /*#__PURE__*/ $8FY87.createElement("img", {
        className: "text-catelina-blue mr-2 hover:cursor-pointer ml-2",
        width: "18",
        src: (parcelRequire("iAm4v")),
        onClick: ()=>{
            setModalOpen(true);
        }
    }), /*#__PURE__*/ $8FY87.createElement("img", {
        className: "text-catelina-blue mr-2 hover:cursor-pointer ml-2",
        width: "18",
        src: (parcelRequire("4o8JF")),
        onClick: ()=>{
            setFile(null);
            props.onImageChange && props.onImageChange('');
        }
    })), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "h-full flex justify-center items-center px-4 cursor-pointer",
        onClick: ()=>{
            setModalOpen(true);
        }
    }, file !== "" && /*#__PURE__*/ $8FY87.createElement("img", {
        className: "h-52 object-contain",
        src: file
    }), (file === "" || file === undefined || !file) && // <ImageNotSupportedOutlinedIcon className="" fontSize="large" />
    /*#__PURE__*/ $8FY87.createElement("img", {
        className: "text-catelina-blue mr-2 hover:cursor-pointer ml-2",
        width: "40",
        src: (parcelRequire("53tPM"))
    })), props.showAlt && /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex  justify-around items-center mb-4"
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: "font-light"
    }, "Alt & Title  ", /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($80cdb5096bdf46ee$exports))), {
        width: "20",
        sx: {
            color: '#243060'
        }
    })), /*#__PURE__*/ $8FY87.createElement((0, $c377b489c6c5df10$export$2e2bcd8739ae039), {
        className: "border rounded border-red py-1 text-base-2 w-3/5 ",
        placeholder: "Image Name",
        size: "small",
        defaultValue: props.altValue,
        onChange: (e)=>props.onAltChange(e.target.value),
        error: props.altError,
        InputProps: {
            classes: {
                input: 'text-base'
            },
            sx: {
                fontSize: '16px',
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#24306099',
                    borderWidth: 1,
                    width: '100%'
                },
                '& .MuiFormControl-root': {
                    width: '250px'
                }
            }
        }
    }))), props.notes && /*#__PURE__*/ $8FY87.createElement("div", {
        className: "items-center text-xsm"
    }, /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($80cdb5096bdf46ee$exports))), {
        fontSize: "inherit"
    }), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "ml-1"
    }, props.notes)));
};
var $4d9d5f5bbbfa7366$export$2e2bcd8739ae039 = $4d9d5f5bbbfa7366$var$ImagePicker;





var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");


var $lXBIJ = parcelRequire("lXBIJ");




var $ifmKX = parcelRequire("ifmKX");

var $lbp1P = parcelRequire("lbp1P");

var $6lkQ3 = parcelRequire("6lkQ3");

var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $9b5b4a3020c9ad03$export$717666c39ec07e12(slot) {
    return (0, $jP65K.default)('MuiFormControlLabel', slot);
}
const $9b5b4a3020c9ad03$var$formControlLabelClasses = (0, $cOYaX.default)('MuiFormControlLabel', [
    'root',
    'labelPlacementStart',
    'labelPlacementTop',
    'labelPlacementBottom',
    'disabled',
    'label',
    'error',
    'required',
    'asterisk'
]);
var $9b5b4a3020c9ad03$export$2e2bcd8739ae039 = $9b5b4a3020c9ad03$var$formControlLabelClasses;




var $2PPWI = parcelRequire("2PPWI");
'use client';
const $56982e92cc58ffb8$var$_excluded = [
    "checked",
    "className",
    "componentsProps",
    "control",
    "disabled",
    "disableTypography",
    "inputRef",
    "label",
    "labelPlacement",
    "name",
    "onChange",
    "required",
    "slotProps",
    "value"
];
const $56982e92cc58ffb8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            `labelPlacement${(0, $ifmKX.default)(labelPlacement)}`,
            error && 'error',
            required && 'required'
        ],
        label: [
            'label',
            disabled && 'disabled'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $9b5b4a3020c9ad03$export$717666c39ec07e12), classes);
};
const $56982e92cc58ffb8$export$1b479270917a5676 = (0, $lbp1P.default)('label', {
    name: 'MuiFormControlLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $9b5b4a3020c9ad03$export$2e2bcd8739ae039).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $ifmKX.default)(ownerState.labelPlacement)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $zgVxD.default)({
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        // For correct alignment with the text.
        verticalAlign: 'middle',
        WebkitTapHighlightColor: 'transparent',
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $9b5b4a3020c9ad03$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        }
    }, ownerState.labelPlacement === 'start' && {
        flexDirection: 'row-reverse',
        marginLeft: 16,
        // used for row presentation of radio/checkbox
        marginRight: -11
    }, ownerState.labelPlacement === 'top' && {
        flexDirection: 'column-reverse',
        marginLeft: 16
    }, ownerState.labelPlacement === 'bottom' && {
        flexDirection: 'column',
        marginLeft: 16
    }, {
        [`& .${(0, $9b5b4a3020c9ad03$export$2e2bcd8739ae039).label}`]: {
            [`&.${(0, $9b5b4a3020c9ad03$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        }
    }));
const $56982e92cc58ffb8$var$AsteriskComponent = (0, $lbp1P.default)('span', {
    name: 'MuiFormControlLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $9b5b4a3020c9ad03$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $56982e92cc58ffb8$var$FormControlLabel = /*#__PURE__*/ $8FY87.forwardRef(function FormControlLabel(inProps, ref) {
    var _ref, _slotProps$typography;
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControlLabel'
    });
    const { className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, label: labelProp, labelPlacement: labelPlacement = 'end', required: requiredProp, slotProps: slotProps = {} } = props, other = (0, $93aRW.default)(props, $56982e92cc58ffb8$var$_excluded);
    const muiFormControl = (0, $e2bd92ffd10d5f17$export$2e2bcd8739ae039)();
    const disabled = (_ref = disabledProp != null ? disabledProp : control.props.disabled) != null ? _ref : muiFormControl == null ? void 0 : muiFormControl.disabled;
    const required = requiredProp != null ? requiredProp : control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        'checked',
        'name',
        'onChange',
        'value',
        'inputRef'
    ].forEach((key)=>{
        if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') controlProps[key] = props[key];
    });
    const fcs = (0, $7e569f38365baceb$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = (0, $zgVxD.default)({}, props, {
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    });
    const classes = $56982e92cc58ffb8$var$useUtilityClasses(ownerState);
    const typographySlotProps = (_slotProps$typography = slotProps.typography) != null ? _slotProps$typography : componentsProps.typography;
    let label = labelProp;
    if (label != null && label.type !== (0, $9e9a2c609bdcf2f0$export$2e2bcd8739ae039) && !disableTypography) label = /*#__PURE__*/ (0, $2PPWI.jsx)((0, $9e9a2c609bdcf2f0$export$2e2bcd8739ae039), (0, $zgVxD.default)({
        component: "span"
    }, typographySlotProps, {
        className: (0, $efJYy.default)(classes.label, typographySlotProps == null ? void 0 : typographySlotProps.className),
        children: label
    }));
    return /*#__PURE__*/ (0, $2PPWI.jsxs)($56982e92cc58ffb8$export$1b479270917a5676, (0, $zgVxD.default)({
        className: (0, $efJYy.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ $8FY87.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $d867c99355c0715a$export$2e2bcd8739ae039), {
                display: "block",
                children: [
                    label,
                    /*#__PURE__*/ (0, $2PPWI.jsxs)($56982e92cc58ffb8$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            '*'
                        ]
                    })
                ]
            }) : label
        ]
    }));
});
var $56982e92cc58ffb8$export$2e2bcd8739ae039 = $56982e92cc58ffb8$var$FormControlLabel;



var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");


var $lXBIJ = parcelRequire("lXBIJ");

var $1r55V = parcelRequire("1r55V");

var $ifmKX = parcelRequire("ifmKX");


var $lbp1P = parcelRequire("lbp1P");

var $6lkQ3 = parcelRequire("6lkQ3");

var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $3a88439e5452934b$export$39f6debbec19b3ba(slot) {
    return (0, $jP65K.default)('MuiSwitch', slot);
}
const $3a88439e5452934b$var$switchClasses = (0, $cOYaX.default)('MuiSwitch', [
    'root',
    'edgeStart',
    'edgeEnd',
    'switchBase',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium',
    'checked',
    'disabled',
    'input',
    'thumb',
    'track'
]);
var $3a88439e5452934b$export$2e2bcd8739ae039 = $3a88439e5452934b$var$switchClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $59115e424f862012$var$_excluded = [
    "className",
    "color",
    "edge",
    "size",
    "sx"
];
const $59115e424f862012$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, edge: edge, size: size, color: color, checked: checked, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            edge && `edge${(0, $ifmKX.default)(edge)}`,
            `size${(0, $ifmKX.default)(size)}`
        ],
        switchBase: [
            'switchBase',
            `color${(0, $ifmKX.default)(color)}`,
            checked && 'checked',
            disabled && 'disabled'
        ],
        thumb: [
            'thumb'
        ],
        track: [
            'track'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $lXBIJ.default)(slots, (0, $3a88439e5452934b$export$39f6debbec19b3ba), classes);
    return (0, $zgVxD.default)({}, classes, composedClasses);
};
const $59115e424f862012$var$SwitchRoot = (0, $lbp1P.default)('span', {
    name: 'MuiSwitch',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, $ifmKX.default)(ownerState.edge)}`],
            styles[`size${(0, $ifmKX.default)(ownerState.size)}`]
        ];
    }
})({
    display: 'inline-flex',
    width: 58,
    height: 38,
    overflow: 'hidden',
    padding: 12,
    boxSizing: 'border-box',
    position: 'relative',
    flexShrink: 0,
    zIndex: 0,
    // Reset the stacking context.
    verticalAlign: 'middle',
    // For correct alignment with the text.
    '@media print': {
        colorAdjust: 'exact'
    },
    variants: [
        {
            props: {
                edge: 'start'
            },
            style: {
                marginLeft: -8
            }
        },
        {
            props: {
                edge: 'end'
            },
            style: {
                marginRight: -8
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                width: 40,
                height: 24,
                padding: 7,
                [`& .${(0, $3a88439e5452934b$export$2e2bcd8739ae039).thumb}`]: {
                    width: 16,
                    height: 16
                },
                [`& .${(0, $3a88439e5452934b$export$2e2bcd8739ae039).switchBase}`]: {
                    padding: 4,
                    [`&.${(0, $3a88439e5452934b$export$2e2bcd8739ae039).checked}`]: {
                        transform: 'translateX(16px)'
                    }
                }
            }
        }
    ]
});
const $59115e424f862012$var$SwitchSwitchBase = (0, $lbp1P.default)((0, $4abd5c88c4f9e648$export$2e2bcd8739ae039), {
    name: 'MuiSwitch',
    slot: 'SwitchBase',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.switchBase,
            {
                [`& .${(0, $3a88439e5452934b$export$2e2bcd8739ae039).input}`]: styles.input
            },
            ownerState.color !== 'default' && styles[`color${(0, $ifmKX.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme })=>({
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.grey[300]}`,
        transition: theme.transitions.create([
            'left',
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $3a88439e5452934b$export$2e2bcd8739ae039).checked}`]: {
            transform: 'translateX(20px)'
        },
        [`&.${(0, $3a88439e5452934b$export$2e2bcd8739ae039).disabled}`]: {
            color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]}`
        },
        [`&.${(0, $3a88439e5452934b$export$2e2bcd8739ae039).checked} + .${(0, $3a88439e5452934b$export$2e2bcd8739ae039).track}`]: {
            opacity: 0.5
        },
        [`&.${(0, $3a88439e5452934b$export$2e2bcd8739ae039).disabled} + .${(0, $3a88439e5452934b$export$2e2bcd8739ae039).track}`]: {
            opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === 'light' ? 0.12 : 0.2}`
        },
        [`& .${(0, $3a88439e5452934b$export$2e2bcd8739ae039).input}`]: {
            left: '-100%',
            width: '300%'
        }
    }), ({ theme: theme })=>({
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $1r55V.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $3a88439e5452934b$export$2e2bcd8739ae039).checked}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            '&:hover': {
                                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $1r55V.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity),
                                '@media (hover: none)': {
                                    backgroundColor: 'transparent'
                                }
                            },
                            [`&.${(0, $3a88439e5452934b$export$2e2bcd8739ae039).disabled}`]: {
                                color: theme.vars ? theme.vars.palette.Switch[`${color}DisabledColor`] : `${theme.palette.mode === 'light' ? (0, $1r55V.lighten)(theme.palette[color].main, 0.62) : (0, $1r55V.darken)(theme.palette[color].main, 0.55)}`
                            }
                        },
                        [`&.${(0, $3a88439e5452934b$export$2e2bcd8739ae039).checked} + .${(0, $3a88439e5452934b$export$2e2bcd8739ae039).track}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].main
                        }
                    }
                }))
        ]
    }));
const $59115e424f862012$var$SwitchTrack = (0, $lbp1P.default)('span', {
    name: 'MuiSwitch',
    slot: 'Track',
    overridesResolver: (props, styles)=>styles.track
})(({ theme: theme })=>({
        height: '100%',
        width: '100%',
        borderRadius: 7,
        zIndex: -1,
        transition: theme.transitions.create([
            'opacity',
            'background-color'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === 'light' ? theme.palette.common.black : theme.palette.common.white}`,
        opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === 'light' ? 0.38 : 0.3}`
    }));
const $59115e424f862012$var$SwitchThumb = (0, $lbp1P.default)('span', {
    name: 'MuiSwitch',
    slot: 'Thumb',
    overridesResolver: (props, styles)=>styles.thumb
})(({ theme: theme })=>({
        boxShadow: (theme.vars || theme).shadows[1],
        backgroundColor: 'currentColor',
        width: 20,
        height: 20,
        borderRadius: '50%'
    }));
const $59115e424f862012$var$Switch = /*#__PURE__*/ $8FY87.forwardRef(function Switch(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiSwitch'
    });
    const { className: className, color: color = 'primary', edge: edge = false, size: size = 'medium', sx: sx } = props, other = (0, $93aRW.default)(props, $59115e424f862012$var$_excluded);
    const ownerState = (0, $zgVxD.default)({}, props, {
        color: color,
        edge: edge,
        size: size
    });
    const classes = $59115e424f862012$var$useUtilityClasses(ownerState);
    const icon = /*#__PURE__*/ (0, $2PPWI.jsx)($59115e424f862012$var$SwitchThumb, {
        className: classes.thumb,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $2PPWI.jsxs)($59115e424f862012$var$SwitchRoot, {
        className: (0, $efJYy.default)(classes.root, className),
        sx: sx,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)($59115e424f862012$var$SwitchSwitchBase, (0, $zgVxD.default)({
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState
            }, other, {
                classes: (0, $zgVxD.default)({}, classes, {
                    root: classes.switchBase
                })
            })),
            /*#__PURE__*/ (0, $2PPWI.jsx)($59115e424f862012$var$SwitchTrack, {
                className: classes.track,
                ownerState: ownerState
            })
        ]
    });
});
var $59115e424f862012$export$2e2bcd8739ae039 = $59115e424f862012$var$Switch;






var $8FY87 = parcelRequire("8FY87");

var $2PPWI = parcelRequire("2PPWI");
function $92c8f74ada418208$var$V(e, { insertAt: n } = {}) {
    if (!e || typeof document > "u") return;
    let t = document.head || document.getElementsByTagName("head")[0], r = document.createElement("style");
    r.type = "text/css", n === "top" && t.firstChild ? t.insertBefore(r, t.firstChild) : t.appendChild(r), r.styleSheet ? r.styleSheet.cssText = e : r.appendChild(document.createTextNode(e));
}
$92c8f74ada418208$var$V(`.rmsc{--rmsc-main: #4285f4;--rmsc-hover: #f1f3f5;--rmsc-selected: #e2e6ea;--rmsc-border: #ccc;--rmsc-gray: #aaa;--rmsc-bg: #fff;--rmsc-p: 10px;--rmsc-radius: 4px;--rmsc-h: 38px}.rmsc *{box-sizing:border-box;transition:all .2s ease}.rmsc .gray{color:var(--rmsc-gray)}.rmsc .dropdown-content{position:absolute;z-index:1;top:100%;width:100%;padding-top:8px}.rmsc .dropdown-content .panel-content{overflow:hidden;border-radius:var(--rmsc-radius);background:var(--rmsc-bg);box-shadow:0 0 0 1px #0000001a,0 4px 11px #0000001a}.rmsc .dropdown-container{position:relative;outline:0;background-color:var(--rmsc-bg);border:1px solid var(--rmsc-border);border-radius:var(--rmsc-radius)}.rmsc .dropdown-container[aria-disabled=true]:focus-within{box-shadow:var(--rmsc-gray) 0 0 0 1px;border-color:var(--rmsc-gray)}.rmsc .dropdown-container:focus-within{box-shadow:var(--rmsc-main) 0 0 0 1px;border-color:var(--rmsc-main)}.rmsc .dropdown-heading{position:relative;padding:0 var(--rmsc-p);display:flex;align-items:center;width:100%;height:var(--rmsc-h);cursor:default;outline:0}.rmsc .dropdown-heading .dropdown-heading-value{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;flex:1}.rmsc .clear-selected-button{cursor:pointer;background:none;border:0;padding:0;display:flex}.rmsc .options{max-height:260px;overflow-y:auto;margin:0;padding-left:0}.rmsc .options li{list-style:none;margin:0}.rmsc .select-item{box-sizing:border-box;cursor:pointer;display:block;padding:var(--rmsc-p);outline-offset:-1px;outline-color:var(--rmsc-primary)}.rmsc .select-item:hover{background:var(--rmsc-hover)}.rmsc .select-item.selected{background:var(--rmsc-selected)}.rmsc .no-options{padding:var(--rmsc-p);text-align:center;color:var(--rmsc-gray)}.rmsc .search{width:100%;position:relative;border-bottom:1px solid var(--rmsc-border)}.rmsc .search input{background:none;height:var(--rmsc-h);padding:0 var(--rmsc-p);width:100%;outline:0;border:0;font-size:1em}.rmsc .search input:focus{background:var(--rmsc-hover)}.rmsc .search-clear-button{cursor:pointer;position:absolute;top:0;right:0;bottom:0;background:none;border:0;padding:0 calc(var(--rmsc-p) / 2)}.rmsc .search-clear-button [hidden]{display:none}.rmsc .item-renderer{display:flex;align-items:baseline}.rmsc .item-renderer input{margin:0 5px 0 0}.rmsc .item-renderer.disabled{opacity:.5}.rmsc .spinner{animation:rotate 2s linear infinite}.rmsc .spinner .path{stroke:var(--rmsc-border);stroke-width:4px;stroke-linecap:round;animation:dash 1.5s ease-in-out infinite}@keyframes rotate{to{transform:rotate(360deg)}}@keyframes dash{0%{stroke-dasharray:1,150;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-35}to{stroke-dasharray:90,150;stroke-dashoffset:-124}}
`);
var $92c8f74ada418208$var$Me = {
    allItemsAreSelected: "All items are selected.",
    clearSearch: "Clear Search",
    clearSelected: "Clear Selected",
    noOptions: "No options",
    search: "Search",
    selectAll: "Select All",
    selectAllFiltered: "Select All (Filtered)",
    selectSomeItems: "Select...",
    create: "Create"
}, $92c8f74ada418208$var$De = {
    value: [],
    hasSelectAll: !0,
    className: "multi-select",
    debounceDuration: 200,
    options: []
}, $92c8f74ada418208$var$re = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createContext({}), $92c8f74ada418208$var$ne = ({ props: e, children: n })=>{
    let [t, r] = (0, $8FY87.useState)(e.options), a = (c)=>{
        var u;
        return ((u = e.overrideStrings) == null ? void 0 : u[c]) || $92c8f74ada418208$var$Me[c];
    };
    return (0, $8FY87.useEffect)(()=>{
        r(e.options);
    }, [
        e.options
    ]), (0, $2PPWI.jsx)($92c8f74ada418208$var$re.Provider, {
        value: {
            t: a,
            ...$92c8f74ada418208$var$De,
            ...e,
            options: t,
            setOptions: r
        },
        children: n
    });
}, $92c8f74ada418208$var$w = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useContext($92c8f74ada418208$var$re);
function $92c8f74ada418208$var$se(e, n) {
    let t = (0, $8FY87.useRef)(!1);
    (0, $8FY87.useEffect)(()=>{
        t.current ? e() : t.current = !0;
    }, n);
}
var $92c8f74ada418208$var$He = {
    when: !0,
    eventTypes: [
        "keydown"
    ]
};
function $92c8f74ada418208$var$R(e, n, t) {
    let r = (0, $8FY87.useMemo)(()=>Array.isArray(e) ? e : [
            e
        ], [
        e
    ]), a = Object.assign({}, $92c8f74ada418208$var$He, t), { when: c, eventTypes: u } = a, b = (0, $8FY87.useRef)(n), { target: s } = a;
    (0, $8FY87.useEffect)(()=>{
        b.current = n;
    });
    let p = (0, $8FY87.useCallback)((i)=>{
        r.some((l)=>i.key === l || i.code === l) && b.current(i);
    }, [
        r
    ]);
    (0, $8FY87.useEffect)(()=>{
        if (c && typeof window < "u") {
            let i = s ? s.current : window;
            return u.forEach((l)=>{
                i && i.addEventListener(l, p);
            }), ()=>{
                u.forEach((l)=>{
                    i && i.removeEventListener(l, p);
                });
            };
        }
    }, [
        c,
        u,
        r,
        s,
        n
    ]);
}
var $92c8f74ada418208$var$f = {
    ARROW_DOWN: "ArrowDown",
    ARROW_UP: "ArrowUp",
    ENTER: "Enter",
    ESCAPE: "Escape",
    SPACE: "Space"
};
var $92c8f74ada418208$var$le = (e, n)=>{
    let t;
    return function(...r) {
        clearTimeout(t), t = setTimeout(()=>{
            e.apply(null, r);
        }, n);
    };
};
function $92c8f74ada418208$var$ie(e, n) {
    return n ? e.filter(({ label: t, value: r })=>t != null && r != null && t.toLowerCase().includes(n.toLowerCase())) : e;
}
var $92c8f74ada418208$var$T = ()=>(0, $2PPWI.jsxs)("svg", {
        width: "24",
        height: "24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        className: "dropdown-search-clear-icon gray",
        children: [
            (0, $2PPWI.jsx)("line", {
                x1: "18",
                y1: "6",
                x2: "6",
                y2: "18"
            }),
            (0, $2PPWI.jsx)("line", {
                x1: "6",
                y1: "6",
                x2: "18",
                y2: "18"
            })
        ]
    });
var $92c8f74ada418208$var$Ue = ({ checked: e, option: n, onClick: t, disabled: r })=>(0, $2PPWI.jsxs)("div", {
        className: `item-renderer ${r ? "disabled" : ""}`,
        children: [
            (0, $2PPWI.jsx)("input", {
                type: "checkbox",
                onChange: t,
                checked: e,
                tabIndex: -1,
                disabled: r
            }),
            (0, $2PPWI.jsx)("span", {
                children: n.label
            })
        ]
    }), $92c8f74ada418208$var$pe = $92c8f74ada418208$var$Ue;
var $92c8f74ada418208$var$Ye = ({ itemRenderer: e = $92c8f74ada418208$var$pe, option: n, checked: t, tabIndex: r, disabled: a, onSelectionChanged: c, onClick: u })=>{
    let b = (0, $8FY87.useRef)(), s = (l)=>{
        p(), l.preventDefault();
    }, p = ()=>{
        a || c(!t);
    }, i = (l)=>{
        p(), u(l);
    };
    return $92c8f74ada418208$var$R([
        $92c8f74ada418208$var$f.ENTER,
        $92c8f74ada418208$var$f.SPACE
    ], s, {
        target: b
    }), (0, $2PPWI.jsx)("label", {
        className: `select-item ${t ? "selected" : ""}`,
        role: "option",
        "aria-selected": t,
        tabIndex: r,
        ref: b,
        children: (0, $2PPWI.jsx)(e, {
            option: n,
            checked: t,
            onClick: i,
            disabled: a
        })
    });
}, $92c8f74ada418208$export$13ef48a934230896 = $92c8f74ada418208$var$Ye;
var $92c8f74ada418208$var$ze = ({ options: e, onClick: n, skipIndex: t })=>{
    let { disabled: r, value: a, onChange: c, ItemRenderer: u } = $92c8f74ada418208$var$w(), b = (s, p)=>{
        r || c(p ? [
            ...a,
            s
        ] : a.filter((i)=>i.value !== s.value));
    };
    return (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
        children: e.map((s, p)=>{
            let i = p + t;
            return (0, $2PPWI.jsx)("li", {
                children: (0, $2PPWI.jsx)($92c8f74ada418208$export$13ef48a934230896, {
                    tabIndex: i,
                    option: s,
                    onSelectionChanged: (l)=>b(s, l),
                    checked: !!a.find((l)=>l.value === s.value),
                    onClick: (l)=>n(l, i),
                    itemRenderer: u,
                    disabled: s.disabled || r
                })
            }, (s == null ? void 0 : s.key) || p);
        })
    });
}, $92c8f74ada418208$var$ue = $92c8f74ada418208$var$ze;
var $92c8f74ada418208$var$Je = ()=>{
    let { t: e, onChange: n, options: t, setOptions: r, value: a, filterOptions: c, ItemRenderer: u, disabled: b, disableSearch: s, hasSelectAll: p, ClearIcon: i, debounceDuration: l, isCreatable: L, onCreateOption: y } = $92c8f74ada418208$var$w(), O = (0, $8FY87.useRef)(), g = (0, $8FY87.useRef)(), [m, M] = (0, $8FY87.useState)(""), [v, K] = (0, $8FY87.useState)(t), [x, D] = (0, $8FY87.useState)(""), [E, I] = (0, $8FY87.useState)(0), W = (0, $8FY87.useCallback)($92c8f74ada418208$var$le((o)=>D(o), l), []), A = (0, $8FY87.useMemo)(()=>{
        let o = 0;
        return s || (o += 1), p && (o += 1), o;
    }, [
        s,
        p
    ]), _ = {
        label: e(m ? "selectAllFiltered" : "selectAll"),
        value: ""
    }, H = (o)=>{
        let d = v.filter((C)=>!C.disabled).map((C)=>C.value);
        if (o) {
            let Ae = [
                ...a.map((U)=>U.value),
                ...d
            ];
            return (c ? v : t).filter((U)=>Ae.includes(U.value));
        }
        return a.filter((C)=>!d.includes(C.value));
    }, B = (o)=>{
        let d = H(o);
        n(d);
    }, h = (o)=>{
        W(o.target.value), M(o.target.value), I(0);
    }, P = ()=>{
        var o;
        D(""), M(""), (o = g == null ? void 0 : g.current) == null || o.focus();
    }, Z = (o)=>I(o), we = (o)=>{
        switch(o.code){
            case $92c8f74ada418208$var$f.ARROW_UP:
                ee(-1);
                break;
            case $92c8f74ada418208$var$f.ARROW_DOWN:
                ee(1);
                break;
            default:
                return;
        }
        o.stopPropagation(), o.preventDefault();
    };
    $92c8f74ada418208$var$R([
        $92c8f74ada418208$var$f.ARROW_DOWN,
        $92c8f74ada418208$var$f.ARROW_UP
    ], we, {
        target: O
    });
    let Oe = ()=>{
        I(0);
    }, j = async ()=>{
        let o = {
            label: m,
            value: m,
            __isNew__: !0
        };
        y && (o = await y(m)), r([
            o,
            ...t
        ]), P(), n([
            ...a,
            o
        ]);
    }, Re = async ()=>c ? await c(t, x) : $92c8f74ada418208$var$ie(t, x), ee = (o)=>{
        let d = E + o;
        d = Math.max(0, d), d = Math.min(d, t.length + Math.max(A - 1, 0)), I(d);
    };
    (0, $8FY87.useEffect)(()=>{
        var o, d;
        (d = (o = O == null ? void 0 : O.current) == null ? void 0 : o.querySelector(`[tabIndex='${E}']`)) == null || d.focus();
    }, [
        E
    ]);
    let [ke, Ee] = (0, $8FY87.useMemo)(()=>{
        let o = v.filter((d)=>!d.disabled);
        return [
            o.every((d)=>a.findIndex((C)=>C.value === d.value) !== -1),
            o.length !== 0
        ];
    }, [
        v,
        a
    ]);
    (0, $8FY87.useEffect)(()=>{
        Re().then(K);
    }, [
        x,
        t
    ]);
    let te = (0, $8FY87.useRef)();
    $92c8f74ada418208$var$R([
        $92c8f74ada418208$var$f.ENTER
    ], j, {
        target: te
    });
    let Ie = L && m && !v.some((o)=>(o == null ? void 0 : o.value) === m);
    return (0, $2PPWI.jsxs)("div", {
        className: "select-panel",
        role: "listbox",
        ref: O,
        children: [
            !s && (0, $2PPWI.jsxs)("div", {
                className: "search",
                children: [
                    (0, $2PPWI.jsx)("input", {
                        placeholder: e("search"),
                        type: "text",
                        "aria-describedby": e("search"),
                        onChange: h,
                        onFocus: Oe,
                        value: m,
                        ref: g,
                        tabIndex: 0
                    }),
                    (0, $2PPWI.jsx)("button", {
                        type: "button",
                        className: "search-clear-button",
                        hidden: !m,
                        onClick: P,
                        "aria-label": e("clearSearch"),
                        children: i || (0, $2PPWI.jsx)($92c8f74ada418208$var$T, {})
                    })
                ]
            }),
            (0, $2PPWI.jsxs)("ul", {
                className: "options",
                children: [
                    p && Ee && (0, $2PPWI.jsx)($92c8f74ada418208$export$13ef48a934230896, {
                        tabIndex: A === 1 ? 0 : 1,
                        checked: ke,
                        option: _,
                        onSelectionChanged: B,
                        onClick: ()=>Z(1),
                        itemRenderer: u,
                        disabled: b
                    }),
                    v.length ? (0, $2PPWI.jsx)($92c8f74ada418208$var$ue, {
                        skipIndex: A,
                        options: v,
                        onClick: (o, d)=>Z(d)
                    }) : Ie ? (0, $2PPWI.jsx)("li", {
                        onClick: j,
                        className: "select-item creatable",
                        tabIndex: 1,
                        ref: te,
                        children: `${e("create")} "${m}"`
                    }) : (0, $2PPWI.jsx)("li", {
                        className: "no-options",
                        children: e("noOptions")
                    })
                ]
            })
        ]
    });
}, $92c8f74ada418208$export$9640093ec8451560 = $92c8f74ada418208$var$Je;
var $92c8f74ada418208$var$ge = ({ expanded: e })=>(0, $2PPWI.jsx)("svg", {
        width: "24",
        height: "24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        className: "dropdown-heading-dropdown-arrow gray",
        children: (0, $2PPWI.jsx)("path", {
            d: e ? "M18 15 12 9 6 15" : "M6 9L12 15 18 9"
        })
    });
var $92c8f74ada418208$var$xe = ()=>{
    let { t: e, value: n, options: t, valueRenderer: r } = $92c8f74ada418208$var$w(), a = n.length === 0, c = n.length === t.length, u = r && r(n, t);
    return a ? (0, $2PPWI.jsx)("span", {
        className: "gray",
        children: u || e("selectSomeItems")
    }) : (0, $2PPWI.jsx)("span", {
        children: u || (c ? e("allItemsAreSelected") : (()=>n.map((s)=>s.label).join(", "))())
    });
};
var $92c8f74ada418208$var$Se = ({ size: e = 24 })=>(0, $2PPWI.jsx)("span", {
        style: {
            width: e,
            marginRight: "0.2rem"
        },
        children: (0, $2PPWI.jsx)("svg", {
            width: e,
            height: e,
            className: "spinner",
            viewBox: "0 0 50 50",
            style: {
                display: "inline",
                verticalAlign: "middle"
            },
            children: (0, $2PPWI.jsx)("circle", {
                cx: "25",
                cy: "25",
                r: "20",
                fill: "none",
                className: "path"
            })
        })
    });
var $92c8f74ada418208$var$Xe = ()=>{
    let { t: e, onMenuToggle: n, ArrowRenderer: t, shouldToggleOnHover: r, isLoading: a, disabled: c, onChange: u, labelledBy: b, value: s, isOpen: p, defaultIsOpen: i, ClearSelectedIcon: l, closeOnChangedValue: L } = $92c8f74ada418208$var$w();
    (0, $8FY87.useEffect)(()=>{
        L && m(!1);
    }, [
        s
    ]);
    let [y, O] = (0, $8FY87.useState)(!0), [g, m] = (0, $8FY87.useState)(i), [M, v] = (0, $8FY87.useState)(!1), K = t || $92c8f74ada418208$var$ge, x = (0, $8FY87.useRef)();
    $92c8f74ada418208$var$se(()=>{
        n && n(g);
    }, [
        g
    ]), (0, $8FY87.useEffect)(()=>{
        i === void 0 && typeof p == "boolean" && (O(!1), m(p));
    }, [
        p
    ]);
    let D = (h)=>{
        var P;
        [
            "text",
            "button"
        ].includes(h.target.type) && [
            $92c8f74ada418208$var$f.SPACE,
            $92c8f74ada418208$var$f.ENTER
        ].includes(h.code) || (y && (h.code === $92c8f74ada418208$var$f.ESCAPE ? (m(!1), (P = x == null ? void 0 : x.current) == null || P.focus()) : m(!0)), h.preventDefault());
    };
    $92c8f74ada418208$var$R([
        $92c8f74ada418208$var$f.ENTER,
        $92c8f74ada418208$var$f.ARROW_DOWN,
        $92c8f74ada418208$var$f.SPACE,
        $92c8f74ada418208$var$f.ESCAPE
    ], D, {
        target: x
    });
    let E = (h)=>{
        y && r && m(h);
    }, I = ()=>!M && v(!0), W = (h)=>{
        !h.currentTarget.contains(h.relatedTarget) && y && (v(!1), m(!1));
    }, A = ()=>E(!0), _ = ()=>E(!1), H = ()=>{
        y && m(a || c ? !1 : !g);
    }, B = (h)=>{
        h.stopPropagation(), u([]), y && m(!1);
    };
    return (0, $2PPWI.jsxs)("div", {
        tabIndex: 0,
        className: "dropdown-container",
        "aria-labelledby": b,
        "aria-expanded": g,
        "aria-readonly": !0,
        "aria-disabled": c,
        ref: x,
        onFocus: I,
        onBlur: W,
        onMouseEnter: A,
        onMouseLeave: _,
        children: [
            (0, $2PPWI.jsxs)("div", {
                className: "dropdown-heading",
                onClick: H,
                children: [
                    (0, $2PPWI.jsx)("div", {
                        className: "dropdown-heading-value",
                        children: (0, $2PPWI.jsx)($92c8f74ada418208$var$xe, {})
                    }),
                    a && (0, $2PPWI.jsx)($92c8f74ada418208$var$Se, {}),
                    s.length > 0 && l !== null && (0, $2PPWI.jsx)("button", {
                        type: "button",
                        className: "clear-selected-button",
                        onClick: B,
                        disabled: c,
                        "aria-label": e("clearSelected"),
                        children: l || (0, $2PPWI.jsx)($92c8f74ada418208$var$T, {})
                    }),
                    (0, $2PPWI.jsx)(K, {
                        expanded: g
                    })
                ]
            }),
            g && (0, $2PPWI.jsx)("div", {
                className: "dropdown-content",
                children: (0, $2PPWI.jsx)("div", {
                    className: "panel-content",
                    children: (0, $2PPWI.jsx)($92c8f74ada418208$export$9640093ec8451560, {})
                })
            })
        ]
    });
}, $92c8f74ada418208$export$931cbfb6bfb85fc = $92c8f74ada418208$var$Xe;
var $92c8f74ada418208$var$Ze = (e)=>(0, $2PPWI.jsx)($92c8f74ada418208$var$ne, {
        props: e,
        children: (0, $2PPWI.jsx)("div", {
            className: `rmsc ${e.className || "multi-select"}`,
            children: (0, $2PPWI.jsx)($92c8f74ada418208$export$931cbfb6bfb85fc, {})
        })
    }), $92c8f74ada418208$export$1e7dfd31545b5809 = $92c8f74ada418208$var$Ze;




//people.sort((a, b) => a.name.localeCompare(b.name));
const $9afa5c10a93e130a$var$ConfigAdministration = (props)=>{
    $8FY87.useEffect(()=>{
        setSelected((props.data.templateCategories || [])?.map((lk)=>({
                label: lk,
                value: lk
            })));
    }, [
        props.data.templateCategories
    ]);
    const [selected, setSelected] = $8FY87.useState([]);
    const colorPalletKeys = (0, (/*@__PURE__*/$parcel$interopDefault($52ca409747836a2e$exports)))();
    // console.log("ConfigAdministration.data", props.data);
    return /*#__PURE__*/ $8FY87.createElement("div", {
        className: "left-sidebar-admin"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col text-black"
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-base-2 mb-2"
    }, "Template name"), /*#__PURE__*/ $8FY87.createElement("input", {
        className: "border rounded border-catelina-blue/60 w-full py-1 px-2 md:w-80",
        placeholder: "Website name",
        value: props.data.templateName || props.data.siteName,
        //   disabled
        onChange: (e)=>{
            props.onDataChange({
                templateName: (0, $df5cb81582703dc6$export$2e2bcd8739ae039)(e.target.value)
            });
        }
    }), props.data && /*#__PURE__*/ $8FY87.createElement((0, $1587b7eed37887b9$export$2e2bcd8739ae039), {
        variant: "standard"
    }, /*#__PURE__*/ $8FY87.createElement((0, $56982e92cc58ffb8$export$2e2bcd8739ae039), {
        control: /*#__PURE__*/ $8FY87.createElement((0, $59115e424f862012$export$2e2bcd8739ae039), {
            defaultChecked: props.data.isTemplate === "true",
            checked: props.data.isTemplate === "true",
            onChange: (event)=>{
                props.onDataChange({
                    isTemplate: event.target.checked ? "true" : "false"
                });
            // setSelected(event.target.checked)
            },
            name: "isTemplate"
        }),
        label: "Is Template"
    }), /*#__PURE__*/ $8FY87.createElement((0, $56982e92cc58ffb8$export$2e2bcd8739ae039), {
        control: /*#__PURE__*/ $8FY87.createElement((0, $59115e424f862012$export$2e2bcd8739ae039), {
            defaultChecked: props.data.isAITemplate === "true",
            checked: props.data.isAITemplate === "true",
            onChange: (event)=>{
                props.onDataChange({
                    isAITemplate: event.target.checked ? "true" : "false"
                });
            // setSelected(event.target.checked)
            },
            name: "isAITemplate"
        }),
        label: "Is AI Template"
    }))), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "py-8"
    }, /*#__PURE__*/ $8FY87.createElement((0, $30a538faf9a95dbb$export$2e2bcd8739ae039), null)), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col text-black"
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-base-2 mb-2"
    }, "Template Categories"), /*#__PURE__*/ $8FY87.createElement((0, $92c8f74ada418208$export$1e7dfd31545b5809), {
        options: props.templateSiteCategories.map((ol)=>{
            return {
                label: ol.name,
                value: ol.name
            };
        }).sort((a, b)=>a.label.localeCompare(b.label, undefined, {
                numeric: true,
                sensitivity: "base"
            })),
        value: selected,
        // value={props.data.templateCategories || []}
        onChange: (vals)=>{
            // console.log(
            //   "sasasdas",
            //   vals.map((kk) => kk.label)
            // );
            setSelected(vals);
            props.onDataChange({
                templateCategories: vals.map((kk)=>kk.label)
            });
        },
        labelledBy: "Template Categories"
    })), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "py-8"
    }, /*#__PURE__*/ $8FY87.createElement((0, $30a538faf9a95dbb$export$2e2bcd8739ae039), null)), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col text-black"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col md:flex-row text-center mb-4"
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-base-2"
    }, "Applicable color pallets "), /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        // className="w-full"
        variant: "outlined",
        size: "small",
        onClick: ()=>{
            let _prevData = [
                ...props.data.templateColorPalettes
            ];
            _prevData.push({
                keyIndex: colorPalletKeys.new(),
                id: props.data.currentSiteColorPalette ? props.data.currentSiteColorPalette.id : "",
                imageUrl: props.data.siteImageURL || ""
            });
            props.onDataChange({
                templateColorPalettes: _prevData
            });
        },
        sx: {
            marginLeft: 2,
            backgroundColor: "#fff",
            border: "1px solid",
            borderColor: "#243060",
            color: "#243060",
            textTransform: "none",
            "&:hover": {
                backgroundColor: "#243060",
                color: "#fff"
            }
        }
    }, "Add new color palette")), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-2"
    }, props.data.templateColorPalettes && props.data.templateColorPalettes.map((rr)=>{
        return /*#__PURE__*/ $8FY87.createElement("div", {
            key: rr.keyIndex,
            className: "w-full md:w-50 xl:w-60 rounded overflow-hidden shadow-lg p-4 bg-white"
        }, /*#__PURE__*/ $8FY87.createElement("div", {
            className: "flex flex-row"
        }, /*#__PURE__*/ $8FY87.createElement((0, $1587b7eed37887b9$export$2e2bcd8739ae039), {
            sx: {
                maxWidth: "100%",
                width: "100%"
            },
            size: "small"
        }, /*#__PURE__*/ $8FY87.createElement((0, $5fa08250992d1a88$export$2e2bcd8739ae039), {
            id: "select",
            value: rr.id,
            onChange: (e)=>{
                // setSelectedLang(e.target.value)
                // console.log(e.target.value);
                // props.onDataChange({ primaryLanguage: e.target.value });
                let _prevData = [
                    ...props.data.templateColorPalettes
                ];
                let idx = _prevData.findIndex((jh)=>jh.keyIndex === rr.keyIndex);
                _prevData[idx] = {
                    ..._prevData[idx],
                    id: e.target.value
                };
                props.onDataChange({
                    templateColorPalettes: _prevData
                });
            },
            className: "w-full text-sm mb-2"
        }, props.allTemplateColors.sort((a, b)=>a.id.localeCompare(b.id, undefined, {
                numeric: true,
                sensitivity: "base"
            })).map((row)=>{
            return /*#__PURE__*/ $8FY87.createElement((0, $ee9f19037253b32c$export$2e2bcd8739ae039), {
                key: row.id,
                className: "text-sm",
                value: row.id
            }, row.id, " - (", row.category, ")");
        })), /*#__PURE__*/ $8FY87.createElement((0, $4d9d5f5bbbfa7366$export$2e2bcd8739ae039), {
            image_url: rr.imageUrl,
            siteId: props.siteId,
            size: "full",
            // title="Favicon image"
            // desc="Favicon is displayed on your site's tab in a browser."
            // notes="Please upload a 16x16px .PNG or .JPG image."
            onImageChange: (img_url)=>{
                let _prevData = [
                    ...props.data.templateColorPalettes
                ];
                let idx = _prevData.findIndex((jh)=>jh.keyIndex === rr.keyIndex);
                _prevData[idx] = {
                    ..._prevData[idx],
                    imageUrl: img_url
                };
                props.onDataChange({
                    templateColorPalettes: _prevData
                });
            }
        }), /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
            className: "w-full",
            variant: "outlined",
            size: "small",
            onClick: ()=>{
                let _prevData = [
                    ...props.data.templateColorPalettes
                ];
                let idx = _prevData.findIndex((jh)=>jh.keyIndex === rr.keyIndex);
                _prevData.splice(idx, 1);
                props.onDataChange({
                    templateColorPalettes: _prevData
                });
            },
            sx: {
                marginTop: 2,
                backgroundColor: "#fff",
                border: "1px solid",
                borderColor: "red",
                color: "red",
                textTransform: "none",
                "&:hover": {
                    backgroundColor: "red",
                    color: "#fff"
                }
            }
        }, "Delete"))));
    }))));
};
var $9afa5c10a93e130a$export$2e2bcd8739ae039 = $9afa5c10a93e130a$var$ConfigAdministration;


var $5e92c14e843d6937$exports = {};
"use strict";
"use client";

var $bcBLN = parcelRequire("bcBLN");
Object.defineProperty($5e92c14e843d6937$exports, "__esModule", {
    value: true
});
$5e92c14e843d6937$exports.default = void 0;

var $5e92c14e843d6937$var$_createSvgIcon = $bcBLN((parcelRequire("485sq")));

var $2PPWI = parcelRequire("2PPWI");
var $5e92c14e843d6937$var$_default = $5e92c14e843d6937$exports.default = (0, $5e92c14e843d6937$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2PPWI.jsx)("path", {
    d: "M18 17H6v-2h12zm0-4H6v-2h12zm0-4H6V7h12zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2z"
}), 'ReceiptSharp');



var $8FY87 = parcelRequire("8FY87");
var $043a290e4855dabe$exports = {};
"use strict";
"use client";

var $bcBLN = parcelRequire("bcBLN");
Object.defineProperty($043a290e4855dabe$exports, "__esModule", {
    value: true
});
$043a290e4855dabe$exports.default = void 0;

var $043a290e4855dabe$var$_createSvgIcon = $bcBLN((parcelRequire("485sq")));

var $2PPWI = parcelRequire("2PPWI");
var $043a290e4855dabe$var$_default = $043a290e4855dabe$exports.default = (0, $043a290e4855dabe$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2PPWI.jsx)("path", {
    d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96M17 13l-5 5-5-5h3V9h4v4z"
}), 'CloudDownload');


var $a6851f29d233916b$exports = {};
"use strict";
"use client";

var $bcBLN = parcelRequire("bcBLN");
Object.defineProperty($a6851f29d233916b$exports, "__esModule", {
    value: true
});
$a6851f29d233916b$exports.default = void 0;

var $a6851f29d233916b$var$_createSvgIcon = $bcBLN((parcelRequire("485sq")));

var $2PPWI = parcelRequire("2PPWI");
var $a6851f29d233916b$var$_default = $a6851f29d233916b$exports.default = (0, $a6851f29d233916b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2PPWI.jsx)("path", {
    d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5m0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3"
}), 'Visibility');




var $8FY87 = parcelRequire("8FY87");

const $263356cc61dd2835$var$InvoiceItem = (props)=>{
    //   console.log("InvoiceItem", props);
    const invoice_date = new Date(props.data.created * 1000);
    return /*#__PURE__*/ $8FY87.createElement("div", {
        className: `bg-white border rounded-lg shadow-md p-3 md:p-4 w-full mr-2 my-2  text-xsm sm:text-base grid grid-cols-1 xl:grid-cols-4 gap-4`
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: "self-center"
    }, invoice_date.toLocaleDateString("en-GB")), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "self-center flex flex-col sm:flex-row"
    }, /*#__PURE__*/ $8FY87.createElement("span", null, "Invoice:\xa0"), /*#__PURE__*/ $8FY87.createElement("span", null, props.data.id)), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "xl:text-right self-center"
    }, "$", props.data.amount_paid / 100), props.data.status !== 'uncollectible' && /*#__PURE__*/ $8FY87.createElement("span", {
        className: "flex justify-center"
    }, /*#__PURE__*/ $8FY87.createElement((0, $8765ef9b64e3c3e6$export$2e2bcd8739ae039), {
        color: "primary",
        "aria-label": "add to shopping cart",
        href: props.data.hosted_invoice_url
    }, /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($a6851f29d233916b$exports))), {
        className: "mx-2",
        fontSize: "small"
    })), /*#__PURE__*/ $8FY87.createElement((0, $8765ef9b64e3c3e6$export$2e2bcd8739ae039), {
        color: "primary",
        "aria-label": "add to shopping cart",
        href: props.data.invoice_pdf
    }, /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($043a290e4855dabe$exports))), {
        className: "mx-2",
        fontSize: "small"
    }))), props.data.status === 'uncollectible' && /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-sm mb-0 flex   text-catelina-blue  rounded bg-[#E1E4EF] px-2 py-0 pl-4 relative"
    }, /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($80cdb5096bdf46ee$exports))), {
        className: "mr-1 absolute top-1.5 left-1",
        style: {
            fontSize: 16
        }
    }), " ", /*#__PURE__*/ $8FY87.createElement("span", {
        className: "flex flex-wrap pl-1"
    }, "Payment failed. View/download unavailable. ")));
};
var $263356cc61dd2835$export$2e2bcd8739ae039 = $263356cc61dd2835$var$InvoiceItem;


const $ef77c9de594ee7e7$var$ConfigBillings = (props)=>{
    return /*#__PURE__*/ $8FY87.createElement("div", {
        className: "config-billings flex flex-col justify-center items-left w-full"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "w-full flex flex-col"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "w-full"
    }, props.isLoading && /*#__PURE__*/ $8FY87.createElement("div", {
        className: "bg-white border rounded-lg shadow-md p-4 w-full h-64 flex flex-col justify-center text-center"
    }, /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5e92c14e843d6937$exports))), {
        className: "self-center mb-2"
    }), /*#__PURE__*/ $8FY87.createElement("h3", {
        className: "text-xl font-bold mb-0 mt-0"
    }, "Fetching Invoices...")), !props.isLoading && props.invoices.length === 0 && /*#__PURE__*/ $8FY87.createElement("div", {
        className: "bg-white border rounded-lg shadow-md p-4 w-full h-64 flex flex-col justify-center text-center"
    }, /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5e92c14e843d6937$exports))), {
        className: "self-center mb-2"
    }), /*#__PURE__*/ $8FY87.createElement("h3", {
        className: "text-xl font-bold mb-0 mt-0"
    }, "No invoices found"), /*#__PURE__*/ $8FY87.createElement("p", {
        className: "text-xsm mb-4 mt-0"
    }, "you haven't generated any invoices so far.")), !props.isLoading && props.invoices.length > 0 && /*#__PURE__*/ $8FY87.createElement("div", {
        className: "bg-white border rounded-lg shadow-md p-4 w-full"
    }, /*#__PURE__*/ $8FY87.createElement("h3", {
        className: "text-lg font-bold mb-4 mt-0"
    }, "Invoices"), props.invoices?.map((invoice)=>{
        return /*#__PURE__*/ $8FY87.createElement((0, $263356cc61dd2835$export$2e2bcd8739ae039), {
            key: invoice.id,
            data: invoice
        });
    })))));
};
var $ef77c9de594ee7e7$export$2e2bcd8739ae039 = $ef77c9de594ee7e7$var$ConfigBillings;




var $8FY87 = parcelRequire("8FY87");


var $dxgjV = parcelRequire("dxgjV");


var $277cc6264f3b734a$exports = {};
"use strict";
"use client";

var $bcBLN = parcelRequire("bcBLN");
Object.defineProperty($277cc6264f3b734a$exports, "__esModule", {
    value: true
});
$277cc6264f3b734a$exports.default = void 0;

var $277cc6264f3b734a$var$_createSvgIcon = $bcBLN((parcelRequire("485sq")));

var $2PPWI = parcelRequire("2PPWI");
var $277cc6264f3b734a$var$_default = $277cc6264f3b734a$exports.default = (0, $277cc6264f3b734a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2PPWI.jsx)("path", {
    d: "m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
}), 'ExpandLess');



const $079176218bec9be8$var$ConfigContactForm = (props)=>{
    const [data, setData] = $8FY87.useState([]);
    const [subscriptions, setSubscriptions] = $8FY87.useState();
    const [loading, setLoading] = $8FY87.useState(false);
    const [fromDate, setFromDate] = $8FY87.useState("");
    const [toDate, setToDate] = $8FY87.useState("");
    const [allData, setAllData] = $8FY87.useState(false);
    const [expandedMonth, setExpandedMonth] = $8FY87.useState(null); // Accordion state
    // Fetch data from the API
    async function fetchData(siteId, fromDate, toDate, allData) {
        setLoading(true);
        try {
            let queryParams = `?siteId=${siteId}`;
            if (!allData) {
                if (fromDate) queryParams += `&fromDate=${fromDate}`;
                if (toDate) queryParams += `&toDate=${toDate}`;
            }
            let response = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).get(`/api/all-form-submissions${queryParams}`);
            setData(response.data.data);
            setSubscriptions(response.data.subsDetails);
        } catch (err) {
            console.log(err);
        } finally{
            setLoading(false);
        }
    }
    $8FY87.useEffect(()=>{
        fetchData(props.siteId);
    }, [
        props.siteId
    ]);
    // Handle date change and API call
    const handleFromDateChange = (e)=>{
        const date = e.target.value;
        setFromDate(date);
        fetchData(props.siteId, date, toDate, allData); // Fetch with the new fromDate
    };
    const handleToDateChange = (e)=>{
        const date = e.target.value;
        setToDate(date);
        fetchData(props.siteId, fromDate, date, allData); // Fetch with the new toDate
    };
    // Handle checkbox change and API call
    const handleAllDataChange = (e)=>{
        const checked = e.target.checked;
        setAllData(checked);
        fetchData(props.siteId, fromDate, toDate, checked); // Fetch with "all" data if checked
    };
    // Toggle accordion
    const toggleMonth = (month)=>{
        setExpandedMonth((prev)=>prev === month ? null : month);
    };
    // Group data by month
    const groupedData = data.reduce((acc, item)=>{
        const month = (0, (/*@__PURE__*/$parcel$interopDefault($dxgjV)))(item.created_at_dt).format("MMMM YYYY");
        if (!acc[month]) acc[month] = [];
        acc[month].push(item);
        return acc;
    }, {});
    return /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col text-black h-screen flex-1 md:mr-4 mt-2.5 md:mt-0"
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-base-2 mb-2"
    }, loading ? "Loading..." : `${data.length} Response(s)`), !loading && data.filter((ll)=>ll.isBlur).length > 0 && /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col md:flex-row justify-between items-center mt-3 mb-5 gap-4 leading-5"
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-base-3 text-red-500 relative pl-6"
    }, /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1c1878fa3817abc$exports))), {
        fontSize: "small",
        sx: {
            color: "red",
            left: "0px",
            position: "absolute",
            top: "2px"
        }
    }), `You have reached the limit of ${subscriptions.form_submission} contact form submissions on the ${subscriptions.name}. Upgrade to view all submissions.`), /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        size: "small",
        className: "h-8 pr-8 pl-8 mt-2 md:mt-0 whitespace-nowrap",
        variant: "contained",
        sx: {
            textTransform: "none"
        },
        onClick: ()=>{
            let _url = `/site-settings/${props.siteId}?section=Subscriptions`;
            window.open(_url, "_self")?.focus();
        }
    }, "View Plans")), Object.keys(groupedData).map((month)=>{
        const hasBlurredRows = groupedData[month].some((row)=>row.isBlur);
        let displayedBlurMessage = false; // Flag to track if the message has been displayed
        const formattedMonth = (0, (/*@__PURE__*/$parcel$interopDefault($dxgjV)))(month, "MMMM YYYY").format("MMMM, YYYY");
        let blurredRowsCount = 0;
        return /*#__PURE__*/ $8FY87.createElement("div", {
            key: month,
            className: "mb-2"
        }, /*#__PURE__*/ $8FY87.createElement("div", {
            className: "cursor-pointer bg-gray-100 py-2 px-4 font-bold border border-gray-300 flex items-center justify-between",
            onClick: ()=>toggleMonth(month)
        }, /*#__PURE__*/ $8FY87.createElement("span", {
            className: "flex-grow"
        }, formattedMonth, " (", groupedData[month].length, " responses)"), expandedMonth === month ? /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($277cc6264f3b734a$exports))), {
            className: "ml-auto text-gray-500"
        }) : /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1401b6f80f1b3ee6$exports))), {
            className: "ml-auto text-gray-500"
        })), /*#__PURE__*/ $8FY87.createElement("div", {
            className: "overflow-x-auto max-h-[400px]"
        }, expandedMonth === month && /*#__PURE__*/ $8FY87.createElement("table", {
            className: "relative xl:w-full border-collapse font-body rounded bg-white table-fixed mb-0 submissionTable"
        }, /*#__PURE__*/ $8FY87.createElement("thead", {
            className: "sticky top-0 bg-white z-10"
        }, /*#__PURE__*/ $8FY87.createElement("tr", null, /*#__PURE__*/ $8FY87.createElement("th", {
            className: "text-left w-1/6 px-2 py-1 border text-base"
        }, "Submitted"), /*#__PURE__*/ $8FY87.createElement("th", {
            className: "text-left w-1/6 px-2 py-1 border text-base"
        }, "First Name"), /*#__PURE__*/ $8FY87.createElement("th", {
            className: "text-left w-1/6 px-2 py-1 border text-base"
        }, "Last Name"), /*#__PURE__*/ $8FY87.createElement("th", {
            className: "text-left w-1/6 px-2 py-1 border text-base"
        }, "Email"), /*#__PURE__*/ $8FY87.createElement("th", {
            className: "text-left w-1/6 px-2 py-1 border text-base"
        }, "Phone Number"), /*#__PURE__*/ $8FY87.createElement("th", {
            className: "text-left w-1/6 min-w-[300px] px-2 py-1 border text-base"
        }, "Message"))), /*#__PURE__*/ $8FY87.createElement("tbody", null, groupedData[month].map((row)=>{
            const isBlurred = row.isBlur;
            const isFirstBlurredRow = isBlurred && !displayedBlurMessage;
            // Skip rendering more than 5 blurred rows
            if (isBlurred && blurredRowsCount >= 5) return null; // Stop rendering if we have already displayed 5 blurred rows
            // Increment the count if it's a blurred row
            if (isBlurred) blurredRowsCount++;
            if (isFirstBlurredRow) displayedBlurMessage = true; // Set the flag to true after displaying the message
            return /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, {
                key: row.id
            }, isFirstBlurredRow && /*#__PURE__*/ $8FY87.createElement("tr", {
                className: "absolute bottom-0 left-0 right-0"
            }, /*#__PURE__*/ $8FY87.createElement("td", {
                colSpan: 6,
                className: "absolute bottom-0 left-0 right-0 py-8"
            }, /*#__PURE__*/ $8FY87.createElement("div", {
                className: "w-[400px] mx-auto text-center bg-white relative border border-red-400 text-red-600 px-4 pb-2 pt-4 flex flex-col items-center justify-center seeResponse"
            }, /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($80cdb5096bdf46ee$exports))), {
                className: "mr-2 text-red-600"
            }), /*#__PURE__*/ $8FY87.createElement("span", {
                className: "mb-3 text-base leading-6"
            }, "Upgrade to see the rest", " ", groupedData[month].length - subscriptions.form_submission, groupedData[month].length - subscriptions.form_submission > 1 ? /*#__PURE__*/ $8FY87.createElement("span", null, " responses") : /*#__PURE__*/ $8FY87.createElement("span", null, " response"), "."), /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
                size: "small",
                className: "h-8 pr-4 pl-4 mt-2 md:mt-0 whitespace-nowrap",
                variant: "contained",
                sx: {
                    textTransform: "none"
                },
                onClick: ()=>{
                    let _url = `/site-settings/${props.siteId}?section=Subscriptions`;
                    window.open(_url, "_self")?.focus();
                }
            }, "View Plans")))), /*#__PURE__*/ $8FY87.createElement("tr", {
                className: `${isBlurred ? "relative isBlurred" : ""}`
            }, /*#__PURE__*/ $8FY87.createElement("td", {
                className: `text-left px-2 py-3 border text-xsm break-words leading-3 ${isBlurred ? "blur-sm text-gray-400" : ""}`
            }, (0, (/*@__PURE__*/$parcel$interopDefault($dxgjV)))(row.created_at_dt).format("HH:mm:ss, DD-MM-YYYY")), /*#__PURE__*/ $8FY87.createElement("td", {
                className: `text-left px-2 py-3 border text-xsm break-words leading-3 ${isBlurred ? "blur-sm text-gray-400" : ""}`
            }, row?.firstName), /*#__PURE__*/ $8FY87.createElement("td", {
                className: `text-left px-2 py-3 border text-xsm break-words leading-3 ${isBlurred ? "blur-sm text-gray-400" : ""}`
            }, row?.lastName), /*#__PURE__*/ $8FY87.createElement("td", {
                className: `text-left px-2 py-3 border text-xsm break-words leading-3 ${isBlurred ? "blur-sm text-gray-400" : ""}`
            }, row?.email), /*#__PURE__*/ $8FY87.createElement("td", {
                className: `text-left px-2 py-3 border text-xsm break-words leading-3 ${isBlurred ? "blur-sm text-gray-400" : ""}`
            }, row?.phoneNumber), /*#__PURE__*/ $8FY87.createElement("td", {
                className: `text-left px-2 py-3 border text-xsm break-words leading-3 ${isBlurred ? "blur-sm text-gray-400" : ""}`
            }, row?.message)));
        }), hasBlurredRows && Array.from({
            length: 5 - blurredRowsCount
        }).map((_, index)=>/*#__PURE__*/ $8FY87.createElement("tr", {
                key: `placeholder-${index}`,
                className: "relative isBlurred"
            }, " ", /*#__PURE__*/ $8FY87.createElement("td", {
                className: "text-left px-2 py-3 border text-xsm break-words leading-3 blur-sm text-gray-400"
            }, "\xa0"), /*#__PURE__*/ $8FY87.createElement("td", {
                className: "text-left px-2 py-3 border text-xsm break-words leading-3 blur-sm text-gray-400"
            }, "\xa0"), /*#__PURE__*/ $8FY87.createElement("td", {
                className: "text-left px-2 py-3 border text-xsm break-words leading-3 blur-sm text-gray-400"
            }, "\xa0"), /*#__PURE__*/ $8FY87.createElement("td", {
                className: "text-left px-2 py-3 border text-xsm break-words leading-3 blur-sm text-gray-400"
            }, "\xa0"), /*#__PURE__*/ $8FY87.createElement("td", {
                className: "text-left px-2 py-3 border text-xsm break-words leading-3 blur-sm text-gray-400"
            }, "\xa0"), /*#__PURE__*/ $8FY87.createElement("td", {
                className: "text-left px-2 py-3 border text-xsm break-words leading-3 blur-sm text-gray-400"
            }, "\xa0")))))));
    }));
};
var $079176218bec9be8$export$2e2bcd8739ae039 = $079176218bec9be8$var$ConfigContactForm;





var $8FY87 = parcelRequire("8FY87");



var $8FY87 = parcelRequire("8FY87");



const $975d19ac31f25d38$var$ContributorItem = (props)=>{
    return /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-row justify-between my-2 items-center"
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-sm sm:text-base"
    }, props.email), /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        size: "small",
        variant: "outlined",
        className: "hidden sm:block",
        sx: {
            textTransform: "none"
        },
        onClick: props.onRemoveUser
    }, "Remove"), /*#__PURE__*/ $8FY87.createElement((0, $8765ef9b64e3c3e6$export$2e2bcd8739ae039), {
        "aria-label": "delete",
        className: "sm:hidden",
        size: "small"
    }, /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($4c5cf14ed582dae7$exports))), {
        fontSize: "inherit"
    })));
};
var $975d19ac31f25d38$export$2e2bcd8739ae039 = $975d19ac31f25d38$var$ContributorItem;



const $6768eaa9b46c6d7c$var$ConfigContributors = (props)=>{
    const [cookies] = (0, $1f373de1ceea6eb7$export$2e2bcd8739ae039)([
        "rp_user_data"
    ]);
    const [emails, setEmails] = $8FY87.useState("");
    const [error, setError] = $8FY87.useState("");
    const [addOnUsers, setAddOnUsers] = $8FY87.useState(props.addOnUsers || []);
    $8FY87.useEffect(()=>{
        // console.log("ConfigContributors", props.addOnUsers);
        setAddOnUsers(props.addOnUsers);
    }, [
        props.addOnUsers
    ]);
    const onSendInvite = ()=>{
        // Split string by comma into an array
        let l_emails = emails.split(",");
        let l_validEmails = [];
        var valid = true;
        var regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let invalidEmails = [];
        for(var i = 0; i < l_emails.length; i++){
            // Trim whitespaces from email address
            l_emails[i] = l_emails[i].trim();
            // Check email against our regex to determine if email is valid
            // console.log(
            //   "asasas",
            //   cookies.rp_user_data ? cookies.rp_user_data.email : ""
            // );
            if (l_emails[i] == "" || !regex.test(l_emails[i]) || l_emails[i] === (cookies.rp_user_data ? cookies.rp_user_data.email : "")) invalidEmails.push(l_emails[i]);
            else if (!addOnUsers.find((kk)=>kk.email === l_emails[i]) && !l_validEmails.find((kk)=>kk.email === l_emails[i])) l_validEmails.push({
                email: l_emails[i],
                role: "editor"
            });
        }
        if (invalidEmails.filter((kk)=>kk !== "").length > 0) // setError(`Invalid Email Address. Please make sure you've entered a correctly formatted email address (e.g., example@email.com): ${invalidEmails.join(", ")}`);
        setError(`The email address "${invalidEmails.join(", ")}" is invalid. Please ensure you've entered a correctly formatted email address (e.g., example@email.com)`);
        else {
            setError(``);
            setEmails("");
            let l_onlyEmails = [];
            l_validEmails.forEach((ii)=>{
                l_onlyEmails.push(ii.email);
            });
            props.onAddOnUsersAdd(l_onlyEmails);
            setAddOnUsers((old)=>{
                props.onDataChange({
                    addOnUsers: [
                        ...old,
                        ...l_validEmails
                    ]
                });
                return [
                    ...old,
                    ...l_validEmails
                ];
            });
        }
    // console.log(invalidEmails);
    };
    return /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col text-black h-screen left-sidebar-contributors"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col"
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-base-2 mb-2"
    }, "Invite contributors"), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "font-normal mb-2"
    }, "Contributors can view, edit and publish the shared website. However, they cannot delete or duplicate it. You can cancel access at any time."), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col lg:flex-row"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col pb-2 lg:pb-0"
    }, /*#__PURE__*/ $8FY87.createElement("input", {
        className: "border rounded border-catelina-blue/60 py-1 px-2 mr-3 w-full md:w-80",
        placeholder: "Email, comma separated",
        value: emails,
        onChange: (e)=>{
            setEmails((0, $df5cb81582703dc6$export$2e2bcd8739ae039)(e.target.value));
            setError("");
        }
    })), /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        size: "small",
        className: "h-8 w-28",
        variant: "contained",
        sx: {
            textTransform: "none"
        },
        onClick: onSendInvite,
        disabled: emails === ""
    }, "Send invite")), error !== "" && /*#__PURE__*/ $8FY87.createElement("label", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($0d91efdf621c0fba$exports))).errorLabels}`
    }, error), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "py-2 w-full max-w-full md:max-w-md"
    }, /*#__PURE__*/ $8FY87.createElement((0, $30a538faf9a95dbb$export$2e2bcd8739ae039), null)), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "w-full max-w-full md:max-w-md"
    }, addOnUsers && addOnUsers.map((row)=>{
        return /*#__PURE__*/ $8FY87.createElement((0, $975d19ac31f25d38$export$2e2bcd8739ae039), {
            key: row.email,
            email: row.email,
            onRemoveUser: ()=>{
                // console.log('onremove user', row.email)
                props.onAddOnUsersRemove(row.email);
                let l_new_addonusers = addOnUsers.filter((ll)=>ll.email !== row.email);
                props.onDataChange({
                    addOnUsers: l_new_addonusers
                });
                setAddOnUsers(l_new_addonusers);
            }
        });
    }))));
};
var $6768eaa9b46c6d7c$export$2e2bcd8739ae039 = $6768eaa9b46c6d7c$var$ConfigContributors;




var $8FY87 = parcelRequire("8FY87");
const $93437f1c2420419c$var$ConfigCustomCode = (props)=>{
    return /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col text-black left-sidebar-custome-code"
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-base-2 mb-2"
    }, "<head> custom HTML code"), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "font-normal mb-2"
    }, "Include HTML code to your website <head>. You can make use of <script> and <style> HTML tags too."), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-row"
    }, /*#__PURE__*/ $8FY87.createElement("textarea", {
        value: props.head_customHtmlCode,
        onChange: (e)=>{
            props.onDataChange({
                head_customHtmlCode: e.target.value
            });
        },
        className: "w-full lg:w-4/5 border rounded border-catelina-blue/60 py-1 px-2",
        placeholder: "<script src=\u201Dhttps://www.googletagmanager.com/gtag/js?id=UA-XXX-X\u201D></script>",
        rows: 8
    })), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "py-8"
    }, /*#__PURE__*/ $8FY87.createElement((0, $30a538faf9a95dbb$export$2e2bcd8739ae039), null)), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-base-2 mb-2"
    }, "<body> custom HTML code"), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "font-normal mb-2"
    }, "Include HTML code to your website <body>. This code will be appended at the last of body tag."), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-row"
    }, /*#__PURE__*/ $8FY87.createElement("textarea", {
        value: props.body_customHtmlCode,
        onChange: (e)=>{
            props.onDataChange({
                body_customHtmlCode: e.target.value
            });
        },
        className: "w-full lg:w-4/5 border rounded border-catelina-blue/60 py-1 px-2",
        placeholder: "<script src=\u201Dhttps://www.googletagmanager.com/gtag/js?id=UA-XXX-X\u201D></script>",
        rows: 8
    })));
};
var $93437f1c2420419c$export$2e2bcd8739ae039 = $93437f1c2420419c$var$ConfigCustomCode;



var $8FY87 = parcelRequire("8FY87");

var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $lXBIJ = parcelRequire("lXBIJ");


var $ifmKX = parcelRequire("ifmKX");

var $6lkQ3 = parcelRequire("6lkQ3");

var $lbp1P = parcelRequire("lbp1P");


var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $837f9757117aa207$export$72aef224d6115253(slot) {
    return (0, $jP65K.default)('MuiTab', slot);
}
const $837f9757117aa207$var$tabClasses = (0, $cOYaX.default)('MuiTab', [
    'root',
    'labelIcon',
    'textColorInherit',
    'textColorPrimary',
    'textColorSecondary',
    'selected',
    'disabled',
    'fullWidth',
    'wrapped',
    'iconWrapper'
]);
var $837f9757117aa207$export$2e2bcd8739ae039 = $837f9757117aa207$var$tabClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $e7d54e7d83e3c56c$var$_excluded = [
    "className",
    "disabled",
    "disableFocusRipple",
    "fullWidth",
    "icon",
    "iconPosition",
    "indicator",
    "label",
    "onChange",
    "onClick",
    "onFocus",
    "selected",
    "selectionFollowsFocus",
    "textColor",
    "value",
    "wrapped"
];
const $e7d54e7d83e3c56c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, textColor: textColor, fullWidth: fullWidth, wrapped: wrapped, icon: icon, label: label, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            icon && label && 'labelIcon',
            `textColor${(0, $ifmKX.default)(textColor)}`,
            fullWidth && 'fullWidth',
            wrapped && 'wrapped',
            selected && 'selected',
            disabled && 'disabled'
        ],
        iconWrapper: [
            'iconWrapper'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $837f9757117aa207$export$72aef224d6115253), classes);
};
const $e7d54e7d83e3c56c$var$TabRoot = (0, $lbp1P.default)((0, $21281888ae95b2bd$export$2e2bcd8739ae039), {
    name: 'MuiTab',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.label && ownerState.icon && styles.labelIcon,
            styles[`textColor${(0, $ifmKX.default)(ownerState.textColor)}`],
            ownerState.fullWidth && styles.fullWidth,
            ownerState.wrapped && styles.wrapped,
            {
                [`& .${(0, $837f9757117aa207$export$2e2bcd8739ae039).iconWrapper}`]: styles.iconWrapper
            }
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $zgVxD.default)({}, theme.typography.button, {
        maxWidth: 360,
        minWidth: 90,
        position: 'relative',
        minHeight: 48,
        flexShrink: 0,
        padding: '12px 16px',
        overflow: 'hidden',
        whiteSpace: 'normal',
        textAlign: 'center'
    }, ownerState.label && {
        flexDirection: ownerState.iconPosition === 'top' || ownerState.iconPosition === 'bottom' ? 'column' : 'row'
    }, {
        lineHeight: 1.25
    }, ownerState.icon && ownerState.label && {
        minHeight: 72,
        paddingTop: 9,
        paddingBottom: 9,
        [`& > .${(0, $837f9757117aa207$export$2e2bcd8739ae039).iconWrapper}`]: (0, $zgVxD.default)({}, ownerState.iconPosition === 'top' && {
            marginBottom: 6
        }, ownerState.iconPosition === 'bottom' && {
            marginTop: 6
        }, ownerState.iconPosition === 'start' && {
            marginRight: theme.spacing(1)
        }, ownerState.iconPosition === 'end' && {
            marginLeft: theme.spacing(1)
        })
    }, ownerState.textColor === 'inherit' && {
        color: 'inherit',
        opacity: 0.6,
        // same opacity as theme.palette.text.secondary
        [`&.${(0, $837f9757117aa207$export$2e2bcd8739ae039).selected}`]: {
            opacity: 1
        },
        [`&.${(0, $837f9757117aa207$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.textColor === 'primary' && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $837f9757117aa207$export$2e2bcd8739ae039).selected}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $837f9757117aa207$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.textColor === 'secondary' && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $837f9757117aa207$export$2e2bcd8739ae039).selected}`]: {
            color: (theme.vars || theme).palette.secondary.main
        },
        [`&.${(0, $837f9757117aa207$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.fullWidth && {
        flexShrink: 1,
        flexGrow: 1,
        flexBasis: 0,
        maxWidth: 'none'
    }, ownerState.wrapped && {
        fontSize: theme.typography.pxToRem(12)
    }));
const $e7d54e7d83e3c56c$var$Tab = /*#__PURE__*/ $8FY87.forwardRef(function Tab(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiTab'
    });
    const { className: className, disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: // eslint-disable-next-line react/prop-types
    fullWidth, icon: iconProp, iconPosition: iconPosition = 'top', indicator: // eslint-disable-next-line react/prop-types
    indicator, label: label, onChange: onChange, onClick: onClick, onFocus: onFocus, selected: // eslint-disable-next-line react/prop-types
    selected, selectionFollowsFocus: // eslint-disable-next-line react/prop-types
    selectionFollowsFocus, textColor: // eslint-disable-next-line react/prop-types
    textColor = 'inherit', value: value, wrapped: wrapped = false } = props, other = (0, $93aRW.default)(props, $e7d54e7d83e3c56c$var$_excluded);
    const ownerState = (0, $zgVxD.default)({}, props, {
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        selected: selected,
        icon: !!iconProp,
        iconPosition: iconPosition,
        label: !!label,
        fullWidth: fullWidth,
        textColor: textColor,
        wrapped: wrapped
    });
    const classes = $e7d54e7d83e3c56c$var$useUtilityClasses(ownerState);
    const icon = iconProp && label && /*#__PURE__*/ $8FY87.isValidElement(iconProp) ? /*#__PURE__*/ $8FY87.cloneElement(iconProp, {
        className: (0, $efJYy.default)(classes.iconWrapper, iconProp.props.className)
    }) : iconProp;
    const handleClick = (event)=>{
        if (!selected && onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    const handleFocus = (event)=>{
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ (0, $2PPWI.jsxs)($e7d54e7d83e3c56c$var$TabRoot, (0, $zgVxD.default)({
        focusRipple: !disableFocusRipple,
        className: (0, $efJYy.default)(classes.root, className),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        ownerState: ownerState,
        tabIndex: selected ? 0 : -1
    }, other, {
        children: [
            iconPosition === 'top' || iconPosition === 'start' ? /*#__PURE__*/ (0, $2PPWI.jsxs)($8FY87.Fragment, {
                children: [
                    icon,
                    label
                ]
            }) : /*#__PURE__*/ (0, $2PPWI.jsxs)($8FY87.Fragment, {
                children: [
                    label,
                    icon
                ]
            }),
            indicator
        ]
    }));
});
var $e7d54e7d83e3c56c$export$2e2bcd8739ae039 = $e7d54e7d83e3c56c$var$Tab;



var $8FY87 = parcelRequire("8FY87");


var $2PPWI = parcelRequire("2PPWI");
'use client';
const $65ede3c1fb83823f$var$Context = /*#__PURE__*/ $8FY87.createContext(null);
function $65ede3c1fb83823f$var$useUniquePrefix() {
    const [id, setId] = $8FY87.useState(null);
    $8FY87.useEffect(()=>{
        setId(`mui-p-${Math.round(Math.random() * 1e5)}`);
    }, []);
    return id;
}
function $65ede3c1fb83823f$export$2e2bcd8739ae039(props) {
    const { children: children, value: value } = props;
    const idPrefix = $65ede3c1fb83823f$var$useUniquePrefix();
    const context = $8FY87.useMemo(()=>{
        return {
            idPrefix: idPrefix,
            value: value
        };
    }, [
        idPrefix,
        value
    ]);
    return /*#__PURE__*/ (0, $2PPWI.jsx)($65ede3c1fb83823f$var$Context.Provider, {
        value: context,
        children: children
    });
}
function $65ede3c1fb83823f$export$5a3bad273ac578e0() {
    return $8FY87.useContext($65ede3c1fb83823f$var$Context);
}
function $65ede3c1fb83823f$export$629f80328afcade5(context, value) {
    const { idPrefix: idPrefix } = context;
    if (idPrefix === null) return null;
    return `${context.idPrefix}-P-${value}`;
}
function $65ede3c1fb83823f$export$46f6d19d28231cb8(context, value) {
    const { idPrefix: idPrefix } = context;
    if (idPrefix === null) return null;
    return `${context.idPrefix}-T-${value}`;
}



var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");

var $8FY87 = parcelRequire("8FY87");

function $7422b12ca81f6261$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $7422b12ca81f6261$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $7422b12ca81f6261$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $7422b12ca81f6261$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $7422b12ca81f6261$export$2e2bcd8739ae039 = $7422b12ca81f6261$export$4f5d2d50c9deca37;



var $lbp1P = parcelRequire("lbp1P");

var $jyLqM = parcelRequire("jyLqM");

var $ab2pD = parcelRequire("ab2pD");
'use client';
function $0bb1688d0ec246cd$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $6ead70688dfc969e$export$2e2bcd8739ae039)({
        props: props,
        name: name,
        defaultTheme: $jyLqM.default,
        themeId: (0, $ab2pD.default)
    });
}



var $lXBIJ = parcelRequire("lXBIJ");

var $jP65K = parcelRequire("jP65K");

var $cOYaX = parcelRequire("cOYaX");
function $16e83b227112fa36$export$cfb3da2e74936ec(slot) {
    return (0, $jP65K.default)('MuiTabPanel', slot);
}
const $16e83b227112fa36$var$tabPanelClasses = (0, $cOYaX.default)('MuiTabPanel', [
    'root'
]);
var $16e83b227112fa36$export$2e2bcd8739ae039 = $16e83b227112fa36$var$tabPanelClasses;




var $2PPWI = parcelRequire("2PPWI");
'use client';
const $0b35694b79d42e6e$var$_excluded = [
    "children",
    "className",
    "value"
];
const $0b35694b79d42e6e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $16e83b227112fa36$export$cfb3da2e74936ec), classes);
};
const $0b35694b79d42e6e$var$TabPanelRoot = (0, $lbp1P.default)('div', {
    name: 'MuiTabPanel',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        padding: theme.spacing(3)
    }));
const $0b35694b79d42e6e$var$TabPanel = /*#__PURE__*/ $8FY87.forwardRef(function TabPanel(inProps, ref) {
    const props = (0, $0bb1688d0ec246cd$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiTabPanel'
    });
    const { children: children, className: className, value: value } = props, other = (0, $93aRW.default)(props, $0b35694b79d42e6e$var$_excluded);
    const ownerState = (0, $zgVxD.default)({}, props);
    const classes = $0b35694b79d42e6e$var$useUtilityClasses(ownerState);
    const context = (0, $65ede3c1fb83823f$export$5a3bad273ac578e0)();
    if (context === null) throw new TypeError('No TabContext provided');
    const id = (0, $65ede3c1fb83823f$export$629f80328afcade5)(context, value);
    const tabId = (0, $65ede3c1fb83823f$export$46f6d19d28231cb8)(context, value);
    return /*#__PURE__*/ (0, $2PPWI.jsx)($0b35694b79d42e6e$var$TabPanelRoot, (0, $zgVxD.default)({
        "aria-labelledby": tabId,
        className: (0, $7422b12ca81f6261$export$2e2bcd8739ae039)(classes.root, className),
        hidden: value !== context.value,
        id: id,
        ref: ref,
        role: "tabpanel",
        ownerState: ownerState
    }, other, {
        children: value === context.value && children
    }));
});
var $0b35694b79d42e6e$export$2e2bcd8739ae039 = $0b35694b79d42e6e$var$TabPanel;



var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");



var $efJYy = parcelRequire("efJYy");


var $lXBIJ = parcelRequire("lXBIJ");



var $lbp1P = parcelRequire("lbp1P");

var $6lkQ3 = parcelRequire("6lkQ3");


// Source from https://github.com/alitaheri/normalize-scroll-left
let $ce10ab839d2d6153$var$cachedType;
function $ce10ab839d2d6153$export$a10970ffb6510128() {
    if ($ce10ab839d2d6153$var$cachedType) return $ce10ab839d2d6153$var$cachedType;
    const dummy = document.createElement('div');
    const container = document.createElement('div');
    container.style.width = '10px';
    container.style.height = '1px';
    dummy.appendChild(container);
    dummy.dir = 'rtl';
    dummy.style.fontSize = '14px';
    dummy.style.width = '4px';
    dummy.style.height = '1px';
    dummy.style.position = 'absolute';
    dummy.style.top = '-1000px';
    dummy.style.overflow = 'scroll';
    document.body.appendChild(dummy);
    $ce10ab839d2d6153$var$cachedType = 'reverse';
    if (dummy.scrollLeft > 0) $ce10ab839d2d6153$var$cachedType = 'default';
    else {
        dummy.scrollLeft = 1;
        if (dummy.scrollLeft === 0) $ce10ab839d2d6153$var$cachedType = 'negative';
    }
    document.body.removeChild(dummy);
    return $ce10ab839d2d6153$var$cachedType;
}
function $ce10ab839d2d6153$export$3c615b88e5d7e4f6(element, direction) {
    const scrollLeft = element.scrollLeft;
    // Perform the calculations only when direction is rtl to avoid messing up the ltr behavior
    if (direction !== 'rtl') return scrollLeft;
    const type = $ce10ab839d2d6153$export$a10970ffb6510128();
    switch(type){
        case 'negative':
            return element.scrollWidth - element.clientWidth + scrollLeft;
        case 'reverse':
            return element.scrollWidth - element.clientWidth - scrollLeft;
        default:
            return scrollLeft;
    }
}


function $9808a0b2879c773a$var$easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function $9808a0b2879c773a$export$2e2bcd8739ae039(property, element, to, options = {}, cb = ()=>{}) {
    const { ease: ease = $9808a0b2879c773a$var$easeInOutSin, duration: duration = 300 // standard
     } = options;
    let start = null;
    const from = element[property];
    let cancelled = false;
    const cancel = ()=>{
        cancelled = true;
    };
    const step = (timestamp)=>{
        if (cancelled) {
            cb(new Error('Animation cancelled'));
            return;
        }
        if (start === null) start = timestamp;
        const time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(()=>{
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error('Element already at target position'));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}



var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");

var $8FY87 = parcelRequire("8FY87");




var $2PPWI = parcelRequire("2PPWI");
'use client';
const $f36d7f868d9ff422$var$_excluded = [
    "onChange"
];
const $f36d7f868d9ff422$var$styles = {
    width: 99,
    height: 99,
    position: 'absolute',
    top: -9999,
    overflow: 'scroll'
};
function $f36d7f868d9ff422$export$2e2bcd8739ae039(props) {
    const { onChange: onChange } = props, other = (0, $93aRW.default)(props, $f36d7f868d9ff422$var$_excluded);
    const scrollbarHeight = $8FY87.useRef();
    const nodeRef = $8FY87.useRef(null);
    const setMeasurements = ()=>{
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    (0, $fb693b740ef0e8ff$export$2e2bcd8739ae039)(()=>{
        const handleResize = (0, $35a8cdd58dd5c41a$export$2e2bcd8739ae039)(()=>{
            const prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        const containerWindow = (0, $e94801ab1411f138$export$2e2bcd8739ae039)(nodeRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        onChange
    ]);
    $8FY87.useEffect(()=>{
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", (0, $zgVxD.default)({
        style: $f36d7f868d9ff422$var$styles
    }, other, {
        ref: nodeRef
    }));
}



var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $lXBIJ = parcelRequire("lXBIJ");


parcelRequire("8FY87");

var $cHXYB = parcelRequire("cHXYB");

var $2PPWI = parcelRequire("2PPWI");
'use client';
var $daadb96598ed108f$export$2e2bcd8739ae039 = (0, $cHXYB.default)(/*#__PURE__*/ (0, $2PPWI.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft');


parcelRequire("8FY87");

var $cHXYB = parcelRequire("cHXYB");

var $2PPWI = parcelRequire("2PPWI");
'use client';
var $14d454ea971dc4e1$export$2e2bcd8739ae039 = (0, $cHXYB.default)(/*#__PURE__*/ (0, $2PPWI.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight');




var $6lkQ3 = parcelRequire("6lkQ3");

var $lbp1P = parcelRequire("lbp1P");

var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $c7d0d6c57828bf52$export$34861783d3c2eef8(slot) {
    return (0, $jP65K.default)('MuiTabScrollButton', slot);
}
const $c7d0d6c57828bf52$var$tabScrollButtonClasses = (0, $cOYaX.default)('MuiTabScrollButton', [
    'root',
    'vertical',
    'horizontal',
    'disabled'
]);
var $c7d0d6c57828bf52$export$2e2bcd8739ae039 = $c7d0d6c57828bf52$var$tabScrollButtonClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $cff5b73e8c479e42$var$_excluded = [
    "className",
    "slots",
    "slotProps",
    "direction",
    "orientation",
    "disabled"
];
const $cff5b73e8c479e42$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            disabled && 'disabled'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $c7d0d6c57828bf52$export$34861783d3c2eef8), classes);
};
const $cff5b73e8c479e42$var$TabScrollButtonRoot = (0, $lbp1P.default)((0, $21281888ae95b2bd$export$2e2bcd8739ae039), {
    name: 'MuiTabScrollButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.orientation && styles[ownerState.orientation]
        ];
    }
})(({ ownerState: ownerState })=>(0, $zgVxD.default)({
        width: 40,
        flexShrink: 0,
        opacity: 0.8,
        [`&.${(0, $c7d0d6c57828bf52$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 0
        }
    }, ownerState.orientation === 'vertical' && {
        width: '100%',
        height: 40,
        '& svg': {
            transform: `rotate(${ownerState.isRtl ? -90 : 90}deg)`
        }
    }));
const $cff5b73e8c479e42$var$TabScrollButton = /*#__PURE__*/ $8FY87.forwardRef(function TabScrollButton(inProps, ref) {
    var _slots$StartScrollBut, _slots$EndScrollButto;
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiTabScrollButton'
    });
    const { className: className, slots: slots = {}, slotProps: slotProps = {}, direction: direction } = props, other = (0, $93aRW.default)(props, $cff5b73e8c479e42$var$_excluded);
    const isRtl = (0, $fd8721cf96f8ae09$export$b2dd014b6c321cb)();
    const ownerState = (0, $zgVxD.default)({
        isRtl: isRtl
    }, props);
    const classes = $cff5b73e8c479e42$var$useUtilityClasses(ownerState);
    const StartButtonIcon = (_slots$StartScrollBut = slots.StartScrollButtonIcon) != null ? _slots$StartScrollBut : (0, $daadb96598ed108f$export$2e2bcd8739ae039);
    const EndButtonIcon = (_slots$EndScrollButto = slots.EndScrollButtonIcon) != null ? _slots$EndScrollButto : (0, $14d454ea971dc4e1$export$2e2bcd8739ae039);
    const startButtonIconProps = (0, $eeee79b1d2d55995$export$2e2bcd8739ae039)({
        elementType: StartButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    const endButtonIconProps = (0, $eeee79b1d2d55995$export$2e2bcd8739ae039)({
        elementType: EndButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $2PPWI.jsx)($cff5b73e8c479e42$var$TabScrollButtonRoot, (0, $zgVxD.default)({
        component: "div",
        className: (0, $efJYy.default)(classes.root, className),
        ref: ref,
        role: null,
        ownerState: ownerState,
        tabIndex: null
    }, other, {
        children: direction === 'left' ? /*#__PURE__*/ (0, $2PPWI.jsx)(StartButtonIcon, (0, $zgVxD.default)({}, startButtonIconProps)) : /*#__PURE__*/ (0, $2PPWI.jsx)(EndButtonIcon, (0, $zgVxD.default)({}, endButtonIconProps))
    }));
});
var $cff5b73e8c479e42$export$2e2bcd8739ae039 = $cff5b73e8c479e42$var$TabScrollButton;




var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $4d3f9ab5c960cbab$export$cdd93bd054dec359(slot) {
    return (0, $jP65K.default)('MuiTabs', slot);
}
const $4d3f9ab5c960cbab$var$tabsClasses = (0, $cOYaX.default)('MuiTabs', [
    'root',
    'vertical',
    'flexContainer',
    'flexContainerVertical',
    'centered',
    'scroller',
    'fixed',
    'scrollableX',
    'scrollableY',
    'hideScrollbar',
    'scrollButtons',
    'scrollButtonsHideMobile',
    'indicator'
]);
var $4d3f9ab5c960cbab$export$2e2bcd8739ae039 = $4d3f9ab5c960cbab$var$tabsClasses;





var $2PPWI = parcelRequire("2PPWI");
'use client';
const $0181e7500204b60c$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "action",
    "centered",
    "children",
    "className",
    "component",
    "allowScrollButtonsMobile",
    "indicatorColor",
    "onChange",
    "orientation",
    "ScrollButtonComponent",
    "scrollButtons",
    "selectionFollowsFocus",
    "slots",
    "slotProps",
    "TabIndicatorProps",
    "TabScrollButtonProps",
    "textColor",
    "value",
    "variant",
    "visibleScrollbar"
];
const $0181e7500204b60c$var$nextItem = (list, item)=>{
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return list.firstChild;
};
const $0181e7500204b60c$var$previousItem = (list, item)=>{
    if (list === item) return list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return list.lastChild;
};
const $0181e7500204b60c$var$moveFocus = (list, currentFocus, traversalFunction)=>{
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus);
        else {
            nextFocus.focus();
            return;
        }
    }
};
const $0181e7500204b60c$var$useUtilityClasses = (ownerState)=>{
    const { vertical: vertical, fixed: fixed, hideScrollbar: hideScrollbar, scrollableX: scrollableX, scrollableY: scrollableY, centered: centered, scrollButtonsHideMobile: scrollButtonsHideMobile, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            vertical && 'vertical'
        ],
        scroller: [
            'scroller',
            fixed && 'fixed',
            hideScrollbar && 'hideScrollbar',
            scrollableX && 'scrollableX',
            scrollableY && 'scrollableY'
        ],
        flexContainer: [
            'flexContainer',
            vertical && 'flexContainerVertical',
            centered && 'centered'
        ],
        indicator: [
            'indicator'
        ],
        scrollButtons: [
            'scrollButtons',
            scrollButtonsHideMobile && 'scrollButtonsHideMobile'
        ],
        scrollableX: [
            scrollableX && 'scrollableX'
        ],
        hideScrollbar: [
            hideScrollbar && 'hideScrollbar'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $4d3f9ab5c960cbab$export$cdd93bd054dec359), classes);
};
const $0181e7500204b60c$var$TabsRoot = (0, $lbp1P.default)('div', {
    name: 'MuiTabs',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $4d3f9ab5c960cbab$export$2e2bcd8739ae039).scrollButtons}`]: styles.scrollButtons
            },
            {
                [`& .${(0, $4d3f9ab5c960cbab$export$2e2bcd8739ae039).scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile
            },
            styles.root,
            ownerState.vertical && styles.vertical
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $zgVxD.default)({
        overflow: 'hidden',
        minHeight: 48,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        display: 'flex'
    }, ownerState.vertical && {
        flexDirection: 'column'
    }, ownerState.scrollButtonsHideMobile && {
        [`& .${(0, $4d3f9ab5c960cbab$export$2e2bcd8739ae039).scrollButtons}`]: {
            [theme.breakpoints.down('sm')]: {
                display: 'none'
            }
        }
    }));
const $0181e7500204b60c$var$TabsScroller = (0, $lbp1P.default)('div', {
    name: 'MuiTabs',
    slot: 'Scroller',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.scroller,
            ownerState.fixed && styles.fixed,
            ownerState.hideScrollbar && styles.hideScrollbar,
            ownerState.scrollableX && styles.scrollableX,
            ownerState.scrollableY && styles.scrollableY
        ];
    }
})(({ ownerState: ownerState })=>(0, $zgVxD.default)({
        position: 'relative',
        display: 'inline-block',
        flex: '1 1 auto',
        whiteSpace: 'nowrap'
    }, ownerState.fixed && {
        overflowX: 'hidden',
        width: '100%'
    }, ownerState.hideScrollbar && {
        // Hide dimensionless scrollbar on macOS
        scrollbarWidth: 'none',
        // Firefox
        '&::-webkit-scrollbar': {
            display: 'none' // Safari + Chrome
        }
    }, ownerState.scrollableX && {
        overflowX: 'auto',
        overflowY: 'hidden'
    }, ownerState.scrollableY && {
        overflowY: 'auto',
        overflowX: 'hidden'
    }));
const $0181e7500204b60c$var$FlexContainer = (0, $lbp1P.default)('div', {
    name: 'MuiTabs',
    slot: 'FlexContainer',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.flexContainer,
            ownerState.vertical && styles.flexContainerVertical,
            ownerState.centered && styles.centered
        ];
    }
})(({ ownerState: ownerState })=>(0, $zgVxD.default)({
        display: 'flex'
    }, ownerState.vertical && {
        flexDirection: 'column'
    }, ownerState.centered && {
        justifyContent: 'center'
    }));
const $0181e7500204b60c$var$TabsIndicator = (0, $lbp1P.default)('span', {
    name: 'MuiTabs',
    slot: 'Indicator',
    overridesResolver: (props, styles)=>styles.indicator
})(({ ownerState: ownerState, theme: theme })=>(0, $zgVxD.default)({
        position: 'absolute',
        height: 2,
        bottom: 0,
        width: '100%',
        transition: theme.transitions.create()
    }, ownerState.indicatorColor === 'primary' && {
        backgroundColor: (theme.vars || theme).palette.primary.main
    }, ownerState.indicatorColor === 'secondary' && {
        backgroundColor: (theme.vars || theme).palette.secondary.main
    }, ownerState.vertical && {
        height: '100%',
        width: 2,
        right: 0
    }));
const $0181e7500204b60c$var$TabsScrollbarSize = (0, $lbp1P.default)((0, $f36d7f868d9ff422$export$2e2bcd8739ae039))({
    overflowX: 'auto',
    overflowY: 'hidden',
    // Hide dimensionless scrollbar on macOS
    scrollbarWidth: 'none',
    // Firefox
    '&::-webkit-scrollbar': {
        display: 'none' // Safari + Chrome
    }
});
const $0181e7500204b60c$var$defaultIndicatorStyle = {};
let $0181e7500204b60c$var$warnedOnceTabPresent = false;
const $0181e7500204b60c$var$Tabs = /*#__PURE__*/ $8FY87.forwardRef(function Tabs(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiTabs'
    });
    const theme = (0, $0f82922e8f0d344d$export$2e2bcd8739ae039)();
    const isRtl = (0, $fd8721cf96f8ae09$export$b2dd014b6c321cb)();
    const { 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, action: action, centered: centered = false, children: childrenProp, className: className, component: component = 'div', allowScrollButtonsMobile: allowScrollButtonsMobile = false, indicatorColor: indicatorColor = 'primary', onChange: onChange, orientation: orientation = 'horizontal', ScrollButtonComponent: ScrollButtonComponent = (0, $cff5b73e8c479e42$export$2e2bcd8739ae039), scrollButtons: scrollButtons = 'auto', selectionFollowsFocus: selectionFollowsFocus, slots: slots = {}, slotProps: slotProps = {}, TabIndicatorProps: TabIndicatorProps = {}, TabScrollButtonProps: TabScrollButtonProps = {}, textColor: textColor = 'primary', value: value, variant: variant = 'standard', visibleScrollbar: visibleScrollbar = false } = props, other = (0, $93aRW.default)(props, $0181e7500204b60c$var$_excluded);
    const scrollable = variant === 'scrollable';
    const vertical = orientation === 'vertical';
    const scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
    const start = vertical ? 'top' : 'left';
    const end = vertical ? 'bottom' : 'right';
    const clientSize = vertical ? 'clientHeight' : 'clientWidth';
    const size = vertical ? 'height' : 'width';
    const ownerState = (0, $zgVxD.default)({}, props, {
        component: component,
        allowScrollButtonsMobile: allowScrollButtonsMobile,
        indicatorColor: indicatorColor,
        orientation: orientation,
        vertical: vertical,
        scrollButtons: scrollButtons,
        textColor: textColor,
        variant: variant,
        visibleScrollbar: visibleScrollbar,
        fixed: !scrollable,
        hideScrollbar: scrollable && !visibleScrollbar,
        scrollableX: scrollable && !vertical,
        scrollableY: scrollable && vertical,
        centered: centered && !scrollable,
        scrollButtonsHideMobile: !allowScrollButtonsMobile
    });
    const classes = $0181e7500204b60c$var$useUtilityClasses(ownerState);
    const startScrollButtonIconProps = (0, $eeee79b1d2d55995$export$2e2bcd8739ae039)({
        elementType: slots.StartScrollButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        ownerState: ownerState
    });
    const endScrollButtonIconProps = (0, $eeee79b1d2d55995$export$2e2bcd8739ae039)({
        elementType: slots.EndScrollButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        ownerState: ownerState
    });
    const [mounted, setMounted] = $8FY87.useState(false);
    const [indicatorStyle, setIndicatorStyle] = $8FY87.useState($0181e7500204b60c$var$defaultIndicatorStyle);
    const [displayStartScroll, setDisplayStartScroll] = $8FY87.useState(false);
    const [displayEndScroll, setDisplayEndScroll] = $8FY87.useState(false);
    const [updateScrollObserver, setUpdateScrollObserver] = $8FY87.useState(false);
    const [scrollerStyle, setScrollerStyle] = $8FY87.useState({
        overflow: 'hidden',
        scrollbarWidth: 0
    });
    const valueToIndex = new Map();
    const tabsRef = $8FY87.useRef(null);
    const tabListRef = $8FY87.useRef(null);
    const getTabsMeta = ()=>{
        const tabsNode = tabsRef.current;
        let tabsMeta;
        if (tabsNode) {
            const rect = tabsNode.getBoundingClientRect();
            // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollLeftNormalized: (0, $ce10ab839d2d6153$export$3c615b88e5d7e4f6)(tabsNode, isRtl ? 'rtl' : 'ltr'),
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        let tabMeta;
        if (tabsNode && value !== false) {
            const children = tabListRef.current.children;
            if (children.length > 0) {
                const tab = children[valueToIndex.get(value)];
                tabMeta = tab ? tab.getBoundingClientRect() : null;
            }
        }
        return {
            tabsMeta: tabsMeta,
            tabMeta: tabMeta
        };
    };
    const updateIndicatorState = (0, $2043fad9aecf10e1$export$2e2bcd8739ae039)(()=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        let startValue = 0;
        let startIndicator;
        if (vertical) {
            startIndicator = 'top';
            if (tabMeta && tabsMeta) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
        } else {
            startIndicator = isRtl ? 'right' : 'left';
            if (tabMeta && tabsMeta) {
                const correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
                startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + correction);
            }
        }
        const newIndicatorStyle = {
            [startIndicator]: startValue,
            // May be wrong until the font is loaded.
            [size]: tabMeta ? tabMeta[size] : 0
        };
        // IE11 support, replace with Number.isNaN
        // eslint-disable-next-line no-restricted-globals
        if (isNaN(indicatorStyle[startIndicator]) || isNaN(indicatorStyle[size])) setIndicatorStyle(newIndicatorStyle);
        else {
            const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
            const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    const scroll = (scrollValue, { animation: animation = true } = {})=>{
        if (animation) (0, $9808a0b2879c773a$export$2e2bcd8739ae039)(scrollStart, tabsRef.current, scrollValue, {
            duration: theme.transitions.duration.standard
        });
        else tabsRef.current[scrollStart] = scrollValue;
    };
    const moveTabsScroll = (delta)=>{
        let scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else {
            scrollValue += delta * (isRtl ? -1 : 1);
            // Fix for Edge
            scrollValue *= isRtl && (0, $ce10ab839d2d6153$export$a10970ffb6510128)() === 'reverse' ? -1 : 1;
        }
        scroll(scrollValue);
    };
    const getScrollSize = ()=>{
        const containerSize = tabsRef.current[clientSize];
        let totalSize = 0;
        const children = Array.from(tabListRef.current.children);
        for(let i = 0; i < children.length; i += 1){
            const tab = children[i];
            if (totalSize + tab[clientSize] > containerSize) {
                // If the first item is longer than the container size, then only scroll
                // by the container size.
                if (i === 0) totalSize = containerSize;
                break;
            }
            totalSize += tab[clientSize];
        }
        return totalSize;
    };
    const handleStartScrollClick = ()=>{
        moveTabsScroll(-1 * getScrollSize());
    };
    const handleEndScrollClick = ()=>{
        moveTabsScroll(getScrollSize());
    };
    // TODO Remove <ScrollbarSize /> as browser support for hiding the scrollbar
    // with CSS improves.
    const handleScrollbarSizeChange = $8FY87.useCallback((scrollbarWidth)=>{
        setScrollerStyle({
            overflow: null,
            scrollbarWidth: scrollbarWidth
        });
    }, []);
    const getConditionalElements = ()=>{
        const conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ (0, $2PPWI.jsx)($0181e7500204b60c$var$TabsScrollbarSize, {
            onChange: handleScrollbarSizeChange,
            className: (0, $efJYy.default)(classes.scrollableX, classes.hideScrollbar)
        }) : null;
        const scrollButtonsActive = displayStartScroll || displayEndScroll;
        const showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === true);
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ (0, $2PPWI.jsx)(ScrollButtonComponent, (0, $zgVxD.default)({
            slots: {
                StartScrollButtonIcon: slots.StartScrollButtonIcon
            },
            slotProps: {
                startScrollButtonIcon: startScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? 'right' : 'left',
            onClick: handleStartScrollClick,
            disabled: !displayStartScroll
        }, TabScrollButtonProps, {
            className: (0, $efJYy.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ (0, $2PPWI.jsx)(ScrollButtonComponent, (0, $zgVxD.default)({
            slots: {
                EndScrollButtonIcon: slots.EndScrollButtonIcon
            },
            slotProps: {
                endScrollButtonIcon: endScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? 'left' : 'right',
            onClick: handleEndScrollClick,
            disabled: !displayEndScroll
        }, TabScrollButtonProps, {
            className: (0, $efJYy.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        return conditionalElements;
    };
    const scrollSelectedIntoView = (0, $2043fad9aecf10e1$export$2e2bcd8739ae039)((animation)=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart, {
                animation: animation
            });
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(nextScrollStart, {
                animation: animation
            });
        }
    });
    const updateScrollButtonState = (0, $2043fad9aecf10e1$export$2e2bcd8739ae039)(()=>{
        if (scrollable && scrollButtons !== false) setUpdateScrollObserver(!updateScrollObserver);
    });
    $8FY87.useEffect(()=>{
        const handleResize = (0, $35a8cdd58dd5c41a$export$2e2bcd8739ae039)(()=>{
            // If the Tabs component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/33276
            // TODO: Add tests that will ensure the component is not failing when
            // replaced by Suspense with a fallback, once React is updated to version 18
            if (tabsRef.current) updateIndicatorState();
        });
        let resizeObserver;
        /**
     * @type {MutationCallback}
     */ const handleMutation = (records)=>{
            records.forEach((record)=>{
                record.removedNodes.forEach((item)=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.unobserve(item);
                });
                record.addedNodes.forEach((item)=>{
                    var _resizeObserver2;
                    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.observe(item);
                });
            });
            handleResize();
            updateScrollButtonState();
        };
        const win = (0, $e94801ab1411f138$export$2e2bcd8739ae039)(tabsRef.current);
        win.addEventListener('resize', handleResize);
        let mutationObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(handleResize);
            Array.from(tabListRef.current.children).forEach((child)=>{
                resizeObserver.observe(child);
            });
        }
        if (typeof MutationObserver !== 'undefined') {
            mutationObserver = new MutationObserver(handleMutation);
            mutationObserver.observe(tabListRef.current, {
                childList: true
            });
        }
        return ()=>{
            var _mutationObserver, _resizeObserver3;
            handleResize.clear();
            win.removeEventListener('resize', handleResize);
            (_mutationObserver = mutationObserver) == null || _mutationObserver.disconnect();
            (_resizeObserver3 = resizeObserver) == null || _resizeObserver3.disconnect();
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    /**
   * Toggle visibility of start and end scroll buttons
   * Using IntersectionObserver on first and last Tabs.
   */ $8FY87.useEffect(()=>{
        const tabListChildren = Array.from(tabListRef.current.children);
        const length = tabListChildren.length;
        if (typeof IntersectionObserver !== 'undefined' && length > 0 && scrollable && scrollButtons !== false) {
            const firstTab = tabListChildren[0];
            const lastTab = tabListChildren[length - 1];
            const observerOptions = {
                root: tabsRef.current,
                threshold: 0.99
            };
            const handleScrollButtonStart = (entries)=>{
                setDisplayStartScroll(!entries[0].isIntersecting);
            };
            const firstObserver = new IntersectionObserver(handleScrollButtonStart, observerOptions);
            firstObserver.observe(firstTab);
            const handleScrollButtonEnd = (entries)=>{
                setDisplayEndScroll(!entries[0].isIntersecting);
            };
            const lastObserver = new IntersectionObserver(handleScrollButtonEnd, observerOptions);
            lastObserver.observe(lastTab);
            return ()=>{
                firstObserver.disconnect();
                lastObserver.disconnect();
            };
        }
        return undefined;
    }, [
        scrollable,
        scrollButtons,
        updateScrollObserver,
        childrenProp == null ? void 0 : childrenProp.length
    ]);
    $8FY87.useEffect(()=>{
        setMounted(true);
    }, []);
    $8FY87.useEffect(()=>{
        updateIndicatorState();
    });
    $8FY87.useEffect(()=>{
        // Don't animate on the first render.
        scrollSelectedIntoView($0181e7500204b60c$var$defaultIndicatorStyle !== indicatorStyle);
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    $8FY87.useImperativeHandle(action, ()=>({
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        }), [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    const indicator = /*#__PURE__*/ (0, $2PPWI.jsx)($0181e7500204b60c$var$TabsIndicator, (0, $zgVxD.default)({}, TabIndicatorProps, {
        className: (0, $efJYy.default)(classes.indicator, TabIndicatorProps.className),
        ownerState: ownerState,
        style: (0, $zgVxD.default)({}, indicatorStyle, TabIndicatorProps.style)
    }));
    let childIndex = 0;
    const children = $8FY87.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ $8FY87.isValidElement(child)) return null;
        const childValue = child.props.value === undefined ? childIndex : child.props.value;
        valueToIndex.set(childValue, childIndex);
        const selected = childValue === value;
        childIndex += 1;
        return /*#__PURE__*/ $8FY87.cloneElement(child, (0, $zgVxD.default)({
            fullWidth: variant === 'fullWidth',
            indicator: selected && !mounted && indicator,
            selected: selected,
            selectionFollowsFocus: selectionFollowsFocus,
            onChange: onChange,
            textColor: textColor,
            value: childValue
        }, childIndex === 1 && value === false && !child.props.tabIndex ? {
            tabIndex: 0
        } : {}));
    });
    const handleKeyDown = (event)=>{
        const list = tabListRef.current;
        const currentFocus = (0, $dd645d3436d5a245$export$2e2bcd8739ae039)(list).activeElement;
        // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        const role = currentFocus.getAttribute('role');
        if (role !== 'tab') return;
        let previousItemKey = orientation === 'horizontal' ? 'ArrowLeft' : 'ArrowUp';
        let nextItemKey = orientation === 'horizontal' ? 'ArrowRight' : 'ArrowDown';
        if (orientation === 'horizontal' && isRtl) {
            // swap previousItemKey with nextItemKey
            previousItemKey = 'ArrowRight';
            nextItemKey = 'ArrowLeft';
        }
        switch(event.key){
            case previousItemKey:
                event.preventDefault();
                $0181e7500204b60c$var$moveFocus(list, currentFocus, $0181e7500204b60c$var$previousItem);
                break;
            case nextItemKey:
                event.preventDefault();
                $0181e7500204b60c$var$moveFocus(list, currentFocus, $0181e7500204b60c$var$nextItem);
                break;
            case 'Home':
                event.preventDefault();
                $0181e7500204b60c$var$moveFocus(list, null, $0181e7500204b60c$var$nextItem);
                break;
            case 'End':
                event.preventDefault();
                $0181e7500204b60c$var$moveFocus(list, null, $0181e7500204b60c$var$previousItem);
                break;
            default:
                break;
        }
    };
    const conditionalElements = getConditionalElements();
    return /*#__PURE__*/ (0, $2PPWI.jsxs)($0181e7500204b60c$var$TabsRoot, (0, $zgVxD.default)({
        className: (0, $efJYy.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        as: component
    }, other, {
        children: [
            conditionalElements.scrollButtonStart,
            conditionalElements.scrollbarSizeListener,
            /*#__PURE__*/ (0, $2PPWI.jsxs)($0181e7500204b60c$var$TabsScroller, {
                className: classes.scroller,
                ownerState: ownerState,
                style: {
                    overflow: scrollerStyle.overflow,
                    [vertical ? `margin${isRtl ? 'Left' : 'Right'}` : 'marginBottom']: visibleScrollbar ? undefined : -scrollerStyle.scrollbarWidth
                },
                ref: tabsRef,
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)($0181e7500204b60c$var$FlexContainer, {
                        "aria-label": ariaLabel,
                        "aria-labelledby": ariaLabelledBy,
                        "aria-orientation": orientation === 'vertical' ? 'vertical' : null,
                        className: classes.flexContainer,
                        ownerState: ownerState,
                        onKeyDown: handleKeyDown,
                        ref: tabListRef,
                        role: "tablist",
                        children: children
                    }),
                    mounted && indicator
                ]
            }),
            conditionalElements.scrollButtonEnd
        ]
    }));
});
var $0181e7500204b60c$export$2e2bcd8739ae039 = $0181e7500204b60c$var$Tabs;




var $8FY87 = parcelRequire("8FY87");



var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");


var $lXBIJ = parcelRequire("lXBIJ");

var $6lkQ3 = parcelRequire("6lkQ3");

var $lbp1P = parcelRequire("lbp1P");

var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $290354ab21a61f24$export$797947b6292e28e1(slot) {
    return (0, $jP65K.default)('MuiStepper', slot);
}
const $290354ab21a61f24$var$stepperClasses = (0, $cOYaX.default)('MuiStepper', [
    'root',
    'horizontal',
    'vertical',
    'nonLinear',
    'alternativeLabel'
]);
var $290354ab21a61f24$export$2e2bcd8739ae039 = $290354ab21a61f24$var$stepperClasses;



var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $lXBIJ = parcelRequire("lXBIJ");

var $ifmKX = parcelRequire("ifmKX");

var $lbp1P = parcelRequire("lbp1P");

var $6lkQ3 = parcelRequire("6lkQ3");

var $8FY87 = parcelRequire("8FY87");
/**
 * Provides information about the current step in Stepper.
 */ const $3dfe3ffde0a206a6$var$StepperContext = /*#__PURE__*/ $8FY87.createContext({});
function $3dfe3ffde0a206a6$export$1ff9b16b13b0447() {
    return $8FY87.useContext($3dfe3ffde0a206a6$var$StepperContext);
}
var $3dfe3ffde0a206a6$export$2e2bcd8739ae039 = $3dfe3ffde0a206a6$var$StepperContext;



var $8FY87 = parcelRequire("8FY87");
/**
 * Provides information about the current step in Stepper.
 */ const $6b47909f808db05e$var$StepContext = /*#__PURE__*/ $8FY87.createContext({});
function $6b47909f808db05e$export$90d5f24cfecec416() {
    return $8FY87.useContext($6b47909f808db05e$var$StepContext);
}
var $6b47909f808db05e$export$2e2bcd8739ae039 = $6b47909f808db05e$var$StepContext;



var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $33863d4fb7cac70c$export$6fbaff484b0d9308(slot) {
    return (0, $jP65K.default)('MuiStepConnector', slot);
}
const $33863d4fb7cac70c$var$stepConnectorClasses = (0, $cOYaX.default)('MuiStepConnector', [
    'root',
    'horizontal',
    'vertical',
    'alternativeLabel',
    'active',
    'completed',
    'disabled',
    'line',
    'lineHorizontal',
    'lineVertical'
]);
var $33863d4fb7cac70c$export$2e2bcd8739ae039 = $33863d4fb7cac70c$var$stepConnectorClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $09932e4000166248$var$_excluded = [
    "className"
];
const $09932e4000166248$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, alternativeLabel: alternativeLabel, active: active, completed: completed, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            alternativeLabel && 'alternativeLabel',
            active && 'active',
            completed && 'completed',
            disabled && 'disabled'
        ],
        line: [
            'line',
            `line${(0, $ifmKX.default)(orientation)}`
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $33863d4fb7cac70c$export$6fbaff484b0d9308), classes);
};
const $09932e4000166248$var$StepConnectorRoot = (0, $lbp1P.default)('div', {
    name: 'MuiStepConnector',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel,
            ownerState.completed && styles.completed
        ];
    }
})(({ ownerState: ownerState })=>(0, $zgVxD.default)({
        flex: '1 1 auto'
    }, ownerState.orientation === 'vertical' && {
        marginLeft: 12 // half icon
    }, ownerState.alternativeLabel && {
        position: 'absolute',
        top: 12,
        left: 'calc(-50% + 20px)',
        right: 'calc(50% + 20px)'
    }));
const $09932e4000166248$var$StepConnectorLine = (0, $lbp1P.default)('span', {
    name: 'MuiStepConnector',
    slot: 'Line',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.line,
            styles[`line${(0, $ifmKX.default)(ownerState.orientation)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[600];
    return (0, $zgVxD.default)({
        display: 'block',
        borderColor: theme.vars ? theme.vars.palette.StepConnector.border : borderColor
    }, ownerState.orientation === 'horizontal' && {
        borderTopStyle: 'solid',
        borderTopWidth: 1
    }, ownerState.orientation === 'vertical' && {
        borderLeftStyle: 'solid',
        borderLeftWidth: 1,
        minHeight: 24
    });
});
const $09932e4000166248$var$StepConnector = /*#__PURE__*/ $8FY87.forwardRef(function StepConnector(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiStepConnector'
    });
    const { className: className } = props, other = (0, $93aRW.default)(props, $09932e4000166248$var$_excluded);
    const { alternativeLabel: alternativeLabel, orientation: orientation = 'horizontal' } = $8FY87.useContext((0, $3dfe3ffde0a206a6$export$2e2bcd8739ae039));
    const { active: active, disabled: disabled, completed: completed } = $8FY87.useContext((0, $6b47909f808db05e$export$2e2bcd8739ae039));
    const ownerState = (0, $zgVxD.default)({}, props, {
        alternativeLabel: alternativeLabel,
        orientation: orientation,
        active: active,
        completed: completed,
        disabled: disabled
    });
    const classes = $09932e4000166248$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2PPWI.jsx)($09932e4000166248$var$StepConnectorRoot, (0, $zgVxD.default)({
        className: (0, $efJYy.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $2PPWI.jsx)($09932e4000166248$var$StepConnectorLine, {
            className: classes.line,
            ownerState: ownerState
        })
    }));
});
var $09932e4000166248$export$2e2bcd8739ae039 = $09932e4000166248$var$StepConnector;




var $2PPWI = parcelRequire("2PPWI");
'use client';
const $babff9cf14f1a2d0$var$_excluded = [
    "activeStep",
    "alternativeLabel",
    "children",
    "className",
    "component",
    "connector",
    "nonLinear",
    "orientation"
];
const $babff9cf14f1a2d0$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, nonLinear: nonLinear, alternativeLabel: alternativeLabel, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            nonLinear && 'nonLinear',
            alternativeLabel && 'alternativeLabel'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $290354ab21a61f24$export$797947b6292e28e1), classes);
};
const $babff9cf14f1a2d0$var$StepperRoot = (0, $lbp1P.default)('div', {
    name: 'MuiStepper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel,
            ownerState.nonLinear && styles.nonLinear
        ];
    }
})(({ ownerState: ownerState })=>(0, $zgVxD.default)({
        display: 'flex'
    }, ownerState.orientation === 'horizontal' && {
        flexDirection: 'row',
        alignItems: 'center'
    }, ownerState.orientation === 'vertical' && {
        flexDirection: 'column'
    }, ownerState.alternativeLabel && {
        alignItems: 'flex-start'
    }));
const $babff9cf14f1a2d0$var$defaultConnector = /*#__PURE__*/ (0, $2PPWI.jsx)((0, $09932e4000166248$export$2e2bcd8739ae039), {});
const $babff9cf14f1a2d0$var$Stepper = /*#__PURE__*/ $8FY87.forwardRef(function Stepper(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiStepper'
    });
    const { activeStep: activeStep = 0, alternativeLabel: alternativeLabel = false, children: children, className: className, component: component = 'div', connector: connector = $babff9cf14f1a2d0$var$defaultConnector, nonLinear: nonLinear = false, orientation: orientation = 'horizontal' } = props, other = (0, $93aRW.default)(props, $babff9cf14f1a2d0$var$_excluded);
    const ownerState = (0, $zgVxD.default)({}, props, {
        nonLinear: nonLinear,
        alternativeLabel: alternativeLabel,
        orientation: orientation,
        component: component
    });
    const classes = $babff9cf14f1a2d0$var$useUtilityClasses(ownerState);
    const childrenArray = $8FY87.Children.toArray(children).filter(Boolean);
    const steps = childrenArray.map((step, index)=>{
        return /*#__PURE__*/ $8FY87.cloneElement(step, (0, $zgVxD.default)({
            index: index,
            last: index + 1 === childrenArray.length
        }, step.props));
    });
    const contextValue = $8FY87.useMemo(()=>({
            activeStep: activeStep,
            alternativeLabel: alternativeLabel,
            connector: connector,
            nonLinear: nonLinear,
            orientation: orientation
        }), [
        activeStep,
        alternativeLabel,
        connector,
        nonLinear,
        orientation
    ]);
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3dfe3ffde0a206a6$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $2PPWI.jsx)($babff9cf14f1a2d0$var$StepperRoot, (0, $zgVxD.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $efJYy.default)(classes.root, className),
            ref: ref
        }, other, {
            children: steps
        }))
    });
});
var $babff9cf14f1a2d0$export$2e2bcd8739ae039 = $babff9cf14f1a2d0$var$Stepper;



var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");


var $lXBIJ = parcelRequire("lXBIJ");



var $6lkQ3 = parcelRequire("6lkQ3");

var $lbp1P = parcelRequire("lbp1P");

var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $642c6071c1b1d630$export$8977e0f3c012cfac(slot) {
    return (0, $jP65K.default)('MuiStep', slot);
}
const $642c6071c1b1d630$var$stepClasses = (0, $cOYaX.default)('MuiStep', [
    'root',
    'horizontal',
    'vertical',
    'alternativeLabel',
    'completed'
]);
var $642c6071c1b1d630$export$2e2bcd8739ae039 = $642c6071c1b1d630$var$stepClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $fa7d4d2739c83480$var$_excluded = [
    "active",
    "children",
    "className",
    "component",
    "completed",
    "disabled",
    "expanded",
    "index",
    "last"
];
const $fa7d4d2739c83480$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, alternativeLabel: alternativeLabel, completed: completed } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            alternativeLabel && 'alternativeLabel',
            completed && 'completed'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $642c6071c1b1d630$export$8977e0f3c012cfac), classes);
};
const $fa7d4d2739c83480$var$StepRoot = (0, $lbp1P.default)('div', {
    name: 'MuiStep',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel,
            ownerState.completed && styles.completed
        ];
    }
})(({ ownerState: ownerState })=>(0, $zgVxD.default)({}, ownerState.orientation === 'horizontal' && {
        paddingLeft: 8,
        paddingRight: 8
    }, ownerState.alternativeLabel && {
        flex: 1,
        position: 'relative'
    }));
const $fa7d4d2739c83480$var$Step = /*#__PURE__*/ $8FY87.forwardRef(function Step(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiStep'
    });
    const { active: activeProp, children: children, className: className, component: component = 'div', completed: completedProp, disabled: disabledProp, expanded: expanded = false, index: index, last: last } = props, other = (0, $93aRW.default)(props, $fa7d4d2739c83480$var$_excluded);
    const { activeStep: activeStep, connector: connector, alternativeLabel: alternativeLabel, orientation: orientation, nonLinear: nonLinear } = $8FY87.useContext((0, $3dfe3ffde0a206a6$export$2e2bcd8739ae039));
    let [active = false, completed = false, disabled = false] = [
        activeProp,
        completedProp,
        disabledProp
    ];
    if (activeStep === index) active = activeProp !== undefined ? activeProp : true;
    else if (!nonLinear && activeStep > index) completed = completedProp !== undefined ? completedProp : true;
    else if (!nonLinear && activeStep < index) disabled = disabledProp !== undefined ? disabledProp : true;
    const contextValue = $8FY87.useMemo(()=>({
            index: index,
            last: last,
            expanded: expanded,
            icon: index + 1,
            active: active,
            completed: completed,
            disabled: disabled
        }), [
        index,
        last,
        expanded,
        active,
        completed,
        disabled
    ]);
    const ownerState = (0, $zgVxD.default)({}, props, {
        active: active,
        orientation: orientation,
        alternativeLabel: alternativeLabel,
        completed: completed,
        disabled: disabled,
        expanded: expanded,
        component: component
    });
    const classes = $fa7d4d2739c83480$var$useUtilityClasses(ownerState);
    const newChildren = /*#__PURE__*/ (0, $2PPWI.jsxs)($fa7d4d2739c83480$var$StepRoot, (0, $zgVxD.default)({
        as: component,
        className: (0, $efJYy.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            connector && alternativeLabel && index !== 0 ? connector : null,
            children
        ]
    }));
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $6b47909f808db05e$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: connector && !alternativeLabel && index !== 0 ? /*#__PURE__*/ (0, $2PPWI.jsxs)($8FY87.Fragment, {
            children: [
                connector,
                newChildren
            ]
        }) : newChildren
    });
});
var $fa7d4d2739c83480$export$2e2bcd8739ae039 = $fa7d4d2739c83480$var$Step;



var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $lXBIJ = parcelRequire("lXBIJ");

var $lbp1P = parcelRequire("lbp1P");

var $6lkQ3 = parcelRequire("6lkQ3");

var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $lXBIJ = parcelRequire("lXBIJ");

var $lbp1P = parcelRequire("lbp1P");

var $6lkQ3 = parcelRequire("6lkQ3");
parcelRequire("8FY87");

var $cHXYB = parcelRequire("cHXYB");

var $2PPWI = parcelRequire("2PPWI");
'use client';
var $96de860f66a7653f$export$2e2bcd8739ae039 = (0, $cHXYB.default)(/*#__PURE__*/ (0, $2PPWI.jsx)("path", {
    d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
}), 'CheckCircle');


parcelRequire("8FY87");

var $cHXYB = parcelRequire("cHXYB");

var $2PPWI = parcelRequire("2PPWI");
'use client';
var $a91356d7535580c6$export$2e2bcd8739ae039 = (0, $cHXYB.default)(/*#__PURE__*/ (0, $2PPWI.jsx)("path", {
    d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), 'Warning');



var $e6kBo = parcelRequire("e6kBo");

var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $cc1277131a4e45db$export$62a6e0748bec9297(slot) {
    return (0, $jP65K.default)('MuiStepIcon', slot);
}
const $cc1277131a4e45db$var$stepIconClasses = (0, $cOYaX.default)('MuiStepIcon', [
    'root',
    'active',
    'completed',
    'error',
    'text'
]);
var $cc1277131a4e45db$export$2e2bcd8739ae039 = $cc1277131a4e45db$var$stepIconClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
var $d4033e9557bb5b4d$var$_circle;
const $d4033e9557bb5b4d$var$_excluded = [
    "active",
    "className",
    "completed",
    "error",
    "icon"
];
const $d4033e9557bb5b4d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, active: active, completed: completed, error: error } = ownerState;
    const slots = {
        root: [
            'root',
            active && 'active',
            completed && 'completed',
            error && 'error'
        ],
        text: [
            'text'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $cc1277131a4e45db$export$62a6e0748bec9297), classes);
};
const $d4033e9557bb5b4d$var$StepIconRoot = (0, $lbp1P.default)((0, $e6kBo.default), {
    name: 'MuiStepIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        display: 'block',
        transition: theme.transitions.create('color', {
            duration: theme.transitions.duration.shortest
        }),
        color: (theme.vars || theme).palette.text.disabled,
        [`&.${(0, $cc1277131a4e45db$export$2e2bcd8739ae039).completed}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $cc1277131a4e45db$export$2e2bcd8739ae039).active}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $cc1277131a4e45db$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $d4033e9557bb5b4d$var$StepIconText = (0, $lbp1P.default)('text', {
    name: 'MuiStepIcon',
    slot: 'Text',
    overridesResolver: (props, styles)=>styles.text
})(({ theme: theme })=>({
        fill: (theme.vars || theme).palette.primary.contrastText,
        fontSize: theme.typography.caption.fontSize,
        fontFamily: theme.typography.fontFamily
    }));
const $d4033e9557bb5b4d$var$StepIcon = /*#__PURE__*/ $8FY87.forwardRef(function StepIcon(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiStepIcon'
    });
    const { active: active = false, className: classNameProp, completed: completed = false, error: error = false, icon: icon } = props, other = (0, $93aRW.default)(props, $d4033e9557bb5b4d$var$_excluded);
    const ownerState = (0, $zgVxD.default)({}, props, {
        active: active,
        completed: completed,
        error: error
    });
    const classes = $d4033e9557bb5b4d$var$useUtilityClasses(ownerState);
    if (typeof icon === 'number' || typeof icon === 'string') {
        const className = (0, $efJYy.default)(classNameProp, classes.root);
        if (error) return /*#__PURE__*/ (0, $2PPWI.jsx)($d4033e9557bb5b4d$var$StepIconRoot, (0, $zgVxD.default)({
            as: (0, $a91356d7535580c6$export$2e2bcd8739ae039),
            className: className,
            ref: ref,
            ownerState: ownerState
        }, other));
        if (completed) return /*#__PURE__*/ (0, $2PPWI.jsx)($d4033e9557bb5b4d$var$StepIconRoot, (0, $zgVxD.default)({
            as: (0, $96de860f66a7653f$export$2e2bcd8739ae039),
            className: className,
            ref: ref,
            ownerState: ownerState
        }, other));
        return /*#__PURE__*/ (0, $2PPWI.jsxs)($d4033e9557bb5b4d$var$StepIconRoot, (0, $zgVxD.default)({
            className: className,
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                $d4033e9557bb5b4d$var$_circle || ($d4033e9557bb5b4d$var$_circle = /*#__PURE__*/ (0, $2PPWI.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "12"
                })),
                /*#__PURE__*/ (0, $2PPWI.jsx)($d4033e9557bb5b4d$var$StepIconText, {
                    className: classes.text,
                    x: "12",
                    y: "12",
                    textAnchor: "middle",
                    dominantBaseline: "central",
                    ownerState: ownerState,
                    children: icon
                })
            ]
        }));
    }
    return icon;
});
var $d4033e9557bb5b4d$export$2e2bcd8739ae039 = $d4033e9557bb5b4d$var$StepIcon;





var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $26e3e46209052138$export$9625a725551d158a(slot) {
    return (0, $jP65K.default)('MuiStepLabel', slot);
}
const $26e3e46209052138$var$stepLabelClasses = (0, $cOYaX.default)('MuiStepLabel', [
    'root',
    'horizontal',
    'vertical',
    'label',
    'active',
    'completed',
    'error',
    'disabled',
    'iconContainer',
    'alternativeLabel',
    'labelContainer'
]);
var $26e3e46209052138$export$2e2bcd8739ae039 = $26e3e46209052138$var$stepLabelClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $ad5acd712c68634f$var$_excluded = [
    "children",
    "className",
    "componentsProps",
    "error",
    "icon",
    "optional",
    "slotProps",
    "StepIconComponent",
    "StepIconProps"
];
const $ad5acd712c68634f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, active: active, completed: completed, error: error, disabled: disabled, alternativeLabel: alternativeLabel } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            error && 'error',
            disabled && 'disabled',
            alternativeLabel && 'alternativeLabel'
        ],
        label: [
            'label',
            active && 'active',
            completed && 'completed',
            error && 'error',
            disabled && 'disabled',
            alternativeLabel && 'alternativeLabel'
        ],
        iconContainer: [
            'iconContainer',
            active && 'active',
            completed && 'completed',
            error && 'error',
            disabled && 'disabled',
            alternativeLabel && 'alternativeLabel'
        ],
        labelContainer: [
            'labelContainer',
            alternativeLabel && 'alternativeLabel'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $26e3e46209052138$export$9625a725551d158a), classes);
};
const $ad5acd712c68634f$var$StepLabelRoot = (0, $lbp1P.default)('span', {
    name: 'MuiStepLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation]
        ];
    }
})(({ ownerState: ownerState })=>(0, $zgVxD.default)({
        display: 'flex',
        alignItems: 'center',
        [`&.${(0, $26e3e46209052138$export$2e2bcd8739ae039).alternativeLabel}`]: {
            flexDirection: 'column'
        },
        [`&.${(0, $26e3e46209052138$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        }
    }, ownerState.orientation === 'vertical' && {
        textAlign: 'left',
        padding: '8px 0'
    }));
const $ad5acd712c68634f$var$StepLabelLabel = (0, $lbp1P.default)('span', {
    name: 'MuiStepLabel',
    slot: 'Label',
    overridesResolver: (props, styles)=>styles.label
})(({ theme: theme })=>(0, $zgVxD.default)({}, theme.typography.body2, {
        display: 'block',
        transition: theme.transitions.create('color', {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $26e3e46209052138$export$2e2bcd8739ae039).active}`]: {
            color: (theme.vars || theme).palette.text.primary,
            fontWeight: 500
        },
        [`&.${(0, $26e3e46209052138$export$2e2bcd8739ae039).completed}`]: {
            color: (theme.vars || theme).palette.text.primary,
            fontWeight: 500
        },
        [`&.${(0, $26e3e46209052138$export$2e2bcd8739ae039).alternativeLabel}`]: {
            marginTop: 16
        },
        [`&.${(0, $26e3e46209052138$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $ad5acd712c68634f$var$StepLabelIconContainer = (0, $lbp1P.default)('span', {
    name: 'MuiStepLabel',
    slot: 'IconContainer',
    overridesResolver: (props, styles)=>styles.iconContainer
})(()=>({
        flexShrink: 0,
        // Fix IE11 issue
        display: 'flex',
        paddingRight: 8,
        [`&.${(0, $26e3e46209052138$export$2e2bcd8739ae039).alternativeLabel}`]: {
            paddingRight: 0
        }
    }));
const $ad5acd712c68634f$var$StepLabelLabelContainer = (0, $lbp1P.default)('span', {
    name: 'MuiStepLabel',
    slot: 'LabelContainer',
    overridesResolver: (props, styles)=>styles.labelContainer
})(({ theme: theme })=>({
        width: '100%',
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $26e3e46209052138$export$2e2bcd8739ae039).alternativeLabel}`]: {
            textAlign: 'center'
        }
    }));
const $ad5acd712c68634f$var$StepLabel = /*#__PURE__*/ $8FY87.forwardRef(function StepLabel(inProps, ref) {
    var _slotProps$label;
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiStepLabel'
    });
    const { children: children, className: className, componentsProps: componentsProps = {}, error: error = false, icon: iconProp, optional: optional, slotProps: slotProps = {}, StepIconComponent: StepIconComponentProp, StepIconProps: StepIconProps } = props, other = (0, $93aRW.default)(props, $ad5acd712c68634f$var$_excluded);
    const { alternativeLabel: alternativeLabel, orientation: orientation } = $8FY87.useContext((0, $3dfe3ffde0a206a6$export$2e2bcd8739ae039));
    const { active: active, disabled: disabled, completed: completed, icon: iconContext } = $8FY87.useContext((0, $6b47909f808db05e$export$2e2bcd8739ae039));
    const icon = iconProp || iconContext;
    let StepIconComponent = StepIconComponentProp;
    if (icon && !StepIconComponent) StepIconComponent = (0, $d4033e9557bb5b4d$export$2e2bcd8739ae039);
    const ownerState = (0, $zgVxD.default)({}, props, {
        active: active,
        alternativeLabel: alternativeLabel,
        completed: completed,
        disabled: disabled,
        error: error,
        orientation: orientation
    });
    const classes = $ad5acd712c68634f$var$useUtilityClasses(ownerState);
    const labelSlotProps = (_slotProps$label = slotProps.label) != null ? _slotProps$label : componentsProps.label;
    return /*#__PURE__*/ (0, $2PPWI.jsxs)($ad5acd712c68634f$var$StepLabelRoot, (0, $zgVxD.default)({
        className: (0, $efJYy.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            icon || StepIconComponent ? /*#__PURE__*/ (0, $2PPWI.jsx)($ad5acd712c68634f$var$StepLabelIconContainer, {
                className: classes.iconContainer,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $2PPWI.jsx)(StepIconComponent, (0, $zgVxD.default)({
                    completed: completed,
                    active: active,
                    error: error,
                    icon: icon
                }, StepIconProps))
            }) : null,
            /*#__PURE__*/ (0, $2PPWI.jsxs)($ad5acd712c68634f$var$StepLabelLabelContainer, {
                className: classes.labelContainer,
                ownerState: ownerState,
                children: [
                    children ? /*#__PURE__*/ (0, $2PPWI.jsx)($ad5acd712c68634f$var$StepLabelLabel, (0, $zgVxD.default)({
                        ownerState: ownerState
                    }, labelSlotProps, {
                        className: (0, $efJYy.default)(classes.label, labelSlotProps == null ? void 0 : labelSlotProps.className),
                        children: children
                    })) : null,
                    optional
                ]
            })
        ]
    }));
});
$ad5acd712c68634f$var$StepLabel.muiName = 'StepLabel';
var $ad5acd712c68634f$export$2e2bcd8739ae039 = $ad5acd712c68634f$var$StepLabel;




var $8FY87 = parcelRequire("8FY87");
const $c443b75593bacc8d$var$DNSProviders = ({ domain: domain, caddyServerIP: caddyServerIP })=>{
    const [openIndex, setOpenIndex] = (0, $8FY87.useState)(null);
    const toggleAccordion = (index)=>{
        setOpenIndex(openIndex === index ? null : index);
    };
    let _isWWW = domain.split(".")[0] === "www" ? true : false;
    let _domain = "";
    if (domain.split(".").length === 2) _domain = "@";
    else if (domain.split(".").length === 3) _domain = domain.split(".")[0];
    console.log('_www', _isWWW, domain.replace("www.", ""));
    const items = [
        {
            title: 'GoDaddy',
            content: `<ol>
              <li>
                <b>Sign In to GoDaddy:</b>
                <ul>
                  <li>Log in to your GoDaddy account.</li>
                </ul>
              </li>
              <li>
                <b>Access Domain Settings:</b>
                <ul>
                  <li>Navigate to "My Products."</li>
                  <li>Find your domain and click on "DNS" or "Manage."</li>
                </ul>
              </li>
              <li>
                <b>Add a New ${_isWWW ? 'CNAME' : 'A'} Record:</b>
                <ul>
                  <li>Scroll down to the "Records" section.</li>
                  <li>Click "Add" to create a new DNS record.</li>
                  <li>Select ${_isWWW ? '"CNAME"' : '"A"'} as the record type.</li>
                  <li>
                    Enter the following details:
                    <ul className="list-square">
                      <li>
                        <b>Name:</b> ${_isWWW ? 'www' : _domain}
                      </li>
                      <li>
                        <b>Value:</b> ${_isWWW ? domain.replace("www.", "") : caddyServerIP}
                      </li>
                      <li>
                        <b>TTL:</b> Default
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <b>Update an Existing ${_isWWW ? 'CNAME' : 'A'} Record:</b>
                <ul>
                  <li>Find the existing ${_isWWW ? 'CNAME' : 'A'} record you want to update.</li>
                  <li>Click the pencil icon next to the record to edit it.</li>
                  <li>
                    Update the details as needed (e.g., change the ${_isWWW ? 'domain name' : 'IP address'} in
                    the "Value" field to ${_isWWW ? domain.replace("www.", "") : caddyServerIP}).
                  </li>
                  <li>Click "Save."</li>
                </ul>
              </li>
            </ol>`
        },
        {
            title: 'Cloudflare',
            content: `<ol>
              <li>
                <b>Sign In to Cloudflare:</b>
                <ul>
                  <li>Log in to your Cloudflare account.</li>
                </ul>
              </li>
              <li>
                <b>Access DNS Settings:</b>
                <ul>
                  <li>Select the domain you want to manage.</li>
                  <li>Click on the "DNS" tab.</li>
                </ul>
              </li>
              <li>
                <b>Add a New ${_isWWW ? 'CNAME' : 'A'} Record:</b>
                <ul>
                  <li>Click "Add record."</li>
                  <li>Select ${_isWWW ? '"CNAME"' : '"A"'} as the record type.</li>
                  <li>
                    Enter the following details:
                    <ul className="list-square">
                      <li>
                        <b>Name:</b> ${_isWWW ? 'www' : _domain}
                      </li>
                      <li>
                        <b>${_isWWW ? 'value:' : 'IPv4 address:'}</b> ${_isWWW ? domain.replace("www.", "") : caddyServerIP}
                      </li>
                      <li>
                        <b>TTL:</b> Auto
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <b>Update an Existing ${_isWWW ? 'CNAME' : 'A'} Record:</b>
                <ul>
                  <li>Find the existing ${_isWWW ? 'CNAME' : 'A'} record you want to update.</li>
                  <li>Click on the record to edit it.</li>
                  <li>
                    Update the details as needed (e.g., change the ${_isWWW ? 'domain name' : 'IP address'} in
                    the "IPv4 address" field to ${_isWWW ? domain.replace("www.", "") : caddyServerIP}).
                  </li>
                  <li>Click "Save."</li>
                </ul>
              </li>
            </ol>`
        },
        {
            title: 'Amazon Route 53',
            content: `<ol>
              <li>
                <b>Sign In to AWS Management Console:</b>
                <ul>
                  <li>Go to the AWS Management Console and log in.</li>
                </ul>
              </li>
              <li>
                <b>Access Route 53:</b>
                <ul>
                  <li>Navigate to Amazon Route 53.</li>
                  <li>Click on "Hosted Zones."</li>
                </ul>
              </li>
              <li>
                <b>Select Domain:</b>
                <ul>
                  <li>Choose the domain you want to manage.</li>
                </ul>
              </li>
              <li>
                <b>Add a New ${_isWWW ? 'CNAME' : 'A'} Record:</b>
                <ul>
                  <li>Click "Create Record Set."</li>
                  <li>
                    Enter the following details:
                    <ul className="list-square">
                      <li>
                        <b>Name:</b> ${_isWWW ? 'www' : _domain}
                      </li>
                      <li>
                        <b>Type:</b> A - IPv4 address
                      </li>
                      <li>
                        <b>Value:</b> ${_isWWW ? domain.replace("www.", "") : caddyServerIP}
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <b>Update an Existing ${_isWWW ? 'CNAME' : 'A'} Record:</b>
                <ul>
                  <li>Find the existing ${_isWWW ? 'CNAME' : 'A'} record you want to update.</li>
                  <li>Click on the record to edit it.</li>
                  <li>
                    Update the details as needed (e.g., change the IP address in
                    the "Value" field to ${_isWWW ? domain.replace("www.", "") : caddyServerIP}).
                  </li>
                  <li>Click "Save Record Set."</li>
                </ul>
              </li>
            </ol>`
        },
        {
            title: 'Google Domains',
            content: `<ol>
              <li>
                <b>Sign In to Google Domains:</b>
                <ul>
                  <li>Go to Google Domains and log in to your account.</li>
                </ul>
              </li>
              <li>
                <b>Manage Domain:</b>
                <ul>
                  <li>Locate your domain and click on "Manage" or "DNS."</li>
                </ul>
              </li>
              <li>
                <b>Add a New ${_isWWW ? 'CNAME' : 'A'} Record:</b>
                <ul>
                  <li>Scroll down to the "Custom resource records" section.</li>
                  <li>
                    Enter the following details:
                    <ul className="list-square">
                      <li>
                        <b>Name:</b> ${_isWWW ? 'www' : _domain}
                      </li>
                      <li>
                        <b>Type:</b>  ${_isWWW ? 'CNAME' : 'A'}
                      </li>
                      <li>
                        <b>TTL:</b> 1h
                      </li>
                      <li>
                        <b>Data:</b> ${_isWWW ? domain.replace("www.", "") : caddyServerIP}
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <b>Update an Existing ${_isWWW ? 'CNAME' : 'A'} Record:</b>
                <ul>
                  <li>Find the existing ${_isWWW ? 'CNAME' : 'A'} record you want to update.</li>
                  <li>
                    Click on the pencil icon next to the record to edit it.
                  </li>
                  <li>
                    Update the details as needed (e.g., change the IP address in
                    the "Data" field to ${_isWWW ? domain.replace("www.", "") : caddyServerIP}).
                  </li>
                  <li>Click "Save."</li>
                </ul>
              </li>
            </ol>`
        },
        {
            title: 'Namecheap',
            content: `<ol>
              <li>
                <b>Sign In to Namecheap:</b>
                <ul>
                  <li>Log in to your Namecheap account.</li>
                </ul>
              </li>
              <li>
                <b>Manage Domain:</b>
                <ul>
                  <li>Select the domain you want to manage.</li>
                  <li>Click on "Manage" next to the domain.</li>
                </ul>
              </li>
              <li>
                <b>Access Advanced DNS:</b>
                <ul>
                  <li>Click on the "Advanced DNS" tab.</li>
                </ul>
              </li>
              <li>
                <b>Add a New ${_isWWW ? 'CNAME' : 'A'} Record:</b>
                <ul>
                  <li>Scroll down to the "Host Records" section.</li>
                  <li>Click "Add New Record."</li>
                  <li>Select "${_isWWW ? 'CNAME' : 'A'} Record" as the type.</li>
                  <li>
                    Enter the following details:
                    <ul className="list-square">
                      <li>
                        <b>Host Record:</b> ${_isWWW ? 'www' : _domain}
                      </li>
                      <li>
                        <b>Points To:</b> ${_isWWW ? domain.replace("www.", "") : caddyServerIP}
                      </li>
                      <li>
                        <b>TTL:</b> Automatic
                      </li>
                    </ul>
                  </li>
                  <li>Click the checkmark to save.</li>
                </ul>
              </li>
              <li>
                <b>Update an Existing ${_isWWW ? 'CNAME' : 'A'} Record:</b>
                <ul>
                  <li>Find the existing ${_isWWW ? 'CNAME' : 'A'} record you want to update.</li>
                  <li>
                    Click on the pencil icon next to the record to edit it.
                  </li>
                  <li>
                    Update the details as needed (e.g., change the IP address in
                    the "IP Address" field to ${_isWWW ? domain.replace("www.", "") : caddyServerIP}).
                  </li>
                  <li>Click the checkmark to save.</li>
                </ul>
              </li>
            </ol>`
        },
        {
            title: 'Bluehost',
            content: `<ol>
              <li>
                <b>Sign In to Namecheap:</b>
                <ul>
                  <li>Log in to your Bluehost account.</li>
                </ul>
              </li>
              <li>
                <b>Access Domain Manager:</b>
                <ul>
                  <li>
                    From the Bluehost dashboard, click on "Domains" and then "My
                    Domains."
                  </li>
                </ul>
              </li>
              <li>
                <b>Manage DNS:</b>
                <ul>
                  <li>
                    Click the "Manage" button next to the domain you want to
                    update.
                  </li>
                </ul>
              </li>
              <li>
                <b>Add a New ${_isWWW ? 'CNAME' : 'A'} Record:</b>
                <ul>
                  <li>Go to the "DNS" tab.</li>
                  <li>Scroll down to the "Add DNS Record" section.</li>
                  <li>Select "${_isWWW ? 'CNAME' : 'A'}" as the record type.</li>
                  <li>
                    Enter the following details:
                    <ul className="list-square">
                      <li>
                        <b>Host Record:</b> ${_isWWW ? 'www' : _domain}
                      </li>
                      <li>
                        <b>Points To:</b> ${_isWWW ? domain.replace("www.", "") : caddyServerIP}
                      </li>
                      <li>
                        <b>TTL:</b> Default
                      </li>
                    </ul>
                  </li>
                  <li>Click "Save."</li>
                </ul>
              </li>
              <li>
                <b>Update an Existing ${_isWWW ? 'CNAME' : 'A'} Record:</b>
                <ul>
                  <li>Find the existing ${_isWWW ? 'CNAME' : 'A'} record you want to update.</li>
                  <li>Click "Edit" next to the record.</li>
                  <li>
                    Update the details as needed (e.g., change the IP address in
                    the "Points To" field to ${_isWWW ? domain.replace("www.", "") : caddyServerIP}).
                  </li>
                  <li>Click "Save."</li>
                </ul>
              </li>
            </ol>`
        },
        {
            title: 'HostGator',
            content: `<ol>
              <li>
                <b>Sign In to HostGator:</b>
                <ul>
                  <li>Log in to your HostGator account.</li>
                </ul>
              </li>
              <li>
                <b>Access Domain Manager:</b>
                <ul>
                  <li>
                    From the HostGator dashboard, click on "Domains" and then
                    "My Domains."
                  </li>
                </ul>
              </li>
              <li>
                <b>Manage DNS:</b>
                <ul>
                  <li>
                    Click the "Manage" button next to the domain you want to
                    update.
                  </li>
                </ul>
              </li>
              <li>
                <b>Add a New ${_isWWW ? 'CNAME' : 'A'} Record:</b>
                <ul>
                  <li>Go to the "DNS" tab.</li>
                  <li>Scroll down to the "Add DNS Record" section.</li>
                  <li>Select "${_isWWW ? 'CNAME' : 'A'}" as the record type.</li>
                  <li>
                    Enter the following details:
                    <ul className="list-square">
                      <li>
                        <b>Host Record:</b> ${_isWWW ? 'www' : _domain}
                      </li>
                      <li>
                        <b>Points To:</b> ${_isWWW ? domain.replace("www.", "") : caddyServerIP}
                      </li>
                      <li>
                        <b>TTL:</b> Default
                      </li>
                    </ul>
                  </li>
                  <li>Click "Save."</li>
                </ul>
              </li>
              <li>
                <b>Update an Existing ${_isWWW ? 'CNAME' : 'A'}  Record:</b>
                <ul>
                  <li>Find the existing ${_isWWW ? 'CNAME' : 'A'}  record you want to update.</li>
                  <li>Click "Edit" next to the record.</li>
                  <li>
                    Update the details as needed (e.g., change the IP address in
                    the "Points To" field to ${_isWWW ? domain.replace("www.", "") : caddyServerIP}).
                  </li>
                  <li>Click "Save."</li>
                </ul>
              </li>
            </ol>`
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("ul", {
        className: "border border-gray-200 rounded-lg list-none p-0 mt-2"
    }, items.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("li", {
            key: index,
            className: "border-b border-gray-200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("button", {
            onClick: ()=>toggleAccordion(index),
            className: "accordion-header w-full text-left px-4 py-2 focus:outline-none focus:ring focus:ring-gray-300"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", null, item.title)), openIndex === index && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
            className: "accordion-content px-4 py-2 font-normal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
            dangerouslySetInnerHTML: {
                __html: item.content
            }
        }))))));
};
var $c443b75593bacc8d$export$2e2bcd8739ae039 = $c443b75593bacc8d$var$DNSProviders;


const $412055656c20c8f0$var$CustomDomainModal = ({ siteId: siteId, domainName: domainName, isOpen: isOpen, onClose: onClose, showStepper: showStepper, isPointDNS: isPointDNS })=>{
    const [domain, setDomain] = (0, $8FY87.useState)(domainName);
    const [isValid, setIsValid] = (0, $8FY87.useState)(false);
    const [showValidattionError, setShowValidationError] = (0, $8FY87.useState)(false);
    const [isChecked, setIsChecked] = (0, $8FY87.useState)(false);
    // const [isSubDomain, setIsSubDomain] = useState(false);
    const [isPrimary, setIsPrimary] = (0, $8FY87.useState)(true);
    const [stepperActive, setStepperActive] = (0, $8FY87.useState)(showStepper);
    const [showPointDNS, setShowPointDNS] = (0, $8FY87.useState)(isPointDNS);
    const [caddyServerIP, setCaddyServerIP] = (0, $8FY87.useState)("143.198.78.133");
    const steps = [
        "Add domain",
        "Point DNS"
    ];
    // Function to handle subdomain input change
    const handleSubdomainChange = (event)=>{
        setDomain(event.target.value);
        const domainPattern = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/; // Change the pattern as needed
        const isValidDomain = domainPattern.test(event.target.value);
        setIsValid(isValidDomain);
        setShowValidationError(false);
    };
    // Function to handle form submission
    const onAddDomain = async (event)=>{
        event.preventDefault();
        setShowValidationError(!isValid);
        if (isValid) {
            // onClose(domain);
            let data = {
                siteId: siteId
            };
            try {
                data = {
                    ...data,
                    domain: domain,
                    isPrimary: isPrimary
                };
                await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).put("/api/configs/custom-domain", data);
                if (isChecked) {
                    data = {
                        ...data,
                        domain: `www.${domain}`,
                        isPrimary: false
                    };
                    await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).put("/api/configs/custom-domain", data);
                }
                setStepperActive(true);
                setShowPointDNS(false);
            } catch (err) {
                console.log(err);
            }
        }
    };
    const getCaddyServerIP = ()=>{
        let currentURL = window.location.href;
        if (currentURL.includes("app.rocketpages.io")) setCaddyServerIP("146.190.156.136");
        else setCaddyServerIP("143.198.78.133");
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useEffect(()=>{
        // Actually runs when isOpen changes
        getCaddyServerIP();
        return ()=>{
            setDomain("");
            setIsValid(false);
            setShowValidationError(false);
            //setStepperActive(false);
            //setShowPointDNS(false);
            setIsChecked(false);
        };
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `fixed z-50 inset-0 overflow-y-auto ${isOpen ? "block" : "hidden"}`
    }, stepperActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex items-center justify-center min-h-screen p-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "fixed inset-0 bg-black opacity-50"
    }), showPointDNS && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "bg-slate-100 rounded-lg p-4 sm:p-8 max-w-2xl w-full mx-auto z-20 add-domain-popup-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "bg-white rounded-lg p-4 sm:p-8 max-w-2xl w-full mx-auto z-20"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("h2", {
        className: "text-lg font-semibold mb-2 mt-0"
    }, "Update your DNS records at your DNS provider"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", {
        className: "text-xsm mb-0"
    }, "Create a records for ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("b", null, domain), isChecked && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", null, " ", "and ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("b", null, "www.", domain)), " ", "with your domain provider so they can direct traffic to your site."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $c443b75593bacc8d$export$2e2bcd8739ae039), {
        domain: domain,
        caddyServerIP: caddyServerIP
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex justify-end mt-6 flex-col sm:flex-row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        id: "save",
        className: "sm:w-32 py-1 z-0 mb-2.5 sm:mb-0 h-[52] sm:h-auto",
        sx: {
            textTransform: "none"
        },
        size: "small",
        variant: "contained",
        onClick: onClose
    }, "Ok I've done this"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("button", {
        onClick: onClose,
        className: "sm:ml-2 px-4 py-2 border rounded-md hover:bg-gray-200 focus:outline-none focus:ring focus:border-blue-300"
    }, "I'll do this later")))), !showPointDNS && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "bg-slate-100 rounded-lg p-4 sm:p-8 max-w-2xl w-full mx-auto z-20 add-domain-popup-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $babff9cf14f1a2d0$export$2e2bcd8739ae039), {
        activeStep: 0,
        alternativeLabel: true
    }, steps.map((label)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $fa7d4d2739c83480$export$2e2bcd8739ae039), {
            key: label
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $ad5acd712c68634f$export$2e2bcd8739ae039), null, label)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "bg-white rounded-lg p-4 sm:p-8 max-w-2xl w-full mx-auto z-20 mt-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("h2", {
        className: "text-lg font-semibold mb-2 mt-0"
    }, "Your domain has been added to your environment."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", {
        className: "text-xsm mb-1"
    }, "The final step when taking your site live is to update your DNS records. This will route web traffic from your domain to your site hosted on Rocket Pages IO's server. Most of the time you will update these records at your domain registrar - where your domain was purchased."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex justify-end mt-6 flex-col sm:flex-row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        id: "save",
        className: "sm:w-32 py-1 z-0 mb-2.5 sm:mb-0 h-[52] sm:h-auto",
        sx: {
            textTransform: "none"
        },
        size: "small",
        variant: "contained",
        onClick: ()=>{
            setStepperActive(true);
            setShowPointDNS(true);
        }
    }, "Point DNS"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("button", {
        onClick: onClose,
        className: "sm:ml-2 px-4 py-2 border rounded-md hover:bg-gray-200 focus:outline-none focus:ring focus:border-blue-300"
    }, "I'll do this later"))))), !stepperActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex items-center justify-center min-h-screen p-4 add-domain-popup-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "fixed inset-0 bg-black opacity-50"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "bg-white rounded-lg p-4 sm:p-8 max-w-2xl w-full mx-auto z-20"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("h2", {
        className: "text-xl font-semibold mb-2 mt-0"
    }, "What is your domain (URL)?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", {
        className: "text-sm font-semibold mb-1"
    }, "Domain"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", {
        className: "text-xsm  mb-2"
    }, "e.g. mydomain.com"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "mb-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("input", {
        type: "text",
        className: "w-full px-4 py-2 border rounded-md focus:outline-none focus:ring focus:border-[#243060]-300",
        // placeholder="Enter subdomain"
        value: domain,
        onChange: handleSubdomainChange
    }), showValidattionError && !isValid && domain !== "" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", {
        className: `text-red-500 mt-1 ${domain === "" ? "hidden" : ""}`
    }, "Please enter a valid domain name.") : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex flex-row mt-2 -ml-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $0bade2783a449747$export$2e2bcd8739ae039), {
        disabled: !(isValid && domain.substring(0, 3) !== "www"),
        checked: isChecked,
        onChange: ()=>setIsChecked(!isChecked),
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", {
        className: `mb-0 self-center ${isValid && domain.substring(0, 3) !== "www" ? "cursor-pointer" : ""} text-xsm`,
        onClick: ()=>{
            if (isValid && domain.substring(0, 3) !== "www") setIsChecked(!isChecked);
        }
    }, `Also add www.${domain} ?`)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex flex-row -ml-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $0bade2783a449747$export$2e2bcd8739ae039), {
        // disabled={!(isValid && domain.substring(0, 3) !== "www")}
        checked: isPrimary,
        onChange: ()=>setIsPrimary(!isPrimary),
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", {
        className: `mb-0 self-center cursor-pointer text-xsm`,
        onClick: ()=>{
            setIsPrimary(!isPrimary);
        }
    }, `Set this domain as primary domain`))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex justify-end mt-4 sm:mt-6 flex-col sm:flex-row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        id: "save",
        className: "sm:w-32 py-1 z-0 mb-2.5 sm:mb-0 h-[52] sm:h-auto",
        sx: {
            textTransform: "none"
        },
        size: "small",
        variant: "contained",
        onClick: onAddDomain
    }, "Add domain"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("button", {
        onClick: onClose,
        className: "sm:ml-2 px-4 py-2 border rounded-md hover:bg-gray-200 focus:outline-none focus:ring focus:border-blue-300"
    }, "Close"))))));
};
var $412055656c20c8f0$export$2e2bcd8739ae039 = $412055656c20c8f0$var$CustomDomainModal;



var $8FY87 = parcelRequire("8FY87");
const $5cbde8797f3b59e2$var$CustomDomainHelpTextModal = ({ siteId: siteId, domainName: domainName, isOpen: isOpen, onClose: onClose })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useEffect(()=>{}, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `fixed z-50 inset-0 overflow-y-auto ${isOpen ? "block" : "hidden"}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex items-center justify-center min-h-screen p-4 add-domain-popup-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "fixed inset-0 bg-black opacity-50"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "bg-white rounded-lg p-4 sm:p-8 max-w-2xl w-full mx-auto z-20"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("h3", {
        className: "text-lg font-semibold mb-2 mt-0"
    }, "Connecting a Custom Domain and Setting a Primary Domain"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", {
        className: "text-sm/6 mb-4"
    }, "A ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("strong", null, "primary domain"), " is the main domain where your site will be served. If you add multiple custom domains, you can set", " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("strong", null, "one"), " as your primary domain."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", {
        className: "text-sm mb-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("ul", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("li", {
        class: "text-sm/6 mb-2"
    }, "If you don\u2019t set any domain as primary, your site will still be available but will use your default RocketPages subdomain (e.g.,", " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("strong", null, "yourproject.rocketpagesweb.com"), "), even if you\u2019ve added a custom domain."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("li", {
        class: "text-sm/6 mb-2"
    }, "When adding a custom domain, you can choose to use it with or without ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("strong", null, "www"), " (for example,", " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("strong", null, "www.example.com"), " or ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("strong", null, "example.com"), "). The version with ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("strong", null, "www"), " is technically a subdomain, while the version without is called the root or apex domain. Both work the same \u2014 you can pick whichever you prefer."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("li", {
        class: "text-sm/6 mb-2"
    }, "It\u2019s best practice to add both versions so your visitors can reach your site no matter which one they type."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("li", {
        class: "text-sm/6 mb-2"
    }, "If you attach a custom domain but don\u2019t validate it, your site will continue to use your RocketPages subdomain until the domain is validated. We strongly recommend validating your domain to ensure secure and reliable delivery."))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex justify-end mt-4 sm:mt-6 flex-col sm:flex-row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("button", {
        onClick: onClose,
        className: "sm:ml-2 px-4 py-2 border rounded-md hover:bg-gray-200 focus:outline-none focus:ring focus:border-blue-300"
    }, "Close"))))));
};
var $5cbde8797f3b59e2$export$2e2bcd8739ae039 = $5cbde8797f3b59e2$var$CustomDomainHelpTextModal;








const $35199937cd04f04a$var$ConfigDomain = (props)=>{
    const { enqueueSnackbar: enqueueSnackbar } = (0, $5e19452f9528802f$export$1c97ac2c9a6e7c09)();
    const [anchorEl, setAnchorEl] = $8FY87.useState(null);
    const [value, setValue] = $8FY87.useState(props.selectedDomainTab);
    const open = Boolean(anchorEl);
    const [moreOptionMenu, setMoreOptionMenu] = $8FY87.useState();
    const handleChange = (event, newValue)=>{
        setValue(newValue);
        props.onTabChange(newValue);
    };
    const [isOpen, setIsOpen] = $8FY87.useState(false);
    const [isModalOpen, setIsModalOpen] = $8FY87.useState(false);
    const [domains, setDomains] = $8FY87.useState([]);
    const [domainWiseCount, setDomainWiseCount] = $8FY87.useState([]);
    const [reloadDomains, setReloadDomains] = $8FY87.useState(false);
    const [currentDomainName, setCurrentDomainName] = $8FY87.useState("");
    const [isPointDNS, setIsPointDNS] = $8FY87.useState(false);
    const [isStepper, setIsStepper] = $8FY87.useState(false);
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const [textClassObj] = $8FY87.useState([
        {
            fontSize: "14px",
            color: "#243060"
        },
        {
            "&:hover": {
                fontWeight: 700
            }
        }
    ]);
    const handleClick = (event, domain)=>{
        // console.log('sssss', domain, isValidated, isPrimary)
        setMoreOptionMenu(domain);
        setAnchorEl(event.currentTarget);
    };
    $8FY87.useEffect(()=>{
        async function fetchDomainData(siteId) {
            let response = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).get(`/api/configs/site-domains?siteId=${siteId}`);
            // console.log("//", response.data);
            setDomains(response.data.data);
            let domainWiseCount = [];
            response.data.data.forEach((row)=>{
                let idx = domainWiseCount.findIndex((kk)=>kk.domain === row.domain.replace("www.", ""));
                if (idx === -1) domainWiseCount.push({
                    domain: row.domain.replace("www.", ""),
                    cnt: 1
                });
                else domainWiseCount[idx].cnt += 1;
            });
            // console.log("domainWiseCount", domainWiseCount);
            setDomainWiseCount(domainWiseCount);
        }
        fetchDomainData(props.siteId);
    }, [
        isOpen,
        reloadDomains
    ]);
    // Function to handle domain validation
    const handleValidate = async (domain)=>{
        props.setIsCheckingSSL(true);
        let response = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post(`/api/configs/validate-custom-domain`, {
            siteId: props.siteId,
            domain: domain
        });
        if (response.data.data.isValidated === "true") {
            if (props.isPublished) handleCheckSSL(domain);
            else {
                setReloadDomains(!reloadDomains);
                props.setIsCheckingSSL(false);
                enqueueSnackbar("Domain validated successfully!", {
                    variant: "info",
                    className: "bg-grey-400"
                });
            }
        } else {
            props.setIsCheckingSSL(false);
            enqueueSnackbar("Domain validation failed!", {
                variant: "error",
                className: "bg-grey-400"
            });
        }
    };
    const handleCheckSSL = async (domain)=>{
        let checkInterval = setInterval(async ()=>{
            const sslResponse = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).get(`/api/configs/check-ssl?url=https://${domain}`);
            if (sslResponse.status === 200) {
                clearInterval(checkInterval);
                checkInterval = false;
                setReloadDomains(!reloadDomains);
                props.setIsCheckingSSL(false);
                enqueueSnackbar("Domain validated successfully!", {
                    variant: "info",
                    className: "bg-grey-400"
                });
            } else if (sslResponse.status === 500) {
                clearInterval(checkInterval);
                checkInterval = false;
                props.setIsCheckingSSL(false);
                enqueueSnackbar("Domain validation failed!", {
                    variant: "info",
                    className: "bg-grey-400"
                });
            }
        }, 5000);
        setTimeout(()=>{
            if (checkInterval) {
                clearInterval(checkInterval);
                checkInterval = false;
                props.setIsCheckingSSL(false);
                enqueueSnackbar("Domain validation failed!", {
                    variant: "info",
                    className: "bg-grey-400"
                });
            }
        }, 300000);
    };
    const handleSetPrimaryDomain = (domainName)=>{
        async function setPrimaryCustomDomain(siteId, domain) {
            props.setIsLoading(true);
            let response = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post(`/api/configs/set-primary-domain`, {
                siteId: siteId,
                domain: domain
            });
            if (response.status === 200) {
                if (props.isPublished) props.checkPublishStatus("Primary domain set successfully!");
                setReloadDomains(!reloadDomains);
            } else props.setIsLoading(false);
        }
        // console.log("onsetprimarydomain", props.siteId, domainName);
        setPrimaryCustomDomain(props.siteId, domainName);
    };
    const handleDelete = (domainName)=>{
        async function deleteCustomDomain(siteId, domain) {
            try {
                props.setIsLoading(true);
                let response = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post(`/api/configs/delete-custom-domain`, {
                    siteId: siteId,
                    domain: domain
                });
                // console.log("//", response.data);
                props.setIsLoading(false);
                setReloadDomains(!reloadDomains);
                enqueueSnackbar("Domain deleted successfully!", {
                    variant: "info",
                    className: "bg-grey-400"
                });
            } catch (err) {
                props.setIsLoading(false);
                enqueueSnackbar(err.response.data.message, {
                    variant: "error",
                    className: "bg-grey-400"
                });
            }
        }
        deleteCustomDomain(props.siteId, domainName);
    };
    function isValidSubdomain(subdomain) {
        // Regular expression to validate subdomain
        const subdomainRegex = /^[a-zA-Z0-9](?:[a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?$/;
        // Check if the subdomain matches the regex
        return subdomainRegex.test(subdomain);
    }
    return /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col text-black h-screen  left-sidebar-domain"
    }, isOpen && /*#__PURE__*/ $8FY87.createElement((0, $412055656c20c8f0$export$2e2bcd8739ae039), {
        siteId: props.siteId,
        showStepper: isPointDNS && isStepper,
        isOpen: isOpen,
        domainName: currentDomainName,
        onClose: ()=>setIsOpen(false),
        isPointDNS: isPointDNS
    }), isModalOpen && /*#__PURE__*/ $8FY87.createElement((0, $5cbde8797f3b59e2$export$2e2bcd8739ae039), {
        siteId: props.siteId,
        isOpen: isModalOpen,
        domainName: currentDomainName,
        onClose: ()=>setIsModalOpen(false)
    }), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "bg-white-smoke z-0"
    }, /*#__PURE__*/ $8FY87.createElement((0, $65ede3c1fb83823f$export$2e2bcd8739ae039), {
        value: value
    }, /*#__PURE__*/ $8FY87.createElement((0, $0181e7500204b60c$export$2e2bcd8739ae039), {
        value: value,
        onChange: handleChange,
        indicatorColor: "secondary",
        variant: "scrollable",
        allowScrollButtonsMobile: true,
        "aria-label": "full width tabs example",
        scrollButtons: "auto",
        className: "domain-tabs"
    }, /*#__PURE__*/ $8FY87.createElement((0, $e7d54e7d83e3c56c$export$2e2bcd8739ae039), {
        value: "subdomain",
        label: "Rocket Pages Domain"
    }), /*#__PURE__*/ $8FY87.createElement((0, $e7d54e7d83e3c56c$export$2e2bcd8739ae039), {
        value: "customdomain",
        label: "Custom Domain"
    })), /*#__PURE__*/ $8FY87.createElement((0, $0b35694b79d42e6e$export$2e2bcd8739ae039), {
        value: "subdomain",
        className: "px-0 bg-white-smoke z-0"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col"
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-base-2 mb-2"
    }, "Subdomain"), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "font-normal mb-4"
    }, "After publishing, this domain name will serve as your website's address, making it easily accessible to your customers or viewers."), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col lg:flex-row font-normal lg:items-baseline"
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: "mr-3"
    }, "https://"), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "flex flex-col"
    }, /*#__PURE__*/ $8FY87.createElement("input", {
        // disabled
        className: "border rounded border-catelina-blue/60 w-full sm:w-80 py-1 px-2",
        placeholder: "xyzwebsite",
        value: props.subDomain,
        onChange: (e)=>{
            let tmp_ErrorMessage = "";
            if (e.target.value.toLowerCase() === "") tmp_ErrorMessage = "Subdomain can't be empty!";
            else if ((e.target.value.toLowerCase() === "app" || e.target.value.toLowerCase() === "server" || e.target.value.toLowerCase() === "editor" || e.target.value.toLowerCase() === "apps" || e.target.value.toLowerCase() === "rocketpages" || e.target.value.toLowerCase() === "admin" || e.target.value.toLowerCase() === "support" || e.target.value.toLowerCase() === "billing" || e.target.value.toLowerCase() === "blog" || e.target.value.toLowerCase() === "docs" || e.target.value.toLowerCase() === "dashboard" || e.target.value.toLowerCase() === "marketplace" || e.target.value.toLowerCase() === "marketing" || e.target.value.toLowerCase() === "account" || e.target.value.toLowerCase() === "feedback" || e.target.value.toLowerCase() === "login" || e.target.value.toLowerCase() === "status" || e.target.value.toLowerCase() === "preview") && props.userData.userType !== "admin") tmp_ErrorMessage = "Invalid Subdomain!";
            else if (isValidSubdomain(e.target.value.toLowerCase())) tmp_ErrorMessage = "";
            else tmp_ErrorMessage = "Invalid Subdomain!";
            props.onDataChange({
                subDomain: e.target.value.toLowerCase(),
                subDomainErrorMessage: tmp_ErrorMessage
            });
        }
    }), props.subDomainErrorMessage !== "" && /*#__PURE__*/ $8FY87.createElement("span", {
        className: `text-sm mx-1 ${"text-red-500"}`
    }, props.subDomainErrorMessage)), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "lg:ml-3"
    }, ".rocketpagesweb.com")))), /*#__PURE__*/ $8FY87.createElement((0, $0b35694b79d42e6e$export$2e2bcd8739ae039), {
        value: "customdomain",
        className: "px-0 bg-white-smoke z-0"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col md:flex-row mb-5 lg:mb-10 pl-3 space-y-2 md:space-y-0 md:items-center"
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-sm md:text-base"
    }, "\u2139\uFE0F Connecting a Custom Domain and Setting a Primary Domain.", /*#__PURE__*/ $8FY87.createElement("a", {
        href: "#",
        onClick: (e)=>{
            e.preventDefault();
            setIsModalOpen(true);
        },
        className: "py-1 px-1 text-blue-600 rounded text-sm w-fit inline-block"
    }, "Learn more."))), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-row justify-start max-w-lg"
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-base-2 mb-2"
    }), /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        id: "save",
        className: "w-40 py-1 z-0",
        sx: {
            textTransform: "none"
        },
        onClick: ()=>{
            setIsOpen(true);
            setIsPointDNS(false);
            setIsStepper(false);
        },
        disabled: domainWiseCount.length > 0,
        size: "small",
        variant: "contained"
    }, "Add Custom Domain")), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-row justify-between font-normal items-center mt-4"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "overflow-x-auto"
    }, /*#__PURE__*/ $8FY87.createElement("table", {
        className: "min-w-full divide-y divide-gray-200 mb-0"
    }, /*#__PURE__*/ $8FY87.createElement("thead", null, /*#__PURE__*/ $8FY87.createElement("tr", null, /*#__PURE__*/ $8FY87.createElement("th", {
        className: "px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 w-72 tracking-wider"
    }, "Domains"), /*#__PURE__*/ $8FY87.createElement("th", {
        className: "px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 w-36 tracking-wider"
    }, "Status"), /*#__PURE__*/ $8FY87.createElement("th", {
        className: "px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 w-20 tracking-wider"
    }, "Actions"))), /*#__PURE__*/ $8FY87.createElement("tbody", {
        className: "bg-white divide-y divide-gray-200"
    }, domains.length > 0 && domains.map((rr)=>{
        // console.log("rr", rr);
        let l_domainName = rr.domain;
        return /*#__PURE__*/ $8FY87.createElement("tr", {
            key: rr.domain
        }, /*#__PURE__*/ $8FY87.createElement("td", {
            className: "px-6 py-4 whitespace-no-wrap"
        }, rr.domain, rr.isPrimary ? /*#__PURE__*/ $8FY87.createElement("span", {
            className: "mx-2 px-2 inline-flex text-xsm leading-5 font-semibold rounded-full bg-purple-100 text-purple-800"
        }, "Primary") : null), /*#__PURE__*/ $8FY87.createElement("td", {
            className: "px-6 py-4 whitespace-no-wrap"
        }, rr.isValidated === "true" ? /*#__PURE__*/ $8FY87.createElement("span", {
            className: "px-2 inline-flex text-xsm leading-5 font-semibold rounded-full bg-green-100 text-green-800"
        }, "Valid") : /*#__PURE__*/ $8FY87.createElement("span", {
            className: "px-2 inline-flex text-xsm leading-5 font-semibold rounded-full bg-red-100 text-red-800"
        }, "Invalid")), /*#__PURE__*/ $8FY87.createElement("td", {
            className: "px-6 py-4 whitespace-no-wrap flex flex-row justify-end"
        }, rr.isValidated !== "true" && /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
            className: "py-1 px-3 z-0 capitalize",
            onClick: ()=>handleValidate(rr.domain),
            size: "small",
            variant: "contained"
        }, "Validate"), /*#__PURE__*/ $8FY87.createElement("button", {
            className: "w-10 mx-2",
            onClick: (e)=>{
                handleClick(e, rr);
            }
        }, /*#__PURE__*/ $8FY87.createElement("img", {
            // onClick={() => {
            //   props.onMoreOptionClick(rr.domain, rr.isValidated === "true", rr.isPrimary)
            // }}
            className: "w-[36px] hover:cursor-pointer",
            // src={require("../../images/extra-option.svg")}
            src: (parcelRequire("jzVBy")),
            alt: ""
        }))));
    })), moreOptionMenu && /*#__PURE__*/ $8FY87.createElement((0, $0b320025c1b3a544$export$2e2bcd8739ae039), {
        anchorEl: anchorEl,
        id: "account-menu",
        open: open,
        onClose: handleClose,
        onClick: handleClose,
        PaperProps: {
            elevation: 0,
            sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                mt: 1.5,
                "& .MuiAvatar-root": {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1
                },
                "&::before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: "background.paper",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0
                }
            }
        },
        transformOrigin: {
            horizontal: "right",
            vertical: "top"
        },
        anchorOrigin: {
            horizontal: "right",
            vertical: "bottom"
        },
        className: "domain-menu-list"
    }, /*#__PURE__*/ $8FY87.createElement((0, $ee9f19037253b32c$export$2e2bcd8739ae039), {
        sx: textClassObj,
        disabled: moreOptionMenu.isPrimary,
        onClick: ()=>{
            // console.log("ccc", moreOptionMenu.domain);
            handleSetPrimaryDomain(moreOptionMenu.domain);
        }
    }, "Set as primary domain"), /*#__PURE__*/ $8FY87.createElement((0, $ee9f19037253b32c$export$2e2bcd8739ae039), {
        sx: textClassObj,
        disabled: moreOptionMenu.isValidated === "true" ? true : false,
        onClick: ()=>handleValidate(moreOptionMenu.domain)
    }, "Validate domain"), /*#__PURE__*/ $8FY87.createElement((0, $ee9f19037253b32c$export$2e2bcd8739ae039), {
        sx: textClassObj,
        onClick: ()=>{
            setIsPointDNS(true);
            setIsOpen(true);
            setIsStepper(true);
            setCurrentDomainName(moreOptionMenu.domain);
        }
    }, "Update DNS"), /*#__PURE__*/ $8FY87.createElement((0, $30a538faf9a95dbb$export$2e2bcd8739ae039), {
        sx: [
            {
                marginTop: 2,
                marginBottom: 2
            }
        ]
    }), /*#__PURE__*/ $8FY87.createElement((0, $ee9f19037253b32c$export$2e2bcd8739ae039), {
        sx: [
            ...textClassObj,
            {
                color: "#F00"
            }
        ],
        onClick: ()=>handleDelete(moreOptionMenu.domain)
    }, "Delete"))))))))));
};
var $35199937cd04f04a$export$2e2bcd8739ae039 = $35199937cd04f04a$var$ConfigDomain;



var $8FY87 = parcelRequire("8FY87");




const $05100f9b0153af82$var$ConfigGeneral = (props)=>{
    return /*#__PURE__*/ $8FY87.createElement("div", {
        className: "left-sidebar-gereral"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col text-black site-name"
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-base-2 mb-2"
    }, "Site name"), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "font-normal mb-4"
    }, "A site name is a unique identifier for a website, aiding in easy organization and navigation within the dashboard."), /*#__PURE__*/ $8FY87.createElement("input", {
        className: "border rounded border-catelina-blue/60 w-full py-1 px-2 md:w-80",
        placeholder: "Website name",
        value: props.siteName,
        //   disabled
        onChange: (e)=>{
            props.onDataChange({
                siteName: (0, $df5cb81582703dc6$export$2e2bcd8739ae039)(e.target.value)
            });
        }
    })), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "py-8"
    }, /*#__PURE__*/ $8FY87.createElement((0, $30a538faf9a95dbb$export$2e2bcd8739ae039), null)), /*#__PURE__*/ $8FY87.createElement((0, $4d9d5f5bbbfa7366$export$2e2bcd8739ae039), {
        className: "favicon-image",
        image_url: props.faviconImage,
        siteId: props.siteId,
        title: "Favicon image",
        desc: "Favicon is displayed on your site's tab in a browser.",
        notes: "Please upload a 16x16px .PNG or .JPG image.",
        onImageChange: (img_url)=>{
            props.onDataChange({
                faviconImage: img_url
            });
        }
    }), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "py-8"
    }, /*#__PURE__*/ $8FY87.createElement((0, $30a538faf9a95dbb$export$2e2bcd8739ae039), null)), /*#__PURE__*/ $8FY87.createElement((0, $4d9d5f5bbbfa7366$export$2e2bcd8739ae039), {
        className: "og-image",
        siteId: props.siteId,
        image_url: props.defaultSocialMediaImage,
        title: "Default social media image (Open graph image)",
        desc: "Open Graph images, also known as OG images, are designated images used to represent webpages when shared on social media platforms. They provide a visual representation of the content and help maintain a consistent and visually appealing appearance across different social media channels.",
        notes: "Please upload a 1200x630px .PNG or .JPG image.",
        onImageChange: (img_url)=>{
            props.onDataChange({
                defaultSocialMediaImage: img_url
            });
        }
    }), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col text-black"
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-base-2 mb-2 mt-4"
    }, "Alt text"), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "font-normal mb-2"
    }, "Alt text for the image provide accessibility and additional information for use."), /*#__PURE__*/ $8FY87.createElement("input", {
        className: "border rounded border-catelina-blue/60 w-full py-1 px-2 md:w-80",
        value: props.defaultSocialMediaImageAlt,
        onChange: (e)=>{
            props.onDataChange({
                defaultSocialMediaImageAlt: (0, $df5cb81582703dc6$export$2e2bcd8739ae039)(e.target.value)
            });
        }
    }), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "items-center text-xsm"
    }, /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($80cdb5096bdf46ee$exports))), {
        fontSize: "inherit"
    }), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "ml-1"
    }, "Please enter social media image alt text."))), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "py-8"
    }, /*#__PURE__*/ $8FY87.createElement((0, $30a538faf9a95dbb$export$2e2bcd8739ae039), null)), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col text-black"
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-base-2 mb-2"
    }, "Default social media description (Open graph description)"), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "font-normal mb-4"
    }, "The Open Graph description enhances the appearance of your content when shared on platforms like Facebook and Twitter, helping to engage users and encourage clicks."), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-row"
    }, /*#__PURE__*/ $8FY87.createElement("textarea", {
        value: props.defaultSocialMediaDescription,
        onChange: (e)=>{
            props.onDataChange({
                defaultSocialMediaDescription: e.target.value
            });
        },
        className: "w-full lg:w-4/5 border rounded border-catelina-blue/60 py-1 px-2",
        rows: 4
    })), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "items-center text-xsm"
    }, /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($80cdb5096bdf46ee$exports))), {
        fontSize: "inherit"
    }), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "ml-1 leading-normal"
    }, "This description will be used across all pages when a page-specific description is not provided. Write a brief, engaging summary (up to 160 characters) that represents your website or brand. It will appear in search results, social media previews (under the 'meta,' 'og,' and 'twitter' tags), and when shared on platforms like Facebook and Twitter."))));
};
var $05100f9b0153af82$export$2e2bcd8739ae039 = $05100f9b0153af82$var$ConfigGeneral;










var $8FY87 = parcelRequire("8FY87");




const $8813eb74b0ee98c8$var$ConfigPricingPlan = (props)=>{
    const { enqueueSnackbar: enqueueSnackbar } = (0, $5e19452f9528802f$export$1c97ac2c9a6e7c09)();
    const [cookies] = (0, $1f373de1ceea6eb7$export$2e2bcd8739ae039)([
        "rp_user_data"
    ]);
    const [isYearly, setIsYearly] = (0, $8FY87.useState)(false);
    const [isLoading, setIsLoading] = (0, $8FY87.useState)(false);
    const [planToBuy, setPlanToBuy] = (0, $8FY87.useState)(null);
    const isQATeam = false;
    const planFeatures = [
        {
            plan: "Forever Free",
            features: [
                "Attach custom domain",
                "Upto 1 GB storage",
                "Upto 10,000 visitors/month",
                "5 Contact form submissions/month",
                "Upto 1GB/month bandwidth",
                "Unlimited pages",
                "Unlimited team members",
                "Free SSL"
            ]
        },
        {
            plan: "Pro",
            features: [
                "Everything from Forever Free plan",
                "5 GB storage",
                "Upto 50,000 visitors/month",
                "50 Contact form submissions/month",
                "5 GB/month bandwidth",
                "No RocketPages branding"
            ]
        },
        {
            plan: "Business",
            features: [
                "Everything from Pro plan",
                "100 GB storage",
                "Upto 500,000 visitors/month",
                "Unlimited contact form submissions",
                "Unlimited bandwidth"
            ]
        }
    ];
    if (isQATeam) {
        if (!planFeatures.find((planFeature)=>planFeature.plan === "QA Only")) planFeatures.push({
            plan: "QA Only",
            features: [
                "Everything from Pro plan",
                "100 GB storage",
                "Upto 500,000 visitors/month",
                "Unlimited contact form submissions",
                "Unlimited bandwidth"
            ]
        });
    }
    const togglePricing = ()=>{
        setIsYearly(!isYearly);
    };
    function checkPlanStatus(currentPlan) {
        if (props.activeSub?.selectedPlan && currentPlan && props.activeSub?.selectedPlan.price > currentPlan.price) return "Downgrade";
        else return "Upgrade";
    }
    function upgradeSubscription(plan) {
        if (props.activeSub?.plan_id === plan.priceId && props.activeSub?.cancel_at_period_end) resumeSubscription();
        else if (props.activeSub?.plan_id) setPlanToBuy(plan);
        else createStripeCheckout(plan.priceId);
    }
    async function createStripeCheckout(priceId) {
        setIsLoading(true);
        let data = JSON.stringify({
            priceId: priceId,
            email: cookies.rp_user_data.email,
            siteId: props.id
        });
        setPlanToBuy(null);
        let config = {
            method: "post",
            mode: "no-cors",
            maxBodyLength: Infinity,
            url: `${"https://api.rocketpages.io"}/api/configs/create-stripe-checkout-session`,
            headers: {
                "Content-Type": "application/json"
            },
            withCredentials: true,
            data: data
        };
        let res = await (0, $bf5b93105d90423b$export$2e2bcd8739ae039).request(config);
        if (res.data.sessionUrl) window.location.href = res.data.sessionUrl;
        else {
            if (res.data.error) {
                setIsLoading(false);
                enqueueSnackbar(res.data.error, {
                    variant: "error",
                    className: "bg-catelina-blue"
                });
                return;
            } else if (res.data.status && res.data.msg) {
                setIsLoading(false);
                enqueueSnackbar(res.data.msg, {
                    variant: "success",
                    className: "bg-catelina-blue"
                });
                props.updateActiveSub(res.data.subscription);
                props.reFetch();
                return;
            }
        }
    }
    async function resumeSubscription() {
        setIsLoading(true);
        let data = JSON.stringify({
            subscriptionId: props.activeSub.subscriptionId,
            email: cookies.rp_user_data.email,
            siteId: props.id
        });
        let config = {
            method: "put",
            mode: "no-cors",
            maxBodyLength: Infinity,
            url: `${"https://api.rocketpages.io"}/api/configs/site-config-resume-subscription`,
            headers: {
                "Content-Type": "application/json"
            },
            withCredentials: true,
            data: data
        };
        let res = await (0, $bf5b93105d90423b$export$2e2bcd8739ae039).request(config);
        if (!res.data.error && res.data.status && !res.data.subscription.cancel_at_period_end) {
            setIsLoading(false);
            enqueueSnackbar("Your subscription is resumed.", {
                variant: "success",
                className: "bg-catelina-blue"
            });
            props.updateActiveSub(res.data.subscription);
            props.reFetch();
        } else {
            setIsLoading(false);
            enqueueSnackbar(res.data.error ?? "Something went wrong while resuming subscription", {
                variant: "error",
                autoHideDuration: 9000
            });
        }
    }
    return /*#__PURE__*/ $8FY87.createElement("section", {
        id: "plans",
        className: "config-pricing-plan flex flex-col justify-center items-center w-full"
    }, !!planToBuy && /*#__PURE__*/ $8FY87.createElement("div", {
        className: "fixed inset-0 overflow-y-auto flex justify-center items-center z-10"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "fixed inset-0"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "absolute inset-0 bg-gray-500 opacity-75"
    })), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "bg-white max-w-xl rounded py-8 px-8 md:px-16 m-4 z-50 items-center flex text-center flex-col relative"
    }, /*#__PURE__*/ $8FY87.createElement("img", {
        src: (parcelRequire("dYuXF")),
        className: "absolute right-2 top-2 cursor-pointer",
        onClick: ()=>setPlanToBuy(null)
    }), /*#__PURE__*/ $8FY87.createElement("img", {
        src: (parcelRequire("ks21t")),
        className: "mb-2"
    }), /*#__PURE__*/ $8FY87.createElement("h4", {
        className: "mb-4"
    }, "Update to ", planToBuy?.plan, " (", planToBuy?.duration, "ly)", " "), /*#__PURE__*/ $8FY87.createElement("p", {
        className: "text-gray-800 mb-4"
    }, "You are currently on the ", props.activeSub?.selectedPlan?.plan, " (", props.activeSub?.selectedPlan?.duration, "ly) plan which expires on", " ", new Date(props.activeSub?.subscription_end * 1000).toLocaleDateString("en-GB"), ".", " "), /*#__PURE__*/ $8FY87.createElement("p", {
        className: "text-grey-primary mb-4 font-normal"
    }, props.activeSub?.selectedPlan?.price > planToBuy?.price && /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, null, "Your ", planToBuy?.plan, " (", planToBuy?.duration, "ly) plan will take effect at the end of your current billing cycle. You will not be charged immediately. New plan will reflect in your account post current plan's expiration."), props.activeSub?.selectedPlan?.price < planToBuy?.price && /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, null, "Your ", planToBuy?.plan, " (", planToBuy?.duration, "ly) plan will start and you will be charged immediately. Your current plan will be replaced with the new plan.")), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex justify-end flex-col sm:flex-row"
    }, /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        className: "shadow-none",
        disabled: isLoading,
        // className="text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
        size: "large",
        variant: "contained",
        color: "primary",
        onClick: ()=>createStripeCheckout(planToBuy.priceId)
    }, "Update Plan")))), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "billing-cycle"
    }, /*#__PURE__*/ $8FY87.createElement((0, $b19176bd78e1869f$export$2e2bcd8739ae039), {
        className: "flex mb-4"
    }, /*#__PURE__*/ $8FY87.createElement((0, $b19176bd78e1869f$export$2e2bcd8739ae039), {
        className: "mask-box"
    }, /*#__PURE__*/ $8FY87.createElement((0, $b19176bd78e1869f$export$2e2bcd8739ae039), {
        className: "mask",
        style: {
            transform: `translateX(${isYearly === false ? 0 : "100px"})`
        }
    }), /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        disableRipple: true,
        variant: "text",
        sx: {
            color: isYearly === false ? "#ffffff" : "#243060"
        },
        onClick: ()=>togglePricing()
    }, "Monthly"), /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        disableRipple: true,
        variant: "text",
        sx: {
            color: isYearly === true ? "#ffffff" : "#243060"
        },
        onClick: ()=>togglePricing()
    }, "Yearly")))), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex relative flex-col lg:flex-row grid grid-col-1 lg:grid-cols-3 md:grid-cols-1 gap-2 pricing-wrapper"
    }, props.plans.filter((plan)=>plan.duration === (isYearly ? "year" : "month")).map((plan, index)=>{
        return /*#__PURE__*/ $8FY87.createElement((0, $70b2c7bd1b8d5210$export$2e2bcd8739ae039), {
            key: index,
            sx: {},
            className: "lg:m-0 mt-2 md:mt-0 shadow-none border border-gray p-2 rounded-lg  flex flex-col justify-between max-w-sm lg:max-w-auto w-full lg:w-auto m-auto"
        }, /*#__PURE__*/ $8FY87.createElement((0, $554c427c007750bc$export$2e2bcd8739ae039), {
            className: "relative p-0"
        }, /*#__PURE__*/ $8FY87.createElement((0, $b19176bd78e1869f$export$2e2bcd8739ae039), {
            className: "flex  border-b border-gray pb-3.5"
        }, /*#__PURE__*/ $8FY87.createElement("h4", {
            className: "text-center m-0 pr-2",
            style: {
                color: "#243060"
            }
        }, plan.plan), !props.isLoading && (props.activeSub?.plan_id === plan.priceId && props.activeSub?.subscription_status === "active" || props.activeSub === undefined && plan.priceId == "") && /*#__PURE__*/ $8FY87.createElement("p", {
            className: "border m-0 text-xs rounded-xl bg-catelina-blue text-white px-2",
            style: {
                fontSize: "12px"
            }
        }, "Current Plan")), /*#__PURE__*/ $8FY87.createElement((0, $b19176bd78e1869f$export$2e2bcd8739ae039), {
            className: "py-3.5 border-b border-gray"
        }, /*#__PURE__*/ $8FY87.createElement("h4", {
            className: "m-0 flex items-center",
            style: {
                color: "#3B3B3B"
            }
        }, /*#__PURE__*/ $8FY87.createElement("sup", null, "$"), /*#__PURE__*/ $8FY87.createElement("span", {
            style: {
                fontSize: "38px"
            }
        }, plan.price), " ", /*#__PURE__*/ $8FY87.createElement("span", {
            style: {
                fontWeight: 300
            }
        }, "/site/", plan.duration))), /*#__PURE__*/ $8FY87.createElement("ul", {
            className: "list-disc list-none plan-feature p-0 mb-8 mt-3.5"
        }, planFeatures.find((planFeature)=>planFeature.plan === plan.plan)?.features.map((feature, idx)=>/*#__PURE__*/ $8FY87.createElement("li", {
                key: idx,
                className: "mb-1"
            }, feature)))), plan.price > 0 && /*#__PURE__*/ $8FY87.createElement((0, $2176c70dc036ba55$export$2e2bcd8739ae039), {
            className: "flex justify-center mb-4 p-0"
        }, /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
            className: "shadow-none w-full",
            // disabled={buttonDisabled}
            disabled: props.isLoading || isLoading || props.activeSub?.plan_id === plan.priceId && props.activeSub?.subscription_status !== "canceled" && (!props.activeSub?.cancel_at_period_end || props.activeSub?.cancel_at_period_end && props.upcomingPhase) || props.upcomingPhase && props.upcomingPhase?.selectedPlan?.priceId === plan.priceId,
            size: "small",
            variant: "contained",
            onClick: ()=>upgradeSubscription(plan)
        }, props.isLoading && "Fetching current plan...", !props.isLoading && /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, null, props.activeSub?.plan_id === plan.priceId && props.activeSub?.cancel_at_period_end && !props.upcomingPhase ? "Resume Subscription" : checkPlanStatus(plan) + " to " + plan.plan))), plan.price > 0 && !props.isLoading && /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, null, props.activeSub?.plan_id === plan.priceId && !props.activeSub?.cancel_at_period_end && /*#__PURE__*/ $8FY87.createElement("div", {
            className: "bg-[#E1E4EF] rounded p-2 mb-8"
        }, /*#__PURE__*/ $8FY87.createElement("p", {
            className: "text-sm mb-0.5 flex items-center text-catelina-blue"
        }, /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($80cdb5096bdf46ee$exports))), {
            className: "mr-1",
            style: {
                fontSize: 20
            }
        }), " ", checkPlanStatus(plan), " button inactive:", " "), /*#__PURE__*/ $8FY87.createElement("p", {
            className: "text-sm mb-0 leading-4 font-normal"
        }, "You are currently on this plan.")), props.activeSub?.plan_id === plan.priceId && props.activeSub?.cancel_at_period_end && /*#__PURE__*/ $8FY87.createElement("div", {
            className: "bg-[#E1E4EF] rounded p-2 mb-8"
        }, /*#__PURE__*/ $8FY87.createElement("p", {
            className: "text-sm mb-0.5 flex items-center text-catelina-blue"
        }, /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($80cdb5096bdf46ee$exports))), {
            className: "mr-1",
            style: {
                fontSize: 20
            }
        }), " ", "Attention"), /*#__PURE__*/ $8FY87.createElement("p", {
            className: "text-sm mb-0 leading-4 font-normal"
        }, "Your subscription ends at the current cycle. Click", " ", /*#__PURE__*/ $8FY87.createElement("b", null, "Resume Subscription"), " to continue your plan.")), props.activeSub?.plan_id !== plan.priceId && props.upcomingPhase && props.upcomingPhase?.selectedPlan?.priceId === plan.priceId && /*#__PURE__*/ $8FY87.createElement("div", {
            className: "bg-[#E1E4EF] rounded p-2 mb-8"
        }, /*#__PURE__*/ $8FY87.createElement("p", {
            className: "text-sm mb-0.5 flex items-center text-catelina-blue"
        }, /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($80cdb5096bdf46ee$exports))), {
            className: "mr-1",
            style: {
                fontSize: 20
            }
        }), " ", checkPlanStatus(plan), " button inactive:", " "), /*#__PURE__*/ $8FY87.createElement("p", {
            className: "text-sm mb-0 leading-4 font-normal"
        }, "This is your upcoming plan which will auto-update post current plan's expiration."))), plan.price > 0 && !props.isLoading && props.activeSub?.plan_id && props.activeSub?.plan_id !== plan.priceId && (!props.upcomingPhase || props.upcomingPhase?.selectedPlan?.priceId !== plan.priceId) && /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, null, props.activeSub?.amount_total / 100 < plan.price && /*#__PURE__*/ $8FY87.createElement("div", {
            className: "bg-[#E1E4EF] rounded p-2 mb-8"
        }, /*#__PURE__*/ $8FY87.createElement("p", {
            className: "text-sm mb-0.5 flex items-center text-catelina-blue"
        }, /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($80cdb5096bdf46ee$exports))), {
            className: "mr-1",
            style: {
                fontSize: 20
            }
        }), " ", "Attention", " "), /*#__PURE__*/ $8FY87.createElement("p", {
            className: "text-sm mb-0 leading-4 font-normal"
        }, "Upgrading to the ", plan.plan, " (", plan.duration, "ly) plan will process your payment immediately (prorated), and access to new features will be granted.")), props.activeSub?.amount_total / 100 > plan.price && /*#__PURE__*/ $8FY87.createElement("div", {
            className: "bg-[#E1E4EF] rounded p-2 mb-8"
        }, /*#__PURE__*/ $8FY87.createElement("p", {
            className: "text-sm mb-0.5 flex items-center text-catelina-blue"
        }, /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($80cdb5096bdf46ee$exports))), {
            className: "mr-1",
            style: {
                fontSize: 20
            }
        }), " ", "Attention", " "), /*#__PURE__*/ $8FY87.createElement("p", {
            className: "text-sm mb-0 leading-4 font-normal"
        }, "Downgrading to the ", plan.plan, " (", plan.duration, "ly) plan will prorate your payment from next billing cycle. You can access your current features until then."))));
    })));
};
var $8813eb74b0ee98c8$export$2e2bcd8739ae039 = $8813eb74b0ee98c8$var$ConfigPricingPlan;










var $8FY87 = parcelRequire("8FY87");

const $fb6c4742a3f9e788$var$ConfigSEO = (props)=>{
    const { enqueueSnackbar: enqueueSnackbar } = (0, $5e19452f9528802f$export$1c97ac2c9a6e7c09)();
    // const [selectedLang, setSelectedLang] = React.useState(props.primaryLanguage);
    // const [selectedLang, setSelectedLang] = React.useState("en-English");
    const languages = [
        {
            lang: "ab-Abkhazian",
            langName: "ab-Abkhazian"
        },
        {
            lang: "aa-Afar",
            langName: "aa-Afar"
        },
        {
            lang: "af-Afrikaans",
            langName: "af-Afrikaans"
        },
        {
            lang: "ak-Akan",
            langName: "ak-Akan"
        },
        {
            lang: "sq-Albanian",
            langName: "sq-Albanian"
        },
        {
            lang: "am-Amharic",
            langName: "am-Amharic"
        },
        {
            lang: "ar-Arabic",
            langName: "ar-Arabic"
        },
        {
            lang: "an-Aragonese",
            langName: "an-Aragonese"
        },
        {
            lang: "hy-Armenian",
            langName: "hy-Armenian"
        },
        {
            lang: "as-Assamese",
            langName: "as-Assamese"
        },
        {
            lang: "av-Avaric",
            langName: "av-Avaric"
        },
        {
            lang: "ae-Avestan",
            langName: "ae-Avestan"
        },
        {
            lang: "ay-Aymara",
            langName: "ay-Aymara"
        },
        {
            lang: "az-Azerbaijani",
            langName: "az-Azerbaijani"
        },
        {
            lang: "bm-Bambara",
            langName: "bm-Bambara"
        },
        {
            lang: "ba-Bashkir",
            langName: "ba-Bashkir"
        },
        {
            lang: "eu-Basque",
            langName: "eu-Basque"
        },
        {
            lang: "be-Belarusian",
            langName: "be-Belarusian"
        },
        {
            lang: "bn-Bengali (Bangla)",
            langName: "bn-Bengali (Bangla)"
        },
        {
            lang: "bh-Bihari",
            langName: "bh-Bihari"
        },
        {
            lang: "bi-Bislama",
            langName: "bi-Bislama"
        },
        {
            lang: "bs-Bosnian",
            langName: "bs-Bosnian"
        },
        {
            lang: "br-Breton",
            langName: "br-Breton"
        },
        {
            lang: "bg-Bulgarian",
            langName: "bg-Bulgarian"
        },
        {
            lang: "my-Burmese",
            langName: "my-Burmese"
        },
        {
            lang: "ca-Catalan",
            langName: "ca-Catalan"
        },
        {
            lang: "ch-Chamorro",
            langName: "ch-Chamorro"
        },
        {
            lang: "ce-Chechen",
            langName: "ce-Chechen"
        },
        {
            lang: "ny-Chichewa, Chewa, Nyanja",
            langName: "ny-Chichewa, Chewa, Nyanja"
        },
        {
            lang: "zh-Chinese",
            langName: "zh-Chinese"
        },
        {
            lang: "zh-Hans-Chinese (Simplified)",
            langName: "zh-Hans-Chinese (Simplified)"
        },
        {
            lang: "zh-Hant-Chinese (Traditional)",
            langName: "zh-Hant-Chinese (Traditional)"
        },
        {
            lang: "cv-Chuvash",
            langName: "cv-Chuvash"
        },
        {
            lang: "kw-Cornish",
            langName: "kw-Cornish"
        },
        {
            lang: "co-Corsican",
            langName: "co-Corsican"
        },
        {
            lang: "cr-Cree",
            langName: "cr-Cree"
        },
        {
            lang: "hr-Croatian",
            langName: "hr-Croatian"
        },
        {
            lang: "cs-Czech",
            langName: "cs-Czech"
        },
        {
            lang: "da-Danish",
            langName: "da-Danish"
        },
        {
            lang: "dv-Divehi, Dhivehi, Maldivian",
            langName: "dv-Divehi, Dhivehi, Maldivian"
        },
        {
            lang: "nl-Dutch",
            langName: "nl-Dutch"
        },
        {
            lang: "dz-Dzongkha",
            langName: "dz-Dzongkha"
        },
        {
            lang: "en-English",
            langName: "en-English"
        },
        {
            lang: "eo-Esperanto",
            langName: "eo-Esperanto"
        },
        {
            lang: "et-Estonian",
            langName: "et-Estonian"
        },
        {
            lang: "ee-Ewe",
            langName: "ee-Ewe"
        },
        {
            lang: "fo-Faroese",
            langName: "fo-Faroese"
        },
        {
            lang: "fj-Fijian",
            langName: "fj-Fijian"
        },
        {
            lang: "fi-Finnish",
            langName: "fi-Finnish"
        },
        {
            lang: "fr-French",
            langName: "fr-French"
        },
        {
            lang: "ff-Fula, Fulah, Pulaar, Pular",
            langName: "ff-Fula, Fulah, Pulaar, Pular"
        },
        {
            lang: "gl-Galician",
            langName: "gl-Galician"
        },
        {
            lang: "gd-Gaelic (Scottish)",
            langName: "gd-Gaelic (Scottish)"
        },
        {
            lang: "gv-Gaelic (Manx)",
            langName: "gv-Gaelic (Manx)"
        },
        {
            lang: "ka-Georgian",
            langName: "ka-Georgian"
        },
        {
            lang: "de-German",
            langName: "de-German"
        },
        {
            lang: "el-Greek",
            langName: "el-Greek"
        },
        {
            lang: "kl-Greenlandic",
            langName: "kl-Greenlandic"
        },
        {
            lang: "gn-Guarani",
            langName: "gn-Guarani"
        },
        {
            lang: "gu-Gujarati",
            langName: "gu-Gujarati"
        },
        {
            lang: "ht-Haitian Creole",
            langName: "ht-Haitian Creole"
        },
        {
            lang: "ha-Hausa",
            langName: "ha-Hausa"
        },
        {
            lang: "he-Hebrew",
            langName: "he-Hebrew"
        },
        {
            lang: "hz-Herero",
            langName: "hz-Herero"
        },
        {
            lang: "hi-Hindi",
            langName: "hi-Hindi"
        },
        {
            lang: "ho-Hiri Motu",
            langName: "ho-Hiri Motu"
        },
        {
            lang: "hu-Hungarian",
            langName: "hu-Hungarian"
        },
        {
            lang: "is-Icelandic",
            langName: "is-Icelandic"
        },
        {
            lang: "io-Ido",
            langName: "io-Ido"
        },
        {
            lang: "ig-Igbo",
            langName: "ig-Igbo"
        },
        {
            lang: "in-Indonesian",
            langName: "in-Indonesian"
        },
        {
            lang: "id-Indonesian",
            langName: "id-Indonesian"
        },
        {
            lang: "ia-Interlingua",
            langName: "ia-Interlingua"
        },
        {
            lang: "ie-Interlingue",
            langName: "ie-Interlingue"
        },
        {
            lang: "iu-Inuktitut",
            langName: "iu-Inuktitut"
        },
        {
            lang: "ik-Inupiak",
            langName: "ik-Inupiak"
        },
        {
            lang: "ga-Irish",
            langName: "ga-Irish"
        },
        {
            lang: "it-Italian",
            langName: "it-Italian"
        },
        {
            lang: "ja-Japanese",
            langName: "ja-Japanese"
        },
        {
            lang: "jv-Javanese",
            langName: "jv-Javanese"
        },
        {
            lang: "kl-Kalaallisut, Greenlandic",
            langName: "kl-Kalaallisut, Greenlandic"
        },
        {
            lang: "kn-Kannada",
            langName: "kn-Kannada"
        },
        {
            lang: "kr-Kanuri",
            langName: "kr-Kanuri"
        },
        {
            lang: "ks-Kashmiri",
            langName: "ks-Kashmiri"
        },
        {
            lang: "kk-Kazakh",
            langName: "kk-Kazakh"
        },
        {
            lang: "km-Khmer",
            langName: "km-Khmer"
        },
        {
            lang: "ki-Kikuyu",
            langName: "ki-Kikuyu"
        },
        {
            lang: "rw-Kinyarwanda (Rwanda)",
            langName: "rw-Kinyarwanda (Rwanda)"
        },
        {
            lang: "rn-Kirundi",
            langName: "rn-Kirundi"
        },
        {
            lang: "ky-Kyrgyz",
            langName: "ky-Kyrgyz"
        },
        {
            lang: "kv-Komi",
            langName: "kv-Komi"
        },
        {
            lang: "kg-Kongo",
            langName: "kg-Kongo"
        },
        {
            lang: "ko-Korean",
            langName: "ko-Korean"
        },
        {
            lang: "ku-Kurdish",
            langName: "ku-Kurdish"
        },
        {
            lang: "kj-Kwanyama",
            langName: "kj-Kwanyama"
        },
        {
            lang: "lo-Lao",
            langName: "lo-Lao"
        },
        {
            lang: "la-Latin",
            langName: "la-Latin"
        },
        {
            lang: "lv-Latvian (Lettish)",
            langName: "lv-Latvian (Lettish)"
        },
        {
            lang: "li-Limburgish ( Limburger)",
            langName: "li-Limburgish ( Limburger)"
        },
        {
            lang: "ln-Lingala",
            langName: "ln-Lingala"
        },
        {
            lang: "lt-Lithuanian",
            langName: "lt-Lithuanian"
        },
        {
            lang: "lu-Luga-Katanga",
            langName: "lu-Luga-Katanga"
        },
        {
            lang: "lg-Luganda, Ganda",
            langName: "lg-Luganda, Ganda"
        },
        {
            lang: "lb-Luxembourgish",
            langName: "lb-Luxembourgish"
        },
        {
            lang: "gv-Manx",
            langName: "gv-Manx"
        },
        {
            lang: "mk-Macedonian",
            langName: "mk-Macedonian"
        },
        {
            lang: "mg-Malagasy",
            langName: "mg-Malagasy"
        },
        {
            lang: "ms-Malay",
            langName: "ms-Malay"
        },
        {
            lang: "ml-Malayalam",
            langName: "ml-Malayalam"
        },
        {
            lang: "mt-Maltese",
            langName: "mt-Maltese"
        },
        {
            lang: "mi-Maori",
            langName: "mi-Maori"
        },
        {
            lang: "mr-Marathi",
            langName: "mr-Marathi"
        },
        {
            lang: "mh-Marshallese",
            langName: "mh-Marshallese"
        },
        {
            lang: "mo-Moldavian",
            langName: "mo-Moldavian"
        },
        {
            lang: "mn-Mongolian",
            langName: "mn-Mongolian"
        },
        {
            lang: "na-Nauru",
            langName: "na-Nauru"
        },
        {
            lang: "nv-Navajo",
            langName: "nv-Navajo"
        },
        {
            lang: "ng-Ndonga",
            langName: "ng-Ndonga"
        },
        {
            lang: "nd-Northern Ndebele",
            langName: "nd-Northern Ndebele"
        },
        {
            lang: "ne-Nepali",
            langName: "ne-Nepali"
        },
        {
            lang: "no-Norwegian",
            langName: "no-Norwegian"
        },
        {
            lang: "nb-Norwegian bokm\xe5l",
            langName: "nb-Norwegian bokm\xe5l"
        },
        {
            lang: "nn-Norwegian nynorsk",
            langName: "nn-Norwegian nynorsk"
        },
        {
            lang: "ii-Nuosu",
            langName: "ii-Nuosu"
        },
        {
            lang: "oc-Occitan",
            langName: "oc-Occitan"
        },
        {
            lang: "oj-Ojibwe",
            langName: "oj-Ojibwe"
        },
        {
            lang: "cu-Old Church Slavonic, Old Bulgarian",
            langName: "cu-Old Church Slavonic, Old Bulgarian"
        },
        {
            lang: "or-Oriya",
            langName: "or-Oriya"
        },
        {
            lang: "om-Oromo (Afaan Oromo)",
            langName: "om-Oromo (Afaan Oromo)"
        },
        {
            lang: "os-Ossetian",
            langName: "os-Ossetian"
        },
        {
            lang: "pi-P\u0101li",
            langName: "pi-P\u0101li"
        },
        {
            lang: "ps-Pashto, Pushto",
            langName: "ps-Pashto, Pushto"
        },
        {
            lang: "fa-Persian (Farsi)",
            langName: "fa-Persian (Farsi)"
        },
        {
            lang: "pl-Polish",
            langName: "pl-Polish"
        },
        {
            lang: "pt-Portuguese",
            langName: "pt-Portuguese"
        },
        {
            lang: "pa-Punjabi (Eastern)",
            langName: "pa-Punjabi (Eastern)"
        },
        {
            lang: "qu-Quechua",
            langName: "qu-Quechua"
        },
        {
            lang: "rm-Romansh",
            langName: "rm-Romansh"
        },
        {
            lang: "ro-Romanian",
            langName: "ro-Romanian"
        },
        {
            lang: "ru-Russian",
            langName: "ru-Russian"
        },
        {
            lang: "se-Sami",
            langName: "se-Sami"
        },
        {
            lang: "sm-Samoan",
            langName: "sm-Samoan"
        },
        {
            lang: "sg-Sango",
            langName: "sg-Sango"
        },
        {
            lang: "sa-Sanskrit",
            langName: "sa-Sanskrit"
        },
        {
            lang: "sr-Serbian",
            langName: "sr-Serbian"
        },
        {
            lang: "sh-Serbo-Croatian",
            langName: "sh-Serbo-Croatian"
        },
        {
            lang: "st-Sesotho",
            langName: "st-Sesotho"
        },
        {
            lang: "tn-Setswana",
            langName: "tn-Setswana"
        },
        {
            lang: "sn-Shona",
            langName: "sn-Shona"
        },
        {
            lang: "ii-Sichuan Yi",
            langName: "ii-Sichuan Yi"
        },
        {
            lang: "sd-Sindhi",
            langName: "sd-Sindhi"
        },
        {
            lang: "si-Sinhalese",
            langName: "si-Sinhalese"
        },
        {
            lang: "ss-Siswati",
            langName: "ss-Siswati"
        },
        {
            lang: "sk-Slovak",
            langName: "sk-Slovak"
        },
        {
            lang: "sl-Slovenian",
            langName: "sl-Slovenian"
        },
        {
            lang: "so-Somali",
            langName: "so-Somali"
        },
        {
            lang: "nr-Southern Ndebele",
            langName: "nr-Southern Ndebele"
        },
        {
            lang: "es-Spanish",
            langName: "es-Spanish"
        },
        {
            lang: "su-Sundanese",
            langName: "su-Sundanese"
        },
        {
            lang: "sw-Swahili (Kiswahili)",
            langName: "sw-Swahili (Kiswahili)"
        },
        {
            lang: "ss-Swati",
            langName: "ss-Swati"
        },
        {
            lang: "sv-Swedish",
            langName: "sv-Swedish"
        },
        {
            lang: "tl-Tagalog",
            langName: "tl-Tagalog"
        },
        {
            lang: "ty-Tahitian",
            langName: "ty-Tahitian"
        },
        {
            lang: "tg-Tajik",
            langName: "tg-Tajik"
        },
        {
            lang: "ta-Tamil",
            langName: "ta-Tamil"
        },
        {
            lang: "tt-Tatar",
            langName: "tt-Tatar"
        },
        {
            lang: "te-Telugu",
            langName: "te-Telugu"
        },
        {
            lang: "th-Thai",
            langName: "th-Thai"
        },
        {
            lang: "bo-Tibetan",
            langName: "bo-Tibetan"
        },
        {
            lang: "ti-Tigrinya",
            langName: "ti-Tigrinya"
        },
        {
            lang: "to-Tonga",
            langName: "to-Tonga"
        },
        {
            lang: "ts-Tsonga",
            langName: "ts-Tsonga"
        },
        {
            lang: "tr-Turkish",
            langName: "tr-Turkish"
        },
        {
            lang: "tk-Turkmen",
            langName: "tk-Turkmen"
        },
        {
            lang: "tw-Twi",
            langName: "tw-Twi"
        },
        {
            lang: "ug-Uyghur",
            langName: "ug-Uyghur"
        },
        {
            lang: "uk-Ukrainian",
            langName: "uk-Ukrainian"
        },
        {
            lang: "ur-Urdu",
            langName: "ur-Urdu"
        },
        {
            lang: "uz-Uzbek",
            langName: "uz-Uzbek"
        },
        {
            lang: "ve-Venda",
            langName: "ve-Venda"
        },
        {
            lang: "vi-Vietnamese",
            langName: "vi-Vietnamese"
        },
        {
            lang: "vo-Volap\xfck",
            langName: "vo-Volap\xfck"
        },
        {
            lang: "wa-Wallon",
            langName: "wa-Wallon"
        },
        {
            lang: "cy-Welsh",
            langName: "cy-Welsh"
        },
        {
            lang: "wo-Wolof",
            langName: "wo-Wolof"
        },
        {
            lang: "fy-Western Frisian",
            langName: "fy-Western Frisian"
        },
        {
            lang: "xh-Xhosa",
            langName: "xh-Xhosa"
        },
        {
            lang: "yi-Yiddish",
            langName: "yi-Yiddish"
        },
        {
            lang: "yo-Yoruba",
            langName: "yo-Yoruba"
        },
        {
            lang: "za-Zhuang, Chuang",
            langName: "za-Zhuang, Chuang"
        },
        {
            lang: "zu-Zulu",
            langName: "zu-Zulu"
        }
    ];
    const [addForm, setAddForm] = $8FY87.useState({
        from: "",
        to: ""
    });
    const [redirects, setRedirects] = $8FY87.useState(props.redirects ?? []);
    $8FY87.useEffect(()=>{
        setRedirects(props.redirects);
    }, [
        props.redirects
    ]);
    const onAddRedirect = ()=>{
        // console.log('onAddRedirect', addForm);
        const from = addForm.from;
        const to = addForm.to;
        if (redirects.find((r)=>r.from === from)) return enqueueSnackbar("Redirect already exists", {
            variant: "error"
        });
        if (from === to) return enqueueSnackbar("Redirect From and To can't be same", {
            variant: "error"
        });
        const redirectsCopy = JSON.parse(JSON.stringify(redirects));
        redirectsCopy.push({
            from: from,
            to: to
        });
        setRedirects(redirectsCopy);
        setAddForm({
            from: "",
            to: ""
        });
        props.onDataChange({
            redirects: redirectsCopy
        });
    };
    const onChangeRedirect = (idx, value, field)=>{
        const redirectsCopy = JSON.parse(JSON.stringify(redirects));
        redirectsCopy[idx][field] = value;
        setRedirects(redirectsCopy);
        // setting error if same value for redirect from
        validateErrors(redirectsCopy);
        props.onDataChange({
            redirects: redirectsCopy
        });
    };
    const validateErrors = (redirectsCopy)=>{
        const redirectsFrom = {};
        redirectsCopy.forEach((r)=>{
            if (!redirectsFrom[r.from]) redirectsFrom[r.from] = 0;
            redirectsFrom[r.from]++;
        });
        redirectsCopy.forEach((r)=>{
            if (redirectsFrom[r.from] > 1) r.error = "duplicate";
            else if (r.from === r.to) r.error = "same";
            else delete r.error;
        });
        redirectsCopy.filter((r)=>r.error).length > 0 ? props.setSaveDisabled(true) : props.setSaveDisabled(false);
    };
    const onRemoveRedirect = (idx)=>{
        const redirectsCopy = JSON.parse(JSON.stringify(redirects));
        redirectsCopy.splice(idx, 1);
        setRedirects(redirectsCopy);
        validateErrors(redirectsCopy);
        props.onDataChange({
            redirects: redirectsCopy
        });
    };
    return /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col text-black left-sidebar-seo"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col"
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-base-2 mb-2"
    }, "Primary language"), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "font-normal mb-2"
    }, "This language will be the default language of your website."), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-row"
    }, /*#__PURE__*/ $8FY87.createElement((0, $1587b7eed37887b9$export$2e2bcd8739ae039), {
        sx: {
            maxWidth: "100%",
            width: "100%"
        },
        size: "small"
    }, /*#__PURE__*/ $8FY87.createElement((0, $5fa08250992d1a88$export$2e2bcd8739ae039), {
        id: "language-select",
        value: props.primaryLanguage,
        onChange: (e)=>{
            // setSelectedLang(e.target.value)
            // console.log(e.target.value);
            props.onDataChange({
                primaryLanguage: e.target.value
            });
        },
        className: "w-full md:w-80 text-sm lang-selector"
    }, languages.map((row)=>{
        return /*#__PURE__*/ $8FY87.createElement((0, $ee9f19037253b32c$export$2e2bcd8739ae039), {
            key: row.lang,
            className: "text-sm site-lang",
            value: row.lang
        }, row.langName);
    }))))), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "py-8"
    }, /*#__PURE__*/ $8FY87.createElement((0, $30a538faf9a95dbb$export$2e2bcd8739ae039), null)), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col"
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-base-2 mb-2"
    }, "301 Redirects (URL mapping)"), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "overflow-x-auto"
    }, /*#__PURE__*/ $8FY87.createElement("table", {
        className: "w-full border-collapse font-body rounded bg-white mb-2"
    }, /*#__PURE__*/ $8FY87.createElement("thead", null, /*#__PURE__*/ $8FY87.createElement("tr", null, /*#__PURE__*/ $8FY87.createElement("th", {
        className: "text-left w-2/5 min-w-[200px] px-2 py-1 border text-base"
    }, "Redirect From"), /*#__PURE__*/ $8FY87.createElement("th", {
        className: "text-left w-2/5 min-w-[200px] px-2 py-1 border text-base"
    }, "Redirect To"), /*#__PURE__*/ $8FY87.createElement("th", {
        className: "text-center w-1/5 min-w-[150px] px-2 py-1 border text-base"
    }, "Action"))), /*#__PURE__*/ $8FY87.createElement("tbody", null, /*#__PURE__*/ $8FY87.createElement("tr", null, /*#__PURE__*/ $8FY87.createElement("td", {
        className: "text-left px-2 py-1 border text-xsm"
    }, /*#__PURE__*/ $8FY87.createElement((0, $3247b0fca8a83d17$export$2e2bcd8739ae039), {
        value: addForm.from,
        className: "w-full border rounded border-catelina-blue/60 py-1 px-2 text-base",
        placeholder: "abc",
        onChange: (e)=>setAddForm({
                ...addForm,
                from: (0, $df5cb81582703dc6$export$2e2bcd8739ae039)(e.target.value)
            }),
        startAdornment: "/",
        size: "small",
        disableUnderline: true
    })), /*#__PURE__*/ $8FY87.createElement("td", {
        className: "text-left px-2 py-1 border text-xsm"
    }, /*#__PURE__*/ $8FY87.createElement((0, $3247b0fca8a83d17$export$2e2bcd8739ae039), {
        value: addForm.to,
        className: "w-full border rounded border-catelina-blue/60 py-1 px-2 text-base",
        placeholder: "xyz",
        onChange: (e)=>setAddForm({
                ...addForm,
                to: (0, $df5cb81582703dc6$export$2e2bcd8739ae039)(e.target.value)
            }),
        startAdornment: "/",
        size: "small",
        disableUnderline: true
    })), /*#__PURE__*/ $8FY87.createElement("td", null, /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        id: "add",
        className: "w-11/12 py-1",
        sx: {
            textTransform: "none"
        },
        variant: "contained",
        onClick: (e)=>onAddRedirect()
    }, "Add"))), redirects.map((row, idx)=>{
        return /*#__PURE__*/ $8FY87.createElement("tr", {
            key: idx
        }, /*#__PURE__*/ $8FY87.createElement("td", {
            className: "text-left px-2 py-1 border text-xsm"
        }, /*#__PURE__*/ $8FY87.createElement((0, $3247b0fca8a83d17$export$2e2bcd8739ae039), {
            value: row.from,
            className: `w-full border rounded border-catelina-blue/60 py-1 px-2 text-base ${!!redirects[idx].error ? "border-red-600" : ""}`,
            onChange: (e)=>onChangeRedirect(idx, e.target.value, "from"),
            startAdornment: "/",
            size: "small",
            disableUnderline: true,
            error: true
        })), /*#__PURE__*/ $8FY87.createElement("td", {
            className: "text-left px-2 py-1 border text-xsm"
        }, /*#__PURE__*/ $8FY87.createElement((0, $3247b0fca8a83d17$export$2e2bcd8739ae039), {
            value: row.to,
            className: `w-full border rounded border-catelina-blue/60 py-1 px-2 text-base ${redirects[idx].error === "same" ? "border-red-600" : ""}`,
            onChange: (e)=>onChangeRedirect(idx, e.target.value, "to"),
            startAdornment: "/",
            size: "small",
            disableUnderline: true
        })), /*#__PURE__*/ $8FY87.createElement("td", null, /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
            id: "delete",
            color: "error",
            className: "w-11/12 py-1",
            sx: {
                textTransform: "none"
            },
            variant: "outlined",
            onClick: (e)=>onRemoveRedirect(idx)
        }, "Remove")));
    }))), redirects.filter((r)=>r.error === "duplicate").length > 0 && /*#__PURE__*/ $8FY87.createElement("p", {
        className: "font-normal mb-2 text-red-600"
    }, "Please remove DUPLICATE redirects."), redirects.filter((r)=>r.error === "same").length > 0 && /*#__PURE__*/ $8FY87.createElement("p", {
        className: "font-normal mb-2 text-red-600"
    }, "Redirect FROM and TO can't be same."))), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "py-8"
    }, /*#__PURE__*/ $8FY87.createElement((0, $30a538faf9a95dbb$export$2e2bcd8739ae039), null)), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col"
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-base-2 mb-2"
    }, "The sitemap.xml file URL"), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "font-normal mb-2"
    }, "The file is used by search engines. The file is auto-generated by RocketPages. We also auto-update when you create and publish a new page, delete or edit a page."), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-row"
    }, /*#__PURE__*/ $8FY87.createElement("input", {
        disabled: true,
        className: "w-full md:w-64 border rounded border-catelina-blue/60 py-1 px-2",
        // placeholder="<script src=”https;//www.googletagmanager.com/gtag/js?id=UA-XXX-X”></script>"
        value: "sitemap.xml"
    }))), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "py-8"
    }, /*#__PURE__*/ $8FY87.createElement((0, $30a538faf9a95dbb$export$2e2bcd8739ae039), null)), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col"
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-base-2 mb-2"
    }, "The robots.txt file URL:"), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "font-normal mb-2"
    }, "The file is used by search engines. The file is autogenerated by RocketPages and you can not change it"), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-row"
    }, /*#__PURE__*/ $8FY87.createElement("input", {
        disabled: true,
        className: "w-full md:w-64 border rounded border-catelina-blue/60 py-1 px-2",
        // placeholder="<script src=”https;//www.googletagmanager.com/gtag/js?id=UA-XXX-X”></script>"
        value: "robots.txt"
    }))));
};
var $fb6c4742a3f9e788$export$2e2bcd8739ae039 = $fb6c4742a3f9e788$var$ConfigSEO;




var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");

var $8FY87 = parcelRequire("8FY87");




var $2PPWI = parcelRequire("2PPWI");
'use client';
const $3f17f2e6226395e3$var$_excluded = [
    "children"
];
const $3f17f2e6226395e3$var$TabList = /*#__PURE__*/ $8FY87.forwardRef(function TabList(props, ref) {
    const { children: childrenProp } = props, other = (0, $93aRW.default)(props, $3f17f2e6226395e3$var$_excluded);
    const context = (0, $65ede3c1fb83823f$export$5a3bad273ac578e0)();
    if (context === null) throw new TypeError('No TabContext provided');
    const children = $8FY87.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ $8FY87.isValidElement(child)) return null;
        return /*#__PURE__*/ $8FY87.cloneElement(child, {
            // SOMEDAY: `Tabs` will set those themselves
            'aria-controls': (0, $65ede3c1fb83823f$export$629f80328afcade5)(context, child.props.value),
            id: (0, $65ede3c1fb83823f$export$46f6d19d28231cb8)(context, child.props.value)
        });
    });
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $0181e7500204b60c$export$2e2bcd8739ae039), (0, $zgVxD.default)({}, other, {
        ref: ref,
        value: context.value,
        children: children
    }));
});
var $3f17f2e6226395e3$export$2e2bcd8739ae039 = $3f17f2e6226395e3$var$TabList;






var $8FY87 = parcelRequire("8FY87");








var $8FY87 = parcelRequire("8FY87");






var $8FY87 = parcelRequire("8FY87");

const $82d9265716822da0$var$SubscriptionCard = (props)=>{
    const { enqueueSnackbar: enqueueSnackbar } = (0, $5e19452f9528802f$export$1c97ac2c9a6e7c09)();
    const [isCreatingUrl, setIsCreatingUrl] = $8FY87.useState(false);
    //   console.log("SubscriptionCard", props);
    const s_start = new Date(props.data.subscription_start * 1000);
    const s_end = new Date(props.data.subscription_end * 1000);
    const getStripeCustomerPortalUrl = async ()=>{
        setIsCreatingUrl(true);
        let response = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).get(`/api/configs/site-config-get-stripe-customer-session?siteId=${props.data.siteId}&subscriptionId=${props.data.subscriptionId}`);
        // console.log("getStripeCustomerPortalUrl", response.data);
        setIsCreatingUrl(false);
        if (response.data.error) return enqueueSnackbar(response.data.error, {
            variant: "error",
            autoHideDuration: 9000
        });
        window.location.href = response.data.url;
    };
    return /*#__PURE__*/ $8FY87.createElement("div", null, props.data.subscription_status !== 'past_due' && /*#__PURE__*/ $8FY87.createElement("div", {
        className: "mt-4 flex justify-end"
    }, /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        className: "shadow-none mr-2 rounded-md",
        disabled: props.data.subscription_status === "canceled" || isCreatingUrl || props.isCancelling || props.data.cancel_at_period_end && !props.upcomingPhase,
        size: "large",
        variant: "contained",
        color: "primary",
        onClick: ()=>getStripeCustomerPortalUrl()
    }, /*#__PURE__*/ $8FY87.createElement((0, $9e9a2c609bdcf2f0$export$2e2bcd8739ae039), {
        textTransform: "capitalize"
    }, "Update payment method")), /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        className: "shadow-none rounded-md bg-red-600",
        disabled: props.data.subscription_status === "canceled" || props.isCancelling || props.data.cancel_at_period_end && !props.upcomingPhase,
        size: "large",
        variant: "contained",
        color: "error",
        onClick: ()=>props.onCancel(props.data.subscription)
    }, /*#__PURE__*/ $8FY87.createElement((0, $9e9a2c609bdcf2f0$export$2e2bcd8739ae039), {
        textTransform: "capitalize"
    }, "Cancel Subscription"))), /*#__PURE__*/ $8FY87.createElement("h4", {
        className: "font-bold mb-2 mt-0"
    }, "Active Plan"), /*#__PURE__*/ $8FY87.createElement("div", {
        className: `bg-white border border-[#E1E4EF] p-4 rounded-md`
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "grid grid-cols-1 gap-2 xl:grid-cols-2 text-xsm sm:text-sm"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col sm:flex-row"
    }, /*#__PURE__*/ $8FY87.createElement("p", {
        className: "text-gray-600 mb-0 w-full sm:w-2/5"
    }, "Subscription ID:"), /*#__PURE__*/ $8FY87.createElement("p", {
        className: "font-semibold mb-0 w-full sm:w-3/5 text-grey-primary"
    }, props.data.subscriptionId)), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col sm:flex-row"
    }, /*#__PURE__*/ $8FY87.createElement("p", {
        className: "text-gray-600 mb-0 w-full sm:w-2/5"
    }, "Subscription Status:"), /*#__PURE__*/ $8FY87.createElement("p", {
        className: "font-semibold mb-0 w-full sm:w-3/5" + (props.data.subscription_status === 'past_due' ? ' text-red-600 font-semibold' : ' text-lime-600 font-semibold capitalize')
    }, props.data.subscription_status === 'past_due' ? 'Pending' : props.data.subscription_status)), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col sm:flex-row"
    }, /*#__PURE__*/ $8FY87.createElement("p", {
        className: "text-gray-600 mb-0 w-full sm:w-2/5"
    }, "Plan:"), /*#__PURE__*/ $8FY87.createElement("p", {
        className: "font-semibold mb-0 w-full sm:w-3/5 text-grey-primary"
    }, props.data.plan_desc)), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col sm:flex-row"
    }, /*#__PURE__*/ $8FY87.createElement("p", {
        className: "text-gray-600 mb-0 w-full sm:w-2/5"
    }, "Price:"), /*#__PURE__*/ $8FY87.createElement("p", {
        className: "font-semibold mb-0 w-full sm:w-3/5 text-grey-primary"
    }, "$", props.data.amount_total / 100)), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col sm:flex-row"
    }, /*#__PURE__*/ $8FY87.createElement("p", {
        className: "text-gray-600 mb-0 w-full sm:w-2/5"
    }, "Start Date:"), /*#__PURE__*/ $8FY87.createElement("p", {
        className: "font-semibold mb-0 w-full sm:w-3/5 text-grey-primary"
    }, s_start.toLocaleDateString("en-GB"))), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col sm:flex-row"
    }, /*#__PURE__*/ $8FY87.createElement("p", {
        className: "text-gray-600 mb-0 w-full sm:w-2/5"
    }, props.data.cancel_at_period_end || props.data.subscription_status === "canceled" || props.upcomingPhase ? 'End' : 'Renew', " Date:"), /*#__PURE__*/ $8FY87.createElement("p", {
        className: "font-semibold mb-0 w-full sm:w-3/5 text-grey-primary"
    }, s_end.toLocaleDateString("en-GB")))), props.data.subscription_status === 'past_due' && /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col items-center lg:flex-row justify-between mt-6"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "bg-[#E1E4EF] rounded p-2 mb-0 flex items-center"
    }, /*#__PURE__*/ $8FY87.createElement("p", {
        className: "text-sm mb-0 flex items-center text-red-600  flex-wrap md:flex-noWrap"
    }, /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($80cdb5096bdf46ee$exports))), {
        className: "mr-1 text-red-600",
        style: {
            fontSize: 20
        }
    }), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "font-semibold"
    }, "Transaction incomplete:"), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-grey-primary ml-1 font-norma text-red-600"
    }, "Please complete your current plan's payment to activate the features of this plan."))), /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        className: "shadow-none ml-2 lg:mt-0 mt-2",
        disabled: !props.latestInvoice,
        size: "large",
        variant: "contained",
        color: "primary",
        onClick: ()=>window.open(props.latestInvoice.hosted_invoice_url, '_blank')
    }, /*#__PURE__*/ $8FY87.createElement((0, $9e9a2c609bdcf2f0$export$2e2bcd8739ae039), {
        textTransform: "capitalize"
    }, "Pay Now")))));
};
var $82d9265716822da0$export$2e2bcd8739ae039 = $82d9265716822da0$var$SubscriptionCard;






const $534c8c85b4abece7$var$ConfigActivePlans = (props)=>{
    const { enqueueSnackbar: enqueueSnackbar } = (0, $5e19452f9528802f$export$1c97ac2c9a6e7c09)();
    const { id: id } = (0, $d5fb2d3e42b0c581$export$99eaa27ddbbb95ef)();
    const [showConfirmation, setShowConfirmation] = $8FY87.useState(false);
    const [showPlanSwitchConfirmation, setShowPlanSwitchConfirmation] = $8FY87.useState(false);
    const [isCancelling, setIsCancelling] = $8FY87.useState(false);
    const handleDelete = ()=>{
        onCancelSubs(props.activeSub.subscriptionId); // Call the delete function passed as a prop
        setShowConfirmation(false); // Close the confirmation dialog after delete
    };
    const onCancelSubs = async (subsId)=>{
        setIsCancelling(true);
        // console.log('onCancelSubs', subsId);
        let l_data = {
            siteId: id,
            subscriptionId: subsId
        };
        let rs = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).put("/api/configs/site-config-cancel-subscription", l_data);
        // console.log("api cancel res", rs.data);
        if (!rs.data.error && rs.data.status && rs.data.subscription.cancel_at_period_end) {
            enqueueSnackbar("Subscription cancelled successfully.", {
                variant: "success",
                className: "bg-catelina-blue"
            });
            setIsCancelling(false);
            props.reFetch();
        } else if (rs.data.error) {
            enqueueSnackbar("Something went wrong while cancelling subscription", {
                variant: "error",
                autoHideDuration: 9000
            });
            setIsCancelling(false);
        }
    // console.log("api cancel res", rs);
    };
    const onCancelUpcomingSubs = async ()=>{
        setShowPlanSwitchConfirmation(false);
        setIsCancelling(true);
        // console.log('onCancelSubs', props.activeSub.subscriptionId);
        let l_data = {
            siteId: id,
            subscriptionId: props.activeSub.subscriptionId
        };
        let rs = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).put("/api/configs/site-config-cancel-upcoming-subscription", l_data);
        // console.log("api cancel res", rs.data);
        if (!rs.data.error && rs.data.subscription) {
            enqueueSnackbar("Upcoming Subscription cancelled successfully.", {
                variant: "success",
                className: "bg-catelina-blue"
            });
            setIsCancelling(false);
            props.reFetch();
        } else if (rs.data.error) {
            enqueueSnackbar(rs.data.error ?? "Something went wrong while cancelling upcoming subscription", {
                variant: "error",
                autoHideDuration: 9000
            });
            setIsCancelling(false);
        }
    // console.log("api cancel res", rs);
    };
    return /*#__PURE__*/ $8FY87.createElement("div", {
        className: "config-active-plan flex flex-col justify-center items-left w-full"
    }, showConfirmation && /*#__PURE__*/ $8FY87.createElement("div", {
        className: "fixed inset-0 overflow-y-auto flex justify-center items-center z-10"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "fixed inset-0"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "absolute inset-0 bg-gray-500 opacity-75"
    })), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "bg-white rounded py-8 py-8 md:px-16 m-4 z-50 flex items-center flex-col relative"
    }, /*#__PURE__*/ $8FY87.createElement("img", {
        src: (parcelRequire("dYuXF")),
        className: "absolute right-2 top-2 cursor-pointer",
        onClick: ()=>setShowConfirmation(false)
    }), /*#__PURE__*/ $8FY87.createElement("img", {
        src: (parcelRequire("bmaA8")),
        className: "mb-2"
    }), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-gray-800 mb-0"
    }, "Are you sure you want to cancel subscription?"), /*#__PURE__*/ $8FY87.createElement("span", null, "This action will take effect at the end of your current billing cycle, and you will lose access to all features that comes with it."), !!props.upcomingPhase && /*#__PURE__*/ $8FY87.createElement("span", {
        className: "font-semibold text-black"
    }, "This will also cancel upcoming plans immediately."), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex justify-end flex-col sm:flex-row mt-6"
    }, /*#__PURE__*/ $8FY87.createElement("button", {
        className: "bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline",
        onClick: handleDelete
    }, "Confirm Cancel")))), showPlanSwitchConfirmation && /*#__PURE__*/ $8FY87.createElement("div", {
        className: "fixed inset-0 overflow-y-auto flex justify-center items-center z-10"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "fixed inset-0"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "absolute inset-0 bg-gray-500 opacity-75"
    })), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "bg-white mx-w-xl rounded py-8 px-8 md:px-16  m-4 z-50 flex items-center flex-col relative"
    }, /*#__PURE__*/ $8FY87.createElement("img", {
        src: (parcelRequire("dYuXF")),
        className: "absolute right-2 top-2 cursor-pointer",
        onClick: ()=>setShowPlanSwitchConfirmation(false)
    }), /*#__PURE__*/ $8FY87.createElement("img", {
        src: (parcelRequire("bmaA8"))
    }), /*#__PURE__*/ $8FY87.createElement("h4", {
        className: "mb-4"
    }, "Cancel upcoming subscription"), /*#__PURE__*/ $8FY87.createElement("p", {
        className: "text-gray-800 mb-3 text-center"
    }, "Are you sure you want to cancel upcoming subscription and stay on current active one?"), /*#__PURE__*/ $8FY87.createElement("p", {
        className: "text-center mb-4 text-grey-primary font-normal w-2/3"
    }, "This action will take effect immediately."), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex justify-end flex-col sm:flex-row"
    }, /*#__PURE__*/ $8FY87.createElement("button", {
        className: "rounded-md bg-red-600 hover:bg-red-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline",
        onClick: onCancelUpcomingSubs
    }, "Confirm Cancel")))), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "w-full flex flex-col"
    }, props.isLoading && /*#__PURE__*/ $8FY87.createElement("div", {
        className: "bg-white border rounded-lg shadow-md p-4 w-full h-64 flex flex-col justify-center text-center"
    }, /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5e92c14e843d6937$exports))), {
        className: "self-center mb-2"
    }), /*#__PURE__*/ $8FY87.createElement("h3", {
        className: "text-xl font-bold mb-0 mt-0"
    }, "Fetching Subscriptions...")), !props.isLoading && !props.activeSub && /*#__PURE__*/ $8FY87.createElement("div", {
        className: "bg-white border rounded-lg shadow-md p-4 w-full h-64 flex flex-col justify-center text-center"
    }, /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5e92c14e843d6937$exports))), {
        className: "self-center mb-2"
    }), /*#__PURE__*/ $8FY87.createElement("h3", {
        className: "text-xl font-bold mb-0 mt-0"
    }, "No active subscription found")), !props.isLoading && /*#__PURE__*/ $8FY87.createElement("div", {
        className: "w-full"
    }, props.activeSub && /*#__PURE__*/ $8FY87.createElement((0, $82d9265716822da0$export$2e2bcd8739ae039), {
        data: props.activeSub,
        upcomingPhase: props.upcomingPhase,
        latestInvoice: props.latestInvoice,
        isCancelling: isCancelling,
        onCancel: (subId)=>{
            setShowConfirmation(true);
        }
    }), props.upcomingPhase && /*#__PURE__*/ $8FY87.createElement("div", null, /*#__PURE__*/ $8FY87.createElement("h4", {
        className: "mb-2"
    }, "Upcoming Plan"), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "bg-white border border-[#E1E4EF] p-4 rounded-md"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex sm:items-center items-start justify-between flex-col sm:flex-row mb-2 sm:mb-0"
    }, /*#__PURE__*/ $8FY87.createElement("p", {
        className: "font-bold mb-0.5 text-grey-primary"
    }, props.upcomingPhase.selectedPlan?.plan, " (", props.upcomingPhase.selectedPlan?.duration, "ly)"), /*#__PURE__*/ $8FY87.createElement("p", {
        className: "font-bold mb-0.5 text-grey-primary"
    }, "$", props.upcomingPhase.selectedPlan?.price, "/site/", props.upcomingPhase.selectedPlan?.duration)), /*#__PURE__*/ $8FY87.createElement("p", {
        className: "mb-1 font-normal"
    }, "Valid for 1 ", props.upcomingPhase.selectedPlan?.duration), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex justify-between mt-6 flex-col lg:flex-row"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "bg-[#E1E4EF] rounded p-2 mb-0 flex items-center"
    }, /*#__PURE__*/ $8FY87.createElement("p", {
        className: "text-sm mb-0 flex items-center text-catelina-blue  flex-wrap md:flex-noWrap"
    }, /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($80cdb5096bdf46ee$exports))), {
        className: "mr-1",
        style: {
            fontSize: 20
        }
    }), "Attention:", /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-grey-primary ml-1 font-normal"
    }, "Your upcoming ", props.upcomingPhase.selectedPlan?.plan, " ", "(", props.upcomingPhase.selectedPlan?.duration, "ly) plan will be auto-updated post current plan expires."))), /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        className: "shadow-none lg:mt-0 mt-2 rounded-md bg-red-600 lg:ml-2",
        disabled: isCancelling,
        size: "large",
        variant: "contained",
        color: "error",
        onClick: ()=>setShowPlanSwitchConfirmation(true)
    }, /*#__PURE__*/ $8FY87.createElement((0, $9e9a2c609bdcf2f0$export$2e2bcd8739ae039), {
        textTransform: "capitalize"
    }, "Cancel", " ", props.activeSub.amount_total / 100 > props.upcomingPhase.selectedPlan.price ? "Downgrade" : "Upgrade"))))))));
};
var $534c8c85b4abece7$export$2e2bcd8739ae039 = $534c8c85b4abece7$var$ConfigActivePlans;




const $2d8a03adb139f410$var$plans = [
    {
        plan: "Forever Free",
        duration: "month",
        price: 0,
        priceId: ""
    },
    {
        plan: "Forever Free",
        duration: "year",
        price: 0,
        priceId: ""
    },
    {
        plan: "Pro",
        duration: "month",
        price: 1.99,
        priceId: "price_1Pvf51H46TpgZNWblJh02txG"
    },
    {
        plan: "Pro",
        duration: "year",
        price: 9.99,
        priceId: "price_1Pvf6PH46TpgZNWbw1eLDIwX"
    },
    {
        plan: "Business",
        duration: "month",
        price: 14.99,
        priceId: "price_1PvfACH46TpgZNWbedRmHjX2"
    },
    {
        plan: "Business",
        duration: "year",
        price: 99.99,
        priceId: "price_1Pvf9TH46TpgZNWbRUkC8Lhd"
    }
];
const $2d8a03adb139f410$var$ConfigSubscriptions = (props)=>{
    const { search: search } = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)();
    const query = $8FY87.useMemo(()=>new URLSearchParams(search), [
        search
    ]);
    const l_activeTab = query.get("activeTab");
    const [currentTab, setCurrentTab] = $8FY87.useState(props.defTab === "pricing" || l_activeTab === "pricing" ? "3" : "1");
    const [isLoading, setIsLoading] = $8FY87.useState(true);
    const [isLoadingInvoices, setIsLoadingInvoices] = $8FY87.useState(true);
    const [invoices, setInvoices] = $8FY87.useState([]);
    const [latestInvoice, setLatestInvoice] = $8FY87.useState();
    const [allSubs, setAllSubs] = $8FY87.useState([]);
    const [activeSub, setActiveSub] = $8FY87.useState();
    const [upcomingPhase, setUpcomingPhase] = $8FY87.useState();
    const { id: id } = (0, $d5fb2d3e42b0c581$export$99eaa27ddbbb95ef)();
    const [cookies] = (0, $1f373de1ceea6eb7$export$2e2bcd8739ae039)([
        "rp_user_data"
    ]);
    const isQATeam = false;
    if (isQATeam) {
        if (!$2d8a03adb139f410$var$plans.find((plan)=>plan.plan === "QA Only")) $2d8a03adb139f410$var$plans.push({
            plan: "QA Only",
            duration: "month",
            price: 1.0,
            priceId: "price_1SmpYWH46TpgZNWb8pBg8EoV"
        }, {
            plan: "QA Only",
            duration: "year",
            price: 1.0,
            priceId: "price_1SmpYWH46TpgZNWb8pBg8EoV"
        });
    }
    // React.useEffect(() => {
    //   console.log("node env", process.env.NODE_ENV)
    // },[])
    async function getAllSubscriptions() {
        try {
            setIsLoading(true);
            setIsLoadingInvoices(true);
            let res = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).get(`/api/configs/site-config-get-subscriptions?siteId=${id}`);
            // console.log("getAllSubscriptions", res.data.data);
            setAllSubs(res.data.data);
            const activeSubscription = res.data.data.find((sub)=>sub.subscription_status !== "canceled");
            if (activeSubscription) activeSubscription.selectedPlan = $2d8a03adb139f410$var$plans.find((plan)=>plan.priceId === activeSubscription.plan_id);
            setActiveSub(activeSubscription);
            let upcomingPlan;
            if (activeSubscription?.scheduleData && activeSubscription.scheduleData.phases?.length > 1) {
                const upcomingSubPhase = activeSubscription.scheduleData.phases.find((phase)=>phase.start_date > Date.now() / 1000);
                // const upcomingSubPhase = activeSubscription.scheduleData.phases[1];
                if (upcomingSubPhase) {
                    upcomingSubPhase.selectedPlan = $2d8a03adb139f410$var$plans.find((plan)=>plan.priceId === upcomingSubPhase.items[0].price);
                    upcomingPlan = upcomingSubPhase;
                }
            }
            setUpcomingPhase(upcomingPlan);
            setIsLoading(false);
            let subscriptions = [];
            res.data.data.forEach((row)=>{
                subscriptions.push(row.subscriptionId);
            });
            if (!subscriptions.length) {
                setIsLoadingInvoices(false);
                return;
            }
            let resInvoices = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post(`/api/configs/site-config-get-invoices`, {
                subscriptions: subscriptions
            });
            // console.log("getAllSubscriptions", resInvoices.data.data);
            setInvoices(resInvoices.data.data);
            if (activeSubscription) setLatestInvoice(resInvoices.data.data.filter((invoice)=>invoice.subscription === activeSubscription.subscriptionId).sort((a, b)=>b.created - a.created)[0]);
            setIsLoadingInvoices(false);
        } catch (err) {
            console.log(err);
            setIsLoading(false);
        }
    }
    $8FY87.useEffect(()=>{
        // setLoggedUserData(JSON.parse(cookies.rp_user_data))
        getAllSubscriptions();
    }, []);
    return /*#__PURE__*/ $8FY87.createElement((0, $b19176bd78e1869f$export$2e2bcd8739ae039), {
        className: "left-sidebar-subscription"
    }, /*#__PURE__*/ $8FY87.createElement((0, $65ede3c1fb83823f$export$2e2bcd8739ae039), {
        value: currentTab
    }, /*#__PURE__*/ $8FY87.createElement((0, $b19176bd78e1869f$export$2e2bcd8739ae039), {
        sx: {
            borderBottom: 1,
            borderColor: "divider"
        }
    }, /*#__PURE__*/ $8FY87.createElement((0, $3f17f2e6226395e3$export$2e2bcd8739ae039), {
        onChange: (e, newValue)=>setCurrentTab(newValue),
        "aria-label": "lab API tabs example",
        className: "subscription-tab-list"
    }, /*#__PURE__*/ $8FY87.createElement((0, $e7d54e7d83e3c56c$export$2e2bcd8739ae039), {
        label: "My Plan(s)",
        value: "1"
    }), /*#__PURE__*/ $8FY87.createElement((0, $e7d54e7d83e3c56c$export$2e2bcd8739ae039), {
        label: "Invoices",
        value: "2"
    }), /*#__PURE__*/ $8FY87.createElement((0, $e7d54e7d83e3c56c$export$2e2bcd8739ae039), {
        label: "Pricing Plans",
        value: "3"
    }))), /*#__PURE__*/ $8FY87.createElement((0, $0b35694b79d42e6e$export$2e2bcd8739ae039), {
        style: {
            paddingLeft: 0,
            paddingRight: 0
        },
        value: "1"
    }, /*#__PURE__*/ $8FY87.createElement((0, $534c8c85b4abece7$export$2e2bcd8739ae039), {
        isLoading: isLoading,
        setIsLoading: setIsLoading,
        activeSub: activeSub,
        updateActiveSub: setActiveSub,
        reFetch: getAllSubscriptions,
        upcomingPhase: upcomingPhase,
        latestInvoice: latestInvoice
    })), /*#__PURE__*/ $8FY87.createElement((0, $0b35694b79d42e6e$export$2e2bcd8739ae039), {
        style: {
            paddingLeft: 0,
            paddingRight: 0
        },
        value: "2"
    }, /*#__PURE__*/ $8FY87.createElement((0, $ef77c9de594ee7e7$export$2e2bcd8739ae039), {
        isLoading: isLoadingInvoices,
        invoices: invoices
    })), /*#__PURE__*/ $8FY87.createElement((0, $0b35694b79d42e6e$export$2e2bcd8739ae039), {
        style: {
            paddingLeft: 0,
            paddingRight: 0
        },
        value: "3"
    }, /*#__PURE__*/ $8FY87.createElement((0, $8813eb74b0ee98c8$export$2e2bcd8739ae039), {
        id: id,
        plans: $2d8a03adb139f410$var$plans,
        isLoading: isLoading,
        setIsLoading: setIsLoading,
        activeSub: activeSub,
        updateActiveSub: setActiveSub,
        reFetch: getAllSubscriptions,
        upcomingPhase: upcomingPhase
    }))));
};
var $2d8a03adb139f410$export$2e2bcd8739ae039 = $2d8a03adb139f410$var$ConfigSubscriptions;



var $8FY87 = parcelRequire("8FY87");


var $8FY87 = parcelRequire("8FY87");
var $bb2c8b52dc31f705$exports = {};
'use strict';
Object.defineProperty($bb2c8b52dc31f705$exports, "__esModule", {
    value: true
});
$bb2c8b52dc31f705$exports.ReactCSS = $bb2c8b52dc31f705$exports.loop = $bb2c8b52dc31f705$exports.handleActive = $bb2c8b52dc31f705$exports.handleHover = $bb2c8b52dc31f705$exports.hover = undefined;
var $01ae635f2c5f2675$exports = {};
'use strict';
Object.defineProperty($01ae635f2c5f2675$exports, "__esModule", {
    value: true
});
$01ae635f2c5f2675$exports.flattenNames = undefined;
var $653ed6e8f58665e2$exports = {};
var $ae89897d0c459443$exports = {};
var $a0a60054fa51f19c$exports = {};

var $aAIWi = parcelRequire("aAIWi");
/** Built-in value references. */ var $a0a60054fa51f19c$var$Symbol = $aAIWi.Symbol;
$a0a60054fa51f19c$exports = $a0a60054fa51f19c$var$Symbol;


var $c92dd38e18a3523b$exports = {};

/** Used for built-in method references. */ var $c92dd38e18a3523b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c92dd38e18a3523b$var$hasOwnProperty = $c92dd38e18a3523b$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $c92dd38e18a3523b$var$nativeObjectToString = $c92dd38e18a3523b$var$objectProto.toString;
/** Built-in value references. */ var $c92dd38e18a3523b$var$symToStringTag = $a0a60054fa51f19c$exports ? $a0a60054fa51f19c$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $c92dd38e18a3523b$var$getRawTag(value) {
    var isOwn = $c92dd38e18a3523b$var$hasOwnProperty.call(value, $c92dd38e18a3523b$var$symToStringTag), tag = value[$c92dd38e18a3523b$var$symToStringTag];
    try {
        value[$c92dd38e18a3523b$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $c92dd38e18a3523b$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$c92dd38e18a3523b$var$symToStringTag] = tag;
        else delete value[$c92dd38e18a3523b$var$symToStringTag];
    }
    return result;
}
$c92dd38e18a3523b$exports = $c92dd38e18a3523b$var$getRawTag;


var $757bd5d400e3d268$exports = {};
/** Used for built-in method references. */ var $757bd5d400e3d268$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $757bd5d400e3d268$var$nativeObjectToString = $757bd5d400e3d268$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $757bd5d400e3d268$var$objectToString(value) {
    return $757bd5d400e3d268$var$nativeObjectToString.call(value);
}
$757bd5d400e3d268$exports = $757bd5d400e3d268$var$objectToString;


/** `Object#toString` result references. */ var $ae89897d0c459443$var$nullTag = '[object Null]', $ae89897d0c459443$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $ae89897d0c459443$var$symToStringTag = $a0a60054fa51f19c$exports ? $a0a60054fa51f19c$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $ae89897d0c459443$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $ae89897d0c459443$var$undefinedTag : $ae89897d0c459443$var$nullTag;
    return $ae89897d0c459443$var$symToStringTag && $ae89897d0c459443$var$symToStringTag in Object(value) ? $c92dd38e18a3523b$exports(value) : $757bd5d400e3d268$exports(value);
}
$ae89897d0c459443$exports = $ae89897d0c459443$var$baseGetTag;


var $97dae14ba26fc62d$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $97dae14ba26fc62d$var$isArray = Array.isArray;
$97dae14ba26fc62d$exports = $97dae14ba26fc62d$var$isArray;


var $5cc8d9ad91c06863$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $5cc8d9ad91c06863$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$5cc8d9ad91c06863$exports = $5cc8d9ad91c06863$var$isObjectLike;


/** `Object#toString` result references. */ var $653ed6e8f58665e2$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $653ed6e8f58665e2$var$isString(value) {
    return typeof value == 'string' || !$97dae14ba26fc62d$exports(value) && $5cc8d9ad91c06863$exports(value) && $ae89897d0c459443$exports(value) == $653ed6e8f58665e2$var$stringTag;
}
$653ed6e8f58665e2$exports = $653ed6e8f58665e2$var$isString;


var $01ae635f2c5f2675$var$_isString3 = $01ae635f2c5f2675$var$_interopRequireDefault($653ed6e8f58665e2$exports);
var $f9b1acfc174f8d1d$exports = {};
var $0d987cdd8ce76e53$exports = {};
var $ee8c16abf996aefc$exports = {};
var $33bab95530c39704$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $33bab95530c39704$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$33bab95530c39704$exports = $33bab95530c39704$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $ee8c16abf996aefc$var$baseFor = $33bab95530c39704$exports();
$ee8c16abf996aefc$exports = $ee8c16abf996aefc$var$baseFor;


var $a5f07da1d5d1d6dc$exports = {};
var $c72302d030d32e01$exports = {};
var $f217bce72086dcfa$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $f217bce72086dcfa$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$f217bce72086dcfa$exports = $f217bce72086dcfa$var$baseTimes;


var $de71cb9d5df29a24$exports = {};
var $f73b9fa30edb0aba$exports = {};


/** `Object#toString` result references. */ var $f73b9fa30edb0aba$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $f73b9fa30edb0aba$var$baseIsArguments(value) {
    return $5cc8d9ad91c06863$exports(value) && $ae89897d0c459443$exports(value) == $f73b9fa30edb0aba$var$argsTag;
}
$f73b9fa30edb0aba$exports = $f73b9fa30edb0aba$var$baseIsArguments;



/** Used for built-in method references. */ var $de71cb9d5df29a24$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $de71cb9d5df29a24$var$hasOwnProperty = $de71cb9d5df29a24$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $de71cb9d5df29a24$var$propertyIsEnumerable = $de71cb9d5df29a24$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $de71cb9d5df29a24$var$isArguments = $f73b9fa30edb0aba$exports(function() {
    return arguments;
}()) ? $f73b9fa30edb0aba$exports : function(value) {
    return $5cc8d9ad91c06863$exports(value) && $de71cb9d5df29a24$var$hasOwnProperty.call(value, 'callee') && !$de71cb9d5df29a24$var$propertyIsEnumerable.call(value, 'callee');
};
$de71cb9d5df29a24$exports = $de71cb9d5df29a24$var$isArguments;




var $48wd1 = parcelRequire("48wd1");
var $55ebd60311919649$exports = {};
/** Used as references for various `Number` constants. */ var $55ebd60311919649$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $55ebd60311919649$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $55ebd60311919649$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $55ebd60311919649$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $55ebd60311919649$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$55ebd60311919649$exports = $55ebd60311919649$var$isIndex;


var $bc734d179edabb39$exports = {};
var $3462d778d53eaf66$exports = {};

var $7cd73cd6178040c5$exports = {};
/** Used as references for various `Number` constants. */ var $7cd73cd6178040c5$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $7cd73cd6178040c5$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $7cd73cd6178040c5$var$MAX_SAFE_INTEGER;
}
$7cd73cd6178040c5$exports = $7cd73cd6178040c5$var$isLength;



/** `Object#toString` result references. */ var $3462d778d53eaf66$var$argsTag = '[object Arguments]', $3462d778d53eaf66$var$arrayTag = '[object Array]', $3462d778d53eaf66$var$boolTag = '[object Boolean]', $3462d778d53eaf66$var$dateTag = '[object Date]', $3462d778d53eaf66$var$errorTag = '[object Error]', $3462d778d53eaf66$var$funcTag = '[object Function]', $3462d778d53eaf66$var$mapTag = '[object Map]', $3462d778d53eaf66$var$numberTag = '[object Number]', $3462d778d53eaf66$var$objectTag = '[object Object]', $3462d778d53eaf66$var$regexpTag = '[object RegExp]', $3462d778d53eaf66$var$setTag = '[object Set]', $3462d778d53eaf66$var$stringTag = '[object String]', $3462d778d53eaf66$var$weakMapTag = '[object WeakMap]';
var $3462d778d53eaf66$var$arrayBufferTag = '[object ArrayBuffer]', $3462d778d53eaf66$var$dataViewTag = '[object DataView]', $3462d778d53eaf66$var$float32Tag = '[object Float32Array]', $3462d778d53eaf66$var$float64Tag = '[object Float64Array]', $3462d778d53eaf66$var$int8Tag = '[object Int8Array]', $3462d778d53eaf66$var$int16Tag = '[object Int16Array]', $3462d778d53eaf66$var$int32Tag = '[object Int32Array]', $3462d778d53eaf66$var$uint8Tag = '[object Uint8Array]', $3462d778d53eaf66$var$uint8ClampedTag = '[object Uint8ClampedArray]', $3462d778d53eaf66$var$uint16Tag = '[object Uint16Array]', $3462d778d53eaf66$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $3462d778d53eaf66$var$typedArrayTags = {};
$3462d778d53eaf66$var$typedArrayTags[$3462d778d53eaf66$var$float32Tag] = $3462d778d53eaf66$var$typedArrayTags[$3462d778d53eaf66$var$float64Tag] = $3462d778d53eaf66$var$typedArrayTags[$3462d778d53eaf66$var$int8Tag] = $3462d778d53eaf66$var$typedArrayTags[$3462d778d53eaf66$var$int16Tag] = $3462d778d53eaf66$var$typedArrayTags[$3462d778d53eaf66$var$int32Tag] = $3462d778d53eaf66$var$typedArrayTags[$3462d778d53eaf66$var$uint8Tag] = $3462d778d53eaf66$var$typedArrayTags[$3462d778d53eaf66$var$uint8ClampedTag] = $3462d778d53eaf66$var$typedArrayTags[$3462d778d53eaf66$var$uint16Tag] = $3462d778d53eaf66$var$typedArrayTags[$3462d778d53eaf66$var$uint32Tag] = true;
$3462d778d53eaf66$var$typedArrayTags[$3462d778d53eaf66$var$argsTag] = $3462d778d53eaf66$var$typedArrayTags[$3462d778d53eaf66$var$arrayTag] = $3462d778d53eaf66$var$typedArrayTags[$3462d778d53eaf66$var$arrayBufferTag] = $3462d778d53eaf66$var$typedArrayTags[$3462d778d53eaf66$var$boolTag] = $3462d778d53eaf66$var$typedArrayTags[$3462d778d53eaf66$var$dataViewTag] = $3462d778d53eaf66$var$typedArrayTags[$3462d778d53eaf66$var$dateTag] = $3462d778d53eaf66$var$typedArrayTags[$3462d778d53eaf66$var$errorTag] = $3462d778d53eaf66$var$typedArrayTags[$3462d778d53eaf66$var$funcTag] = $3462d778d53eaf66$var$typedArrayTags[$3462d778d53eaf66$var$mapTag] = $3462d778d53eaf66$var$typedArrayTags[$3462d778d53eaf66$var$numberTag] = $3462d778d53eaf66$var$typedArrayTags[$3462d778d53eaf66$var$objectTag] = $3462d778d53eaf66$var$typedArrayTags[$3462d778d53eaf66$var$regexpTag] = $3462d778d53eaf66$var$typedArrayTags[$3462d778d53eaf66$var$setTag] = $3462d778d53eaf66$var$typedArrayTags[$3462d778d53eaf66$var$stringTag] = $3462d778d53eaf66$var$typedArrayTags[$3462d778d53eaf66$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $3462d778d53eaf66$var$baseIsTypedArray(value) {
    return $5cc8d9ad91c06863$exports(value) && $7cd73cd6178040c5$exports(value.length) && !!$3462d778d53eaf66$var$typedArrayTags[$ae89897d0c459443$exports(value)];
}
$3462d778d53eaf66$exports = $3462d778d53eaf66$var$baseIsTypedArray;


var $a0ea4d8fc1f42197$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $a0ea4d8fc1f42197$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$a0ea4d8fc1f42197$exports = $a0ea4d8fc1f42197$var$baseUnary;



var $lw6rp = parcelRequire("lw6rp");
/* Node.js helper references. */ var $bc734d179edabb39$var$nodeIsTypedArray = $lw6rp && $lw6rp.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $bc734d179edabb39$var$isTypedArray = $bc734d179edabb39$var$nodeIsTypedArray ? $a0ea4d8fc1f42197$exports($bc734d179edabb39$var$nodeIsTypedArray) : $3462d778d53eaf66$exports;
$bc734d179edabb39$exports = $bc734d179edabb39$var$isTypedArray;


/** Used for built-in method references. */ var $c72302d030d32e01$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c72302d030d32e01$var$hasOwnProperty = $c72302d030d32e01$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $c72302d030d32e01$var$arrayLikeKeys(value, inherited) {
    var isArr = $97dae14ba26fc62d$exports(value), isArg = !isArr && $de71cb9d5df29a24$exports(value), isBuff = !isArr && !isArg && $48wd1(value), isType = !isArr && !isArg && !isBuff && $bc734d179edabb39$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $f217bce72086dcfa$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $c72302d030d32e01$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $55ebd60311919649$exports(key, length)))) result.push(key);
    return result;
}
$c72302d030d32e01$exports = $c72302d030d32e01$var$arrayLikeKeys;


var $46cdab2d339e07ed$exports = {};
var $962d7e9f98268bad$exports = {};
/** Used for built-in method references. */ var $962d7e9f98268bad$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $962d7e9f98268bad$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $962d7e9f98268bad$var$objectProto;
    return value === proto;
}
$962d7e9f98268bad$exports = $962d7e9f98268bad$var$isPrototype;


var $dd9d58449b8a9517$exports = {};
var $6c42641211fa2d93$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $6c42641211fa2d93$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$6c42641211fa2d93$exports = $6c42641211fa2d93$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $dd9d58449b8a9517$var$nativeKeys = $6c42641211fa2d93$exports(Object.keys, Object);
$dd9d58449b8a9517$exports = $dd9d58449b8a9517$var$nativeKeys;


/** Used for built-in method references. */ var $46cdab2d339e07ed$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $46cdab2d339e07ed$var$hasOwnProperty = $46cdab2d339e07ed$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $46cdab2d339e07ed$var$baseKeys(object) {
    if (!$962d7e9f98268bad$exports(object)) return $dd9d58449b8a9517$exports(object);
    var result = [];
    for(var key in Object(object))if ($46cdab2d339e07ed$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
$46cdab2d339e07ed$exports = $46cdab2d339e07ed$var$baseKeys;


var $2f55927cb1f1acdf$exports = {};
var $a108eed467798a33$exports = {};

var $478ac5aeb3a35670$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $478ac5aeb3a35670$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$478ac5aeb3a35670$exports = $478ac5aeb3a35670$var$isObject;


/** `Object#toString` result references. */ var $a108eed467798a33$var$asyncTag = '[object AsyncFunction]', $a108eed467798a33$var$funcTag = '[object Function]', $a108eed467798a33$var$genTag = '[object GeneratorFunction]', $a108eed467798a33$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $a108eed467798a33$var$isFunction(value) {
    if (!$478ac5aeb3a35670$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $ae89897d0c459443$exports(value);
    return tag == $a108eed467798a33$var$funcTag || tag == $a108eed467798a33$var$genTag || tag == $a108eed467798a33$var$asyncTag || tag == $a108eed467798a33$var$proxyTag;
}
$a108eed467798a33$exports = $a108eed467798a33$var$isFunction;



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $2f55927cb1f1acdf$var$isArrayLike(value) {
    return value != null && $7cd73cd6178040c5$exports(value.length) && !$a108eed467798a33$exports(value);
}
$2f55927cb1f1acdf$exports = $2f55927cb1f1acdf$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $a5f07da1d5d1d6dc$var$keys(object) {
    return $2f55927cb1f1acdf$exports(object) ? $c72302d030d32e01$exports(object) : $46cdab2d339e07ed$exports(object);
}
$a5f07da1d5d1d6dc$exports = $a5f07da1d5d1d6dc$var$keys;


/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $0d987cdd8ce76e53$var$baseForOwn(object, iteratee) {
    return object && $ee8c16abf996aefc$exports(object, iteratee, $a5f07da1d5d1d6dc$exports);
}
$0d987cdd8ce76e53$exports = $0d987cdd8ce76e53$var$baseForOwn;


var $b41c508c251e2b04$exports = {};
var $5517116c9adddf6c$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $5517116c9adddf6c$var$identity(value) {
    return value;
}
$5517116c9adddf6c$exports = $5517116c9adddf6c$var$identity;


/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $b41c508c251e2b04$var$castFunction(value) {
    return typeof value == 'function' ? value : $5517116c9adddf6c$exports;
}
$b41c508c251e2b04$exports = $b41c508c251e2b04$var$castFunction;


/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $f9b1acfc174f8d1d$var$forOwn(object, iteratee) {
    return object && $0d987cdd8ce76e53$exports(object, $b41c508c251e2b04$exports(iteratee));
}
$f9b1acfc174f8d1d$exports = $f9b1acfc174f8d1d$var$forOwn;


var $01ae635f2c5f2675$var$_forOwn3 = $01ae635f2c5f2675$var$_interopRequireDefault($f9b1acfc174f8d1d$exports);
var $1c6964e4cf296ca3$exports = {};

var $157c500be85b0f64$exports = {};

/** Built-in value references. */ var $157c500be85b0f64$var$getPrototype = $6c42641211fa2d93$exports(Object.getPrototypeOf, Object);
$157c500be85b0f64$exports = $157c500be85b0f64$var$getPrototype;



/** `Object#toString` result references. */ var $1c6964e4cf296ca3$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $1c6964e4cf296ca3$var$funcProto = Function.prototype, $1c6964e4cf296ca3$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $1c6964e4cf296ca3$var$funcToString = $1c6964e4cf296ca3$var$funcProto.toString;
/** Used to check objects for own properties. */ var $1c6964e4cf296ca3$var$hasOwnProperty = $1c6964e4cf296ca3$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $1c6964e4cf296ca3$var$objectCtorString = $1c6964e4cf296ca3$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $1c6964e4cf296ca3$var$isPlainObject(value) {
    if (!$5cc8d9ad91c06863$exports(value) || $ae89897d0c459443$exports(value) != $1c6964e4cf296ca3$var$objectTag) return false;
    var proto = $157c500be85b0f64$exports(value);
    if (proto === null) return true;
    var Ctor = $1c6964e4cf296ca3$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $1c6964e4cf296ca3$var$funcToString.call(Ctor) == $1c6964e4cf296ca3$var$objectCtorString;
}
$1c6964e4cf296ca3$exports = $1c6964e4cf296ca3$var$isPlainObject;


var $01ae635f2c5f2675$var$_isPlainObject3 = $01ae635f2c5f2675$var$_interopRequireDefault($1c6964e4cf296ca3$exports);
var $85a48c45b465a6f3$exports = {};
var $17d0bd42fa028fde$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $17d0bd42fa028fde$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$17d0bd42fa028fde$exports = $17d0bd42fa028fde$var$arrayMap;


var $e0465e0d2ccffd94$exports = {};
var $b23adfcec065934e$exports = {};
var $48ca07e766336cbd$exports = {};
var $5614867d3628ea39$exports = {};
var $b64227110a639eb4$exports = {};
var $fada87659a2707fb$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $fada87659a2707fb$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$fada87659a2707fb$exports = $fada87659a2707fb$var$listCacheClear;


var $512817078b801aad$exports = {};
var $bbb7bd9e9e115355$exports = {};
var $9a4d378c7d52a11f$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $9a4d378c7d52a11f$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$9a4d378c7d52a11f$exports = $9a4d378c7d52a11f$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $bbb7bd9e9e115355$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($9a4d378c7d52a11f$exports(array[length][0], key)) return length;
    }
    return -1;
}
$bbb7bd9e9e115355$exports = $bbb7bd9e9e115355$var$assocIndexOf;


/** Used for built-in method references. */ var $512817078b801aad$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $512817078b801aad$var$splice = $512817078b801aad$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $512817078b801aad$var$listCacheDelete(key) {
    var data = this.__data__, index = $bbb7bd9e9e115355$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $512817078b801aad$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$512817078b801aad$exports = $512817078b801aad$var$listCacheDelete;


var $ea7505e21ee8144b$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ea7505e21ee8144b$var$listCacheGet(key) {
    var data = this.__data__, index = $bbb7bd9e9e115355$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$ea7505e21ee8144b$exports = $ea7505e21ee8144b$var$listCacheGet;


var $bef413c7fea63745$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $bef413c7fea63745$var$listCacheHas(key) {
    return $bbb7bd9e9e115355$exports(this.__data__, key) > -1;
}
$bef413c7fea63745$exports = $bef413c7fea63745$var$listCacheHas;


var $2a02ab7850572d41$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $2a02ab7850572d41$var$listCacheSet(key, value) {
    var data = this.__data__, index = $bbb7bd9e9e115355$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$2a02ab7850572d41$exports = $2a02ab7850572d41$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $b64227110a639eb4$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$b64227110a639eb4$var$ListCache.prototype.clear = $fada87659a2707fb$exports;
$b64227110a639eb4$var$ListCache.prototype['delete'] = $512817078b801aad$exports;
$b64227110a639eb4$var$ListCache.prototype.get = $ea7505e21ee8144b$exports;
$b64227110a639eb4$var$ListCache.prototype.has = $bef413c7fea63745$exports;
$b64227110a639eb4$var$ListCache.prototype.set = $2a02ab7850572d41$exports;
$b64227110a639eb4$exports = $b64227110a639eb4$var$ListCache;


var $b89cfe41a96e18c9$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $b89cfe41a96e18c9$var$stackClear() {
    this.__data__ = new $b64227110a639eb4$exports;
    this.size = 0;
}
$b89cfe41a96e18c9$exports = $b89cfe41a96e18c9$var$stackClear;


var $6051c64b69430302$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $6051c64b69430302$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
$6051c64b69430302$exports = $6051c64b69430302$var$stackDelete;


var $01b20ed3d85f2dd7$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $01b20ed3d85f2dd7$var$stackGet(key) {
    return this.__data__.get(key);
}
$01b20ed3d85f2dd7$exports = $01b20ed3d85f2dd7$var$stackGet;


var $a864d1ab56d809d2$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $a864d1ab56d809d2$var$stackHas(key) {
    return this.__data__.has(key);
}
$a864d1ab56d809d2$exports = $a864d1ab56d809d2$var$stackHas;


var $d76ba478c09bbcc1$exports = {};

var $caea276279073513$exports = {};
var $9aa4abe19b685989$exports = {};
var $9171e59ad6f6f37b$exports = {};

var $e0b970e3596cf31b$exports = {};
var $b4236671ec26dd8f$exports = {};

var $aAIWi = parcelRequire("aAIWi");
/** Used to detect overreaching core-js shims. */ var $b4236671ec26dd8f$var$coreJsData = $aAIWi["__core-js_shared__"];
$b4236671ec26dd8f$exports = $b4236671ec26dd8f$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $e0b970e3596cf31b$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($b4236671ec26dd8f$exports && $b4236671ec26dd8f$exports.keys && $b4236671ec26dd8f$exports.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $e0b970e3596cf31b$var$isMasked(func) {
    return !!$e0b970e3596cf31b$var$maskSrcKey && $e0b970e3596cf31b$var$maskSrcKey in func;
}
$e0b970e3596cf31b$exports = $e0b970e3596cf31b$var$isMasked;



var $65aa2633e1c2f634$exports = {};
/** Used for built-in method references. */ var $65aa2633e1c2f634$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $65aa2633e1c2f634$var$funcToString = $65aa2633e1c2f634$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $65aa2633e1c2f634$var$toSource(func) {
    if (func != null) {
        try {
            return $65aa2633e1c2f634$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
$65aa2633e1c2f634$exports = $65aa2633e1c2f634$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $9171e59ad6f6f37b$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $9171e59ad6f6f37b$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $9171e59ad6f6f37b$var$funcProto = Function.prototype, $9171e59ad6f6f37b$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $9171e59ad6f6f37b$var$funcToString = $9171e59ad6f6f37b$var$funcProto.toString;
/** Used to check objects for own properties. */ var $9171e59ad6f6f37b$var$hasOwnProperty = $9171e59ad6f6f37b$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $9171e59ad6f6f37b$var$reIsNative = RegExp('^' + $9171e59ad6f6f37b$var$funcToString.call($9171e59ad6f6f37b$var$hasOwnProperty).replace($9171e59ad6f6f37b$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $9171e59ad6f6f37b$var$baseIsNative(value) {
    if (!$478ac5aeb3a35670$exports(value) || $e0b970e3596cf31b$exports(value)) return false;
    var pattern = $a108eed467798a33$exports(value) ? $9171e59ad6f6f37b$var$reIsNative : $9171e59ad6f6f37b$var$reIsHostCtor;
    return pattern.test($65aa2633e1c2f634$exports(value));
}
$9171e59ad6f6f37b$exports = $9171e59ad6f6f37b$var$baseIsNative;


var $90ccfbce6217a793$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $90ccfbce6217a793$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$90ccfbce6217a793$exports = $90ccfbce6217a793$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $9aa4abe19b685989$var$getNative(object, key) {
    var value = $90ccfbce6217a793$exports(object, key);
    return $9171e59ad6f6f37b$exports(value) ? value : undefined;
}
$9aa4abe19b685989$exports = $9aa4abe19b685989$var$getNative;



var $aAIWi = parcelRequire("aAIWi");
/* Built-in method references that are verified to be native. */ var $caea276279073513$var$Map = $9aa4abe19b685989$exports($aAIWi, 'Map');
$caea276279073513$exports = $caea276279073513$var$Map;


var $50717c576c1798f1$exports = {};
var $f350daaf681776f8$exports = {};
var $ffd9f4a621fe4516$exports = {};
var $051af84a649efdb6$exports = {};
var $7afad1513d136b7c$exports = {};

/* Built-in method references that are verified to be native. */ var $7afad1513d136b7c$var$nativeCreate = $9aa4abe19b685989$exports(Object, 'create');
$7afad1513d136b7c$exports = $7afad1513d136b7c$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $051af84a649efdb6$var$hashClear() {
    this.__data__ = $7afad1513d136b7c$exports ? $7afad1513d136b7c$exports(null) : {};
    this.size = 0;
}
$051af84a649efdb6$exports = $051af84a649efdb6$var$hashClear;


var $0f907b23a06a2d06$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $0f907b23a06a2d06$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$0f907b23a06a2d06$exports = $0f907b23a06a2d06$var$hashDelete;


var $f1002db354dab090$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $f1002db354dab090$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $f1002db354dab090$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f1002db354dab090$var$hasOwnProperty = $f1002db354dab090$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $f1002db354dab090$var$hashGet(key) {
    var data = this.__data__;
    if ($7afad1513d136b7c$exports) {
        var result = data[key];
        return result === $f1002db354dab090$var$HASH_UNDEFINED ? undefined : result;
    }
    return $f1002db354dab090$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$f1002db354dab090$exports = $f1002db354dab090$var$hashGet;


var $c9131f939852a895$exports = {};

/** Used for built-in method references. */ var $c9131f939852a895$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c9131f939852a895$var$hasOwnProperty = $c9131f939852a895$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c9131f939852a895$var$hashHas(key) {
    var data = this.__data__;
    return $7afad1513d136b7c$exports ? data[key] !== undefined : $c9131f939852a895$var$hasOwnProperty.call(data, key);
}
$c9131f939852a895$exports = $c9131f939852a895$var$hashHas;


var $fe13d03e34731a0d$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $fe13d03e34731a0d$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $fe13d03e34731a0d$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $7afad1513d136b7c$exports && value === undefined ? $fe13d03e34731a0d$var$HASH_UNDEFINED : value;
    return this;
}
$fe13d03e34731a0d$exports = $fe13d03e34731a0d$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $ffd9f4a621fe4516$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$ffd9f4a621fe4516$var$Hash.prototype.clear = $051af84a649efdb6$exports;
$ffd9f4a621fe4516$var$Hash.prototype['delete'] = $0f907b23a06a2d06$exports;
$ffd9f4a621fe4516$var$Hash.prototype.get = $f1002db354dab090$exports;
$ffd9f4a621fe4516$var$Hash.prototype.has = $c9131f939852a895$exports;
$ffd9f4a621fe4516$var$Hash.prototype.set = $fe13d03e34731a0d$exports;
$ffd9f4a621fe4516$exports = $ffd9f4a621fe4516$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $f350daaf681776f8$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $ffd9f4a621fe4516$exports,
        'map': new ($caea276279073513$exports || $b64227110a639eb4$exports),
        'string': new $ffd9f4a621fe4516$exports
    };
}
$f350daaf681776f8$exports = $f350daaf681776f8$var$mapCacheClear;


var $dab3ed28061e761c$exports = {};
var $c5006d34e091f8e7$exports = {};
var $f9be8c6d411b7151$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $f9be8c6d411b7151$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
$f9be8c6d411b7151$exports = $f9be8c6d411b7151$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $c5006d34e091f8e7$var$getMapData(map, key) {
    var data = map.__data__;
    return $f9be8c6d411b7151$exports(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
$c5006d34e091f8e7$exports = $c5006d34e091f8e7$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $dab3ed28061e761c$var$mapCacheDelete(key) {
    var result = $c5006d34e091f8e7$exports(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
$dab3ed28061e761c$exports = $dab3ed28061e761c$var$mapCacheDelete;


var $c18a6abcf145f2fb$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $c18a6abcf145f2fb$var$mapCacheGet(key) {
    return $c5006d34e091f8e7$exports(this, key).get(key);
}
$c18a6abcf145f2fb$exports = $c18a6abcf145f2fb$var$mapCacheGet;


var $7b9c82218c4ace59$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $7b9c82218c4ace59$var$mapCacheHas(key) {
    return $c5006d34e091f8e7$exports(this, key).has(key);
}
$7b9c82218c4ace59$exports = $7b9c82218c4ace59$var$mapCacheHas;


var $fffe424d408a9805$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $fffe424d408a9805$var$mapCacheSet(key, value) {
    var data = $c5006d34e091f8e7$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$fffe424d408a9805$exports = $fffe424d408a9805$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $50717c576c1798f1$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$50717c576c1798f1$var$MapCache.prototype.clear = $f350daaf681776f8$exports;
$50717c576c1798f1$var$MapCache.prototype['delete'] = $dab3ed28061e761c$exports;
$50717c576c1798f1$var$MapCache.prototype.get = $c18a6abcf145f2fb$exports;
$50717c576c1798f1$var$MapCache.prototype.has = $7b9c82218c4ace59$exports;
$50717c576c1798f1$var$MapCache.prototype.set = $fffe424d408a9805$exports;
$50717c576c1798f1$exports = $50717c576c1798f1$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $d76ba478c09bbcc1$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $d76ba478c09bbcc1$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $b64227110a639eb4$exports) {
        var pairs = data.__data__;
        if (!$caea276279073513$exports || pairs.length < $d76ba478c09bbcc1$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $50717c576c1798f1$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$d76ba478c09bbcc1$exports = $d76ba478c09bbcc1$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $5614867d3628ea39$var$Stack(entries) {
    var data = this.__data__ = new $b64227110a639eb4$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$5614867d3628ea39$var$Stack.prototype.clear = $b89cfe41a96e18c9$exports;
$5614867d3628ea39$var$Stack.prototype['delete'] = $6051c64b69430302$exports;
$5614867d3628ea39$var$Stack.prototype.get = $01b20ed3d85f2dd7$exports;
$5614867d3628ea39$var$Stack.prototype.has = $a864d1ab56d809d2$exports;
$5614867d3628ea39$var$Stack.prototype.set = $d76ba478c09bbcc1$exports;
$5614867d3628ea39$exports = $5614867d3628ea39$var$Stack;


var $6fb3def86f14c15b$exports = {};
var $230a3939be30ec7a$exports = {};

var $cab8cd8a7e67dd54$exports = {};
var $609d1d8865dc257d$exports = {};

var $6fa7b3a51757db18$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $6fa7b3a51757db18$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $6fa7b3a51757db18$var$setCacheAdd(value) {
    this.__data__.set(value, $6fa7b3a51757db18$var$HASH_UNDEFINED);
    return this;
}
$6fa7b3a51757db18$exports = $6fa7b3a51757db18$var$setCacheAdd;


var $b1b72eb87cb60e60$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ function $b1b72eb87cb60e60$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$b1b72eb87cb60e60$exports = $b1b72eb87cb60e60$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $609d1d8865dc257d$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $50717c576c1798f1$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$609d1d8865dc257d$var$SetCache.prototype.add = $609d1d8865dc257d$var$SetCache.prototype.push = $6fa7b3a51757db18$exports;
$609d1d8865dc257d$var$SetCache.prototype.has = $b1b72eb87cb60e60$exports;
$609d1d8865dc257d$exports = $609d1d8865dc257d$var$SetCache;


var $b225963393dbff20$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $b225963393dbff20$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$b225963393dbff20$exports = $b225963393dbff20$var$arraySome;


var $5259694f5df36b4a$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $5259694f5df36b4a$var$cacheHas(cache, key) {
    return cache.has(key);
}
$5259694f5df36b4a$exports = $5259694f5df36b4a$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $cab8cd8a7e67dd54$var$COMPARE_PARTIAL_FLAG = 1, $cab8cd8a7e67dd54$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $cab8cd8a7e67dd54$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $cab8cd8a7e67dd54$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $cab8cd8a7e67dd54$var$COMPARE_UNORDERED_FLAG ? new $609d1d8865dc257d$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$b225963393dbff20$exports(other, function(othValue, othIndex) {
                if (!$5259694f5df36b4a$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
$cab8cd8a7e67dd54$exports = $cab8cd8a7e67dd54$var$equalArrays;


var $34f7d74ff327c3b8$exports = {};

var $10c9c0e2a3f39745$exports = {};

var $aAIWi = parcelRequire("aAIWi");
/** Built-in value references. */ var $10c9c0e2a3f39745$var$Uint8Array = $aAIWi.Uint8Array;
$10c9c0e2a3f39745$exports = $10c9c0e2a3f39745$var$Uint8Array;




var $6e46ac91eeb038e1$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $6e46ac91eeb038e1$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$6e46ac91eeb038e1$exports = $6e46ac91eeb038e1$var$mapToArray;


var $169ce79b4782efef$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $169ce79b4782efef$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$169ce79b4782efef$exports = $169ce79b4782efef$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $34f7d74ff327c3b8$var$COMPARE_PARTIAL_FLAG = 1, $34f7d74ff327c3b8$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $34f7d74ff327c3b8$var$boolTag = '[object Boolean]', $34f7d74ff327c3b8$var$dateTag = '[object Date]', $34f7d74ff327c3b8$var$errorTag = '[object Error]', $34f7d74ff327c3b8$var$mapTag = '[object Map]', $34f7d74ff327c3b8$var$numberTag = '[object Number]', $34f7d74ff327c3b8$var$regexpTag = '[object RegExp]', $34f7d74ff327c3b8$var$setTag = '[object Set]', $34f7d74ff327c3b8$var$stringTag = '[object String]', $34f7d74ff327c3b8$var$symbolTag = '[object Symbol]';
var $34f7d74ff327c3b8$var$arrayBufferTag = '[object ArrayBuffer]', $34f7d74ff327c3b8$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $34f7d74ff327c3b8$var$symbolProto = $a0a60054fa51f19c$exports ? $a0a60054fa51f19c$exports.prototype : undefined, $34f7d74ff327c3b8$var$symbolValueOf = $34f7d74ff327c3b8$var$symbolProto ? $34f7d74ff327c3b8$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $34f7d74ff327c3b8$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $34f7d74ff327c3b8$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $34f7d74ff327c3b8$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $10c9c0e2a3f39745$exports(object), new $10c9c0e2a3f39745$exports(other))) return false;
            return true;
        case $34f7d74ff327c3b8$var$boolTag:
        case $34f7d74ff327c3b8$var$dateTag:
        case $34f7d74ff327c3b8$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $9a4d378c7d52a11f$exports(+object, +other);
        case $34f7d74ff327c3b8$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $34f7d74ff327c3b8$var$regexpTag:
        case $34f7d74ff327c3b8$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $34f7d74ff327c3b8$var$mapTag:
            var convert = $6e46ac91eeb038e1$exports;
        case $34f7d74ff327c3b8$var$setTag:
            var isPartial = bitmask & $34f7d74ff327c3b8$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $169ce79b4782efef$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $34f7d74ff327c3b8$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $cab8cd8a7e67dd54$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $34f7d74ff327c3b8$var$symbolTag:
            if ($34f7d74ff327c3b8$var$symbolValueOf) return $34f7d74ff327c3b8$var$symbolValueOf.call(object) == $34f7d74ff327c3b8$var$symbolValueOf.call(other);
    }
    return false;
}
$34f7d74ff327c3b8$exports = $34f7d74ff327c3b8$var$equalByTag;


var $9b9f713ba9676a17$exports = {};
var $907cb5a478bb2c95$exports = {};
var $b1a0ca0ccb510d6a$exports = {};
var $7ae74e472b94e95b$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $7ae74e472b94e95b$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$7ae74e472b94e95b$exports = $7ae74e472b94e95b$var$arrayPush;



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $b1a0ca0ccb510d6a$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $97dae14ba26fc62d$exports(object) ? result : $7ae74e472b94e95b$exports(result, symbolsFunc(object));
}
$b1a0ca0ccb510d6a$exports = $b1a0ca0ccb510d6a$var$baseGetAllKeys;


var $6de92f7dafc08418$exports = {};
var $01dcbf77023bba3b$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $01dcbf77023bba3b$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$01dcbf77023bba3b$exports = $01dcbf77023bba3b$var$arrayFilter;


var $40cbda45169ab926$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $40cbda45169ab926$var$stubArray() {
    return [];
}
$40cbda45169ab926$exports = $40cbda45169ab926$var$stubArray;


/** Used for built-in method references. */ var $6de92f7dafc08418$var$objectProto = Object.prototype;
/** Built-in value references. */ var $6de92f7dafc08418$var$propertyIsEnumerable = $6de92f7dafc08418$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6de92f7dafc08418$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $6de92f7dafc08418$var$getSymbols = !$6de92f7dafc08418$var$nativeGetSymbols ? $40cbda45169ab926$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $01dcbf77023bba3b$exports($6de92f7dafc08418$var$nativeGetSymbols(object), function(symbol) {
        return $6de92f7dafc08418$var$propertyIsEnumerable.call(object, symbol);
    });
};
$6de92f7dafc08418$exports = $6de92f7dafc08418$var$getSymbols;



/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $907cb5a478bb2c95$var$getAllKeys(object) {
    return $b1a0ca0ccb510d6a$exports(object, $a5f07da1d5d1d6dc$exports, $6de92f7dafc08418$exports);
}
$907cb5a478bb2c95$exports = $907cb5a478bb2c95$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $9b9f713ba9676a17$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $9b9f713ba9676a17$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9b9f713ba9676a17$var$hasOwnProperty = $9b9f713ba9676a17$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $9b9f713ba9676a17$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $9b9f713ba9676a17$var$COMPARE_PARTIAL_FLAG, objProps = $907cb5a478bb2c95$exports(object), objLength = objProps.length, othProps = $907cb5a478bb2c95$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $9b9f713ba9676a17$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
$9b9f713ba9676a17$exports = $9b9f713ba9676a17$var$equalObjects;


var $67ae2614b625b36c$exports = {};
var $7fe866c66c1821e4$exports = {};


var $aAIWi = parcelRequire("aAIWi");
/* Built-in method references that are verified to be native. */ var $7fe866c66c1821e4$var$DataView = $9aa4abe19b685989$exports($aAIWi, 'DataView');
$7fe866c66c1821e4$exports = $7fe866c66c1821e4$var$DataView;



var $872ec63180937865$exports = {};


var $aAIWi = parcelRequire("aAIWi");
/* Built-in method references that are verified to be native. */ var $872ec63180937865$var$Promise = $9aa4abe19b685989$exports($aAIWi, 'Promise');
$872ec63180937865$exports = $872ec63180937865$var$Promise;


var $1742e3660954c51f$exports = {};


var $aAIWi = parcelRequire("aAIWi");
/* Built-in method references that are verified to be native. */ var $1742e3660954c51f$var$Set = $9aa4abe19b685989$exports($aAIWi, 'Set');
$1742e3660954c51f$exports = $1742e3660954c51f$var$Set;


var $f2d375d51a2b3ad5$exports = {};


var $aAIWi = parcelRequire("aAIWi");
/* Built-in method references that are verified to be native. */ var $f2d375d51a2b3ad5$var$WeakMap = $9aa4abe19b685989$exports($aAIWi, 'WeakMap');
$f2d375d51a2b3ad5$exports = $f2d375d51a2b3ad5$var$WeakMap;




/** `Object#toString` result references. */ var $67ae2614b625b36c$var$mapTag = '[object Map]', $67ae2614b625b36c$var$objectTag = '[object Object]', $67ae2614b625b36c$var$promiseTag = '[object Promise]', $67ae2614b625b36c$var$setTag = '[object Set]', $67ae2614b625b36c$var$weakMapTag = '[object WeakMap]';
var $67ae2614b625b36c$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $67ae2614b625b36c$var$dataViewCtorString = $65aa2633e1c2f634$exports($7fe866c66c1821e4$exports), $67ae2614b625b36c$var$mapCtorString = $65aa2633e1c2f634$exports($caea276279073513$exports), $67ae2614b625b36c$var$promiseCtorString = $65aa2633e1c2f634$exports($872ec63180937865$exports), $67ae2614b625b36c$var$setCtorString = $65aa2633e1c2f634$exports($1742e3660954c51f$exports), $67ae2614b625b36c$var$weakMapCtorString = $65aa2633e1c2f634$exports($f2d375d51a2b3ad5$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $67ae2614b625b36c$var$getTag = $ae89897d0c459443$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($7fe866c66c1821e4$exports && $67ae2614b625b36c$var$getTag(new $7fe866c66c1821e4$exports(new ArrayBuffer(1))) != $67ae2614b625b36c$var$dataViewTag || $caea276279073513$exports && $67ae2614b625b36c$var$getTag(new $caea276279073513$exports) != $67ae2614b625b36c$var$mapTag || $872ec63180937865$exports && $67ae2614b625b36c$var$getTag($872ec63180937865$exports.resolve()) != $67ae2614b625b36c$var$promiseTag || $1742e3660954c51f$exports && $67ae2614b625b36c$var$getTag(new $1742e3660954c51f$exports) != $67ae2614b625b36c$var$setTag || $f2d375d51a2b3ad5$exports && $67ae2614b625b36c$var$getTag(new $f2d375d51a2b3ad5$exports) != $67ae2614b625b36c$var$weakMapTag) $67ae2614b625b36c$var$getTag = function(value) {
    var result = $ae89897d0c459443$exports(value), Ctor = result == $67ae2614b625b36c$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $65aa2633e1c2f634$exports(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $67ae2614b625b36c$var$dataViewCtorString:
            return $67ae2614b625b36c$var$dataViewTag;
        case $67ae2614b625b36c$var$mapCtorString:
            return $67ae2614b625b36c$var$mapTag;
        case $67ae2614b625b36c$var$promiseCtorString:
            return $67ae2614b625b36c$var$promiseTag;
        case $67ae2614b625b36c$var$setCtorString:
            return $67ae2614b625b36c$var$setTag;
        case $67ae2614b625b36c$var$weakMapCtorString:
            return $67ae2614b625b36c$var$weakMapTag;
    }
    return result;
};
$67ae2614b625b36c$exports = $67ae2614b625b36c$var$getTag;




var $48wd1 = parcelRequire("48wd1");

/** Used to compose bitmasks for value comparisons. */ var $230a3939be30ec7a$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $230a3939be30ec7a$var$argsTag = '[object Arguments]', $230a3939be30ec7a$var$arrayTag = '[object Array]', $230a3939be30ec7a$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $230a3939be30ec7a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $230a3939be30ec7a$var$hasOwnProperty = $230a3939be30ec7a$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $230a3939be30ec7a$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $97dae14ba26fc62d$exports(object), othIsArr = $97dae14ba26fc62d$exports(other), objTag = objIsArr ? $230a3939be30ec7a$var$arrayTag : $67ae2614b625b36c$exports(object), othTag = othIsArr ? $230a3939be30ec7a$var$arrayTag : $67ae2614b625b36c$exports(other);
    objTag = objTag == $230a3939be30ec7a$var$argsTag ? $230a3939be30ec7a$var$objectTag : objTag;
    othTag = othTag == $230a3939be30ec7a$var$argsTag ? $230a3939be30ec7a$var$objectTag : othTag;
    var objIsObj = objTag == $230a3939be30ec7a$var$objectTag, othIsObj = othTag == $230a3939be30ec7a$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $48wd1(object)) {
        if (!$48wd1(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $5614867d3628ea39$exports);
        return objIsArr || $bc734d179edabb39$exports(object) ? $cab8cd8a7e67dd54$exports(object, other, bitmask, customizer, equalFunc, stack) : $34f7d74ff327c3b8$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $230a3939be30ec7a$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $230a3939be30ec7a$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $230a3939be30ec7a$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $5614867d3628ea39$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $5614867d3628ea39$exports);
    return $9b9f713ba9676a17$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$230a3939be30ec7a$exports = $230a3939be30ec7a$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $6fb3def86f14c15b$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$5cc8d9ad91c06863$exports(value) && !$5cc8d9ad91c06863$exports(other)) return value !== value && other !== other;
    return $230a3939be30ec7a$exports(value, other, bitmask, customizer, $6fb3def86f14c15b$var$baseIsEqual, stack);
}
$6fb3def86f14c15b$exports = $6fb3def86f14c15b$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $48ca07e766336cbd$var$COMPARE_PARTIAL_FLAG = 1, $48ca07e766336cbd$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $48ca07e766336cbd$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $5614867d3628ea39$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $6fb3def86f14c15b$exports(srcValue, objValue, $48ca07e766336cbd$var$COMPARE_PARTIAL_FLAG | $48ca07e766336cbd$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$48ca07e766336cbd$exports = $48ca07e766336cbd$var$baseIsMatch;


var $4a7f0ec556803384$exports = {};
var $d363b1c3993dce1d$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $d363b1c3993dce1d$var$isStrictComparable(value) {
    return value === value && !$478ac5aeb3a35670$exports(value);
}
$d363b1c3993dce1d$exports = $d363b1c3993dce1d$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $4a7f0ec556803384$var$getMatchData(object) {
    var result = $a5f07da1d5d1d6dc$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $d363b1c3993dce1d$exports(value)
        ];
    }
    return result;
}
$4a7f0ec556803384$exports = $4a7f0ec556803384$var$getMatchData;


var $33dc343591bf735f$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $33dc343591bf735f$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$33dc343591bf735f$exports = $33dc343591bf735f$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $b23adfcec065934e$var$baseMatches(source) {
    var matchData = $4a7f0ec556803384$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $33dc343591bf735f$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $48ca07e766336cbd$exports(object, source, matchData);
    };
}
$b23adfcec065934e$exports = $b23adfcec065934e$var$baseMatches;


var $6810f225fcbc0cd3$exports = {};

var $be146ae20f56753e$exports = {};
var $2e471ef2e9c58348$exports = {};
var $cf6b1f6410daa69c$exports = {};

var $dda08bd6253e354e$exports = {};

var $43a388a5b32b687a$exports = {};


/** `Object#toString` result references. */ var $43a388a5b32b687a$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $43a388a5b32b687a$var$isSymbol(value) {
    return typeof value == 'symbol' || $5cc8d9ad91c06863$exports(value) && $ae89897d0c459443$exports(value) == $43a388a5b32b687a$var$symbolTag;
}
$43a388a5b32b687a$exports = $43a388a5b32b687a$var$isSymbol;


/** Used to match property names within property paths. */ var $dda08bd6253e354e$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $dda08bd6253e354e$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $dda08bd6253e354e$var$isKey(value, object) {
    if ($97dae14ba26fc62d$exports(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $43a388a5b32b687a$exports(value)) return true;
    return $dda08bd6253e354e$var$reIsPlainProp.test(value) || !$dda08bd6253e354e$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$dda08bd6253e354e$exports = $dda08bd6253e354e$var$isKey;


var $2c3d4434572054af$exports = {};
var $a1a7ce8fcbead449$exports = {};
var $f2563318c52d94dd$exports = {};

/** Error message constants. */ var $f2563318c52d94dd$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $f2563318c52d94dd$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($f2563318c52d94dd$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($f2563318c52d94dd$var$memoize.Cache || $50717c576c1798f1$exports);
    return memoized;
}
// Expose `MapCache`.
$f2563318c52d94dd$var$memoize.Cache = $50717c576c1798f1$exports;
$f2563318c52d94dd$exports = $f2563318c52d94dd$var$memoize;


/** Used as the maximum memoize cache size. */ var $a1a7ce8fcbead449$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $a1a7ce8fcbead449$var$memoizeCapped(func) {
    var result = $f2563318c52d94dd$exports(func, function(key) {
        if (cache.size === $a1a7ce8fcbead449$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$a1a7ce8fcbead449$exports = $a1a7ce8fcbead449$var$memoizeCapped;


/** Used to match property names within property paths. */ var $2c3d4434572054af$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $2c3d4434572054af$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $2c3d4434572054af$var$stringToPath = $a1a7ce8fcbead449$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($2c3d4434572054af$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($2c3d4434572054af$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
$2c3d4434572054af$exports = $2c3d4434572054af$var$stringToPath;


var $333a3cb70de986c6$exports = {};
var $e44c6be1db4e6a3d$exports = {};




/** Used as references for various `Number` constants. */ var $e44c6be1db4e6a3d$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $e44c6be1db4e6a3d$var$symbolProto = $a0a60054fa51f19c$exports ? $a0a60054fa51f19c$exports.prototype : undefined, $e44c6be1db4e6a3d$var$symbolToString = $e44c6be1db4e6a3d$var$symbolProto ? $e44c6be1db4e6a3d$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $e44c6be1db4e6a3d$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($97dae14ba26fc62d$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $17d0bd42fa028fde$exports(value, $e44c6be1db4e6a3d$var$baseToString) + '';
    if ($43a388a5b32b687a$exports(value)) return $e44c6be1db4e6a3d$var$symbolToString ? $e44c6be1db4e6a3d$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$e44c6be1db4e6a3d$var$INFINITY ? '-0' : result;
}
$e44c6be1db4e6a3d$exports = $e44c6be1db4e6a3d$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $333a3cb70de986c6$var$toString(value) {
    return value == null ? '' : $e44c6be1db4e6a3d$exports(value);
}
$333a3cb70de986c6$exports = $333a3cb70de986c6$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $cf6b1f6410daa69c$var$castPath(value, object) {
    if ($97dae14ba26fc62d$exports(value)) return value;
    return $dda08bd6253e354e$exports(value, object) ? [
        value
    ] : $2c3d4434572054af$exports($333a3cb70de986c6$exports(value));
}
$cf6b1f6410daa69c$exports = $cf6b1f6410daa69c$var$castPath;


var $3e6d6dd0b05fc336$exports = {};

/** Used as references for various `Number` constants. */ var $3e6d6dd0b05fc336$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $3e6d6dd0b05fc336$var$toKey(value) {
    if (typeof value == 'string' || $43a388a5b32b687a$exports(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$3e6d6dd0b05fc336$var$INFINITY ? '-0' : result;
}
$3e6d6dd0b05fc336$exports = $3e6d6dd0b05fc336$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $2e471ef2e9c58348$var$baseGet(object, path) {
    path = $cf6b1f6410daa69c$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$3e6d6dd0b05fc336$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$2e471ef2e9c58348$exports = $2e471ef2e9c58348$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $be146ae20f56753e$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $2e471ef2e9c58348$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$be146ae20f56753e$exports = $be146ae20f56753e$var$get;


var $6c038a255cc74009$exports = {};
var $269a1c08de7102d8$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $269a1c08de7102d8$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$269a1c08de7102d8$exports = $269a1c08de7102d8$var$baseHasIn;


var $449748cc93712787$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $449748cc93712787$var$hasPath(object, path, hasFunc) {
    path = $cf6b1f6410daa69c$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $3e6d6dd0b05fc336$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $7cd73cd6178040c5$exports(length) && $55ebd60311919649$exports(key, length) && ($97dae14ba26fc62d$exports(object) || $de71cb9d5df29a24$exports(object));
}
$449748cc93712787$exports = $449748cc93712787$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $6c038a255cc74009$var$hasIn(object, path) {
    return object != null && $449748cc93712787$exports(object, path, $269a1c08de7102d8$exports);
}
$6c038a255cc74009$exports = $6c038a255cc74009$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $6810f225fcbc0cd3$var$COMPARE_PARTIAL_FLAG = 1, $6810f225fcbc0cd3$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $6810f225fcbc0cd3$var$baseMatchesProperty(path, srcValue) {
    if ($dda08bd6253e354e$exports(path) && $d363b1c3993dce1d$exports(srcValue)) return $33dc343591bf735f$exports($3e6d6dd0b05fc336$exports(path), srcValue);
    return function(object) {
        var objValue = $be146ae20f56753e$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $6c038a255cc74009$exports(object, path) : $6fb3def86f14c15b$exports(srcValue, objValue, $6810f225fcbc0cd3$var$COMPARE_PARTIAL_FLAG | $6810f225fcbc0cd3$var$COMPARE_UNORDERED_FLAG);
    };
}
$6810f225fcbc0cd3$exports = $6810f225fcbc0cd3$var$baseMatchesProperty;




var $7690dd23f3b8318c$exports = {};
var $2fcf4bf857cd247b$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $2fcf4bf857cd247b$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$2fcf4bf857cd247b$exports = $2fcf4bf857cd247b$var$baseProperty;


var $949acfd29177baba$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $949acfd29177baba$var$basePropertyDeep(path) {
    return function(object) {
        return $2e471ef2e9c58348$exports(object, path);
    };
}
$949acfd29177baba$exports = $949acfd29177baba$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $7690dd23f3b8318c$var$property(path) {
    return $dda08bd6253e354e$exports(path) ? $2fcf4bf857cd247b$exports($3e6d6dd0b05fc336$exports(path)) : $949acfd29177baba$exports(path);
}
$7690dd23f3b8318c$exports = $7690dd23f3b8318c$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $e0465e0d2ccffd94$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $5517116c9adddf6c$exports;
    if (typeof value == 'object') return $97dae14ba26fc62d$exports(value) ? $6810f225fcbc0cd3$exports(value[0], value[1]) : $b23adfcec065934e$exports(value);
    return $7690dd23f3b8318c$exports(value);
}
$e0465e0d2ccffd94$exports = $e0465e0d2ccffd94$var$baseIteratee;


var $f2a36e4f14f85142$exports = {};
var $72cc277c8ea6fce4$exports = {};

var $340d796e3b48a1f8$exports = {};

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $340d796e3b48a1f8$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$2f55927cb1f1acdf$exports(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$340d796e3b48a1f8$exports = $340d796e3b48a1f8$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $72cc277c8ea6fce4$var$baseEach = $340d796e3b48a1f8$exports($0d987cdd8ce76e53$exports);
$72cc277c8ea6fce4$exports = $72cc277c8ea6fce4$var$baseEach;



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $f2a36e4f14f85142$var$baseMap(collection, iteratee) {
    var index = -1, result = $2f55927cb1f1acdf$exports(collection) ? Array(collection.length) : [];
    $72cc277c8ea6fce4$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$f2a36e4f14f85142$exports = $f2a36e4f14f85142$var$baseMap;



/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $85a48c45b465a6f3$var$map(collection, iteratee) {
    var func = $97dae14ba26fc62d$exports(collection) ? $17d0bd42fa028fde$exports : $f2a36e4f14f85142$exports;
    return func(collection, $e0465e0d2ccffd94$exports(iteratee, 3));
}
$85a48c45b465a6f3$exports = $85a48c45b465a6f3$var$map;


var $01ae635f2c5f2675$var$_map3 = $01ae635f2c5f2675$var$_interopRequireDefault($85a48c45b465a6f3$exports);
function $01ae635f2c5f2675$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $01ae635f2c5f2675$var$flattenNames = $01ae635f2c5f2675$exports.flattenNames = function flattenNames() {
    var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var names = [];
    (0, $01ae635f2c5f2675$var$_map3.default)(things, function(thing) {
        if (Array.isArray(thing)) flattenNames(thing).map(function(name) {
            return names.push(name);
        });
        else if ((0, $01ae635f2c5f2675$var$_isPlainObject3.default)(thing)) (0, $01ae635f2c5f2675$var$_forOwn3.default)(thing, function(value, key) {
            value === true && names.push(key);
            names.push(key + '-' + value);
        });
        else if ((0, $01ae635f2c5f2675$var$_isString3.default)(thing)) names.push(thing);
    });
    return names;
};
$01ae635f2c5f2675$exports.default = $01ae635f2c5f2675$var$flattenNames;


var $bb2c8b52dc31f705$var$_flattenNames2 = $bb2c8b52dc31f705$var$_interopRequireDefault($01ae635f2c5f2675$exports);
var $1a673cb097f9c8e0$exports = {};
'use strict';
Object.defineProperty($1a673cb097f9c8e0$exports, "__esModule", {
    value: true
});
$1a673cb097f9c8e0$exports.mergeClasses = undefined;

var $1a673cb097f9c8e0$var$_forOwn3 = $1a673cb097f9c8e0$var$_interopRequireDefault($f9b1acfc174f8d1d$exports);
var $660ac3c604cbb0a6$exports = {};
var $f0d000f2fdfd6cc8$exports = {};

var $ef9fc0c99a56feec$exports = {};
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $ef9fc0c99a56feec$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
$ef9fc0c99a56feec$exports = $ef9fc0c99a56feec$var$arrayEach;


var $c2877cc0402576dd$exports = {};
var $060735c662fdf6f1$exports = {};
var $6d9afa90483e53e1$exports = {};

var $6d9afa90483e53e1$var$defineProperty = function() {
    try {
        var func = $9aa4abe19b685989$exports(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
$6d9afa90483e53e1$exports = $6d9afa90483e53e1$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $060735c662fdf6f1$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $6d9afa90483e53e1$exports) $6d9afa90483e53e1$exports(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
$060735c662fdf6f1$exports = $060735c662fdf6f1$var$baseAssignValue;



/** Used for built-in method references. */ var $c2877cc0402576dd$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c2877cc0402576dd$var$hasOwnProperty = $c2877cc0402576dd$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $c2877cc0402576dd$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($c2877cc0402576dd$var$hasOwnProperty.call(object, key) && $9a4d378c7d52a11f$exports(objValue, value)) || value === undefined && !(key in object)) $060735c662fdf6f1$exports(object, key, value);
}
$c2877cc0402576dd$exports = $c2877cc0402576dd$var$assignValue;


var $232e8a10b10fa897$exports = {};
var $946c3567cd1eca09$exports = {};


/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $946c3567cd1eca09$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $060735c662fdf6f1$exports(object, key, newValue);
        else $c2877cc0402576dd$exports(object, key, newValue);
    }
    return object;
}
$946c3567cd1eca09$exports = $946c3567cd1eca09$var$copyObject;



/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $232e8a10b10fa897$var$baseAssign(object, source) {
    return object && $946c3567cd1eca09$exports(source, $a5f07da1d5d1d6dc$exports(source), object);
}
$232e8a10b10fa897$exports = $232e8a10b10fa897$var$baseAssign;


var $8ed3ac63bdcdde1f$exports = {};

var $7b0f7206cc15891e$exports = {};

var $b56130a6176732b5$exports = {};


var $53204e5f4da36ff3$exports = {};
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $53204e5f4da36ff3$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
$53204e5f4da36ff3$exports = $53204e5f4da36ff3$var$nativeKeysIn;


/** Used for built-in method references. */ var $b56130a6176732b5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b56130a6176732b5$var$hasOwnProperty = $b56130a6176732b5$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $b56130a6176732b5$var$baseKeysIn(object) {
    if (!$478ac5aeb3a35670$exports(object)) return $53204e5f4da36ff3$exports(object);
    var isProto = $962d7e9f98268bad$exports(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$b56130a6176732b5$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
$b56130a6176732b5$exports = $b56130a6176732b5$var$baseKeysIn;



/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $7b0f7206cc15891e$var$keysIn(object) {
    return $2f55927cb1f1acdf$exports(object) ? $c72302d030d32e01$exports(object, true) : $b56130a6176732b5$exports(object);
}
$7b0f7206cc15891e$exports = $7b0f7206cc15891e$var$keysIn;


/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $8ed3ac63bdcdde1f$var$baseAssignIn(object, source) {
    return object && $946c3567cd1eca09$exports(source, $7b0f7206cc15891e$exports(source), object);
}
$8ed3ac63bdcdde1f$exports = $8ed3ac63bdcdde1f$var$baseAssignIn;



var $iGrNT = parcelRequire("iGrNT");
var $0969e613d28b017c$exports = {};
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $0969e613d28b017c$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
$0969e613d28b017c$exports = $0969e613d28b017c$var$copyArray;


var $cce37feba06ec390$exports = {};


/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $cce37feba06ec390$var$copySymbols(source, object) {
    return $946c3567cd1eca09$exports(source, $6de92f7dafc08418$exports(source), object);
}
$cce37feba06ec390$exports = $cce37feba06ec390$var$copySymbols;


var $a1c4886be2e78969$exports = {};

var $16a39bae69329d4a$exports = {};




/* Built-in method references for those with the same name as other `lodash` methods. */ var $16a39bae69329d4a$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $16a39bae69329d4a$var$getSymbolsIn = !$16a39bae69329d4a$var$nativeGetSymbols ? $40cbda45169ab926$exports : function(object) {
    var result = [];
    while(object){
        $7ae74e472b94e95b$exports(result, $6de92f7dafc08418$exports(object));
        object = $157c500be85b0f64$exports(object);
    }
    return result;
};
$16a39bae69329d4a$exports = $16a39bae69329d4a$var$getSymbolsIn;


/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $a1c4886be2e78969$var$copySymbolsIn(source, object) {
    return $946c3567cd1eca09$exports(source, $16a39bae69329d4a$exports(source), object);
}
$a1c4886be2e78969$exports = $a1c4886be2e78969$var$copySymbolsIn;



var $d96eb3f64e9e710d$exports = {};



/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $d96eb3f64e9e710d$var$getAllKeysIn(object) {
    return $b1a0ca0ccb510d6a$exports(object, $7b0f7206cc15891e$exports, $16a39bae69329d4a$exports);
}
$d96eb3f64e9e710d$exports = $d96eb3f64e9e710d$var$getAllKeysIn;



var $6f8bd9feeafc4f7c$exports = {};
/** Used for built-in method references. */ var $6f8bd9feeafc4f7c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $6f8bd9feeafc4f7c$var$hasOwnProperty = $6f8bd9feeafc4f7c$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $6f8bd9feeafc4f7c$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $6f8bd9feeafc4f7c$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
$6f8bd9feeafc4f7c$exports = $6f8bd9feeafc4f7c$var$initCloneArray;


var $462ae50cee24fd17$exports = {};
var $908ec6c2ac01822f$exports = {};

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $908ec6c2ac01822f$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $10c9c0e2a3f39745$exports(result).set(new $10c9c0e2a3f39745$exports(arrayBuffer));
    return result;
}
$908ec6c2ac01822f$exports = $908ec6c2ac01822f$var$cloneArrayBuffer;


var $7da71b2adab956c8$exports = {};

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $7da71b2adab956c8$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $908ec6c2ac01822f$exports(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
$7da71b2adab956c8$exports = $7da71b2adab956c8$var$cloneDataView;


var $075f5ca76566cc95$exports = {};
/** Used to match `RegExp` flags from their coerced string values. */ var $075f5ca76566cc95$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $075f5ca76566cc95$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $075f5ca76566cc95$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
$075f5ca76566cc95$exports = $075f5ca76566cc95$var$cloneRegExp;


var $09231320d4788351$exports = {};

/** Used to convert symbols to primitives and strings. */ var $09231320d4788351$var$symbolProto = $a0a60054fa51f19c$exports ? $a0a60054fa51f19c$exports.prototype : undefined, $09231320d4788351$var$symbolValueOf = $09231320d4788351$var$symbolProto ? $09231320d4788351$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $09231320d4788351$var$cloneSymbol(symbol) {
    return $09231320d4788351$var$symbolValueOf ? Object($09231320d4788351$var$symbolValueOf.call(symbol)) : {};
}
$09231320d4788351$exports = $09231320d4788351$var$cloneSymbol;


var $66a62ea11531e039$exports = {};

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $66a62ea11531e039$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $908ec6c2ac01822f$exports(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
$66a62ea11531e039$exports = $66a62ea11531e039$var$cloneTypedArray;


/** `Object#toString` result references. */ var $462ae50cee24fd17$var$boolTag = '[object Boolean]', $462ae50cee24fd17$var$dateTag = '[object Date]', $462ae50cee24fd17$var$mapTag = '[object Map]', $462ae50cee24fd17$var$numberTag = '[object Number]', $462ae50cee24fd17$var$regexpTag = '[object RegExp]', $462ae50cee24fd17$var$setTag = '[object Set]', $462ae50cee24fd17$var$stringTag = '[object String]', $462ae50cee24fd17$var$symbolTag = '[object Symbol]';
var $462ae50cee24fd17$var$arrayBufferTag = '[object ArrayBuffer]', $462ae50cee24fd17$var$dataViewTag = '[object DataView]', $462ae50cee24fd17$var$float32Tag = '[object Float32Array]', $462ae50cee24fd17$var$float64Tag = '[object Float64Array]', $462ae50cee24fd17$var$int8Tag = '[object Int8Array]', $462ae50cee24fd17$var$int16Tag = '[object Int16Array]', $462ae50cee24fd17$var$int32Tag = '[object Int32Array]', $462ae50cee24fd17$var$uint8Tag = '[object Uint8Array]', $462ae50cee24fd17$var$uint8ClampedTag = '[object Uint8ClampedArray]', $462ae50cee24fd17$var$uint16Tag = '[object Uint16Array]', $462ae50cee24fd17$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $462ae50cee24fd17$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $462ae50cee24fd17$var$arrayBufferTag:
            return $908ec6c2ac01822f$exports(object);
        case $462ae50cee24fd17$var$boolTag:
        case $462ae50cee24fd17$var$dateTag:
            return new Ctor(+object);
        case $462ae50cee24fd17$var$dataViewTag:
            return $7da71b2adab956c8$exports(object, isDeep);
        case $462ae50cee24fd17$var$float32Tag:
        case $462ae50cee24fd17$var$float64Tag:
        case $462ae50cee24fd17$var$int8Tag:
        case $462ae50cee24fd17$var$int16Tag:
        case $462ae50cee24fd17$var$int32Tag:
        case $462ae50cee24fd17$var$uint8Tag:
        case $462ae50cee24fd17$var$uint8ClampedTag:
        case $462ae50cee24fd17$var$uint16Tag:
        case $462ae50cee24fd17$var$uint32Tag:
            return $66a62ea11531e039$exports(object, isDeep);
        case $462ae50cee24fd17$var$mapTag:
            return new Ctor;
        case $462ae50cee24fd17$var$numberTag:
        case $462ae50cee24fd17$var$stringTag:
            return new Ctor(object);
        case $462ae50cee24fd17$var$regexpTag:
            return $075f5ca76566cc95$exports(object);
        case $462ae50cee24fd17$var$setTag:
            return new Ctor;
        case $462ae50cee24fd17$var$symbolTag:
            return $09231320d4788351$exports(object);
    }
}
$462ae50cee24fd17$exports = $462ae50cee24fd17$var$initCloneByTag;


var $88ab91d77d37bedb$exports = {};
var $1104b3e74cde6c90$exports = {};

/** Built-in value references. */ var $1104b3e74cde6c90$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $1104b3e74cde6c90$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$478ac5aeb3a35670$exports(proto)) return {};
        if ($1104b3e74cde6c90$var$objectCreate) return $1104b3e74cde6c90$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
$1104b3e74cde6c90$exports = $1104b3e74cde6c90$var$baseCreate;




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $88ab91d77d37bedb$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !$962d7e9f98268bad$exports(object) ? $1104b3e74cde6c90$exports($157c500be85b0f64$exports(object)) : {};
}
$88ab91d77d37bedb$exports = $88ab91d77d37bedb$var$initCloneObject;




var $48wd1 = parcelRequire("48wd1");
var $4f148a1f5c86d165$exports = {};
var $c52f98aa35e6bbc6$exports = {};


/** `Object#toString` result references. */ var $c52f98aa35e6bbc6$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $c52f98aa35e6bbc6$var$baseIsMap(value) {
    return $5cc8d9ad91c06863$exports(value) && $67ae2614b625b36c$exports(value) == $c52f98aa35e6bbc6$var$mapTag;
}
$c52f98aa35e6bbc6$exports = $c52f98aa35e6bbc6$var$baseIsMap;




var $lw6rp = parcelRequire("lw6rp");
/* Node.js helper references. */ var $4f148a1f5c86d165$var$nodeIsMap = $lw6rp && $lw6rp.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $4f148a1f5c86d165$var$isMap = $4f148a1f5c86d165$var$nodeIsMap ? $a0ea4d8fc1f42197$exports($4f148a1f5c86d165$var$nodeIsMap) : $c52f98aa35e6bbc6$exports;
$4f148a1f5c86d165$exports = $4f148a1f5c86d165$var$isMap;



var $0e20e4532105f01d$exports = {};
var $256ba3d8efc6cf90$exports = {};


/** `Object#toString` result references. */ var $256ba3d8efc6cf90$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $256ba3d8efc6cf90$var$baseIsSet(value) {
    return $5cc8d9ad91c06863$exports(value) && $67ae2614b625b36c$exports(value) == $256ba3d8efc6cf90$var$setTag;
}
$256ba3d8efc6cf90$exports = $256ba3d8efc6cf90$var$baseIsSet;




var $lw6rp = parcelRequire("lw6rp");
/* Node.js helper references. */ var $0e20e4532105f01d$var$nodeIsSet = $lw6rp && $lw6rp.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $0e20e4532105f01d$var$isSet = $0e20e4532105f01d$var$nodeIsSet ? $a0ea4d8fc1f42197$exports($0e20e4532105f01d$var$nodeIsSet) : $256ba3d8efc6cf90$exports;
$0e20e4532105f01d$exports = $0e20e4532105f01d$var$isSet;




/** Used to compose bitmasks for cloning. */ var $f0d000f2fdfd6cc8$var$CLONE_DEEP_FLAG = 1, $f0d000f2fdfd6cc8$var$CLONE_FLAT_FLAG = 2, $f0d000f2fdfd6cc8$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $f0d000f2fdfd6cc8$var$argsTag = '[object Arguments]', $f0d000f2fdfd6cc8$var$arrayTag = '[object Array]', $f0d000f2fdfd6cc8$var$boolTag = '[object Boolean]', $f0d000f2fdfd6cc8$var$dateTag = '[object Date]', $f0d000f2fdfd6cc8$var$errorTag = '[object Error]', $f0d000f2fdfd6cc8$var$funcTag = '[object Function]', $f0d000f2fdfd6cc8$var$genTag = '[object GeneratorFunction]', $f0d000f2fdfd6cc8$var$mapTag = '[object Map]', $f0d000f2fdfd6cc8$var$numberTag = '[object Number]', $f0d000f2fdfd6cc8$var$objectTag = '[object Object]', $f0d000f2fdfd6cc8$var$regexpTag = '[object RegExp]', $f0d000f2fdfd6cc8$var$setTag = '[object Set]', $f0d000f2fdfd6cc8$var$stringTag = '[object String]', $f0d000f2fdfd6cc8$var$symbolTag = '[object Symbol]', $f0d000f2fdfd6cc8$var$weakMapTag = '[object WeakMap]';
var $f0d000f2fdfd6cc8$var$arrayBufferTag = '[object ArrayBuffer]', $f0d000f2fdfd6cc8$var$dataViewTag = '[object DataView]', $f0d000f2fdfd6cc8$var$float32Tag = '[object Float32Array]', $f0d000f2fdfd6cc8$var$float64Tag = '[object Float64Array]', $f0d000f2fdfd6cc8$var$int8Tag = '[object Int8Array]', $f0d000f2fdfd6cc8$var$int16Tag = '[object Int16Array]', $f0d000f2fdfd6cc8$var$int32Tag = '[object Int32Array]', $f0d000f2fdfd6cc8$var$uint8Tag = '[object Uint8Array]', $f0d000f2fdfd6cc8$var$uint8ClampedTag = '[object Uint8ClampedArray]', $f0d000f2fdfd6cc8$var$uint16Tag = '[object Uint16Array]', $f0d000f2fdfd6cc8$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $f0d000f2fdfd6cc8$var$cloneableTags = {};
$f0d000f2fdfd6cc8$var$cloneableTags[$f0d000f2fdfd6cc8$var$argsTag] = $f0d000f2fdfd6cc8$var$cloneableTags[$f0d000f2fdfd6cc8$var$arrayTag] = $f0d000f2fdfd6cc8$var$cloneableTags[$f0d000f2fdfd6cc8$var$arrayBufferTag] = $f0d000f2fdfd6cc8$var$cloneableTags[$f0d000f2fdfd6cc8$var$dataViewTag] = $f0d000f2fdfd6cc8$var$cloneableTags[$f0d000f2fdfd6cc8$var$boolTag] = $f0d000f2fdfd6cc8$var$cloneableTags[$f0d000f2fdfd6cc8$var$dateTag] = $f0d000f2fdfd6cc8$var$cloneableTags[$f0d000f2fdfd6cc8$var$float32Tag] = $f0d000f2fdfd6cc8$var$cloneableTags[$f0d000f2fdfd6cc8$var$float64Tag] = $f0d000f2fdfd6cc8$var$cloneableTags[$f0d000f2fdfd6cc8$var$int8Tag] = $f0d000f2fdfd6cc8$var$cloneableTags[$f0d000f2fdfd6cc8$var$int16Tag] = $f0d000f2fdfd6cc8$var$cloneableTags[$f0d000f2fdfd6cc8$var$int32Tag] = $f0d000f2fdfd6cc8$var$cloneableTags[$f0d000f2fdfd6cc8$var$mapTag] = $f0d000f2fdfd6cc8$var$cloneableTags[$f0d000f2fdfd6cc8$var$numberTag] = $f0d000f2fdfd6cc8$var$cloneableTags[$f0d000f2fdfd6cc8$var$objectTag] = $f0d000f2fdfd6cc8$var$cloneableTags[$f0d000f2fdfd6cc8$var$regexpTag] = $f0d000f2fdfd6cc8$var$cloneableTags[$f0d000f2fdfd6cc8$var$setTag] = $f0d000f2fdfd6cc8$var$cloneableTags[$f0d000f2fdfd6cc8$var$stringTag] = $f0d000f2fdfd6cc8$var$cloneableTags[$f0d000f2fdfd6cc8$var$symbolTag] = $f0d000f2fdfd6cc8$var$cloneableTags[$f0d000f2fdfd6cc8$var$uint8Tag] = $f0d000f2fdfd6cc8$var$cloneableTags[$f0d000f2fdfd6cc8$var$uint8ClampedTag] = $f0d000f2fdfd6cc8$var$cloneableTags[$f0d000f2fdfd6cc8$var$uint16Tag] = $f0d000f2fdfd6cc8$var$cloneableTags[$f0d000f2fdfd6cc8$var$uint32Tag] = true;
$f0d000f2fdfd6cc8$var$cloneableTags[$f0d000f2fdfd6cc8$var$errorTag] = $f0d000f2fdfd6cc8$var$cloneableTags[$f0d000f2fdfd6cc8$var$funcTag] = $f0d000f2fdfd6cc8$var$cloneableTags[$f0d000f2fdfd6cc8$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $f0d000f2fdfd6cc8$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $f0d000f2fdfd6cc8$var$CLONE_DEEP_FLAG, isFlat = bitmask & $f0d000f2fdfd6cc8$var$CLONE_FLAT_FLAG, isFull = bitmask & $f0d000f2fdfd6cc8$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$478ac5aeb3a35670$exports(value)) return value;
    var isArr = $97dae14ba26fc62d$exports(value);
    if (isArr) {
        result = $6f8bd9feeafc4f7c$exports(value);
        if (!isDeep) return $0969e613d28b017c$exports(value, result);
    } else {
        var tag = $67ae2614b625b36c$exports(value), isFunc = tag == $f0d000f2fdfd6cc8$var$funcTag || tag == $f0d000f2fdfd6cc8$var$genTag;
        if ($48wd1(value)) return $iGrNT(value, isDeep);
        if (tag == $f0d000f2fdfd6cc8$var$objectTag || tag == $f0d000f2fdfd6cc8$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $88ab91d77d37bedb$exports(value);
            if (!isDeep) return isFlat ? $a1c4886be2e78969$exports(value, $8ed3ac63bdcdde1f$exports(result, value)) : $cce37feba06ec390$exports(value, $232e8a10b10fa897$exports(result, value));
        } else {
            if (!$f0d000f2fdfd6cc8$var$cloneableTags[tag]) return object ? value : {};
            result = $462ae50cee24fd17$exports(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $5614867d3628ea39$exports);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($0e20e4532105f01d$exports(value)) value.forEach(function(subValue) {
        result.add($f0d000f2fdfd6cc8$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($4f148a1f5c86d165$exports(value)) value.forEach(function(subValue, key) {
        result.set(key, $f0d000f2fdfd6cc8$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $d96eb3f64e9e710d$exports : $907cb5a478bb2c95$exports : isFlat ? $7b0f7206cc15891e$exports : $a5f07da1d5d1d6dc$exports;
    var props = isArr ? undefined : keysFunc(value);
    $ef9fc0c99a56feec$exports(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $c2877cc0402576dd$exports(result, key, $f0d000f2fdfd6cc8$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
$f0d000f2fdfd6cc8$exports = $f0d000f2fdfd6cc8$var$baseClone;


/** Used to compose bitmasks for cloning. */ var $660ac3c604cbb0a6$var$CLONE_DEEP_FLAG = 1, $660ac3c604cbb0a6$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $660ac3c604cbb0a6$var$cloneDeep(value) {
    return $f0d000f2fdfd6cc8$exports(value, $660ac3c604cbb0a6$var$CLONE_DEEP_FLAG | $660ac3c604cbb0a6$var$CLONE_SYMBOLS_FLAG);
}
$660ac3c604cbb0a6$exports = $660ac3c604cbb0a6$var$cloneDeep;


var $1a673cb097f9c8e0$var$_cloneDeep3 = $1a673cb097f9c8e0$var$_interopRequireDefault($660ac3c604cbb0a6$exports);
var $1a673cb097f9c8e0$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $1a673cb097f9c8e0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1a673cb097f9c8e0$var$mergeClasses = $1a673cb097f9c8e0$exports.mergeClasses = function mergeClasses(classes) {
    var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var styles = classes.default && (0, $1a673cb097f9c8e0$var$_cloneDeep3.default)(classes.default) || {};
    activeNames.map(function(name) {
        var toMerge = classes[name];
        if (toMerge) (0, $1a673cb097f9c8e0$var$_forOwn3.default)(toMerge, function(value, key) {
            if (!styles[key]) styles[key] = {};
            styles[key] = $1a673cb097f9c8e0$var$_extends({}, styles[key], toMerge[key]);
        });
        return name;
    });
    return styles;
};
$1a673cb097f9c8e0$exports.default = $1a673cb097f9c8e0$var$mergeClasses;


var $bb2c8b52dc31f705$var$_mergeClasses2 = $bb2c8b52dc31f705$var$_interopRequireDefault($1a673cb097f9c8e0$exports);
var $f82c589933586a58$exports = {};
'use strict';
Object.defineProperty($f82c589933586a58$exports, "__esModule", {
    value: true
});
$f82c589933586a58$exports.autoprefix = undefined;

var $f82c589933586a58$var$_forOwn3 = $f82c589933586a58$var$_interopRequireDefault($f9b1acfc174f8d1d$exports);
var $f82c589933586a58$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $f82c589933586a58$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $f82c589933586a58$var$transforms = {
    borderRadius: function borderRadius(value) {
        return {
            msBorderRadius: value,
            MozBorderRadius: value,
            OBorderRadius: value,
            WebkitBorderRadius: value,
            borderRadius: value
        };
    },
    boxShadow: function boxShadow(value) {
        return {
            msBoxShadow: value,
            MozBoxShadow: value,
            OBoxShadow: value,
            WebkitBoxShadow: value,
            boxShadow: value
        };
    },
    userSelect: function userSelect(value) {
        return {
            WebkitTouchCallout: value,
            KhtmlUserSelect: value,
            MozUserSelect: value,
            msUserSelect: value,
            WebkitUserSelect: value,
            userSelect: value
        };
    },
    flex: function flex(value) {
        return {
            WebkitBoxFlex: value,
            MozBoxFlex: value,
            WebkitFlex: value,
            msFlex: value,
            flex: value
        };
    },
    flexBasis: function flexBasis(value) {
        return {
            WebkitFlexBasis: value,
            flexBasis: value
        };
    },
    justifyContent: function justifyContent(value) {
        return {
            WebkitJustifyContent: value,
            justifyContent: value
        };
    },
    transition: function transition(value) {
        return {
            msTransition: value,
            MozTransition: value,
            OTransition: value,
            WebkitTransition: value,
            transition: value
        };
    },
    transform: function transform(value) {
        return {
            msTransform: value,
            MozTransform: value,
            OTransform: value,
            WebkitTransform: value,
            transform: value
        };
    },
    absolute: function absolute(value) {
        var direction = value && value.split(' ');
        return {
            position: 'absolute',
            top: direction && direction[0],
            right: direction && direction[1],
            bottom: direction && direction[2],
            left: direction && direction[3]
        };
    },
    extend: function extend(name, otherElementStyles) {
        var otherStyle = otherElementStyles[name];
        if (otherStyle) return otherStyle;
        return {
            'extend': name
        };
    }
};
var $f82c589933586a58$var$autoprefix = $f82c589933586a58$exports.autoprefix = function autoprefix(elements) {
    var prefixed = {};
    (0, $f82c589933586a58$var$_forOwn3.default)(elements, function(styles, element) {
        var expanded = {};
        (0, $f82c589933586a58$var$_forOwn3.default)(styles, function(value, key) {
            var transform = $f82c589933586a58$var$transforms[key];
            if (transform) expanded = $f82c589933586a58$var$_extends({}, expanded, transform(value));
            else expanded[key] = value;
        });
        prefixed[element] = expanded;
    });
    return prefixed;
};
$f82c589933586a58$exports.default = $f82c589933586a58$var$autoprefix;


var $bb2c8b52dc31f705$var$_autoprefix2 = $bb2c8b52dc31f705$var$_interopRequireDefault($f82c589933586a58$exports);
var $1d35e0257cb095b6$exports = {};
'use strict';
Object.defineProperty($1d35e0257cb095b6$exports, "__esModule", {
    value: true
});
$1d35e0257cb095b6$exports.hover = undefined;
var $1d35e0257cb095b6$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $8FY87 = parcelRequire("8FY87");
var $1d35e0257cb095b6$var$_react2 = $1d35e0257cb095b6$var$_interopRequireDefault($8FY87);
function $1d35e0257cb095b6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1d35e0257cb095b6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1d35e0257cb095b6$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $1d35e0257cb095b6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $1d35e0257cb095b6$var$hover = $1d35e0257cb095b6$exports.hover = function hover(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
    return function(_React$Component) {
        $1d35e0257cb095b6$var$_inherits(Hover, _React$Component);
        function Hover() {
            var _ref;
            var _temp, _this, _ret;
            $1d35e0257cb095b6$var$_classCallCheck(this, Hover);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $1d35e0257cb095b6$var$_possibleConstructorReturn(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                hover: false
            }, _this.handleMouseOver = function() {
                return _this.setState({
                    hover: true
                });
            }, _this.handleMouseOut = function() {
                return _this.setState({
                    hover: false
                });
            }, _this.render = function() {
                return $1d35e0257cb095b6$var$_react2.default.createElement(Span, {
                    onMouseOver: _this.handleMouseOver,
                    onMouseOut: _this.handleMouseOut
                }, $1d35e0257cb095b6$var$_react2.default.createElement(Component, $1d35e0257cb095b6$var$_extends({}, _this.props, _this.state)));
            }, _temp), $1d35e0257cb095b6$var$_possibleConstructorReturn(_this, _ret);
        }
        return Hover;
    }($1d35e0257cb095b6$var$_react2.default.Component);
};
$1d35e0257cb095b6$exports.default = $1d35e0257cb095b6$var$hover;


var $bb2c8b52dc31f705$var$_hover3 = $bb2c8b52dc31f705$var$_interopRequireDefault($1d35e0257cb095b6$exports);
var $f3f0987a205938e9$exports = {};
'use strict';
Object.defineProperty($f3f0987a205938e9$exports, "__esModule", {
    value: true
});
$f3f0987a205938e9$exports.active = undefined;
var $f3f0987a205938e9$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $8FY87 = parcelRequire("8FY87");
var $f3f0987a205938e9$var$_react2 = $f3f0987a205938e9$var$_interopRequireDefault($8FY87);
function $f3f0987a205938e9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f3f0987a205938e9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f3f0987a205938e9$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $f3f0987a205938e9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $f3f0987a205938e9$var$active = $f3f0987a205938e9$exports.active = function active(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
    return function(_React$Component) {
        $f3f0987a205938e9$var$_inherits(Active, _React$Component);
        function Active() {
            var _ref;
            var _temp, _this, _ret;
            $f3f0987a205938e9$var$_classCallCheck(this, Active);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $f3f0987a205938e9$var$_possibleConstructorReturn(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                active: false
            }, _this.handleMouseDown = function() {
                return _this.setState({
                    active: true
                });
            }, _this.handleMouseUp = function() {
                return _this.setState({
                    active: false
                });
            }, _this.render = function() {
                return $f3f0987a205938e9$var$_react2.default.createElement(Span, {
                    onMouseDown: _this.handleMouseDown,
                    onMouseUp: _this.handleMouseUp
                }, $f3f0987a205938e9$var$_react2.default.createElement(Component, $f3f0987a205938e9$var$_extends({}, _this.props, _this.state)));
            }, _temp), $f3f0987a205938e9$var$_possibleConstructorReturn(_this, _ret);
        }
        return Active;
    }($f3f0987a205938e9$var$_react2.default.Component);
};
$f3f0987a205938e9$exports.default = $f3f0987a205938e9$var$active;


var $bb2c8b52dc31f705$var$_active2 = $bb2c8b52dc31f705$var$_interopRequireDefault($f3f0987a205938e9$exports);
var $f6219cde3a3c4c22$exports = {};
'use strict';
Object.defineProperty($f6219cde3a3c4c22$exports, "__esModule", {
    value: true
});
var $f6219cde3a3c4c22$var$loopable = function loopable(i, length) {
    var props = {};
    var setProp = function setProp(name) {
        var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        props[name] = value;
    };
    i === 0 && setProp('first-child');
    i === length - 1 && setProp('last-child');
    (i === 0 || i % 2 === 0) && setProp('even');
    Math.abs(i % 2) === 1 && setProp('odd');
    setProp('nth-child', i);
    return props;
};
$f6219cde3a3c4c22$exports.default = $f6219cde3a3c4c22$var$loopable;


var $bb2c8b52dc31f705$var$_loop3 = $bb2c8b52dc31f705$var$_interopRequireDefault($f6219cde3a3c4c22$exports);
function $bb2c8b52dc31f705$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$bb2c8b52dc31f705$exports.hover = $bb2c8b52dc31f705$var$_hover3.default;
$bb2c8b52dc31f705$exports.handleHover = $bb2c8b52dc31f705$var$_hover3.default;
$bb2c8b52dc31f705$exports.handleActive = $bb2c8b52dc31f705$var$_active2.default;
$bb2c8b52dc31f705$exports.loop = $bb2c8b52dc31f705$var$_loop3.default;
var $bb2c8b52dc31f705$var$ReactCSS = $bb2c8b52dc31f705$exports.ReactCSS = function ReactCSS(classes) {
    for(var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)activations[_key - 1] = arguments[_key];
    var activeNames = (0, $bb2c8b52dc31f705$var$_flattenNames2.default)(activations);
    var merged = (0, $bb2c8b52dc31f705$var$_mergeClasses2.default)(classes, activeNames);
    return (0, $bb2c8b52dc31f705$var$_autoprefix2.default)(merged);
};
$bb2c8b52dc31f705$exports.default = $bb2c8b52dc31f705$var$ReactCSS;



var $8FY87 = parcelRequire("8FY87");

var $6cbb5b3811748d32$export$a056a977bf6a9a3c = function calculateChange(e, hsl, direction, initialA, container) {
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (direction === 'vertical') {
        var a = void 0;
        if (top < 0) a = 0;
        else if (top > containerHeight) a = 1;
        else a = Math.round(top * 100 / containerHeight) / 100;
        if (hsl.a !== a) return {
            h: hsl.h,
            s: hsl.s,
            l: hsl.l,
            a: a,
            source: 'rgb'
        };
    } else {
        var _a = void 0;
        if (left < 0) _a = 0;
        else if (left > containerWidth) _a = 1;
        else _a = Math.round(left * 100 / containerWidth) / 100;
        if (initialA !== _a) return {
            h: hsl.h,
            s: hsl.s,
            l: hsl.l,
            a: _a,
            source: 'rgb'
        };
    }
    return null;
};



var $8FY87 = parcelRequire("8FY87");

var $ac8438da8dcc22f8$var$checkboardCache = {};
var $ac8438da8dcc22f8$export$b3890eb0ae9dca99 = function render(c1, c2, size, serverCanvas) {
    if (typeof document === 'undefined' && !serverCanvas) return null;
    var canvas = serverCanvas ? new serverCanvas() : document.createElement('canvas');
    canvas.width = size * 2;
    canvas.height = size * 2;
    var ctx = canvas.getContext('2d');
    if (!ctx) return null;
     // If no context can be found, return early.
    ctx.fillStyle = c1;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = c2;
    ctx.fillRect(0, 0, size, size);
    ctx.translate(size, size);
    ctx.fillRect(0, 0, size, size);
    return canvas.toDataURL();
};
var $ac8438da8dcc22f8$export$3988ae62b71be9a3 = function get(c1, c2, size, serverCanvas) {
    var key = c1 + '-' + c2 + '-' + size + (serverCanvas ? '-server' : '');
    if ($ac8438da8dcc22f8$var$checkboardCache[key]) return $ac8438da8dcc22f8$var$checkboardCache[key];
    var checkboard = $ac8438da8dcc22f8$export$b3890eb0ae9dca99(c1, c2, size, serverCanvas);
    $ac8438da8dcc22f8$var$checkboardCache[key] = checkboard;
    return checkboard;
};


var $41a8f0ec8c9e9c24$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $41a8f0ec8c9e9c24$export$457ff74489f64b4a = function Checkboard(_ref) {
    var white = _ref.white, grey = _ref.grey, size = _ref.size, renderers = _ref.renderers, borderRadius = _ref.borderRadius, boxShadow = _ref.boxShadow, children = _ref.children;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))({
        'default': {
            grid: {
                borderRadius: borderRadius,
                boxShadow: boxShadow,
                absolute: '0px 0px 0px 0px',
                background: 'url(' + $ac8438da8dcc22f8$export$3988ae62b71be9a3(white, grey, size, renderers.canvas) + ') center left'
            }
        }
    });
    return (0, $8FY87.isValidElement)(children) ? (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).cloneElement(children, $41a8f0ec8c9e9c24$var$_extends({}, children.props, {
        style: $41a8f0ec8c9e9c24$var$_extends({}, children.props.style, styles.grid)
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.grid
    });
};
$41a8f0ec8c9e9c24$export$457ff74489f64b4a.defaultProps = {
    size: 8,
    white: 'transparent',
    grey: 'rgba(0,0,0,.08)',
    renderers: {}
};
var $41a8f0ec8c9e9c24$export$2e2bcd8739ae039 = $41a8f0ec8c9e9c24$export$457ff74489f64b4a;


var $5f0e862746c8c551$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $5f0e862746c8c551$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $5f0e862746c8c551$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5f0e862746c8c551$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $5f0e862746c8c551$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $5f0e862746c8c551$export$b3d0ceb706f8af43 = function(_ref) {
    $5f0e862746c8c551$var$_inherits(Alpha, _ref);
    function Alpha() {
        var _ref2;
        var _temp, _this, _ret;
        $5f0e862746c8c551$var$_classCallCheck(this, Alpha);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $5f0e862746c8c551$var$_possibleConstructorReturn(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [
            this
        ].concat(args))), _this), _this.handleChange = function(e) {
            var change = $6cbb5b3811748d32$export$a056a977bf6a9a3c(e, _this.props.hsl, _this.props.direction, _this.props.a, _this.container);
            change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
        }, _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            window.addEventListener('mousemove', _this.handleChange);
            window.addEventListener('mouseup', _this.handleMouseUp);
        }, _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        }, _this.unbindEventListeners = function() {
            window.removeEventListener('mousemove', _this.handleChange);
            window.removeEventListener('mouseup', _this.handleMouseUp);
        }, _temp), $5f0e862746c8c551$var$_possibleConstructorReturn(_this, _ret);
    }
    $5f0e862746c8c551$var$_createClass(Alpha, [
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var rgb = this.props.rgb;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))({
                    'default': {
                        alpha: {
                            absolute: '0px 0px 0px 0px',
                            borderRadius: this.props.radius
                        },
                        checkboard: {
                            absolute: '0px 0px 0px 0px',
                            overflow: 'hidden',
                            borderRadius: this.props.radius
                        },
                        gradient: {
                            absolute: '0px 0px 0px 0px',
                            background: 'linear-gradient(to right, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)',
                            boxShadow: this.props.shadow,
                            borderRadius: this.props.radius
                        },
                        container: {
                            position: 'relative',
                            height: '100%',
                            margin: '0 3px'
                        },
                        pointer: {
                            position: 'absolute',
                            left: rgb.a * 100 + '%'
                        },
                        slider: {
                            width: '4px',
                            borderRadius: '1px',
                            height: '8px',
                            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
                            background: '#fff',
                            marginTop: '1px',
                            transform: 'translateX(-2px)'
                        }
                    },
                    'vertical': {
                        gradient: {
                            background: 'linear-gradient(to bottom, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)'
                        },
                        pointer: {
                            left: 0,
                            top: rgb.a * 100 + '%'
                        }
                    },
                    'overwrite': $5f0e862746c8c551$var$_extends({}, this.props.style)
                }, {
                    vertical: this.props.direction === 'vertical',
                    overwrite: true
                });
                return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.alpha
                }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.checkboard
                }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $41a8f0ec8c9e9c24$export$2e2bcd8739ae039), {
                    renderers: this.props.renderers
                })), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.gradient
                }), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.container,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.pointer
                }, this.props.pointer ? (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement(this.props.pointer, this.props) : (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.slider
                }))));
            }
        }
    ]);
    return Alpha;
}((0, $8FY87.PureComponent) || (0, $8FY87.Component));
var $5f0e862746c8c551$export$2e2bcd8739ae039 = $5f0e862746c8c551$export$b3d0ceb706f8af43;




var $8FY87 = parcelRequire("8FY87");

var $5e4e3784fbcdba0a$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $5e4e3784fbcdba0a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5e4e3784fbcdba0a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5e4e3784fbcdba0a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $5e4e3784fbcdba0a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $5e4e3784fbcdba0a$var$DEFAULT_ARROW_OFFSET = 1;
var $5e4e3784fbcdba0a$var$UP_KEY_CODE = 38;
var $5e4e3784fbcdba0a$var$DOWN_KEY_CODE = 40;
var $5e4e3784fbcdba0a$var$VALID_KEY_CODES = [
    $5e4e3784fbcdba0a$var$UP_KEY_CODE,
    $5e4e3784fbcdba0a$var$DOWN_KEY_CODE
];
var $5e4e3784fbcdba0a$var$isValidKeyCode = function isValidKeyCode(keyCode) {
    return $5e4e3784fbcdba0a$var$VALID_KEY_CODES.indexOf(keyCode) > -1;
};
var $5e4e3784fbcdba0a$var$getNumberValue = function getNumberValue(value) {
    return Number(String(value).replace(/%/g, ''));
};
var $5e4e3784fbcdba0a$var$idCounter = 1;
var $5e4e3784fbcdba0a$export$bfb3cbb78d3c298 = function(_ref) {
    $5e4e3784fbcdba0a$var$_inherits(EditableInput, _ref);
    function EditableInput(props) {
        $5e4e3784fbcdba0a$var$_classCallCheck(this, EditableInput);
        var _this = $5e4e3784fbcdba0a$var$_possibleConstructorReturn(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));
        _this.handleBlur = function() {
            if (_this.state.blurValue) _this.setState({
                value: _this.state.blurValue,
                blurValue: null
            });
        };
        _this.handleChange = function(e) {
            _this.setUpdatedValue(e.target.value, e);
        };
        _this.handleKeyDown = function(e) {
            // In case `e.target.value` is a percentage remove the `%` character
            // and update accordingly with a percentage
            // https://github.com/casesandberg/react-color/issues/383
            var value = $5e4e3784fbcdba0a$var$getNumberValue(e.target.value);
            if (!isNaN(value) && $5e4e3784fbcdba0a$var$isValidKeyCode(e.keyCode)) {
                var offset = _this.getArrowOffset();
                var updatedValue = e.keyCode === $5e4e3784fbcdba0a$var$UP_KEY_CODE ? value + offset : value - offset;
                _this.setUpdatedValue(updatedValue, e);
            }
        };
        _this.handleDrag = function(e) {
            if (_this.props.dragLabel) {
                var newValue = Math.round(_this.props.value + e.movementX);
                if (newValue >= 0 && newValue <= _this.props.dragMax) _this.props.onChange && _this.props.onChange(_this.getValueObjectWithLabel(newValue), e);
            }
        };
        _this.handleMouseDown = function(e) {
            if (_this.props.dragLabel) {
                e.preventDefault();
                _this.handleDrag(e);
                window.addEventListener('mousemove', _this.handleDrag);
                window.addEventListener('mouseup', _this.handleMouseUp);
            }
        };
        _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        };
        _this.unbindEventListeners = function() {
            window.removeEventListener('mousemove', _this.handleDrag);
            window.removeEventListener('mouseup', _this.handleMouseUp);
        };
        _this.state = {
            value: String(props.value).toUpperCase(),
            blurValue: String(props.value).toUpperCase()
        };
        _this.inputId = 'rc-editable-input-' + $5e4e3784fbcdba0a$var$idCounter++;
        return _this;
    }
    $5e4e3784fbcdba0a$var$_createClass(EditableInput, [
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.value !== this.state.value && (prevProps.value !== this.props.value || prevState.value !== this.state.value)) {
                    if (this.input === document.activeElement) this.setState({
                        blurValue: String(this.props.value).toUpperCase()
                    });
                    else this.setState({
                        value: String(this.props.value).toUpperCase(),
                        blurValue: !this.state.blurValue && String(this.props.value).toUpperCase()
                    });
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: 'getValueObjectWithLabel',
            value: function getValueObjectWithLabel(value) {
                return $5e4e3784fbcdba0a$var$_defineProperty({}, this.props.label, value);
            }
        },
        {
            key: 'getArrowOffset',
            value: function getArrowOffset() {
                return this.props.arrowOffset || $5e4e3784fbcdba0a$var$DEFAULT_ARROW_OFFSET;
            }
        },
        {
            key: 'setUpdatedValue',
            value: function setUpdatedValue(value, e) {
                var onChangeValue = this.props.label ? this.getValueObjectWithLabel(value) : value;
                this.props.onChange && this.props.onChange(onChangeValue, e);
                this.setState({
                    value: value
                });
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))({
                    'default': {
                        wrap: {
                            position: 'relative'
                        }
                    },
                    'user-override': {
                        wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
                        input: this.props.style && this.props.style.input ? this.props.style.input : {},
                        label: this.props.style && this.props.style.label ? this.props.style.label : {}
                    },
                    'dragLabel-true': {
                        label: {
                            cursor: 'ew-resize'
                        }
                    }
                }, {
                    'user-override': true
                }, this.props);
                return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.wrap
                }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('input', {
                    id: this.inputId,
                    style: styles.input,
                    ref: function ref(input) {
                        return _this2.input = input;
                    },
                    value: this.state.value,
                    onKeyDown: this.handleKeyDown,
                    onChange: this.handleChange,
                    onBlur: this.handleBlur,
                    placeholder: this.props.placeholder,
                    spellCheck: 'false'
                }), this.props.label && !this.props.hideLabel ? (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('label', {
                    htmlFor: this.inputId,
                    style: styles.label,
                    onMouseDown: this.handleMouseDown
                }, this.props.label) : null);
            }
        }
    ]);
    return EditableInput;
}((0, $8FY87.PureComponent) || (0, $8FY87.Component));
var $5e4e3784fbcdba0a$export$2e2bcd8739ae039 = $5e4e3784fbcdba0a$export$bfb3cbb78d3c298;



var $8FY87 = parcelRequire("8FY87");

var $4e9e4ec5ef541481$export$a056a977bf6a9a3c = function calculateChange(e, direction, hsl, container) {
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (direction === 'vertical') {
        var h = void 0;
        if (top < 0) h = 359;
        else if (top > containerHeight) h = 0;
        else {
            var percent = -(top * 100 / containerHeight) + 100;
            h = 360 * percent / 100;
        }
        if (hsl.h !== h) return {
            h: h,
            s: hsl.s,
            l: hsl.l,
            a: hsl.a,
            source: 'hsl'
        };
    } else {
        var _h = void 0;
        if (left < 0) _h = 0;
        else if (left > containerWidth) _h = 359;
        else {
            var _percent = left * 100 / containerWidth;
            _h = 360 * _percent / 100;
        }
        if (hsl.h !== _h) return {
            h: _h,
            s: hsl.s,
            l: hsl.l,
            a: hsl.a,
            source: 'hsl'
        };
    }
    return null;
};


var $54f2bbfcaac0993e$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $54f2bbfcaac0993e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $54f2bbfcaac0993e$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $54f2bbfcaac0993e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $54f2bbfcaac0993e$export$3e22a96a58989a47 = function(_ref) {
    $54f2bbfcaac0993e$var$_inherits(Hue, _ref);
    function Hue() {
        var _ref2;
        var _temp, _this, _ret;
        $54f2bbfcaac0993e$var$_classCallCheck(this, Hue);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $54f2bbfcaac0993e$var$_possibleConstructorReturn(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [
            this
        ].concat(args))), _this), _this.handleChange = function(e) {
            var change = $4e9e4ec5ef541481$export$a056a977bf6a9a3c(e, _this.props.direction, _this.props.hsl, _this.container);
            change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
        }, _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            window.addEventListener('mousemove', _this.handleChange);
            window.addEventListener('mouseup', _this.handleMouseUp);
        }, _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        }, _temp), $54f2bbfcaac0993e$var$_possibleConstructorReturn(_this, _ret);
    }
    $54f2bbfcaac0993e$var$_createClass(Hue, [
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: 'unbindEventListeners',
            value: function unbindEventListeners() {
                window.removeEventListener('mousemove', this.handleChange);
                window.removeEventListener('mouseup', this.handleMouseUp);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var _props$direction = this.props.direction, direction = _props$direction === undefined ? 'horizontal' : _props$direction;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))({
                    'default': {
                        hue: {
                            absolute: '0px 0px 0px 0px',
                            borderRadius: this.props.radius,
                            boxShadow: this.props.shadow
                        },
                        container: {
                            padding: '0 2px',
                            position: 'relative',
                            height: '100%',
                            borderRadius: this.props.radius
                        },
                        pointer: {
                            position: 'absolute',
                            left: this.props.hsl.h * 100 / 360 + '%'
                        },
                        slider: {
                            marginTop: '1px',
                            width: '4px',
                            borderRadius: '1px',
                            height: '8px',
                            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
                            background: '#fff',
                            transform: 'translateX(-2px)'
                        }
                    },
                    'vertical': {
                        pointer: {
                            left: '0px',
                            top: -(this.props.hsl.h * 100 / 360) + 100 + '%'
                        }
                    }
                }, {
                    vertical: direction === 'vertical'
                });
                return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.hue
                }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    className: 'hue-' + direction,
                    style: styles.container,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('style', null, '\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          '), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.pointer
                }, this.props.pointer ? (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement(this.props.pointer, this.props) : (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.slider
                }))));
            }
        }
    ]);
    return Hue;
}((0, $8FY87.PureComponent) || (0, $8FY87.Component));
var $54f2bbfcaac0993e$export$2e2bcd8739ae039 = $54f2bbfcaac0993e$export$3e22a96a58989a47;



var $8FY87 = parcelRequire("8FY87");

var $4VW2f = parcelRequire("4VW2f");

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $e6ac8de38035354a$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $e6ac8de38035354a$export$2e2bcd8739ae039 = $e6ac8de38035354a$var$listCacheClear;


/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $20d35a3e3bd6bf79$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $20d35a3e3bd6bf79$export$2e2bcd8739ae039 = $20d35a3e3bd6bf79$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $8c69c2b336da2e99$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $20d35a3e3bd6bf79$export$2e2bcd8739ae039)(array[length][0], key)) return length;
    }
    return -1;
}
var $8c69c2b336da2e99$export$2e2bcd8739ae039 = $8c69c2b336da2e99$var$assocIndexOf;


/** Used for built-in method references. */ var $f3dbc91cf1c70e38$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $f3dbc91cf1c70e38$var$splice = $f3dbc91cf1c70e38$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $f3dbc91cf1c70e38$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $8c69c2b336da2e99$export$2e2bcd8739ae039)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $f3dbc91cf1c70e38$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $f3dbc91cf1c70e38$export$2e2bcd8739ae039 = $f3dbc91cf1c70e38$var$listCacheDelete;



/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $63e47f868d21c75d$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $8c69c2b336da2e99$export$2e2bcd8739ae039)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $63e47f868d21c75d$export$2e2bcd8739ae039 = $63e47f868d21c75d$var$listCacheGet;



/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $50f04f4eaebea989$var$listCacheHas(key) {
    return (0, $8c69c2b336da2e99$export$2e2bcd8739ae039)(this.__data__, key) > -1;
}
var $50f04f4eaebea989$export$2e2bcd8739ae039 = $50f04f4eaebea989$var$listCacheHas;



/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $0a3a77412cd8bcbf$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $8c69c2b336da2e99$export$2e2bcd8739ae039)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $0a3a77412cd8bcbf$export$2e2bcd8739ae039 = $0a3a77412cd8bcbf$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $5a5656b5c1a4c911$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$5a5656b5c1a4c911$var$ListCache.prototype.clear = (0, $e6ac8de38035354a$export$2e2bcd8739ae039);
$5a5656b5c1a4c911$var$ListCache.prototype['delete'] = (0, $f3dbc91cf1c70e38$export$2e2bcd8739ae039);
$5a5656b5c1a4c911$var$ListCache.prototype.get = (0, $63e47f868d21c75d$export$2e2bcd8739ae039);
$5a5656b5c1a4c911$var$ListCache.prototype.has = (0, $50f04f4eaebea989$export$2e2bcd8739ae039);
$5a5656b5c1a4c911$var$ListCache.prototype.set = (0, $0a3a77412cd8bcbf$export$2e2bcd8739ae039);
var $5a5656b5c1a4c911$export$2e2bcd8739ae039 = $5a5656b5c1a4c911$var$ListCache;



/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $b20ac8c245b940df$var$stackClear() {
    this.__data__ = new (0, $5a5656b5c1a4c911$export$2e2bcd8739ae039);
    this.size = 0;
}
var $b20ac8c245b940df$export$2e2bcd8739ae039 = $b20ac8c245b940df$var$stackClear;


/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $dce9a78575b9dcf2$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
var $dce9a78575b9dcf2$export$2e2bcd8739ae039 = $dce9a78575b9dcf2$var$stackDelete;


/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $6e69ef3566e53104$var$stackGet(key) {
    return this.__data__.get(key);
}
var $6e69ef3566e53104$export$2e2bcd8739ae039 = $6e69ef3566e53104$var$stackGet;


/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $4257cb94b5c67205$var$stackHas(key) {
    return this.__data__.has(key);
}
var $4257cb94b5c67205$export$2e2bcd8739ae039 = $4257cb94b5c67205$var$stackHas;




var $kgEOh = parcelRequire("kgEOh");
/** Built-in value references. */ var $e9bc3be843ae7db3$var$Symbol = (0, $kgEOh.default).Symbol;
var $e9bc3be843ae7db3$export$2e2bcd8739ae039 = $e9bc3be843ae7db3$var$Symbol;



/** Used for built-in method references. */ var $015c244d1ea209ae$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $015c244d1ea209ae$var$hasOwnProperty = $015c244d1ea209ae$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $015c244d1ea209ae$var$nativeObjectToString = $015c244d1ea209ae$var$objectProto.toString;
/** Built-in value references. */ var $015c244d1ea209ae$var$symToStringTag = (0, $e9bc3be843ae7db3$export$2e2bcd8739ae039) ? (0, $e9bc3be843ae7db3$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $015c244d1ea209ae$var$getRawTag(value) {
    var isOwn = $015c244d1ea209ae$var$hasOwnProperty.call(value, $015c244d1ea209ae$var$symToStringTag), tag = value[$015c244d1ea209ae$var$symToStringTag];
    try {
        value[$015c244d1ea209ae$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $015c244d1ea209ae$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$015c244d1ea209ae$var$symToStringTag] = tag;
        else delete value[$015c244d1ea209ae$var$symToStringTag];
    }
    return result;
}
var $015c244d1ea209ae$export$2e2bcd8739ae039 = $015c244d1ea209ae$var$getRawTag;


/** Used for built-in method references. */ var $09dceedc5e4d5c6b$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $09dceedc5e4d5c6b$var$nativeObjectToString = $09dceedc5e4d5c6b$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $09dceedc5e4d5c6b$var$objectToString(value) {
    return $09dceedc5e4d5c6b$var$nativeObjectToString.call(value);
}
var $09dceedc5e4d5c6b$export$2e2bcd8739ae039 = $09dceedc5e4d5c6b$var$objectToString;


/** `Object#toString` result references. */ var $492d0391f2ac61ec$var$nullTag = '[object Null]', $492d0391f2ac61ec$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $492d0391f2ac61ec$var$symToStringTag = (0, $e9bc3be843ae7db3$export$2e2bcd8739ae039) ? (0, $e9bc3be843ae7db3$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $492d0391f2ac61ec$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $492d0391f2ac61ec$var$undefinedTag : $492d0391f2ac61ec$var$nullTag;
    return $492d0391f2ac61ec$var$symToStringTag && $492d0391f2ac61ec$var$symToStringTag in Object(value) ? (0, $015c244d1ea209ae$export$2e2bcd8739ae039)(value) : (0, $09dceedc5e4d5c6b$export$2e2bcd8739ae039)(value);
}
var $492d0391f2ac61ec$export$2e2bcd8739ae039 = $492d0391f2ac61ec$var$baseGetTag;


/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $0f0b33514751195d$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $0f0b33514751195d$export$2e2bcd8739ae039 = $0f0b33514751195d$var$isObject;


/** `Object#toString` result references. */ var $5bc7ec7c8d0c750f$var$asyncTag = '[object AsyncFunction]', $5bc7ec7c8d0c750f$var$funcTag = '[object Function]', $5bc7ec7c8d0c750f$var$genTag = '[object GeneratorFunction]', $5bc7ec7c8d0c750f$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $5bc7ec7c8d0c750f$var$isFunction(value) {
    if (!(0, $0f0b33514751195d$export$2e2bcd8739ae039)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $492d0391f2ac61ec$export$2e2bcd8739ae039)(value);
    return tag == $5bc7ec7c8d0c750f$var$funcTag || tag == $5bc7ec7c8d0c750f$var$genTag || tag == $5bc7ec7c8d0c750f$var$asyncTag || tag == $5bc7ec7c8d0c750f$var$proxyTag;
}
var $5bc7ec7c8d0c750f$export$2e2bcd8739ae039 = $5bc7ec7c8d0c750f$var$isFunction;



var $kgEOh = parcelRequire("kgEOh");
/** Used to detect overreaching core-js shims. */ var $11508a74e085c27a$var$coreJsData = (0, $kgEOh.default)['__core-js_shared__'];
var $11508a74e085c27a$export$2e2bcd8739ae039 = $11508a74e085c27a$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $297b2177245424a9$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $11508a74e085c27a$export$2e2bcd8739ae039) && (0, $11508a74e085c27a$export$2e2bcd8739ae039).keys && (0, $11508a74e085c27a$export$2e2bcd8739ae039).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $297b2177245424a9$var$isMasked(func) {
    return !!$297b2177245424a9$var$maskSrcKey && $297b2177245424a9$var$maskSrcKey in func;
}
var $297b2177245424a9$export$2e2bcd8739ae039 = $297b2177245424a9$var$isMasked;



/** Used for built-in method references. */ var $1f79199214c6d21a$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $1f79199214c6d21a$var$funcToString = $1f79199214c6d21a$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $1f79199214c6d21a$var$toSource(func) {
    if (func != null) {
        try {
            return $1f79199214c6d21a$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var $1f79199214c6d21a$export$2e2bcd8739ae039 = $1f79199214c6d21a$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $c439502870640f66$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $c439502870640f66$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $c439502870640f66$var$funcProto = Function.prototype, $c439502870640f66$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $c439502870640f66$var$funcToString = $c439502870640f66$var$funcProto.toString;
/** Used to check objects for own properties. */ var $c439502870640f66$var$hasOwnProperty = $c439502870640f66$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $c439502870640f66$var$reIsNative = RegExp('^' + $c439502870640f66$var$funcToString.call($c439502870640f66$var$hasOwnProperty).replace($c439502870640f66$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $c439502870640f66$var$baseIsNative(value) {
    if (!(0, $0f0b33514751195d$export$2e2bcd8739ae039)(value) || (0, $297b2177245424a9$export$2e2bcd8739ae039)(value)) return false;
    var pattern = (0, $5bc7ec7c8d0c750f$export$2e2bcd8739ae039)(value) ? $c439502870640f66$var$reIsNative : $c439502870640f66$var$reIsHostCtor;
    return pattern.test((0, $1f79199214c6d21a$export$2e2bcd8739ae039)(value));
}
var $c439502870640f66$export$2e2bcd8739ae039 = $c439502870640f66$var$baseIsNative;


/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $065b3272b60591b6$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $065b3272b60591b6$export$2e2bcd8739ae039 = $065b3272b60591b6$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $903050517465572f$var$getNative(object, key) {
    var value = (0, $065b3272b60591b6$export$2e2bcd8739ae039)(object, key);
    return (0, $c439502870640f66$export$2e2bcd8739ae039)(value) ? value : undefined;
}
var $903050517465572f$export$2e2bcd8739ae039 = $903050517465572f$var$getNative;



var $kgEOh = parcelRequire("kgEOh");
/* Built-in method references that are verified to be native. */ var $ccbd53005879ec2c$var$Map = (0, $903050517465572f$export$2e2bcd8739ae039)((0, $kgEOh.default), 'Map');
var $ccbd53005879ec2c$export$2e2bcd8739ae039 = $ccbd53005879ec2c$var$Map;



/* Built-in method references that are verified to be native. */ var $73657465ed714b67$var$nativeCreate = (0, $903050517465572f$export$2e2bcd8739ae039)(Object, 'create');
var $73657465ed714b67$export$2e2bcd8739ae039 = $73657465ed714b67$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $1c4827ebc3fa2588$var$hashClear() {
    this.__data__ = (0, $73657465ed714b67$export$2e2bcd8739ae039) ? (0, $73657465ed714b67$export$2e2bcd8739ae039)(null) : {};
    this.size = 0;
}
var $1c4827ebc3fa2588$export$2e2bcd8739ae039 = $1c4827ebc3fa2588$var$hashClear;


/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $c2c0b3c3b68e03cf$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $c2c0b3c3b68e03cf$export$2e2bcd8739ae039 = $c2c0b3c3b68e03cf$var$hashDelete;



/** Used to stand-in for `undefined` hash values. */ var $6d8610d3857abe5f$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $6d8610d3857abe5f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $6d8610d3857abe5f$var$hasOwnProperty = $6d8610d3857abe5f$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $6d8610d3857abe5f$var$hashGet(key) {
    var data = this.__data__;
    if (0, $73657465ed714b67$export$2e2bcd8739ae039) {
        var result = data[key];
        return result === $6d8610d3857abe5f$var$HASH_UNDEFINED ? undefined : result;
    }
    return $6d8610d3857abe5f$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $6d8610d3857abe5f$export$2e2bcd8739ae039 = $6d8610d3857abe5f$var$hashGet;



/** Used for built-in method references. */ var $e17b640aaa3ab2b5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e17b640aaa3ab2b5$var$hasOwnProperty = $e17b640aaa3ab2b5$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e17b640aaa3ab2b5$var$hashHas(key) {
    var data = this.__data__;
    return (0, $73657465ed714b67$export$2e2bcd8739ae039) ? data[key] !== undefined : $e17b640aaa3ab2b5$var$hasOwnProperty.call(data, key);
}
var $e17b640aaa3ab2b5$export$2e2bcd8739ae039 = $e17b640aaa3ab2b5$var$hashHas;



/** Used to stand-in for `undefined` hash values. */ var $f003a92ad86bd35e$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $f003a92ad86bd35e$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $73657465ed714b67$export$2e2bcd8739ae039) && value === undefined ? $f003a92ad86bd35e$var$HASH_UNDEFINED : value;
    return this;
}
var $f003a92ad86bd35e$export$2e2bcd8739ae039 = $f003a92ad86bd35e$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $11c6ea538504ac7c$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$11c6ea538504ac7c$var$Hash.prototype.clear = (0, $1c4827ebc3fa2588$export$2e2bcd8739ae039);
$11c6ea538504ac7c$var$Hash.prototype['delete'] = (0, $c2c0b3c3b68e03cf$export$2e2bcd8739ae039);
$11c6ea538504ac7c$var$Hash.prototype.get = (0, $6d8610d3857abe5f$export$2e2bcd8739ae039);
$11c6ea538504ac7c$var$Hash.prototype.has = (0, $e17b640aaa3ab2b5$export$2e2bcd8739ae039);
$11c6ea538504ac7c$var$Hash.prototype.set = (0, $f003a92ad86bd35e$export$2e2bcd8739ae039);
var $11c6ea538504ac7c$export$2e2bcd8739ae039 = $11c6ea538504ac7c$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $6cb790e271f42f5b$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, $11c6ea538504ac7c$export$2e2bcd8739ae039),
        'map': new ((0, $ccbd53005879ec2c$export$2e2bcd8739ae039) || (0, $5a5656b5c1a4c911$export$2e2bcd8739ae039)),
        'string': new (0, $11c6ea538504ac7c$export$2e2bcd8739ae039)
    };
}
var $6cb790e271f42f5b$export$2e2bcd8739ae039 = $6cb790e271f42f5b$var$mapCacheClear;


/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $b713e93654740599$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var $b713e93654740599$export$2e2bcd8739ae039 = $b713e93654740599$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $8be2fcaa8f469962$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $b713e93654740599$export$2e2bcd8739ae039)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var $8be2fcaa8f469962$export$2e2bcd8739ae039 = $8be2fcaa8f469962$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $6e49b8d9e70ae9f4$var$mapCacheDelete(key) {
    var result = (0, $8be2fcaa8f469962$export$2e2bcd8739ae039)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $6e49b8d9e70ae9f4$export$2e2bcd8739ae039 = $6e49b8d9e70ae9f4$var$mapCacheDelete;



/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $d0070466a8fa205e$var$mapCacheGet(key) {
    return (0, $8be2fcaa8f469962$export$2e2bcd8739ae039)(this, key).get(key);
}
var $d0070466a8fa205e$export$2e2bcd8739ae039 = $d0070466a8fa205e$var$mapCacheGet;



/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $42a07bf6f59eb814$var$mapCacheHas(key) {
    return (0, $8be2fcaa8f469962$export$2e2bcd8739ae039)(this, key).has(key);
}
var $42a07bf6f59eb814$export$2e2bcd8739ae039 = $42a07bf6f59eb814$var$mapCacheHas;



/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $b5e109ef99408144$var$mapCacheSet(key, value) {
    var data = (0, $8be2fcaa8f469962$export$2e2bcd8739ae039)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $b5e109ef99408144$export$2e2bcd8739ae039 = $b5e109ef99408144$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $d757e6f151d4449d$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$d757e6f151d4449d$var$MapCache.prototype.clear = (0, $6cb790e271f42f5b$export$2e2bcd8739ae039);
$d757e6f151d4449d$var$MapCache.prototype['delete'] = (0, $6e49b8d9e70ae9f4$export$2e2bcd8739ae039);
$d757e6f151d4449d$var$MapCache.prototype.get = (0, $d0070466a8fa205e$export$2e2bcd8739ae039);
$d757e6f151d4449d$var$MapCache.prototype.has = (0, $42a07bf6f59eb814$export$2e2bcd8739ae039);
$d757e6f151d4449d$var$MapCache.prototype.set = (0, $b5e109ef99408144$export$2e2bcd8739ae039);
var $d757e6f151d4449d$export$2e2bcd8739ae039 = $d757e6f151d4449d$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $995bbf682fb255e2$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $995bbf682fb255e2$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $5a5656b5c1a4c911$export$2e2bcd8739ae039)) {
        var pairs = data.__data__;
        if (!(0, $ccbd53005879ec2c$export$2e2bcd8739ae039) || pairs.length < $995bbf682fb255e2$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $d757e6f151d4449d$export$2e2bcd8739ae039)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $995bbf682fb255e2$export$2e2bcd8739ae039 = $995bbf682fb255e2$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4629ffd999cc27d4$var$Stack(entries) {
    var data = this.__data__ = new (0, $5a5656b5c1a4c911$export$2e2bcd8739ae039)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$4629ffd999cc27d4$var$Stack.prototype.clear = (0, $b20ac8c245b940df$export$2e2bcd8739ae039);
$4629ffd999cc27d4$var$Stack.prototype['delete'] = (0, $dce9a78575b9dcf2$export$2e2bcd8739ae039);
$4629ffd999cc27d4$var$Stack.prototype.get = (0, $6e69ef3566e53104$export$2e2bcd8739ae039);
$4629ffd999cc27d4$var$Stack.prototype.has = (0, $4257cb94b5c67205$export$2e2bcd8739ae039);
$4629ffd999cc27d4$var$Stack.prototype.set = (0, $995bbf682fb255e2$export$2e2bcd8739ae039);
var $4629ffd999cc27d4$export$2e2bcd8739ae039 = $4629ffd999cc27d4$var$Stack;



var $ae8655aee4fe199f$var$defineProperty = function() {
    try {
        var func = (0, $903050517465572f$export$2e2bcd8739ae039)(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
var $ae8655aee4fe199f$export$2e2bcd8739ae039 = $ae8655aee4fe199f$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $79fd9a437e5b577f$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && (0, $ae8655aee4fe199f$export$2e2bcd8739ae039)) (0, $ae8655aee4fe199f$export$2e2bcd8739ae039)(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
var $79fd9a437e5b577f$export$2e2bcd8739ae039 = $79fd9a437e5b577f$var$baseAssignValue;



/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $cba6905212caa719$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !(0, $20d35a3e3bd6bf79$export$2e2bcd8739ae039)(object[key], value) || value === undefined && !(key in object)) (0, $79fd9a437e5b577f$export$2e2bcd8739ae039)(object, key, value);
}
var $cba6905212caa719$export$2e2bcd8739ae039 = $cba6905212caa719$var$assignMergeValue;


/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $04eacfaaa1c7ac35$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
var $04eacfaaa1c7ac35$export$2e2bcd8739ae039 = $04eacfaaa1c7ac35$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $1d02b30d0f0d3042$var$baseFor = (0, $04eacfaaa1c7ac35$export$2e2bcd8739ae039)();
var $1d02b30d0f0d3042$export$2e2bcd8739ae039 = $1d02b30d0f0d3042$var$baseFor;




var $2eDJ7 = parcelRequire("2eDJ7");

var $kgEOh = parcelRequire("kgEOh");
/** Built-in value references. */ var $dae9e0a0e77b1ad1$var$Uint8Array = (0, $kgEOh.default).Uint8Array;
var $dae9e0a0e77b1ad1$export$2e2bcd8739ae039 = $dae9e0a0e77b1ad1$var$Uint8Array;


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $d5acac4d1d0ddac1$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $dae9e0a0e77b1ad1$export$2e2bcd8739ae039)(result).set(new (0, $dae9e0a0e77b1ad1$export$2e2bcd8739ae039)(arrayBuffer));
    return result;
}
var $d5acac4d1d0ddac1$export$2e2bcd8739ae039 = $d5acac4d1d0ddac1$var$cloneArrayBuffer;


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $4128b24309084d7c$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $d5acac4d1d0ddac1$export$2e2bcd8739ae039)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $4128b24309084d7c$export$2e2bcd8739ae039 = $4128b24309084d7c$var$cloneTypedArray;


/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $6ee5ba3b93e896be$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $6ee5ba3b93e896be$export$2e2bcd8739ae039 = $6ee5ba3b93e896be$var$copyArray;



/** Built-in value references. */ var $3d5cbd05b6391848$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $3d5cbd05b6391848$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $0f0b33514751195d$export$2e2bcd8739ae039)(proto)) return {};
        if ($3d5cbd05b6391848$var$objectCreate) return $3d5cbd05b6391848$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $3d5cbd05b6391848$export$2e2bcd8739ae039 = $3d5cbd05b6391848$var$baseCreate;


/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $4902ec53a1ca302a$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $4902ec53a1ca302a$export$2e2bcd8739ae039 = $4902ec53a1ca302a$var$overArg;


/** Built-in value references. */ var $7d88ac4aa101dab4$var$getPrototype = (0, $4902ec53a1ca302a$export$2e2bcd8739ae039)(Object.getPrototypeOf, Object);
var $7d88ac4aa101dab4$export$2e2bcd8739ae039 = $7d88ac4aa101dab4$var$getPrototype;


/** Used for built-in method references. */ var $e99fdb1634bd539a$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $e99fdb1634bd539a$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $e99fdb1634bd539a$var$objectProto;
    return value === proto;
}
var $e99fdb1634bd539a$export$2e2bcd8739ae039 = $e99fdb1634bd539a$var$isPrototype;


/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $6c800f80d8c79e51$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !(0, $e99fdb1634bd539a$export$2e2bcd8739ae039)(object) ? (0, $3d5cbd05b6391848$export$2e2bcd8739ae039)((0, $7d88ac4aa101dab4$export$2e2bcd8739ae039)(object)) : {};
}
var $6c800f80d8c79e51$export$2e2bcd8739ae039 = $6c800f80d8c79e51$var$initCloneObject;



/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $8ef6de3f0576ee8c$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $8ef6de3f0576ee8c$export$2e2bcd8739ae039 = $8ef6de3f0576ee8c$var$isObjectLike;


/** `Object#toString` result references. */ var $d3bb5b58ad8206c9$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $d3bb5b58ad8206c9$var$baseIsArguments(value) {
    return (0, $8ef6de3f0576ee8c$export$2e2bcd8739ae039)(value) && (0, $492d0391f2ac61ec$export$2e2bcd8739ae039)(value) == $d3bb5b58ad8206c9$var$argsTag;
}
var $d3bb5b58ad8206c9$export$2e2bcd8739ae039 = $d3bb5b58ad8206c9$var$baseIsArguments;



/** Used for built-in method references. */ var $20760ba0446df02d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $20760ba0446df02d$var$hasOwnProperty = $20760ba0446df02d$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $20760ba0446df02d$var$propertyIsEnumerable = $20760ba0446df02d$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $20760ba0446df02d$var$isArguments = (0, $d3bb5b58ad8206c9$export$2e2bcd8739ae039)(function() {
    return arguments;
}()) ? (0, $d3bb5b58ad8206c9$export$2e2bcd8739ae039) : function(value) {
    return (0, $8ef6de3f0576ee8c$export$2e2bcd8739ae039)(value) && $20760ba0446df02d$var$hasOwnProperty.call(value, 'callee') && !$20760ba0446df02d$var$propertyIsEnumerable.call(value, 'callee');
};
var $20760ba0446df02d$export$2e2bcd8739ae039 = $20760ba0446df02d$var$isArguments;


/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $acb56a590d5e2bcb$var$isArray = Array.isArray;
var $acb56a590d5e2bcb$export$2e2bcd8739ae039 = $acb56a590d5e2bcb$var$isArray;



/** Used as references for various `Number` constants. */ var $7a3de10c37036eb2$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $7a3de10c37036eb2$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $7a3de10c37036eb2$var$MAX_SAFE_INTEGER;
}
var $7a3de10c37036eb2$export$2e2bcd8739ae039 = $7a3de10c37036eb2$var$isLength;


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $5c88ed82b217ac2c$var$isArrayLike(value) {
    return value != null && (0, $7a3de10c37036eb2$export$2e2bcd8739ae039)(value.length) && !(0, $5bc7ec7c8d0c750f$export$2e2bcd8739ae039)(value);
}
var $5c88ed82b217ac2c$export$2e2bcd8739ae039 = $5c88ed82b217ac2c$var$isArrayLike;



/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $eb54a7d64f909bdf$var$isArrayLikeObject(value) {
    return (0, $8ef6de3f0576ee8c$export$2e2bcd8739ae039)(value) && (0, $5c88ed82b217ac2c$export$2e2bcd8739ae039)(value);
}
var $eb54a7d64f909bdf$export$2e2bcd8739ae039 = $eb54a7d64f909bdf$var$isArrayLikeObject;



var $kmshc = parcelRequire("kmshc");





/** `Object#toString` result references. */ var $c363a5fbb261e0e8$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $c363a5fbb261e0e8$var$funcProto = Function.prototype, $c363a5fbb261e0e8$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $c363a5fbb261e0e8$var$funcToString = $c363a5fbb261e0e8$var$funcProto.toString;
/** Used to check objects for own properties. */ var $c363a5fbb261e0e8$var$hasOwnProperty = $c363a5fbb261e0e8$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $c363a5fbb261e0e8$var$objectCtorString = $c363a5fbb261e0e8$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $c363a5fbb261e0e8$var$isPlainObject(value) {
    if (!(0, $8ef6de3f0576ee8c$export$2e2bcd8739ae039)(value) || (0, $492d0391f2ac61ec$export$2e2bcd8739ae039)(value) != $c363a5fbb261e0e8$var$objectTag) return false;
    var proto = (0, $7d88ac4aa101dab4$export$2e2bcd8739ae039)(value);
    if (proto === null) return true;
    var Ctor = $c363a5fbb261e0e8$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $c363a5fbb261e0e8$var$funcToString.call(Ctor) == $c363a5fbb261e0e8$var$objectCtorString;
}
var $c363a5fbb261e0e8$export$2e2bcd8739ae039 = $c363a5fbb261e0e8$var$isPlainObject;





/** `Object#toString` result references. */ var $66ca1974f7a76ce4$var$argsTag = '[object Arguments]', $66ca1974f7a76ce4$var$arrayTag = '[object Array]', $66ca1974f7a76ce4$var$boolTag = '[object Boolean]', $66ca1974f7a76ce4$var$dateTag = '[object Date]', $66ca1974f7a76ce4$var$errorTag = '[object Error]', $66ca1974f7a76ce4$var$funcTag = '[object Function]', $66ca1974f7a76ce4$var$mapTag = '[object Map]', $66ca1974f7a76ce4$var$numberTag = '[object Number]', $66ca1974f7a76ce4$var$objectTag = '[object Object]', $66ca1974f7a76ce4$var$regexpTag = '[object RegExp]', $66ca1974f7a76ce4$var$setTag = '[object Set]', $66ca1974f7a76ce4$var$stringTag = '[object String]', $66ca1974f7a76ce4$var$weakMapTag = '[object WeakMap]';
var $66ca1974f7a76ce4$var$arrayBufferTag = '[object ArrayBuffer]', $66ca1974f7a76ce4$var$dataViewTag = '[object DataView]', $66ca1974f7a76ce4$var$float32Tag = '[object Float32Array]', $66ca1974f7a76ce4$var$float64Tag = '[object Float64Array]', $66ca1974f7a76ce4$var$int8Tag = '[object Int8Array]', $66ca1974f7a76ce4$var$int16Tag = '[object Int16Array]', $66ca1974f7a76ce4$var$int32Tag = '[object Int32Array]', $66ca1974f7a76ce4$var$uint8Tag = '[object Uint8Array]', $66ca1974f7a76ce4$var$uint8ClampedTag = '[object Uint8ClampedArray]', $66ca1974f7a76ce4$var$uint16Tag = '[object Uint16Array]', $66ca1974f7a76ce4$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $66ca1974f7a76ce4$var$typedArrayTags = {};
$66ca1974f7a76ce4$var$typedArrayTags[$66ca1974f7a76ce4$var$float32Tag] = $66ca1974f7a76ce4$var$typedArrayTags[$66ca1974f7a76ce4$var$float64Tag] = $66ca1974f7a76ce4$var$typedArrayTags[$66ca1974f7a76ce4$var$int8Tag] = $66ca1974f7a76ce4$var$typedArrayTags[$66ca1974f7a76ce4$var$int16Tag] = $66ca1974f7a76ce4$var$typedArrayTags[$66ca1974f7a76ce4$var$int32Tag] = $66ca1974f7a76ce4$var$typedArrayTags[$66ca1974f7a76ce4$var$uint8Tag] = $66ca1974f7a76ce4$var$typedArrayTags[$66ca1974f7a76ce4$var$uint8ClampedTag] = $66ca1974f7a76ce4$var$typedArrayTags[$66ca1974f7a76ce4$var$uint16Tag] = $66ca1974f7a76ce4$var$typedArrayTags[$66ca1974f7a76ce4$var$uint32Tag] = true;
$66ca1974f7a76ce4$var$typedArrayTags[$66ca1974f7a76ce4$var$argsTag] = $66ca1974f7a76ce4$var$typedArrayTags[$66ca1974f7a76ce4$var$arrayTag] = $66ca1974f7a76ce4$var$typedArrayTags[$66ca1974f7a76ce4$var$arrayBufferTag] = $66ca1974f7a76ce4$var$typedArrayTags[$66ca1974f7a76ce4$var$boolTag] = $66ca1974f7a76ce4$var$typedArrayTags[$66ca1974f7a76ce4$var$dataViewTag] = $66ca1974f7a76ce4$var$typedArrayTags[$66ca1974f7a76ce4$var$dateTag] = $66ca1974f7a76ce4$var$typedArrayTags[$66ca1974f7a76ce4$var$errorTag] = $66ca1974f7a76ce4$var$typedArrayTags[$66ca1974f7a76ce4$var$funcTag] = $66ca1974f7a76ce4$var$typedArrayTags[$66ca1974f7a76ce4$var$mapTag] = $66ca1974f7a76ce4$var$typedArrayTags[$66ca1974f7a76ce4$var$numberTag] = $66ca1974f7a76ce4$var$typedArrayTags[$66ca1974f7a76ce4$var$objectTag] = $66ca1974f7a76ce4$var$typedArrayTags[$66ca1974f7a76ce4$var$regexpTag] = $66ca1974f7a76ce4$var$typedArrayTags[$66ca1974f7a76ce4$var$setTag] = $66ca1974f7a76ce4$var$typedArrayTags[$66ca1974f7a76ce4$var$stringTag] = $66ca1974f7a76ce4$var$typedArrayTags[$66ca1974f7a76ce4$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $66ca1974f7a76ce4$var$baseIsTypedArray(value) {
    return (0, $8ef6de3f0576ee8c$export$2e2bcd8739ae039)(value) && (0, $7a3de10c37036eb2$export$2e2bcd8739ae039)(value.length) && !!$66ca1974f7a76ce4$var$typedArrayTags[(0, $492d0391f2ac61ec$export$2e2bcd8739ae039)(value)];
}
var $66ca1974f7a76ce4$export$2e2bcd8739ae039 = $66ca1974f7a76ce4$var$baseIsTypedArray;


/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $2bbf683a8d173f77$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $2bbf683a8d173f77$export$2e2bcd8739ae039 = $2bbf683a8d173f77$var$baseUnary;



var $5LKLe = parcelRequire("5LKLe");
/* Node.js helper references. */ var $b55076106e830d0e$var$nodeIsTypedArray = (0, $5LKLe.default) && (0, $5LKLe.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $b55076106e830d0e$var$isTypedArray = $b55076106e830d0e$var$nodeIsTypedArray ? (0, $2bbf683a8d173f77$export$2e2bcd8739ae039)($b55076106e830d0e$var$nodeIsTypedArray) : (0, $66ca1974f7a76ce4$export$2e2bcd8739ae039);
var $b55076106e830d0e$export$2e2bcd8739ae039 = $b55076106e830d0e$var$isTypedArray;


/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $c821926ff71fd2ca$var$safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
var $c821926ff71fd2ca$export$2e2bcd8739ae039 = $c821926ff71fd2ca$var$safeGet;




/** Used for built-in method references. */ var $bfd5f6dbfe570507$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $bfd5f6dbfe570507$var$hasOwnProperty = $bfd5f6dbfe570507$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $bfd5f6dbfe570507$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($bfd5f6dbfe570507$var$hasOwnProperty.call(object, key) && (0, $20d35a3e3bd6bf79$export$2e2bcd8739ae039)(objValue, value)) || value === undefined && !(key in object)) (0, $79fd9a437e5b577f$export$2e2bcd8739ae039)(object, key, value);
}
var $bfd5f6dbfe570507$export$2e2bcd8739ae039 = $bfd5f6dbfe570507$var$assignValue;



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $2a832f5cd9b6cb15$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $79fd9a437e5b577f$export$2e2bcd8739ae039)(object, key, newValue);
        else (0, $bfd5f6dbfe570507$export$2e2bcd8739ae039)(object, key, newValue);
    }
    return object;
}
var $2a832f5cd9b6cb15$export$2e2bcd8739ae039 = $2a832f5cd9b6cb15$var$copyObject;


/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $83d285ef769f5b51$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $83d285ef769f5b51$export$2e2bcd8739ae039 = $83d285ef769f5b51$var$baseTimes;





var $kmshc = parcelRequire("kmshc");
/** Used as references for various `Number` constants. */ var $b1905f533236458e$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $b1905f533236458e$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $b1905f533236458e$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $b1905f533236458e$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $b1905f533236458e$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $b1905f533236458e$export$2e2bcd8739ae039 = $b1905f533236458e$var$isIndex;



/** Used for built-in method references. */ var $b724d1dcfe1dcaf1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b724d1dcfe1dcaf1$var$hasOwnProperty = $b724d1dcfe1dcaf1$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $b724d1dcfe1dcaf1$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $acb56a590d5e2bcb$export$2e2bcd8739ae039)(value), isArg = !isArr && (0, $20760ba0446df02d$export$2e2bcd8739ae039)(value), isBuff = !isArr && !isArg && (0, $kmshc.default)(value), isType = !isArr && !isArg && !isBuff && (0, $b55076106e830d0e$export$2e2bcd8739ae039)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $83d285ef769f5b51$export$2e2bcd8739ae039)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $b724d1dcfe1dcaf1$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    (0, $b1905f533236458e$export$2e2bcd8739ae039)(key, length)))) result.push(key);
    return result;
}
var $b724d1dcfe1dcaf1$export$2e2bcd8739ae039 = $b724d1dcfe1dcaf1$var$arrayLikeKeys;




/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $e0ef664e0e803a0f$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $e0ef664e0e803a0f$export$2e2bcd8739ae039 = $e0ef664e0e803a0f$var$nativeKeysIn;


/** Used for built-in method references. */ var $2f223fc3178d16e1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2f223fc3178d16e1$var$hasOwnProperty = $2f223fc3178d16e1$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $2f223fc3178d16e1$var$baseKeysIn(object) {
    if (!(0, $0f0b33514751195d$export$2e2bcd8739ae039)(object)) return (0, $e0ef664e0e803a0f$export$2e2bcd8739ae039)(object);
    var isProto = (0, $e99fdb1634bd539a$export$2e2bcd8739ae039)(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$2f223fc3178d16e1$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $2f223fc3178d16e1$export$2e2bcd8739ae039 = $2f223fc3178d16e1$var$baseKeysIn;



/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $a597badc098aca4b$var$keysIn(object) {
    return (0, $5c88ed82b217ac2c$export$2e2bcd8739ae039)(object) ? (0, $b724d1dcfe1dcaf1$export$2e2bcd8739ae039)(object, true) : (0, $2f223fc3178d16e1$export$2e2bcd8739ae039)(object);
}
var $a597badc098aca4b$export$2e2bcd8739ae039 = $a597badc098aca4b$var$keysIn;


/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $e79a2b3dd8e50d71$var$toPlainObject(value) {
    return (0, $2a832f5cd9b6cb15$export$2e2bcd8739ae039)(value, (0, $a597badc098aca4b$export$2e2bcd8739ae039)(value));
}
var $e79a2b3dd8e50d71$export$2e2bcd8739ae039 = $e79a2b3dd8e50d71$var$toPlainObject;


/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $4806db2122970c8b$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = (0, $c821926ff71fd2ca$export$2e2bcd8739ae039)(object, key), srcValue = (0, $c821926ff71fd2ca$export$2e2bcd8739ae039)(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        (0, $cba6905212caa719$export$2e2bcd8739ae039)(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = (0, $acb56a590d5e2bcb$export$2e2bcd8739ae039)(srcValue), isBuff = !isArr && (0, $kmshc.default)(srcValue), isTyped = !isArr && !isBuff && (0, $b55076106e830d0e$export$2e2bcd8739ae039)(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ((0, $acb56a590d5e2bcb$export$2e2bcd8739ae039)(objValue)) newValue = objValue;
            else if ((0, $eb54a7d64f909bdf$export$2e2bcd8739ae039)(objValue)) newValue = (0, $6ee5ba3b93e896be$export$2e2bcd8739ae039)(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = (0, $2eDJ7.default)(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = (0, $4128b24309084d7c$export$2e2bcd8739ae039)(srcValue, true);
            } else newValue = [];
        } else if ((0, $c363a5fbb261e0e8$export$2e2bcd8739ae039)(srcValue) || (0, $20760ba0446df02d$export$2e2bcd8739ae039)(srcValue)) {
            newValue = objValue;
            if ((0, $20760ba0446df02d$export$2e2bcd8739ae039)(objValue)) newValue = (0, $e79a2b3dd8e50d71$export$2e2bcd8739ae039)(objValue);
            else if (!(0, $0f0b33514751195d$export$2e2bcd8739ae039)(objValue) || (0, $5bc7ec7c8d0c750f$export$2e2bcd8739ae039)(objValue)) newValue = (0, $6c800f80d8c79e51$export$2e2bcd8739ae039)(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    (0, $cba6905212caa719$export$2e2bcd8739ae039)(object, key, newValue);
}
var $4806db2122970c8b$export$2e2bcd8739ae039 = $4806db2122970c8b$var$baseMergeDeep;





/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $e65a113fbada4b73$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    (0, $1d02b30d0f0d3042$export$2e2bcd8739ae039)(source, function(srcValue, key) {
        stack || (stack = new (0, $4629ffd999cc27d4$export$2e2bcd8739ae039));
        if ((0, $0f0b33514751195d$export$2e2bcd8739ae039)(srcValue)) (0, $4806db2122970c8b$export$2e2bcd8739ae039)(object, source, key, srcIndex, $e65a113fbada4b73$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer((0, $c821926ff71fd2ca$export$2e2bcd8739ae039)(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            (0, $cba6905212caa719$export$2e2bcd8739ae039)(object, key, newValue);
        }
    }, (0, $a597badc098aca4b$export$2e2bcd8739ae039));
}
var $e65a113fbada4b73$export$2e2bcd8739ae039 = $e65a113fbada4b73$var$baseMerge;


/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $1c32b2559fcaca3b$var$identity(value) {
    return value;
}
var $1c32b2559fcaca3b$export$2e2bcd8739ae039 = $1c32b2559fcaca3b$var$identity;


/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $77b53e0aff72e993$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
var $77b53e0aff72e993$export$2e2bcd8739ae039 = $77b53e0aff72e993$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $78dfcff373eae476$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $78dfcff373eae476$var$overRest(func, start, transform) {
    start = $78dfcff373eae476$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $78dfcff373eae476$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return (0, $77b53e0aff72e993$export$2e2bcd8739ae039)(func, this, otherArgs);
    };
}
var $78dfcff373eae476$export$2e2bcd8739ae039 = $78dfcff373eae476$var$overRest;


/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $bfc1a3ceea2fbc22$var$constant(value) {
    return function() {
        return value;
    };
}
var $bfc1a3ceea2fbc22$export$2e2bcd8739ae039 = $bfc1a3ceea2fbc22$var$constant;




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $e3b0669e3607ebc6$var$baseSetToString = !(0, $ae8655aee4fe199f$export$2e2bcd8739ae039) ? (0, $1c32b2559fcaca3b$export$2e2bcd8739ae039) : function(func, string) {
    return (0, $ae8655aee4fe199f$export$2e2bcd8739ae039)(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': (0, $bfc1a3ceea2fbc22$export$2e2bcd8739ae039)(string),
        'writable': true
    });
};
var $e3b0669e3607ebc6$export$2e2bcd8739ae039 = $e3b0669e3607ebc6$var$baseSetToString;


/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $c105378839fc8cfa$var$HOT_COUNT = 800, $c105378839fc8cfa$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $c105378839fc8cfa$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $c105378839fc8cfa$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $c105378839fc8cfa$var$nativeNow(), remaining = $c105378839fc8cfa$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $c105378839fc8cfa$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
var $c105378839fc8cfa$export$2e2bcd8739ae039 = $c105378839fc8cfa$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $35bc78e399f0b28e$var$setToString = (0, $c105378839fc8cfa$export$2e2bcd8739ae039)((0, $e3b0669e3607ebc6$export$2e2bcd8739ae039));
var $35bc78e399f0b28e$export$2e2bcd8739ae039 = $35bc78e399f0b28e$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $aa7be9aefd40c425$var$baseRest(func, start) {
    return (0, $35bc78e399f0b28e$export$2e2bcd8739ae039)((0, $78dfcff373eae476$export$2e2bcd8739ae039)(func, start, (0, $1c32b2559fcaca3b$export$2e2bcd8739ae039)), func + '');
}
var $aa7be9aefd40c425$export$2e2bcd8739ae039 = $aa7be9aefd40c425$var$baseRest;






/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $eb9a18e9cea9d166$var$isIterateeCall(value, index, object) {
    if (!(0, $0f0b33514751195d$export$2e2bcd8739ae039)(object)) return false;
    var type = typeof index;
    if (type == 'number' ? (0, $5c88ed82b217ac2c$export$2e2bcd8739ae039)(object) && (0, $b1905f533236458e$export$2e2bcd8739ae039)(index, object.length) : type == 'string' && index in object) return (0, $20d35a3e3bd6bf79$export$2e2bcd8739ae039)(object[index], value);
    return false;
}
var $eb9a18e9cea9d166$export$2e2bcd8739ae039 = $eb9a18e9cea9d166$var$isIterateeCall;


/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $0182d9e87648117d$var$createAssigner(assigner) {
    return (0, $aa7be9aefd40c425$export$2e2bcd8739ae039)(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && (0, $eb9a18e9cea9d166$export$2e2bcd8739ae039)(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
var $0182d9e87648117d$export$2e2bcd8739ae039 = $0182d9e87648117d$var$createAssigner;


/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $4dea300bb9269819$var$merge = (0, $0182d9e87648117d$export$2e2bcd8739ae039)(function(object, source, srcIndex) {
    (0, $e65a113fbada4b73$export$2e2bcd8739ae039)(object, source, srcIndex);
});
var $4dea300bb9269819$export$2e2bcd8739ae039 = $4dea300bb9269819$var$merge;


var $53ba7047d513ec75$export$5eec0980ed568dae = function Raised(_ref) {
    var zDepth = _ref.zDepth, radius = _ref.radius, background = _ref.background, children = _ref.children, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))((0, $4dea300bb9269819$export$2e2bcd8739ae039)({
        'default': {
            wrap: {
                position: 'relative',
                display: 'inline-block'
            },
            content: {
                position: 'relative'
            },
            bg: {
                absolute: '0px 0px 0px 0px',
                boxShadow: '0 ' + zDepth + 'px ' + zDepth * 4 + 'px rgba(0,0,0,.24)',
                borderRadius: radius,
                background: background
            }
        },
        'zDepth-0': {
            bg: {
                boxShadow: 'none'
            }
        },
        'zDepth-1': {
            bg: {
                boxShadow: '0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)'
            }
        },
        'zDepth-2': {
            bg: {
                boxShadow: '0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)'
            }
        },
        'zDepth-3': {
            bg: {
                boxShadow: '0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)'
            }
        },
        'zDepth-4': {
            bg: {
                boxShadow: '0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)'
            }
        },
        'zDepth-5': {
            bg: {
                boxShadow: '0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)'
            }
        },
        'square': {
            bg: {
                borderRadius: '0'
            }
        },
        'circle': {
            bg: {
                borderRadius: '50%'
            }
        }
    }, passedStyles), {
        'zDepth-1': zDepth === 1
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.wrap
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.bg
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.content
    }, children));
};
$53ba7047d513ec75$export$5eec0980ed568dae.propTypes = {
    background: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).string,
    zDepth: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).oneOf([
        0,
        1,
        2,
        3,
        4,
        5
    ]),
    radius: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).number,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).object
};
$53ba7047d513ec75$export$5eec0980ed568dae.defaultProps = {
    background: '#fff',
    zDepth: 1,
    radius: 2,
    styles: {}
};
var $53ba7047d513ec75$export$2e2bcd8739ae039 = $53ba7047d513ec75$export$5eec0980ed568dae;



var $8FY87 = parcelRequire("8FY87");



var $kgEOh = parcelRequire("kgEOh");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $6b503b5592189cfe$var$now = function() {
    return (0, $kgEOh.default).Date.now();
};
var $6b503b5592189cfe$export$2e2bcd8739ae039 = $6b503b5592189cfe$var$now;


/** Used to match a single whitespace character. */ var $ae4409f48aef3014$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $ae4409f48aef3014$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $ae4409f48aef3014$var$reWhitespace.test(string.charAt(index)));
    return index;
}
var $ae4409f48aef3014$export$2e2bcd8739ae039 = $ae4409f48aef3014$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $bd99693620e50515$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $bd99693620e50515$var$baseTrim(string) {
    return string ? string.slice(0, (0, $ae4409f48aef3014$export$2e2bcd8739ae039)(string) + 1).replace($bd99693620e50515$var$reTrimStart, '') : string;
}
var $bd99693620e50515$export$2e2bcd8739ae039 = $bd99693620e50515$var$baseTrim;





/** `Object#toString` result references. */ var $9b727c88123a0fb8$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $9b727c88123a0fb8$var$isSymbol(value) {
    return typeof value == 'symbol' || (0, $8ef6de3f0576ee8c$export$2e2bcd8739ae039)(value) && (0, $492d0391f2ac61ec$export$2e2bcd8739ae039)(value) == $9b727c88123a0fb8$var$symbolTag;
}
var $9b727c88123a0fb8$export$2e2bcd8739ae039 = $9b727c88123a0fb8$var$isSymbol;


/** Used as references for various `Number` constants. */ var $af42f8a970a5e42d$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $af42f8a970a5e42d$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $af42f8a970a5e42d$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $af42f8a970a5e42d$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $af42f8a970a5e42d$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $af42f8a970a5e42d$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ((0, $9b727c88123a0fb8$export$2e2bcd8739ae039)(value)) return $af42f8a970a5e42d$var$NAN;
    if ((0, $0f0b33514751195d$export$2e2bcd8739ae039)(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = (0, $0f0b33514751195d$export$2e2bcd8739ae039)(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = (0, $bd99693620e50515$export$2e2bcd8739ae039)(value);
    var isBinary = $af42f8a970a5e42d$var$reIsBinary.test(value);
    return isBinary || $af42f8a970a5e42d$var$reIsOctal.test(value) ? $af42f8a970a5e42d$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $af42f8a970a5e42d$var$reIsBadHex.test(value) ? $af42f8a970a5e42d$var$NAN : +value;
}
var $af42f8a970a5e42d$export$2e2bcd8739ae039 = $af42f8a970a5e42d$var$toNumber;


/** Error message constants. */ var $66cfcacde6964208$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $66cfcacde6964208$var$nativeMax = Math.max, $66cfcacde6964208$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $66cfcacde6964208$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($66cfcacde6964208$var$FUNC_ERROR_TEXT);
    wait = (0, $af42f8a970a5e42d$export$2e2bcd8739ae039)(wait) || 0;
    if ((0, $0f0b33514751195d$export$2e2bcd8739ae039)(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $66cfcacde6964208$var$nativeMax((0, $af42f8a970a5e42d$export$2e2bcd8739ae039)(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $66cfcacde6964208$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = (0, $6b503b5592189cfe$export$2e2bcd8739ae039)();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge((0, $6b503b5592189cfe$export$2e2bcd8739ae039)());
    }
    function debounced() {
        var time = (0, $6b503b5592189cfe$export$2e2bcd8739ae039)(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var $66cfcacde6964208$export$2e2bcd8739ae039 = $66cfcacde6964208$var$debounce;



/** Error message constants. */ var $28a26b3c2d876d0b$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $28a26b3c2d876d0b$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($28a26b3c2d876d0b$var$FUNC_ERROR_TEXT);
    if ((0, $0f0b33514751195d$export$2e2bcd8739ae039)(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return (0, $66cfcacde6964208$export$2e2bcd8739ae039)(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
var $28a26b3c2d876d0b$export$2e2bcd8739ae039 = $28a26b3c2d876d0b$var$throttle;


var $6e5c7cd9bca79ec4$export$a056a977bf6a9a3c = function calculateChange(e, hsl, container) {
    var _container$getBoundin = container.getBoundingClientRect(), containerWidth = _container$getBoundin.width, containerHeight = _container$getBoundin.height;
    var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (left < 0) left = 0;
    else if (left > containerWidth) left = containerWidth;
    if (top < 0) top = 0;
    else if (top > containerHeight) top = containerHeight;
    var saturation = left / containerWidth;
    var bright = 1 - top / containerHeight;
    return {
        h: hsl.h,
        s: saturation,
        v: bright,
        a: hsl.a,
        source: 'hsv'
    };
};


var $16928b06bc556b42$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $16928b06bc556b42$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $16928b06bc556b42$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $16928b06bc556b42$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $16928b06bc556b42$export$c4dbe12ffaee3c8e = function(_ref) {
    $16928b06bc556b42$var$_inherits(Saturation, _ref);
    function Saturation(props) {
        $16928b06bc556b42$var$_classCallCheck(this, Saturation);
        var _this = $16928b06bc556b42$var$_possibleConstructorReturn(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));
        _this.handleChange = function(e) {
            typeof _this.props.onChange === 'function' && _this.throttle(_this.props.onChange, $6e5c7cd9bca79ec4$export$a056a977bf6a9a3c(e, _this.props.hsl, _this.container), e);
        };
        _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            var renderWindow = _this.getContainerRenderWindow();
            renderWindow.addEventListener('mousemove', _this.handleChange);
            renderWindow.addEventListener('mouseup', _this.handleMouseUp);
        };
        _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        };
        _this.throttle = (0, $28a26b3c2d876d0b$export$2e2bcd8739ae039)(function(fn, data, e) {
            fn(data, e);
        }, 50);
        return _this;
    }
    $16928b06bc556b42$var$_createClass(Saturation, [
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.throttle.cancel();
                this.unbindEventListeners();
            }
        },
        {
            key: 'getContainerRenderWindow',
            value: function getContainerRenderWindow() {
                var container = this.container;
                var renderWindow = window;
                while(!renderWindow.document.contains(container) && renderWindow.parent !== renderWindow)renderWindow = renderWindow.parent;
                return renderWindow;
            }
        },
        {
            key: 'unbindEventListeners',
            value: function unbindEventListeners() {
                var renderWindow = this.getContainerRenderWindow();
                renderWindow.removeEventListener('mousemove', this.handleChange);
                renderWindow.removeEventListener('mouseup', this.handleMouseUp);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var _ref2 = this.props.style || {}, color = _ref2.color, white = _ref2.white, black = _ref2.black, pointer = _ref2.pointer, circle = _ref2.circle;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))({
                    'default': {
                        color: {
                            absolute: '0px 0px 0px 0px',
                            background: 'hsl(' + this.props.hsl.h + ',100%, 50%)',
                            borderRadius: this.props.radius
                        },
                        white: {
                            absolute: '0px 0px 0px 0px',
                            borderRadius: this.props.radius
                        },
                        black: {
                            absolute: '0px 0px 0px 0px',
                            boxShadow: this.props.shadow,
                            borderRadius: this.props.radius
                        },
                        pointer: {
                            position: 'absolute',
                            top: -(this.props.hsv.v * 100) + 100 + '%',
                            left: this.props.hsv.s * 100 + '%',
                            cursor: 'default'
                        },
                        circle: {
                            width: '4px',
                            height: '4px',
                            boxShadow: '0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)',
                            borderRadius: '50%',
                            cursor: 'hand',
                            transform: 'translate(-2px, -2px)'
                        }
                    },
                    'custom': {
                        color: color,
                        white: white,
                        black: black,
                        pointer: pointer,
                        circle: circle
                    }
                }, {
                    'custom': !!this.props.style
                });
                return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.color,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('style', null, '\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        '), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.white,
                    className: 'saturation-white'
                }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.black,
                    className: 'saturation-black'
                }), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.pointer
                }, this.props.pointer ? (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement(this.props.pointer, this.props) : (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.circle
                }))));
            }
        }
    ]);
    return Saturation;
}((0, $8FY87.PureComponent) || (0, $8FY87.Component));
var $16928b06bc556b42$export$2e2bcd8739ae039 = $16928b06bc556b42$export$c4dbe12ffaee3c8e;



var $8FY87 = parcelRequire("8FY87");

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $565eb47815d24591$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $565eb47815d24591$export$2e2bcd8739ae039 = $565eb47815d24591$var$arrayEach;






/* Built-in method references for those with the same name as other `lodash` methods. */ var $76ffac1c4aa0127a$var$nativeKeys = (0, $4902ec53a1ca302a$export$2e2bcd8739ae039)(Object.keys, Object);
var $76ffac1c4aa0127a$export$2e2bcd8739ae039 = $76ffac1c4aa0127a$var$nativeKeys;


/** Used for built-in method references. */ var $0fdaabe4cc14a0fc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0fdaabe4cc14a0fc$var$hasOwnProperty = $0fdaabe4cc14a0fc$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $0fdaabe4cc14a0fc$var$baseKeys(object) {
    if (!(0, $e99fdb1634bd539a$export$2e2bcd8739ae039)(object)) return (0, $76ffac1c4aa0127a$export$2e2bcd8739ae039)(object);
    var result = [];
    for(var key in Object(object))if ($0fdaabe4cc14a0fc$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
var $0fdaabe4cc14a0fc$export$2e2bcd8739ae039 = $0fdaabe4cc14a0fc$var$baseKeys;



/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $a11509b56113c9fb$var$keys(object) {
    return (0, $5c88ed82b217ac2c$export$2e2bcd8739ae039)(object) ? (0, $b724d1dcfe1dcaf1$export$2e2bcd8739ae039)(object) : (0, $0fdaabe4cc14a0fc$export$2e2bcd8739ae039)(object);
}
var $a11509b56113c9fb$export$2e2bcd8739ae039 = $a11509b56113c9fb$var$keys;


/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $ce01b1ee7685708c$var$baseForOwn(object, iteratee) {
    return object && (0, $1d02b30d0f0d3042$export$2e2bcd8739ae039)(object, iteratee, (0, $a11509b56113c9fb$export$2e2bcd8739ae039));
}
var $ce01b1ee7685708c$export$2e2bcd8739ae039 = $ce01b1ee7685708c$var$baseForOwn;



/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $5dcb8872264c4d1b$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!(0, $5c88ed82b217ac2c$export$2e2bcd8739ae039)(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
var $5dcb8872264c4d1b$export$2e2bcd8739ae039 = $5dcb8872264c4d1b$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $4b0525113f2f7fa7$var$baseEach = (0, $5dcb8872264c4d1b$export$2e2bcd8739ae039)((0, $ce01b1ee7685708c$export$2e2bcd8739ae039));
var $4b0525113f2f7fa7$export$2e2bcd8739ae039 = $4b0525113f2f7fa7$var$baseEach;



/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $b93bc2f41bc5bc68$var$castFunction(value) {
    return typeof value == 'function' ? value : (0, $1c32b2559fcaca3b$export$2e2bcd8739ae039);
}
var $b93bc2f41bc5bc68$export$2e2bcd8739ae039 = $b93bc2f41bc5bc68$var$castFunction;



/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $b80ff2f95835af92$var$forEach(collection, iteratee) {
    var func = (0, $acb56a590d5e2bcb$export$2e2bcd8739ae039)(collection) ? (0, $565eb47815d24591$export$2e2bcd8739ae039) : (0, $4b0525113f2f7fa7$export$2e2bcd8739ae039);
    return func(collection, (0, $b93bc2f41bc5bc68$export$2e2bcd8739ae039)(iteratee));
}
var $b80ff2f95835af92$export$2e2bcd8739ae039 = $b80ff2f95835af92$var$forEach;


var $84ebedfd68f8ec8c$exports = {};
// This file is autogenerated. It's used to publish CJS to npm.
(function(global, factory) {
    $84ebedfd68f8ec8c$exports = factory();
})($84ebedfd68f8ec8c$exports, function() {
    'use strict';
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    // https://github.com/bgrins/TinyColor
    // Brian Grinstead, MIT License
    var trimLeft = /^\s+/;
    var trimRight = /\s+$/;
    function tinycolor(color, opts) {
        color = color ? color : "";
        opts = opts || {};
        // If input is already a tinycolor, return itself
        if (color instanceof tinycolor) return color;
        // If we are called as a function, call using new instead
        if (!(this instanceof tinycolor)) return new tinycolor(color, opts);
        var rgb = inputToRGB(color);
        this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
        this._gradientType = opts.gradientType;
        // Don't let the range of [0,255] come back in [0,1].
        // Potentially lose a little bit of precision here, but will fix issues where
        // .5 gets interpreted as half of the total, instead of half of 1
        // If it was supposed to be 128, this was already taken care of by `inputToRgb`
        if (this._r < 1) this._r = Math.round(this._r);
        if (this._g < 1) this._g = Math.round(this._g);
        if (this._b < 1) this._b = Math.round(this._b);
        this._ok = rgb.ok;
    }
    tinycolor.prototype = {
        isDark: function isDark() {
            return this.getBrightness() < 128;
        },
        isLight: function isLight() {
            return !this.isDark();
        },
        isValid: function isValid() {
            return this._ok;
        },
        getOriginalInput: function getOriginalInput() {
            return this._originalInput;
        },
        getFormat: function getFormat() {
            return this._format;
        },
        getAlpha: function getAlpha() {
            return this._a;
        },
        getBrightness: function getBrightness() {
            //http://www.w3.org/TR/AERT#color-contrast
            var rgb = this.toRgb();
            return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
        },
        getLuminance: function getLuminance() {
            //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
            var rgb = this.toRgb();
            var RsRGB, GsRGB, BsRGB, R, G, B;
            RsRGB = rgb.r / 255;
            GsRGB = rgb.g / 255;
            BsRGB = rgb.b / 255;
            if (RsRGB <= 0.03928) R = RsRGB / 12.92;
            else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
            if (GsRGB <= 0.03928) G = GsRGB / 12.92;
            else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
            if (BsRGB <= 0.03928) B = BsRGB / 12.92;
            else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
            return 0.2126 * R + 0.7152 * G + 0.0722 * B;
        },
        setAlpha: function setAlpha(value) {
            this._a = boundAlpha(value);
            this._roundA = Math.round(100 * this._a) / 100;
            return this;
        },
        toHsv: function toHsv() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            return {
                h: hsv.h * 360,
                s: hsv.s,
                v: hsv.v,
                a: this._a
            };
        },
        toHsvString: function toHsvString() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            var h = Math.round(hsv.h * 360), s = Math.round(hsv.s * 100), v = Math.round(hsv.v * 100);
            return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
        },
        toHsl: function toHsl() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            return {
                h: hsl.h * 360,
                s: hsl.s,
                l: hsl.l,
                a: this._a
            };
        },
        toHslString: function toHslString() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            var h = Math.round(hsl.h * 360), s = Math.round(hsl.s * 100), l = Math.round(hsl.l * 100);
            return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
        },
        toHex: function toHex(allow3Char) {
            return rgbToHex(this._r, this._g, this._b, allow3Char);
        },
        toHexString: function toHexString(allow3Char) {
            return "#" + this.toHex(allow3Char);
        },
        toHex8: function toHex8(allow4Char) {
            return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
        },
        toHex8String: function toHex8String(allow4Char) {
            return "#" + this.toHex8(allow4Char);
        },
        toRgb: function toRgb() {
            return {
                r: Math.round(this._r),
                g: Math.round(this._g),
                b: Math.round(this._b),
                a: this._a
            };
        },
        toRgbString: function toRgbString() {
            return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
        },
        toPercentageRgb: function toPercentageRgb() {
            return {
                r: Math.round(bound01(this._r, 255) * 100) + "%",
                g: Math.round(bound01(this._g, 255) * 100) + "%",
                b: Math.round(bound01(this._b, 255) * 100) + "%",
                a: this._a
            };
        },
        toPercentageRgbString: function toPercentageRgbString() {
            return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
        },
        toName: function toName() {
            if (this._a === 0) return "transparent";
            if (this._a < 1) return false;
            return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
        },
        toFilter: function toFilter(secondColor) {
            var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
            var secondHex8String = hex8String;
            var gradientType = this._gradientType ? "GradientType = 1, " : "";
            if (secondColor) {
                var s = tinycolor(secondColor);
                secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
            }
            return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
        },
        toString: function toString(format) {
            var formatSet = !!format;
            format = format || this._format;
            var formattedString = false;
            var hasAlpha = this._a < 1 && this._a >= 0;
            var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
            if (needsAlphaFormat) {
                // Special case for "transparent", all other non-alpha formats
                // will return rgba when there is transparency.
                if (format === "name" && this._a === 0) return this.toName();
                return this.toRgbString();
            }
            if (format === "rgb") formattedString = this.toRgbString();
            if (format === "prgb") formattedString = this.toPercentageRgbString();
            if (format === "hex" || format === "hex6") formattedString = this.toHexString();
            if (format === "hex3") formattedString = this.toHexString(true);
            if (format === "hex4") formattedString = this.toHex8String(true);
            if (format === "hex8") formattedString = this.toHex8String();
            if (format === "name") formattedString = this.toName();
            if (format === "hsl") formattedString = this.toHslString();
            if (format === "hsv") formattedString = this.toHsvString();
            return formattedString || this.toHexString();
        },
        clone: function clone() {
            return tinycolor(this.toString());
        },
        _applyModification: function _applyModification(fn, args) {
            var color = fn.apply(null, [
                this
            ].concat([].slice.call(args)));
            this._r = color._r;
            this._g = color._g;
            this._b = color._b;
            this.setAlpha(color._a);
            return this;
        },
        lighten: function lighten() {
            return this._applyModification(_lighten, arguments);
        },
        brighten: function brighten() {
            return this._applyModification(_brighten, arguments);
        },
        darken: function darken() {
            return this._applyModification(_darken, arguments);
        },
        desaturate: function desaturate() {
            return this._applyModification(_desaturate, arguments);
        },
        saturate: function saturate() {
            return this._applyModification(_saturate, arguments);
        },
        greyscale: function greyscale() {
            return this._applyModification(_greyscale, arguments);
        },
        spin: function spin() {
            return this._applyModification(_spin, arguments);
        },
        _applyCombination: function _applyCombination(fn, args) {
            return fn.apply(null, [
                this
            ].concat([].slice.call(args)));
        },
        analogous: function analogous() {
            return this._applyCombination(_analogous, arguments);
        },
        complement: function complement() {
            return this._applyCombination(_complement, arguments);
        },
        monochromatic: function monochromatic() {
            return this._applyCombination(_monochromatic, arguments);
        },
        splitcomplement: function splitcomplement() {
            return this._applyCombination(_splitcomplement, arguments);
        },
        // Disabled until https://github.com/bgrins/TinyColor/issues/254
        // polyad: function (number) {
        //   return this._applyCombination(polyad, [number]);
        // },
        triad: function triad() {
            return this._applyCombination(polyad, [
                3
            ]);
        },
        tetrad: function tetrad() {
            return this._applyCombination(polyad, [
                4
            ]);
        }
    };
    // If input is an object, force 1 into "1.0" to handle ratios properly
    // String input requires "1.0" as input, so 1 will be treated as 1
    tinycolor.fromRatio = function(color, opts) {
        if (_typeof(color) == "object") {
            var newColor = {};
            for(var i in color)if (color.hasOwnProperty(i)) {
                if (i === "a") newColor[i] = color[i];
                else newColor[i] = convertToPercentage(color[i]);
            }
            color = newColor;
        }
        return tinycolor(color, opts);
    };
    // Given a string or object, convert that input to RGB
    // Possible string inputs:
    //
    //     "red"
    //     "#f00" or "f00"
    //     "#ff0000" or "ff0000"
    //     "#ff000000" or "ff000000"
    //     "rgb 255 0 0" or "rgb (255, 0, 0)"
    //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
    //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
    //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
    //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
    //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
    //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
    //
    function inputToRGB(color) {
        var rgb = {
            r: 0,
            g: 0,
            b: 0
        };
        var a = 1;
        var s = null;
        var v = null;
        var l = null;
        var ok = false;
        var format = false;
        if (typeof color == "string") color = stringInputToObject(color);
        if (_typeof(color) == "object") {
            if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
                rgb = rgbToRgb(color.r, color.g, color.b);
                ok = true;
                format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
                s = convertToPercentage(color.s);
                v = convertToPercentage(color.v);
                rgb = hsvToRgb(color.h, s, v);
                ok = true;
                format = "hsv";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
                s = convertToPercentage(color.s);
                l = convertToPercentage(color.l);
                rgb = hslToRgb(color.h, s, l);
                ok = true;
                format = "hsl";
            }
            if (color.hasOwnProperty("a")) a = color.a;
        }
        a = boundAlpha(a);
        return {
            ok: ok,
            format: color.format || format,
            r: Math.min(255, Math.max(rgb.r, 0)),
            g: Math.min(255, Math.max(rgb.g, 0)),
            b: Math.min(255, Math.max(rgb.b, 0)),
            a: a
        };
    }
    // Conversion Functions
    // --------------------
    // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
    // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
    // `rgbToRgb`
    // Handle bounds / percentage checking to conform to CSS color spec
    // <http://www.w3.org/TR/css3-color/>
    // *Assumes:* r, g, b in [0, 255] or [0, 1]
    // *Returns:* { r, g, b } in [0, 255]
    function rgbToRgb(r, g, b) {
        return {
            r: bound01(r, 255) * 255,
            g: bound01(g, 255) * 255,
            b: bound01(b, 255) * 255
        };
    }
    // `rgbToHsl`
    // Converts an RGB color value to HSL.
    // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
    // *Returns:* { h, s, l } in [0,1]
    function rgbToHsl(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, l = (max + min) / 2;
        if (max == min) h = s = 0; // achromatic
        else {
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            l: l
        };
    }
    // `hslToRgb`
    // Converts an HSL color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hslToRgb(h, s, l) {
        var r, g, b;
        h = bound01(h, 360);
        s = bound01(s, 100);
        l = bound01(l, 100);
        function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        }
        if (s === 0) r = g = b = l; // achromatic
        else {
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = hue2rgb(p, q, h + 1 / 3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1 / 3);
        }
        return {
            r: r * 255,
            g: g * 255,
            b: b * 255
        };
    }
    // `rgbToHsv`
    // Converts an RGB color value to HSV
    // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
    // *Returns:* { h, s, v } in [0,1]
    function rgbToHsv(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, v = max;
        var d = max - min;
        s = max === 0 ? 0 : d / max;
        if (max == min) h = 0; // achromatic
        else {
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            v: v
        };
    }
    // `hsvToRgb`
    // Converts an HSV color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hsvToRgb(h, s, v) {
        h = bound01(h, 360) * 6;
        s = bound01(s, 100);
        v = bound01(v, 100);
        var i = Math.floor(h), f = h - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s), mod = i % 6, r = [
            v,
            q,
            p,
            p,
            t,
            v
        ][mod], g = [
            t,
            v,
            v,
            q,
            p,
            p
        ][mod], b = [
            p,
            p,
            t,
            v,
            v,
            q
        ][mod];
        return {
            r: r * 255,
            g: g * 255,
            b: b * 255
        };
    }
    // `rgbToHex`
    // Converts an RGB color to hex
    // Assumes r, g, and b are contained in the set [0, 255]
    // Returns a 3 or 6 character hex
    function rgbToHex(r, g, b, allow3Char) {
        var hex = [
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16))
        ];
        // Return a 3 character hex if possible
        if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
        return hex.join("");
    }
    // `rgbaToHex`
    // Converts an RGBA color plus alpha transparency to hex
    // Assumes r, g, b are contained in the set [0, 255] and
    // a in [0, 1]. Returns a 4 or 8 character rgba hex
    function rgbaToHex(r, g, b, a, allow4Char) {
        var hex = [
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16)),
            pad2(convertDecimalToHex(a))
        ];
        // Return a 4 character hex if possible
        if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
        return hex.join("");
    }
    // `rgbaToArgbHex`
    // Converts an RGBA color to an ARGB Hex8 string
    // Rarely used, but required for "toFilter()"
    function rgbaToArgbHex(r, g, b, a) {
        var hex = [
            pad2(convertDecimalToHex(a)),
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16))
        ];
        return hex.join("");
    }
    // `equals`
    // Can be called with any tinycolor input
    tinycolor.equals = function(color1, color2) {
        if (!color1 || !color2) return false;
        return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
    };
    tinycolor.random = function() {
        return tinycolor.fromRatio({
            r: Math.random(),
            g: Math.random(),
            b: Math.random()
        });
    };
    // Modification Functions
    // ----------------------
    // Thanks to less.js for some of the basics here
    // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
    function _desaturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s -= amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }
    function _saturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s += amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }
    function _greyscale(color) {
        return tinycolor(color).desaturate(100);
    }
    function _lighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l += amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }
    function _brighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var rgb = tinycolor(color).toRgb();
        rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
        rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
        rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
        return tinycolor(rgb);
    }
    function _darken(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l -= amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }
    // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
    // Values outside of this range will be wrapped into this range.
    function _spin(color, amount) {
        var hsl = tinycolor(color).toHsl();
        var hue = (hsl.h + amount) % 360;
        hsl.h = hue < 0 ? 360 + hue : hue;
        return tinycolor(hsl);
    }
    // Combination Functions
    // ---------------------
    // Thanks to jQuery xColor for some of the ideas behind these
    // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
    function _complement(color) {
        var hsl = tinycolor(color).toHsl();
        hsl.h = (hsl.h + 180) % 360;
        return tinycolor(hsl);
    }
    function polyad(color, number) {
        if (isNaN(number) || number <= 0) throw new Error("Argument to polyad must be a positive number");
        var hsl = tinycolor(color).toHsl();
        var result = [
            tinycolor(color)
        ];
        var step = 360 / number;
        for(var i = 1; i < number; i++)result.push(tinycolor({
            h: (hsl.h + i * step) % 360,
            s: hsl.s,
            l: hsl.l
        }));
        return result;
    }
    function _splitcomplement(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({
                h: (h + 72) % 360,
                s: hsl.s,
                l: hsl.l
            }),
            tinycolor({
                h: (h + 216) % 360,
                s: hsl.s,
                l: hsl.l
            })
        ];
    }
    function _analogous(color, results, slices) {
        results = results || 6;
        slices = slices || 30;
        var hsl = tinycolor(color).toHsl();
        var part = 360 / slices;
        var ret = [
            tinycolor(color)
        ];
        for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
            hsl.h = (hsl.h + part) % 360;
            ret.push(tinycolor(hsl));
        }
        return ret;
    }
    function _monochromatic(color, results) {
        results = results || 6;
        var hsv = tinycolor(color).toHsv();
        var h = hsv.h, s = hsv.s, v = hsv.v;
        var ret = [];
        var modification = 1 / results;
        while(results--){
            ret.push(tinycolor({
                h: h,
                s: s,
                v: v
            }));
            v = (v + modification) % 1;
        }
        return ret;
    }
    // Utility Functions
    // ---------------------
    tinycolor.mix = function(color1, color2, amount) {
        amount = amount === 0 ? 0 : amount || 50;
        var rgb1 = tinycolor(color1).toRgb();
        var rgb2 = tinycolor(color2).toRgb();
        var p = amount / 100;
        var rgba = {
            r: (rgb2.r - rgb1.r) * p + rgb1.r,
            g: (rgb2.g - rgb1.g) * p + rgb1.g,
            b: (rgb2.b - rgb1.b) * p + rgb1.b,
            a: (rgb2.a - rgb1.a) * p + rgb1.a
        };
        return tinycolor(rgba);
    };
    // Readability Functions
    // ---------------------
    // <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
    // `contrast`
    // Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
    tinycolor.readability = function(color1, color2) {
        var c1 = tinycolor(color1);
        var c2 = tinycolor(color2);
        return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
    };
    // `isReadable`
    // Ensure that foreground and background color combinations meet WCAG2 guidelines.
    // The third argument is an optional Object.
    //      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
    //      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
    // If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
    // *Example*
    //    tinycolor.isReadable("#000", "#111") => false
    //    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
    tinycolor.isReadable = function(color1, color2, wcag2) {
        var readability = tinycolor.readability(color1, color2);
        var wcag2Parms, out;
        out = false;
        wcag2Parms = validateWCAG2Parms(wcag2);
        switch(wcag2Parms.level + wcag2Parms.size){
            case "AAsmall":
            case "AAAlarge":
                out = readability >= 4.5;
                break;
            case "AAlarge":
                out = readability >= 3;
                break;
            case "AAAsmall":
                out = readability >= 7;
                break;
        }
        return out;
    };
    // `mostReadable`
    // Given a base color and a list of possible foreground or background
    // colors for that base, returns the most readable color.
    // Optionally returns Black or White if the most readable color is unreadable.
    // *Example*
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
    tinycolor.mostReadable = function(baseColor, colorList, args) {
        var bestColor = null;
        var bestScore = 0;
        var readability;
        var includeFallbackColors, level, size;
        args = args || {};
        includeFallbackColors = args.includeFallbackColors;
        level = args.level;
        size = args.size;
        for(var i = 0; i < colorList.length; i++){
            readability = tinycolor.readability(baseColor, colorList[i]);
            if (readability > bestScore) {
                bestScore = readability;
                bestColor = tinycolor(colorList[i]);
            }
        }
        if (tinycolor.isReadable(baseColor, bestColor, {
            level: level,
            size: size
        }) || !includeFallbackColors) return bestColor;
        else {
            args.includeFallbackColors = false;
            return tinycolor.mostReadable(baseColor, [
                "#fff",
                "#000"
            ], args);
        }
    };
    // Big List of Colors
    // ------------------
    // <https://www.w3.org/TR/css-color-4/#named-colors>
    var names = tinycolor.names = {
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "0ff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000",
        blanchedalmond: "ffebcd",
        blue: "00f",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        burntsienna: "ea7e5d",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "0ff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkgrey: "a9a9a9",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkslategrey: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dimgrey: "696969",
        dodgerblue: "1e90ff",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "f0f",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        grey: "808080",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgray: "d3d3d3",
        lightgreen: "90ee90",
        lightgrey: "d3d3d3",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslategray: "789",
        lightslategrey: "789",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "0f0",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "f0f",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370db",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "db7093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        rebeccapurple: "663399",
        red: "f00",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        slategrey: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        wheat: "f5deb3",
        white: "fff",
        whitesmoke: "f5f5f5",
        yellow: "ff0",
        yellowgreen: "9acd32"
    };
    // Make it easy to access colors via `hexNames[hex]`
    var hexNames = tinycolor.hexNames = flip(names);
    // Utilities
    // ---------
    // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
    function flip(o) {
        var flipped = {};
        for(var i in o)if (o.hasOwnProperty(i)) flipped[o[i]] = i;
        return flipped;
    }
    // Return a valid alpha value [0,1] with all invalid values being set to 1
    function boundAlpha(a) {
        a = parseFloat(a);
        if (isNaN(a) || a < 0 || a > 1) a = 1;
        return a;
    }
    // Take input from [0, n] and return it as [0, 1]
    function bound01(n, max) {
        if (isOnePointZero(n)) n = "100%";
        var processPercent = isPercentage(n);
        n = Math.min(max, Math.max(0, parseFloat(n)));
        // Automatically convert percentage into number
        if (processPercent) n = parseInt(n * max, 10) / 100;
        // Handle floating point rounding errors
        if (Math.abs(n - max) < 0.000001) return 1;
        // Convert into [0, 1] range if it isn't already
        return n % max / parseFloat(max);
    }
    // Force a number between 0 and 1
    function clamp01(val) {
        return Math.min(1, Math.max(0, val));
    }
    // Parse a base-16 hex value into a base-10 integer
    function parseIntFromHex(val) {
        return parseInt(val, 16);
    }
    // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
    // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
    function isOnePointZero(n) {
        return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
    }
    // Check to see if string passed in is a percentage
    function isPercentage(n) {
        return typeof n === "string" && n.indexOf("%") != -1;
    }
    // Force a hex value to have 2 characters
    function pad2(c) {
        return c.length == 1 ? "0" + c : "" + c;
    }
    // Replace a decimal with it's percentage value
    function convertToPercentage(n) {
        if (n <= 1) n = n * 100 + "%";
        return n;
    }
    // Converts a decimal to a hex value
    function convertDecimalToHex(d) {
        return Math.round(parseFloat(d) * 255).toString(16);
    }
    // Converts a hex value to a decimal
    function convertHexToDecimal(h) {
        return parseIntFromHex(h) / 255;
    }
    var matchers = function() {
        // <http://www.w3.org/TR/css3-values/#integers>
        var CSS_INTEGER = "[-\\+]?\\d+%?";
        // <http://www.w3.org/TR/css3-values/#number-value>
        var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
        // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
        var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
        // Actual matching.
        // Parentheses and commas are optional, but not required.
        // Whitespace can take the place of commas or opening paren
        var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        return {
            CSS_UNIT: new RegExp(CSS_UNIT),
            rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
            rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
            hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
            hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
            hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
            hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
            hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
            hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
        };
    }();
    // `isValidCSSUnit`
    // Take in a single string / number and check to see if it looks like a CSS unit
    // (see `matchers` above for definition).
    function isValidCSSUnit(color) {
        return !!matchers.CSS_UNIT.exec(color);
    }
    // `stringInputToObject`
    // Permissive string parsing.  Take in a number of formats, and output an object
    // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
    function stringInputToObject(color) {
        color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
        var named = false;
        if (names[color]) {
            color = names[color];
            named = true;
        } else if (color == "transparent") return {
            r: 0,
            g: 0,
            b: 0,
            a: 0,
            format: "name"
        };
        // Try to match string input using regular expressions.
        // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
        // Just return an object and let the conversion functions handle that.
        // This way the result will be the same whether the tinycolor is initialized with string or object.
        var match;
        if (match = matchers.rgb.exec(color)) return {
            r: match[1],
            g: match[2],
            b: match[3]
        };
        if (match = matchers.rgba.exec(color)) return {
            r: match[1],
            g: match[2],
            b: match[3],
            a: match[4]
        };
        if (match = matchers.hsl.exec(color)) return {
            h: match[1],
            s: match[2],
            l: match[3]
        };
        if (match = matchers.hsla.exec(color)) return {
            h: match[1],
            s: match[2],
            l: match[3],
            a: match[4]
        };
        if (match = matchers.hsv.exec(color)) return {
            h: match[1],
            s: match[2],
            v: match[3]
        };
        if (match = matchers.hsva.exec(color)) return {
            h: match[1],
            s: match[2],
            v: match[3],
            a: match[4]
        };
        if (match = matchers.hex8.exec(color)) return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
        if (match = matchers.hex6.exec(color)) return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
        if (match = matchers.hex4.exec(color)) return {
            r: parseIntFromHex(match[1] + "" + match[1]),
            g: parseIntFromHex(match[2] + "" + match[2]),
            b: parseIntFromHex(match[3] + "" + match[3]),
            a: convertHexToDecimal(match[4] + "" + match[4]),
            format: named ? "name" : "hex8"
        };
        if (match = matchers.hex3.exec(color)) return {
            r: parseIntFromHex(match[1] + "" + match[1]),
            g: parseIntFromHex(match[2] + "" + match[2]),
            b: parseIntFromHex(match[3] + "" + match[3]),
            format: named ? "name" : "hex"
        };
        return false;
    }
    function validateWCAG2Parms(parms) {
        // return valid WCAG2 parms for isReadable.
        // If input parms are invalid, return {"level":"AA", "size":"small"}
        var level, size;
        parms = parms || {
            level: "AA",
            size: "small"
        };
        level = (parms.level || "AA").toUpperCase();
        size = (parms.size || "small").toLowerCase();
        if (level !== "AA" && level !== "AAA") level = "AA";
        if (size !== "small" && size !== "large") size = "small";
        return {
            level: level,
            size: size
        };
    }
    return tinycolor;
});


var $0484844d062f071f$export$4837207a530c7f21 = function simpleCheckForValidColor(data) {
    var keysToCheck = [
        'r',
        'g',
        'b',
        'a',
        'h',
        's',
        'l',
        'v'
    ];
    var checked = 0;
    var passed = 0;
    (0, $b80ff2f95835af92$export$2e2bcd8739ae039)(keysToCheck, function(letter) {
        if (data[letter]) {
            checked += 1;
            if (!isNaN(data[letter])) passed += 1;
            if (letter === 's' || letter === 'l') {
                var percentPatt = /^\d+%$/;
                if (percentPatt.test(data[letter])) passed += 1;
            }
        }
    });
    return checked === passed ? data : false;
};
var $0484844d062f071f$export$6bed283375899438 = function toState(data, oldHue) {
    var color = data.hex ? (0, (/*@__PURE__*/$parcel$interopDefault($84ebedfd68f8ec8c$exports)))(data.hex) : (0, (/*@__PURE__*/$parcel$interopDefault($84ebedfd68f8ec8c$exports)))(data);
    var hsl = color.toHsl();
    var hsv = color.toHsv();
    var rgb = color.toRgb();
    var hex = color.toHex();
    if (hsl.s === 0) {
        hsl.h = oldHue || 0;
        hsv.h = oldHue || 0;
    }
    var transparent = hex === '000000' && rgb.a === 0;
    return {
        hsl: hsl,
        hex: transparent ? 'transparent' : '#' + hex,
        rgb: rgb,
        hsv: hsv,
        oldHue: data.h || oldHue || hsl.h,
        source: data.source
    };
};
var $0484844d062f071f$export$944f75ec5697b362 = function isValidHex(hex) {
    if (hex === 'transparent') return true;
    // disable hex4 and hex8
    var lh = String(hex).charAt(0) === '#' ? 1 : 0;
    return hex.length !== 4 + lh && hex.length < 7 + lh && (0, (/*@__PURE__*/$parcel$interopDefault($84ebedfd68f8ec8c$exports)))(hex).isValid();
};
var $0484844d062f071f$export$3609eb1d7e55dec = function getContrastingColor(data) {
    if (!data) return '#fff';
    var col = $0484844d062f071f$export$6bed283375899438(data);
    if (col.hex === 'transparent') return 'rgba(0,0,0,0.4)';
    var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1000;
    return yiq >= 128 ? '#000' : '#fff';
};
var $0484844d062f071f$export$a90204d1394caf30 = {
    hsl: {
        a: 1,
        h: 0,
        l: 0.5,
        s: 1
    },
    hex: '#ff0000',
    rgb: {
        r: 255,
        g: 0,
        b: 0,
        a: 1
    },
    hsv: {
        h: 0,
        s: 1,
        v: 1,
        a: 1
    }
};
var $0484844d062f071f$export$e76ec4c5b3cadd73 = function isvalidColorString(string, type) {
    var stringWithoutDegree = string.replace("\xb0", '');
    return (0, (/*@__PURE__*/$parcel$interopDefault($84ebedfd68f8ec8c$exports)))(type + ' (' + stringWithoutDegree + ')')._ok;
};


var $b0ac51c924707ae7$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $b0ac51c924707ae7$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $b0ac51c924707ae7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b0ac51c924707ae7$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $b0ac51c924707ae7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $b0ac51c924707ae7$export$68265aef2e61bec7 = function ColorWrap(Picker) {
    var ColorPicker = function(_ref) {
        $b0ac51c924707ae7$var$_inherits(ColorPicker, _ref);
        function ColorPicker(props) {
            $b0ac51c924707ae7$var$_classCallCheck(this, ColorPicker);
            var _this = $b0ac51c924707ae7$var$_possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));
            _this.handleChange = function(data, event) {
                var isValidColor = $0484844d062f071f$export$4837207a530c7f21(data);
                if (isValidColor) {
                    var colors = $0484844d062f071f$export$6bed283375899438(data, data.h || _this.state.oldHue);
                    _this.setState(colors);
                    _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
                    _this.props.onChange && _this.props.onChange(colors, event);
                }
            };
            _this.handleSwatchHover = function(data, event) {
                var isValidColor = $0484844d062f071f$export$4837207a530c7f21(data);
                if (isValidColor) {
                    var colors = $0484844d062f071f$export$6bed283375899438(data, data.h || _this.state.oldHue);
                    _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
                }
            };
            _this.state = $b0ac51c924707ae7$var$_extends({}, $0484844d062f071f$export$6bed283375899438(props.color, 0));
            _this.debounce = (0, $66cfcacde6964208$export$2e2bcd8739ae039)(function(fn, data, event) {
                fn(data, event);
            }, 100);
            return _this;
        }
        $b0ac51c924707ae7$var$_createClass(ColorPicker, [
            {
                key: 'render',
                value: function render() {
                    var optionalEvents = {};
                    if (this.props.onSwatchHover) optionalEvents.onSwatchHover = this.handleSwatchHover;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement(Picker, $b0ac51c924707ae7$var$_extends({}, this.props, this.state, {
                        onChange: this.handleChange
                    }, optionalEvents));
                }
            }
        ], [
            {
                key: 'getDerivedStateFromProps',
                value: function getDerivedStateFromProps(nextProps, state) {
                    return $b0ac51c924707ae7$var$_extends({}, $0484844d062f071f$export$6bed283375899438(nextProps.color, state.oldHue));
                }
            }
        ]);
        return ColorPicker;
    }((0, $8FY87.PureComponent) || (0, $8FY87.Component));
    ColorPicker.propTypes = $b0ac51c924707ae7$var$_extends({}, Picker.propTypes);
    ColorPicker.defaultProps = $b0ac51c924707ae7$var$_extends({}, Picker.defaultProps, {
        color: {
            h: 250,
            s: 0.50,
            l: 0.20,
            a: 1
        }
    });
    return ColorPicker;
};
var $b0ac51c924707ae7$export$2e2bcd8739ae039 = $b0ac51c924707ae7$export$68265aef2e61bec7;



var $8FY87 = parcelRequire("8FY87");


var $dvzee = parcelRequire("dvzee");

var $aab2657fe6a56e51$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $aab2657fe6a56e51$var$ENTER = 13;
var $aab2657fe6a56e51$export$c463048d6131b309 = function Swatch(_ref) {
    var color = _ref.color, style = _ref.style, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onHover = _ref.onHover, _ref$title = _ref.title, title = _ref$title === undefined ? color : _ref$title, children = _ref.children, focus = _ref.focus, _ref$focusStyle = _ref.focusStyle, focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;
    var transparent = color === 'transparent';
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))({
        default: {
            swatch: $aab2657fe6a56e51$var$_extends({
                background: color,
                height: '100%',
                width: '100%',
                cursor: 'pointer',
                position: 'relative',
                outline: 'none'
            }, style, focus ? focusStyle : {})
        }
    });
    var handleClick = function handleClick(e) {
        return onClick(color, e);
    };
    var handleKeyDown = function handleKeyDown(e) {
        return e.keyCode === $aab2657fe6a56e51$var$ENTER && onClick(color, e);
    };
    var handleHover = function handleHover(e) {
        return onHover(color, e);
    };
    var optionalEvents = {};
    if (onHover) optionalEvents.onMouseOver = handleHover;
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', $aab2657fe6a56e51$var$_extends({
        style: styles.swatch,
        onClick: handleClick,
        title: title,
        tabIndex: 0,
        onKeyDown: handleKeyDown
    }, optionalEvents), children, transparent && (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $41a8f0ec8c9e9c24$export$2e2bcd8739ae039), {
        borderRadius: styles.swatch.borderRadius,
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.1)'
    }));
};
var $aab2657fe6a56e51$export$2e2bcd8739ae039 = (0, $dvzee.handleFocus)($aab2657fe6a56e51$export$c463048d6131b309);





var $8FY87 = parcelRequire("8FY87");

var $d09506b45457c161$export$5bbd8091d1d0e224 = function AlphaPointer(_ref) {
    var direction = _ref.direction;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))({
        'default': {
            picker: {
                width: '18px',
                height: '18px',
                borderRadius: '50%',
                transform: 'translate(-9px, -1px)',
                backgroundColor: 'rgb(248, 248, 248)',
                boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
            }
        },
        'vertical': {
            picker: {
                transform: 'translate(-3px, -9px)'
            }
        }
    }, {
        vertical: direction === 'vertical'
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.picker
    });
};
var $d09506b45457c161$export$2e2bcd8739ae039 = $d09506b45457c161$export$5bbd8091d1d0e224;


var $7787b6e38464a35e$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $7787b6e38464a35e$export$421d2c1bdabf8a68 = function AlphaPicker(_ref) {
    var rgb = _ref.rgb, hsl = _ref.hsl, width = _ref.width, height = _ref.height, onChange = _ref.onChange, direction = _ref.direction, style = _ref.style, renderers = _ref.renderers, pointer = _ref.pointer, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))({
        'default': {
            picker: {
                position: 'relative',
                width: width,
                height: height
            },
            alpha: {
                radius: '2px',
                style: style
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.picker,
        className: 'alpha-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $5f0e862746c8c551$export$2e2bcd8739ae039), $7787b6e38464a35e$var$_extends({}, styles.alpha, {
        rgb: rgb,
        hsl: hsl,
        pointer: pointer,
        renderers: renderers,
        onChange: onChange,
        direction: direction
    })));
};
$7787b6e38464a35e$export$421d2c1bdabf8a68.defaultProps = {
    width: '316px',
    height: '16px',
    direction: 'horizontal',
    pointer: (0, $d09506b45457c161$export$2e2bcd8739ae039)
};
var $7787b6e38464a35e$export$2e2bcd8739ae039 = (0, $b0ac51c924707ae7$export$2e2bcd8739ae039)($7787b6e38464a35e$export$421d2c1bdabf8a68);



var $8FY87 = parcelRequire("8FY87");

var $4VW2f = parcelRequire("4VW2f");





var $8FY87 = parcelRequire("8FY87");

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $acc15e3b7bec2fa1$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $acc15e3b7bec2fa1$export$2e2bcd8739ae039 = $acc15e3b7bec2fa1$var$arrayMap;





/** Used to stand-in for `undefined` hash values. */ var $0b6bfb9fe751e077$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $0b6bfb9fe751e077$var$setCacheAdd(value) {
    this.__data__.set(value, $0b6bfb9fe751e077$var$HASH_UNDEFINED);
    return this;
}
var $0b6bfb9fe751e077$export$2e2bcd8739ae039 = $0b6bfb9fe751e077$var$setCacheAdd;


/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ function $dc364a83590cd9d4$var$setCacheHas(value) {
    return this.__data__.has(value);
}
var $dc364a83590cd9d4$export$2e2bcd8739ae039 = $dc364a83590cd9d4$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $d03ddb6f77456f9f$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new (0, $d757e6f151d4449d$export$2e2bcd8739ae039);
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$d03ddb6f77456f9f$var$SetCache.prototype.add = $d03ddb6f77456f9f$var$SetCache.prototype.push = (0, $0b6bfb9fe751e077$export$2e2bcd8739ae039);
$d03ddb6f77456f9f$var$SetCache.prototype.has = (0, $dc364a83590cd9d4$export$2e2bcd8739ae039);
var $d03ddb6f77456f9f$export$2e2bcd8739ae039 = $d03ddb6f77456f9f$var$SetCache;


/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $7b7d5452bbbb3cc6$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
var $7b7d5452bbbb3cc6$export$2e2bcd8739ae039 = $7b7d5452bbbb3cc6$var$arraySome;


/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d0d72f3afbf0acdb$var$cacheHas(cache, key) {
    return cache.has(key);
}
var $d0d72f3afbf0acdb$export$2e2bcd8739ae039 = $d0d72f3afbf0acdb$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $0d2971ab62be47a2$var$COMPARE_PARTIAL_FLAG = 1, $0d2971ab62be47a2$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $0d2971ab62be47a2$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $0d2971ab62be47a2$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $0d2971ab62be47a2$var$COMPARE_UNORDERED_FLAG ? new (0, $d03ddb6f77456f9f$export$2e2bcd8739ae039) : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!(0, $7b7d5452bbbb3cc6$export$2e2bcd8739ae039)(other, function(othValue, othIndex) {
                if (!(0, $d0d72f3afbf0acdb$export$2e2bcd8739ae039)(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
var $0d2971ab62be47a2$export$2e2bcd8739ae039 = $0d2971ab62be47a2$var$equalArrays;






/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $8f478a11c8ea7b11$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
var $8f478a11c8ea7b11$export$2e2bcd8739ae039 = $8f478a11c8ea7b11$var$mapToArray;


/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $111b683217408f0a$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
var $111b683217408f0a$export$2e2bcd8739ae039 = $111b683217408f0a$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $26eda24cef5ffce2$var$COMPARE_PARTIAL_FLAG = 1, $26eda24cef5ffce2$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $26eda24cef5ffce2$var$boolTag = '[object Boolean]', $26eda24cef5ffce2$var$dateTag = '[object Date]', $26eda24cef5ffce2$var$errorTag = '[object Error]', $26eda24cef5ffce2$var$mapTag = '[object Map]', $26eda24cef5ffce2$var$numberTag = '[object Number]', $26eda24cef5ffce2$var$regexpTag = '[object RegExp]', $26eda24cef5ffce2$var$setTag = '[object Set]', $26eda24cef5ffce2$var$stringTag = '[object String]', $26eda24cef5ffce2$var$symbolTag = '[object Symbol]';
var $26eda24cef5ffce2$var$arrayBufferTag = '[object ArrayBuffer]', $26eda24cef5ffce2$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $26eda24cef5ffce2$var$symbolProto = (0, $e9bc3be843ae7db3$export$2e2bcd8739ae039) ? (0, $e9bc3be843ae7db3$export$2e2bcd8739ae039).prototype : undefined, $26eda24cef5ffce2$var$symbolValueOf = $26eda24cef5ffce2$var$symbolProto ? $26eda24cef5ffce2$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $26eda24cef5ffce2$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $26eda24cef5ffce2$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $26eda24cef5ffce2$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new (0, $dae9e0a0e77b1ad1$export$2e2bcd8739ae039)(object), new (0, $dae9e0a0e77b1ad1$export$2e2bcd8739ae039)(other))) return false;
            return true;
        case $26eda24cef5ffce2$var$boolTag:
        case $26eda24cef5ffce2$var$dateTag:
        case $26eda24cef5ffce2$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return (0, $20d35a3e3bd6bf79$export$2e2bcd8739ae039)(+object, +other);
        case $26eda24cef5ffce2$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $26eda24cef5ffce2$var$regexpTag:
        case $26eda24cef5ffce2$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $26eda24cef5ffce2$var$mapTag:
            var convert = (0, $8f478a11c8ea7b11$export$2e2bcd8739ae039);
        case $26eda24cef5ffce2$var$setTag:
            var isPartial = bitmask & $26eda24cef5ffce2$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = (0, $111b683217408f0a$export$2e2bcd8739ae039));
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $26eda24cef5ffce2$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = (0, $0d2971ab62be47a2$export$2e2bcd8739ae039)(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $26eda24cef5ffce2$var$symbolTag:
            if ($26eda24cef5ffce2$var$symbolValueOf) return $26eda24cef5ffce2$var$symbolValueOf.call(object) == $26eda24cef5ffce2$var$symbolValueOf.call(other);
    }
    return false;
}
var $26eda24cef5ffce2$export$2e2bcd8739ae039 = $26eda24cef5ffce2$var$equalByTag;


/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $719b592aa8a00f04$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $719b592aa8a00f04$export$2e2bcd8739ae039 = $719b592aa8a00f04$var$arrayPush;



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $98781eb34f3e36ac$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $acb56a590d5e2bcb$export$2e2bcd8739ae039)(object) ? result : (0, $719b592aa8a00f04$export$2e2bcd8739ae039)(result, symbolsFunc(object));
}
var $98781eb34f3e36ac$export$2e2bcd8739ae039 = $98781eb34f3e36ac$var$baseGetAllKeys;


/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $7e86c069de53ab9f$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $7e86c069de53ab9f$export$2e2bcd8739ae039 = $7e86c069de53ab9f$var$arrayFilter;


/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $98123970b3618300$var$stubArray() {
    return [];
}
var $98123970b3618300$export$2e2bcd8739ae039 = $98123970b3618300$var$stubArray;


/** Used for built-in method references. */ var $4b5f315807e3de5b$var$objectProto = Object.prototype;
/** Built-in value references. */ var $4b5f315807e3de5b$var$propertyIsEnumerable = $4b5f315807e3de5b$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $4b5f315807e3de5b$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $4b5f315807e3de5b$var$getSymbols = !$4b5f315807e3de5b$var$nativeGetSymbols ? (0, $98123970b3618300$export$2e2bcd8739ae039) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $7e86c069de53ab9f$export$2e2bcd8739ae039)($4b5f315807e3de5b$var$nativeGetSymbols(object), function(symbol) {
        return $4b5f315807e3de5b$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $4b5f315807e3de5b$export$2e2bcd8739ae039 = $4b5f315807e3de5b$var$getSymbols;



/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $e3e5da42377fea37$var$getAllKeys(object) {
    return (0, $98781eb34f3e36ac$export$2e2bcd8739ae039)(object, (0, $a11509b56113c9fb$export$2e2bcd8739ae039), (0, $4b5f315807e3de5b$export$2e2bcd8739ae039));
}
var $e3e5da42377fea37$export$2e2bcd8739ae039 = $e3e5da42377fea37$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $62970b170670c253$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $62970b170670c253$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $62970b170670c253$var$hasOwnProperty = $62970b170670c253$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $62970b170670c253$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $62970b170670c253$var$COMPARE_PARTIAL_FLAG, objProps = (0, $e3e5da42377fea37$export$2e2bcd8739ae039)(object), objLength = objProps.length, othProps = (0, $e3e5da42377fea37$export$2e2bcd8739ae039)(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $62970b170670c253$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
var $62970b170670c253$export$2e2bcd8739ae039 = $62970b170670c253$var$equalObjects;




var $kgEOh = parcelRequire("kgEOh");
/* Built-in method references that are verified to be native. */ var $8eeba190c3686de3$var$DataView = (0, $903050517465572f$export$2e2bcd8739ae039)((0, $kgEOh.default), 'DataView');
var $8eeba190c3686de3$export$2e2bcd8739ae039 = $8eeba190c3686de3$var$DataView;





var $kgEOh = parcelRequire("kgEOh");
/* Built-in method references that are verified to be native. */ var $113f08010f1dff7e$var$Promise = (0, $903050517465572f$export$2e2bcd8739ae039)((0, $kgEOh.default), 'Promise');
var $113f08010f1dff7e$export$2e2bcd8739ae039 = $113f08010f1dff7e$var$Promise;




var $kgEOh = parcelRequire("kgEOh");
/* Built-in method references that are verified to be native. */ var $ff5c8612657dafc2$var$Set = (0, $903050517465572f$export$2e2bcd8739ae039)((0, $kgEOh.default), 'Set');
var $ff5c8612657dafc2$export$2e2bcd8739ae039 = $ff5c8612657dafc2$var$Set;




var $kgEOh = parcelRequire("kgEOh");
/* Built-in method references that are verified to be native. */ var $8abd684cb1f57704$var$WeakMap = (0, $903050517465572f$export$2e2bcd8739ae039)((0, $kgEOh.default), 'WeakMap');
var $8abd684cb1f57704$export$2e2bcd8739ae039 = $8abd684cb1f57704$var$WeakMap;




/** `Object#toString` result references. */ var $f99ddab08b845c56$var$mapTag = '[object Map]', $f99ddab08b845c56$var$objectTag = '[object Object]', $f99ddab08b845c56$var$promiseTag = '[object Promise]', $f99ddab08b845c56$var$setTag = '[object Set]', $f99ddab08b845c56$var$weakMapTag = '[object WeakMap]';
var $f99ddab08b845c56$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $f99ddab08b845c56$var$dataViewCtorString = (0, $1f79199214c6d21a$export$2e2bcd8739ae039)((0, $8eeba190c3686de3$export$2e2bcd8739ae039)), $f99ddab08b845c56$var$mapCtorString = (0, $1f79199214c6d21a$export$2e2bcd8739ae039)((0, $ccbd53005879ec2c$export$2e2bcd8739ae039)), $f99ddab08b845c56$var$promiseCtorString = (0, $1f79199214c6d21a$export$2e2bcd8739ae039)((0, $113f08010f1dff7e$export$2e2bcd8739ae039)), $f99ddab08b845c56$var$setCtorString = (0, $1f79199214c6d21a$export$2e2bcd8739ae039)((0, $ff5c8612657dafc2$export$2e2bcd8739ae039)), $f99ddab08b845c56$var$weakMapCtorString = (0, $1f79199214c6d21a$export$2e2bcd8739ae039)((0, $8abd684cb1f57704$export$2e2bcd8739ae039));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $f99ddab08b845c56$var$getTag = (0, $492d0391f2ac61ec$export$2e2bcd8739ae039);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $8eeba190c3686de3$export$2e2bcd8739ae039) && $f99ddab08b845c56$var$getTag(new (0, $8eeba190c3686de3$export$2e2bcd8739ae039)(new ArrayBuffer(1))) != $f99ddab08b845c56$var$dataViewTag || (0, $ccbd53005879ec2c$export$2e2bcd8739ae039) && $f99ddab08b845c56$var$getTag(new (0, $ccbd53005879ec2c$export$2e2bcd8739ae039)) != $f99ddab08b845c56$var$mapTag || (0, $113f08010f1dff7e$export$2e2bcd8739ae039) && $f99ddab08b845c56$var$getTag((0, $113f08010f1dff7e$export$2e2bcd8739ae039).resolve()) != $f99ddab08b845c56$var$promiseTag || (0, $ff5c8612657dafc2$export$2e2bcd8739ae039) && $f99ddab08b845c56$var$getTag(new (0, $ff5c8612657dafc2$export$2e2bcd8739ae039)) != $f99ddab08b845c56$var$setTag || (0, $8abd684cb1f57704$export$2e2bcd8739ae039) && $f99ddab08b845c56$var$getTag(new (0, $8abd684cb1f57704$export$2e2bcd8739ae039)) != $f99ddab08b845c56$var$weakMapTag) $f99ddab08b845c56$var$getTag = function(value) {
    var result = (0, $492d0391f2ac61ec$export$2e2bcd8739ae039)(value), Ctor = result == $f99ddab08b845c56$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $1f79199214c6d21a$export$2e2bcd8739ae039)(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $f99ddab08b845c56$var$dataViewCtorString:
            return $f99ddab08b845c56$var$dataViewTag;
        case $f99ddab08b845c56$var$mapCtorString:
            return $f99ddab08b845c56$var$mapTag;
        case $f99ddab08b845c56$var$promiseCtorString:
            return $f99ddab08b845c56$var$promiseTag;
        case $f99ddab08b845c56$var$setCtorString:
            return $f99ddab08b845c56$var$setTag;
        case $f99ddab08b845c56$var$weakMapCtorString:
            return $f99ddab08b845c56$var$weakMapTag;
    }
    return result;
};
var $f99ddab08b845c56$export$2e2bcd8739ae039 = $f99ddab08b845c56$var$getTag;




var $kmshc = parcelRequire("kmshc");

/** Used to compose bitmasks for value comparisons. */ var $31b878b170561b10$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $31b878b170561b10$var$argsTag = '[object Arguments]', $31b878b170561b10$var$arrayTag = '[object Array]', $31b878b170561b10$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $31b878b170561b10$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $31b878b170561b10$var$hasOwnProperty = $31b878b170561b10$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $31b878b170561b10$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = (0, $acb56a590d5e2bcb$export$2e2bcd8739ae039)(object), othIsArr = (0, $acb56a590d5e2bcb$export$2e2bcd8739ae039)(other), objTag = objIsArr ? $31b878b170561b10$var$arrayTag : (0, $f99ddab08b845c56$export$2e2bcd8739ae039)(object), othTag = othIsArr ? $31b878b170561b10$var$arrayTag : (0, $f99ddab08b845c56$export$2e2bcd8739ae039)(other);
    objTag = objTag == $31b878b170561b10$var$argsTag ? $31b878b170561b10$var$objectTag : objTag;
    othTag = othTag == $31b878b170561b10$var$argsTag ? $31b878b170561b10$var$objectTag : othTag;
    var objIsObj = objTag == $31b878b170561b10$var$objectTag, othIsObj = othTag == $31b878b170561b10$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && (0, $kmshc.default)(object)) {
        if (!(0, $kmshc.default)(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new (0, $4629ffd999cc27d4$export$2e2bcd8739ae039));
        return objIsArr || (0, $b55076106e830d0e$export$2e2bcd8739ae039)(object) ? (0, $0d2971ab62be47a2$export$2e2bcd8739ae039)(object, other, bitmask, customizer, equalFunc, stack) : (0, $26eda24cef5ffce2$export$2e2bcd8739ae039)(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $31b878b170561b10$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $31b878b170561b10$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $31b878b170561b10$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new (0, $4629ffd999cc27d4$export$2e2bcd8739ae039));
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new (0, $4629ffd999cc27d4$export$2e2bcd8739ae039));
    return (0, $62970b170670c253$export$2e2bcd8739ae039)(object, other, bitmask, customizer, equalFunc, stack);
}
var $31b878b170561b10$export$2e2bcd8739ae039 = $31b878b170561b10$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $d40606ebf563d6aa$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !(0, $8ef6de3f0576ee8c$export$2e2bcd8739ae039)(value) && !(0, $8ef6de3f0576ee8c$export$2e2bcd8739ae039)(other)) return value !== value && other !== other;
    return (0, $31b878b170561b10$export$2e2bcd8739ae039)(value, other, bitmask, customizer, $d40606ebf563d6aa$var$baseIsEqual, stack);
}
var $d40606ebf563d6aa$export$2e2bcd8739ae039 = $d40606ebf563d6aa$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $8ce3db7522fc5c6d$var$COMPARE_PARTIAL_FLAG = 1, $8ce3db7522fc5c6d$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $8ce3db7522fc5c6d$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new (0, $4629ffd999cc27d4$export$2e2bcd8739ae039);
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? (0, $d40606ebf563d6aa$export$2e2bcd8739ae039)(srcValue, objValue, $8ce3db7522fc5c6d$var$COMPARE_PARTIAL_FLAG | $8ce3db7522fc5c6d$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
var $8ce3db7522fc5c6d$export$2e2bcd8739ae039 = $8ce3db7522fc5c6d$var$baseIsMatch;



/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $4c7a7aa8803c9f59$var$isStrictComparable(value) {
    return value === value && !(0, $0f0b33514751195d$export$2e2bcd8739ae039)(value);
}
var $4c7a7aa8803c9f59$export$2e2bcd8739ae039 = $4c7a7aa8803c9f59$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $4eabccff39cd73f5$var$getMatchData(object) {
    var result = (0, $a11509b56113c9fb$export$2e2bcd8739ae039)(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            (0, $4c7a7aa8803c9f59$export$2e2bcd8739ae039)(value)
        ];
    }
    return result;
}
var $4eabccff39cd73f5$export$2e2bcd8739ae039 = $4eabccff39cd73f5$var$getMatchData;


/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $655773647915fd30$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
var $655773647915fd30$export$2e2bcd8739ae039 = $655773647915fd30$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $6a534b0390e594cc$var$baseMatches(source) {
    var matchData = (0, $4eabccff39cd73f5$export$2e2bcd8739ae039)(source);
    if (matchData.length == 1 && matchData[0][2]) return (0, $655773647915fd30$export$2e2bcd8739ae039)(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || (0, $8ce3db7522fc5c6d$export$2e2bcd8739ae039)(object, source, matchData);
    };
}
var $6a534b0390e594cc$export$2e2bcd8739ae039 = $6a534b0390e594cc$var$baseMatches;






/** Used to match property names within property paths. */ var $ce56a9d98d519e90$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $ce56a9d98d519e90$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $ce56a9d98d519e90$var$isKey(value, object) {
    if ((0, $acb56a590d5e2bcb$export$2e2bcd8739ae039)(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || (0, $9b727c88123a0fb8$export$2e2bcd8739ae039)(value)) return true;
    return $ce56a9d98d519e90$var$reIsPlainProp.test(value) || !$ce56a9d98d519e90$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
var $ce56a9d98d519e90$export$2e2bcd8739ae039 = $ce56a9d98d519e90$var$isKey;



/** Error message constants. */ var $4a96244c06e66e50$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $4a96244c06e66e50$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($4a96244c06e66e50$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($4a96244c06e66e50$var$memoize.Cache || (0, $d757e6f151d4449d$export$2e2bcd8739ae039));
    return memoized;
}
// Expose `MapCache`.
$4a96244c06e66e50$var$memoize.Cache = (0, $d757e6f151d4449d$export$2e2bcd8739ae039);
var $4a96244c06e66e50$export$2e2bcd8739ae039 = $4a96244c06e66e50$var$memoize;


/** Used as the maximum memoize cache size. */ var $185c3a137495ca01$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $185c3a137495ca01$var$memoizeCapped(func) {
    var result = (0, $4a96244c06e66e50$export$2e2bcd8739ae039)(func, function(key) {
        if (cache.size === $185c3a137495ca01$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $185c3a137495ca01$export$2e2bcd8739ae039 = $185c3a137495ca01$var$memoizeCapped;


/** Used to match property names within property paths. */ var $d131e7a4423877f9$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $d131e7a4423877f9$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $d131e7a4423877f9$var$stringToPath = (0, $185c3a137495ca01$export$2e2bcd8739ae039)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($d131e7a4423877f9$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($d131e7a4423877f9$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
var $d131e7a4423877f9$export$2e2bcd8739ae039 = $d131e7a4423877f9$var$stringToPath;






/** Used as references for various `Number` constants. */ var $72dbc579acf63a5e$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $72dbc579acf63a5e$var$symbolProto = (0, $e9bc3be843ae7db3$export$2e2bcd8739ae039) ? (0, $e9bc3be843ae7db3$export$2e2bcd8739ae039).prototype : undefined, $72dbc579acf63a5e$var$symbolToString = $72dbc579acf63a5e$var$symbolProto ? $72dbc579acf63a5e$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $72dbc579acf63a5e$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ((0, $acb56a590d5e2bcb$export$2e2bcd8739ae039)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $acc15e3b7bec2fa1$export$2e2bcd8739ae039)(value, $72dbc579acf63a5e$var$baseToString) + '';
    if ((0, $9b727c88123a0fb8$export$2e2bcd8739ae039)(value)) return $72dbc579acf63a5e$var$symbolToString ? $72dbc579acf63a5e$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$72dbc579acf63a5e$var$INFINITY ? '-0' : result;
}
var $72dbc579acf63a5e$export$2e2bcd8739ae039 = $72dbc579acf63a5e$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $1bd2193653c8b79b$var$toString(value) {
    return value == null ? '' : (0, $72dbc579acf63a5e$export$2e2bcd8739ae039)(value);
}
var $1bd2193653c8b79b$export$2e2bcd8739ae039 = $1bd2193653c8b79b$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $cfb1d5115e9b4477$var$castPath(value, object) {
    if ((0, $acb56a590d5e2bcb$export$2e2bcd8739ae039)(value)) return value;
    return (0, $ce56a9d98d519e90$export$2e2bcd8739ae039)(value, object) ? [
        value
    ] : (0, $d131e7a4423877f9$export$2e2bcd8739ae039)((0, $1bd2193653c8b79b$export$2e2bcd8739ae039)(value));
}
var $cfb1d5115e9b4477$export$2e2bcd8739ae039 = $cfb1d5115e9b4477$var$castPath;



/** Used as references for various `Number` constants. */ var $5202dcd7dc1330c3$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $5202dcd7dc1330c3$var$toKey(value) {
    if (typeof value == 'string' || (0, $9b727c88123a0fb8$export$2e2bcd8739ae039)(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$5202dcd7dc1330c3$var$INFINITY ? '-0' : result;
}
var $5202dcd7dc1330c3$export$2e2bcd8739ae039 = $5202dcd7dc1330c3$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $4bd86f497ab1f2ae$var$baseGet(object, path) {
    path = (0, $cfb1d5115e9b4477$export$2e2bcd8739ae039)(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[(0, $5202dcd7dc1330c3$export$2e2bcd8739ae039)(path[index++])];
    return index && index == length ? object : undefined;
}
var $4bd86f497ab1f2ae$export$2e2bcd8739ae039 = $4bd86f497ab1f2ae$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $5b2734271e77b4ac$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : (0, $4bd86f497ab1f2ae$export$2e2bcd8739ae039)(object, path);
    return result === undefined ? defaultValue : result;
}
var $5b2734271e77b4ac$export$2e2bcd8739ae039 = $5b2734271e77b4ac$var$get;


/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $770526aac2c2c14a$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
var $770526aac2c2c14a$export$2e2bcd8739ae039 = $770526aac2c2c14a$var$baseHasIn;








/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $cc78627ed9d1a763$var$hasPath(object, path, hasFunc) {
    path = (0, $cfb1d5115e9b4477$export$2e2bcd8739ae039)(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = (0, $5202dcd7dc1330c3$export$2e2bcd8739ae039)(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && (0, $7a3de10c37036eb2$export$2e2bcd8739ae039)(length) && (0, $b1905f533236458e$export$2e2bcd8739ae039)(key, length) && ((0, $acb56a590d5e2bcb$export$2e2bcd8739ae039)(object) || (0, $20760ba0446df02d$export$2e2bcd8739ae039)(object));
}
var $cc78627ed9d1a763$export$2e2bcd8739ae039 = $cc78627ed9d1a763$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $9ea762c10b5d7e4f$var$hasIn(object, path) {
    return object != null && (0, $cc78627ed9d1a763$export$2e2bcd8739ae039)(object, path, (0, $770526aac2c2c14a$export$2e2bcd8739ae039));
}
var $9ea762c10b5d7e4f$export$2e2bcd8739ae039 = $9ea762c10b5d7e4f$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $04056bc07f5f17de$var$COMPARE_PARTIAL_FLAG = 1, $04056bc07f5f17de$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $04056bc07f5f17de$var$baseMatchesProperty(path, srcValue) {
    if ((0, $ce56a9d98d519e90$export$2e2bcd8739ae039)(path) && (0, $4c7a7aa8803c9f59$export$2e2bcd8739ae039)(srcValue)) return (0, $655773647915fd30$export$2e2bcd8739ae039)((0, $5202dcd7dc1330c3$export$2e2bcd8739ae039)(path), srcValue);
    return function(object) {
        var objValue = (0, $5b2734271e77b4ac$export$2e2bcd8739ae039)(object, path);
        return objValue === undefined && objValue === srcValue ? (0, $9ea762c10b5d7e4f$export$2e2bcd8739ae039)(object, path) : (0, $d40606ebf563d6aa$export$2e2bcd8739ae039)(srcValue, objValue, $04056bc07f5f17de$var$COMPARE_PARTIAL_FLAG | $04056bc07f5f17de$var$COMPARE_UNORDERED_FLAG);
    };
}
var $04056bc07f5f17de$export$2e2bcd8739ae039 = $04056bc07f5f17de$var$baseMatchesProperty;




/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $8083a367c48b36c0$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
var $8083a367c48b36c0$export$2e2bcd8739ae039 = $8083a367c48b36c0$var$baseProperty;



/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $08ec77e4993faa2c$var$basePropertyDeep(path) {
    return function(object) {
        return (0, $4bd86f497ab1f2ae$export$2e2bcd8739ae039)(object, path);
    };
}
var $08ec77e4993faa2c$export$2e2bcd8739ae039 = $08ec77e4993faa2c$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $0c3c88ef9f8da6ca$var$property(path) {
    return (0, $ce56a9d98d519e90$export$2e2bcd8739ae039)(path) ? (0, $8083a367c48b36c0$export$2e2bcd8739ae039)((0, $5202dcd7dc1330c3$export$2e2bcd8739ae039)(path)) : (0, $08ec77e4993faa2c$export$2e2bcd8739ae039)(path);
}
var $0c3c88ef9f8da6ca$export$2e2bcd8739ae039 = $0c3c88ef9f8da6ca$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $273820791b100219$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return 0, $1c32b2559fcaca3b$export$2e2bcd8739ae039;
    if (typeof value == 'object') return (0, $acb56a590d5e2bcb$export$2e2bcd8739ae039)(value) ? (0, $04056bc07f5f17de$export$2e2bcd8739ae039)(value[0], value[1]) : (0, $6a534b0390e594cc$export$2e2bcd8739ae039)(value);
    return (0, $0c3c88ef9f8da6ca$export$2e2bcd8739ae039)(value);
}
var $273820791b100219$export$2e2bcd8739ae039 = $273820791b100219$var$baseIteratee;




/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $b67ffc5b2abf199b$var$baseMap(collection, iteratee) {
    var index = -1, result = (0, $5c88ed82b217ac2c$export$2e2bcd8739ae039)(collection) ? Array(collection.length) : [];
    (0, $4b0525113f2f7fa7$export$2e2bcd8739ae039)(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
var $b67ffc5b2abf199b$export$2e2bcd8739ae039 = $b67ffc5b2abf199b$var$baseMap;



/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $2d9216e96febe2b9$var$map(collection, iteratee) {
    var func = (0, $acb56a590d5e2bcb$export$2e2bcd8739ae039)(collection) ? (0, $acc15e3b7bec2fa1$export$2e2bcd8739ae039) : (0, $b67ffc5b2abf199b$export$2e2bcd8739ae039);
    return func(collection, (0, $273820791b100219$export$2e2bcd8739ae039)(iteratee, 3));
}
var $2d9216e96febe2b9$export$2e2bcd8739ae039 = $2d9216e96febe2b9$var$map;



var $2905dfae45b4438d$export$2ce88c5250e54734 = function BlockSwatches(_ref) {
    var colors = _ref.colors, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))({
        'default': {
            swatches: {
                marginRight: '-10px'
            },
            swatch: {
                width: '22px',
                height: '22px',
                float: 'left',
                marginRight: '10px',
                marginBottom: '10px',
                borderRadius: '4px'
            },
            clear: {
                clear: 'both'
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.swatches
    }, (0, $2d9216e96febe2b9$export$2e2bcd8739ae039)(colors, function(c) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $aab2657fe6a56e51$export$2e2bcd8739ae039), {
            key: c,
            color: c,
            style: styles.swatch,
            onClick: onClick,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: '0 0 4px ' + c
            }
        });
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.clear
    }));
};
var $2905dfae45b4438d$export$2e2bcd8739ae039 = $2905dfae45b4438d$export$2ce88c5250e54734;


var $128480d4605e3fb0$export$d96a8827a60d6b69 = function Block(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, hex = _ref.hex, colors = _ref.colors, width = _ref.width, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var transparent = hex === 'transparent';
    var handleChange = function handleChange(hexCode, e) {
        $0484844d062f071f$export$944f75ec5697b362(hexCode) && onChange({
            hex: hexCode,
            source: 'hex'
        }, e);
    };
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))((0, $4dea300bb9269819$export$2e2bcd8739ae039)({
        'default': {
            card: {
                width: width,
                background: '#fff',
                boxShadow: '0 1px rgba(0,0,0,.1)',
                borderRadius: '6px',
                position: 'relative'
            },
            head: {
                height: '110px',
                background: hex,
                borderRadius: '6px 6px 0 0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative'
            },
            body: {
                padding: '10px'
            },
            label: {
                fontSize: '18px',
                color: $0484844d062f071f$export$3609eb1d7e55dec(hex),
                position: 'relative'
            },
            triangle: {
                width: '0px',
                height: '0px',
                borderStyle: 'solid',
                borderWidth: '0 10px 10px 10px',
                borderColor: 'transparent transparent ' + hex + ' transparent',
                position: 'absolute',
                top: '-10px',
                left: '50%',
                marginLeft: '-10px'
            },
            input: {
                width: '100%',
                fontSize: '12px',
                color: '#666',
                border: '0px',
                outline: 'none',
                height: '22px',
                boxShadow: 'inset 0 0 0 1px #ddd',
                borderRadius: '4px',
                padding: '0 7px',
                boxSizing: 'border-box'
            }
        },
        'hide-triangle': {
            triangle: {
                display: 'none'
            }
        }
    }, passedStyles), {
        'hide-triangle': triangle === 'hide'
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.card,
        className: 'block-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.triangle
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.head
    }, transparent && (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $41a8f0ec8c9e9c24$export$2e2bcd8739ae039), {
        borderRadius: '6px 6px 0 0'
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.label
    }, hex)), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.body
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $2905dfae45b4438d$export$2e2bcd8739ae039), {
        colors: colors,
        onClick: handleChange,
        onSwatchHover: onSwatchHover
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $5e4e3784fbcdba0a$export$2e2bcd8739ae039), {
        style: {
            input: styles.input
        },
        value: hex,
        onChange: handleChange
    })));
};
$128480d4605e3fb0$export$d96a8827a60d6b69.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).number
    ]),
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).string),
    triangle: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).oneOf([
        'top',
        'hide'
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).object
};
$128480d4605e3fb0$export$d96a8827a60d6b69.defaultProps = {
    width: 170,
    colors: [
        '#D9E3F0',
        '#F47373',
        '#697689',
        '#37D67A',
        '#2CCCE4',
        '#555555',
        '#dce775',
        '#ff8a65',
        '#ba68c8'
    ],
    triangle: 'top',
    styles: {}
};
var $128480d4605e3fb0$export$2e2bcd8739ae039 = (0, $b0ac51c924707ae7$export$2e2bcd8739ae039)($128480d4605e3fb0$export$d96a8827a60d6b69);



var $8FY87 = parcelRequire("8FY87");

var $4VW2f = parcelRequire("4VW2f");



var $7579141b3dc4090f$export$a90204d1394caf30 = {
    "50": "#ffebee",
    "100": "#ffcdd2",
    "200": "#ef9a9a",
    "300": "#e57373",
    "400": "#ef5350",
    "500": "#f44336",
    "600": "#e53935",
    "700": "#d32f2f",
    "800": "#c62828",
    "900": "#b71c1c",
    "a100": "#ff8a80",
    "a200": "#ff5252",
    "a400": "#ff1744",
    "a700": "#d50000"
};
var $7579141b3dc4090f$export$47853bc718611763 = {
    "50": "#fce4ec",
    "100": "#f8bbd0",
    "200": "#f48fb1",
    "300": "#f06292",
    "400": "#ec407a",
    "500": "#e91e63",
    "600": "#d81b60",
    "700": "#c2185b",
    "800": "#ad1457",
    "900": "#880e4f",
    "a100": "#ff80ab",
    "a200": "#ff4081",
    "a400": "#f50057",
    "a700": "#c51162"
};
var $7579141b3dc4090f$export$e13cce2a2d16a9d4 = {
    "50": "#f3e5f5",
    "100": "#e1bee7",
    "200": "#ce93d8",
    "300": "#ba68c8",
    "400": "#ab47bc",
    "500": "#9c27b0",
    "600": "#8e24aa",
    "700": "#7b1fa2",
    "800": "#6a1b9a",
    "900": "#4a148c",
    "a100": "#ea80fc",
    "a200": "#e040fb",
    "a400": "#d500f9",
    "a700": "#aa00ff"
};
var $7579141b3dc4090f$export$51ef95b19086af57 = {
    "50": "#ede7f6",
    "100": "#d1c4e9",
    "200": "#b39ddb",
    "300": "#9575cd",
    "400": "#7e57c2",
    "500": "#673ab7",
    "600": "#5e35b1",
    "700": "#512da8",
    "800": "#4527a0",
    "900": "#311b92",
    "a100": "#b388ff",
    "a200": "#7c4dff",
    "a400": "#651fff",
    "a700": "#6200ea"
};
var $7579141b3dc4090f$export$3e6ccc7b8562d453 = {
    "50": "#e8eaf6",
    "100": "#c5cae9",
    "200": "#9fa8da",
    "300": "#7986cb",
    "400": "#5c6bc0",
    "500": "#3f51b5",
    "600": "#3949ab",
    "700": "#303f9f",
    "800": "#283593",
    "900": "#1a237e",
    "a100": "#8c9eff",
    "a200": "#536dfe",
    "a400": "#3d5afe",
    "a700": "#304ffe"
};
var $7579141b3dc4090f$export$2aa0182783e7e9de = {
    "50": "#e3f2fd",
    "100": "#bbdefb",
    "200": "#90caf9",
    "300": "#64b5f6",
    "400": "#42a5f5",
    "500": "#2196f3",
    "600": "#1e88e5",
    "700": "#1976d2",
    "800": "#1565c0",
    "900": "#0d47a1",
    "a100": "#82b1ff",
    "a200": "#448aff",
    "a400": "#2979ff",
    "a700": "#2962ff"
};
var $7579141b3dc4090f$export$7b0d29b70b435c21 = {
    "50": "#e1f5fe",
    "100": "#b3e5fc",
    "200": "#81d4fa",
    "300": "#4fc3f7",
    "400": "#29b6f6",
    "500": "#03a9f4",
    "600": "#039be5",
    "700": "#0288d1",
    "800": "#0277bd",
    "900": "#01579b",
    "a100": "#80d8ff",
    "a200": "#40c4ff",
    "a400": "#00b0ff",
    "a700": "#0091ea"
};
var $7579141b3dc4090f$export$7474046f446842ee = {
    "50": "#e0f7fa",
    "100": "#b2ebf2",
    "200": "#80deea",
    "300": "#4dd0e1",
    "400": "#26c6da",
    "500": "#00bcd4",
    "600": "#00acc1",
    "700": "#0097a7",
    "800": "#00838f",
    "900": "#006064",
    "a100": "#84ffff",
    "a200": "#18ffff",
    "a400": "#00e5ff",
    "a700": "#00b8d4"
};
var $7579141b3dc4090f$export$8bf7dff220b82b4a = {
    "50": "#e0f2f1",
    "100": "#b2dfdb",
    "200": "#80cbc4",
    "300": "#4db6ac",
    "400": "#26a69a",
    "500": "#009688",
    "600": "#00897b",
    "700": "#00796b",
    "800": "#00695c",
    "900": "#004d40",
    "a100": "#a7ffeb",
    "a200": "#64ffda",
    "a400": "#1de9b6",
    "a700": "#00bfa5"
};
var $7579141b3dc4090f$export$955a2ebd2fb142ae = {
    "50": "#e8f5e9",
    "100": "#c8e6c9",
    "200": "#a5d6a7",
    "300": "#81c784",
    "400": "#66bb6a",
    "500": "#4caf50",
    "600": "#43a047",
    "700": "#388e3c",
    "800": "#2e7d32",
    "900": "#1b5e20",
    "a100": "#b9f6ca",
    "a200": "#69f0ae",
    "a400": "#00e676",
    "a700": "#00c853"
};
var $7579141b3dc4090f$export$559a8c00376dc936 = {
    "50": "#f1f8e9",
    "100": "#dcedc8",
    "200": "#c5e1a5",
    "300": "#aed581",
    "400": "#9ccc65",
    "500": "#8bc34a",
    "600": "#7cb342",
    "700": "#689f38",
    "800": "#558b2f",
    "900": "#33691e",
    "a100": "#ccff90",
    "a200": "#b2ff59",
    "a400": "#76ff03",
    "a700": "#64dd17"
};
var $7579141b3dc4090f$export$221d31baf2636aad = {
    "50": "#f9fbe7",
    "100": "#f0f4c3",
    "200": "#e6ee9c",
    "300": "#dce775",
    "400": "#d4e157",
    "500": "#cddc39",
    "600": "#c0ca33",
    "700": "#afb42b",
    "800": "#9e9d24",
    "900": "#827717",
    "a100": "#f4ff81",
    "a200": "#eeff41",
    "a400": "#c6ff00",
    "a700": "#aeea00"
};
var $7579141b3dc4090f$export$594c5a8758200c32 = {
    "50": "#fffde7",
    "100": "#fff9c4",
    "200": "#fff59d",
    "300": "#fff176",
    "400": "#ffee58",
    "500": "#ffeb3b",
    "600": "#fdd835",
    "700": "#fbc02d",
    "800": "#f9a825",
    "900": "#f57f17",
    "a100": "#ffff8d",
    "a200": "#ffff00",
    "a400": "#ffea00",
    "a700": "#ffd600"
};
var $7579141b3dc4090f$export$7c1ecc66643fdbd6 = {
    "50": "#fff8e1",
    "100": "#ffecb3",
    "200": "#ffe082",
    "300": "#ffd54f",
    "400": "#ffca28",
    "500": "#ffc107",
    "600": "#ffb300",
    "700": "#ffa000",
    "800": "#ff8f00",
    "900": "#ff6f00",
    "a100": "#ffe57f",
    "a200": "#ffd740",
    "a400": "#ffc400",
    "a700": "#ffab00"
};
var $7579141b3dc4090f$export$ad766f34ace1cafd = {
    "50": "#fff3e0",
    "100": "#ffe0b2",
    "200": "#ffcc80",
    "300": "#ffb74d",
    "400": "#ffa726",
    "500": "#ff9800",
    "600": "#fb8c00",
    "700": "#f57c00",
    "800": "#ef6c00",
    "900": "#e65100",
    "a100": "#ffd180",
    "a200": "#ffab40",
    "a400": "#ff9100",
    "a700": "#ff6d00"
};
var $7579141b3dc4090f$export$1ceed3dd9ec11704 = {
    "50": "#fbe9e7",
    "100": "#ffccbc",
    "200": "#ffab91",
    "300": "#ff8a65",
    "400": "#ff7043",
    "500": "#ff5722",
    "600": "#f4511e",
    "700": "#e64a19",
    "800": "#d84315",
    "900": "#bf360c",
    "a100": "#ff9e80",
    "a200": "#ff6e40",
    "a400": "#ff3d00",
    "a700": "#dd2c00"
};
var $7579141b3dc4090f$export$b6e6178d3f565007 = {
    "50": "#efebe9",
    "100": "#d7ccc8",
    "200": "#bcaaa4",
    "300": "#a1887f",
    "400": "#8d6e63",
    "500": "#795548",
    "600": "#6d4c41",
    "700": "#5d4037",
    "800": "#4e342e",
    "900": "#3e2723"
};
var $7579141b3dc4090f$export$e4c89085febbc618 = {
    "50": "#fafafa",
    "100": "#f5f5f5",
    "200": "#eeeeee",
    "300": "#e0e0e0",
    "400": "#bdbdbd",
    "500": "#9e9e9e",
    "600": "#757575",
    "700": "#616161",
    "800": "#424242",
    "900": "#212121"
};
var $7579141b3dc4090f$export$7c2da42d08c019c9 = {
    "50": "#eceff1",
    "100": "#cfd8dc",
    "200": "#b0bec5",
    "300": "#90a4ae",
    "400": "#78909c",
    "500": "#607d8b",
    "600": "#546e7a",
    "700": "#455a64",
    "800": "#37474f",
    "900": "#263238"
};
var $7579141b3dc4090f$export$b413907788b50267 = {
    "primary": "rgba(0, 0, 0, 0.87)",
    "secondary": "rgba(0, 0, 0, 0.54)",
    "disabled": "rgba(0, 0, 0, 0.38)",
    "dividers": "rgba(0, 0, 0, 0.12)"
};
var $7579141b3dc4090f$export$c962f8177a273028 = {
    "primary": "rgba(255, 255, 255, 1)",
    "secondary": "rgba(255, 255, 255, 0.7)",
    "disabled": "rgba(255, 255, 255, 0.5)",
    "dividers": "rgba(255, 255, 255, 0.12)"
};
var $7579141b3dc4090f$export$969f6c634341b5cf = {
    "active": "rgba(0, 0, 0, 0.54)",
    "inactive": "rgba(0, 0, 0, 0.38)"
};
var $7579141b3dc4090f$export$6b4a43519c60f4b1 = {
    "active": "rgba(255, 255, 255, 1)",
    "inactive": "rgba(255, 255, 255, 0.5)"
};
var $7579141b3dc4090f$export$8fa4e5556fd77a60 = "#ffffff";
var $7579141b3dc4090f$export$c073df10e766abfa = "#000000";
var $7579141b3dc4090f$export$2e2bcd8739ae039 = {
    red: $7579141b3dc4090f$export$a90204d1394caf30,
    pink: $7579141b3dc4090f$export$47853bc718611763,
    purple: $7579141b3dc4090f$export$e13cce2a2d16a9d4,
    deepPurple: $7579141b3dc4090f$export$51ef95b19086af57,
    indigo: $7579141b3dc4090f$export$3e6ccc7b8562d453,
    blue: $7579141b3dc4090f$export$2aa0182783e7e9de,
    lightBlue: $7579141b3dc4090f$export$7b0d29b70b435c21,
    cyan: $7579141b3dc4090f$export$7474046f446842ee,
    teal: $7579141b3dc4090f$export$8bf7dff220b82b4a,
    green: $7579141b3dc4090f$export$955a2ebd2fb142ae,
    lightGreen: $7579141b3dc4090f$export$559a8c00376dc936,
    lime: $7579141b3dc4090f$export$221d31baf2636aad,
    yellow: $7579141b3dc4090f$export$594c5a8758200c32,
    amber: $7579141b3dc4090f$export$7c1ecc66643fdbd6,
    orange: $7579141b3dc4090f$export$ad766f34ace1cafd,
    deepOrange: $7579141b3dc4090f$export$1ceed3dd9ec11704,
    brown: $7579141b3dc4090f$export$b6e6178d3f565007,
    grey: $7579141b3dc4090f$export$e4c89085febbc618,
    blueGrey: $7579141b3dc4090f$export$7c2da42d08c019c9,
    darkText: $7579141b3dc4090f$export$b413907788b50267,
    lightText: $7579141b3dc4090f$export$c962f8177a273028,
    darkIcons: $7579141b3dc4090f$export$969f6c634341b5cf,
    lightIcons: $7579141b3dc4090f$export$6b4a43519c60f4b1,
    white: $7579141b3dc4090f$export$8fa4e5556fd77a60,
    black: $7579141b3dc4090f$export$c073df10e766abfa
};




var $8FY87 = parcelRequire("8FY87");


var $1af28e307b7e2c03$export$945d5c8ebb42b0ff = function CircleSwatch(_ref) {
    var color = _ref.color, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover, hover = _ref.hover, active = _ref.active, circleSize = _ref.circleSize, circleSpacing = _ref.circleSpacing;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))({
        'default': {
            swatch: {
                width: circleSize,
                height: circleSize,
                marginRight: circleSpacing,
                marginBottom: circleSpacing,
                transform: 'scale(1)',
                transition: '100ms transform ease'
            },
            Swatch: {
                borderRadius: '50%',
                background: 'transparent',
                boxShadow: 'inset 0 0 0 ' + (circleSize / 2 + 1) + 'px ' + color,
                transition: '100ms box-shadow ease'
            }
        },
        'hover': {
            swatch: {
                transform: 'scale(1.2)'
            }
        },
        'active': {
            Swatch: {
                boxShadow: 'inset 0 0 0 3px ' + color
            }
        }
    }, {
        hover: hover,
        active: active
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $aab2657fe6a56e51$export$2e2bcd8739ae039), {
        style: styles.Swatch,
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: styles.Swatch.boxShadow + ', 0 0 5px ' + color
        }
    }));
};
$1af28e307b7e2c03$export$945d5c8ebb42b0ff.defaultProps = {
    circleSize: 28,
    circleSpacing: 14
};
var $1af28e307b7e2c03$export$2e2bcd8739ae039 = (0, $bb2c8b52dc31f705$exports.handleHover)($1af28e307b7e2c03$export$945d5c8ebb42b0ff);


var $7e14e7b88d0d91e3$export$c89a927ffc67e6fa = function Circle(_ref) {
    var width = _ref.width, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, circleSize = _ref.circleSize, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, circleSpacing = _ref.circleSpacing, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))((0, $4dea300bb9269819$export$2e2bcd8739ae039)({
        'default': {
            card: {
                width: width,
                display: 'flex',
                flexWrap: 'wrap',
                marginRight: -circleSpacing,
                marginBottom: -circleSpacing
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(hexCode, e) {
        return onChange({
            hex: hexCode,
            source: 'hex'
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.card,
        className: 'circle-picker ' + className
    }, (0, $2d9216e96febe2b9$export$2e2bcd8739ae039)(colors, function(c) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $1af28e307b7e2c03$export$2e2bcd8739ae039), {
            key: c,
            color: c,
            onClick: handleChange,
            onSwatchHover: onSwatchHover,
            active: hex === c.toLowerCase(),
            circleSize: circleSize,
            circleSpacing: circleSpacing
        });
    }));
};
$7e14e7b88d0d91e3$export$c89a927ffc67e6fa.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).number
    ]),
    circleSize: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).number,
    circleSpacing: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).number,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).object
};
$7e14e7b88d0d91e3$export$c89a927ffc67e6fa.defaultProps = {
    width: 252,
    circleSize: 28,
    circleSpacing: 14,
    colors: [
        $7579141b3dc4090f$export$a90204d1394caf30['500'],
        $7579141b3dc4090f$export$47853bc718611763['500'],
        $7579141b3dc4090f$export$e13cce2a2d16a9d4['500'],
        $7579141b3dc4090f$export$51ef95b19086af57['500'],
        $7579141b3dc4090f$export$3e6ccc7b8562d453['500'],
        $7579141b3dc4090f$export$2aa0182783e7e9de['500'],
        $7579141b3dc4090f$export$7b0d29b70b435c21['500'],
        $7579141b3dc4090f$export$7474046f446842ee['500'],
        $7579141b3dc4090f$export$8bf7dff220b82b4a['500'],
        $7579141b3dc4090f$export$955a2ebd2fb142ae['500'],
        $7579141b3dc4090f$export$559a8c00376dc936['500'],
        $7579141b3dc4090f$export$221d31baf2636aad['500'],
        $7579141b3dc4090f$export$594c5a8758200c32['500'],
        $7579141b3dc4090f$export$7c1ecc66643fdbd6['500'],
        $7579141b3dc4090f$export$ad766f34ace1cafd['500'],
        $7579141b3dc4090f$export$1ceed3dd9ec11704['500'],
        $7579141b3dc4090f$export$b6e6178d3f565007['500'],
        $7579141b3dc4090f$export$7c2da42d08c019c9['500']
    ],
    styles: {}
};
var $7e14e7b88d0d91e3$export$2e2bcd8739ae039 = (0, $b0ac51c924707ae7$export$2e2bcd8739ae039)($7e14e7b88d0d91e3$export$c89a927ffc67e6fa);



var $8FY87 = parcelRequire("8FY87");

var $4VW2f = parcelRequire("4VW2f");




var $8FY87 = parcelRequire("8FY87");


/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $d7870fc4550651f6$var$isUndefined(value) {
    return value === undefined;
}
var $d7870fc4550651f6$export$2e2bcd8739ae039 = $d7870fc4550651f6$var$isUndefined;



var $7b4614ffa6e1bfa9$exports = {};
'use strict';
Object.defineProperty($7b4614ffa6e1bfa9$exports, "__esModule", {
    value: true
});
var $7b4614ffa6e1bfa9$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $8FY87 = parcelRequire("8FY87");
var $7b4614ffa6e1bfa9$var$_react2 = $7b4614ffa6e1bfa9$var$_interopRequireDefault($8FY87);
function $7b4614ffa6e1bfa9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7b4614ffa6e1bfa9$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var $7b4614ffa6e1bfa9$var$DEFAULT_SIZE = 24;
$7b4614ffa6e1bfa9$exports.default = function(_ref) {
    var _ref$fill = _ref.fill, fill = _ref$fill === undefined ? 'currentColor' : _ref$fill, _ref$width = _ref.width, width = _ref$width === undefined ? $7b4614ffa6e1bfa9$var$DEFAULT_SIZE : _ref$width, _ref$height = _ref.height, height = _ref$height === undefined ? $7b4614ffa6e1bfa9$var$DEFAULT_SIZE : _ref$height, _ref$style = _ref.style, style = _ref$style === undefined ? {} : _ref$style, props = $7b4614ffa6e1bfa9$var$_objectWithoutProperties(_ref, [
        'fill',
        'width',
        'height',
        'style'
    ]);
    return $7b4614ffa6e1bfa9$var$_react2.default.createElement('svg', $7b4614ffa6e1bfa9$var$_extends({
        viewBox: '0 0 ' + $7b4614ffa6e1bfa9$var$DEFAULT_SIZE + ' ' + $7b4614ffa6e1bfa9$var$DEFAULT_SIZE,
        style: $7b4614ffa6e1bfa9$var$_extends({
            fill: fill,
            width: width,
            height: height
        }, style)
    }, props), $7b4614ffa6e1bfa9$var$_react2.default.createElement('path', {
        d: 'M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z'
    }));
};


var $de1ad8238a0c5b22$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $de1ad8238a0c5b22$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $de1ad8238a0c5b22$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $de1ad8238a0c5b22$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $de1ad8238a0c5b22$export$71685d48a2432635 = function(_React$Component) {
    $de1ad8238a0c5b22$var$_inherits(ChromeFields, _React$Component);
    function ChromeFields(props) {
        $de1ad8238a0c5b22$var$_classCallCheck(this, ChromeFields);
        var _this = $de1ad8238a0c5b22$var$_possibleConstructorReturn(this, (ChromeFields.__proto__ || Object.getPrototypeOf(ChromeFields)).call(this));
        _this.toggleViews = function() {
            if (_this.state.view === 'hex') _this.setState({
                view: 'rgb'
            });
            else if (_this.state.view === 'rgb') _this.setState({
                view: 'hsl'
            });
            else if (_this.state.view === 'hsl') {
                if (_this.props.hsl.a === 1) _this.setState({
                    view: 'hex'
                });
                else _this.setState({
                    view: 'rgb'
                });
            }
        };
        _this.handleChange = function(data, e) {
            if (data.hex) $0484844d062f071f$export$944f75ec5697b362(data.hex) && _this.props.onChange({
                hex: data.hex,
                source: 'hex'
            }, e);
            else if (data.r || data.g || data.b) _this.props.onChange({
                r: data.r || _this.props.rgb.r,
                g: data.g || _this.props.rgb.g,
                b: data.b || _this.props.rgb.b,
                source: 'rgb'
            }, e);
            else if (data.a) {
                if (data.a < 0) data.a = 0;
                else if (data.a > 1) data.a = 1;
                _this.props.onChange({
                    h: _this.props.hsl.h,
                    s: _this.props.hsl.s,
                    l: _this.props.hsl.l,
                    a: Math.round(data.a * 100) / 100,
                    source: 'rgb'
                }, e);
            } else if (data.h || data.s || data.l) {
                // Remove any occurances of '%'.
                if (typeof data.s === 'string' && data.s.includes('%')) data.s = data.s.replace('%', '');
                if (typeof data.l === 'string' && data.l.includes('%')) data.l = data.l.replace('%', '');
                // We store HSL as a unit interval so we need to override the 1 input to 0.01
                if (data.s == 1) data.s = 0.01;
                else if (data.l == 1) data.l = 0.01;
                _this.props.onChange({
                    h: data.h || _this.props.hsl.h,
                    s: Number(!(0, $d7870fc4550651f6$export$2e2bcd8739ae039)(data.s) ? data.s : _this.props.hsl.s),
                    l: Number(!(0, $d7870fc4550651f6$export$2e2bcd8739ae039)(data.l) ? data.l : _this.props.hsl.l),
                    source: 'hsl'
                }, e);
            }
        };
        _this.showHighlight = function(e) {
            e.currentTarget.style.background = '#eee';
        };
        _this.hideHighlight = function(e) {
            e.currentTarget.style.background = 'transparent';
        };
        if (props.hsl.a !== 1 && props.view === "hex") _this.state = {
            view: "rgb"
        };
        else _this.state = {
            view: props.view
        };
        return _this;
    }
    $de1ad8238a0c5b22$var$_createClass(ChromeFields, [
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))({
                    'default': {
                        wrap: {
                            paddingTop: '16px',
                            display: 'flex'
                        },
                        fields: {
                            flex: '1',
                            display: 'flex',
                            marginLeft: '-6px'
                        },
                        field: {
                            paddingLeft: '6px',
                            width: '100%'
                        },
                        alpha: {
                            paddingLeft: '6px',
                            width: '100%'
                        },
                        toggle: {
                            width: '32px',
                            textAlign: 'right',
                            position: 'relative'
                        },
                        icon: {
                            marginRight: '-4px',
                            marginTop: '12px',
                            cursor: 'pointer',
                            position: 'relative'
                        },
                        iconHighlight: {
                            position: 'absolute',
                            width: '24px',
                            height: '28px',
                            background: '#eee',
                            borderRadius: '4px',
                            top: '10px',
                            left: '12px',
                            display: 'none'
                        },
                        input: {
                            fontSize: '11px',
                            color: '#333',
                            width: '100%',
                            borderRadius: '2px',
                            border: 'none',
                            boxShadow: 'inset 0 0 0 1px #dadada',
                            height: '21px',
                            textAlign: 'center'
                        },
                        label: {
                            textTransform: 'uppercase',
                            fontSize: '11px',
                            lineHeight: '11px',
                            color: '#969696',
                            textAlign: 'center',
                            display: 'block',
                            marginTop: '12px'
                        },
                        svg: {
                            fill: '#333',
                            width: '24px',
                            height: '24px',
                            border: '1px transparent solid',
                            borderRadius: '5px'
                        }
                    },
                    'disableAlpha': {
                        alpha: {
                            display: 'none'
                        }
                    }
                }, this.props, this.state);
                var fields = void 0;
                if (this.state.view === 'hex') fields = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.fields,
                    className: 'flexbox-fix'
                }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $5e4e3784fbcdba0a$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'hex',
                    value: this.props.hex,
                    onChange: this.handleChange
                })));
                else if (this.state.view === 'rgb') fields = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.fields,
                    className: 'flexbox-fix'
                }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $5e4e3784fbcdba0a$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'r',
                    value: this.props.rgb.r,
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $5e4e3784fbcdba0a$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'g',
                    value: this.props.rgb.g,
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $5e4e3784fbcdba0a$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'b',
                    value: this.props.rgb.b,
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.alpha
                }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $5e4e3784fbcdba0a$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'a',
                    value: this.props.rgb.a,
                    arrowOffset: 0.01,
                    onChange: this.handleChange
                })));
                else if (this.state.view === 'hsl') fields = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.fields,
                    className: 'flexbox-fix'
                }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $5e4e3784fbcdba0a$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'h',
                    value: Math.round(this.props.hsl.h),
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $5e4e3784fbcdba0a$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 's',
                    value: Math.round(this.props.hsl.s * 100) + '%',
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $5e4e3784fbcdba0a$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'l',
                    value: Math.round(this.props.hsl.l * 100) + '%',
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.alpha
                }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $5e4e3784fbcdba0a$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'a',
                    value: this.props.hsl.a,
                    arrowOffset: 0.01,
                    onChange: this.handleChange
                })));
                return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.wrap,
                    className: 'flexbox-fix'
                }, fields, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.toggle
                }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.icon,
                    onClick: this.toggleViews,
                    ref: function ref(icon) {
                        return _this2.icon = icon;
                    }
                }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7b4614ffa6e1bfa9$exports))), {
                    style: styles.svg,
                    onMouseOver: this.showHighlight,
                    onMouseEnter: this.showHighlight,
                    onMouseOut: this.hideHighlight
                }))));
            }
        }
    ], [
        {
            key: 'getDerivedStateFromProps',
            value: function getDerivedStateFromProps(nextProps, state) {
                if (nextProps.hsl.a !== 1 && state.view === 'hex') return {
                    view: 'rgb'
                };
                return null;
            }
        }
    ]);
    return ChromeFields;
}((0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).Component);
$de1ad8238a0c5b22$export$71685d48a2432635.defaultProps = {
    view: "hex"
};
var $de1ad8238a0c5b22$export$2e2bcd8739ae039 = $de1ad8238a0c5b22$export$71685d48a2432635;



var $8FY87 = parcelRequire("8FY87");

var $b427603c68e9062c$export$a632586f9a957100 = function ChromePointer() {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))({
        'default': {
            picker: {
                width: '12px',
                height: '12px',
                borderRadius: '6px',
                transform: 'translate(-6px, -1px)',
                backgroundColor: 'rgb(248, 248, 248)',
                boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.picker
    });
};
var $b427603c68e9062c$export$2e2bcd8739ae039 = $b427603c68e9062c$export$a632586f9a957100;



var $8FY87 = parcelRequire("8FY87");

var $c1ff1002ce7e394c$export$190c1afe887f7ef7 = function ChromePointerCircle() {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))({
        'default': {
            picker: {
                width: '12px',
                height: '12px',
                borderRadius: '6px',
                boxShadow: 'inset 0 0 0 1px #fff',
                transform: 'translate(-6px, -6px)'
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.picker
    });
};
var $c1ff1002ce7e394c$export$2e2bcd8739ae039 = $c1ff1002ce7e394c$export$190c1afe887f7ef7;


var $7fde91aef940e993$export$31a305e9779b48b4 = function Chrome(_ref) {
    var width = _ref.width, onChange = _ref.onChange, disableAlpha = _ref.disableAlpha, rgb = _ref.rgb, hsl = _ref.hsl, hsv = _ref.hsv, hex = _ref.hex, renderers = _ref.renderers, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className, defaultView = _ref.defaultView;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))((0, $4dea300bb9269819$export$2e2bcd8739ae039)({
        'default': {
            picker: {
                width: width,
                background: '#fff',
                borderRadius: '2px',
                boxShadow: '0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)',
                boxSizing: 'initial',
                fontFamily: 'Menlo'
            },
            saturation: {
                width: '100%',
                paddingBottom: '55%',
                position: 'relative',
                borderRadius: '2px 2px 0 0',
                overflow: 'hidden'
            },
            Saturation: {
                radius: '2px 2px 0 0'
            },
            body: {
                padding: '16px 16px 12px'
            },
            controls: {
                display: 'flex'
            },
            color: {
                width: '32px'
            },
            swatch: {
                marginTop: '6px',
                width: '16px',
                height: '16px',
                borderRadius: '8px',
                position: 'relative',
                overflow: 'hidden'
            },
            active: {
                absolute: '0px 0px 0px 0px',
                borderRadius: '8px',
                boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.1)',
                background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', ' + rgb.a + ')',
                zIndex: '2'
            },
            toggles: {
                flex: '1'
            },
            hue: {
                height: '10px',
                position: 'relative',
                marginBottom: '8px'
            },
            Hue: {
                radius: '2px'
            },
            alpha: {
                height: '10px',
                position: 'relative'
            },
            Alpha: {
                radius: '2px'
            }
        },
        'disableAlpha': {
            color: {
                width: '22px'
            },
            alpha: {
                display: 'none'
            },
            hue: {
                marginBottom: '0px'
            },
            swatch: {
                width: '10px',
                height: '10px',
                marginTop: '0px'
            }
        }
    }, passedStyles), {
        disableAlpha: disableAlpha
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.picker,
        className: 'chrome-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.saturation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $16928b06bc556b42$export$2e2bcd8739ae039), {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        pointer: (0, $c1ff1002ce7e394c$export$2e2bcd8739ae039),
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.body
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.controls,
        className: 'flexbox-fix'
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.color
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.active
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $41a8f0ec8c9e9c24$export$2e2bcd8739ae039), {
        renderers: renderers
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.toggles
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.hue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $54f2bbfcaac0993e$export$2e2bcd8739ae039), {
        style: styles.Hue,
        hsl: hsl,
        pointer: (0, $b427603c68e9062c$export$2e2bcd8739ae039),
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.alpha
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $5f0e862746c8c551$export$2e2bcd8739ae039), {
        style: styles.Alpha,
        rgb: rgb,
        hsl: hsl,
        pointer: (0, $b427603c68e9062c$export$2e2bcd8739ae039),
        renderers: renderers,
        onChange: onChange
    })))), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $de1ad8238a0c5b22$export$2e2bcd8739ae039), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        view: defaultView,
        onChange: onChange,
        disableAlpha: disableAlpha
    })));
};
$7fde91aef940e993$export$31a305e9779b48b4.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).number
    ]),
    disableAlpha: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).bool,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).object,
    defaultView: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).oneOf([
        "hex",
        "rgb",
        "hsl"
    ])
};
$7fde91aef940e993$export$31a305e9779b48b4.defaultProps = {
    width: 225,
    disableAlpha: false,
    styles: {}
};
var $7fde91aef940e993$export$2e2bcd8739ae039 = (0, $b0ac51c924707ae7$export$2e2bcd8739ae039)($7fde91aef940e993$export$31a305e9779b48b4);



var $8FY87 = parcelRequire("8FY87");

var $4VW2f = parcelRequire("4VW2f");






var $8FY87 = parcelRequire("8FY87");



var $631175b97c54efe4$export$df654652e5203306 = function CompactColor(_ref) {
    var color = _ref.color, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover, active = _ref.active;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))({
        'default': {
            color: {
                background: color,
                width: '15px',
                height: '15px',
                float: 'left',
                marginRight: '5px',
                marginBottom: '5px',
                position: 'relative',
                cursor: 'pointer'
            },
            dot: {
                absolute: '5px 5px 5px 5px',
                background: $0484844d062f071f$export$3609eb1d7e55dec(color),
                borderRadius: '50%',
                opacity: '0'
            }
        },
        'active': {
            dot: {
                opacity: '1'
            }
        },
        'color-#FFFFFF': {
            color: {
                boxShadow: 'inset 0 0 0 1px #ddd'
            },
            dot: {
                background: '#000'
            }
        },
        'transparent': {
            dot: {
                background: '#000'
            }
        }
    }, {
        active: active,
        'color-#FFFFFF': color === '#FFFFFF',
        'transparent': color === 'transparent'
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $aab2657fe6a56e51$export$2e2bcd8739ae039), {
        style: styles.color,
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: '0 0 4px ' + color
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.dot
    }));
};
var $631175b97c54efe4$export$2e2bcd8739ae039 = $631175b97c54efe4$export$df654652e5203306;



var $8FY87 = parcelRequire("8FY87");


var $e646353b18d5976b$export$11cdb14a03223d9c = function CompactFields(_ref) {
    var hex = _ref.hex, rgb = _ref.rgb, onChange = _ref.onChange;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))({
        'default': {
            fields: {
                display: 'flex',
                paddingBottom: '6px',
                paddingRight: '5px',
                position: 'relative'
            },
            active: {
                position: 'absolute',
                top: '6px',
                left: '5px',
                height: '9px',
                width: '9px',
                background: hex
            },
            HEXwrap: {
                flex: '6',
                position: 'relative'
            },
            HEXinput: {
                width: '80%',
                padding: '0px',
                paddingLeft: '20%',
                border: 'none',
                outline: 'none',
                background: 'none',
                fontSize: '12px',
                color: '#333',
                height: '16px'
            },
            HEXlabel: {
                display: 'none'
            },
            RGBwrap: {
                flex: '3',
                position: 'relative'
            },
            RGBinput: {
                width: '70%',
                padding: '0px',
                paddingLeft: '30%',
                border: 'none',
                outline: 'none',
                background: 'none',
                fontSize: '12px',
                color: '#333',
                height: '16px'
            },
            RGBlabel: {
                position: 'absolute',
                top: '3px',
                left: '0px',
                lineHeight: '16px',
                textTransform: 'uppercase',
                fontSize: '12px',
                color: '#999'
            }
        }
    });
    var handleChange = function handleChange(data, e) {
        if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: 'rgb'
        }, e);
        else onChange({
            hex: data.hex,
            source: 'hex'
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.fields,
        className: 'flexbox-fix'
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.active
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $5e4e3784fbcdba0a$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: 'hex',
        value: hex,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $5e4e3784fbcdba0a$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'r',
        value: rgb.r,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $5e4e3784fbcdba0a$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'g',
        value: rgb.g,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $5e4e3784fbcdba0a$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'b',
        value: rgb.b,
        onChange: handleChange
    }));
};
var $e646353b18d5976b$export$2e2bcd8739ae039 = $e646353b18d5976b$export$11cdb14a03223d9c;


var $ab90aa0f890883de$export$6479582a9c9e50ce = function Compact(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, rgb = _ref.rgb, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))((0, $4dea300bb9269819$export$2e2bcd8739ae039)({
        'default': {
            Compact: {
                background: '#f6f6f6',
                radius: '4px'
            },
            compact: {
                paddingTop: '5px',
                paddingLeft: '5px',
                boxSizing: 'initial',
                width: '240px'
            },
            clear: {
                clear: 'both'
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        if (data.hex) $0484844d062f071f$export$944f75ec5697b362(data.hex) && onChange({
            hex: data.hex,
            source: 'hex'
        }, e);
        else onChange(data, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $53ba7047d513ec75$export$2e2bcd8739ae039), {
        style: styles.Compact,
        styles: passedStyles
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.compact,
        className: 'compact-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', null, (0, $2d9216e96febe2b9$export$2e2bcd8739ae039)(colors, function(c) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $631175b97c54efe4$export$2e2bcd8739ae039), {
            key: c,
            color: c,
            active: c.toLowerCase() === hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.clear
    })), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $e646353b18d5976b$export$2e2bcd8739ae039), {
        hex: hex,
        rgb: rgb,
        onChange: handleChange
    })));
};
$ab90aa0f890883de$export$6479582a9c9e50ce.propTypes = {
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).string),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).object
};
$ab90aa0f890883de$export$6479582a9c9e50ce.defaultProps = {
    colors: [
        '#4D4D4D',
        '#999999',
        '#FFFFFF',
        '#F44E3B',
        '#FE9200',
        '#FCDC00',
        '#DBDF00',
        '#A4DD00',
        '#68CCCA',
        '#73D8FF',
        '#AEA1FF',
        '#FDA1FF',
        '#333333',
        '#808080',
        '#cccccc',
        '#D33115',
        '#E27300',
        '#FCC400',
        '#B0BC00',
        '#68BC00',
        '#16A5A5',
        '#009CE0',
        '#7B64FF',
        '#FA28FF',
        '#000000',
        '#666666',
        '#B3B3B3',
        '#9F0500',
        '#C45100',
        '#FB9E00',
        '#808900',
        '#194D33',
        '#0C797D',
        '#0062B1',
        '#653294',
        '#AB149E'
    ],
    styles: {}
};
var $ab90aa0f890883de$export$2e2bcd8739ae039 = (0, $b0ac51c924707ae7$export$2e2bcd8739ae039)($ab90aa0f890883de$export$6479582a9c9e50ce);



var $8FY87 = parcelRequire("8FY87");

var $4VW2f = parcelRequire("4VW2f");





var $8FY87 = parcelRequire("8FY87");


var $8835142b51a85897$export$d653c538b92bb84f = function GithubSwatch(_ref) {
    var hover = _ref.hover, color = _ref.color, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover;
    var hoverSwatch = {
        position: 'relative',
        zIndex: '2',
        outline: '2px solid #fff',
        boxShadow: '0 0 5px 2px rgba(0,0,0,0.25)'
    };
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))({
        'default': {
            swatch: {
                width: '25px',
                height: '25px',
                fontSize: '0'
            }
        },
        'hover': {
            swatch: hoverSwatch
        }
    }, {
        hover: hover
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $aab2657fe6a56e51$export$2e2bcd8739ae039), {
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: hoverSwatch
    }));
};
var $8835142b51a85897$export$2e2bcd8739ae039 = (0, $bb2c8b52dc31f705$exports.handleHover)($8835142b51a85897$export$d653c538b92bb84f);


var $a8ad3e06694c127e$export$61d478c2aba5d9a5 = function Github(_ref) {
    var width = _ref.width, colors = _ref.colors, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))((0, $4dea300bb9269819$export$2e2bcd8739ae039)({
        'default': {
            card: {
                width: width,
                background: '#fff',
                border: '1px solid rgba(0,0,0,0.2)',
                boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
                borderRadius: '4px',
                position: 'relative',
                padding: '5px',
                display: 'flex',
                flexWrap: 'wrap'
            },
            triangle: {
                position: 'absolute',
                border: '7px solid transparent',
                borderBottomColor: '#fff'
            },
            triangleShadow: {
                position: 'absolute',
                border: '8px solid transparent',
                borderBottomColor: 'rgba(0,0,0,0.15)'
            }
        },
        'hide-triangle': {
            triangle: {
                display: 'none'
            },
            triangleShadow: {
                display: 'none'
            }
        },
        'top-left-triangle': {
            triangle: {
                top: '-14px',
                left: '10px'
            },
            triangleShadow: {
                top: '-16px',
                left: '9px'
            }
        },
        'top-right-triangle': {
            triangle: {
                top: '-14px',
                right: '10px'
            },
            triangleShadow: {
                top: '-16px',
                right: '9px'
            }
        },
        'bottom-left-triangle': {
            triangle: {
                top: '35px',
                left: '10px',
                transform: 'rotate(180deg)'
            },
            triangleShadow: {
                top: '37px',
                left: '9px',
                transform: 'rotate(180deg)'
            }
        },
        'bottom-right-triangle': {
            triangle: {
                top: '35px',
                right: '10px',
                transform: 'rotate(180deg)'
            },
            triangleShadow: {
                top: '37px',
                right: '9px',
                transform: 'rotate(180deg)'
            }
        }
    }, passedStyles), {
        'hide-triangle': triangle === 'hide',
        'top-left-triangle': triangle === 'top-left',
        'top-right-triangle': triangle === 'top-right',
        'bottom-left-triangle': triangle === 'bottom-left',
        'bottom-right-triangle': triangle === 'bottom-right'
    });
    var handleChange = function handleChange(hex, e) {
        return onChange({
            hex: hex,
            source: 'hex'
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.card,
        className: 'github-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.triangleShadow
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.triangle
    }), (0, $2d9216e96febe2b9$export$2e2bcd8739ae039)(colors, function(c) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $8835142b51a85897$export$2e2bcd8739ae039), {
            color: c,
            key: c,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }));
};
$a8ad3e06694c127e$export$61d478c2aba5d9a5.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).number
    ]),
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).string),
    triangle: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).oneOf([
        'hide',
        'top-left',
        'top-right',
        'bottom-left',
        'bottom-right'
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).object
};
$a8ad3e06694c127e$export$61d478c2aba5d9a5.defaultProps = {
    width: 200,
    colors: [
        '#B80000',
        '#DB3E00',
        '#FCCB00',
        '#008B02',
        '#006B76',
        '#1273DE',
        '#004DCF',
        '#5300EB',
        '#EB9694',
        '#FAD0C3',
        '#FEF3BD',
        '#C1E1C5',
        '#BEDADC',
        '#C4DEF6',
        '#BED3F3',
        '#D4C4FB'
    ],
    triangle: 'top-left',
    styles: {}
};
var $a8ad3e06694c127e$export$2e2bcd8739ae039 = (0, $b0ac51c924707ae7$export$2e2bcd8739ae039)($a8ad3e06694c127e$export$61d478c2aba5d9a5);



var $8FY87 = parcelRequire("8FY87");

var $4VW2f = parcelRequire("4VW2f");




var $8FY87 = parcelRequire("8FY87");

var $32152b688a80f6d2$export$9c10b52c64965f67 = function SliderPointer(_ref) {
    var direction = _ref.direction;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))({
        'default': {
            picker: {
                width: '18px',
                height: '18px',
                borderRadius: '50%',
                transform: 'translate(-9px, -1px)',
                backgroundColor: 'rgb(248, 248, 248)',
                boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
            }
        },
        'vertical': {
            picker: {
                transform: 'translate(-3px, -9px)'
            }
        }
    }, {
        vertical: direction === 'vertical'
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.picker
    });
};
var $32152b688a80f6d2$export$2e2bcd8739ae039 = $32152b688a80f6d2$export$9c10b52c64965f67;


var $44d5bccdc7846295$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $44d5bccdc7846295$export$f176087feb20230e = function HuePicker(_ref) {
    var width = _ref.width, height = _ref.height, onChange = _ref.onChange, hsl = _ref.hsl, direction = _ref.direction, pointer = _ref.pointer, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))((0, $4dea300bb9269819$export$2e2bcd8739ae039)({
        'default': {
            picker: {
                position: 'relative',
                width: width,
                height: height
            },
            hue: {
                radius: '2px'
            }
        }
    }, passedStyles));
    // Overwrite to provide pure hue color
    var handleChange = function handleChange(data) {
        return onChange({
            a: 1,
            h: data.h,
            l: 0.5,
            s: 1
        });
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.picker,
        className: 'hue-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $54f2bbfcaac0993e$export$2e2bcd8739ae039), $44d5bccdc7846295$var$_extends({}, styles.hue, {
        hsl: hsl,
        pointer: pointer,
        onChange: handleChange,
        direction: direction
    })));
};
$44d5bccdc7846295$export$f176087feb20230e.propTypes = {
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).object
};
$44d5bccdc7846295$export$f176087feb20230e.defaultProps = {
    width: '316px',
    height: '16px',
    direction: 'horizontal',
    pointer: (0, $32152b688a80f6d2$export$2e2bcd8739ae039),
    styles: {}
};
var $44d5bccdc7846295$export$2e2bcd8739ae039 = (0, $b0ac51c924707ae7$export$2e2bcd8739ae039)($44d5bccdc7846295$export$f176087feb20230e);



var $8FY87 = parcelRequire("8FY87");




var $28b002a86d559fcc$export$a2d8b23205c25948 = function Material(_ref) {
    var onChange = _ref.onChange, hex = _ref.hex, rgb = _ref.rgb, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))((0, $4dea300bb9269819$export$2e2bcd8739ae039)({
        'default': {
            material: {
                width: '98px',
                height: '98px',
                padding: '16px',
                fontFamily: 'Roboto'
            },
            HEXwrap: {
                position: 'relative'
            },
            HEXinput: {
                width: '100%',
                marginTop: '12px',
                fontSize: '15px',
                color: '#333',
                padding: '0px',
                border: '0px',
                borderBottom: '2px solid ' + hex,
                outline: 'none',
                height: '30px'
            },
            HEXlabel: {
                position: 'absolute',
                top: '0px',
                left: '0px',
                fontSize: '11px',
                color: '#999999',
                textTransform: 'capitalize'
            },
            Hex: {
                style: {}
            },
            RGBwrap: {
                position: 'relative'
            },
            RGBinput: {
                width: '100%',
                marginTop: '12px',
                fontSize: '15px',
                color: '#333',
                padding: '0px',
                border: '0px',
                borderBottom: '1px solid #eee',
                outline: 'none',
                height: '30px'
            },
            RGBlabel: {
                position: 'absolute',
                top: '0px',
                left: '0px',
                fontSize: '11px',
                color: '#999999',
                textTransform: 'capitalize'
            },
            split: {
                display: 'flex',
                marginRight: '-10px',
                paddingTop: '11px'
            },
            third: {
                flex: '1',
                paddingRight: '10px'
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        if (data.hex) $0484844d062f071f$export$944f75ec5697b362(data.hex) && onChange({
            hex: data.hex,
            source: 'hex'
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: 'rgb'
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $53ba7047d513ec75$export$2e2bcd8739ae039), {
        styles: passedStyles
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.material,
        className: 'material-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $5e4e3784fbcdba0a$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: 'hex',
        value: hex,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.split,
        className: 'flexbox-fix'
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.third
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $5e4e3784fbcdba0a$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'r',
        value: rgb.r,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.third
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $5e4e3784fbcdba0a$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'g',
        value: rgb.g,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.third
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $5e4e3784fbcdba0a$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'b',
        value: rgb.b,
        onChange: handleChange
    })))));
};
var $28b002a86d559fcc$export$2e2bcd8739ae039 = (0, $b0ac51c924707ae7$export$2e2bcd8739ae039)($28b002a86d559fcc$export$a2d8b23205c25948);



var $8FY87 = parcelRequire("8FY87");

var $4VW2f = parcelRequire("4VW2f");




var $8FY87 = parcelRequire("8FY87");



var $6485d3677cc4c0af$export$b1808ee9bfa8f4d0 = function PhotoshopPicker(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsv = _ref.hsv, hex = _ref.hex;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))({
        'default': {
            fields: {
                paddingTop: '5px',
                paddingBottom: '9px',
                width: '80px',
                position: 'relative'
            },
            divider: {
                height: '5px'
            },
            RGBwrap: {
                position: 'relative'
            },
            RGBinput: {
                marginLeft: '40%',
                width: '40%',
                height: '18px',
                border: '1px solid #888888',
                boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
                marginBottom: '5px',
                fontSize: '13px',
                paddingLeft: '3px',
                marginRight: '10px'
            },
            RGBlabel: {
                left: '0px',
                top: '0px',
                width: '34px',
                textTransform: 'uppercase',
                fontSize: '13px',
                height: '18px',
                lineHeight: '22px',
                position: 'absolute'
            },
            HEXwrap: {
                position: 'relative'
            },
            HEXinput: {
                marginLeft: '20%',
                width: '80%',
                height: '18px',
                border: '1px solid #888888',
                boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
                marginBottom: '6px',
                fontSize: '13px',
                paddingLeft: '3px'
            },
            HEXlabel: {
                position: 'absolute',
                top: '0px',
                left: '0px',
                width: '14px',
                textTransform: 'uppercase',
                fontSize: '13px',
                height: '18px',
                lineHeight: '22px'
            },
            fieldSymbols: {
                position: 'absolute',
                top: '5px',
                right: '-7px',
                fontSize: '13px'
            },
            symbol: {
                height: '20px',
                lineHeight: '22px',
                paddingBottom: '7px'
            }
        }
    });
    var handleChange = function handleChange(data, e) {
        if (data['#']) $0484844d062f071f$export$944f75ec5697b362(data['#']) && onChange({
            hex: data['#'],
            source: 'hex'
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: 'rgb'
        }, e);
        else if (data.h || data.s || data.v) onChange({
            h: data.h || hsv.h,
            s: data.s || hsv.s,
            v: data.v || hsv.v,
            source: 'hsv'
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.fields
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $5e4e3784fbcdba0a$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'h',
        value: Math.round(hsv.h),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $5e4e3784fbcdba0a$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 's',
        value: Math.round(hsv.s * 100),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $5e4e3784fbcdba0a$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'v',
        value: Math.round(hsv.v * 100),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.divider
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $5e4e3784fbcdba0a$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'r',
        value: rgb.r,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $5e4e3784fbcdba0a$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'g',
        value: rgb.g,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $5e4e3784fbcdba0a$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'b',
        value: rgb.b,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.divider
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $5e4e3784fbcdba0a$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: '#',
        value: hex.replace('#', ''),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.fieldSymbols
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.symbol
    }, '\xB0'), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.symbol
    }, '%'), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.symbol
    }, '%')));
};
var $6485d3677cc4c0af$export$2e2bcd8739ae039 = $6485d3677cc4c0af$export$b1808ee9bfa8f4d0;



var $8FY87 = parcelRequire("8FY87");

var $16a91ae2b44e33eb$export$123b96ff8455915 = function PhotoshopPointerCircle(_ref) {
    var hsl = _ref.hsl;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))({
        'default': {
            picker: {
                width: '12px',
                height: '12px',
                borderRadius: '6px',
                boxShadow: 'inset 0 0 0 1px #fff',
                transform: 'translate(-6px, -6px)'
            }
        },
        'black-outline': {
            picker: {
                boxShadow: 'inset 0 0 0 1px #000'
            }
        }
    }, {
        'black-outline': hsl.l > 0.5
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.picker
    });
};
var $16a91ae2b44e33eb$export$2e2bcd8739ae039 = $16a91ae2b44e33eb$export$123b96ff8455915;



var $8FY87 = parcelRequire("8FY87");

var $1b9ce628483b48ad$export$123b96ff8455915 = function PhotoshopPointerCircle() {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))({
        'default': {
            triangle: {
                width: 0,
                height: 0,
                borderStyle: 'solid',
                borderWidth: '4px 0 4px 6px',
                borderColor: 'transparent transparent transparent #fff',
                position: 'absolute',
                top: '1px',
                left: '1px'
            },
            triangleBorder: {
                width: 0,
                height: 0,
                borderStyle: 'solid',
                borderWidth: '5px 0 5px 8px',
                borderColor: 'transparent transparent transparent #555'
            },
            left: {
                Extend: 'triangleBorder',
                transform: 'translate(-13px, -4px)'
            },
            leftInside: {
                Extend: 'triangle',
                transform: 'translate(-8px, -5px)'
            },
            right: {
                Extend: 'triangleBorder',
                transform: 'translate(20px, -14px) rotate(180deg)'
            },
            rightInside: {
                Extend: 'triangle',
                transform: 'translate(-8px, -5px)'
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.pointer
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.left
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.leftInside
    })), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.right
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.rightInside
    })));
};
var $1b9ce628483b48ad$export$2e2bcd8739ae039 = $1b9ce628483b48ad$export$123b96ff8455915;



var $8FY87 = parcelRequire("8FY87");

var $7ac7e14a02bac442$export$f7d38a0bd3b98717 = function PhotoshopButton(_ref) {
    var onClick = _ref.onClick, label = _ref.label, children = _ref.children, active = _ref.active;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))({
        'default': {
            button: {
                backgroundImage: 'linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)',
                border: '1px solid #878787',
                borderRadius: '2px',
                height: '20px',
                boxShadow: '0 1px 0 0 #EAEAEA',
                fontSize: '14px',
                color: '#000',
                lineHeight: '20px',
                textAlign: 'center',
                marginBottom: '10px',
                cursor: 'pointer'
            }
        },
        'active': {
            button: {
                boxShadow: '0 0 0 1px #878787'
            }
        }
    }, {
        active: active
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.button,
        onClick: onClick
    }, label || children);
};
var $7ac7e14a02bac442$export$2e2bcd8739ae039 = $7ac7e14a02bac442$export$f7d38a0bd3b98717;



var $8FY87 = parcelRequire("8FY87");

var $d9b372823ebcc198$export$ce0d7acd66f46f2b = function PhotoshopPreviews(_ref) {
    var rgb = _ref.rgb, currentColor = _ref.currentColor;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))({
        'default': {
            swatches: {
                border: '1px solid #B3B3B3',
                borderBottom: '1px solid #F0F0F0',
                marginBottom: '2px',
                marginTop: '1px'
            },
            new: {
                height: '34px',
                background: 'rgb(' + rgb.r + ',' + rgb.g + ', ' + rgb.b + ')',
                boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000'
            },
            current: {
                height: '34px',
                background: currentColor,
                boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000'
            },
            label: {
                fontSize: '14px',
                color: '#000',
                textAlign: 'center'
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', null, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.label
    }, 'new'), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.swatches
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.new
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.current
    })), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.label
    }, 'current'));
};
var $d9b372823ebcc198$export$2e2bcd8739ae039 = $d9b372823ebcc198$export$ce0d7acd66f46f2b;


var $e4654023cfa88917$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $e4654023cfa88917$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e4654023cfa88917$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $e4654023cfa88917$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $e4654023cfa88917$export$4ed116dea8ad5956 = function(_React$Component) {
    $e4654023cfa88917$var$_inherits(Photoshop, _React$Component);
    function Photoshop(props) {
        $e4654023cfa88917$var$_classCallCheck(this, Photoshop);
        var _this = $e4654023cfa88917$var$_possibleConstructorReturn(this, (Photoshop.__proto__ || Object.getPrototypeOf(Photoshop)).call(this));
        _this.state = {
            currentColor: props.hex
        };
        return _this;
    }
    $e4654023cfa88917$var$_createClass(Photoshop, [
        {
            key: 'render',
            value: function render() {
                var _props = this.props, _props$styles = _props.styles, passedStyles = _props$styles === undefined ? {} : _props$styles, _props$className = _props.className, className = _props$className === undefined ? '' : _props$className;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))((0, $4dea300bb9269819$export$2e2bcd8739ae039)({
                    'default': {
                        picker: {
                            background: '#DCDCDC',
                            borderRadius: '4px',
                            boxShadow: '0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)',
                            boxSizing: 'initial',
                            width: '513px'
                        },
                        head: {
                            backgroundImage: 'linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)',
                            borderBottom: '1px solid #B1B1B1',
                            boxShadow: 'inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)',
                            height: '23px',
                            lineHeight: '24px',
                            borderRadius: '4px 4px 0 0',
                            fontSize: '13px',
                            color: '#4D4D4D',
                            textAlign: 'center'
                        },
                        body: {
                            padding: '15px 15px 0',
                            display: 'flex'
                        },
                        saturation: {
                            width: '256px',
                            height: '256px',
                            position: 'relative',
                            border: '2px solid #B3B3B3',
                            borderBottom: '2px solid #F0F0F0',
                            overflow: 'hidden'
                        },
                        hue: {
                            position: 'relative',
                            height: '256px',
                            width: '19px',
                            marginLeft: '10px',
                            border: '2px solid #B3B3B3',
                            borderBottom: '2px solid #F0F0F0'
                        },
                        controls: {
                            width: '180px',
                            marginLeft: '10px'
                        },
                        top: {
                            display: 'flex'
                        },
                        previews: {
                            width: '60px'
                        },
                        actions: {
                            flex: '1',
                            marginLeft: '20px'
                        }
                    }
                }, passedStyles));
                return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.picker,
                    className: 'photoshop-picker ' + className
                }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.head
                }, this.props.header), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.body,
                    className: 'flexbox-fix'
                }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.saturation
                }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $16928b06bc556b42$export$2e2bcd8739ae039), {
                    hsl: this.props.hsl,
                    hsv: this.props.hsv,
                    pointer: (0, $16a91ae2b44e33eb$export$2e2bcd8739ae039),
                    onChange: this.props.onChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.hue
                }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $54f2bbfcaac0993e$export$2e2bcd8739ae039), {
                    direction: 'vertical',
                    hsl: this.props.hsl,
                    pointer: (0, $1b9ce628483b48ad$export$2e2bcd8739ae039),
                    onChange: this.props.onChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.controls
                }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.top,
                    className: 'flexbox-fix'
                }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.previews
                }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $d9b372823ebcc198$export$2e2bcd8739ae039), {
                    rgb: this.props.rgb,
                    currentColor: this.state.currentColor
                })), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
                    style: styles.actions
                }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $7ac7e14a02bac442$export$2e2bcd8739ae039), {
                    label: 'OK',
                    onClick: this.props.onAccept,
                    active: true
                }), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $7ac7e14a02bac442$export$2e2bcd8739ae039), {
                    label: 'Cancel',
                    onClick: this.props.onCancel
                }), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $6485d3677cc4c0af$export$2e2bcd8739ae039), {
                    onChange: this.props.onChange,
                    rgb: this.props.rgb,
                    hsv: this.props.hsv,
                    hex: this.props.hex
                }))))));
            }
        }
    ]);
    return Photoshop;
}((0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).Component);
$e4654023cfa88917$export$4ed116dea8ad5956.propTypes = {
    header: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).string,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).object
};
$e4654023cfa88917$export$4ed116dea8ad5956.defaultProps = {
    header: 'Color Picker',
    styles: {}
};
var $e4654023cfa88917$export$2e2bcd8739ae039 = (0, $b0ac51c924707ae7$export$2e2bcd8739ae039)($e4654023cfa88917$export$4ed116dea8ad5956);



var $8FY87 = parcelRequire("8FY87");

var $4VW2f = parcelRequire("4VW2f");



/* eslint-disable no-param-reassign */ 
var $8FY87 = parcelRequire("8FY87");



var $f2f8543a377469d4$export$a9bdb1170868e062 = function SketchFields(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hex = _ref.hex, disableAlpha = _ref.disableAlpha;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))({
        'default': {
            fields: {
                display: 'flex',
                paddingTop: '4px'
            },
            single: {
                flex: '1',
                paddingLeft: '6px'
            },
            alpha: {
                flex: '1',
                paddingLeft: '6px'
            },
            double: {
                flex: '2'
            },
            input: {
                width: '80%',
                padding: '4px 10% 3px',
                border: 'none',
                boxShadow: 'inset 0 0 0 1px #ccc',
                fontSize: '11px'
            },
            label: {
                display: 'block',
                textAlign: 'center',
                fontSize: '11px',
                color: '#222',
                paddingTop: '3px',
                paddingBottom: '4px',
                textTransform: 'capitalize'
            }
        },
        'disableAlpha': {
            alpha: {
                display: 'none'
            }
        }
    }, {
        disableAlpha: disableAlpha
    });
    var handleChange = function handleChange(data, e) {
        if (data.hex) $0484844d062f071f$export$944f75ec5697b362(data.hex) && onChange({
            hex: data.hex,
            source: 'hex'
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            a: rgb.a,
            source: 'rgb'
        }, e);
        else if (data.a) {
            if (data.a < 0) data.a = 0;
            else if (data.a > 100) data.a = 100;
            data.a /= 100;
            onChange({
                h: hsl.h,
                s: hsl.s,
                l: hsl.l,
                a: data.a,
                source: 'rgb'
            }, e);
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.fields,
        className: 'flexbox-fix'
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.double
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $5e4e3784fbcdba0a$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'hex',
        value: hex.replace('#', ''),
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $5e4e3784fbcdba0a$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'r',
        value: rgb.r,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
    })), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $5e4e3784fbcdba0a$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'g',
        value: rgb.g,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
    })), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $5e4e3784fbcdba0a$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'b',
        value: rgb.b,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
    })), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.alpha
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $5e4e3784fbcdba0a$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'a',
        value: Math.round(rgb.a * 100),
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '100'
    })));
};
var $f2f8543a377469d4$export$2e2bcd8739ae039 = $f2f8543a377469d4$export$a9bdb1170868e062;



var $8FY87 = parcelRequire("8FY87");

var $4VW2f = parcelRequire("4VW2f");


var $e763d3d16373e296$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $e763d3d16373e296$export$cc78acae6744db3b = function SketchPresetColors(_ref) {
    var colors = _ref.colors, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))({
        'default': {
            colors: {
                margin: '0 -10px',
                padding: '10px 0 0 10px',
                borderTop: '1px solid #eee',
                display: 'flex',
                flexWrap: 'wrap',
                position: 'relative'
            },
            swatchWrap: {
                width: '16px',
                height: '16px',
                margin: '0 10px 10px 0'
            },
            swatch: {
                borderRadius: '3px',
                boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15)'
            }
        },
        'no-presets': {
            colors: {
                display: 'none'
            }
        }
    }, {
        'no-presets': !colors || !colors.length
    });
    var handleClick = function handleClick(hex, e) {
        onClick({
            hex: hex,
            source: 'hex'
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.colors,
        className: 'flexbox-fix'
    }, colors.map(function(colorObjOrString) {
        var c = typeof colorObjOrString === 'string' ? {
            color: colorObjOrString
        } : colorObjOrString;
        var key = '' + c.color + (c.title || '');
        return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
            key: key,
            style: styles.swatchWrap
        }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $aab2657fe6a56e51$export$2e2bcd8739ae039), $e763d3d16373e296$var$_extends({}, c, {
            style: styles.swatch,
            onClick: handleClick,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px ' + c.color
            }
        })));
    }));
};
$e763d3d16373e296$export$cc78acae6744db3b.propTypes = {
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).shape({
            color: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).string,
            title: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).string
        })
    ])).isRequired
};
var $e763d3d16373e296$export$2e2bcd8739ae039 = $e763d3d16373e296$export$cc78acae6744db3b;


var $524fa9e6de024fac$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $524fa9e6de024fac$export$361fce2090be193f = function Sketch(_ref) {
    var width = _ref.width, rgb = _ref.rgb, hex = _ref.hex, hsv = _ref.hsv, hsl = _ref.hsl, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, disableAlpha = _ref.disableAlpha, presetColors = _ref.presetColors, renderers = _ref.renderers, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))((0, $4dea300bb9269819$export$2e2bcd8739ae039)({
        'default': $524fa9e6de024fac$var$_extends({
            picker: {
                width: width,
                padding: '10px 10px 0',
                boxSizing: 'initial',
                background: '#fff',
                borderRadius: '4px',
                boxShadow: '0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)'
            },
            saturation: {
                width: '100%',
                paddingBottom: '75%',
                position: 'relative',
                overflow: 'hidden'
            },
            Saturation: {
                radius: '3px',
                shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
            },
            controls: {
                display: 'flex'
            },
            sliders: {
                padding: '4px 0',
                flex: '1'
            },
            color: {
                width: '24px',
                height: '24px',
                position: 'relative',
                marginTop: '4px',
                marginLeft: '4px',
                borderRadius: '3px'
            },
            activeColor: {
                absolute: '0px 0px 0px 0px',
                borderRadius: '2px',
                background: 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')',
                boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
            },
            hue: {
                position: 'relative',
                height: '10px',
                overflow: 'hidden'
            },
            Hue: {
                radius: '2px',
                shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
            },
            alpha: {
                position: 'relative',
                height: '10px',
                marginTop: '4px',
                overflow: 'hidden'
            },
            Alpha: {
                radius: '2px',
                shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
            }
        }, passedStyles),
        'disableAlpha': {
            color: {
                height: '10px'
            },
            hue: {
                height: '10px'
            },
            alpha: {
                display: 'none'
            }
        }
    }, passedStyles), {
        disableAlpha: disableAlpha
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.picker,
        className: 'sketch-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.saturation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $16928b06bc556b42$export$2e2bcd8739ae039), {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.controls,
        className: 'flexbox-fix'
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.sliders
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.hue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $54f2bbfcaac0993e$export$2e2bcd8739ae039), {
        style: styles.Hue,
        hsl: hsl,
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.alpha
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $5f0e862746c8c551$export$2e2bcd8739ae039), {
        style: styles.Alpha,
        rgb: rgb,
        hsl: hsl,
        renderers: renderers,
        onChange: onChange
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.color
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $41a8f0ec8c9e9c24$export$2e2bcd8739ae039), null), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.activeColor
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $f2f8543a377469d4$export$2e2bcd8739ae039), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        onChange: onChange,
        disableAlpha: disableAlpha
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $e763d3d16373e296$export$2e2bcd8739ae039), {
        colors: presetColors,
        onClick: onChange,
        onSwatchHover: onSwatchHover
    }));
};
$524fa9e6de024fac$export$361fce2090be193f.propTypes = {
    disableAlpha: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).bool,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).number
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).object
};
$524fa9e6de024fac$export$361fce2090be193f.defaultProps = {
    disableAlpha: false,
    width: 200,
    styles: {},
    presetColors: [
        '#D0021B',
        '#F5A623',
        '#F8E71C',
        '#8B572A',
        '#7ED321',
        '#417505',
        '#BD10E0',
        '#9013FE',
        '#4A90E2',
        '#50E3C2',
        '#B8E986',
        '#000000',
        '#4A4A4A',
        '#9B9B9B',
        '#FFFFFF'
    ]
};
var $524fa9e6de024fac$export$2e2bcd8739ae039 = (0, $b0ac51c924707ae7$export$2e2bcd8739ae039)($524fa9e6de024fac$export$361fce2090be193f);



var $8FY87 = parcelRequire("8FY87");

var $4VW2f = parcelRequire("4VW2f");




var $8FY87 = parcelRequire("8FY87");


var $8FY87 = parcelRequire("8FY87");

var $866c8ca5ad393e8b$export$5c11afa672411de4 = function SliderSwatch(_ref) {
    var hsl = _ref.hsl, offset = _ref.offset, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, active = _ref.active, first = _ref.first, last = _ref.last;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))({
        'default': {
            swatch: {
                height: '12px',
                background: 'hsl(' + hsl.h + ', 50%, ' + offset * 100 + '%)',
                cursor: 'pointer'
            }
        },
        'first': {
            swatch: {
                borderRadius: '2px 0 0 2px'
            }
        },
        'last': {
            swatch: {
                borderRadius: '0 2px 2px 0'
            }
        },
        'active': {
            swatch: {
                transform: 'scaleY(1.8)',
                borderRadius: '3.6px/2px'
            }
        }
    }, {
        active: active,
        first: first,
        last: last
    });
    var handleClick = function handleClick(e) {
        return onClick({
            h: hsl.h,
            s: 0.5,
            l: offset,
            source: 'hsl'
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.swatch,
        onClick: handleClick
    });
};
var $866c8ca5ad393e8b$export$2e2bcd8739ae039 = $866c8ca5ad393e8b$export$5c11afa672411de4;


var $1328e84d4409c086$export$48f49e32c66cdd61 = function SliderSwatches(_ref) {
    var onClick = _ref.onClick, hsl = _ref.hsl;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))({
        'default': {
            swatches: {
                marginTop: '20px'
            },
            swatch: {
                boxSizing: 'border-box',
                width: '20%',
                paddingRight: '1px',
                float: 'left'
            },
            clear: {
                clear: 'both'
            }
        }
    });
    // Acceptible difference in floating point equality
    var epsilon = 0.1;
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.swatches
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $866c8ca5ad393e8b$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: '.80',
        active: Math.abs(hsl.l - 0.80) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        first: true
    })), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $866c8ca5ad393e8b$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: '.65',
        active: Math.abs(hsl.l - 0.65) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $866c8ca5ad393e8b$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: '.50',
        active: Math.abs(hsl.l - 0.50) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $866c8ca5ad393e8b$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: '.35',
        active: Math.abs(hsl.l - 0.35) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $866c8ca5ad393e8b$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: '.20',
        active: Math.abs(hsl.l - 0.20) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        last: true
    })), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.clear
    }));
};
var $1328e84d4409c086$export$2e2bcd8739ae039 = $1328e84d4409c086$export$48f49e32c66cdd61;



var $8FY87 = parcelRequire("8FY87");

var $0160e7995b7b1b6c$export$9c10b52c64965f67 = function SliderPointer() {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))({
        'default': {
            picker: {
                width: '14px',
                height: '14px',
                borderRadius: '6px',
                transform: 'translate(-7px, -1px)',
                backgroundColor: 'rgb(248, 248, 248)',
                boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.picker
    });
};
var $0160e7995b7b1b6c$export$2e2bcd8739ae039 = $0160e7995b7b1b6c$export$9c10b52c64965f67;


var $1d03a5bcb20156a7$export$472062a354075cee = function Slider(_ref) {
    var hsl = _ref.hsl, onChange = _ref.onChange, pointer = _ref.pointer, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))((0, $4dea300bb9269819$export$2e2bcd8739ae039)({
        'default': {
            hue: {
                height: '12px',
                position: 'relative'
            },
            Hue: {
                radius: '2px'
            }
        }
    }, passedStyles));
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.wrap || {},
        className: 'slider-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.hue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $54f2bbfcaac0993e$export$2e2bcd8739ae039), {
        style: styles.Hue,
        hsl: hsl,
        pointer: pointer,
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.swatches
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $1328e84d4409c086$export$2e2bcd8739ae039), {
        hsl: hsl,
        onClick: onChange
    })));
};
$1d03a5bcb20156a7$export$472062a354075cee.propTypes = {
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).object
};
$1d03a5bcb20156a7$export$472062a354075cee.defaultProps = {
    pointer: (0, $0160e7995b7b1b6c$export$2e2bcd8739ae039),
    styles: {}
};
var $1d03a5bcb20156a7$export$2e2bcd8739ae039 = (0, $b0ac51c924707ae7$export$2e2bcd8739ae039)($1d03a5bcb20156a7$export$472062a354075cee);



var $8FY87 = parcelRequire("8FY87");

var $4VW2f = parcelRequire("4VW2f");






var $8FY87 = parcelRequire("8FY87");



var $8FY87 = parcelRequire("8FY87");



var $26175cc4fd76e4e6$exports = {};
'use strict';
Object.defineProperty($26175cc4fd76e4e6$exports, "__esModule", {
    value: true
});
var $26175cc4fd76e4e6$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $8FY87 = parcelRequire("8FY87");
var $26175cc4fd76e4e6$var$_react2 = $26175cc4fd76e4e6$var$_interopRequireDefault($8FY87);
function $26175cc4fd76e4e6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $26175cc4fd76e4e6$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var $26175cc4fd76e4e6$var$DEFAULT_SIZE = 24;
$26175cc4fd76e4e6$exports.default = function(_ref) {
    var _ref$fill = _ref.fill, fill = _ref$fill === undefined ? 'currentColor' : _ref$fill, _ref$width = _ref.width, width = _ref$width === undefined ? $26175cc4fd76e4e6$var$DEFAULT_SIZE : _ref$width, _ref$height = _ref.height, height = _ref$height === undefined ? $26175cc4fd76e4e6$var$DEFAULT_SIZE : _ref$height, _ref$style = _ref.style, style = _ref$style === undefined ? {} : _ref$style, props = $26175cc4fd76e4e6$var$_objectWithoutProperties(_ref, [
        'fill',
        'width',
        'height',
        'style'
    ]);
    return $26175cc4fd76e4e6$var$_react2.default.createElement('svg', $26175cc4fd76e4e6$var$_extends({
        viewBox: '0 0 ' + $26175cc4fd76e4e6$var$DEFAULT_SIZE + ' ' + $26175cc4fd76e4e6$var$DEFAULT_SIZE,
        style: $26175cc4fd76e4e6$var$_extends({
            fill: fill,
            width: width,
            height: height
        }, style)
    }, props), $26175cc4fd76e4e6$var$_react2.default.createElement('path', {
        d: 'M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z'
    }));
};


var $8120254c366ff0b5$export$af5303fde6798b43 = function SwatchesColor(_ref) {
    var color = _ref.color, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover, first = _ref.first, last = _ref.last, active = _ref.active;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))({
        'default': {
            color: {
                width: '40px',
                height: '24px',
                cursor: 'pointer',
                background: color,
                marginBottom: '1px'
            },
            check: {
                color: $0484844d062f071f$export$3609eb1d7e55dec(color),
                marginLeft: '8px',
                display: 'none'
            }
        },
        'first': {
            color: {
                overflow: 'hidden',
                borderRadius: '2px 2px 0 0'
            }
        },
        'last': {
            color: {
                overflow: 'hidden',
                borderRadius: '0 0 2px 2px'
            }
        },
        'active': {
            check: {
                display: 'block'
            }
        },
        'color-#FFFFFF': {
            color: {
                boxShadow: 'inset 0 0 0 1px #ddd'
            },
            check: {
                color: '#333'
            }
        },
        'transparent': {
            check: {
                color: '#333'
            }
        }
    }, {
        first: first,
        last: last,
        active: active,
        'color-#FFFFFF': color === '#FFFFFF',
        'transparent': color === 'transparent'
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $aab2657fe6a56e51$export$2e2bcd8739ae039), {
        color: color,
        style: styles.color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: '0 0 4px ' + color
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.check
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($26175cc4fd76e4e6$exports))), null)));
};
var $8120254c366ff0b5$export$2e2bcd8739ae039 = $8120254c366ff0b5$export$af5303fde6798b43;


var $0e16c464cc6369b1$export$354a0399ec1ad469 = function SwatchesGroup(_ref) {
    var onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover, group = _ref.group, active = _ref.active;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))({
        'default': {
            group: {
                paddingBottom: '10px',
                width: '40px',
                float: 'left',
                marginRight: '10px'
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.group
    }, (0, $2d9216e96febe2b9$export$2e2bcd8739ae039)(group, function(color, i) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $8120254c366ff0b5$export$2e2bcd8739ae039), {
            key: color,
            color: color,
            active: color.toLowerCase() === active,
            first: i === 0,
            last: i === group.length - 1,
            onClick: onClick,
            onSwatchHover: onSwatchHover
        });
    }));
};
var $0e16c464cc6369b1$export$2e2bcd8739ae039 = $0e16c464cc6369b1$export$354a0399ec1ad469;


var $dbba7fcc6e12ef03$export$81ebbfd13e06b049 = function Swatches(_ref) {
    var width = _ref.width, height = _ref.height, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))((0, $4dea300bb9269819$export$2e2bcd8739ae039)({
        'default': {
            picker: {
                width: width,
                height: height
            },
            overflow: {
                height: height,
                overflowY: 'scroll'
            },
            body: {
                padding: '16px 0 6px 16px'
            },
            clear: {
                clear: 'both'
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        return onChange({
            hex: data,
            source: 'hex'
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.picker,
        className: 'swatches-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $53ba7047d513ec75$export$2e2bcd8739ae039), null, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.overflow
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.body
    }, (0, $2d9216e96febe2b9$export$2e2bcd8739ae039)(colors, function(group) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $0e16c464cc6369b1$export$2e2bcd8739ae039), {
            key: group.toString(),
            group: group,
            active: hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.clear
    })))));
};
$dbba7fcc6e12ef03$export$81ebbfd13e06b049.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).number
    ]),
    height: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).number
    ]),
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).string)),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).object
};
$dbba7fcc6e12ef03$export$81ebbfd13e06b049.defaultProps = {
    width: 320,
    height: 240,
    colors: [
        [
            $7579141b3dc4090f$export$a90204d1394caf30['900'],
            $7579141b3dc4090f$export$a90204d1394caf30['700'],
            $7579141b3dc4090f$export$a90204d1394caf30['500'],
            $7579141b3dc4090f$export$a90204d1394caf30['300'],
            $7579141b3dc4090f$export$a90204d1394caf30['100']
        ],
        [
            $7579141b3dc4090f$export$47853bc718611763['900'],
            $7579141b3dc4090f$export$47853bc718611763['700'],
            $7579141b3dc4090f$export$47853bc718611763['500'],
            $7579141b3dc4090f$export$47853bc718611763['300'],
            $7579141b3dc4090f$export$47853bc718611763['100']
        ],
        [
            $7579141b3dc4090f$export$e13cce2a2d16a9d4['900'],
            $7579141b3dc4090f$export$e13cce2a2d16a9d4['700'],
            $7579141b3dc4090f$export$e13cce2a2d16a9d4['500'],
            $7579141b3dc4090f$export$e13cce2a2d16a9d4['300'],
            $7579141b3dc4090f$export$e13cce2a2d16a9d4['100']
        ],
        [
            $7579141b3dc4090f$export$51ef95b19086af57['900'],
            $7579141b3dc4090f$export$51ef95b19086af57['700'],
            $7579141b3dc4090f$export$51ef95b19086af57['500'],
            $7579141b3dc4090f$export$51ef95b19086af57['300'],
            $7579141b3dc4090f$export$51ef95b19086af57['100']
        ],
        [
            $7579141b3dc4090f$export$3e6ccc7b8562d453['900'],
            $7579141b3dc4090f$export$3e6ccc7b8562d453['700'],
            $7579141b3dc4090f$export$3e6ccc7b8562d453['500'],
            $7579141b3dc4090f$export$3e6ccc7b8562d453['300'],
            $7579141b3dc4090f$export$3e6ccc7b8562d453['100']
        ],
        [
            $7579141b3dc4090f$export$2aa0182783e7e9de['900'],
            $7579141b3dc4090f$export$2aa0182783e7e9de['700'],
            $7579141b3dc4090f$export$2aa0182783e7e9de['500'],
            $7579141b3dc4090f$export$2aa0182783e7e9de['300'],
            $7579141b3dc4090f$export$2aa0182783e7e9de['100']
        ],
        [
            $7579141b3dc4090f$export$7b0d29b70b435c21['900'],
            $7579141b3dc4090f$export$7b0d29b70b435c21['700'],
            $7579141b3dc4090f$export$7b0d29b70b435c21['500'],
            $7579141b3dc4090f$export$7b0d29b70b435c21['300'],
            $7579141b3dc4090f$export$7b0d29b70b435c21['100']
        ],
        [
            $7579141b3dc4090f$export$7474046f446842ee['900'],
            $7579141b3dc4090f$export$7474046f446842ee['700'],
            $7579141b3dc4090f$export$7474046f446842ee['500'],
            $7579141b3dc4090f$export$7474046f446842ee['300'],
            $7579141b3dc4090f$export$7474046f446842ee['100']
        ],
        [
            $7579141b3dc4090f$export$8bf7dff220b82b4a['900'],
            $7579141b3dc4090f$export$8bf7dff220b82b4a['700'],
            $7579141b3dc4090f$export$8bf7dff220b82b4a['500'],
            $7579141b3dc4090f$export$8bf7dff220b82b4a['300'],
            $7579141b3dc4090f$export$8bf7dff220b82b4a['100']
        ],
        [
            '#194D33',
            $7579141b3dc4090f$export$955a2ebd2fb142ae['700'],
            $7579141b3dc4090f$export$955a2ebd2fb142ae['500'],
            $7579141b3dc4090f$export$955a2ebd2fb142ae['300'],
            $7579141b3dc4090f$export$955a2ebd2fb142ae['100']
        ],
        [
            $7579141b3dc4090f$export$559a8c00376dc936['900'],
            $7579141b3dc4090f$export$559a8c00376dc936['700'],
            $7579141b3dc4090f$export$559a8c00376dc936['500'],
            $7579141b3dc4090f$export$559a8c00376dc936['300'],
            $7579141b3dc4090f$export$559a8c00376dc936['100']
        ],
        [
            $7579141b3dc4090f$export$221d31baf2636aad['900'],
            $7579141b3dc4090f$export$221d31baf2636aad['700'],
            $7579141b3dc4090f$export$221d31baf2636aad['500'],
            $7579141b3dc4090f$export$221d31baf2636aad['300'],
            $7579141b3dc4090f$export$221d31baf2636aad['100']
        ],
        [
            $7579141b3dc4090f$export$594c5a8758200c32['900'],
            $7579141b3dc4090f$export$594c5a8758200c32['700'],
            $7579141b3dc4090f$export$594c5a8758200c32['500'],
            $7579141b3dc4090f$export$594c5a8758200c32['300'],
            $7579141b3dc4090f$export$594c5a8758200c32['100']
        ],
        [
            $7579141b3dc4090f$export$7c1ecc66643fdbd6['900'],
            $7579141b3dc4090f$export$7c1ecc66643fdbd6['700'],
            $7579141b3dc4090f$export$7c1ecc66643fdbd6['500'],
            $7579141b3dc4090f$export$7c1ecc66643fdbd6['300'],
            $7579141b3dc4090f$export$7c1ecc66643fdbd6['100']
        ],
        [
            $7579141b3dc4090f$export$ad766f34ace1cafd['900'],
            $7579141b3dc4090f$export$ad766f34ace1cafd['700'],
            $7579141b3dc4090f$export$ad766f34ace1cafd['500'],
            $7579141b3dc4090f$export$ad766f34ace1cafd['300'],
            $7579141b3dc4090f$export$ad766f34ace1cafd['100']
        ],
        [
            $7579141b3dc4090f$export$1ceed3dd9ec11704['900'],
            $7579141b3dc4090f$export$1ceed3dd9ec11704['700'],
            $7579141b3dc4090f$export$1ceed3dd9ec11704['500'],
            $7579141b3dc4090f$export$1ceed3dd9ec11704['300'],
            $7579141b3dc4090f$export$1ceed3dd9ec11704['100']
        ],
        [
            $7579141b3dc4090f$export$b6e6178d3f565007['900'],
            $7579141b3dc4090f$export$b6e6178d3f565007['700'],
            $7579141b3dc4090f$export$b6e6178d3f565007['500'],
            $7579141b3dc4090f$export$b6e6178d3f565007['300'],
            $7579141b3dc4090f$export$b6e6178d3f565007['100']
        ],
        [
            $7579141b3dc4090f$export$7c2da42d08c019c9['900'],
            $7579141b3dc4090f$export$7c2da42d08c019c9['700'],
            $7579141b3dc4090f$export$7c2da42d08c019c9['500'],
            $7579141b3dc4090f$export$7c2da42d08c019c9['300'],
            $7579141b3dc4090f$export$7c2da42d08c019c9['100']
        ],
        [
            '#000000',
            '#525252',
            '#969696',
            '#D9D9D9',
            '#FFFFFF'
        ]
    ],
    styles: {}
};
var $dbba7fcc6e12ef03$export$2e2bcd8739ae039 = (0, $b0ac51c924707ae7$export$2e2bcd8739ae039)($dbba7fcc6e12ef03$export$81ebbfd13e06b049);



var $8FY87 = parcelRequire("8FY87");

var $4VW2f = parcelRequire("4VW2f");





var $815c871a089e12da$export$9e389cdad32a5b7a = function Twitter(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, hex = _ref.hex, colors = _ref.colors, width = _ref.width, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))((0, $4dea300bb9269819$export$2e2bcd8739ae039)({
        'default': {
            card: {
                width: width,
                background: '#fff',
                border: '0 solid rgba(0,0,0,0.25)',
                boxShadow: '0 1px 4px rgba(0,0,0,0.25)',
                borderRadius: '4px',
                position: 'relative'
            },
            body: {
                padding: '15px 9px 9px 15px'
            },
            label: {
                fontSize: '18px',
                color: '#fff'
            },
            triangle: {
                width: '0px',
                height: '0px',
                borderStyle: 'solid',
                borderWidth: '0 9px 10px 9px',
                borderColor: 'transparent transparent #fff transparent',
                position: 'absolute'
            },
            triangleShadow: {
                width: '0px',
                height: '0px',
                borderStyle: 'solid',
                borderWidth: '0 9px 10px 9px',
                borderColor: 'transparent transparent rgba(0,0,0,.1) transparent',
                position: 'absolute'
            },
            hash: {
                background: '#F0F0F0',
                height: '30px',
                width: '30px',
                borderRadius: '4px 0 0 4px',
                float: 'left',
                color: '#98A1A4',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            },
            input: {
                width: '100px',
                fontSize: '14px',
                color: '#666',
                border: '0px',
                outline: 'none',
                height: '28px',
                boxShadow: 'inset 0 0 0 1px #F0F0F0',
                boxSizing: 'content-box',
                borderRadius: '0 4px 4px 0',
                float: 'left',
                paddingLeft: '8px'
            },
            swatch: {
                width: '30px',
                height: '30px',
                float: 'left',
                borderRadius: '4px',
                margin: '0 6px 6px 0'
            },
            clear: {
                clear: 'both'
            }
        },
        'hide-triangle': {
            triangle: {
                display: 'none'
            },
            triangleShadow: {
                display: 'none'
            }
        },
        'top-left-triangle': {
            triangle: {
                top: '-10px',
                left: '12px'
            },
            triangleShadow: {
                top: '-11px',
                left: '12px'
            }
        },
        'top-right-triangle': {
            triangle: {
                top: '-10px',
                right: '12px'
            },
            triangleShadow: {
                top: '-11px',
                right: '12px'
            }
        }
    }, passedStyles), {
        'hide-triangle': triangle === 'hide',
        'top-left-triangle': triangle === 'top-left',
        'top-right-triangle': triangle === 'top-right'
    });
    var handleChange = function handleChange(hexcode, e) {
        $0484844d062f071f$export$944f75ec5697b362(hexcode) && onChange({
            hex: hexcode,
            source: 'hex'
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.card,
        className: 'twitter-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.triangleShadow
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.triangle
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.body
    }, (0, $2d9216e96febe2b9$export$2e2bcd8739ae039)(colors, function(c, i) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $aab2657fe6a56e51$export$2e2bcd8739ae039), {
            key: i,
            color: c,
            hex: c,
            style: styles.swatch,
            onClick: handleChange,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: '0 0 4px ' + c
            }
        });
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.hash
    }, '#'), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $5e4e3784fbcdba0a$export$2e2bcd8739ae039), {
        label: null,
        style: {
            input: styles.input
        },
        value: hex.replace('#', ''),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.clear
    })));
};
$815c871a089e12da$export$9e389cdad32a5b7a.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).number
    ]),
    triangle: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).oneOf([
        'hide',
        'top-left',
        'top-right'
    ]),
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).string),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).object
};
$815c871a089e12da$export$9e389cdad32a5b7a.defaultProps = {
    width: 276,
    colors: [
        '#FF6900',
        '#FCB900',
        '#7BDCB5',
        '#00D084',
        '#8ED1FC',
        '#0693E3',
        '#ABB8C3',
        '#EB144C',
        '#F78DA7',
        '#9900EF'
    ],
    triangle: 'top-left',
    styles: {}
};
var $815c871a089e12da$export$2e2bcd8739ae039 = (0, $b0ac51c924707ae7$export$2e2bcd8739ae039)($815c871a089e12da$export$9e389cdad32a5b7a);



var $8FY87 = parcelRequire("8FY87");

var $4VW2f = parcelRequire("4VW2f");




var $8FY87 = parcelRequire("8FY87");


var $4VW2f = parcelRequire("4VW2f");
var $37a508a9e8dc768d$export$a928e0fe8b70765d = function GooglePointerCircle(props) {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))({
        'default': {
            picker: {
                width: '20px',
                height: '20px',
                borderRadius: '22px',
                border: '2px #fff solid',
                transform: 'translate(-12px, -13px)',
                background: 'hsl(' + Math.round(props.hsl.h) + ', ' + Math.round(props.hsl.s * 100) + '%, ' + Math.round(props.hsl.l * 100) + '%)'
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.picker
    });
};
$37a508a9e8dc768d$export$a928e0fe8b70765d.propTypes = {
    hsl: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).shape({
        h: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).number,
        s: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).number,
        l: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).number,
        a: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).number
    })
};
$37a508a9e8dc768d$export$a928e0fe8b70765d.defaultProps = {
    hsl: {
        a: 1,
        h: 249.94,
        l: 0.2,
        s: 0.50
    }
};
var $37a508a9e8dc768d$export$2e2bcd8739ae039 = $37a508a9e8dc768d$export$a928e0fe8b70765d;



var $8FY87 = parcelRequire("8FY87");


var $4VW2f = parcelRequire("4VW2f");
var $b4e4809da81c3c85$export$9de61b9626feed9a = function GooglePointer(props) {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))({
        'default': {
            picker: {
                width: '20px',
                height: '20px',
                borderRadius: '22px',
                transform: 'translate(-10px, -7px)',
                background: 'hsl(' + Math.round(props.hsl.h) + ', 100%, 50%)',
                border: '2px white solid'
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.picker
    });
};
$b4e4809da81c3c85$export$9de61b9626feed9a.propTypes = {
    hsl: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).shape({
        h: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).number,
        s: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).number,
        l: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).number,
        a: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).number
    })
};
$b4e4809da81c3c85$export$9de61b9626feed9a.defaultProps = {
    hsl: {
        a: 1,
        h: 249.94,
        l: 0.2,
        s: 0.50
    }
};
var $b4e4809da81c3c85$export$2e2bcd8739ae039 = $b4e4809da81c3c85$export$9de61b9626feed9a;



var $8FY87 = parcelRequire("8FY87");



var $88f1245629e3b36e$export$e50902ed332e5599 = function GoogleFields(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hex = _ref.hex, hsv = _ref.hsv;
    var handleChange = function handleChange(data, e) {
        if (data.hex) $0484844d062f071f$export$944f75ec5697b362(data.hex) && onChange({
            hex: data.hex,
            source: 'hex'
        }, e);
        else if (data.rgb) {
            var values = data.rgb.split(',');
            $0484844d062f071f$export$e76ec4c5b3cadd73(data.rgb, 'rgb') && onChange({
                r: values[0],
                g: values[1],
                b: values[2],
                a: 1,
                source: 'rgb'
            }, e);
        } else if (data.hsv) {
            var _values = data.hsv.split(',');
            if ($0484844d062f071f$export$e76ec4c5b3cadd73(data.hsv, 'hsv')) {
                _values[2] = _values[2].replace('%', '');
                _values[1] = _values[1].replace('%', '');
                _values[0] = _values[0].replace("\xb0", '');
                if (_values[1] == 1) _values[1] = 0.01;
                else if (_values[2] == 1) _values[2] = 0.01;
                onChange({
                    h: Number(_values[0]),
                    s: Number(_values[1]),
                    v: Number(_values[2]),
                    source: 'hsv'
                }, e);
            }
        } else if (data.hsl) {
            var _values2 = data.hsl.split(',');
            if ($0484844d062f071f$export$e76ec4c5b3cadd73(data.hsl, 'hsl')) {
                _values2[2] = _values2[2].replace('%', '');
                _values2[1] = _values2[1].replace('%', '');
                _values2[0] = _values2[0].replace("\xb0", '');
                if (hsvValue[1] == 1) hsvValue[1] = 0.01;
                else if (hsvValue[2] == 1) hsvValue[2] = 0.01;
                onChange({
                    h: Number(_values2[0]),
                    s: Number(_values2[1]),
                    v: Number(_values2[2]),
                    source: 'hsl'
                }, e);
            }
        }
    };
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))({
        'default': {
            wrap: {
                display: 'flex',
                height: '100px',
                marginTop: '4px'
            },
            fields: {
                width: '100%'
            },
            column: {
                paddingTop: '10px',
                display: 'flex',
                justifyContent: 'space-between'
            },
            double: {
                padding: '0px 4.4px',
                boxSizing: 'border-box'
            },
            input: {
                width: '100%',
                height: '38px',
                boxSizing: 'border-box',
                padding: '4px 10% 3px',
                textAlign: 'center',
                border: '1px solid #dadce0',
                fontSize: '11px',
                textTransform: 'lowercase',
                borderRadius: '5px',
                outline: 'none',
                fontFamily: 'Roboto,Arial,sans-serif'
            },
            input2: {
                height: '38px',
                width: '100%',
                border: '1px solid #dadce0',
                boxSizing: 'border-box',
                fontSize: '11px',
                textTransform: 'lowercase',
                borderRadius: '5px',
                outline: 'none',
                paddingLeft: '10px',
                fontFamily: 'Roboto,Arial,sans-serif'
            },
            label: {
                textAlign: 'center',
                fontSize: '12px',
                background: '#fff',
                position: 'absolute',
                textTransform: 'uppercase',
                color: '#3c4043',
                width: '35px',
                top: '-6px',
                left: '0',
                right: '0',
                marginLeft: 'auto',
                marginRight: 'auto',
                fontFamily: 'Roboto,Arial,sans-serif'
            },
            label2: {
                left: '10px',
                textAlign: 'center',
                fontSize: '12px',
                background: '#fff',
                position: 'absolute',
                textTransform: 'uppercase',
                color: '#3c4043',
                width: '32px',
                top: '-6px',
                fontFamily: 'Roboto,Arial,sans-serif'
            },
            single: {
                flexGrow: '1',
                margin: '0px 4.4px'
            }
        }
    });
    var rgbValue = rgb.r + ', ' + rgb.g + ', ' + rgb.b;
    var hslValue = Math.round(hsl.h) + '\xB0, ' + Math.round(hsl.s * 100) + '%, ' + Math.round(hsl.l * 100) + '%';
    var hsvValue = Math.round(hsv.h) + '\xB0, ' + Math.round(hsv.s * 100) + '%, ' + Math.round(hsv.v * 100) + '%';
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.wrap,
        className: 'flexbox-fix'
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.fields
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.double
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $5e4e3784fbcdba0a$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'hex',
        value: hex,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.column
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $5e4e3784fbcdba0a$export$2e2bcd8739ae039), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: 'rgb',
        value: rgbValue,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $5e4e3784fbcdba0a$export$2e2bcd8739ae039), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: 'hsv',
        value: hsvValue,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $5e4e3784fbcdba0a$export$2e2bcd8739ae039), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: 'hsl',
        value: hslValue,
        onChange: handleChange
    })))));
};
var $88f1245629e3b36e$export$2e2bcd8739ae039 = $88f1245629e3b36e$export$e50902ed332e5599;


var $937699d84ed19a87$export$347eee6e8bf67997 = function Google(_ref) {
    var width = _ref.width, onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hsv = _ref.hsv, hex = _ref.hex, header = _ref.header, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bb2c8b52dc31f705$exports)))((0, $4dea300bb9269819$export$2e2bcd8739ae039)({
        'default': {
            picker: {
                width: width,
                background: '#fff',
                border: '1px solid #dfe1e5',
                boxSizing: 'initial',
                display: 'flex',
                flexWrap: 'wrap',
                borderRadius: '8px 8px 0px 0px'
            },
            head: {
                height: '57px',
                width: '100%',
                paddingTop: '16px',
                paddingBottom: '16px',
                paddingLeft: '16px',
                fontSize: '20px',
                boxSizing: 'border-box',
                fontFamily: 'Roboto-Regular,HelveticaNeue,Arial,sans-serif'
            },
            saturation: {
                width: '70%',
                padding: '0px',
                position: 'relative',
                overflow: 'hidden'
            },
            swatch: {
                width: '30%',
                height: '228px',
                padding: '0px',
                background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', 1)',
                position: 'relative',
                overflow: 'hidden'
            },
            body: {
                margin: 'auto',
                width: '95%'
            },
            controls: {
                display: 'flex',
                boxSizing: 'border-box',
                height: '52px',
                paddingTop: '22px'
            },
            color: {
                width: '32px'
            },
            hue: {
                height: '8px',
                position: 'relative',
                margin: '0px 16px 0px 16px',
                width: '100%'
            },
            Hue: {
                radius: '2px'
            }
        }
    }, passedStyles));
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.picker,
        className: 'google-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.head
    }, header), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.swatch
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.saturation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $16928b06bc556b42$export$2e2bcd8739ae039), {
        hsl: hsl,
        hsv: hsv,
        pointer: (0, $37a508a9e8dc768d$export$2e2bcd8739ae039),
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.body
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.controls,
        className: 'flexbox-fix'
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement('div', {
        style: styles.hue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $54f2bbfcaac0993e$export$2e2bcd8739ae039), {
        style: styles.Hue,
        hsl: hsl,
        radius: '4px',
        pointer: (0, $b4e4809da81c3c85$export$2e2bcd8739ae039),
        onChange: onChange
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $88f1245629e3b36e$export$2e2bcd8739ae039), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        hsv: hsv,
        onChange: onChange
    })));
};
$937699d84ed19a87$export$347eee6e8bf67997.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).number
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).object,
    header: (0, (/*@__PURE__*/$parcel$interopDefault($4VW2f))).string
};
$937699d84ed19a87$export$347eee6e8bf67997.defaultProps = {
    width: 652,
    styles: {},
    header: 'Color picker'
};
var $937699d84ed19a87$export$2e2bcd8739ae039 = (0, $b0ac51c924707ae7$export$2e2bcd8739ae039)($937699d84ed19a87$export$347eee6e8bf67997);





var $c050405cbed75a4c$exports = {};
"use strict";
"use client";

var $bcBLN = parcelRequire("bcBLN");
Object.defineProperty($c050405cbed75a4c$exports, "__esModule", {
    value: true
});
$c050405cbed75a4c$exports.default = void 0;

var $c050405cbed75a4c$var$_createSvgIcon = $bcBLN((parcelRequire("485sq")));

var $2PPWI = parcelRequire("2PPWI");
var $c050405cbed75a4c$var$_default = $c050405cbed75a4c$exports.default = (0, $c050405cbed75a4c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2PPWI.jsx)("path", {
    d: "M16.56 8.94 7.62 0 6.21 1.41l2.38 2.38-5.15 5.15c-.59.59-.59 1.54 0 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12M5.21 10 10 5.21 14.79 10zM19 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5M2 20h20v4H2z"
}), 'FormatColorFillOutlined');


var $f6547254d7848109$exports = {};
"use strict";
"use client";

var $bcBLN = parcelRequire("bcBLN");
Object.defineProperty($f6547254d7848109$exports, "__esModule", {
    value: true
});
$f6547254d7848109$exports.default = void 0;

var $f6547254d7848109$var$_createSvgIcon = $bcBLN((parcelRequire("485sq")));

var $2PPWI = parcelRequire("2PPWI");
var $f6547254d7848109$var$_default = $f6547254d7848109$exports.default = (0, $f6547254d7848109$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2PPWI.jsx)("path", {
    d: "M2 20h20v4H2zm3.49-3h2.42l1.27-3.58h5.65L16.09 17h2.42L13.25 3h-2.5zm4.42-5.61 2.03-5.79h.12l2.03 5.79z"
}), 'FormatColorTextOutlined');



const $1a96556205575969$var$ConfigWidgets = (props)=>{
    const [backgroudColor, setBackgroundColor] = $8FY87.useState({
        displayColorPicker: false,
        color: props.cookies.cookieBackgroundColor
    });
    const [fontColor, setFontColor] = $8FY87.useState({
        displayColorPicker: false,
        color: props.cookies.cookieFontColor
    });
    return /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col text-black h-screen left-sidebar-widgets"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col"
    }, /*#__PURE__*/ $8FY87.createElement("span", {
        className: "text-base-2 mb-2"
    }, "Cookie consent banner", /*#__PURE__*/ $8FY87.createElement((0, $59115e424f862012$export$2e2bcd8739ae039), {
        checked: props.cookies.cookieBannerVisible,
        onChange: (e)=>{
            props.onDataChange({
                cookies: {
                    ...props.cookies,
                    cookieBannerVisible: e.target.checked
                }
            });
        }
    })), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "font-normal mb-2"
    }, "This will add a cookie policy widget on each page."), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col mt-3 text-sm font-normal relative"
    }, /*#__PURE__*/ $8FY87.createElement("span", null, "Message"), /*#__PURE__*/ $8FY87.createElement("input", {
        className: "w-96 border rounded border-catelina-blue/60 py-1 px-2",
        placeholder: "We use cookies to improve your experience on our site.  ",
        value: props.cookies.cookieText,
        onChange: (e)=>{
            props.onDataChange({
                cookies: {
                    ...props.cookies,
                    cookieText: (0, $df5cb81582703dc6$export$2e2bcd8739ae039)(e.target.value)
                }
            });
        }
    })), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-col mt-3 text-sm font-normal"
    }, /*#__PURE__*/ $8FY87.createElement("span", null, "Button title"), /*#__PURE__*/ $8FY87.createElement("input", {
        className: "w-96 border rounded border-catelina-blue/60 py-1 px-2",
        placeholder: "Okay",
        value: props.cookies.cookieButtonText,
        onChange: (e)=>{
            props.onDataChange({
                cookies: {
                    ...props.cookies,
                    cookieButtonText: (0, $df5cb81582703dc6$export$2e2bcd8739ae039)(e.target.value)
                }
            });
        }
    })), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-row mt-6 text-sm font-normal items-center w-96 justify-between relative"
    }, /*#__PURE__*/ $8FY87.createElement("div", null, /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($c050405cbed75a4c$exports))), null), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "mx-2"
    }, "Background color")), /*#__PURE__*/ $8FY87.createElement("div", {
        style: {
            backgroundColor: `rgba(${backgroudColor.color.r}, ${backgroudColor.color.g}, ${backgroudColor.color.b}, ${backgroudColor.color.a})`
        },
        className: `h-8 w-8 rounded border`,
        onClick: ()=>{
            setBackgroundColor((old)=>{
                return {
                    ...old,
                    displayColorPicker: !old.displayColorPicker
                };
            });
        }
    }), backgroudColor.displayColorPicker ? /*#__PURE__*/ $8FY87.createElement("div", {
        className: "absolute z-10 inset-x-60 inset-y-0"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "fixed inset-0",
        onClick: ()=>{
            setBackgroundColor((old)=>{
                return {
                    ...old,
                    displayColorPicker: false
                };
            });
        }
    }), /*#__PURE__*/ $8FY87.createElement((0, $524fa9e6de024fac$export$2e2bcd8739ae039), {
        color: backgroudColor.color,
        onChange: (color)=>{
            setBackgroundColor((old)=>{
                return {
                    ...old,
                    color: color.rgb
                };
            });
            props.onDataChange({
                cookies: {
                    ...props.cookies,
                    cookieBackgroundColor: color.rgb
                }
            });
        }
    })) : null), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex flex-row mt-3 text-sm font-normal items-center w-96 justify-between relative"
    }, /*#__PURE__*/ $8FY87.createElement("div", null, /*#__PURE__*/ $8FY87.createElement((0, (/*@__PURE__*/$parcel$interopDefault($f6547254d7848109$exports))), null), /*#__PURE__*/ $8FY87.createElement("span", {
        className: "mx-2"
    }, "Font color")), /*#__PURE__*/ $8FY87.createElement("div", {
        style: {
            backgroundColor: `rgba(${fontColor.color.r}, ${fontColor.color.g}, ${fontColor.color.b}, ${fontColor.color.a})`
        },
        className: `h-8 w-8 rounded border`,
        onClick: ()=>{
            setFontColor((old)=>{
                return {
                    ...old,
                    displayColorPicker: !old.displayColorPicker
                };
            });
        }
    }), fontColor.displayColorPicker ? /*#__PURE__*/ $8FY87.createElement("div", {
        className: "absolute z-10 inset-x-60 inset-y-0"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "fixed inset-0",
        onClick: ()=>{
            setFontColor((old)=>{
                return {
                    ...old,
                    displayColorPicker: false
                };
            });
        }
    }), /*#__PURE__*/ $8FY87.createElement((0, $524fa9e6de024fac$export$2e2bcd8739ae039), {
        color: fontColor.color,
        onChange: (color)=>{
            setFontColor((old)=>{
                return {
                    ...old,
                    color: color.rgb
                };
            });
            props.onDataChange({
                cookies: {
                    ...props.cookies,
                    cookieFontColor: color.rgb
                }
            });
        }
    })) : null)));
};
var $1a96556205575969$export$2e2bcd8739ae039 = $1a96556205575969$var$ConfigWidgets;



const $2e98481ba6198bc2$export$bae4861c03af8b17 = (props)=>{
    const [cookies] = (0, $1f373de1ceea6eb7$export$2e2bcd8739ae039)([
        "rp_user_data"
    ]);
    const navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    const { enqueueSnackbar: enqueueSnackbar } = (0, $5e19452f9528802f$export$1c97ac2c9a6e7c09)();
    const [searchParams, setSearchParams] = (0, $734169eef5d6795a$export$f1a78c17382fe22a)();
    const [saveDisabled, setSaveDisabled] = (0, $8FY87.useState)();
    const updateQueryParam = (key, value)=>{
        const params = new URLSearchParams(searchParams);
        params.set(key, value);
        setSearchParams(params);
    };
    const getQueryParam = (key)=>{
        return searchParams.get(key);
    };
    const handleUpdateQueryParam = (section)=>{
        updateQueryParam("section", section);
    };
    const colorPalletKeys = (0, (/*@__PURE__*/$parcel$interopDefault($52ca409747836a2e$exports)))();
    const { id: id } = (0, $d5fb2d3e42b0c581$export$99eaa27ddbbb95ef)();
    const location = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)();
    const [selectedDomainTab, setSelectedDomainTab] = (0, $8FY87.useState)("subdomain");
    const [isLoading, setIsLoading] = (0, $8FY87.useState)(false);
    const [isCheckingSSL, setIsCheckingSSL] = (0, $8FY87.useState)(false);
    const [siteData, setSiteData] = (0, $8FY87.useState)({});
    const [allTemplateColors, setAllTemplateColors] = (0, $8FY87.useState)([]);
    const [formData, setFormData] = (0, $8FY87.useState)({
        siteId: id,
        siteName: "",
        faviconImage: "",
        defaultSocialMediaImage: "",
        defaultSocialMediaDescription: "",
        defaultSocialMediaImageAlt: "",
        subDomain: "",
        head_customHtmlCode: "",
        body_customHtmlCode: "",
        primaryLanguage: "en",
        redirects: [],
        subDomainErrorMessage: "",
        cookies: {
            cookieBannerVisible: false,
            cookieText: "",
            cookieButtonText: "",
            cookieBackgroundColor: {
                r: "24",
                g: "160",
                b: "251",
                a: "100"
            },
            cookieFontColor: {
                r: "0",
                g: "0",
                b: "0",
                a: "100"
            }
        },
        siteOwnerUserId: "",
        addOnUsers: [],
        currButtonConfig: [],
        isPublished: false,
        templateColorPalettes: [],
        templateCategories: [],
        templateName: "",
        isTemplate: "false",
        isAITemplate: "false",
        siteUrl: ""
    });
    const stateData = location.state;
    const [templateSiteCategories, setTemplateSiteCategories] = (0, $8FY87.useState)([]);
    const [siteCategory, setSiteCategory] = (0, $8FY87.useState)([
        "General",
        "Domain",
        "Custom Code",
        "SEO",
        // "Widgets",
        // "Contributors",
        "Contact Form"
    ]);
    const onFormDataChange = (data)=>{
        // console.log("onFormDataChange", data);
        setFormData((old)=>{
            return {
                ...old,
                ...data
            };
        });
    };
    const objectWithoutKey = (object, key)=>{
        const { [key]: deletedKey, ...otherKeys } = object;
        return otherKeys;
    };
    const deepCompare = (arg1, arg2)=>{
        if (Object.prototype.toString.call(arg1) === Object.prototype.toString.call(arg2)) {
            if (Object.prototype.toString.call(arg1) === "[object Object]" || Object.prototype.toString.call(arg1) === "[object Array]") {
                if (Object.keys(arg1).length !== Object.keys(arg2).length) return false;
                return Object.keys(arg1).every(function(key) {
                    return deepCompare(arg1[key], arg2[key]);
                });
            }
            return arg1 === arg2;
        }
        return false;
    };
    function findDuplicates(array) {
        const seen = {};
        const duplicates = [];
        array.forEach((item)=>{
            const itemString = JSON.stringify(item);
            if (seen[itemString]) {
                if (seen[itemString] === 1) duplicates.push(item);
                seen[itemString]++;
            } else seen[itemString] = 1;
        });
        return duplicates;
    }
    const onSave = async ()=>{
        //validation for templates
        if (formData.templateColorPalettes) {
            let _dup = findDuplicates(formData.templateColorPalettes?.map((ol)=>ol.id));
            let _emptyImage = formData.templateColorPalettes.filter((kl)=>kl.imageUrl.length === 0);
            if (_dup.length > 0 || _emptyImage.length > 0) {
                enqueueSnackbar("Invalid applicable color pallet", {
                    variant: "error"
                });
                return;
            }
        }
        if ((formData.isTemplate === "true" || formData.isAITemplate === "true") && (!Array.isArray(formData.templateCategories) || formData.templateCategories.length === 0)) {
            enqueueSnackbar("Atleast one template category should be selected!", {
                variant: "error"
            });
            return;
        }
        if ((formData.isTemplate === "true" || formData.isAITemplate === "true") && (!Array.isArray(formData.templateColorPalettes) || formData.templateColorPalettes.length === 0)) {
            enqueueSnackbar("Atleast one template color pallet should be there!", {
                variant: "error"
            });
            return;
        }
        if ((formData.isTemplate === "true" || formData.isAITemplate === "true") && (formData.templateName === "" || !formData.templateName || formData.templateName === null || formData.templateName === undefined)) {
            enqueueSnackbar("Template name can't be blank!", {
                variant: "error"
            });
            return;
        }
        if (formData.defaultSocialMediaDescription && formData.defaultSocialMediaDescription.trim().length > 160) {
            enqueueSnackbar("Description exceeds the 160-character limit.", {
                variant: "error"
            });
            return;
        }
        // return;
        setIsLoading(true);
        try {
            if (formData.subDomainErrorMessage && formData.subDomainErrorMessage !== "") {
                enqueueSnackbar(formData.subDomainErrorMessage, {
                    variant: "error"
                });
                setIsLoading(false);
                return;
            }
            let data = objectWithoutKey(formData, "subDomainErrorMessage");
            data = objectWithoutKey(data, "siteOwnerUserId");
            // console.log("onsave click", data);
            await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post("/api/configs/append-site-config", data);
            if (siteData.isPublished) {
                if (data.subDomain !== siteData.subDomain) await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).patch("/api/configs/subdomain", {
                    siteId: data.siteId
                });
                if (data.siteName !== siteData.siteName || data.head_customHtmlCode !== siteData.head_customHtmlCode || data.body_customHtmlCode !== siteData.body_customHtmlCode || data.primaryLanguage !== siteData.primaryLanguage || data.defaultSocialMediaImage && !siteData.defaultSocialMediaImage || !data.defaultSocialMediaImage && siteData.defaultSocialMediaImage || data.defaultSocialMediaDescription !== siteData.defaultSocialMediaDescription || data.defaultSocialMediaImageAlt !== siteData.defaultSocialMediaImageAlt) {
                    const publishRes = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post("/api/configs/publish", {
                        siteId: data.siteId,
                        siteConfig: true
                    });
                    checkPublishStatus({
                        kind: "site",
                        siteId: data.siteId
                    }, "Site setting saved successfully!");
                } else {
                    if (data.faviconImage && data.faviconImage !== siteData.faviconImage || data.defaultSocialMediaImage !== siteData.defaultSocialMediaImage) await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).patch("/api/configs/site-images", {
                        siteId: data.siteId,
                        faviconChanged: data.faviconImage !== siteData.faviconImage,
                        socialImageChanged: data.defaultSocialMediaImage !== siteData.defaultSocialMediaImage
                    });
                    if (!deepCompare(data.redirects, siteData.redirects)) await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).patch("/api/configs/url-redirects", {
                        siteId: data.siteId
                    });
                    setIsLoading(false);
                    enqueueSnackbar("Site setting saved successfully!", {
                        variant: "success",
                        className: "bg-catelina-blue",
                        onExited: ()=>{
                            enqueueSnackbar("Refreshing preview. Please wait.", {
                                variant: "info",
                                autoHideDuration: 10000
                            });
                        }
                    });
                }
            } else {
                setIsLoading(false);
                enqueueSnackbar("Site setting saved successfully!", {
                    variant: "success",
                    className: "bg-catelina-blue"
                });
            }
            // Update siteUrl to reflect the new subdomain after save
            const updatedData = {
                ...data
            };
            if (data.subDomain !== siteData.subDomain && siteData.siteUrl) {
                const domainParts = siteData.siteUrl.split(".").slice(1).join(".");
                updatedData.siteUrl = `${data.subDomain}.${domainParts}`;
            }
            setSiteData(updatedData);
        } catch (err) {
            console.log(err);
            setIsLoading(false);
            let message = "An error occurred";
            if (err && typeof err === "object" && "response" in err) {
                const axiosError = err;
                message = axiosError.response?.data?.message || "An error occurred";
            } else if (err instanceof Error) message = err.message;
            enqueueSnackbar(message, {
                variant: "error"
            });
        }
    };
    // --- Publish status polling (singleton) ---
    const publishPollRef = $8FY87.useRef({
        intervalId: null,
        timeoutId: null,
        inFlight: false
    });
    const stopPublishPolling = $8FY87.useCallback(()=>{
        if (publishPollRef.current.intervalId) clearInterval(publishPollRef.current.intervalId);
        if (publishPollRef.current.timeoutId) clearTimeout(publishPollRef.current.timeoutId);
        publishPollRef.current.intervalId = null;
        publishPollRef.current.timeoutId = null;
        publishPollRef.current.inFlight = false;
    }, []);
    $8FY87.useEffect(()=>{
        return ()=>stopPublishPolling();
    }, [
        stopPublishPolling
    ]);
    const normalizeStatus = (raw)=>{
        const s = raw?.status ?? raw?.publishStatus ?? raw?.pageStatus ?? raw?.publishingStatus ?? raw;
        const out = String(s || "").trim().toLowerCase();
        return out;
    };
    const checkPublishStatus = (target, successMessage)=>{
        // Ensure there is only one active poller at a time.
        stopPublishPolling();
        publishPollRef.current.intervalId = setInterval(async ()=>{
            if (publishPollRef.current.inFlight) return;
            publishPollRef.current.inFlight = true;
            try {
                const queryString = target.kind === "page" ? `pageId=${encodeURIComponent(target.pageId)}` : `siteId=${encodeURIComponent(target.siteId)}`;
                const publishResponse = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).get(`/api/configs/check-publish-status?${queryString}`);
                const envelope = publishResponse?.data ?? publishResponse;
                const raw = envelope?.data ?? envelope;
                const raw2 = raw?.data ?? raw;
                const status = normalizeStatus(raw2);
                if (status === "completed") {
                    stopPublishPolling();
                    setIsLoading(false);
                    enqueueSnackbar(successMessage, {
                        variant: "success",
                        className: "bg-catelina-blue",
                        onExited: ()=>{
                            enqueueSnackbar("Refreshing preview. Please wait.", {
                                variant: "info",
                                autoHideDuration: 10000
                            });
                        }
                    });
                    if (raw?.publishError) enqueueSnackbar(raw.publishError, {
                        variant: "info",
                        className: "bg-grey-400"
                    });
                } else if (status === "failed") {
                    stopPublishPolling();
                    setIsLoading(false);
                    enqueueSnackbar(raw?.publishError || "Something went wrong. Please try again.", {
                        variant: "error"
                    });
                }
            } catch (e) {
                stopPublishPolling();
                setIsLoading(false);
                enqueueSnackbar("Failed to check publish status.", {
                    variant: "error"
                });
            } finally{
                publishPollRef.current.inFlight = false;
            }
        }, 5000);
        publishPollRef.current.timeoutId = setTimeout(()=>{
            stopPublishPolling();
            setIsLoading(false);
            enqueueSnackbar("Something went wrong. Please try again.", {
                variant: "error"
            });
        }, 300000);
    };
    const onAddOnUsersAdd = async (emails)=>{
        setIsLoading(true);
        try {
            let l_data = {
                siteId: formData.siteId,
                contributorsEmail: emails
            };
            // console.log("onAddOnUsersAdd", l_data);
            let rs = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).put("/api/configs/site-config-add-contributors", l_data);
            // console.log(l_data);
            // Lets send the email.
            emails.map(async (email)=>{
                let mailBody = "Dear " + email + ",";
                let siteLink = "https://editor.rocketpages.io/" + l_data.siteId;
                // mailBody += "<br> You are added as contributor";
                mailBody += "<br><br> We are excited to inform you that you have been added as a contributor to RocketPages.";
                mailBody += "<br><br> You can now access the site and start collaborating by visiting " + siteLink + ".";
                mailBody += "<br><br> Best regards,";
                mailBody += "<br> The RocketPages Team";
                let mailData = {
                    to: email,
                    subject: "Welcome to RocketPages!",
                    text: mailBody,
                    html: mailBody
                };
                let res = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post("/api/sg-mail/send", mailData);
            });
            // Lets notify the user that mail has been sent.
            enqueueSnackbar("Contributor mail has been sent!", {
                variant: "info",
                className: "bg-grey-400"
            });
            setIsLoading(false);
        // console.log("save res", rs);
        } catch (err) {
            console.log(err);
            setIsLoading(false);
        }
    };
    const onAddOnUsersRemove = async (email)=>{
        setIsLoading(true);
        try {
            let l_data = {
                siteId: formData.siteId,
                email: email
            };
            // console.log("onAddOnUsersRemove", l_data);
            let rs = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).put("/api/configs/site-config-remove-contributor", l_data);
            setIsLoading(false);
        // console.log("save res", rs);
        } catch (err) {
            console.log(err);
            setIsLoading(false);
        }
    };
    const [selectedCategory, setSelectedCategory] = (0, $8FY87.useState)(searchParams.get("section") || "General");
    const handleCategoryChange = (category)=>{
        setSelectedCategory(category);
        handleUpdateQueryParam(category);
    };
    // Fetch site data when id changes
    $8FY87.useEffect(()=>{
        if (!id) return;
        let cancelled = false;
        (async ()=>{
            setIsLoading(true);
            try {
                const [siteRes, colorsRes, categoriesRes] = await Promise.all([
                    (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).get(`/api/configs/site-config?siteId=${id}`),
                    (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).get(`/api/configs/all-template-color-theme`),
                    (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).get(`/api/configs/all-site-category`)
                ]);
                if (cancelled) return;
                const site = siteRes.data;
                setSiteData(site);
                setFormData({
                    ...site,
                    templateColorPalettes: site.templateColorPalettes ? site.templateColorPalettes.map((item)=>({
                            ...item,
                            keyIndex: colorPalletKeys.new()
                        })) : []
                });
                setAllTemplateColors(colorsRes.data.data);
                setTemplateSiteCategories(categoriesRes.data.data);
                // Use functional update to avoid stale 'siteCategory'
                setSiteCategory((prev)=>{
                    const next = [
                        ...prev
                    ];
                    if (site.siteOwnerUserId === cookies.rp_user_data.userId) {
                        if (!next.includes("Contributors")) next.push("Contributors");
                        if (!next.includes("Subscriptions")) next.push("Subscriptions");
                    }
                    if (cookies.rp_user_data.userType === "admin") {
                        if (!next.includes("Administration")) next.push("Administration");
                    }
                    return next;
                });
            } catch (err) {
                const status = err?.response?.status;
                if (status === 404) navigate(`/404?msgType=SiteNotFound`);
                else if (status === 401) navigate(`/404?msgType=SiteNotAuthorizedToAccess`);
                else console.log("err", err);
            } finally{
                if (!cancelled) setIsLoading(false);
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        id
    ]);
    // To hide sitename of preview on mobile view
    const useMobileView = ()=>{
        const [isMobileView, setIsMobile] = (0, $8FY87.useState)(window.innerWidth <= 601);
        $8FY87.useEffect(()=>{
            const mediaQuery = window.matchMedia("(max-width: 601px)");
            const handleMediaChange = ()=>setIsMobile(mediaQuery.matches);
            handleMediaChange(); // Initial check
            mediaQuery.addEventListener("change", handleMediaChange); // Listen for changes
            return ()=>mediaQuery.removeEventListener("change", handleMediaChange); // Cleanup
        }, []);
        return isMobileView;
    };
    let isMobile = useMobileView();
    return /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, null, /*#__PURE__*/ $8FY87.createElement((0, $33586719f2f33a17$export$dcef8f9bb9a41431), null, /*#__PURE__*/ $8FY87.createElement("title", null, "RocketPages - Site Settings"), /*#__PURE__*/ $8FY87.createElement("meta", {
        name: "description",
        content: "Build and Launch Your Free Website in Just 15 Minutes"
    }), /*#__PURE__*/ $8FY87.createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap",
        rel: "stylesheet"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "icon",
        href: "/favicon.ico"
    }), false), /*#__PURE__*/ $8FY87.createElement((0, $9ada84cce5691847$export$2e2bcd8739ae039), null), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "font-body text-base font-medium"
    }, /*#__PURE__*/ $8FY87.createElement((0, $56dcde36b8493878$export$2e2bcd8739ae039), {
        sx: {
            color: "#fff",
            display: "flex",
            flexDirection: "column",
            zIndex: (theme)=>theme.zIndex.drawer + 1
        },
        open: isLoading || isCheckingSSL
    }, /*#__PURE__*/ $8FY87.createElement((0, $b391f94ee7b6de9b$export$2e2bcd8739ae039), {
        color: "inherit"
    }), isCheckingSSL && /*#__PURE__*/ $8FY87.createElement("p", {
        className: "mt-4"
    }, "Updating your site's domain...")), /*#__PURE__*/ $8FY87.createElement((0, $c0f0a0f6efad2fa3$export$42cfbb80f7861e77), {
        ...stateData,
        isPublished: formData.isPublished,
        siteId: id,
        title: `Site settings${!isMobile ? ` : ${formData ? formData.siteName : ""}` : ""}`,
        siteUrl: siteData.siteUrl ? `https://${siteData.siteUrl}` : ""
    }), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "bg-gray-100 flex-row fixed h-screen w-48 top-[64px] hidden md:flex"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "left-navbar-tabs w-full h-full bg-catelina-blue text-white flex flex-col py-2"
    }, siteCategory.map((ii)=>{
        return /*#__PURE__*/ $8FY87.createElement("span", {
            className: `px-6 hover:cursor-pointer py-2 left-sidebar-tab-${ii.toLowerCase().replace(/\s+/g, "-")} ${selectedCategory === ii ? "bg-white-smoke text-catelina-blue" : ""}`,
            key: ii,
            onClick: ()=>handleCategoryChange(ii)
        }, ii);
    }))), /*#__PURE__*/ $8FY87.createElement("div", {
        className: " left-navbar-tab-contents min-h-screen flex w-full my-4 px-4 md:pl-[280px] pb-10 pt-[64px] bg-white-smoke flex-col"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex md:hidden py-2"
    }, /*#__PURE__*/ $8FY87.createElement((0, $e9e435d08b475b0d$export$2e2bcd8739ae039), {
        items: siteCategory,
        handleChange: handleCategoryChange,
        category: selectedCategory
    })), formData && selectedCategory === "General" && /*#__PURE__*/ $8FY87.createElement((0, $05100f9b0153af82$export$2e2bcd8739ae039), {
        siteId: formData.siteId,
        onDataChange: onFormDataChange,
        faviconImage: formData.faviconImage,
        siteName: formData.siteName,
        defaultSocialMediaImage: formData.defaultSocialMediaImage,
        defaultSocialMediaDescription: formData.defaultSocialMediaDescription,
        defaultSocialMediaImageAlt: formData.defaultSocialMediaImageAlt
    }), formData && selectedCategory === "Administration" && cookies.rp_user_data.userType === "admin" && /*#__PURE__*/ $8FY87.createElement((0, $9afa5c10a93e130a$export$2e2bcd8739ae039), {
        siteId: formData.siteId,
        onDataChange: onFormDataChange,
        data: formData,
        allTemplateColors: allTemplateColors,
        templateSiteCategories: templateSiteCategories
    }), formData && selectedCategory === "Domain" && /*#__PURE__*/ $8FY87.createElement((0, $35199937cd04f04a$export$2e2bcd8739ae039), {
        siteId: formData.siteId,
        userData: cookies.rp_user_data,
        onDataChange: onFormDataChange,
        subDomain: formData.subDomain,
        subDomainErrorMessage: formData.subDomainErrorMessage,
        selectedDomainTab: selectedDomainTab,
        onTabChange: (tab)=>{
            setSelectedDomainTab(tab);
        },
        isPublished: formData.isPublished,
        setIsLoading: setIsLoading,
        setIsCheckingSSL: setIsCheckingSSL,
        checkPublishStatus: checkPublishStatus
    }), formData && selectedCategory === "Custom Code" && /*#__PURE__*/ $8FY87.createElement((0, $93437f1c2420419c$export$2e2bcd8739ae039), {
        onDataChange: onFormDataChange,
        head_customHtmlCode: formData.head_customHtmlCode,
        body_customHtmlCode: formData.body_customHtmlCode
    }), formData && selectedCategory === "SEO" && /*#__PURE__*/ $8FY87.createElement((0, $fb6c4742a3f9e788$export$2e2bcd8739ae039), {
        onDataChange: onFormDataChange,
        primaryLanguage: formData.primaryLanguage,
        redirects: formData.redirects ?? [],
        setSaveDisabled: setSaveDisabled
    }), formData && selectedCategory === "Widgets" && /*#__PURE__*/ $8FY87.createElement((0, $1a96556205575969$export$2e2bcd8739ae039), {
        onDataChange: onFormDataChange,
        cookies: formData.cookies
    }), formData && cookies.rp_user_data?.userId && selectedCategory === "Contributors" && formData.siteOwnerUserId === cookies.rp_user_data.userId && /*#__PURE__*/ $8FY87.createElement((0, $6768eaa9b46c6d7c$export$2e2bcd8739ae039), {
        onDataChange: onFormDataChange,
        addOnUsers: formData.addOnUsers,
        onAddOnUsersAdd: onAddOnUsersAdd,
        onAddOnUsersRemove: onAddOnUsersRemove
    }), formData && selectedCategory === "Contact Form" && /*#__PURE__*/ $8FY87.createElement((0, $079176218bec9be8$export$2e2bcd8739ae039), {
        siteId: id
    }), formData && cookies.rp_user_data?.userId && formData.siteOwnerUserId === cookies.rp_user_data.userId && /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, null, selectedCategory === "Plans" && /*#__PURE__*/ $8FY87.createElement((0, $8813eb74b0ee98c8$export$2e2bcd8739ae039), null), selectedCategory === "Billing" && /*#__PURE__*/ $8FY87.createElement((0, $ef77c9de594ee7e7$export$2e2bcd8739ae039), null), selectedCategory === "Subscriptions" && /*#__PURE__*/ $8FY87.createElement((0, $2d8a03adb139f410$export$2e2bcd8739ae039), null))), selectedCategory !== "Contributors" && selectedCategory !== "Contact Form" && (selectedCategory !== "Domain" || selectedDomainTab !== "customdomain") && selectedCategory !== "Billing" && selectedCategory !== "Blog" && selectedCategory !== "Plans" && selectedCategory !== "Subscriptions" && /*#__PURE__*/ $8FY87.createElement("div", {
        className: "fixed bottom-0 w-full z-50 flex justify-end px-4 py-2 bg-white-smoke"
    }, /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        id: "save",
        disabled: saveDisabled,
        className: "min-w-[6rem] px-4 py-1 capitalize",
        sx: {
            textTransform: "none"
        },
        size: "small",
        variant: "contained",
        onClick: onSave
    }, "Save ", siteData.isPublished && " & Publish"))), /*#__PURE__*/ $8FY87.createElement((0, $fdcc8de0ec44fdd8$export$2e2bcd8739ae039), null));
};



var $8FY87 = parcelRequire("8FY87");




var $8FY87 = parcelRequire("8FY87");



const $94abf75555c4d07e$var$TermsAndConditions = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("main", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).contentWrapper}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).spacing} mt-8`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("h1", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).h1}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("strong", null, "RocketPages Terms and Conditions"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).description}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("strong", null, "Last updated: May 17, 2024")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", null, "Welcome to RocketPages! These terms and conditions govern your use of our Website Builder. By accessing and using RocketPages, you agree to comply with the following terms and conditions. If you do not agree with any part of these terms, please refrain from using RocketPages.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("strong", null, "User Accounts"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("ol", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("li", null, "To access certain features of RocketPages, users may be required to create an account. Users are responsible for maintaining the confidentiality of their account credentials and for any activity that occurs under their accounts."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("li", null, "RocketPages reserves the right to refuse service, terminate accounts, or remove content at our sole discretion."))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("strong", null, "User Roles"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("ol", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("li", null, "RocketPages offers various user roles with differing levels of access and permissions. These roles include but are not limited to contributors, who can create and edit content, and owners, who have full control over site management."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("li", null, "Account owners are responsible for managing user roles and permissions within RocketPages."))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("strong", null, "Site Creation and Duplication"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("ol", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("li", null, "Users can create and duplicate websites using RocketPages Website Builder."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("li", null, "RocketPages does not claim ownership of any content created by users but may use such content for promotional purposes."))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("strong", null, "Site Publication"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("ol", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("li", null, "Users can publish their websites using RocketPages, making them accessible to end-users."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("li", null, "RocketPages is not responsible for the content published by users and does not endorse any views expressed therein."))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("strong", null, "Video Embedding and Social Login"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("ol", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("li", null, "RocketPages allows users to embed videos from Vimeo and YouTube and utilize social login features within their websites."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("li", null, "By embedding videos or using social login features, users agree to comply with the terms and conditions of Vimeo, YouTube, and any other applicable third-party platforms."))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("strong", null, "Custom Domain Attachment"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("ol", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("li", null, "Users have the option to attach a custom domain to their website on RocketPages.\xa0"))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("strong", null, "Payment Processing and Subscription"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("ol", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("li", null, "RocketPages offers paid subscription plans for access to premium features. Payment for RocketPages services is handled by Stripe, a third-party payment processor."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("li", null, "By subscribing to a paid plan, you agree to comply with the terms of service and privacy policy of Stripe."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("li", null, "RocketPages does not store or process payment information directly and is not responsible for any issues arising from the use of Stripe's services."))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("strong", null, "Limitation of Liability"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("ol", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("li", null, "RocketPages shall not be liable for any direct, indirect, incidental, special, or consequential damages arising out of or in any way connected with the use of RocketPages."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("li", null, "RocketPages does not guarantee the accuracy, completeness, or reliability of any content or information provided on the platform."))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("strong", null, "Privacy Policy"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("ol", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("li", null, "Your use of RocketPages is subject to our Privacy Policy, which outlines how we collect, use, and disclose your personal information."))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("strong", null, "Modification of Terms"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("ol", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("li", null, "RocketPages reserves the right to modify these terms and conditions at any time without prior notice. Continued use of RocketPages after any such changes shall constitute your consent to such changes."))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("strong", null, "Governing Law"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("ol", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("li", null, "These terms and conditions shall be governed by and construed in accordance with the laws of California, and any disputes relating to these terms and conditions shall be subject to the exclusive jurisdiction of the courts of California."))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("strong", null, " Acceptance of Terms"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("ol", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("li", null, "By using RocketPages, you acknowledge that you have read, understood, and agree to be bound by these terms and conditions. If you do not agree with any part of these terms and conditions, please refrain from using RocketPages."))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).title}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("strong", null, "Age Requirements"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).description}  ${(0, (/*@__PURE__*/$parcel$interopDefault($a8bf90d2d4c0cd11$exports))).fsmd}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("ol", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("li", null, "By accessing or using this website, you affirm that you are at least 13 years old or the age of majority in your jurisdiction, whichever is greater. If you are under the specified age, you must obtain consent from your parent or guardian before using this website. Please be aware that if you are located in the European Union, you may need to comply with the General Data Protection Regulation (GDPR), which sets the minimum age for consent at 16 in most cases, though individual EU member states may have different age requirements.")))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $0a87a32205fa1e51$export$2e2bcd8739ae039), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $fdcc8de0ec44fdd8$export$2e2bcd8739ae039), null));
};
var $94abf75555c4d07e$export$2e2bcd8739ae039 = $94abf75555c4d07e$var$TermsAndConditions;




const $fefd9524ab4ddc67$export$3e6dfd2ec8bf3ef9 = (props)=>{
    const navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    const location = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)();
    const stateData = location.state;
    const [cookie, setCookie, removeCookie] = (0, $1f373de1ceea6eb7$export$2e2bcd8739ae039)([
        "rp_user_data"
    ]);
    return /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, null, /*#__PURE__*/ $8FY87.createElement((0, $274ffc8236991365$export$dcef8f9bb9a41431), null, /*#__PURE__*/ $8FY87.createElement("title", null, "RocketPages - Terms and conditions"), /*#__PURE__*/ $8FY87.createElement("meta", {
        name: "description",
        content: "Build and Launch Your Free Website in Just 15 Minutes"
    }), /*#__PURE__*/ $8FY87.createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap",
        rel: "stylesheet"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "icon",
        href: "/favicon.ico"
    }), false), /*#__PURE__*/ $8FY87.createElement((0, $9ada84cce5691847$export$2e2bcd8739ae039), null), /*#__PURE__*/ $8FY87.createElement((0, $c0f0a0f6efad2fa3$export$42cfbb80f7861e77), {
        ...stateData,
        skipCheckCookies: true
    }), /*#__PURE__*/ $8FY87.createElement((0, $94abf75555c4d07e$export$2e2bcd8739ae039), null));
};



var $ccfLL = parcelRequire("ccfLL");
var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");
parcelRequire("8FY87");


var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");



var $8FY87 = parcelRequire("8FY87");
const $0d240c2e90957e07$var$ThemeContext = /*#__PURE__*/ $8FY87.createContext(null);
var $0d240c2e90957e07$export$2e2bcd8739ae039 = $0d240c2e90957e07$var$ThemeContext;



var $8FY87 = parcelRequire("8FY87");

function $fee952e0bf998cc2$export$2e2bcd8739ae039() {
    const theme = $8FY87.useContext((0, $0d240c2e90957e07$export$2e2bcd8739ae039));
    return theme;
}


const $869b6cf8a22999cb$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $869b6cf8a22999cb$export$2e2bcd8739ae039 = $869b6cf8a22999cb$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';



var $2PPWI = parcelRequire("2PPWI");
function $facaca805e87c116$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $zgVxD.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $facaca805e87c116$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $fee952e0bf998cc2$export$2e2bcd8739ae039)();
    const theme = $8FY87.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $facaca805e87c116$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $869b6cf8a22999cb$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $0d240c2e90957e07$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $facaca805e87c116$export$2e2bcd8739ae039 = $facaca805e87c116$var$ThemeProvider;



parcelRequire("icSEh");
var $8MSLN = parcelRequire("8MSLN");



var $fkLNr = parcelRequire("fkLNr");
parcelRequire("8FY87");





var $2PPWI = parcelRequire("2PPWI");
'use client';
function $22dc49a67e74dca0$export$2e2bcd8739ae039(theme) {
    const upperTheme = (0, $5952bd9f3861b4fa$export$2e2bcd8739ae039)();
    const id = (0, $a3608bb1fb347cd9$export$2e2bcd8739ae039)() || '';
    const { modularCssLayers: modularCssLayers } = theme;
    let layerOrder = 'mui.global, mui.components, mui.theme, mui.custom, mui.sx';
    if (!modularCssLayers || upperTheme !== null) // skip this hook if upper theme exists.
    layerOrder = '';
    else if (typeof modularCssLayers === 'string') layerOrder = modularCssLayers.replace(/mui(?!\.)/g, layerOrder);
    else layerOrder = `@layer ${layerOrder};`;
    (0, $1eb4765744b30085$export$2e2bcd8739ae039)(()=>{
        const head = document.querySelector('head');
        if (!head) return;
        const firstChild = head.firstChild;
        if (layerOrder) {
            var _firstChild$hasAttrib;
            // Only insert if first child doesn't have data-mui-layer-order attribute
            if (firstChild && (_firstChild$hasAttrib = firstChild.hasAttribute) != null && _firstChild$hasAttrib.call(firstChild, 'data-mui-layer-order') && firstChild.getAttribute('data-mui-layer-order') === id) return;
            const styleElement = document.createElement('style');
            styleElement.setAttribute('data-mui-layer-order', id);
            styleElement.textContent = layerOrder;
            head.prepend(styleElement);
        } else {
            var _head$querySelector;
            (_head$querySelector = head.querySelector(`style[data-mui-layer-order="${id}"]`)) == null || _head$querySelector.remove();
        }
    }, [
        layerOrder,
        id
    ]);
    if (!layerOrder) return null;
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $b9e15c80096b23eb$export$2e2bcd8739ae039), {
        styles: layerOrder
    });
}



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $6d957a853b095e99$var$EMPTY_THEME = {};
function $6d957a853b095e99$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $8FY87.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $zgVxD.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $zgVxD.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $zgVxD.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $6d957a853b095e99$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $5952bd9f3861b4fa$export$2e2bcd8739ae039)($6d957a853b095e99$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $fee952e0bf998cc2$export$2e2bcd8739ae039)() || $6d957a853b095e99$var$EMPTY_THEME;
    const engineTheme = $6d957a853b095e99$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $6d957a853b095e99$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = engineTheme.direction === 'rtl';
    const layerOrder = (0, $22dc49a67e74dca0$export$2e2bcd8739ae039)(engineTheme);
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $facaca805e87c116$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8MSLN.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $fd8721cf96f8ae09$export$2e2bcd8739ae039), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $fkLNr.default), {
                    value: engineTheme == null ? void 0 : engineTheme.components,
                    children: [
                        layerOrder,
                        children
                    ]
                })
            })
        })
    });
}
var $6d957a853b095e99$export$2e2bcd8739ae039 = $6d957a853b095e99$var$ThemeProvider;



var $ab2pD = parcelRequire("ab2pD");

var $2PPWI = parcelRequire("2PPWI");
'use client';
const $965150fe664c8832$var$_excluded = [
    "theme"
];
function $965150fe664c8832$export$2e2bcd8739ae039(_ref) {
    let { theme: themeInput } = _ref, props = (0, $93aRW.default)(_ref, $965150fe664c8832$var$_excluded);
    const scopedTheme = themeInput[0, $ab2pD.default];
    let finalTheme = scopedTheme || themeInput;
    if (typeof themeInput !== 'function') {
        if (scopedTheme && !scopedTheme.vars) finalTheme = (0, $zgVxD.default)({}, scopedTheme, {
            vars: null
        });
        else if (themeInput && !themeInput.vars) finalTheme = (0, $zgVxD.default)({}, themeInput, {
            vars: null
        });
    }
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $6d957a853b095e99$export$2e2bcd8739ae039), (0, $zgVxD.default)({}, props, {
        themeId: scopedTheme ? (0, $ab2pD.default) : undefined,
        theme: finalTheme
    }));
}




var $8FY87 = parcelRequire("8FY87");


var $7676345fa334d851$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $7676345fa334d851$var$CookiesProvider = /** @class */ function(_super) {
    $7676345fa334d851$var$__extends(CookiesProvider, _super);
    function CookiesProvider(props) {
        var _this = _super.call(this, props) || this;
        if (props.cookies) _this.cookies = props.cookies;
        else _this.cookies = new (0, $611be68d13069d5c$export$2e2bcd8739ae039)();
        return _this;
    }
    CookiesProvider.prototype.render = function() {
        return $8FY87.createElement((0, $66584bdd2edfca74$export$2881499e37b75b9a), {
            value: this.cookies
        }, this.props.children);
    };
    return CookiesProvider;
}($8FY87.Component);
var $7676345fa334d851$export$2e2bcd8739ae039 = $7676345fa334d851$var$CookiesProvider;






var $8FY87 = parcelRequire("8FY87");









const $6621759a7b4e8a8a$var$NotFoundPage = ()=>{
    const navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    const [isLoading, setIsLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useState(false);
    const [cookie] = (0, $1f373de1ceea6eb7$export$2e2bcd8739ae039)([
        "rp_user_data"
    ]);
    const location = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)();
    const stateData = location.state;
    function useQuery() {
        const { search: search } = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)();
        return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useMemo(()=>new URLSearchParams(search), [
            search
        ]);
    }
    let query = useQuery();
    let l_msgType = query.get("msgType");
    let actionInfos;
    if (l_msgType === "SiteNotFound") actionInfos = {
        message: "Oops! This site doesn't exist. Go back to the homepage to explore.",
        actionButtomText: "Back to homepage",
        actionButtonUrl: "/dashboard"
    };
    else if (l_msgType === "SiteNotAuthorizedToAccess" && cookie.rp_user_data) actionInfos = {
        message: "Access Denied. Check your dashboard for your websites.",
        actionButtomText: "Go to Dashboard",
        actionButtonUrl: "/dashboard"
    };
    else if (l_msgType === "SiteNotAuthorizedToAccess" && !cookie.rp_user_data) actionInfos = {
        message: "Login Required. Log in or sign up to access this page.",
        actionButtomText: "Log In or Sign Up",
        actionButtonUrl: "/login"
    };
    else if (l_msgType === "UnAuthorizedUser") actionInfos = {
        message: "Private Content. Log in or sign up to access this page.",
        actionButtomText: "Log In or Sign Up",
        actionButtonUrl: "/login"
    };
    else if (l_msgType === "UnAuthorizedAdmin") actionInfos = {
        message: "Unauthorised access. Check your dashboard for your websites.",
        actionButtomText: "Go to Dashboard",
        actionButtonUrl: "/dashboard"
    };
    else actionInfos = {
        message: "Oops! This page doesn't exist. Go back to the homepage to explore.",
        actionButtomText: "Back to homepage",
        actionButtonUrl: "/dashboard"
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $274ffc8236991365$export$dcef8f9bb9a41431), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("title", null, "RocketPages - Choose Template"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("meta", {
        name: "description",
        content: "Build and Launch Your Free Website in Just 15 Minutes"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("link", {
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("link", {
        href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap",
        rel: "stylesheet"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("link", {
        rel: "icon",
        href: "/favicon.ico"
    }), false), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $9ada84cce5691847$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "font-body text-base font-medium"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $56dcde36b8493878$export$2e2bcd8739ae039), {
        sx: {
            color: "#fff",
            zIndex: (theme)=>theme.zIndex.drawer + 1
        },
        open: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $b391f94ee7b6de9b$export$2e2bcd8739ae039), {
        color: "inherit"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $c0f0a0f6efad2fa3$export$42cfbb80f7861e77), {
        ...stateData,
        skipCheckCookies: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "fixed w-full h-screen flex justify-center items-center text-center page404"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex items-center flex-col bg-white w-full -mt-12 px-8"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("h1", {
        className: "m-0 text-catelina-blue tracking-widest"
    }, "404"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", {
        className: "text-catelina-blue mt-1 text-lg"
    }, actionInfos.message), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("button", {
        className: "mt-0 bg-transparent hover:bg-catelina-blue text-catelina-blue font-medium py-2 px-4 border border-catelina-blue hover:border-catelina-blue hover:text-white rounded",
        onClick: ()=>{
            navigate(actionInfos.actionButtonUrl);
        }
    }, actionInfos.actionButtomText)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "absolute bottom-0 w-full"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $0a87a32205fa1e51$export$2e2bcd8739ae039), null)));
};
var $6621759a7b4e8a8a$export$2e2bcd8739ae039 = $6621759a7b4e8a8a$var$NotFoundPage;






var $8FY87 = parcelRequire("8FY87");







var $a7ec1eb8e8517a72$exports = {};

$a7ec1eb8e8517a72$exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "bi_eye.6d8dacc1.svg";


var $11fee8f7274bba31$exports = {};

$11fee8f7274bba31$exports = (parcelRequire("lslan")).getBundleURL('gCzzu') + "open_eye.688ef7e6.svg";






const $63f5a8e49b0d65b1$var$AccountSetting = ()=>{
    const [isLoading, setIsLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useState(false);
    const [updatePasswordRes, setUpdatePasswordRes] = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useState({
        message: "",
        isVisible: false,
        isError: false
    });
    const [googleLinkRes, setGoogleLinkRes] = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useState({
        message: "",
        isVisible: false,
        isError: false
    });
    const [linkedInLinkRes, setLinkedInLinkRes] = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useState({
        message: "",
        isVisible: false,
        isError: false
    });
    const navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    const location = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)();
    const stateData = location.state;
    const [cookies, setCookie, removeCookie] = (0, $1f373de1ceea6eb7$export$2e2bcd8739ae039)([
        "rp_user_data",
        "rp_user_id"
    ]);
    const [accountSettingData, setAccountSettingData] = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useState({});
    (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useState([]);
    const styleEnabled = {
        backgroundColor: "#fff",
        border: "1px solid",
        borderColor: "#243060",
        color: "#243060",
        textTransform: "none",
        "&:hover": {
            backgroundColor: "#243060",
            color: "#fff"
        }
    };
    const styleDisabled = {
        backgroundColor: "#fff",
        border: "1px solid",
        borderColor: "#ff0000",
        color: "#ff0000",
        textTransform: "none",
        "&:hover": {
            backgroundColor: "#ff0000",
            color: "#fff"
        }
    };
    const [formData, setFormData] = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useState({
        currentPassword: "",
        password: "",
        rePassword: ""
    });
    const [formErrors, setFormErrors] = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useState({
        currentPassword: "",
        password: "",
        rePassword: ""
    });
    const [toggleAttributes, setToggleAttributes] = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useState({
        currentPassword: "password",
        password: "password",
        rePassword: "password"
    });
    async function fetchAccountSettings(email) {
        let response = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).get(`/api/account-settings?email=${email}`);
        let prepData = {};
        response.data.linkedAccounts && response.data.linkedAccounts.forEach((row)=>{
            if (row.googleSource === true) prepData = {
                ...prepData,
                googleSource: true,
                googleSourceEmail: row.email
            };
            if (row.linkedInSource === true) prepData = {
                ...prepData,
                linkedInSource: true,
                linkedInSourceEmail: row.email
            };
            if (row.emailSource) prepData = {
                ...prepData,
                emailSource: true,
                emailSourceEmail: row.email
            };
        });
        setAccountSettingData({
            ...response.data.data,
            ...prepData
        });
    // console.log("setAccountSettingData", {
    //   ...response.data.data,
    //   ...prepData,
    // });
    }
    (0, $8FY87.useEffect)(()=>{
        fetchAccountSettings(cookies.rp_user_data ? cookies.rp_user_data.email : "");
    }, []);
    function handleChange(event) {
        setFormData((old)=>{
            return {
                ...old,
                [event.target.id]: event.target.value.trim()
            };
        });
        setFormErrors((old)=>{
            return {
                ...old,
                [event.target.id]: ""
            };
        });
    }
    function handleTogglePassword(id) {
        setToggleAttributes((old)=>{
            return {
                ...old,
                [id]: old[id] === "password" ? "text" : "password"
            };
        });
    }
    function validateForm(formData) {
        try {
            // console.log("formData", formData);
            setFormErrors({
                currentPassword: "",
                password: "",
                rePassword: ""
            });
            if (formData.currentPassword === "" && accountSettingData.emailSource) {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        currentPassword: "Current password can not be empty"
                    };
                });
                return false;
            }
            if (formData.password === "") {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        password: "New password can not be empty"
                    };
                });
                return false;
            }
            if (formData.rePassword === "") {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        rePassword: "Re-password can not be empty"
                    };
                });
                return false;
            }
            if (formData.password.length < 8) {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        password: "New password length can not be less than 8 chars."
                    };
                });
                return false;
            }
            if (formData.password !== formData.rePassword) {
                setFormErrors((old)=>{
                    return {
                        ...old,
                        rePassword: "Re-password does not match password."
                    };
                });
                return false;
            }
            return true;
        } catch (err) {
            return false;
        }
    }
    const onUpdatePassword = async ()=>{
        // console.log("onUpdatePassword");
        if (validateForm(formData)) try {
            (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post("/api/update-account-password", {
                email: cookies.rp_user_data.email,
                currentPassword: formData.currentPassword,
                newPassword: formData.password
            }).then((response)=>{
                setUpdatePasswordRes({
                    message: response.data.message,
                    isVisible: true,
                    isError: false
                });
            }).catch((err)=>{
                setUpdatePasswordRes({
                    message: err.response.data.message,
                    isVisible: true,
                    isError: true
                });
            }).finally(()=>{
                setUpdatePasswordRes((old)=>{
                    if (!old.isError) setFormData({
                        currentPassword: "",
                        password: "",
                        rePassword: ""
                    });
                    return {
                        ...old
                    };
                });
                setTimeout(()=>{
                    setUpdatePasswordRes((old)=>{
                        if (!old.isError) setFormData({
                            currentPassword: "",
                            password: "",
                            rePassword: ""
                        });
                        return {
                            ...old,
                            isVisible: false
                        };
                    });
                    fetchAccountSettings(cookies.rp_user_data ? cookies.rp_user_data.email : "");
                }, 5000);
            });
        } catch (err) {
            console.log("onUpdatePassword", err);
        }
        else console.log("false", formErrors);
    };
    const handleLogout = ()=>{
        async function logoutUser() {
            try {
                // console.log("before.remove.cookies");
                setCookie("rp_user_data", "", {
                    maxAge: 0,
                    domain: ".rocketpages.io"
                });
                setCookie("rp_user_id", "", {
                    maxAge: 0,
                    domain: ".rocketpages.io"
                });
                await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post("/api/logout", {}, {
                    withCredentials: true
                });
            } catch (err) {
                console.log(err);
            }
        }
        logoutUser();
        // removeCookie("rp_access_token");
        navigate("/login", {
            state: {
                removeCookies: true
            }
        });
    // removeCookie_userData("rp_user_data");
    };
    const { linkedInLogin: linkedInLogin } = (0, $c87118bc1c828d28$export$798996ac402ec5d0)({
        clientId: "86q0502we7bi54",
        scope: "email profile openid",
        redirectUri: "https://app.rocketpages.io/linkedin",
        onSuccess: (code)=>{
            onLoginViaLinkedIn(code);
        },
        onError: (error)=>{
            console.log(error);
        }
    });
    async function onLoginViaLinkedIn(authCode) {
        setIsLoading(true);
        try {
            await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post(`api/link-social-login`, {
                userId: cookies.rp_user_data.userId,
                email: cookies.rp_user_data.email,
                socialAccountType: "linkedIn",
                authCode: authCode
            }).then((response)=>{
                setLinkedInLinkRes({
                    message: "Linked Successfully!",
                    isVisible: true,
                    isError: false
                });
                fetchAccountSettings(cookies.rp_user_data ? cookies.rp_user_data.email : "");
            }).catch((err)=>{
                setLinkedInLinkRes({
                    message: err.response.data.message,
                    isVisible: true,
                    isError: true
                });
            }).finally(()=>{
                setTimeout(()=>{
                    setLinkedInLinkRes((old)=>{
                        return {
                            ...old,
                            isVisible: false
                        };
                    });
                }, 5000);
            });
            setIsLoading(false);
        } catch (err) {
            setIsLoading(false);
        }
    }
    async function unLinkAccount(type) {
        setIsLoading(true);
        try {
            await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post(`api/unlink-social-login`, {
                email: type === "google" ? accountSettingData.googleSourceEmail : accountSettingData.linkedInSourceEmail,
                socialAccountType: type
            }).then((response)=>{
                // console.log('active email',response.data.data.email);
                if (response.status === 200) {
                    setCookie("rp_user_data", JSON.stringify(response.data.data), {
                        maxAge: 604800,
                        domain: ".rocketpages.io"
                    });
                    fetchAccountSettings(response.data.data.email);
                }
            }).catch((err)=>{
                if (type === "google") setGoogleLinkRes({
                    message: err.response.data.message,
                    isVisible: true,
                    isError: true
                });
                else if (type === "linkedIn") setLinkedInLinkRes({
                    message: err.response.data.message,
                    isVisible: true,
                    isError: true
                });
            }).finally(()=>{
                setTimeout(()=>{
                    if (type === "google") setGoogleLinkRes((old)=>{
                        return {
                            ...old,
                            isVisible: false
                        };
                    });
                    else if (type === "linkedIn") setLinkedInLinkRes((old)=>{
                        return {
                            ...old,
                            isVisible: false
                        };
                    });
                }, 5000);
            });
            setIsLoading(false);
        } catch (err) {
            setIsLoading(false);
        }
    }
    const googleLinkAccount = (0, $e7ed5c4b4f4b44fc$export$6ca4c5d94f9e170b)({
        hint: cookies.rp_user_data ? cookies.rp_user_data.email : "",
        onSuccess: async (codeResponse)=>{
            const userInfo = await (0, $bf5b93105d90423b$export$2e2bcd8739ae039).get("https://www.googleapis.com/oauth2/v3/userinfo", {
                headers: {
                    Authorization: `Bearer ${codeResponse.access_token}`
                }
            });
            const result = userInfo.data;
            // console.log("result", result);
            await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post(`api/link-social-login`, {
                userId: cookies.rp_user_data.userId,
                email: cookies.rp_user_data.email,
                socialAccountType: "google",
                googleRes: result
            }).then((response)=>{
                setGoogleLinkRes({
                    message: "Linked Successfully!",
                    isVisible: true,
                    isError: false
                });
                fetchAccountSettings(cookies.rp_user_data ? cookies.rp_user_data.email : "");
            }).catch((err)=>{
                setGoogleLinkRes({
                    message: err.response.data.message,
                    isVisible: true,
                    isError: true
                });
            }).finally(()=>{
                setTimeout(()=>{
                    setGoogleLinkRes((old)=>{
                        return {
                            ...old,
                            isVisible: false
                        };
                    });
                }, 5000);
            });
        },
        onError: (errorResponse)=>console.log(errorResponse)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $274ffc8236991365$export$dcef8f9bb9a41431), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("title", null, "Account Settings | RocketPages IO"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("meta", {
        name: "description",
        content: "Build and Launch Your Free Website in Just 15 Minutes"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("link", {
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("link", {
        href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap",
        rel: "stylesheet"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("link", {
        rel: "icon",
        href: "/favicon.ico"
    }), false), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $9ada84cce5691847$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "font-body text-base font-medium account-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $c0f0a0f6efad2fa3$export$42cfbb80f7861e77), {
        ...stateData,
        title: "Account settings"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "my-4 pl-[20px]  pb-10 pt-[64px] bg-white-smoke pr-[20px]"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "lg:w-auto xl:w-8/12 m-auto bg-white px-4 lg:px-24 py-8"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "pb-[30px] sm:pb-8 border-b border-slate-300 email"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        style: {
            color: "#243060"
        }
    }, "Email"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex justify-between items-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
        className: "text-sm sm:text-base break-all font-normal",
        style: {
            color: "#3B3B3B"
        }
    }, cookies.rp_user_data ? cookies.rp_user_data.email : ""))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "py-5 sm:py-8 border-b border-slate-300 password"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        style: {
            color: "#243060"
        }
    }, "Password"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        className: "text-sm font-normal",
        style: {
            color: "#3B3B3B"
        }
    }, "Current password"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "relative mb-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("input", {
        className: `pw-field appearance-none border ${formErrors.currentPassword !== "" ? "border-red-500" : ""} rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline`,
        id: "currentPassword",
        type: toggleAttributes.currentPassword,
        // placeholder={!accountSettingData.emailSource ? "set pa password" : ""}
        value: formData.currentPassword,
        onChange: handleChange,
        disabled: !accountSettingData.emailSource
    }), formData.currentPassword !== "" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("button", {
        tabIndex: -1,
        type: "button",
        id: "toggleCurrentPassword",
        onClick: ()=>handleTogglePassword("currentPassword")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("img", {
        src: toggleAttributes.currentPassword === "text" ? (0, (/*@__PURE__*/$parcel$interopDefault($a7ec1eb8e8517a72$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($11fee8f7274bba31$exports))),
        alt: "Show/Hide Password",
        id: "eye-icon"
    })), formErrors.currentPassword !== "" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        className: `text-red-500 text-xsm`
    }, formErrors.currentPassword))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "grid grid-cols-1 sm:grid-cols-2 gap-0 sm:gap-4 mt-3 mb-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        className: "text-sm font-normal",
        style: {
            color: "#3B3B3B"
        }
    }, "New password"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "relative mb-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("input", {
        className: `pw-field pw-position appearance-none border ${formErrors.password !== "" ? "border-red-500" : ""} rounded w-full py-2 px-3 text-gray-700  leading-tight focus:outline-none focus:shadow-outline`,
        id: "password",
        type: toggleAttributes.password,
        placeholder: "",
        value: formData.password,
        onChange: handleChange
    }), formData.password !== "" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("button", {
        tabIndex: -1,
        type: "button",
        id: "togglePassword",
        onClick: ()=>handleTogglePassword("password")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("img", {
        src: toggleAttributes.password === "text" ? (0, (/*@__PURE__*/$parcel$interopDefault($a7ec1eb8e8517a72$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($11fee8f7274bba31$exports))),
        alt: "Show/Hide Password",
        id: "eye-icon"
    })), formErrors.password !== "" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        className: `text-red-500 text-xsm leading-3`
    }, formErrors.password))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        className: "text-sm font-normal",
        style: {
            color: "#3B3B3B"
        }
    }, "Repeat password"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "relative mb-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("input", {
        className: `pw-field pw-position appearance-none border ${formErrors.rePassword !== "" ? "border-red-500" : ""} rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline`,
        id: "rePassword",
        type: toggleAttributes.rePassword,
        placeholder: "",
        value: formData.rePassword,
        onChange: handleChange
    }), formData.rePassword !== "" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("button", {
        tabIndex: -1,
        type: "button",
        id: "toggleRePassword",
        onClick: ()=>handleTogglePassword("rePassword")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("img", {
        src: toggleAttributes.rePassword === "text" ? (0, (/*@__PURE__*/$parcel$interopDefault($a7ec1eb8e8517a72$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($11fee8f7274bba31$exports))),
        alt: "Show/Hide Password",
        id: "eye-icon"
    })), formErrors.rePassword !== "" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        className: `text-red-500 text-xsm`
    }, formErrors.rePassword)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        className: "w-full",
        variant: "contained",
        size: "small",
        onClick: onUpdatePassword,
        sx: {
            backgroundColor: "#243060",
            border: "1px solid",
            borderColor: "#243060",
            color: "#fff",
            textTransform: "none",
            "&:hover": {
                backgroundColor: "#243060",
                color: "#fff"
            }
        }
    }, "Save"), updatePasswordRes.isVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "mt-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
        className: `${updatePasswordRes.isError ? "text-red-500" : "text-green-500"}`
    }, updatePasswordRes.message))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "pt-5 social-logins"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        style: {
            color: "#243060",
            marginBottom: "24px",
            display: "flex"
        }
    }, "Social logins"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex flex-col items-start justify-between sm:flex-row sm:items-center mb-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex items-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("img", {
        style: {
            marginRight: "16px",
            marginTop: "8px"
        },
        src: (parcelRequire("7kCot")),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex flex-col"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        style: {
            fontWeight: 600,
            color: "#3B3B3B"
        }
    }, "Google account"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", {
        style: {
            color: "#3B3B3B"
        },
        className: "mb-0 font-normal"
    }, accountSettingData.googleSource && accountSettingData.googleSource === true ? "Enabled " : "Disabled ", accountSettingData.googleSourceEmail && accountSettingData.googleSourceEmail !== accountSettingData.email && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", null, "(", accountSettingData.googleSourceEmail, ")")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex ml-8 mt-2 sm:ml-0 sm:mt-0"
    }, googleLinkRes.isVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "mt-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
        className: `text-xsm mx-2 ${googleLinkRes.isError ? "text-red-500" : "text-green-500"}`
    }, googleLinkRes.message)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        className: "px-4 py-2 w-24",
        variant: "contained",
        size: "small",
        onClick: ()=>{
            if (accountSettingData.googleSource && accountSettingData.googleSource === true) unLinkAccount("google");
            else googleLinkAccount();
        },
        sx: accountSettingData.googleSource && accountSettingData.googleSource === true ? styleDisabled : styleEnabled
    }, accountSettingData.googleSource && accountSettingData.googleSource === true ? "Disable" : "Enable"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex flex-col items-start justify-between sm:flex-row sm:items-center mb-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex items-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("img", {
        style: {
            marginRight: "16px",
            marginTop: "8px"
        },
        src: (parcelRequire("dnc3N")),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex flex-col"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        style: {
            fontWeight: 600,
            color: "#3B3B3B"
        }
    }, "LinkedIn account"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", {
        style: {
            color: "#3B3B3B"
        },
        className: "mb-0 font-normal"
    }, accountSettingData.linkedInSource && accountSettingData.linkedInSource === true ? "Enabled " : "Disabled ", accountSettingData.linkedInSourceEmail && accountSettingData.linkedInSourceEmail !== accountSettingData.email && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", null, "(", accountSettingData.linkedInSourceEmail, ")")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex ml-8 mt-2 sm:ml-0 sm:mt-0"
    }, linkedInLinkRes.isVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "mt-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("span", {
        className: `text-xsm mx-2 ${linkedInLinkRes.isError ? "text-red-500" : "text-green-500"}`
    }, linkedInLinkRes.message)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        className: "px-4 py-2 w-24",
        variant: "contained",
        size: "small",
        onClick: ()=>{
            if (accountSettingData.linkedInSource && accountSettingData.linkedInSource === true) unLinkAccount("linkedIn");
            else linkedInLogin();
        },
        sx: accountSettingData.linkedInSource && accountSettingData.linkedInSource === true ? styleDisabled : styleEnabled
    }, accountSettingData.linkedInSource && accountSettingData.linkedInSource === true ? "Disable" : "Enable"))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $fdcc8de0ec44fdd8$export$2e2bcd8739ae039), null));
};
var $63f5a8e49b0d65b1$export$2e2bcd8739ae039 = $63f5a8e49b0d65b1$var$AccountSetting;







var $8FY87 = parcelRequire("8FY87");





var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $lXBIJ = parcelRequire("lXBIJ");


var $ifmKX = parcelRequire("ifmKX");




var $6lkQ3 = parcelRequire("6lkQ3");

var $lbp1P = parcelRequire("lbp1P");

var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $d17d11ed528cf7f1$export$2177af0aa15c34c2(slot) {
    return (0, $jP65K.default)('MuiDialog', slot);
}
const $d17d11ed528cf7f1$var$dialogClasses = (0, $cOYaX.default)('MuiDialog', [
    'root',
    'scrollPaper',
    'scrollBody',
    'container',
    'paper',
    'paperScrollPaper',
    'paperScrollBody',
    'paperWidthFalse',
    'paperWidthXs',
    'paperWidthSm',
    'paperWidthMd',
    'paperWidthLg',
    'paperWidthXl',
    'paperFullWidth',
    'paperFullScreen'
]);
var $d17d11ed528cf7f1$export$2e2bcd8739ae039 = $d17d11ed528cf7f1$var$dialogClasses;



var $8FY87 = parcelRequire("8FY87");
const $70e0f2c2b1aaf389$var$DialogContext = /*#__PURE__*/ $8FY87.createContext({});
var $70e0f2c2b1aaf389$export$2e2bcd8739ae039 = $70e0f2c2b1aaf389$var$DialogContext;





var $2PPWI = parcelRequire("2PPWI");
'use client';
const $b9bff6d0b2f517f4$var$_excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $b9bff6d0b2f517f4$var$DialogBackdrop = (0, $lbp1P.default)((0, $56dcde36b8493878$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Backdrop',
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $b9bff6d0b2f517f4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        container: [
            'container',
            `scroll${(0, $ifmKX.default)(scroll)}`
        ],
        paper: [
            'paper',
            `paperScroll${(0, $ifmKX.default)(scroll)}`,
            `paperWidth${(0, $ifmKX.default)(String(maxWidth))}`,
            fullWidth && 'paperFullWidth',
            fullScreen && 'paperFullScreen'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $d17d11ed528cf7f1$export$2177af0aa15c34c2), classes);
};
const $b9bff6d0b2f517f4$var$DialogRoot = (0, $lbp1P.default)((0, $8f893b086317be6b$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
    }
});
const $b9bff6d0b2f517f4$var$DialogContainer = (0, $lbp1P.default)('div', {
    name: 'MuiDialog',
    slot: 'Container',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $ifmKX.default)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $zgVxD.default)({
        height: '100%',
        '@media print': {
            height: 'auto'
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === 'paper' && {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }, ownerState.scroll === 'body' && {
        overflowY: 'auto',
        overflowX: 'hidden',
        textAlign: 'center',
        '&::after': {
            content: '""',
            display: 'inline-block',
            verticalAlign: 'middle',
            height: '100%',
            width: '0'
        }
    }));
const $b9bff6d0b2f517f4$var$DialogPaper = (0, $lbp1P.default)((0, $d9c49ac25a55e29d$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $ifmKX.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $ifmKX.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $zgVxD.default)({
        margin: 32,
        position: 'relative',
        overflowY: 'auto',
        // Fix IE11 issue, to remove at some point.
        '@media print': {
            overflowY: 'visible',
            boxShadow: 'none'
        }
    }, ownerState.scroll === 'paper' && {
        display: 'flex',
        flexDirection: 'column',
        maxHeight: 'calc(100% - 64px)'
    }, ownerState.scroll === 'body' && {
        display: 'inline-block',
        verticalAlign: 'middle',
        textAlign: 'left' // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: 'calc(100% - 64px)'
    }, ownerState.maxWidth === 'xs' && {
        maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
        [`&.${(0, $d17d11ed528cf7f1$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: 'calc(100% - 64px)'
            }
        }
    }, ownerState.maxWidth && ownerState.maxWidth !== 'xs' && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, $d17d11ed528cf7f1$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: 'calc(100% - 64px)'
            }
        }
    }, ownerState.fullWidth && {
        width: 'calc(100% - 64px)'
    }, ownerState.fullScreen && {
        margin: 0,
        width: '100%',
        maxWidth: '100%',
        height: '100%',
        maxHeight: 'none',
        borderRadius: 0,
        [`&.${(0, $d17d11ed528cf7f1$export$2e2bcd8739ae039).paperScrollBody}`]: {
            margin: 0,
            maxWidth: '100%'
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $b9bff6d0b2f517f4$var$Dialog = /*#__PURE__*/ $8FY87.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiDialog'
    });
    const theme = (0, $0f82922e8f0d344d$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { 'aria-describedby': ariaDescribedby, 'aria-labelledby': ariaLabelledbyProp, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = 'sm', onBackdropClick: onBackdropClick, onClick: onClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $d9c49ac25a55e29d$export$2e2bcd8739ae039), PaperProps: PaperProps = {}, scroll: scroll = 'paper', TransitionComponent: TransitionComponent = (0, $e8b97d13d921cb51$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps } = props, other = (0, $93aRW.default)(props, $b9bff6d0b2f517f4$var$_excluded);
    const ownerState = (0, $zgVxD.default)({}, props, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    });
    const classes = $b9bff6d0b2f517f4$var$useUtilityClasses(ownerState);
    const backdropClick = $8FY87.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        if (onClick) onClick(event);
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, 'backdropClick');
    };
    const ariaLabelledby = (0, $a3608bb1fb347cd9$export$2e2bcd8739ae039)(ariaLabelledbyProp);
    const dialogContextValue = $8FY87.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $2PPWI.jsx)($b9bff6d0b2f517f4$var$DialogRoot, (0, $zgVxD.default)({
        className: (0, $efJYy.default)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: $b9bff6d0b2f517f4$var$DialogBackdrop
        },
        componentsProps: {
            backdrop: (0, $zgVxD.default)({
                transitionDuration: transitionDuration,
                as: BackdropComponent
            }, BackdropProps)
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $2PPWI.jsx)(TransitionComponent, (0, $zgVxD.default)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $2PPWI.jsx)($b9bff6d0b2f517f4$var$DialogContainer, {
                className: (0, $efJYy.default)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $2PPWI.jsx)($b9bff6d0b2f517f4$var$DialogPaper, (0, $zgVxD.default)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, $efJYy.default)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $70e0f2c2b1aaf389$export$2e2bcd8739ae039).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
var $b9bff6d0b2f517f4$export$2e2bcd8739ae039 = $b9bff6d0b2f517f4$var$Dialog;


var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $lXBIJ = parcelRequire("lXBIJ");

var $lbp1P = parcelRequire("lbp1P");

var $6lkQ3 = parcelRequire("6lkQ3");

var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $8bea6dc3fcfe84b6$export$5e57a444791c63be(slot) {
    return (0, $jP65K.default)('MuiDialogActions', slot);
}
const $8bea6dc3fcfe84b6$var$dialogActionsClasses = (0, $cOYaX.default)('MuiDialogActions', [
    'root',
    'spacing'
]);
var $8bea6dc3fcfe84b6$export$2e2bcd8739ae039 = $8bea6dc3fcfe84b6$var$dialogActionsClasses;



var $2PPWI = parcelRequire("2PPWI");
'use client';
const $dba36486529bbea3$var$_excluded = [
    "className",
    "disableSpacing"
];
const $dba36486529bbea3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $8bea6dc3fcfe84b6$export$5e57a444791c63be), classes);
};
const $dba36486529bbea3$var$DialogActionsRoot = (0, $lbp1P.default)('div', {
    name: 'MuiDialogActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $zgVxD.default)({
        display: 'flex',
        alignItems: 'center',
        padding: 8,
        justifyContent: 'flex-end',
        flex: '0 0 auto'
    }, !ownerState.disableSpacing && {
        '& > :not(style) ~ :not(style)': {
            marginLeft: 8
        }
    }));
const $dba36486529bbea3$var$DialogActions = /*#__PURE__*/ $8FY87.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogActions'
    });
    const { className: className, disableSpacing: disableSpacing = false } = props, other = (0, $93aRW.default)(props, $dba36486529bbea3$var$_excluded);
    const ownerState = (0, $zgVxD.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $dba36486529bbea3$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2PPWI.jsx)($dba36486529bbea3$var$DialogActionsRoot, (0, $zgVxD.default)({
        className: (0, $efJYy.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $dba36486529bbea3$export$2e2bcd8739ae039 = $dba36486529bbea3$var$DialogActions;


var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $lXBIJ = parcelRequire("lXBIJ");


var $lbp1P = parcelRequire("lbp1P");

var $6lkQ3 = parcelRequire("6lkQ3");

var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $49f216cc38081357$export$f5d2ec7e4c47e088(slot) {
    return (0, $jP65K.default)('MuiDialogTitle', slot);
}
const $49f216cc38081357$var$dialogTitleClasses = (0, $cOYaX.default)('MuiDialogTitle', [
    'root'
]);
var $49f216cc38081357$export$2e2bcd8739ae039 = $49f216cc38081357$var$dialogTitleClasses;




var $2PPWI = parcelRequire("2PPWI");
'use client';
const $81eaac82b5cc00cd$var$_excluded = [
    "className",
    "id"
];
const $81eaac82b5cc00cd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $49f216cc38081357$export$f5d2ec7e4c47e088), classes);
};
const $81eaac82b5cc00cd$var$DialogTitleRoot = (0, $lbp1P.default)((0, $9e9a2c609bdcf2f0$export$2e2bcd8739ae039), {
    name: 'MuiDialogTitle',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    padding: '16px 24px',
    flex: '0 0 auto'
});
const $81eaac82b5cc00cd$var$DialogTitle = /*#__PURE__*/ $8FY87.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogTitle'
    });
    const { className: className, id: idProp } = props, other = (0, $93aRW.default)(props, $81eaac82b5cc00cd$var$_excluded);
    const ownerState = props;
    const classes = $81eaac82b5cc00cd$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $8FY87.useContext((0, $70e0f2c2b1aaf389$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $2PPWI.jsx)($81eaac82b5cc00cd$var$DialogTitleRoot, (0, $zgVxD.default)({
        component: "h2",
        className: (0, $efJYy.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp != null ? idProp : titleId
    }, other));
});
var $81eaac82b5cc00cd$export$2e2bcd8739ae039 = $81eaac82b5cc00cd$var$DialogTitle;


var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $lXBIJ = parcelRequire("lXBIJ");


var $6lkQ3 = parcelRequire("6lkQ3");

var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $d9c5bdf36cf71bfc$export$427f1c1e2e839f85(slot) {
    return (0, $jP65K.default)('MuiPagination', slot);
}
const $d9c5bdf36cf71bfc$var$paginationClasses = (0, $cOYaX.default)('MuiPagination', [
    'root',
    'ul',
    'outlined',
    'text'
]);
var $d9c5bdf36cf71bfc$export$2e2bcd8739ae039 = $d9c5bdf36cf71bfc$var$paginationClasses;



var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");

'use client';
const $f5448056a0f01c5e$var$_excluded = [
    "boundaryCount",
    "componentName",
    "count",
    "defaultPage",
    "disabled",
    "hideNextButton",
    "hidePrevButton",
    "onChange",
    "page",
    "showFirstButton",
    "showLastButton",
    "siblingCount"
];
function $f5448056a0f01c5e$export$2e2bcd8739ae039(props = {}) {
    // keep default values in sync with @default tags in Pagination.propTypes
    const { boundaryCount: boundaryCount = 1, componentName: componentName = 'usePagination', count: count = 1, defaultPage: defaultPage = 1, disabled: disabled = false, hideNextButton: hideNextButton = false, hidePrevButton: hidePrevButton = false, onChange: handleChange, page: pageProp, showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, siblingCount: siblingCount = 1 } = props, other = (0, $93aRW.default)(props, $f5448056a0f01c5e$var$_excluded);
    const [page, setPageState] = (0, $0c786808b2800672$export$2e2bcd8739ae039)({
        controlled: pageProp,
        default: defaultPage,
        name: componentName,
        state: 'page'
    });
    const handleClick = (event, value)=>{
        if (!pageProp) setPageState(value);
        if (handleChange) handleChange(event, value);
    };
    // https://dev.to/namirsab/comment/2050
    const range = (start, end)=>{
        const length = end - start + 1;
        return Array.from({
            length: length
        }, (_, i)=>start + i);
    };
    const startPages = range(1, Math.min(boundaryCount, count));
    const endPages = range(Math.max(count - boundaryCount + 1, boundaryCount + 1), count);
    const siblingsStart = Math.max(Math.min(// Natural start
    page - siblingCount, // Lower boundary when page is high
    count - boundaryCount - siblingCount * 2 - 1), // Greater than startPages
    boundaryCount + 2);
    const siblingsEnd = Math.min(Math.max(// Natural end
    page + siblingCount, // Upper boundary when page is low
    boundaryCount + siblingCount * 2 + 2), // Less than endPages
    endPages.length > 0 ? endPages[0] - 2 : count - 1);
    // Basic list of items to render
    // for example itemList = ['first', 'previous', 1, 'ellipsis', 4, 5, 6, 'ellipsis', 10, 'next', 'last']
    const itemList = [
        ...showFirstButton ? [
            'first'
        ] : [],
        ...hidePrevButton ? [] : [
            'previous'
        ],
        ...startPages,
        // Start ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...siblingsStart > boundaryCount + 2 ? [
            'start-ellipsis'
        ] : boundaryCount + 1 < count - boundaryCount ? [
            boundaryCount + 1
        ] : [],
        // Sibling pages
        ...range(siblingsStart, siblingsEnd),
        // End ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...siblingsEnd < count - boundaryCount - 1 ? [
            'end-ellipsis'
        ] : count - boundaryCount > boundaryCount ? [
            count - boundaryCount
        ] : [],
        ...endPages,
        ...hideNextButton ? [] : [
            'next'
        ],
        ...showLastButton ? [
            'last'
        ] : []
    ];
    // Map the button type to its page number
    const buttonPage = (type)=>{
        switch(type){
            case 'first':
                return 1;
            case 'previous':
                return page - 1;
            case 'next':
                return page + 1;
            case 'last':
                return count;
            default:
                return null;
        }
    };
    // Convert the basic item list to PaginationItem props objects
    const items = itemList.map((item)=>{
        return typeof item === 'number' ? {
            onClick: (event)=>{
                handleClick(event, item);
            },
            type: 'page',
            page: item,
            selected: item === page,
            disabled: disabled,
            'aria-current': item === page ? 'true' : undefined
        } : {
            onClick: (event)=>{
                handleClick(event, buttonPage(item));
            },
            type: item,
            page: buttonPage(item),
            selected: false,
            disabled: disabled || item.indexOf('ellipsis') === -1 && (item === 'next' || item === 'last' ? page >= count : page <= 1)
        };
    });
    return (0, $zgVxD.default)({
        items: items
    }, other);
}



var $93aRW = parcelRequire("93aRW");

var $zgVxD = parcelRequire("zgVxD");

var $8FY87 = parcelRequire("8FY87");


var $efJYy = parcelRequire("efJYy");

var $lXBIJ = parcelRequire("lXBIJ");

var $1r55V = parcelRequire("1r55V");


var $6lkQ3 = parcelRequire("6lkQ3");

var $cOYaX = parcelRequire("cOYaX");

var $jP65K = parcelRequire("jP65K");
function $dc198e35c778e82e$export$e4ce0a775adf2f74(slot) {
    return (0, $jP65K.default)('MuiPaginationItem', slot);
}
const $dc198e35c778e82e$var$paginationItemClasses = (0, $cOYaX.default)('MuiPaginationItem', [
    'root',
    'page',
    'sizeSmall',
    'sizeLarge',
    'text',
    'textPrimary',
    'textSecondary',
    'outlined',
    'outlinedPrimary',
    'outlinedSecondary',
    'rounded',
    'ellipsis',
    'firstLast',
    'previousNext',
    'focusVisible',
    'disabled',
    'selected',
    'icon',
    'colorPrimary',
    'colorSecondary'
]);
var $dc198e35c778e82e$export$2e2bcd8739ae039 = $dc198e35c778e82e$var$paginationItemClasses;




var $ifmKX = parcelRequire("ifmKX");
parcelRequire("8FY87");

var $cHXYB = parcelRequire("cHXYB");

var $2PPWI = parcelRequire("2PPWI");
'use client';
var $c9cacf58f2a3bddd$export$2e2bcd8739ae039 = (0, $cHXYB.default)(/*#__PURE__*/ (0, $2PPWI.jsx)("path", {
    d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), 'FirstPage');


parcelRequire("8FY87");

var $cHXYB = parcelRequire("cHXYB");

var $2PPWI = parcelRequire("2PPWI");
'use client';
var $977afdfde6bc352c$export$2e2bcd8739ae039 = (0, $cHXYB.default)(/*#__PURE__*/ (0, $2PPWI.jsx)("path", {
    d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), 'LastPage');


parcelRequire("8FY87");

var $cHXYB = parcelRequire("cHXYB");

var $2PPWI = parcelRequire("2PPWI");
'use client';
var $f4a21958f0e917a7$export$2e2bcd8739ae039 = (0, $cHXYB.default)(/*#__PURE__*/ (0, $2PPWI.jsx)("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), 'NavigateBefore');


parcelRequire("8FY87");

var $cHXYB = parcelRequire("cHXYB");

var $2PPWI = parcelRequire("2PPWI");
'use client';
var $50ae9f942f047edd$export$2e2bcd8739ae039 = (0, $cHXYB.default)(/*#__PURE__*/ (0, $2PPWI.jsx)("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'NavigateNext');



var $lbp1P = parcelRequire("lbp1P");

var $2PPWI = parcelRequire("2PPWI");
'use client';
const $5feddb68855d5933$var$_excluded = [
    "className",
    "color",
    "component",
    "components",
    "disabled",
    "page",
    "selected",
    "shape",
    "size",
    "slots",
    "type",
    "variant"
];
const $5feddb68855d5933$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[ownerState.variant],
        styles[`size${(0, $ifmKX.default)(ownerState.size)}`],
        ownerState.variant === 'text' && styles[`text${(0, $ifmKX.default)(ownerState.color)}`],
        ownerState.variant === 'outlined' && styles[`outlined${(0, $ifmKX.default)(ownerState.color)}`],
        ownerState.shape === 'rounded' && styles.rounded,
        ownerState.type === 'page' && styles.page,
        (ownerState.type === 'start-ellipsis' || ownerState.type === 'end-ellipsis') && styles.ellipsis,
        (ownerState.type === 'previous' || ownerState.type === 'next') && styles.previousNext,
        (ownerState.type === 'first' || ownerState.type === 'last') && styles.firstLast
    ];
};
const $5feddb68855d5933$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, selected: selected, size: size, shape: shape, type: type, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            `size${(0, $ifmKX.default)(size)}`,
            variant,
            shape,
            color !== 'standard' && `color${(0, $ifmKX.default)(color)}`,
            color !== 'standard' && `${variant}${(0, $ifmKX.default)(color)}`,
            disabled && 'disabled',
            selected && 'selected',
            {
                page: 'page',
                first: 'firstLast',
                last: 'firstLast',
                'start-ellipsis': 'ellipsis',
                'end-ellipsis': 'ellipsis',
                previous: 'previousNext',
                next: 'previousNext'
            }[type]
        ],
        icon: [
            'icon'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $dc198e35c778e82e$export$e4ce0a775adf2f74), classes);
};
const $5feddb68855d5933$var$PaginationItemEllipsis = (0, $lbp1P.default)('div', {
    name: 'MuiPaginationItem',
    slot: 'Root',
    overridesResolver: $5feddb68855d5933$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $zgVxD.default)({}, theme.typography.body2, {
        borderRadius: 16,
        textAlign: 'center',
        boxSizing: 'border-box',
        minWidth: 32,
        padding: '0 6px',
        margin: '0 3px',
        color: (theme.vars || theme).palette.text.primary,
        height: 'auto',
        [`&.${(0, $dc198e35c778e82e$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.size === 'small' && {
        minWidth: 26,
        borderRadius: 13,
        margin: '0 1px',
        padding: '0 4px'
    }, ownerState.size === 'large' && {
        minWidth: 40,
        borderRadius: 20,
        padding: '0 10px',
        fontSize: theme.typography.pxToRem(15)
    }));
const $5feddb68855d5933$var$PaginationItemPage = (0, $lbp1P.default)((0, $21281888ae95b2bd$export$2e2bcd8739ae039), {
    name: 'MuiPaginationItem',
    slot: 'Root',
    overridesResolver: $5feddb68855d5933$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $zgVxD.default)({}, theme.typography.body2, {
        borderRadius: 16,
        textAlign: 'center',
        boxSizing: 'border-box',
        minWidth: 32,
        height: 32,
        padding: '0 6px',
        margin: '0 3px',
        color: (theme.vars || theme).palette.text.primary,
        [`&.${(0, $dc198e35c778e82e$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $dc198e35c778e82e$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        transition: theme.transitions.create([
            'color',
            'background-color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': {
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $dc198e35c778e82e$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: (theme.vars || theme).palette.action.selected,
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $1r55V.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: (theme.vars || theme).palette.action.selected
                }
            },
            [`&.${(0, $dc198e35c778e82e$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $1r55V.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            },
            [`&.${(0, $dc198e35c778e82e$export$2e2bcd8739ae039).disabled}`]: {
                opacity: 1,
                color: (theme.vars || theme).palette.action.disabled,
                backgroundColor: (theme.vars || theme).palette.action.selected
            }
        }
    }, ownerState.size === 'small' && {
        minWidth: 26,
        height: 26,
        borderRadius: 13,
        margin: '0 1px',
        padding: '0 4px'
    }, ownerState.size === 'large' && {
        minWidth: 40,
        height: 40,
        borderRadius: 20,
        padding: '0 10px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.shape === 'rounded' && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }), ({ theme: theme, ownerState: ownerState })=>(0, $zgVxD.default)({}, ownerState.variant === 'text' && {
        [`&.${(0, $dc198e35c778e82e$export$2e2bcd8739ae039).selected}`]: (0, $zgVxD.default)({}, ownerState.color !== 'standard' && {
            color: (theme.vars || theme).palette[ownerState.color].contrastText,
            backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
            '&:hover': {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: (theme.vars || theme).palette[ownerState.color].main
                }
            },
            [`&.${(0, $dc198e35c778e82e$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
            }
        }, {
            [`&.${(0, $dc198e35c778e82e$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.action.disabled
            }
        })
    }, ownerState.variant === 'outlined' && {
        border: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
        [`&.${(0, $dc198e35c778e82e$export$2e2bcd8739ae039).selected}`]: (0, $zgVxD.default)({}, ownerState.color !== 'standard' && {
            color: (theme.vars || theme).palette[ownerState.color].main,
            border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : (0, $1r55V.alpha)(theme.palette[ownerState.color].main, 0.5)}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.activatedOpacity})` : (0, $1r55V.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity),
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / calc(${theme.vars.palette.action.activatedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $1r55V.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity + theme.palette.action.focusOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            [`&.${(0, $dc198e35c778e82e$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / calc(${theme.vars.palette.action.activatedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $1r55V.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity + theme.palette.action.focusOpacity)
            }
        }, {
            [`&.${(0, $dc198e35c778e82e$export$2e2bcd8739ae039).disabled}`]: {
                borderColor: (theme.vars || theme).palette.action.disabledBackground,
                color: (theme.vars || theme).palette.action.disabled
            }
        })
    }));
const $5feddb68855d5933$var$PaginationItemPageIcon = (0, $lbp1P.default)('div', {
    name: 'MuiPaginationItem',
    slot: 'Icon',
    overridesResolver: (props, styles)=>styles.icon
})(({ theme: theme, ownerState: ownerState })=>(0, $zgVxD.default)({
        fontSize: theme.typography.pxToRem(20),
        margin: '0 -8px'
    }, ownerState.size === 'small' && {
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === 'large' && {
        fontSize: theme.typography.pxToRem(22)
    }));
const $5feddb68855d5933$var$PaginationItem = /*#__PURE__*/ $8FY87.forwardRef(function PaginationItem(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiPaginationItem'
    });
    const { className: className, color: color = 'standard', component: component, components: components = {}, disabled: disabled = false, page: page, selected: selected = false, shape: shape = 'circular', size: size = 'medium', slots: slots = {}, type: type = 'page', variant: variant = 'text' } = props, other = (0, $93aRW.default)(props, $5feddb68855d5933$var$_excluded);
    const ownerState = (0, $zgVxD.default)({}, props, {
        color: color,
        disabled: disabled,
        selected: selected,
        shape: shape,
        size: size,
        type: type,
        variant: variant
    });
    const isRtl = (0, $fd8721cf96f8ae09$export$b2dd014b6c321cb)();
    const classes = $5feddb68855d5933$var$useUtilityClasses(ownerState);
    const normalizedIcons = isRtl ? {
        previous: slots.next || components.next || (0, $50ae9f942f047edd$export$2e2bcd8739ae039),
        next: slots.previous || components.previous || (0, $f4a21958f0e917a7$export$2e2bcd8739ae039),
        last: slots.first || components.first || (0, $c9cacf58f2a3bddd$export$2e2bcd8739ae039),
        first: slots.last || components.last || (0, $977afdfde6bc352c$export$2e2bcd8739ae039)
    } : {
        previous: slots.previous || components.previous || (0, $f4a21958f0e917a7$export$2e2bcd8739ae039),
        next: slots.next || components.next || (0, $50ae9f942f047edd$export$2e2bcd8739ae039),
        first: slots.first || components.first || (0, $c9cacf58f2a3bddd$export$2e2bcd8739ae039),
        last: slots.last || components.last || (0, $977afdfde6bc352c$export$2e2bcd8739ae039)
    };
    const Icon = normalizedIcons[type];
    return type === 'start-ellipsis' || type === 'end-ellipsis' ? /*#__PURE__*/ (0, $2PPWI.jsx)($5feddb68855d5933$var$PaginationItemEllipsis, {
        ref: ref,
        ownerState: ownerState,
        className: (0, $efJYy.default)(classes.root, className),
        children: "\u2026"
    }) : /*#__PURE__*/ (0, $2PPWI.jsxs)($5feddb68855d5933$var$PaginationItemPage, (0, $zgVxD.default)({
        ref: ref,
        ownerState: ownerState,
        component: component,
        disabled: disabled,
        className: (0, $efJYy.default)(classes.root, className)
    }, other, {
        children: [
            type === 'page' && page,
            Icon ? /*#__PURE__*/ (0, $2PPWI.jsx)($5feddb68855d5933$var$PaginationItemPageIcon, {
                as: Icon,
                ownerState: ownerState,
                className: classes.icon
            }) : null
        ]
    }));
});
var $5feddb68855d5933$export$2e2bcd8739ae039 = $5feddb68855d5933$var$PaginationItem;



var $lbp1P = parcelRequire("lbp1P");

var $2PPWI = parcelRequire("2PPWI");
'use client';
const $ba2c328083ea94b4$var$_excluded = [
    "boundaryCount",
    "className",
    "color",
    "count",
    "defaultPage",
    "disabled",
    "getItemAriaLabel",
    "hideNextButton",
    "hidePrevButton",
    "onChange",
    "page",
    "renderItem",
    "shape",
    "showFirstButton",
    "showLastButton",
    "siblingCount",
    "size",
    "variant"
];
const $ba2c328083ea94b4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant
        ],
        ul: [
            'ul'
        ]
    };
    return (0, $lXBIJ.default)(slots, (0, $d9c5bdf36cf71bfc$export$427f1c1e2e839f85), classes);
};
const $ba2c328083ea94b4$var$PaginationRoot = (0, $lbp1P.default)('nav', {
    name: 'MuiPagination',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant]
        ];
    }
})({});
const $ba2c328083ea94b4$var$PaginationUl = (0, $lbp1P.default)('ul', {
    name: 'MuiPagination',
    slot: 'Ul',
    overridesResolver: (props, styles)=>styles.ul
})({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    listStyle: 'none'
});
function $ba2c328083ea94b4$var$defaultGetAriaLabel(type, page, selected) {
    if (type === 'page') return `${selected ? '' : 'Go to '}page ${page}`;
    return `Go to ${type} page`;
}
const $ba2c328083ea94b4$var$Pagination = /*#__PURE__*/ $8FY87.forwardRef(function Pagination(inProps, ref) {
    const props = (0, $6lkQ3.useDefaultProps)({
        props: inProps,
        name: 'MuiPagination'
    });
    const { boundaryCount: boundaryCount = 1, className: className, color: color = 'standard', count: count = 1, defaultPage: defaultPage = 1, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel = $ba2c328083ea94b4$var$defaultGetAriaLabel, hideNextButton: hideNextButton = false, hidePrevButton: hidePrevButton = false, renderItem: renderItem = (item)=>/*#__PURE__*/ (0, $2PPWI.jsx)((0, $5feddb68855d5933$export$2e2bcd8739ae039), (0, $zgVxD.default)({}, item)), shape: shape = 'circular', showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, siblingCount: siblingCount = 1, size: size = 'medium', variant: variant = 'text' } = props, other = (0, $93aRW.default)(props, $ba2c328083ea94b4$var$_excluded);
    const { items: items } = (0, $f5448056a0f01c5e$export$2e2bcd8739ae039)((0, $zgVxD.default)({}, props, {
        componentName: 'Pagination'
    }));
    const ownerState = (0, $zgVxD.default)({}, props, {
        boundaryCount: boundaryCount,
        color: color,
        count: count,
        defaultPage: defaultPage,
        disabled: disabled,
        getItemAriaLabel: getItemAriaLabel,
        hideNextButton: hideNextButton,
        hidePrevButton: hidePrevButton,
        renderItem: renderItem,
        shape: shape,
        showFirstButton: showFirstButton,
        showLastButton: showLastButton,
        siblingCount: siblingCount,
        size: size,
        variant: variant
    });
    const classes = $ba2c328083ea94b4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2PPWI.jsx)($ba2c328083ea94b4$var$PaginationRoot, (0, $zgVxD.default)({
        "aria-label": "pagination navigation",
        className: (0, $efJYy.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: /*#__PURE__*/ (0, $2PPWI.jsx)($ba2c328083ea94b4$var$PaginationUl, {
            className: classes.ul,
            ownerState: ownerState,
            children: items.map((item, index)=>/*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                    children: renderItem((0, $zgVxD.default)({}, item, {
                        color: color,
                        'aria-label': getItemAriaLabel(item.type, item.page, item.selected),
                        shape: shape,
                        size: size,
                        variant: variant
                    }))
                }, index))
        })
    }));
});
var $ba2c328083ea94b4$export$2e2bcd8739ae039 = $ba2c328083ea94b4$var$Pagination;



var $8FY87 = parcelRequire("8FY87");

// import "quill/dist/quill.snow.css";
var $710cce91ee8d14b2$exports = {};
"use strict";
"use client";

var $bcBLN = parcelRequire("bcBLN");
Object.defineProperty($710cce91ee8d14b2$exports, "__esModule", {
    value: true
});
$710cce91ee8d14b2$exports.default = void 0;

var $710cce91ee8d14b2$var$_createSvgIcon = $bcBLN((parcelRequire("485sq")));

var $2PPWI = parcelRequire("2PPWI");
var $710cce91ee8d14b2$var$_default = $710cce91ee8d14b2$exports.default = (0, $710cce91ee8d14b2$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2PPWI.jsx)("path", {
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z"
}), 'ArrowBackOutlined');





var $8FY87 = parcelRequire("8FY87");



var $569e748944e69916$exports = {};

$parcel$export($569e748944e69916$exports, "Scope", function () { return $569e748944e69916$export$775b6bb06e53a214; });
$parcel$export($569e748944e69916$exports, "Attributor", function () { return $569e748944e69916$export$217610c4183502d0; });
$parcel$export($569e748944e69916$exports, "Registry", function () { return $569e748944e69916$export$4d9facee29974f3; });
$parcel$export($569e748944e69916$exports, "ClassAttributor", function () { return $569e748944e69916$export$651d45509677cf07; });
$parcel$export($569e748944e69916$exports, "StyleAttributor", function () { return $569e748944e69916$export$7c8099bbfe87b94d; });
$parcel$export($569e748944e69916$exports, "AttributorStore", function () { return $569e748944e69916$export$68ad86ab95e8de42; });
$parcel$export($569e748944e69916$exports, "LeafBlot", function () { return $569e748944e69916$export$7420b9c542181544; });
$parcel$export($569e748944e69916$exports, "ParentBlot", function () { return $569e748944e69916$export$e43113f0aad76fe; });
$parcel$export($569e748944e69916$exports, "InlineBlot", function () { return $569e748944e69916$export$f67a34bc25a7a861; });
$parcel$export($569e748944e69916$exports, "BlockBlot", function () { return $569e748944e69916$export$4f7f03641f7bfc8c; });
$parcel$export($569e748944e69916$exports, "ContainerBlot", function () { return $569e748944e69916$export$c898d510319704c0; });
$parcel$export($569e748944e69916$exports, "EmbedBlot", function () { return $569e748944e69916$export$297a1fa96f55f00f; });
$parcel$export($569e748944e69916$exports, "ScrollBlot", function () { return $569e748944e69916$export$7175329dad7a46f1; });
$parcel$export($569e748944e69916$exports, "TextBlot", function () { return $569e748944e69916$export$10ac0c5716409de6; });
var $569e748944e69916$export$775b6bb06e53a214 = /* @__PURE__ */ ((Scope2)=>(Scope2[Scope2.TYPE = 3] = "TYPE", Scope2[Scope2.LEVEL = 12] = "LEVEL", Scope2[Scope2.ATTRIBUTE = 13] = "ATTRIBUTE", Scope2[Scope2.BLOT = 14] = "BLOT", Scope2[Scope2.INLINE = 7] = "INLINE", Scope2[Scope2.BLOCK = 11] = "BLOCK", Scope2[Scope2.BLOCK_BLOT = 10] = "BLOCK_BLOT", Scope2[Scope2.INLINE_BLOT = 6] = "INLINE_BLOT", Scope2[Scope2.BLOCK_ATTRIBUTE = 9] = "BLOCK_ATTRIBUTE", Scope2[Scope2.INLINE_ATTRIBUTE = 5] = "INLINE_ATTRIBUTE", Scope2[Scope2.ANY = 15] = "ANY", Scope2))($569e748944e69916$export$775b6bb06e53a214 || {});
class $569e748944e69916$export$217610c4183502d0 {
    constructor(attrName, keyName, options = {}){
        this.attrName = attrName, this.keyName = keyName;
        const attributeBit = $569e748944e69916$export$775b6bb06e53a214.TYPE & $569e748944e69916$export$775b6bb06e53a214.ATTRIBUTE;
        this.scope = options.scope != null ? // Ignore type bits, force attribute bit
        options.scope & $569e748944e69916$export$775b6bb06e53a214.LEVEL | attributeBit : $569e748944e69916$export$775b6bb06e53a214.ATTRIBUTE, options.whitelist != null && (this.whitelist = options.whitelist);
    }
    static keys(node) {
        return Array.from(node.attributes).map((item)=>item.name);
    }
    add(node, value) {
        return this.canAdd(node, value) ? (node.setAttribute(this.keyName, value), !0) : !1;
    }
    canAdd(_node, value) {
        return this.whitelist == null ? !0 : typeof value == "string" ? this.whitelist.indexOf(value.replace(/["']/g, "")) > -1 : this.whitelist.indexOf(value) > -1;
    }
    remove(node) {
        node.removeAttribute(this.keyName);
    }
    value(node) {
        const value = node.getAttribute(this.keyName);
        return this.canAdd(node, value) && value ? value : "";
    }
}
class $569e748944e69916$var$ParchmentError extends Error {
    constructor(message){
        message = "[Parchment] " + message, super(message), this.message = message, this.name = this.constructor.name;
    }
}
const $569e748944e69916$var$_Registry = class _Registry {
    constructor(){
        this.attributes = {}, this.classes = {}, this.tags = {}, this.types = {};
    }
    static find(node, bubble = !1) {
        if (node == null) return null;
        if (this.blots.has(node)) return this.blots.get(node) || null;
        if (bubble) {
            let parentNode = null;
            try {
                parentNode = node.parentNode;
            } catch  {
                return null;
            }
            return this.find(parentNode, bubble);
        }
        return null;
    }
    create(scroll, input, value) {
        const match2 = this.query(input);
        if (match2 == null) throw new $569e748944e69916$var$ParchmentError(`Unable to create ${input} blot`);
        const blotClass = match2, node = // @ts-expect-error Fix me later
        input instanceof Node || input.nodeType === Node.TEXT_NODE ? input : blotClass.create(value), blot = new blotClass(scroll, node, value);
        return _Registry.blots.set(blot.domNode, blot), blot;
    }
    find(node, bubble = !1) {
        return _Registry.find(node, bubble);
    }
    query(query, scope = $569e748944e69916$export$775b6bb06e53a214.ANY) {
        let match2;
        return typeof query == "string" ? match2 = this.types[query] || this.attributes[query] : query instanceof Text || query.nodeType === Node.TEXT_NODE ? match2 = this.types.text : typeof query == "number" ? query & $569e748944e69916$export$775b6bb06e53a214.LEVEL & $569e748944e69916$export$775b6bb06e53a214.BLOCK ? match2 = this.types.block : query & $569e748944e69916$export$775b6bb06e53a214.LEVEL & $569e748944e69916$export$775b6bb06e53a214.INLINE && (match2 = this.types.inline) : query instanceof Element && ((query.getAttribute("class") || "").split(/\s+/).some((name)=>(match2 = this.classes[name], !!match2)), match2 = match2 || this.tags[query.tagName]), match2 == null ? null : "scope" in match2 && scope & $569e748944e69916$export$775b6bb06e53a214.LEVEL & match2.scope && scope & $569e748944e69916$export$775b6bb06e53a214.TYPE & match2.scope ? match2 : null;
    }
    register(...definitions) {
        return definitions.map((definition)=>{
            const isBlot = "blotName" in definition, isAttr = "attrName" in definition;
            if (!isBlot && !isAttr) throw new $569e748944e69916$var$ParchmentError("Invalid definition");
            if (isBlot && definition.blotName === "abstract") throw new $569e748944e69916$var$ParchmentError("Cannot register abstract class");
            const key = isBlot ? definition.blotName : isAttr ? definition.attrName : void 0;
            return this.types[key] = definition, isAttr ? typeof definition.keyName == "string" && (this.attributes[definition.keyName] = definition) : isBlot && (definition.className && (this.classes[definition.className] = definition), definition.tagName && (Array.isArray(definition.tagName) ? definition.tagName = definition.tagName.map((tagName)=>tagName.toUpperCase()) : definition.tagName = definition.tagName.toUpperCase(), (Array.isArray(definition.tagName) ? definition.tagName : [
                definition.tagName
            ]).forEach((tag)=>{
                (this.tags[tag] == null || definition.className == null) && (this.tags[tag] = definition);
            }))), definition;
        });
    }
};
$569e748944e69916$var$_Registry.blots = /* @__PURE__ */ new WeakMap();
let $569e748944e69916$export$4d9facee29974f3 = $569e748944e69916$var$_Registry;
function $569e748944e69916$var$match(node, prefix) {
    return (node.getAttribute("class") || "").split(/\s+/).filter((name)=>name.indexOf(`${prefix}-`) === 0);
}
class $569e748944e69916$var$ClassAttributor extends $569e748944e69916$export$217610c4183502d0 {
    static keys(node) {
        return (node.getAttribute("class") || "").split(/\s+/).map((name)=>name.split("-").slice(0, -1).join("-"));
    }
    add(node, value) {
        return this.canAdd(node, value) ? (this.remove(node), node.classList.add(`${this.keyName}-${value}`), !0) : !1;
    }
    remove(node) {
        $569e748944e69916$var$match(node, this.keyName).forEach((name)=>{
            node.classList.remove(name);
        }), node.classList.length === 0 && node.removeAttribute("class");
    }
    value(node) {
        const value = ($569e748944e69916$var$match(node, this.keyName)[0] || "").slice(this.keyName.length + 1);
        return this.canAdd(node, value) ? value : "";
    }
}
const $569e748944e69916$export$651d45509677cf07 = $569e748944e69916$var$ClassAttributor;
function $569e748944e69916$var$camelize(name) {
    const parts = name.split("-"), rest = parts.slice(1).map((part)=>part[0].toUpperCase() + part.slice(1)).join("");
    return parts[0] + rest;
}
class $569e748944e69916$var$StyleAttributor extends $569e748944e69916$export$217610c4183502d0 {
    static keys(node) {
        return (node.getAttribute("style") || "").split(";").map((value)=>value.split(":")[0].trim());
    }
    add(node, value) {
        return this.canAdd(node, value) ? (node.style[$569e748944e69916$var$camelize(this.keyName)] = value, !0) : !1;
    }
    remove(node) {
        node.style[$569e748944e69916$var$camelize(this.keyName)] = "", node.getAttribute("style") || node.removeAttribute("style");
    }
    value(node) {
        const value = node.style[$569e748944e69916$var$camelize(this.keyName)];
        return this.canAdd(node, value) ? value : "";
    }
}
const $569e748944e69916$export$7c8099bbfe87b94d = $569e748944e69916$var$StyleAttributor;
class $569e748944e69916$var$AttributorStore {
    constructor(domNode){
        this.attributes = {}, this.domNode = domNode, this.build();
    }
    attribute(attribute, value) {
        value ? attribute.add(this.domNode, value) && (attribute.value(this.domNode) != null ? this.attributes[attribute.attrName] = attribute : delete this.attributes[attribute.attrName]) : (attribute.remove(this.domNode), delete this.attributes[attribute.attrName]);
    }
    build() {
        this.attributes = {};
        const blot = $569e748944e69916$export$4d9facee29974f3.find(this.domNode);
        if (blot == null) return;
        const attributes = $569e748944e69916$export$217610c4183502d0.keys(this.domNode), classes = $569e748944e69916$export$651d45509677cf07.keys(this.domNode), styles = $569e748944e69916$export$7c8099bbfe87b94d.keys(this.domNode);
        attributes.concat(classes).concat(styles).forEach((name)=>{
            const attr = blot.scroll.query(name, $569e748944e69916$export$775b6bb06e53a214.ATTRIBUTE);
            attr instanceof $569e748944e69916$export$217610c4183502d0 && (this.attributes[attr.attrName] = attr);
        });
    }
    copy(target) {
        Object.keys(this.attributes).forEach((key)=>{
            const value = this.attributes[key].value(this.domNode);
            target.format(key, value);
        });
    }
    move(target) {
        this.copy(target), Object.keys(this.attributes).forEach((key)=>{
            this.attributes[key].remove(this.domNode);
        }), this.attributes = {};
    }
    values() {
        return Object.keys(this.attributes).reduce((attributes, name)=>(attributes[name] = this.attributes[name].value(this.domNode), attributes), {});
    }
}
const $569e748944e69916$export$68ad86ab95e8de42 = $569e748944e69916$var$AttributorStore, $569e748944e69916$var$_ShadowBlot = class _ShadowBlot {
    constructor(scroll, domNode){
        this.scroll = scroll, this.domNode = domNode, $569e748944e69916$export$4d9facee29974f3.blots.set(domNode, this), this.prev = null, this.next = null;
    }
    static create(rawValue) {
        if (this.tagName == null) throw new $569e748944e69916$var$ParchmentError("Blot definition missing tagName");
        let node, value;
        return Array.isArray(this.tagName) ? (typeof rawValue == "string" ? (value = rawValue.toUpperCase(), parseInt(value, 10).toString() === value && (value = parseInt(value, 10))) : typeof rawValue == "number" && (value = rawValue), typeof value == "number" ? node = document.createElement(this.tagName[value - 1]) : value && this.tagName.indexOf(value) > -1 ? node = document.createElement(value) : node = document.createElement(this.tagName[0])) : node = document.createElement(this.tagName), this.className && node.classList.add(this.className), node;
    }
    // Hack for accessing inherited static methods
    get statics() {
        return this.constructor;
    }
    attach() {}
    clone() {
        const domNode = this.domNode.cloneNode(!1);
        return this.scroll.create(domNode);
    }
    detach() {
        this.parent != null && this.parent.removeChild(this), $569e748944e69916$export$4d9facee29974f3.blots.delete(this.domNode);
    }
    deleteAt(index, length) {
        this.isolate(index, length).remove();
    }
    formatAt(index, length, name, value) {
        const blot = this.isolate(index, length);
        if (this.scroll.query(name, $569e748944e69916$export$775b6bb06e53a214.BLOT) != null && value) blot.wrap(name, value);
        else if (this.scroll.query(name, $569e748944e69916$export$775b6bb06e53a214.ATTRIBUTE) != null) {
            const parent = this.scroll.create(this.statics.scope);
            blot.wrap(parent), parent.format(name, value);
        }
    }
    insertAt(index, value, def) {
        const blot = def == null ? this.scroll.create("text", value) : this.scroll.create(value, def), ref = this.split(index);
        this.parent.insertBefore(blot, ref || void 0);
    }
    isolate(index, length) {
        const target = this.split(index);
        if (target == null) throw new Error("Attempt to isolate at end");
        return target.split(length), target;
    }
    length() {
        return 1;
    }
    offset(root = this.parent) {
        return this.parent == null || this === root ? 0 : this.parent.children.offset(this) + this.parent.offset(root);
    }
    optimize(_context) {
        this.statics.requiredContainer && !(this.parent instanceof this.statics.requiredContainer) && this.wrap(this.statics.requiredContainer.blotName);
    }
    remove() {
        this.domNode.parentNode != null && this.domNode.parentNode.removeChild(this.domNode), this.detach();
    }
    replaceWith(name, value) {
        const replacement = typeof name == "string" ? this.scroll.create(name, value) : name;
        return this.parent != null && (this.parent.insertBefore(replacement, this.next || void 0), this.remove()), replacement;
    }
    split(index, _force) {
        return index === 0 ? this : this.next;
    }
    update(_mutations, _context) {}
    wrap(name, value) {
        const wrapper = typeof name == "string" ? this.scroll.create(name, value) : name;
        if (this.parent != null && this.parent.insertBefore(wrapper, this.next || void 0), typeof wrapper.appendChild != "function") throw new $569e748944e69916$var$ParchmentError(`Cannot wrap ${name}`);
        return wrapper.appendChild(this), wrapper;
    }
};
$569e748944e69916$var$_ShadowBlot.blotName = "abstract";
let $569e748944e69916$var$ShadowBlot = $569e748944e69916$var$_ShadowBlot;
const $569e748944e69916$var$_LeafBlot = class _LeafBlot extends $569e748944e69916$var$ShadowBlot {
    /**
   * Returns the value represented by domNode if it is this Blot's type
   * No checking that domNode can represent this Blot type is required so
   * applications needing it should check externally before calling.
   */ static value(_domNode) {
        return !0;
    }
    /**
   * Given location represented by node and offset from DOM Selection Range,
   * return index to that location.
   */ index(node, offset) {
        return this.domNode === node || this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY ? Math.min(offset, 1) : -1;
    }
    /**
   * Given index to location within blot, return node and offset representing
   * that location, consumable by DOM Selection Range
   */ position(index, _inclusive) {
        let offset = Array.from(this.parent.domNode.childNodes).indexOf(this.domNode);
        return index > 0 && (offset += 1), [
            this.parent.domNode,
            offset
        ];
    }
    /**
   * Return value represented by this blot
   * Should not change without interaction from API or
   * user change detectable by update()
   */ value() {
        return {
            [this.statics.blotName]: this.statics.value(this.domNode) || !0
        };
    }
};
$569e748944e69916$var$_LeafBlot.scope = $569e748944e69916$export$775b6bb06e53a214.INLINE_BLOT;
let $569e748944e69916$var$LeafBlot = $569e748944e69916$var$_LeafBlot;
const $569e748944e69916$export$7420b9c542181544 = $569e748944e69916$var$LeafBlot;
class $569e748944e69916$var$LinkedList {
    constructor(){
        this.head = null, this.tail = null, this.length = 0;
    }
    append(...nodes) {
        if (this.insertBefore(nodes[0], null), nodes.length > 1) {
            const rest = nodes.slice(1);
            this.append(...rest);
        }
    }
    at(index) {
        const next = this.iterator();
        let cur = next();
        for(; cur && index > 0;)index -= 1, cur = next();
        return cur;
    }
    contains(node) {
        const next = this.iterator();
        let cur = next();
        for(; cur;){
            if (cur === node) return !0;
            cur = next();
        }
        return !1;
    }
    indexOf(node) {
        const next = this.iterator();
        let cur = next(), index = 0;
        for(; cur;){
            if (cur === node) return index;
            index += 1, cur = next();
        }
        return -1;
    }
    insertBefore(node, refNode) {
        node != null && (this.remove(node), node.next = refNode, refNode != null ? (node.prev = refNode.prev, refNode.prev != null && (refNode.prev.next = node), refNode.prev = node, refNode === this.head && (this.head = node)) : this.tail != null ? (this.tail.next = node, node.prev = this.tail, this.tail = node) : (node.prev = null, this.head = this.tail = node), this.length += 1);
    }
    offset(target) {
        let index = 0, cur = this.head;
        for(; cur != null;){
            if (cur === target) return index;
            index += cur.length(), cur = cur.next;
        }
        return -1;
    }
    remove(node) {
        this.contains(node) && (node.prev != null && (node.prev.next = node.next), node.next != null && (node.next.prev = node.prev), node === this.head && (this.head = node.next), node === this.tail && (this.tail = node.prev), this.length -= 1);
    }
    iterator(curNode = this.head) {
        return ()=>{
            const ret = curNode;
            return curNode != null && (curNode = curNode.next), ret;
        };
    }
    find(index, inclusive = !1) {
        const next = this.iterator();
        let cur = next();
        for(; cur;){
            const length = cur.length();
            if (index < length || inclusive && index === length && (cur.next == null || cur.next.length() !== 0)) return [
                cur,
                index
            ];
            index -= length, cur = next();
        }
        return [
            null,
            0
        ];
    }
    forEach(callback) {
        const next = this.iterator();
        let cur = next();
        for(; cur;)callback(cur), cur = next();
    }
    forEachAt(index, length, callback) {
        if (length <= 0) return;
        const [startNode, offset] = this.find(index);
        let curIndex = index - offset;
        const next = this.iterator(startNode);
        let cur = next();
        for(; cur && curIndex < index + length;){
            const curLength = cur.length();
            index > curIndex ? callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index)) : callback(cur, 0, Math.min(curLength, index + length - curIndex)), curIndex += curLength, cur = next();
        }
    }
    map(callback) {
        return this.reduce((memo, cur)=>(memo.push(callback(cur)), memo), []);
    }
    reduce(callback, memo) {
        const next = this.iterator();
        let cur = next();
        for(; cur;)memo = callback(memo, cur), cur = next();
        return memo;
    }
}
function $569e748944e69916$var$makeAttachedBlot(node, scroll) {
    const found = scroll.find(node);
    if (found) return found;
    try {
        return scroll.create(node);
    } catch  {
        const blot = scroll.create($569e748944e69916$export$775b6bb06e53a214.INLINE);
        return Array.from(node.childNodes).forEach((child)=>{
            blot.domNode.appendChild(child);
        }), node.parentNode && node.parentNode.replaceChild(blot.domNode, node), blot.attach(), blot;
    }
}
const $569e748944e69916$var$_ParentBlot = class _ParentBlot extends $569e748944e69916$var$ShadowBlot {
    constructor(scroll, domNode){
        super(scroll, domNode), this.uiNode = null, this.build();
    }
    appendChild(other) {
        this.insertBefore(other);
    }
    attach() {
        super.attach(), this.children.forEach((child)=>{
            child.attach();
        });
    }
    attachUI(node) {
        this.uiNode != null && this.uiNode.remove(), this.uiNode = node, _ParentBlot.uiClass && this.uiNode.classList.add(_ParentBlot.uiClass), this.uiNode.setAttribute("contenteditable", "false"), this.domNode.insertBefore(this.uiNode, this.domNode.firstChild);
    }
    /**
   * Called during construction, should fill its own children LinkedList.
   */ build() {
        this.children = new $569e748944e69916$var$LinkedList(), Array.from(this.domNode.childNodes).filter((node)=>node !== this.uiNode).reverse().forEach((node)=>{
            try {
                const child = $569e748944e69916$var$makeAttachedBlot(node, this.scroll);
                this.insertBefore(child, this.children.head || void 0);
            } catch (err) {
                if (err instanceof $569e748944e69916$var$ParchmentError) return;
                throw err;
            }
        });
    }
    deleteAt(index, length) {
        if (index === 0 && length === this.length()) return this.remove();
        this.children.forEachAt(index, length, (child, offset, childLength)=>{
            child.deleteAt(offset, childLength);
        });
    }
    descendant(criteria, index = 0) {
        const [child, offset] = this.children.find(index);
        return criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria ? [
            child,
            offset
        ] : child instanceof _ParentBlot ? child.descendant(criteria, offset) : [
            null,
            -1
        ];
    }
    descendants(criteria, index = 0, length = Number.MAX_VALUE) {
        let descendants = [], lengthLeft = length;
        return this.children.forEachAt(index, length, (child, childIndex, childLength)=>{
            (criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria) && descendants.push(child), child instanceof _ParentBlot && (descendants = descendants.concat(child.descendants(criteria, childIndex, lengthLeft))), lengthLeft -= childLength;
        }), descendants;
    }
    detach() {
        this.children.forEach((child)=>{
            child.detach();
        }), super.detach();
    }
    enforceAllowedChildren() {
        let done = !1;
        this.children.forEach((child)=>{
            done || this.statics.allowedChildren.some((def)=>child instanceof def) || (child.statics.scope === $569e748944e69916$export$775b6bb06e53a214.BLOCK_BLOT ? (child.next != null && this.splitAfter(child), child.prev != null && this.splitAfter(child.prev), child.parent.unwrap(), done = !0) : child instanceof _ParentBlot ? child.unwrap() : child.remove());
        });
    }
    formatAt(index, length, name, value) {
        this.children.forEachAt(index, length, (child, offset, childLength)=>{
            child.formatAt(offset, childLength, name, value);
        });
    }
    insertAt(index, value, def) {
        const [child, offset] = this.children.find(index);
        if (child) child.insertAt(offset, value, def);
        else {
            const blot = def == null ? this.scroll.create("text", value) : this.scroll.create(value, def);
            this.appendChild(blot);
        }
    }
    insertBefore(childBlot, refBlot) {
        childBlot.parent != null && childBlot.parent.children.remove(childBlot);
        let refDomNode = null;
        this.children.insertBefore(childBlot, refBlot || null), childBlot.parent = this, refBlot != null && (refDomNode = refBlot.domNode), (this.domNode.parentNode !== childBlot.domNode || this.domNode.nextSibling !== refDomNode) && this.domNode.insertBefore(childBlot.domNode, refDomNode), childBlot.attach();
    }
    length() {
        return this.children.reduce((memo, child)=>memo + child.length(), 0);
    }
    moveChildren(targetParent, refNode) {
        this.children.forEach((child)=>{
            targetParent.insertBefore(child, refNode);
        });
    }
    optimize(context) {
        if (super.optimize(context), this.enforceAllowedChildren(), this.uiNode != null && this.uiNode !== this.domNode.firstChild && this.domNode.insertBefore(this.uiNode, this.domNode.firstChild), this.children.length === 0) {
            if (this.statics.defaultChild != null) {
                const child = this.scroll.create(this.statics.defaultChild.blotName);
                this.appendChild(child);
            } else this.remove();
        }
    }
    path(index, inclusive = !1) {
        const [child, offset] = this.children.find(index, inclusive), position = [
            [
                this,
                index
            ]
        ];
        return child instanceof _ParentBlot ? position.concat(child.path(offset, inclusive)) : (child != null && position.push([
            child,
            offset
        ]), position);
    }
    removeChild(child) {
        this.children.remove(child);
    }
    replaceWith(name, value) {
        const replacement = typeof name == "string" ? this.scroll.create(name, value) : name;
        return replacement instanceof _ParentBlot && this.moveChildren(replacement), super.replaceWith(replacement);
    }
    split(index, force = !1) {
        if (!force) {
            if (index === 0) return this;
            if (index === this.length()) return this.next;
        }
        const after = this.clone();
        return this.parent && this.parent.insertBefore(after, this.next || void 0), this.children.forEachAt(index, this.length(), (child, offset, _length)=>{
            const split = child.split(offset, force);
            split != null && after.appendChild(split);
        }), after;
    }
    splitAfter(child) {
        const after = this.clone();
        for(; child.next != null;)after.appendChild(child.next);
        return this.parent && this.parent.insertBefore(after, this.next || void 0), after;
    }
    unwrap() {
        this.parent && this.moveChildren(this.parent, this.next || void 0), this.remove();
    }
    update(mutations, _context) {
        const addedNodes = [], removedNodes = [];
        mutations.forEach((mutation)=>{
            mutation.target === this.domNode && mutation.type === "childList" && (addedNodes.push(...mutation.addedNodes), removedNodes.push(...mutation.removedNodes));
        }), removedNodes.forEach((node)=>{
            if (node.parentNode != null && // @ts-expect-error Fix me later
            node.tagName !== "IFRAME" && document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) return;
            const blot = this.scroll.find(node);
            blot != null && (blot.domNode.parentNode == null || blot.domNode.parentNode === this.domNode) && blot.detach();
        }), addedNodes.filter((node)=>node.parentNode === this.domNode && node !== this.uiNode).sort((a, b)=>a === b ? 0 : a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? 1 : -1).forEach((node)=>{
            let refBlot = null;
            node.nextSibling != null && (refBlot = this.scroll.find(node.nextSibling));
            const blot = $569e748944e69916$var$makeAttachedBlot(node, this.scroll);
            (blot.next !== refBlot || blot.next == null) && (blot.parent != null && blot.parent.removeChild(this), this.insertBefore(blot, refBlot || void 0));
        }), this.enforceAllowedChildren();
    }
};
$569e748944e69916$var$_ParentBlot.uiClass = "";
let $569e748944e69916$var$ParentBlot = $569e748944e69916$var$_ParentBlot;
const $569e748944e69916$export$e43113f0aad76fe = $569e748944e69916$var$ParentBlot;
function $569e748944e69916$var$isEqual(obj1, obj2) {
    if (Object.keys(obj1).length !== Object.keys(obj2).length) return !1;
    for(const prop in obj1)if (obj1[prop] !== obj2[prop]) return !1;
    return !0;
}
const $569e748944e69916$var$_InlineBlot = class _InlineBlot extends $569e748944e69916$export$e43113f0aad76fe {
    static create(value) {
        return super.create(value);
    }
    static formats(domNode, scroll) {
        const match2 = scroll.query(_InlineBlot.blotName);
        if (!(match2 != null && domNode.tagName === match2.tagName)) {
            if (typeof this.tagName == "string") return !0;
            if (Array.isArray(this.tagName)) return domNode.tagName.toLowerCase();
        }
    }
    constructor(scroll, domNode){
        super(scroll, domNode), this.attributes = new $569e748944e69916$export$68ad86ab95e8de42(this.domNode);
    }
    format(name, value) {
        if (name === this.statics.blotName && !value) this.children.forEach((child)=>{
            child instanceof _InlineBlot || (child = child.wrap(_InlineBlot.blotName, !0)), this.attributes.copy(child);
        }), this.unwrap();
        else {
            const format = this.scroll.query(name, $569e748944e69916$export$775b6bb06e53a214.INLINE);
            if (format == null) return;
            format instanceof $569e748944e69916$export$217610c4183502d0 ? this.attributes.attribute(format, value) : value && (name !== this.statics.blotName || this.formats()[name] !== value) && this.replaceWith(name, value);
        }
    }
    formats() {
        const formats = this.attributes.values(), format = this.statics.formats(this.domNode, this.scroll);
        return format != null && (formats[this.statics.blotName] = format), formats;
    }
    formatAt(index, length, name, value) {
        this.formats()[name] != null || this.scroll.query(name, $569e748944e69916$export$775b6bb06e53a214.ATTRIBUTE) ? this.isolate(index, length).format(name, value) : super.formatAt(index, length, name, value);
    }
    optimize(context) {
        super.optimize(context);
        const formats = this.formats();
        if (Object.keys(formats).length === 0) return this.unwrap();
        const next = this.next;
        next instanceof _InlineBlot && next.prev === this && $569e748944e69916$var$isEqual(formats, next.formats()) && (next.moveChildren(this), next.remove());
    }
    replaceWith(name, value) {
        const replacement = super.replaceWith(name, value);
        return this.attributes.copy(replacement), replacement;
    }
    update(mutations, context) {
        super.update(mutations, context), mutations.some((mutation)=>mutation.target === this.domNode && mutation.type === "attributes") && this.attributes.build();
    }
    wrap(name, value) {
        const wrapper = super.wrap(name, value);
        return wrapper instanceof _InlineBlot && this.attributes.move(wrapper), wrapper;
    }
};
$569e748944e69916$var$_InlineBlot.allowedChildren = [
    $569e748944e69916$var$_InlineBlot,
    $569e748944e69916$export$7420b9c542181544
], $569e748944e69916$var$_InlineBlot.blotName = "inline", $569e748944e69916$var$_InlineBlot.scope = $569e748944e69916$export$775b6bb06e53a214.INLINE_BLOT, $569e748944e69916$var$_InlineBlot.tagName = "SPAN";
let $569e748944e69916$var$InlineBlot = $569e748944e69916$var$_InlineBlot;
const $569e748944e69916$export$f67a34bc25a7a861 = $569e748944e69916$var$InlineBlot, $569e748944e69916$var$_BlockBlot = class _BlockBlot extends $569e748944e69916$export$e43113f0aad76fe {
    static create(value) {
        return super.create(value);
    }
    static formats(domNode, scroll) {
        const match2 = scroll.query(_BlockBlot.blotName);
        if (!(match2 != null && domNode.tagName === match2.tagName)) {
            if (typeof this.tagName == "string") return !0;
            if (Array.isArray(this.tagName)) return domNode.tagName.toLowerCase();
        }
    }
    constructor(scroll, domNode){
        super(scroll, domNode), this.attributes = new $569e748944e69916$export$68ad86ab95e8de42(this.domNode);
    }
    format(name, value) {
        const format = this.scroll.query(name, $569e748944e69916$export$775b6bb06e53a214.BLOCK);
        format != null && (format instanceof $569e748944e69916$export$217610c4183502d0 ? this.attributes.attribute(format, value) : name === this.statics.blotName && !value ? this.replaceWith(_BlockBlot.blotName) : value && (name !== this.statics.blotName || this.formats()[name] !== value) && this.replaceWith(name, value));
    }
    formats() {
        const formats = this.attributes.values(), format = this.statics.formats(this.domNode, this.scroll);
        return format != null && (formats[this.statics.blotName] = format), formats;
    }
    formatAt(index, length, name, value) {
        this.scroll.query(name, $569e748944e69916$export$775b6bb06e53a214.BLOCK) != null ? this.format(name, value) : super.formatAt(index, length, name, value);
    }
    insertAt(index, value, def) {
        if (def == null || this.scroll.query(value, $569e748944e69916$export$775b6bb06e53a214.INLINE) != null) super.insertAt(index, value, def);
        else {
            const after = this.split(index);
            if (after != null) {
                const blot = this.scroll.create(value, def);
                after.parent.insertBefore(blot, after);
            } else throw new Error("Attempt to insertAt after block boundaries");
        }
    }
    replaceWith(name, value) {
        const replacement = super.replaceWith(name, value);
        return this.attributes.copy(replacement), replacement;
    }
    update(mutations, context) {
        super.update(mutations, context), mutations.some((mutation)=>mutation.target === this.domNode && mutation.type === "attributes") && this.attributes.build();
    }
};
$569e748944e69916$var$_BlockBlot.blotName = "block", $569e748944e69916$var$_BlockBlot.scope = $569e748944e69916$export$775b6bb06e53a214.BLOCK_BLOT, $569e748944e69916$var$_BlockBlot.tagName = "P", $569e748944e69916$var$_BlockBlot.allowedChildren = [
    $569e748944e69916$export$f67a34bc25a7a861,
    $569e748944e69916$var$_BlockBlot,
    $569e748944e69916$export$7420b9c542181544
];
let $569e748944e69916$var$BlockBlot = $569e748944e69916$var$_BlockBlot;
const $569e748944e69916$export$4f7f03641f7bfc8c = $569e748944e69916$var$BlockBlot, $569e748944e69916$var$_ContainerBlot = class _ContainerBlot extends $569e748944e69916$export$e43113f0aad76fe {
    checkMerge() {
        return this.next !== null && this.next.statics.blotName === this.statics.blotName;
    }
    deleteAt(index, length) {
        super.deleteAt(index, length), this.enforceAllowedChildren();
    }
    formatAt(index, length, name, value) {
        super.formatAt(index, length, name, value), this.enforceAllowedChildren();
    }
    insertAt(index, value, def) {
        super.insertAt(index, value, def), this.enforceAllowedChildren();
    }
    optimize(context) {
        super.optimize(context), this.children.length > 0 && this.next != null && this.checkMerge() && (this.next.moveChildren(this), this.next.remove());
    }
};
$569e748944e69916$var$_ContainerBlot.blotName = "container", $569e748944e69916$var$_ContainerBlot.scope = $569e748944e69916$export$775b6bb06e53a214.BLOCK_BLOT;
let $569e748944e69916$var$ContainerBlot = $569e748944e69916$var$_ContainerBlot;
const $569e748944e69916$export$c898d510319704c0 = $569e748944e69916$var$ContainerBlot;
class $569e748944e69916$var$EmbedBlot extends $569e748944e69916$export$7420b9c542181544 {
    static formats(_domNode, _scroll) {}
    format(name, value) {
        super.formatAt(0, this.length(), name, value);
    }
    formatAt(index, length, name, value) {
        index === 0 && length === this.length() ? this.format(name, value) : super.formatAt(index, length, name, value);
    }
    formats() {
        return this.statics.formats(this.domNode, this.scroll);
    }
}
const $569e748944e69916$export$297a1fa96f55f00f = $569e748944e69916$var$EmbedBlot, $569e748944e69916$var$OBSERVER_CONFIG = {
    attributes: !0,
    characterData: !0,
    characterDataOldValue: !0,
    childList: !0,
    subtree: !0
}, $569e748944e69916$var$MAX_OPTIMIZE_ITERATIONS = 100, $569e748944e69916$var$_ScrollBlot = class _ScrollBlot extends $569e748944e69916$export$e43113f0aad76fe {
    constructor(registry, node){
        super(null, node), this.registry = registry, this.scroll = this, this.build(), this.observer = new MutationObserver((mutations)=>{
            this.update(mutations);
        }), this.observer.observe(this.domNode, $569e748944e69916$var$OBSERVER_CONFIG), this.attach();
    }
    create(input, value) {
        return this.registry.create(this, input, value);
    }
    find(node, bubble = !1) {
        const blot = this.registry.find(node, bubble);
        return blot ? blot.scroll === this ? blot : bubble ? this.find(blot.scroll.domNode.parentNode, !0) : null : null;
    }
    query(query, scope = $569e748944e69916$export$775b6bb06e53a214.ANY) {
        return this.registry.query(query, scope);
    }
    register(...definitions) {
        return this.registry.register(...definitions);
    }
    build() {
        this.scroll != null && super.build();
    }
    detach() {
        super.detach(), this.observer.disconnect();
    }
    deleteAt(index, length) {
        this.update(), index === 0 && length === this.length() ? this.children.forEach((child)=>{
            child.remove();
        }) : super.deleteAt(index, length);
    }
    formatAt(index, length, name, value) {
        this.update(), super.formatAt(index, length, name, value);
    }
    insertAt(index, value, def) {
        this.update(), super.insertAt(index, value, def);
    }
    optimize(mutations = [], context = {}) {
        super.optimize(context);
        const mutationsMap = context.mutationsMap || /* @__PURE__ */ new WeakMap();
        let records = Array.from(this.observer.takeRecords());
        for(; records.length > 0;)mutations.push(records.pop());
        const mark = (blot, markParent = !0)=>{
            blot == null || blot === this || blot.domNode.parentNode != null && (mutationsMap.has(blot.domNode) || mutationsMap.set(blot.domNode, []), markParent && mark(blot.parent));
        }, optimize = (blot)=>{
            mutationsMap.has(blot.domNode) && (blot instanceof $569e748944e69916$export$e43113f0aad76fe && blot.children.forEach(optimize), mutationsMap.delete(blot.domNode), blot.optimize(context));
        };
        let remaining = mutations;
        for(let i = 0; remaining.length > 0; i += 1){
            if (i >= $569e748944e69916$var$MAX_OPTIMIZE_ITERATIONS) throw new Error("[Parchment] Maximum optimize iterations reached");
            for(remaining.forEach((mutation)=>{
                const blot = this.find(mutation.target, !0);
                blot != null && (blot.domNode === mutation.target && (mutation.type === "childList" ? (mark(this.find(mutation.previousSibling, !1)), Array.from(mutation.addedNodes).forEach((node)=>{
                    const child = this.find(node, !1);
                    mark(child, !1), child instanceof $569e748944e69916$export$e43113f0aad76fe && child.children.forEach((grandChild)=>{
                        mark(grandChild, !1);
                    });
                })) : mutation.type === "attributes" && mark(blot.prev)), mark(blot));
            }), this.children.forEach(optimize), remaining = Array.from(this.observer.takeRecords()), records = remaining.slice(); records.length > 0;)mutations.push(records.pop());
        }
    }
    update(mutations, context = {}) {
        mutations = mutations || this.observer.takeRecords();
        const mutationsMap = /* @__PURE__ */ new WeakMap();
        mutations.map((mutation)=>{
            const blot = this.find(mutation.target, !0);
            return blot == null ? null : mutationsMap.has(blot.domNode) ? (mutationsMap.get(blot.domNode).push(mutation), null) : (mutationsMap.set(blot.domNode, [
                mutation
            ]), blot);
        }).forEach((blot)=>{
            blot != null && blot !== this && mutationsMap.has(blot.domNode) && blot.update(mutationsMap.get(blot.domNode) || [], context);
        }), context.mutationsMap = mutationsMap, mutationsMap.has(this.domNode) && super.update(mutationsMap.get(this.domNode), context), this.optimize(mutations, context);
    }
};
$569e748944e69916$var$_ScrollBlot.blotName = "scroll", $569e748944e69916$var$_ScrollBlot.defaultChild = $569e748944e69916$export$4f7f03641f7bfc8c, $569e748944e69916$var$_ScrollBlot.allowedChildren = [
    $569e748944e69916$export$4f7f03641f7bfc8c,
    $569e748944e69916$export$c898d510319704c0
], $569e748944e69916$var$_ScrollBlot.scope = $569e748944e69916$export$775b6bb06e53a214.BLOCK_BLOT, $569e748944e69916$var$_ScrollBlot.tagName = "DIV";
let $569e748944e69916$var$ScrollBlot = $569e748944e69916$var$_ScrollBlot;
const $569e748944e69916$export$7175329dad7a46f1 = $569e748944e69916$var$ScrollBlot, $569e748944e69916$var$_TextBlot = class _TextBlot extends $569e748944e69916$export$7420b9c542181544 {
    static create(value) {
        return document.createTextNode(value);
    }
    static value(domNode) {
        return domNode.data;
    }
    constructor(scroll, node){
        super(scroll, node), this.text = this.statics.value(this.domNode);
    }
    deleteAt(index, length) {
        this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
    }
    index(node, offset) {
        return this.domNode === node ? offset : -1;
    }
    insertAt(index, value, def) {
        def == null ? (this.text = this.text.slice(0, index) + value + this.text.slice(index), this.domNode.data = this.text) : super.insertAt(index, value, def);
    }
    length() {
        return this.text.length;
    }
    optimize(context) {
        super.optimize(context), this.text = this.statics.value(this.domNode), this.text.length === 0 ? this.remove() : this.next instanceof _TextBlot && this.next.prev === this && (this.insertAt(this.length(), this.next.value()), this.next.remove());
    }
    position(index, _inclusive = !1) {
        return [
            this.domNode,
            index
        ];
    }
    split(index, force = !1) {
        if (!force) {
            if (index === 0) return this;
            if (index === this.length()) return this.next;
        }
        const after = this.scroll.create(this.domNode.splitText(index));
        return this.parent.insertBefore(after, this.next || void 0), this.text = this.statics.value(this.domNode), after;
    }
    update(mutations, _context) {
        mutations.some((mutation)=>mutation.type === "characterData" && mutation.target === this.domNode) && (this.text = this.statics.value(this.domNode));
    }
    value() {
        return this.text;
    }
};
$569e748944e69916$var$_TextBlot.blotName = "text", $569e748944e69916$var$_TextBlot.scope = $569e748944e69916$export$775b6bb06e53a214.INLINE_BLOT;
let $569e748944e69916$var$TextBlot = $569e748944e69916$var$_TextBlot;
const $569e748944e69916$export$10ac0c5716409de6 = $569e748944e69916$var$TextBlot;


var $88e60522c01c2553$exports = {};
"use strict";
Object.defineProperty($88e60522c01c2553$exports, "__esModule", {
    value: true
});
$88e60522c01c2553$exports.AttributeMap = $88e60522c01c2553$exports.OpIterator = $88e60522c01c2553$exports.Op = void 0;
var $4648e7a23084bb3e$exports = {};
/**
 * This library modifies the diff-patch-match library by Neil Fraser
 * by removing the patch and match functionality and certain advanced
 * options in the diff function. The original license is as follows:
 *
 * ===
 *
 * Diff Match and Patch
 *
 * Copyright 2006 Google Inc.
 * http://code.google.com/p/google-diff-match-patch/
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The data structure representing a diff is an array of tuples:
 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
 */ var $4648e7a23084bb3e$var$DIFF_DELETE = -1;
var $4648e7a23084bb3e$var$DIFF_INSERT = 1;
var $4648e7a23084bb3e$var$DIFF_EQUAL = 0;
/**
 * Find the differences between two texts.  Simplifies the problem by stripping
 * any common prefix or suffix off the texts before diffing.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {Int|Object} [cursor_pos] Edit position in text1 or object with more info
 * @param {boolean} [cleanup] Apply semantic cleanup before returning.
 * @return {Array} Array of diff tuples.
 */ function $4648e7a23084bb3e$var$diff_main(text1, text2, cursor_pos, cleanup, _fix_unicode) {
    // Check for equality
    if (text1 === text2) {
        if (text1) return [
            [
                $4648e7a23084bb3e$var$DIFF_EQUAL,
                text1
            ]
        ];
        return [];
    }
    if (cursor_pos != null) {
        var editdiff = $4648e7a23084bb3e$var$find_cursor_edit_diff(text1, text2, cursor_pos);
        if (editdiff) return editdiff;
    }
    // Trim off common prefix (speedup).
    var commonlength = $4648e7a23084bb3e$var$diff_commonPrefix(text1, text2);
    var commonprefix = text1.substring(0, commonlength);
    text1 = text1.substring(commonlength);
    text2 = text2.substring(commonlength);
    // Trim off common suffix (speedup).
    commonlength = $4648e7a23084bb3e$var$diff_commonSuffix(text1, text2);
    var commonsuffix = text1.substring(text1.length - commonlength);
    text1 = text1.substring(0, text1.length - commonlength);
    text2 = text2.substring(0, text2.length - commonlength);
    // Compute the diff on the middle block.
    var diffs = $4648e7a23084bb3e$var$diff_compute_(text1, text2);
    // Restore the prefix and suffix.
    if (commonprefix) diffs.unshift([
        $4648e7a23084bb3e$var$DIFF_EQUAL,
        commonprefix
    ]);
    if (commonsuffix) diffs.push([
        $4648e7a23084bb3e$var$DIFF_EQUAL,
        commonsuffix
    ]);
    $4648e7a23084bb3e$var$diff_cleanupMerge(diffs, _fix_unicode);
    if (cleanup) $4648e7a23084bb3e$var$diff_cleanupSemantic(diffs);
    return diffs;
}
/**
 * Find the differences between two texts.  Assumes that the texts do not
 * have any common prefix or suffix.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 */ function $4648e7a23084bb3e$var$diff_compute_(text1, text2) {
    var diffs;
    if (!text1) // Just add some text (speedup).
    return [
        [
            $4648e7a23084bb3e$var$DIFF_INSERT,
            text2
        ]
    ];
    if (!text2) // Just delete some text (speedup).
    return [
        [
            $4648e7a23084bb3e$var$DIFF_DELETE,
            text1
        ]
    ];
    var longtext = text1.length > text2.length ? text1 : text2;
    var shorttext = text1.length > text2.length ? text2 : text1;
    var i = longtext.indexOf(shorttext);
    if (i !== -1) {
        // Shorter text is inside the longer text (speedup).
        diffs = [
            [
                $4648e7a23084bb3e$var$DIFF_INSERT,
                longtext.substring(0, i)
            ],
            [
                $4648e7a23084bb3e$var$DIFF_EQUAL,
                shorttext
            ],
            [
                $4648e7a23084bb3e$var$DIFF_INSERT,
                longtext.substring(i + shorttext.length)
            ]
        ];
        // Swap insertions for deletions if diff is reversed.
        if (text1.length > text2.length) diffs[0][0] = diffs[2][0] = $4648e7a23084bb3e$var$DIFF_DELETE;
        return diffs;
    }
    if (shorttext.length === 1) // Single character string.
    // After the previous speedup, the character can't be an equality.
    return [
        [
            $4648e7a23084bb3e$var$DIFF_DELETE,
            text1
        ],
        [
            $4648e7a23084bb3e$var$DIFF_INSERT,
            text2
        ]
    ];
    // Check to see if the problem can be split in two.
    var hm = $4648e7a23084bb3e$var$diff_halfMatch_(text1, text2);
    if (hm) {
        // A half-match was found, sort out the return data.
        var text1_a = hm[0];
        var text1_b = hm[1];
        var text2_a = hm[2];
        var text2_b = hm[3];
        var mid_common = hm[4];
        // Send both pairs off for separate processing.
        var diffs_a = $4648e7a23084bb3e$var$diff_main(text1_a, text2_a);
        var diffs_b = $4648e7a23084bb3e$var$diff_main(text1_b, text2_b);
        // Merge the results.
        return diffs_a.concat([
            [
                $4648e7a23084bb3e$var$DIFF_EQUAL,
                mid_common
            ]
        ], diffs_b);
    }
    return $4648e7a23084bb3e$var$diff_bisect_(text1, text2);
}
/**
 * Find the 'middle snake' of a diff, split the problem in two
 * and return the recursively constructed diff.
 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 * @private
 */ function $4648e7a23084bb3e$var$diff_bisect_(text1, text2) {
    // Cache the text lengths to prevent multiple calls.
    var text1_length = text1.length;
    var text2_length = text2.length;
    var max_d = Math.ceil((text1_length + text2_length) / 2);
    var v_offset = max_d;
    var v_length = 2 * max_d;
    var v1 = new Array(v_length);
    var v2 = new Array(v_length);
    // Setting all elements to -1 is faster in Chrome & Firefox than mixing
    // integers and undefined.
    for(var x = 0; x < v_length; x++){
        v1[x] = -1;
        v2[x] = -1;
    }
    v1[v_offset + 1] = 0;
    v2[v_offset + 1] = 0;
    var delta = text1_length - text2_length;
    // If the total number of characters is odd, then the front path will collide
    // with the reverse path.
    var front = delta % 2 !== 0;
    // Offsets for start and end of k loop.
    // Prevents mapping of space beyond the grid.
    var k1start = 0;
    var k1end = 0;
    var k2start = 0;
    var k2end = 0;
    for(var d = 0; d < max_d; d++){
        // Walk the front path one step.
        for(var k1 = -d + k1start; k1 <= d - k1end; k1 += 2){
            var k1_offset = v_offset + k1;
            var x1;
            if (k1 === -d || k1 !== d && v1[k1_offset - 1] < v1[k1_offset + 1]) x1 = v1[k1_offset + 1];
            else x1 = v1[k1_offset - 1] + 1;
            var y1 = x1 - k1;
            while(x1 < text1_length && y1 < text2_length && text1.charAt(x1) === text2.charAt(y1)){
                x1++;
                y1++;
            }
            v1[k1_offset] = x1;
            if (x1 > text1_length) // Ran off the right of the graph.
            k1end += 2;
            else if (y1 > text2_length) // Ran off the bottom of the graph.
            k1start += 2;
            else if (front) {
                var k2_offset = v_offset + delta - k1;
                if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] !== -1) {
                    // Mirror x2 onto top-left coordinate system.
                    var x2 = text1_length - v2[k2_offset];
                    if (x1 >= x2) // Overlap detected.
                    return $4648e7a23084bb3e$var$diff_bisectSplit_(text1, text2, x1, y1);
                }
            }
        }
        // Walk the reverse path one step.
        for(var k2 = -d + k2start; k2 <= d - k2end; k2 += 2){
            var k2_offset = v_offset + k2;
            var x2;
            if (k2 === -d || k2 !== d && v2[k2_offset - 1] < v2[k2_offset + 1]) x2 = v2[k2_offset + 1];
            else x2 = v2[k2_offset - 1] + 1;
            var y2 = x2 - k2;
            while(x2 < text1_length && y2 < text2_length && text1.charAt(text1_length - x2 - 1) === text2.charAt(text2_length - y2 - 1)){
                x2++;
                y2++;
            }
            v2[k2_offset] = x2;
            if (x2 > text1_length) // Ran off the left of the graph.
            k2end += 2;
            else if (y2 > text2_length) // Ran off the top of the graph.
            k2start += 2;
            else if (!front) {
                var k1_offset = v_offset + delta - k2;
                if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] !== -1) {
                    var x1 = v1[k1_offset];
                    var y1 = v_offset + x1 - k1_offset;
                    // Mirror x2 onto top-left coordinate system.
                    x2 = text1_length - x2;
                    if (x1 >= x2) // Overlap detected.
                    return $4648e7a23084bb3e$var$diff_bisectSplit_(text1, text2, x1, y1);
                }
            }
        }
    }
    // Diff took too long and hit the deadline or
    // number of diffs equals number of characters, no commonality at all.
    return [
        [
            $4648e7a23084bb3e$var$DIFF_DELETE,
            text1
        ],
        [
            $4648e7a23084bb3e$var$DIFF_INSERT,
            text2
        ]
    ];
}
/**
 * Given the location of the 'middle snake', split the diff in two parts
 * and recurse.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} x Index of split point in text1.
 * @param {number} y Index of split point in text2.
 * @return {Array} Array of diff tuples.
 */ function $4648e7a23084bb3e$var$diff_bisectSplit_(text1, text2, x, y) {
    var text1a = text1.substring(0, x);
    var text2a = text2.substring(0, y);
    var text1b = text1.substring(x);
    var text2b = text2.substring(y);
    // Compute both diffs serially.
    var diffs = $4648e7a23084bb3e$var$diff_main(text1a, text2a);
    var diffsb = $4648e7a23084bb3e$var$diff_main(text1b, text2b);
    return diffs.concat(diffsb);
}
/**
 * Determine the common prefix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the start of each
 *     string.
 */ function $4648e7a23084bb3e$var$diff_commonPrefix(text1, text2) {
    // Quick check for common null cases.
    if (!text1 || !text2 || text1.charAt(0) !== text2.charAt(0)) return 0;
    // Binary search.
    // Performance analysis: http://neil.fraser.name/news/2007/10/09/
    var pointermin = 0;
    var pointermax = Math.min(text1.length, text2.length);
    var pointermid = pointermax;
    var pointerstart = 0;
    while(pointermin < pointermid){
        if (text1.substring(pointerstart, pointermid) == text2.substring(pointerstart, pointermid)) {
            pointermin = pointermid;
            pointerstart = pointermin;
        } else pointermax = pointermid;
        pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
    }
    if ($4648e7a23084bb3e$var$is_surrogate_pair_start(text1.charCodeAt(pointermid - 1))) pointermid--;
    return pointermid;
}
/**
 * Determine if the suffix of one string is the prefix of another.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of the first
 *     string and the start of the second string.
 * @private
 */ function $4648e7a23084bb3e$var$diff_commonOverlap_(text1, text2) {
    // Cache the text lengths to prevent multiple calls.
    var text1_length = text1.length;
    var text2_length = text2.length;
    // Eliminate the null case.
    if (text1_length == 0 || text2_length == 0) return 0;
    // Truncate the longer string.
    if (text1_length > text2_length) text1 = text1.substring(text1_length - text2_length);
    else if (text1_length < text2_length) text2 = text2.substring(0, text1_length);
    var text_length = Math.min(text1_length, text2_length);
    // Quick check for the worst case.
    if (text1 == text2) return text_length;
    // Start by looking for a single character match
    // and increase length until no match is found.
    // Performance analysis: http://neil.fraser.name/news/2010/11/04/
    var best = 0;
    var length = 1;
    while(true){
        var pattern = text1.substring(text_length - length);
        var found = text2.indexOf(pattern);
        if (found == -1) return best;
        length += found;
        if (found == 0 || text1.substring(text_length - length) == text2.substring(0, length)) {
            best = length;
            length++;
        }
    }
}
/**
 * Determine the common suffix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of each string.
 */ function $4648e7a23084bb3e$var$diff_commonSuffix(text1, text2) {
    // Quick check for common null cases.
    if (!text1 || !text2 || text1.slice(-1) !== text2.slice(-1)) return 0;
    // Binary search.
    // Performance analysis: http://neil.fraser.name/news/2007/10/09/
    var pointermin = 0;
    var pointermax = Math.min(text1.length, text2.length);
    var pointermid = pointermax;
    var pointerend = 0;
    while(pointermin < pointermid){
        if (text1.substring(text1.length - pointermid, text1.length - pointerend) == text2.substring(text2.length - pointermid, text2.length - pointerend)) {
            pointermin = pointermid;
            pointerend = pointermin;
        } else pointermax = pointermid;
        pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
    }
    if ($4648e7a23084bb3e$var$is_surrogate_pair_end(text1.charCodeAt(text1.length - pointermid))) pointermid--;
    return pointermid;
}
/**
 * Do the two texts share a substring which is at least half the length of the
 * longer text?
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {Array.<string>} Five element Array, containing the prefix of
 *     text1, the suffix of text1, the prefix of text2, the suffix of
 *     text2 and the common middle.  Or null if there was no match.
 */ function $4648e7a23084bb3e$var$diff_halfMatch_(text1, text2) {
    var longtext = text1.length > text2.length ? text1 : text2;
    var shorttext = text1.length > text2.length ? text2 : text1;
    if (longtext.length < 4 || shorttext.length * 2 < longtext.length) return null; // Pointless.
    /**
   * Does a substring of shorttext exist within longtext such that the substring
   * is at least half the length of longtext?
   * Closure, but does not reference any external variables.
   * @param {string} longtext Longer string.
   * @param {string} shorttext Shorter string.
   * @param {number} i Start index of quarter length substring within longtext.
   * @return {Array.<string>} Five element Array, containing the prefix of
   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
   *     of shorttext and the common middle.  Or null if there was no match.
   * @private
   */ function diff_halfMatchI_(longtext, shorttext, i) {
        // Start with a 1/4 length substring at position i as a seed.
        var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
        var j = -1;
        var best_common = "";
        var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
        while((j = shorttext.indexOf(seed, j + 1)) !== -1){
            var prefixLength = $4648e7a23084bb3e$var$diff_commonPrefix(longtext.substring(i), shorttext.substring(j));
            var suffixLength = $4648e7a23084bb3e$var$diff_commonSuffix(longtext.substring(0, i), shorttext.substring(0, j));
            if (best_common.length < suffixLength + prefixLength) {
                best_common = shorttext.substring(j - suffixLength, j) + shorttext.substring(j, j + prefixLength);
                best_longtext_a = longtext.substring(0, i - suffixLength);
                best_longtext_b = longtext.substring(i + prefixLength);
                best_shorttext_a = shorttext.substring(0, j - suffixLength);
                best_shorttext_b = shorttext.substring(j + prefixLength);
            }
        }
        if (best_common.length * 2 >= longtext.length) return [
            best_longtext_a,
            best_longtext_b,
            best_shorttext_a,
            best_shorttext_b,
            best_common
        ];
        else return null;
    }
    // First check if the second quarter is the seed for a half-match.
    var hm1 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 4));
    // Check again based on the third quarter.
    var hm2 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 2));
    var hm;
    if (!hm1 && !hm2) return null;
    else if (!hm2) hm = hm1;
    else if (!hm1) hm = hm2;
    else // Both matched.  Select the longest.
    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
    // A half-match was found, sort out the return data.
    var text1_a, text1_b, text2_a, text2_b;
    if (text1.length > text2.length) {
        text1_a = hm[0];
        text1_b = hm[1];
        text2_a = hm[2];
        text2_b = hm[3];
    } else {
        text2_a = hm[0];
        text2_b = hm[1];
        text1_a = hm[2];
        text1_b = hm[3];
    }
    var mid_common = hm[4];
    return [
        text1_a,
        text1_b,
        text2_a,
        text2_b,
        mid_common
    ];
}
/**
 * Reduce the number of edits by eliminating semantically trivial equalities.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */ function $4648e7a23084bb3e$var$diff_cleanupSemantic(diffs) {
    var changes = false;
    var equalities = []; // Stack of indices where equalities are found.
    var equalitiesLength = 0; // Keeping our own length var is faster in JS.
    /** @type {?string} */ var lastequality = null;
    // Always equal to diffs[equalities[equalitiesLength - 1]][1]
    var pointer = 0; // Index of current position.
    // Number of characters that changed prior to the equality.
    var length_insertions1 = 0;
    var length_deletions1 = 0;
    // Number of characters that changed after the equality.
    var length_insertions2 = 0;
    var length_deletions2 = 0;
    while(pointer < diffs.length){
        if (diffs[pointer][0] == $4648e7a23084bb3e$var$DIFF_EQUAL) {
            // Equality found.
            equalities[equalitiesLength++] = pointer;
            length_insertions1 = length_insertions2;
            length_deletions1 = length_deletions2;
            length_insertions2 = 0;
            length_deletions2 = 0;
            lastequality = diffs[pointer][1];
        } else {
            // An insertion or deletion.
            if (diffs[pointer][0] == $4648e7a23084bb3e$var$DIFF_INSERT) length_insertions2 += diffs[pointer][1].length;
            else length_deletions2 += diffs[pointer][1].length;
            // Eliminate an equality that is smaller or equal to the edits on both
            // sides of it.
            if (lastequality && lastequality.length <= Math.max(length_insertions1, length_deletions1) && lastequality.length <= Math.max(length_insertions2, length_deletions2)) {
                // Duplicate record.
                diffs.splice(equalities[equalitiesLength - 1], 0, [
                    $4648e7a23084bb3e$var$DIFF_DELETE,
                    lastequality
                ]);
                // Change second copy to insert.
                diffs[equalities[equalitiesLength - 1] + 1][0] = $4648e7a23084bb3e$var$DIFF_INSERT;
                // Throw away the equality we just deleted.
                equalitiesLength--;
                // Throw away the previous equality (it needs to be reevaluated).
                equalitiesLength--;
                pointer = equalitiesLength > 0 ? equalities[equalitiesLength - 1] : -1;
                length_insertions1 = 0; // Reset the counters.
                length_deletions1 = 0;
                length_insertions2 = 0;
                length_deletions2 = 0;
                lastequality = null;
                changes = true;
            }
        }
        pointer++;
    }
    // Normalize the diff.
    if (changes) $4648e7a23084bb3e$var$diff_cleanupMerge(diffs);
    $4648e7a23084bb3e$var$diff_cleanupSemanticLossless(diffs);
    // Find any overlaps between deletions and insertions.
    // e.g: <del>abcxxx</del><ins>xxxdef</ins>
    //   -> <del>abc</del>xxx<ins>def</ins>
    // e.g: <del>xxxabc</del><ins>defxxx</ins>
    //   -> <ins>def</ins>xxx<del>abc</del>
    // Only extract an overlap if it is as big as the edit ahead or behind it.
    pointer = 1;
    while(pointer < diffs.length){
        if (diffs[pointer - 1][0] == $4648e7a23084bb3e$var$DIFF_DELETE && diffs[pointer][0] == $4648e7a23084bb3e$var$DIFF_INSERT) {
            var deletion = diffs[pointer - 1][1];
            var insertion = diffs[pointer][1];
            var overlap_length1 = $4648e7a23084bb3e$var$diff_commonOverlap_(deletion, insertion);
            var overlap_length2 = $4648e7a23084bb3e$var$diff_commonOverlap_(insertion, deletion);
            if (overlap_length1 >= overlap_length2) {
                if (overlap_length1 >= deletion.length / 2 || overlap_length1 >= insertion.length / 2) {
                    // Overlap found.  Insert an equality and trim the surrounding edits.
                    diffs.splice(pointer, 0, [
                        $4648e7a23084bb3e$var$DIFF_EQUAL,
                        insertion.substring(0, overlap_length1)
                    ]);
                    diffs[pointer - 1][1] = deletion.substring(0, deletion.length - overlap_length1);
                    diffs[pointer + 1][1] = insertion.substring(overlap_length1);
                    pointer++;
                }
            } else if (overlap_length2 >= deletion.length / 2 || overlap_length2 >= insertion.length / 2) {
                // Reverse overlap found.
                // Insert an equality and swap and trim the surrounding edits.
                diffs.splice(pointer, 0, [
                    $4648e7a23084bb3e$var$DIFF_EQUAL,
                    deletion.substring(0, overlap_length2)
                ]);
                diffs[pointer - 1][0] = $4648e7a23084bb3e$var$DIFF_INSERT;
                diffs[pointer - 1][1] = insertion.substring(0, insertion.length - overlap_length2);
                diffs[pointer + 1][0] = $4648e7a23084bb3e$var$DIFF_DELETE;
                diffs[pointer + 1][1] = deletion.substring(overlap_length2);
                pointer++;
            }
            pointer++;
        }
        pointer++;
    }
}
var $4648e7a23084bb3e$var$nonAlphaNumericRegex_ = /[^a-zA-Z0-9]/;
var $4648e7a23084bb3e$var$whitespaceRegex_ = /\s/;
var $4648e7a23084bb3e$var$linebreakRegex_ = /[\r\n]/;
var $4648e7a23084bb3e$var$blanklineEndRegex_ = /\n\r?\n$/;
var $4648e7a23084bb3e$var$blanklineStartRegex_ = /^\r?\n\r?\n/;
/**
 * Look for single edits surrounded on both sides by equalities
 * which can be shifted sideways to align the edit to a word boundary.
 * e.g: The c<ins>at c</ins>ame. -> The <ins>cat </ins>came.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */ function $4648e7a23084bb3e$var$diff_cleanupSemanticLossless(diffs) {
    /**
   * Given two strings, compute a score representing whether the internal
   * boundary falls on logical boundaries.
   * Scores range from 6 (best) to 0 (worst).
   * Closure, but does not reference any external variables.
   * @param {string} one First string.
   * @param {string} two Second string.
   * @return {number} The score.
   * @private
   */ function diff_cleanupSemanticScore_(one, two) {
        if (!one || !two) // Edges are the best.
        return 6;
        // Each port of this function behaves slightly differently due to
        // subtle differences in each language's definition of things like
        // 'whitespace'.  Since this function's purpose is largely cosmetic,
        // the choice has been made to use each language's native features
        // rather than force total conformity.
        var char1 = one.charAt(one.length - 1);
        var char2 = two.charAt(0);
        var nonAlphaNumeric1 = char1.match($4648e7a23084bb3e$var$nonAlphaNumericRegex_);
        var nonAlphaNumeric2 = char2.match($4648e7a23084bb3e$var$nonAlphaNumericRegex_);
        var whitespace1 = nonAlphaNumeric1 && char1.match($4648e7a23084bb3e$var$whitespaceRegex_);
        var whitespace2 = nonAlphaNumeric2 && char2.match($4648e7a23084bb3e$var$whitespaceRegex_);
        var lineBreak1 = whitespace1 && char1.match($4648e7a23084bb3e$var$linebreakRegex_);
        var lineBreak2 = whitespace2 && char2.match($4648e7a23084bb3e$var$linebreakRegex_);
        var blankLine1 = lineBreak1 && one.match($4648e7a23084bb3e$var$blanklineEndRegex_);
        var blankLine2 = lineBreak2 && two.match($4648e7a23084bb3e$var$blanklineStartRegex_);
        if (blankLine1 || blankLine2) // Five points for blank lines.
        return 5;
        else if (lineBreak1 || lineBreak2) // Four points for line breaks.
        return 4;
        else if (nonAlphaNumeric1 && !whitespace1 && whitespace2) // Three points for end of sentences.
        return 3;
        else if (whitespace1 || whitespace2) // Two points for whitespace.
        return 2;
        else if (nonAlphaNumeric1 || nonAlphaNumeric2) // One point for non-alphanumeric.
        return 1;
        return 0;
    }
    var pointer = 1;
    // Intentionally ignore the first and last element (don't need checking).
    while(pointer < diffs.length - 1){
        if (diffs[pointer - 1][0] == $4648e7a23084bb3e$var$DIFF_EQUAL && diffs[pointer + 1][0] == $4648e7a23084bb3e$var$DIFF_EQUAL) {
            // This is a single edit surrounded by equalities.
            var equality1 = diffs[pointer - 1][1];
            var edit = diffs[pointer][1];
            var equality2 = diffs[pointer + 1][1];
            // First, shift the edit as far left as possible.
            var commonOffset = $4648e7a23084bb3e$var$diff_commonSuffix(equality1, edit);
            if (commonOffset) {
                var commonString = edit.substring(edit.length - commonOffset);
                equality1 = equality1.substring(0, equality1.length - commonOffset);
                edit = commonString + edit.substring(0, edit.length - commonOffset);
                equality2 = commonString + equality2;
            }
            // Second, step character by character right, looking for the best fit.
            var bestEquality1 = equality1;
            var bestEdit = edit;
            var bestEquality2 = equality2;
            var bestScore = diff_cleanupSemanticScore_(equality1, edit) + diff_cleanupSemanticScore_(edit, equality2);
            while(edit.charAt(0) === equality2.charAt(0)){
                equality1 += edit.charAt(0);
                edit = edit.substring(1) + equality2.charAt(0);
                equality2 = equality2.substring(1);
                var score = diff_cleanupSemanticScore_(equality1, edit) + diff_cleanupSemanticScore_(edit, equality2);
                // The >= encourages trailing rather than leading whitespace on edits.
                if (score >= bestScore) {
                    bestScore = score;
                    bestEquality1 = equality1;
                    bestEdit = edit;
                    bestEquality2 = equality2;
                }
            }
            if (diffs[pointer - 1][1] != bestEquality1) {
                // We have an improvement, save it back to the diff.
                if (bestEquality1) diffs[pointer - 1][1] = bestEquality1;
                else {
                    diffs.splice(pointer - 1, 1);
                    pointer--;
                }
                diffs[pointer][1] = bestEdit;
                if (bestEquality2) diffs[pointer + 1][1] = bestEquality2;
                else {
                    diffs.splice(pointer + 1, 1);
                    pointer--;
                }
            }
        }
        pointer++;
    }
}
/**
 * Reorder and merge like edit sections.  Merge equalities.
 * Any edit section can move as long as it doesn't cross an equality.
 * @param {Array} diffs Array of diff tuples.
 * @param {boolean} fix_unicode Whether to normalize to a unicode-correct diff
 */ function $4648e7a23084bb3e$var$diff_cleanupMerge(diffs, fix_unicode) {
    diffs.push([
        $4648e7a23084bb3e$var$DIFF_EQUAL,
        ""
    ]); // Add a dummy entry at the end.
    var pointer = 0;
    var count_delete = 0;
    var count_insert = 0;
    var text_delete = "";
    var text_insert = "";
    var commonlength;
    while(pointer < diffs.length){
        if (pointer < diffs.length - 1 && !diffs[pointer][1]) {
            diffs.splice(pointer, 1);
            continue;
        }
        switch(diffs[pointer][0]){
            case $4648e7a23084bb3e$var$DIFF_INSERT:
                count_insert++;
                text_insert += diffs[pointer][1];
                pointer++;
                break;
            case $4648e7a23084bb3e$var$DIFF_DELETE:
                count_delete++;
                text_delete += diffs[pointer][1];
                pointer++;
                break;
            case $4648e7a23084bb3e$var$DIFF_EQUAL:
                var previous_equality = pointer - count_insert - count_delete - 1;
                if (fix_unicode) {
                    // prevent splitting of unicode surrogate pairs.  when fix_unicode is true,
                    // we assume that the old and new text in the diff are complete and correct
                    // unicode-encoded JS strings, but the tuple boundaries may fall between
                    // surrogate pairs.  we fix this by shaving off stray surrogates from the end
                    // of the previous equality and the beginning of this equality.  this may create
                    // empty equalities or a common prefix or suffix.  for example, if AB and AC are
                    // emojis, `[[0, 'A'], [-1, 'BA'], [0, 'C']]` would turn into deleting 'ABAC' and
                    // inserting 'AC', and then the common suffix 'AC' will be eliminated.  in this
                    // particular case, both equalities go away, we absorb any previous inequalities,
                    // and we keep scanning for the next equality before rewriting the tuples.
                    if (previous_equality >= 0 && $4648e7a23084bb3e$var$ends_with_pair_start(diffs[previous_equality][1])) {
                        var stray = diffs[previous_equality][1].slice(-1);
                        diffs[previous_equality][1] = diffs[previous_equality][1].slice(0, -1);
                        text_delete = stray + text_delete;
                        text_insert = stray + text_insert;
                        if (!diffs[previous_equality][1]) {
                            // emptied out previous equality, so delete it and include previous delete/insert
                            diffs.splice(previous_equality, 1);
                            pointer--;
                            var k = previous_equality - 1;
                            if (diffs[k] && diffs[k][0] === $4648e7a23084bb3e$var$DIFF_INSERT) {
                                count_insert++;
                                text_insert = diffs[k][1] + text_insert;
                                k--;
                            }
                            if (diffs[k] && diffs[k][0] === $4648e7a23084bb3e$var$DIFF_DELETE) {
                                count_delete++;
                                text_delete = diffs[k][1] + text_delete;
                                k--;
                            }
                            previous_equality = k;
                        }
                    }
                    if ($4648e7a23084bb3e$var$starts_with_pair_end(diffs[pointer][1])) {
                        var stray = diffs[pointer][1].charAt(0);
                        diffs[pointer][1] = diffs[pointer][1].slice(1);
                        text_delete += stray;
                        text_insert += stray;
                    }
                }
                if (pointer < diffs.length - 1 && !diffs[pointer][1]) {
                    // for empty equality not at end, wait for next equality
                    diffs.splice(pointer, 1);
                    break;
                }
                if (text_delete.length > 0 || text_insert.length > 0) {
                    // note that diff_commonPrefix and diff_commonSuffix are unicode-aware
                    if (text_delete.length > 0 && text_insert.length > 0) {
                        // Factor out any common prefixes.
                        commonlength = $4648e7a23084bb3e$var$diff_commonPrefix(text_insert, text_delete);
                        if (commonlength !== 0) {
                            if (previous_equality >= 0) diffs[previous_equality][1] += text_insert.substring(0, commonlength);
                            else {
                                diffs.splice(0, 0, [
                                    $4648e7a23084bb3e$var$DIFF_EQUAL,
                                    text_insert.substring(0, commonlength)
                                ]);
                                pointer++;
                            }
                            text_insert = text_insert.substring(commonlength);
                            text_delete = text_delete.substring(commonlength);
                        }
                        // Factor out any common suffixes.
                        commonlength = $4648e7a23084bb3e$var$diff_commonSuffix(text_insert, text_delete);
                        if (commonlength !== 0) {
                            diffs[pointer][1] = text_insert.substring(text_insert.length - commonlength) + diffs[pointer][1];
                            text_insert = text_insert.substring(0, text_insert.length - commonlength);
                            text_delete = text_delete.substring(0, text_delete.length - commonlength);
                        }
                    }
                    // Delete the offending records and add the merged ones.
                    var n = count_insert + count_delete;
                    if (text_delete.length === 0 && text_insert.length === 0) {
                        diffs.splice(pointer - n, n);
                        pointer = pointer - n;
                    } else if (text_delete.length === 0) {
                        diffs.splice(pointer - n, n, [
                            $4648e7a23084bb3e$var$DIFF_INSERT,
                            text_insert
                        ]);
                        pointer = pointer - n + 1;
                    } else if (text_insert.length === 0) {
                        diffs.splice(pointer - n, n, [
                            $4648e7a23084bb3e$var$DIFF_DELETE,
                            text_delete
                        ]);
                        pointer = pointer - n + 1;
                    } else {
                        diffs.splice(pointer - n, n, [
                            $4648e7a23084bb3e$var$DIFF_DELETE,
                            text_delete
                        ], [
                            $4648e7a23084bb3e$var$DIFF_INSERT,
                            text_insert
                        ]);
                        pointer = pointer - n + 2;
                    }
                }
                if (pointer !== 0 && diffs[pointer - 1][0] === $4648e7a23084bb3e$var$DIFF_EQUAL) {
                    // Merge this equality with the previous one.
                    diffs[pointer - 1][1] += diffs[pointer][1];
                    diffs.splice(pointer, 1);
                } else pointer++;
                count_insert = 0;
                count_delete = 0;
                text_delete = "";
                text_insert = "";
                break;
        }
    }
    if (diffs[diffs.length - 1][1] === "") diffs.pop(); // Remove the dummy entry at the end.
    // Second pass: look for single edits surrounded on both sides by equalities
    // which can be shifted sideways to eliminate an equality.
    // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
    var changes = false;
    pointer = 1;
    // Intentionally ignore the first and last element (don't need checking).
    while(pointer < diffs.length - 1){
        if (diffs[pointer - 1][0] === $4648e7a23084bb3e$var$DIFF_EQUAL && diffs[pointer + 1][0] === $4648e7a23084bb3e$var$DIFF_EQUAL) {
            // This is a single edit surrounded by equalities.
            if (diffs[pointer][1].substring(diffs[pointer][1].length - diffs[pointer - 1][1].length) === diffs[pointer - 1][1]) {
                // Shift the edit over the previous equality.
                diffs[pointer][1] = diffs[pointer - 1][1] + diffs[pointer][1].substring(0, diffs[pointer][1].length - diffs[pointer - 1][1].length);
                diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
                diffs.splice(pointer - 1, 1);
                changes = true;
            } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) == diffs[pointer + 1][1]) {
                // Shift the edit over the next equality.
                diffs[pointer - 1][1] += diffs[pointer + 1][1];
                diffs[pointer][1] = diffs[pointer][1].substring(diffs[pointer + 1][1].length) + diffs[pointer + 1][1];
                diffs.splice(pointer + 1, 1);
                changes = true;
            }
        }
        pointer++;
    }
    // If shifts were made, the diff needs reordering and another shift sweep.
    if (changes) $4648e7a23084bb3e$var$diff_cleanupMerge(diffs, fix_unicode);
}
function $4648e7a23084bb3e$var$is_surrogate_pair_start(charCode) {
    return charCode >= 0xd800 && charCode <= 0xdbff;
}
function $4648e7a23084bb3e$var$is_surrogate_pair_end(charCode) {
    return charCode >= 0xdc00 && charCode <= 0xdfff;
}
function $4648e7a23084bb3e$var$starts_with_pair_end(str) {
    return $4648e7a23084bb3e$var$is_surrogate_pair_end(str.charCodeAt(0));
}
function $4648e7a23084bb3e$var$ends_with_pair_start(str) {
    return $4648e7a23084bb3e$var$is_surrogate_pair_start(str.charCodeAt(str.length - 1));
}
function $4648e7a23084bb3e$var$remove_empty_tuples(tuples) {
    var ret = [];
    for(var i = 0; i < tuples.length; i++)if (tuples[i][1].length > 0) ret.push(tuples[i]);
    return ret;
}
function $4648e7a23084bb3e$var$make_edit_splice(before, oldMiddle, newMiddle, after) {
    if ($4648e7a23084bb3e$var$ends_with_pair_start(before) || $4648e7a23084bb3e$var$starts_with_pair_end(after)) return null;
    return $4648e7a23084bb3e$var$remove_empty_tuples([
        [
            $4648e7a23084bb3e$var$DIFF_EQUAL,
            before
        ],
        [
            $4648e7a23084bb3e$var$DIFF_DELETE,
            oldMiddle
        ],
        [
            $4648e7a23084bb3e$var$DIFF_INSERT,
            newMiddle
        ],
        [
            $4648e7a23084bb3e$var$DIFF_EQUAL,
            after
        ]
    ]);
}
function $4648e7a23084bb3e$var$find_cursor_edit_diff(oldText, newText, cursor_pos) {
    // note: this runs after equality check has ruled out exact equality
    var oldRange = typeof cursor_pos === "number" ? {
        index: cursor_pos,
        length: 0
    } : cursor_pos.oldRange;
    var newRange = typeof cursor_pos === "number" ? null : cursor_pos.newRange;
    // take into account the old and new selection to generate the best diff
    // possible for a text edit.  for example, a text change from "xxx" to "xx"
    // could be a delete or forwards-delete of any one of the x's, or the
    // result of selecting two of the x's and typing "x".
    var oldLength = oldText.length;
    var newLength = newText.length;
    if (oldRange.length === 0 && (newRange === null || newRange.length === 0)) {
        // see if we have an insert or delete before or after cursor
        var oldCursor = oldRange.index;
        var oldBefore = oldText.slice(0, oldCursor);
        var oldAfter = oldText.slice(oldCursor);
        var maybeNewCursor = newRange ? newRange.index : null;
        editBefore: {
            // is this an insert or delete right before oldCursor?
            var newCursor = oldCursor + newLength - oldLength;
            if (maybeNewCursor !== null && maybeNewCursor !== newCursor) break editBefore;
            if (newCursor < 0 || newCursor > newLength) break editBefore;
            var newBefore = newText.slice(0, newCursor);
            var newAfter = newText.slice(newCursor);
            if (newAfter !== oldAfter) break editBefore;
            var prefixLength = Math.min(oldCursor, newCursor);
            var oldPrefix = oldBefore.slice(0, prefixLength);
            var newPrefix = newBefore.slice(0, prefixLength);
            if (oldPrefix !== newPrefix) break editBefore;
            var oldMiddle = oldBefore.slice(prefixLength);
            var newMiddle = newBefore.slice(prefixLength);
            return $4648e7a23084bb3e$var$make_edit_splice(oldPrefix, oldMiddle, newMiddle, oldAfter);
        }
        editAfter: {
            // is this an insert or delete right after oldCursor?
            if (maybeNewCursor !== null && maybeNewCursor !== oldCursor) break editAfter;
            var cursor = oldCursor;
            var newBefore = newText.slice(0, cursor);
            var newAfter = newText.slice(cursor);
            if (newBefore !== oldBefore) break editAfter;
            var suffixLength = Math.min(oldLength - cursor, newLength - cursor);
            var oldSuffix = oldAfter.slice(oldAfter.length - suffixLength);
            var newSuffix = newAfter.slice(newAfter.length - suffixLength);
            if (oldSuffix !== newSuffix) break editAfter;
            var oldMiddle = oldAfter.slice(0, oldAfter.length - suffixLength);
            var newMiddle = newAfter.slice(0, newAfter.length - suffixLength);
            return $4648e7a23084bb3e$var$make_edit_splice(oldBefore, oldMiddle, newMiddle, oldSuffix);
        }
    }
    if (oldRange.length > 0 && newRange && newRange.length === 0) replaceRange: {
        // see if diff could be a splice of the old selection range
        var oldPrefix = oldText.slice(0, oldRange.index);
        var oldSuffix = oldText.slice(oldRange.index + oldRange.length);
        var prefixLength = oldPrefix.length;
        var suffixLength = oldSuffix.length;
        if (newLength < prefixLength + suffixLength) break replaceRange;
        var newPrefix = newText.slice(0, prefixLength);
        var newSuffix = newText.slice(newLength - suffixLength);
        if (oldPrefix !== newPrefix || oldSuffix !== newSuffix) break replaceRange;
        var oldMiddle = oldText.slice(prefixLength, oldLength - suffixLength);
        var newMiddle = newText.slice(prefixLength, newLength - suffixLength);
        return $4648e7a23084bb3e$var$make_edit_splice(oldPrefix, oldMiddle, newMiddle, oldSuffix);
    }
    return null;
}
function $4648e7a23084bb3e$var$diff(text1, text2, cursor_pos, cleanup) {
    // only pass fix_unicode=true at the top level, not when diff_main is
    // recursively invoked
    return $4648e7a23084bb3e$var$diff_main(text1, text2, cursor_pos, cleanup, true);
}
$4648e7a23084bb3e$var$diff.INSERT = $4648e7a23084bb3e$var$DIFF_INSERT;
$4648e7a23084bb3e$var$diff.DELETE = $4648e7a23084bb3e$var$DIFF_DELETE;
$4648e7a23084bb3e$var$diff.EQUAL = $4648e7a23084bb3e$var$DIFF_EQUAL;
$4648e7a23084bb3e$exports = $4648e7a23084bb3e$var$diff;



var $bqDqN = parcelRequire("bqDqN");

var $c4HIr = parcelRequire("c4HIr");
var $7ad854af07ca65f1$exports = {};
"use strict";
Object.defineProperty($7ad854af07ca65f1$exports, "__esModule", {
    value: true
});

var $bqDqN = parcelRequire("bqDqN");

var $c4HIr = parcelRequire("c4HIr");
var $7ad854af07ca65f1$var$AttributeMap;
(function(AttributeMap) {
    function compose(a = {}, b = {}, keepNull = false) {
        if (typeof a !== 'object') a = {};
        if (typeof b !== 'object') b = {};
        let attributes = $bqDqN(b);
        if (!keepNull) attributes = Object.keys(attributes).reduce((copy, key)=>{
            if (attributes[key] != null) copy[key] = attributes[key];
            return copy;
        }, {});
        for(const key in a)if (a[key] !== undefined && b[key] === undefined) attributes[key] = a[key];
        return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
    AttributeMap.compose = compose;
    function diff(a = {}, b = {}) {
        if (typeof a !== 'object') a = {};
        if (typeof b !== 'object') b = {};
        const attributes = Object.keys(a).concat(Object.keys(b)).reduce((attrs, key)=>{
            if (!$c4HIr(a[key], b[key])) attrs[key] = b[key] === undefined ? null : b[key];
            return attrs;
        }, {});
        return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
    AttributeMap.diff = diff;
    function invert(attr = {}, base = {}) {
        attr = attr || {};
        const baseInverted = Object.keys(base).reduce((memo, key)=>{
            if (base[key] !== attr[key] && attr[key] !== undefined) memo[key] = base[key];
            return memo;
        }, {});
        return Object.keys(attr).reduce((memo, key)=>{
            if (attr[key] !== base[key] && base[key] === undefined) memo[key] = null;
            return memo;
        }, baseInverted);
    }
    AttributeMap.invert = invert;
    function transform(a, b, priority = false) {
        if (typeof a !== 'object') return b;
        if (typeof b !== 'object') return undefined;
        if (!priority) return b; // b simply overwrites us without priority
        const attributes = Object.keys(b).reduce((attrs, key)=>{
            if (a[key] === undefined) attrs[key] = b[key]; // null is a valid value
            return attrs;
        }, {});
        return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
    AttributeMap.transform = transform;
})($7ad854af07ca65f1$var$AttributeMap || ($7ad854af07ca65f1$var$AttributeMap = {}));
$7ad854af07ca65f1$exports.default = $7ad854af07ca65f1$var$AttributeMap;


$88e60522c01c2553$exports.AttributeMap = $7ad854af07ca65f1$exports.default;
var $3257d51204e0c21d$exports = {};
"use strict";
Object.defineProperty($3257d51204e0c21d$exports, "__esModule", {
    value: true
});
var $3257d51204e0c21d$var$Op;
(function(Op) {
    function length(op) {
        if (typeof op.delete === 'number') return op.delete;
        else if (typeof op.retain === 'number') return op.retain;
        else if (typeof op.retain === 'object' && op.retain !== null) return 1;
        else return typeof op.insert === 'string' ? op.insert.length : 1;
    }
    Op.length = length;
})($3257d51204e0c21d$var$Op || ($3257d51204e0c21d$var$Op = {}));
$3257d51204e0c21d$exports.default = $3257d51204e0c21d$var$Op;


$88e60522c01c2553$exports.Op = $3257d51204e0c21d$exports.default;
var $8c9f6738b14af3bd$exports = {};
"use strict";
Object.defineProperty($8c9f6738b14af3bd$exports, "__esModule", {
    value: true
});

class $8c9f6738b14af3bd$var$Iterator {
    constructor(ops){
        this.ops = ops;
        this.index = 0;
        this.offset = 0;
    }
    hasNext() {
        return this.peekLength() < Infinity;
    }
    next(length) {
        if (!length) length = Infinity;
        const nextOp = this.ops[this.index];
        if (nextOp) {
            const offset = this.offset;
            const opLength = $3257d51204e0c21d$exports.default.length(nextOp);
            if (length >= opLength - offset) {
                length = opLength - offset;
                this.index += 1;
                this.offset = 0;
            } else this.offset += length;
            if (typeof nextOp.delete === 'number') return {
                delete: length
            };
            else {
                const retOp = {};
                if (nextOp.attributes) retOp.attributes = nextOp.attributes;
                if (typeof nextOp.retain === 'number') retOp.retain = length;
                else if (typeof nextOp.retain === 'object' && nextOp.retain !== null) // offset should === 0, length should === 1
                retOp.retain = nextOp.retain;
                else if (typeof nextOp.insert === 'string') retOp.insert = nextOp.insert.substr(offset, length);
                else // offset should === 0, length should === 1
                retOp.insert = nextOp.insert;
                return retOp;
            }
        } else return {
            retain: Infinity
        };
    }
    peek() {
        return this.ops[this.index];
    }
    peekLength() {
        if (this.ops[this.index]) // Should never return 0 if our index is being managed correctly
        return $3257d51204e0c21d$exports.default.length(this.ops[this.index]) - this.offset;
        else return Infinity;
    }
    peekType() {
        const op = this.ops[this.index];
        if (op) {
            if (typeof op.delete === 'number') return 'delete';
            else if (typeof op.retain === 'number' || typeof op.retain === 'object' && op.retain !== null) return 'retain';
            else return 'insert';
        }
        return 'retain';
    }
    rest() {
        if (!this.hasNext()) return [];
        else if (this.offset === 0) return this.ops.slice(this.index);
        else {
            const offset = this.offset;
            const index = this.index;
            const next = this.next();
            const rest = this.ops.slice(this.index);
            this.offset = offset;
            this.index = index;
            return [
                next
            ].concat(rest);
        }
    }
}
$8c9f6738b14af3bd$exports.default = $8c9f6738b14af3bd$var$Iterator;


$88e60522c01c2553$exports.OpIterator = $8c9f6738b14af3bd$exports.default;
const $88e60522c01c2553$var$NULL_CHARACTER = String.fromCharCode(0); // Placeholder char for embed in diff()
const $88e60522c01c2553$var$getEmbedTypeAndData = (a, b)=>{
    if (typeof a !== 'object' || a === null) throw new Error(`cannot retain a ${typeof a}`);
    if (typeof b !== 'object' || b === null) throw new Error(`cannot retain a ${typeof b}`);
    const embedType = Object.keys(a)[0];
    if (!embedType || embedType !== Object.keys(b)[0]) throw new Error(`embed types not matched: ${embedType} != ${Object.keys(b)[0]}`);
    return [
        embedType,
        a[embedType],
        b[embedType]
    ];
};
class $88e60522c01c2553$var$Delta {
    constructor(ops){
        // Assume we are given a well formed ops
        if (Array.isArray(ops)) this.ops = ops;
        else if (ops != null && Array.isArray(ops.ops)) this.ops = ops.ops;
        else this.ops = [];
    }
    static registerEmbed(embedType, handler) {
        this.handlers[embedType] = handler;
    }
    static unregisterEmbed(embedType) {
        delete this.handlers[embedType];
    }
    static getHandler(embedType) {
        const handler = this.handlers[embedType];
        if (!handler) throw new Error(`no handlers for embed type "${embedType}"`);
        return handler;
    }
    insert(arg, attributes) {
        const newOp = {};
        if (typeof arg === 'string' && arg.length === 0) return this;
        newOp.insert = arg;
        if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) newOp.attributes = attributes;
        return this.push(newOp);
    }
    delete(length) {
        if (length <= 0) return this;
        return this.push({
            delete: length
        });
    }
    retain(length, attributes) {
        if (typeof length === 'number' && length <= 0) return this;
        const newOp = {
            retain: length
        };
        if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) newOp.attributes = attributes;
        return this.push(newOp);
    }
    push(newOp) {
        let index = this.ops.length;
        let lastOp = this.ops[index - 1];
        newOp = $bqDqN(newOp);
        if (typeof lastOp === 'object') {
            if (typeof newOp.delete === 'number' && typeof lastOp.delete === 'number') {
                this.ops[index - 1] = {
                    delete: lastOp.delete + newOp.delete
                };
                return this;
            }
            // Since it does not matter if we insert before or after deleting at the same index,
            // always prefer to insert first
            if (typeof lastOp.delete === 'number' && newOp.insert != null) {
                index -= 1;
                lastOp = this.ops[index - 1];
                if (typeof lastOp !== 'object') {
                    this.ops.unshift(newOp);
                    return this;
                }
            }
            if ($c4HIr(newOp.attributes, lastOp.attributes)) {
                if (typeof newOp.insert === 'string' && typeof lastOp.insert === 'string') {
                    this.ops[index - 1] = {
                        insert: lastOp.insert + newOp.insert
                    };
                    if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes;
                    return this;
                } else if (typeof newOp.retain === 'number' && typeof lastOp.retain === 'number') {
                    this.ops[index - 1] = {
                        retain: lastOp.retain + newOp.retain
                    };
                    if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes;
                    return this;
                }
            }
        }
        if (index === this.ops.length) this.ops.push(newOp);
        else this.ops.splice(index, 0, newOp);
        return this;
    }
    chop() {
        const lastOp = this.ops[this.ops.length - 1];
        if (lastOp && typeof lastOp.retain === 'number' && !lastOp.attributes) this.ops.pop();
        return this;
    }
    filter(predicate) {
        return this.ops.filter(predicate);
    }
    forEach(predicate) {
        this.ops.forEach(predicate);
    }
    map(predicate) {
        return this.ops.map(predicate);
    }
    partition(predicate) {
        const passed = [];
        const failed = [];
        this.forEach((op)=>{
            const target = predicate(op) ? passed : failed;
            target.push(op);
        });
        return [
            passed,
            failed
        ];
    }
    reduce(predicate, initialValue) {
        return this.ops.reduce(predicate, initialValue);
    }
    changeLength() {
        return this.reduce((length, elem)=>{
            if (elem.insert) return length + $3257d51204e0c21d$exports.default.length(elem);
            else if (elem.delete) return length - elem.delete;
            return length;
        }, 0);
    }
    length() {
        return this.reduce((length, elem)=>{
            return length + $3257d51204e0c21d$exports.default.length(elem);
        }, 0);
    }
    slice(start = 0, end = Infinity) {
        const ops = [];
        const iter = new $8c9f6738b14af3bd$exports.default(this.ops);
        let index = 0;
        while(index < end && iter.hasNext()){
            let nextOp;
            if (index < start) nextOp = iter.next(start - index);
            else {
                nextOp = iter.next(end - index);
                ops.push(nextOp);
            }
            index += $3257d51204e0c21d$exports.default.length(nextOp);
        }
        return new $88e60522c01c2553$var$Delta(ops);
    }
    compose(other) {
        const thisIter = new $8c9f6738b14af3bd$exports.default(this.ops);
        const otherIter = new $8c9f6738b14af3bd$exports.default(other.ops);
        const ops = [];
        const firstOther = otherIter.peek();
        if (firstOther != null && typeof firstOther.retain === 'number' && firstOther.attributes == null) {
            let firstLeft = firstOther.retain;
            while(thisIter.peekType() === 'insert' && thisIter.peekLength() <= firstLeft){
                firstLeft -= thisIter.peekLength();
                ops.push(thisIter.next());
            }
            if (firstOther.retain - firstLeft > 0) otherIter.next(firstOther.retain - firstLeft);
        }
        const delta = new $88e60522c01c2553$var$Delta(ops);
        while(thisIter.hasNext() || otherIter.hasNext()){
            if (otherIter.peekType() === 'insert') delta.push(otherIter.next());
            else if (thisIter.peekType() === 'delete') delta.push(thisIter.next());
            else {
                const length = Math.min(thisIter.peekLength(), otherIter.peekLength());
                const thisOp = thisIter.next(length);
                const otherOp = otherIter.next(length);
                if (otherOp.retain) {
                    const newOp = {};
                    if (typeof thisOp.retain === 'number') newOp.retain = typeof otherOp.retain === 'number' ? length : otherOp.retain;
                    else if (typeof otherOp.retain === 'number') {
                        if (thisOp.retain == null) newOp.insert = thisOp.insert;
                        else newOp.retain = thisOp.retain;
                    } else {
                        const action = thisOp.retain == null ? 'insert' : 'retain';
                        const [embedType, thisData, otherData] = $88e60522c01c2553$var$getEmbedTypeAndData(thisOp[action], otherOp.retain);
                        const handler = $88e60522c01c2553$var$Delta.getHandler(embedType);
                        newOp[action] = {
                            [embedType]: handler.compose(thisData, otherData, action === 'retain')
                        };
                    }
                    // Preserve null when composing with a retain, otherwise remove it for inserts
                    const attributes = $7ad854af07ca65f1$exports.default.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === 'number');
                    if (attributes) newOp.attributes = attributes;
                    delta.push(newOp);
                    // Optimization if rest of other is just retain
                    if (!otherIter.hasNext() && $c4HIr(delta.ops[delta.ops.length - 1], newOp)) {
                        const rest = new $88e60522c01c2553$var$Delta(thisIter.rest());
                        return delta.concat(rest).chop();
                    }
                // Other op should be delete, we could be an insert or retain
                // Insert + delete cancels out
                } else if (typeof otherOp.delete === 'number' && (typeof thisOp.retain === 'number' || typeof thisOp.retain === 'object' && thisOp.retain !== null)) delta.push(otherOp);
            }
        }
        return delta.chop();
    }
    concat(other) {
        const delta = new $88e60522c01c2553$var$Delta(this.ops.slice());
        if (other.ops.length > 0) {
            delta.push(other.ops[0]);
            delta.ops = delta.ops.concat(other.ops.slice(1));
        }
        return delta;
    }
    diff(other, cursor) {
        if (this.ops === other.ops) return new $88e60522c01c2553$var$Delta();
        const strings = [
            this,
            other
        ].map((delta)=>{
            return delta.map((op)=>{
                if (op.insert != null) return typeof op.insert === 'string' ? op.insert : $88e60522c01c2553$var$NULL_CHARACTER;
                const prep = delta === other ? 'on' : 'with';
                throw new Error('diff() called ' + prep + ' non-document');
            }).join('');
        });
        const retDelta = new $88e60522c01c2553$var$Delta();
        const diffResult = $4648e7a23084bb3e$exports(strings[0], strings[1], cursor, true);
        const thisIter = new $8c9f6738b14af3bd$exports.default(this.ops);
        const otherIter = new $8c9f6738b14af3bd$exports.default(other.ops);
        diffResult.forEach((component)=>{
            let length = component[1].length;
            while(length > 0){
                let opLength = 0;
                switch(component[0]){
                    case $4648e7a23084bb3e$exports.INSERT:
                        opLength = Math.min(otherIter.peekLength(), length);
                        retDelta.push(otherIter.next(opLength));
                        break;
                    case $4648e7a23084bb3e$exports.DELETE:
                        opLength = Math.min(length, thisIter.peekLength());
                        thisIter.next(opLength);
                        retDelta.delete(opLength);
                        break;
                    case $4648e7a23084bb3e$exports.EQUAL:
                        opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
                        const thisOp = thisIter.next(opLength);
                        const otherOp = otherIter.next(opLength);
                        if ($c4HIr(thisOp.insert, otherOp.insert)) retDelta.retain(opLength, $7ad854af07ca65f1$exports.default.diff(thisOp.attributes, otherOp.attributes));
                        else retDelta.push(otherOp).delete(opLength);
                        break;
                }
                length -= opLength;
            }
        });
        return retDelta.chop();
    }
    eachLine(predicate, newline = '\n') {
        const iter = new $8c9f6738b14af3bd$exports.default(this.ops);
        let line = new $88e60522c01c2553$var$Delta();
        let i = 0;
        while(iter.hasNext()){
            if (iter.peekType() !== 'insert') return;
            const thisOp = iter.peek();
            const start = $3257d51204e0c21d$exports.default.length(thisOp) - iter.peekLength();
            const index = typeof thisOp.insert === 'string' ? thisOp.insert.indexOf(newline, start) - start : -1;
            if (index < 0) line.push(iter.next());
            else if (index > 0) line.push(iter.next(index));
            else {
                if (predicate(line, iter.next(1).attributes || {}, i) === false) return;
                i += 1;
                line = new $88e60522c01c2553$var$Delta();
            }
        }
        if (line.length() > 0) predicate(line, {}, i);
    }
    invert(base) {
        const inverted = new $88e60522c01c2553$var$Delta();
        this.reduce((baseIndex, op)=>{
            if (op.insert) inverted.delete($3257d51204e0c21d$exports.default.length(op));
            else if (typeof op.retain === 'number' && op.attributes == null) {
                inverted.retain(op.retain);
                return baseIndex + op.retain;
            } else if (op.delete || typeof op.retain === 'number') {
                const length = op.delete || op.retain;
                const slice = base.slice(baseIndex, baseIndex + length);
                slice.forEach((baseOp)=>{
                    if (op.delete) inverted.push(baseOp);
                    else if (op.retain && op.attributes) inverted.retain($3257d51204e0c21d$exports.default.length(baseOp), $7ad854af07ca65f1$exports.default.invert(op.attributes, baseOp.attributes));
                });
                return baseIndex + length;
            } else if (typeof op.retain === 'object' && op.retain !== null) {
                const slice = base.slice(baseIndex, baseIndex + 1);
                const baseOp = new $8c9f6738b14af3bd$exports.default(slice.ops).next();
                const [embedType, opData, baseOpData] = $88e60522c01c2553$var$getEmbedTypeAndData(op.retain, baseOp.insert);
                const handler = $88e60522c01c2553$var$Delta.getHandler(embedType);
                inverted.retain({
                    [embedType]: handler.invert(opData, baseOpData)
                }, $7ad854af07ca65f1$exports.default.invert(op.attributes, baseOp.attributes));
                return baseIndex + 1;
            }
            return baseIndex;
        }, 0);
        return inverted.chop();
    }
    transform(arg, priority = false) {
        priority = !!priority;
        if (typeof arg === 'number') return this.transformPosition(arg, priority);
        const other = arg;
        const thisIter = new $8c9f6738b14af3bd$exports.default(this.ops);
        const otherIter = new $8c9f6738b14af3bd$exports.default(other.ops);
        const delta = new $88e60522c01c2553$var$Delta();
        while(thisIter.hasNext() || otherIter.hasNext()){
            if (thisIter.peekType() === 'insert' && (priority || otherIter.peekType() !== 'insert')) delta.retain($3257d51204e0c21d$exports.default.length(thisIter.next()));
            else if (otherIter.peekType() === 'insert') delta.push(otherIter.next());
            else {
                const length = Math.min(thisIter.peekLength(), otherIter.peekLength());
                const thisOp = thisIter.next(length);
                const otherOp = otherIter.next(length);
                if (thisOp.delete) continue;
                else if (otherOp.delete) delta.push(otherOp);
                else {
                    const thisData = thisOp.retain;
                    const otherData = otherOp.retain;
                    let transformedData = typeof otherData === 'object' && otherData !== null ? otherData : length;
                    if (typeof thisData === 'object' && thisData !== null && typeof otherData === 'object' && otherData !== null) {
                        const embedType = Object.keys(thisData)[0];
                        if (embedType === Object.keys(otherData)[0]) {
                            const handler = $88e60522c01c2553$var$Delta.getHandler(embedType);
                            if (handler) transformedData = {
                                [embedType]: handler.transform(thisData[embedType], otherData[embedType], priority)
                            };
                        }
                    }
                    // We retain either their retain or insert
                    delta.retain(transformedData, $7ad854af07ca65f1$exports.default.transform(thisOp.attributes, otherOp.attributes, priority));
                }
            }
        }
        return delta.chop();
    }
    transformPosition(index, priority = false) {
        priority = !!priority;
        const thisIter = new $8c9f6738b14af3bd$exports.default(this.ops);
        let offset = 0;
        while(thisIter.hasNext() && offset <= index){
            const length = thisIter.peekLength();
            const nextType = thisIter.peekType();
            thisIter.next();
            if (nextType === 'delete') {
                index -= Math.min(length, index - offset);
                continue;
            } else if (nextType === 'insert' && (offset < index || !priority)) index += length;
            offset += length;
        }
        return index;
    }
}
$88e60522c01c2553$var$Delta.Op = $3257d51204e0c21d$exports.default;
$88e60522c01c2553$var$Delta.OpIterator = $8c9f6738b14af3bd$exports.default;
$88e60522c01c2553$var$Delta.AttributeMap = $7ad854af07ca65f1$exports.default;
$88e60522c01c2553$var$Delta.handlers = {};
$88e60522c01c2553$exports.default = $88e60522c01c2553$var$Delta;
$88e60522c01c2553$exports = $88e60522c01c2553$var$Delta;
$88e60522c01c2553$exports.default = $88e60522c01c2553$var$Delta;







/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $b8862b2b94fedac8$var$baseAssign(object, source) {
    return object && (0, $2a832f5cd9b6cb15$export$2e2bcd8739ae039)(source, (0, $a11509b56113c9fb$export$2e2bcd8739ae039)(source), object);
}
var $b8862b2b94fedac8$export$2e2bcd8739ae039 = $b8862b2b94fedac8$var$baseAssign;




/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $79c65028a07bba19$var$baseAssignIn(object, source) {
    return object && (0, $2a832f5cd9b6cb15$export$2e2bcd8739ae039)(source, (0, $a597badc098aca4b$export$2e2bcd8739ae039)(source), object);
}
var $79c65028a07bba19$export$2e2bcd8739ae039 = $79c65028a07bba19$var$baseAssignIn;



var $2eDJ7 = parcelRequire("2eDJ7");



/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $9ed9e7c200747f93$var$copySymbols(source, object) {
    return (0, $2a832f5cd9b6cb15$export$2e2bcd8739ae039)(source, (0, $4b5f315807e3de5b$export$2e2bcd8739ae039)(source), object);
}
var $9ed9e7c200747f93$export$2e2bcd8739ae039 = $9ed9e7c200747f93$var$copySymbols;







/* Built-in method references for those with the same name as other `lodash` methods. */ var $a7d79a3387834fde$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $a7d79a3387834fde$var$getSymbolsIn = !$a7d79a3387834fde$var$nativeGetSymbols ? (0, $98123970b3618300$export$2e2bcd8739ae039) : function(object) {
    var result = [];
    while(object){
        (0, $719b592aa8a00f04$export$2e2bcd8739ae039)(result, (0, $4b5f315807e3de5b$export$2e2bcd8739ae039)(object));
        object = (0, $7d88ac4aa101dab4$export$2e2bcd8739ae039)(object);
    }
    return result;
};
var $a7d79a3387834fde$export$2e2bcd8739ae039 = $a7d79a3387834fde$var$getSymbolsIn;


/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $a8cc7e8f06c0ed9b$var$copySymbolsIn(source, object) {
    return (0, $2a832f5cd9b6cb15$export$2e2bcd8739ae039)(source, (0, $a7d79a3387834fde$export$2e2bcd8739ae039)(source), object);
}
var $a8cc7e8f06c0ed9b$export$2e2bcd8739ae039 = $a8cc7e8f06c0ed9b$var$copySymbolsIn;






/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $1571c45bb644e209$var$getAllKeysIn(object) {
    return (0, $98781eb34f3e36ac$export$2e2bcd8739ae039)(object, (0, $a597badc098aca4b$export$2e2bcd8739ae039), (0, $a7d79a3387834fde$export$2e2bcd8739ae039));
}
var $1571c45bb644e209$export$2e2bcd8739ae039 = $1571c45bb644e209$var$getAllKeysIn;



/** Used for built-in method references. */ var $c6072646e2485127$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c6072646e2485127$var$hasOwnProperty = $c6072646e2485127$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $c6072646e2485127$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $c6072646e2485127$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $c6072646e2485127$export$2e2bcd8739ae039 = $c6072646e2485127$var$initCloneArray;




/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $63ff2d96301c4856$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $d5acac4d1d0ddac1$export$2e2bcd8739ae039)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $63ff2d96301c4856$export$2e2bcd8739ae039 = $63ff2d96301c4856$var$cloneDataView;


/** Used to match `RegExp` flags from their coerced string values. */ var $af96b269000655b5$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $af96b269000655b5$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $af96b269000655b5$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $af96b269000655b5$export$2e2bcd8739ae039 = $af96b269000655b5$var$cloneRegExp;



/** Used to convert symbols to primitives and strings. */ var $6f0bd16cb979ce99$var$symbolProto = (0, $e9bc3be843ae7db3$export$2e2bcd8739ae039) ? (0, $e9bc3be843ae7db3$export$2e2bcd8739ae039).prototype : undefined, $6f0bd16cb979ce99$var$symbolValueOf = $6f0bd16cb979ce99$var$symbolProto ? $6f0bd16cb979ce99$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $6f0bd16cb979ce99$var$cloneSymbol(symbol) {
    return $6f0bd16cb979ce99$var$symbolValueOf ? Object($6f0bd16cb979ce99$var$symbolValueOf.call(symbol)) : {};
}
var $6f0bd16cb979ce99$export$2e2bcd8739ae039 = $6f0bd16cb979ce99$var$cloneSymbol;



/** `Object#toString` result references. */ var $95d6377e5f935fea$var$boolTag = '[object Boolean]', $95d6377e5f935fea$var$dateTag = '[object Date]', $95d6377e5f935fea$var$mapTag = '[object Map]', $95d6377e5f935fea$var$numberTag = '[object Number]', $95d6377e5f935fea$var$regexpTag = '[object RegExp]', $95d6377e5f935fea$var$setTag = '[object Set]', $95d6377e5f935fea$var$stringTag = '[object String]', $95d6377e5f935fea$var$symbolTag = '[object Symbol]';
var $95d6377e5f935fea$var$arrayBufferTag = '[object ArrayBuffer]', $95d6377e5f935fea$var$dataViewTag = '[object DataView]', $95d6377e5f935fea$var$float32Tag = '[object Float32Array]', $95d6377e5f935fea$var$float64Tag = '[object Float64Array]', $95d6377e5f935fea$var$int8Tag = '[object Int8Array]', $95d6377e5f935fea$var$int16Tag = '[object Int16Array]', $95d6377e5f935fea$var$int32Tag = '[object Int32Array]', $95d6377e5f935fea$var$uint8Tag = '[object Uint8Array]', $95d6377e5f935fea$var$uint8ClampedTag = '[object Uint8ClampedArray]', $95d6377e5f935fea$var$uint16Tag = '[object Uint16Array]', $95d6377e5f935fea$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $95d6377e5f935fea$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $95d6377e5f935fea$var$arrayBufferTag:
            return (0, $d5acac4d1d0ddac1$export$2e2bcd8739ae039)(object);
        case $95d6377e5f935fea$var$boolTag:
        case $95d6377e5f935fea$var$dateTag:
            return new Ctor(+object);
        case $95d6377e5f935fea$var$dataViewTag:
            return (0, $63ff2d96301c4856$export$2e2bcd8739ae039)(object, isDeep);
        case $95d6377e5f935fea$var$float32Tag:
        case $95d6377e5f935fea$var$float64Tag:
        case $95d6377e5f935fea$var$int8Tag:
        case $95d6377e5f935fea$var$int16Tag:
        case $95d6377e5f935fea$var$int32Tag:
        case $95d6377e5f935fea$var$uint8Tag:
        case $95d6377e5f935fea$var$uint8ClampedTag:
        case $95d6377e5f935fea$var$uint16Tag:
        case $95d6377e5f935fea$var$uint32Tag:
            return (0, $4128b24309084d7c$export$2e2bcd8739ae039)(object, isDeep);
        case $95d6377e5f935fea$var$mapTag:
            return new Ctor;
        case $95d6377e5f935fea$var$numberTag:
        case $95d6377e5f935fea$var$stringTag:
            return new Ctor(object);
        case $95d6377e5f935fea$var$regexpTag:
            return (0, $af96b269000655b5$export$2e2bcd8739ae039)(object);
        case $95d6377e5f935fea$var$setTag:
            return new Ctor;
        case $95d6377e5f935fea$var$symbolTag:
            return (0, $6f0bd16cb979ce99$export$2e2bcd8739ae039)(object);
    }
}
var $95d6377e5f935fea$export$2e2bcd8739ae039 = $95d6377e5f935fea$var$initCloneByTag;





var $kmshc = parcelRequire("kmshc");


/** `Object#toString` result references. */ var $85cbff35625a6e4c$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $85cbff35625a6e4c$var$baseIsMap(value) {
    return (0, $8ef6de3f0576ee8c$export$2e2bcd8739ae039)(value) && (0, $f99ddab08b845c56$export$2e2bcd8739ae039)(value) == $85cbff35625a6e4c$var$mapTag;
}
var $85cbff35625a6e4c$export$2e2bcd8739ae039 = $85cbff35625a6e4c$var$baseIsMap;




var $5LKLe = parcelRequire("5LKLe");
/* Node.js helper references. */ var $c5f0bde35a503a98$var$nodeIsMap = (0, $5LKLe.default) && (0, $5LKLe.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $c5f0bde35a503a98$var$isMap = $c5f0bde35a503a98$var$nodeIsMap ? (0, $2bbf683a8d173f77$export$2e2bcd8739ae039)($c5f0bde35a503a98$var$nodeIsMap) : (0, $85cbff35625a6e4c$export$2e2bcd8739ae039);
var $c5f0bde35a503a98$export$2e2bcd8739ae039 = $c5f0bde35a503a98$var$isMap;





/** `Object#toString` result references. */ var $deba86a12a968c87$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $deba86a12a968c87$var$baseIsSet(value) {
    return (0, $8ef6de3f0576ee8c$export$2e2bcd8739ae039)(value) && (0, $f99ddab08b845c56$export$2e2bcd8739ae039)(value) == $deba86a12a968c87$var$setTag;
}
var $deba86a12a968c87$export$2e2bcd8739ae039 = $deba86a12a968c87$var$baseIsSet;




var $5LKLe = parcelRequire("5LKLe");
/* Node.js helper references. */ var $819d0870c9967090$var$nodeIsSet = (0, $5LKLe.default) && (0, $5LKLe.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $819d0870c9967090$var$isSet = $819d0870c9967090$var$nodeIsSet ? (0, $2bbf683a8d173f77$export$2e2bcd8739ae039)($819d0870c9967090$var$nodeIsSet) : (0, $deba86a12a968c87$export$2e2bcd8739ae039);
var $819d0870c9967090$export$2e2bcd8739ae039 = $819d0870c9967090$var$isSet;




/** Used to compose bitmasks for cloning. */ var $96b6bdfb49eb2b47$var$CLONE_DEEP_FLAG = 1, $96b6bdfb49eb2b47$var$CLONE_FLAT_FLAG = 2, $96b6bdfb49eb2b47$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $96b6bdfb49eb2b47$var$argsTag = '[object Arguments]', $96b6bdfb49eb2b47$var$arrayTag = '[object Array]', $96b6bdfb49eb2b47$var$boolTag = '[object Boolean]', $96b6bdfb49eb2b47$var$dateTag = '[object Date]', $96b6bdfb49eb2b47$var$errorTag = '[object Error]', $96b6bdfb49eb2b47$var$funcTag = '[object Function]', $96b6bdfb49eb2b47$var$genTag = '[object GeneratorFunction]', $96b6bdfb49eb2b47$var$mapTag = '[object Map]', $96b6bdfb49eb2b47$var$numberTag = '[object Number]', $96b6bdfb49eb2b47$var$objectTag = '[object Object]', $96b6bdfb49eb2b47$var$regexpTag = '[object RegExp]', $96b6bdfb49eb2b47$var$setTag = '[object Set]', $96b6bdfb49eb2b47$var$stringTag = '[object String]', $96b6bdfb49eb2b47$var$symbolTag = '[object Symbol]', $96b6bdfb49eb2b47$var$weakMapTag = '[object WeakMap]';
var $96b6bdfb49eb2b47$var$arrayBufferTag = '[object ArrayBuffer]', $96b6bdfb49eb2b47$var$dataViewTag = '[object DataView]', $96b6bdfb49eb2b47$var$float32Tag = '[object Float32Array]', $96b6bdfb49eb2b47$var$float64Tag = '[object Float64Array]', $96b6bdfb49eb2b47$var$int8Tag = '[object Int8Array]', $96b6bdfb49eb2b47$var$int16Tag = '[object Int16Array]', $96b6bdfb49eb2b47$var$int32Tag = '[object Int32Array]', $96b6bdfb49eb2b47$var$uint8Tag = '[object Uint8Array]', $96b6bdfb49eb2b47$var$uint8ClampedTag = '[object Uint8ClampedArray]', $96b6bdfb49eb2b47$var$uint16Tag = '[object Uint16Array]', $96b6bdfb49eb2b47$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $96b6bdfb49eb2b47$var$cloneableTags = {};
$96b6bdfb49eb2b47$var$cloneableTags[$96b6bdfb49eb2b47$var$argsTag] = $96b6bdfb49eb2b47$var$cloneableTags[$96b6bdfb49eb2b47$var$arrayTag] = $96b6bdfb49eb2b47$var$cloneableTags[$96b6bdfb49eb2b47$var$arrayBufferTag] = $96b6bdfb49eb2b47$var$cloneableTags[$96b6bdfb49eb2b47$var$dataViewTag] = $96b6bdfb49eb2b47$var$cloneableTags[$96b6bdfb49eb2b47$var$boolTag] = $96b6bdfb49eb2b47$var$cloneableTags[$96b6bdfb49eb2b47$var$dateTag] = $96b6bdfb49eb2b47$var$cloneableTags[$96b6bdfb49eb2b47$var$float32Tag] = $96b6bdfb49eb2b47$var$cloneableTags[$96b6bdfb49eb2b47$var$float64Tag] = $96b6bdfb49eb2b47$var$cloneableTags[$96b6bdfb49eb2b47$var$int8Tag] = $96b6bdfb49eb2b47$var$cloneableTags[$96b6bdfb49eb2b47$var$int16Tag] = $96b6bdfb49eb2b47$var$cloneableTags[$96b6bdfb49eb2b47$var$int32Tag] = $96b6bdfb49eb2b47$var$cloneableTags[$96b6bdfb49eb2b47$var$mapTag] = $96b6bdfb49eb2b47$var$cloneableTags[$96b6bdfb49eb2b47$var$numberTag] = $96b6bdfb49eb2b47$var$cloneableTags[$96b6bdfb49eb2b47$var$objectTag] = $96b6bdfb49eb2b47$var$cloneableTags[$96b6bdfb49eb2b47$var$regexpTag] = $96b6bdfb49eb2b47$var$cloneableTags[$96b6bdfb49eb2b47$var$setTag] = $96b6bdfb49eb2b47$var$cloneableTags[$96b6bdfb49eb2b47$var$stringTag] = $96b6bdfb49eb2b47$var$cloneableTags[$96b6bdfb49eb2b47$var$symbolTag] = $96b6bdfb49eb2b47$var$cloneableTags[$96b6bdfb49eb2b47$var$uint8Tag] = $96b6bdfb49eb2b47$var$cloneableTags[$96b6bdfb49eb2b47$var$uint8ClampedTag] = $96b6bdfb49eb2b47$var$cloneableTags[$96b6bdfb49eb2b47$var$uint16Tag] = $96b6bdfb49eb2b47$var$cloneableTags[$96b6bdfb49eb2b47$var$uint32Tag] = true;
$96b6bdfb49eb2b47$var$cloneableTags[$96b6bdfb49eb2b47$var$errorTag] = $96b6bdfb49eb2b47$var$cloneableTags[$96b6bdfb49eb2b47$var$funcTag] = $96b6bdfb49eb2b47$var$cloneableTags[$96b6bdfb49eb2b47$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $96b6bdfb49eb2b47$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $96b6bdfb49eb2b47$var$CLONE_DEEP_FLAG, isFlat = bitmask & $96b6bdfb49eb2b47$var$CLONE_FLAT_FLAG, isFull = bitmask & $96b6bdfb49eb2b47$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $0f0b33514751195d$export$2e2bcd8739ae039)(value)) return value;
    var isArr = (0, $acb56a590d5e2bcb$export$2e2bcd8739ae039)(value);
    if (isArr) {
        result = (0, $c6072646e2485127$export$2e2bcd8739ae039)(value);
        if (!isDeep) return (0, $6ee5ba3b93e896be$export$2e2bcd8739ae039)(value, result);
    } else {
        var tag = (0, $f99ddab08b845c56$export$2e2bcd8739ae039)(value), isFunc = tag == $96b6bdfb49eb2b47$var$funcTag || tag == $96b6bdfb49eb2b47$var$genTag;
        if ((0, $kmshc.default)(value)) return (0, $2eDJ7.default)(value, isDeep);
        if (tag == $96b6bdfb49eb2b47$var$objectTag || tag == $96b6bdfb49eb2b47$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $6c800f80d8c79e51$export$2e2bcd8739ae039)(value);
            if (!isDeep) return isFlat ? (0, $a8cc7e8f06c0ed9b$export$2e2bcd8739ae039)(value, (0, $79c65028a07bba19$export$2e2bcd8739ae039)(result, value)) : (0, $9ed9e7c200747f93$export$2e2bcd8739ae039)(value, (0, $b8862b2b94fedac8$export$2e2bcd8739ae039)(result, value));
        } else {
            if (!$96b6bdfb49eb2b47$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $95d6377e5f935fea$export$2e2bcd8739ae039)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $4629ffd999cc27d4$export$2e2bcd8739ae039));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $819d0870c9967090$export$2e2bcd8739ae039)(value)) value.forEach(function(subValue) {
        result.add($96b6bdfb49eb2b47$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $c5f0bde35a503a98$export$2e2bcd8739ae039)(value)) value.forEach(function(subValue, key) {
        result.set(key, $96b6bdfb49eb2b47$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $1571c45bb644e209$export$2e2bcd8739ae039) : (0, $e3e5da42377fea37$export$2e2bcd8739ae039) : isFlat ? (0, $a597badc098aca4b$export$2e2bcd8739ae039) : (0, $a11509b56113c9fb$export$2e2bcd8739ae039);
    var props = isArr ? undefined : keysFunc(value);
    (0, $565eb47815d24591$export$2e2bcd8739ae039)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $bfd5f6dbfe570507$export$2e2bcd8739ae039)(result, key, $96b6bdfb49eb2b47$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $96b6bdfb49eb2b47$export$2e2bcd8739ae039 = $96b6bdfb49eb2b47$var$baseClone;


/** Used to compose bitmasks for cloning. */ var $56054693bbe43fe9$var$CLONE_DEEP_FLAG = 1, $56054693bbe43fe9$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $56054693bbe43fe9$var$cloneDeep(value) {
    return (0, $96b6bdfb49eb2b47$export$2e2bcd8739ae039)(value, $56054693bbe43fe9$var$CLONE_DEEP_FLAG | $56054693bbe43fe9$var$CLONE_SYMBOLS_FLAG);
}
var $56054693bbe43fe9$export$2e2bcd8739ae039 = $56054693bbe43fe9$var$cloneDeep;


/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $b3a13963d3f219f8$var$isEqual(value, other) {
    return (0, $d40606ebf563d6aa$export$2e2bcd8739ae039)(value, other);
}
var $b3a13963d3f219f8$export$2e2bcd8739ae039 = $b3a13963d3f219f8$var$isEqual;







class $ed7188caee9f09fc$var$Break extends (0, $569e748944e69916$export$297a1fa96f55f00f) {
    static value() {
        return undefined;
    }
    optimize() {
        if (this.prev || this.next) this.remove();
    }
    length() {
        return 0;
    }
    value() {
        return '';
    }
}
$ed7188caee9f09fc$var$Break.blotName = 'break';
$ed7188caee9f09fc$var$Break.tagName = 'BR';
var $ed7188caee9f09fc$export$2e2bcd8739ae039 = $ed7188caee9f09fc$var$Break;





class $97f4bef342825216$export$2e2bcd8739ae039 extends (0, $569e748944e69916$export$10ac0c5716409de6) {
}
// https://lodash.com/docs#escape
const $97f4bef342825216$var$entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
};
function $97f4bef342825216$export$96e6fc3a139b2555(text) {
    return text.replace(/[&<>"']/g, (s)=>$97f4bef342825216$var$entityMap[s]);
}


class $90a3f5612e2e28d2$var$Inline extends (0, $569e748944e69916$export$f67a34bc25a7a861) {
    static allowedChildren = [
        $90a3f5612e2e28d2$var$Inline,
        (0, $ed7188caee9f09fc$export$2e2bcd8739ae039),
        (0, $569e748944e69916$export$297a1fa96f55f00f),
        (0, $97f4bef342825216$export$2e2bcd8739ae039)
    ];
    // Lower index means deeper in the DOM tree, since not found (-1) is for embeds
    static order = [
        'cursor',
        'inline',
        // Must be lower
        'link',
        // Chrome wants <a> to be lower
        'underline',
        'strike',
        'italic',
        'bold',
        'script',
        'code' // Must be higher
    ];
    static compare(self, other) {
        const selfIndex = $90a3f5612e2e28d2$var$Inline.order.indexOf(self);
        const otherIndex = $90a3f5612e2e28d2$var$Inline.order.indexOf(other);
        if (selfIndex >= 0 || otherIndex >= 0) return selfIndex - otherIndex;
        if (self === other) return 0;
        if (self < other) return -1;
        return 1;
    }
    formatAt(index, length, name, value) {
        if ($90a3f5612e2e28d2$var$Inline.compare(this.statics.blotName, name) < 0 && this.scroll.query(name, (0, $569e748944e69916$export$775b6bb06e53a214).BLOT)) {
            const blot = this.isolate(index, length);
            if (value) blot.wrap(name, value);
        } else super.formatAt(index, length, name, value);
    }
    optimize(context) {
        super.optimize(context);
        if (this.parent instanceof $90a3f5612e2e28d2$var$Inline && $90a3f5612e2e28d2$var$Inline.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
            const parent = this.parent.isolate(this.offset(), this.length());
            // @ts-expect-error TODO: make isolate generic
            this.moveChildren(parent);
            parent.wrap(this);
        }
    }
}
var $90a3f5612e2e28d2$export$2e2bcd8739ae039 = $90a3f5612e2e28d2$var$Inline;



const $85f480a53d3839c4$var$NEWLINE_LENGTH = 1;
class $85f480a53d3839c4$export$2e2bcd8739ae039 extends (0, $569e748944e69916$export$4f7f03641f7bfc8c) {
    cache = {};
    delta() {
        if (this.cache.delta == null) this.cache.delta = $85f480a53d3839c4$export$992ff47219af5a2b(this);
        return this.cache.delta;
    }
    deleteAt(index, length) {
        super.deleteAt(index, length);
        this.cache = {};
    }
    formatAt(index, length, name, value) {
        if (length <= 0) return;
        if (this.scroll.query(name, (0, $569e748944e69916$export$775b6bb06e53a214).BLOCK)) {
            if (index + length === this.length()) this.format(name, value);
        } else super.formatAt(index, Math.min(length, this.length() - index - 1), name, value);
        this.cache = {};
    }
    insertAt(index, value, def) {
        if (def != null) {
            super.insertAt(index, value, def);
            this.cache = {};
            return;
        }
        if (value.length === 0) return;
        const lines = value.split('\n');
        const text = lines.shift();
        if (text.length > 0) {
            if (index < this.length() - 1 || this.children.tail == null) super.insertAt(Math.min(index, this.length() - 1), text);
            else this.children.tail.insertAt(this.children.tail.length(), text);
            this.cache = {};
        }
        // TODO: Fix this next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let block = this;
        lines.reduce((lineIndex, line)=>{
            // @ts-expect-error Fix me later
            block = block.split(lineIndex, true);
            block.insertAt(0, line);
            return line.length;
        }, index + text.length);
    }
    insertBefore(blot, ref) {
        const { head: head } = this.children;
        super.insertBefore(blot, ref);
        if (head instanceof (0, $ed7188caee9f09fc$export$2e2bcd8739ae039)) head.remove();
        this.cache = {};
    }
    length() {
        if (this.cache.length == null) this.cache.length = super.length() + $85f480a53d3839c4$var$NEWLINE_LENGTH;
        return this.cache.length;
    }
    moveChildren(target, ref) {
        super.moveChildren(target, ref);
        this.cache = {};
    }
    optimize(context) {
        super.optimize(context);
        this.cache = {};
    }
    path(index) {
        return super.path(index, true);
    }
    removeChild(child) {
        super.removeChild(child);
        this.cache = {};
    }
    split(index) {
        let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (force && (index === 0 || index >= this.length() - $85f480a53d3839c4$var$NEWLINE_LENGTH)) {
            const clone = this.clone();
            if (index === 0) {
                this.parent.insertBefore(clone, this);
                return this;
            }
            this.parent.insertBefore(clone, this.next);
            return clone;
        }
        const next = super.split(index, force);
        this.cache = {};
        return next;
    }
}
$85f480a53d3839c4$export$2e2bcd8739ae039.blotName = 'block';
$85f480a53d3839c4$export$2e2bcd8739ae039.tagName = 'P';
$85f480a53d3839c4$export$2e2bcd8739ae039.defaultChild = (0, $ed7188caee9f09fc$export$2e2bcd8739ae039);
$85f480a53d3839c4$export$2e2bcd8739ae039.allowedChildren = [
    (0, $ed7188caee9f09fc$export$2e2bcd8739ae039),
    (0, $90a3f5612e2e28d2$export$2e2bcd8739ae039),
    (0, $569e748944e69916$export$297a1fa96f55f00f),
    (0, $97f4bef342825216$export$2e2bcd8739ae039)
];
class $85f480a53d3839c4$export$48b9f0688962d028 extends (0, $569e748944e69916$export$297a1fa96f55f00f) {
    attach() {
        super.attach();
        this.attributes = new (0, $569e748944e69916$export$68ad86ab95e8de42)(this.domNode);
    }
    delta() {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))().insert(this.value(), {
            ...this.formats(),
            ...this.attributes.values()
        });
    }
    format(name, value) {
        const attribute = this.scroll.query(name, (0, $569e748944e69916$export$775b6bb06e53a214).BLOCK_ATTRIBUTE);
        if (attribute != null) // @ts-expect-error TODO: Scroll#query() should return Attributor when scope is attribute
        this.attributes.attribute(attribute, value);
    }
    formatAt(index, length, name, value) {
        this.format(name, value);
    }
    insertAt(index, value, def) {
        if (def != null) {
            super.insertAt(index, value, def);
            return;
        }
        const lines = value.split('\n');
        const text = lines.pop();
        const blocks = lines.map((line)=>{
            const block = this.scroll.create($85f480a53d3839c4$export$2e2bcd8739ae039.blotName);
            block.insertAt(0, line);
            return block;
        });
        const ref = this.split(index);
        blocks.forEach((block)=>{
            this.parent.insertBefore(block, ref);
        });
        if (text) this.parent.insertBefore(this.scroll.create('text', text), ref);
    }
}
$85f480a53d3839c4$export$48b9f0688962d028.scope = (0, $569e748944e69916$export$775b6bb06e53a214).BLOCK_BLOT;
// It is important for cursor behavior BlockEmbeds use tags that are block level elements
function $85f480a53d3839c4$export$992ff47219af5a2b(blot) {
    let filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return blot.descendants((0, $569e748944e69916$export$7420b9c542181544)).reduce((delta, leaf)=>{
        if (leaf.length() === 0) return delta;
        return delta.insert(leaf.value(), $85f480a53d3839c4$export$e4bb5a6163449612(leaf, {}, filter));
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))()).insert('\n', $85f480a53d3839c4$export$e4bb5a6163449612(blot));
}
function $85f480a53d3839c4$export$e4bb5a6163449612(blot) {
    let formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (blot == null) return formats;
    if ('formats' in blot && typeof blot.formats === 'function') {
        formats = {
            ...formats,
            ...blot.formats()
        };
        if (filter) // exclude syntax highlighting from deltas and getFormat()
        delete formats['code-token'];
    }
    if (blot.parent == null || blot.parent.statics.blotName === 'scroll' || blot.parent.statics.scope !== blot.statics.scope) return formats;
    return $85f480a53d3839c4$export$e4bb5a6163449612(blot.parent, formats, filter);
}





class $3f7aca29b1a55496$var$Cursor extends (0, $569e748944e69916$export$297a1fa96f55f00f) {
    static blotName = 'cursor';
    static className = 'ql-cursor';
    static tagName = 'span';
    static CONTENTS = '\uFEFF';
    static value() {
        return undefined;
    }
    constructor(scroll, domNode, selection){
        super(scroll, domNode);
        this.selection = selection;
        this.textNode = document.createTextNode($3f7aca29b1a55496$var$Cursor.CONTENTS);
        this.domNode.appendChild(this.textNode);
        this.savedLength = 0;
    }
    detach() {
        // super.detach() will also clear domNode.__blot
        if (this.parent != null) this.parent.removeChild(this);
    }
    format(name, value) {
        if (this.savedLength !== 0) {
            super.format(name, value);
            return;
        }
        // TODO: Fix this next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let target = this;
        let index = 0;
        while(target != null && target.statics.scope !== (0, $569e748944e69916$export$775b6bb06e53a214).BLOCK_BLOT){
            index += target.offset(target.parent);
            target = target.parent;
        }
        if (target != null) {
            this.savedLength = $3f7aca29b1a55496$var$Cursor.CONTENTS.length;
            // @ts-expect-error TODO: allow empty context in Parchment
            target.optimize();
            target.formatAt(index, $3f7aca29b1a55496$var$Cursor.CONTENTS.length, name, value);
            this.savedLength = 0;
        }
    }
    index(node, offset) {
        if (node === this.textNode) return 0;
        return super.index(node, offset);
    }
    length() {
        return this.savedLength;
    }
    position() {
        return [
            this.textNode,
            this.textNode.data.length
        ];
    }
    remove() {
        super.remove();
        // @ts-expect-error Fix me later
        this.parent = null;
    }
    restore() {
        if (this.selection.composing || this.parent == null) return null;
        const range = this.selection.getNativeRange();
        // Browser may push down styles/nodes inside the cursor blot.
        // https://dvcs.w3.org/hg/editing/raw-file/tip/editing.html#push-down-values
        while(this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode)// @ts-expect-error Fix me later
        this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
        const prevTextBlot = this.prev instanceof (0, $97f4bef342825216$export$2e2bcd8739ae039) ? this.prev : null;
        const prevTextLength = prevTextBlot ? prevTextBlot.length() : 0;
        const nextTextBlot = this.next instanceof (0, $97f4bef342825216$export$2e2bcd8739ae039) ? this.next : null;
        // @ts-expect-error TODO: make TextBlot.text public
        const nextText = nextTextBlot ? nextTextBlot.text : '';
        const { textNode: textNode } = this;
        // take text from inside this blot and reset it
        const newText = textNode.data.split($3f7aca29b1a55496$var$Cursor.CONTENTS).join('');
        textNode.data = $3f7aca29b1a55496$var$Cursor.CONTENTS;
        // proactively merge TextBlots around cursor so that optimization
        // doesn't lose the cursor.  the reason we are here in cursor.restore
        // could be that the user clicked in prevTextBlot or nextTextBlot, or
        // the user typed something.
        let mergedTextBlot;
        if (prevTextBlot) {
            mergedTextBlot = prevTextBlot;
            if (newText || nextTextBlot) {
                prevTextBlot.insertAt(prevTextBlot.length(), newText + nextText);
                if (nextTextBlot) nextTextBlot.remove();
            }
        } else if (nextTextBlot) {
            mergedTextBlot = nextTextBlot;
            nextTextBlot.insertAt(0, newText);
        } else {
            const newTextNode = document.createTextNode(newText);
            mergedTextBlot = this.scroll.create(newTextNode);
            this.parent.insertBefore(mergedTextBlot, this);
        }
        this.remove();
        if (range) {
            // calculate selection to restore
            const remapOffset = (node, offset)=>{
                if (prevTextBlot && node === prevTextBlot.domNode) return offset;
                if (node === textNode) return prevTextLength + offset - 1;
                if (nextTextBlot && node === nextTextBlot.domNode) return prevTextLength + newText.length + offset;
                return null;
            };
            const start = remapOffset(range.start.node, range.start.offset);
            const end = remapOffset(range.end.node, range.end.offset);
            if (start !== null && end !== null) return {
                startNode: mergedTextBlot.domNode,
                startOffset: start,
                endNode: mergedTextBlot.domNode,
                endOffset: end
            };
        }
        return null;
    }
    update(mutations, context) {
        if (mutations.some((mutation)=>{
            return mutation.type === 'characterData' && mutation.target === this.textNode;
        })) {
            const range = this.restore();
            if (range) context.range = range;
        }
    }
    // Avoid .ql-cursor being a descendant of `<a/>`.
    // The reason is Safari pushes down `<a/>` on text insertion.
    // That will cause DOM nodes not sync with the model.
    //
    // For example ({I} is the caret), given the markup:
    //    <a><span class="ql-cursor">\uFEFF{I}</span></a>
    // When typing a char "x", `<a/>` will be pushed down inside the `<span>` first:
    //    <span class="ql-cursor"><a>\uFEFF{I}</a></span>
    // And then "x" will be inserted after `<a/>`:
    //    <span class="ql-cursor"><a>\uFEFF</a>d{I}</span>
    optimize(context) {
        // @ts-expect-error Fix me later
        super.optimize(context);
        let { parent: parent } = this;
        while(parent){
            if (parent.domNode.tagName === 'A') {
                this.savedLength = $3f7aca29b1a55496$var$Cursor.CONTENTS.length;
                // @ts-expect-error TODO: make isolate generic
                parent.isolate(this.offset(parent), this.length()).unwrap();
                this.savedLength = 0;
                break;
            }
            parent = parent.parent;
        }
    }
    value() {
        return '';
    }
}
var $3f7aca29b1a55496$export$2e2bcd8739ae039 = $3f7aca29b1a55496$var$Cursor;





var $08db28f380de7a98$exports = {};
'use strict';
var $08db28f380de7a98$var$has = Object.prototype.hasOwnProperty, $08db28f380de7a98$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $08db28f380de7a98$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $08db28f380de7a98$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $08db28f380de7a98$var$Events().__proto__) $08db28f380de7a98$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $08db28f380de7a98$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $08db28f380de7a98$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $08db28f380de7a98$var$EE(fn, context || emitter, once), evt = $08db28f380de7a98$var$prefix ? $08db28f380de7a98$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $08db28f380de7a98$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $08db28f380de7a98$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $08db28f380de7a98$var$EventEmitter() {
    this._events = new $08db28f380de7a98$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $08db28f380de7a98$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($08db28f380de7a98$var$has.call(events, name)) names.push($08db28f380de7a98$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $08db28f380de7a98$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $08db28f380de7a98$var$prefix ? $08db28f380de7a98$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $08db28f380de7a98$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $08db28f380de7a98$var$prefix ? $08db28f380de7a98$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $08db28f380de7a98$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $08db28f380de7a98$var$prefix ? $08db28f380de7a98$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $08db28f380de7a98$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $08db28f380de7a98$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $08db28f380de7a98$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $08db28f380de7a98$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $08db28f380de7a98$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $08db28f380de7a98$var$prefix ? $08db28f380de7a98$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $08db28f380de7a98$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $08db28f380de7a98$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $08db28f380de7a98$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $08db28f380de7a98$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $08db28f380de7a98$var$prefix ? $08db28f380de7a98$var$prefix + event : event;
        if (this._events[evt]) $08db28f380de7a98$var$clearEvent(this, evt);
    } else {
        this._events = new $08db28f380de7a98$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$08db28f380de7a98$var$EventEmitter.prototype.off = $08db28f380de7a98$var$EventEmitter.prototype.removeListener;
$08db28f380de7a98$var$EventEmitter.prototype.addListener = $08db28f380de7a98$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$08db28f380de7a98$var$EventEmitter.prefixed = $08db28f380de7a98$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$08db28f380de7a98$var$EventEmitter.EventEmitter = $08db28f380de7a98$var$EventEmitter;
$08db28f380de7a98$exports = $08db28f380de7a98$var$EventEmitter;


var $58f298d123c67abd$export$2e2bcd8739ae039 = new WeakMap();


const $17c49cda18fab12a$var$levels = [
    'error',
    'warn',
    'log',
    'info'
];
let $17c49cda18fab12a$var$level = 'warn';
function $17c49cda18fab12a$var$debug(method) {
    if ($17c49cda18fab12a$var$level) {
        if ($17c49cda18fab12a$var$levels.indexOf(method) <= $17c49cda18fab12a$var$levels.indexOf($17c49cda18fab12a$var$level)) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            console[method](...args); // eslint-disable-line no-console
        }
    }
}
function $17c49cda18fab12a$var$namespace(ns) {
    return $17c49cda18fab12a$var$levels.reduce((logger, method)=>{
        logger[method] = $17c49cda18fab12a$var$debug.bind(console, method, ns);
        return logger;
    }, {});
}
$17c49cda18fab12a$var$namespace.level = (newLevel)=>{
    $17c49cda18fab12a$var$level = newLevel;
};
$17c49cda18fab12a$var$debug.level = $17c49cda18fab12a$var$namespace.level;
var $17c49cda18fab12a$export$2e2bcd8739ae039 = $17c49cda18fab12a$var$namespace;


const $8d79d079139d3d60$var$debug = (0, $17c49cda18fab12a$export$2e2bcd8739ae039)('quill:events');
const $8d79d079139d3d60$var$EVENTS = [
    'selectionchange',
    'mousedown',
    'mouseup',
    'click'
];
$8d79d079139d3d60$var$EVENTS.forEach((eventName)=>{
    document.addEventListener(eventName, function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        Array.from(document.querySelectorAll('.ql-container')).forEach((node)=>{
            const quill = (0, $58f298d123c67abd$export$2e2bcd8739ae039).get(node);
            if (quill && quill.emitter) quill.emitter.handleDOM(...args);
        });
    });
});
class $8d79d079139d3d60$var$Emitter extends (0, $08db28f380de7a98$exports.EventEmitter) {
    static events = {
        EDITOR_CHANGE: 'editor-change',
        SCROLL_BEFORE_UPDATE: 'scroll-before-update',
        SCROLL_BLOT_MOUNT: 'scroll-blot-mount',
        SCROLL_BLOT_UNMOUNT: 'scroll-blot-unmount',
        SCROLL_OPTIMIZE: 'scroll-optimize',
        SCROLL_UPDATE: 'scroll-update',
        SCROLL_EMBED_UPDATE: 'scroll-embed-update',
        SELECTION_CHANGE: 'selection-change',
        TEXT_CHANGE: 'text-change',
        COMPOSITION_BEFORE_START: 'composition-before-start',
        COMPOSITION_START: 'composition-start',
        COMPOSITION_BEFORE_END: 'composition-before-end',
        COMPOSITION_END: 'composition-end'
    };
    static sources = {
        API: 'api',
        SILENT: 'silent',
        USER: 'user'
    };
    constructor(){
        super();
        this.domListeners = {};
        this.on('error', $8d79d079139d3d60$var$debug.error);
    }
    emit() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        $8d79d079139d3d60$var$debug.log.call($8d79d079139d3d60$var$debug, ...args);
        // @ts-expect-error
        return super.emit(...args);
    }
    handleDOM(event) {
        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        (this.domListeners[event.type] || []).forEach((_ref)=>{
            let { node: node, handler: handler } = _ref;
            if (event.target === node || node.contains(event.target)) handler(event, ...args);
        });
    }
    listenDOM(eventName, node, handler) {
        if (!this.domListeners[eventName]) this.domListeners[eventName] = [];
        this.domListeners[eventName].push({
            node: node,
            handler: handler
        });
    }
}
var $8d79d079139d3d60$export$2e2bcd8739ae039 = $8d79d079139d3d60$var$Emitter;



const $b3a4906c4c866f2e$var$debug = (0, $17c49cda18fab12a$export$2e2bcd8739ae039)('quill:selection');
class $b3a4906c4c866f2e$export$9a58ef0d7ad3278c {
    constructor(index){
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        this.index = index;
        this.length = length;
    }
}
class $b3a4906c4c866f2e$var$Selection {
    constructor(scroll, emitter){
        this.emitter = emitter;
        this.scroll = scroll;
        this.composing = false;
        this.mouseDown = false;
        this.root = this.scroll.domNode;
        // @ts-expect-error
        this.cursor = this.scroll.create('cursor', this);
        // savedRange is last non-null range
        this.savedRange = new $b3a4906c4c866f2e$export$9a58ef0d7ad3278c(0, 0);
        this.lastRange = this.savedRange;
        this.lastNative = null;
        this.handleComposition();
        this.handleDragging();
        this.emitter.listenDOM('selectionchange', document, ()=>{
            if (!this.mouseDown && !this.composing) setTimeout(this.update.bind(this, (0, $8d79d079139d3d60$export$2e2bcd8739ae039).sources.USER), 1);
        });
        this.emitter.on((0, $8d79d079139d3d60$export$2e2bcd8739ae039).events.SCROLL_BEFORE_UPDATE, ()=>{
            if (!this.hasFocus()) return;
            const native = this.getNativeRange();
            if (native == null) return;
            if (native.start.node === this.cursor.textNode) return; // cursor.restore() will handle
            this.emitter.once((0, $8d79d079139d3d60$export$2e2bcd8739ae039).events.SCROLL_UPDATE, (source, mutations)=>{
                try {
                    if (this.root.contains(native.start.node) && this.root.contains(native.end.node)) this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
                    const triggeredByTyping = mutations.some((mutation)=>mutation.type === 'characterData' || mutation.type === 'childList' || mutation.type === 'attributes' && mutation.target === this.root);
                    this.update(triggeredByTyping ? (0, $8d79d079139d3d60$export$2e2bcd8739ae039).sources.SILENT : source);
                } catch (ignored) {
                // ignore
                }
            });
        });
        this.emitter.on((0, $8d79d079139d3d60$export$2e2bcd8739ae039).events.SCROLL_OPTIMIZE, (mutations, context)=>{
            if (context.range) {
                const { startNode: startNode, startOffset: startOffset, endNode: endNode, endOffset: endOffset } = context.range;
                this.setNativeRange(startNode, startOffset, endNode, endOffset);
                this.update((0, $8d79d079139d3d60$export$2e2bcd8739ae039).sources.SILENT);
            }
        });
        this.update((0, $8d79d079139d3d60$export$2e2bcd8739ae039).sources.SILENT);
    }
    handleComposition() {
        this.emitter.on((0, $8d79d079139d3d60$export$2e2bcd8739ae039).events.COMPOSITION_BEFORE_START, ()=>{
            this.composing = true;
        });
        this.emitter.on((0, $8d79d079139d3d60$export$2e2bcd8739ae039).events.COMPOSITION_END, ()=>{
            this.composing = false;
            if (this.cursor.parent) {
                const range = this.cursor.restore();
                if (!range) return;
                setTimeout(()=>{
                    this.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
                }, 1);
            }
        });
    }
    handleDragging() {
        this.emitter.listenDOM('mousedown', document.body, ()=>{
            this.mouseDown = true;
        });
        this.emitter.listenDOM('mouseup', document.body, ()=>{
            this.mouseDown = false;
            this.update((0, $8d79d079139d3d60$export$2e2bcd8739ae039).sources.USER);
        });
    }
    focus() {
        if (this.hasFocus()) return;
        this.root.focus({
            preventScroll: true
        });
        this.setRange(this.savedRange);
    }
    format(format, value) {
        this.scroll.update();
        const nativeRange = this.getNativeRange();
        if (nativeRange == null || !nativeRange.native.collapsed || this.scroll.query(format, (0, $569e748944e69916$export$775b6bb06e53a214).BLOCK)) return;
        if (nativeRange.start.node !== this.cursor.textNode) {
            const blot = this.scroll.find(nativeRange.start.node, false);
            if (blot == null) return;
            // TODO Give blot ability to not split
            if (blot instanceof (0, $569e748944e69916$export$7420b9c542181544)) {
                const after = blot.split(nativeRange.start.offset);
                blot.parent.insertBefore(this.cursor, after);
            } else // @ts-expect-error TODO: nativeRange.start.node doesn't seem to match function signature
            blot.insertBefore(this.cursor, nativeRange.start.node); // Should never happen
            this.cursor.attach();
        }
        this.cursor.format(format, value);
        this.scroll.optimize();
        this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
        this.update();
    }
    getBounds(index) {
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        const scrollLength = this.scroll.length();
        index = Math.min(index, scrollLength - 1);
        length = Math.min(index + length, scrollLength - 1) - index;
        let node;
        let [leaf, offset] = this.scroll.leaf(index);
        if (leaf == null) return null;
        if (length > 0 && offset === leaf.length()) {
            const [next] = this.scroll.leaf(index + 1);
            if (next) {
                const [line] = this.scroll.line(index);
                const [nextLine] = this.scroll.line(index + 1);
                if (line === nextLine) {
                    leaf = next;
                    offset = 0;
                }
            }
        }
        [node, offset] = leaf.position(offset, true);
        const range = document.createRange();
        if (length > 0) {
            range.setStart(node, offset);
            [leaf, offset] = this.scroll.leaf(index + length);
            if (leaf == null) return null;
            [node, offset] = leaf.position(offset, true);
            range.setEnd(node, offset);
            return range.getBoundingClientRect();
        }
        let side = 'left';
        let rect;
        if (node instanceof Text) {
            // Return null if the text node is empty because it is
            // not able to get a useful client rect:
            // https://github.com/w3c/csswg-drafts/issues/2514.
            // Empty text nodes are most likely caused by TextBlot#optimize()
            // not getting called when editor content changes.
            if (!node.data.length) return null;
            if (offset < node.data.length) {
                range.setStart(node, offset);
                range.setEnd(node, offset + 1);
            } else {
                range.setStart(node, offset - 1);
                range.setEnd(node, offset);
                side = 'right';
            }
            rect = range.getBoundingClientRect();
        } else {
            if (!(leaf.domNode instanceof Element)) return null;
            rect = leaf.domNode.getBoundingClientRect();
            if (offset > 0) side = 'right';
        }
        return {
            bottom: rect.top + rect.height,
            height: rect.height,
            left: rect[side],
            right: rect[side],
            top: rect.top,
            width: 0
        };
    }
    getNativeRange() {
        const selection = document.getSelection();
        if (selection == null || selection.rangeCount <= 0) return null;
        const nativeRange = selection.getRangeAt(0);
        if (nativeRange == null) return null;
        const range = this.normalizeNative(nativeRange);
        $b3a4906c4c866f2e$var$debug.info('getNativeRange', range);
        return range;
    }
    getRange() {
        const root = this.scroll.domNode;
        if ('isConnected' in root && !root.isConnected) // document.getSelection() forces layout on Blink, so we trend to
        // not calling it.
        return [
            null,
            null
        ];
        const normalized = this.getNativeRange();
        if (normalized == null) return [
            null,
            null
        ];
        const range = this.normalizedToRange(normalized);
        return [
            range,
            normalized
        ];
    }
    hasFocus() {
        return document.activeElement === this.root || document.activeElement != null && $b3a4906c4c866f2e$var$contains(this.root, document.activeElement);
    }
    normalizedToRange(range) {
        const positions = [
            [
                range.start.node,
                range.start.offset
            ]
        ];
        if (!range.native.collapsed) positions.push([
            range.end.node,
            range.end.offset
        ]);
        const indexes = positions.map((position)=>{
            const [node, offset] = position;
            const blot = this.scroll.find(node, true);
            // @ts-expect-error Fix me later
            const index = blot.offset(this.scroll);
            if (offset === 0) return index;
            if (blot instanceof (0, $569e748944e69916$export$7420b9c542181544)) return index + blot.index(node, offset);
            // @ts-expect-error Fix me later
            return index + blot.length();
        });
        const end = Math.min(Math.max(...indexes), this.scroll.length() - 1);
        const start = Math.min(end, ...indexes);
        return new $b3a4906c4c866f2e$export$9a58ef0d7ad3278c(start, end - start);
    }
    normalizeNative(nativeRange) {
        if (!$b3a4906c4c866f2e$var$contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !$b3a4906c4c866f2e$var$contains(this.root, nativeRange.endContainer)) return null;
        const range = {
            start: {
                node: nativeRange.startContainer,
                offset: nativeRange.startOffset
            },
            end: {
                node: nativeRange.endContainer,
                offset: nativeRange.endOffset
            },
            native: nativeRange
        };
        [
            range.start,
            range.end
        ].forEach((position)=>{
            let { node: node, offset: offset } = position;
            while(!(node instanceof Text) && node.childNodes.length > 0){
                if (node.childNodes.length > offset) {
                    node = node.childNodes[offset];
                    offset = 0;
                } else if (node.childNodes.length === offset) {
                    // @ts-expect-error Fix me later
                    node = node.lastChild;
                    if (node instanceof Text) offset = node.data.length;
                    else if (node.childNodes.length > 0) // Container case
                    offset = node.childNodes.length;
                    else // Embed case
                    offset = node.childNodes.length + 1;
                } else break;
            }
            position.node = node;
            position.offset = offset;
        });
        return range;
    }
    rangeToNative(range) {
        const scrollLength = this.scroll.length();
        const getPosition = (index, inclusive)=>{
            index = Math.min(scrollLength - 1, index);
            const [leaf, leafOffset] = this.scroll.leaf(index);
            return leaf ? leaf.position(leafOffset, inclusive) : [
                null,
                -1
            ];
        };
        return [
            ...getPosition(range.index, false),
            ...getPosition(range.index + range.length, true)
        ];
    }
    setNativeRange(startNode, startOffset) {
        let endNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startNode;
        let endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : startOffset;
        let force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
        $b3a4906c4c866f2e$var$debug.info('setNativeRange', startNode, startOffset, endNode, endOffset);
        if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || // @ts-expect-error Fix me later
        endNode.parentNode == null)) return;
        const selection = document.getSelection();
        if (selection == null) return;
        if (startNode != null) {
            if (!this.hasFocus()) this.root.focus({
                preventScroll: true
            });
            const { native: native } = this.getNativeRange() || {};
            if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {
                if (startNode instanceof Element && startNode.tagName === 'BR') {
                    // @ts-expect-error Fix me later
                    startOffset = Array.from(startNode.parentNode.childNodes).indexOf(startNode);
                    startNode = startNode.parentNode;
                }
                if (endNode instanceof Element && endNode.tagName === 'BR') {
                    // @ts-expect-error Fix me later
                    endOffset = Array.from(endNode.parentNode.childNodes).indexOf(endNode);
                    endNode = endNode.parentNode;
                }
                const range = document.createRange();
                // @ts-expect-error Fix me later
                range.setStart(startNode, startOffset);
                // @ts-expect-error Fix me later
                range.setEnd(endNode, endOffset);
                selection.removeAllRanges();
                selection.addRange(range);
            }
        } else {
            selection.removeAllRanges();
            this.root.blur();
        }
    }
    setRange(range) {
        let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $8d79d079139d3d60$export$2e2bcd8739ae039).sources.API;
        if (typeof force === 'string') {
            source = force;
            force = false;
        }
        $b3a4906c4c866f2e$var$debug.info('setRange', range);
        if (range != null) {
            const args = this.rangeToNative(range);
            this.setNativeRange(...args, force);
        } else this.setNativeRange(null);
        this.update(source);
    }
    update() {
        let source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $8d79d079139d3d60$export$2e2bcd8739ae039).sources.USER;
        const oldRange = this.lastRange;
        const [lastRange, nativeRange] = this.getRange();
        this.lastRange = lastRange;
        this.lastNative = nativeRange;
        if (this.lastRange != null) this.savedRange = this.lastRange;
        if (!(0, $b3a13963d3f219f8$export$2e2bcd8739ae039)(oldRange, this.lastRange)) {
            if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) {
                const range = this.cursor.restore();
                if (range) this.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
            }
            const args = [
                (0, $8d79d079139d3d60$export$2e2bcd8739ae039).events.SELECTION_CHANGE,
                (0, $56054693bbe43fe9$export$2e2bcd8739ae039)(this.lastRange),
                (0, $56054693bbe43fe9$export$2e2bcd8739ae039)(oldRange),
                source
            ];
            this.emitter.emit((0, $8d79d079139d3d60$export$2e2bcd8739ae039).events.EDITOR_CHANGE, ...args);
            if (source !== (0, $8d79d079139d3d60$export$2e2bcd8739ae039).sources.SILENT) this.emitter.emit(...args);
        }
    }
}
function $b3a4906c4c866f2e$var$contains(parent, descendant) {
    try {
        // Firefox inserts inaccessible nodes around video elements
        descendant.parentNode; // eslint-disable-line @typescript-eslint/no-unused-expressions
    } catch (e) {
        return false;
    }
    return parent.contains(descendant);
}
var $b3a4906c4c866f2e$export$2e2bcd8739ae039 = $b3a4906c4c866f2e$var$Selection;


const $48412219c70f2c92$var$ASCII = /^[ -~]*$/;
class $48412219c70f2c92$var$Editor {
    constructor(scroll){
        this.scroll = scroll;
        this.delta = this.getDelta();
    }
    applyDelta(delta) {
        this.scroll.update();
        let scrollLength = this.scroll.length();
        this.scroll.batchStart();
        const normalizedDelta = $48412219c70f2c92$var$normalizeDelta(delta);
        const deleteDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))();
        const normalizedOps = $48412219c70f2c92$var$splitOpLines(normalizedDelta.ops.slice());
        normalizedOps.reduce((index, op)=>{
            const length = (0, $88e60522c01c2553$exports.Op).length(op);
            let attributes = op.attributes || {};
            let isImplicitNewlinePrepended = false;
            let isImplicitNewlineAppended = false;
            if (op.insert != null) {
                deleteDelta.retain(length);
                if (typeof op.insert === 'string') {
                    const text = op.insert;
                    isImplicitNewlineAppended = !text.endsWith('\n') && (scrollLength <= index || !!this.scroll.descendant((0, $85f480a53d3839c4$export$48b9f0688962d028), index)[0]);
                    this.scroll.insertAt(index, text);
                    const [line, offset] = this.scroll.line(index);
                    let formats = (0, $4dea300bb9269819$export$2e2bcd8739ae039)({}, (0, $85f480a53d3839c4$export$e4bb5a6163449612)(line));
                    if (line instanceof (0, $85f480a53d3839c4$export$2e2bcd8739ae039)) {
                        const [leaf] = line.descendant((0, $569e748944e69916$export$7420b9c542181544), offset);
                        if (leaf) formats = (0, $4dea300bb9269819$export$2e2bcd8739ae039)(formats, (0, $85f480a53d3839c4$export$e4bb5a6163449612)(leaf));
                    }
                    attributes = (0, $88e60522c01c2553$exports.AttributeMap).diff(formats, attributes) || {};
                } else if (typeof op.insert === 'object') {
                    const key = Object.keys(op.insert)[0]; // There should only be one key
                    if (key == null) return index;
                    const isInlineEmbed = this.scroll.query(key, (0, $569e748944e69916$export$775b6bb06e53a214).INLINE) != null;
                    if (isInlineEmbed) {
                        if (scrollLength <= index || !!this.scroll.descendant((0, $85f480a53d3839c4$export$48b9f0688962d028), index)[0]) isImplicitNewlineAppended = true;
                    } else if (index > 0) {
                        const [leaf, offset] = this.scroll.descendant((0, $569e748944e69916$export$7420b9c542181544), index - 1);
                        if (leaf instanceof (0, $97f4bef342825216$export$2e2bcd8739ae039)) {
                            const text = leaf.value();
                            if (text[offset] !== '\n') isImplicitNewlinePrepended = true;
                        } else if (leaf instanceof (0, $569e748944e69916$export$297a1fa96f55f00f) && leaf.statics.scope === (0, $569e748944e69916$export$775b6bb06e53a214).INLINE_BLOT) isImplicitNewlinePrepended = true;
                    }
                    this.scroll.insertAt(index, key, op.insert[key]);
                    if (isInlineEmbed) {
                        const [leaf] = this.scroll.descendant((0, $569e748944e69916$export$7420b9c542181544), index);
                        if (leaf) {
                            const formats = (0, $4dea300bb9269819$export$2e2bcd8739ae039)({}, (0, $85f480a53d3839c4$export$e4bb5a6163449612)(leaf));
                            attributes = (0, $88e60522c01c2553$exports.AttributeMap).diff(formats, attributes) || {};
                        }
                    }
                }
                scrollLength += length;
            } else {
                deleteDelta.push(op);
                if (op.retain !== null && typeof op.retain === 'object') {
                    const key = Object.keys(op.retain)[0];
                    if (key == null) return index;
                    this.scroll.updateEmbedAt(index, key, op.retain[key]);
                }
            }
            Object.keys(attributes).forEach((name)=>{
                this.scroll.formatAt(index, length, name, attributes[name]);
            });
            const prependedLength = isImplicitNewlinePrepended ? 1 : 0;
            const addedLength = isImplicitNewlineAppended ? 1 : 0;
            scrollLength += prependedLength + addedLength;
            deleteDelta.retain(prependedLength);
            deleteDelta.delete(addedLength);
            return index + length + prependedLength + addedLength;
        }, 0);
        deleteDelta.reduce((index, op)=>{
            if (typeof op.delete === 'number') {
                this.scroll.deleteAt(index, op.delete);
                return index;
            }
            return index + (0, $88e60522c01c2553$exports.Op).length(op);
        }, 0);
        this.scroll.batchEnd();
        this.scroll.optimize();
        return this.update(normalizedDelta);
    }
    deleteText(index, length) {
        this.scroll.deleteAt(index, length);
        return this.update(new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))().retain(index).delete(length));
    }
    formatLine(index, length) {
        let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.scroll.update();
        Object.keys(formats).forEach((format)=>{
            this.scroll.lines(index, Math.max(length, 1)).forEach((line)=>{
                line.format(format, formats[format]);
            });
        });
        this.scroll.optimize();
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))().retain(index).retain(length, (0, $56054693bbe43fe9$export$2e2bcd8739ae039)(formats));
        return this.update(delta);
    }
    formatText(index, length) {
        let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        Object.keys(formats).forEach((format)=>{
            this.scroll.formatAt(index, length, format, formats[format]);
        });
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))().retain(index).retain(length, (0, $56054693bbe43fe9$export$2e2bcd8739ae039)(formats));
        return this.update(delta);
    }
    getContents(index, length) {
        return this.delta.slice(index, index + length);
    }
    getDelta() {
        return this.scroll.lines().reduce((delta, line)=>{
            return delta.concat(line.delta());
        }, new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))());
    }
    getFormat(index) {
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        let lines = [];
        let leaves = [];
        if (length === 0) this.scroll.path(index).forEach((path)=>{
            const [blot] = path;
            if (blot instanceof (0, $85f480a53d3839c4$export$2e2bcd8739ae039)) lines.push(blot);
            else if (blot instanceof (0, $569e748944e69916$export$7420b9c542181544)) leaves.push(blot);
        });
        else {
            lines = this.scroll.lines(index, length);
            leaves = this.scroll.descendants((0, $569e748944e69916$export$7420b9c542181544), index, length);
        }
        const [lineFormats, leafFormats] = [
            lines,
            leaves
        ].map((blots)=>{
            const blot = blots.shift();
            if (blot == null) return {};
            let formats = (0, $85f480a53d3839c4$export$e4bb5a6163449612)(blot);
            while(Object.keys(formats).length > 0){
                const blot = blots.shift();
                if (blot == null) return formats;
                formats = $48412219c70f2c92$var$combineFormats((0, $85f480a53d3839c4$export$e4bb5a6163449612)(blot), formats);
            }
            return formats;
        });
        return {
            ...lineFormats,
            ...leafFormats
        };
    }
    getHTML(index, length) {
        const [line, lineOffset] = this.scroll.line(index);
        if (line) {
            const lineLength = line.length();
            const isWithinLine = line.length() >= lineOffset + length;
            if (isWithinLine && !(lineOffset === 0 && length === lineLength)) return $48412219c70f2c92$var$convertHTML(line, lineOffset, length, true);
            return $48412219c70f2c92$var$convertHTML(this.scroll, index, length, true);
        }
        return '';
    }
    getText(index, length) {
        return this.getContents(index, length).filter((op)=>typeof op.insert === 'string').map((op)=>op.insert).join('');
    }
    insertContents(index, contents) {
        const normalizedDelta = $48412219c70f2c92$var$normalizeDelta(contents);
        const change = new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))().retain(index).concat(normalizedDelta);
        this.scroll.insertContents(index, normalizedDelta);
        return this.update(change);
    }
    insertEmbed(index, embed, value) {
        this.scroll.insertAt(index, embed, value);
        return this.update(new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))().retain(index).insert({
            [embed]: value
        }));
    }
    insertText(index, text) {
        let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
        this.scroll.insertAt(index, text);
        Object.keys(formats).forEach((format)=>{
            this.scroll.formatAt(index, text.length, format, formats[format]);
        });
        return this.update(new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))().retain(index).insert(text, (0, $56054693bbe43fe9$export$2e2bcd8739ae039)(formats)));
    }
    isBlank() {
        if (this.scroll.children.length === 0) return true;
        if (this.scroll.children.length > 1) return false;
        const blot = this.scroll.children.head;
        if (blot?.statics.blotName !== (0, $85f480a53d3839c4$export$2e2bcd8739ae039).blotName) return false;
        const block = blot;
        if (block.children.length > 1) return false;
        return block.children.head instanceof (0, $ed7188caee9f09fc$export$2e2bcd8739ae039);
    }
    removeFormat(index, length) {
        const text = this.getText(index, length);
        const [line, offset] = this.scroll.line(index + length);
        let suffixLength = 0;
        let suffix = new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))();
        if (line != null) {
            suffixLength = line.length() - offset;
            suffix = line.delta().slice(offset, offset + suffixLength - 1).insert('\n');
        }
        const contents = this.getContents(index, length + suffixLength);
        const diff = contents.diff(new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))().insert(text).concat(suffix));
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))().retain(index).concat(diff);
        return this.applyDelta(delta);
    }
    update(change) {
        let mutations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        let selectionInfo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
        const oldDelta = this.delta;
        if (mutations.length === 1 && mutations[0].type === 'characterData' && // @ts-expect-error Fix me later
        mutations[0].target.data.match($48412219c70f2c92$var$ASCII) && this.scroll.find(mutations[0].target)) {
            // Optimization for character changes
            const textBlot = this.scroll.find(mutations[0].target);
            const formats = (0, $85f480a53d3839c4$export$e4bb5a6163449612)(textBlot);
            const index = textBlot.offset(this.scroll);
            // @ts-expect-error Fix me later
            const oldValue = mutations[0].oldValue.replace((0, $3f7aca29b1a55496$export$2e2bcd8739ae039).CONTENTS, '');
            const oldText = new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))().insert(oldValue);
            // @ts-expect-error
            const newText = new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))().insert(textBlot.value());
            const relativeSelectionInfo = selectionInfo && {
                oldRange: $48412219c70f2c92$var$shiftRange(selectionInfo.oldRange, -index),
                newRange: $48412219c70f2c92$var$shiftRange(selectionInfo.newRange, -index)
            };
            const diffDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))().retain(index).concat(oldText.diff(newText, relativeSelectionInfo));
            change = diffDelta.reduce((delta, op)=>{
                if (op.insert) return delta.insert(op.insert, formats);
                return delta.push(op);
            }, new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))());
            this.delta = oldDelta.compose(change);
        } else {
            this.delta = this.getDelta();
            if (!change || !(0, $b3a13963d3f219f8$export$2e2bcd8739ae039)(oldDelta.compose(change), this.delta)) change = oldDelta.diff(this.delta, selectionInfo);
        }
        return change;
    }
}
function $48412219c70f2c92$var$convertListHTML(items, lastIndent, types) {
    if (items.length === 0) {
        const [endTag] = $48412219c70f2c92$var$getListType(types.pop());
        if (lastIndent <= 0) return `</li></${endTag}>`;
        return `</li></${endTag}>${$48412219c70f2c92$var$convertListHTML([], lastIndent - 1, types)}`;
    }
    const [{ child: child, offset: offset, length: length, indent: indent, type: type }, ...rest] = items;
    const [tag, attribute] = $48412219c70f2c92$var$getListType(type);
    if (indent > lastIndent) {
        types.push(type);
        if (indent === lastIndent + 1) return `<${tag}><li${attribute}>${$48412219c70f2c92$var$convertHTML(child, offset, length)}${$48412219c70f2c92$var$convertListHTML(rest, indent, types)}`;
        return `<${tag}><li>${$48412219c70f2c92$var$convertListHTML(items, lastIndent + 1, types)}`;
    }
    const previousType = types[types.length - 1];
    if (indent === lastIndent && type === previousType) return `</li><li${attribute}>${$48412219c70f2c92$var$convertHTML(child, offset, length)}${$48412219c70f2c92$var$convertListHTML(rest, indent, types)}`;
    const [endTag] = $48412219c70f2c92$var$getListType(types.pop());
    return `</li></${endTag}>${$48412219c70f2c92$var$convertListHTML(items, lastIndent - 1, types)}`;
}
function $48412219c70f2c92$var$convertHTML(blot, index, length) {
    let isRoot = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if ('html' in blot && typeof blot.html === 'function') return blot.html(index, length);
    if (blot instanceof (0, $97f4bef342825216$export$2e2bcd8739ae039)) {
        const escapedText = (0, $97f4bef342825216$export$96e6fc3a139b2555)(blot.value().slice(index, index + length));
        return escapedText.replaceAll(' ', '&nbsp;');
    }
    if (blot instanceof (0, $569e748944e69916$export$e43113f0aad76fe)) {
        // TODO fix API
        if (blot.statics.blotName === 'list-container') {
            const items = [];
            blot.children.forEachAt(index, length, (child, offset, childLength)=>{
                const formats = 'formats' in child && typeof child.formats === 'function' ? child.formats() : {};
                items.push({
                    child: child,
                    offset: offset,
                    length: childLength,
                    indent: formats.indent || 0,
                    type: formats.list
                });
            });
            return $48412219c70f2c92$var$convertListHTML(items, -1, []);
        }
        const parts = [];
        blot.children.forEachAt(index, length, (child, offset, childLength)=>{
            parts.push($48412219c70f2c92$var$convertHTML(child, offset, childLength));
        });
        if (isRoot || blot.statics.blotName === 'list') return parts.join('');
        const { outerHTML: outerHTML, innerHTML: innerHTML } = blot.domNode;
        const [start, end] = outerHTML.split(`>${innerHTML}<`);
        // TODO cleanup
        if (start === '<table') return `<table style="border: 1px solid #000;">${parts.join('')}<${end}`;
        return `${start}>${parts.join('')}<${end}`;
    }
    return blot.domNode instanceof Element ? blot.domNode.outerHTML : '';
}
function $48412219c70f2c92$var$combineFormats(formats, combined) {
    return Object.keys(combined).reduce((merged, name)=>{
        if (formats[name] == null) return merged;
        const combinedValue = combined[name];
        if (combinedValue === formats[name]) merged[name] = combinedValue;
        else if (Array.isArray(combinedValue)) {
            if (combinedValue.indexOf(formats[name]) < 0) merged[name] = combinedValue.concat([
                formats[name]
            ]);
            else // If style already exists, don't add to an array, but don't lose other styles
            merged[name] = combinedValue;
        } else merged[name] = [
            combinedValue,
            formats[name]
        ];
        return merged;
    }, {});
}
function $48412219c70f2c92$var$getListType(type) {
    const tag = type === 'ordered' ? 'ol' : 'ul';
    switch(type){
        case 'checked':
            return [
                tag,
                ' data-list="checked"'
            ];
        case 'unchecked':
            return [
                tag,
                ' data-list="unchecked"'
            ];
        default:
            return [
                tag,
                ''
            ];
    }
}
function $48412219c70f2c92$var$normalizeDelta(delta) {
    return delta.reduce((normalizedDelta, op)=>{
        if (typeof op.insert === 'string') {
            const text = op.insert.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
            return normalizedDelta.insert(text, op.attributes);
        }
        return normalizedDelta.push(op);
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))());
}
function $48412219c70f2c92$var$shiftRange(_ref, amount) {
    let { index: index, length: length } = _ref;
    return new (0, $b3a4906c4c866f2e$export$9a58ef0d7ad3278c)(index + amount, length);
}
function $48412219c70f2c92$var$splitOpLines(ops) {
    const split = [];
    ops.forEach((op)=>{
        if (typeof op.insert === 'string') {
            const lines = op.insert.split('\n');
            lines.forEach((line, index)=>{
                if (index) split.push({
                    insert: '\n',
                    attributes: op.attributes
                });
                if (line) split.push({
                    insert: line,
                    attributes: op.attributes
                });
            });
        } else split.push(op);
    });
    return split;
}
var $48412219c70f2c92$export$2e2bcd8739ae039 = $48412219c70f2c92$var$Editor;





class $9dc68b38e283832b$var$Module {
    static DEFAULTS = {};
    constructor(quill){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.quill = quill;
        this.options = options;
    }
}
var $9dc68b38e283832b$export$2e2bcd8739ae039 = $9dc68b38e283832b$var$Module;





const $d7d8defead8474f8$var$GUARD_TEXT = '\uFEFF';
class $d7d8defead8474f8$var$Embed extends (0, $569e748944e69916$export$297a1fa96f55f00f) {
    constructor(scroll, node){
        super(scroll, node);
        this.contentNode = document.createElement('span');
        this.contentNode.setAttribute('contenteditable', 'false');
        Array.from(this.domNode.childNodes).forEach((childNode)=>{
            this.contentNode.appendChild(childNode);
        });
        this.leftGuard = document.createTextNode($d7d8defead8474f8$var$GUARD_TEXT);
        this.rightGuard = document.createTextNode($d7d8defead8474f8$var$GUARD_TEXT);
        this.domNode.appendChild(this.leftGuard);
        this.domNode.appendChild(this.contentNode);
        this.domNode.appendChild(this.rightGuard);
    }
    index(node, offset) {
        if (node === this.leftGuard) return 0;
        if (node === this.rightGuard) return 1;
        return super.index(node, offset);
    }
    restore(node) {
        let range = null;
        let textNode;
        const text = node.data.split($d7d8defead8474f8$var$GUARD_TEXT).join('');
        if (node === this.leftGuard) {
            if (this.prev instanceof (0, $97f4bef342825216$export$2e2bcd8739ae039)) {
                const prevLength = this.prev.length();
                this.prev.insertAt(prevLength, text);
                range = {
                    startNode: this.prev.domNode,
                    startOffset: prevLength + text.length
                };
            } else {
                textNode = document.createTextNode(text);
                this.parent.insertBefore(this.scroll.create(textNode), this);
                range = {
                    startNode: textNode,
                    startOffset: text.length
                };
            }
        } else if (node === this.rightGuard) {
            if (this.next instanceof (0, $97f4bef342825216$export$2e2bcd8739ae039)) {
                this.next.insertAt(0, text);
                range = {
                    startNode: this.next.domNode,
                    startOffset: text.length
                };
            } else {
                textNode = document.createTextNode(text);
                this.parent.insertBefore(this.scroll.create(textNode), this.next);
                range = {
                    startNode: textNode,
                    startOffset: text.length
                };
            }
        }
        node.data = $d7d8defead8474f8$var$GUARD_TEXT;
        return range;
    }
    update(mutations, context) {
        mutations.forEach((mutation)=>{
            if (mutation.type === 'characterData' && (mutation.target === this.leftGuard || mutation.target === this.rightGuard)) {
                const range = this.restore(mutation.target);
                if (range) context.range = range;
            }
        });
    }
}
var $d7d8defead8474f8$export$2e2bcd8739ae039 = $d7d8defead8474f8$var$Embed;



class $51e755309a5b3b6d$var$Composition {
    isComposing = false;
    constructor(scroll, emitter){
        this.scroll = scroll;
        this.emitter = emitter;
        this.setupListeners();
    }
    setupListeners() {
        this.scroll.domNode.addEventListener('compositionstart', (event)=>{
            if (!this.isComposing) this.handleCompositionStart(event);
        });
        this.scroll.domNode.addEventListener('compositionend', (event)=>{
            if (this.isComposing) // Webkit makes DOM changes after compositionend, so we use microtask to
            // ensure the order.
            // https://bugs.webkit.org/show_bug.cgi?id=31902
            queueMicrotask(()=>{
                this.handleCompositionEnd(event);
            });
        });
    }
    handleCompositionStart(event) {
        const blot = event.target instanceof Node ? this.scroll.find(event.target, true) : null;
        if (blot && !(blot instanceof (0, $d7d8defead8474f8$export$2e2bcd8739ae039))) {
            this.emitter.emit((0, $8d79d079139d3d60$export$2e2bcd8739ae039).events.COMPOSITION_BEFORE_START, event);
            this.scroll.batchStart();
            this.emitter.emit((0, $8d79d079139d3d60$export$2e2bcd8739ae039).events.COMPOSITION_START, event);
            this.isComposing = true;
        }
    }
    handleCompositionEnd(event) {
        this.emitter.emit((0, $8d79d079139d3d60$export$2e2bcd8739ae039).events.COMPOSITION_BEFORE_END, event);
        this.scroll.batchEnd();
        this.emitter.emit((0, $8d79d079139d3d60$export$2e2bcd8739ae039).events.COMPOSITION_END, event);
        this.isComposing = false;
    }
}
var $51e755309a5b3b6d$export$2e2bcd8739ae039 = $51e755309a5b3b6d$var$Composition;


class $8f053e3fa6387219$var$Theme {
    static DEFAULTS = {
        modules: {}
    };
    static themes = {
        default: $8f053e3fa6387219$var$Theme
    };
    modules = {};
    constructor(quill, options){
        this.quill = quill;
        this.options = options;
    }
    init() {
        Object.keys(this.options.modules).forEach((name)=>{
            if (this.modules[name] == null) this.addModule(name);
        });
    }
    addModule(name) {
        // @ts-expect-error
        const ModuleClass = this.quill.constructor.import(`modules/${name}`);
        this.modules[name] = new ModuleClass(this.quill, this.options.modules[name] || {});
        return this.modules[name];
    }
}
var $8f053e3fa6387219$export$2e2bcd8739ae039 = $8f053e3fa6387219$var$Theme;


const $456477f40a6de37b$var$getParentElement = (element)=>element.parentElement || element.getRootNode().host || null;
const $456477f40a6de37b$var$getElementRect = (element)=>{
    const rect = element.getBoundingClientRect();
    const scaleX = 'offsetWidth' in element && Math.abs(rect.width) / element.offsetWidth || 1;
    const scaleY = 'offsetHeight' in element && Math.abs(rect.height) / element.offsetHeight || 1;
    return {
        top: rect.top,
        right: rect.left + element.clientWidth * scaleX,
        bottom: rect.top + element.clientHeight * scaleY,
        left: rect.left
    };
};
const $456477f40a6de37b$var$paddingValueToInt = (value)=>{
    const number = parseInt(value, 10);
    return Number.isNaN(number) ? 0 : number;
};
// Follow the steps described in https://www.w3.org/TR/cssom-view-1/#element-scrolling-members,
// assuming that the scroll option is set to 'nearest'.
const $456477f40a6de37b$var$getScrollDistance = (targetStart, targetEnd, scrollStart, scrollEnd, scrollPaddingStart, scrollPaddingEnd)=>{
    if (targetStart < scrollStart && targetEnd > scrollEnd) return 0;
    if (targetStart < scrollStart) return -(scrollStart - targetStart + scrollPaddingStart);
    if (targetEnd > scrollEnd) return targetEnd - targetStart > scrollEnd - scrollStart ? targetStart + scrollPaddingStart - scrollStart : targetEnd - scrollEnd + scrollPaddingEnd;
    return 0;
};
const $456477f40a6de37b$var$scrollRectIntoView = (root, targetRect)=>{
    const document = root.ownerDocument;
    let rect = targetRect;
    let current = root;
    while(current){
        const isDocumentBody = current === document.body;
        const bounding = isDocumentBody ? {
            top: 0,
            right: window.visualViewport?.width ?? document.documentElement.clientWidth,
            bottom: window.visualViewport?.height ?? document.documentElement.clientHeight,
            left: 0
        } : $456477f40a6de37b$var$getElementRect(current);
        const style = getComputedStyle(current);
        const scrollDistanceX = $456477f40a6de37b$var$getScrollDistance(rect.left, rect.right, bounding.left, bounding.right, $456477f40a6de37b$var$paddingValueToInt(style.scrollPaddingLeft), $456477f40a6de37b$var$paddingValueToInt(style.scrollPaddingRight));
        const scrollDistanceY = $456477f40a6de37b$var$getScrollDistance(rect.top, rect.bottom, bounding.top, bounding.bottom, $456477f40a6de37b$var$paddingValueToInt(style.scrollPaddingTop), $456477f40a6de37b$var$paddingValueToInt(style.scrollPaddingBottom));
        if (scrollDistanceX || scrollDistanceY) {
            if (isDocumentBody) document.defaultView?.scrollBy(scrollDistanceX, scrollDistanceY);
            else {
                const { scrollLeft: scrollLeft, scrollTop: scrollTop } = current;
                if (scrollDistanceY) current.scrollTop += scrollDistanceY;
                if (scrollDistanceX) current.scrollLeft += scrollDistanceX;
                const scrolledLeft = current.scrollLeft - scrollLeft;
                const scrolledTop = current.scrollTop - scrollTop;
                rect = {
                    left: rect.left - scrolledLeft,
                    top: rect.top - scrolledTop,
                    right: rect.right - scrolledLeft,
                    bottom: rect.bottom - scrolledTop
                };
            }
        }
        current = isDocumentBody || style.position === 'fixed' ? null : $456477f40a6de37b$var$getParentElement(current);
    }
};
var $456477f40a6de37b$export$2e2bcd8739ae039 = $456477f40a6de37b$var$scrollRectIntoView;



const $6b31f5396e3f3453$var$MAX_REGISTER_ITERATIONS = 100;
const $6b31f5396e3f3453$var$CORE_FORMATS = [
    'block',
    'break',
    'cursor',
    'inline',
    'scroll',
    'text'
];
const $6b31f5396e3f3453$var$createRegistryWithFormats = (formats, sourceRegistry, debug)=>{
    const registry = new (0, $569e748944e69916$export$4d9facee29974f3)();
    $6b31f5396e3f3453$var$CORE_FORMATS.forEach((name)=>{
        const coreBlot = sourceRegistry.query(name);
        if (coreBlot) registry.register(coreBlot);
    });
    formats.forEach((name)=>{
        let format = sourceRegistry.query(name);
        if (!format) debug.error(`Cannot register "${name}" specified in "formats" config. Are you sure it was registered?`);
        let iterations = 0;
        while(format){
            registry.register(format);
            format = 'blotName' in format ? format.requiredContainer ?? null : null;
            iterations += 1;
            if (iterations > $6b31f5396e3f3453$var$MAX_REGISTER_ITERATIONS) {
                debug.error(`Cycle detected in registering blot requiredContainer: "${name}"`);
                break;
            }
        }
    });
    return registry;
};
var $6b31f5396e3f3453$export$2e2bcd8739ae039 = $6b31f5396e3f3453$var$createRegistryWithFormats;


const $f2fc927e4ed7c435$var$debug = (0, $17c49cda18fab12a$export$2e2bcd8739ae039)('quill');
const $f2fc927e4ed7c435$export$bc58ce2776ecdb6f = new $569e748944e69916$exports.Registry();
$569e748944e69916$exports.ParentBlot.uiClass = 'ql-ui';
/**
 * Options for initializing a Quill instance
 */ /**
 * Similar to QuillOptions, but with all properties expanded to their default values,
 * and all selectors resolved to HTMLElements.
 */ class $f2fc927e4ed7c435$export$2e2bcd8739ae039 {
    static DEFAULTS = {
        bounds: null,
        modules: {
            clipboard: true,
            keyboard: true,
            history: true,
            uploader: true
        },
        placeholder: '',
        readOnly: false,
        registry: $f2fc927e4ed7c435$export$bc58ce2776ecdb6f,
        theme: 'default'
    };
    static events = (0, $8d79d079139d3d60$export$2e2bcd8739ae039).events;
    static sources = (0, $8d79d079139d3d60$export$2e2bcd8739ae039).sources;
    static version = "2.0.3";
    static imports = {
        delta: (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports))),
        parchment: $569e748944e69916$exports,
        'core/module': (0, $9dc68b38e283832b$export$2e2bcd8739ae039),
        'core/theme': (0, $8f053e3fa6387219$export$2e2bcd8739ae039)
    };
    static debug(limit) {
        if (limit === true) limit = 'log';
        (0, $17c49cda18fab12a$export$2e2bcd8739ae039).level(limit);
    }
    static find(node) {
        let bubble = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        return (0, $58f298d123c67abd$export$2e2bcd8739ae039).get(node) || $f2fc927e4ed7c435$export$bc58ce2776ecdb6f.find(node, bubble);
    }
    static import(name) {
        if (this.imports[name] == null) $f2fc927e4ed7c435$var$debug.error(`Cannot import ${name}. Are you sure it was registered?`);
        return this.imports[name];
    }
    static register() {
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) !== 'string') {
            const target = arguments.length <= 0 ? undefined : arguments[0];
            const overwrite = !!(arguments.length <= 1 ? undefined : arguments[1]);
            const name = 'attrName' in target ? target.attrName : target.blotName;
            if (typeof name === 'string') // Shortcut for formats:
            // register(Blot | Attributor, overwrite)
            this.register(`formats/${name}`, target, overwrite);
            else Object.keys(target).forEach((key)=>{
                this.register(key, target[key], overwrite);
            });
        } else {
            const path = arguments.length <= 0 ? undefined : arguments[0];
            const target = arguments.length <= 1 ? undefined : arguments[1];
            const overwrite = !!(arguments.length <= 2 ? undefined : arguments[2]);
            if (this.imports[path] != null && !overwrite) $f2fc927e4ed7c435$var$debug.warn(`Overwriting ${path} with`, target);
            this.imports[path] = target;
            if ((path.startsWith('blots/') || path.startsWith('formats/')) && target && typeof target !== 'boolean' && target.blotName !== 'abstract') $f2fc927e4ed7c435$export$bc58ce2776ecdb6f.register(target);
            if (typeof target.register === 'function') target.register($f2fc927e4ed7c435$export$bc58ce2776ecdb6f);
        }
    }
    constructor(container){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.options = $f2fc927e4ed7c435$export$72ab7189806b6df5(container, options);
        this.container = this.options.container;
        if (this.container == null) {
            $f2fc927e4ed7c435$var$debug.error('Invalid Quill container', container);
            return;
        }
        if (this.options.debug) $f2fc927e4ed7c435$export$2e2bcd8739ae039.debug(this.options.debug);
        const html = this.container.innerHTML.trim();
        this.container.classList.add('ql-container');
        this.container.innerHTML = '';
        (0, $58f298d123c67abd$export$2e2bcd8739ae039).set(this.container, this);
        this.root = this.addContainer('ql-editor');
        this.root.classList.add('ql-blank');
        this.emitter = new (0, $8d79d079139d3d60$export$2e2bcd8739ae039)();
        const scrollBlotName = $569e748944e69916$exports.ScrollBlot.blotName;
        const ScrollBlot = this.options.registry.query(scrollBlotName);
        if (!ScrollBlot || !('blotName' in ScrollBlot)) throw new Error(`Cannot initialize Quill without "${scrollBlotName}" blot`);
        this.scroll = new ScrollBlot(this.options.registry, this.root, {
            emitter: this.emitter
        });
        this.editor = new (0, $48412219c70f2c92$export$2e2bcd8739ae039)(this.scroll);
        this.selection = new (0, $b3a4906c4c866f2e$export$2e2bcd8739ae039)(this.scroll, this.emitter);
        this.composition = new (0, $51e755309a5b3b6d$export$2e2bcd8739ae039)(this.scroll, this.emitter);
        this.theme = new this.options.theme(this, this.options); // eslint-disable-line new-cap
        this.keyboard = this.theme.addModule('keyboard');
        this.clipboard = this.theme.addModule('clipboard');
        this.history = this.theme.addModule('history');
        this.uploader = this.theme.addModule('uploader');
        this.theme.addModule('input');
        this.theme.addModule('uiNode');
        this.theme.init();
        this.emitter.on((0, $8d79d079139d3d60$export$2e2bcd8739ae039).events.EDITOR_CHANGE, (type)=>{
            if (type === (0, $8d79d079139d3d60$export$2e2bcd8739ae039).events.TEXT_CHANGE) this.root.classList.toggle('ql-blank', this.editor.isBlank());
        });
        this.emitter.on((0, $8d79d079139d3d60$export$2e2bcd8739ae039).events.SCROLL_UPDATE, (source, mutations)=>{
            const oldRange = this.selection.lastRange;
            const [newRange] = this.selection.getRange();
            const selectionInfo = oldRange && newRange ? {
                oldRange: oldRange,
                newRange: newRange
            } : undefined;
            $f2fc927e4ed7c435$var$modify.call(this, ()=>this.editor.update(null, mutations, selectionInfo), source);
        });
        this.emitter.on((0, $8d79d079139d3d60$export$2e2bcd8739ae039).events.SCROLL_EMBED_UPDATE, (blot, delta)=>{
            const oldRange = this.selection.lastRange;
            const [newRange] = this.selection.getRange();
            const selectionInfo = oldRange && newRange ? {
                oldRange: oldRange,
                newRange: newRange
            } : undefined;
            $f2fc927e4ed7c435$var$modify.call(this, ()=>{
                const change = new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))().retain(blot.offset(this)).retain({
                    [blot.statics.blotName]: delta
                });
                return this.editor.update(change, [], selectionInfo);
            }, $f2fc927e4ed7c435$export$2e2bcd8739ae039.sources.USER);
        });
        if (html) {
            const contents = this.clipboard.convert({
                html: `${html}<p><br></p>`,
                text: '\n'
            });
            this.setContents(contents);
        }
        this.history.clear();
        if (this.options.placeholder) this.root.setAttribute('data-placeholder', this.options.placeholder);
        if (this.options.readOnly) this.disable();
        this.allowReadOnlyEdits = false;
    }
    addContainer(container) {
        let refNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        if (typeof container === 'string') {
            const className = container;
            container = document.createElement('div');
            container.classList.add(className);
        }
        this.container.insertBefore(container, refNode);
        return container;
    }
    blur() {
        this.selection.setRange(null);
    }
    deleteText(index, length, source) {
        // @ts-expect-error
        [index, length, , source] = $f2fc927e4ed7c435$export$e336952123c0bccd(index, length, source);
        return $f2fc927e4ed7c435$var$modify.call(this, ()=>{
            return this.editor.deleteText(index, length);
        }, source, index, -1 * length);
    }
    disable() {
        this.enable(false);
    }
    editReadOnly(modifier) {
        this.allowReadOnlyEdits = true;
        const value = modifier();
        this.allowReadOnlyEdits = false;
        return value;
    }
    enable() {
        let enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        this.scroll.enable(enabled);
        this.container.classList.toggle('ql-disabled', !enabled);
    }
    focus() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.selection.focus();
        if (!options.preventScroll) this.scrollSelectionIntoView();
    }
    format(name, value) {
        let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $8d79d079139d3d60$export$2e2bcd8739ae039).sources.API;
        return $f2fc927e4ed7c435$var$modify.call(this, ()=>{
            const range = this.getSelection(true);
            let change = new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))();
            if (range == null) return change;
            if (this.scroll.query(name, $569e748944e69916$exports.Scope.BLOCK)) change = this.editor.formatLine(range.index, range.length, {
                [name]: value
            });
            else if (range.length === 0) {
                this.selection.format(name, value);
                return change;
            } else change = this.editor.formatText(range.index, range.length, {
                [name]: value
            });
            this.setSelection(range, (0, $8d79d079139d3d60$export$2e2bcd8739ae039).sources.SILENT);
            return change;
        }, source);
    }
    formatLine(index, length, name, value, source) {
        let formats;
        // eslint-disable-next-line prefer-const
        [index, length, formats, source] = $f2fc927e4ed7c435$export$e336952123c0bccd(index, length, // @ts-expect-error
        name, value, source);
        return $f2fc927e4ed7c435$var$modify.call(this, ()=>{
            return this.editor.formatLine(index, length, formats);
        }, source, index, 0);
    }
    formatText(index, length, name, value, source) {
        let formats;
        // eslint-disable-next-line prefer-const
        [index, length, formats, source] = $f2fc927e4ed7c435$export$e336952123c0bccd(// @ts-expect-error
        index, length, name, value, source);
        return $f2fc927e4ed7c435$var$modify.call(this, ()=>{
            return this.editor.formatText(index, length, formats);
        }, source, index, 0);
    }
    getBounds(index) {
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        let bounds = null;
        if (typeof index === 'number') bounds = this.selection.getBounds(index, length);
        else bounds = this.selection.getBounds(index.index, index.length);
        if (!bounds) return null;
        const containerBounds = this.container.getBoundingClientRect();
        return {
            bottom: bounds.bottom - containerBounds.top,
            height: bounds.height,
            left: bounds.left - containerBounds.left,
            right: bounds.right - containerBounds.left,
            top: bounds.top - containerBounds.top,
            width: bounds.width
        };
    }
    getContents() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;
        [index, length] = $f2fc927e4ed7c435$export$e336952123c0bccd(index, length);
        return this.editor.getContents(index, length);
    }
    getFormat() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelection(true);
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        if (typeof index === 'number') return this.editor.getFormat(index, length);
        return this.editor.getFormat(index.index, index.length);
    }
    getIndex(blot) {
        return blot.offset(this.scroll);
    }
    getLength() {
        return this.scroll.length();
    }
    getLeaf(index) {
        return this.scroll.leaf(index);
    }
    getLine(index) {
        return this.scroll.line(index);
    }
    getLines() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
        if (typeof index !== 'number') return this.scroll.lines(index.index, index.length);
        return this.scroll.lines(index, length);
    }
    getModule(name) {
        return this.theme.modules[name];
    }
    getSelection() {
        let focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (focus) this.focus();
        this.update(); // Make sure we access getRange with editor in consistent state
        return this.selection.getRange()[0];
    }
    getSemanticHTML() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 ? arguments[1] : undefined;
        if (typeof index === 'number') length = length ?? this.getLength() - index;
        // @ts-expect-error
        [index, length] = $f2fc927e4ed7c435$export$e336952123c0bccd(index, length);
        return this.editor.getHTML(index, length);
    }
    getText() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 ? arguments[1] : undefined;
        if (typeof index === 'number') length = length ?? this.getLength() - index;
        // @ts-expect-error
        [index, length] = $f2fc927e4ed7c435$export$e336952123c0bccd(index, length);
        return this.editor.getText(index, length);
    }
    hasFocus() {
        return this.selection.hasFocus();
    }
    insertEmbed(index, embed, value) {
        let source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $f2fc927e4ed7c435$export$2e2bcd8739ae039.sources.API;
        return $f2fc927e4ed7c435$var$modify.call(this, ()=>{
            return this.editor.insertEmbed(index, embed, value);
        }, source, index);
    }
    insertText(index, text, name, value, source) {
        let formats;
        // eslint-disable-next-line prefer-const
        // @ts-expect-error
        [index, , formats, source] = $f2fc927e4ed7c435$export$e336952123c0bccd(index, 0, name, value, source);
        return $f2fc927e4ed7c435$var$modify.call(this, ()=>{
            return this.editor.insertText(index, text, formats);
        }, source, index, text.length);
    }
    isEnabled() {
        return this.scroll.isEnabled();
    }
    off() {
        return this.emitter.off(...arguments);
    }
    on() {
        return this.emitter.on(...arguments);
    }
    once() {
        return this.emitter.once(...arguments);
    }
    removeFormat(index, length, source) {
        [index, length, , source] = $f2fc927e4ed7c435$export$e336952123c0bccd(index, length, source);
        return $f2fc927e4ed7c435$var$modify.call(this, ()=>{
            return this.editor.removeFormat(index, length);
        }, source, index);
    }
    scrollRectIntoView(rect) {
        (0, $456477f40a6de37b$export$2e2bcd8739ae039)(this.root, rect);
    }
    /**
   * @deprecated Use Quill#scrollSelectionIntoView() instead.
   */ scrollIntoView() {
        console.warn('Quill#scrollIntoView() has been deprecated and will be removed in the near future. Please use Quill#scrollSelectionIntoView() instead.');
        this.scrollSelectionIntoView();
    }
    /**
   * Scroll the current selection into the visible area.
   * If the selection is already visible, no scrolling will occur.
   */ scrollSelectionIntoView() {
        const range = this.selection.lastRange;
        const bounds = range && this.selection.getBounds(range.index, range.length);
        if (bounds) this.scrollRectIntoView(bounds);
    }
    setContents(delta) {
        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $8d79d079139d3d60$export$2e2bcd8739ae039).sources.API;
        return $f2fc927e4ed7c435$var$modify.call(this, ()=>{
            delta = new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))(delta);
            const length = this.getLength();
            // Quill will set empty editor to \n
            const delete1 = this.editor.deleteText(0, length);
            const applied = this.editor.insertContents(0, delta);
            // Remove extra \n from empty editor initialization
            const delete2 = this.editor.deleteText(this.getLength() - 1, 1);
            return delete1.compose(applied).compose(delete2);
        }, source);
    }
    setSelection(index, length, source) {
        if (index == null) // @ts-expect-error https://github.com/microsoft/TypeScript/issues/22609
        this.selection.setRange(null, length || $f2fc927e4ed7c435$export$2e2bcd8739ae039.sources.API);
        else {
            // @ts-expect-error
            [index, length, , source] = $f2fc927e4ed7c435$export$e336952123c0bccd(index, length, source);
            this.selection.setRange(new (0, $b3a4906c4c866f2e$export$9a58ef0d7ad3278c)(Math.max(0, index), length), source);
            if (source !== (0, $8d79d079139d3d60$export$2e2bcd8739ae039).sources.SILENT) this.scrollSelectionIntoView();
        }
    }
    setText(text) {
        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $8d79d079139d3d60$export$2e2bcd8739ae039).sources.API;
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))().insert(text);
        return this.setContents(delta, source);
    }
    update() {
        let source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $8d79d079139d3d60$export$2e2bcd8739ae039).sources.USER;
        const change = this.scroll.update(source); // Will update selection before selection.update() does if text changes
        this.selection.update(source);
        // TODO this is usually undefined
        return change;
    }
    updateContents(delta) {
        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $8d79d079139d3d60$export$2e2bcd8739ae039).sources.API;
        return $f2fc927e4ed7c435$var$modify.call(this, ()=>{
            delta = new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))(delta);
            return this.editor.applyDelta(delta);
        }, source, true);
    }
}
function $f2fc927e4ed7c435$var$resolveSelector(selector) {
    return typeof selector === 'string' ? document.querySelector(selector) : selector;
}
function $f2fc927e4ed7c435$var$expandModuleConfig(config) {
    return Object.entries(config ?? {}).reduce((expanded, _ref)=>{
        let [key, value] = _ref;
        return {
            ...expanded,
            [key]: value === true ? {} : value
        };
    }, {});
}
function $f2fc927e4ed7c435$var$omitUndefinedValuesFromOptions(obj) {
    return Object.fromEntries(Object.entries(obj).filter((entry)=>entry[1] !== undefined));
}
function $f2fc927e4ed7c435$export$72ab7189806b6df5(containerOrSelector, options) {
    const container = $f2fc927e4ed7c435$var$resolveSelector(containerOrSelector);
    if (!container) throw new Error('Invalid Quill container');
    const shouldUseDefaultTheme = !options.theme || options.theme === $f2fc927e4ed7c435$export$2e2bcd8739ae039.DEFAULTS.theme;
    const theme = shouldUseDefaultTheme ? (0, $8f053e3fa6387219$export$2e2bcd8739ae039) : $f2fc927e4ed7c435$export$2e2bcd8739ae039.import(`themes/${options.theme}`);
    if (!theme) throw new Error(`Invalid theme ${options.theme}. Did you register it?`);
    const { modules: quillModuleDefaults, ...quillDefaults } = $f2fc927e4ed7c435$export$2e2bcd8739ae039.DEFAULTS;
    const { modules: themeModuleDefaults, ...themeDefaults } = theme.DEFAULTS;
    let userModuleOptions = $f2fc927e4ed7c435$var$expandModuleConfig(options.modules);
    // Special case toolbar shorthand
    if (userModuleOptions != null && userModuleOptions.toolbar && userModuleOptions.toolbar.constructor !== Object) userModuleOptions = {
        ...userModuleOptions,
        toolbar: {
            container: userModuleOptions.toolbar
        }
    };
    const modules = (0, $4dea300bb9269819$export$2e2bcd8739ae039)({}, $f2fc927e4ed7c435$var$expandModuleConfig(quillModuleDefaults), $f2fc927e4ed7c435$var$expandModuleConfig(themeModuleDefaults), userModuleOptions);
    const config = {
        ...quillDefaults,
        ...$f2fc927e4ed7c435$var$omitUndefinedValuesFromOptions(themeDefaults),
        ...$f2fc927e4ed7c435$var$omitUndefinedValuesFromOptions(options)
    };
    let registry = options.registry;
    if (registry) {
        if (options.formats) $f2fc927e4ed7c435$var$debug.warn('Ignoring "formats" option because "registry" is specified');
    } else registry = options.formats ? (0, $6b31f5396e3f3453$export$2e2bcd8739ae039)(options.formats, config.registry, $f2fc927e4ed7c435$var$debug) : config.registry;
    return {
        ...config,
        registry: registry,
        container: container,
        theme: theme,
        modules: Object.entries(modules).reduce((modulesWithDefaults, _ref2)=>{
            let [name, value] = _ref2;
            if (!value) return modulesWithDefaults;
            const moduleClass = $f2fc927e4ed7c435$export$2e2bcd8739ae039.import(`modules/${name}`);
            if (moduleClass == null) {
                $f2fc927e4ed7c435$var$debug.error(`Cannot load ${name} module. Are you sure you registered it?`);
                return modulesWithDefaults;
            }
            return {
                ...modulesWithDefaults,
                // @ts-expect-error
                [name]: (0, $4dea300bb9269819$export$2e2bcd8739ae039)({}, moduleClass.DEFAULTS || {}, value)
            };
        }, {}),
        bounds: $f2fc927e4ed7c435$var$resolveSelector(config.bounds)
    };
}
// Handle selection preservation and TEXT_CHANGE emission
// common to modification APIs
function $f2fc927e4ed7c435$var$modify(modifier, source, index, shift) {
    if (!this.isEnabled() && source === (0, $8d79d079139d3d60$export$2e2bcd8739ae039).sources.USER && !this.allowReadOnlyEdits) return new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))();
    let range = index == null ? null : this.getSelection();
    const oldDelta = this.editor.delta;
    const change = modifier();
    if (range != null) {
        if (index === true) index = range.index; // eslint-disable-line prefer-destructuring
        if (shift == null) range = $f2fc927e4ed7c435$var$shiftRange(range, change, source);
        else if (shift !== 0) // @ts-expect-error index should always be number
        range = $f2fc927e4ed7c435$var$shiftRange(range, index, shift, source);
        this.setSelection(range, (0, $8d79d079139d3d60$export$2e2bcd8739ae039).sources.SILENT);
    }
    if (change.length() > 0) {
        const args = [
            (0, $8d79d079139d3d60$export$2e2bcd8739ae039).events.TEXT_CHANGE,
            change,
            oldDelta,
            source
        ];
        this.emitter.emit((0, $8d79d079139d3d60$export$2e2bcd8739ae039).events.EDITOR_CHANGE, ...args);
        if (source !== (0, $8d79d079139d3d60$export$2e2bcd8739ae039).sources.SILENT) this.emitter.emit(...args);
    }
    return change;
}
function $f2fc927e4ed7c435$export$e336952123c0bccd(index, length, name, value, source) {
    let formats = {};
    // @ts-expect-error
    if (typeof index.index === 'number' && typeof index.length === 'number') {
        // Allow for throwaway end (used by insertText/insertEmbed)
        if (typeof length !== 'number') {
            // @ts-expect-error
            source = value;
            value = name;
            name = length;
            // @ts-expect-error
            length = index.length; // eslint-disable-line prefer-destructuring
            // @ts-expect-error
            index = index.index; // eslint-disable-line prefer-destructuring
        } else {
            // @ts-expect-error
            length = index.length; // eslint-disable-line prefer-destructuring
            // @ts-expect-error
            index = index.index; // eslint-disable-line prefer-destructuring
        }
    } else if (typeof length !== 'number') {
        // @ts-expect-error
        source = value;
        value = name;
        name = length;
        length = 0;
    }
    // Handle format being object, two format name/value strings or excluded
    if (typeof name === 'object') {
        // @ts-expect-error Fix me later
        formats = name;
        // @ts-expect-error
        source = value;
    } else if (typeof name === 'string') {
        if (value != null) formats[name] = value;
        else // @ts-expect-error
        source = name;
    }
    // Handle optional source
    source = source || (0, $8d79d079139d3d60$export$2e2bcd8739ae039).sources.API;
    // @ts-expect-error
    return [
        index,
        length,
        formats,
        source
    ];
}
function $f2fc927e4ed7c435$var$shiftRange(range, index, lengthOrSource, source) {
    const length = typeof lengthOrSource === 'number' ? lengthOrSource : 0;
    if (range == null) return null;
    let start;
    let end;
    // @ts-expect-error -- TODO: add a better type guard around `index`
    if (index && typeof index.transformPosition === 'function') [start, end] = [
        range.index,
        range.index + range.length
    ].map((pos)=>// @ts-expect-error -- TODO: add a better type guard around `index`
        index.transformPosition(pos, source !== (0, $8d79d079139d3d60$export$2e2bcd8739ae039).sources.USER));
    else [start, end] = [
        range.index,
        range.index + range.length
    ].map((pos)=>{
        // @ts-expect-error -- TODO: add a better type guard around `index`
        if (pos < index || pos === index && source === (0, $8d79d079139d3d60$export$2e2bcd8739ae039).sources.USER) return pos;
        if (length >= 0) return pos + length;
        // @ts-expect-error -- TODO: add a better type guard around `index`
        return Math.max(index, pos + length);
    });
    return new (0, $b3a4906c4c866f2e$export$9a58ef0d7ad3278c)(start, end - start);
}





class $30b436bea069535f$var$Container extends (0, $569e748944e69916$export$c898d510319704c0) {
}
var $30b436bea069535f$export$2e2bcd8739ae039 = $30b436bea069535f$var$Container;











function $c80c0f1fd30fc5f1$var$isLine(blot) {
    return blot instanceof (0, $85f480a53d3839c4$export$2e2bcd8739ae039) || blot instanceof (0, $85f480a53d3839c4$export$48b9f0688962d028);
}
function $c80c0f1fd30fc5f1$var$isUpdatable(blot) {
    return typeof blot.updateContent === 'function';
}
class $c80c0f1fd30fc5f1$var$Scroll extends (0, $569e748944e69916$export$7175329dad7a46f1) {
    static blotName = 'scroll';
    static className = 'ql-editor';
    static tagName = 'DIV';
    static defaultChild = (0, $85f480a53d3839c4$export$2e2bcd8739ae039);
    static allowedChildren = [
        (0, $85f480a53d3839c4$export$2e2bcd8739ae039),
        (0, $85f480a53d3839c4$export$48b9f0688962d028),
        (0, $30b436bea069535f$export$2e2bcd8739ae039)
    ];
    constructor(registry, domNode, _ref){
        let { emitter: emitter } = _ref;
        super(registry, domNode);
        this.emitter = emitter;
        this.batch = false;
        this.optimize();
        this.enable();
        this.domNode.addEventListener('dragstart', (e)=>this.handleDragStart(e));
    }
    batchStart() {
        if (!Array.isArray(this.batch)) this.batch = [];
    }
    batchEnd() {
        if (!this.batch) return;
        const mutations = this.batch;
        this.batch = false;
        this.update(mutations);
    }
    emitMount(blot) {
        this.emitter.emit((0, $8d79d079139d3d60$export$2e2bcd8739ae039).events.SCROLL_BLOT_MOUNT, blot);
    }
    emitUnmount(blot) {
        this.emitter.emit((0, $8d79d079139d3d60$export$2e2bcd8739ae039).events.SCROLL_BLOT_UNMOUNT, blot);
    }
    emitEmbedUpdate(blot, change) {
        this.emitter.emit((0, $8d79d079139d3d60$export$2e2bcd8739ae039).events.SCROLL_EMBED_UPDATE, blot, change);
    }
    deleteAt(index, length) {
        const [first, offset] = this.line(index);
        const [last] = this.line(index + length);
        super.deleteAt(index, length);
        if (last != null && first !== last && offset > 0) {
            if (first instanceof (0, $85f480a53d3839c4$export$48b9f0688962d028) || last instanceof (0, $85f480a53d3839c4$export$48b9f0688962d028)) {
                this.optimize();
                return;
            }
            const ref = last.children.head instanceof (0, $ed7188caee9f09fc$export$2e2bcd8739ae039) ? null : last.children.head;
            // @ts-expect-error
            first.moveChildren(last, ref);
            // @ts-expect-error
            first.remove();
        }
        this.optimize();
    }
    enable() {
        let enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        this.domNode.setAttribute('contenteditable', enabled ? 'true' : 'false');
    }
    formatAt(index, length, format, value) {
        super.formatAt(index, length, format, value);
        this.optimize();
    }
    insertAt(index, value, def) {
        if (index >= this.length()) {
            if (def == null || this.scroll.query(value, (0, $569e748944e69916$export$775b6bb06e53a214).BLOCK) == null) {
                const blot = this.scroll.create(this.statics.defaultChild.blotName);
                this.appendChild(blot);
                if (def == null && value.endsWith('\n')) blot.insertAt(0, value.slice(0, -1), def);
                else blot.insertAt(0, value, def);
            } else {
                const embed = this.scroll.create(value, def);
                this.appendChild(embed);
            }
        } else super.insertAt(index, value, def);
        this.optimize();
    }
    insertBefore(blot, ref) {
        if (blot.statics.scope === (0, $569e748944e69916$export$775b6bb06e53a214).INLINE_BLOT) {
            const wrapper = this.scroll.create(this.statics.defaultChild.blotName);
            wrapper.appendChild(blot);
            super.insertBefore(wrapper, ref);
        } else super.insertBefore(blot, ref);
    }
    insertContents(index, delta) {
        const renderBlocks = this.deltaToRenderBlocks(delta.concat(new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))().insert('\n')));
        const last = renderBlocks.pop();
        if (last == null) return;
        this.batchStart();
        const first = renderBlocks.shift();
        if (first) {
            const shouldInsertNewlineChar = first.type === 'block' && (first.delta.length() === 0 || !this.descendant((0, $85f480a53d3839c4$export$48b9f0688962d028), index)[0] && index < this.length());
            const delta = first.type === 'block' ? first.delta : new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))().insert({
                [first.key]: first.value
            });
            $c80c0f1fd30fc5f1$var$insertInlineContents(this, index, delta);
            const newlineCharLength = first.type === 'block' ? 1 : 0;
            const lineEndIndex = index + delta.length() + newlineCharLength;
            if (shouldInsertNewlineChar) this.insertAt(lineEndIndex - 1, '\n');
            const formats = (0, $85f480a53d3839c4$export$e4bb5a6163449612)(this.line(index)[0]);
            const attributes = (0, $88e60522c01c2553$exports.AttributeMap).diff(formats, first.attributes) || {};
            Object.keys(attributes).forEach((name)=>{
                this.formatAt(lineEndIndex - 1, 1, name, attributes[name]);
            });
            index = lineEndIndex;
        }
        let [refBlot, refBlotOffset] = this.children.find(index);
        if (renderBlocks.length) {
            if (refBlot) {
                refBlot = refBlot.split(refBlotOffset);
                refBlotOffset = 0;
            }
            renderBlocks.forEach((renderBlock)=>{
                if (renderBlock.type === 'block') {
                    const block = this.createBlock(renderBlock.attributes, refBlot || undefined);
                    $c80c0f1fd30fc5f1$var$insertInlineContents(block, 0, renderBlock.delta);
                } else {
                    const blockEmbed = this.create(renderBlock.key, renderBlock.value);
                    this.insertBefore(blockEmbed, refBlot || undefined);
                    Object.keys(renderBlock.attributes).forEach((name)=>{
                        blockEmbed.format(name, renderBlock.attributes[name]);
                    });
                }
            });
        }
        if (last.type === 'block' && last.delta.length()) {
            const offset = refBlot ? refBlot.offset(refBlot.scroll) + refBlotOffset : this.length();
            $c80c0f1fd30fc5f1$var$insertInlineContents(this, offset, last.delta);
        }
        this.batchEnd();
        this.optimize();
    }
    isEnabled() {
        return this.domNode.getAttribute('contenteditable') === 'true';
    }
    leaf(index) {
        const last = this.path(index).pop();
        if (!last) return [
            null,
            -1
        ];
        const [blot, offset] = last;
        return blot instanceof (0, $569e748944e69916$export$7420b9c542181544) ? [
            blot,
            offset
        ] : [
            null,
            -1
        ];
    }
    line(index) {
        if (index === this.length()) return this.line(index - 1);
        // @ts-expect-error TODO: make descendant() generic
        return this.descendant($c80c0f1fd30fc5f1$var$isLine, index);
    }
    lines() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
        const getLines = (blot, blotIndex, blotLength)=>{
            let lines = [];
            let lengthLeft = blotLength;
            blot.children.forEachAt(blotIndex, blotLength, (child, childIndex, childLength)=>{
                if ($c80c0f1fd30fc5f1$var$isLine(child)) lines.push(child);
                else if (child instanceof (0, $569e748944e69916$export$c898d510319704c0)) lines = lines.concat(getLines(child, childIndex, lengthLeft));
                lengthLeft -= childLength;
            });
            return lines;
        };
        return getLines(this, index, length);
    }
    optimize() {
        let mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (this.batch) return;
        super.optimize(mutations, context);
        if (mutations.length > 0) this.emitter.emit((0, $8d79d079139d3d60$export$2e2bcd8739ae039).events.SCROLL_OPTIMIZE, mutations, context);
    }
    path(index) {
        return super.path(index).slice(1); // Exclude self
    }
    remove() {
    // Never remove self
    }
    update(mutations) {
        if (this.batch) {
            if (Array.isArray(mutations)) this.batch = this.batch.concat(mutations);
            return;
        }
        let source = (0, $8d79d079139d3d60$export$2e2bcd8739ae039).sources.USER;
        if (typeof mutations === 'string') source = mutations;
        if (!Array.isArray(mutations)) mutations = this.observer.takeRecords();
        mutations = mutations.filter((_ref2)=>{
            let { target: target } = _ref2;
            const blot = this.find(target, true);
            return blot && !$c80c0f1fd30fc5f1$var$isUpdatable(blot);
        });
        if (mutations.length > 0) this.emitter.emit((0, $8d79d079139d3d60$export$2e2bcd8739ae039).events.SCROLL_BEFORE_UPDATE, source, mutations);
        super.update(mutations.concat([])); // pass copy
        if (mutations.length > 0) this.emitter.emit((0, $8d79d079139d3d60$export$2e2bcd8739ae039).events.SCROLL_UPDATE, source, mutations);
    }
    updateEmbedAt(index, key, change) {
        // Currently it only supports top-level embeds (BlockEmbed).
        // We can update `ParentBlot` in parchment to support inline embeds.
        const [blot] = this.descendant((b)=>b instanceof (0, $85f480a53d3839c4$export$48b9f0688962d028), index);
        if (blot && blot.statics.blotName === key && $c80c0f1fd30fc5f1$var$isUpdatable(blot)) blot.updateContent(change);
    }
    handleDragStart(event) {
        event.preventDefault();
    }
    deltaToRenderBlocks(delta) {
        const renderBlocks = [];
        let currentBlockDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))();
        delta.forEach((op)=>{
            const insert = op?.insert;
            if (!insert) return;
            if (typeof insert === 'string') {
                const splitted = insert.split('\n');
                splitted.slice(0, -1).forEach((text)=>{
                    currentBlockDelta.insert(text, op.attributes);
                    renderBlocks.push({
                        type: 'block',
                        delta: currentBlockDelta,
                        attributes: op.attributes ?? {}
                    });
                    currentBlockDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))();
                });
                const last = splitted[splitted.length - 1];
                if (last) currentBlockDelta.insert(last, op.attributes);
            } else {
                const key = Object.keys(insert)[0];
                if (!key) return;
                if (this.query(key, (0, $569e748944e69916$export$775b6bb06e53a214).INLINE)) currentBlockDelta.push(op);
                else {
                    if (currentBlockDelta.length()) renderBlocks.push({
                        type: 'block',
                        delta: currentBlockDelta,
                        attributes: {}
                    });
                    currentBlockDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))();
                    renderBlocks.push({
                        type: 'blockEmbed',
                        key: key,
                        value: insert[key],
                        attributes: op.attributes ?? {}
                    });
                }
            }
        });
        if (currentBlockDelta.length()) renderBlocks.push({
            type: 'block',
            delta: currentBlockDelta,
            attributes: {}
        });
        return renderBlocks;
    }
    createBlock(attributes, refBlot) {
        let blotName;
        const formats = {};
        Object.entries(attributes).forEach((_ref3)=>{
            let [key, value] = _ref3;
            const isBlockBlot = this.query(key, (0, $569e748944e69916$export$775b6bb06e53a214).BLOCK & (0, $569e748944e69916$export$775b6bb06e53a214).BLOT) != null;
            if (isBlockBlot) blotName = key;
            else formats[key] = value;
        });
        const block = this.create(blotName || this.statics.defaultChild.blotName, blotName ? attributes[blotName] : undefined);
        this.insertBefore(block, refBlot || undefined);
        const length = block.length();
        Object.entries(formats).forEach((_ref4)=>{
            let [key, value] = _ref4;
            block.formatAt(0, length, key, value);
        });
        return block;
    }
}
function $c80c0f1fd30fc5f1$var$insertInlineContents(parent, index, inlineContents) {
    inlineContents.reduce((index, op)=>{
        const length = (0, $88e60522c01c2553$exports.Op).length(op);
        let attributes = op.attributes || {};
        if (op.insert != null) {
            if (typeof op.insert === 'string') {
                const text = op.insert;
                parent.insertAt(index, text);
                const [leaf] = parent.descendant((0, $569e748944e69916$export$7420b9c542181544), index);
                const formats = (0, $85f480a53d3839c4$export$e4bb5a6163449612)(leaf);
                attributes = (0, $88e60522c01c2553$exports.AttributeMap).diff(formats, attributes) || {};
            } else if (typeof op.insert === 'object') {
                const key = Object.keys(op.insert)[0]; // There should only be one key
                if (key == null) return index;
                parent.insertAt(index, key, op.insert[key]);
                const isInlineEmbed = parent.scroll.query(key, (0, $569e748944e69916$export$775b6bb06e53a214).INLINE) != null;
                if (isInlineEmbed) {
                    const [leaf] = parent.descendant((0, $569e748944e69916$export$7420b9c542181544), index);
                    const formats = (0, $85f480a53d3839c4$export$e4bb5a6163449612)(leaf);
                    attributes = (0, $88e60522c01c2553$exports.AttributeMap).diff(formats, attributes) || {};
                }
            }
        }
        Object.keys(attributes).forEach((key)=>{
            parent.formatAt(index, length, key, attributes[key]);
        });
        return index + length;
    }, index);
}
var $c80c0f1fd30fc5f1$export$2e2bcd8739ae039 = $c80c0f1fd30fc5f1$var$Scroll;










const $46becb55ac73c7d6$var$config = {
    scope: (0, $569e748944e69916$export$775b6bb06e53a214).BLOCK,
    whitelist: [
        'right',
        'center',
        'justify'
    ]
};
const $46becb55ac73c7d6$export$2ef0f9fb04a51388 = new (0, $569e748944e69916$export$217610c4183502d0)('align', 'align', $46becb55ac73c7d6$var$config);
const $46becb55ac73c7d6$export$7f3685f5846c07da = new (0, $569e748944e69916$export$651d45509677cf07)('align', 'ql-align', $46becb55ac73c7d6$var$config);
const $46becb55ac73c7d6$export$d2060f5d114c9fe8 = new (0, $569e748944e69916$export$7c8099bbfe87b94d)('align', 'text-align', $46becb55ac73c7d6$var$config);




class $73f85d61d1cfa261$export$c992e3369f248f6e extends (0, $569e748944e69916$export$7c8099bbfe87b94d) {
    value(domNode) {
        let value = super.value(domNode);
        if (!value.startsWith('rgb(')) return value;
        value = value.replace(/^[^\d]+/, '').replace(/[^\d]+$/, '');
        const hex = value.split(',').map((component)=>`00${parseInt(component, 10).toString(16)}`.slice(-2)).join('');
        return `#${hex}`;
    }
}
const $73f85d61d1cfa261$export$42795dcf0ec6f3c8 = new (0, $569e748944e69916$export$651d45509677cf07)('color', 'ql-color', {
    scope: (0, $569e748944e69916$export$775b6bb06e53a214).INLINE
});
const $73f85d61d1cfa261$export$1415f56796d9a5a9 = new $73f85d61d1cfa261$export$c992e3369f248f6e('color', 'color', {
    scope: (0, $569e748944e69916$export$775b6bb06e53a214).INLINE
});


const $2f71c8f40f0309fa$export$8aa96c8963152b12 = new (0, $569e748944e69916$export$651d45509677cf07)('background', 'ql-bg', {
    scope: (0, $569e748944e69916$export$775b6bb06e53a214).INLINE
});
const $2f71c8f40f0309fa$export$dc1cbcab4c682ef = new (0, $73f85d61d1cfa261$export$c992e3369f248f6e)('background', 'background-color', {
    scope: (0, $569e748944e69916$export$775b6bb06e53a214).INLINE
});









class $c2ac4be2a790a238$export$3b131632d3d15165 extends (0, $30b436bea069535f$export$2e2bcd8739ae039) {
    static create(value) {
        const domNode = super.create(value);
        domNode.setAttribute('spellcheck', 'false');
        return domNode;
    }
    code(index, length) {
        return this.children// @ts-expect-error
        .map((child)=>child.length() <= 1 ? '' : child.domNode.innerText).join('\n').slice(index, index + length);
    }
    html(index, length) {
        // `\n`s are needed in order to support empty lines at the beginning and the end.
        // https://html.spec.whatwg.org/multipage/syntax.html#element-restrictions
        return `<pre>\n${(0, $97f4bef342825216$export$96e6fc3a139b2555)(this.code(index, length))}\n</pre>`;
    }
}
class $c2ac4be2a790a238$export$2e2bcd8739ae039 extends (0, $85f480a53d3839c4$export$2e2bcd8739ae039) {
    static TAB = '  ';
    static register() {
        (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).register($c2ac4be2a790a238$export$3b131632d3d15165);
    }
}
class $c2ac4be2a790a238$export$52f0f02147b12c03 extends (0, $90a3f5612e2e28d2$export$2e2bcd8739ae039) {
}
$c2ac4be2a790a238$export$52f0f02147b12c03.blotName = 'code';
$c2ac4be2a790a238$export$52f0f02147b12c03.tagName = 'CODE';
$c2ac4be2a790a238$export$2e2bcd8739ae039.blotName = 'code-block';
$c2ac4be2a790a238$export$2e2bcd8739ae039.className = 'ql-code-block';
$c2ac4be2a790a238$export$2e2bcd8739ae039.tagName = 'DIV';
$c2ac4be2a790a238$export$3b131632d3d15165.blotName = 'code-block-container';
$c2ac4be2a790a238$export$3b131632d3d15165.className = 'ql-code-block-container';
$c2ac4be2a790a238$export$3b131632d3d15165.tagName = 'DIV';
$c2ac4be2a790a238$export$3b131632d3d15165.allowedChildren = [
    $c2ac4be2a790a238$export$2e2bcd8739ae039
];
$c2ac4be2a790a238$export$2e2bcd8739ae039.allowedChildren = [
    (0, $97f4bef342825216$export$2e2bcd8739ae039),
    (0, $ed7188caee9f09fc$export$2e2bcd8739ae039),
    (0, $3f7aca29b1a55496$export$2e2bcd8739ae039)
];
$c2ac4be2a790a238$export$2e2bcd8739ae039.requiredContainer = $c2ac4be2a790a238$export$3b131632d3d15165;




const $a2626d0dc7de782b$var$config = {
    scope: (0, $569e748944e69916$export$775b6bb06e53a214).BLOCK,
    whitelist: [
        'rtl'
    ]
};
const $a2626d0dc7de782b$export$4158215dafad9efa = new (0, $569e748944e69916$export$217610c4183502d0)('direction', 'dir', $a2626d0dc7de782b$var$config);
const $a2626d0dc7de782b$export$630028b3af294dec = new (0, $569e748944e69916$export$651d45509677cf07)('direction', 'ql-direction', $a2626d0dc7de782b$var$config);
const $a2626d0dc7de782b$export$175979e518d1dfd1 = new (0, $569e748944e69916$export$7c8099bbfe87b94d)('direction', 'direction', $a2626d0dc7de782b$var$config);



const $2a028af46fe54a35$var$config = {
    scope: (0, $569e748944e69916$export$775b6bb06e53a214).INLINE,
    whitelist: [
        'serif',
        'monospace'
    ]
};
const $2a028af46fe54a35$export$78a99ee601572ab = new (0, $569e748944e69916$export$651d45509677cf07)('font', 'ql-font', $2a028af46fe54a35$var$config);
class $2a028af46fe54a35$var$FontStyleAttributor extends (0, $569e748944e69916$export$7c8099bbfe87b94d) {
    value(node) {
        return super.value(node).replace(/["']/g, '');
    }
}
const $2a028af46fe54a35$export$23b468d4ca3f8c96 = new $2a028af46fe54a35$var$FontStyleAttributor('font', 'font-family', $2a028af46fe54a35$var$config);



const $f9040a7bf4f5573f$export$c84684d52bca9684 = new (0, $569e748944e69916$export$651d45509677cf07)('size', 'ql-size', {
    scope: (0, $569e748944e69916$export$775b6bb06e53a214).INLINE,
    whitelist: [
        'small',
        'large',
        'huge'
    ]
});
const $f9040a7bf4f5573f$export$5443b95a30e89ac5 = new (0, $569e748944e69916$export$7c8099bbfe87b94d)('size', 'font-size', {
    scope: (0, $569e748944e69916$export$775b6bb06e53a214).INLINE,
    whitelist: [
        '10px',
        '18px',
        '32px'
    ]
});








const $505caf055cb4e70c$var$debug = (0, $17c49cda18fab12a$export$2e2bcd8739ae039)('quill:keyboard');
const $505caf055cb4e70c$export$34a157fc58f3dd07 = /Mac/i.test(navigator.platform) ? 'metaKey' : 'ctrlKey';
class $505caf055cb4e70c$export$2e2bcd8739ae039 extends (0, $9dc68b38e283832b$export$2e2bcd8739ae039) {
    static match(evt, binding) {
        if ([
            'altKey',
            'ctrlKey',
            'metaKey',
            'shiftKey'
        ].some((key)=>{
            return !!binding[key] !== evt[key] && binding[key] !== null;
        })) return false;
        return binding.key === evt.key || binding.key === evt.which;
    }
    constructor(quill, options){
        super(quill, options);
        this.bindings = {};
        // @ts-expect-error Fix me later
        Object.keys(this.options.bindings).forEach((name)=>{
            // @ts-expect-error Fix me later
            if (this.options.bindings[name]) // @ts-expect-error Fix me later
            this.addBinding(this.options.bindings[name]);
        });
        this.addBinding({
            key: 'Enter',
            shiftKey: null
        }, this.handleEnter);
        this.addBinding({
            key: 'Enter',
            metaKey: null,
            ctrlKey: null,
            altKey: null
        }, ()=>{});
        if (/Firefox/i.test(navigator.userAgent)) {
            // Need to handle delete and backspace for Firefox in the general case #1171
            this.addBinding({
                key: 'Backspace'
            }, {
                collapsed: true
            }, this.handleBackspace);
            this.addBinding({
                key: 'Delete'
            }, {
                collapsed: true
            }, this.handleDelete);
        } else {
            this.addBinding({
                key: 'Backspace'
            }, {
                collapsed: true,
                prefix: /^.?$/
            }, this.handleBackspace);
            this.addBinding({
                key: 'Delete'
            }, {
                collapsed: true,
                suffix: /^.?$/
            }, this.handleDelete);
        }
        this.addBinding({
            key: 'Backspace'
        }, {
            collapsed: false
        }, this.handleDeleteRange);
        this.addBinding({
            key: 'Delete'
        }, {
            collapsed: false
        }, this.handleDeleteRange);
        this.addBinding({
            key: 'Backspace',
            altKey: null,
            ctrlKey: null,
            metaKey: null,
            shiftKey: null
        }, {
            collapsed: true,
            offset: 0
        }, this.handleBackspace);
        this.listen();
    }
    addBinding(keyBinding) {
        let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const binding = $505caf055cb4e70c$export$a3295358bff77e(keyBinding);
        if (binding == null) {
            $505caf055cb4e70c$var$debug.warn('Attempted to add invalid keyboard binding', binding);
            return;
        }
        if (typeof context === 'function') context = {
            handler: context
        };
        if (typeof handler === 'function') handler = {
            handler: handler
        };
        const keys = Array.isArray(binding.key) ? binding.key : [
            binding.key
        ];
        keys.forEach((key)=>{
            const singleBinding = {
                ...binding,
                key: key,
                ...context,
                ...handler
            };
            this.bindings[singleBinding.key] = this.bindings[singleBinding.key] || [];
            this.bindings[singleBinding.key].push(singleBinding);
        });
    }
    listen() {
        this.quill.root.addEventListener('keydown', (evt)=>{
            if (evt.defaultPrevented || evt.isComposing) return;
            // evt.isComposing is false when pressing Enter/Backspace when composing in Safari
            // https://bugs.webkit.org/show_bug.cgi?id=165004
            const isComposing = evt.keyCode === 229 && (evt.key === 'Enter' || evt.key === 'Backspace');
            if (isComposing) return;
            const bindings = (this.bindings[evt.key] || []).concat(this.bindings[evt.which] || []);
            const matches = bindings.filter((binding)=>$505caf055cb4e70c$export$2e2bcd8739ae039.match(evt, binding));
            if (matches.length === 0) return;
            // @ts-expect-error
            const blot = (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).find(evt.target, true);
            if (blot && blot.scroll !== this.quill.scroll) return;
            const range = this.quill.getSelection();
            if (range == null || !this.quill.hasFocus()) return;
            const [line, offset] = this.quill.getLine(range.index);
            const [leafStart, offsetStart] = this.quill.getLeaf(range.index);
            const [leafEnd, offsetEnd] = range.length === 0 ? [
                leafStart,
                offsetStart
            ] : this.quill.getLeaf(range.index + range.length);
            const prefixText = leafStart instanceof (0, $569e748944e69916$export$10ac0c5716409de6) ? leafStart.value().slice(0, offsetStart) : '';
            const suffixText = leafEnd instanceof (0, $569e748944e69916$export$10ac0c5716409de6) ? leafEnd.value().slice(offsetEnd) : '';
            const curContext = {
                collapsed: range.length === 0,
                // @ts-expect-error Fix me later
                empty: range.length === 0 && line.length() <= 1,
                format: this.quill.getFormat(range),
                line: line,
                offset: offset,
                prefix: prefixText,
                suffix: suffixText,
                event: evt
            };
            const prevented = matches.some((binding)=>{
                if (binding.collapsed != null && binding.collapsed !== curContext.collapsed) return false;
                if (binding.empty != null && binding.empty !== curContext.empty) return false;
                if (binding.offset != null && binding.offset !== curContext.offset) return false;
                if (Array.isArray(binding.format)) {
                    // any format is present
                    if (binding.format.every((name)=>curContext.format[name] == null)) return false;
                } else if (typeof binding.format === 'object') {
                    // all formats must match
                    if (!Object.keys(binding.format).every((name)=>{
                        // @ts-expect-error Fix me later
                        if (binding.format[name] === true) return curContext.format[name] != null;
                        // @ts-expect-error Fix me later
                        if (binding.format[name] === false) return curContext.format[name] == null;
                        // @ts-expect-error Fix me later
                        return (0, $b3a13963d3f219f8$export$2e2bcd8739ae039)(binding.format[name], curContext.format[name]);
                    })) return false;
                }
                if (binding.prefix != null && !binding.prefix.test(curContext.prefix)) return false;
                if (binding.suffix != null && !binding.suffix.test(curContext.suffix)) return false;
                // @ts-expect-error Fix me later
                return binding.handler.call(this, range, curContext, binding) !== true;
            });
            if (prevented) evt.preventDefault();
        });
    }
    handleBackspace(range, context) {
        // Check for astral symbols
        const length = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(context.prefix) ? 2 : 1;
        if (range.index === 0 || this.quill.getLength() <= 1) return;
        let formats = {};
        const [line] = this.quill.getLine(range.index);
        let delta = new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))().retain(range.index - length).delete(length);
        if (context.offset === 0) {
            // Always deleting newline here, length always 1
            const [prev] = this.quill.getLine(range.index - 1);
            if (prev) {
                const isPrevLineEmpty = prev.statics.blotName === 'block' && prev.length() <= 1;
                if (!isPrevLineEmpty) {
                    // @ts-expect-error Fix me later
                    const curFormats = line.formats();
                    const prevFormats = this.quill.getFormat(range.index - 1, 1);
                    formats = (0, $88e60522c01c2553$exports.AttributeMap).diff(curFormats, prevFormats) || {};
                    if (Object.keys(formats).length > 0) {
                        // line.length() - 1 targets \n in line, another -1 for newline being deleted
                        const formatDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))()// @ts-expect-error Fix me later
                        .retain(range.index + line.length() - 2).retain(1, formats);
                        delta = delta.compose(formatDelta);
                    }
                }
            }
        }
        this.quill.updateContents(delta, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
        this.quill.focus();
    }
    handleDelete(range, context) {
        // Check for astral symbols
        const length = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(context.suffix) ? 2 : 1;
        if (range.index >= this.quill.getLength() - length) return;
        let formats = {};
        const [line] = this.quill.getLine(range.index);
        let delta = new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))().retain(range.index).delete(length);
        // @ts-expect-error Fix me later
        if (context.offset >= line.length() - 1) {
            const [next] = this.quill.getLine(range.index + 1);
            if (next) {
                // @ts-expect-error Fix me later
                const curFormats = line.formats();
                const nextFormats = this.quill.getFormat(range.index, 1);
                formats = (0, $88e60522c01c2553$exports.AttributeMap).diff(curFormats, nextFormats) || {};
                if (Object.keys(formats).length > 0) delta = delta.retain(next.length() - 1).retain(1, formats);
            }
        }
        this.quill.updateContents(delta, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
        this.quill.focus();
    }
    handleDeleteRange(range) {
        $505caf055cb4e70c$export$a6c813797f379898({
            range: range,
            quill: this.quill
        });
        this.quill.focus();
    }
    handleEnter(range, context) {
        const lineFormats = Object.keys(context.format).reduce((formats, format)=>{
            if (this.quill.scroll.query(format, (0, $569e748944e69916$export$775b6bb06e53a214).BLOCK) && !Array.isArray(context.format[format])) formats[format] = context.format[format];
            return formats;
        }, {});
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))().retain(range.index).delete(range.length).insert('\n', lineFormats);
        this.quill.updateContents(delta, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
        this.quill.setSelection(range.index + 1, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.SILENT);
        this.quill.focus();
    }
}
const $505caf055cb4e70c$var$defaultOptions = {
    bindings: {
        bold: $505caf055cb4e70c$var$makeFormatHandler('bold'),
        italic: $505caf055cb4e70c$var$makeFormatHandler('italic'),
        underline: $505caf055cb4e70c$var$makeFormatHandler('underline'),
        indent: {
            // highlight tab or tab at beginning of list, indent or blockquote
            key: 'Tab',
            format: [
                'blockquote',
                'indent',
                'list'
            ],
            handler (range, context) {
                if (context.collapsed && context.offset !== 0) return true;
                this.quill.format('indent', '+1', (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
                return false;
            }
        },
        outdent: {
            key: 'Tab',
            shiftKey: true,
            format: [
                'blockquote',
                'indent',
                'list'
            ],
            // highlight tab or tab at beginning of list, indent or blockquote
            handler (range, context) {
                if (context.collapsed && context.offset !== 0) return true;
                this.quill.format('indent', '-1', (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
                return false;
            }
        },
        'outdent backspace': {
            key: 'Backspace',
            collapsed: true,
            shiftKey: null,
            metaKey: null,
            ctrlKey: null,
            altKey: null,
            format: [
                'indent',
                'list'
            ],
            offset: 0,
            handler (range, context) {
                if (context.format.indent != null) this.quill.format('indent', '-1', (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
                else if (context.format.list != null) this.quill.format('list', false, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
            }
        },
        'indent code-block': $505caf055cb4e70c$var$makeCodeBlockHandler(true),
        'outdent code-block': $505caf055cb4e70c$var$makeCodeBlockHandler(false),
        'remove tab': {
            key: 'Tab',
            shiftKey: true,
            collapsed: true,
            prefix: /\t$/,
            handler (range) {
                this.quill.deleteText(range.index - 1, 1, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
            }
        },
        tab: {
            key: 'Tab',
            handler (range, context) {
                if (context.format.table) return true;
                this.quill.history.cutoff();
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))().retain(range.index).delete(range.length).insert('\t');
                this.quill.updateContents(delta, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
                this.quill.history.cutoff();
                this.quill.setSelection(range.index + 1, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.SILENT);
                return false;
            }
        },
        'blockquote empty enter': {
            key: 'Enter',
            collapsed: true,
            format: [
                'blockquote'
            ],
            empty: true,
            handler () {
                this.quill.format('blockquote', false, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
            }
        },
        'list empty enter': {
            key: 'Enter',
            collapsed: true,
            format: [
                'list'
            ],
            empty: true,
            handler (range, context) {
                const formats = {
                    list: false
                };
                if (context.format.indent) formats.indent = false;
                this.quill.formatLine(range.index, range.length, formats, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
            }
        },
        'checklist enter': {
            key: 'Enter',
            collapsed: true,
            format: {
                list: 'checked'
            },
            handler (range) {
                const [line, offset] = this.quill.getLine(range.index);
                const formats = {
                    // @ts-expect-error Fix me later
                    ...line.formats(),
                    list: 'checked'
                };
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))().retain(range.index).insert('\n', formats)// @ts-expect-error Fix me later
                .retain(line.length() - offset - 1).retain(1, {
                    list: 'unchecked'
                });
                this.quill.updateContents(delta, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
                this.quill.setSelection(range.index + 1, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.SILENT);
                this.quill.scrollSelectionIntoView();
            }
        },
        'header enter': {
            key: 'Enter',
            collapsed: true,
            format: [
                'header'
            ],
            suffix: /^$/,
            handler (range, context) {
                const [line, offset] = this.quill.getLine(range.index);
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))().retain(range.index).insert('\n', context.format)// @ts-expect-error Fix me later
                .retain(line.length() - offset - 1).retain(1, {
                    header: null
                });
                this.quill.updateContents(delta, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
                this.quill.setSelection(range.index + 1, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.SILENT);
                this.quill.scrollSelectionIntoView();
            }
        },
        'table backspace': {
            key: 'Backspace',
            format: [
                'table'
            ],
            collapsed: true,
            offset: 0,
            handler () {}
        },
        'table delete': {
            key: 'Delete',
            format: [
                'table'
            ],
            collapsed: true,
            suffix: /^$/,
            handler () {}
        },
        'table enter': {
            key: 'Enter',
            shiftKey: null,
            format: [
                'table'
            ],
            handler (range) {
                const module = this.quill.getModule('table');
                if (module) {
                    // @ts-expect-error
                    const [table, row, cell, offset] = module.getTable(range);
                    const shift = $505caf055cb4e70c$var$tableSide(table, row, cell, offset);
                    if (shift == null) return;
                    let index = table.offset();
                    if (shift < 0) {
                        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))().retain(index).insert('\n');
                        this.quill.updateContents(delta, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
                        this.quill.setSelection(range.index + 1, range.length, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.SILENT);
                    } else if (shift > 0) {
                        index += table.length();
                        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))().retain(index).insert('\n');
                        this.quill.updateContents(delta, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
                        this.quill.setSelection(index, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
                    }
                }
            }
        },
        'table tab': {
            key: 'Tab',
            shiftKey: null,
            format: [
                'table'
            ],
            handler (range, context) {
                const { event: event, line: cell } = context;
                const offset = cell.offset(this.quill.scroll);
                if (event.shiftKey) this.quill.setSelection(offset - 1, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
                else this.quill.setSelection(offset + cell.length(), (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
            }
        },
        'list autofill': {
            key: ' ',
            shiftKey: null,
            collapsed: true,
            format: {
                'code-block': false,
                blockquote: false,
                table: false
            },
            prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
            handler (range, context) {
                if (this.quill.scroll.query('list') == null) return true;
                const { length: length } = context.prefix;
                const [line, offset] = this.quill.getLine(range.index);
                if (offset > length) return true;
                let value;
                switch(context.prefix.trim()){
                    case '[]':
                    case '[ ]':
                        value = 'unchecked';
                        break;
                    case '[x]':
                        value = 'checked';
                        break;
                    case '-':
                    case '*':
                        value = 'bullet';
                        break;
                    default:
                        value = 'ordered';
                }
                this.quill.insertText(range.index, ' ', (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
                this.quill.history.cutoff();
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))().retain(range.index - offset).delete(length + 1)// @ts-expect-error Fix me later
                .retain(line.length() - 2 - offset).retain(1, {
                    list: value
                });
                this.quill.updateContents(delta, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
                this.quill.history.cutoff();
                this.quill.setSelection(range.index - length, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.SILENT);
                return false;
            }
        },
        'code exit': {
            key: 'Enter',
            collapsed: true,
            format: [
                'code-block'
            ],
            prefix: /^$/,
            suffix: /^\s*$/,
            handler (range) {
                const [line, offset] = this.quill.getLine(range.index);
                let numLines = 2;
                let cur = line;
                while(cur != null && cur.length() <= 1 && cur.formats()['code-block']){
                    // @ts-expect-error
                    cur = cur.prev;
                    numLines -= 1;
                    // Requisite prev lines are empty
                    if (numLines <= 0) {
                        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))()// @ts-expect-error Fix me later
                        .retain(range.index + line.length() - offset - 2).retain(1, {
                            'code-block': null
                        }).delete(1);
                        this.quill.updateContents(delta, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
                        this.quill.setSelection(range.index - 1, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.SILENT);
                        return false;
                    }
                }
                return true;
            }
        },
        'embed left': $505caf055cb4e70c$var$makeEmbedArrowHandler('ArrowLeft', false),
        'embed left shift': $505caf055cb4e70c$var$makeEmbedArrowHandler('ArrowLeft', true),
        'embed right': $505caf055cb4e70c$var$makeEmbedArrowHandler('ArrowRight', false),
        'embed right shift': $505caf055cb4e70c$var$makeEmbedArrowHandler('ArrowRight', true),
        'table down': $505caf055cb4e70c$var$makeTableArrowHandler(false),
        'table up': $505caf055cb4e70c$var$makeTableArrowHandler(true)
    }
};
$505caf055cb4e70c$export$2e2bcd8739ae039.DEFAULTS = $505caf055cb4e70c$var$defaultOptions;
function $505caf055cb4e70c$var$makeCodeBlockHandler(indent) {
    return {
        key: 'Tab',
        shiftKey: !indent,
        format: {
            'code-block': true
        },
        handler (range, _ref) {
            let { event: event } = _ref;
            const CodeBlock = this.quill.scroll.query('code-block');
            // @ts-expect-error
            const { TAB: TAB } = CodeBlock;
            if (range.length === 0 && !event.shiftKey) {
                this.quill.insertText(range.index, TAB, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
                this.quill.setSelection(range.index + TAB.length, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.SILENT);
                return;
            }
            const lines = range.length === 0 ? this.quill.getLines(range.index, 1) : this.quill.getLines(range);
            let { index: index, length: length } = range;
            lines.forEach((line, i)=>{
                if (indent) {
                    line.insertAt(0, TAB);
                    if (i === 0) index += TAB.length;
                    else length += TAB.length;
                // @ts-expect-error Fix me later
                } else if (line.domNode.textContent.startsWith(TAB)) {
                    line.deleteAt(0, TAB.length);
                    if (i === 0) index -= TAB.length;
                    else length -= TAB.length;
                }
            });
            this.quill.update((0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
            this.quill.setSelection(index, length, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.SILENT);
        }
    };
}
function $505caf055cb4e70c$var$makeEmbedArrowHandler(key, shiftKey) {
    const where = key === 'ArrowLeft' ? 'prefix' : 'suffix';
    return {
        key: key,
        shiftKey: shiftKey,
        altKey: null,
        [where]: /^$/,
        handler (range) {
            let { index: index } = range;
            if (key === 'ArrowRight') index += range.length + 1;
            const [leaf] = this.quill.getLeaf(index);
            if (!(leaf instanceof (0, $569e748944e69916$export$297a1fa96f55f00f))) return true;
            if (key === 'ArrowLeft') {
                if (shiftKey) this.quill.setSelection(range.index - 1, range.length + 1, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
                else this.quill.setSelection(range.index - 1, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
            } else if (shiftKey) this.quill.setSelection(range.index, range.length + 1, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
            else this.quill.setSelection(range.index + range.length + 1, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
            return false;
        }
    };
}
function $505caf055cb4e70c$var$makeFormatHandler(format) {
    return {
        key: format[0],
        shortKey: true,
        handler (range, context) {
            this.quill.format(format, !context.format[format], (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
        }
    };
}
function $505caf055cb4e70c$var$makeTableArrowHandler(up) {
    return {
        key: up ? 'ArrowUp' : 'ArrowDown',
        collapsed: true,
        format: [
            'table'
        ],
        handler (range, context) {
            // TODO move to table module
            const key = up ? 'prev' : 'next';
            const cell = context.line;
            const targetRow = cell.parent[key];
            if (targetRow != null) {
                if (targetRow.statics.blotName === 'table-row') {
                    // @ts-expect-error
                    let targetCell = targetRow.children.head;
                    let cur = cell;
                    while(cur.prev != null){
                        // @ts-expect-error
                        cur = cur.prev;
                        targetCell = targetCell.next;
                    }
                    const index = targetCell.offset(this.quill.scroll) + Math.min(context.offset, targetCell.length() - 1);
                    this.quill.setSelection(index, 0, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
                }
            } else {
                // @ts-expect-error
                const targetLine = cell.table()[key];
                if (targetLine != null) {
                    if (up) this.quill.setSelection(targetLine.offset(this.quill.scroll) + targetLine.length() - 1, 0, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
                    else this.quill.setSelection(targetLine.offset(this.quill.scroll), 0, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
                }
            }
            return false;
        }
    };
}
function $505caf055cb4e70c$export$a3295358bff77e(binding) {
    if (typeof binding === 'string' || typeof binding === 'number') binding = {
        key: binding
    };
    else if (typeof binding === 'object') binding = (0, $56054693bbe43fe9$export$2e2bcd8739ae039)(binding);
    else return null;
    if (binding.shortKey) {
        binding[$505caf055cb4e70c$export$34a157fc58f3dd07] = binding.shortKey;
        delete binding.shortKey;
    }
    return binding;
}
// TODO: Move into quill.ts or editor.ts
function $505caf055cb4e70c$export$a6c813797f379898(_ref2) {
    let { quill: quill, range: range } = _ref2;
    const lines = quill.getLines(range);
    let formats = {};
    if (lines.length > 1) {
        const firstFormats = lines[0].formats();
        const lastFormats = lines[lines.length - 1].formats();
        formats = (0, $88e60522c01c2553$exports.AttributeMap).diff(lastFormats, firstFormats) || {};
    }
    quill.deleteText(range, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
    if (Object.keys(formats).length > 0) quill.formatLine(range.index, 1, formats, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
    quill.setSelection(range.index, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.SILENT);
}
function $505caf055cb4e70c$var$tableSide(_table, row, cell, offset) {
    if (row.prev == null && row.next == null) {
        if (cell.prev == null && cell.next == null) return offset === 0 ? -1 : 1;
        return cell.prev == null ? -1 : 1;
    }
    if (row.prev == null) return -1;
    if (row.next == null) return 1;
    return null;
}


const $08f7db12a6e27946$var$normalWeightRegexp = /font-weight:\s*normal/;
const $08f7db12a6e27946$var$blockTagNames = [
    'P',
    'OL',
    'UL'
];
const $08f7db12a6e27946$var$isBlockElement = (element)=>{
    return element && $08f7db12a6e27946$var$blockTagNames.includes(element.tagName);
};
const $08f7db12a6e27946$var$normalizeEmptyLines = (doc)=>{
    Array.from(doc.querySelectorAll('br')).filter((br)=>$08f7db12a6e27946$var$isBlockElement(br.previousElementSibling) && $08f7db12a6e27946$var$isBlockElement(br.nextElementSibling)).forEach((br)=>{
        br.parentNode?.removeChild(br);
    });
};
const $08f7db12a6e27946$var$normalizeFontWeight = (doc)=>{
    Array.from(doc.querySelectorAll('b[style*="font-weight"]')).filter((node)=>node.getAttribute('style')?.match($08f7db12a6e27946$var$normalWeightRegexp)).forEach((node)=>{
        const fragment = doc.createDocumentFragment();
        fragment.append(...node.childNodes);
        node.parentNode?.replaceChild(fragment, node);
    });
};
function $08f7db12a6e27946$export$2e2bcd8739ae039(doc) {
    if (doc.querySelector('[id^="docs-internal-guid-"]')) {
        $08f7db12a6e27946$var$normalizeFontWeight(doc);
        $08f7db12a6e27946$var$normalizeEmptyLines(doc);
    }
}


const $8afb94e531a81d67$var$ignoreRegexp = /\bmso-list:[^;]*ignore/i;
const $8afb94e531a81d67$var$idRegexp = /\bmso-list:[^;]*\bl(\d+)/i;
const $8afb94e531a81d67$var$indentRegexp = /\bmso-list:[^;]*\blevel(\d+)/i;
const $8afb94e531a81d67$var$parseListItem = (element, html)=>{
    const style = element.getAttribute('style');
    const idMatch = style?.match($8afb94e531a81d67$var$idRegexp);
    if (!idMatch) return null;
    const id = Number(idMatch[1]);
    const indentMatch = style?.match($8afb94e531a81d67$var$indentRegexp);
    const indent = indentMatch ? Number(indentMatch[1]) : 1;
    const typeRegexp = new RegExp(`@list l${id}:level${indent}\\s*\\{[^\\}]*mso-level-number-format:\\s*([\\w-]+)`, 'i');
    const typeMatch = html.match(typeRegexp);
    const type = typeMatch && typeMatch[1] === 'bullet' ? 'bullet' : 'ordered';
    return {
        id: id,
        indent: indent,
        type: type,
        element: element
    };
};
// list items are represented as `p` tags with styles like `mso-list: l0 level1` where:
// 1. "0" in "l0" means the list item id;
// 2. "1" in "level1" means the indent level, starting from 1.
const $8afb94e531a81d67$var$normalizeListItem = (doc)=>{
    const msoList = Array.from(doc.querySelectorAll('[style*=mso-list]'));
    const ignored = [];
    const others = [];
    msoList.forEach((node)=>{
        const shouldIgnore = (node.getAttribute('style') || '').match($8afb94e531a81d67$var$ignoreRegexp);
        if (shouldIgnore) ignored.push(node);
        else others.push(node);
    });
    // Each list item contains a marker wrapped with "mso-list: Ignore".
    ignored.forEach((node)=>node.parentNode?.removeChild(node));
    // The list stype is not defined inline with the tag, instead, it's in the
    // style tag so we need to pass the html as a string.
    const html = doc.documentElement.innerHTML;
    const listItems = others.map((element)=>$8afb94e531a81d67$var$parseListItem(element, html)).filter((parsed)=>parsed);
    while(listItems.length){
        const childListItems = [];
        let current = listItems.shift();
        // Group continuous items into the same group (aka "ul")
        while(current){
            childListItems.push(current);
            current = listItems.length && listItems[0]?.element === current.element.nextElementSibling && // Different id means the next item doesn't belong to this group.
            listItems[0].id === current.id ? listItems.shift() : null;
        }
        const ul = document.createElement('ul');
        childListItems.forEach((listItem)=>{
            const li = document.createElement('li');
            li.setAttribute('data-list', listItem.type);
            if (listItem.indent > 1) li.setAttribute('class', `ql-indent-${listItem.indent - 1}`);
            li.innerHTML = listItem.element.innerHTML;
            ul.appendChild(li);
        });
        const element = childListItems[0]?.element;
        const { parentNode: parentNode } = element ?? {};
        if (element) parentNode?.replaceChild(ul, element);
        childListItems.slice(1).forEach((_ref)=>{
            let { element: e } = _ref;
            parentNode?.removeChild(e);
        });
    }
};
function $8afb94e531a81d67$export$2e2bcd8739ae039(doc) {
    if (doc.documentElement.getAttribute('xmlns:w') === 'urn:schemas-microsoft-com:office:word') $8afb94e531a81d67$var$normalizeListItem(doc);
}


const $e3c88f90cb1d70a7$var$NORMALIZERS = [
    (0, $8afb94e531a81d67$export$2e2bcd8739ae039),
    (0, $08f7db12a6e27946$export$2e2bcd8739ae039)
];
const $e3c88f90cb1d70a7$var$normalizeExternalHTML = (doc)=>{
    if (doc.documentElement) $e3c88f90cb1d70a7$var$NORMALIZERS.forEach((normalize)=>{
        normalize(doc);
    });
};
var $e3c88f90cb1d70a7$export$2e2bcd8739ae039 = $e3c88f90cb1d70a7$var$normalizeExternalHTML;


const $7d186ec37584d3f8$var$debug = (0, $17c49cda18fab12a$export$2e2bcd8739ae039)('quill:clipboard');
const $7d186ec37584d3f8$var$CLIPBOARD_CONFIG = [
    [
        Node.TEXT_NODE,
        $7d186ec37584d3f8$export$9b884371b5570711
    ],
    [
        Node.TEXT_NODE,
        $7d186ec37584d3f8$export$c695b9637111f586
    ],
    [
        'br',
        $7d186ec37584d3f8$var$matchBreak
    ],
    [
        Node.ELEMENT_NODE,
        $7d186ec37584d3f8$export$c695b9637111f586
    ],
    [
        Node.ELEMENT_NODE,
        $7d186ec37584d3f8$export$e9719de873a22c03
    ],
    [
        Node.ELEMENT_NODE,
        $7d186ec37584d3f8$export$7da59a717dc94488
    ],
    [
        Node.ELEMENT_NODE,
        $7d186ec37584d3f8$var$matchStyles
    ],
    [
        'li',
        $7d186ec37584d3f8$var$matchIndent
    ],
    [
        'ol, ul',
        $7d186ec37584d3f8$var$matchList
    ],
    [
        'pre',
        $7d186ec37584d3f8$var$matchCodeBlock
    ],
    [
        'tr',
        $7d186ec37584d3f8$var$matchTable
    ],
    [
        'b',
        $7d186ec37584d3f8$var$createMatchAlias('bold')
    ],
    [
        'i',
        $7d186ec37584d3f8$var$createMatchAlias('italic')
    ],
    [
        'strike',
        $7d186ec37584d3f8$var$createMatchAlias('strike')
    ],
    [
        'style',
        $7d186ec37584d3f8$var$matchIgnore
    ]
];
const $7d186ec37584d3f8$var$ATTRIBUTE_ATTRIBUTORS = [
    (0, $46becb55ac73c7d6$export$2ef0f9fb04a51388),
    (0, $a2626d0dc7de782b$export$4158215dafad9efa)
].reduce((memo, attr)=>{
    memo[attr.keyName] = attr;
    return memo;
}, {});
const $7d186ec37584d3f8$var$STYLE_ATTRIBUTORS = [
    (0, $46becb55ac73c7d6$export$d2060f5d114c9fe8),
    (0, $2f71c8f40f0309fa$export$dc1cbcab4c682ef),
    (0, $73f85d61d1cfa261$export$1415f56796d9a5a9),
    (0, $a2626d0dc7de782b$export$175979e518d1dfd1),
    (0, $2a028af46fe54a35$export$23b468d4ca3f8c96),
    (0, $f9040a7bf4f5573f$export$5443b95a30e89ac5)
].reduce((memo, attr)=>{
    memo[attr.keyName] = attr;
    return memo;
}, {});
class $7d186ec37584d3f8$export$2e2bcd8739ae039 extends (0, $9dc68b38e283832b$export$2e2bcd8739ae039) {
    static DEFAULTS = {
        matchers: []
    };
    constructor(quill, options){
        super(quill, options);
        this.quill.root.addEventListener('copy', (e)=>this.onCaptureCopy(e, false));
        this.quill.root.addEventListener('cut', (e)=>this.onCaptureCopy(e, true));
        this.quill.root.addEventListener('paste', this.onCapturePaste.bind(this));
        this.matchers = [];
        $7d186ec37584d3f8$var$CLIPBOARD_CONFIG.concat(this.options.matchers ?? []).forEach((_ref)=>{
            let [selector, matcher] = _ref;
            this.addMatcher(selector, matcher);
        });
    }
    addMatcher(selector, matcher) {
        this.matchers.push([
            selector,
            matcher
        ]);
    }
    convert(_ref2) {
        let { html: html, text: text } = _ref2;
        let formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (formats[(0, $c2ac4be2a790a238$export$2e2bcd8739ae039).blotName]) return new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))().insert(text || '', {
            [(0, $c2ac4be2a790a238$export$2e2bcd8739ae039).blotName]: formats[(0, $c2ac4be2a790a238$export$2e2bcd8739ae039).blotName]
        });
        if (!html) return new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))().insert(text || '', formats);
        const delta = this.convertHTML(html);
        // Remove trailing newline
        if ($7d186ec37584d3f8$var$deltaEndsWith(delta, '\n') && (delta.ops[delta.ops.length - 1].attributes == null || formats.table)) return delta.compose(new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))().retain(delta.length() - 1).delete(1));
        return delta;
    }
    normalizeHTML(doc) {
        (0, $e3c88f90cb1d70a7$export$2e2bcd8739ae039)(doc);
    }
    convertHTML(html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        this.normalizeHTML(doc);
        const container = doc.body;
        const nodeMatches = new WeakMap();
        const [elementMatchers, textMatchers] = this.prepareMatching(container, nodeMatches);
        return $7d186ec37584d3f8$export$df3f009e3d155b20(this.quill.scroll, container, elementMatchers, textMatchers, nodeMatches);
    }
    dangerouslyPasteHTML(index, html) {
        let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.API;
        if (typeof index === 'string') {
            const delta = this.convert({
                html: index,
                text: ''
            });
            // @ts-expect-error
            this.quill.setContents(delta, html);
            this.quill.setSelection(0, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.SILENT);
        } else {
            const paste = this.convert({
                html: html,
                text: ''
            });
            this.quill.updateContents(new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))().retain(index).concat(paste), source);
            this.quill.setSelection(index + paste.length(), (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.SILENT);
        }
    }
    onCaptureCopy(e) {
        let isCut = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (e.defaultPrevented) return;
        e.preventDefault();
        const [range] = this.quill.selection.getRange();
        if (range == null) return;
        const { html: html, text: text } = this.onCopy(range, isCut);
        e.clipboardData?.setData('text/plain', text);
        e.clipboardData?.setData('text/html', html);
        if (isCut) (0, $505caf055cb4e70c$export$a6c813797f379898)({
            range: range,
            quill: this.quill
        });
    }
    /*
   * https://www.iana.org/assignments/media-types/text/uri-list
   */ normalizeURIList(urlList) {
        return urlList.split(/\r?\n/)// Ignore all comments
        .filter((url)=>url[0] !== '#').join('\n');
    }
    onCapturePaste(e) {
        if (e.defaultPrevented || !this.quill.isEnabled()) return;
        e.preventDefault();
        const range = this.quill.getSelection(true);
        if (range == null) return;
        const html = e.clipboardData?.getData('text/html');
        let text = e.clipboardData?.getData('text/plain');
        if (!html && !text) {
            const urlList = e.clipboardData?.getData('text/uri-list');
            if (urlList) text = this.normalizeURIList(urlList);
        }
        const files = Array.from(e.clipboardData?.files || []);
        if (!html && files.length > 0) {
            this.quill.uploader.upload(range, files);
            return;
        }
        if (html && files.length > 0) {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            if (doc.body.childElementCount === 1 && doc.body.firstElementChild?.tagName === 'IMG') {
                this.quill.uploader.upload(range, files);
                return;
            }
        }
        this.onPaste(range, {
            html: html,
            text: text
        });
    }
    onCopy(range) {
        const text = this.quill.getText(range);
        const html = this.quill.getSemanticHTML(range);
        return {
            html: html,
            text: text
        };
    }
    onPaste(range, _ref3) {
        let { text: text, html: html } = _ref3;
        const formats = this.quill.getFormat(range.index);
        const pastedDelta = this.convert({
            text: text,
            html: html
        }, formats);
        $7d186ec37584d3f8$var$debug.log('onPaste', pastedDelta, {
            text: text,
            html: html
        });
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))().retain(range.index).delete(range.length).concat(pastedDelta);
        this.quill.updateContents(delta, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
        // range.length contributes to delta.length()
        this.quill.setSelection(delta.length() - range.length, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.SILENT);
        this.quill.scrollSelectionIntoView();
    }
    prepareMatching(container, nodeMatches) {
        const elementMatchers = [];
        const textMatchers = [];
        this.matchers.forEach((pair)=>{
            const [selector, matcher] = pair;
            switch(selector){
                case Node.TEXT_NODE:
                    textMatchers.push(matcher);
                    break;
                case Node.ELEMENT_NODE:
                    elementMatchers.push(matcher);
                    break;
                default:
                    Array.from(container.querySelectorAll(selector)).forEach((node)=>{
                        if (nodeMatches.has(node)) {
                            const matches = nodeMatches.get(node);
                            matches?.push(matcher);
                        } else nodeMatches.set(node, [
                            matcher
                        ]);
                    });
                    break;
            }
        });
        return [
            elementMatchers,
            textMatchers
        ];
    }
}
function $7d186ec37584d3f8$var$applyFormat(delta, format, value, scroll) {
    if (!scroll.query(format)) return delta;
    return delta.reduce((newDelta, op)=>{
        if (!op.insert) return newDelta;
        if (op.attributes && op.attributes[format]) return newDelta.push(op);
        const formats = value ? {
            [format]: value
        } : {};
        return newDelta.insert(op.insert, {
            ...formats,
            ...op.attributes
        });
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))());
}
function $7d186ec37584d3f8$var$deltaEndsWith(delta, text) {
    let endText = '';
    for(let i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i // eslint-disable-line no-plusplus
    ){
        const op = delta.ops[i];
        if (typeof op.insert !== 'string') break;
        endText = op.insert + endText;
    }
    return endText.slice(-1 * text.length) === text;
}
function $7d186ec37584d3f8$var$isLine(node, scroll) {
    if (!(node instanceof Element)) return false;
    const match = scroll.query(node);
    // @ts-expect-error
    if (match && match.prototype instanceof (0, $569e748944e69916$export$297a1fa96f55f00f)) return false;
    return [
        'address',
        'article',
        'blockquote',
        'canvas',
        'dd',
        'div',
        'dl',
        'dt',
        'fieldset',
        'figcaption',
        'figure',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'header',
        'iframe',
        'li',
        'main',
        'nav',
        'ol',
        'output',
        'p',
        'pre',
        'section',
        'table',
        'td',
        'tr',
        'ul',
        'video'
    ].includes(node.tagName.toLowerCase());
}
function $7d186ec37584d3f8$var$isBetweenInlineElements(node, scroll) {
    return node.previousElementSibling && node.nextElementSibling && !$7d186ec37584d3f8$var$isLine(node.previousElementSibling, scroll) && !$7d186ec37584d3f8$var$isLine(node.nextElementSibling, scroll);
}
const $7d186ec37584d3f8$var$preNodes = new WeakMap();
function $7d186ec37584d3f8$var$isPre(node) {
    if (node == null) return false;
    if (!$7d186ec37584d3f8$var$preNodes.has(node)) {
        // @ts-expect-error
        if (node.tagName === 'PRE') $7d186ec37584d3f8$var$preNodes.set(node, true);
        else $7d186ec37584d3f8$var$preNodes.set(node, $7d186ec37584d3f8$var$isPre(node.parentNode));
    }
    return $7d186ec37584d3f8$var$preNodes.get(node);
}
function $7d186ec37584d3f8$export$df3f009e3d155b20(scroll, node, elementMatchers, textMatchers, nodeMatches) {
    // Post-order
    if (node.nodeType === node.TEXT_NODE) return textMatchers.reduce((delta, matcher)=>{
        return matcher(node, delta, scroll);
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))());
    if (node.nodeType === node.ELEMENT_NODE) return Array.from(node.childNodes || []).reduce((delta, childNode)=>{
        let childrenDelta = $7d186ec37584d3f8$export$df3f009e3d155b20(scroll, childNode, elementMatchers, textMatchers, nodeMatches);
        if (childNode.nodeType === node.ELEMENT_NODE) {
            childrenDelta = elementMatchers.reduce((reducedDelta, matcher)=>{
                return matcher(childNode, reducedDelta, scroll);
            }, childrenDelta);
            childrenDelta = (nodeMatches.get(childNode) || []).reduce((reducedDelta, matcher)=>{
                return matcher(childNode, reducedDelta, scroll);
            }, childrenDelta);
        }
        return delta.concat(childrenDelta);
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))());
    return new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))();
}
function $7d186ec37584d3f8$var$createMatchAlias(format) {
    return (_node, delta, scroll)=>{
        return $7d186ec37584d3f8$var$applyFormat(delta, format, true, scroll);
    };
}
function $7d186ec37584d3f8$export$7da59a717dc94488(node, delta, scroll) {
    const attributes = (0, $569e748944e69916$export$217610c4183502d0).keys(node);
    const classes = (0, $569e748944e69916$export$651d45509677cf07).keys(node);
    const styles = (0, $569e748944e69916$export$7c8099bbfe87b94d).keys(node);
    const formats = {};
    attributes.concat(classes).concat(styles).forEach((name)=>{
        let attr = scroll.query(name, (0, $569e748944e69916$export$775b6bb06e53a214).ATTRIBUTE);
        if (attr != null) {
            formats[attr.attrName] = attr.value(node);
            if (formats[attr.attrName]) return;
        }
        attr = $7d186ec37584d3f8$var$ATTRIBUTE_ATTRIBUTORS[name];
        if (attr != null && (attr.attrName === name || attr.keyName === name)) formats[attr.attrName] = attr.value(node) || undefined;
        attr = $7d186ec37584d3f8$var$STYLE_ATTRIBUTORS[name];
        if (attr != null && (attr.attrName === name || attr.keyName === name)) {
            attr = $7d186ec37584d3f8$var$STYLE_ATTRIBUTORS[name];
            formats[attr.attrName] = attr.value(node) || undefined;
        }
    });
    return Object.entries(formats).reduce((newDelta, _ref4)=>{
        let [name, value] = _ref4;
        return $7d186ec37584d3f8$var$applyFormat(newDelta, name, value, scroll);
    }, delta);
}
function $7d186ec37584d3f8$export$e9719de873a22c03(node, delta, scroll) {
    const match = scroll.query(node);
    if (match == null) return delta;
    // @ts-expect-error
    if (match.prototype instanceof (0, $569e748944e69916$export$297a1fa96f55f00f)) {
        const embed = {};
        // @ts-expect-error
        const value = match.value(node);
        if (value != null) {
            // @ts-expect-error
            embed[match.blotName] = value;
            // @ts-expect-error
            return new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))().insert(embed, match.formats(node, scroll));
        }
    } else {
        // @ts-expect-error
        if (match.prototype instanceof (0, $569e748944e69916$export$4f7f03641f7bfc8c) && !$7d186ec37584d3f8$var$deltaEndsWith(delta, '\n')) delta.insert('\n');
        if ('blotName' in match && 'formats' in match && typeof match.formats === 'function') return $7d186ec37584d3f8$var$applyFormat(delta, match.blotName, match.formats(node, scroll), scroll);
    }
    return delta;
}
function $7d186ec37584d3f8$var$matchBreak(node, delta) {
    if (!$7d186ec37584d3f8$var$deltaEndsWith(delta, '\n')) delta.insert('\n');
    return delta;
}
function $7d186ec37584d3f8$var$matchCodeBlock(node, delta, scroll) {
    const match = scroll.query('code-block');
    const language = match && 'formats' in match && typeof match.formats === 'function' ? match.formats(node, scroll) : true;
    return $7d186ec37584d3f8$var$applyFormat(delta, 'code-block', language, scroll);
}
function $7d186ec37584d3f8$var$matchIgnore() {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))();
}
function $7d186ec37584d3f8$var$matchIndent(node, delta, scroll) {
    const match = scroll.query(node);
    if (match == null || // @ts-expect-error
    match.blotName !== 'list' || !$7d186ec37584d3f8$var$deltaEndsWith(delta, '\n')) return delta;
    let indent = -1;
    let parent = node.parentNode;
    while(parent != null){
        // @ts-expect-error
        if ([
            'OL',
            'UL'
        ].includes(parent.tagName)) indent += 1;
        parent = parent.parentNode;
    }
    if (indent <= 0) return delta;
    return delta.reduce((composed, op)=>{
        if (!op.insert) return composed;
        if (op.attributes && typeof op.attributes.indent === 'number') return composed.push(op);
        return composed.insert(op.insert, {
            indent: indent,
            ...op.attributes || {}
        });
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))());
}
function $7d186ec37584d3f8$var$matchList(node, delta, scroll) {
    const element = node;
    let list = element.tagName === 'OL' ? 'ordered' : 'bullet';
    const checkedAttr = element.getAttribute('data-checked');
    if (checkedAttr) list = checkedAttr === 'true' ? 'checked' : 'unchecked';
    return $7d186ec37584d3f8$var$applyFormat(delta, 'list', list, scroll);
}
function $7d186ec37584d3f8$export$c695b9637111f586(node, delta, scroll) {
    if (!$7d186ec37584d3f8$var$deltaEndsWith(delta, '\n')) {
        if ($7d186ec37584d3f8$var$isLine(node, scroll) && (node.childNodes.length > 0 || node instanceof HTMLParagraphElement)) return delta.insert('\n');
        if (delta.length() > 0 && node.nextSibling) {
            let nextSibling = node.nextSibling;
            while(nextSibling != null){
                if ($7d186ec37584d3f8$var$isLine(nextSibling, scroll)) return delta.insert('\n');
                const match = scroll.query(nextSibling);
                // @ts-expect-error
                if (match && match.prototype instanceof (0, $85f480a53d3839c4$export$48b9f0688962d028)) return delta.insert('\n');
                nextSibling = nextSibling.firstChild;
            }
        }
    }
    return delta;
}
function $7d186ec37584d3f8$var$matchStyles(node, delta, scroll) {
    const formats = {};
    const style = node.style || {};
    if (style.fontStyle === 'italic') formats.italic = true;
    if (style.textDecoration === 'underline') formats.underline = true;
    if (style.textDecoration === 'line-through') formats.strike = true;
    if (style.fontWeight?.startsWith('bold') || // @ts-expect-error Fix me later
    parseInt(style.fontWeight, 10) >= 700) formats.bold = true;
    delta = Object.entries(formats).reduce((newDelta, _ref5)=>{
        let [name, value] = _ref5;
        return $7d186ec37584d3f8$var$applyFormat(newDelta, name, value, scroll);
    }, delta);
    // @ts-expect-error
    if (parseFloat(style.textIndent || 0) > 0) // Could be 0.5in
    return new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))().insert('\t').concat(delta);
    return delta;
}
function $7d186ec37584d3f8$var$matchTable(node, delta, scroll) {
    const table = node.parentElement?.tagName === 'TABLE' ? node.parentElement : node.parentElement?.parentElement;
    if (table != null) {
        const rows = Array.from(table.querySelectorAll('tr'));
        const row = rows.indexOf(node) + 1;
        return $7d186ec37584d3f8$var$applyFormat(delta, 'table', row, scroll);
    }
    return delta;
}
function $7d186ec37584d3f8$export$9b884371b5570711(node, delta, scroll) {
    // @ts-expect-error
    let text = node.data;
    // Word represents empty line with <o:p>&nbsp;</o:p>
    if (node.parentElement?.tagName === 'O:P') return delta.insert(text.trim());
    if (!$7d186ec37584d3f8$var$isPre(node)) {
        if (text.trim().length === 0 && text.includes('\n') && !$7d186ec37584d3f8$var$isBetweenInlineElements(node, scroll)) return delta;
        // convert all non-nbsp whitespace into regular space
        text = text.replace(/[^\S\u00a0]/g, ' ');
        // collapse consecutive spaces into one
        text = text.replace(/ {2,}/g, ' ');
        if (node.previousSibling == null && node.parentElement != null && $7d186ec37584d3f8$var$isLine(node.parentElement, scroll) || node.previousSibling instanceof Element && $7d186ec37584d3f8$var$isLine(node.previousSibling, scroll)) // block structure means we don't need leading space
        text = text.replace(/^ /, '');
        if (node.nextSibling == null && node.parentElement != null && $7d186ec37584d3f8$var$isLine(node.parentElement, scroll) || node.nextSibling instanceof Element && $7d186ec37584d3f8$var$isLine(node.nextSibling, scroll)) // block structure means we don't need trailing space
        text = text.replace(/ $/, '');
        // done removing whitespace and can normalize all to regular space
        text = text.replaceAll('\u00a0', ' ');
    }
    return delta.insert(text);
}





class $34d5b5283ccd1972$export$2e2bcd8739ae039 extends (0, $9dc68b38e283832b$export$2e2bcd8739ae039) {
    static DEFAULTS = {
        delay: 1000,
        maxStack: 100,
        userOnly: false
    };
    lastRecorded = 0;
    ignoreChange = false;
    stack = {
        undo: [],
        redo: []
    };
    currentRange = null;
    constructor(quill, options){
        super(quill, options);
        this.quill.on((0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).events.EDITOR_CHANGE, (eventName, value, oldValue, source)=>{
            if (eventName === (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).events.SELECTION_CHANGE) {
                if (value && source !== (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.SILENT) this.currentRange = value;
            } else if (eventName === (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).events.TEXT_CHANGE) {
                if (!this.ignoreChange) {
                    if (!this.options.userOnly || source === (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER) this.record(value, oldValue);
                    else this.transform(value);
                }
                this.currentRange = $34d5b5283ccd1972$var$transformRange(this.currentRange, value);
            }
        });
        this.quill.keyboard.addBinding({
            key: 'z',
            shortKey: true
        }, this.undo.bind(this));
        this.quill.keyboard.addBinding({
            key: [
                'z',
                'Z'
            ],
            shortKey: true,
            shiftKey: true
        }, this.redo.bind(this));
        if (/Win/i.test(navigator.platform)) this.quill.keyboard.addBinding({
            key: 'y',
            shortKey: true
        }, this.redo.bind(this));
        this.quill.root.addEventListener('beforeinput', (event)=>{
            if (event.inputType === 'historyUndo') {
                this.undo();
                event.preventDefault();
            } else if (event.inputType === 'historyRedo') {
                this.redo();
                event.preventDefault();
            }
        });
    }
    change(source, dest) {
        if (this.stack[source].length === 0) return;
        const item = this.stack[source].pop();
        if (!item) return;
        const base = this.quill.getContents();
        const inverseDelta = item.delta.invert(base);
        this.stack[dest].push({
            delta: inverseDelta,
            range: $34d5b5283ccd1972$var$transformRange(item.range, inverseDelta)
        });
        this.lastRecorded = 0;
        this.ignoreChange = true;
        this.quill.updateContents(item.delta, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
        this.ignoreChange = false;
        this.restoreSelection(item);
    }
    clear() {
        this.stack = {
            undo: [],
            redo: []
        };
    }
    cutoff() {
        this.lastRecorded = 0;
    }
    record(changeDelta, oldDelta) {
        if (changeDelta.ops.length === 0) return;
        this.stack.redo = [];
        let undoDelta = changeDelta.invert(oldDelta);
        let undoRange = this.currentRange;
        const timestamp = Date.now();
        if (// @ts-expect-error Fix me later
        this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
            const item = this.stack.undo.pop();
            if (item) {
                undoDelta = undoDelta.compose(item.delta);
                undoRange = item.range;
            }
        } else this.lastRecorded = timestamp;
        if (undoDelta.length() === 0) return;
        this.stack.undo.push({
            delta: undoDelta,
            range: undoRange
        });
        // @ts-expect-error Fix me later
        if (this.stack.undo.length > this.options.maxStack) this.stack.undo.shift();
    }
    redo() {
        this.change('redo', 'undo');
    }
    transform(delta) {
        $34d5b5283ccd1972$var$transformStack(this.stack.undo, delta);
        $34d5b5283ccd1972$var$transformStack(this.stack.redo, delta);
    }
    undo() {
        this.change('undo', 'redo');
    }
    restoreSelection(stackItem) {
        if (stackItem.range) this.quill.setSelection(stackItem.range, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
        else {
            const index = $34d5b5283ccd1972$export$64042f78dc41d29e(this.quill.scroll, stackItem.delta);
            this.quill.setSelection(index, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
        }
    }
}
function $34d5b5283ccd1972$var$transformStack(stack, delta) {
    let remoteDelta = delta;
    for(let i = stack.length - 1; i >= 0; i -= 1){
        const oldItem = stack[i];
        stack[i] = {
            delta: remoteDelta.transform(oldItem.delta, true),
            range: oldItem.range && $34d5b5283ccd1972$var$transformRange(oldItem.range, remoteDelta)
        };
        remoteDelta = oldItem.delta.transform(remoteDelta);
        if (stack[i].delta.length() === 0) stack.splice(i, 1);
    }
}
function $34d5b5283ccd1972$var$endsWithNewlineChange(scroll, delta) {
    const lastOp = delta.ops[delta.ops.length - 1];
    if (lastOp == null) return false;
    if (lastOp.insert != null) return typeof lastOp.insert === 'string' && lastOp.insert.endsWith('\n');
    if (lastOp.attributes != null) return Object.keys(lastOp.attributes).some((attr)=>{
        return scroll.query(attr, (0, $569e748944e69916$export$775b6bb06e53a214).BLOCK) != null;
    });
    return false;
}
function $34d5b5283ccd1972$export$64042f78dc41d29e(scroll, delta) {
    const deleteLength = delta.reduce((length, op)=>{
        return length + (op.delete || 0);
    }, 0);
    let changeIndex = delta.length() - deleteLength;
    if ($34d5b5283ccd1972$var$endsWithNewlineChange(scroll, delta)) changeIndex -= 1;
    return changeIndex;
}
function $34d5b5283ccd1972$var$transformRange(range, delta) {
    if (!range) return range;
    const start = delta.transformPosition(range.index);
    const end = delta.transformPosition(range.index + range.length);
    return {
        index: start,
        length: end - start
    };
}






class $2d4f931019be2dc4$var$Uploader extends (0, $9dc68b38e283832b$export$2e2bcd8739ae039) {
    constructor(quill, options){
        super(quill, options);
        quill.root.addEventListener('drop', (e)=>{
            e.preventDefault();
            let native = null;
            if (document.caretRangeFromPoint) native = document.caretRangeFromPoint(e.clientX, e.clientY);
            else if (document.caretPositionFromPoint) {
                // @ts-expect-error
                const position = document.caretPositionFromPoint(e.clientX, e.clientY);
                native = document.createRange();
                native.setStart(position.offsetNode, position.offset);
                native.setEnd(position.offsetNode, position.offset);
            }
            const normalized = native && quill.selection.normalizeNative(native);
            if (normalized) {
                const range = quill.selection.normalizedToRange(normalized);
                if (e.dataTransfer?.files) this.upload(range, e.dataTransfer.files);
            }
        });
    }
    upload(range, files) {
        const uploads = [];
        Array.from(files).forEach((file)=>{
            if (file && this.options.mimetypes?.includes(file.type)) uploads.push(file);
        });
        if (uploads.length > 0) // @ts-expect-error Fix me later
        this.options.handler.call(this, range, uploads);
    }
}
$2d4f931019be2dc4$var$Uploader.DEFAULTS = {
    mimetypes: [
        'image/png',
        'image/jpeg'
    ],
    handler (range, files) {
        if (!this.quill.scroll.query('image')) return;
        const promises = files.map((file)=>{
            return new Promise((resolve)=>{
                const reader = new FileReader();
                reader.onload = ()=>{
                    resolve(reader.result);
                };
                reader.readAsDataURL(file);
            });
        });
        Promise.all(promises).then((images)=>{
            const update = images.reduce((delta, image)=>{
                return delta.insert({
                    image: image
                });
            }, new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))().retain(range.index).delete(range.length));
            this.quill.updateContents(update, (0, $8d79d079139d3d60$export$2e2bcd8739ae039).sources.USER);
            this.quill.setSelection(range.index + images.length, (0, $8d79d079139d3d60$export$2e2bcd8739ae039).sources.SILENT);
        });
    }
};
var $2d4f931019be2dc4$export$2e2bcd8739ae039 = $2d4f931019be2dc4$var$Uploader;







const $dacc238880625786$var$INSERT_TYPES = [
    'insertText',
    'insertReplacementText'
];
class $dacc238880625786$var$Input extends (0, $9dc68b38e283832b$export$2e2bcd8739ae039) {
    constructor(quill, options){
        super(quill, options);
        quill.root.addEventListener('beforeinput', (event)=>{
            this.handleBeforeInput(event);
        });
        // Gboard with English input on Android triggers `compositionstart` sometimes even
        // users are not going to type anything.
        if (!/Android/i.test(navigator.userAgent)) quill.on((0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).events.COMPOSITION_BEFORE_START, ()=>{
            this.handleCompositionStart();
        });
    }
    deleteRange(range) {
        (0, $505caf055cb4e70c$export$a6c813797f379898)({
            range: range,
            quill: this.quill
        });
    }
    replaceText(range) {
        let text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        if (range.length === 0) return false;
        if (text) {
            // Follow the native behavior that inherits the formats of the first character
            const formats = this.quill.getFormat(range.index, 1);
            this.deleteRange(range);
            this.quill.updateContents(new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))().retain(range.index).insert(text, formats), (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
        } else this.deleteRange(range);
        this.quill.setSelection(range.index + text.length, 0, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.SILENT);
        return true;
    }
    handleBeforeInput(event) {
        if (this.quill.composition.isComposing || event.defaultPrevented || !$dacc238880625786$var$INSERT_TYPES.includes(event.inputType)) return;
        const staticRange = event.getTargetRanges ? event.getTargetRanges()[0] : null;
        if (!staticRange || staticRange.collapsed === true) return;
        const text = $dacc238880625786$var$getPlainTextFromInputEvent(event);
        if (text == null) return;
        const normalized = this.quill.selection.normalizeNative(staticRange);
        const range = normalized ? this.quill.selection.normalizedToRange(normalized) : null;
        if (range && this.replaceText(range, text)) event.preventDefault();
    }
    handleCompositionStart() {
        const range = this.quill.getSelection();
        if (range) this.replaceText(range);
    }
}
function $dacc238880625786$var$getPlainTextFromInputEvent(event) {
    // When `inputType` is "insertText":
    // - `event.data` should be string (Safari uses `event.dataTransfer`).
    // - `event.dataTransfer` should be null.
    // When `inputType` is "insertReplacementText":
    // - `event.data` should be null.
    // - `event.dataTransfer` should contain "text/plain" data.
    if (typeof event.data === 'string') return event.data;
    if (event.dataTransfer?.types.includes('text/plain')) return event.dataTransfer.getData('text/plain');
    return null;
}
var $dacc238880625786$export$2e2bcd8739ae039 = $dacc238880625786$var$Input;





const $d1f66893a82028c4$var$isMac = /Mac/i.test(navigator.platform);
const $d1f66893a82028c4$export$b6cc50769bf06658 = 100;
// A loose check to determine if the shortcut can move the caret before a UI node:
// <ANY_PARENT>[CARET]<div class="ql-ui"></div>[CONTENT]</ANY_PARENT>
const $d1f66893a82028c4$var$canMoveCaretBeforeUINode = (event)=>{
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight' || // RTL scripts or moving from the end of the previous line
    event.key === 'ArrowUp' || event.key === 'ArrowDown' || event.key === 'Home') return true;
    if ($d1f66893a82028c4$var$isMac && event.key === 'a' && event.ctrlKey === true) return true;
    return false;
};
class $d1f66893a82028c4$var$UINode extends (0, $9dc68b38e283832b$export$2e2bcd8739ae039) {
    isListening = false;
    selectionChangeDeadline = 0;
    constructor(quill, options){
        super(quill, options);
        this.handleArrowKeys();
        this.handleNavigationShortcuts();
    }
    handleArrowKeys() {
        this.quill.keyboard.addBinding({
            key: [
                'ArrowLeft',
                'ArrowRight'
            ],
            offset: 0,
            shiftKey: null,
            handler (range, _ref) {
                let { line: line, event: event } = _ref;
                if (!(line instanceof (0, $569e748944e69916$export$e43113f0aad76fe)) || !line.uiNode) return true;
                const isRTL = getComputedStyle(line.domNode)['direction'] === 'rtl';
                if (isRTL && event.key !== 'ArrowRight' || !isRTL && event.key !== 'ArrowLeft') return true;
                this.quill.setSelection(range.index - 1, range.length + (event.shiftKey ? 1 : 0), (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
                return false;
            }
        });
    }
    handleNavigationShortcuts() {
        this.quill.root.addEventListener('keydown', (event)=>{
            if (!event.defaultPrevented && $d1f66893a82028c4$var$canMoveCaretBeforeUINode(event)) this.ensureListeningToSelectionChange();
        });
    }
    /**
   * We only listen to the `selectionchange` event when
   * there is an intention of moving the caret to the beginning using shortcuts.
   * This is primarily implemented to prevent infinite loops, as we are changing
   * the selection within the handler of a `selectionchange` event.
   */ ensureListeningToSelectionChange() {
        this.selectionChangeDeadline = Date.now() + $d1f66893a82028c4$export$b6cc50769bf06658;
        if (this.isListening) return;
        this.isListening = true;
        const listener = ()=>{
            this.isListening = false;
            if (Date.now() <= this.selectionChangeDeadline) this.handleSelectionChange();
        };
        document.addEventListener('selectionchange', listener, {
            once: true
        });
    }
    handleSelectionChange() {
        const selection = document.getSelection();
        if (!selection) return;
        const range = selection.getRangeAt(0);
        if (range.collapsed !== true || range.startOffset !== 0) return;
        const line = this.quill.scroll.find(range.startContainer);
        if (!(line instanceof (0, $569e748944e69916$export$e43113f0aad76fe)) || !line.uiNode) return;
        const newRange = document.createRange();
        newRange.setStartAfter(line.uiNode);
        newRange.setEndAfter(line.uiNode);
        selection.removeAllRanges();
        selection.addRange(newRange);
    }
}
var $d1f66893a82028c4$export$2e2bcd8739ae039 = $d1f66893a82028c4$var$UINode;



(0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).register({
    'blots/block': (0, $85f480a53d3839c4$export$2e2bcd8739ae039),
    'blots/block/embed': (0, $85f480a53d3839c4$export$48b9f0688962d028),
    'blots/break': (0, $ed7188caee9f09fc$export$2e2bcd8739ae039),
    'blots/container': (0, $30b436bea069535f$export$2e2bcd8739ae039),
    'blots/cursor': (0, $3f7aca29b1a55496$export$2e2bcd8739ae039),
    'blots/embed': (0, $d7d8defead8474f8$export$2e2bcd8739ae039),
    'blots/inline': (0, $90a3f5612e2e28d2$export$2e2bcd8739ae039),
    'blots/scroll': (0, $c80c0f1fd30fc5f1$export$2e2bcd8739ae039),
    'blots/text': (0, $97f4bef342825216$export$2e2bcd8739ae039),
    'modules/clipboard': (0, $7d186ec37584d3f8$export$2e2bcd8739ae039),
    'modules/history': (0, $34d5b5283ccd1972$export$2e2bcd8739ae039),
    'modules/keyboard': (0, $505caf055cb4e70c$export$2e2bcd8739ae039),
    'modules/uploader': (0, $2d4f931019be2dc4$export$2e2bcd8739ae039),
    'modules/input': (0, $dacc238880625786$export$2e2bcd8739ae039),
    'modules/uiNode': (0, $d1f66893a82028c4$export$2e2bcd8739ae039)
});
var $d42578f98d4c3164$export$2e2bcd8739ae039 = (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039);





class $31292d57a9a2820d$var$IndentAttributor extends (0, $569e748944e69916$export$651d45509677cf07) {
    add(node, value) {
        let normalizedValue = 0;
        if (value === '+1' || value === '-1') {
            const indent = this.value(node) || 0;
            normalizedValue = value === '+1' ? indent + 1 : indent - 1;
        } else if (typeof value === 'number') normalizedValue = value;
        if (normalizedValue === 0) {
            this.remove(node);
            return true;
        }
        return super.add(node, normalizedValue.toString());
    }
    canAdd(node, value) {
        return super.canAdd(node, value) || super.canAdd(node, parseInt(value, 10));
    }
    value(node) {
        return parseInt(super.value(node), 10) || undefined; // Don't return NaN
    }
}
const $31292d57a9a2820d$var$IndentClass = new $31292d57a9a2820d$var$IndentAttributor('indent', 'ql-indent', {
    scope: (0, $569e748944e69916$export$775b6bb06e53a214).BLOCK,
    // @ts-expect-error
    whitelist: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8
    ]
});
var $31292d57a9a2820d$export$2e2bcd8739ae039 = $31292d57a9a2820d$var$IndentClass;



class $3cd36aae285c93dc$var$Blockquote extends (0, $85f480a53d3839c4$export$2e2bcd8739ae039) {
    static blotName = 'blockquote';
    static tagName = 'blockquote';
}
var $3cd36aae285c93dc$export$2e2bcd8739ae039 = $3cd36aae285c93dc$var$Blockquote;



class $1c7ad43b1cf874cc$var$Header extends (0, $85f480a53d3839c4$export$2e2bcd8739ae039) {
    static blotName = 'header';
    static tagName = [
        'H1',
        'H2',
        'H3',
        'H4',
        'H5',
        'H6'
    ];
    static formats(domNode) {
        return this.tagName.indexOf(domNode.tagName) + 1;
    }
}
var $1c7ad43b1cf874cc$export$2e2bcd8739ae039 = $1c7ad43b1cf874cc$var$Header;





class $239ce2e44c993438$export$122a2a667e12876b extends (0, $30b436bea069535f$export$2e2bcd8739ae039) {
}
$239ce2e44c993438$export$122a2a667e12876b.blotName = 'list-container';
$239ce2e44c993438$export$122a2a667e12876b.tagName = 'OL';
class $239ce2e44c993438$export$2e2bcd8739ae039 extends (0, $85f480a53d3839c4$export$2e2bcd8739ae039) {
    static create(value) {
        const node = super.create();
        node.setAttribute('data-list', value);
        return node;
    }
    static formats(domNode) {
        return domNode.getAttribute('data-list') || undefined;
    }
    static register() {
        (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).register($239ce2e44c993438$export$122a2a667e12876b);
    }
    constructor(scroll, domNode){
        super(scroll, domNode);
        const ui = domNode.ownerDocument.createElement('span');
        const listEventHandler = (e)=>{
            if (!scroll.isEnabled()) return;
            const format = this.statics.formats(domNode, scroll);
            if (format === 'checked') {
                this.format('list', 'unchecked');
                e.preventDefault();
            } else if (format === 'unchecked') {
                this.format('list', 'checked');
                e.preventDefault();
            }
        };
        ui.addEventListener('mousedown', listEventHandler);
        ui.addEventListener('touchstart', listEventHandler);
        this.attachUI(ui);
    }
    format(name, value) {
        if (name === this.statics.blotName && value) this.domNode.setAttribute('data-list', value);
        else super.format(name, value);
    }
}
$239ce2e44c993438$export$2e2bcd8739ae039.blotName = 'list';
$239ce2e44c993438$export$2e2bcd8739ae039.tagName = 'LI';
$239ce2e44c993438$export$122a2a667e12876b.allowedChildren = [
    $239ce2e44c993438$export$2e2bcd8739ae039
];
$239ce2e44c993438$export$2e2bcd8739ae039.requiredContainer = $239ce2e44c993438$export$122a2a667e12876b;







class $2cbff3bb34c6b593$var$Bold extends (0, $90a3f5612e2e28d2$export$2e2bcd8739ae039) {
    static blotName = 'bold';
    static tagName = [
        'STRONG',
        'B'
    ];
    static create() {
        return super.create();
    }
    static formats() {
        return true;
    }
    optimize(context) {
        super.optimize(context);
        if (this.domNode.tagName !== this.statics.tagName[0]) this.replaceWith(this.statics.blotName);
    }
}
var $2cbff3bb34c6b593$export$2e2bcd8739ae039 = $2cbff3bb34c6b593$var$Bold;



class $6453543bdd43d36f$var$Italic extends (0, $2cbff3bb34c6b593$export$2e2bcd8739ae039) {
    static blotName = 'italic';
    static tagName = [
        'EM',
        'I'
    ];
}
var $6453543bdd43d36f$export$2e2bcd8739ae039 = $6453543bdd43d36f$var$Italic;



class $fc7bc1d44330de59$export$2e2bcd8739ae039 extends (0, $90a3f5612e2e28d2$export$2e2bcd8739ae039) {
    static blotName = 'link';
    static tagName = 'A';
    static SANITIZED_URL = 'about:blank';
    static PROTOCOL_WHITELIST = [
        'http',
        'https',
        'mailto',
        'tel',
        'sms'
    ];
    static create(value) {
        const node = super.create(value);
        node.setAttribute('href', this.sanitize(value));
        node.setAttribute('rel', 'noopener noreferrer');
        node.setAttribute('target', '_blank');
        return node;
    }
    static formats(domNode) {
        return domNode.getAttribute('href');
    }
    static sanitize(url) {
        return $fc7bc1d44330de59$export$83d2e9e3e4ee39ed(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
    }
    format(name, value) {
        if (name !== this.statics.blotName || !value) super.format(name, value);
        else // @ts-expect-error
        this.domNode.setAttribute('href', this.constructor.sanitize(value));
    }
}
function $fc7bc1d44330de59$export$83d2e9e3e4ee39ed(url, protocols) {
    const anchor = document.createElement('a');
    anchor.href = url;
    const protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
    return protocols.indexOf(protocol) > -1;
}



class $d295522436ad41e0$var$Script extends (0, $90a3f5612e2e28d2$export$2e2bcd8739ae039) {
    static blotName = 'script';
    static tagName = [
        'SUB',
        'SUP'
    ];
    static create(value) {
        if (value === 'super') return document.createElement('sup');
        if (value === 'sub') return document.createElement('sub');
        return super.create(value);
    }
    static formats(domNode) {
        if (domNode.tagName === 'SUB') return 'sub';
        if (domNode.tagName === 'SUP') return 'super';
        return undefined;
    }
}
var $d295522436ad41e0$export$2e2bcd8739ae039 = $d295522436ad41e0$var$Script;



class $951803218a1aaa90$var$Strike extends (0, $2cbff3bb34c6b593$export$2e2bcd8739ae039) {
    static blotName = 'strike';
    static tagName = [
        'S',
        'STRIKE'
    ];
}
var $951803218a1aaa90$export$2e2bcd8739ae039 = $951803218a1aaa90$var$Strike;



class $064a335b69e61eaf$var$Underline extends (0, $90a3f5612e2e28d2$export$2e2bcd8739ae039) {
    static blotName = 'underline';
    static tagName = 'U';
}
var $064a335b69e61eaf$export$2e2bcd8739ae039 = $064a335b69e61eaf$var$Underline;



class $3a0c6ad9122ac914$var$Formula extends (0, $d7d8defead8474f8$export$2e2bcd8739ae039) {
    static blotName = 'formula';
    static className = 'ql-formula';
    static tagName = 'SPAN';
    static create(value) {
        // @ts-expect-error
        if (window.katex == null) throw new Error('Formula module requires KaTeX.');
        const node = super.create(value);
        if (typeof value === 'string') {
            // @ts-expect-error
            window.katex.render(value, node, {
                throwOnError: false,
                errorColor: '#f00'
            });
            node.setAttribute('data-value', value);
        }
        return node;
    }
    static value(domNode) {
        return domNode.getAttribute('data-value');
    }
    html() {
        const { formula: formula } = this.value();
        return `<span>${formula}</span>`;
    }
}
var $3a0c6ad9122ac914$export$2e2bcd8739ae039 = $3a0c6ad9122ac914$var$Formula;




const $f5e5180db55b7783$var$ATTRIBUTES = [
    'alt',
    'height',
    'width'
];
class $f5e5180db55b7783$var$Image extends (0, $569e748944e69916$export$297a1fa96f55f00f) {
    static blotName = 'image';
    static tagName = 'IMG';
    static create(value) {
        const node = super.create(value);
        if (typeof value === 'string') node.setAttribute('src', this.sanitize(value));
        return node;
    }
    static formats(domNode) {
        return $f5e5180db55b7783$var$ATTRIBUTES.reduce((formats, attribute)=>{
            if (domNode.hasAttribute(attribute)) formats[attribute] = domNode.getAttribute(attribute);
            return formats;
        }, {});
    }
    static match(url) {
        return /\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url);
    }
    static sanitize(url) {
        return (0, $fc7bc1d44330de59$export$83d2e9e3e4ee39ed)(url, [
            'http',
            'https',
            'data'
        ]) ? url : '//:0';
    }
    static value(domNode) {
        return domNode.getAttribute('src');
    }
    format(name, value) {
        if ($f5e5180db55b7783$var$ATTRIBUTES.indexOf(name) > -1) {
            if (value) this.domNode.setAttribute(name, value);
            else this.domNode.removeAttribute(name);
        } else super.format(name, value);
    }
}
var $f5e5180db55b7783$export$2e2bcd8739ae039 = $f5e5180db55b7783$var$Image;




const $6207c271ebc5873b$var$ATTRIBUTES = [
    'height',
    'width'
];
class $6207c271ebc5873b$var$Video extends (0, $85f480a53d3839c4$export$48b9f0688962d028) {
    static blotName = 'video';
    static className = 'ql-video';
    static tagName = 'IFRAME';
    static create(value) {
        const node = super.create(value);
        node.setAttribute('frameborder', '0');
        node.setAttribute('allowfullscreen', 'true');
        node.setAttribute('src', this.sanitize(value));
        return node;
    }
    static formats(domNode) {
        return $6207c271ebc5873b$var$ATTRIBUTES.reduce((formats, attribute)=>{
            if (domNode.hasAttribute(attribute)) formats[attribute] = domNode.getAttribute(attribute);
            return formats;
        }, {});
    }
    static sanitize(url) {
        return (0, $fc7bc1d44330de59$export$2e2bcd8739ae039).sanitize(url);
    }
    static value(domNode) {
        return domNode.getAttribute('src');
    }
    format(name, value) {
        if ($6207c271ebc5873b$var$ATTRIBUTES.indexOf(name) > -1) {
            if (value) this.domNode.setAttribute(name, value);
            else this.domNode.removeAttribute(name);
        } else super.format(name, value);
    }
    html() {
        const { video: video } = this.value();
        return `<a href="${video}">${video}</a>`;
    }
}
var $6207c271ebc5873b$export$2e2bcd8739ae039 = $6207c271ebc5873b$var$Video;














const $7fd6118b9b50b99a$var$TokenAttributor = new (0, $569e748944e69916$export$651d45509677cf07)('code-token', 'hljs', {
    scope: (0, $569e748944e69916$export$775b6bb06e53a214).INLINE
});
class $7fd6118b9b50b99a$export$9460eee64f276be7 extends (0, $90a3f5612e2e28d2$export$2e2bcd8739ae039) {
    static formats(node, scroll) {
        while(node != null && node !== scroll.domNode){
            if (node.classList && node.classList.contains((0, $c2ac4be2a790a238$export$2e2bcd8739ae039).className)) // @ts-expect-error
            return super.formats(node, scroll);
            // @ts-expect-error
            node = node.parentNode;
        }
        return undefined;
    }
    constructor(scroll, domNode, value){
        // @ts-expect-error
        super(scroll, domNode, value);
        $7fd6118b9b50b99a$var$TokenAttributor.add(this.domNode, value);
    }
    format(format, value) {
        if (format !== $7fd6118b9b50b99a$export$9460eee64f276be7.blotName) super.format(format, value);
        else if (value) $7fd6118b9b50b99a$var$TokenAttributor.add(this.domNode, value);
        else {
            $7fd6118b9b50b99a$var$TokenAttributor.remove(this.domNode);
            this.domNode.classList.remove(this.statics.className);
        }
    }
    optimize() {
        // @ts-expect-error
        super.optimize(...arguments);
        if (!$7fd6118b9b50b99a$var$TokenAttributor.value(this.domNode)) this.unwrap();
    }
}
$7fd6118b9b50b99a$export$9460eee64f276be7.blotName = 'code-token';
$7fd6118b9b50b99a$export$9460eee64f276be7.className = 'ql-token';
class $7fd6118b9b50b99a$export$6c415d1fdae3dfdb extends (0, $c2ac4be2a790a238$export$2e2bcd8739ae039) {
    static create(value) {
        const domNode = super.create(value);
        if (typeof value === 'string') domNode.setAttribute('data-language', value);
        return domNode;
    }
    static formats(domNode) {
        // @ts-expect-error
        return domNode.getAttribute('data-language') || 'plain';
    }
    static register() {}
    format(name, value) {
        if (name === this.statics.blotName && value) // @ts-expect-error
        this.domNode.setAttribute('data-language', value);
        else super.format(name, value);
    }
    replaceWith(name, value) {
        this.formatAt(0, this.length(), $7fd6118b9b50b99a$export$9460eee64f276be7.blotName, false);
        return super.replaceWith(name, value);
    }
}
class $7fd6118b9b50b99a$var$SyntaxCodeBlockContainer extends (0, $c2ac4be2a790a238$export$3b131632d3d15165) {
    attach() {
        super.attach();
        this.forceNext = false;
        // @ts-expect-error
        this.scroll.emitMount(this);
    }
    format(name, value) {
        if (name === $7fd6118b9b50b99a$export$6c415d1fdae3dfdb.blotName) {
            this.forceNext = true;
            this.children.forEach((child)=>{
                // @ts-expect-error
                child.format(name, value);
            });
        }
    }
    formatAt(index, length, name, value) {
        if (name === $7fd6118b9b50b99a$export$6c415d1fdae3dfdb.blotName) this.forceNext = true;
        super.formatAt(index, length, name, value);
    }
    highlight(highlight) {
        let forced = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (this.children.head == null) return;
        const nodes = Array.from(this.domNode.childNodes).filter((node)=>node !== this.uiNode);
        const text = `${nodes.map((node)=>node.textContent).join('\n')}\n`;
        const language = $7fd6118b9b50b99a$export$6c415d1fdae3dfdb.formats(this.children.head.domNode);
        if (forced || this.forceNext || this.cachedText !== text) {
            if (text.trim().length > 0 || this.cachedText == null) {
                const oldDelta = this.children.reduce((delta, child)=>{
                    // @ts-expect-error
                    return delta.concat((0, $85f480a53d3839c4$export$992ff47219af5a2b)(child, false));
                }, new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))());
                const delta = highlight(text, language);
                oldDelta.diff(delta).reduce((index, _ref)=>{
                    let { retain: retain, attributes: attributes } = _ref;
                    // Should be all retains
                    if (!retain) return index;
                    if (attributes) Object.keys(attributes).forEach((format)=>{
                        if ([
                            $7fd6118b9b50b99a$export$6c415d1fdae3dfdb.blotName,
                            $7fd6118b9b50b99a$export$9460eee64f276be7.blotName
                        ].includes(format)) // @ts-expect-error
                        this.formatAt(index, retain, format, attributes[format]);
                    });
                    // @ts-expect-error
                    return index + retain;
                }, 0);
            }
            this.cachedText = text;
            this.forceNext = false;
        }
    }
    html(index, length) {
        const [codeBlock] = this.children.find(index);
        const language = codeBlock ? $7fd6118b9b50b99a$export$6c415d1fdae3dfdb.formats(codeBlock.domNode) : 'plain';
        return `<pre data-language="${language}">\n${(0, $97f4bef342825216$export$96e6fc3a139b2555)(this.code(index, length))}\n</pre>`;
    }
    optimize(context) {
        super.optimize(context);
        if (this.parent != null && this.children.head != null && this.uiNode != null) {
            const language = $7fd6118b9b50b99a$export$6c415d1fdae3dfdb.formats(this.children.head.domNode);
            // @ts-expect-error
            if (language !== this.uiNode.value) // @ts-expect-error
            this.uiNode.value = language;
        }
    }
}
$7fd6118b9b50b99a$var$SyntaxCodeBlockContainer.allowedChildren = [
    $7fd6118b9b50b99a$export$6c415d1fdae3dfdb
];
$7fd6118b9b50b99a$export$6c415d1fdae3dfdb.requiredContainer = $7fd6118b9b50b99a$var$SyntaxCodeBlockContainer;
$7fd6118b9b50b99a$export$6c415d1fdae3dfdb.allowedChildren = [
    $7fd6118b9b50b99a$export$9460eee64f276be7,
    (0, $3f7aca29b1a55496$export$2e2bcd8739ae039),
    (0, $97f4bef342825216$export$2e2bcd8739ae039),
    (0, $ed7188caee9f09fc$export$2e2bcd8739ae039)
];
const $7fd6118b9b50b99a$var$highlight = (lib, language, text)=>{
    if (typeof lib.versionString === 'string') {
        const majorVersion = lib.versionString.split('.')[0];
        if (parseInt(majorVersion, 10) >= 11) return lib.highlight(text, {
            language: language
        }).value;
    }
    return lib.highlight(language, text).value;
};
class $7fd6118b9b50b99a$export$2e2bcd8739ae039 extends (0, $9dc68b38e283832b$export$2e2bcd8739ae039) {
    static register() {
        (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).register($7fd6118b9b50b99a$export$9460eee64f276be7, true);
        (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).register($7fd6118b9b50b99a$export$6c415d1fdae3dfdb, true);
        (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).register($7fd6118b9b50b99a$var$SyntaxCodeBlockContainer, true);
    }
    constructor(quill, options){
        super(quill, options);
        if (this.options.hljs == null) throw new Error('Syntax module requires highlight.js. Please include the library on the page before Quill.');
        // @ts-expect-error Fix me later
        this.languages = this.options.languages.reduce((memo, _ref2)=>{
            let { key: key } = _ref2;
            memo[key] = true;
            return memo;
        }, {});
        this.highlightBlot = this.highlightBlot.bind(this);
        this.initListener();
        this.initTimer();
    }
    initListener() {
        this.quill.on((0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).events.SCROLL_BLOT_MOUNT, (blot)=>{
            if (!(blot instanceof $7fd6118b9b50b99a$var$SyntaxCodeBlockContainer)) return;
            const select = this.quill.root.ownerDocument.createElement('select');
            // @ts-expect-error Fix me later
            this.options.languages.forEach((_ref3)=>{
                let { key: key, label: label } = _ref3;
                const option = select.ownerDocument.createElement('option');
                option.textContent = label;
                option.setAttribute('value', key);
                select.appendChild(option);
            });
            select.addEventListener('change', ()=>{
                blot.format($7fd6118b9b50b99a$export$6c415d1fdae3dfdb.blotName, select.value);
                this.quill.root.focus(); // Prevent scrolling
                this.highlight(blot, true);
            });
            if (blot.uiNode == null) {
                blot.attachUI(select);
                if (blot.children.head) select.value = $7fd6118b9b50b99a$export$6c415d1fdae3dfdb.formats(blot.children.head.domNode);
            }
        });
    }
    initTimer() {
        let timer = null;
        this.quill.on((0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).events.SCROLL_OPTIMIZE, ()=>{
            if (timer) clearTimeout(timer);
            timer = setTimeout(()=>{
                this.highlight();
                timer = null;
            }, this.options.interval);
        });
    }
    highlight() {
        let blot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (this.quill.selection.composing) return;
        this.quill.update((0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
        const range = this.quill.getSelection();
        const blots = blot == null ? this.quill.scroll.descendants($7fd6118b9b50b99a$var$SyntaxCodeBlockContainer) : [
            blot
        ];
        blots.forEach((container)=>{
            container.highlight(this.highlightBlot, force);
        });
        this.quill.update((0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.SILENT);
        if (range != null) this.quill.setSelection(range, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.SILENT);
    }
    highlightBlot(text) {
        let language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'plain';
        language = this.languages[language] ? language : 'plain';
        if (language === 'plain') return (0, $97f4bef342825216$export$96e6fc3a139b2555)(text).split('\n').reduce((delta, line, i)=>{
            if (i !== 0) delta.insert('\n', {
                [(0, $c2ac4be2a790a238$export$2e2bcd8739ae039).blotName]: language
            });
            return delta.insert(line);
        }, new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))());
        const container = this.quill.root.ownerDocument.createElement('div');
        container.classList.add((0, $c2ac4be2a790a238$export$2e2bcd8739ae039).className);
        container.innerHTML = $7fd6118b9b50b99a$var$highlight(this.options.hljs, language, text);
        return (0, $7d186ec37584d3f8$export$df3f009e3d155b20)(this.quill.scroll, container, [
            (node, delta)=>{
                // @ts-expect-error
                const value = $7fd6118b9b50b99a$var$TokenAttributor.value(node);
                if (value) return delta.compose(new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))().retain(delta.length(), {
                    [$7fd6118b9b50b99a$export$9460eee64f276be7.blotName]: value
                }));
                return delta;
            }
        ], [
            (node, delta)=>{
                // @ts-expect-error
                return node.data.split('\n').reduce((memo, nodeText, i)=>{
                    if (i !== 0) memo.insert('\n', {
                        [(0, $c2ac4be2a790a238$export$2e2bcd8739ae039).blotName]: language
                    });
                    return memo.insert(nodeText);
                }, delta);
            }
        ], new WeakMap());
    }
}
$7fd6118b9b50b99a$export$2e2bcd8739ae039.DEFAULTS = {
    hljs: (()=>{
        return window.hljs;
    })(),
    interval: 1000,
    languages: [
        {
            key: 'plain',
            label: 'Plain'
        },
        {
            key: 'bash',
            label: 'Bash'
        },
        {
            key: 'cpp',
            label: 'C++'
        },
        {
            key: 'cs',
            label: 'C#'
        },
        {
            key: 'css',
            label: 'CSS'
        },
        {
            key: 'diff',
            label: 'Diff'
        },
        {
            key: 'xml',
            label: 'HTML/XML'
        },
        {
            key: 'java',
            label: 'Java'
        },
        {
            key: 'javascript',
            label: 'JavaScript'
        },
        {
            key: 'markdown',
            label: 'Markdown'
        },
        {
            key: 'php',
            label: 'PHP'
        },
        {
            key: 'python',
            label: 'Python'
        },
        {
            key: 'ruby',
            label: 'Ruby'
        },
        {
            key: 'sql',
            label: 'SQL'
        }
    ]
};







class $c6f437606f3d9f1f$export$1e4baea7053fc0e3 extends (0, $85f480a53d3839c4$export$2e2bcd8739ae039) {
    static blotName = 'table';
    static tagName = 'TD';
    static create(value) {
        const node = super.create();
        if (value) node.setAttribute('data-row', value);
        else node.setAttribute('data-row', $c6f437606f3d9f1f$export$9bd6f73cbe857f1b());
        return node;
    }
    static formats(domNode) {
        if (domNode.hasAttribute('data-row')) return domNode.getAttribute('data-row');
        return undefined;
    }
    cellOffset() {
        if (this.parent) return this.parent.children.indexOf(this);
        return -1;
    }
    format(name, value) {
        if (name === $c6f437606f3d9f1f$export$1e4baea7053fc0e3.blotName && value) this.domNode.setAttribute('data-row', value);
        else super.format(name, value);
    }
    row() {
        return this.parent;
    }
    rowOffset() {
        if (this.row()) return this.row().rowOffset();
        return -1;
    }
    table() {
        return this.row() && this.row().table();
    }
}
class $c6f437606f3d9f1f$export$b05581f4e764e162 extends (0, $30b436bea069535f$export$2e2bcd8739ae039) {
    static blotName = 'table-row';
    static tagName = 'TR';
    checkMerge() {
        // @ts-expect-error
        if (super.checkMerge() && this.next.children.head != null) {
            // @ts-expect-error
            const thisHead = this.children.head.formats();
            // @ts-expect-error
            const thisTail = this.children.tail.formats();
            // @ts-expect-error
            const nextHead = this.next.children.head.formats();
            // @ts-expect-error
            const nextTail = this.next.children.tail.formats();
            return thisHead.table === thisTail.table && thisHead.table === nextHead.table && thisHead.table === nextTail.table;
        }
        return false;
    }
    optimize(context) {
        super.optimize(context);
        this.children.forEach((child)=>{
            if (child.next == null) return;
            const childFormats = child.formats();
            const nextFormats = child.next.formats();
            if (childFormats.table !== nextFormats.table) {
                const next = this.splitAfter(child);
                if (next) // @ts-expect-error TODO: parameters of optimize() should be a optional
                next.optimize();
                // We might be able to merge with prev now
                if (this.prev) // @ts-expect-error TODO: parameters of optimize() should be a optional
                this.prev.optimize();
            }
        });
    }
    rowOffset() {
        if (this.parent) return this.parent.children.indexOf(this);
        return -1;
    }
    table() {
        return this.parent && this.parent.parent;
    }
}
class $c6f437606f3d9f1f$export$76ccd210b9029917 extends (0, $30b436bea069535f$export$2e2bcd8739ae039) {
    static blotName = 'table-body';
    static tagName = 'TBODY';
}
class $c6f437606f3d9f1f$export$f2c3aea42b2a048f extends (0, $30b436bea069535f$export$2e2bcd8739ae039) {
    static blotName = 'table-container';
    static tagName = 'TABLE';
    balanceCells() {
        const rows = this.descendants($c6f437606f3d9f1f$export$b05581f4e764e162);
        const maxColumns = rows.reduce((max, row)=>{
            return Math.max(row.children.length, max);
        }, 0);
        rows.forEach((row)=>{
            new Array(maxColumns - row.children.length).fill(0).forEach(()=>{
                let value;
                if (row.children.head != null) value = $c6f437606f3d9f1f$export$1e4baea7053fc0e3.formats(row.children.head.domNode);
                const blot = this.scroll.create($c6f437606f3d9f1f$export$1e4baea7053fc0e3.blotName, value);
                row.appendChild(blot);
                // @ts-expect-error TODO: parameters of optimize() should be a optional
                blot.optimize(); // Add break blot
            });
        });
    }
    cells(column) {
        return this.rows().map((row)=>row.children.at(column));
    }
    deleteColumn(index) {
        // @ts-expect-error
        const [body] = this.descendant($c6f437606f3d9f1f$export$76ccd210b9029917);
        if (body == null || body.children.head == null) return;
        body.children.forEach((row)=>{
            const cell = row.children.at(index);
            if (cell != null) cell.remove();
        });
    }
    insertColumn(index) {
        // @ts-expect-error
        const [body] = this.descendant($c6f437606f3d9f1f$export$76ccd210b9029917);
        if (body == null || body.children.head == null) return;
        body.children.forEach((row)=>{
            const ref = row.children.at(index);
            // @ts-expect-error
            const value = $c6f437606f3d9f1f$export$1e4baea7053fc0e3.formats(row.children.head.domNode);
            const cell = this.scroll.create($c6f437606f3d9f1f$export$1e4baea7053fc0e3.blotName, value);
            row.insertBefore(cell, ref);
        });
    }
    insertRow(index) {
        // @ts-expect-error
        const [body] = this.descendant($c6f437606f3d9f1f$export$76ccd210b9029917);
        if (body == null || body.children.head == null) return;
        const id = $c6f437606f3d9f1f$export$9bd6f73cbe857f1b();
        const row = this.scroll.create($c6f437606f3d9f1f$export$b05581f4e764e162.blotName);
        body.children.head.children.forEach(()=>{
            const cell = this.scroll.create($c6f437606f3d9f1f$export$1e4baea7053fc0e3.blotName, id);
            row.appendChild(cell);
        });
        const ref = body.children.at(index);
        body.insertBefore(row, ref);
    }
    rows() {
        const body = this.children.head;
        if (body == null) return [];
        return body.children.map((row)=>row);
    }
}
$c6f437606f3d9f1f$export$f2c3aea42b2a048f.allowedChildren = [
    $c6f437606f3d9f1f$export$76ccd210b9029917
];
$c6f437606f3d9f1f$export$76ccd210b9029917.requiredContainer = $c6f437606f3d9f1f$export$f2c3aea42b2a048f;
$c6f437606f3d9f1f$export$76ccd210b9029917.allowedChildren = [
    $c6f437606f3d9f1f$export$b05581f4e764e162
];
$c6f437606f3d9f1f$export$b05581f4e764e162.requiredContainer = $c6f437606f3d9f1f$export$76ccd210b9029917;
$c6f437606f3d9f1f$export$b05581f4e764e162.allowedChildren = [
    $c6f437606f3d9f1f$export$1e4baea7053fc0e3
];
$c6f437606f3d9f1f$export$1e4baea7053fc0e3.requiredContainer = $c6f437606f3d9f1f$export$b05581f4e764e162;
function $c6f437606f3d9f1f$export$9bd6f73cbe857f1b() {
    const id = Math.random().toString(36).slice(2, 6);
    return `row-${id}`;
}


class $ccf17529e6ac36b2$var$Table extends (0, $9dc68b38e283832b$export$2e2bcd8739ae039) {
    static register() {
        (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).register((0, $c6f437606f3d9f1f$export$1e4baea7053fc0e3));
        (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).register((0, $c6f437606f3d9f1f$export$b05581f4e764e162));
        (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).register((0, $c6f437606f3d9f1f$export$76ccd210b9029917));
        (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).register((0, $c6f437606f3d9f1f$export$f2c3aea42b2a048f));
    }
    constructor(){
        super(...arguments);
        this.listenBalanceCells();
    }
    balanceTables() {
        this.quill.scroll.descendants((0, $c6f437606f3d9f1f$export$f2c3aea42b2a048f)).forEach((table)=>{
            table.balanceCells();
        });
    }
    deleteColumn() {
        const [table, , cell] = this.getTable();
        if (cell == null) return;
        // @ts-expect-error
        table.deleteColumn(cell.cellOffset());
        this.quill.update((0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
    }
    deleteRow() {
        const [, row] = this.getTable();
        if (row == null) return;
        row.remove();
        this.quill.update((0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
    }
    deleteTable() {
        const [table] = this.getTable();
        if (table == null) return;
        // @ts-expect-error
        const offset = table.offset();
        // @ts-expect-error
        table.remove();
        this.quill.update((0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
        this.quill.setSelection(offset, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.SILENT);
    }
    getTable() {
        let range = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.quill.getSelection();
        if (range == null) return [
            null,
            null,
            null,
            -1
        ];
        const [cell, offset] = this.quill.getLine(range.index);
        if (cell == null || cell.statics.blotName !== (0, $c6f437606f3d9f1f$export$1e4baea7053fc0e3).blotName) return [
            null,
            null,
            null,
            -1
        ];
        const row = cell.parent;
        const table = row.parent.parent;
        // @ts-expect-error
        return [
            table,
            row,
            cell,
            offset
        ];
    }
    insertColumn(offset) {
        const range = this.quill.getSelection();
        if (!range) return;
        const [table, row, cell] = this.getTable(range);
        if (cell == null) return;
        const column = cell.cellOffset();
        table.insertColumn(column + offset);
        this.quill.update((0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
        let shift = row.rowOffset();
        if (offset === 0) shift += 1;
        this.quill.setSelection(range.index + shift, range.length, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.SILENT);
    }
    insertColumnLeft() {
        this.insertColumn(0);
    }
    insertColumnRight() {
        this.insertColumn(1);
    }
    insertRow(offset) {
        const range = this.quill.getSelection();
        if (!range) return;
        const [table, row, cell] = this.getTable(range);
        if (cell == null) return;
        const index = row.rowOffset();
        table.insertRow(index + offset);
        this.quill.update((0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
        if (offset > 0) this.quill.setSelection(range, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.SILENT);
        else this.quill.setSelection(range.index + row.children.length, range.length, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.SILENT);
    }
    insertRowAbove() {
        this.insertRow(0);
    }
    insertRowBelow() {
        this.insertRow(1);
    }
    insertTable(rows, columns) {
        const range = this.quill.getSelection();
        if (range == null) return;
        const delta = new Array(rows).fill(0).reduce((memo)=>{
            const text = new Array(columns).fill('\n').join('');
            return memo.insert(text, {
                table: (0, $c6f437606f3d9f1f$export$9bd6f73cbe857f1b)()
            });
        }, new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))().retain(range.index));
        this.quill.updateContents(delta, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
        this.quill.setSelection(range.index, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.SILENT);
        this.balanceTables();
    }
    listenBalanceCells() {
        this.quill.on((0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).events.SCROLL_OPTIMIZE, (mutations)=>{
            mutations.some((mutation)=>{
                if ([
                    'TD',
                    'TR',
                    'TBODY',
                    'TABLE'
                ].includes(mutation.target.tagName)) {
                    this.quill.once((0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).events.TEXT_CHANGE, (delta, old, source)=>{
                        if (source !== (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER) return;
                        this.balanceTables();
                    });
                    return true;
                }
                return false;
            });
        });
    }
}
var $ccf17529e6ac36b2$export$2e2bcd8739ae039 = $ccf17529e6ac36b2$var$Table;







const $c5297f7eb4c02af6$var$debug = (0, $17c49cda18fab12a$export$2e2bcd8739ae039)('quill:toolbar');
class $c5297f7eb4c02af6$export$2e2bcd8739ae039 extends (0, $9dc68b38e283832b$export$2e2bcd8739ae039) {
    constructor(quill, options){
        super(quill, options);
        if (Array.isArray(this.options.container)) {
            const container = document.createElement('div');
            container.setAttribute('role', 'toolbar');
            $c5297f7eb4c02af6$export$faadaf0198b97fbe(container, this.options.container);
            quill.container?.parentNode?.insertBefore(container, quill.container);
            this.container = container;
        } else if (typeof this.options.container === 'string') this.container = document.querySelector(this.options.container);
        else this.container = this.options.container;
        if (!(this.container instanceof HTMLElement)) {
            $c5297f7eb4c02af6$var$debug.error('Container required for toolbar', this.options);
            return;
        }
        this.container.classList.add('ql-toolbar');
        this.controls = [];
        this.handlers = {};
        if (this.options.handlers) Object.keys(this.options.handlers).forEach((format)=>{
            const handler = this.options.handlers?.[format];
            if (handler) this.addHandler(format, handler);
        });
        Array.from(this.container.querySelectorAll('button, select')).forEach((input)=>{
            // @ts-expect-error
            this.attach(input);
        });
        this.quill.on((0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).events.EDITOR_CHANGE, ()=>{
            const [range] = this.quill.selection.getRange(); // quill.getSelection triggers update
            this.update(range);
        });
    }
    addHandler(format, handler) {
        this.handlers[format] = handler;
    }
    attach(input) {
        let format = Array.from(input.classList).find((className)=>{
            return className.indexOf('ql-') === 0;
        });
        if (!format) return;
        format = format.slice(3);
        if (input.tagName === 'BUTTON') input.setAttribute('type', 'button');
        if (this.handlers[format] == null && this.quill.scroll.query(format) == null) {
            $c5297f7eb4c02af6$var$debug.warn('ignoring attaching to nonexistent format', format, input);
            return;
        }
        const eventName = input.tagName === 'SELECT' ? 'change' : 'click';
        input.addEventListener(eventName, (e)=>{
            let value;
            if (input.tagName === 'SELECT') {
                // @ts-expect-error
                if (input.selectedIndex < 0) return;
                // @ts-expect-error
                const selected = input.options[input.selectedIndex];
                if (selected.hasAttribute('selected')) value = false;
                else value = selected.value || false;
            } else {
                if (input.classList.contains('ql-active')) value = false;
                else // @ts-expect-error
                value = input.value || !input.hasAttribute('value');
                e.preventDefault();
            }
            this.quill.focus();
            const [range] = this.quill.selection.getRange();
            if (this.handlers[format] != null) this.handlers[format].call(this, value);
            else if (// @ts-expect-error
            this.quill.scroll.query(format).prototype instanceof (0, $569e748944e69916$export$297a1fa96f55f00f)) {
                value = prompt(`Enter ${format}`); // eslint-disable-line no-alert
                if (!value) return;
                this.quill.updateContents(new (0, (/*@__PURE__*/$parcel$interopDefault($88e60522c01c2553$exports)))()// @ts-expect-error Fix me later
                .retain(range.index)// @ts-expect-error Fix me later
                .delete(range.length).insert({
                    [format]: value
                }), (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
            } else this.quill.format(format, value, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
            this.update(range);
        });
        this.controls.push([
            format,
            input
        ]);
    }
    update(range) {
        const formats = range == null ? {} : this.quill.getFormat(range);
        this.controls.forEach((pair)=>{
            const [format, input] = pair;
            if (input.tagName === 'SELECT') {
                let option = null;
                if (range == null) option = null;
                else if (formats[format] == null) option = input.querySelector('option[selected]');
                else if (!Array.isArray(formats[format])) {
                    let value = formats[format];
                    if (typeof value === 'string') value = value.replace(/"/g, '\\"');
                    option = input.querySelector(`option[value="${value}"]`);
                }
                if (option == null) {
                    // @ts-expect-error TODO fix me later
                    input.value = ''; // TODO make configurable?
                    // @ts-expect-error TODO fix me later
                    input.selectedIndex = -1;
                } else option.selected = true;
            } else if (range == null) {
                input.classList.remove('ql-active');
                input.setAttribute('aria-pressed', 'false');
            } else if (input.hasAttribute('value')) {
                // both being null should match (default values)
                // '1' should match with 1 (headers)
                const value = formats[format];
                const isActive = value === input.getAttribute('value') || value != null && value.toString() === input.getAttribute('value') || value == null && !input.getAttribute('value');
                input.classList.toggle('ql-active', isActive);
                input.setAttribute('aria-pressed', isActive.toString());
            } else {
                const isActive = formats[format] != null;
                input.classList.toggle('ql-active', isActive);
                input.setAttribute('aria-pressed', isActive.toString());
            }
        });
    }
}
$c5297f7eb4c02af6$export$2e2bcd8739ae039.DEFAULTS = {};
function $c5297f7eb4c02af6$var$addButton(container, format, value) {
    const input = document.createElement('button');
    input.setAttribute('type', 'button');
    input.classList.add(`ql-${format}`);
    input.setAttribute('aria-pressed', 'false');
    if (value != null) {
        input.value = value;
        input.setAttribute('aria-label', `${format}: ${value}`);
    } else input.setAttribute('aria-label', format);
    container.appendChild(input);
}
function $c5297f7eb4c02af6$export$faadaf0198b97fbe(container, groups) {
    if (!Array.isArray(groups[0])) // @ts-expect-error
    groups = [
        groups
    ];
    groups.forEach((controls)=>{
        const group = document.createElement('span');
        group.classList.add('ql-formats');
        controls.forEach((control)=>{
            if (typeof control === 'string') $c5297f7eb4c02af6$var$addButton(group, control);
            else {
                const format = Object.keys(control)[0];
                const value = control[format];
                if (Array.isArray(value)) $c5297f7eb4c02af6$var$addSelect(group, format, value);
                else $c5297f7eb4c02af6$var$addButton(group, format, value);
            }
        });
        container.appendChild(group);
    });
}
function $c5297f7eb4c02af6$var$addSelect(container, format, values) {
    const input = document.createElement('select');
    input.classList.add(`ql-${format}`);
    values.forEach((value)=>{
        const option = document.createElement('option');
        if (value !== false) option.setAttribute('value', String(value));
        else option.setAttribute('selected', 'selected');
        input.appendChild(option);
    });
    container.appendChild(input);
}
$c5297f7eb4c02af6$export$2e2bcd8739ae039.DEFAULTS = {
    container: null,
    handlers: {
        clean () {
            const range = this.quill.getSelection();
            if (range == null) return;
            if (range.length === 0) {
                const formats = this.quill.getFormat();
                Object.keys(formats).forEach((name)=>{
                    // Clean functionality in existing apps only clean inline formats
                    if (this.quill.scroll.query(name, (0, $569e748944e69916$export$775b6bb06e53a214).INLINE) != null) this.quill.format(name, false, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
                });
            } else this.quill.removeFormat(range.index, range.length, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
        },
        direction (value) {
            const { align: align } = this.quill.getFormat();
            if (value === 'rtl' && align == null) this.quill.format('align', 'right', (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
            else if (!value && align === 'right') this.quill.format('align', false, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
            this.quill.format('direction', value, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
        },
        indent (value) {
            const range = this.quill.getSelection();
            // @ts-expect-error
            const formats = this.quill.getFormat(range);
            // @ts-expect-error
            const indent = parseInt(formats.indent || 0, 10);
            if (value === '+1' || value === '-1') {
                let modifier = value === '+1' ? 1 : -1;
                if (formats.direction === 'rtl') modifier *= -1;
                this.quill.format('indent', indent + modifier, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
            }
        },
        link (value) {
            if (value === true) value = prompt('Enter link URL:'); // eslint-disable-line no-alert
            this.quill.format('link', value, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
        },
        list (value) {
            const range = this.quill.getSelection();
            // @ts-expect-error
            const formats = this.quill.getFormat(range);
            if (value === 'check') {
                if (formats.list === 'checked' || formats.list === 'unchecked') this.quill.format('list', false, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
                else this.quill.format('list', 'unchecked', (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
            } else this.quill.format('list', value, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
        }
    }
};


const $18092f99c50a7661$var$alignLeftIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"13\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"9\" y1=\"4\" y2=\"4\"/></svg>";
const $18092f99c50a7661$var$alignCenterIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"14\" x2=\"4\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"12\" x2=\"6\" y1=\"4\" y2=\"4\"/></svg>";
const $18092f99c50a7661$var$alignRightIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"5\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"9\" y1=\"4\" y2=\"4\"/></svg>";
const $18092f99c50a7661$var$alignJustifyIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"4\" y2=\"4\"/></svg>";
const $18092f99c50a7661$var$backgroundIcon = "<svg viewbox=\"0 0 18 18\"><g class=\"ql-fill ql-color-label\"><polygon points=\"6 6.868 6 6 5 6 5 7 5.942 7 6 6.868\"/><rect height=\"1\" width=\"1\" x=\"4\" y=\"4\"/><polygon points=\"6.817 5 6 5 6 6 6.38 6 6.817 5\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"6\"/><rect height=\"1\" width=\"1\" x=\"3\" y=\"5\"/><rect height=\"1\" width=\"1\" x=\"4\" y=\"7\"/><polygon points=\"4 11.439 4 11 3 11 3 12 3.755 12 4 11.439\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"12\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"9\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"15\"/><polygon points=\"4.63 10 4 10 4 11 4.192 11 4.63 10\"/><rect height=\"1\" width=\"1\" x=\"3\" y=\"8\"/><path d=\"M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z\"/><path d=\"M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z\"/><path d=\"M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z\"/><rect height=\"1\" width=\"1\" x=\"12\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"11\" y=\"3\"/><path d=\"M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"3\"/><rect height=\"1\" width=\"1\" x=\"6\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"3\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"5\" y=\"3\"/><rect height=\"1\" width=\"1\" x=\"9\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"14\"/><polygon points=\"13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174\"/><rect height=\"1\" width=\"1\" x=\"13\" y=\"7\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"5\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"6\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"8\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"9\"/><path d=\"M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"3\"/><polygon points=\"12 6.868 12 6 11.62 6 12 6.868\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"12\" y=\"5\"/><rect height=\"1\" width=\"1\" x=\"13\" y=\"4\"/><polygon points=\"12.933 9 13 9 13 8 12.495 8 12.933 9\"/><rect height=\"1\" width=\"1\" x=\"9\" y=\"14\"/><rect height=\"1\" width=\"1\" x=\"8\" y=\"15\"/><path d=\"M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z\"/><rect height=\"1\" width=\"1\" x=\"5\" y=\"15\"/><path d=\"M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z\"/><rect height=\"1\" width=\"1\" x=\"11\" y=\"15\"/><path d=\"M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"15\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"11\"/></g><polyline class=\"ql-stroke\" points=\"5.5 13 9 5 12.5 13\"/><line class=\"ql-stroke\" x1=\"11.63\" x2=\"6.38\" y1=\"11\" y2=\"11\"/></svg>";
const $18092f99c50a7661$var$blockquoteIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-fill ql-stroke\" height=\"3\" width=\"3\" x=\"4\" y=\"5\"/><rect class=\"ql-fill ql-stroke\" height=\"3\" width=\"3\" x=\"11\" y=\"5\"/><path class=\"ql-even ql-fill ql-stroke\" d=\"M7,8c0,4.031-3,5-3,5\"/><path class=\"ql-even ql-fill ql-stroke\" d=\"M14,8c0,4.031-3,5-3,5\"/></svg>";
const $18092f99c50a7661$var$boldIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-stroke\" d=\"M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z\"/><path class=\"ql-stroke\" d=\"M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z\"/></svg>";
const $18092f99c50a7661$var$cleanIcon = "<svg class=\"\" viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"5\" x2=\"13\" y1=\"3\" y2=\"3\"/><line class=\"ql-stroke\" x1=\"6\" x2=\"9.35\" y1=\"12\" y2=\"3\"/><line class=\"ql-stroke\" x1=\"11\" x2=\"15\" y1=\"11\" y2=\"15\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"11\" y1=\"11\" y2=\"15\"/><rect class=\"ql-fill\" height=\"1\" rx=\"0.5\" ry=\"0.5\" width=\"7\" x=\"2\" y=\"14\"/></svg>";
const $18092f99c50a7661$var$codeIcon = "<svg viewbox=\"0 0 18 18\"><polyline class=\"ql-even ql-stroke\" points=\"5 7 3 9 5 11\"/><polyline class=\"ql-even ql-stroke\" points=\"13 7 15 9 13 11\"/><line class=\"ql-stroke\" x1=\"10\" x2=\"8\" y1=\"5\" y2=\"13\"/></svg>";
const $18092f99c50a7661$var$colorIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-color-label ql-stroke ql-transparent\" x1=\"3\" x2=\"15\" y1=\"15\" y2=\"15\"/><polyline class=\"ql-stroke\" points=\"5.5 11 9 3 12.5 11\"/><line class=\"ql-stroke\" x1=\"11.63\" x2=\"6.38\" y1=\"9\" y2=\"9\"/></svg>";
const $18092f99c50a7661$var$directionLeftToRightIcon = "<svg viewbox=\"0 0 18 18\"><polygon class=\"ql-stroke ql-fill\" points=\"3 11 5 9 3 7 3 11\"/><line class=\"ql-stroke ql-fill\" x1=\"15\" x2=\"11\" y1=\"4\" y2=\"4\"/><path class=\"ql-fill\" d=\"M11,3a3,3,0,0,0,0,6h1V3H11Z\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"11\" y=\"4\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"13\" y=\"4\"/></svg>";
const $18092f99c50a7661$var$directionRightToLeftIcon = "<svg viewbox=\"0 0 18 18\"><polygon class=\"ql-stroke ql-fill\" points=\"15 12 13 10 15 8 15 12\"/><line class=\"ql-stroke ql-fill\" x1=\"9\" x2=\"5\" y1=\"4\" y2=\"4\"/><path class=\"ql-fill\" d=\"M5,3A3,3,0,0,0,5,9H6V3H5Z\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"5\" y=\"4\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"7\" y=\"4\"/></svg>";
const $18092f99c50a7661$var$formulaIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z\"/><rect class=\"ql-fill\" height=\"1.6\" rx=\"0.8\" ry=\"0.8\" width=\"5\" x=\"5.15\" y=\"6.2\"/><path class=\"ql-fill\" d=\"M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z\"/></svg>";
const $18092f99c50a7661$var$headerIcon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z\"/></svg>";
const $18092f99c50a7661$var$header2Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z\"/></svg>";
const $18092f99c50a7661$var$header3Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M16.65186,12.30664a2.6742,2.6742,0,0,1-2.915,2.68457,3.96592,3.96592,0,0,1-2.25537-.6709.56007.56007,0,0,1-.13232-.83594L11.64648,13c.209-.34082.48389-.36328.82471-.1543a2.32654,2.32654,0,0,0,1.12256.33008c.71484,0,1.12207-.35156,1.12207-.78125,0-.61523-.61621-.86816-1.46338-.86816H13.2085a.65159.65159,0,0,1-.68213-.41895l-.05518-.10937a.67114.67114,0,0,1,.14307-.78125l.71533-.86914a8.55289,8.55289,0,0,1,.68213-.7373V8.58887a3.93913,3.93913,0,0,1-.748.05469H11.9873a.54085.54085,0,0,1-.605-.60547V7.59863a.54085.54085,0,0,1,.605-.60547h3.75146a.53773.53773,0,0,1,.60547.59375v.17676a1.03723,1.03723,0,0,1-.27539.748L14.74854,10.0293A2.31132,2.31132,0,0,1,16.65186,12.30664ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z\"/></svg>";
const $18092f99c50a7661$var$header4Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm7.05371,7.96582v.38477c0,.39648-.165.60547-.46191.60547h-.47314v1.29785a.54085.54085,0,0,1-.605.60547h-.69336a.54085.54085,0,0,1-.605-.60547V12.95605H11.333a.5412.5412,0,0,1-.60547-.60547v-.15332a1.199,1.199,0,0,1,.22021-.748l2.56348-4.05957a.7819.7819,0,0,1,.72607-.39648h1.27637a.54085.54085,0,0,1,.605.60547v3.7627h.33008A.54055.54055,0,0,1,17.05371,11.96582ZM14.28125,8.7207h-.022a4.18969,4.18969,0,0,1-.38525.81348l-1.188,1.80469v.02246h1.5293V9.60059A7.04058,7.04058,0,0,1,14.28125,8.7207Z\"/></svg>";
const $18092f99c50a7661$var$header5Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M16.74023,12.18555a2.75131,2.75131,0,0,1-2.91553,2.80566,3.908,3.908,0,0,1-2.25537-.68164.54809.54809,0,0,1-.13184-.8252L11.73438,13c.209-.34082.48389-.36328.8252-.1543a2.23757,2.23757,0,0,0,1.1001.33008,1.01827,1.01827,0,0,0,1.1001-.96777c0-.61621-.53906-.97949-1.25439-.97949a2.15554,2.15554,0,0,0-.64893.09961,1.15209,1.15209,0,0,1-.814.01074l-.12109-.04395a.64116.64116,0,0,1-.45117-.71484l.231-3.00391a.56666.56666,0,0,1,.62744-.583H15.541a.54085.54085,0,0,1,.605.60547v.43945a.54085.54085,0,0,1-.605.60547H13.41748l-.04395.72559a1.29306,1.29306,0,0,1-.04395.30859h.022a2.39776,2.39776,0,0,1,.57227-.07715A2.53266,2.53266,0,0,1,16.74023,12.18555ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z\"/></svg>";
const $18092f99c50a7661$var$header6Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M14.51758,9.64453a1.85627,1.85627,0,0,0-1.24316.38477H13.252a1.73532,1.73532,0,0,1,1.72754-1.4082,2.66491,2.66491,0,0,1,.5498.06641c.35254.05469.57227.01074.70508-.40723l.16406-.5166a.53393.53393,0,0,0-.373-.75977,4.83723,4.83723,0,0,0-1.17773-.14258c-2.43164,0-3.7627,2.17773-3.7627,4.43359,0,2.47559,1.60645,3.69629,3.19043,3.69629A2.70585,2.70585,0,0,0,16.96,12.19727,2.43861,2.43861,0,0,0,14.51758,9.64453Zm-.23047,3.58691c-.67187,0-1.22168-.81445-1.22168-1.45215,0-.47363.30762-.583.72559-.583.96875,0,1.27734.59375,1.27734,1.12207A.82182.82182,0,0,1,14.28711,13.23145ZM10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Z\"/></svg>";
const $18092f99c50a7661$var$italicIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"7\" x2=\"13\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"5\" x2=\"11\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"8\" x2=\"10\" y1=\"14\" y2=\"4\"/></svg>";
const $18092f99c50a7661$var$imageIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-stroke\" height=\"10\" width=\"12\" x=\"3\" y=\"4\"/><circle class=\"ql-fill\" cx=\"6\" cy=\"7\" r=\"1\"/><polyline class=\"ql-even ql-fill\" points=\"5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12\"/></svg>";
const $18092f99c50a7661$var$indentIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"9\" y2=\"9\"/><polyline class=\"ql-fill ql-stroke\" points=\"3 7 3 11 5 9 3 7\"/></svg>";
const $18092f99c50a7661$var$outdentIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"9\" y2=\"9\"/><polyline class=\"ql-stroke\" points=\"5 7 5 11 3 9 5 7\"/></svg>";
const $18092f99c50a7661$var$linkIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"7\" x2=\"11\" y1=\"7\" y2=\"11\"/><path class=\"ql-even ql-stroke\" d=\"M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z\"/><path class=\"ql-even ql-stroke\" d=\"M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z\"/></svg>";
const $18092f99c50a7661$var$listBulletIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"6\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"6\" x2=\"15\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"6\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"3\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"3\" y1=\"14\" y2=\"14\"/></svg>";
const $18092f99c50a7661$var$listCheckIcon = "<svg class=\"\" viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"4\" y2=\"4\"/><polyline class=\"ql-stroke\" points=\"3 4 4 5 6 3\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"14\" y2=\"14\"/><polyline class=\"ql-stroke\" points=\"3 14 4 15 6 13\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"9\" y2=\"9\"/><polyline class=\"ql-stroke\" points=\"3 9 4 10 6 8\"/></svg>";
const $18092f99c50a7661$var$listOrderedIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"7\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"7\" x2=\"15\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"7\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke ql-thin\" x1=\"2.5\" x2=\"4.5\" y1=\"5.5\" y2=\"5.5\"/><path class=\"ql-fill\" d=\"M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z\"/><path class=\"ql-stroke ql-thin\" d=\"M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156\"/><path class=\"ql-stroke ql-thin\" d=\"M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109\"/></svg>";
const $18092f99c50a7661$var$subscriptIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z\"/><path class=\"ql-fill\" d=\"M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z\"/></svg>";
const $18092f99c50a7661$var$superscriptIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z\"/><path class=\"ql-fill\" d=\"M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z\"/></svg>";
const $18092f99c50a7661$var$strikeIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke ql-thin\" x1=\"15.5\" x2=\"2.5\" y1=\"8.5\" y2=\"9.5\"/><path class=\"ql-fill\" d=\"M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z\"/><path class=\"ql-fill\" d=\"M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z\"/></svg>";
const $18092f99c50a7661$var$tableIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-stroke\" height=\"12\" width=\"12\" x=\"3\" y=\"3\"/><rect class=\"ql-fill\" height=\"2\" width=\"3\" x=\"5\" y=\"5\"/><rect class=\"ql-fill\" height=\"2\" width=\"4\" x=\"9\" y=\"5\"/><g class=\"ql-fill ql-transparent\"><rect height=\"2\" width=\"3\" x=\"5\" y=\"8\"/><rect height=\"2\" width=\"4\" x=\"9\" y=\"8\"/><rect height=\"2\" width=\"3\" x=\"5\" y=\"11\"/><rect height=\"2\" width=\"4\" x=\"9\" y=\"11\"/></g></svg>";
const $18092f99c50a7661$var$underlineIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-stroke\" d=\"M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3\"/><rect class=\"ql-fill\" height=\"1\" rx=\"0.5\" ry=\"0.5\" width=\"12\" x=\"3\" y=\"15\"/></svg>";
const $18092f99c50a7661$var$videoIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-stroke\" height=\"12\" width=\"12\" x=\"3\" y=\"3\"/><rect class=\"ql-fill\" height=\"12\" width=\"1\" x=\"5\" y=\"3\"/><rect class=\"ql-fill\" height=\"12\" width=\"1\" x=\"12\" y=\"3\"/><rect class=\"ql-fill\" height=\"2\" width=\"8\" x=\"5\" y=\"8\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"5\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"7\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"10\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"12\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"5\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"7\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"10\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"12\"/></svg>";
var $18092f99c50a7661$export$2e2bcd8739ae039 = {
    align: {
        '': $18092f99c50a7661$var$alignLeftIcon,
        center: $18092f99c50a7661$var$alignCenterIcon,
        right: $18092f99c50a7661$var$alignRightIcon,
        justify: $18092f99c50a7661$var$alignJustifyIcon
    },
    background: $18092f99c50a7661$var$backgroundIcon,
    blockquote: $18092f99c50a7661$var$blockquoteIcon,
    bold: $18092f99c50a7661$var$boldIcon,
    clean: $18092f99c50a7661$var$cleanIcon,
    code: $18092f99c50a7661$var$codeIcon,
    'code-block': $18092f99c50a7661$var$codeIcon,
    color: $18092f99c50a7661$var$colorIcon,
    direction: {
        '': $18092f99c50a7661$var$directionLeftToRightIcon,
        rtl: $18092f99c50a7661$var$directionRightToLeftIcon
    },
    formula: $18092f99c50a7661$var$formulaIcon,
    header: {
        '1': $18092f99c50a7661$var$headerIcon,
        '2': $18092f99c50a7661$var$header2Icon,
        '3': $18092f99c50a7661$var$header3Icon,
        '4': $18092f99c50a7661$var$header4Icon,
        '5': $18092f99c50a7661$var$header5Icon,
        '6': $18092f99c50a7661$var$header6Icon
    },
    italic: $18092f99c50a7661$var$italicIcon,
    image: $18092f99c50a7661$var$imageIcon,
    indent: {
        '+1': $18092f99c50a7661$var$indentIcon,
        '-1': $18092f99c50a7661$var$outdentIcon
    },
    link: $18092f99c50a7661$var$linkIcon,
    list: {
        bullet: $18092f99c50a7661$var$listBulletIcon,
        check: $18092f99c50a7661$var$listCheckIcon,
        ordered: $18092f99c50a7661$var$listOrderedIcon
    },
    script: {
        sub: $18092f99c50a7661$var$subscriptIcon,
        super: $18092f99c50a7661$var$superscriptIcon
    },
    strike: $18092f99c50a7661$var$strikeIcon,
    table: $18092f99c50a7661$var$tableIcon,
    underline: $18092f99c50a7661$var$underlineIcon,
    video: $18092f99c50a7661$var$videoIcon
};


const $eb6e70714479083b$var$DropdownIcon = "<svg viewbox=\"0 0 18 18\"><polygon class=\"ql-stroke\" points=\"7 11 9 13 11 11 7 11\"/><polygon class=\"ql-stroke\" points=\"7 7 9 5 11 7 7 7\"/></svg>";
let $eb6e70714479083b$var$optionsCounter = 0;
function $eb6e70714479083b$var$toggleAriaAttribute(element, attribute) {
    element.setAttribute(attribute, `${!(element.getAttribute(attribute) === 'true')}`);
}
class $eb6e70714479083b$var$Picker {
    constructor(select){
        this.select = select;
        this.container = document.createElement('span');
        this.buildPicker();
        this.select.style.display = 'none';
        // @ts-expect-error Fix me later
        this.select.parentNode.insertBefore(this.container, this.select);
        this.label.addEventListener('mousedown', ()=>{
            this.togglePicker();
        });
        this.label.addEventListener('keydown', (event)=>{
            switch(event.key){
                case 'Enter':
                    this.togglePicker();
                    break;
                case 'Escape':
                    this.escape();
                    event.preventDefault();
                    break;
                default:
            }
        });
        this.select.addEventListener('change', this.update.bind(this));
    }
    togglePicker() {
        this.container.classList.toggle('ql-expanded');
        // Toggle aria-expanded and aria-hidden to make the picker accessible
        $eb6e70714479083b$var$toggleAriaAttribute(this.label, 'aria-expanded');
        // @ts-expect-error
        $eb6e70714479083b$var$toggleAriaAttribute(this.options, 'aria-hidden');
    }
    buildItem(option) {
        const item = document.createElement('span');
        // @ts-expect-error
        item.tabIndex = '0';
        item.setAttribute('role', 'button');
        item.classList.add('ql-picker-item');
        const value = option.getAttribute('value');
        if (value) item.setAttribute('data-value', value);
        if (option.textContent) item.setAttribute('data-label', option.textContent);
        item.addEventListener('click', ()=>{
            this.selectItem(item, true);
        });
        item.addEventListener('keydown', (event)=>{
            switch(event.key){
                case 'Enter':
                    this.selectItem(item, true);
                    event.preventDefault();
                    break;
                case 'Escape':
                    this.escape();
                    event.preventDefault();
                    break;
                default:
            }
        });
        return item;
    }
    buildLabel() {
        const label = document.createElement('span');
        label.classList.add('ql-picker-label');
        label.innerHTML = $eb6e70714479083b$var$DropdownIcon;
        // @ts-expect-error
        label.tabIndex = '0';
        label.setAttribute('role', 'button');
        label.setAttribute('aria-expanded', 'false');
        this.container.appendChild(label);
        return label;
    }
    buildOptions() {
        const options = document.createElement('span');
        options.classList.add('ql-picker-options');
        // Don't want screen readers to read this until options are visible
        options.setAttribute('aria-hidden', 'true');
        // @ts-expect-error
        options.tabIndex = '-1';
        // Need a unique id for aria-controls
        options.id = `ql-picker-options-${$eb6e70714479083b$var$optionsCounter}`;
        $eb6e70714479083b$var$optionsCounter += 1;
        this.label.setAttribute('aria-controls', options.id);
        // @ts-expect-error
        this.options = options;
        Array.from(this.select.options).forEach((option)=>{
            const item = this.buildItem(option);
            options.appendChild(item);
            if (option.selected === true) this.selectItem(item);
        });
        this.container.appendChild(options);
    }
    buildPicker() {
        Array.from(this.select.attributes).forEach((item)=>{
            this.container.setAttribute(item.name, item.value);
        });
        this.container.classList.add('ql-picker');
        this.label = this.buildLabel();
        this.buildOptions();
    }
    escape() {
        // Close menu and return focus to trigger label
        this.close();
        // Need setTimeout for accessibility to ensure that the browser executes
        // focus on the next process thread and after any DOM content changes
        setTimeout(()=>this.label.focus(), 1);
    }
    close() {
        this.container.classList.remove('ql-expanded');
        this.label.setAttribute('aria-expanded', 'false');
        // @ts-expect-error
        this.options.setAttribute('aria-hidden', 'true');
    }
    selectItem(item) {
        let trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        const selected = this.container.querySelector('.ql-selected');
        if (item === selected) return;
        if (selected != null) selected.classList.remove('ql-selected');
        if (item == null) return;
        item.classList.add('ql-selected');
        // @ts-expect-error Fix me later
        this.select.selectedIndex = Array.from(item.parentNode.children).indexOf(item);
        if (item.hasAttribute('data-value')) // @ts-expect-error Fix me later
        this.label.setAttribute('data-value', item.getAttribute('data-value'));
        else this.label.removeAttribute('data-value');
        if (item.hasAttribute('data-label')) // @ts-expect-error Fix me later
        this.label.setAttribute('data-label', item.getAttribute('data-label'));
        else this.label.removeAttribute('data-label');
        if (trigger) {
            this.select.dispatchEvent(new Event('change'));
            this.close();
        }
    }
    update() {
        let option;
        if (this.select.selectedIndex > -1) {
            const item = // @ts-expect-error Fix me later
            this.container.querySelector('.ql-picker-options').children[this.select.selectedIndex];
            option = this.select.options[this.select.selectedIndex];
            // @ts-expect-error
            this.selectItem(item);
        } else this.selectItem(null);
        const isActive = option != null && option !== this.select.querySelector('option[selected]');
        this.label.classList.toggle('ql-active', isActive);
    }
}
var $eb6e70714479083b$export$2e2bcd8739ae039 = $eb6e70714479083b$var$Picker;



class $2b9b8c5555c7bb05$var$ColorPicker extends (0, $eb6e70714479083b$export$2e2bcd8739ae039) {
    constructor(select, label){
        super(select);
        this.label.innerHTML = label;
        this.container.classList.add('ql-color-picker');
        Array.from(this.container.querySelectorAll('.ql-picker-item')).slice(0, 7).forEach((item)=>{
            item.classList.add('ql-primary');
        });
    }
    buildItem(option) {
        const item = super.buildItem(option);
        item.style.backgroundColor = option.getAttribute('value') || '';
        return item;
    }
    selectItem(item, trigger) {
        super.selectItem(item, trigger);
        const colorLabel = this.label.querySelector('.ql-color-label');
        const value = item ? item.getAttribute('data-value') || '' : '';
        if (colorLabel) {
            if (colorLabel.tagName === 'line') colorLabel.style.stroke = value;
            else colorLabel.style.fill = value;
        }
    }
}
var $2b9b8c5555c7bb05$export$2e2bcd8739ae039 = $2b9b8c5555c7bb05$var$ColorPicker;



class $3679b0ee90acad55$var$IconPicker extends (0, $eb6e70714479083b$export$2e2bcd8739ae039) {
    constructor(select, icons){
        super(select);
        this.container.classList.add('ql-icon-picker');
        Array.from(this.container.querySelectorAll('.ql-picker-item')).forEach((item)=>{
            item.innerHTML = icons[item.getAttribute('data-value') || ''];
        });
        this.defaultItem = this.container.querySelector('.ql-selected');
        this.selectItem(this.defaultItem);
    }
    selectItem(target, trigger) {
        super.selectItem(target, trigger);
        const item = target || this.defaultItem;
        if (item != null) {
            if (this.label.innerHTML === item.innerHTML) return;
            this.label.innerHTML = item.innerHTML;
        }
    }
}
var $3679b0ee90acad55$export$2e2bcd8739ae039 = $3679b0ee90acad55$var$IconPicker;


const $5a93d0b080bf8d28$var$isScrollable = (el)=>{
    const { overflowY: overflowY } = getComputedStyle(el, null);
    return overflowY !== 'visible' && overflowY !== 'clip';
};
class $5a93d0b080bf8d28$var$Tooltip {
    constructor(quill, boundsContainer){
        this.quill = quill;
        this.boundsContainer = boundsContainer || document.body;
        this.root = quill.addContainer('ql-tooltip');
        // @ts-expect-error
        this.root.innerHTML = this.constructor.TEMPLATE;
        if ($5a93d0b080bf8d28$var$isScrollable(this.quill.root)) this.quill.root.addEventListener('scroll', ()=>{
            this.root.style.marginTop = `${-1 * this.quill.root.scrollTop}px`;
        });
        this.hide();
    }
    hide() {
        this.root.classList.add('ql-hidden');
    }
    position(reference) {
        const left = reference.left + reference.width / 2 - this.root.offsetWidth / 2;
        // root.scrollTop should be 0 if scrollContainer !== root
        const top = reference.bottom + this.quill.root.scrollTop;
        this.root.style.left = `${left}px`;
        this.root.style.top = `${top}px`;
        this.root.classList.remove('ql-flip');
        const containerBounds = this.boundsContainer.getBoundingClientRect();
        const rootBounds = this.root.getBoundingClientRect();
        let shift = 0;
        if (rootBounds.right > containerBounds.right) {
            shift = containerBounds.right - rootBounds.right;
            this.root.style.left = `${left + shift}px`;
        }
        if (rootBounds.left < containerBounds.left) {
            shift = containerBounds.left - rootBounds.left;
            this.root.style.left = `${left + shift}px`;
        }
        if (rootBounds.bottom > containerBounds.bottom) {
            const height = rootBounds.bottom - rootBounds.top;
            const verticalShift = reference.bottom - reference.top + height;
            this.root.style.top = `${top - verticalShift}px`;
            this.root.classList.add('ql-flip');
        }
        return shift;
    }
    show() {
        this.root.classList.remove('ql-editing');
        this.root.classList.remove('ql-hidden');
    }
}
var $5a93d0b080bf8d28$export$2e2bcd8739ae039 = $5a93d0b080bf8d28$var$Tooltip;











const $7bbf3cab9c94648f$var$ALIGNS = [
    false,
    'center',
    'right',
    'justify'
];
const $7bbf3cab9c94648f$var$COLORS = [
    '#000000',
    '#e60000',
    '#ff9900',
    '#ffff00',
    '#008a00',
    '#0066cc',
    '#9933ff',
    '#ffffff',
    '#facccc',
    '#ffebcc',
    '#ffffcc',
    '#cce8cc',
    '#cce0f5',
    '#ebd6ff',
    '#bbbbbb',
    '#f06666',
    '#ffc266',
    '#ffff66',
    '#66b966',
    '#66a3e0',
    '#c285ff',
    '#888888',
    '#a10000',
    '#b26b00',
    '#b2b200',
    '#006100',
    '#0047b2',
    '#6b24b2',
    '#444444',
    '#5c0000',
    '#663d00',
    '#666600',
    '#003700',
    '#002966',
    '#3d1466'
];
const $7bbf3cab9c94648f$var$FONTS = [
    false,
    'serif',
    'monospace'
];
const $7bbf3cab9c94648f$var$HEADERS = [
    '1',
    '2',
    '3',
    false
];
const $7bbf3cab9c94648f$var$SIZES = [
    'small',
    false,
    'large',
    'huge'
];
class $7bbf3cab9c94648f$export$2e2bcd8739ae039 extends (0, $8f053e3fa6387219$export$2e2bcd8739ae039) {
    constructor(quill, options){
        super(quill, options);
        const listener = (e)=>{
            if (!document.body.contains(quill.root)) {
                document.body.removeEventListener('click', listener);
                return;
            }
            if (this.tooltip != null && // @ts-expect-error
            !this.tooltip.root.contains(e.target) && // @ts-expect-error
            document.activeElement !== this.tooltip.textbox && !this.quill.hasFocus()) this.tooltip.hide();
            if (this.pickers != null) this.pickers.forEach((picker)=>{
                // @ts-expect-error
                if (!picker.container.contains(e.target)) picker.close();
            });
        };
        quill.emitter.listenDOM('click', document.body, listener);
    }
    addModule(name) {
        const module = super.addModule(name);
        if (name === 'toolbar') // @ts-expect-error
        this.extendToolbar(module);
        return module;
    }
    buildButtons(buttons, icons) {
        Array.from(buttons).forEach((button)=>{
            const className = button.getAttribute('class') || '';
            className.split(/\s+/).forEach((name)=>{
                if (!name.startsWith('ql-')) return;
                name = name.slice(3);
                if (icons[name] == null) return;
                if (name === 'direction') // @ts-expect-error
                button.innerHTML = icons[name][''] + icons[name].rtl;
                else if (typeof icons[name] === 'string') // @ts-expect-error
                button.innerHTML = icons[name];
                else {
                    // @ts-expect-error
                    const value = button.value || '';
                    // @ts-expect-error
                    if (value != null && icons[name][value]) // @ts-expect-error
                    button.innerHTML = icons[name][value];
                }
            });
        });
    }
    buildPickers(selects, icons) {
        this.pickers = Array.from(selects).map((select)=>{
            if (select.classList.contains('ql-align')) {
                if (select.querySelector('option') == null) $7bbf3cab9c94648f$var$fillSelect(select, $7bbf3cab9c94648f$var$ALIGNS);
                if (typeof icons.align === 'object') return new (0, $3679b0ee90acad55$export$2e2bcd8739ae039)(select, icons.align);
            }
            if (select.classList.contains('ql-background') || select.classList.contains('ql-color')) {
                const format = select.classList.contains('ql-background') ? 'background' : 'color';
                if (select.querySelector('option') == null) $7bbf3cab9c94648f$var$fillSelect(select, $7bbf3cab9c94648f$var$COLORS, format === 'background' ? '#ffffff' : '#000000');
                return new (0, $2b9b8c5555c7bb05$export$2e2bcd8739ae039)(select, icons[format]);
            }
            if (select.querySelector('option') == null) {
                if (select.classList.contains('ql-font')) $7bbf3cab9c94648f$var$fillSelect(select, $7bbf3cab9c94648f$var$FONTS);
                else if (select.classList.contains('ql-header')) $7bbf3cab9c94648f$var$fillSelect(select, $7bbf3cab9c94648f$var$HEADERS);
                else if (select.classList.contains('ql-size')) $7bbf3cab9c94648f$var$fillSelect(select, $7bbf3cab9c94648f$var$SIZES);
            }
            return new (0, $eb6e70714479083b$export$2e2bcd8739ae039)(select);
        });
        const update = ()=>{
            this.pickers.forEach((picker)=>{
                picker.update();
            });
        };
        this.quill.on((0, $8d79d079139d3d60$export$2e2bcd8739ae039).events.EDITOR_CHANGE, update);
    }
}
$7bbf3cab9c94648f$export$2e2bcd8739ae039.DEFAULTS = (0, $4dea300bb9269819$export$2e2bcd8739ae039)({}, (0, $8f053e3fa6387219$export$2e2bcd8739ae039).DEFAULTS, {
    modules: {
        toolbar: {
            handlers: {
                formula () {
                    this.quill.theme.tooltip.edit('formula');
                },
                image () {
                    let fileInput = this.container.querySelector('input.ql-image[type=file]');
                    if (fileInput == null) {
                        fileInput = document.createElement('input');
                        fileInput.setAttribute('type', 'file');
                        fileInput.setAttribute('accept', this.quill.uploader.options.mimetypes.join(', '));
                        fileInput.classList.add('ql-image');
                        fileInput.addEventListener('change', ()=>{
                            const range = this.quill.getSelection(true);
                            this.quill.uploader.upload(range, fileInput.files);
                            fileInput.value = '';
                        });
                        this.container.appendChild(fileInput);
                    }
                    fileInput.click();
                },
                video () {
                    this.quill.theme.tooltip.edit('video');
                }
            }
        }
    }
});
class $7bbf3cab9c94648f$export$ba0102162f9e195c extends (0, $5a93d0b080bf8d28$export$2e2bcd8739ae039) {
    constructor(quill, boundsContainer){
        super(quill, boundsContainer);
        this.textbox = this.root.querySelector('input[type="text"]');
        this.listen();
    }
    listen() {
        // @ts-expect-error Fix me later
        this.textbox.addEventListener('keydown', (event)=>{
            if (event.key === 'Enter') {
                this.save();
                event.preventDefault();
            } else if (event.key === 'Escape') {
                this.cancel();
                event.preventDefault();
            }
        });
    }
    cancel() {
        this.hide();
        this.restoreFocus();
    }
    edit() {
        let mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
        let preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        this.root.classList.remove('ql-hidden');
        this.root.classList.add('ql-editing');
        if (this.textbox == null) return;
        if (preview != null) this.textbox.value = preview;
        else if (mode !== this.root.getAttribute('data-mode')) this.textbox.value = '';
        const bounds = this.quill.getBounds(this.quill.selection.savedRange);
        if (bounds != null) this.position(bounds);
        this.textbox.select();
        this.textbox.setAttribute('placeholder', this.textbox.getAttribute(`data-${mode}`) || '');
        this.root.setAttribute('data-mode', mode);
    }
    restoreFocus() {
        this.quill.focus({
            preventScroll: true
        });
    }
    save() {
        // @ts-expect-error Fix me later
        let { value: value } = this.textbox;
        switch(this.root.getAttribute('data-mode')){
            case 'link':
                {
                    const { scrollTop: scrollTop } = this.quill.root;
                    if (this.linkRange) {
                        this.quill.formatText(this.linkRange, 'link', value, (0, $8d79d079139d3d60$export$2e2bcd8739ae039).sources.USER);
                        delete this.linkRange;
                    } else {
                        this.restoreFocus();
                        this.quill.format('link', value, (0, $8d79d079139d3d60$export$2e2bcd8739ae039).sources.USER);
                    }
                    this.quill.root.scrollTop = scrollTop;
                    break;
                }
            case 'video':
                value = $7bbf3cab9c94648f$var$extractVideoUrl(value);
            // eslint-disable-next-line no-fallthrough
            case 'formula':
                {
                    if (!value) break;
                    const range = this.quill.getSelection(true);
                    if (range != null) {
                        const index = range.index + range.length;
                        this.quill.insertEmbed(index, // @ts-expect-error Fix me later
                        this.root.getAttribute('data-mode'), value, (0, $8d79d079139d3d60$export$2e2bcd8739ae039).sources.USER);
                        if (this.root.getAttribute('data-mode') === 'formula') this.quill.insertText(index + 1, ' ', (0, $8d79d079139d3d60$export$2e2bcd8739ae039).sources.USER);
                        this.quill.setSelection(index + 2, (0, $8d79d079139d3d60$export$2e2bcd8739ae039).sources.USER);
                    }
                    break;
                }
            default:
        }
        // @ts-expect-error Fix me later
        this.textbox.value = '';
        this.hide();
    }
}
function $7bbf3cab9c94648f$var$extractVideoUrl(url) {
    let match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
    if (match) return `${match[1] || 'https'}://www.youtube.com/embed/${match[2]}?showinfo=0`;
    // eslint-disable-next-line no-cond-assign
    if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) return `${match[1] || 'https'}://player.vimeo.com/video/${match[2]}/`;
    return url;
}
function $7bbf3cab9c94648f$var$fillSelect(select, values) {
    let defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    values.forEach((value)=>{
        const option = document.createElement('option');
        if (value === defaultValue) option.setAttribute('selected', 'selected');
        else option.setAttribute('value', String(value));
        select.appendChild(option);
    });
}





const $c2a1de1e8c81e1ac$var$TOOLBAR_CONFIG = [
    [
        'bold',
        'italic',
        'link'
    ],
    [
        {
            header: 1
        },
        {
            header: 2
        },
        'blockquote'
    ]
];
class $c2a1de1e8c81e1ac$export$572b56f7a5e9813a extends (0, $7bbf3cab9c94648f$export$ba0102162f9e195c) {
    static TEMPLATE = [
        '<span class="ql-tooltip-arrow"></span>',
        '<div class="ql-tooltip-editor">',
        '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">',
        '<a class="ql-close"></a>',
        '</div>'
    ].join('');
    constructor(quill, bounds){
        super(quill, bounds);
        this.quill.on((0, $8d79d079139d3d60$export$2e2bcd8739ae039).events.EDITOR_CHANGE, (type, range, oldRange, source)=>{
            if (type !== (0, $8d79d079139d3d60$export$2e2bcd8739ae039).events.SELECTION_CHANGE) return;
            if (range != null && range.length > 0 && source === (0, $8d79d079139d3d60$export$2e2bcd8739ae039).sources.USER) {
                this.show();
                // Lock our width so we will expand beyond our offsetParent boundaries
                this.root.style.left = '0px';
                this.root.style.width = '';
                this.root.style.width = `${this.root.offsetWidth}px`;
                const lines = this.quill.getLines(range.index, range.length);
                if (lines.length === 1) {
                    const bounds = this.quill.getBounds(range);
                    if (bounds != null) this.position(bounds);
                } else {
                    const lastLine = lines[lines.length - 1];
                    const index = this.quill.getIndex(lastLine);
                    const length = Math.min(lastLine.length() - 1, range.index + range.length - index);
                    const indexBounds = this.quill.getBounds(new (0, $b3a4906c4c866f2e$export$9a58ef0d7ad3278c)(index, length));
                    if (indexBounds != null) this.position(indexBounds);
                }
            } else if (document.activeElement !== this.textbox && this.quill.hasFocus()) this.hide();
        });
    }
    listen() {
        super.listen();
        // @ts-expect-error Fix me later
        this.root.querySelector('.ql-close').addEventListener('click', ()=>{
            this.root.classList.remove('ql-editing');
        });
        this.quill.on((0, $8d79d079139d3d60$export$2e2bcd8739ae039).events.SCROLL_OPTIMIZE, ()=>{
            // Let selection be restored by toolbar handlers before repositioning
            setTimeout(()=>{
                if (this.root.classList.contains('ql-hidden')) return;
                const range = this.quill.getSelection();
                if (range != null) {
                    const bounds = this.quill.getBounds(range);
                    if (bounds != null) this.position(bounds);
                }
            }, 1);
        });
    }
    cancel() {
        this.show();
    }
    position(reference) {
        const shift = super.position(reference);
        const arrow = this.root.querySelector('.ql-tooltip-arrow');
        // @ts-expect-error
        arrow.style.marginLeft = '';
        if (shift !== 0) // @ts-expect-error
        arrow.style.marginLeft = `${-1 * shift - arrow.offsetWidth / 2}px`;
        return shift;
    }
}
class $c2a1de1e8c81e1ac$export$2e2bcd8739ae039 extends (0, $7bbf3cab9c94648f$export$2e2bcd8739ae039) {
    constructor(quill, options){
        if (options.modules.toolbar != null && options.modules.toolbar.container == null) options.modules.toolbar.container = $c2a1de1e8c81e1ac$var$TOOLBAR_CONFIG;
        super(quill, options);
        this.quill.container.classList.add('ql-bubble');
    }
    extendToolbar(toolbar) {
        // @ts-expect-error
        this.tooltip = new $c2a1de1e8c81e1ac$export$572b56f7a5e9813a(this.quill, this.options.bounds);
        if (toolbar.container != null) {
            this.tooltip.root.appendChild(toolbar.container);
            this.buildButtons(toolbar.container.querySelectorAll('button'), (0, $18092f99c50a7661$export$2e2bcd8739ae039));
            this.buildPickers(toolbar.container.querySelectorAll('select'), (0, $18092f99c50a7661$export$2e2bcd8739ae039));
        }
    }
}
$c2a1de1e8c81e1ac$export$2e2bcd8739ae039.DEFAULTS = (0, $4dea300bb9269819$export$2e2bcd8739ae039)({}, (0, $7bbf3cab9c94648f$export$2e2bcd8739ae039).DEFAULTS, {
    modules: {
        toolbar: {
            handlers: {
                link (value) {
                    if (!value) this.quill.format('link', false, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
                    else // @ts-expect-error
                    this.quill.theme.tooltip.edit();
                }
            }
        }
    }
});









const $6dfe6ed3893e241f$var$TOOLBAR_CONFIG = [
    [
        {
            header: [
                '1',
                '2',
                '3',
                false
            ]
        }
    ],
    [
        'bold',
        'italic',
        'underline',
        'link'
    ],
    [
        {
            list: 'ordered'
        },
        {
            list: 'bullet'
        }
    ],
    [
        'clean'
    ]
];
class $6dfe6ed3893e241f$var$SnowTooltip extends (0, $7bbf3cab9c94648f$export$ba0102162f9e195c) {
    static TEMPLATE = [
        '<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>',
        '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">',
        '<a class="ql-action"></a>',
        '<a class="ql-remove"></a>'
    ].join('');
    preview = this.root.querySelector('a.ql-preview');
    listen() {
        super.listen();
        // @ts-expect-error Fix me later
        this.root.querySelector('a.ql-action').addEventListener('click', (event)=>{
            if (this.root.classList.contains('ql-editing')) this.save();
            else // @ts-expect-error Fix me later
            this.edit('link', this.preview.textContent);
            event.preventDefault();
        });
        // @ts-expect-error Fix me later
        this.root.querySelector('a.ql-remove').addEventListener('click', (event)=>{
            if (this.linkRange != null) {
                const range = this.linkRange;
                this.restoreFocus();
                this.quill.formatText(range, 'link', false, (0, $8d79d079139d3d60$export$2e2bcd8739ae039).sources.USER);
                delete this.linkRange;
            }
            event.preventDefault();
            this.hide();
        });
        this.quill.on((0, $8d79d079139d3d60$export$2e2bcd8739ae039).events.SELECTION_CHANGE, (range, oldRange, source)=>{
            if (range == null) return;
            if (range.length === 0 && source === (0, $8d79d079139d3d60$export$2e2bcd8739ae039).sources.USER) {
                const [link, offset] = this.quill.scroll.descendant((0, $fc7bc1d44330de59$export$2e2bcd8739ae039), range.index);
                if (link != null) {
                    this.linkRange = new (0, $b3a4906c4c866f2e$export$9a58ef0d7ad3278c)(range.index - offset, link.length());
                    const preview = (0, $fc7bc1d44330de59$export$2e2bcd8739ae039).formats(link.domNode);
                    // @ts-expect-error Fix me later
                    this.preview.textContent = preview;
                    // @ts-expect-error Fix me later
                    this.preview.setAttribute('href', preview);
                    this.show();
                    const bounds = this.quill.getBounds(this.linkRange);
                    if (bounds != null) this.position(bounds);
                    return;
                }
            } else delete this.linkRange;
            this.hide();
        });
    }
    show() {
        super.show();
        this.root.removeAttribute('data-mode');
    }
}
class $6dfe6ed3893e241f$var$SnowTheme extends (0, $7bbf3cab9c94648f$export$2e2bcd8739ae039) {
    constructor(quill, options){
        if (options.modules.toolbar != null && options.modules.toolbar.container == null) options.modules.toolbar.container = $6dfe6ed3893e241f$var$TOOLBAR_CONFIG;
        super(quill, options);
        this.quill.container.classList.add('ql-snow');
    }
    extendToolbar(toolbar) {
        if (toolbar.container != null) {
            toolbar.container.classList.add('ql-snow');
            this.buildButtons(toolbar.container.querySelectorAll('button'), (0, $18092f99c50a7661$export$2e2bcd8739ae039));
            this.buildPickers(toolbar.container.querySelectorAll('select'), (0, $18092f99c50a7661$export$2e2bcd8739ae039));
            // @ts-expect-error
            this.tooltip = new $6dfe6ed3893e241f$var$SnowTooltip(this.quill, this.options.bounds);
            if (toolbar.container.querySelector('.ql-link')) this.quill.keyboard.addBinding({
                key: 'k',
                shortKey: true
            }, (_range, context)=>{
                toolbar.handlers.link.call(toolbar, !context.format.link);
            });
        }
    }
}
$6dfe6ed3893e241f$var$SnowTheme.DEFAULTS = (0, $4dea300bb9269819$export$2e2bcd8739ae039)({}, (0, $7bbf3cab9c94648f$export$2e2bcd8739ae039).DEFAULTS, {
    modules: {
        toolbar: {
            handlers: {
                link (value) {
                    if (value) {
                        const range = this.quill.getSelection();
                        if (range == null || range.length === 0) return;
                        let preview = this.quill.getText(range);
                        if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf('mailto:') !== 0) preview = `mailto:${preview}`;
                        // @ts-expect-error
                        const { tooltip: tooltip } = this.quill.theme;
                        tooltip.edit('link', preview);
                    } else this.quill.format('link', false, (0, $f2fc927e4ed7c435$export$2e2bcd8739ae039).sources.USER);
                }
            }
        }
    }
});
var $6dfe6ed3893e241f$export$2e2bcd8739ae039 = $6dfe6ed3893e241f$var$SnowTheme;


(0, $d42578f98d4c3164$export$2e2bcd8739ae039).register({
    'attributors/attribute/direction': (0, $a2626d0dc7de782b$export$4158215dafad9efa),
    'attributors/class/align': (0, $46becb55ac73c7d6$export$7f3685f5846c07da),
    'attributors/class/background': (0, $2f71c8f40f0309fa$export$8aa96c8963152b12),
    'attributors/class/color': (0, $73f85d61d1cfa261$export$42795dcf0ec6f3c8),
    'attributors/class/direction': (0, $a2626d0dc7de782b$export$630028b3af294dec),
    'attributors/class/font': (0, $2a028af46fe54a35$export$78a99ee601572ab),
    'attributors/class/size': (0, $f9040a7bf4f5573f$export$c84684d52bca9684),
    'attributors/style/align': (0, $46becb55ac73c7d6$export$d2060f5d114c9fe8),
    'attributors/style/background': (0, $2f71c8f40f0309fa$export$dc1cbcab4c682ef),
    'attributors/style/color': (0, $73f85d61d1cfa261$export$1415f56796d9a5a9),
    'attributors/style/direction': (0, $a2626d0dc7de782b$export$175979e518d1dfd1),
    'attributors/style/font': (0, $2a028af46fe54a35$export$23b468d4ca3f8c96),
    'attributors/style/size': (0, $f9040a7bf4f5573f$export$5443b95a30e89ac5)
}, true);
(0, $d42578f98d4c3164$export$2e2bcd8739ae039).register({
    'formats/align': (0, $46becb55ac73c7d6$export$7f3685f5846c07da),
    'formats/direction': (0, $a2626d0dc7de782b$export$630028b3af294dec),
    'formats/indent': (0, $31292d57a9a2820d$export$2e2bcd8739ae039),
    'formats/background': (0, $2f71c8f40f0309fa$export$dc1cbcab4c682ef),
    'formats/color': (0, $73f85d61d1cfa261$export$1415f56796d9a5a9),
    'formats/font': (0, $2a028af46fe54a35$export$78a99ee601572ab),
    'formats/size': (0, $f9040a7bf4f5573f$export$c84684d52bca9684),
    'formats/blockquote': (0, $3cd36aae285c93dc$export$2e2bcd8739ae039),
    'formats/code-block': (0, $c2ac4be2a790a238$export$2e2bcd8739ae039),
    'formats/header': (0, $1c7ad43b1cf874cc$export$2e2bcd8739ae039),
    'formats/list': (0, $239ce2e44c993438$export$2e2bcd8739ae039),
    'formats/bold': (0, $2cbff3bb34c6b593$export$2e2bcd8739ae039),
    'formats/code': (0, $c2ac4be2a790a238$export$52f0f02147b12c03),
    'formats/italic': (0, $6453543bdd43d36f$export$2e2bcd8739ae039),
    'formats/link': (0, $fc7bc1d44330de59$export$2e2bcd8739ae039),
    'formats/script': (0, $d295522436ad41e0$export$2e2bcd8739ae039),
    'formats/strike': (0, $951803218a1aaa90$export$2e2bcd8739ae039),
    'formats/underline': (0, $064a335b69e61eaf$export$2e2bcd8739ae039),
    'formats/formula': (0, $3a0c6ad9122ac914$export$2e2bcd8739ae039),
    'formats/image': (0, $f5e5180db55b7783$export$2e2bcd8739ae039),
    'formats/video': (0, $6207c271ebc5873b$export$2e2bcd8739ae039),
    'modules/syntax': (0, $7fd6118b9b50b99a$export$2e2bcd8739ae039),
    'modules/table': (0, $ccf17529e6ac36b2$export$2e2bcd8739ae039),
    'modules/toolbar': (0, $c5297f7eb4c02af6$export$2e2bcd8739ae039),
    'themes/bubble': (0, $c2a1de1e8c81e1ac$export$2e2bcd8739ae039),
    'themes/snow': (0, $6dfe6ed3893e241f$export$2e2bcd8739ae039),
    'ui/icons': (0, $18092f99c50a7661$export$2e2bcd8739ae039),
    'ui/picker': (0, $eb6e70714479083b$export$2e2bcd8739ae039),
    'ui/icon-picker': (0, $3679b0ee90acad55$export$2e2bcd8739ae039),
    'ui/color-picker': (0, $2b9b8c5555c7bb05$export$2e2bcd8739ae039),
    'ui/tooltip': (0, $5a93d0b080bf8d28$export$2e2bcd8739ae039)
}, true);
var $dee3ca9eb659e93c$export$2e2bcd8739ae039 = (0, $d42578f98d4c3164$export$2e2bcd8739ae039);




var $8FY87 = parcelRequire("8FY87");

// Editor is an uncontrolled React component
const $73dfbc6c9ba1cad1$var$Editor = /*#__PURE__*/ (0, $8FY87.forwardRef)(({ readOnly: readOnly, siteId: siteId, defaultValue: defaultValue, content: content, onTextChange: onTextChange, onSelectionChange: onSelectionChange, error: error }, ref)=>{
    const containerRef = (0, $8FY87.useRef)(null);
    // const defaultValueRef = useRef(defaultValue);
    const onTextChangeRef = (0, $8FY87.useRef)(onTextChange);
    const onSelectionChangeRef = (0, $8FY87.useRef)(onSelectionChange);
    const [showImageUpload, setShowImageUpload] = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useState(false);
    const [range, setRange] = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useState(null);
    (0, $8FY87.useLayoutEffect)(()=>{
        onTextChangeRef.current = onTextChange;
        onSelectionChangeRef.current = onSelectionChange;
    });
    (0, $8FY87.useEffect)(()=>{
        ref.current?.enable(!readOnly);
    }, [
        ref,
        readOnly
    ]);
    (0, $8FY87.useEffect)(()=>{
        if (ref?.current?.root) ref.current.root.innerHTML = content;
    }, [
        content
    ]);
    (0, $8FY87.useEffect)(()=>{
        const container = containerRef.current;
        const editorContainer = container.appendChild(container.ownerDocument.createElement('div'));
        const quill = new (0, $dee3ca9eb659e93c$export$2e2bcd8739ae039)(editorContainer, {
            modules: {
                toolbar: {
                    container: [
                        [
                            // { 'font': [] }, 
                            {
                                'size': []
                            }
                        ],
                        [
                            'bold',
                            'italic',
                            'underline',
                            'strike'
                        ],
                        [
                            {
                                'color': []
                            },
                            {
                                'background': []
                            }
                        ],
                        [
                            {
                                'script': 'super'
                            },
                            {
                                'script': 'sub'
                            }
                        ],
                        [
                            {
                                'header': '1'
                            },
                            {
                                'header': '2'
                            },
                            'blockquote',
                            'code-block'
                        ],
                        [
                            {
                                'list': 'ordered'
                            },
                            {
                                'list': 'bullet'
                            },
                            {
                                'indent': '-1'
                            },
                            {
                                'indent': '+1'
                            }
                        ],
                        [
                            'direction',
                            {
                                'align': []
                            }
                        ],
                        [
                            'link',
                            'image',
                            'video',
                            'formula'
                        ],
                        [
                            'clean'
                        ]
                    ],
                    handlers: {
                        'image': ()=>{
                            // setShowImageUpload(true);
                            const range = ref.current.getSelection();
                            // setRange(range);
                            insertImage('https://pagebuilder-images-bucket.s3.amazonaws.com/01c1d933-53c9-4b12-803a-b264d5e94cd7-ScreenshotatPM.png');
                        }
                    }
                }
            },
            placeholder: 'Enter post content here...',
            theme: 'snow'
        });
        ref.current = quill;
        if (content) // quill.setContents(defaultValue);
        quill.root.innerHTML = content;
        quill.on((0, $dee3ca9eb659e93c$export$2e2bcd8739ae039).events.TEXT_CHANGE, (...args)=>{
            onTextChangeRef.current?.(quill.root.innerHTML);
        });
        quill.on((0, $dee3ca9eb659e93c$export$2e2bcd8739ae039).events.SELECTION_CHANGE, (...args)=>{
            onSelectionChangeRef.current?.(...args);
        });
        return ()=>{
            ref.current = null;
            container.innerHTML = '';
        };
    }, [
        ref
    ]);
    function insertImage(url) {
        console.log('insertImage', url);
        // const range = ref.current.getSelection();
        ref.current.insertEmbed(range?.index, 'image', url);
        setShowImageUpload(false);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: error ? 'border border-red-300' : 'py-1',
        ref: containerRef
    }), showImageUpload && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        style: {
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 100,
            backgroundColor: 'white',
            borderRadius: '10px',
            width: '80%',
            height: '80%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $4a7775f76d2692f7$export$2e2bcd8739ae039), {
        siteId: siteId,
        onClose: ()=>setShowImageUpload(false),
        onSelect: (url)=>insertImage(url)
    })), !!error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "text-red-500 text-sm"
    }, error));
});
$73dfbc6c9ba1cad1$var$Editor.displayName = 'Editor';
var $73dfbc6c9ba1cad1$export$2e2bcd8739ae039 = $73dfbc6c9ba1cad1$var$Editor;


function $ee28cd68f760d0bd$export$2e2bcd8739ae039(props) {
    const quillRef = (0, $8FY87.useRef)(null);
    const [postData, setPostData] = (0, $8FY87.useState)(props?.post ?? {}); // form data
    const [post, setPost] = (0, $8FY87.useState)({}); // post we get from backend (full data in here)
    const [errors, setErrors] = (0, $8FY87.useState)({});
    const [isLoading, setIsLoading] = (0, $8FY87.useState)(false);
    const { enqueueSnackbar: enqueueSnackbar } = (0, $5e19452f9528802f$export$1c97ac2c9a6e7c09)();
    (0, $8FY87.useEffect)(()=>{
        if (!props.post) return;
        (async ()=>{
            const post = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).get('/api/configs/post-for-admin', {
                params: {
                    id: props.post?.id
                }
            });
            console.log('post.data', post.data);
            setPost(post.data.post);
            setPostData(post.data.post);
        })();
    }, []);
    const validateForm = (action = 'save')=>{
        const errors = {};
        if (!postData.title) errors['title'] = 'Title is required';
        let isSlugAlreadyUsed = !!props.posts.find((p)=>p.slug === postData.slug && p.id !== postData.id); // find if slug is already used
        if (isSlugAlreadyUsed) errors['slug'] = 'Slug is already used';
        if (!postData.slug) errors['slug'] = 'Slug is required';
        if (action === 'publish') {
            if (!postData.bannerImage) errors['bannerImage'] = 'Banner image is required';
            if (!postData.bannerImageAlt) errors['bannerImageAlt'] = 'Banner image alt text is required';
            if (!quillRef.current?.root.innerText) errors['content'] = 'Content is required';
            else if (quillRef.current?.root.innerText.length < 50) errors['content'] = 'Content should be atleast 50 characters';
        }
        console.log('errors', errors, {
            ...postData,
            innerText: quillRef.current?.root?.innerText
        });
        setErrors(errors);
        if (Object.keys(errors).length > 0) {
            // scroll to top smoothly
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
            enqueueSnackbar('Please fix errors!', {
                variant: 'error'
            });
        }
        return Object.keys(errors).length === 0;
    };
    const handleBlogCreate = async ()=>{
        setIsLoading(true);
        const innerText = quillRef?.current?.root.innerHTML;
        setPostData({
            ...postData,
            content: innerText
        });
        if (!validateForm(!post?.publishedAt ? 'save' : 'publish')) {
            setIsLoading(false);
            return;
        }
        const assets = getImageUrlsFromContent(innerText);
        const res = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post('/api/configs/post-for-admin', {
            ...post,
            ...postData,
            siteId: props.siteId,
            content: innerText,
            assets: assets
        });
        if (res.data.error) {
            enqueueSnackbar(res.data.error, {
                variant: 'error'
            });
            setIsLoading(false);
            return;
        }
        setPost(res.data.data);
        setPostData(res.data.data);
        props.onPostUpdateOrCreate && props.onPostUpdateOrCreate(res.data.data);
        if (!post.publishedAt) enqueueSnackbar('Post saved successfully', {
            variant: 'success'
        });
        else enqueueSnackbar('Post saved successfully. \nWe\'ll notify you once it\'s published.', {
            variant: 'success'
        });
        setIsLoading(false);
    };
    const handleBlogPublish = async ()=>{
        if (!post?.id) return;
        setIsLoading(true);
        if (!validateForm('publish')) {
            setIsLoading(false);
            return;
        }
        const res = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post('/api/configs/post-for-admin', {
            id: post.id,
            siteId: props.siteId,
            publish: true
        });
        if (res.data.error) {
            enqueueSnackbar(res.data.error, {
                variant: 'error'
            });
            setIsLoading(false);
            return;
        }
        setPost(res.data.data);
        props.onPostUpdateOrCreate && props.onPostUpdateOrCreate(res.data.data);
        enqueueSnackbar("Post saved successfully. \nWe'll notify you once it's published.", {
            variant: 'success'
        });
        setIsLoading(false);
    };
    /**
   * get images embedded in the content text
   * we need these to upload to caddy server
   */ function getImageUrlsFromContent(htmlContent) {
        // Create a hidden DOM element
        const div = document.createElement('div');
        div.innerHTML = htmlContent;
        // Query for all img elements
        const imgElements = div.querySelectorAll('img');
        // Extract the src attribute from each img element
        const imageUrls = Array.from(imgElements).map((img)=>img.src).filter((src)=>src.startsWith('https://pagebuilder-images-bucket.s3.amazonaws.com'));
        return imageUrls;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", null, props.onBackClick && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex justify-between items-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        className: "py-1 lg:my-6 my-2 rounded-md",
        sx: {
            textTransform: "none"
        },
        variant: "contained",
        onClick: (e)=>props.onBackClick(),
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($710cce91ee8d14b2$exports))), {
        sx: {
            height: "22px",
            width: "22px",
            marginRight: 0.5
        }
    }), "Back")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex lg:flex-row flex-col"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "image-upload-box"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $4d9d5f5bbbfa7366$export$2e2bcd8739ae039), {
        size: "full",
        image_url: post?.bannerImage,
        siteId: props.siteId,
        title: "Post Cover image",
        notes: "Please upload a .PNG or .JPG image.",
        onImageChange: (img_url)=>setPostData({
                ...postData,
                bannerImage: img_url
            }),
        error: !!errors['bannerImage'],
        altError: !!errors['bannerImageAlt'],
        showAlt: true,
        altValue: postData?.bannerImageAlt,
        onAltChange: (value)=>setPostData({
                ...postData,
                bannerImageAlt: value
            })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "w-full"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "lg:ml-10 ml-0 "
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        className: "text-base-2 mb-2  text-grey-primary"
    }, "Post Url"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $c377b489c6c5df10$export$2e2bcd8739ae039), {
        defaultValue: props?.post?.slug,
        className: "w-full border rounded border-catelina-blue/60 py-1 text-base-2 mb-3  bg-white",
        onChange: (e)=>setPostData({
                ...postData,
                slug: e.target.value
            }),
        size: "small",
        InputProps: {
            startAdornment: 'xyz.rocketpages.io/blog/',
            classes: {
                input: 'text-base-2'
            },
            sx: {
                fontSize: '16px',
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#24306099',
                    borderWidth: 1
                }
            }
        },
        error: !!errors['slug'],
        helperText: errors['slug']
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        className: "text-base-2 mb-2  text-grey-primary"
    }, "Post Title"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $c377b489c6c5df10$export$2e2bcd8739ae039), {
        defaultValue: props?.post?.title,
        className: "w-full border rounded border-red py-1 text-base-2 mb-3  bg-white",
        placeholder: "Post Title",
        onChange: (e)=>setPostData({
                ...postData,
                title: e.target.value
            }),
        size: "small",
        error: !!errors['title'],
        helperText: errors['title'],
        InputProps: {
            classes: {
                input: 'text-base'
            },
            sx: {
                fontSize: '16px',
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#24306099',
                    borderWidth: 1
                }
            }
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        className: "text-base-2 mb-2  text-grey-primary"
    }, "Post Meta Description"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $c377b489c6c5df10$export$2e2bcd8739ae039), {
        value: postData?.metaDesc,
        className: "w-full border rounded border-red py-1 text-base-2 mb-3  bg-white",
        placeholder: "Post Meta Description",
        onChange: (e)=>setPostData({
                ...postData,
                metaDesc: e.target.value
            }),
        size: "small",
        error: !!errors['metaDesc'],
        helperText: errors['metaDesc'],
        InputProps: {
            classes: {
                input: 'text-base'
            },
            sx: {
                fontSize: '16px',
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#24306099',
                    borderWidth: 1
                }
            }
        }
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        className: "text-lg mb-2  text-grey-primary"
    }, "Post Body"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $73dfbc6c9ba1cad1$export$2e2bcd8739ae039), {
        ref: quillRef,
        siteId: props.siteId,
        content: post?.content,
        error: errors['content']
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex justify-end"
    }, post.publishedAt && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        className: "py-1 my-6 mr-4",
        sx: {
            textTransform: "none"
        },
        variant: "contained",
        color: "error",
        disableElevation: true,
        onClick: (e)=>props.onPostDelete()
    }, "Delete"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        className: "py-1 my-6 rounded-md",
        disabled: isLoading,
        sx: {
            textTransform: "none"
        },
        variant: !post?.publishedAt ? "outlined" : "contained",
        onClick: (e)=>handleBlogCreate(),
        disableElevation: true
    }, post?.publishedAt ? 'Save & Publish' : 'Save'), !post?.publishedAt && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        disabled: !post?.id || isLoading,
        className: "py-1 my-6 ml-4 rounded-md",
        sx: {
            textTransform: "none"
        },
        variant: "contained",
        onClick: (e)=>handleBlogPublish()
    }, "Publish")));
}




var $8FY87 = parcelRequire("8FY87");

function $4725a2d4f0317f8f$export$2e2bcd8739ae039(props) {
    const [blogDetails, setBlogDetails] = (0, $8FY87.useState)(props?.blogConfig?.blog ?? {
        url: 'blog'
    });
    const [errors, setErrors] = (0, $8FY87.useState)({});
    (0, $8FY87.useEffect)(()=>{
        // if (!props?.blogConfig?.blog?.url) return;
        const url = props?.blogConfig?.blog?.url?.startsWith('/') ? props?.blogConfig?.blog?.url?.substr(1) : props?.blogConfig?.blog?.url;
        setBlogDetails({
            ...props?.blogConfig?.blog,
            url: url || 'blog'
        });
    }, [
        JSON.stringify(props?.blogConfig?.blog ?? {})
    ]);
    const validateForm = ()=>{
        const errors = {};
        if (!blogDetails.title) errors['title'] = 'Title is required';
        if (!blogDetails.desc) errors['desc'] = 'Description is required';
        if (!blogDetails.url) errors['url'] = 'Blog URL is required';
        else if (props.sitePages?.map((page)=>page?.pageUrl?.split('/')?.filter((urlSection)=>urlSection !== '/' && !!urlSection)[0]).find((url)=>url === blogDetails.url)) errors['url'] = 'Page already exists with this URL';
        if (!blogDetails.metaImage) errors['metaImage'] = 'Meta Image is required';
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };
    const handleSave = ()=>{
        if (!validateForm()) return;
        props.onBlogConfigChange({
            ...props.blogConfig,
            blog: {
                ...props.blogConfig.blog,
                ...blogDetails
            }
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex gap-10 flex-col-reverse lg:flex-row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "image-upload-box"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $4d9d5f5bbbfa7366$export$2e2bcd8739ae039), {
        size: "full",
        image_url: blogDetails?.metaImage,
        siteId: props.siteId,
        title: "Bloglist Meta Image",
        notes: "Please upload a .PNG or .JPG image.",
        onImageChange: (img_url)=>setBlogDetails({
                ...blogDetails,
                metaImage: img_url
            }),
        error: !!errors['metaImage'],
        altError: !!errors['metaImageAlt'],
        showAlt: true,
        altValue: blogDetails?.metaImageAlt,
        onAltChange: (value)=>setBlogDetails({
                ...blogDetails,
                metaImageAlt: value
            })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "w-full"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        className: "text-base-2 mb-2  text-grey-primary"
    }, "Blog Title"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $c377b489c6c5df10$export$2e2bcd8739ae039), {
        value: blogDetails?.title,
        className: "w-full border rounded border-red py-1 text-base-2 mb-3  bg-white",
        placeholder: "Blog Title",
        onChange: (e)=>setBlogDetails({
                ...blogDetails,
                title: e.target.value
            }),
        size: "small",
        error: !!errors['title'],
        helperText: errors['title'],
        InputProps: {
            classes: {
                input: 'text-base'
            },
            sx: {
                fontSize: '16px',
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#24306099',
                    borderWidth: 1
                }
            }
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        className: "text-base-2 mb-2  text-grey-primary"
    }, "Blog Description"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $c377b489c6c5df10$export$2e2bcd8739ae039), {
        value: blogDetails?.desc,
        className: "w-full border rounded border-red py-1 text-base-2 mb-3  bg-white",
        placeholder: "Blog Description",
        onChange: (e)=>setBlogDetails({
                ...blogDetails,
                desc: e.target.value
            }),
        size: "small",
        error: !!errors['desc'],
        helperText: errors['desc'],
        InputProps: {
            classes: {
                input: 'text-base'
            },
            sx: {
                fontSize: '16px',
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#24306099',
                    borderWidth: 1
                }
            }
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("label", {
        className: "md:text-base-2 text-md mb-2 text-grey-primary flex"
    }, "Blog URL"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $c377b489c6c5df10$export$2e2bcd8739ae039), {
        value: blogDetails?.url,
        // value={blogUrl ?? ''}
        className: "w-full border rounded border-catelina-blue/60  text-base  mr-4 ",
        onChange: (e)=>{
            let value = e.target.value;
            if (value.startsWith('/')) value = value.substring(1);
            if (value.endsWith('/')) value = value.substring(0, value.length - 1);
            setBlogDetails({
                ...blogDetails,
                url: value
            });
        },
        // size="small"
        error: !!errors['url'],
        helperText: errors['url'] ?? '',
        InputProps: {
            startAdornment: 'xyz.rocketpages.io/',
            sx: {
                fontSize: '16px',
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#24306099',
                    borderWidth: 1
                }
            },
            classes: {
                input: 'py-2 text-base'
            }
        },
        sx: {
            padding: '0'
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex justify-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        id: "save",
        className: "py-1 md:w-20 w-full md:mt-0 mt-2  rounded-md",
        sx: {
            textTransform: "none"
        },
        variant: "contained",
        disabled: JSON.stringify(blogDetails) === JSON.stringify(props?.blogConfig?.blog),
        onClick: handleSave
    }, "Save")));
}


function $d4b0116acf67651f$export$2e2bcd8739ae039(props) {
    const [posts, setPosts] = (0, $8FY87.useState)([]);
    const [showDeleteDialog, setShowDeleteDialog] = (0, $8FY87.useState)(false);
    const [currentPage, setCurrentPage] = (0, $8FY87.useState)(1);
    const [editMode, setEditMode] = (0, $8FY87.useState)(false);
    const [currentEditPost, setCurrentEditPost] = (0, $8FY87.useState)(props?.blogConfig?.blog ?? {});
    const [tab, setTab] = (0, $8FY87.useState)(0);
    (0, $8FY87.useEffect)(()=>{
        fetchPosts();
    }, []);
    const fetchPosts = async ()=>{
        const posts = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).get('/api/configs/posts-for-admin', {
            params: {
                siteId: props.siteId
            }
        });
        console.log('posts.data', posts.data);
        setPosts(posts.data?.posts?.sort((a, b)=>{
            let dateA = new Date(a.createdAt);
            let dateB = new Date(b.createdAt);
            return dateB - dateA;
        }) ?? []);
    // setTotalPosts(posts.data?.count ?? 0);
    };
    // click of back button
    const handleBack = ()=>{
        setEditMode(false);
        setCurrentEditPost(null);
    };
    // if a post is updated from child component,
    // we update the posts array to update paginated list
    const handlePostUpdateOrCreate = (post)=>{
        if (post.id) {
            const idx = posts.findIndex((p)=>p.id === post.id);
            if (idx !== -1) posts[idx] = post;
            else posts.unshift(post);
        }
        setPosts(posts);
        if (post.publishedAt) props.listenToBlogPublish();
    // setEditMode(false);
    // setCurrentEditPost(null);
    };
    const handleDeletePost = async ()=>{
        if (!currentEditPost) return;
        const res = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).delete('/api/configs/post-for-admin', {
            params: {
                id: currentEditPost.id
            }
        });
        console.log('res', res);
        const idx = posts.findIndex((p)=>p.id === currentEditPost.id);
        if (idx !== -1) posts.splice(idx, 1);
        setPosts(posts);
        setShowDeleteDialog(false);
        setCurrentEditPost(null);
        setEditMode(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", null, !editMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $4725a2d4f0317f8f$export$2e2bcd8739ae039), {
        blogConfig: props.blogConfig,
        sitePages: props.sitePages,
        onBlogConfigChange: props.onBlogConfigChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $30a538faf9a95dbb$export$2e2bcd8739ae039), {
        className: "md:mt-10 mt-4",
        sx: {
            '&.MuiDivider-root': {
                borderColor: '#3B3B3B66'
            }
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex justify-between items-center my-5 bg-white border border-catelina-blue/20 py-2 px-4 rounded-md"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("h1", {
        className: "text-lg my-0"
    }, "Posts"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        id: "add",
        className: "py-1.5 px-4 rounded-md text-base",
        sx: {
            textTransform: "none"
        },
        variant: "contained",
        onClick: (e)=>setEditMode(true)
    }, "Create New Post")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement($d4b0116acf67651f$var$BlogList, {
        posts: posts,
        currentPage: currentPage,
        setCurrentPage: setCurrentPage,
        setEditMode: setEditMode,
        setCurrentEditPost: setCurrentEditPost,
        setShowDeleteDialog: setShowDeleteDialog,
        tab: tab,
        setTab: setTab
    })), editMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $ee28cd68f760d0bd$export$2e2bcd8739ae039), {
        posts: posts,
        siteId: props.siteId,
        onBackClick: handleBack,
        post: currentEditPost,
        onPostUpdateOrCreate: handlePostUpdateOrCreate,
        onPostDelete: ()=>setShowDeleteDialog(true)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement($d4b0116acf67651f$var$BlogDeleteDialog, {
        showDeleteDialog: showDeleteDialog,
        setShowDeleteDialog: setShowDeleteDialog,
        handleDeletePost: handleDeletePost
    }));
}



const $d4b0116acf67651f$var$BlogList = ({ posts: posts, currentPage: currentPage, setCurrentPage: setCurrentPage, setEditMode: setEditMode, setCurrentEditPost: setCurrentEditPost, setShowDeleteDialog: setShowDeleteDialog, tab: tab, setTab: setTab })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $0181e7500204b60c$export$2e2bcd8739ae039), {
        value: tab,
        onChange: (e, newValue)=>{
            setCurrentPage(1);
            setTab(newValue);
        },
        className: "mb-4 border-b-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $e7d54e7d83e3c56c$export$2e2bcd8739ae039), {
        sx: {
            '&.MuiTab-root': {
                textTransform: 'capitalize'
            }
        },
        label: `Published (${posts.filter((post)=>post.publishedAt).length})`,
        ...$d4b0116acf67651f$var$a11yProps(0)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $e7d54e7d83e3c56c$export$2e2bcd8739ae039), {
        sx: {
            '&.MuiTab-root': {
                textTransform: 'capitalize'
            }
        },
        label: `Drafts (${posts.filter((post)=>!post.publishedAt).length})`,
        ...$d4b0116acf67651f$var$a11yProps(1)
    })), posts.filter((_, idx)=>(currentPage - 1) * 10 < idx + 1 && idx <= currentPage * 10 && (tab === 0 ? _.publishedAt : !_.publishedAt)).map((post)=>{
        const postDate = new Date(post.createdAt);
        const formattedDate = postDate.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: '2-digit'
        }).replace(/\//g, '-');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
            key: post.id,
            className: "flex justify-between bg-white mb-4 p-6 rounded-md border border-[#E1E4EF] items-start md:flex-row flex-col relative"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
            className: "flex mr-0 md:mr-10 md:flex-row flex-col"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
            className: "border border-[#24306099] bg-[#FAFAFA] h-12 justify-center flex rounded-[6px]",
            style: {
                minWidth: '100px',
                width: '100px'
            }
        }, post.bannerImage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("img", {
            src: post.bannerImage,
            alt: post.title,
            className: " object-cover rounded-[6px] w-full"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("img", {
            src: (parcelRequire("53tPM")),
            alt: post.title,
            width: "30px"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
            className: "md:ml-4 ml-0 md:mt-0 mt-4"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", {
            className: "text-grey-primary font-bold mb-0"
        }, post.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", {
            className: "text-grey-primary text-sm mb-0"
        }, formattedDate))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
            className: "flex items-center  justify-end w-full  md:w-auto edit-delete-icon"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("img", {
            className: "lg:mr-3 mr-2",
            width: "20",
            src: (parcelRequire("iAm4v")),
            onClick: ()=>{
                setCurrentEditPost(post);
                setEditMode(true);
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("img", {
            className: "lg:ml-4 ml-2",
            width: "20",
            src: (parcelRequire("4o8JF")),
            onClick: ()=>{
                setCurrentEditPost(post);
                setShowDeleteDialog(true);
            }
        })));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "flex justify-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $ba2c328083ea94b4$export$2e2bcd8739ae039), {
        hidden: posts.filter((_)=>tab === 0 ? _.publishedAt : !_.publishedAt).length <= 10,
        count: Math.ceil(posts.length / 10),
        page: currentPage,
        variant: "outlined",
        shape: "rounded",
        onChange: (e, page)=>setCurrentPage(page)
    })));
};
const $d4b0116acf67651f$var$BlogDeleteDialog = ({ showDeleteDialog: showDeleteDialog, setShowDeleteDialog: setShowDeleteDialog, handleDeletePost: handleDeletePost })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $b9bff6d0b2f517f4$export$2e2bcd8739ae039), {
        open: showDeleteDialog,
        onClose: ()=>setShowDeleteDialog(false),
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $81eaac82b5cc00cd$export$2e2bcd8739ae039), {
        id: "alert-dialog-title"
    }, "Are you sure you want to delete this blog post?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $dba36486529bbea3$export$2e2bcd8739ae039), {
        sx: {
            justifyContent: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        onClick: ()=>setShowDeleteDialog(false),
        variant: "outlined",
        disableElevation: true
    }, "Cancel"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        onClick: ()=>handleDeletePost(),
        autoFocus: true,
        color: "error",
        variant: "contained",
        disableElevation: true
    }, "Delete")));
};
function $d4b0116acf67651f$var$a11yProps(index) {
    return {
        id: `blog-tab-${index}`,
        'aria-controls': `blog-tabpanel-${index}`
    };
}




var $8FY87 = parcelRequire("8FY87");

const $64d0416dd12b112f$var$BlogThumbnails = [
    {
        layout: 'blog_v1',
        src: (parcelRequire("7Lphs")),
        default: true
    }
];
function $64d0416dd12b112f$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("h1", {
        className: "text-lg mb-2"
    }, "Blog Listing Page"), $64d0416dd12b112f$var$BlogThumbnails.map((thumbnail)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("img", {
            key: thumbnail.layout,
            src: thumbnail.src,
            alt: "Blog Listing Page",
            className: `mb-4 cursor-pointer ${thumbnail.layout === props.blogConfig?.blog?.layout || thumbnail.default && !props.blogConfig?.blog?.layout ? ' border-solid border-2 border-catelina-blue' : ''}`,
            onClick: ()=>props.onBlogConfigChange({
                    ...props.blogConfig,
                    blog: {
                        ...props.blogConfig.blog,
                        layout: thumbnail.layout
                    }
                })
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, $30a538faf9a95dbb$export$2e2bcd8739ae039), {
        className: "mt-10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("h1", {
        className: "text-lg mb-2"
    }, "Blog Post Page"), $64d0416dd12b112f$var$BlogThumbnails.map((thumbnail)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("img", {
            key: thumbnail.layout,
            src: thumbnail.src,
            alt: "Blog Listing Page",
            className: `mb-4 cursor-pointer ${thumbnail.layout === props.blogConfig?.post?.layout || thumbnail.default && !props.blogConfig?.post?.layout ? ' border-solid border-2 border-catelina-blue' : ''}`,
            onClick: ()=>props.onBlogConfigChange({
                    ...props.blogConfig,
                    post: {
                        ...props.blogConfig.post,
                        layout: thumbnail.layout
                    }
                })
        })));
}





function $c0c8ebc5be4f0f13$var$checkIsInFrame() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}
const $c0c8ebc5be4f0f13$export$6d5196b1205ae727 = (props)=>{
    const [isInIframe] = (0, $8FY87.useState)($c0c8ebc5be4f0f13$var$checkIsInFrame());
    const [cookies] = (0, $1f373de1ceea6eb7$export$2e2bcd8739ae039)([
        "rp_user_data"
    ]);
    const navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    const { enqueueSnackbar: enqueueSnackbar } = (0, $5e19452f9528802f$export$1c97ac2c9a6e7c09)();
    const [searchParams, setSearchParams] = (0, $734169eef5d6795a$export$f1a78c17382fe22a)();
    const [saveDisabled, setSaveDisabled] = (0, $8FY87.useState)();
    const [checkPublishIntervalIterations, setCheckPublishIntervalIterations] = (0, $8FY87.useState)(0);
    const [sitePages, setSitePages] = (0, $8FY87.useState)([]);
    const updateQueryParam = (key, value)=>{
        const params = new URLSearchParams(searchParams);
        params.set(key, value);
        setSearchParams(params);
    };
    const getQueryParam = (key)=>{
        return searchParams.get(key);
    };
    const handleUpdateQueryParam = (section)=>{
        updateQueryParam("section", section);
    };
    const { id: id } = (0, $d5fb2d3e42b0c581$export$99eaa27ddbbb95ef)();
    const location = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)();
    const [isLoading, setIsLoading] = (0, $8FY87.useState)(true);
    const [siteData, setSiteData] = (0, $8FY87.useState)({});
    const [formData, setFormData] = (0, $8FY87.useState)({
        siteId: id,
        siteName: ""
    });
    const stateData = location.state;
    const [siteCategory, setSiteCategory] = (0, $8FY87.useState)([
        "Manage Posts",
        "Layout Settings"
    ]);
    const [blogConfig, setBlogConfig] = (0, $8FY87.useState)(null);
    const [selectedCategory, setSelectedCategory] = (0, $8FY87.useState)("");
    $8FY87.useEffect(()=>{
        async function fetchSiteData(siteId) {
            try {
                let response = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).get(`/api/configs/site-config?siteId=${siteId}`);
                console.log("//", response.data);
                setSiteData(response.data);
                setFormData(response.data);
                setIsLoading(false);
            } catch (err) {
                if (err.response.status === 404) navigate(`/404?msgType=SiteNotFound`);
                else if (err.response.status === 401) navigate(`/404?msgType=SiteNotAuthorizedToAccess`);
                else console.log("err", err.response.data.error);
            }
        }
        fetchSiteData(id);
        let gg = getQueryParam("section");
        if (!gg) setSelectedCategory("General");
        else setSelectedCategory(gg);
    // console.log('asasas', gg)
    // setSelectedCategory(gg ? "General" : "");
    }, []);
    $8FY87.useEffect(()=>{
        handleUpdateQueryParam(selectedCategory);
    // console.log("s", selectedCategory);
    }, [
        selectedCategory
    ]);
    const updateBlogConfig = async (updatedBlogConfig = blogConfig, publishData = {})=>{
        const response = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post(`/api/configs/blog?siteId=${id}`, updatedBlogConfig);
        console.log('response', response);
        setSiteData(response.data?.data);
        setBlogConfig(null);
        sendBlogConfigToParent(response.data?.data?.blogConfig);
        if (!response.data?.data?.blogConfig?.isPublished) {
            enqueueSnackbar("Changes saved successfully", {
                variant: "success"
            });
            return;
        }
        enqueueSnackbar("Blog is being published.\nWe'll notify you once it's ready.", {
            variant: "success"
        });
        const publishResponse = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).post(`/api/configs/publish-blog`, {
            ...publishData,
            siteId: id
        });
        console.log('publishResponse', publishResponse);
        listenToBlogPublish();
    };
    const listenToBlogPublish = async ()=>{
        const checkPublishInterval = setInterval(async ()=>{
            if (checkPublishIntervalIterations > 10) {
                clearInterval(checkPublishInterval);
                enqueueSnackbar('Blog publishing failed', {
                    variant: 'error'
                });
                setCheckPublishIntervalIterations(0);
                return;
            }
            setCheckPublishIntervalIterations(checkPublishIntervalIterations + 1);
            let response = await (0, $1deddb86eae7e53e$export$2e2bcd8739ae039).get(`/api/configs/site-config?siteId=${id}`);
            console.log('publish status', response.data);
            if (response.data?.blogConfig?.publishingStatus === 'Completed') {
                clearInterval(checkPublishInterval);
                enqueueSnackbar('Blog published successfully', {
                    variant: 'success'
                });
                sendBlogConfigToParent(response.data?.blogConfig);
            } else if (response.data?.blogConfig?.publishingStatus === 'Error') {
                clearInterval(checkPublishInterval);
                enqueueSnackbar('Blog publishing failed', {
                    variant: 'error'
                });
                setCheckPublishIntervalIterations(0);
                sendBlogConfigToParent(response.data?.blogConfig);
            } else if (!response.data?.blogConfig?.publishingStatus) {
                clearInterval(checkPublishInterval);
                enqueueSnackbar('Changes saved', {
                    variant: 'success'
                });
                setCheckPublishIntervalIterations(0);
                sendBlogConfigToParent(response.data?.blogConfig);
            }
        }, 5000);
    };
    // if is rendered in iframe, then send latest blog data to pagebuilder
    const sendBlogConfigToParent = (blogConfig)=>{
        if (isInIframe) window.parent.postMessage({
            blogUpdated: true,
            blogConfig: blogConfig
        }, "*");
    };
    return /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, null, /*#__PURE__*/ $8FY87.createElement((0, $274ffc8236991365$export$dcef8f9bb9a41431), null, /*#__PURE__*/ $8FY87.createElement("title", null, "RocketPages - Site Settings"), /*#__PURE__*/ $8FY87.createElement("meta", {
        name: "description",
        content: "Build and Launch Your Free Website in Just 15 Minutes"
    }), /*#__PURE__*/ $8FY87.createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap",
        rel: "stylesheet"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "icon",
        href: "/favicon.ico"
    })), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "font-body text-base font-medium"
    }, /*#__PURE__*/ $8FY87.createElement((0, $56dcde36b8493878$export$2e2bcd8739ae039), {
        sx: {
            color: "#fff",
            display: "flex",
            flexDirection: "column",
            zIndex: (theme)=>theme.zIndex.drawer + 1
        },
        open: isLoading
    }, /*#__PURE__*/ $8FY87.createElement((0, $b391f94ee7b6de9b$export$2e2bcd8739ae039), {
        color: "inherit"
    })), !isInIframe && /*#__PURE__*/ $8FY87.createElement((0, $c0f0a0f6efad2fa3$export$42cfbb80f7861e77), {
        ...stateData,
        siteId: id,
        title: `Site settings : ${formData ? formData.siteName : ""}`
    }), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "bg-gray-100 flex-row fixed h-screen w-48 hidden md:flex" + (isInIframe ? '' : ' top-[64px]')
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "w-full h-full bg-catelina-blue text-white flex flex-col py-2"
    }, siteCategory.map((ii)=>{
        return /*#__PURE__*/ $8FY87.createElement("span", {
            className: `px-6 hover:cursor-pointer text-sm py-2 ${selectedCategory === ii ? "bg-[#FAFAFA] text-catelina-blue" : ""}`,
            key: ii,
            onClick: ()=>setSelectedCategory(ii)
        }, ii);
    }))), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex w-full px-4 md:pl-[280px] pb-10 bg-[#FAFAFA] flex-col pt-5" + (isInIframe ? '' : ' min-h-screen pt-[64px] my-4')
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: "flex md:hidden py-2"
    }, /*#__PURE__*/ $8FY87.createElement((0, $e9e435d08b475b0d$export$2e2bcd8739ae039), {
        items: siteCategory,
        handleChange: setSelectedCategory,
        category: selectedCategory
    })), formData && selectedCategory === "Manage Posts" && /*#__PURE__*/ $8FY87.createElement((0, $d4b0116acf67651f$export$2e2bcd8739ae039), {
        siteId: id,
        blogConfig: siteData?.blogConfig || {},
        sitePages: sitePages,
        listenToBlogPublish: listenToBlogPublish,
        onBlogConfigChange: (updatedConfig)=>{
            setBlogConfig(updatedConfig);
            let publishData = {};
            if (updatedConfig?.blogConfig?.blog?.url !== siteData?.blogConfig?.blog?.url) publishData = {
                ...publishData,
                prevPageUrl: siteData?.blogConfig?.blog?.url
            };
            updateBlogConfig(updatedConfig, publishData);
        }
    }), formData && selectedCategory === "Layout Settings" && /*#__PURE__*/ $8FY87.createElement((0, $64d0416dd12b112f$export$2e2bcd8739ae039), {
        siteId: id,
        blogConfig: siteData?.blogConfig || {},
        onBlogConfigChange: (updatedConfig)=>setBlogConfig(updatedConfig)
    })), selectedCategory === "Layout Settings" && /*#__PURE__*/ $8FY87.createElement("div", {
        className: "fixed bottom-0 w-full z-50 flex justify-end px-4 py-2 bg-white-smoke"
    }, /*#__PURE__*/ $8FY87.createElement((0, $bd3665a0fad0f879$export$2e2bcd8739ae039), {
        id: "save",
        disabled: !blogConfig,
        className: "min-w-[6rem] px-4 py-1 capitalize",
        sx: {
            textTransform: "none"
        },
        size: "small",
        variant: "contained",
        onClick: ()=>updateBlogConfig()
    }, "Save"))), /*#__PURE__*/ $8FY87.createElement((0, $fdcc8de0ec44fdd8$export$2e2bcd8739ae039), null));
};



var $8FY87 = parcelRequire("8FY87");






const $df942ca9182ae671$export$324bdbb198bfbf81 = ()=>{
    const location = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)();
    // const stateData = location.state;
    const [isLoading, setIsLoading] = (0, $8FY87.useState)(false);
    // const [data, setData] = useState();
    // const [subsRes, setSubsRes] = useState(null);
    const search = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)().search;
    // const session_id = new URLSearchParams(search).get("session_id");
    return /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, null, /*#__PURE__*/ $8FY87.createElement((0, $274ffc8236991365$export$dcef8f9bb9a41431), null, /*#__PURE__*/ $8FY87.createElement("title", null, "RocketPages - Dashboard"), /*#__PURE__*/ $8FY87.createElement("meta", {
        name: "description",
        content: "Build and Launch Your Free Website in Just 15 Minutes"
    }), /*#__PURE__*/ $8FY87.createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap",
        rel: "stylesheet"
    }), /*#__PURE__*/ $8FY87.createElement("link", {
        rel: "icon",
        href: "/favicon.ico"
    }), false), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "font-body text-base font-medium"
    }, /*#__PURE__*/ $8FY87.createElement((0, $56dcde36b8493878$export$2e2bcd8739ae039), {
        sx: {
            color: "#fff",
            zIndex: (theme)=>theme.zIndex.drawer + 1
        },
        open: isLoading
    }, /*#__PURE__*/ $8FY87.createElement((0, $b391f94ee7b6de9b$export$2e2bcd8739ae039), {
        color: "inherit"
    })), /*#__PURE__*/ $8FY87.createElement((0, $c0f0a0f6efad2fa3$export$42cfbb80f7861e77), null), /*#__PURE__*/ $8FY87.createElement("div", {
        className: "bg-red-300 h-full absolute top-[64px] w-full"
    }, /*#__PURE__*/ $8FY87.createElement("div", {
        className: " m-auto h-20 bg-white-smoke"
    }, "failed"))), /*#__PURE__*/ $8FY87.createElement((0, $fdcc8de0ec44fdd8$export$2e2bcd8739ae039), null));
};


const $e44220deb002a90a$var$router = (0, $734169eef5d6795a$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ $8FY87.createElement((0, $75db671276d04424$export$74ba1212fd768fa5), null)
    },
    {
        path: "/login",
        element: /*#__PURE__*/ $8FY87.createElement((0, $34e9424c20ddd47f$export$f14c0e3f98d164c0), null)
    },
    {
        path: "/signup",
        element: /*#__PURE__*/ $8FY87.createElement((0, $c7ec45247ad7ac2c$export$a2f4b65ede167ce5), null)
    },
    {
        path: "/linkedin",
        element: /*#__PURE__*/ $8FY87.createElement((0, $c87118bc1c828d28$export$4eba75a127a285cf), null)
    },
    {
        path: "/reset-password",
        element: /*#__PURE__*/ $8FY87.createElement((0, $9bc36596a13505af$export$da4433e8d8a5678), null)
    },
    {
        path: "/forgot-password",
        element: /*#__PURE__*/ $8FY87.createElement((0, $d0889cc1565a9695$export$c7a55480dba6f1f1), null)
    },
    {
        path: "/dashboard",
        element: /*#__PURE__*/ $8FY87.createElement((0, $1bdb4b0e6d203096$export$fedd53519a0e2bce), null)
    },
    {
        path: "/site-settings/:id",
        element: /*#__PURE__*/ $8FY87.createElement((0, $2e98481ba6198bc2$export$bae4861c03af8b17), null)
    },
    {
        path: "/admin",
        element: /*#__PURE__*/ $8FY87.createElement((0, $9d2bfff234f9d017$export$2e2bcd8739ae039), null)
    },
    {
        path: "/manage-blog/:id",
        element: /*#__PURE__*/ $8FY87.createElement((0, $c0c8ebc5be4f0f13$export$6d5196b1205ae727), null)
    },
    {
        path: "/preview/:id",
        element: /*#__PURE__*/ $8FY87.createElement((0, $ec102dcec4aad640$export$2d07bc60194ed90c), null)
    },
    {
        path: "/choose-template",
        element: /*#__PURE__*/ $8FY87.createElement((0, $4ce06e48c5f9d768$export$d26f610c9dea7073), null)
    },
    {
        path: "/image-uploder",
        element: /*#__PURE__*/ $8FY87.createElement((0, $1d242ce450cfc6aa$export$2e2bcd8739ae039), null)
    },
    {
        path: "/404",
        element: /*#__PURE__*/ $8FY87.createElement((0, $6621759a7b4e8a8a$export$2e2bcd8739ae039), null)
    },
    {
        path: "/image-uploder",
        element: /*#__PURE__*/ $8FY87.createElement((0, $1d242ce450cfc6aa$export$2e2bcd8739ae039), null)
    },
    {
        path: "/account-settings",
        element: /*#__PURE__*/ $8FY87.createElement((0, $63f5a8e49b0d65b1$export$2e2bcd8739ae039), null)
    },
    // { path: "/checkout/:subscriptionId/:clientSecret", element: <CheckoutPage /> },
    {
        path: "/plan-success/:siteId",
        element: /*#__PURE__*/ $8FY87.createElement((0, $c9be578d1e08ddaa$export$d1fd69b62921db79), null)
    },
    {
        path: "/plan-fail/:siteId",
        element: /*#__PURE__*/ $8FY87.createElement((0, $df942ca9182ae671$export$324bdbb198bfbf81), null)
    },
    {
        path: "*",
        element: /*#__PURE__*/ $8FY87.createElement((0, $6621759a7b4e8a8a$export$2e2bcd8739ae039), null)
    },
    {
        path: "/terms-conditions",
        element: /*#__PURE__*/ $8FY87.createElement((0, $fefd9524ab4ddc67$export$3e6dfd2ec8bf3ef9), null)
    },
    {
        path: "/privacy-policy",
        element: /*#__PURE__*/ $8FY87.createElement((0, $53d5cc9f6d337e44$export$d5a29154259e944d), null)
    },
    {
        path: "/dns-service-providers",
        element: /*#__PURE__*/ $8FY87.createElement((0, $f721fe497a6e5e78$export$a76a49cc6daba0ed), null)
    }
]);
const $e44220deb002a90a$var$theme = (0, $ccfLL.default)({
    typography: {
        fontFamily: "Poppins"
    },
    palette: {
        primary: {
            main: "#243060"
        },
        secondary: {
            main: "#04155c"
        }
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                "@font-face": {
                    fontFamily: "Poppins"
                },
                body: {
                    fontSize: "3rem",
                    color: "purple"
                }
            }
        }
    }
});
const $e44220deb002a90a$var$container = document.getElementById("app");
const $e44220deb002a90a$var$root = (0, $adc227c367c2f6aa$export$882461b6382ed46c)($e44220deb002a90a$var$container); // createRoot(container!) if you use TypeScript
$e44220deb002a90a$var$root.render(// <div>
//   Pagepro best react team in the world
//   <h1 className="text-3xl font-bold underline">Hello world!</h1>
// </div>
/*#__PURE__*/ $8FY87.createElement((0, $33586719f2f33a17$export$4719288a8f5f7e71), null, /*#__PURE__*/ $8FY87.createElement((0, $965150fe664c8832$export$2e2bcd8739ae039), {
    theme: $e44220deb002a90a$var$theme
}, /*#__PURE__*/ $8FY87.createElement((0, $7676345fa334d851$export$2e2bcd8739ae039), null, /*#__PURE__*/ $8FY87.createElement((0, $e7ed5c4b4f4b44fc$export$a325976a38f291f5), {
    clientId: "1067520135858-3vc0neclju25u7amqeebqkmne2ouf3fe.apps.googleusercontent.com"
}, /*#__PURE__*/ $8FY87.createElement((0, $5e19452f9528802f$export$d1e619fddc3508ce), {
    maxSnack: 3,
    autoHideDuration: 2000,
    anchorOrigin: {
        horizontal: "right",
        vertical: "top"
    }
}, /*#__PURE__*/ $8FY87.createElement("div", {
    className: "App"
}, /*#__PURE__*/ $8FY87.createElement((0, $734169eef5d6795a$export$323e4fc2fa4753fb), {
    router: $e44220deb002a90a$var$router
}))))))));

})();
//# sourceMappingURL=index.8bedba1b.js.map
